import "core-js/modules/es.regexp.flags.js";
import * as Bn from "react";
import Nt, { forwardRef as Qn, useRef as vt, useCallback as pn, useId as ME, useState as rt, useEffect as Rt, createContext as Up, useMemo as ci, useImperativeHandle as jR, Children as AT, isValidElement as rR, cloneElement as FR, useContext as bl, Fragment as Qv, useLayoutEffect as NR, useReducer as MW, Component as oH, lazy as kF, Suspense as TF, createElement as sH, PureComponent as OW, useInsertionEffect as LW } from "react";
import './assets/main.css';
function lH(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function uH(t) {
  if (t.__esModule) return t;
  var e = t.default;
  if (typeof e == "function") {
    var i = function l() {
      return this instanceof l ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    i.prototype = e.prototype;
  } else i = {};
  return Object.defineProperty(i, "__esModule", {
    value: !0
  }), Object.keys(t).forEach(function (l) {
    var c = Object.getOwnPropertyDescriptor(t, l);
    Object.defineProperty(i, l, c.get ? c : {
      enumerable: !0,
      get: function () {
        return t[l];
      }
    });
  }), i;
}
var r2 = {
    exports: {}
  },
  vT = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wz;
function PW() {
  if (Wz) return vT;
  Wz = 1;
  var t = Nt,
    e = Symbol.for("react.element"),
    i = Symbol.for("react.fragment"),
    l = Object.prototype.hasOwnProperty,
    c = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
    p = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    };
  function h(y, w, x) {
    var E,
      C = {},
      k = null,
      D = null;
    x !== void 0 && (k = "" + x), w.key !== void 0 && (k = "" + w.key), w.ref !== void 0 && (D = w.ref);
    for (E in w) l.call(w, E) && !p.hasOwnProperty(E) && (C[E] = w[E]);
    if (y && y.defaultProps) for (E in w = y.defaultProps, w) C[E] === void 0 && (C[E] = w[E]);
    return {
      $$typeof: e,
      type: y,
      key: k,
      ref: D,
      props: C,
      _owner: c.current
    };
  }
  return vT.Fragment = i, vT.jsx = h, vT.jsxs = h, vT;
}
var eM = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qz;
function AW() {
  return qz || (qz = 1, process.env.NODE_ENV !== "production" && function () {
    var t = Nt,
      e = Symbol.for("react.element"),
      i = Symbol.for("react.portal"),
      l = Symbol.for("react.fragment"),
      c = Symbol.for("react.strict_mode"),
      p = Symbol.for("react.profiler"),
      h = Symbol.for("react.provider"),
      y = Symbol.for("react.context"),
      w = Symbol.for("react.forward_ref"),
      x = Symbol.for("react.suspense"),
      E = Symbol.for("react.suspense_list"),
      C = Symbol.for("react.memo"),
      k = Symbol.for("react.lazy"),
      D = Symbol.for("react.offscreen"),
      I = Symbol.iterator,
      O = "@@iterator";
    function P(Z) {
      if (Z === null || typeof Z != "object") return null;
      var Ne = I && Z[I] || Z[O];
      return typeof Ne == "function" ? Ne : null;
    }
    var N = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function L(Z) {
      {
        for (var Ne = arguments.length, Ye = new Array(Ne > 1 ? Ne - 1 : 0), xt = 1; xt < Ne; xt++) Ye[xt - 1] = arguments[xt];
        F("error", Z, Ye);
      }
    }
    function F(Z, Ne, Ye) {
      {
        var xt = N.ReactDebugCurrentFrame,
          rn = xt.getStackAddendum();
        rn !== "" && (Ne += "%s", Ye = Ye.concat([rn]));
        var $t = Ye.map(function (Ct) {
          return String(Ct);
        });
        $t.unshift("Warning: " + Ne), Function.prototype.apply.call(console[Z], console, $t);
      }
    }
    var j = !1,
      V = !1,
      K = !1,
      G = !1,
      Q = !1,
      te;
    te = Symbol.for("react.module.reference");
    function ie(Z) {
      return !!(typeof Z == "string" || typeof Z == "function" || Z === l || Z === p || Q || Z === c || Z === x || Z === E || G || Z === D || j || V || K || typeof Z == "object" && Z !== null && (Z.$$typeof === k || Z.$$typeof === C || Z.$$typeof === h || Z.$$typeof === y || Z.$$typeof === w ||
      // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Z.$$typeof === te || Z.getModuleId !== void 0));
    }
    function Y(Z, Ne, Ye) {
      var xt = Z.displayName;
      if (xt) return xt;
      var rn = Ne.displayName || Ne.name || "";
      return rn !== "" ? Ye + "(" + rn + ")" : Ye;
    }
    function ee(Z) {
      return Z.displayName || "Context";
    }
    function oe(Z) {
      if (Z == null) return null;
      if (typeof Z.tag == "number" && L("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof Z == "function") return Z.displayName || Z.name || null;
      if (typeof Z == "string") return Z;
      switch (Z) {
        case l:
          return "Fragment";
        case i:
          return "Portal";
        case p:
          return "Profiler";
        case c:
          return "StrictMode";
        case x:
          return "Suspense";
        case E:
          return "SuspenseList";
      }
      if (typeof Z == "object") switch (Z.$$typeof) {
        case y:
          var Ne = Z;
          return ee(Ne) + ".Consumer";
        case h:
          var Ye = Z;
          return ee(Ye._context) + ".Provider";
        case w:
          return Y(Z, Z.render, "ForwardRef");
        case C:
          var xt = Z.displayName || null;
          return xt !== null ? xt : oe(Z.type) || "Memo";
        case k:
          {
            var rn = Z,
              $t = rn._payload,
              Ct = rn._init;
            try {
              return oe(Ct($t));
            } catch {
              return null;
            }
          }
      }
      return null;
    }
    var ne = Object.assign,
      se = 0,
      ue,
      W,
      $,
      le,
      H,
      ce,
      de;
    function Ce() {}
    Ce.__reactDisabledLog = !0;
    function Ee() {
      {
        if (se === 0) {
          ue = console.log, W = console.info, $ = console.warn, le = console.error, H = console.group, ce = console.groupCollapsed, de = console.groupEnd;
          var Z = {
            configurable: !0,
            enumerable: !0,
            value: Ce,
            writable: !0
          };
          Object.defineProperties(console, {
            info: Z,
            log: Z,
            warn: Z,
            error: Z,
            group: Z,
            groupCollapsed: Z,
            groupEnd: Z
          });
        }
        se++;
      }
    }
    function fe() {
      {
        if (se--, se === 0) {
          var Z = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ne({}, Z, {
              value: ue
            }),
            info: ne({}, Z, {
              value: W
            }),
            warn: ne({}, Z, {
              value: $
            }),
            error: ne({}, Z, {
              value: le
            }),
            group: ne({}, Z, {
              value: H
            }),
            groupCollapsed: ne({}, Z, {
              value: ce
            }),
            groupEnd: ne({}, Z, {
              value: de
            })
          });
        }
        se < 0 && L("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var xe = N.ReactCurrentDispatcher,
      we;
    function ve(Z, Ne, Ye) {
      {
        if (we === void 0) try {
          throw Error();
        } catch (rn) {
          var xt = rn.stack.trim().match(/\n( *(at )?)/);
          we = xt && xt[1] || "";
        }
        return `
` + we + Z;
      }
    }
    var Te = !1,
      ze;
    {
      var Xe = typeof WeakMap == "function" ? WeakMap : Map;
      ze = new Xe();
    }
    function ye(Z, Ne) {
      if (!Z || Te) return "";
      {
        var Ye = ze.get(Z);
        if (Ye !== void 0) return Ye;
      }
      var xt;
      Te = !0;
      var rn = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var $t;
      $t = xe.current, xe.current = null, Ee();
      try {
        if (Ne) {
          var Ct = function () {
            throw Error();
          };
          if (Object.defineProperty(Ct.prototype, "props", {
            set: function () {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Ct, []);
            } catch (Wi) {
              xt = Wi;
            }
            Reflect.construct(Z, [], Ct);
          } else {
            try {
              Ct.call();
            } catch (Wi) {
              xt = Wi;
            }
            Z.call(Ct.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Wi) {
            xt = Wi;
          }
          Z();
        }
      } catch (Wi) {
        if (Wi && xt && typeof Wi.stack == "string") {
          for (var qt = Wi.stack.split(`
`), yr = xt.stack.split(`
`), Tn = qt.length - 1, jn = yr.length - 1; Tn >= 1 && jn >= 0 && qt[Tn] !== yr[jn];) jn--;
          for (; Tn >= 1 && jn >= 0; Tn--, jn--) if (qt[Tn] !== yr[jn]) {
            if (Tn !== 1 || jn !== 1) do if (Tn--, jn--, jn < 0 || qt[Tn] !== yr[jn]) {
              var Lr = `
` + qt[Tn].replace(" at new ", " at ");
              return Z.displayName && Lr.includes("<anonymous>") && (Lr = Lr.replace("<anonymous>", Z.displayName)), typeof Z == "function" && ze.set(Z, Lr), Lr;
            } while (Tn >= 1 && jn >= 0);
            break;
          }
        }
      } finally {
        Te = !1, xe.current = $t, fe(), Error.prepareStackTrace = rn;
      }
      var Wa = Z ? Z.displayName || Z.name : "",
        Ru = Wa ? ve(Wa) : "";
      return typeof Z == "function" && ze.set(Z, Ru), Ru;
    }
    function qe(Z, Ne, Ye) {
      return ye(Z, !1);
    }
    function Ae(Z) {
      var Ne = Z.prototype;
      return !!(Ne && Ne.isReactComponent);
    }
    function Mt(Z, Ne, Ye) {
      if (Z == null) return "";
      if (typeof Z == "function") return ye(Z, Ae(Z));
      if (typeof Z == "string") return ve(Z);
      switch (Z) {
        case x:
          return ve("Suspense");
        case E:
          return ve("SuspenseList");
      }
      if (typeof Z == "object") switch (Z.$$typeof) {
        case w:
          return qe(Z.render);
        case C:
          return Mt(Z.type, Ne, Ye);
        case k:
          {
            var xt = Z,
              rn = xt._payload,
              $t = xt._init;
            try {
              return Mt($t(rn), Ne, Ye);
            } catch {}
          }
      }
      return "";
    }
    var Ft = Object.prototype.hasOwnProperty,
      un = {},
      gt = N.ReactDebugCurrentFrame;
    function Pt(Z) {
      if (Z) {
        var Ne = Z._owner,
          Ye = Mt(Z.type, Z._source, Ne ? Ne.type : null);
        gt.setExtraStackFrame(Ye);
      } else gt.setExtraStackFrame(null);
    }
    function St(Z, Ne, Ye, xt, rn) {
      {
        var $t = Function.call.bind(Ft);
        for (var Ct in Z) if ($t(Z, Ct)) {
          var qt = void 0;
          try {
            if (typeof Z[Ct] != "function") {
              var yr = Error((xt || "React class") + ": " + Ye + " type `" + Ct + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Z[Ct] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
              throw yr.name = "Invariant Violation", yr;
            }
            qt = Z[Ct](Ne, Ct, xt, Ye, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
          } catch (Tn) {
            qt = Tn;
          }
          qt && !(qt instanceof Error) && (Pt(rn), L("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", xt || "React class", Ye, Ct, typeof qt), Pt(null)), qt instanceof Error && !(qt.message in un) && (un[qt.message] = !0, Pt(rn), L("Failed %s type: %s", Ye, qt.message), Pt(null));
        }
      }
    }
    var Dt = Array.isArray;
    function Kt(Z) {
      return Dt(Z);
    }
    function hn(Z) {
      {
        var Ne = typeof Symbol == "function" && Symbol.toStringTag,
          Ye = Ne && Z[Symbol.toStringTag] || Z.constructor.name || "Object";
        return Ye;
      }
    }
    function Ot(Z) {
      try {
        return Et(Z), !1;
      } catch {
        return !0;
      }
    }
    function Et(Z) {
      return "" + Z;
    }
    function Vt(Z) {
      if (Ot(Z)) return L("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", hn(Z)), Et(Z);
    }
    var Xt = N.ReactCurrentOwner,
      vn = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      },
      ot,
      We;
    function ht(Z) {
      if (Ft.call(Z, "ref")) {
        var Ne = Object.getOwnPropertyDescriptor(Z, "ref").get;
        if (Ne && Ne.isReactWarning) return !1;
      }
      return Z.ref !== void 0;
    }
    function Ke(Z) {
      if (Ft.call(Z, "key")) {
        var Ne = Object.getOwnPropertyDescriptor(Z, "key").get;
        if (Ne && Ne.isReactWarning) return !1;
      }
      return Z.key !== void 0;
    }
    function yt(Z, Ne) {
      typeof Z.ref == "string" && Xt.current;
    }
    function je(Z, Ne) {
      {
        var Ye = function () {
          ot || (ot = !0, L("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ne));
        };
        Ye.isReactWarning = !0, Object.defineProperty(Z, "key", {
          get: Ye,
          configurable: !0
        });
      }
    }
    function at(Z, Ne) {
      {
        var Ye = function () {
          We || (We = !0, L("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ne));
        };
        Ye.isReactWarning = !0, Object.defineProperty(Z, "ref", {
          get: Ye,
          configurable: !0
        });
      }
    }
    var kt = function (Z, Ne, Ye, xt, rn, $t, Ct) {
      var qt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: Z,
        key: Ne,
        ref: Ye,
        props: Ct,
        // Record the component responsible for creating this element.
        _owner: $t
      };
      return qt._store = {}, Object.defineProperty(qt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(qt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: xt
      }), Object.defineProperty(qt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: rn
      }), Object.freeze && (Object.freeze(qt.props), Object.freeze(qt)), qt;
    };
    function Bt(Z, Ne, Ye, xt, rn) {
      {
        var $t,
          Ct = {},
          qt = null,
          yr = null;
        Ye !== void 0 && (Vt(Ye), qt = "" + Ye), Ke(Ne) && (Vt(Ne.key), qt = "" + Ne.key), ht(Ne) && (yr = Ne.ref, yt(Ne));
        for ($t in Ne) Ft.call(Ne, $t) && !vn.hasOwnProperty($t) && (Ct[$t] = Ne[$t]);
        if (Z && Z.defaultProps) {
          var Tn = Z.defaultProps;
          for ($t in Tn) Ct[$t] === void 0 && (Ct[$t] = Tn[$t]);
        }
        if (qt || yr) {
          var jn = typeof Z == "function" ? Z.displayName || Z.name || "Unknown" : Z;
          qt && je(Ct, jn), yr && at(Ct, jn);
        }
        return kt(Z, qt, yr, rn, xt, Xt.current, Ct);
      }
    }
    var Ht = N.ReactCurrentOwner,
      ln = N.ReactDebugCurrentFrame;
    function en(Z) {
      if (Z) {
        var Ne = Z._owner,
          Ye = Mt(Z.type, Z._source, Ne ? Ne.type : null);
        ln.setExtraStackFrame(Ye);
      } else ln.setExtraStackFrame(null);
    }
    var Rr;
    Rr = !1;
    function Nr(Z) {
      return typeof Z == "object" && Z !== null && Z.$$typeof === e;
    }
    function Hi() {
      {
        if (Ht.current) {
          var Z = oe(Ht.current.type);
          if (Z) return `

Check the render method of \`` + Z + "`.";
        }
        return "";
      }
    }
    function ll(Z) {
      return "";
    }
    var yo = {};
    function _l(Z) {
      {
        var Ne = Hi();
        if (!Ne) {
          var Ye = typeof Z == "string" ? Z : Z.displayName || Z.name;
          Ye && (Ne = `

Check the top-level render call using <` + Ye + ">.");
        }
        return Ne;
      }
    }
    function Mo(Z, Ne) {
      {
        if (!Z._store || Z._store.validated || Z.key != null) return;
        Z._store.validated = !0;
        var Ye = _l(Ne);
        if (yo[Ye]) return;
        yo[Ye] = !0;
        var xt = "";
        Z && Z._owner && Z._owner !== Ht.current && (xt = " It was passed a child from " + oe(Z._owner.type) + "."), en(Z), L('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Ye, xt), en(null);
      }
    }
    function bo(Z, Ne) {
      {
        if (typeof Z != "object") return;
        if (Kt(Z)) for (var Ye = 0; Ye < Z.length; Ye++) {
          var xt = Z[Ye];
          Nr(xt) && Mo(xt, Ne);
        } else if (Nr(Z)) Z._store && (Z._store.validated = !0);else if (Z) {
          var rn = P(Z);
          if (typeof rn == "function" && rn !== Z.entries) for (var $t = rn.call(Z), Ct; !(Ct = $t.next()).done;) Nr(Ct.value) && Mo(Ct.value, Ne);
        }
      }
    }
    function Tu(Z) {
      {
        var Ne = Z.type;
        if (Ne == null || typeof Ne == "string") return;
        var Ye;
        if (typeof Ne == "function") Ye = Ne.propTypes;else if (typeof Ne == "object" && (Ne.$$typeof === w ||
        // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Ne.$$typeof === C)) Ye = Ne.propTypes;else return;
        if (Ye) {
          var xt = oe(Ne);
          St(Ye, Z.props, "prop", xt, Z);
        } else if (Ne.PropTypes !== void 0 && !Rr) {
          Rr = !0;
          var rn = oe(Ne);
          L("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", rn || "Unknown");
        }
        typeof Ne.getDefaultProps == "function" && !Ne.getDefaultProps.isReactClassApproved && L("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ha(Z) {
      {
        for (var Ne = Object.keys(Z.props), Ye = 0; Ye < Ne.length; Ye++) {
          var xt = Ne[Ye];
          if (xt !== "children" && xt !== "key") {
            en(Z), L("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", xt), en(null);
            break;
          }
        }
        Z.ref !== null && (en(Z), L("Invalid attribute `ref` supplied to `React.Fragment`."), en(null));
      }
    }
    function $i(Z, Ne, Ye, xt, rn, $t) {
      {
        var Ct = ie(Z);
        if (!Ct) {
          var qt = "";
          (Z === void 0 || typeof Z == "object" && Z !== null && Object.keys(Z).length === 0) && (qt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var yr = ll();
          yr ? qt += yr : qt += Hi();
          var Tn;
          Z === null ? Tn = "null" : Kt(Z) ? Tn = "array" : Z !== void 0 && Z.$$typeof === e ? (Tn = "<" + (oe(Z.type) || "Unknown") + " />", qt = " Did you accidentally export a JSX literal instead of a component?") : Tn = typeof Z, L("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Tn, qt);
        }
        var jn = Bt(Z, Ne, Ye, rn, $t);
        if (jn == null) return jn;
        if (Ct) {
          var Lr = Ne.children;
          if (Lr !== void 0) if (xt) {
            if (Kt(Lr)) {
              for (var Wa = 0; Wa < Lr.length; Wa++) bo(Lr[Wa], Z);
              Object.freeze && Object.freeze(Lr);
            } else L("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
          } else bo(Lr, Z);
        }
        return Z === l ? Ha(jn) : Tu(jn), jn;
      }
    }
    function oi(Z, Ne, Ye) {
      return $i(Z, Ne, Ye, !0);
    }
    function Oo(Z, Ne, Ye) {
      return $i(Z, Ne, Ye, !1);
    }
    var $a = Oo,
      Lo = oi;
    eM.Fragment = l, eM.jsx = $a, eM.jsxs = Lo;
  }()), eM;
}
var Yz;
function jW() {
  return Yz || (Yz = 1, process.env.NODE_ENV === "production" ? r2.exports = PW() : r2.exports = AW()), r2.exports;
}
var _e = jW();
const up = "Accordion",
  tO = "AccordionItem",
  cH = "AccordionHeader",
  wj = "AccordionTrigger",
  dH = "AccordionContent",
  FW = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"];
function OE(t, e = []) {
  let i = [];
  function l(p, h) {
    const y = Up(h),
      w = i.length;
    i = [...i, h];
    const x = C => {
      var k;
      const {
          scope: D,
          children: I,
          ...O
        } = C,
        P = ((k = D == null ? void 0 : D[t]) == null ? void 0 : k[w]) || y,
        N = ci(() => O, Object.values(O));
      return /* @__PURE__ */_e.jsx(P.Provider, {
        value: N,
        children: I
      });
    };
    x.displayName = p + "Provider";
    function E(C, k) {
      var D;
      const I = ((D = k == null ? void 0 : k[t]) == null ? void 0 : D[w]) || y,
        O = bl(I);
      if (O) return O;
      if (h !== void 0) return h;
      throw new Error(`\`${C}\` must be used within \`${p}\``);
    }
    return [x, E];
  }
  const c = () => {
    const p = i.map(h => Up(h));
    return function (h) {
      const y = (h == null ? void 0 : h[t]) || p;
      return ci(() => ({
        [`__scope${t}`]: {
          ...h,
          [t]: y
        }
      }), [h, y]);
    };
  };
  return c.scopeName = t, [l, NW(c, ...e)];
}
function NW(...t) {
  const e = t[0];
  if (t.length === 1) return e;
  const i = () => {
    const l = t.map(c => ({
      useScope: c(),
      scopeName: c.scopeName
    }));
    return function (c) {
      const p = l.reduce((h, {
        useScope: y,
        scopeName: w
      }) => {
        const x = y(c)[`__scope${w}`];
        return {
          ...h,
          ...x
        };
      }, {});
      return ci(() => ({
        [`__scope${e.scopeName}`]: p
      }), [p]);
    };
  };
  return i.scopeName = e.scopeName, i;
}
function Gz(t, e) {
  if (typeof t == "function") return t(e);
  t != null && (t.current = e);
}
function zW(...t) {
  return e => {
    const i = t.map(l => Gz(l, e));
    if (i.some(l => typeof l == "function")) return () => {
      i.forEach((l, c) => {
        typeof l == "function" ? l() : Gz(t[c], null);
      });
    };
  };
}
function _E(...t) {
  return pn(zW(...t), t);
}
const VW = t => /^on[A-Z]/.test(t),
  BW = (t, e) => {
    const i = {
      ...e
    };
    return Object.entries(e).forEach(([l, c]) => {
      const p = t[l];
      VW(l) && p && c ? i[l] = (...h) => {
        const y = c(...h);
        return p(...h), y;
      } : l === "style" ? i[l] = {
        ...p,
        ...c
      } : l === "className" && (i[l] = [p, c].filter(Boolean).join(" "));
    }), {
      ...t,
      ...i
    };
  },
  UW = t => "ref" in t ? t.ref : t.props.ref,
  HW = t => rR(t) && typeof t.type == "function",
  $W = t => {
    const e = Qn((i, l) => {
      const {
        children: c,
        ...p
      } = i;
      if (!rR(c)) return AT.count(c) > 1 ? AT.only(null) : null;
      const h = UW(c),
        y = _E(h, l),
        w = BW(p, c.props);
      return c.type !== Qv && (w.ref = y), FR(c, w);
    });
    return e.displayName = `${t}SlotClone`, e;
  },
  nO = t => {
    const e = $W(t),
      i = Qn((l, c) => {
        const {
            children: p,
            ...h
          } = l,
          y = AT.toArray(p),
          w = y.find(HW);
        if (!w) return /* @__PURE__ */_e.jsx(e, {
          ...h,
          ref: c,
          children: p
        });
        const x = w.props.children,
          E = y.map(C => C === w ? AT.count(x) > 1 ? AT.only(null) : rR(x) ? x.props.children : null : C);
        return /* @__PURE__ */_e.jsx(e, {
          ...h,
          ref: c,
          children: rR(x) ? FR(x, void 0, E) : null
        });
      });
    return i.displayName = `${t}Slot`, i;
  };
nO("Base");
function fH(t) {
  const e = `${t}CollectionProvider`,
    [i, l] = OE(e),
    [c, p] = i(e, {
      collectionRef: {
        current: null
      },
      itemMap: /* @__PURE__ */new Map()
    }),
    h = O => {
      const {
          scope: P,
          children: N
        } = O,
        L = vt(null),
        F = vt(/* @__PURE__ */new Map()).current;
      return /* @__PURE__ */_e.jsx(c, {
        scope: P,
        itemMap: F,
        collectionRef: L,
        children: N
      });
    };
  h.displayName = e;
  const y = `${t}CollectionSlot`,
    w = nO(y),
    x = Qn((O, P) => {
      const {
          scope: N,
          children: L
        } = O,
        F = p(y, N),
        j = _E(P, F.collectionRef);
      return /* @__PURE__ */_e.jsx(w, {
        ref: j,
        children: L
      });
    });
  x.displayName = y;
  const E = `${t}CollectionItemSlot`,
    C = "data-collection-item",
    k = nO(E),
    D = Qn((O, P) => {
      const {
          scope: N,
          children: L,
          ...F
        } = O,
        j = vt(null),
        V = _E(P, j),
        K = p(E, N);
      return Rt(() => (K.itemMap.set(j, {
        ref: j,
        ...F
      }), () => void K.itemMap.delete(j))), /* @__PURE__ */_e.jsx(k, {
        ref: V,
        [C]: "",
        children: L
      });
    });
  D.displayName = E;
  function I(O) {
    const P = p(t + "CollectionConsumer", O);
    return pn(() => {
      const N = P == null ? void 0 : P.collectionRef,
        L = N && "current" in N ? N.current : null;
      if (!L) return [];
      const F = Array.from(L.querySelectorAll(C));
      return Array.from(P.itemMap.values()).sort((j, V) => F.indexOf(j.ref.current) - F.indexOf(V.ref.current));
    }, [P.collectionRef, P.itemMap]);
  }
  return [{
    Provider: h,
    Slot: x,
    ItemSlot: D
  }, I, l];
}
const [WW, pH] = OE("Disclosure"),
  [qW, hH] = WW("Disclosure"),
  [RF, YW, GW] = fH(up),
  DF = pH(),
  [VO, S_e] = OE(up, [GW, pH]),
  [mH, vH] = VO(up),
  [gH, XW] = VO(up, {
    collapsible: !1
  }),
  [KW, BO] = VO(up),
  [QW, IF] = VO(tO);
function LE(t) {
  return t ? "open" : "closed";
}
const ZW = ["a", "button", "div", "h1", "h2", "h3", "h4", "img", "input", "label", "li", "nav", "ol", "p", "section", "select", "span", "ul"],
  sa = ZW.reduce((t, e) => {
    const i = nO(`BaseComponent.${e}`),
      l = Qn((c, p) => {
        const {
            asChild: h,
            ...y
          } = c,
          w = h ? i : e;
        return /* @__PURE__ */_e.jsx(w, {
          ...y,
          ref: p
        });
      });
    return l.displayName = `BaseComponent.${e}`, {
      ...t,
      [e]: l
    };
  }, {}),
  yH = Qn((t, e) => {
    const {
        __scopeDisclosure: i,
        children: l,
        ...c
      } = t,
      p = hH("DisclosureContent", i),
      h = vt(null),
      y = _E(e, h),
      w = p.open;
    return /* @__PURE__ */_e.jsx(sa.div, {
      "data-state": LE(p.open),
      "data-disabled": p.disabled ? "" : void 0,
      id: p.contentId,
      hidden: !w,
      ...c,
      ref: y,
      children: l
    });
  });
yH.displayName = "DisclosureContent";
const bH = Qn(function (t, e) {
  const {
      __scopeAccordion: i,
      ...l
    } = t,
    c = BO(up, i),
    p = IF(dH, i),
    h = DF(i);
  return /* @__PURE__ */_e.jsx(yH, {
    role: "region",
    "aria-labelledby": p.triggerId,
    "data-orientation": c.orientation,
    ...h,
    ...l,
    ref: e
  });
});
bH.displayName = dH;
const wH = Qn(function (t, e) {
  const {
      __scopeAccordion: i,
      ...l
    } = t,
    c = BO(up, i),
    p = IF(cH, i);
  return /* @__PURE__ */_e.jsx(sa.h3, {
    "data-orientation": c.orientation,
    "data-state": LE(p.open),
    "data-disabled": p.disabled ? "" : void 0,
    ...l,
    ref: e
  });
});
wH.displayName = cH;
function PE({
  prop: t,
  defaultProp: e,
  onChange: i = () => {}
}) {
  const [l, c, p] = JW({
      defaultProp: e,
      onChange: i
    }),
    h = t !== void 0,
    y = h ? t : l,
    w = pn(x => {
      var E;
      if (h) {
        const C = e9(x) ? x(t) : x;
        C !== t && ((E = p.current) == null || E.call(p, C));
      } else c(x);
    }, [h, t, c, p]);
  return [y, w];
}
function JW({
  defaultProp: t,
  onChange: e
}) {
  const [i, l] = rt(t),
    c = vt(i),
    p = vt(e);
  return Rt(() => {
    var h;
    c.current !== i && ((h = p.current) == null || h.call(p, i), c.current = i);
  }, [i, c]), [i, l, p];
}
function e9(t) {
  return typeof t == "function";
}
const _H = Qn((t, e) => {
  const {
      __scopeDisclosure: i,
      ...l
    } = t,
    c = hH("DisclosureTrigger", i);
  return /* @__PURE__ */_e.jsx(sa.button, {
    type: "button",
    "aria-controls": c.contentId,
    "aria-expanded": c.open || !1,
    "data-state": LE(c.open),
    "data-disabled": c.disabled,
    disabled: c.disabled,
    ...l,
    ref: e,
    onClick: c.onOpenToggle
  });
});
_H.displayName = "DisclosureTrigger";
const xH = Qn((t, e) => {
  const {
      __scopeDisclosure: i,
      open: l,
      defaultOpen: c,
      disabled: p,
      onOpenChange: h,
      ...y
    } = t,
    [w, x] = PE({
      prop: l,
      defaultProp: c ?? !1,
      onChange: h
    }),
    E = pn(() => {
      x(C => !C);
    }, [x]);
  return /* @__PURE__ */_e.jsx(qW, {
    scope: i,
    disabled: p,
    contentId: ME(),
    open: w,
    onOpenToggle: E,
    children: /* @__PURE__ */_e.jsx(sa.div, {
      "data-state": LE(w),
      "data-disabled": p ? "" : void 0,
      ...y,
      ref: e
    })
  });
});
xH.displayName = "Disclosure";
const SH = Qn(function (t, e) {
  const {
      __scopeAccordion: i,
      value: l,
      ...c
    } = t,
    p = BO(tO, i),
    h = vH(tO, i),
    y = DF(i),
    w = ME(),
    x = l && h.value.includes(l) || !1,
    E = p.disabled || t.disabled;
  return /* @__PURE__ */_e.jsx(QW, {
    scope: i,
    open: x,
    disabled: E,
    triggerId: w,
    children: /* @__PURE__ */_e.jsx(xH, {
      "data-orientation": p.orientation,
      "data-state": LE(x),
      ...y,
      ...c,
      ref: e,
      disabled: E,
      open: x,
      onOpenChange: C => {
        C ? h.onItemOpen(l) : h.onItemClose(l);
      }
    })
  });
});
SH.displayName = tO;
function zp(t, e, {
  isDefaultPrevented: i = !0
} = {}) {
  return function (l) {
    if (t == null || t(l), i === !1 || !l.defaultPrevented) return e == null ? void 0 : e(l);
  };
}
const MF = Nt.forwardRef((t, e) => {
  const {
      __scopeAccordion: i,
      disabled: l,
      dir: c,
      orientation: p = "vertical",
      ...h
    } = t,
    y = Nt.useRef(null),
    w = _E(y, e),
    x = YW(i),
    E = c === "ltr",
    C = zp(t.onKeyDown, k => {
      var D;
      if (!FW.includes(k.key)) return;
      const I = k.target,
        O = x().filter(Q => {
          var te;
          return !((te = Q.ref.current) != null && te.disabled);
        }),
        P = O.findIndex(Q => Q.ref.current === I),
        N = O.length;
      if (P === -1) return;
      k.preventDefault();
      let L = P;
      const F = 0,
        j = N - 1,
        V = () => {
          L = P + 1, L > j && (L = F);
        },
        K = () => {
          L = P - 1, L < F && (L = j);
        };
      switch (k.key) {
        case "Home":
          L = F;
          break;
        case "End":
          L = j;
          break;
        case "ArrowRight":
          p === "horizontal" && (E ? V() : K());
          break;
        case "ArrowDown":
          p === "vertical" && V();
          break;
        case "ArrowLeft":
          p === "horizontal" && (E ? K() : V());
          break;
        case "ArrowUp":
          p === "vertical" && K();
          break;
      }
      const G = L % N;
      (D = O[G].ref.current) == null || D.focus();
    });
  return /* @__PURE__ */_e.jsx(KW, {
    scope: i,
    disabled: l,
    direction: c,
    orientation: p,
    children: /* @__PURE__ */_e.jsx(RF.Slot, {
      scope: i,
      children: /* @__PURE__ */_e.jsx(sa.div, {
        ...h,
        "data-orientation": p,
        ref: w,
        onKeyDown: l ? void 0 : C
      })
    })
  });
});
MF.displayName = up + "Base";
const EH = Qn((t, e) => {
  const {
      value: i,
      defaultValue: l,
      onValueChange: c = () => {},
      collapsible: p = !1,
      ...h
    } = t,
    [y, w] = PE({
      prop: i,
      defaultProp: l ?? [],
      onChange: c
    }),
    x = Nt.useCallback(I => {
      w((O = []) => [...O, I]);
    }, [w]),
    E = Nt.useCallback(I => w((O = []) => O.filter(P => P !== I)), [w]),
    C = () => Nt.Children.toArray(t.children).filter(I => Nt.isValidElement(I) && I.props.value).map(I => I.props.value),
    k = Nt.useCallback(() => {
      const I = C();
      w(I);
    }, [w, t.children]),
    D = Nt.useCallback(() => {
      w([]);
    }, [w]);
  return /* @__PURE__ */_e.jsx(mH, {
    scope: t.__scopeAccordion,
    value: y,
    onItemOpen: x,
    onItemClose: E,
    expandAll: k,
    collapseAll: D,
    children: /* @__PURE__ */_e.jsx(gH, {
      scope: t.__scopeAccordion,
      collapsible: p,
      children: /* @__PURE__ */_e.jsx(MF, {
        ...h,
        ref: e
      })
    })
  });
});
EH.displayName = up + "Multiple";
const CH = Qn(function (t, e) {
  const {
      value: i,
      defaultValue: l,
      onValueChange: c = () => {},
      collapsible: p = !1,
      ...h
    } = t,
    [y, w] = PE({
      prop: i,
      defaultProp: l ?? "",
      onChange: c
    });
  return /* @__PURE__ */_e.jsx(mH, {
    scope: t.__scopeAccordion,
    value: Nt.useMemo(() => y ? [y] : [], [y]),
    onItemOpen: w,
    onItemClose: Nt.useCallback(() => p && w(""), [p, w]),
    children: /* @__PURE__ */_e.jsx(gH, {
      scope: t.__scopeAccordion,
      collapsible: p,
      children: /* @__PURE__ */_e.jsx(MF, {
        ...h,
        ref: e
      })
    })
  });
});
CH.displayName = up + "Single";
const kH = Qn(function (t, e) {
  const {
      __scopeAccordion: i,
      ...l
    } = t,
    c = BO(up, i),
    p = IF(wj, i),
    h = XW(wj, i),
    y = DF(i);
  return /* @__PURE__ */_e.jsx(RF.ItemSlot, {
    scope: i,
    children: /* @__PURE__ */_e.jsx(_H, {
      "aria-disabled": p.open && !h.collapsible || void 0,
      "data-orientation": c.orientation,
      id: p.triggerId,
      ...y,
      ...l,
      ref: e
    })
  });
});
kH.displayName = wj;
const t9 = Qn((t, e) => {
    const {
        __scopeAccordion: i,
        className: l,
        children: c,
        expandText: p = "Expand All",
        collapseText: h = "Collapse All"
      } = t,
      y = vH(up, i),
      [w, x] = rt(!1),
      E = () => {
        !y.expandAll || !y.collapseAll || (w ? y.collapseAll() : y.expandAll(), x(!w));
      };
    return /* @__PURE__ */_e.jsxs(sa.button, {
      type: "button",
      "data-state": LE(w),
      onClick: E,
      className: l,
      disabled: !y.expandAll || !y.collapseAll,
      ref: e,
      children: [w ? h : p, c]
    });
  }),
  TH = Qn(function ({
    __scopeAccordion: t,
    type: e = "single",
    ...i
  }, l) {
    const c = i,
      p = i;
    return /* @__PURE__ */_e.jsx(RF.Provider, {
      scope: t,
      children: e === "multiple" ? /* @__PURE__ */_e.jsx(EH, {
        ...p,
        ref: l
      }) : /* @__PURE__ */_e.jsx(CH, {
        ...c,
        ref: l
      })
    });
  });
TH.displayName = up;
function RH(t) {
  var e,
    i,
    l = "";
  if (typeof t == "string" || typeof t == "number") l += t;else if (typeof t == "object") if (Array.isArray(t)) {
    var c = t.length;
    for (e = 0; e < c; e++) t[e] && (i = RH(t[e])) && (l && (l += " "), l += i);
  } else for (i in t) t[i] && (l && (l += " "), l += i);
  return l;
}
function Ze() {
  for (var t, e, i = 0, l = "", c = arguments.length; i < c; i++) (t = arguments[i]) && (e = RH(t)) && (l && (l += " "), l += e);
  return l;
}
const n9 = "_alert_1lo9d_1",
  r9 = "_alertBody_1lo9d_6",
  i9 = "_alertDismissibleButton_1lo9d_10",
  i2 = {
    alert: n9,
    alertBody: r9,
    alertDismissibleButton: i9
  },
  DH = Qn(({
    className: t,
    classNames: e = {},
    children: i,
    dismissible: l = !0,
    dismissibleLabel: c = "Close alert",
    dismissibleIcon: p = "×",
    onDismiss: h = async () => await !0,
    ...y
  }, w) => {
    const [x, E] = rt(!0);
    if (!x) return null;
    const C = async () => {
      (await h()) && E(!1);
    };
    return /* @__PURE__ */_e.jsxs("div", {
      ...y,
      role: "alert",
      className: Ze(i2.alert, t),
      ref: w,
      children: [/* @__PURE__ */_e.jsx("div", {
        className: Ze(i2.alertBody, e.body),
        children: i
      }), l && /* @__PURE__ */_e.jsx("button", {
        type: "button",
        className: Ze(i2.alertDismissibleButton, e.dismissibleButton),
        onClick: C,
        "aria-label": c,
        children: p
      })]
    });
  });
DH.displayName = "Alert";
const a9 = "_button_15y99_1",
  o9 = "_disabled_15y99_20",
  s9 = "_fullWidth_15y99_29",
  a2 = {
    button: a9,
    disabled: o9,
    fullWidth: s9
  },
  _j = Qn((t, e) => {
    const {
        as: i,
        type: l,
        className: c,
        classNames: p,
        disabled: h,
        fullWidth: y,
        leftSection: w,
        children: x,
        rightSection: E,
        renderLink: C,
        ...k
      } = t,
      D = Ze(c, a2.button, {
        [a2.disabled]: h,
        [a2.fullWidth]: y
      }),
      I = /* @__PURE__ */_e.jsxs(_e.Fragment, {
        children: [w && /* @__PURE__ */_e.jsx("span", {
          className: p == null ? void 0 : p.leftSection,
          children: w
        }), x, E && /* @__PURE__ */_e.jsx("span", {
          className: p == null ? void 0 : p.rightSection,
          children: E
        })]
      });
    if (i === "a") {
      const {
          href: P,
          ...N
        } = k,
        L = {
          ...N,
          className: D,
          children: I
        };
      return C ? C(P, L) : /* @__PURE__ */_e.jsx("a", {
        ref: e,
        href: P,
        ...L
      });
    }
    const O = {
      ...k,
      disabled: h,
      className: D
    };
    return /* @__PURE__ */_e.jsx("button", {
      ref: e,
      ...O,
      type: l ?? "button",
      children: I
    });
  });
_j.displayName = "Button";
const l9 = "_checkbox_uuvf2_2",
  u9 = "_ui_uuvf2_23",
  c9 = "_checkboxWrapper_uuvf2_69",
  d9 = "_checkboxLabel_uuvf2_73",
  f9 = "_checkboxLabelWrapper_uuvf2_83",
  p9 = "_checkboxHelperText_uuvf2_90",
  h9 = "_checkboxError_uuvf2_96",
  m9 = "_checkboxDisabled_uuvf2_100",
  ab = {
    checkbox: l9,
    ui: u9,
    checkboxWrapper: c9,
    checkboxLabel: d9,
    checkboxLabelWrapper: f9,
    checkboxHelperText: p9,
    checkboxError: h9,
    checkboxDisabled: m9
  },
  v9 = Qn(({
    id: t,
    label: e,
    helperText: i,
    isDisabled: l = !1,
    isSelected: c = !1,
    onChange: p,
    className: h,
    classNames: y,
    isRequired: w = !1,
    errorMessage: x,
    isError: E = !1,
    ...C
  }, k) => {
    const [D, I] = rt(c),
      O = P => {
        I(!D), p == null || p(P, !D, t);
      };
    return Rt(() => {
      I(c);
    }, [c]), /* @__PURE__ */_e.jsx("div", {
      className: Ze(ab.checkbox, h, !l && !D && E && w && Ze(ab.checkboxError, y == null ? void 0 : y.error), l && Ze(ab.checkboxDisabled, y == null ? void 0 : y.disabled)),
      children: /* @__PURE__ */_e.jsxs("div", {
        className: Ze(ab.checkboxWrapper, y == null ? void 0 : y.wrapper),
        children: [/* @__PURE__ */_e.jsx("input", {
          ref: k,
          type: "checkbox",
          onChange: O,
          id: t,
          checked: D,
          disabled: l,
          required: w,
          ...C
        }), /* @__PURE__ */_e.jsx("span", {
          className: Ze(ab.ui, y == null ? void 0 : y.ui)
        }), /* @__PURE__ */_e.jsx("div", {
          className: Ze(ab.checkboxLabelWrapper, y == null ? void 0 : y.labelWrapper),
          children: /* @__PURE__ */_e.jsx("label", {
            className: Ze(ab.checkboxLabel, y == null ? void 0 : y.label),
            htmlFor: t,
            children: e
          })
        }), (i || w && E && x) && /* @__PURE__ */_e.jsx("div", {
          "data-disabled": !l,
          className: Ze(ab.checkboxHelperText, !D && !l && w && E && x && Ze(ab.checkboxErrorMsg, y == null ? void 0 : y.errorMsg), y == null ? void 0 : y.helperText),
          children: /* @__PURE__ */_e.jsx("span", {
            children: !D && !l && E && w && x || i
          })
        })]
      })
    });
  }),
  rd = {
    breakpoint: {
      sm: {
        value: "576px"
      },
      "sm-max": {
        value: "575px"
      },
      md: {
        value: "768px"
      },
      "md-max": {
        value: "767px"
      },
      lg: {
        value: "992px"
      },
      "lg-max": {
        value: "991px"
      },
      xl: {
        value: "1200px",
        original: {
          value: "1200px"
        },
        name: "BreakpointXl",
        attributes: {
          category: "breakpoint",
          type: "xl",
          cssVariables: "--breakpoint-xl"
        }
      },
      "xl-max": {
        value: "1199px"
      }
    },
    color: {
      white: {
        default: {
          value: "#FFFFFF"
        }
      },
      black: {
        default: {
          value: "#000000"
        }
      }
    }
  },
  g9 = t => {
    const e = [],
      i = (l, c = 0) => {
        l.forEach(p => {
          p._level = c;
          const {
            items: h,
            ...y
          } = p;
          e.push(y), h != null && h.length && i(h, c + 1);
        });
      };
    return t.forEach(l => {
      var c;
      (c = l.items) != null && c.length && i(l.items, 0);
    }), e;
  };
function ip(t, e) {
  if (t == null) return {};
  var i = {};
  for (var l in t) if ({}.hasOwnProperty.call(t, l)) {
    if (e.includes(l)) continue;
    i[l] = t[l];
  }
  return i;
}
function Jn() {
  return Jn = Object.assign ? Object.assign.bind() : function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var i = arguments[e];
      for (var l in i) ({}).hasOwnProperty.call(i, l) && (t[l] = i[l]);
    }
    return t;
  }, Jn.apply(null, arguments);
}
function xj(t, e) {
  return xj = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (i, l) {
    return i.__proto__ = l, i;
  }, xj(t, e);
}
function y9(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, xj(t, e);
}
var tM = {
    exports: {}
  },
  o2 = {
    exports: {}
  },
  pi = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xz;
function b9() {
  if (Xz) return pi;
  Xz = 1;
  var t = typeof Symbol == "function" && Symbol.for,
    e = t ? Symbol.for("react.element") : 60103,
    i = t ? Symbol.for("react.portal") : 60106,
    l = t ? Symbol.for("react.fragment") : 60107,
    c = t ? Symbol.for("react.strict_mode") : 60108,
    p = t ? Symbol.for("react.profiler") : 60114,
    h = t ? Symbol.for("react.provider") : 60109,
    y = t ? Symbol.for("react.context") : 60110,
    w = t ? Symbol.for("react.async_mode") : 60111,
    x = t ? Symbol.for("react.concurrent_mode") : 60111,
    E = t ? Symbol.for("react.forward_ref") : 60112,
    C = t ? Symbol.for("react.suspense") : 60113,
    k = t ? Symbol.for("react.suspense_list") : 60120,
    D = t ? Symbol.for("react.memo") : 60115,
    I = t ? Symbol.for("react.lazy") : 60116,
    O = t ? Symbol.for("react.block") : 60121,
    P = t ? Symbol.for("react.fundamental") : 60117,
    N = t ? Symbol.for("react.responder") : 60118,
    L = t ? Symbol.for("react.scope") : 60119;
  function F(V) {
    if (typeof V == "object" && V !== null) {
      var K = V.$$typeof;
      switch (K) {
        case e:
          switch (V = V.type, V) {
            case w:
            case x:
            case l:
            case p:
            case c:
            case C:
              return V;
            default:
              switch (V = V && V.$$typeof, V) {
                case y:
                case E:
                case I:
                case D:
                case h:
                  return V;
                default:
                  return K;
              }
          }
        case i:
          return K;
      }
    }
  }
  function j(V) {
    return F(V) === x;
  }
  return pi.AsyncMode = w, pi.ConcurrentMode = x, pi.ContextConsumer = y, pi.ContextProvider = h, pi.Element = e, pi.ForwardRef = E, pi.Fragment = l, pi.Lazy = I, pi.Memo = D, pi.Portal = i, pi.Profiler = p, pi.StrictMode = c, pi.Suspense = C, pi.isAsyncMode = function (V) {
    return j(V) || F(V) === w;
  }, pi.isConcurrentMode = j, pi.isContextConsumer = function (V) {
    return F(V) === y;
  }, pi.isContextProvider = function (V) {
    return F(V) === h;
  }, pi.isElement = function (V) {
    return typeof V == "object" && V !== null && V.$$typeof === e;
  }, pi.isForwardRef = function (V) {
    return F(V) === E;
  }, pi.isFragment = function (V) {
    return F(V) === l;
  }, pi.isLazy = function (V) {
    return F(V) === I;
  }, pi.isMemo = function (V) {
    return F(V) === D;
  }, pi.isPortal = function (V) {
    return F(V) === i;
  }, pi.isProfiler = function (V) {
    return F(V) === p;
  }, pi.isStrictMode = function (V) {
    return F(V) === c;
  }, pi.isSuspense = function (V) {
    return F(V) === C;
  }, pi.isValidElementType = function (V) {
    return typeof V == "string" || typeof V == "function" || V === l || V === x || V === p || V === c || V === C || V === k || typeof V == "object" && V !== null && (V.$$typeof === I || V.$$typeof === D || V.$$typeof === h || V.$$typeof === y || V.$$typeof === E || V.$$typeof === P || V.$$typeof === N || V.$$typeof === L || V.$$typeof === O);
  }, pi.typeOf = F, pi;
}
var zi = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Kz;
function w9() {
  return Kz || (Kz = 1, process.env.NODE_ENV !== "production" && function () {
    var t = typeof Symbol == "function" && Symbol.for,
      e = t ? Symbol.for("react.element") : 60103,
      i = t ? Symbol.for("react.portal") : 60106,
      l = t ? Symbol.for("react.fragment") : 60107,
      c = t ? Symbol.for("react.strict_mode") : 60108,
      p = t ? Symbol.for("react.profiler") : 60114,
      h = t ? Symbol.for("react.provider") : 60109,
      y = t ? Symbol.for("react.context") : 60110,
      w = t ? Symbol.for("react.async_mode") : 60111,
      x = t ? Symbol.for("react.concurrent_mode") : 60111,
      E = t ? Symbol.for("react.forward_ref") : 60112,
      C = t ? Symbol.for("react.suspense") : 60113,
      k = t ? Symbol.for("react.suspense_list") : 60120,
      D = t ? Symbol.for("react.memo") : 60115,
      I = t ? Symbol.for("react.lazy") : 60116,
      O = t ? Symbol.for("react.block") : 60121,
      P = t ? Symbol.for("react.fundamental") : 60117,
      N = t ? Symbol.for("react.responder") : 60118,
      L = t ? Symbol.for("react.scope") : 60119;
    function F(ye) {
      return typeof ye == "string" || typeof ye == "function" ||
      // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      ye === l || ye === x || ye === p || ye === c || ye === C || ye === k || typeof ye == "object" && ye !== null && (ye.$$typeof === I || ye.$$typeof === D || ye.$$typeof === h || ye.$$typeof === y || ye.$$typeof === E || ye.$$typeof === P || ye.$$typeof === N || ye.$$typeof === L || ye.$$typeof === O);
    }
    function j(ye) {
      if (typeof ye == "object" && ye !== null) {
        var qe = ye.$$typeof;
        switch (qe) {
          case e:
            var Ae = ye.type;
            switch (Ae) {
              case w:
              case x:
              case l:
              case p:
              case c:
              case C:
                return Ae;
              default:
                var Mt = Ae && Ae.$$typeof;
                switch (Mt) {
                  case y:
                  case E:
                  case I:
                  case D:
                  case h:
                    return Mt;
                  default:
                    return qe;
                }
            }
          case i:
            return qe;
        }
      }
    }
    var V = w,
      K = x,
      G = y,
      Q = h,
      te = e,
      ie = E,
      Y = l,
      ee = I,
      oe = D,
      ne = i,
      se = p,
      ue = c,
      W = C,
      $ = !1;
    function le(ye) {
      return $ || ($ = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), H(ye) || j(ye) === w;
    }
    function H(ye) {
      return j(ye) === x;
    }
    function ce(ye) {
      return j(ye) === y;
    }
    function de(ye) {
      return j(ye) === h;
    }
    function Ce(ye) {
      return typeof ye == "object" && ye !== null && ye.$$typeof === e;
    }
    function Ee(ye) {
      return j(ye) === E;
    }
    function fe(ye) {
      return j(ye) === l;
    }
    function xe(ye) {
      return j(ye) === I;
    }
    function we(ye) {
      return j(ye) === D;
    }
    function ve(ye) {
      return j(ye) === i;
    }
    function Te(ye) {
      return j(ye) === p;
    }
    function ze(ye) {
      return j(ye) === c;
    }
    function Xe(ye) {
      return j(ye) === C;
    }
    zi.AsyncMode = V, zi.ConcurrentMode = K, zi.ContextConsumer = G, zi.ContextProvider = Q, zi.Element = te, zi.ForwardRef = ie, zi.Fragment = Y, zi.Lazy = ee, zi.Memo = oe, zi.Portal = ne, zi.Profiler = se, zi.StrictMode = ue, zi.Suspense = W, zi.isAsyncMode = le, zi.isConcurrentMode = H, zi.isContextConsumer = ce, zi.isContextProvider = de, zi.isElement = Ce, zi.isForwardRef = Ee, zi.isFragment = fe, zi.isLazy = xe, zi.isMemo = we, zi.isPortal = ve, zi.isProfiler = Te, zi.isStrictMode = ze, zi.isSuspense = Xe, zi.isValidElementType = F, zi.typeOf = j;
  }()), zi;
}
var Qz;
function IH() {
  return Qz || (Qz = 1, process.env.NODE_ENV === "production" ? o2.exports = b9() : o2.exports = w9()), o2.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var s2, Zz;
function _9() {
  if (Zz) return s2;
  Zz = 1;
  var t = Object.getOwnPropertySymbols,
    e = Object.prototype.hasOwnProperty,
    i = Object.prototype.propertyIsEnumerable;
  function l(p) {
    if (p == null) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(p);
  }
  function c() {
    try {
      if (!Object.assign) return !1;
      var p = new String("abc");
      if (p[5] = "de", Object.getOwnPropertyNames(p)[0] === "5") return !1;
      for (var h = {}, y = 0; y < 10; y++) h["_" + String.fromCharCode(y)] = y;
      var w = Object.getOwnPropertyNames(h).map(function (E) {
        return h[E];
      });
      if (w.join("") !== "0123456789") return !1;
      var x = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (E) {
        x[E] = E;
      }), Object.keys(Object.assign({}, x)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return s2 = c() ? Object.assign : function (p, h) {
    for (var y, w = l(p), x, E = 1; E < arguments.length; E++) {
      y = Object(arguments[E]);
      for (var C in y) e.call(y, C) && (w[C] = y[C]);
      if (t) {
        x = t(y);
        for (var k = 0; k < x.length; k++) i.call(y, x[k]) && (w[x[k]] = y[x[k]]);
      }
    }
    return w;
  }, s2;
}
var l2, Jz;
function OF() {
  if (Jz) return l2;
  Jz = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return l2 = t, l2;
}
var eV, tV;
function MH() {
  return tV || (tV = 1, eV = Function.call.bind(Object.prototype.hasOwnProperty)), eV;
}
var u2, nV;
function x9() {
  if (nV) return u2;
  nV = 1;
  var t = function () {};
  if (process.env.NODE_ENV !== "production") {
    var e = /* @__PURE__ */OF(),
      i = {},
      l = /* @__PURE__ */MH();
    t = function (p) {
      var h = "Warning: " + p;
      typeof console < "u" && console.error(h);
      try {
        throw new Error(h);
      } catch {}
    };
  }
  function c(p, h, y, w, x) {
    if (process.env.NODE_ENV !== "production") {
      for (var E in p) if (l(p, E)) {
        var C;
        try {
          if (typeof p[E] != "function") {
            var k = Error((w || "React class") + ": " + y + " type `" + E + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof p[E] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
            throw k.name = "Invariant Violation", k;
          }
          C = p[E](h, E, w, y, null, e);
        } catch (I) {
          C = I;
        }
        if (C && !(C instanceof Error) && t((w || "React class") + ": type specification of " + y + " `" + E + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof C + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), C instanceof Error && !(C.message in i)) {
          i[C.message] = !0;
          var D = x ? x() : "";
          t("Failed " + y + " type: " + C.message + (D ?? ""));
        }
      }
    }
  }
  return c.resetWarningCache = function () {
    process.env.NODE_ENV !== "production" && (i = {});
  }, u2 = c, u2;
}
var c2, rV;
function S9() {
  if (rV) return c2;
  rV = 1;
  var t = IH(),
    e = _9(),
    i = /* @__PURE__ */OF(),
    l = /* @__PURE__ */MH(),
    c = /* @__PURE__ */x9(),
    p = function () {};
  process.env.NODE_ENV !== "production" && (p = function (y) {
    var w = "Warning: " + y;
    typeof console < "u" && console.error(w);
    try {
      throw new Error(w);
    } catch {}
  });
  function h() {
    return null;
  }
  return c2 = function (y, w) {
    var x = typeof Symbol == "function" && Symbol.iterator,
      E = "@@iterator";
    function C(H) {
      var ce = H && (x && H[x] || H[E]);
      if (typeof ce == "function") return ce;
    }
    var k = "<<anonymous>>",
      D = {
        array: N("array"),
        bigint: N("bigint"),
        bool: N("boolean"),
        func: N("function"),
        number: N("number"),
        object: N("object"),
        string: N("string"),
        symbol: N("symbol"),
        any: L(),
        arrayOf: F,
        element: j(),
        elementType: V(),
        instanceOf: K,
        node: ie(),
        objectOf: Q,
        oneOf: G,
        oneOfType: te,
        shape: ee,
        exact: oe
      };
    function I(H, ce) {
      return H === ce ? H !== 0 || 1 / H === 1 / ce : H !== H && ce !== ce;
    }
    function O(H, ce) {
      this.message = H, this.data = ce && typeof ce == "object" ? ce : {}, this.stack = "";
    }
    O.prototype = Error.prototype;
    function P(H) {
      if (process.env.NODE_ENV !== "production") var ce = {},
        de = 0;
      function Ce(fe, xe, we, ve, Te, ze, Xe) {
        if (ve = ve || k, ze = ze || we, Xe !== i) {
          if (w) {
            var ye = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            throw ye.name = "Invariant Violation", ye;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var qe = ve + ":" + we;
            !ce[qe] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            de < 3 && (p("You are manually calling a React.PropTypes validation function for the `" + ze + "` prop on `" + ve + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), ce[qe] = !0, de++);
          }
        }
        return xe[we] == null ? fe ? xe[we] === null ? new O("The " + Te + " `" + ze + "` is marked as required " + ("in `" + ve + "`, but its value is `null`.")) : new O("The " + Te + " `" + ze + "` is marked as required in " + ("`" + ve + "`, but its value is `undefined`.")) : null : H(xe, we, ve, Te, ze);
      }
      var Ee = Ce.bind(null, !1);
      return Ee.isRequired = Ce.bind(null, !0), Ee;
    }
    function N(H) {
      function ce(de, Ce, Ee, fe, xe, we) {
        var ve = de[Ce],
          Te = ue(ve);
        if (Te !== H) {
          var ze = W(ve);
          return new O("Invalid " + fe + " `" + xe + "` of type " + ("`" + ze + "` supplied to `" + Ee + "`, expected ") + ("`" + H + "`."), {
            expectedType: H
          });
        }
        return null;
      }
      return P(ce);
    }
    function L() {
      return P(h);
    }
    function F(H) {
      function ce(de, Ce, Ee, fe, xe) {
        if (typeof H != "function") return new O("Property `" + xe + "` of component `" + Ee + "` has invalid PropType notation inside arrayOf.");
        var we = de[Ce];
        if (!Array.isArray(we)) {
          var ve = ue(we);
          return new O("Invalid " + fe + " `" + xe + "` of type " + ("`" + ve + "` supplied to `" + Ee + "`, expected an array."));
        }
        for (var Te = 0; Te < we.length; Te++) {
          var ze = H(we, Te, Ee, fe, xe + "[" + Te + "]", i);
          if (ze instanceof Error) return ze;
        }
        return null;
      }
      return P(ce);
    }
    function j() {
      function H(ce, de, Ce, Ee, fe) {
        var xe = ce[de];
        if (!y(xe)) {
          var we = ue(xe);
          return new O("Invalid " + Ee + " `" + fe + "` of type " + ("`" + we + "` supplied to `" + Ce + "`, expected a single ReactElement."));
        }
        return null;
      }
      return P(H);
    }
    function V() {
      function H(ce, de, Ce, Ee, fe) {
        var xe = ce[de];
        if (!t.isValidElementType(xe)) {
          var we = ue(xe);
          return new O("Invalid " + Ee + " `" + fe + "` of type " + ("`" + we + "` supplied to `" + Ce + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return P(H);
    }
    function K(H) {
      function ce(de, Ce, Ee, fe, xe) {
        if (!(de[Ce] instanceof H)) {
          var we = H.name || k,
            ve = le(de[Ce]);
          return new O("Invalid " + fe + " `" + xe + "` of type " + ("`" + ve + "` supplied to `" + Ee + "`, expected ") + ("instance of `" + we + "`."));
        }
        return null;
      }
      return P(ce);
    }
    function G(H) {
      if (!Array.isArray(H)) return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? p("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).") : p("Invalid argument supplied to oneOf, expected an array.")), h;
      function ce(de, Ce, Ee, fe, xe) {
        for (var we = de[Ce], ve = 0; ve < H.length; ve++) if (I(we, H[ve])) return null;
        var Te = JSON.stringify(H, function (ze, Xe) {
          var ye = W(Xe);
          return ye === "symbol" ? String(Xe) : Xe;
        });
        return new O("Invalid " + fe + " `" + xe + "` of value `" + String(we) + "` " + ("supplied to `" + Ee + "`, expected one of " + Te + "."));
      }
      return P(ce);
    }
    function Q(H) {
      function ce(de, Ce, Ee, fe, xe) {
        if (typeof H != "function") return new O("Property `" + xe + "` of component `" + Ee + "` has invalid PropType notation inside objectOf.");
        var we = de[Ce],
          ve = ue(we);
        if (ve !== "object") return new O("Invalid " + fe + " `" + xe + "` of type " + ("`" + ve + "` supplied to `" + Ee + "`, expected an object."));
        for (var Te in we) if (l(we, Te)) {
          var ze = H(we, Te, Ee, fe, xe + "." + Te, i);
          if (ze instanceof Error) return ze;
        }
        return null;
      }
      return P(ce);
    }
    function te(H) {
      if (!Array.isArray(H)) return process.env.NODE_ENV !== "production" && p("Invalid argument supplied to oneOfType, expected an instance of array."), h;
      for (var ce = 0; ce < H.length; ce++) {
        var de = H[ce];
        if (typeof de != "function") return p("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + $(de) + " at index " + ce + "."), h;
      }
      function Ce(Ee, fe, xe, we, ve) {
        for (var Te = [], ze = 0; ze < H.length; ze++) {
          var Xe = H[ze],
            ye = Xe(Ee, fe, xe, we, ve, i);
          if (ye == null) return null;
          ye.data && l(ye.data, "expectedType") && Te.push(ye.data.expectedType);
        }
        var qe = Te.length > 0 ? ", expected one of type [" + Te.join(", ") + "]" : "";
        return new O("Invalid " + we + " `" + ve + "` supplied to " + ("`" + xe + "`" + qe + "."));
      }
      return P(Ce);
    }
    function ie() {
      function H(ce, de, Ce, Ee, fe) {
        return ne(ce[de]) ? null : new O("Invalid " + Ee + " `" + fe + "` supplied to " + ("`" + Ce + "`, expected a ReactNode."));
      }
      return P(H);
    }
    function Y(H, ce, de, Ce, Ee) {
      return new O((H || "React class") + ": " + ce + " type `" + de + "." + Ce + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Ee + "`.");
    }
    function ee(H) {
      function ce(de, Ce, Ee, fe, xe) {
        var we = de[Ce],
          ve = ue(we);
        if (ve !== "object") return new O("Invalid " + fe + " `" + xe + "` of type `" + ve + "` " + ("supplied to `" + Ee + "`, expected `object`."));
        for (var Te in H) {
          var ze = H[Te];
          if (typeof ze != "function") return Y(Ee, fe, xe, Te, W(ze));
          var Xe = ze(we, Te, Ee, fe, xe + "." + Te, i);
          if (Xe) return Xe;
        }
        return null;
      }
      return P(ce);
    }
    function oe(H) {
      function ce(de, Ce, Ee, fe, xe) {
        var we = de[Ce],
          ve = ue(we);
        if (ve !== "object") return new O("Invalid " + fe + " `" + xe + "` of type `" + ve + "` " + ("supplied to `" + Ee + "`, expected `object`."));
        var Te = e({}, de[Ce], H);
        for (var ze in Te) {
          var Xe = H[ze];
          if (l(H, ze) && typeof Xe != "function") return Y(Ee, fe, xe, ze, W(Xe));
          if (!Xe) return new O("Invalid " + fe + " `" + xe + "` key `" + ze + "` supplied to `" + Ee + "`.\nBad object: " + JSON.stringify(de[Ce], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(H), null, "  "));
          var ye = Xe(we, ze, Ee, fe, xe + "." + ze, i);
          if (ye) return ye;
        }
        return null;
      }
      return P(ce);
    }
    function ne(H) {
      switch (typeof H) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !H;
        case "object":
          if (Array.isArray(H)) return H.every(ne);
          if (H === null || y(H)) return !0;
          var ce = C(H);
          if (ce) {
            var de = ce.call(H),
              Ce;
            if (ce !== H.entries) {
              for (; !(Ce = de.next()).done;) if (!ne(Ce.value)) return !1;
            } else for (; !(Ce = de.next()).done;) {
              var Ee = Ce.value;
              if (Ee && !ne(Ee[1])) return !1;
            }
          } else return !1;
          return !0;
        default:
          return !1;
      }
    }
    function se(H, ce) {
      return H === "symbol" ? !0 : ce ? ce["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && ce instanceof Symbol : !1;
    }
    function ue(H) {
      var ce = typeof H;
      return Array.isArray(H) ? "array" : H instanceof RegExp ? "object" : se(ce, H) ? "symbol" : ce;
    }
    function W(H) {
      if (typeof H > "u" || H === null) return "" + H;
      var ce = ue(H);
      if (ce === "object") {
        if (H instanceof Date) return "date";
        if (H instanceof RegExp) return "regexp";
      }
      return ce;
    }
    function $(H) {
      var ce = W(H);
      switch (ce) {
        case "array":
        case "object":
          return "an " + ce;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + ce;
        default:
          return ce;
      }
    }
    function le(H) {
      return !H.constructor || !H.constructor.name ? k : H.constructor.name;
    }
    return D.checkPropTypes = c, D.resetWarningCache = c.resetWarningCache, D.PropTypes = D, D;
  }, c2;
}
var d2, iV;
function E9() {
  if (iV) return d2;
  iV = 1;
  var t = /* @__PURE__ */OF();
  function e() {}
  function i() {}
  return i.resetWarningCache = e, d2 = function () {
    function l(h, y, w, x, E, C) {
      if (C !== t) {
        var k = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw k.name = "Invariant Violation", k;
      }
    }
    l.isRequired = l;
    function c() {
      return l;
    }
    var p = {
      array: l,
      bigint: l,
      bool: l,
      func: l,
      number: l,
      object: l,
      string: l,
      symbol: l,
      any: l,
      arrayOf: c,
      element: l,
      elementType: l,
      instanceOf: c,
      node: l,
      objectOf: c,
      oneOf: c,
      oneOfType: c,
      shape: c,
      exact: c,
      checkPropTypes: i,
      resetWarningCache: e
    };
    return p.PropTypes = p, p;
  }, d2;
}
var aV;
function C9() {
  if (aV) return tM.exports;
  if (aV = 1, process.env.NODE_ENV !== "production") {
    var t = IH(),
      e = !0;
    tM.exports = /* @__PURE__ */S9()(t.isElement, e);
  } else tM.exports = /* @__PURE__ */E9()();
  return tM.exports;
}
var k9 = /* @__PURE__ */C9();
const Lt = /* @__PURE__ */lH(k9);
var f2 = {
    exports: {}
  },
  hi = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var oV;
function T9() {
  if (oV) return hi;
  oV = 1;
  var t = Symbol.for("react.element"),
    e = Symbol.for("react.portal"),
    i = Symbol.for("react.fragment"),
    l = Symbol.for("react.strict_mode"),
    c = Symbol.for("react.profiler"),
    p = Symbol.for("react.provider"),
    h = Symbol.for("react.context"),
    y = Symbol.for("react.server_context"),
    w = Symbol.for("react.forward_ref"),
    x = Symbol.for("react.suspense"),
    E = Symbol.for("react.suspense_list"),
    C = Symbol.for("react.memo"),
    k = Symbol.for("react.lazy"),
    D = Symbol.for("react.offscreen"),
    I;
  I = Symbol.for("react.module.reference");
  function O(P) {
    if (typeof P == "object" && P !== null) {
      var N = P.$$typeof;
      switch (N) {
        case t:
          switch (P = P.type, P) {
            case i:
            case c:
            case l:
            case x:
            case E:
              return P;
            default:
              switch (P = P && P.$$typeof, P) {
                case y:
                case h:
                case w:
                case k:
                case C:
                case p:
                  return P;
                default:
                  return N;
              }
          }
        case e:
          return N;
      }
    }
  }
  return hi.ContextConsumer = h, hi.ContextProvider = p, hi.Element = t, hi.ForwardRef = w, hi.Fragment = i, hi.Lazy = k, hi.Memo = C, hi.Portal = e, hi.Profiler = c, hi.StrictMode = l, hi.Suspense = x, hi.SuspenseList = E, hi.isAsyncMode = function () {
    return !1;
  }, hi.isConcurrentMode = function () {
    return !1;
  }, hi.isContextConsumer = function (P) {
    return O(P) === h;
  }, hi.isContextProvider = function (P) {
    return O(P) === p;
  }, hi.isElement = function (P) {
    return typeof P == "object" && P !== null && P.$$typeof === t;
  }, hi.isForwardRef = function (P) {
    return O(P) === w;
  }, hi.isFragment = function (P) {
    return O(P) === i;
  }, hi.isLazy = function (P) {
    return O(P) === k;
  }, hi.isMemo = function (P) {
    return O(P) === C;
  }, hi.isPortal = function (P) {
    return O(P) === e;
  }, hi.isProfiler = function (P) {
    return O(P) === c;
  }, hi.isStrictMode = function (P) {
    return O(P) === l;
  }, hi.isSuspense = function (P) {
    return O(P) === x;
  }, hi.isSuspenseList = function (P) {
    return O(P) === E;
  }, hi.isValidElementType = function (P) {
    return typeof P == "string" || typeof P == "function" || P === i || P === c || P === l || P === x || P === E || P === D || typeof P == "object" && P !== null && (P.$$typeof === k || P.$$typeof === C || P.$$typeof === p || P.$$typeof === h || P.$$typeof === w || P.$$typeof === I || P.getModuleId !== void 0);
  }, hi.typeOf = O, hi;
}
var Vi = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var sV;
function R9() {
  return sV || (sV = 1, process.env.NODE_ENV !== "production" && function () {
    var t = Symbol.for("react.element"),
      e = Symbol.for("react.portal"),
      i = Symbol.for("react.fragment"),
      l = Symbol.for("react.strict_mode"),
      c = Symbol.for("react.profiler"),
      p = Symbol.for("react.provider"),
      h = Symbol.for("react.context"),
      y = Symbol.for("react.server_context"),
      w = Symbol.for("react.forward_ref"),
      x = Symbol.for("react.suspense"),
      E = Symbol.for("react.suspense_list"),
      C = Symbol.for("react.memo"),
      k = Symbol.for("react.lazy"),
      D = Symbol.for("react.offscreen"),
      I = !1,
      O = !1,
      P = !1,
      N = !1,
      L = !1,
      F;
    F = Symbol.for("react.module.reference");
    function j(Ae) {
      return !!(typeof Ae == "string" || typeof Ae == "function" || Ae === i || Ae === c || L || Ae === l || Ae === x || Ae === E || N || Ae === D || I || O || P || typeof Ae == "object" && Ae !== null && (Ae.$$typeof === k || Ae.$$typeof === C || Ae.$$typeof === p || Ae.$$typeof === h || Ae.$$typeof === w ||
      // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Ae.$$typeof === F || Ae.getModuleId !== void 0));
    }
    function V(Ae) {
      if (typeof Ae == "object" && Ae !== null) {
        var Mt = Ae.$$typeof;
        switch (Mt) {
          case t:
            var Ft = Ae.type;
            switch (Ft) {
              case i:
              case c:
              case l:
              case x:
              case E:
                return Ft;
              default:
                var un = Ft && Ft.$$typeof;
                switch (un) {
                  case y:
                  case h:
                  case w:
                  case k:
                  case C:
                  case p:
                    return un;
                  default:
                    return Mt;
                }
            }
          case e:
            return Mt;
        }
      }
    }
    var K = h,
      G = p,
      Q = t,
      te = w,
      ie = i,
      Y = k,
      ee = C,
      oe = e,
      ne = c,
      se = l,
      ue = x,
      W = E,
      $ = !1,
      le = !1;
    function H(Ae) {
      return $ || ($ = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ce(Ae) {
      return le || (le = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function de(Ae) {
      return V(Ae) === h;
    }
    function Ce(Ae) {
      return V(Ae) === p;
    }
    function Ee(Ae) {
      return typeof Ae == "object" && Ae !== null && Ae.$$typeof === t;
    }
    function fe(Ae) {
      return V(Ae) === w;
    }
    function xe(Ae) {
      return V(Ae) === i;
    }
    function we(Ae) {
      return V(Ae) === k;
    }
    function ve(Ae) {
      return V(Ae) === C;
    }
    function Te(Ae) {
      return V(Ae) === e;
    }
    function ze(Ae) {
      return V(Ae) === c;
    }
    function Xe(Ae) {
      return V(Ae) === l;
    }
    function ye(Ae) {
      return V(Ae) === x;
    }
    function qe(Ae) {
      return V(Ae) === E;
    }
    Vi.ContextConsumer = K, Vi.ContextProvider = G, Vi.Element = Q, Vi.ForwardRef = te, Vi.Fragment = ie, Vi.Lazy = Y, Vi.Memo = ee, Vi.Portal = oe, Vi.Profiler = ne, Vi.StrictMode = se, Vi.Suspense = ue, Vi.SuspenseList = W, Vi.isAsyncMode = H, Vi.isConcurrentMode = ce, Vi.isContextConsumer = de, Vi.isContextProvider = Ce, Vi.isElement = Ee, Vi.isForwardRef = fe, Vi.isFragment = xe, Vi.isLazy = we, Vi.isMemo = ve, Vi.isPortal = Te, Vi.isProfiler = ze, Vi.isStrictMode = Xe, Vi.isSuspense = ye, Vi.isSuspenseList = qe, Vi.isValidElementType = j, Vi.typeOf = V;
  }()), Vi;
}
var lV;
function D9() {
  return lV || (lV = 1, process.env.NODE_ENV === "production" ? f2.exports = T9() : f2.exports = R9()), f2.exports;
}
var uV = D9();
const cV = t => typeof t == "object" && t != null && t.nodeType === 1,
  dV = (t, e) => (!e || t !== "hidden") && t !== "visible" && t !== "clip",
  nM = (t, e) => {
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
      const i = getComputedStyle(t, null);
      return dV(i.overflowY, e) || dV(i.overflowX, e) || (l => {
        const c = (p => {
          if (!p.ownerDocument || !p.ownerDocument.defaultView) return null;
          try {
            return p.ownerDocument.defaultView.frameElement;
          } catch {
            return null;
          }
        })(l);
        return !!c && (c.clientHeight < l.scrollHeight || c.clientWidth < l.scrollWidth);
      })(t);
    }
    return !1;
  },
  rM = (t, e, i, l, c, p, h, y) => p < t && h > e || p > t && h < e ? 0 : p <= t && y <= i || h >= e && y >= i ? p - t - l : h > e && y < i || p < t && y > i ? h - e + c : 0,
  I9 = t => t.parentElement ?? (t.getRootNode().host || null),
  M9 = (t, e) => {
    var i, l, c, p;
    if (typeof document > "u") return [];
    const {
        inline: h,
        boundary: y,
        skipOverflowHiddenElements: w
      } = e,
      x = typeof y == "function" ? y : oe => oe !== y;
    if (!cV(t)) throw new TypeError("Invalid target");
    const E = document.scrollingElement || document.documentElement,
      C = [];
    let k = t;
    for (; cV(k) && x(k);) {
      if (k = I9(k), k === E) {
        C.push(k);
        break;
      }
      k != null && k === document.body && nM(k) && !nM(document.documentElement) || k != null && nM(k, w) && C.push(k);
    }
    const D = (l = (i = window.visualViewport) == null ? void 0 : i.width) != null ? l : innerWidth,
      I = (p = (c = window.visualViewport) == null ? void 0 : c.height) != null ? p : innerHeight,
      {
        scrollX: O,
        scrollY: P
      } = window,
      {
        height: N,
        width: L,
        top: F,
        right: j,
        bottom: V,
        left: K
      } = t.getBoundingClientRect(),
      {
        top: G,
        right: Q,
        left: te
      } = (oe => {
        const ne = window.getComputedStyle(oe);
        return {
          top: parseFloat(ne.scrollMarginTop) || 0,
          right: parseFloat(ne.scrollMarginRight) || 0,
          bottom: parseFloat(ne.scrollMarginBottom) || 0,
          left: parseFloat(ne.scrollMarginLeft) || 0
        };
      })(t);
    let ie = F - G,
      Y = h === "center" ? K + L / 2 - te + Q : h === "end" ? j + Q : K - te;
    const ee = [];
    for (let oe = 0; oe < C.length; oe++) {
      const ne = C[oe],
        {
          height: se,
          width: ue,
          top: W,
          right: $,
          bottom: le,
          left: H
        } = ne.getBoundingClientRect();
      if (F >= 0 && K >= 0 && V <= I && j <= D && (ne === E && !nM(ne) || F >= W && V <= le && K >= H && j <= $)) return ee;
      const ce = getComputedStyle(ne),
        de = parseInt(ce.borderLeftWidth, 10),
        Ce = parseInt(ce.borderTopWidth, 10),
        Ee = parseInt(ce.borderRightWidth, 10),
        fe = parseInt(ce.borderBottomWidth, 10);
      let xe = 0,
        we = 0;
      const ve = "offsetWidth" in ne ? ne.offsetWidth - ne.clientWidth - de - Ee : 0,
        Te = "offsetHeight" in ne ? ne.offsetHeight - ne.clientHeight - Ce - fe : 0,
        ze = "offsetWidth" in ne ? ne.offsetWidth === 0 ? 0 : ue / ne.offsetWidth : 0,
        Xe = "offsetHeight" in ne ? ne.offsetHeight === 0 ? 0 : se / ne.offsetHeight : 0;
      if (E === ne) xe = rM(P, P + I, I, Ce, fe, P + ie, P + ie + N, N), we = h === "start" ? Y : h === "center" ? Y - D / 2 : h === "end" ? Y - D : rM(O, O + D, D, de, Ee, O + Y, O + Y + L, L), xe = Math.max(0, xe + P), we = Math.max(0, we + O);else {
        xe = rM(W, le, se, Ce, fe + Te, ie, ie + N, N), we = h === "start" ? Y - H - de : h === "center" ? Y - (H + ue / 2) + ve / 2 : h === "end" ? Y - $ + Ee + ve : rM(H, $, ue, de, Ee + ve, Y, Y + L, L);
        const {
          scrollLeft: ye,
          scrollTop: qe
        } = ne;
        xe = Xe === 0 ? 0 : Math.max(0, Math.min(qe + xe / Xe, ne.scrollHeight - se / Xe + Te)), we = ze === 0 ? 0 : Math.max(0, Math.min(ye + we / ze, ne.scrollWidth - ue / ze + ve)), ie += qe - xe, Y += ye - we;
      }
      ee.push({
        el: ne,
        top: xe,
        left: we
      });
    }
    return ee;
  };
var xE = function () {
    return xE = Object.assign || function (t) {
      for (var e, i = 1, l = arguments.length; i < l; i++) {
        e = arguments[i];
        for (var c in e) Object.prototype.hasOwnProperty.call(e, c) && (t[c] = e[c]);
      }
      return t;
    }, xE.apply(this, arguments);
  },
  O9 = 0;
function fV(t) {
  return typeof t == "function" ? t : id;
}
function id() {}
function OH(t, e) {
  if (t) {
    var i = M9(t, {
      boundary: e
    });
    i.forEach(function (l) {
      var c = l.el,
        p = l.top,
        h = l.left;
      c.scrollTop = p, c.scrollLeft = h;
    });
  }
}
function pV(t, e, i) {
  var l = t === e || e instanceof i.Node && t.contains && t.contains(e);
  return l;
}
function UO(t, e) {
  var i;
  function l() {
    i && clearTimeout(i);
  }
  function c() {
    for (var p = arguments.length, h = new Array(p), y = 0; y < p; y++) h[y] = arguments[y];
    l(), i = setTimeout(function () {
      i = null, t.apply(void 0, h);
    }, e);
  }
  return c.cancel = l, c;
}
function oa() {
  for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
  return function (l) {
    for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), h = 1; h < c; h++) p[h - 1] = arguments[h];
    return e.some(function (y) {
      return y && y.apply(void 0, [l].concat(p)), l.preventDownshiftDefault || l.hasOwnProperty("nativeEvent") && l.nativeEvent.preventDownshiftDefault;
    });
  };
}
function pb() {
  for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
  return function (l) {
    e.forEach(function (c) {
      typeof c == "function" ? c(l) : c && (c.current = l);
    });
  };
}
function LH() {
  return String(O9++);
}
function L9(t) {
  var e = t.isOpen,
    i = t.resultCount,
    l = t.previousResultCount;
  return e ? i ? i !== l ? i + " result" + (i === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function hV(t, e) {
  return t = Array.isArray(t) ? (/* istanbul ignore next (preact) */
  t[0]) : t, !t && e ? e : t;
}
function PH(t) {
  return typeof t.type == "string";
}
function AH(t) {
  return t.props;
}
function P9(t, e) {
  console.error('The property "' + e + '" is required in "' + t + '"');
}
var A9 = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function iM(t) {
  t === void 0 && (t = {});
  var e = {};
  return A9.forEach(function (i) {
    t.hasOwnProperty(i) && (e[i] = t[i]);
  }), e;
}
function iR(t, e) {
  return !t || !e ? t : Object.keys(t).reduce(function (i, l) {
    return i[l] = rO(e, l) ? e[l] : t[l], i;
  }, {});
}
function rO(t, e) {
  return t[e] !== void 0;
}
function iO(t) {
  var e = t.key,
    i = t.keyCode;
  return i >= 37 && i <= 40 && e.indexOf("Arrow") !== 0 ? "Arrow" + e : e;
}
function j9(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function $m(t, e, i, l, c) {
  c === void 0 && (c = !1);
  var p = i.length;
  if (p === 0) return -1;
  var h = p - 1;
  (typeof t != "number" || t < 0 || t > h) && (t = e > 0 ? -1 : h + 1);
  var y = t + e;
  y < 0 ? y = c ? h : 0 : y > h && (y = c ? 0 : h);
  var w = iw(y, e < 0, i, l, c);
  return w === -1 ? t >= p ? -1 : t : w;
}
function iw(t, e, i, l, c) {
  c === void 0 && (c = !1);
  var p = i.length;
  if (e) {
    for (var h = t; h >= 0; h--) if (!l(i[h], h)) return h;
  } else for (var y = t; y < p; y++) if (!l(i[y], y)) return y;
  return c ? iw(e ? p - 1 : 0, e, i, l) : -1;
}
function aO(t, e, i, l) {
  return l === void 0 && (l = !0), i && e.some(function (c) {
    return c && (pV(c, t, i) || l && pV(c, i.document.activeElement, i));
  });
}
var LF = id;
process.env.NODE_ENV !== "production" && (LF = function (t, e, i) {
  var l = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  Object.keys(t).forEach(function (c) {
    e[c] !== void 0 && i[c] === void 0 ? console.error('downshift: A component has changed the controlled prop "' + c + '" to be uncontrolled. ' + l) : e[c] === void 0 && i[c] !== void 0 && console.error('downshift: A component has changed the uncontrolled prop "' + c + '" to be controlled. ' + l);
  });
});
var F9 = UO(function (t) {
  jH(t).textContent = "";
}, 500);
function jH(t) {
  var e = t.getElementById("a11y-status-message");
  return e || (e = t.createElement("div"), e.setAttribute("id", "a11y-status-message"), e.setAttribute("role", "status"), e.setAttribute("aria-live", "polite"), e.setAttribute("aria-relevant", "additions text"), Object.assign(e.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), t.body.appendChild(e), e);
}
function FH(t, e) {
  if (!(!t || !e)) {
    var i = jH(e);
    i.textContent = t, F9(e);
  }
}
function N9(t) {
  var e = t == null ? void 0 : t.getElementById("a11y-status-message");
  e && e.remove();
}
var NH = process.env.NODE_ENV !== "production" ? "__autocomplete_unknown__" : 0,
  zH = process.env.NODE_ENV !== "production" ? "__autocomplete_mouseup__" : 1,
  VH = process.env.NODE_ENV !== "production" ? "__autocomplete_item_mouseenter__" : 2,
  FM = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_up__" : 3,
  NM = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_down__" : 4,
  BH = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_escape__" : 5,
  UH = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_enter__" : 6,
  HH = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_home__" : 7,
  $H = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_end__" : 8,
  WH = process.env.NODE_ENV !== "production" ? "__autocomplete_click_item__" : 9,
  qH = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_input__" : 10,
  YH = process.env.NODE_ENV !== "production" ? "__autocomplete_change_input__" : 11,
  GH = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_space_button__" : 12,
  Sj = process.env.NODE_ENV !== "production" ? "__autocomplete_click_button__" : 13,
  XH = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_button__" : 14,
  KH = process.env.NODE_ENV !== "production" ? "__autocomplete_controlled_prop_updated_selected_item__" : 15,
  QH = process.env.NODE_ENV !== "production" ? "__autocomplete_touchend__" : 16,
  z9 = /* @__PURE__ */Object.freeze({
    __proto__: null,
    blurButton: XH,
    blurInput: qH,
    changeInput: YH,
    clickButton: Sj,
    clickItem: WH,
    controlledPropUpdatedSelectedItem: KH,
    itemMouseEnter: VH,
    keyDownArrowDown: NM,
    keyDownArrowUp: FM,
    keyDownEnd: $H,
    keyDownEnter: UH,
    keyDownEscape: BH,
    keyDownHome: HH,
    keyDownSpaceButton: GH,
    mouseUp: zH,
    touchEnd: QH,
    unknown: NH
  }),
  V9 = ["refKey", "ref"],
  B9 = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"],
  U9 = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"],
  H9 = ["refKey", "ref"],
  $9 = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"],
  W9 = /* @__PURE__ */function () {
    var t = /* @__PURE__ */function (e) {
      function i(c) {
        var p;
        p = e.call(this, c) || this, p.id = p.props.id || "downshift-" + LH(), p.menuId = p.props.menuId || p.id + "-menu", p.labelId = p.props.labelId || p.id + "-label", p.inputId = p.props.inputId || p.id + "-input", p.getItemId = p.props.getItemId || function (L) {
          return p.id + "-item-" + L;
        }, p.items = [], p.itemCount = null, p.previousResultCount = 0, p.timeoutIds = [], p.internalSetTimeout = function (L, F) {
          var j = setTimeout(function () {
            p.timeoutIds = p.timeoutIds.filter(function (V) {
              return V !== j;
            }), L();
          }, F);
          p.timeoutIds.push(j);
        }, p.setItemCount = function (L) {
          p.itemCount = L;
        }, p.unsetItemCount = function () {
          p.itemCount = null;
        }, p.isItemDisabled = function (L, F) {
          var j = p.getItemNodeFromIndex(F);
          return j && j.hasAttribute("disabled");
        }, p.setHighlightedIndex = function (L, F) {
          L === void 0 && (L = p.props.defaultHighlightedIndex), F === void 0 && (F = {}), F = iM(F), p.internalSetState(Jn({
            highlightedIndex: L
          }, F));
        }, p.clearSelection = function (L) {
          p.internalSetState({
            selectedItem: null,
            inputValue: "",
            highlightedIndex: p.props.defaultHighlightedIndex,
            isOpen: p.props.defaultIsOpen
          }, L);
        }, p.selectItem = function (L, F, j) {
          F = iM(F), p.internalSetState(Jn({
            isOpen: p.props.defaultIsOpen,
            highlightedIndex: p.props.defaultHighlightedIndex,
            selectedItem: L,
            inputValue: p.props.itemToString(L)
          }, F), j);
        }, p.selectItemAtIndex = function (L, F, j) {
          var V = p.items[L];
          V != null && p.selectItem(V, F, j);
        }, p.selectHighlightedItem = function (L, F) {
          return p.selectItemAtIndex(p.getState().highlightedIndex, L, F);
        }, p.internalSetState = function (L, F) {
          var j,
            V,
            K = {},
            G = typeof L == "function";
          return !G && L.hasOwnProperty("inputValue") && p.props.onInputValueChange(L.inputValue, Jn({}, p.getStateAndHelpers(), L)), p.setState(function (Q) {
            var te;
            Q = p.getState(Q);
            var ie = G ? L(Q) : L;
            ie = p.props.stateReducer(Q, ie), j = ie.hasOwnProperty("selectedItem");
            var Y = {};
            return j && ie.selectedItem !== Q.selectedItem && (V = ie.selectedItem), (te = ie).type || (te.type = NH), Object.keys(ie).forEach(function (ee) {
              Q[ee] !== ie[ee] && (K[ee] = ie[ee]), ee !== "type" && (ie[ee], rO(p.props, ee) || (Y[ee] = ie[ee]));
            }), G && ie.hasOwnProperty("inputValue") && p.props.onInputValueChange(ie.inputValue, Jn({}, p.getStateAndHelpers(), ie)), Y;
          }, function () {
            fV(F)();
            var Q = Object.keys(K).length > 1;
            Q && p.props.onStateChange(K, p.getStateAndHelpers()), j && p.props.onSelect(L.selectedItem, p.getStateAndHelpers()), V !== void 0 && p.props.onChange(V, p.getStateAndHelpers()), p.props.onUserAction(K, p.getStateAndHelpers());
          });
        }, p.rootRef = function (L) {
          return p._rootNode = L;
        }, p.getRootProps = function (L, F) {
          var j,
            V = L === void 0 ? {} : L,
            K = V.refKey,
            G = K === void 0 ? "ref" : K,
            Q = V.ref,
            te = ip(V, V9),
            ie = F === void 0 ? {} : F,
            Y = ie.suppressRefError,
            ee = Y === void 0 ? !1 : Y;
          p.getRootProps.called = !0, p.getRootProps.refKey = G, p.getRootProps.suppressRefError = ee;
          var oe = p.getState(),
            ne = oe.isOpen;
          return Jn((j = {}, j[G] = pb(Q, p.rootRef), j.role = "combobox", j["aria-expanded"] = ne, j["aria-haspopup"] = "listbox", j["aria-owns"] = ne ? p.menuId : void 0, j["aria-labelledby"] = p.labelId, j), te);
        }, p.keyDownHandlers = {
          ArrowDown: function (L) {
            var F = this;
            if (L.preventDefault(), this.getState().isOpen) {
              var j = L.shiftKey ? 5 : 1;
              this.moveHighlightedIndex(j, {
                type: NM
              });
            } else this.internalSetState({
              isOpen: !0,
              type: NM
            }, function () {
              var V = F.getItemCount();
              if (V > 0) {
                var K = F.getState(),
                  G = K.highlightedIndex,
                  Q = $m(G, 1, {
                    length: V
                  }, F.isItemDisabled, !0);
                F.setHighlightedIndex(Q, {
                  type: NM
                });
              }
            });
          },
          ArrowUp: function (L) {
            var F = this;
            if (L.preventDefault(), this.getState().isOpen) {
              var j = L.shiftKey ? -5 : -1;
              this.moveHighlightedIndex(j, {
                type: FM
              });
            } else this.internalSetState({
              isOpen: !0,
              type: FM
            }, function () {
              var V = F.getItemCount();
              if (V > 0) {
                var K = F.getState(),
                  G = K.highlightedIndex,
                  Q = $m(G, -1, {
                    length: V
                  }, F.isItemDisabled, !0);
                F.setHighlightedIndex(Q, {
                  type: FM
                });
              }
            });
          },
          Enter: function (L) {
            if (L.which !== 229) {
              var F = this.getState(),
                j = F.isOpen,
                V = F.highlightedIndex;
              if (j && V != null) {
                L.preventDefault();
                var K = this.items[V],
                  G = this.getItemNodeFromIndex(V);
                if (K == null || G && G.hasAttribute("disabled")) return;
                this.selectHighlightedItem({
                  type: UH
                });
              }
            }
          },
          Escape: function (L) {
            L.preventDefault(), this.reset(Jn({
              type: BH
            }, !this.state.isOpen && {
              selectedItem: null,
              inputValue: ""
            }));
          }
        }, p.buttonKeyDownHandlers = Jn({}, p.keyDownHandlers, {
          " ": function (L) {
            L.preventDefault(), this.toggleMenu({
              type: GH
            });
          }
        }), p.inputKeyDownHandlers = Jn({}, p.keyDownHandlers, {
          Home: function (L) {
            var F = this.getState(),
              j = F.isOpen;
            if (j) {
              L.preventDefault();
              var V = this.getItemCount();
              if (!(V <= 0 || !j)) {
                var K = iw(0, !1, {
                  length: V
                }, this.isItemDisabled);
                this.setHighlightedIndex(K, {
                  type: HH
                });
              }
            }
          },
          End: function (L) {
            var F = this.getState(),
              j = F.isOpen;
            if (j) {
              L.preventDefault();
              var V = this.getItemCount();
              if (!(V <= 0 || !j)) {
                var K = iw(V - 1, !0, {
                  length: V
                }, this.isItemDisabled);
                this.setHighlightedIndex(K, {
                  type: $H
                });
              }
            }
          }
        }), p.getToggleButtonProps = function (L) {
          var F = L === void 0 ? {} : L,
            j = F.onClick;
          F.onPress;
          var V = F.onKeyDown,
            K = F.onKeyUp,
            G = F.onBlur,
            Q = ip(F, B9),
            te = p.getState(),
            ie = te.isOpen,
            Y = {
              onClick: oa(j, p.buttonHandleClick),
              onKeyDown: oa(V, p.buttonHandleKeyDown),
              onKeyUp: oa(K, p.buttonHandleKeyUp),
              onBlur: oa(G, p.buttonHandleBlur)
            },
            ee = Q.disabled ? {} : Y;
          return Jn({
            type: "button",
            role: "button",
            "aria-label": ie ? "close menu" : "open menu",
            "aria-haspopup": !0,
            "data-toggle": !0
          }, ee, Q);
        }, p.buttonHandleKeyUp = function (L) {
          L.preventDefault();
        }, p.buttonHandleKeyDown = function (L) {
          var F = iO(L);
          p.buttonKeyDownHandlers[F] && p.buttonKeyDownHandlers[F].call(p, L);
        }, p.buttonHandleClick = function (L) {
          if (L.preventDefault(), p.props.environment) {
            var F = p.props.environment.document,
              j = F.body,
              V = F.activeElement;
            j && j === V && L.target.focus();
          }
          process.env.NODE_ENV === "test" ? p.toggleMenu({
            type: Sj
          }) : p.internalSetTimeout(function () {
            return p.toggleMenu({
              type: Sj
            });
          });
        }, p.buttonHandleBlur = function (L) {
          var F = L.target;
          p.internalSetTimeout(function () {
            if (!(p.isMouseDown || !p.props.environment)) {
              var j = p.props.environment.document.activeElement;
              (j == null || j.id !== p.inputId) && j !== F && p.reset({
                type: XH
              });
            }
          });
        }, p.getLabelProps = function (L) {
          return Jn({
            htmlFor: p.inputId,
            id: p.labelId
          }, L);
        }, p.getInputProps = function (L) {
          var F = L === void 0 ? {} : L,
            j = F.onKeyDown,
            V = F.onBlur,
            K = F.onChange,
            G = F.onInput;
          F.onChangeText;
          var Q = ip(F, U9),
            te,
            ie = {};
          te = "onChange";
          var Y = p.getState(),
            ee = Y.inputValue,
            oe = Y.isOpen,
            ne = Y.highlightedIndex;
          if (!Q.disabled) {
            var se;
            ie = (se = {}, se[te] = oa(K, G, p.inputHandleChange), se.onKeyDown = oa(j, p.inputHandleKeyDown), se.onBlur = oa(V, p.inputHandleBlur), se);
          }
          return Jn({
            "aria-autocomplete": "list",
            "aria-activedescendant": oe && typeof ne == "number" && ne >= 0 ? p.getItemId(ne) : void 0,
            "aria-controls": oe ? p.menuId : void 0,
            "aria-labelledby": Q && Q["aria-label"] ? void 0 : p.labelId,
            // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
            // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
            autoComplete: "off",
            value: ee,
            id: p.inputId
          }, ie, Q);
        }, p.inputHandleKeyDown = function (L) {
          var F = iO(L);
          F && p.inputKeyDownHandlers[F] && p.inputKeyDownHandlers[F].call(p, L);
        }, p.inputHandleChange = function (L) {
          p.internalSetState({
            type: YH,
            isOpen: !0,
            inputValue: L.target.value,
            highlightedIndex: p.props.defaultHighlightedIndex
          });
        }, p.inputHandleBlur = function () {
          p.internalSetTimeout(function () {
            var L;
            if (!(p.isMouseDown || !p.props.environment)) {
              var F = p.props.environment.document.activeElement,
                j = (F == null || (L = F.dataset) == null ? void 0 : L.toggle) && p._rootNode && p._rootNode.contains(F);
              j || p.reset({
                type: qH
              });
            }
          });
        }, p.menuRef = function (L) {
          p._menuNode = L;
        }, p.getMenuProps = function (L, F) {
          var j,
            V = L === void 0 ? {} : L,
            K = V.refKey,
            G = K === void 0 ? "ref" : K,
            Q = V.ref,
            te = ip(V, H9),
            ie = F === void 0 ? {} : F,
            Y = ie.suppressRefError,
            ee = Y === void 0 ? !1 : Y;
          return p.getMenuProps.called = !0, p.getMenuProps.refKey = G, p.getMenuProps.suppressRefError = ee, Jn((j = {}, j[G] = pb(Q, p.menuRef), j.role = "listbox", j["aria-labelledby"] = te && te["aria-label"] ? void 0 : p.labelId, j.id = p.menuId, j), te);
        }, p.getItemProps = function (L) {
          var F,
            j = L === void 0 ? {} : L,
            V = j.onMouseMove,
            K = j.onMouseDown,
            G = j.onClick;
          j.onPress;
          var Q = j.index,
            te = j.item,
            ie = te === void 0 ? process.env.NODE_ENV === "production" ? (/* istanbul ignore next */
            void 0) : P9("getItemProps", "item") : te,
            Y = ip(j, $9);
          Q === void 0 ? (p.items.push(ie), Q = p.items.indexOf(ie)) : p.items[Q] = ie;
          var ee = "onClick",
            oe = G,
            ne = (F = {
              // onMouseMove is used over onMouseEnter here. onMouseMove
              // is only triggered on actual mouse movement while onMouseEnter
              // can fire on DOM changes, interrupting keyboard navigation
              onMouseMove: oa(V, function () {
                Q !== p.getState().highlightedIndex && (p.setHighlightedIndex(Q, {
                  type: VH
                }), p.avoidScrolling = !0, p.internalSetTimeout(function () {
                  return p.avoidScrolling = !1;
                }, 250));
              }),
              onMouseDown: oa(K, function (ue) {
                ue.preventDefault();
              })
            }, F[ee] = oa(oe, function () {
              p.selectItemAtIndex(Q, {
                type: WH
              });
            }), F),
            se = Y.disabled ? {
              onMouseDown: ne.onMouseDown
            } : ne;
          return Jn({
            id: p.getItemId(Q),
            role: "option",
            "aria-selected": p.getState().highlightedIndex === Q
          }, se, Y);
        }, p.clearItems = function () {
          p.items = [];
        }, p.reset = function (L, F) {
          L === void 0 && (L = {}), L = iM(L), p.internalSetState(function (j) {
            var V = j.selectedItem;
            return Jn({
              isOpen: p.props.defaultIsOpen,
              highlightedIndex: p.props.defaultHighlightedIndex,
              inputValue: p.props.itemToString(V)
            }, L);
          }, F);
        }, p.toggleMenu = function (L, F) {
          L === void 0 && (L = {}), L = iM(L), p.internalSetState(function (j) {
            var V = j.isOpen;
            return Jn({
              isOpen: !V
            }, V && {
              highlightedIndex: p.props.defaultHighlightedIndex
            }, L);
          }, function () {
            var j = p.getState(),
              V = j.isOpen,
              K = j.highlightedIndex;
            V && p.getItemCount() > 0 && typeof K == "number" && p.setHighlightedIndex(K, L), fV(F)();
          });
        }, p.openMenu = function (L) {
          p.internalSetState({
            isOpen: !0
          }, L);
        }, p.closeMenu = function (L) {
          p.internalSetState({
            isOpen: !1
          }, L);
        }, p.updateStatus = UO(function () {
          var L;
          if ((L = p.props) != null && (L = L.environment) != null && L.document) {
            var F = p.getState(),
              j = p.items[F.highlightedIndex],
              V = p.getItemCount(),
              K = p.props.getA11yStatusMessage(Jn({
                itemToString: p.props.itemToString,
                previousResultCount: p.previousResultCount,
                resultCount: V,
                highlightedItem: j
              }, F));
            p.previousResultCount = V, FH(K, p.props.environment.document);
          }
        }, 200);
        var h = p.props,
          y = h.defaultHighlightedIndex,
          w = h.initialHighlightedIndex,
          x = w === void 0 ? y : w,
          E = h.defaultIsOpen,
          C = h.initialIsOpen,
          k = C === void 0 ? E : C,
          D = h.initialInputValue,
          I = D === void 0 ? "" : D,
          O = h.initialSelectedItem,
          P = O === void 0 ? null : O,
          N = p.getState({
            highlightedIndex: x,
            isOpen: k,
            inputValue: I,
            selectedItem: P
          });
        return N.selectedItem != null && p.props.initialInputValue === void 0 && (N.inputValue = p.props.itemToString(N.selectedItem)), p.state = N, p;
      }
      y9(i, e);
      var l = i.prototype;
      return l.internalClearTimeouts = function () {
        this.timeoutIds.forEach(function (c) {
          clearTimeout(c);
        }), this.timeoutIds = [];
      }, l.getState = function (c) {
        return c === void 0 && (c = this.state), iR(c, this.props);
      }, l.getItemCount = function () {
        var c = this.items.length;
        return this.itemCount != null ? c = this.itemCount : this.props.itemCount !== void 0 && (c = this.props.itemCount), c;
      }, l.getItemNodeFromIndex = function (c) {
        return this.props.environment ? this.props.environment.document.getElementById(this.getItemId(c)) : null;
      }, l.scrollHighlightedItemIntoView = function () {
        {
          var c = this.getItemNodeFromIndex(this.getState().highlightedIndex);
          this.props.scrollIntoView(c, this._menuNode);
        }
      }, l.moveHighlightedIndex = function (c, p) {
        var h = this.getItemCount(),
          y = this.getState(),
          w = y.highlightedIndex;
        if (h > 0) {
          var x = $m(w, c, {
            length: h
          }, this.isItemDisabled, !0);
          this.setHighlightedIndex(x, p);
        }
      }, l.getStateAndHelpers = function () {
        var c = this.getState(),
          p = c.highlightedIndex,
          h = c.inputValue,
          y = c.selectedItem,
          w = c.isOpen,
          x = this.props.itemToString,
          E = this.id,
          C = this.getRootProps,
          k = this.getToggleButtonProps,
          D = this.getLabelProps,
          I = this.getMenuProps,
          O = this.getInputProps,
          P = this.getItemProps,
          N = this.openMenu,
          L = this.closeMenu,
          F = this.toggleMenu,
          j = this.selectItem,
          V = this.selectItemAtIndex,
          K = this.selectHighlightedItem,
          G = this.setHighlightedIndex,
          Q = this.clearSelection,
          te = this.clearItems,
          ie = this.reset,
          Y = this.setItemCount,
          ee = this.unsetItemCount,
          oe = this.internalSetState;
        return {
          // prop getters
          getRootProps: C,
          getToggleButtonProps: k,
          getLabelProps: D,
          getMenuProps: I,
          getInputProps: O,
          getItemProps: P,
          // actions
          reset: ie,
          openMenu: N,
          closeMenu: L,
          toggleMenu: F,
          selectItem: j,
          selectItemAtIndex: V,
          selectHighlightedItem: K,
          setHighlightedIndex: G,
          clearSelection: Q,
          clearItems: te,
          setItemCount: Y,
          unsetItemCount: ee,
          setState: oe,
          // props
          itemToString: x,
          // derived
          id: E,
          // state
          highlightedIndex: p,
          inputValue: h,
          isOpen: w,
          selectedItem: y
        };
      }, l.componentDidMount = function () {
        var c = this;
        if (process.env.NODE_ENV !== "production" && this.getMenuProps.called && !this.getMenuProps.suppressRefError && mV(this._menuNode, this.getMenuProps), !this.props.environment) this.cleanup = function () {
          c.internalClearTimeouts();
        };else {
          var p = function () {
              c.isMouseDown = !0;
            },
            h = function (C) {
              c.isMouseDown = !1;
              var k = aO(C.target, [c._rootNode, c._menuNode], c.props.environment);
              !k && c.getState().isOpen && c.reset({
                type: zH
              }, function () {
                return c.props.onOuterClick(c.getStateAndHelpers());
              });
            },
            y = function () {
              c.isTouchMove = !1;
            },
            w = function () {
              c.isTouchMove = !0;
            },
            x = function (C) {
              var k = aO(C.target, [c._rootNode, c._menuNode], c.props.environment, !1);
              !c.isTouchMove && !k && c.getState().isOpen && c.reset({
                type: QH
              }, function () {
                return c.props.onOuterClick(c.getStateAndHelpers());
              });
            },
            E = this.props.environment;
          E.addEventListener("mousedown", p), E.addEventListener("mouseup", h), E.addEventListener("touchstart", y), E.addEventListener("touchmove", w), E.addEventListener("touchend", x), this.cleanup = function () {
            c.internalClearTimeouts(), c.updateStatus.cancel(), E.removeEventListener("mousedown", p), E.removeEventListener("mouseup", h), E.removeEventListener("touchstart", y), E.removeEventListener("touchmove", w), E.removeEventListener("touchend", x);
          };
        }
      }, l.shouldScroll = function (c, p) {
        var h = this.props.highlightedIndex === void 0 ? this.getState() : this.props,
          y = h.highlightedIndex,
          w = p.highlightedIndex === void 0 ? c : p,
          x = w.highlightedIndex,
          E = y && this.getState().isOpen && !c.isOpen,
          C = y !== x;
        return E || C;
      }, l.componentDidUpdate = function (c, p) {
        process.env.NODE_ENV !== "production" && (LF(this.state, c, this.props), this.getMenuProps.called && !this.getMenuProps.suppressRefError && mV(this._menuNode, this.getMenuProps)), rO(this.props, "selectedItem") && this.props.selectedItemChanged(c.selectedItem, this.props.selectedItem) && this.internalSetState({
          type: KH,
          inputValue: this.props.itemToString(this.props.selectedItem)
        }), !this.avoidScrolling && this.shouldScroll(p, c) && this.scrollHighlightedItemIntoView(), this.updateStatus();
      }, l.componentWillUnmount = function () {
        this.cleanup();
      }, l.render = function () {
        var c = hV(this.props.children, id);
        this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
        var p = hV(c(this.getStateAndHelpers()));
        if (!p) return null;
        if (this.getRootProps.called || this.props.suppressRefError) return process.env.NODE_ENV !== "production" && !this.getRootProps.suppressRefError && !this.props.suppressRefError && q9(p, this.getRootProps), p;
        if (PH(p)) return /* @__PURE__ */FR(p, this.getRootProps(AH(p)));
        if (process.env.NODE_ENV !== "production") throw new Error("downshift: If you return a non-DOM element, you must apply the getRootProps function");
      }, i;
    }(oH);
    return t.defaultProps = {
      defaultHighlightedIndex: null,
      defaultIsOpen: !1,
      getA11yStatusMessage: L9,
      itemToString: function (e) {
        return e == null ? "" : (process.env.NODE_ENV !== "production" && j9(e) && !e.hasOwnProperty("toString") && console.warn("downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.", "The object that was passed:", e), String(e));
      },
      onStateChange: id,
      onInputValueChange: id,
      onUserAction: id,
      onChange: id,
      onSelect: id,
      onOuterClick: id,
      selectedItemChanged: function (e, i) {
        return e !== i;
      },
      environment: (/* istanbul ignore next (ssr) */
      typeof window > "u" ? void 0 : window),
      stateReducer: function (e, i) {
        return i;
      },
      suppressRefError: !1,
      scrollIntoView: OH
    }, t.stateChangeTypes = z9, t;
  }();
process.env.NODE_ENV !== "production" && (W9.propTypes = {
  children: Lt.func,
  defaultHighlightedIndex: Lt.number,
  defaultIsOpen: Lt.bool,
  initialHighlightedIndex: Lt.number,
  initialSelectedItem: Lt.any,
  initialInputValue: Lt.string,
  initialIsOpen: Lt.bool,
  getA11yStatusMessage: Lt.func,
  itemToString: Lt.func,
  onChange: Lt.func,
  onSelect: Lt.func,
  onStateChange: Lt.func,
  onInputValueChange: Lt.func,
  onUserAction: Lt.func,
  onOuterClick: Lt.func,
  selectedItemChanged: Lt.func,
  stateReducer: Lt.func,
  itemCount: Lt.number,
  id: Lt.string,
  environment: Lt.shape({
    addEventListener: Lt.func.isRequired,
    removeEventListener: Lt.func.isRequired,
    document: Lt.shape({
      createElement: Lt.func.isRequired,
      getElementById: Lt.func.isRequired,
      activeElement: Lt.any.isRequired,
      body: Lt.any.isRequired
    }).isRequired,
    Node: Lt.func.isRequired
  }),
  suppressRefError: Lt.bool,
  scrollIntoView: Lt.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: Lt.any,
  isOpen: Lt.bool,
  inputValue: Lt.string,
  highlightedIndex: Lt.number,
  labelId: Lt.string,
  inputId: Lt.string,
  menuId: Lt.string,
  getItemId: Lt.func
  /* eslint-enable react/no-unused-prop-types */
});
function mV(t, e) {
  var i = e.refKey;
  t || console.error('downshift: The ref prop "' + i + '" from getMenuProps was not applied correctly on your menu element.');
}
function q9(t, e) {
  var i = e.refKey,
    l = i !== "ref",
    c = !PH(t);
  c && !l && !uV.isForwardRef(t) ? console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps") : !c && l && console.error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + i + '"'), !uV.isForwardRef(t) && !AH(t)[i] && console.error('downshift: You must apply the ref prop "' + i + '" from getRootProps onto your root element.');
}
var ZH = {
  highlightedIndex: -1,
  isOpen: !1,
  selectedItem: null,
  inputValue: ""
};
function Y9(t, e, i) {
  var l = t.props,
    c = t.type,
    p = {};
  Object.keys(e).forEach(function (h) {
    G9(h, t, e, i), i[h] !== e[h] && (p[h] = i[h]);
  }), l.onStateChange && Object.keys(p).length && l.onStateChange(Jn({
    type: c
  }, p));
}
function G9(t, e, i, l) {
  var c = e.props,
    p = e.type,
    h = "on" + PF(t) + "Change";
  c[h] && l[t] !== void 0 && l[t] !== i[t] && c[h](Jn({
    type: p
  }, l));
}
function X9(t, e) {
  return e.changes;
}
var vV = UO(function (t, e) {
    FH(t, e);
  }, 200),
  K9 = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? NR : Rt,
  JH = "useId" in Nt ? function (t) {
    var e = t.id,
      i = t.labelId,
      l = t.menuId,
      c = t.getItemId,
      p = t.toggleButtonId,
      h = t.inputId,
      y = "downshift-" + Nt.useId();
    e || (e = y);
    var w = vt({
      labelId: i || e + "-label",
      menuId: l || e + "-menu",
      getItemId: c || function (x) {
        return e + "-item-" + x;
      },
      toggleButtonId: p || e + "-toggle-button",
      inputId: h || e + "-input"
    });
    return w.current;
  } : function (t) {
    var e = t.id,
      i = e === void 0 ? "downshift-" + LH() : e,
      l = t.labelId,
      c = t.menuId,
      p = t.getItemId,
      h = t.toggleButtonId,
      y = t.inputId,
      w = vt({
        labelId: l || i + "-label",
        menuId: c || i + "-menu",
        getItemId: p || function (x) {
          return i + "-item-" + x;
        },
        toggleButtonId: h || i + "-toggle-button",
        inputId: y || i + "-input"
      });
    return w.current;
  };
function e5(t, e, i, l) {
  var c, p;
  if (t === void 0) {
    if (e === void 0) throw new Error(l);
    c = i[e], p = e;
  } else p = e === void 0 ? i.indexOf(t) : e, c = t;
  return [c, p];
}
function Q9(t) {
  return /^\S{1}$/.test(t);
}
function PF(t) {
  return "" + t.slice(0, 1).toUpperCase() + t.slice(1);
}
function AF(t) {
  var e = vt(t);
  return e.current = t, e;
}
function t5(t, e, i, l) {
  var c = vt(),
    p = vt(),
    h = pn(function (D, I) {
      p.current = I, D = iR(D, I.props);
      var O = t(D, I),
        P = I.props.stateReducer(D, Jn({}, I, {
          changes: O
        }));
      return P;
    }, [t]),
    y = MW(h, e, i),
    w = y[0],
    x = y[1],
    E = AF(e),
    C = pn(function (D) {
      return x(Jn({
        props: E.current
      }, D));
    }, [E]),
    k = p.current;
  return Rt(function () {
    var D = iR(c.current, k == null ? void 0 : k.props),
      I = k && c.current && !l(D, w);
    I && Y9(k, D, w), c.current = w;
  }, [w, k, l]), [w, C];
}
function Z9(t, e, i, l) {
  var c = t5(t, e, i, l),
    p = c[0],
    h = c[1];
  return [iR(p, e), h];
}
var jT = {
  itemToString: function (t) {
    return t ? String(t) : "";
  },
  itemToKey: function (t) {
    return t;
  },
  stateReducer: X9,
  scrollIntoView: OH,
  environment: (/* istanbul ignore next (ssr) */
  typeof window > "u" ? void 0 : window)
};
function vb(t, e, i) {
  i === void 0 && (i = ZH);
  var l = t["default" + PF(e)];
  return l !== void 0 ? l : i[e];
}
function pE(t, e, i) {
  i === void 0 && (i = ZH);
  var l = t[e];
  if (l !== void 0) return l;
  var c = t["initial" + PF(e)];
  return c !== void 0 ? c : vb(t, e, i);
}
function n5(t) {
  var e = pE(t, "selectedItem"),
    i = pE(t, "isOpen"),
    l = J9(t),
    c = pE(t, "inputValue");
  return {
    highlightedIndex: l < 0 && e && i ? t.items.findIndex(function (p) {
      return t.itemToKey(p) === t.itemToKey(e);
    }) : l,
    isOpen: i,
    selectedItem: e,
    inputValue: c
  };
}
function qx(t, e, i) {
  var l = t.items,
    c = t.initialHighlightedIndex,
    p = t.defaultHighlightedIndex,
    h = t.isItemDisabled,
    y = t.itemToKey,
    w = e.selectedItem,
    x = e.highlightedIndex;
  return l.length === 0 ? -1 : c !== void 0 && x === c && !h(l[c], c) ? c : p !== void 0 && !h(l[p], p) ? p : w ? l.findIndex(function (E) {
    return y(w) === y(E);
  }) : i < 0 && !h(l[l.length - 1], l.length - 1) ? l.length - 1 : i > 0 && !h(l[0], 0) ? 0 : -1;
}
function r5(t, e, i) {
  var l = vt({
    isMouseDown: !1,
    isTouchMove: !1,
    isTouchEnd: !1
  });
  return Rt(function () {
    if (!t) return id;
    var c = i.map(function (E) {
      return E.current;
    });
    function p() {
      l.current.isTouchEnd = !1, l.current.isMouseDown = !0;
    }
    function h(E) {
      l.current.isMouseDown = !1, aO(E.target, c, t) || e();
    }
    function y() {
      l.current.isTouchEnd = !1, l.current.isTouchMove = !1;
    }
    function w() {
      l.current.isTouchMove = !0;
    }
    function x(E) {
      l.current.isTouchEnd = !0, !l.current.isTouchMove && !aO(E.target, c, t, !1) && e();
    }
    return t.addEventListener("mousedown", p), t.addEventListener("mouseup", h), t.addEventListener("touchstart", y), t.addEventListener("touchmove", w), t.addEventListener("touchend", x), function () {
      t.removeEventListener("mousedown", p), t.removeEventListener("mouseup", h), t.removeEventListener("touchstart", y), t.removeEventListener("touchmove", w), t.removeEventListener("touchend", x);
    };
  }, [i, t, e]), l.current;
}
var jF = function () {
  return id;
};
process.env.NODE_ENV !== "production" && (jF = function () {
  for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
  var l = vt(e.reduce(function (p, h) {
    return p[h] = {}, p;
  }, {}));
  Rt(function () {
    Object.keys(l.current).forEach(function (p) {
      var h = l.current[p];
      if (!Object.keys(h).length) {
        console.error("downshift: You forgot to call the " + p + " getter function on your component / element.");
        return;
      }
      var y = h.suppressRefError,
        w = h.refKey,
        x = h.elementRef;
      y || x != null && x.current || console.error('downshift: The ref prop "' + w + '" from ' + p + " was not applied correctly on your element.");
    });
  }, []);
  var c = pn(function (p, h, y, w) {
    l.current[p] = {
      suppressRefError: h,
      refKey: y,
      elementRef: w
    };
  }, []);
  return c;
});
function i5(t, e, i, l) {
  l === void 0 && (l = {});
  var c = l.document,
    p = HO();
  Rt(function () {
    if (!(!t || p || !c)) {
      var h = t(e);
      vV(h, c);
    }
  }, i), Rt(function () {
    return function () {
      vV.cancel(), N9(c);
    };
  }, [c]);
}
function a5(t) {
  var e = t.highlightedIndex,
    i = t.isOpen,
    l = t.itemRefs,
    c = t.getItemNodeFromIndex,
    p = t.menuElement,
    h = t.scrollIntoView,
    y = vt(!0);
  return K9(function () {
    e < 0 || !i || !Object.keys(l.current).length || (y.current === !1 ? y.current = !0 : h(c(e), p));
  }, [e]), y;
}
var FF = id;
process.env.NODE_ENV !== "production" && (FF = function (t) {
  var e = t.props,
    i = t.state,
    l = vt(e),
    c = HO();
  Rt(function () {
    c || (LF(i, l.current, e), l.current = e);
  }, [i, e, c]);
});
function oO(t, e, i) {
  var l;
  i === void 0 && (i = !0);
  var c = ((l = t.items) == null ? void 0 : l.length) && e >= 0;
  return Jn({
    isOpen: !1,
    highlightedIndex: -1
  }, c && Jn({
    selectedItem: t.items[e],
    isOpen: vb(t, "isOpen"),
    highlightedIndex: vb(t, "highlightedIndex")
  }, i && {
    inputValue: t.itemToString(t.items[e])
  }));
}
function o5(t, e) {
  return t.isOpen === e.isOpen && t.inputValue === e.inputValue && t.highlightedIndex === e.highlightedIndex && t.selectedItem === e.selectedItem;
}
function HO() {
  var t = Nt.useRef(!0);
  return Nt.useEffect(function () {
    return t.current = !1, function () {
      t.current = !0;
    };
  }, []), t.current;
}
function sO(t) {
  var e = vb(t, "highlightedIndex");
  return e > -1 && t.isItemDisabled(t.items[e], e) ? -1 : e;
}
function J9(t) {
  var e = pE(t, "highlightedIndex");
  return e > -1 && t.isItemDisabled(t.items[e], e) ? -1 : e;
}
var zM = {
    environment: Lt.shape({
      addEventListener: Lt.func.isRequired,
      removeEventListener: Lt.func.isRequired,
      document: Lt.shape({
        createElement: Lt.func.isRequired,
        getElementById: Lt.func.isRequired,
        activeElement: Lt.any.isRequired,
        body: Lt.any.isRequired
      }).isRequired,
      Node: Lt.func.isRequired
    }),
    itemToString: Lt.func,
    itemToKey: Lt.func,
    stateReducer: Lt.func
  },
  s5 = Jn({}, zM, {
    getA11yStatusMessage: Lt.func,
    highlightedIndex: Lt.number,
    defaultHighlightedIndex: Lt.number,
    initialHighlightedIndex: Lt.number,
    isOpen: Lt.bool,
    defaultIsOpen: Lt.bool,
    initialIsOpen: Lt.bool,
    selectedItem: Lt.any,
    initialSelectedItem: Lt.any,
    defaultSelectedItem: Lt.any,
    id: Lt.string,
    labelId: Lt.string,
    menuId: Lt.string,
    getItemId: Lt.func,
    toggleButtonId: Lt.string,
    onSelectedItemChange: Lt.func,
    onHighlightedIndexChange: Lt.func,
    onStateChange: Lt.func,
    onIsOpenChange: Lt.func,
    scrollIntoView: Lt.func
  });
function l5(t, e, i) {
  var l = e.type,
    c = e.props,
    p;
  switch (l) {
    case i.ItemMouseMove:
      p = {
        highlightedIndex: e.disabled ? -1 : e.index
      };
      break;
    case i.MenuMouseLeave:
      p = {
        highlightedIndex: -1
      };
      break;
    case i.ToggleButtonClick:
    case i.FunctionToggleMenu:
      p = {
        isOpen: !t.isOpen,
        highlightedIndex: t.isOpen ? -1 : qx(c, t, 0)
      };
      break;
    case i.FunctionOpenMenu:
      p = {
        isOpen: !0,
        highlightedIndex: qx(c, t, 0)
      };
      break;
    case i.FunctionCloseMenu:
      p = {
        isOpen: !1
      };
      break;
    case i.FunctionSetHighlightedIndex:
      p = {
        highlightedIndex: c.isItemDisabled(c.items[e.highlightedIndex], e.highlightedIndex) ? -1 : e.highlightedIndex
      };
      break;
    case i.FunctionSetInputValue:
      p = {
        inputValue: e.inputValue
      };
      break;
    case i.FunctionReset:
      p = {
        highlightedIndex: sO(c),
        isOpen: vb(c, "isOpen"),
        selectedItem: vb(c, "selectedItem"),
        inputValue: vb(c, "inputValue")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return Jn({}, t, p);
}
function e7(t) {
  for (var e = t.keysSoFar, i = t.highlightedIndex, l = t.items, c = t.itemToString, p = t.isItemDisabled, h = e.toLowerCase(), y = 0; y < l.length; y++) {
    var w = (y + i + (e.length < 2 ? 1 : 0)) % l.length,
      x = l[w];
    if (x !== void 0 && c(x).toLowerCase().startsWith(h) && !p(x, w)) return w;
  }
  return i;
}
var t7 = xE(xE({}, s5), {
    items: Lt.array.isRequired,
    isItemDisabled: Lt.func
  }),
  n7 = xE(xE({}, jT), {
    isItemDisabled: function () {
      return !1;
    }
  }),
  u5 = id;
process.env.NODE_ENV !== "production" && (u5 = function (t, e) {
  Lt.checkPropTypes(t7, t, "prop", e.name);
});
var VM = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 0,
  NF = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_arrow_down__" : 1,
  zF = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_arrow_up__" : 2,
  lO = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_character__" : 3,
  VF = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_escape__" : 4,
  BF = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_home__" : 5,
  UF = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_end__" : 6,
  HF = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_enter__" : 7,
  $F = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_space_button__" : 8,
  WF = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_page_up__" : 9,
  qF = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_page_down__" : 10,
  uO = process.env.NODE_ENV !== "production" ? "__togglebutton_blur__" : 11,
  c5 = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 12,
  d5 = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 13,
  YF = process.env.NODE_ENV !== "production" ? "__item_click__" : 14,
  f5 = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15,
  p5 = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16,
  h5 = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17,
  m5 = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18,
  GF = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19,
  Ej = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20,
  v5 = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21,
  g5 = /* @__PURE__ */Object.freeze({
    __proto__: null,
    FunctionCloseMenu: h5,
    FunctionOpenMenu: p5,
    FunctionReset: v5,
    FunctionSelectItem: GF,
    FunctionSetHighlightedIndex: m5,
    FunctionSetInputValue: Ej,
    FunctionToggleMenu: f5,
    ItemClick: YF,
    ItemMouseMove: d5,
    MenuMouseLeave: c5,
    ToggleButtonBlur: uO,
    ToggleButtonClick: VM,
    ToggleButtonKeyDownArrowDown: NF,
    ToggleButtonKeyDownArrowUp: zF,
    ToggleButtonKeyDownCharacter: lO,
    ToggleButtonKeyDownEnd: UF,
    ToggleButtonKeyDownEnter: HF,
    ToggleButtonKeyDownEscape: VF,
    ToggleButtonKeyDownHome: BF,
    ToggleButtonKeyDownPageDown: qF,
    ToggleButtonKeyDownPageUp: WF,
    ToggleButtonKeyDownSpaceButton: $F
  });
function r7(t, e) {
  var i,
    l = e.type,
    c = e.props,
    p = e.altKey,
    h;
  switch (l) {
    case YF:
      h = {
        isOpen: vb(c, "isOpen"),
        highlightedIndex: sO(c),
        selectedItem: c.items[e.index]
      };
      break;
    case lO:
      {
        var y = e.key,
          w = "" + t.inputValue + y,
          x = !t.isOpen && t.selectedItem ? c.items.findIndex(function (D) {
            return c.itemToKey(D) === c.itemToKey(t.selectedItem);
          }) : t.highlightedIndex,
          E = e7({
            keysSoFar: w,
            highlightedIndex: x,
            items: c.items,
            itemToString: c.itemToString,
            isItemDisabled: c.isItemDisabled
          });
        h = {
          inputValue: w,
          highlightedIndex: E,
          isOpen: !0
        };
      }
      break;
    case NF:
      {
        var C = t.isOpen ? $m(t.highlightedIndex, 1, c.items, c.isItemDisabled) : p && t.selectedItem == null ? -1 : qx(c, t, 1);
        h = {
          highlightedIndex: C,
          isOpen: !0
        };
      }
      break;
    case zF:
      if (t.isOpen && p) h = oO(c, t.highlightedIndex, !1);else {
        var k = t.isOpen ? $m(t.highlightedIndex, -1, c.items, c.isItemDisabled) : qx(c, t, -1);
        h = {
          highlightedIndex: k,
          isOpen: !0
        };
      }
      break;
    // only triggered when menu is open.
    case HF:
    case $F:
      h = oO(c, t.highlightedIndex, !1);
      break;
    case BF:
      h = {
        highlightedIndex: iw(0, !1, c.items, c.isItemDisabled),
        isOpen: !0
      };
      break;
    case UF:
      h = {
        highlightedIndex: iw(c.items.length - 1, !0, c.items, c.isItemDisabled),
        isOpen: !0
      };
      break;
    case WF:
      h = {
        highlightedIndex: $m(t.highlightedIndex, -10, c.items, c.isItemDisabled)
      };
      break;
    case qF:
      h = {
        highlightedIndex: $m(t.highlightedIndex, 10, c.items, c.isItemDisabled)
      };
      break;
    case VF:
      h = {
        isOpen: !1,
        highlightedIndex: -1
      };
      break;
    case uO:
      h = Jn({
        isOpen: !1,
        highlightedIndex: -1
      }, t.highlightedIndex >= 0 && ((i = c.items) == null ? void 0 : i.length) && {
        selectedItem: c.items[t.highlightedIndex]
      });
      break;
    case GF:
      h = {
        selectedItem: e.selectedItem
      };
      break;
    default:
      return l5(t, e, g5);
  }
  return Jn({}, t, h);
}
var i7 = ["onClick"],
  a7 = ["onMouseLeave", "refKey", "ref"],
  o7 = ["onBlur", "onClick", "onPress", "onKeyDown", "refKey", "ref"],
  s7 = ["item", "index", "onMouseMove", "onClick", "onMouseDown", "onPress", "refKey", "disabled", "ref"];
jp.stateChangeTypes = g5;
function jp(t) {
  t === void 0 && (t = {}), u5(t, jp);
  var e = Jn({}, n7, t),
    i = e.scrollIntoView,
    l = e.environment,
    c = e.getA11yStatusMessage,
    p = Z9(r7, e, n5, o5),
    h = p[0],
    y = p[1],
    w = h.isOpen,
    x = h.highlightedIndex,
    E = h.selectedItem,
    C = h.inputValue,
    k = vt(null),
    D = vt(null),
    I = vt({}),
    O = vt(null),
    P = JH(e),
    N = AF({
      state: h,
      props: e
    }),
    L = pn(function ($) {
      return I.current[P.getItemId($)];
    }, [P]);
  i5(c, h, [w, x, E, C], l);
  var F = a5({
    menuElement: D.current,
    highlightedIndex: x,
    isOpen: w,
    itemRefs: I,
    scrollIntoView: i,
    getItemNodeFromIndex: L
  });
  Rt(function () {
    return O.current = UO(function ($) {
      $({
        type: Ej,
        inputValue: ""
      });
    }, 500), function () {
      O.current.cancel();
    };
  }, []), Rt(function () {
    C && O.current(y);
  }, [y, C]), FF({
    props: e,
    state: h
  }), Rt(function () {
    var $ = pE(e, "isOpen");
    $ && k.current && k.current.focus();
  }, []);
  var j = r5(l, pn(function () {
      N.current.state.isOpen && y({
        type: uO
      });
    }, [y, N]), ci(function () {
      return [D, k];
    }, [D.current, k.current])),
    V = jF("getMenuProps", "getToggleButtonProps");
  Rt(function () {
    w || (I.current = {});
  }, [w]);
  var K = ci(function () {
      return {
        ArrowDown: function ($) {
          $.preventDefault(), y({
            type: NF,
            altKey: $.altKey
          });
        },
        ArrowUp: function ($) {
          $.preventDefault(), y({
            type: zF,
            altKey: $.altKey
          });
        },
        Home: function ($) {
          $.preventDefault(), y({
            type: BF
          });
        },
        End: function ($) {
          $.preventDefault(), y({
            type: UF
          });
        },
        Escape: function () {
          N.current.state.isOpen && y({
            type: VF
          });
        },
        Enter: function ($) {
          $.preventDefault(), y({
            type: N.current.state.isOpen ? HF : VM
          });
        },
        PageUp: function ($) {
          N.current.state.isOpen && ($.preventDefault(), y({
            type: WF
          }));
        },
        PageDown: function ($) {
          N.current.state.isOpen && ($.preventDefault(), y({
            type: qF
          }));
        },
        " ": function ($) {
          $.preventDefault();
          var le = N.current.state;
          if (!le.isOpen) {
            y({
              type: VM
            });
            return;
          }
          le.inputValue ? y({
            type: lO,
            key: " "
          }) : y({
            type: $F
          });
        }
      };
    }, [y, N]),
    G = pn(function () {
      y({
        type: f5
      });
    }, [y]),
    Q = pn(function () {
      y({
        type: h5
      });
    }, [y]),
    te = pn(function () {
      y({
        type: p5
      });
    }, [y]),
    ie = pn(function ($) {
      y({
        type: m5,
        highlightedIndex: $
      });
    }, [y]),
    Y = pn(function ($) {
      y({
        type: GF,
        selectedItem: $
      });
    }, [y]),
    ee = pn(function () {
      y({
        type: v5
      });
    }, [y]),
    oe = pn(function ($) {
      y({
        type: Ej,
        inputValue: $
      });
    }, [y]),
    ne = pn(function ($) {
      var le = $ === void 0 ? {} : $,
        H = le.onClick,
        ce = ip(le, i7),
        de = function () {
          var Ce;
          (Ce = k.current) == null || Ce.focus();
        };
      return Jn({
        id: P.labelId,
        htmlFor: P.toggleButtonId,
        onClick: oa(H, de)
      }, ce);
    }, [P]),
    se = pn(function ($, le) {
      var H,
        ce = $ === void 0 ? {} : $,
        de = ce.onMouseLeave,
        Ce = ce.refKey,
        Ee = Ce === void 0 ? "ref" : Ce,
        fe = ce.ref,
        xe = ip(ce, a7),
        we = le === void 0 ? {} : le,
        ve = we.suppressRefError,
        Te = ve === void 0 ? !1 : ve,
        ze = function () {
          y({
            type: c5
          });
        };
      return V("getMenuProps", Te, Ee, D), Jn((H = {}, H[Ee] = pb(fe, function (Xe) {
        D.current = Xe;
      }), H.id = P.menuId, H.role = "listbox", H["aria-labelledby"] = xe && xe["aria-label"] ? void 0 : "" + P.labelId, H.onMouseLeave = oa(de, ze), H), xe);
    }, [y, V, P]),
    ue = pn(function ($, le) {
      var H,
        ce = $ === void 0 ? {} : $,
        de = ce.onBlur,
        Ce = ce.onClick;
      ce.onPress;
      var Ee = ce.onKeyDown,
        fe = ce.refKey,
        xe = fe === void 0 ? "ref" : fe,
        we = ce.ref,
        ve = ip(ce, o7),
        Te = le === void 0 ? {} : le,
        ze = Te.suppressRefError,
        Xe = ze === void 0 ? !1 : ze,
        ye = N.current.state,
        qe = function () {
          y({
            type: VM
          });
        },
        Ae = function () {
          ye.isOpen && !j.isMouseDown && y({
            type: uO
          });
        },
        Mt = function (un) {
          var gt = iO(un);
          gt && K[gt] ? K[gt](un) : Q9(gt) && y({
            type: lO,
            key: gt
          });
        },
        Ft = Jn((H = {}, H[xe] = pb(we, function (un) {
          k.current = un;
        }), H["aria-activedescendant"] = ye.isOpen && ye.highlightedIndex > -1 ? P.getItemId(ye.highlightedIndex) : "", H["aria-controls"] = P.menuId, H["aria-expanded"] = N.current.state.isOpen, H["aria-haspopup"] = "listbox", H["aria-labelledby"] = ve && ve["aria-label"] ? void 0 : "" + P.labelId, H.id = P.toggleButtonId, H.role = "combobox", H.tabIndex = 0, H.onBlur = oa(de, Ae), H), ve);
      return ve.disabled || (Ft.onClick = oa(Ce, qe), Ft.onKeyDown = oa(Ee, Mt)), V("getToggleButtonProps", Xe, xe, k), Ft;
    }, [y, P, N, j, V, K]),
    W = pn(function ($) {
      var le,
        H = $ === void 0 ? {} : $,
        ce = H.item,
        de = H.index,
        Ce = H.onMouseMove,
        Ee = H.onClick,
        fe = H.onMouseDown;
      H.onPress;
      var xe = H.refKey,
        we = xe === void 0 ? "ref" : xe,
        ve = H.disabled,
        Te = H.ref,
        ze = ip(H, s7);
      ve !== void 0 && console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useSelect.');
      var Xe = N.current,
        ye = Xe.state,
        qe = Xe.props,
        Ae = e5(ce, de, qe.items, "Pass either item or index to getItemProps!"),
        Mt = Ae[0],
        Ft = Ae[1],
        un = qe.isItemDisabled(Mt, Ft),
        gt = function () {
          j.isTouchEnd || Ft === ye.highlightedIndex || (F.current = !1, y({
            type: d5,
            index: Ft,
            disabled: un
          }));
        },
        Pt = function () {
          y({
            type: YF,
            index: Ft
          });
        },
        St = function (Kt) {
          return Kt.preventDefault();
        },
        Dt = Jn((le = {}, le[we] = pb(Te, function (Kt) {
          Kt && (I.current[P.getItemId(Ft)] = Kt);
        }), le["aria-disabled"] = un, le["aria-selected"] = Mt === ye.selectedItem, le.id = P.getItemId(Ft), le.role = "option", le), ze);
      return un || (Dt.onClick = oa(Ee, Pt)), Dt.onMouseMove = oa(Ce, gt), Dt.onMouseDown = oa(fe, St), Dt;
    }, [N, P, j, F, y]);
  return {
    // prop getters.
    getToggleButtonProps: ue,
    getLabelProps: ne,
    getMenuProps: se,
    getItemProps: W,
    // actions.
    toggleMenu: G,
    openMenu: te,
    closeMenu: Q,
    setHighlightedIndex: ie,
    selectItem: Y,
    reset: ee,
    setInputValue: oe,
    // state.
    highlightedIndex: x,
    isOpen: w,
    selectedItem: E,
    inputValue: C
  };
}
var XF = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_down__" : 0,
  KF = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_up__" : 1,
  QF = process.env.NODE_ENV !== "production" ? "__input_keydown_escape__" : 2,
  ZF = process.env.NODE_ENV !== "production" ? "__input_keydown_home__" : 3,
  JF = process.env.NODE_ENV !== "production" ? "__input_keydown_end__" : 4,
  eN = process.env.NODE_ENV !== "production" ? "__input_keydown_page_up__" : 5,
  tN = process.env.NODE_ENV !== "production" ? "__input_keydown_page_down__" : 6,
  nN = process.env.NODE_ENV !== "production" ? "__input_keydown_enter__" : 7,
  rN = process.env.NODE_ENV !== "production" ? "__input_change__" : 8,
  cO = process.env.NODE_ENV !== "production" ? "__input_blur__" : 9,
  iN = process.env.NODE_ENV !== "production" ? "__input_click__" : 10,
  y5 = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 11,
  b5 = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 12,
  aN = process.env.NODE_ENV !== "production" ? "__item_click__" : 13,
  w5 = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 14,
  _5 = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15,
  x5 = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16,
  S5 = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17,
  E5 = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18,
  oN = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19,
  C5 = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20,
  k5 = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21,
  sN = process.env.NODE_ENV !== "production" ? "__controlled_prop_updated_selected_item__" : 22,
  T5 = /* @__PURE__ */Object.freeze({
    __proto__: null,
    ControlledPropUpdatedSelectedItem: sN,
    FunctionCloseMenu: S5,
    FunctionOpenMenu: x5,
    FunctionReset: k5,
    FunctionSelectItem: oN,
    FunctionSetHighlightedIndex: E5,
    FunctionSetInputValue: C5,
    FunctionToggleMenu: _5,
    InputBlur: cO,
    InputChange: rN,
    InputClick: iN,
    InputKeyDownArrowDown: XF,
    InputKeyDownArrowUp: KF,
    InputKeyDownEnd: JF,
    InputKeyDownEnter: nN,
    InputKeyDownEscape: QF,
    InputKeyDownHome: ZF,
    InputKeyDownPageDown: tN,
    InputKeyDownPageUp: eN,
    ItemClick: aN,
    ItemMouseMove: b5,
    MenuMouseLeave: y5,
    ToggleButtonClick: w5
  });
function l7(t) {
  var e = n5(t),
    i = e.selectedItem,
    l = e.inputValue;
  return l === "" && i && t.defaultInputValue === void 0 && t.initialInputValue === void 0 && t.inputValue === void 0 && (l = t.itemToString(i)), Jn({}, e, {
    inputValue: l
  });
}
var u7 = Jn({}, s5, {
  items: Lt.array.isRequired,
  isItemDisabled: Lt.func,
  inputValue: Lt.string,
  defaultInputValue: Lt.string,
  initialInputValue: Lt.string,
  inputId: Lt.string,
  onInputValueChange: Lt.func
});
function c7(t, e, i, l) {
  var c = vt(),
    p = t5(t, e, i, l),
    h = p[0],
    y = p[1],
    w = HO();
  return Rt(function () {
    if (rO(e, "selectedItem")) {
      if (!w) {
        var x = e.itemToKey(e.selectedItem) !== e.itemToKey(c.current);
        x && y({
          type: sN,
          inputValue: e.itemToString(e.selectedItem)
        });
      }
      c.current = h.selectedItem === c.current ? e.selectedItem : h.selectedItem;
    }
  }, [h.selectedItem, e.selectedItem]), [iR(h, e), y];
}
var R5 = id;
process.env.NODE_ENV !== "production" && (R5 = function (t, e) {
  Lt.checkPropTypes(u7, t, "prop", e.name);
});
var d7 = Jn({}, jT, {
  isItemDisabled: function () {
    return !1;
  }
});
function f7(t, e) {
  var i,
    l = e.type,
    c = e.props,
    p = e.altKey,
    h;
  switch (l) {
    case aN:
      h = {
        isOpen: vb(c, "isOpen"),
        highlightedIndex: sO(c),
        selectedItem: c.items[e.index],
        inputValue: c.itemToString(c.items[e.index])
      };
      break;
    case XF:
      t.isOpen ? h = {
        highlightedIndex: $m(t.highlightedIndex, 1, c.items, c.isItemDisabled, !0)
      } : h = {
        highlightedIndex: p && t.selectedItem == null ? -1 : qx(c, t, 1),
        isOpen: c.items.length >= 0
      };
      break;
    case KF:
      t.isOpen ? p ? h = oO(c, t.highlightedIndex) : h = {
        highlightedIndex: $m(t.highlightedIndex, -1, c.items, c.isItemDisabled, !0)
      } : h = {
        highlightedIndex: qx(c, t, -1),
        isOpen: c.items.length >= 0
      };
      break;
    case nN:
      h = oO(c, t.highlightedIndex);
      break;
    case QF:
      h = Jn({
        isOpen: !1,
        highlightedIndex: -1
      }, !t.isOpen && {
        selectedItem: null,
        inputValue: ""
      });
      break;
    case eN:
      h = {
        highlightedIndex: $m(t.highlightedIndex, -10, c.items, c.isItemDisabled, !0)
      };
      break;
    case tN:
      h = {
        highlightedIndex: $m(t.highlightedIndex, 10, c.items, c.isItemDisabled, !0)
      };
      break;
    case ZF:
      h = {
        highlightedIndex: iw(0, !1, c.items, c.isItemDisabled)
      };
      break;
    case JF:
      h = {
        highlightedIndex: iw(c.items.length - 1, !0, c.items, c.isItemDisabled)
      };
      break;
    case cO:
      h = Jn({
        isOpen: !1,
        highlightedIndex: -1
      }, t.highlightedIndex >= 0 && ((i = c.items) == null ? void 0 : i.length) && e.selectItem && {
        selectedItem: c.items[t.highlightedIndex],
        inputValue: c.itemToString(c.items[t.highlightedIndex])
      });
      break;
    case rN:
      h = {
        isOpen: !0,
        highlightedIndex: sO(c),
        inputValue: e.inputValue
      };
      break;
    case iN:
      h = {
        isOpen: !t.isOpen,
        highlightedIndex: t.isOpen ? -1 : qx(c, t, 0)
      };
      break;
    case oN:
      h = {
        selectedItem: e.selectedItem,
        inputValue: c.itemToString(e.selectedItem)
      };
      break;
    case sN:
      h = {
        inputValue: e.inputValue
      };
      break;
    default:
      return l5(t, e, T5);
  }
  return Jn({}, t, h);
}
var p7 = ["onMouseLeave", "refKey", "ref"],
  h7 = ["item", "index", "refKey", "ref", "onMouseMove", "onMouseDown", "onClick", "onPress", "disabled"],
  m7 = ["onClick", "onPress", "refKey", "ref"],
  v7 = ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "onClick", "refKey", "ref"];
iE.stateChangeTypes = T5;
function iE(t) {
  t === void 0 && (t = {}), R5(t, iE);
  var e = Jn({}, d7, t),
    i = e.items,
    l = e.scrollIntoView,
    c = e.environment,
    p = e.getA11yStatusMessage,
    h = c7(f7, e, l7, o5),
    y = h[0],
    w = h[1],
    x = y.isOpen,
    E = y.highlightedIndex,
    C = y.selectedItem,
    k = y.inputValue,
    D = vt(null),
    I = vt({}),
    O = vt(null),
    P = vt(null),
    N = HO(),
    L = JH(e),
    F = vt(),
    j = AF({
      state: y,
      props: e
    }),
    V = pn(function (de) {
      return I.current[L.getItemId(de)];
    }, [L]);
  i5(p, y, [x, E, C, k], c);
  var K = a5({
    menuElement: D.current,
    highlightedIndex: E,
    isOpen: x,
    itemRefs: I,
    scrollIntoView: l,
    getItemNodeFromIndex: V
  });
  FF({
    props: e,
    state: y
  }), Rt(function () {
    var de = pE(e, "isOpen");
    de && O.current && O.current.focus();
  }, []), Rt(function () {
    N || (F.current = i.length);
  });
  var G = r5(c, pn(function () {
      j.current.state.isOpen && w({
        type: cO,
        selectItem: !1
      });
    }, [w, j]), ci(function () {
      return [D, P, O];
    }, [D.current, P.current, O.current])),
    Q = jF("getInputProps", "getMenuProps");
  Rt(function () {
    x || (I.current = {});
  }, [x]), Rt(function () {
    var de;
    !x || !(c != null && c.document) || !(O != null && (de = O.current) != null && de.focus) || c.document.activeElement !== O.current && O.current.focus();
  }, [x, c]);
  var te = ci(function () {
      return {
        ArrowDown: function (de) {
          de.preventDefault(), w({
            type: XF,
            altKey: de.altKey
          });
        },
        ArrowUp: function (de) {
          de.preventDefault(), w({
            type: KF,
            altKey: de.altKey
          });
        },
        Home: function (de) {
          j.current.state.isOpen && (de.preventDefault(), w({
            type: ZF
          }));
        },
        End: function (de) {
          j.current.state.isOpen && (de.preventDefault(), w({
            type: JF
          }));
        },
        Escape: function (de) {
          var Ce = j.current.state;
          (Ce.isOpen || Ce.inputValue || Ce.selectedItem || Ce.highlightedIndex > -1) && (de.preventDefault(), w({
            type: QF
          }));
        },
        Enter: function (de) {
          var Ce = j.current.state;
          !Ce.isOpen || de.which === 229 || (de.preventDefault(), w({
            type: nN
          }));
        },
        PageUp: function (de) {
          j.current.state.isOpen && (de.preventDefault(), w({
            type: eN
          }));
        },
        PageDown: function (de) {
          j.current.state.isOpen && (de.preventDefault(), w({
            type: tN
          }));
        }
      };
    }, [w, j]),
    ie = pn(function (de) {
      return Jn({
        id: L.labelId,
        htmlFor: L.inputId
      }, de);
    }, [L]),
    Y = pn(function (de, Ce) {
      var Ee,
        fe = de === void 0 ? {} : de,
        xe = fe.onMouseLeave,
        we = fe.refKey,
        ve = we === void 0 ? "ref" : we,
        Te = fe.ref,
        ze = ip(fe, p7),
        Xe = Ce === void 0 ? {} : Ce,
        ye = Xe.suppressRefError,
        qe = ye === void 0 ? !1 : ye;
      return Q("getMenuProps", qe, ve, D), Jn((Ee = {}, Ee[ve] = pb(Te, function (Ae) {
        D.current = Ae;
      }), Ee.id = L.menuId, Ee.role = "listbox", Ee["aria-labelledby"] = ze && ze["aria-label"] ? void 0 : "" + L.labelId, Ee.onMouseLeave = oa(xe, function () {
        w({
          type: y5
        });
      }), Ee), ze);
    }, [w, Q, L]),
    ee = pn(function (de) {
      var Ce,
        Ee,
        fe = de === void 0 ? {} : de,
        xe = fe.item,
        we = fe.index,
        ve = fe.refKey,
        Te = ve === void 0 ? "ref" : ve,
        ze = fe.ref,
        Xe = fe.onMouseMove,
        ye = fe.onMouseDown,
        qe = fe.onClick;
      fe.onPress;
      var Ae = fe.disabled,
        Mt = ip(fe, h7);
      Ae !== void 0 && console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useCombobox.');
      var Ft = j.current,
        un = Ft.props,
        gt = Ft.state,
        Pt = e5(xe, we, un.items, "Pass either item or index to getItemProps!"),
        St = Pt[0],
        Dt = Pt[1],
        Kt = un.isItemDisabled(St, Dt),
        hn = "onClick",
        Ot = qe,
        Et = function () {
          G.isTouchEnd || Dt === gt.highlightedIndex || (K.current = !1, w({
            type: b5,
            index: Dt,
            disabled: Kt
          }));
        },
        Vt = function () {
          w({
            type: aN,
            index: Dt
          });
        },
        Xt = function (vn) {
          return vn.preventDefault();
        };
      return Jn((Ce = {}, Ce[Te] = pb(ze, function (vn) {
        vn && (I.current[L.getItemId(Dt)] = vn);
      }), Ce["aria-disabled"] = Kt, Ce["aria-selected"] = Dt === gt.highlightedIndex, Ce.id = L.getItemId(Dt), Ce.role = "option", Ce), !Kt && (Ee = {}, Ee[hn] = oa(Ot, Vt), Ee), {
        onMouseMove: oa(Xe, Et),
        onMouseDown: oa(ye, Xt)
      }, Mt);
    }, [w, L, j, G, K]),
    oe = pn(function (de) {
      var Ce,
        Ee = de === void 0 ? {} : de,
        fe = Ee.onClick;
      Ee.onPress;
      var xe = Ee.refKey,
        we = xe === void 0 ? "ref" : xe,
        ve = Ee.ref,
        Te = ip(Ee, m7),
        ze = j.current.state,
        Xe = function () {
          w({
            type: w5
          });
        };
      return Jn((Ce = {}, Ce[we] = pb(ve, function (ye) {
        P.current = ye;
      }), Ce["aria-controls"] = L.menuId, Ce["aria-expanded"] = ze.isOpen, Ce.id = L.toggleButtonId, Ce.tabIndex = -1, Ce), !Te.disabled && Jn({}, {
        onClick: oa(fe, Xe)
      }), Te);
    }, [w, j, L]),
    ne = pn(function (de, Ce) {
      var Ee,
        fe = de === void 0 ? {} : de,
        xe = fe.onKeyDown,
        we = fe.onChange,
        ve = fe.onInput,
        Te = fe.onBlur;
      fe.onChangeText;
      var ze = fe.onClick,
        Xe = fe.refKey,
        ye = Xe === void 0 ? "ref" : Xe,
        qe = fe.ref,
        Ae = ip(fe, v7),
        Mt = Ce === void 0 ? {} : Ce,
        Ft = Mt.suppressRefError,
        un = Ft === void 0 ? !1 : Ft;
      Q("getInputProps", un, ye, O);
      var gt = j.current.state,
        Pt = function (Vt) {
          var Xt = iO(Vt);
          Xt && te[Xt] && te[Xt](Vt);
        },
        St = function (Vt) {
          w({
            type: rN,
            inputValue: Vt.target.value
          });
        },
        Dt = function (Vt) {
          if (c != null && c.document && gt.isOpen && !G.isMouseDown) {
            var Xt = Vt.relatedTarget === null && c.document.activeElement !== c.document.body;
            w({
              type: cO,
              selectItem: !Xt
            });
          }
        },
        Kt = function () {
          w({
            type: iN
          });
        },
        hn = "onChange",
        Ot = {};
      if (!Ae.disabled) {
        var Et;
        Ot = (Et = {}, Et[hn] = oa(we, ve, St), Et.onKeyDown = oa(xe, Pt), Et.onBlur = oa(Te, Dt), Et.onClick = oa(ze, Kt), Et);
      }
      return Jn((Ee = {}, Ee[ye] = pb(qe, function (Vt) {
        O.current = Vt;
      }), Ee["aria-activedescendant"] = gt.isOpen && gt.highlightedIndex > -1 ? L.getItemId(gt.highlightedIndex) : "", Ee["aria-autocomplete"] = "list", Ee["aria-controls"] = L.menuId, Ee["aria-expanded"] = gt.isOpen, Ee["aria-labelledby"] = Ae && Ae["aria-label"] ? void 0 : L.labelId, Ee.autoComplete = "off", Ee.id = L.inputId, Ee.role = "combobox", Ee.value = gt.inputValue, Ee), Ot, Ae);
    }, [w, L, c, te, j, G, Q]),
    se = pn(function () {
      w({
        type: _5
      });
    }, [w]),
    ue = pn(function () {
      w({
        type: S5
      });
    }, [w]),
    W = pn(function () {
      w({
        type: x5
      });
    }, [w]),
    $ = pn(function (de) {
      w({
        type: E5,
        highlightedIndex: de
      });
    }, [w]),
    le = pn(function (de) {
      w({
        type: oN,
        selectedItem: de
      });
    }, [w]),
    H = pn(function (de) {
      w({
        type: C5,
        inputValue: de
      });
    }, [w]),
    ce = pn(function () {
      w({
        type: k5
      });
    }, [w]);
  return {
    // prop getters.
    getItemProps: ee,
    getLabelProps: ie,
    getMenuProps: Y,
    getInputProps: ne,
    getToggleButtonProps: oe,
    // actions.
    toggleMenu: se,
    openMenu: W,
    closeMenu: ue,
    setHighlightedIndex: $,
    setInputValue: H,
    selectItem: le,
    reset: ce,
    // state.
    highlightedIndex: E,
    isOpen: x,
    selectedItem: C,
    inputValue: k
  };
}
zM.stateReducer, zM.itemToKey, zM.environment, Lt.array, Lt.array, Lt.array, Lt.func, Lt.number, Lt.number, Lt.number, Lt.func, Lt.func, Lt.string, Lt.string;
jT.itemToKey, jT.stateReducer, jT.environment;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
function g7(t) {
  if (Array.isArray(t)) {
    for (var e = 0, i = Array(t.length); e < t.length; e++) i[e] = t[e];
    return i;
  } else return Array.from(t);
}
var lN = !1;
if (typeof window < "u") {
  var gV = {
    get passive() {
      lN = !0;
    }
  };
  window.addEventListener("testPassive", null, gV), window.removeEventListener("testPassive", null, gV);
}
var D5 = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1),
  Q0 = [],
  dO = !1,
  I5 = -1,
  FT = void 0,
  NT = void 0,
  M5 = function (t) {
    return Q0.some(function (e) {
      return !!(e.options.allowTouchMove && e.options.allowTouchMove(t));
    });
  },
  uN = function (t) {
    var e = t || window.event;
    return M5(e.target) || e.touches.length > 1 ? !0 : (e.preventDefault && e.preventDefault(), !1);
  },
  y7 = function (t) {
    if (NT === void 0) {
      var e = !!t && t.reserveScrollBarGap === !0,
        i = window.innerWidth - document.documentElement.clientWidth;
      e && i > 0 && (NT = document.body.style.paddingRight, document.body.style.paddingRight = i + "px");
    }
    FT === void 0 && (FT = document.body.style.overflow, document.body.style.overflow = "hidden");
  },
  b7 = function () {
    NT !== void 0 && (document.body.style.paddingRight = NT, NT = void 0), FT !== void 0 && (document.body.style.overflow = FT, FT = void 0);
  },
  w7 = function (t) {
    return t ? t.scrollHeight - t.scrollTop <= t.clientHeight : !1;
  },
  _7 = function (t, e) {
    var i = t.targetTouches[0].clientY - I5;
    return M5(t.target) ? !1 : e && e.scrollTop === 0 && i > 0 || w7(e) && i < 0 ? uN(t) : (t.stopPropagation(), !0);
  },
  $O = function (t, e) {
    if (!t) {
      console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
      return;
    }
    if (!Q0.some(function (l) {
      return l.targetElement === t;
    })) {
      var i = {
        targetElement: t,
        options: e || {}
      };
      Q0 = [].concat(g7(Q0), [i]), D5 ? (t.ontouchstart = function (l) {
        l.targetTouches.length === 1 && (I5 = l.targetTouches[0].clientY);
      }, t.ontouchmove = function (l) {
        l.targetTouches.length === 1 && _7(l, t);
      }, dO || (document.addEventListener("touchmove", uN, lN ? {
        passive: !1
      } : void 0), dO = !0)) : y7(e);
    }
  },
  aR = function (t) {
    if (!t) {
      console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
      return;
    }
    Q0 = Q0.filter(function (e) {
      return e.targetElement !== t;
    }), D5 ? (t.ontouchstart = null, t.ontouchmove = null, dO && Q0.length === 0 && (document.removeEventListener("touchmove", uN, lN ? {
      passive: !1
    } : void 0), dO = !1)) : Q0.length || b7();
  };
const x7 = "_container_1wrr6_1",
  S7 = "_containerHelperText_1wrr6_22",
  E7 = "_containerErrorMesssage_1wrr6_22",
  C7 = "_containerInputLabel_1wrr6_26",
  V0 = {
    container: x7,
    containerHelperText: S7,
    containerErrorMesssage: E7,
    containerInputLabel: C7
  },
  AE = Qn(({
    id: t,
    label: e,
    labelId: i,
    isLabel: l = !0,
    isDisabled: c,
    errorMessage: p,
    helperText: h,
    messageId: y,
    isFocused: w,
    children: x,
    className: E,
    classNames: C
  }, k) => /* @__PURE__ */_e.jsxs(_e.Fragment, {
    children: [/* @__PURE__ */_e.jsxs("div", {
      ref: k,
      className: Ze(E, V0.container, w && (C == null ? void 0 : C.focus), !c && p && [V0.error, V0.containerError, C == null ? void 0 : C.error], c && [V0.containerInputDisable, C == null ? void 0 : C.disabled]),
      children: [l ? e && /* @__PURE__ */_e.jsx("label", {
        id: i || void 0,
        htmlFor: t,
        className: Ze(V0.containerInputLabel, C == null ? void 0 : C.label),
        children: e
      }) : e && /* @__PURE__ */_e.jsx("span", {
        id: i || void 0,
        className: Ze(V0.containerInputLabel, C == null ? void 0 : C.label),
        children: e
      }), x]
    }), !p && h && /* @__PURE__ */_e.jsx("div", {
      id: y || void 0,
      className: Ze(V0.containerHelperText, C == null ? void 0 : C.helperText),
      children: h
    }), p && /* @__PURE__ */_e.jsx("div", {
      id: y || void 0,
      role: "alert",
      className: Ze(V0.containerErrorMesssage, C == null ? void 0 : C.errorText),
      children: p
    })]
  }));
function cN(t, e, i) {
  var l = i || {},
    c = l.noTrailing,
    p = c === void 0 ? !1 : c,
    h = l.noLeading,
    y = h === void 0 ? !1 : h,
    w = l.debounceMode,
    x = w === void 0 ? void 0 : w,
    E,
    C = !1,
    k = 0;
  function D() {
    E && clearTimeout(E);
  }
  function I(P) {
    var N = P || {},
      L = N.upcomingOnly,
      F = L === void 0 ? !1 : L;
    D(), C = !F;
  }
  function O() {
    for (var P = arguments.length, N = new Array(P), L = 0; L < P; L++) N[L] = arguments[L];
    var F = this,
      j = Date.now() - k;
    if (C) return;
    function V() {
      k = Date.now(), e.apply(F, N);
    }
    function K() {
      E = void 0;
    }
    !y && x && !E && V(), D(), x === void 0 && j > t ? y ? (k = Date.now(), p || (E = setTimeout(x ? K : V, t))) : V() : p !== !0 && (E = setTimeout(x ? K : V, x === void 0 ? t - j : t));
  }
  return O.cancel = I, O;
}
function k7(t, e, i) {
  var l = i || {},
    c = l.atBegin,
    p = c === void 0 ? !1 : c;
  return cN(t, e, {
    debounceMode: p !== !1
  });
}
function WO(t = 150) {
  const [e, i] = rt({
      isXs: !1,
      isSm: !1,
      isMd: !1,
      isLg: !1,
      isXl: !1
    }),
    l = cN(t, () => {
      window && i({
        isXs: window.matchMedia(`(max-width: ${rd.breakpoint["sm-max"].value})`).matches,
        isSm: window.matchMedia(`(min-width: ${rd.breakpoint.sm.value}) and (max-width: ${rd.breakpoint["md-max"].value})`).matches,
        isMd: window.matchMedia(`(min-width: ${rd.breakpoint.md.value}) and (max-width: ${rd.breakpoint["lg-max"].value})`).matches,
        isLg: window.matchMedia(`(min-width: ${rd.breakpoint.lg.value}) and (max-width: ${rd.breakpoint["xl-max"].value})`).matches,
        isXl: window.matchMedia(`(min-width: ${rd.breakpoint.xl})`).matches
      });
    });
  return Rt(() => (l(), window.addEventListener("resize", l), () => {
    window.removeEventListener("resize", l);
  }), [t]), e;
}
const O5 = Up(void 0),
  T7 = t => {
    const {
      dir: e,
      children: i
    } = t;
    return /* @__PURE__ */_e.jsx(O5.Provider, {
      value: e,
      children: i
    });
  };
function dN(t) {
  const e = bl(O5);
  return t || e || "ltr";
}
function R7(t) {
  const e = vt(t);
  return Rt(() => {
    e.current = t;
  }), ci(() => (...i) => {
    var l;
    return (l = e.current) == null ? void 0 : l.call(e, ...i);
  }, []);
}
const D7 = ({
    method: t = "debounce",
    delayTime: e = 0,
    breakpoint: i
  } = {}) => {
    const l = i ? typeof i == "string" ? parseFloat(i) : i : parseFloat(rd.breakpoint.lg.value),
      [c, p] = rt(() => typeof window < "u" ? window.innerWidth <= l : !1),
      h = t === "throttle" ? cN : k7,
      y = ci(() => h(e, () => {
        p(window.innerWidth <= l);
      }), [h, e, l]);
    return Rt(() => (y(), window.addEventListener("resize", y), () => {
      var w;
      window.removeEventListener("resize", y), (w = y.cancel) == null || w.call(y);
    }), [y]), c;
  },
  $1 = {
    small: 12,
    medium: 36,
    large: 77
  },
  hb = {
    small: "small",
    medium: "medium",
    large: "large"
  },
  jE = {
    vertical: "vertical"
  },
  Um = {
    loading: "loading",
    success: "success"
  },
  I7 = "_spinnerContainer_1m7io_1",
  M7 = "_vertical_1m7io_8",
  O7 = "_messageContainer_1m7io_12",
  L7 = "_horizontal_1m7io_16",
  P7 = "_spinnerLoader_1m7io_21",
  A7 = "_messageTitle_1m7io_32",
  j7 = "_message_1m7io_12",
  F7 = "_spinnerLoaderCircle_1m7io_47",
  N7 = "_spinnerLoaderCircleStatic_1m7io_52",
  z7 = "_spinnerLoaderCircleLoading_1m7io_56",
  V7 = "_spinnerLoaderCircleComplete_1m7io_56",
  B7 = "_spinnerLoaderIcon_1m7io_63",
  U7 = "_spinnerLoaderSvg_1m7io_70",
  H7 = "_spinnerLoaderCheck_1m7io_74",
  $7 = "_spinnerLoaderIntro_1m7io_82",
  W7 = "_spinnerLoaderMessage_1m7io_89",
  q7 = "_animated_1m7io_93",
  Y7 = "_large_1m7io_99",
  G7 = "_pulse_1m7io_1",
  X7 = "_success_1m7io_129",
  K7 = "_spinnerLoaderCircleStop_1m7io_129",
  Q7 = "_animate_1m7io_93",
  Z7 = "_medium_1m7io_179",
  J7 = "_small_1m7io_259",
  Do = {
    spinnerContainer: I7,
    vertical: M7,
    messageContainer: O7,
    horizontal: L7,
    spinnerLoader: P7,
    messageTitle: A7,
    message: j7,
    spinnerLoaderCircle: F7,
    spinnerLoaderCircleStatic: N7,
    spinnerLoaderCircleLoading: z7,
    spinnerLoaderCircleComplete: V7,
    spinnerLoaderIcon: B7,
    spinnerLoaderSvg: U7,
    spinnerLoaderCheck: H7,
    spinnerLoaderIntro: $7,
    spinnerLoaderMessage: W7,
    animated: q7,
    large: Y7,
    pulse: G7,
    "loading-large": "_loading-large_1m7io_1",
    success: X7,
    spinnerLoaderCircleStop: K7,
    "fade-in": "_fade-in_1m7io_1",
    "complete-large": "_complete-large_1m7io_1",
    animate: Q7,
    "checkmark-large": "_checkmark-large_1m7io_1",
    "intro-large": "_intro-large_1m7io_1",
    medium: Z7,
    "loading-medium": "_loading-medium_1m7io_1",
    "complete-medium": "_complete-medium_1m7io_1",
    "checkmark-medium": "_checkmark-medium_1m7io_1",
    "intro-medium": "_intro-medium_1m7io_1",
    small: J7,
    "loading-small": "_loading-small_1m7io_1",
    "complete-small": "_complete-small_1m7io_1",
    "checkmark-small": "_checkmark-small_1m7io_1",
    "intro-small": "_intro-small_1m7io_1"
  },
  FE = ({
    className: t,
    message: e,
    align: i = jE.vertical,
    size: l = hb.medium,
    status: c = Um.loading,
    responsive: p = !0,
    trackColor: h = rd.color.white.default.value,
    strokeColor: y = rd.color.black.default.value,
    disableLarge: w,
    title: x,
    classNames: E
  }) => {
    const {
        isXs: C,
        isSm: k,
        isMd: D
      } = WO(),
      I = vt(p),
      O = vt(l),
      [P, N] = rt(!1),
      [L, F] = rt(!1),
      [j, V] = rt(!1),
      [K, G] = rt(!1),
      Q = vt(0),
      te = vt(),
      ie = 100,
      Y = 2e3,
      ee = {
        [Do[i]]: i,
        [Do[c]]: c === Um.success
      };
    return Rt(() => {
      I.current && (C ? O.current = hb.small : k || D ? O.current = hb.medium : w || (O.current = hb.large));
    }, [C, k, D, I]), Rt(() => (te.current = window.setInterval(() => {
      Q.current += ie, Q.current % Y === 0 && c === Um.success && (F(!0), window.clearInterval(te.current), te.current = void 0, N(!0));
    }, ie), () => {
      te.current && (window.clearInterval(te.current), te.current = void 0);
    }), [c]), Rt(() => {
      c === Um.success && L && !j ? setTimeout(() => {
        V(!0);
      }, 1500) : c === Um.success && L && j ? setTimeout(() => {
        G(!0);
      }, 2e3) : c === Um.loading && (V(!1), G(!1));
    }, [j, L, c]), /* @__PURE__ */_e.jsxs("div", {
      className: Ze(ee, Do[I.current ? O.current : l], Do.spinnerContainer, t),
      children: [/* @__PURE__ */_e.jsx("div", {
        className: Do.spinnerLoader,
        children: /* @__PURE__ */_e.jsxs("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          className: Ze(Do.spinnerLoaderSvg, Do.spinnerLoaderIcon),
          children: [/* @__PURE__ */_e.jsx("circle", {
            cx: $1[I.current ? O.current : l] + 2,
            cy: $1[I.current ? O.current : l] + 2,
            r: $1[I.current ? O.current : l],
            className: Ze(Do.spinnerLoaderCircle, Do.spinnerLoaderCircleStatic),
            stroke: h
          }), /* @__PURE__ */_e.jsx("circle", {
            cx: $1[I.current ? O.current : l] + 2,
            cy: $1[I.current ? O.current : l] + 2,
            r: $1[I.current ? O.current : l],
            className: Ze(Do.spinnerLoaderCircle, (!j || !L) && Do.spinnerLoaderCircleLoading, L && !j && Do.spinnerLoaderCircleStop, j && Do.spinnerLoaderCircleComplete, K && Do.animated),
            strokeLinecap: "round",
            strokeLinejoin: "round",
            stroke: y
          }), /* @__PURE__ */_e.jsxs("g", {
            children: [L && P && /* @__PURE__ */_e.jsx("path", {
              className: Ze(Do.spinnerLoaderCheck, Do.animate, K && Do.animated),
              stroke: y,
              vectorEffect: "non-scaling-stroke",
              d: "M13.6667 30.3333L21.8333 39.6666L44 16.3333",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }), L && !K && /* @__PURE__ */_e.jsx("path", {
              className: Ze(Do.spinnerLoaderIntro, Do.animate),
              vectorEffect: "non-scaling-stroke",
              width: "72",
              height: "72",
              d: "M36 1C45 1 56 4.5 62.5 13.5L30 47.5",
              strokeLinecap: "round",
              stroke: y
            })]
          })]
        })
      }), (x || e) && /* @__PURE__ */_e.jsxs("div", {
        className: Ze(Do.messageContainer, E == null ? void 0 : E.messageContainer),
        children: [x && /* @__PURE__ */_e.jsx("div", {
          className: Ze(Do.messageTitle, E == null ? void 0 : E.title),
          children: x
        }), e && /* @__PURE__ */_e.jsx("span", {
          className: Ze(Do.message, E == null ? void 0 : E.message),
          children: e
        })]
      })]
    });
  },
  eq = "_dropdown_10iq7_2",
  tq = "_selectedValue_10iq7_6",
  nq = "_dropdownOpen_10iq7_17",
  rq = "_dropdownFocus_10iq7_28",
  iq = "_dropdownInput_10iq7_41",
  aq = "_dropdownInputValue_10iq7_53",
  oq = "_dropdownIcon_10iq7_63",
  sq = "_dropdownIconDisabled_10iq7_75",
  lq = "_dropdownListbox_10iq7_79",
  uq = "_dropdownListboxOpen_10iq7_93",
  cq = "_list_10iq7_99",
  dq = "_item_10iq7_104",
  fq = "_disabled_10iq7_135",
  pq = "_noResults_10iq7_139",
  hq = "_srOnly_10iq7_144",
  Vn = {
    dropdown: eq,
    selectedValue: tq,
    dropdownOpen: nq,
    dropdownFocus: rq,
    dropdownInput: iq,
    dropdownInputValue: aq,
    dropdownIcon: oq,
    dropdownIconDisabled: sq,
    dropdownListbox: lq,
    dropdownListboxOpen: uq,
    list: cq,
    item: dq,
    disabled: fq,
    noResults: pq,
    srOnly: hq
  },
  mq = {
    noResults: "No results found",
    a11yOpenMenu: "Open menu",
    a11yCloseMenu: "Close menu",
    a11ySelectedLiveRegion: 'Selected option changed to "{{ label }}"'
  },
  vq = Qn(({
    id: t,
    data: e = [],
    isDisabled: i = !1,
    errorMessage: l,
    initialSelectedItem: c,
    hideDisplayValue: p,
    selectedItem: h,
    iconOptions: y,
    isAutoCloseMenu: w = !0,
    environment: x,
    children: E,
    className: C,
    classNames: k,
    onFocus: D,
    onBlur: I,
    onChange: O,
    onOpenDropdown: P,
    label: N,
    labels: L = {},
    helperText: F,
    renderCustomListItem: j,
    renderCustomItemContent: V,
    renderCustomLabel: K,
    isLoading: G = !1,
    loaderConfig: Q
  }, te) => {
    const ie = {
        ...mq,
        ...L
      },
      [Y, ee] = rt(!1),
      oe = vt(null),
      ne = vt(null),
      se = typeof window < "u",
      [ue, W] = rt(!1),
      [$, le] = rt(""),
      [H, ce] = rt(""),
      [de, Ce] = rt(),
      Ee = (gt, Pt) => {
        const {
          type: St,
          changes: Dt
        } = Pt;
        return [jp.stateChangeTypes.ToggleButtonKeyDownEnter, jp.stateChangeTypes.ToggleButtonKeyDownSpaceButton, jp.stateChangeTypes.ItemClick].includes(St) ? {
          ...Dt,
          isOpen: !w
        } : Dt;
      },
      fe = gt => {
        let Pt = (gt == null ? void 0 : gt.label) ?? "";
        return V && gt && V(gt) && (Pt = V(gt)), Pt;
      },
      xe = g9(e),
      {
        isOpen: we,
        closeMenu: ve,
        selectItem: Te,
        highlightedIndex: ze,
        setHighlightedIndex: Xe,
        getMenuProps: ye,
        getToggleButtonProps: qe,
        getItemProps: Ae
      } = jp({
        id: t,
        labelId: t,
        stateReducer: Ee,
        items: xe,
        itemToString: fe,
        isItemDisabled: gt => gt != null && gt.disabled ? !!gt.disabled : !1,
        onHighlightedIndexChange: gt => {
          const Pt = gt.highlightedIndex - (ze ?? 0);
          gt.highlightedIndex === de && gt.type !== jp.stateChangeTypes.ItemMouseMove && (de + Pt >= 0 && de + Pt <= xe.length - 1 ? Xe(de + Pt) : Xe(de - Pt));
        },
        onIsOpenChange: gt => {
          var Pt;
          const {
            matches: St
          } = window.matchMedia(`(max-width: ${rd.breakpoint.sm.value})`);
          gt.isOpen ? D == null || D() : (I == null || I(), (Pt = oe.current) == null || Pt.focus()), gt.isOpen && St && ne != null && ne.current ? ($O(ne.current), P == null || P(ne.current)) : ne.current && aR(ne.current);
        },
        onSelectedItemChange: gt => {
          var Pt, St;
          const Dt = gt.selectedItem ?? {};
          O == null || O(Dt), ee(!1), le(Dt.label);
          const Kt = xe.findIndex(hn => {
            var Ot;
            return hn.id === ((Ot = gt.selectedItem) == null ? void 0 : Ot.id);
          });
          Ce(Kt), gt.type !== "__function_select_item__" && ((Pt = gt.selectedItem) == null ? void 0 : Pt.value) !== (c == null ? void 0 : c.value) && (ee(!0), W(!0), (St = oe.current) == null || St.focus(), gt.isOpen && !w && Xe(ze));
        },
        environment: x ? {
          addEventListener: x.addEventListener.bind(x),
          removeEventListener: x.removeEventListener.bind(x),
          document: x != null && x.document ? x.document : document,
          Node: x.Node
        } : se ? window : void 0
      }),
      Mt = gt => {
        var Pt, St;
        if (ne) {
          if ((Pt = ne.current) != null && Pt.contains(gt == null ? void 0 : gt.target) || oe && (St = oe.current) != null && St.contains(gt == null ? void 0 : gt.target)) return;
          ve(), W(!1);
        }
      },
      Ft = gt => gt.reduce((Pt, St, Dt) => {
        const Kt = [];
        if (St != null && St.title) {
          let Ot = (St == null ? void 0 : St.displayTitle) === void 0 ? !1 : St.displayTitle;
          St.displayTitle === void 0 && (e == null ? void 0 : e.length) <= 1 ? Ot = !1 : St.displayTitle === void 0 && (Ot = !0), Pt.sections.push(/* @__PURE__ */_e.jsx("div", {
            id: `${t}-group-${Dt}`,
            role: "heading",
            "aria-level": 2,
            className: Ze(Vn.sectionHeading, !Ot && Vn.srOnly, k == null ? void 0 : k.listHeading),
            children: St.title
          }, `${t}-group-${Dt}`));
        }
        const hn = Ot => (Ot.forEach(Et => {
          ++Pt.itemIndex;
          const Vt = ((h == null ? void 0 : h.id) ?? "") === Et.id,
            Xt = {
              item: Et,
              index: Pt.itemIndex,
              "data-level": Et._level,
              className: Ze(Vn.item, k == null ? void 0 : k.listItem, Et.isGrouping && (k == null ? void 0 : k.itemGroup), Vt && (k == null ? void 0 : k.itemSelected), ze === Pt.itemIndex && (k == null ? void 0 : k.itemActive), Et.disabled && [Vn.disabled, k == null ? void 0 : k.itemDisabled]),
              "aria-selected": Vt,
              "aria-disabled": Et.disabled ? !0 : void 0,
              // Add this event to help limit the section heading accessibility fix
              onClick: vn => {
                vn.stopPropagation();
              }
            };
          if (j) {
            const vn = j(`item-${Pt.itemIndex}`, (h == null ? void 0 : h.id) ?? "", Et, Ae, Xt);
            Kt.push(/* @__PURE__ */_e.jsx(Qv, {
              children: vn
            }, `item-${Pt.itemIndex}`));
          } else Kt.push(/* @__PURE__ */_e.jsx("li", {
            ...Ae(Xt),
            children: fe(Et)
          }, `item-${Pt.itemIndex}`));
          Et && Et.items && Et.items.length > 0 && hn(Et.items);
        }), Kt);
        return St != null && St.items && St.items.length > 0 && (hn(St.items), Pt.sections.push(/* @__PURE__ */_e.jsx("ul", {
          role: gt.length > 1 ? "group" : "listbox",
          "aria-labelledby": `${t}-group-${Dt}`,
          className: Vn.list,
          children: Kt
        }, `dropdown-ul-${Dt}`))), Pt;
      }, {
        sections: [],
        itemIndex: -1
      }).sections,
      un = () => !p && h != null && h.label ? `${fe(h)}` : !p && c != null && c.label ? `${fe(c)}` : "";
    return Rt(() => (window.addEventListener("mousedown", Mt, !1), () => {
      window.removeEventListener("mousedown", Mt, !1);
    }), []), Rt(() => {
      const gt = setTimeout(() => {
        ce($);
      }, 200);
      return () => clearTimeout(gt);
    }, [$]), Rt(() => {
      c && Te(c);
    }, []), Rt(() => {
      h && Te(h);
    }, [h]), /* @__PURE__ */_e.jsx(_e.Fragment, {
      children: /* @__PURE__ */_e.jsx(AE, {
        ref: te,
        className: Ze(Vn.dropdown, we && !G && [Vn.dropdownOpen, k == null ? void 0 : k.inputWrapperOpen], !p && (Y || G || !!h) && [Vn.selectedValue, k == null ? void 0 : k.inputWrapperSelected], C, ue && Vn.dropdownFocus),
        classNames: {
          helperText: k == null ? void 0 : k.inputHelperText,
          errorText: Ze(!i && l && (k == null ? void 0 : k.inputErrorText)),
          focus: Ze(ue && (k == null ? void 0 : k.inputWrapperFocus)),
          error: Ze(!i && l && [Vn.dropdownError, k == null ? void 0 : k.inputWrapperError]),
          disabled: Ze(i && [Vn.dropdownInputDisabled, k == null ? void 0 : k.inputWrapperDisabled])
        },
        errorMessage: l,
        messageId: `${t}-message`,
        isDisabled: i,
        helperText: F,
        isFocused: ue && !G,
        children: /* @__PURE__ */_e.jsxs(_e.Fragment, {
          children: [/* @__PURE__ */_e.jsxs("button", {
            disabled: i,
            type: "button",
            "aria-label": we && !G ? ie.a11yCloseMenu : ie.a11yOpenMenu,
            "aria-describedby": F || l ? `${t}-message` : void 0,
            onFocusCapture: () => {
              W(!0);
            },
            onBlurCapture: () => {
              W(!1);
            },
            className: Ze(Vn.dropdownInput, G && (k == null ? void 0 : k.inputLoader), k == null ? void 0 : k.inputToggleButton),
            ...qe({
              ref: oe,
              "aria-labelledby": `${t}-label`,
              "aria-activedescendant": ze !== -1 ? `${t}-item-${ze}` : de != null ? `${t}-item-${de}` : void 0,
              onFocus: () => {
                D == null || D();
              },
              onBlur: () => {
                !we && !i && (I == null || I());
              }
            }),
            children: [/* @__PURE__ */_e.jsx("span", {
              className: Ze(k == null ? void 0 : k.inputLabel),
              id: `${t}-label`,
              children: K ? K(h || c, N) : N
            }), /* @__PURE__ */_e.jsx("span", {
              className: Ze(Vn.dropdownInputValue, k == null ? void 0 : k.value),
              children: un()
            }), G && /* @__PURE__ */_e.jsx(FE, {
              className: k == null ? void 0 : k.loader,
              size: hb.small,
              status: Um.loading,
              align: jE.vertical,
              responsive: !1,
              ...Q
            }), !i && !G && /* @__PURE__ */_e.jsxs("span", {
              "aria-hidden": "true",
              className: Ze(k == null ? void 0 : k.icon, l ? [Vn.dropdownIcon, Vn.dropdownIconError, k == null ? void 0 : k.iconError] : Vn.dropdownIcon),
              children: [we && ((y == null ? void 0 : y.open) || /* @__PURE__ */_e.jsx(_e.Fragment, {
                children: "▲"
              })), !we && ((y == null ? void 0 : y.close) || /* @__PURE__ */_e.jsx(_e.Fragment, {
                children: "▼"
              }))]
            }), i && /* @__PURE__ */_e.jsx("span", {
              "aria-hidden": "true",
              className: Ze(Vn.dropdownIcon, Vn.dropdownIconDisabled, k == null ? void 0 : k.icon, k == null ? void 0 : k.iconDisabled),
              children: (y == null ? void 0 : y.disabled) || /* @__PURE__ */_e.jsx(_e.Fragment, {
                children: "×"
              })
            })]
          }), /* @__PURE__ */_e.jsx("span", {
            role: "presentation",
            className: Ze(k == null ? void 0 : k.inputBorder)
          }), E, /* @__PURE__ */_e.jsx("div", {
            id: `${t}-selection-changes`,
            className: Vn.srOnly,
            "aria-live": "polite",
            "aria-atomic": "true",
            children: H && ie != null && ie.a11ySelectedLiveRegion ? ie.a11ySelectedLiveRegion.replace("{{ label }}", H) : H
          }), /* @__PURE__ */_e.jsx("div", {
            ...ye({
              ref: ne,
              onBlur: () => {
                var gt;
                I == null || I(), (gt = oe.current) == null || gt.focus();
              },
              onClick: gt => {
                var Pt, St;
                const Dt = parseInt((Pt = gt.nativeEvent.target) == null ? void 0 : Pt.id.replace(`${t}-group-`, ""), 10);
                if (Dt !== null) {
                  let Kt = 0;
                  ((hn, Ot) => {
                    var Et;
                    const Vt = Xt => Xt.reduce((vn, ot) => ot.items && ot.items.length > 0 ? vn + 1 + Vt(ot.items) : vn + 1, 0);
                    for (let Xt = 0; Xt < Ot; Xt++) (Et = hn[Xt]) != null && Et.items && (Kt += Vt(hn[Xt].items));
                  })(e, Dt), Xe(Kt);
                }
                (St = oe.current) == null || St.focus();
              },
              role: e.length > 1 ? "listbox" : void 0,
              "aria-labelledby": void 0,
              "aria-expanded": void 0,
              tabIndex: we ? 0 : -1
            }),
            className: Ze(Vn.dropdownListbox, we && !G && Vn.dropdownListboxOpen, k == null ? void 0 : k.listBox),
            children: !G && (e.length ? Ft(e) : /* @__PURE__ */_e.jsx("span", {
              className: Ze(Vn.noResults, k == null ? void 0 : k.noResults),
              children: ie.noResults
            }))
          })]
        })
      })
    });
  }),
  aE = ({
    number: t,
    locale: e = "en-CA",
    currency: i = "CAD",
    showCents: l = !1,
    className: c,
    renderCurrencyAsSup: p = !1
  }) => {
    if (t == null || t === "") return null;
    const h = Number(t);
    if (Number.isNaN(h)) return /* @__PURE__ */_e.jsx(_e.Fragment, {
      children: String(t)
    });
    const y = typeof l == "boolean" ? l : h % 1 !== 0,
      w = new Intl.NumberFormat(e, {
        style: "currency",
        currency: i,
        currencyDisplay: "narrowSymbol",
        minimumFractionDigits: y ? 2 : 0,
        maximumFractionDigits: y ? 2 : 0
      }).format(h),
      x = w.match(/([^\d\s.,]+)/);
    if (!p || !x) return /* @__PURE__ */_e.jsx("span", {
      className: c,
      children: w
    });
    const E = x[1],
      C = w.split(E);
    return /* @__PURE__ */_e.jsxs("span", {
      className: c,
      children: [C[0], /* @__PURE__ */_e.jsx("sup", {
        children: E
      }), C[1]]
    });
  },
  gq = "_grid_1wa4n_1",
  yq = "_gridItem_1wa4n_10",
  bq = "_gridItemNormal_1wa4n_16",
  wq = "_gridNoGap_1wa4n_20",
  zT = {
    grid: gq,
    gridItem: yq,
    gridItemNormal: bq,
    gridNoGap: wq
  },
  NE = ({
    className: t,
    cols: e = 1,
    minWidth: i,
    customCols: l,
    children: c,
    gap: p = !0
  }) => {
    const h = l || zT[`grid--${e}`],
      y = {
        ...(e && {
          "--_grid-cols": e
        }),
        ...(i && {
          "--_col-min-width": i
        })
      };
    return /* @__PURE__ */_e.jsx("div", {
      "data-cols": l || e,
      style: y,
      className: Ze(zT.grid, h, t, {
        [zT.gridNoGap]: !p
      }),
      children: Nt.Children.map(c, w => {
        if (!rR(w) || w.type !== gb) throw new Error("Children of <Row> must be of type Cell");
        return w;
      })
    });
  };
NE.displayName = "Row";
const gb = ({
  className: t,
  children: e,
  cellNormal: i = !1
}) => /* @__PURE__ */_e.jsx("div", {
  className: Ze(zT.gridItem, t, i && zT.gridItemNormal),
  children: e
});
gb.displayName = "Cell";
const E_e = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    p: "p",
    span: "span",
    div: "div"
  },
  C_e = {
    normal: "normal",
    bold: "bold"
  },
  k_e = {
    left: "left",
    center: "center",
    right: "right"
  },
  Nx = {
    div: "div",
    span: "span",
    p: "p",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6"
  },
  _q = t => Object.keys(Nx).includes(t),
  gT = {
    xl: "xl",
    lg: "lg",
    md: "md",
    sm: "sm",
    xs: "xs"
  },
  xq = t => {
    switch (!0) {
      case t === gT.xl:
        return Nx.h1;
      case t === gT.lg:
        return Nx.h2;
      case t == gT.md:
        return Nx.h3;
      case t === gT.sm:
        return Nx.h4;
      case t === gT.xs:
        return Nx.h5;
      default:
        return Nx.div;
    }
  },
  Sq = ({
    Tag: t,
    size: e,
    ...i
  }) => {
    const l = _q(t) ? t : xq(e);
    return /* @__PURE__ */_e.jsx(l, {
      ...i
    });
  },
  Eq = "_container_bdgjx_2",
  Cq = "_input_bdgjx_15",
  kq = "_inputButtonActive_bdgjx_28",
  Tq = "_inputIcon_bdgjx_36",
  Rq = "_inputButton_bdgjx_28",
  Dq = "_show_bdgjx_54",
  Iq = "_hide_bdgjx_58",
  Am = {
    container: Eq,
    input: Cq,
    inputButtonActive: kq,
    inputIcon: Tq,
    inputButton: Rq,
    show: Dq,
    hide: Iq
  },
  Mq = {
    clear: "Clear",
    ariaClearLabel: "Clear entry",
    hide: "Hide",
    ariaHidePassword: "Hide your password",
    show: "Show",
    ariaShowPassword: "Show your password"
  },
  L5 = Qn(({
    id: t,
    label: e,
    name: i,
    disabled: l = !1,
    readOnly: c = !1,
    onChange: p,
    onBlur: h,
    onFocus: y,
    onKeyUp: w,
    helperText: x,
    errorMessage: E,
    value: C,
    type: k = "text",
    required: D,
    labels: I = {},
    enableClearButton: O = !1,
    displayClearLabel: P,
    iconOptions: N,
    isLoading: L = !1,
    loaderConfig: F,
    className: j,
    classNames: V,
    // Mask Props
    isMasked: K = !1,
    isMaskedValue: G = !1,
    maskedPattern: Q = "",
    onMaskUpdate: te,
    children: ie,
    // Catch-all prop for anything not exclusively specified
    ...Y
  }, ee) => {
    var oe;
    const ne = {
        ...Mq,
        ...I
      },
      [se, ue] = rt(K ? void 0 : ""),
      [W, $] = rt(!1),
      [le, H] = rt(!1),
      [ce, de] = rt(!1),
      Ce = vt(null),
      Ee = vt(null),
      fe = vt(null),
      [xe, we] = rt(),
      [ve, Te] = rt(!1),
      ze = St => {
        if (!(St instanceof Node)) throw new Error("Node expected");
      },
      Xe = () => {
        de(!0);
      },
      ye = () => {
        de(!1), H(!1);
      },
      qe = (St, Dt) => {
        var Kt;
        switch (St.preventDefault(), (Kt = fe.current) == null || Kt.focus(), Dt) {
          case "clear":
            if (K ? te == null || te("") : ue(""), H(!1), fe.current && !K) {
              const hn = new Event("input", {
                bubbles: !0
              });
              fe.current.value = "", fe.current.dispatchEvent(hn), Ae(hn);
            }
            break;
          case "password":
            Te(!ve);
            break;
        }
      },
      Ae = St => {
        const Dt = St.target.value;
        if (!K) {
          ue(Dt);
          const Kt = St.target.validity;
          p == null || p(St, Dt, Kt.valid);
        }
        we(xe);
      },
      Mt = St => {
        const Dt = St.target.value;
        K || ue(Dt), w == null || w(St);
      },
      Ft = St => {
        $(!1), h == null || h(St), we(St.target.validity);
      },
      un = St => {
        $(!0), y == null || y(St);
      },
      gt = ci(() => k === "password" ? ve ? ne.ariaHidePassword : ne.ariaShowPassword : P ? void 0 : ne.ariaClearLabel, [k, P, ve, ne]),
      Pt = ci(() => !c && (W ||
      // The input is currently focused
      se || (
      // There is a value present
      xe == null ? void 0 : xe.badInput) ||
      // The current input is invalid
      G && se !== Q) || c && !!se && !!e || !!Q || L, [c, W, se, xe, e, L, G, Q]);
    return Rt(() => {
      K || ue(C);
    }, [C, K]), Rt(() => {
      const St = Dt => {
        var Kt, hn;
        ze(Dt.target), Ce.current && !((Kt = Ce.current) != null && Kt.contains(Dt.target)) && !((hn = fe.current) != null && hn.contains(Dt.target)) && !W && ye();
      };
      return window.document.addEventListener("click", St, !1), () => {
        window.document.removeEventListener("click", St, !1);
      };
    }, [t]), jR(ee, () => fe.current, []), /* @__PURE__ */_e.jsx(AE, {
      id: t,
      isLabel: !0,
      label: e || "<Label is required>",
      errorMessage: E,
      helperText: x,
      messageId: `${t}-message`,
      className: V == null ? void 0 : V.wrapper,
      classNames: {
        label: Ze(Am.label, V == null ? void 0 : V.inputLabel, l && (V == null ? void 0 : V.inputLabelDisabled), Pt && (V == null ? void 0 : V.inputFocus)),
        helperText: V == null ? void 0 : V.inputHelperText,
        errorText: Ze(V == null ? void 0 : V.inputHelperText, (E || !xe) && (V == null ? void 0 : V.inputErrorText))
      },
      children: /* @__PURE__ */_e.jsxs("div", {
        ref: Ee,
        className: Ze(Am.container, j, E && [Am.inputError, V == null ? void 0 : V.inputError]),
        children: [/* @__PURE__ */_e.jsx("input", {
          style: {
            "--_button-width": `${((oe = Ce.current) == null ? void 0 : oe.clientWidth) || 16}px`
          },
          id: t,
          ref: fe,
          className: Ze(Am.input, V == null ? void 0 : V.input, se && [Am.inputValue, V == null ? void 0 : V.value], (ne == null ? void 0 : ne.clear) && !c && Am.inputButtonActive),
          type: k === "password" && ve ? "text" : k,
          name: i || t,
          value: se,
          disabled: l,
          readOnly: L || c,
          onChange: Ae,
          onKeyUp: Mt,
          onFocus: un,
          onMouseEnter: Xe,
          onMouseLeave: () => !le && !W && ye(),
          onBlur: Ft,
          required: D,
          "data-masked-value": G,
          "data-masked-pattern": Q,
          ...Y,
          ...((x || E) && {
            "aria-describedby": `${t}-message`
          })
        }), /* @__PURE__ */_e.jsx("span", {
          role: "presentation",
          className: Ze(V == null ? void 0 : V.inputBorder)
        }), (L && !K || L && K && !Q) && /* @__PURE__ */_e.jsx(FE, {
          className: V == null ? void 0 : V.loader,
          size: hb.small,
          status: Um.loading,
          align: jE.vertical,
          responsive: !1,
          ...F
        }), l && /* @__PURE__ */_e.jsx("div", {
          "aria-hidden": "true",
          className: Ze(Am.inputIcon, V == null ? void 0 : V.iconDisable),
          children: N != null && N.disabled ? N.disabled : /* @__PURE__ */_e.jsx(_e.Fragment, {
            children: "×"
          })
        }), k !== "number" && (se || G && se !== Q) && ((ne == null ? void 0 : ne.clear) || k === "password") && !c && !l && O && /* @__PURE__ */_e.jsxs("button", {
          type: "button",
          "aria-label": gt,
          "aria-pressed": k === "password" ? ve : void 0,
          "aria-controls": t,
          ref: Ce,
          className: Ze(Am.inputButton, V == null ? void 0 : V.inputButton, W || ce ? Am.show : Am.hide),
          onClick: St => qe(St, k === "password" ? "password" : "clear"),
          onMouseEnter: Xe,
          onMouseLeave: () => !le && !W && ye(),
          onFocus: () => {
            H(!0), Xe();
          },
          onBlur: ye,
          children: [k === "password" && !ve && (ne == null ? void 0 : ne.show), k === "password" && ve && (ne == null ? void 0 : ne.hide), k !== "password" && O && /* @__PURE__ */_e.jsx("div", {
            "aria-hidden": P ? void 0 : "true",
            className: Ze(Am.iconClear, V == null ? void 0 : V.iconClear),
            children: P && (ne == null ? void 0 : ne.clear) || (N == null ? void 0 : N.clear) || /* @__PURE__ */_e.jsx(_e.Fragment, {
              children: "×"
            })
          })]
        }), ie]
      })
    });
  });
function nw(t) {
  return typeof t == "string" || t instanceof String;
}
function yV(t) {
  var e;
  return typeof t == "object" && t != null && (t == null || (e = t.constructor) == null ? void 0 : e.name) === "Object";
}
function P5(t, e) {
  return Array.isArray(e) ? P5(t, (i, l) => e.includes(l)) : Object.entries(t).reduce((i, l) => {
    let [c, p] = l;
    return e(p, c) && (i[c] = p), i;
  }, {});
}
const kn = {
  NONE: "NONE",
  LEFT: "LEFT",
  FORCE_LEFT: "FORCE_LEFT",
  RIGHT: "RIGHT",
  FORCE_RIGHT: "FORCE_RIGHT"
};
function Oq(t) {
  switch (t) {
    case kn.LEFT:
      return kn.FORCE_LEFT;
    case kn.RIGHT:
      return kn.FORCE_RIGHT;
    default:
      return t;
  }
}
function p2(t) {
  return t.replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1");
}
function fO(t, e) {
  if (e === t) return !0;
  const i = Array.isArray(e),
    l = Array.isArray(t);
  let c;
  if (i && l) {
    if (e.length != t.length) return !1;
    for (c = 0; c < e.length; c++) if (!fO(e[c], t[c])) return !1;
    return !0;
  }
  if (i != l) return !1;
  if (e && t && typeof e == "object" && typeof t == "object") {
    const p = e instanceof Date,
      h = t instanceof Date;
    if (p && h) return e.getTime() == t.getTime();
    if (p != h) return !1;
    const y = e instanceof RegExp,
      w = t instanceof RegExp;
    if (y && w) return e.toString() == t.toString();
    if (y != w) return !1;
    const x = Object.keys(e);
    for (c = 0; c < x.length; c++) if (!Object.prototype.hasOwnProperty.call(t, x[c])) return !1;
    for (c = 0; c < x.length; c++) if (!fO(t[x[c]], e[x[c]])) return !1;
    return !0;
  } else if (e && t && typeof e == "function" && typeof t == "function") return e.toString() === t.toString();
  return !1;
}
class Lq {
  /** Current input value */
  /** Current cursor position */
  /** Old input value */
  /** Old selection */
  constructor(e) {
    for (Object.assign(this, e); this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos);) --this.oldSelection.start;
    if (this.insertedCount) for (; this.value.slice(this.cursorPos) !== this.oldValue.slice(this.oldSelection.end);) this.value.length - this.cursorPos < this.oldValue.length - this.oldSelection.end ? ++this.oldSelection.end : ++this.cursorPos;
  }
  /** Start changing position */
  get startChangePos() {
    return Math.min(this.cursorPos, this.oldSelection.start);
  }
  /** Inserted symbols count */
  get insertedCount() {
    return this.cursorPos - this.startChangePos;
  }
  /** Inserted symbols */
  get inserted() {
    return this.value.substr(this.startChangePos, this.insertedCount);
  }
  /** Removed symbols count */
  get removedCount() {
    return Math.max(this.oldSelection.end - this.startChangePos ||
    // for Delete
    this.oldValue.length - this.value.length, 0);
  }
  /** Removed symbols */
  get removed() {
    return this.oldValue.substr(this.startChangePos, this.removedCount);
  }
  /** Unchanged head symbols */
  get head() {
    return this.value.substring(0, this.startChangePos);
  }
  /** Unchanged tail symbols */
  get tail() {
    return this.value.substring(this.startChangePos + this.insertedCount);
  }
  /** Remove direction */
  get removeDirection() {
    return !this.removedCount || this.insertedCount ? kn.NONE : (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) &&
    // if not range removed (event with backspace)
    this.oldSelection.end === this.oldSelection.start ? kn.RIGHT : kn.LEFT;
  }
}
function ar(t, e) {
  return new ar.InputMask(t, e);
}
function A5(t) {
  if (t == null) throw new Error("mask property should be defined");
  return t instanceof RegExp ? ar.MaskedRegExp : nw(t) ? ar.MaskedPattern : t === Date ? ar.MaskedDate : t === Number ? ar.MaskedNumber : Array.isArray(t) || t === Array ? ar.MaskedDynamic : ar.Masked && t.prototype instanceof ar.Masked ? t : ar.Masked && t instanceof ar.Masked ? t.constructor : t instanceof Function ? ar.MaskedFunction : (console.warn("Mask not found for mask", t), ar.Masked);
}
function oR(t) {
  if (!t) throw new Error("Options in not defined");
  if (ar.Masked) {
    if (t.prototype instanceof ar.Masked) return {
      mask: t
    };
    const {
      mask: e = void 0,
      ...i
    } = t instanceof ar.Masked ? {
      mask: t
    } : yV(t) && t.mask instanceof ar.Masked ? t : {};
    if (e) {
      const l = e.mask;
      return {
        ...P5(e, (c, p) => !p.startsWith("_")),
        mask: e.constructor,
        _mask: l,
        ...i
      };
    }
  }
  return yV(t) ? {
    ...t
  } : {
    mask: t
  };
}
function yb(t) {
  if (ar.Masked && t instanceof ar.Masked) return t;
  const e = oR(t),
    i = A5(e.mask);
  if (!i) throw new Error("Masked class is not found for provided mask " + e.mask + ", appropriate module needs to be imported manually before creating mask.");
  return e.mask === i && delete e.mask, e._mask && (e.mask = e._mask, delete e._mask), new i(e);
}
ar.createMask = yb;
class fN {
  /** */
  /** */
  /** */
  /** Safely returns selection start */
  get selectionStart() {
    let e;
    try {
      e = this._unsafeSelectionStart;
    } catch {}
    return e ?? this.value.length;
  }
  /** Safely returns selection end */
  get selectionEnd() {
    let e;
    try {
      e = this._unsafeSelectionEnd;
    } catch {}
    return e ?? this.value.length;
  }
  /** Safely sets element selection */
  select(e, i) {
    if (!(e == null || i == null || e === this.selectionStart && i === this.selectionEnd)) try {
      this._unsafeSelect(e, i);
    } catch {}
  }
  /** */
  get isActive() {
    return !1;
  }
  /** */
  /** */
  /** */
}
ar.MaskElement = fN;
const bV = 90,
  Pq = 89;
class qO extends fN {
  /** HTMLElement to use mask on */
  constructor(e) {
    super(), this.input = e, this._onKeydown = this._onKeydown.bind(this), this._onInput = this._onInput.bind(this), this._onBeforeinput = this._onBeforeinput.bind(this), this._onCompositionEnd = this._onCompositionEnd.bind(this);
  }
  get rootElement() {
    var e, i, l;
    return (e = (i = (l = this.input).getRootNode) == null ? void 0 : i.call(l)) != null ? e : document;
  }
  /** Is element in focus */
  get isActive() {
    return this.input === this.rootElement.activeElement;
  }
  /** Binds HTMLElement events to mask internal events */
  bindEvents(e) {
    this.input.addEventListener("keydown", this._onKeydown), this.input.addEventListener("input", this._onInput), this.input.addEventListener("beforeinput", this._onBeforeinput), this.input.addEventListener("compositionend", this._onCompositionEnd), this.input.addEventListener("drop", e.drop), this.input.addEventListener("click", e.click), this.input.addEventListener("focus", e.focus), this.input.addEventListener("blur", e.commit), this._handlers = e;
  }
  _onKeydown(e) {
    if (this._handlers.redo && (e.keyCode === bV && e.shiftKey && (e.metaKey || e.ctrlKey) || e.keyCode === Pq && e.ctrlKey)) return e.preventDefault(), this._handlers.redo(e);
    if (this._handlers.undo && e.keyCode === bV && (e.metaKey || e.ctrlKey)) return e.preventDefault(), this._handlers.undo(e);
    e.isComposing || this._handlers.selectionChange(e);
  }
  _onBeforeinput(e) {
    if (e.inputType === "historyUndo" && this._handlers.undo) return e.preventDefault(), this._handlers.undo(e);
    if (e.inputType === "historyRedo" && this._handlers.redo) return e.preventDefault(), this._handlers.redo(e);
  }
  _onCompositionEnd(e) {
    this._handlers.input(e);
  }
  _onInput(e) {
    e.isComposing || this._handlers.input(e);
  }
  /** Unbinds HTMLElement events to mask internal events */
  unbindEvents() {
    this.input.removeEventListener("keydown", this._onKeydown), this.input.removeEventListener("input", this._onInput), this.input.removeEventListener("beforeinput", this._onBeforeinput), this.input.removeEventListener("compositionend", this._onCompositionEnd), this.input.removeEventListener("drop", this._handlers.drop), this.input.removeEventListener("click", this._handlers.click), this.input.removeEventListener("focus", this._handlers.focus), this.input.removeEventListener("blur", this._handlers.commit), this._handlers = {};
  }
}
ar.HTMLMaskElement = qO;
class Aq extends qO {
  /** InputElement to use mask on */
  constructor(e) {
    super(e), this.input = e;
  }
  /** Returns InputElement selection start */
  get _unsafeSelectionStart() {
    return this.input.selectionStart != null ? this.input.selectionStart : this.value.length;
  }
  /** Returns InputElement selection end */
  get _unsafeSelectionEnd() {
    return this.input.selectionEnd;
  }
  /** Sets InputElement selection */
  _unsafeSelect(e, i) {
    this.input.setSelectionRange(e, i);
  }
  get value() {
    return this.input.value;
  }
  set value(e) {
    this.input.value = e;
  }
}
ar.HTMLMaskElement = qO;
class j5 extends qO {
  /** Returns HTMLElement selection start */
  get _unsafeSelectionStart() {
    const e = this.rootElement,
      i = e.getSelection && e.getSelection(),
      l = i && i.anchorOffset,
      c = i && i.focusOffset;
    return c == null || l == null || l < c ? l : c;
  }
  /** Returns HTMLElement selection end */
  get _unsafeSelectionEnd() {
    const e = this.rootElement,
      i = e.getSelection && e.getSelection(),
      l = i && i.anchorOffset,
      c = i && i.focusOffset;
    return c == null || l == null || l > c ? l : c;
  }
  /** Sets HTMLElement selection */
  _unsafeSelect(e, i) {
    if (!this.rootElement.createRange) return;
    const l = this.rootElement.createRange();
    l.setStart(this.input.firstChild || this.input, e), l.setEnd(this.input.lastChild || this.input, i);
    const c = this.rootElement,
      p = c.getSelection && c.getSelection();
    p && (p.removeAllRanges(), p.addRange(l));
  }
  /** HTMLElement value */
  get value() {
    return this.input.textContent || "";
  }
  set value(e) {
    this.input.textContent = e;
  }
}
ar.HTMLContenteditableMaskElement = j5;
class YO {
  constructor() {
    this.states = [], this.currentIndex = 0;
  }
  get currentState() {
    return this.states[this.currentIndex];
  }
  get isEmpty() {
    return this.states.length === 0;
  }
  push(e) {
    this.currentIndex < this.states.length - 1 && (this.states.length = this.currentIndex + 1), this.states.push(e), this.states.length > YO.MAX_LENGTH && this.states.shift(), this.currentIndex = this.states.length - 1;
  }
  go(e) {
    return this.currentIndex = Math.min(Math.max(this.currentIndex + e, 0), this.states.length - 1), this.currentState;
  }
  undo() {
    return this.go(-1);
  }
  redo() {
    return this.go(1);
  }
  clear() {
    this.states.length = 0, this.currentIndex = 0;
  }
}
YO.MAX_LENGTH = 100;
class jq {
  /**
    View element
  */
  /** Internal {@link Masked} model */
  constructor(e, i) {
    this.el = e instanceof fN ? e : e.isContentEditable && e.tagName !== "INPUT" && e.tagName !== "TEXTAREA" ? new j5(e) : new Aq(e), this.masked = yb(i), this._listeners = {}, this._value = "", this._unmaskedValue = "", this._rawInputValue = "", this.history = new YO(), this._saveSelection = this._saveSelection.bind(this), this._onInput = this._onInput.bind(this), this._onChange = this._onChange.bind(this), this._onDrop = this._onDrop.bind(this), this._onFocus = this._onFocus.bind(this), this._onClick = this._onClick.bind(this), this._onUndo = this._onUndo.bind(this), this._onRedo = this._onRedo.bind(this), this.alignCursor = this.alignCursor.bind(this), this.alignCursorFriendly = this.alignCursorFriendly.bind(this), this._bindEvents(), this.updateValue(), this._onChange();
  }
  maskEquals(e) {
    var i;
    return e == null || ((i = this.masked) == null ? void 0 : i.maskEquals(e));
  }
  /** Masked */
  get mask() {
    return this.masked.mask;
  }
  set mask(e) {
    if (this.maskEquals(e)) return;
    if (!(e instanceof ar.Masked) && this.masked.constructor === A5(e)) {
      this.masked.updateOptions({
        mask: e
      });
      return;
    }
    const i = e instanceof ar.Masked ? e : yb({
      mask: e
    });
    i.unmaskedValue = this.masked.unmaskedValue, this.masked = i;
  }
  /** Raw value */
  get value() {
    return this._value;
  }
  set value(e) {
    this.value !== e && (this.masked.value = e, this.updateControl("auto"));
  }
  /** Unmasked value */
  get unmaskedValue() {
    return this._unmaskedValue;
  }
  set unmaskedValue(e) {
    this.unmaskedValue !== e && (this.masked.unmaskedValue = e, this.updateControl("auto"));
  }
  /** Raw input value */
  get rawInputValue() {
    return this._rawInputValue;
  }
  set rawInputValue(e) {
    this.rawInputValue !== e && (this.masked.rawInputValue = e, this.updateControl(), this.alignCursor());
  }
  /** Typed unmasked value */
  get typedValue() {
    return this.masked.typedValue;
  }
  set typedValue(e) {
    this.masked.typedValueEquals(e) || (this.masked.typedValue = e, this.updateControl("auto"));
  }
  /** Display value */
  get displayValue() {
    return this.masked.displayValue;
  }
  /** Starts listening to element events */
  _bindEvents() {
    this.el.bindEvents({
      selectionChange: this._saveSelection,
      input: this._onInput,
      drop: this._onDrop,
      click: this._onClick,
      focus: this._onFocus,
      commit: this._onChange,
      undo: this._onUndo,
      redo: this._onRedo
    });
  }
  /** Stops listening to element events */
  _unbindEvents() {
    this.el && this.el.unbindEvents();
  }
  /** Fires custom event */
  _fireEvent(e, i) {
    const l = this._listeners[e];
    l && l.forEach(c => c(i));
  }
  /** Current selection start */
  get selectionStart() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
  }
  /** Current cursor position */
  get cursorPos() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
  }
  set cursorPos(e) {
    !this.el || !this.el.isActive || (this.el.select(e, e), this._saveSelection());
  }
  /** Stores current selection */
  _saveSelection() {
    this.displayValue !== this.el.value && console.warn("Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly."), this._selection = {
      start: this.selectionStart,
      end: this.cursorPos
    };
  }
  /** Syncronizes model value from view */
  updateValue() {
    this.masked.value = this.el.value, this._value = this.masked.value, this._unmaskedValue = this.masked.unmaskedValue, this._rawInputValue = this.masked.rawInputValue;
  }
  /** Syncronizes view from model value, fires change events */
  updateControl(e) {
    const i = this.masked.unmaskedValue,
      l = this.masked.value,
      c = this.masked.rawInputValue,
      p = this.displayValue,
      h = this.unmaskedValue !== i || this.value !== l || this._rawInputValue !== c;
    this._unmaskedValue = i, this._value = l, this._rawInputValue = c, this.el.value !== p && (this.el.value = p), e === "auto" ? this.alignCursor() : e != null && (this.cursorPos = e), h && this._fireChangeEvents(), !this._historyChanging && (h || this.history.isEmpty) && this.history.push({
      unmaskedValue: i,
      selection: {
        start: this.selectionStart,
        end: this.cursorPos
      }
    });
  }
  /** Updates options with deep equal check, recreates {@link Masked} model if mask type changes */
  updateOptions(e) {
    const {
        mask: i,
        ...l
      } = e,
      c = !this.maskEquals(i),
      p = this.masked.optionsIsChanged(l);
    c && (this.mask = i), p && this.masked.updateOptions(l), (c || p) && this.updateControl();
  }
  /** Updates cursor */
  updateCursor(e) {
    e != null && (this.cursorPos = e, this._delayUpdateCursor(e));
  }
  /** Delays cursor update to support mobile browsers */
  _delayUpdateCursor(e) {
    this._abortUpdateCursor(), this._changingCursorPos = e, this._cursorChanging = setTimeout(() => {
      this.el && (this.cursorPos = this._changingCursorPos, this._abortUpdateCursor());
    }, 10);
  }
  /** Fires custom events */
  _fireChangeEvents() {
    this._fireEvent("accept", this._inputEvent), this.masked.isComplete && this._fireEvent("complete", this._inputEvent);
  }
  /** Aborts delayed cursor update */
  _abortUpdateCursor() {
    this._cursorChanging && (clearTimeout(this._cursorChanging), delete this._cursorChanging);
  }
  /** Aligns cursor to nearest available position */
  alignCursor() {
    this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, kn.LEFT));
  }
  /** Aligns cursor only if selection is empty */
  alignCursorFriendly() {
    this.selectionStart === this.cursorPos && this.alignCursor();
  }
  /** Adds listener on custom event */
  on(e, i) {
    return this._listeners[e] || (this._listeners[e] = []), this._listeners[e].push(i), this;
  }
  /** Removes custom event listener */
  off(e, i) {
    if (!this._listeners[e]) return this;
    if (!i) return delete this._listeners[e], this;
    const l = this._listeners[e].indexOf(i);
    return l >= 0 && this._listeners[e].splice(l, 1), this;
  }
  /** Handles view input event */
  _onInput(e) {
    this._inputEvent = e, this._abortUpdateCursor();
    const i = new Lq({
        // new state
        value: this.el.value,
        cursorPos: this.cursorPos,
        // old state
        oldValue: this.displayValue,
        oldSelection: this._selection
      }),
      l = this.masked.rawInputValue,
      c = this.masked.splice(i.startChangePos, i.removed.length, i.inserted, i.removeDirection, {
        input: !0,
        raw: !0
      }).offset,
      p = l === this.masked.rawInputValue ? i.removeDirection : kn.NONE;
    let h = this.masked.nearestInputPos(i.startChangePos + c, p);
    p !== kn.NONE && (h = this.masked.nearestInputPos(h, kn.NONE)), this.updateControl(h), delete this._inputEvent;
  }
  /** Handles view change event and commits model value */
  _onChange() {
    this.displayValue !== this.el.value && this.updateValue(), this.masked.doCommit(), this.updateControl(), this._saveSelection();
  }
  /** Handles view drop event, prevents by default */
  _onDrop(e) {
    e.preventDefault(), e.stopPropagation();
  }
  /** Restore last selection on focus */
  _onFocus(e) {
    this.alignCursorFriendly();
  }
  /** Restore last selection on focus */
  _onClick(e) {
    this.alignCursorFriendly();
  }
  _onUndo() {
    this._applyHistoryState(this.history.undo());
  }
  _onRedo() {
    this._applyHistoryState(this.history.redo());
  }
  _applyHistoryState(e) {
    e && (this._historyChanging = !0, this.unmaskedValue = e.unmaskedValue, this.el.select(e.selection.start, e.selection.end), this._saveSelection(), this._historyChanging = !1);
  }
  /** Unbind view events and removes element reference */
  destroy() {
    this._unbindEvents(), this._listeners.length = 0, delete this.el;
  }
}
ar.InputMask = jq;
class gr {
  /** Inserted symbols */
  /** Additional offset if any changes occurred before tail */
  /** Raw inserted is used by dynamic mask */
  /** Can skip chars */
  static normalize(e) {
    return Array.isArray(e) ? e : [e, new gr()];
  }
  constructor(e) {
    Object.assign(this, {
      inserted: "",
      rawInserted: "",
      tailShift: 0,
      skip: !1
    }, e);
  }
  /** Aggregate changes */
  aggregate(e) {
    return this.inserted += e.inserted, this.rawInserted += e.rawInserted, this.tailShift += e.tailShift, this.skip = this.skip || e.skip, this;
  }
  /** Total offset considering all changes */
  get offset() {
    return this.tailShift + this.inserted.length;
  }
  get consumed() {
    return !!this.rawInserted || this.skip;
  }
  equals(e) {
    return this.inserted === e.inserted && this.tailShift === e.tailShift && this.rawInserted === e.rawInserted && this.skip === e.skip;
  }
}
ar.ChangeDetails = gr;
class Yv {
  /** Tail value as string */
  /** Tail start position */
  /** Start position */
  constructor(e, i, l) {
    e === void 0 && (e = ""), i === void 0 && (i = 0), this.value = e, this.from = i, this.stop = l;
  }
  toString() {
    return this.value;
  }
  extend(e) {
    this.value += String(e);
  }
  appendTo(e) {
    return e.append(this.toString(), {
      tail: !0
    }).aggregate(e._appendPlaceholder());
  }
  get state() {
    return {
      value: this.value,
      from: this.from,
      stop: this.stop
    };
  }
  set state(e) {
    Object.assign(this, e);
  }
  unshift(e) {
    if (!this.value.length || e != null && this.from >= e) return "";
    const i = this.value[0];
    return this.value = this.value.slice(1), i;
  }
  shift() {
    if (!this.value.length) return "";
    const e = this.value[this.value.length - 1];
    return this.value = this.value.slice(0, -1), e;
  }
}
class ku {
  /** */
  /** */
  /** Transforms value before mask processing */
  /** Transforms each char before mask processing */
  /** Validates if value is acceptable */
  /** Does additional processing at the end of editing */
  /** Format typed value to string */
  /** Parse string to get typed value */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  /** */
  constructor(e) {
    this._value = "", this._update({
      ...ku.DEFAULTS,
      ...e
    }), this._initialized = !0;
  }
  /** Sets and applies new options */
  updateOptions(e) {
    this.optionsIsChanged(e) && this.withValueRefresh(this._update.bind(this, e));
  }
  /** Sets new options */
  _update(e) {
    Object.assign(this, e);
  }
  /** Mask state */
  get state() {
    return {
      _value: this.value,
      _rawInputValue: this.rawInputValue
    };
  }
  set state(e) {
    this._value = e._value;
  }
  /** Resets value */
  reset() {
    this._value = "";
  }
  get value() {
    return this._value;
  }
  set value(e) {
    this.resolve(e, {
      input: !0
    });
  }
  /** Resolve new value */
  resolve(e, i) {
    i === void 0 && (i = {
      input: !0
    }), this.reset(), this.append(e, i, ""), this.doCommit();
  }
  get unmaskedValue() {
    return this.value;
  }
  set unmaskedValue(e) {
    this.resolve(e, {});
  }
  get typedValue() {
    return this.parse ? this.parse(this.value, this) : this.unmaskedValue;
  }
  set typedValue(e) {
    this.format ? this.value = this.format(e, this) : this.unmaskedValue = String(e);
  }
  /** Value that includes raw user input */
  get rawInputValue() {
    return this.extractInput(0, this.displayValue.length, {
      raw: !0
    });
  }
  set rawInputValue(e) {
    this.resolve(e, {
      raw: !0
    });
  }
  get displayValue() {
    return this.value;
  }
  get isComplete() {
    return !0;
  }
  get isFilled() {
    return this.isComplete;
  }
  /** Finds nearest input position in direction */
  nearestInputPos(e, i) {
    return e;
  }
  totalInputPositions(e, i) {
    return e === void 0 && (e = 0), i === void 0 && (i = this.displayValue.length), Math.min(this.displayValue.length, i - e);
  }
  /** Extracts value in range considering flags */
  extractInput(e, i, l) {
    return e === void 0 && (e = 0), i === void 0 && (i = this.displayValue.length), this.displayValue.slice(e, i);
  }
  /** Extracts tail in range */
  extractTail(e, i) {
    return e === void 0 && (e = 0), i === void 0 && (i = this.displayValue.length), new Yv(this.extractInput(e, i), e);
  }
  /** Appends tail */
  appendTail(e) {
    return nw(e) && (e = new Yv(String(e))), e.appendTo(this);
  }
  /** Appends char */
  _appendCharRaw(e, i) {
    return e ? (this._value += e, new gr({
      inserted: e,
      rawInserted: e
    })) : new gr();
  }
  /** Appends char */
  _appendChar(e, i, l) {
    i === void 0 && (i = {});
    const c = this.state;
    let p;
    if ([e, p] = this.doPrepareChar(e, i), e && (p = p.aggregate(this._appendCharRaw(e, i)), !p.rawInserted && this.autofix === "pad")) {
      const h = this.state;
      this.state = c;
      let y = this.pad(i);
      const w = this._appendCharRaw(e, i);
      y = y.aggregate(w), w.rawInserted || y.equals(p) ? p = y : this.state = h;
    }
    if (p.inserted) {
      let h,
        y = this.doValidate(i) !== !1;
      if (y && l != null) {
        const w = this.state;
        if (this.overwrite === !0) {
          h = l.state;
          for (let E = 0; E < p.rawInserted.length; ++E) l.unshift(this.displayValue.length - p.tailShift);
        }
        let x = this.appendTail(l);
        if (y = x.rawInserted.length === l.toString().length, !(y && x.inserted) && this.overwrite === "shift") {
          this.state = w, h = l.state;
          for (let E = 0; E < p.rawInserted.length; ++E) l.shift();
          x = this.appendTail(l), y = x.rawInserted.length === l.toString().length;
        }
        y && x.inserted && (this.state = w);
      }
      y || (p = new gr(), this.state = c, l && h && (l.state = h));
    }
    return p;
  }
  /** Appends optional placeholder at the end */
  _appendPlaceholder() {
    return new gr();
  }
  /** Appends optional eager placeholder at the end */
  _appendEager() {
    return new gr();
  }
  /** Appends symbols considering flags */
  append(e, i, l) {
    if (!nw(e)) throw new Error("value should be string");
    const c = nw(l) ? new Yv(String(l)) : l;
    i != null && i.tail && (i._beforeTailState = this.state);
    let p;
    [e, p] = this.doPrepare(e, i);
    for (let h = 0; h < e.length; ++h) {
      const y = this._appendChar(e[h], i, c);
      if (!y.rawInserted && !this.doSkipInvalid(e[h], i, c)) break;
      p.aggregate(y);
    }
    return (this.eager === !0 || this.eager === "append") && i != null && i.input && e && p.aggregate(this._appendEager()), c != null && (p.tailShift += this.appendTail(c).tailShift), p;
  }
  remove(e, i) {
    return e === void 0 && (e = 0), i === void 0 && (i = this.displayValue.length), this._value = this.displayValue.slice(0, e) + this.displayValue.slice(i), new gr();
  }
  /** Calls function and reapplies current value */
  withValueRefresh(e) {
    if (this._refreshing || !this._initialized) return e();
    this._refreshing = !0;
    const i = this.rawInputValue,
      l = this.value,
      c = e();
    return this.rawInputValue = i, this.value && this.value !== l && l.indexOf(this.value) === 0 && (this.append(l.slice(this.displayValue.length), {}, ""), this.doCommit()), delete this._refreshing, c;
  }
  runIsolated(e) {
    if (this._isolated || !this._initialized) return e(this);
    this._isolated = !0;
    const i = this.state,
      l = e(this);
    return this.state = i, delete this._isolated, l;
  }
  doSkipInvalid(e, i, l) {
    return !!this.skipInvalid;
  }
  /** Prepares string before mask processing */
  doPrepare(e, i) {
    return i === void 0 && (i = {}), gr.normalize(this.prepare ? this.prepare(e, this, i) : e);
  }
  /** Prepares each char before mask processing */
  doPrepareChar(e, i) {
    return i === void 0 && (i = {}), gr.normalize(this.prepareChar ? this.prepareChar(e, this, i) : e);
  }
  /** Validates if value is acceptable */
  doValidate(e) {
    return (!this.validate || this.validate(this.value, this, e)) && (!this.parent || this.parent.doValidate(e));
  }
  /** Does additional processing at the end of editing */
  doCommit() {
    this.commit && this.commit(this.value, this);
  }
  splice(e, i, l, c, p) {
    l === void 0 && (l = ""), c === void 0 && (c = kn.NONE), p === void 0 && (p = {
      input: !0
    });
    const h = e + i,
      y = this.extractTail(h),
      w = this.eager === !0 || this.eager === "remove";
    let x;
    w && (c = Oq(c), x = this.extractInput(0, h, {
      raw: !0
    }));
    let E = e;
    const C = new gr();
    if (c !== kn.NONE && (E = this.nearestInputPos(e, i > 1 && e !== 0 && !w ? kn.NONE : c), C.tailShift = E - e), C.aggregate(this.remove(E)), w && c !== kn.NONE && x === this.rawInputValue) if (c === kn.FORCE_LEFT) {
      let k;
      for (; x === this.rawInputValue && (k = this.displayValue.length);) C.aggregate(new gr({
        tailShift: -1
      })).aggregate(this.remove(k - 1));
    } else c === kn.FORCE_RIGHT && y.unshift();
    return C.aggregate(this.append(l, p, y));
  }
  maskEquals(e) {
    return this.mask === e;
  }
  optionsIsChanged(e) {
    return !fO(this, e);
  }
  typedValueEquals(e) {
    const i = this.typedValue;
    return e === i || ku.EMPTY_VALUES.includes(e) && ku.EMPTY_VALUES.includes(i) || (this.format ? this.format(e, this) === this.format(this.typedValue, this) : !1);
  }
  pad(e) {
    return new gr();
  }
}
ku.DEFAULTS = {
  skipInvalid: !0
};
ku.EMPTY_VALUES = [void 0, null, ""];
ar.Masked = ku;
class Hx {
  /** */
  constructor(e, i) {
    e === void 0 && (e = []), i === void 0 && (i = 0), this.chunks = e, this.from = i;
  }
  toString() {
    return this.chunks.map(String).join("");
  }
  extend(e) {
    if (!String(e)) return;
    e = nw(e) ? new Yv(String(e)) : e;
    const i = this.chunks[this.chunks.length - 1],
      l = i && (
      // if stops are same or tail has no stop
      i.stop === e.stop || e.stop == null) &&
      // if tail chunk goes just after last chunk
      e.from === i.from + i.toString().length;
    if (e instanceof Yv) l ? i.extend(e.toString()) : this.chunks.push(e);else if (e instanceof Hx) {
      if (e.stop == null) {
        let c;
        for (; e.chunks.length && e.chunks[0].stop == null;) c = e.chunks.shift(), c.from += e.from, this.extend(c);
      }
      e.toString() && (e.stop = e.blockIndex, this.chunks.push(e));
    }
  }
  appendTo(e) {
    if (!(e instanceof ar.MaskedPattern)) return new Yv(this.toString()).appendTo(e);
    const i = new gr();
    for (let l = 0; l < this.chunks.length; ++l) {
      const c = this.chunks[l],
        p = e._mapPosToBlock(e.displayValue.length),
        h = c.stop;
      let y;
      if (h != null && (
      // if block not found or stop is behind lastBlock
      !p || p.index <= h) && ((c instanceof Hx ||
      // for continuous block also check if stop is exist
      e._stops.indexOf(h) >= 0) && i.aggregate(e._appendPlaceholder(h)), y = c instanceof Hx && e._blocks[h]), y) {
        const w = y.appendTail(c);
        i.aggregate(w);
        const x = c.toString().slice(w.rawInserted.length);
        x && i.aggregate(e.append(x, {
          tail: !0
        }));
      } else i.aggregate(e.append(c.toString(), {
        tail: !0
      }));
    }
    return i;
  }
  get state() {
    return {
      chunks: this.chunks.map(e => e.state),
      from: this.from,
      stop: this.stop,
      blockIndex: this.blockIndex
    };
  }
  set state(e) {
    const {
      chunks: i,
      ...l
    } = e;
    Object.assign(this, l), this.chunks = i.map(c => {
      const p = "chunks" in c ? new Hx() : new Yv();
      return p.state = c, p;
    });
  }
  unshift(e) {
    if (!this.chunks.length || e != null && this.from >= e) return "";
    const i = e != null ? e - this.from : e;
    let l = 0;
    for (; l < this.chunks.length;) {
      const c = this.chunks[l],
        p = c.unshift(i);
      if (c.toString()) {
        if (!p) break;
        ++l;
      } else this.chunks.splice(l, 1);
      if (p) return p;
    }
    return "";
  }
  shift() {
    if (!this.chunks.length) return "";
    let e = this.chunks.length - 1;
    for (; 0 <= e;) {
      const i = this.chunks[e],
        l = i.shift();
      if (i.toString()) {
        if (!l) break;
        --e;
      } else this.chunks.splice(e, 1);
      if (l) return l;
    }
    return "";
  }
}
class Fq {
  constructor(e, i) {
    this.masked = e, this._log = [];
    const {
      offset: l,
      index: c
    } = e._mapPosToBlock(i) || (i < 0 ?
    // first
    {
      index: 0,
      offset: 0
    } :
    // last
    {
      index: this.masked._blocks.length,
      offset: 0
    });
    this.offset = l, this.index = c, this.ok = !1;
  }
  get block() {
    return this.masked._blocks[this.index];
  }
  get pos() {
    return this.masked._blockStartPos(this.index) + this.offset;
  }
  get state() {
    return {
      index: this.index,
      offset: this.offset,
      ok: this.ok
    };
  }
  set state(e) {
    Object.assign(this, e);
  }
  pushState() {
    this._log.push(this.state);
  }
  popState() {
    const e = this._log.pop();
    return e && (this.state = e), e;
  }
  bindBlock() {
    this.block || (this.index < 0 && (this.index = 0, this.offset = 0), this.index >= this.masked._blocks.length && (this.index = this.masked._blocks.length - 1, this.offset = this.block.displayValue.length));
  }
  _pushLeft(e) {
    for (this.pushState(), this.bindBlock(); 0 <= this.index; --this.index, this.offset = ((i = this.block) == null ? void 0 : i.displayValue.length) || 0) {
      var i;
      if (e()) return this.ok = !0;
    }
    return this.ok = !1;
  }
  _pushRight(e) {
    for (this.pushState(), this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0) if (e()) return this.ok = !0;
    return this.ok = !1;
  }
  pushLeftBeforeFilled() {
    return this._pushLeft(() => {
      if (!(this.block.isFixed || !this.block.value) && (this.offset = this.block.nearestInputPos(this.offset, kn.FORCE_LEFT), this.offset !== 0)) return !0;
    });
  }
  pushLeftBeforeInput() {
    return this._pushLeft(() => {
      if (!this.block.isFixed) return this.offset = this.block.nearestInputPos(this.offset, kn.LEFT), !0;
    });
  }
  pushLeftBeforeRequired() {
    return this._pushLeft(() => {
      if (!(this.block.isFixed || this.block.isOptional && !this.block.value)) return this.offset = this.block.nearestInputPos(this.offset, kn.LEFT), !0;
    });
  }
  pushRightBeforeFilled() {
    return this._pushRight(() => {
      if (!(this.block.isFixed || !this.block.value) && (this.offset = this.block.nearestInputPos(this.offset, kn.FORCE_RIGHT), this.offset !== this.block.value.length)) return !0;
    });
  }
  pushRightBeforeInput() {
    return this._pushRight(() => {
      if (!this.block.isFixed) return this.offset = this.block.nearestInputPos(this.offset, kn.NONE), !0;
    });
  }
  pushRightBeforeRequired() {
    return this._pushRight(() => {
      if (!(this.block.isFixed || this.block.isOptional && !this.block.value)) return this.offset = this.block.nearestInputPos(this.offset, kn.NONE), !0;
    });
  }
}
class F5 {
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  constructor(e) {
    Object.assign(this, e), this._value = "", this.isFixed = !0;
  }
  get value() {
    return this._value;
  }
  get unmaskedValue() {
    return this.isUnmasking ? this.value : "";
  }
  get rawInputValue() {
    return this._isRawInput ? this.value : "";
  }
  get displayValue() {
    return this.value;
  }
  reset() {
    this._isRawInput = !1, this._value = "";
  }
  remove(e, i) {
    return e === void 0 && (e = 0), i === void 0 && (i = this._value.length), this._value = this._value.slice(0, e) + this._value.slice(i), this._value || (this._isRawInput = !1), new gr();
  }
  nearestInputPos(e, i) {
    i === void 0 && (i = kn.NONE);
    const l = 0,
      c = this._value.length;
    switch (i) {
      case kn.LEFT:
      case kn.FORCE_LEFT:
        return l;
      case kn.NONE:
      case kn.RIGHT:
      case kn.FORCE_RIGHT:
      default:
        return c;
    }
  }
  totalInputPositions(e, i) {
    return e === void 0 && (e = 0), i === void 0 && (i = this._value.length), this._isRawInput ? i - e : 0;
  }
  extractInput(e, i, l) {
    return e === void 0 && (e = 0), i === void 0 && (i = this._value.length), l === void 0 && (l = {}), l.raw && this._isRawInput && this._value.slice(e, i) || "";
  }
  get isComplete() {
    return !0;
  }
  get isFilled() {
    return !!this._value;
  }
  _appendChar(e, i) {
    if (i === void 0 && (i = {}), this.isFilled) return new gr();
    const l = this.eager === !0 || this.eager === "append",
      c = this.char === e && (this.isUnmasking || i.input || i.raw) && (!i.raw || !l) && !i.tail,
      p = new gr({
        inserted: this.char,
        rawInserted: c ? this.char : ""
      });
    return this._value = this.char, this._isRawInput = c && (i.raw || i.input), p;
  }
  _appendEager() {
    return this._appendChar(this.char, {
      tail: !0
    });
  }
  _appendPlaceholder() {
    const e = new gr();
    return this.isFilled || (this._value = e.inserted = this.char), e;
  }
  extractTail() {
    return new Yv("");
  }
  appendTail(e) {
    return nw(e) && (e = new Yv(String(e))), e.appendTo(this);
  }
  append(e, i, l) {
    const c = this._appendChar(e[0], i);
    return l != null && (c.tailShift += this.appendTail(l).tailShift), c;
  }
  doCommit() {}
  get state() {
    return {
      _value: this._value,
      _rawInputValue: this.rawInputValue
    };
  }
  set state(e) {
    this._value = e._value, this._isRawInput = !!e._rawInputValue;
  }
  pad(e) {
    return this._appendPlaceholder();
  }
}
class pO {
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  constructor(e) {
    const {
      parent: i,
      isOptional: l,
      placeholderChar: c,
      displayChar: p,
      lazy: h,
      eager: y,
      ...w
    } = e;
    this.masked = yb(w), Object.assign(this, {
      parent: i,
      isOptional: l,
      placeholderChar: c,
      displayChar: p,
      lazy: h,
      eager: y
    });
  }
  reset() {
    this.isFilled = !1, this.masked.reset();
  }
  remove(e, i) {
    return e === void 0 && (e = 0), i === void 0 && (i = this.value.length), e === 0 && i >= 1 ? (this.isFilled = !1, this.masked.remove(e, i)) : new gr();
  }
  get value() {
    return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : "");
  }
  get unmaskedValue() {
    return this.masked.unmaskedValue;
  }
  get rawInputValue() {
    return this.masked.rawInputValue;
  }
  get displayValue() {
    return this.masked.value && this.displayChar || this.value;
  }
  get isComplete() {
    return !!this.masked.value || this.isOptional;
  }
  _appendChar(e, i) {
    if (i === void 0 && (i = {}), this.isFilled) return new gr();
    const l = this.masked.state;
    let c = this.masked._appendChar(e, this.currentMaskFlags(i));
    return c.inserted && this.doValidate(i) === !1 && (c = new gr(), this.masked.state = l), !c.inserted && !this.isOptional && !this.lazy && !i.input && (c.inserted = this.placeholderChar), c.skip = !c.inserted && !this.isOptional, this.isFilled = !!c.inserted, c;
  }
  append(e, i, l) {
    return this.masked.append(e, this.currentMaskFlags(i), l);
  }
  _appendPlaceholder() {
    return this.isFilled || this.isOptional ? new gr() : (this.isFilled = !0, new gr({
      inserted: this.placeholderChar
    }));
  }
  _appendEager() {
    return new gr();
  }
  extractTail(e, i) {
    return this.masked.extractTail(e, i);
  }
  appendTail(e) {
    return this.masked.appendTail(e);
  }
  extractInput(e, i, l) {
    return e === void 0 && (e = 0), i === void 0 && (i = this.value.length), this.masked.extractInput(e, i, l);
  }
  nearestInputPos(e, i) {
    i === void 0 && (i = kn.NONE);
    const l = 0,
      c = this.value.length,
      p = Math.min(Math.max(e, l), c);
    switch (i) {
      case kn.LEFT:
      case kn.FORCE_LEFT:
        return this.isComplete ? p : l;
      case kn.RIGHT:
      case kn.FORCE_RIGHT:
        return this.isComplete ? p : c;
      case kn.NONE:
      default:
        return p;
    }
  }
  totalInputPositions(e, i) {
    return e === void 0 && (e = 0), i === void 0 && (i = this.value.length), this.value.slice(e, i).length;
  }
  doValidate(e) {
    return this.masked.doValidate(this.currentMaskFlags(e)) && (!this.parent || this.parent.doValidate(this.currentMaskFlags(e)));
  }
  doCommit() {
    this.masked.doCommit();
  }
  get state() {
    return {
      _value: this.value,
      _rawInputValue: this.rawInputValue,
      masked: this.masked.state,
      isFilled: this.isFilled
    };
  }
  set state(e) {
    this.masked.state = e.masked, this.isFilled = e.isFilled;
  }
  currentMaskFlags(e) {
    var i;
    return {
      ...e,
      _beforeTailState: (e == null || (i = e._beforeTailState) == null ? void 0 : i.masked) || (e == null ? void 0 : e._beforeTailState)
    };
  }
  pad(e) {
    return new gr();
  }
}
pO.DEFAULT_DEFINITIONS = {
  0: /\d/,
  a: /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
  // http://stackoverflow.com/a/22075070
  "*": /./
};
class N5 extends ku {
  /** */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const i = e.mask;
    i && (e.validate = l => l.search(i) >= 0), super._update(e);
  }
}
ar.MaskedRegExp = N5;
class uu extends ku {
  /** */
  /** */
  /** Single char for empty input */
  /** Single char for filled input */
  /** Show placeholder only when needed */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  constructor(e) {
    super({
      ...uu.DEFAULTS,
      ...e,
      definitions: Object.assign({}, pO.DEFAULT_DEFINITIONS, e == null ? void 0 : e.definitions)
    });
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    e.definitions = Object.assign({}, this.definitions, e.definitions), super._update(e), this._rebuildMask();
  }
  _rebuildMask() {
    const e = this.definitions;
    this._blocks = [], this.exposeBlock = void 0, this._stops = [], this._maskedBlocks = {};
    const i = this.mask;
    if (!i || !e) return;
    let l = !1,
      c = !1;
    for (let p = 0; p < i.length; ++p) {
      if (this.blocks) {
        const x = i.slice(p),
          E = Object.keys(this.blocks).filter(k => x.indexOf(k) === 0);
        E.sort((k, D) => D.length - k.length);
        const C = E[0];
        if (C) {
          const {
              expose: k,
              repeat: D,
              ...I
            } = oR(this.blocks[C]),
            O = {
              lazy: this.lazy,
              eager: this.eager,
              placeholderChar: this.placeholderChar,
              displayChar: this.displayChar,
              overwrite: this.overwrite,
              autofix: this.autofix,
              ...I,
              repeat: D,
              parent: this
            },
            P = D != null ? new ar.RepeatBlock(O
            /* TODO */) : yb(O);
          P && (this._blocks.push(P), k && (this.exposeBlock = P), this._maskedBlocks[C] || (this._maskedBlocks[C] = []), this._maskedBlocks[C].push(this._blocks.length - 1)), p += C.length - 1;
          continue;
        }
      }
      let h = i[p],
        y = h in e;
      if (h === uu.STOP_CHAR) {
        this._stops.push(this._blocks.length);
        continue;
      }
      if (h === "{" || h === "}") {
        l = !l;
        continue;
      }
      if (h === "[" || h === "]") {
        c = !c;
        continue;
      }
      if (h === uu.ESCAPE_CHAR) {
        if (++p, h = i[p], !h) break;
        y = !1;
      }
      const w = y ? new pO({
        isOptional: c,
        lazy: this.lazy,
        eager: this.eager,
        placeholderChar: this.placeholderChar,
        displayChar: this.displayChar,
        ...oR(e[h]),
        parent: this
      }) : new F5({
        char: h,
        eager: this.eager,
        isUnmasking: l
      });
      this._blocks.push(w);
    }
  }
  get state() {
    return {
      ...super.state,
      _blocks: this._blocks.map(e => e.state)
    };
  }
  set state(e) {
    if (!e) {
      this.reset();
      return;
    }
    const {
      _blocks: i,
      ...l
    } = e;
    this._blocks.forEach((c, p) => c.state = i[p]), super.state = l;
  }
  reset() {
    super.reset(), this._blocks.forEach(e => e.reset());
  }
  get isComplete() {
    return this.exposeBlock ? this.exposeBlock.isComplete : this._blocks.every(e => e.isComplete);
  }
  get isFilled() {
    return this._blocks.every(e => e.isFilled);
  }
  get isFixed() {
    return this._blocks.every(e => e.isFixed);
  }
  get isOptional() {
    return this._blocks.every(e => e.isOptional);
  }
  doCommit() {
    this._blocks.forEach(e => e.doCommit()), super.doCommit();
  }
  get unmaskedValue() {
    return this.exposeBlock ? this.exposeBlock.unmaskedValue : this._blocks.reduce((e, i) => e += i.unmaskedValue, "");
  }
  set unmaskedValue(e) {
    if (this.exposeBlock) {
      const i = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.unmaskedValue = e, this.appendTail(i), this.doCommit();
    } else super.unmaskedValue = e;
  }
  get value() {
    return this.exposeBlock ? this.exposeBlock.value :
    // TODO return _value when not in change?
    this._blocks.reduce((e, i) => e += i.value, "");
  }
  set value(e) {
    if (this.exposeBlock) {
      const i = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.value = e, this.appendTail(i), this.doCommit();
    } else super.value = e;
  }
  get typedValue() {
    return this.exposeBlock ? this.exposeBlock.typedValue : super.typedValue;
  }
  set typedValue(e) {
    if (this.exposeBlock) {
      const i = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.typedValue = e, this.appendTail(i), this.doCommit();
    } else super.typedValue = e;
  }
  get displayValue() {
    return this._blocks.reduce((e, i) => e += i.displayValue, "");
  }
  appendTail(e) {
    return super.appendTail(e).aggregate(this._appendPlaceholder());
  }
  _appendEager() {
    var e;
    const i = new gr();
    let l = (e = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : e.index;
    if (l == null) return i;
    this._blocks[l].isFilled && ++l;
    for (let c = l; c < this._blocks.length; ++c) {
      const p = this._blocks[c]._appendEager();
      if (!p.inserted) break;
      i.aggregate(p);
    }
    return i;
  }
  _appendCharRaw(e, i) {
    i === void 0 && (i = {});
    const l = this._mapPosToBlock(this.displayValue.length),
      c = new gr();
    if (!l) return c;
    for (let h = l.index, y; y = this._blocks[h]; ++h) {
      var p;
      const w = y._appendChar(e, {
        ...i,
        _beforeTailState: (p = i._beforeTailState) == null || (p = p._blocks) == null ? void 0 : p[h]
      });
      if (c.aggregate(w), w.consumed) break;
    }
    return c;
  }
  extractTail(e, i) {
    e === void 0 && (e = 0), i === void 0 && (i = this.displayValue.length);
    const l = new Hx();
    return e === i || this._forEachBlocksInRange(e, i, (c, p, h, y) => {
      const w = c.extractTail(h, y);
      w.stop = this._findStopBefore(p), w.from = this._blockStartPos(p), w instanceof Hx && (w.blockIndex = p), l.extend(w);
    }), l;
  }
  extractInput(e, i, l) {
    if (e === void 0 && (e = 0), i === void 0 && (i = this.displayValue.length), l === void 0 && (l = {}), e === i) return "";
    let c = "";
    return this._forEachBlocksInRange(e, i, (p, h, y, w) => {
      c += p.extractInput(y, w, l);
    }), c;
  }
  _findStopBefore(e) {
    let i;
    for (let l = 0; l < this._stops.length; ++l) {
      const c = this._stops[l];
      if (c <= e) i = c;else break;
    }
    return i;
  }
  /** Appends placeholder depending on laziness */
  _appendPlaceholder(e) {
    const i = new gr();
    if (this.lazy && e == null) return i;
    const l = this._mapPosToBlock(this.displayValue.length);
    if (!l) return i;
    const c = l.index,
      p = e ?? this._blocks.length;
    return this._blocks.slice(c, p).forEach(h => {
      if (!h.lazy || e != null) {
        var y;
        i.aggregate(h._appendPlaceholder((y = h._blocks) == null ? void 0 : y.length));
      }
    }), i;
  }
  /** Finds block in pos */
  _mapPosToBlock(e) {
    let i = "";
    for (let l = 0; l < this._blocks.length; ++l) {
      const c = this._blocks[l],
        p = i.length;
      if (i += c.displayValue, e <= i.length) return {
        index: l,
        offset: e - p
      };
    }
  }
  _blockStartPos(e) {
    return this._blocks.slice(0, e).reduce((i, l) => i += l.displayValue.length, 0);
  }
  _forEachBlocksInRange(e, i, l) {
    i === void 0 && (i = this.displayValue.length);
    const c = this._mapPosToBlock(e);
    if (c) {
      const p = this._mapPosToBlock(i),
        h = p && c.index === p.index,
        y = c.offset,
        w = p && h ? p.offset : this._blocks[c.index].displayValue.length;
      if (l(this._blocks[c.index], c.index, y, w), p && !h) {
        for (let x = c.index + 1; x < p.index; ++x) l(this._blocks[x], x, 0, this._blocks[x].displayValue.length);
        l(this._blocks[p.index], p.index, 0, p.offset);
      }
    }
  }
  remove(e, i) {
    e === void 0 && (e = 0), i === void 0 && (i = this.displayValue.length);
    const l = super.remove(e, i);
    return this._forEachBlocksInRange(e, i, (c, p, h, y) => {
      l.aggregate(c.remove(h, y));
    }), l;
  }
  nearestInputPos(e, i) {
    if (i === void 0 && (i = kn.NONE), !this._blocks.length) return 0;
    const l = new Fq(this, e);
    if (i === kn.NONE) return l.pushRightBeforeInput() || (l.popState(), l.pushLeftBeforeInput()) ? l.pos : this.displayValue.length;
    if (i === kn.LEFT || i === kn.FORCE_LEFT) {
      if (i === kn.LEFT) {
        if (l.pushRightBeforeFilled(), l.ok && l.pos === e) return e;
        l.popState();
      }
      if (l.pushLeftBeforeInput(), l.pushLeftBeforeRequired(), l.pushLeftBeforeFilled(), i === kn.LEFT) {
        if (l.pushRightBeforeInput(), l.pushRightBeforeRequired(), l.ok && l.pos <= e || (l.popState(), l.ok && l.pos <= e)) return l.pos;
        l.popState();
      }
      return l.ok ? l.pos : i === kn.FORCE_LEFT ? 0 : (l.popState(), l.ok || (l.popState(), l.ok) ? l.pos : 0);
    }
    return i === kn.RIGHT || i === kn.FORCE_RIGHT ? (l.pushRightBeforeInput(), l.pushRightBeforeRequired(), l.pushRightBeforeFilled() ? l.pos : i === kn.FORCE_RIGHT ? this.displayValue.length : (l.popState(), l.ok || (l.popState(), l.ok) ? l.pos : this.nearestInputPos(e, kn.LEFT))) : e;
  }
  totalInputPositions(e, i) {
    e === void 0 && (e = 0), i === void 0 && (i = this.displayValue.length);
    let l = 0;
    return this._forEachBlocksInRange(e, i, (c, p, h, y) => {
      l += c.totalInputPositions(h, y);
    }), l;
  }
  /** Get block by name */
  maskedBlock(e) {
    return this.maskedBlocks(e)[0];
  }
  /** Get all blocks by name */
  maskedBlocks(e) {
    const i = this._maskedBlocks[e];
    return i ? i.map(l => this._blocks[l]) : [];
  }
  pad(e) {
    const i = new gr();
    return this._forEachBlocksInRange(0, this.displayValue.length, l => i.aggregate(l.pad(e))), i;
  }
}
uu.DEFAULTS = {
  ...ku.DEFAULTS,
  lazy: !0,
  placeholderChar: "_"
};
uu.STOP_CHAR = "`";
uu.ESCAPE_CHAR = "\\";
uu.InputDefinition = pO;
uu.FixedDefinition = F5;
ar.MaskedPattern = uu;
class VT extends uu {
  /**
    Optionally sets max length of pattern.
    Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
  */
  /** Min bound */
  /** Max bound */
  get _matchFrom() {
    return this.maxLength - String(this.from).length;
  }
  constructor(e) {
    super(e);
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const {
      to: i = this.to || 0,
      from: l = this.from || 0,
      maxLength: c = this.maxLength || 0,
      autofix: p = this.autofix,
      ...h
    } = e;
    this.to = i, this.from = l, this.maxLength = Math.max(String(i).length, c), this.autofix = p;
    const y = String(this.from).padStart(this.maxLength, "0"),
      w = String(this.to).padStart(this.maxLength, "0");
    let x = 0;
    for (; x < w.length && w[x] === y[x];) ++x;
    h.mask = w.slice(0, x).replace(/0/g, "\\0") + "0".repeat(this.maxLength - x), super._update(h);
  }
  get isComplete() {
    return super.isComplete && !!this.value;
  }
  boundaries(e) {
    let i = "",
      l = "";
    const [, c, p] = e.match(/^(\D*)(\d*)(\D*)/) || [];
    return p && (i = "0".repeat(c.length) + p, l = "9".repeat(c.length) + p), i = i.padEnd(this.maxLength, "0"), l = l.padEnd(this.maxLength, "9"), [i, l];
  }
  doPrepareChar(e, i) {
    i === void 0 && (i = {});
    let l;
    return [e, l] = super.doPrepareChar(e.replace(/\D/g, ""), i), e || (l.skip = !this.isComplete), [e, l];
  }
  _appendCharRaw(e, i) {
    if (i === void 0 && (i = {}), !this.autofix || this.value.length + 1 > this.maxLength) return super._appendCharRaw(e, i);
    const l = String(this.from).padStart(this.maxLength, "0"),
      c = String(this.to).padStart(this.maxLength, "0"),
      [p, h] = this.boundaries(this.value + e);
    return Number(h) < this.from ? super._appendCharRaw(l[this.value.length], i) : Number(p) > this.to ? !i.tail && this.autofix === "pad" && this.value.length + 1 < this.maxLength ? super._appendCharRaw(l[this.value.length], i).aggregate(this._appendCharRaw(e, i)) : super._appendCharRaw(c[this.value.length], i) : super._appendCharRaw(e, i);
  }
  doValidate(e) {
    const i = this.value;
    if (i.search(/[^0]/) === -1 && i.length <= this._matchFrom) return !0;
    const [l, c] = this.boundaries(i);
    return this.from <= Number(c) && Number(l) <= this.to && super.doValidate(e);
  }
  pad(e) {
    const i = new gr();
    if (this.value.length === this.maxLength) return i;
    const l = this.value,
      c = this.maxLength - this.value.length;
    if (c) {
      this.reset();
      for (let p = 0; p < c; ++p) i.aggregate(super._appendCharRaw("0", e));
      l.split("").forEach(p => this._appendCharRaw(p));
    }
    return i;
  }
}
ar.MaskedRange = VT;
const Nq = "d{.}`m{.}`Y";
class qv extends uu {
  static extractPatternOptions(e) {
    const {
      mask: i,
      pattern: l,
      ...c
    } = e;
    return {
      ...c,
      mask: nw(i) ? i : l
    };
  }
  /** Pattern mask for date according to {@link MaskedDate#format} */
  /** Start date */
  /** End date */
  /** Format typed value to string */
  /** Parse string to get typed value */
  constructor(e) {
    super(qv.extractPatternOptions({
      ...qv.DEFAULTS,
      ...e
    }));
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const {
        mask: i,
        pattern: l,
        blocks: c,
        ...p
      } = {
        ...qv.DEFAULTS,
        ...e
      },
      h = Object.assign({}, qv.GET_DEFAULT_BLOCKS());
    e.min && (h.Y.from = e.min.getFullYear()), e.max && (h.Y.to = e.max.getFullYear()), e.min && e.max && h.Y.from === h.Y.to && (h.m.from = e.min.getMonth() + 1, h.m.to = e.max.getMonth() + 1, h.m.from === h.m.to && (h.d.from = e.min.getDate(), h.d.to = e.max.getDate())), Object.assign(h, this.blocks, c), super._update({
      ...p,
      mask: nw(i) ? i : l,
      blocks: h
    });
  }
  doValidate(e) {
    const i = this.date;
    return super.doValidate(e) && (!this.isComplete || this.isDateExist(this.value) && i != null && (this.min == null || this.min <= i) && (this.max == null || i <= this.max));
  }
  /** Checks if date is exists */
  isDateExist(e) {
    return this.format(this.parse(e, this), this).indexOf(e) >= 0;
  }
  /** Parsed Date */
  get date() {
    return this.typedValue;
  }
  set date(e) {
    this.typedValue = e;
  }
  get typedValue() {
    return this.isComplete ? super.typedValue : null;
  }
  set typedValue(e) {
    super.typedValue = e;
  }
  maskEquals(e) {
    return e === Date || super.maskEquals(e);
  }
  optionsIsChanged(e) {
    return super.optionsIsChanged(qv.extractPatternOptions(e));
  }
}
qv.GET_DEFAULT_BLOCKS = () => ({
  d: {
    mask: VT,
    from: 1,
    to: 31,
    maxLength: 2
  },
  m: {
    mask: VT,
    from: 1,
    to: 12,
    maxLength: 2
  },
  Y: {
    mask: VT,
    from: 1900,
    to: 9999
  }
});
qv.DEFAULTS = {
  ...uu.DEFAULTS,
  mask: Date,
  pattern: Nq,
  format: (t, e) => {
    if (!t) return "";
    const i = String(t.getDate()).padStart(2, "0"),
      l = String(t.getMonth() + 1).padStart(2, "0"),
      c = t.getFullYear();
    return [i, l, c].join(".");
  },
  parse: (t, e) => {
    const [i, l, c] = t.split(".").map(Number);
    return new Date(c, l - 1, i);
  }
};
ar.MaskedDate = qv;
class zR extends ku {
  constructor(e) {
    super({
      ...zR.DEFAULTS,
      ...e
    }), this.currentMask = void 0;
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    super._update(e), "mask" in e && (this.exposeMask = void 0, this.compiledMasks = Array.isArray(e.mask) ? e.mask.map(i => {
      const {
          expose: l,
          ...c
        } = oR(i),
        p = yb({
          overwrite: this._overwrite,
          eager: this._eager,
          skipInvalid: this._skipInvalid,
          ...c
        });
      return l && (this.exposeMask = p), p;
    }) : []);
  }
  _appendCharRaw(e, i) {
    i === void 0 && (i = {});
    const l = this._applyDispatch(e, i);
    return this.currentMask && l.aggregate(this.currentMask._appendChar(e, this.currentMaskFlags(i))), l;
  }
  _applyDispatch(e, i, l) {
    e === void 0 && (e = ""), i === void 0 && (i = {}), l === void 0 && (l = "");
    const c = i.tail && i._beforeTailState != null ? i._beforeTailState._value : this.value,
      p = this.rawInputValue,
      h = i.tail && i._beforeTailState != null ? i._beforeTailState._rawInputValue : p,
      y = p.slice(h.length),
      w = this.currentMask,
      x = new gr(),
      E = w == null ? void 0 : w.state;
    return this.currentMask = this.doDispatch(e, {
      ...i
    }, l), this.currentMask && (this.currentMask !== w ? (this.currentMask.reset(), h && (this.currentMask.append(h, {
      raw: !0
    }), x.tailShift = this.currentMask.value.length - c.length), y && (x.tailShift += this.currentMask.append(y, {
      raw: !0,
      tail: !0
    }).tailShift)) : E && (this.currentMask.state = E)), x;
  }
  _appendPlaceholder() {
    const e = this._applyDispatch();
    return this.currentMask && e.aggregate(this.currentMask._appendPlaceholder()), e;
  }
  _appendEager() {
    const e = this._applyDispatch();
    return this.currentMask && e.aggregate(this.currentMask._appendEager()), e;
  }
  appendTail(e) {
    const i = new gr();
    return e && i.aggregate(this._applyDispatch("", {}, e)), i.aggregate(this.currentMask ? this.currentMask.appendTail(e) : super.appendTail(e));
  }
  currentMaskFlags(e) {
    var i, l;
    return {
      ...e,
      _beforeTailState: ((i = e._beforeTailState) == null ? void 0 : i.currentMaskRef) === this.currentMask && ((l = e._beforeTailState) == null ? void 0 : l.currentMask) || e._beforeTailState
    };
  }
  doDispatch(e, i, l) {
    return i === void 0 && (i = {}), l === void 0 && (l = ""), this.dispatch(e, this, i, l);
  }
  doValidate(e) {
    return super.doValidate(e) && (!this.currentMask || this.currentMask.doValidate(this.currentMaskFlags(e)));
  }
  doPrepare(e, i) {
    i === void 0 && (i = {});
    let [l, c] = super.doPrepare(e, i);
    if (this.currentMask) {
      let p;
      [l, p] = super.doPrepare(l, this.currentMaskFlags(i)), c = c.aggregate(p);
    }
    return [l, c];
  }
  doPrepareChar(e, i) {
    i === void 0 && (i = {});
    let [l, c] = super.doPrepareChar(e, i);
    if (this.currentMask) {
      let p;
      [l, p] = super.doPrepareChar(l, this.currentMaskFlags(i)), c = c.aggregate(p);
    }
    return [l, c];
  }
  reset() {
    var e;
    (e = this.currentMask) == null || e.reset(), this.compiledMasks.forEach(i => i.reset());
  }
  get value() {
    return this.exposeMask ? this.exposeMask.value : this.currentMask ? this.currentMask.value : "";
  }
  set value(e) {
    this.exposeMask ? (this.exposeMask.value = e, this.currentMask = this.exposeMask, this._applyDispatch()) : super.value = e;
  }
  get unmaskedValue() {
    return this.exposeMask ? this.exposeMask.unmaskedValue : this.currentMask ? this.currentMask.unmaskedValue : "";
  }
  set unmaskedValue(e) {
    this.exposeMask ? (this.exposeMask.unmaskedValue = e, this.currentMask = this.exposeMask, this._applyDispatch()) : super.unmaskedValue = e;
  }
  get typedValue() {
    return this.exposeMask ? this.exposeMask.typedValue : this.currentMask ? this.currentMask.typedValue : "";
  }
  set typedValue(e) {
    if (this.exposeMask) {
      this.exposeMask.typedValue = e, this.currentMask = this.exposeMask, this._applyDispatch();
      return;
    }
    let i = String(e);
    this.currentMask && (this.currentMask.typedValue = e, i = this.currentMask.unmaskedValue), this.unmaskedValue = i;
  }
  get displayValue() {
    return this.currentMask ? this.currentMask.displayValue : "";
  }
  get isComplete() {
    var e;
    return !!((e = this.currentMask) != null && e.isComplete);
  }
  get isFilled() {
    var e;
    return !!((e = this.currentMask) != null && e.isFilled);
  }
  remove(e, i) {
    const l = new gr();
    return this.currentMask && l.aggregate(this.currentMask.remove(e, i)).aggregate(this._applyDispatch()), l;
  }
  get state() {
    var e;
    return {
      ...super.state,
      _rawInputValue: this.rawInputValue,
      compiledMasks: this.compiledMasks.map(i => i.state),
      currentMaskRef: this.currentMask,
      currentMask: (e = this.currentMask) == null ? void 0 : e.state
    };
  }
  set state(e) {
    const {
      compiledMasks: i,
      currentMaskRef: l,
      currentMask: c,
      ...p
    } = e;
    i && this.compiledMasks.forEach((h, y) => h.state = i[y]), l != null && (this.currentMask = l, this.currentMask.state = c), super.state = p;
  }
  extractInput(e, i, l) {
    return this.currentMask ? this.currentMask.extractInput(e, i, l) : "";
  }
  extractTail(e, i) {
    return this.currentMask ? this.currentMask.extractTail(e, i) : super.extractTail(e, i);
  }
  doCommit() {
    this.currentMask && this.currentMask.doCommit(), super.doCommit();
  }
  nearestInputPos(e, i) {
    return this.currentMask ? this.currentMask.nearestInputPos(e, i) : super.nearestInputPos(e, i);
  }
  get overwrite() {
    return this.currentMask ? this.currentMask.overwrite : this._overwrite;
  }
  set overwrite(e) {
    this._overwrite = e;
  }
  get eager() {
    return this.currentMask ? this.currentMask.eager : this._eager;
  }
  set eager(e) {
    this._eager = e;
  }
  get skipInvalid() {
    return this.currentMask ? this.currentMask.skipInvalid : this._skipInvalid;
  }
  set skipInvalid(e) {
    this._skipInvalid = e;
  }
  get autofix() {
    return this.currentMask ? this.currentMask.autofix : this._autofix;
  }
  set autofix(e) {
    this._autofix = e;
  }
  maskEquals(e) {
    return Array.isArray(e) ? this.compiledMasks.every((i, l) => {
      if (!e[l]) return;
      const {
        mask: c,
        ...p
      } = e[l];
      return fO(i, p) && i.maskEquals(c);
    }) : super.maskEquals(e);
  }
  typedValueEquals(e) {
    var i;
    return !!((i = this.currentMask) != null && i.typedValueEquals(e));
  }
}
zR.DEFAULTS = {
  ...ku.DEFAULTS,
  dispatch: (t, e, i, l) => {
    if (!e.compiledMasks.length) return;
    const c = e.rawInputValue,
      p = e.compiledMasks.map((h, y) => {
        const w = e.currentMask === h,
          x = w ? h.displayValue.length : h.nearestInputPos(h.displayValue.length, kn.FORCE_LEFT);
        return h.rawInputValue !== c ? (h.reset(), h.append(c, {
          raw: !0
        })) : w || h.remove(x), h.append(t, e.currentMaskFlags(i)), h.appendTail(l), {
          index: y,
          weight: h.rawInputValue.length,
          totalInputPositions: h.totalInputPositions(0, Math.max(x, h.nearestInputPos(h.displayValue.length, kn.FORCE_LEFT)))
        };
      });
    return p.sort((h, y) => y.weight - h.weight || y.totalInputPositions - h.totalInputPositions), e.compiledMasks[p[0].index];
  }
};
ar.MaskedDynamic = zR;
class VR extends uu {
  constructor(e) {
    super({
      ...VR.DEFAULTS,
      ...e
    });
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const {
      enum: i,
      ...l
    } = e;
    if (i) {
      const c = i.map(y => y.length),
        p = Math.min(...c),
        h = Math.max(...c) - p;
      l.mask = "*".repeat(p), h && (l.mask += "[" + "*".repeat(h) + "]"), this.enum = i;
    }
    super._update(l);
  }
  _appendCharRaw(e, i) {
    i === void 0 && (i = {});
    const l = Math.min(this.nearestInputPos(0, kn.FORCE_RIGHT), this.value.length),
      c = this.enum.filter(p => this.matchValue(p, this.unmaskedValue + e, l));
    if (c.length) {
      c.length === 1 && this._forEachBlocksInRange(0, this.value.length, (h, y) => {
        const w = c[0][y];
        y >= this.value.length || w === h.value || (h.reset(), h._appendChar(w, i));
      });
      const p = super._appendCharRaw(c[0][this.value.length], i);
      return c.length === 1 && c[0].slice(this.unmaskedValue.length).split("").forEach(h => p.aggregate(super._appendCharRaw(h))), p;
    }
    return new gr({
      skip: !this.isComplete
    });
  }
  extractTail(e, i) {
    return e === void 0 && (e = 0), i === void 0 && (i = this.displayValue.length), new Yv("", e);
  }
  remove(e, i) {
    if (e === void 0 && (e = 0), i === void 0 && (i = this.displayValue.length), e === i) return new gr();
    const l = Math.min(super.nearestInputPos(0, kn.FORCE_RIGHT), this.value.length);
    let c;
    for (c = e; c >= 0 && !(this.enum.filter(h => this.matchValue(h, this.value.slice(l, c), l)).length > 1); --c);
    const p = super.remove(c, i);
    return p.tailShift += c - e, p;
  }
  get isComplete() {
    return this.enum.indexOf(this.value) >= 0;
  }
}
VR.DEFAULTS = {
  ...uu.DEFAULTS,
  matchValue: (t, e, i) => t.indexOf(e, i) === i
};
ar.MaskedEnum = VR;
class z5 extends ku {
  /** */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    super._update({
      ...e,
      validate: e.mask
    });
  }
}
ar.MaskedFunction = z5;
var V5;
class ad extends ku {
  /** Single char */
  /** Single char */
  /** Array of single chars */
  /** */
  /** */
  /** Digits after point */
  /** Flag to remove leading and trailing zeros in the end of editing */
  /** Flag to pad trailing zeros after point in the end of editing */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  /** Format typed value to string */
  /** Parse string to get typed value */
  constructor(e) {
    super({
      ...ad.DEFAULTS,
      ...e
    });
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    super._update(e), this._updateRegExps();
  }
  _updateRegExps() {
    const e = "^" + (this.allowNegative ? "[+|\\-]?" : ""),
      i = "\\d*",
      l = (this.scale ? "(" + p2(this.radix) + "\\d{0," + this.scale + "})?" : "") + "$";
    this._numberRegExp = new RegExp(e + i + l), this._mapToRadixRegExp = new RegExp("[" + this.mapToRadix.map(p2).join("") + "]", "g"), this._thousandsSeparatorRegExp = new RegExp(p2(this.thousandsSeparator), "g");
  }
  _removeThousandsSeparators(e) {
    return e.replace(this._thousandsSeparatorRegExp, "");
  }
  _insertThousandsSeparators(e) {
    const i = e.split(this.radix);
    return i[0] = i[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator), i.join(this.radix);
  }
  doPrepareChar(e, i) {
    i === void 0 && (i = {});
    const [l, c] = super.doPrepareChar(this._removeThousandsSeparators(this.scale && this.mapToRadix.length && (
    /*
    radix should be mapped when
    1) input is done from keyboard = flags.input && flags.raw
    2) unmasked value is set = !flags.input && !flags.raw
    and should not be mapped when
    1) value is set = flags.input && !flags.raw
    2) raw value is set = !flags.input && flags.raw
    */
    i.input && i.raw || !i.input && !i.raw) ? e.replace(this._mapToRadixRegExp, this.radix) : e), i);
    return e && !l && (c.skip = !0), l && !this.allowPositive && !this.value && l !== "-" && c.aggregate(this._appendChar("-")), [l, c];
  }
  _separatorsCount(e, i) {
    i === void 0 && (i = !1);
    let l = 0;
    for (let c = 0; c < e; ++c) this._value.indexOf(this.thousandsSeparator, c) === c && (++l, i && (e += this.thousandsSeparator.length));
    return l;
  }
  _separatorsCountFromSlice(e) {
    return e === void 0 && (e = this._value), this._separatorsCount(this._removeThousandsSeparators(e).length, !0);
  }
  extractInput(e, i, l) {
    return e === void 0 && (e = 0), i === void 0 && (i = this.displayValue.length), [e, i] = this._adjustRangeWithSeparators(e, i), this._removeThousandsSeparators(super.extractInput(e, i, l));
  }
  _appendCharRaw(e, i) {
    i === void 0 && (i = {});
    const l = i.tail && i._beforeTailState ? i._beforeTailState._value : this._value,
      c = this._separatorsCountFromSlice(l);
    this._value = this._removeThousandsSeparators(this.value);
    const p = this._value;
    this._value += e;
    const h = this.number;
    let y = !isNaN(h),
      w = !1;
    if (y) {
      let k;
      this.min != null && this.min < 0 && this.number < this.min && (k = this.min), this.max != null && this.max > 0 && this.number > this.max && (k = this.max), k != null && (this.autofix ? (this._value = this.format(k, this).replace(ad.UNMASKED_RADIX, this.radix), w || (w = p === this._value && !i.tail)) : y = !1), y && (y = !!this._value.match(this._numberRegExp));
    }
    let x;
    y ? x = new gr({
      inserted: this._value.slice(p.length),
      rawInserted: w ? "" : e,
      skip: w
    }) : (this._value = p, x = new gr()), this._value = this._insertThousandsSeparators(this._value);
    const E = i.tail && i._beforeTailState ? i._beforeTailState._value : this._value,
      C = this._separatorsCountFromSlice(E);
    return x.tailShift += (C - c) * this.thousandsSeparator.length, x;
  }
  _findSeparatorAround(e) {
    if (this.thousandsSeparator) {
      const i = e - this.thousandsSeparator.length + 1,
        l = this.value.indexOf(this.thousandsSeparator, i);
      if (l <= e) return l;
    }
    return -1;
  }
  _adjustRangeWithSeparators(e, i) {
    const l = this._findSeparatorAround(e);
    l >= 0 && (e = l);
    const c = this._findSeparatorAround(i);
    return c >= 0 && (i = c + this.thousandsSeparator.length), [e, i];
  }
  remove(e, i) {
    e === void 0 && (e = 0), i === void 0 && (i = this.displayValue.length), [e, i] = this._adjustRangeWithSeparators(e, i);
    const l = this.value.slice(0, e),
      c = this.value.slice(i),
      p = this._separatorsCount(l.length);
    this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(l + c));
    const h = this._separatorsCountFromSlice(l);
    return new gr({
      tailShift: (h - p) * this.thousandsSeparator.length
    });
  }
  nearestInputPos(e, i) {
    if (!this.thousandsSeparator) return e;
    switch (i) {
      case kn.NONE:
      case kn.LEFT:
      case kn.FORCE_LEFT:
        {
          const l = this._findSeparatorAround(e - 1);
          if (l >= 0) {
            const c = l + this.thousandsSeparator.length;
            if (e < c || this.value.length <= c || i === kn.FORCE_LEFT) return l;
          }
          break;
        }
      case kn.RIGHT:
      case kn.FORCE_RIGHT:
        {
          const l = this._findSeparatorAround(e);
          if (l >= 0) return l + this.thousandsSeparator.length;
        }
    }
    return e;
  }
  doCommit() {
    if (this.value) {
      const e = this.number;
      let i = e;
      this.min != null && (i = Math.max(i, this.min)), this.max != null && (i = Math.min(i, this.max)), i !== e && (this.unmaskedValue = this.format(i, this));
      let l = this.value;
      this.normalizeZeros && (l = this._normalizeZeros(l)), this.padFractionalZeros && this.scale > 0 && (l = this._padFractionalZeros(l)), this._value = l;
    }
    super.doCommit();
  }
  _normalizeZeros(e) {
    const i = this._removeThousandsSeparators(e).split(this.radix);
    return i[0] = i[0].replace(/^(\D*)(0*)(\d*)/, (l, c, p, h) => c + h), e.length && !/\d$/.test(i[0]) && (i[0] = i[0] + "0"), i.length > 1 && (i[1] = i[1].replace(/0*$/, ""), i[1].length || (i.length = 1)), this._insertThousandsSeparators(i.join(this.radix));
  }
  _padFractionalZeros(e) {
    if (!e) return e;
    const i = e.split(this.radix);
    return i.length < 2 && i.push(""), i[1] = i[1].padEnd(this.scale, "0"), i.join(this.radix);
  }
  doSkipInvalid(e, i, l) {
    i === void 0 && (i = {});
    const c = this.scale === 0 && e !== this.thousandsSeparator && (e === this.radix || e === ad.UNMASKED_RADIX || this.mapToRadix.includes(e));
    return super.doSkipInvalid(e, i, l) && !c;
  }
  get unmaskedValue() {
    return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, ad.UNMASKED_RADIX);
  }
  set unmaskedValue(e) {
    super.unmaskedValue = e;
  }
  get typedValue() {
    return this.parse(this.unmaskedValue, this);
  }
  set typedValue(e) {
    this.rawInputValue = this.format(e, this).replace(ad.UNMASKED_RADIX, this.radix);
  }
  /** Parsed Number */
  get number() {
    return this.typedValue;
  }
  set number(e) {
    this.typedValue = e;
  }
  get allowNegative() {
    return this.min != null && this.min < 0 || this.max != null && this.max < 0;
  }
  get allowPositive() {
    return this.min != null && this.min > 0 || this.max != null && this.max > 0;
  }
  typedValueEquals(e) {
    return (super.typedValueEquals(e) || ad.EMPTY_VALUES.includes(e) && ad.EMPTY_VALUES.includes(this.typedValue)) && !(e === 0 && this.value === "");
  }
}
V5 = ad;
ad.UNMASKED_RADIX = ".";
ad.EMPTY_VALUES = [...ku.EMPTY_VALUES, 0];
ad.DEFAULTS = {
  ...ku.DEFAULTS,
  mask: Number,
  radix: ",",
  thousandsSeparator: "",
  mapToRadix: [V5.UNMASKED_RADIX],
  min: Number.MIN_SAFE_INTEGER,
  max: Number.MAX_SAFE_INTEGER,
  scale: 2,
  normalizeZeros: !0,
  padFractionalZeros: !1,
  parse: Number,
  format: t => t.toLocaleString("en-US", {
    useGrouping: !1,
    maximumFractionDigits: 20
  })
};
ar.MaskedNumber = ad;
const Cj = {
  MASKED: "value",
  UNMASKED: "unmaskedValue",
  TYPED: "typedValue"
};
function B5(t, e, i) {
  e === void 0 && (e = Cj.MASKED), i === void 0 && (i = Cj.MASKED);
  const l = yb(t);
  return c => l.runIsolated(p => (p[e] = c, p[i]));
}
function zq(t, e, i, l) {
  return B5(e, i, l)(t);
}
ar.PIPE_TYPE = Cj;
ar.createPipe = B5;
ar.pipe = zq;
class Vq extends uu {
  get repeatFrom() {
    var e;
    return (e = Array.isArray(this.repeat) ? this.repeat[0] : this.repeat === 1 / 0 ? 0 : this.repeat) != null ? e : 0;
  }
  get repeatTo() {
    var e;
    return (e = Array.isArray(this.repeat) ? this.repeat[1] : this.repeat) != null ? e : 1 / 0;
  }
  constructor(e) {
    super(e);
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    var i, l, c;
    const {
      repeat: p,
      ...h
    } = oR(e);
    this._blockOpts = Object.assign({}, this._blockOpts, h);
    const y = yb(this._blockOpts);
    this.repeat = (i = (l = p ?? y.repeat) != null ? l : this.repeat) != null ? i : 1 / 0, super._update({
      mask: "m".repeat(Math.max(this.repeatTo === 1 / 0 && ((c = this._blocks) == null ? void 0 : c.length) || 0, this.repeatFrom)),
      blocks: {
        m: y
      },
      eager: y.eager,
      overwrite: y.overwrite,
      skipInvalid: y.skipInvalid,
      lazy: y.lazy,
      placeholderChar: y.placeholderChar,
      displayChar: y.displayChar
    });
  }
  _allocateBlock(e) {
    if (e < this._blocks.length) return this._blocks[e];
    if (this.repeatTo === 1 / 0 || this._blocks.length < this.repeatTo) return this._blocks.push(yb(this._blockOpts)), this.mask += "m", this._blocks[this._blocks.length - 1];
  }
  _appendCharRaw(e, i) {
    i === void 0 && (i = {});
    const l = new gr();
    for (let w = (c = (p = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : p.index) != null ? c : Math.max(this._blocks.length - 1, 0), x, E;
    // try to get a block or
    // try to allocate a new block if not allocated already
    x = (h = this._blocks[w]) != null ? h : E = !E && this._allocateBlock(w); ++w) {
      var c, p, h, y;
      const C = x._appendChar(e, {
        ...i,
        _beforeTailState: (y = i._beforeTailState) == null || (y = y._blocks) == null ? void 0 : y[w]
      });
      if (C.skip && E) {
        this._blocks.pop(), this.mask = this.mask.slice(1);
        break;
      }
      if (l.aggregate(C), C.consumed) break;
    }
    return l;
  }
  _trimEmptyTail(e, i) {
    var l, c;
    e === void 0 && (e = 0);
    const p = Math.max(((l = this._mapPosToBlock(e)) == null ? void 0 : l.index) || 0, this.repeatFrom, 0);
    let h;
    i != null && (h = (c = this._mapPosToBlock(i)) == null ? void 0 : c.index), h == null && (h = this._blocks.length - 1);
    let y = 0;
    for (let w = h; p <= w && !this._blocks[w].unmaskedValue; --w, ++y);
    y && (this._blocks.splice(h - y + 1, y), this.mask = this.mask.slice(y));
  }
  reset() {
    super.reset(), this._trimEmptyTail();
  }
  remove(e, i) {
    e === void 0 && (e = 0), i === void 0 && (i = this.displayValue.length);
    const l = super.remove(e, i);
    return this._trimEmptyTail(e, i), l;
  }
  totalInputPositions(e, i) {
    return e === void 0 && (e = 0), i == null && this.repeatTo === 1 / 0 ? 1 / 0 : super.totalInputPositions(e, i);
  }
  get state() {
    return super.state;
  }
  set state(e) {
    this._blocks.length = e._blocks.length, this.mask = this.mask.slice(0, this._blocks.length), super.state = e;
  }
}
ar.RepeatBlock = Vq;
try {
  globalThis.IMask = ar;
} catch {}
const Bq = Qn(({
  id: t,
  label: e,
  name: i,
  helperText: l,
  errorMessage: c,
  readOnly: p,
  required: h,
  disabled: y,
  labels: w,
  enableClearButton: x,
  displayClearLabel: E,
  iconOptions: C,
  isLoading: k = !1,
  loaderConfig: D,
  maskOptions: I,
  value: O = "",
  onAccept: P,
  className: N,
  classNames: L,
  children: F,
  // Catch-all prop for anything not exclusively specified
  ...j
}, V) => {
  const K = vt(null),
    G = vt(null),
    [Q, te] = rt(""),
    [ie, Y] = rt(""),
    [ee, oe] = rt(),
    [ne, se] = rt(!1);
  let ue = !0;
  const W = pn((de, Ce = !1) => {
      var Ee;
      G.current && (P == null || P(G.current, Ce));
      const fe = ((Ee = de == null ? void 0 : de.target) == null ? void 0 : Ee.value) ?? "";
      (de == null ? void 0 : de.inputType) === "deleteContentBackward" ? te(fe === ie ? "" : fe) : te(fe);
    }, [ie, P]),
    $ = de => {
      G.current && G.current.unmaskedValue !== de && (G.current.unmaskedValue = de, te(de));
    },
    le = de => {
      switch (de == null ? void 0 : de.mask) {
        case Number:
        case "MaskedNumber":
          de.mask = ad;
          break;
        case Date:
        case "MaskedDate":
          de.mask = qv;
          break;
        case "MaskedDynamic":
          de.mask = zR;
          break;
        case "MaskedEnum":
          de.mask = VR;
          break;
        case "MaskedFunction":
          de.mask = z5;
          break;
        case "MaskedPattern":
          de.mask = uu;
          break;
        case "MaskedRange":
          de.mask = VT;
          break;
        case RegExp:
        case "MaskedRegExp":
          de.mask = N5;
          break;
      }
      return de;
    },
    H = de => (de = le(de), "blocks" in de && de != null && de.blocks && typeof de.blocks == "object" && (de.blocks = Object.fromEntries(Object.entries(de.blocks).map(([Ce, Ee]) => ("mask" in Ee && (Ee = le(Ee)), [Ce, Ee])))), "definitions" in de && de != null && de.definitions && typeof de.definitions == "object" && (de.definitions = Object.fromEntries(Object.entries(de.definitions).map(([Ce, Ee]) => ("mask" in Ee && (Ee = le(Ee)), [Ce, Ee])))), de),
    ce = async de => {
      if (!I) ue = !1;else try {
        I = H(I);
        const Ce = ar(de, I);
        G.current = Ce;
        let Ee = !0;
        Ce.on("accept", fe => {
          Ee || W(fe, !1);
        }), Ce.on("complete", fe => {
          Ee || W(fe, !0);
        }), O && Ce.unmaskedValue !== O ? (Ce.unmaskedValue = O, te(O)) : te(Ce.unmaskedValue), Y(Ce.value), Ee = !1;
      } catch (Ce) {
        console.error("[MaskedInput] Failed to initialize IMask:", Ce), ue = !1;
      }
    };
  return Rt(() => {
    Q && (I != null && I.lazy || Q !== ie && !(I != null && I.lazy)) ? oe(!0) : oe(!1);
  }, [Q, ie, I == null ? void 0 : I.lazy]), Rt(() => {
    se(!0);
  }, []), Rt(() => {
    if (!(!ne || !K.current || G.current)) return ce(K.current), () => {
      G.current && (G.current.destroy(), G.current = null);
    };
  }, [ne]), jR(V, () => K.current, []), ne ? /* @__PURE__ */_e.jsx(_e.Fragment, {
    children: /* @__PURE__ */_e.jsx(L5, {
      type: "text",
      id: t,
      label: e || "<Label is required>",
      name: i,
      helperText: l,
      errorMessage: c,
      readOnly: p,
      required: h,
      disabled: y,
      labels: w,
      enableClearButton: x,
      displayClearLabel: E,
      ref: K,
      iconOptions: C,
      isLoading: k,
      loaderConfig: D,
      isMasked: ue,
      isMaskedValue: ee,
      maskedPattern: ie,
      onMaskUpdate: $,
      className: N,
      classNames: L,
      children: F,
      ...j
    })
  }) : null;
});
var wV = {
  exports: {}
};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var _V;
function Uq() {
  return _V || (_V = 1, function (t) {
    (function () {
      var e = {}.hasOwnProperty;
      function i() {
        for (var p = "", h = 0; h < arguments.length; h++) {
          var y = arguments[h];
          y && (p = c(p, l(y)));
        }
        return p;
      }
      function l(p) {
        if (typeof p == "string" || typeof p == "number") return p;
        if (typeof p != "object") return "";
        if (Array.isArray(p)) return i.apply(null, p);
        if (p.toString !== Object.prototype.toString && !p.toString.toString().includes("[native code]")) return p.toString();
        var h = "";
        for (var y in p) e.call(p, y) && p[y] && (h = c(h, y));
        return h;
      }
      function c(p, h) {
        return h ? p ? p + " " + h : p + h : p;
      }
      t.exports ? (i.default = i, t.exports = i) : window.classNames = i;
    })();
  }(wV)), wV.exports;
}
var Hq = Uq();
const vl = /* @__PURE__ */lH(Hq),
  pN = "RovingFocusGroup",
  [kj, U5, $q] = fH(pN),
  [Wq, GO] = OE(pN, [$q]),
  [qq, Yq] = Wq(pN),
  Gq = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
  };
function Xq(t, e) {
  return e !== "rtl" ? t : t === "ArrowLeft" ? "ArrowRight" : t === "ArrowRight" ? "ArrowLeft" : t;
}
function Kq(t, e, i) {
  const l = Xq(t.key, i);
  if (!(e === "vertical" && ["ArrowLeft", "ArrowRight"].includes(l)) && !(e === "horizontal" && ["ArrowUp", "ArrowDown"].includes(l))) return Gq[l];
}
function H5(t, e = !1) {
  const i = document.activeElement;
  for (const l of t) if (l === i || (l.focus({
    preventScroll: e
  }), document.activeElement !== i)) return;
}
function Qq(t, e) {
  return t.map((i, l) => t[(e + l) % t.length]);
}
const h2 = "rovingFocusGroup.onEntryFocus",
  Zq = {
    bubbles: !1,
    cancelable: !0
  },
  Jq = "RovingFocusGroup",
  eY = "RovingFocusGroupItem",
  tY = Nt.forwardRef((t, e) => {
    const {
        __scopeRovingFocusGroup: i,
        orientation: l,
        loop: c = !1,
        dir: p,
        currentTabStopId: h,
        defaultCurrentTabStopId: y,
        onCurrentTabStopIdChange: w,
        onEntryFocus: x,
        preventScrollOnEntryFocus: E = !1,
        ...C
      } = t,
      k = vt(null),
      D = _E(e, k),
      I = dN(p),
      [O, P] = PE({
        prop: h,
        defaultProp: y ?? null,
        onChange: w
      }),
      [N, L] = rt(!1),
      F = R7(x),
      j = U5(i),
      V = Nt.useRef(!1),
      [K, G] = rt(0),
      Q = pn(oe => P(oe), [P]),
      te = pn(() => L(!0), []),
      ie = pn(() => G(oe => oe + 1), []),
      Y = pn(() => G(oe => oe - 1), []),
      ee = zp(t.onFocus, oe => {
        const ne = !V.current;
        if (oe.target === oe.currentTarget && ne && !N) {
          const se = new CustomEvent(h2, Zq);
          if (oe.currentTarget.dispatchEvent(se), !se.defaultPrevented) {
            const ue = j().filter(H => H.focusable),
              W = ue.find(H => H.active),
              $ = ue.find(H => H.id === O),
              le = [W, $, ...ue].filter(Boolean).map(H => H.ref.current);
            H5(le, E);
          }
        }
        V.current = !1;
      });
    return Rt(() => {
      const oe = k.current;
      if (oe) return oe.addEventListener(h2, F), () => oe.removeEventListener(h2, F);
    }, [F]), /* @__PURE__ */_e.jsx(qq, {
      scope: i,
      orientation: l,
      dir: I,
      loop: c,
      currentTabStopId: O,
      onItemFocus: Q,
      onItemShiftTab: te,
      onFocusableItemAdd: ie,
      onFocusableItemRemove: Y,
      children: /* @__PURE__ */_e.jsx(sa.div, {
        tabIndex: N || K === 0 ? -1 : 0,
        "data-orientation": l,
        ...C,
        ref: D,
        style: {
          outline: "none",
          ...t.style
        },
        onMouseDown: zp(t.onMouseDown, () => {
          V.current = !0;
        }),
        onFocus: ee,
        onBlur: zp(t.onBlur, () => L(!1))
      })
    });
  }),
  $5 = Qn((t, e) => {
    const {
        __scopeRovingFocusGroup: i,
        focusable: l = !0,
        active: c = !1,
        tabStopId: p,
        children: h,
        ...y
      } = t,
      w = ME(),
      x = p || w,
      E = Yq(eY, i),
      C = E.currentTabStopId === x,
      k = U5(i),
      {
        onFocusableItemAdd: D,
        onFocusableItemRemove: I,
        currentTabStopId: O
      } = E;
    return Rt(() => {
      if (l) return D(), () => I();
    }, [l, D, I]), /* @__PURE__ */_e.jsx(kj.ItemSlot, {
      scope: i,
      id: x,
      focusable: l,
      active: c,
      children: /* @__PURE__ */_e.jsx(sa.span, {
        tabIndex: C ? 0 : -1,
        "data-orientation": E.orientation,
        ...y,
        ref: e,
        onMouseDown: zp(t.onMouseDown, P => {
          l ? E.onItemFocus(x) : P.preventDefault();
        }),
        onFocus: zp(t.onFocus, () => E.onItemFocus(x)),
        onKeyDown: zp(t.onKeyDown, P => {
          if (P.key === "Tab" && P.shiftKey) {
            E.onItemShiftTab();
            return;
          }
          if (P.target !== P.currentTarget) return;
          const N = Kq(P, E.orientation, E.dir);
          if (N !== void 0) {
            if (P.metaKey || P.ctrlKey || P.altKey || P.shiftKey) return;
            P.preventDefault();
            let L = k().filter(F => F.focusable).map(F => F.ref.current);
            if (N === "last") L.reverse();else if (N === "prev" || N === "next") {
              N === "prev" && L.reverse();
              const F = L.indexOf(P.currentTarget);
              L = E.loop ? Qq(L, F + 1) : L.slice(F + 1);
            }
            setTimeout(() => H5(L));
          }
        }),
        children: typeof h == "function" ? h({
          isCurrentTabStop: C,
          hasTabStop: O != null
        }) : h
      })
    });
  }),
  hN = Qn((t, e) => /* @__PURE__ */_e.jsx(kj.Provider, {
    scope: t.__scopeRovingFocusGroup,
    children: /* @__PURE__ */_e.jsx(kj.Slot, {
      scope: t.__scopeRovingFocusGroup,
      children: /* @__PURE__ */_e.jsx(tY, {
        ...t,
        ref: e
      })
    })
  }));
hN.displayName = Jq;
const mN = "NavList",
  [nY, T_e] = OE(mN, [GO]),
  W5 = GO(),
  [rY, iY] = nY(mN),
  aY = Qn((t, e) => {
    const {
        __scopeNavList: i,
        disabled: l,
        value: c,
        ...p
      } = t,
      h = iY(mN, i),
      y = W5(i),
      w = c === h.value;
    return /* @__PURE__ */_e.jsx($5, {
      asChild: !0,
      ...y,
      focusable: !l,
      children: /* @__PURE__ */_e.jsx(sa.a, {
        href: `#${c}`,
        "data-state": w ? "active" : "inactive",
        ...p,
        onMouseDown: zp(t.onMouseDown, x => {
          !l && x.button === 0 && x.ctrlKey === !1 ? h.onValueChange(c) : x.preventDefault();
        }),
        onKeyDown: zp(t.onKeyDown, x => {
          [" ", "Enter"].includes(x.key) && h.onValueChange(c);
        }),
        ref: e
      })
    });
  }),
  oY = Qn((t, e) => {
    const {
        __scopeNavList: i,
        value: l,
        onValueChange: c,
        defaultValue: p,
        loop: h = !0,
        dir: y,
        orientation: w,
        ...x
      } = t,
      E = W5(i),
      [C, k] = PE({
        prop: l,
        onChange: c,
        defaultProp: p ?? ""
      });
    return /* @__PURE__ */_e.jsx(rY, {
      scope: i,
      baseId: ME(),
      value: C,
      onValueChange: k,
      orientation: "horizontal",
      dir: "ltr",
      children: /* @__PURE__ */_e.jsx(hN, {
        asChild: !0,
        ...E,
        orientation: w,
        dir: y,
        loop: h,
        children: /* @__PURE__ */_e.jsx(sa.nav, {
          ...x,
          ref: e
        })
      })
    });
  }),
  sY = {
    noResults: "No results found",
    a11yOpenMenu: "Open menu",
    a11yCloseMenu: "Close menu",
    a11ySelectedLiveRegion: 'Selected "{{ label }}"',
    a11yUnselectedLiveRegion: "No selected options",
    clearAll: "Clear All"
  },
  lY = Qn(({
    id: t,
    isLoading: e = !1,
    data: i = [],
    values: l,
    initialSelectedItem: c,
    onSelectChange: p,
    iconOptions: h,
    isAutoCloseMenu: y = !1,
    environment: w,
    children: x,
    className: E,
    classNames: C,
    valueClassName: k,
    iconClassName: D,
    onFocus: I = () => {},
    onBlur: O = () => {},
    handleClearAll: P = () => {},
    resetTrigger: N,
    onOpenDropdown: L,
    label: F,
    labels: j = {},
    onReset: V = () => {},
    clearAllOption: K = !0,
    isDisabled: G = !1,
    errorMessage: Q,
    helperText: te,
    renderCustomListItem: ie,
    loaderConfig: Y
  }, ee) => {
    const oe = {
        ...sY,
        ...j
      },
      ne = vt(null),
      se = vt(null),
      [ue, W] = rt(!1),
      [$, le] = rt(""),
      [H, ce] = rt(""),
      de = vt(null),
      Ce = typeof window < "u",
      [Ee, fe] = rt(),
      xe = (Ot, Et) => {
        const {
            type: Vt,
            changes: Xt
          } = Et,
          vn = [jp.stateChangeTypes.MenuMouseLeave, jp.stateChangeTypes.ToggleButtonKeyDownEscape, jp.stateChangeTypes.FunctionCloseMenu];
        return Vt === jp.stateChangeTypes.ToggleButtonClick ? Xt : !vn.includes(Vt) && !y && Xt.isOpen === !1 ? {
          ...Xt,
          isOpen: !0
        } : Xt;
      },
      we = Ot => Ot ? Ot.label ?? "" : "",
      ve = ci(() => i ? i.reduce((Ot, Et) => {
        Et.title && Ot.push({
          title: Et.title,
          label: Et.title,
          value: Et.title,
          isGroupTitle: !0
        });
        const Vt = Et.items.filter(Xt => Xt.label !== Et.title);
        return Ot.push(...Vt), Ot;
      }, []) : [], [i]),
      Te = ci(() => ve.filter(Ot => Ot.title || Ot.isGroupTitle).length <= 1 ? ve.filter(Ot => !Ot.isGroupTitle && !Ot.title) : ve, [i]),
      ze = Ot => (l || []).some(Et => Et.value === Ot.value),
      Xe = Ot => {
        const Et = i.find(Xt => Xt.title === Ot);
        if (!Et) return !1;
        const Vt = Et.items.filter(Xt => Xt.label !== Et.title);
        return Vt.length === 0 ? !1 : Vt.every(Xt => (l || []).some(vn => vn.value === Xt.value));
      },
      ye = (Ot = "") => {
        var Et;
        const Vt = (l || []).filter(We => We.countryName || We.isGroupTitle);
        if (Vt.length === 0) return Ot;
        if (Vt.length === 1) return (Et = Vt[0]) == null ? void 0 : Et.label;
        const Xt = Vt.filter(We => We.isGroupTitle),
          vn = Vt.filter(We => !We.isGroupTitle),
          ot = Xt.filter(We => !vn.some(ht => ht.countryName === We.title));
        return `${F} (${ot.length + vn.length})`;
      },
      {
        isOpen: qe,
        closeMenu: Ae,
        selectItem: Mt,
        highlightedIndex: Ft,
        setHighlightedIndex: un,
        getMenuProps: gt,
        getToggleButtonProps: Pt,
        getItemProps: St
      } = jp({
        id: t,
        labelId: t,
        stateReducer: xe,
        items: Te,
        itemToString: we,
        selectedItem: null,
        // Prevents single select behaviour
        onIsOpenChange: Ot => {
          var Et;
          const Vt = Ce ? window.matchMedia(`(max-width: ${rd.breakpoint.sm.value})`).matches : !1;
          Ot.isOpen ? I == null || I() : (O == null || O(), (Et = ne.current) == null || Et.focus()), Ot.isOpen && Vt && se != null && se.current ? ($O(se.current), L == null || L(se.current)) : se.current && aR(se.current);
        },
        onSelectedItemChange: Ot => {
          var Et, Vt;
          Ot.selectedItem && (p == null || p(Ot.selectedItem));
          const Xt = Te.findIndex(vn => {
            var ot;
            return vn.value === ((ot = Ot.selectedItem) == null ? void 0 : ot.value);
          });
          fe(Xt), Ot.type !== "__function_select_item__" && ((Et = Ot.selectedItem) == null ? void 0 : Et.value) !== (c == null ? void 0 : c.value) && (W(!0), (Vt = ne.current) == null || Vt.focus(), Ot.isOpen && !y && un(Ft));
        },
        environment: w ? {
          addEventListener: w.addEventListener.bind(w),
          removeEventListener: w.removeEventListener.bind(w),
          document: w != null && w.document ? w.document : document,
          Node: w.Node
        } : Ce ? window : void 0
      }),
      Dt = pn(Ot => {
        var Et, Vt;
        if (se) {
          if ((Et = se.current) != null && Et.contains(Ot == null ? void 0 : Ot.target) || ne && (Vt = ne.current) != null && Vt.contains(Ot == null ? void 0 : Ot.target)) return;
          Ae(), W(!1);
        }
      }, [Ae]),
      Kt = Ot => {
        var Et;
        const Vt = ve.filter(ot => ot.title || ot.isGroupTitle).length;
        let Xt = -1;
        const vn = (ot, We) => {
          const ht = ze(ot),
            Ke = ot.isGroupTitle || !!ot.title,
            yt = Ke ? Xe(ot.title || ot.label || "") : !1,
            je = {
              item: ot,
              index: We,
              className: Ze(Vn.item, C == null ? void 0 : C.listItem, ht && (C == null ? void 0 : C.itemSelected), Ke && [Vn.group, C == null ? void 0 : C.itemGroup, C == null ? void 0 : C.listHeading], Ke && yt && Vn.groupSelected, Ft === We && [Vn.highlighted, C == null ? void 0 : C.itemActive], ot.disabled && [Vn.disabled, C == null ? void 0 : C.itemDisabled], ot.className),
              "aria-selected": ht || Ke && yt,
              "aria-disabled": ot.disabled ? !0 : void 0,
              onClick: at => {
                at.stopPropagation();
              }
            };
          if (ie) {
            const at = ie(`item-${We}`, ot, St, je);
            return /* @__PURE__ */_e.jsx(Nt.Fragment, {
              children: at
            }, `item-${We}`);
          }
          return /* @__PURE__ */_e.jsx("li", {
            ...St(je),
            children: ot.title ? ot.title : we(ot)
          }, `item-${We}`);
        };
        return Vt > 1 ? /* @__PURE__ */_e.jsx("ul", {
          role: "group",
          "aria-labelledby": `${t}-group`,
          className: Ze(Vn.list),
          children: ve.map(ot => (Xt++, vn(ot, Xt)))
        }) : /* @__PURE__ */_e.jsxs("ul", {
          role: "group",
          "aria-labelledby": `${t}-group`,
          className: Ze(Vn.list),
          children: [((Et = ve[0]) == null ? void 0 : Et.title) && /* @__PURE__ */_e.jsx("div", {
            className: Ze(Vn.group, C == null ? void 0 : C.listHeading),
            id: `${t}-group-0`,
            children: ve[0].title
          }), Ot.map(ot => (Xt++, vn(ot, Xt)))]
        });
      },
      hn = () => {
        P(), V == null || V();
      };
    return Rt(() => (window.document.addEventListener("mousedown", Dt, !1), () => {
      window.document.removeEventListener("mousedown", Dt, !1);
    }), [Dt]), Rt(() => {
      const Ot = setTimeout(() => {
        ce($);
      }, 200);
      return () => clearTimeout(Ot);
    }, [$]), Rt(() => {
      c && Mt(c);
    }, [Mt, c]), Rt(() => {
      N !== void 0 && N > 0 && P();
    }, [N, P]), Rt(() => () => {
      se.current && aR(se.current);
    }, []), Rt(() => {
      le((l == null ? void 0 : l.map(Ot => Ot.label).join(", ")) || "");
    }, [l]), /* @__PURE__ */_e.jsx(AE, {
      ref: ee,
      className: Ze(Vn.dropdown, qe && !e && [Vn.dropdownOpen, C == null ? void 0 : C.inputWrapperOpen], (e || (l == null ? void 0 : l.length)) && [Vn.selectedValue, C == null ? void 0 : C.inputWrapperSelected], E, ue && Vn.dropdownFocus),
      classNames: {
        label: Ze(C == null ? void 0 : C.inputLabel),
        helperText: C == null ? void 0 : C.inputHelperText,
        errorText: Ze(!G && Q && (C == null ? void 0 : C.inputErrorText)),
        focus: Ze(ue && (C == null ? void 0 : C.inputWrapperFocus)),
        error: Ze(!G && Q && [Vn.dropdownError, C == null ? void 0 : C.inputWrapperError]),
        disabled: Ze(G && [Vn.dropdownInputDisabled, C == null ? void 0 : C.inputWrapperDisabled])
      },
      errorMessage: Q,
      messageId: `${t}-message`,
      isDisabled: G,
      helperText: te,
      isFocused: ue && !e,
      children: /* @__PURE__ */_e.jsxs(_e.Fragment, {
        children: [/* @__PURE__ */_e.jsxs("button", {
          disabled: G,
          type: "button",
          "aria-label": qe && !e ? oe.a11yCloseMenu : oe.a11yOpenMenu,
          "aria-describedby": te || Q ? `${t}-message` : void 0,
          onFocusCapture: () => {
            W(!0);
          },
          onBlurCapture: () => {
            W(!1);
          },
          className: Ze(Vn.dropdownInput, e && (C == null ? void 0 : C.inputLoader), C == null ? void 0 : C.inputToggleButton),
          ...Pt({
            ref: ne,
            "aria-labelledby": `${t}-label`,
            "aria-activedescendant": Ft !== -1 ? `${t}-item-${Ft}` : Ee != null ? `${t}-item-${Ee}` : void 0,
            onFocus: () => {
              I == null || I();
            },
            onBlur: () => {
              !qe && !G && (O == null || O());
            }
          }),
          children: [/* @__PURE__ */_e.jsx("label", {
            id: `${t}-label`,
            children: F
          }), /* @__PURE__ */_e.jsx("span", {
            className: Ze(k, Vn.dropdownInputValue, C == null ? void 0 : C.value),
            children: ye()
          }), e && /* @__PURE__ */_e.jsx(FE, {
            className: C == null ? void 0 : C.loader,
            size: hb.small,
            status: Um.loading,
            align: jE.vertical,
            responsive: !1,
            ...Y
          }), !G && !e && /* @__PURE__ */_e.jsxs("span", {
            "aria-hidden": "true",
            className: Ze(Vn.dropdownIcon, D, C == null ? void 0 : C.icon, Q ? [Vn.dropdownIcon, Vn.dropdownIconError, C == null ? void 0 : C.iconError] : Vn.dropdownIcon),
            ref: de,
            children: [qe && ((h == null ? void 0 : h.open) || /* @__PURE__ */_e.jsx(_e.Fragment, {
              children: "▲"
            })), !qe && ((h == null ? void 0 : h.close) || /* @__PURE__ */_e.jsx(_e.Fragment, {
              children: "▼"
            }))]
          }), G && /* @__PURE__ */_e.jsx("span", {
            "aria-hidden": "true",
            className: Ze(Vn.dropdownIcon, Vn.dropdownIconDisabled, D, C == null ? void 0 : C.icon, C == null ? void 0 : C.iconDisabled),
            children: (h == null ? void 0 : h.disabled) || /* @__PURE__ */_e.jsx(_e.Fragment, {
              children: "×"
            })
          })]
        }), x, /* @__PURE__ */_e.jsx("div", {
          id: `${t}-live`,
          className: Vn.srOnly,
          "aria-live": "polite",
          "aria-atomic": "true",
          children: H ? oe.a11ySelectedLiveRegion.replace("{{ label }}", H) : oe.a11yUnselectedLiveRegion
        }), /* @__PURE__ */_e.jsxs("div", {
          ...gt({
            ref: se,
            isOpen: qe,
            onBlur: () => {
              var Ot;
              O == null || O(), (Ot = ne.current) == null || Ot.focus();
            },
            onClick: Ot => {
              var Et, Vt;
              const Xt = parseInt((Et = Ot.nativeEvent.target) == null ? void 0 : Et.id.replace(`${t}-group-`, ""), 10);
              if (Xt !== null) {
                let vn = 0;
                ((ot, We) => {
                  var ht;
                  for (let Ke = 0; Ke < We; Ke++) (ht = ot[Ke]) != null && ht.items && (vn += ot[Ke].items.length);
                })(i, Xt), un(vn);
              }
              (Vt = ne.current) == null || Vt.focus();
            },
            role: "listbox",
            "aria-labelledby": void 0,
            "aria-expanded": void 0,
            tabIndex: qe ? 0 : -1
          }),
          className: Ze(Vn.dropdownListbox, qe && !e && [Vn.dropdownListboxOpen, Vn.open], C == null ? void 0 : C.listBox),
          children: [!e && (i.length > 0 && qe ? Kt(Te) : qe ? /* @__PURE__ */_e.jsx("li", {
            className: Ze(Vn.noResults, C == null ? void 0 : C.noResults),
            children: oe.noResults
          }) : null), K && qe && /* @__PURE__ */_e.jsx("button", {
            type: "button",
            className: Ze(Vn.clearAllBtn, C == null ? void 0 : C.clearAllBtn),
            onClick: () => {
              hn(), P();
            },
            children: oe.clearAll
          })]
        })]
      })
    });
  }),
  aM = "all",
  xV = "alert",
  SV = "offer",
  uY = {
    a11yCloseMenu: "Close notifications",
    a11yOpenLiveRegion: 'Showing "{{ filter }}" notifications',
    a11yClosedLiveRegion: "Notifications are hidden",
    a11yMenu: "Notification categories",
    a11yList: "Notifications list"
  };
var oM = {
  exports: {}
};
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var q5 = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"],
  hO = /* @__PURE__ */q5.join(","),
  Y5 = typeof Element > "u",
  Zx = Y5 ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector,
  mO = !Y5 && Element.prototype.getRootNode ? function (t) {
    var e;
    return t == null || (e = t.getRootNode) === null || e === void 0 ? void 0 : e.call(t);
  } : function (t) {
    return t == null ? void 0 : t.ownerDocument;
  },
  vO = function t(e, i) {
    var l;
    i === void 0 && (i = !0);
    var c = e == null || (l = e.getAttribute) === null || l === void 0 ? void 0 : l.call(e, "inert"),
      p = c === "" || c === "true",
      h = p || i && e && t(e.parentNode);
    return h;
  },
  cY = function (t) {
    var e,
      i = t == null || (e = t.getAttribute) === null || e === void 0 ? void 0 : e.call(t, "contenteditable");
    return i === "" || i === "true";
  },
  G5 = function (t, e, i) {
    if (vO(t)) return [];
    var l = Array.prototype.slice.apply(t.querySelectorAll(hO));
    return e && Zx.call(t, hO) && l.unshift(t), l = l.filter(i), l;
  },
  X5 = function t(e, i, l) {
    for (var c = [], p = Array.from(e); p.length;) {
      var h = p.shift();
      if (!vO(h, !1)) if (h.tagName === "SLOT") {
        var y = h.assignedElements(),
          w = y.length ? y : h.children,
          x = t(w, !0, l);
        l.flatten ? c.push.apply(c, x) : c.push({
          scopeParent: h,
          candidates: x
        });
      } else {
        var E = Zx.call(h, hO);
        E && l.filter(h) && (i || !e.includes(h)) && c.push(h);
        var C = h.shadowRoot ||
          // check for an undisclosed shadow
          typeof l.getShadowRoot == "function" && l.getShadowRoot(h),
          k = !vO(C, !1) && (!l.shadowRootFilter || l.shadowRootFilter(h));
        if (C && k) {
          var D = t(C === !0 ? h.children : C.children, !0, l);
          l.flatten ? c.push.apply(c, D) : c.push({
            scopeParent: h,
            candidates: D
          });
        } else p.unshift.apply(p, h.children);
      }
    }
    return c;
  },
  K5 = function (t) {
    return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
  },
  X0 = function (t) {
    if (!t) throw new Error("No node provided");
    return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || cY(t)) && !K5(t) ? 0 : t.tabIndex;
  },
  dY = function (t, e) {
    var i = X0(t);
    return i < 0 && e && !K5(t) ? 0 : i;
  },
  fY = function (t, e) {
    return t.tabIndex === e.tabIndex ? t.documentOrder - e.documentOrder : t.tabIndex - e.tabIndex;
  },
  Q5 = function (t) {
    return t.tagName === "INPUT";
  },
  pY = function (t) {
    return Q5(t) && t.type === "hidden";
  },
  hY = function (t) {
    var e = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function (i) {
      return i.tagName === "SUMMARY";
    });
    return e;
  },
  mY = function (t, e) {
    for (var i = 0; i < t.length; i++) if (t[i].checked && t[i].form === e) return t[i];
  },
  vY = function (t) {
    if (!t.name) return !0;
    var e = t.form || mO(t),
      i = function (p) {
        return e.querySelectorAll('input[type="radio"][name="' + p + '"]');
      },
      l;
    if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function") l = i(window.CSS.escape(t.name));else try {
      l = i(t.name);
    } catch (p) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", p.message), !1;
    }
    var c = mY(l, t.form);
    return !c || c === t;
  },
  gY = function (t) {
    return Q5(t) && t.type === "radio";
  },
  yY = function (t) {
    return gY(t) && !vY(t);
  },
  bY = function (t) {
    var e,
      i = t && mO(t),
      l = (e = i) === null || e === void 0 ? void 0 : e.host,
      c = !1;
    if (i && i !== t) {
      var p, h, y;
      for (c = !!((p = l) !== null && p !== void 0 && (h = p.ownerDocument) !== null && h !== void 0 && h.contains(l) || t != null && (y = t.ownerDocument) !== null && y !== void 0 && y.contains(t)); !c && l;) {
        var w, x, E;
        i = mO(l), l = (w = i) === null || w === void 0 ? void 0 : w.host, c = !!((x = l) !== null && x !== void 0 && (E = x.ownerDocument) !== null && E !== void 0 && E.contains(l));
      }
    }
    return c;
  },
  EV = function (t) {
    var e = t.getBoundingClientRect(),
      i = e.width,
      l = e.height;
    return i === 0 && l === 0;
  },
  wY = function (t, e) {
    var i = e.displayCheck,
      l = e.getShadowRoot;
    if (getComputedStyle(t).visibility === "hidden") return !0;
    var c = Zx.call(t, "details>summary:first-of-type"),
      p = c ? t.parentElement : t;
    if (Zx.call(p, "details:not([open]) *")) return !0;
    if (!i || i === "full" || i === "legacy-full") {
      if (typeof l == "function") {
        for (var h = t; t;) {
          var y = t.parentElement,
            w = mO(t);
          if (y && !y.shadowRoot && l(y) === !0) return EV(t);
          t.assignedSlot ? t = t.assignedSlot : !y && w !== t.ownerDocument ? t = w.host : t = y;
        }
        t = h;
      }
      if (bY(t)) return !t.getClientRects().length;
      if (i !== "legacy-full") return !0;
    } else if (i === "non-zero-area") return EV(t);
    return !1;
  },
  _Y = function (t) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName)) for (var e = t.parentElement; e;) {
      if (e.tagName === "FIELDSET" && e.disabled) {
        for (var i = 0; i < e.children.length; i++) {
          var l = e.children.item(i);
          if (l.tagName === "LEGEND") return Zx.call(e, "fieldset[disabled] *") ? !0 : !l.contains(t);
        }
        return !0;
      }
      e = e.parentElement;
    }
    return !1;
  },
  gO = function (t, e) {
    return !(e.disabled ||
    // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    vO(e) || pY(e) || wY(e, t) ||
    // For a details element with a summary, the summary element gets the focus
    hY(e) || _Y(e));
  },
  Tj = function (t, e) {
    return !(yY(e) || X0(e) < 0 || !gO(t, e));
  },
  xY = function (t) {
    var e = parseInt(t.getAttribute("tabindex"), 10);
    return !!(isNaN(e) || e >= 0);
  },
  SY = function t(e) {
    var i = [],
      l = [];
    return e.forEach(function (c, p) {
      var h = !!c.scopeParent,
        y = h ? c.scopeParent : c,
        w = dY(y, h),
        x = h ? t(c.candidates) : y;
      w === 0 ? h ? i.push.apply(i, x) : i.push(y) : l.push({
        documentOrder: p,
        tabIndex: w,
        item: c,
        isScope: h,
        content: x
      });
    }), l.sort(fY).reduce(function (c, p) {
      return p.isScope ? c.push.apply(c, p.content) : c.push(p.content), c;
    }, []).concat(i);
  },
  Z5 = function (t, e) {
    e = e || {};
    var i;
    return e.getShadowRoot ? i = X5([t], e.includeContainer, {
      filter: Tj.bind(null, e),
      flatten: !1,
      getShadowRoot: e.getShadowRoot,
      shadowRootFilter: xY
    }) : i = G5(t, e.includeContainer, Tj.bind(null, e)), SY(i);
  },
  J5 = function (t, e) {
    e = e || {};
    var i;
    return e.getShadowRoot ? i = X5([t], e.includeContainer, {
      filter: gO.bind(null, e),
      flatten: !0,
      getShadowRoot: e.getShadowRoot
    }) : i = G5(t, e.includeContainer, gO.bind(null, e)), i;
  },
  zx = function (t, e) {
    if (e = e || {}, !t) throw new Error("No node provided");
    return Zx.call(t, hO) === !1 ? !1 : Tj(e, t);
  },
  EY = /* @__PURE__ */q5.concat("iframe").join(","),
  BM = function (t, e) {
    if (e = e || {}, !t) throw new Error("No node provided");
    return Zx.call(t, EY) === !1 ? !1 : gO(e, t);
  };
const CY = /* @__PURE__ */Object.freeze(/* @__PURE__ */Object.defineProperty({
  __proto__: null,
  focusable: J5,
  getTabIndex: X0,
  isFocusable: BM,
  isTabbable: zx,
  tabbable: Z5
}, Symbol.toStringTag, {
  value: "Module"
}));
/*!
* focus-trap 7.6.5
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function Rj(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var i = 0, l = Array(e); i < e; i++) l[i] = t[i];
  return l;
}
function kY(t) {
  if (Array.isArray(t)) return Rj(t);
}
function TY(t, e, i) {
  return (e = OY(e)) in t ? Object.defineProperty(t, e, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = i, t;
}
function RY(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function DY() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function CV(t, e) {
  var i = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(t);
    e && (l = l.filter(function (c) {
      return Object.getOwnPropertyDescriptor(t, c).enumerable;
    })), i.push.apply(i, l);
  }
  return i;
}
function kV(t) {
  for (var e = 1; e < arguments.length; e++) {
    var i = arguments[e] != null ? arguments[e] : {};
    e % 2 ? CV(Object(i), !0).forEach(function (l) {
      TY(t, l, i[l]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : CV(Object(i)).forEach(function (l) {
      Object.defineProperty(t, l, Object.getOwnPropertyDescriptor(i, l));
    });
  }
  return t;
}
function IY(t) {
  return kY(t) || RY(t) || LY(t) || DY();
}
function MY(t, e) {
  if (typeof t != "object" || !t) return t;
  var i = t[Symbol.toPrimitive];
  if (i !== void 0) {
    var l = i.call(t, e);
    if (typeof l != "object") return l;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function OY(t) {
  var e = MY(t, "string");
  return typeof e == "symbol" ? e : e + "";
}
function LY(t, e) {
  if (t) {
    if (typeof t == "string") return Rj(t, e);
    var i = {}.toString.call(t).slice(8, -1);
    return i === "Object" && t.constructor && (i = t.constructor.name), i === "Map" || i === "Set" ? Array.from(t) : i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? Rj(t, e) : void 0;
  }
}
var TV = {
    activateTrap: function (t, e) {
      if (t.length > 0) {
        var i = t[t.length - 1];
        i !== e && i._setPausedState(!0);
      }
      var l = t.indexOf(e);
      l === -1 || t.splice(l, 1), t.push(e);
    },
    deactivateTrap: function (t, e) {
      var i = t.indexOf(e);
      i !== -1 && t.splice(i, 1), t.length > 0 && !t[t.length - 1]._isManuallyPaused() && t[t.length - 1]._setPausedState(!1);
    }
  },
  PY = function (t) {
    return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
  },
  AY = function (t) {
    return (t == null ? void 0 : t.key) === "Escape" || (t == null ? void 0 : t.key) === "Esc" || (t == null ? void 0 : t.keyCode) === 27;
  },
  BT = function (t) {
    return (t == null ? void 0 : t.key) === "Tab" || (t == null ? void 0 : t.keyCode) === 9;
  },
  jY = function (t) {
    return BT(t) && !t.shiftKey;
  },
  FY = function (t) {
    return BT(t) && t.shiftKey;
  },
  RV = function (t) {
    return setTimeout(t, 0);
  },
  yT = function (t) {
    for (var e = arguments.length, i = new Array(e > 1 ? e - 1 : 0), l = 1; l < e; l++) i[l - 1] = arguments[l];
    return typeof t == "function" ? t.apply(void 0, i) : t;
  },
  sM = function (t) {
    return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
  },
  NY = [],
  zY = function (t, e) {
    var i = (e == null ? void 0 : e.document) || document,
      l = (e == null ? void 0 : e.trapStack) || NY,
      c = kV({
        returnFocusOnDeactivate: !0,
        escapeDeactivates: !0,
        delayInitialFocus: !0,
        isKeyForward: jY,
        isKeyBackward: FY
      }, e),
      p = {
        // containers given to createFocusTrap()
        // @type {Array<HTMLElement>}
        containers: [],
        // list of objects identifying tabbable nodes in `containers` in the trap
        // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
        //  is active, but the trap should never get to a state where there isn't at least one group
        //  with at least one tabbable node in it (that would lead to an error condition that would
        //  result in an error being thrown)
        // @type {Array<{
        //   container: HTMLElement,
        //   tabbableNodes: Array<HTMLElement>, // empty if none
        //   focusableNodes: Array<HTMLElement>, // empty if none
        //   posTabIndexesFound: boolean,
        //   firstTabbableNode: HTMLElement|undefined,
        //   lastTabbableNode: HTMLElement|undefined,
        //   firstDomTabbableNode: HTMLElement|undefined,
        //   lastDomTabbableNode: HTMLElement|undefined,
        //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
        // }>}
        containerGroups: [],
        // same order/length as `containers` list
        // references to objects in `containerGroups`, but only those that actually have
        //  tabbable nodes in them
        // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
        //  the same length
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: !1,
        paused: !1,
        manuallyPaused: !1,
        // timer ID for when delayInitialFocus is true and initial focus in this trap
        //  has been delayed during activation
        delayInitialFocusTimer: void 0,
        // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
        recentNavEvent: void 0
      },
      h,
      y = function (Y, ee, oe) {
        return Y && Y[ee] !== void 0 ? Y[ee] : c[oe || ee];
      },
      w = function (Y, ee) {
        var oe = typeof (ee == null ? void 0 : ee.composedPath) == "function" ? ee.composedPath() : void 0;
        return p.containerGroups.findIndex(function (ne) {
          var se = ne.container,
            ue = ne.tabbableNodes;
          return se.contains(Y) || (
          // fall back to explicit tabbable search which will take into consideration any
          //  web components if the `tabbableOptions.getShadowRoot` option was used for
          //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
          //  look inside web components even if open)
          oe == null ? void 0 : oe.includes(se)) || ue.find(function (W) {
            return W === Y;
          });
        });
      },
      x = function (Y) {
        var ee = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
          oe = ee.hasFallback,
          ne = oe === void 0 ? !1 : oe,
          se = ee.params,
          ue = se === void 0 ? [] : se,
          W = c[Y];
        if (typeof W == "function" && (W = W.apply(void 0, IY(ue))), W === !0 && (W = void 0), !W) {
          if (W === void 0 || W === !1) return W;
          throw new Error("`".concat(Y, "` was specified but was not a node, or did not return a node"));
        }
        var $ = W;
        if (typeof W == "string") {
          try {
            $ = i.querySelector(W);
          } catch (le) {
            throw new Error("`".concat(Y, '` appears to be an invalid selector; error="').concat(le.message, '"'));
          }
          if (!$ && !ne) throw new Error("`".concat(Y, "` as selector refers to no known node"));
        }
        return $;
      },
      E = function () {
        var Y = x("initialFocus", {
          hasFallback: !0
        });
        if (Y === !1) return !1;
        if (Y === void 0 || Y && !BM(Y, c.tabbableOptions)) {
          if (w(i.activeElement) >= 0) Y = i.activeElement;else {
            var ee = p.tabbableGroups[0],
              oe = ee && ee.firstTabbableNode;
            Y = oe || x("fallbackFocus");
          }
        } else Y === null && (Y = x("fallbackFocus"));
        if (!Y) throw new Error("Your focus-trap needs to have at least one focusable element");
        return Y;
      },
      C = function () {
        if (p.containerGroups = p.containers.map(function (Y) {
          var ee = Z5(Y, c.tabbableOptions),
            oe = J5(Y, c.tabbableOptions),
            ne = ee.length > 0 ? ee[0] : void 0,
            se = ee.length > 0 ? ee[ee.length - 1] : void 0,
            ue = oe.find(function (le) {
              return zx(le);
            }),
            W = oe.slice().reverse().find(function (le) {
              return zx(le);
            }),
            $ = !!ee.find(function (le) {
              return X0(le) > 0;
            });
          return {
            container: Y,
            tabbableNodes: ee,
            focusableNodes: oe,
            /** True if at least one node with positive `tabindex` was found in this container. */
            posTabIndexesFound: $,
            /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
            firstTabbableNode: ne,
            /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
            lastTabbableNode: se,
            // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
            //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
            //  because that API doesn't work with Shadow DOM as well as it should (@see
            //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
            //  to address an edge case related to positive tabindex support, this seems like a much easier,
            //  "close enough most of the time" alternative for positive tabindexes which should generally
            //  be avoided anyway...
            /** First tabbable node in container, __DOM__ order; `undefined` if none. */
            firstDomTabbableNode: ue,
            /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
            lastDomTabbableNode: W,
            /**
             * Finds the __tabbable__ node that follows the given node in the specified direction,
             *  in this container, if any.
             * @param {HTMLElement} node
             * @param {boolean} [forward] True if going in forward tab order; false if going
             *  in reverse.
             * @returns {HTMLElement|undefined} The next tabbable node, if any.
             */
            nextTabbableNode: function (le) {
              var H = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0,
                ce = ee.indexOf(le);
              return ce < 0 ? H ? oe.slice(oe.indexOf(le) + 1).find(function (de) {
                return zx(de);
              }) : oe.slice(0, oe.indexOf(le)).reverse().find(function (de) {
                return zx(de);
              }) : ee[ce + (H ? 1 : -1)];
            }
          };
        }), p.tabbableGroups = p.containerGroups.filter(function (Y) {
          return Y.tabbableNodes.length > 0;
        }), p.tabbableGroups.length <= 0 && !x("fallbackFocus")) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
        if (p.containerGroups.find(function (Y) {
          return Y.posTabIndexesFound;
        }) && p.containerGroups.length > 1) throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
      },
      k = function (Y) {
        var ee = Y.activeElement;
        if (ee) return ee.shadowRoot && ee.shadowRoot.activeElement !== null ? k(ee.shadowRoot) : ee;
      },
      D = function (Y) {
        if (Y !== !1 && Y !== k(document)) {
          if (!Y || !Y.focus) {
            D(E());
            return;
          }
          Y.focus({
            preventScroll: !!c.preventScroll
          }), p.mostRecentlyFocusedNode = Y, PY(Y) && Y.select();
        }
      },
      I = function (Y) {
        var ee = x("setReturnFocus", {
          params: [Y]
        });
        return ee || (ee === !1 ? !1 : Y);
      },
      O = function (Y) {
        var ee = Y.target,
          oe = Y.event,
          ne = Y.isBackward,
          se = ne === void 0 ? !1 : ne;
        ee = ee || sM(oe), C();
        var ue = null;
        if (p.tabbableGroups.length > 0) {
          var W = w(ee, oe),
            $ = W >= 0 ? p.containerGroups[W] : void 0;
          if (W < 0) se ? ue = p.tabbableGroups[p.tabbableGroups.length - 1].lastTabbableNode : ue = p.tabbableGroups[0].firstTabbableNode;else if (se) {
            var le = p.tabbableGroups.findIndex(function (fe) {
              var xe = fe.firstTabbableNode;
              return ee === xe;
            });
            if (le < 0 && ($.container === ee || BM(ee, c.tabbableOptions) && !zx(ee, c.tabbableOptions) && !$.nextTabbableNode(ee, !1)) && (le = W), le >= 0) {
              var H = le === 0 ? p.tabbableGroups.length - 1 : le - 1,
                ce = p.tabbableGroups[H];
              ue = X0(ee) >= 0 ? ce.lastTabbableNode : ce.lastDomTabbableNode;
            } else BT(oe) || (ue = $.nextTabbableNode(ee, !1));
          } else {
            var de = p.tabbableGroups.findIndex(function (fe) {
              var xe = fe.lastTabbableNode;
              return ee === xe;
            });
            if (de < 0 && ($.container === ee || BM(ee, c.tabbableOptions) && !zx(ee, c.tabbableOptions) && !$.nextTabbableNode(ee)) && (de = W), de >= 0) {
              var Ce = de === p.tabbableGroups.length - 1 ? 0 : de + 1,
                Ee = p.tabbableGroups[Ce];
              ue = X0(ee) >= 0 ? Ee.firstTabbableNode : Ee.firstDomTabbableNode;
            } else BT(oe) || (ue = $.nextTabbableNode(ee));
          }
        } else ue = x("fallbackFocus");
        return ue;
      },
      P = function (Y) {
        var ee = sM(Y);
        if (!(w(ee, Y) >= 0)) {
          if (yT(c.clickOutsideDeactivates, Y)) {
            h.deactivate({
              // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
              //  which will result in the outside click setting focus to the node
              //  that was clicked (and if not focusable, to "nothing"); by setting
              //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
              //  on activation (or the configured `setReturnFocus` node), whether the
              //  outside click was on a focusable node or not
              returnFocus: c.returnFocusOnDeactivate
            });
            return;
          }
          yT(c.allowOutsideClick, Y) || Y.preventDefault();
        }
      },
      N = function (Y) {
        var ee = sM(Y),
          oe = w(ee, Y) >= 0;
        if (oe || ee instanceof Document) oe && (p.mostRecentlyFocusedNode = ee);else {
          Y.stopImmediatePropagation();
          var ne,
            se = !0;
          if (p.mostRecentlyFocusedNode) {
            if (X0(p.mostRecentlyFocusedNode) > 0) {
              var ue = w(p.mostRecentlyFocusedNode),
                W = p.containerGroups[ue].tabbableNodes;
              if (W.length > 0) {
                var $ = W.findIndex(function (le) {
                  return le === p.mostRecentlyFocusedNode;
                });
                $ >= 0 && (c.isKeyForward(p.recentNavEvent) ? $ + 1 < W.length && (ne = W[$ + 1], se = !1) : $ - 1 >= 0 && (ne = W[$ - 1], se = !1));
              }
            } else p.containerGroups.some(function (le) {
              return le.tabbableNodes.some(function (H) {
                return X0(H) > 0;
              });
            }) || (se = !1);
          } else se = !1;
          se && (ne = O({
            // move FROM the MRU node, not event-related node (which will be the node that is
            //  outside the trap causing the focus escape we're trying to fix)
            target: p.mostRecentlyFocusedNode,
            isBackward: c.isKeyBackward(p.recentNavEvent)
          })), D(ne || p.mostRecentlyFocusedNode || E());
        }
        p.recentNavEvent = void 0;
      },
      L = function (Y) {
        var ee = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
        p.recentNavEvent = Y;
        var oe = O({
          event: Y,
          isBackward: ee
        });
        oe && (BT(Y) && Y.preventDefault(), D(oe));
      },
      F = function (Y) {
        (c.isKeyForward(Y) || c.isKeyBackward(Y)) && L(Y, c.isKeyBackward(Y));
      },
      j = function (Y) {
        AY(Y) && yT(c.escapeDeactivates, Y) !== !1 && (Y.preventDefault(), h.deactivate());
      },
      V = function (Y) {
        var ee = sM(Y);
        w(ee, Y) >= 0 || yT(c.clickOutsideDeactivates, Y) || yT(c.allowOutsideClick, Y) || (Y.preventDefault(), Y.stopImmediatePropagation());
      },
      K = function () {
        if (p.active) return TV.activateTrap(l, h), p.delayInitialFocusTimer = c.delayInitialFocus ? RV(function () {
          D(E());
        }) : D(E()), i.addEventListener("focusin", N, !0), i.addEventListener("mousedown", P, {
          capture: !0,
          passive: !1
        }), i.addEventListener("touchstart", P, {
          capture: !0,
          passive: !1
        }), i.addEventListener("click", V, {
          capture: !0,
          passive: !1
        }), i.addEventListener("keydown", F, {
          capture: !0,
          passive: !1
        }), i.addEventListener("keydown", j), h;
      },
      G = function () {
        if (p.active) return i.removeEventListener("focusin", N, !0), i.removeEventListener("mousedown", P, !0), i.removeEventListener("touchstart", P, !0), i.removeEventListener("click", V, !0), i.removeEventListener("keydown", F, !0), i.removeEventListener("keydown", j), h;
      },
      Q = function (Y) {
        var ee = Y.some(function (oe) {
          var ne = Array.from(oe.removedNodes);
          return ne.some(function (se) {
            return se === p.mostRecentlyFocusedNode;
          });
        });
        ee && D(E());
      },
      te = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(Q) : void 0,
      ie = function () {
        te && (te.disconnect(), p.active && !p.paused && p.containers.map(function (Y) {
          te.observe(Y, {
            subtree: !0,
            childList: !0
          });
        }));
      };
    return h = {
      get active() {
        return p.active;
      },
      get paused() {
        return p.paused;
      },
      activate: function (Y) {
        if (p.active) return this;
        var ee = y(Y, "onActivate"),
          oe = y(Y, "onPostActivate"),
          ne = y(Y, "checkCanFocusTrap");
        ne || C(), p.active = !0, p.paused = !1, p.nodeFocusedBeforeActivation = k(i), ee == null || ee();
        var se = function () {
          ne && C(), K(), ie(), oe == null || oe();
        };
        return ne ? (ne(p.containers.concat()).then(se, se), this) : (se(), this);
      },
      deactivate: function (Y) {
        if (!p.active) return this;
        var ee = kV({
          onDeactivate: c.onDeactivate,
          onPostDeactivate: c.onPostDeactivate,
          checkCanReturnFocus: c.checkCanReturnFocus
        }, Y);
        clearTimeout(p.delayInitialFocusTimer), p.delayInitialFocusTimer = void 0, G(), p.active = !1, p.paused = !1, ie(), TV.deactivateTrap(l, h);
        var oe = y(ee, "onDeactivate"),
          ne = y(ee, "onPostDeactivate"),
          se = y(ee, "checkCanReturnFocus"),
          ue = y(ee, "returnFocus", "returnFocusOnDeactivate");
        oe == null || oe();
        var W = function () {
          RV(function () {
            ue && D(I(p.nodeFocusedBeforeActivation)), ne == null || ne();
          });
        };
        return ue && se ? (se(I(p.nodeFocusedBeforeActivation)).then(W, W), this) : (W(), this);
      },
      pause: function (Y) {
        return p.active ? (p.manuallyPaused = !0, this._setPausedState(!0, Y)) : this;
      },
      unpause: function (Y) {
        return p.active ? (p.manuallyPaused = !1, l[l.length - 1] !== this ? this : this._setPausedState(!1, Y)) : this;
      },
      updateContainerElements: function (Y) {
        var ee = [].concat(Y).filter(Boolean);
        return p.containers = ee.map(function (oe) {
          return typeof oe == "string" ? i.querySelector(oe) : oe;
        }), p.active && C(), ie(), this;
      }
    }, Object.defineProperties(h, {
      _isManuallyPaused: {
        value: function () {
          return p.manuallyPaused;
        }
      },
      _setPausedState: {
        value: function (Y, ee) {
          if (p.paused === Y) return this;
          if (p.paused = Y, Y) {
            var oe = y(ee, "onPause"),
              ne = y(ee, "onPostPause");
            oe == null || oe(), G(), ie(), ne == null || ne();
          } else {
            var se = y(ee, "onUnpause"),
              ue = y(ee, "onPostUnpause");
            se == null || se(), C(), K(), ie(), ue == null || ue();
          }
          return this;
        }
      }
    }), h.updateContainerElements(t), h;
  };
const VY = /* @__PURE__ */Object.freeze(/* @__PURE__ */Object.defineProperty({
    __proto__: null,
    createFocusTrap: zY
  }, Symbol.toStringTag, {
    value: "Module"
  })),
  BY = /* @__PURE__ */uH(VY),
  UY = /* @__PURE__ */uH(CY);
var DV;
function HY() {
  if (DV) return oM.exports;
  DV = 1;
  function t(G) {
    "@babel/helpers - typeof";

    return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (Q) {
      return typeof Q;
    } : function (Q) {
      return Q && typeof Symbol == "function" && Q.constructor === Symbol && Q !== Symbol.prototype ? "symbol" : typeof Q;
    }, t(G);
  }
  var e, i;
  function l(G, Q) {
    if (!(G instanceof Q)) throw new TypeError("Cannot call a class as a function");
  }
  function c(G, Q) {
    for (var te = 0; te < Q.length; te++) {
      var ie = Q[te];
      ie.enumerable = ie.enumerable || !1, ie.configurable = !0, "value" in ie && (ie.writable = !0), Object.defineProperty(G, I(ie.key), ie);
    }
  }
  function p(G, Q, te) {
    return Q && c(G.prototype, Q), Object.defineProperty(G, "prototype", {
      writable: !1
    }), G;
  }
  function h(G, Q, te) {
    return Q = E(Q), y(G, x() ? Reflect.construct(Q, te || [], E(G).constructor) : Q.apply(G, te));
  }
  function y(G, Q) {
    if (Q && (t(Q) == "object" || typeof Q == "function")) return Q;
    if (Q !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return w(G);
  }
  function w(G) {
    if (G === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return G;
  }
  function x() {
    try {
      var G = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch {}
    return (x = function () {
      return !!G;
    })();
  }
  function E(G) {
    return E = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (Q) {
      return Q.__proto__ || Object.getPrototypeOf(Q);
    }, E(G);
  }
  function C(G, Q) {
    if (typeof Q != "function" && Q !== null) throw new TypeError("Super expression must either be null or a function");
    G.prototype = Object.create(Q && Q.prototype, {
      constructor: {
        value: G,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(G, "prototype", {
      writable: !1
    }), Q && k(G, Q);
  }
  function k(G, Q) {
    return k = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (te, ie) {
      return te.__proto__ = ie, te;
    }, k(G, Q);
  }
  function D(G, Q, te) {
    return (Q = I(Q)) in G ? Object.defineProperty(G, Q, {
      value: te,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : G[Q] = te, G;
  }
  function I(G) {
    var Q = O(G, "string");
    return t(Q) == "symbol" ? Q : Q + "";
  }
  function O(G, Q) {
    if (t(G) != "object" || !G) return G;
    var te = G[Symbol.toPrimitive];
    if (te !== void 0) {
      var ie = te.call(G, Q);
      if (t(ie) != "object") return ie;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (Q === "string" ? String : Number)(G);
  }
  var P = Nt,
    N = BY,
    L = N.createFocusTrap,
    F = UY,
    j = F.isFocusable,
    V = parseInt((e = (i = /^(\d+)\./.exec(P.version)) === null || i === void 0 ? void 0 : i[1]) !== null && e !== void 0 ? e : 0, 10),
    K = /* @__PURE__ */function (G) {
      function Q(te) {
        var ie;
        l(this, Q), ie = h(this, Q, [te]), D(ie, "getNodeForOption", function (oe) {
          var ne,
            se = (ne = this.internalOptions[oe]) !== null && ne !== void 0 ? ne : this.originalOptions[oe];
          if (typeof se == "function") {
            for (var ue = arguments.length, W = new Array(ue > 1 ? ue - 1 : 0), $ = 1; $ < ue; $++) W[$ - 1] = arguments[$];
            se = se.apply(void 0, W);
          }
          if (se === !0 && (se = void 0), !se) {
            if (se === void 0 || se === !1) return se;
            throw new Error("`".concat(oe, "` was specified but was not a node, or did not return a node"));
          }
          var le = se;
          if (typeof se == "string") {
            var H;
            if (le = (H = this.getDocument()) === null || H === void 0 ? void 0 : H.querySelector(se), !le) throw new Error("`".concat(oe, "` as selector refers to no known node"));
          }
          return le;
        }), ie.handleDeactivate = ie.handleDeactivate.bind(ie), ie.handlePostDeactivate = ie.handlePostDeactivate.bind(ie), ie.handleClickOutsideDeactivates = ie.handleClickOutsideDeactivates.bind(ie), ie.internalOptions = {
          // We need to hijack the returnFocusOnDeactivate option,
          // because React can move focus into the element before we arrived at
          // this lifecycle hook (e.g. with autoFocus inputs). So the component
          // captures the previouslyFocusedElement in componentWillMount,
          // then (optionally) returns focus to it in componentWillUnmount.
          returnFocusOnDeactivate: !1,
          // the rest of these are also related to deactivation of the trap, and we
          //  need to use them and control them as well
          checkCanReturnFocus: null,
          onDeactivate: ie.handleDeactivate,
          onPostDeactivate: ie.handlePostDeactivate,
          // we need to special-case this setting as well so that we can know if we should
          //  NOT return focus if the trap gets auto-deactivated as the result of an
          //  outside click (otherwise, we'll always think we should return focus because
          //  of how we manage that flag internally here)
          clickOutsideDeactivates: ie.handleClickOutsideDeactivates
        }, ie.originalOptions = {
          // because of the above `internalOptions`, we maintain our own flag for
          //  this option, and default it to `true` because that's focus-trap's default
          returnFocusOnDeactivate: !0,
          // because of the above `internalOptions`, we keep these separate since
          //  they're part of the deactivation process which we configure (internally) to
          //  be shared between focus-trap and focus-trap-react
          onDeactivate: null,
          onPostDeactivate: null,
          checkCanReturnFocus: null,
          // the user's setting, defaulted to false since focus-trap defaults this to false
          clickOutsideDeactivates: !1
        };
        var Y = te.focusTrapOptions;
        for (var ee in Y) if (Object.prototype.hasOwnProperty.call(Y, ee)) {
          if (ee === "returnFocusOnDeactivate" || ee === "onDeactivate" || ee === "onPostDeactivate" || ee === "checkCanReturnFocus" || ee === "clickOutsideDeactivates") {
            ie.originalOptions[ee] = Y[ee];
            continue;
          }
          ie.internalOptions[ee] = Y[ee];
        }
        return ie.outsideClick = null, ie.focusTrapElements = te.containerElements || [], ie.updatePreviousElement(), ie;
      }
      return C(Q, G), p(Q, [{
        key: "getDocument",
        value: function () {
          return this.props.focusTrapOptions.document || (typeof document < "u" ? document : void 0);
        }
      }, {
        key: "getReturnFocusNode",
        value: function () {
          var te = this.getNodeForOption("setReturnFocus", this.previouslyFocusedElement);
          return te || (te === !1 ? !1 : this.previouslyFocusedElement);
        }
        /** Update the previously focused element with the currently focused element. */
      }, {
        key: "updatePreviousElement",
        value: function () {
          var te = this.getDocument();
          te && (this.previouslyFocusedElement = te.activeElement);
        }
      }, {
        key: "deactivateTrap",
        value: function () {
          !this.focusTrap || !this.focusTrap.active || this.focusTrap.deactivate({
            // NOTE: we never let the trap return the focus since we do that ourselves
            returnFocus: !1,
            // we'll call this in our own post deactivate handler so make sure the trap doesn't
            //  do it prematurely
            checkCanReturnFocus: null,
            // let it call the user's original deactivate handler, if any, instead of
            //  our own which calls back into this function
            onDeactivate: this.originalOptions.onDeactivate
            // NOTE: for post deactivate, don't specify anything so that it calls the
            //  onPostDeactivate handler specified on `this.internalOptions`
            //  which will always be our own `handlePostDeactivate()` handler, which
            //  will finish things off by calling the user's provided onPostDeactivate
            //  handler, if any, at the right time
            // onPostDeactivate: NOTHING
          });
        }
      }, {
        key: "handleClickOutsideDeactivates",
        value: function (te) {
          var ie = typeof this.originalOptions.clickOutsideDeactivates == "function" ? this.originalOptions.clickOutsideDeactivates.call(null, te) : this.originalOptions.clickOutsideDeactivates;
          return ie && (this.outsideClick = {
            target: te.target,
            allowDeactivation: ie
          }), ie;
        }
      }, {
        key: "handleDeactivate",
        value: function () {
          this.originalOptions.onDeactivate && this.originalOptions.onDeactivate.call(null), this.deactivateTrap();
        }
      }, {
        key: "handlePostDeactivate",
        value: function () {
          var te = this,
            ie = function () {
              var Y = te.getReturnFocusNode(),
                ee = !!(
                // did the consumer allow it?
                te.originalOptions.returnFocusOnDeactivate &&
                // can we actually focus the node?
                Y !== null && Y !== void 0 && Y.focus && (
                // was there an outside click that allowed deactivation?
                !te.outsideClick ||
                // did the consumer allow deactivation when the outside node was clicked?
                te.outsideClick.allowDeactivation &&
                // is the outside node NOT focusable (implying that it did NOT receive focus
                //  as a result of the click-through) -- in which case do NOT restore focus
                //  to `returnFocusNode` because focus should remain on the outside node
                !j(te.outsideClick.target, te.internalOptions.tabbableOptions))),
                oe = te.internalOptions.preventScroll,
                ne = oe === void 0 ? !1 : oe;
              ee && Y.focus({
                preventScroll: ne
              }), te.originalOptions.onPostDeactivate && te.originalOptions.onPostDeactivate.call(null), te.outsideClick = null;
            };
          this.originalOptions.checkCanReturnFocus ? this.originalOptions.checkCanReturnFocus.call(null, this.getReturnFocusNode()).then(ie, ie) : ie();
        }
      }, {
        key: "setupFocusTrap",
        value: function () {
          if (this.focusTrap) this.props.active && !this.focusTrap.active && (this.focusTrap.activate(), this.props.paused && this.focusTrap.pause());else {
            var te = this.focusTrapElements.some(Boolean);
            te && (this.focusTrap = this.props._createFocusTrap(this.focusTrapElements, this.internalOptions), this.props.active && this.focusTrap.activate(), this.props.paused && this.focusTrap.pause());
          }
        }
      }, {
        key: "componentDidMount",
        value: function () {
          this.props.active && this.setupFocusTrap();
        }
      }, {
        key: "componentDidUpdate",
        value: function (te) {
          if (this.focusTrap) {
            te.containerElements !== this.props.containerElements && this.focusTrap.updateContainerElements(this.props.containerElements);
            var ie = !te.active && this.props.active,
              Y = te.active && !this.props.active,
              ee = !te.paused && this.props.paused,
              oe = te.paused && !this.props.paused;
            if (ie && (this.updatePreviousElement(), this.focusTrap.activate()), Y) {
              this.deactivateTrap();
              return;
            }
            ee && this.focusTrap.pause(), oe && this.focusTrap.unpause();
          } else te.containerElements !== this.props.containerElements && (this.focusTrapElements = this.props.containerElements), this.props.active && (this.updatePreviousElement(), this.setupFocusTrap());
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.deactivateTrap();
        }
      }, {
        key: "render",
        value: function () {
          var te = this,
            ie = this.props.children ? P.Children.only(this.props.children) : void 0;
          if (ie) {
            if (ie.type && ie.type === P.Fragment) throw new Error("A focus-trap cannot use a Fragment as its child container. Try replacing it with a <div> element.");
            var Y = function (oe) {
                var ne = te.props.containerElements;
                ie && (V >= 19 ? typeof ie.props.ref == "function" ? ie.props.ref(oe) : ie.props.ref && (ie.props.ref.current = oe) : typeof ie.ref == "function" ? ie.ref(oe) : ie.ref && (ie.ref.current = oe)), te.focusTrapElements = ne || [oe];
              },
              ee = P.cloneElement(ie, {
                ref: Y
              });
            return ee;
          }
          return null;
        }
      }]);
    }(P.Component);
  return K.defaultProps = {
    active: !0,
    paused: !1,
    focusTrapOptions: {},
    _createFocusTrap: L
  }, oM.exports = K, oM.exports.FocusTrap = K, oM.exports;
}
var e4 = HY();
const $Y = "_alert_3baq8_1",
  WY = "_alertHeader_3baq8_5",
  qY = "_alertHeading_3baq8_11",
  YY = "_anchorTarget_3baq8_16",
  jm = {
    alert: $Y,
    alertHeader: WY,
    alertHeading: qY,
    anchorTarget: YY
  },
  GY = ({
    type: t,
    date: e,
    title: i,
    message: l,
    url: c,
    urlTarget: p = "_self",
    viewedIds: h,
    id: y,
    locale: w,
    renderNotificationLink: x,
    renderNotificationIcon: E,
    listItemClasses: C,
    handleClose: k
  }) => {
    const D = !h.includes(y),
      [I, O, P] = e.split("T")[0].split("-"),
      N = new Date(Number(I), Number(O) - 1, Number(P)).toLocaleDateString(w, {
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    if (t === "alert" && c && i) {
      const L = /* @__PURE__ */_e.jsxs("span", {
        onClick: k,
        className: Ze(jm.anchorTarget, C == null ? void 0 : C.anchorTarget),
        children: [/* @__PURE__ */_e.jsxs("div", {
          className: Ze(jm.alertHeader, C == null ? void 0 : C.header),
          children: [/* @__PURE__ */_e.jsxs("span", {
            className: Ze(jm.alertHeading, C == null ? void 0 : C.heading),
            children: [E && /* @__PURE__ */_e.jsx("span", {
              className: Ze(jm.alertIcon, C == null ? void 0 : C.icon),
              children: E("warning")
            }), /* @__PURE__ */_e.jsx("span", {
              className: Ze(jm.alertTitle, C == null ? void 0 : C.title),
              children: i
            })]
          }), e && /* @__PURE__ */_e.jsx("time", {
            className: Ze(jm.alertDate, C == null ? void 0 : C.date),
            dateTime: e,
            children: N
          })]
        }), /* @__PURE__ */_e.jsx("div", {
          className: Ze(jm.alertMessage, C == null ? void 0 : C.message),
          children: l
        })]
      });
      return /* @__PURE__ */_e.jsx("div", {
        className: Ze(jm.alert, D && [jm.active, C == null ? void 0 : C.active], C == null ? void 0 : C.wrapper),
        "data-type": t,
        role: "listitem",
        children: typeof x == "function" ? x(c, L, Ze(jm.anchor, C == null ? void 0 : C.anchor), p) : /* @__PURE__ */_e.jsx("a", {
          className: Ze(jm.anchor, C == null ? void 0 : C.anchor),
          href: c,
          target: p,
          children: L
        })
      });
    }
    return null;
  },
  XY = "_offer_19e6b_1",
  KY = "_offerHeader_19e6b_5",
  QY = "_offerHeading_19e6b_11",
  ZY = "_anchorTarget_19e6b_16",
  Tp = {
    offer: XY,
    offerHeader: KY,
    offerHeading: QY,
    anchorTarget: ZY
  },
  JY = ({
    type: t,
    date: e,
    title: i,
    heading: l,
    message: c,
    url: p = "#",
    urlTarget: h = "_self",
    viewedIds: y,
    id: w,
    locale: x,
    renderNotificationLink: E,
    renderNotificationIcon: C,
    listItemClasses: k,
    handleClose: D
  }) => {
    const I = !y.includes(w),
      [O, P, N] = e.split("T")[0].split("-"),
      L = new Date(Number(O), Number(P) - 1, Number(N)).toLocaleDateString(x, {
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    if (t === "offer" && p && i) {
      const F = /* @__PURE__ */_e.jsxs("span", {
        onClick: D,
        className: Ze(Tp.anchorTarget, k == null ? void 0 : k.anchorTarget),
        children: [/* @__PURE__ */_e.jsxs("div", {
          className: Ze(Tp.offerHeader, k == null ? void 0 : k.header),
          children: [/* @__PURE__ */_e.jsxs("span", {
            className: Ze(Tp.offerHeading, k == null ? void 0 : k.heading),
            children: [C && /* @__PURE__ */_e.jsx("span", {
              className: Ze(Tp.offerIcon, k == null ? void 0 : k.icon),
              children: C("deal")
            }), /* @__PURE__ */_e.jsx("span", {
              className: Ze(Tp.offerTitle, k == null ? void 0 : k.title),
              children: i
            })]
          }), e && /* @__PURE__ */_e.jsx("time", {
            className: Ze(Tp.offerDate, k == null ? void 0 : k.date),
            dateTime: e,
            children: L
          })]
        }), l && /* @__PURE__ */_e.jsx("div", {
          className: Ze(Tp.offerSubHeading, k == null ? void 0 : k.subHeading),
          children: l
        }), /* @__PURE__ */_e.jsx("div", {
          className: Ze(Tp.offerMessage, k == null ? void 0 : k.message),
          children: c
        })]
      });
      return /* @__PURE__ */_e.jsx("div", {
        className: Ze(Tp.offer, I && [Tp.active, k == null ? void 0 : k.active], k == null ? void 0 : k.wrapper),
        "data-type": t,
        role: "listitem",
        children: typeof E == "function" ? E(p, F, Ze(Tp.anchor, k == null ? void 0 : k.anchor), h) : /* @__PURE__ */_e.jsx("a", {
          className: Ze(Tp.anchor, k == null ? void 0 : k.anchor),
          href: p,
          target: h,
          children: F
        })
      });
    }
    return null;
  },
  eG = "_menuWrapper_1whf1_1",
  tG = "_menuContainer_1whf1_5",
  nG = "_menuItem_1whf1_10",
  W1 = {
    menuWrapper: eG,
    menuContainer: tG,
    menuItem: nG
  },
  rG = ({
    setActiveFilterId: t,
    activeFilterId: e,
    menuConfig: i,
    a11yMenu: l,
    renderMenuIcon: c,
    menuClassNames: p = {}
  }) => {
    const [h, y] = rt(e),
      w = vt(null),
      x = C => {
        h !== C.filterId && (t(C.filterId), y(C.filterId));
      },
      E = pn(C => {
        var k;
        if (!w.current) return;
        const D = Array.from(w.current.querySelectorAll("button[role='tab']") || []),
          I = D.findIndex(N => N === document.activeElement);
        if (I === -1) return;
        let O = I;
        switch (C.key) {
          case "ArrowDown":
            C.preventDefault(), O = (I + 1) % D.length;
            break;
          case "ArrowUp":
            C.preventDefault(), O = (I - 1 + D.length) % D.length;
            break;
          case "Home":
            C.preventDefault(), O = 0;
            break;
          case "End":
            C.preventDefault(), O = D.length - 1;
            break;
          default:
            return;
        }
        const P = D[O];
        if (P) {
          P.focus();
          const N = ((k = P.dataset) == null ? void 0 : k.filterid) ?? "";
          t(N), y(N);
        }
      }, [t]);
    return Rt(() => {
      const C = w.current;
      if (C) return C.addEventListener("keydown", E), () => {
        C.removeEventListener("keydown", E);
      };
    }, [E]), /* @__PURE__ */_e.jsx("div", {
      role: "group",
      className: Ze(W1.menuWrapper, p == null ? void 0 : p.wrapper),
      "aria-label": l,
      children: /* @__PURE__ */_e.jsx("div", {
        className: Ze(W1.menuContainer, p == null ? void 0 : p.container),
        role: "tablist",
        "aria-orientation": "vertical",
        ref: w,
        children: i.map((C, k) => /* @__PURE__ */_e.jsxs("button", {
          "data-filterid": C.filterId,
          id: `tab-${C.filterId}`,
          role: "tab",
          "aria-selected": h === C.filterId,
          "aria-controls": "panelList",
          tabIndex: h === C.filterId ? 0 : -1,
          type: "button",
          className: Ze(W1.menuItem, h === C.filterId && [W1.active, p == null ? void 0 : p.itemActive], p == null ? void 0 : p.item),
          onClick: () => x(C),
          children: [c && /* @__PURE__ */_e.jsx("span", {
            className: Ze(W1.icon, p == null ? void 0 : p.icon),
            children: c(C.filterIcon)
          }), /* @__PURE__ */_e.jsx("span", {
            className: Ze(W1.type, p == null ? void 0 : p.type),
            children: C.filterName
          })]
        }, k))
      })
    });
  },
  iG = "_notifications_unwp8_1",
  aG = "_listBody_unwp8_13",
  oG = "_listContainer_unwp8_17",
  sG = "_listHeader_unwp8_21",
  lG = "_listClose_unwp8_27",
  uG = "_srOnly_unwp8_31",
  Fm = {
    notifications: iG,
    listBody: aG,
    listContainer: oG,
    listHeader: sG,
    listClose: lG,
    srOnly: uG
  },
  cG = ({
    storageId: t = "notifications",
    locale: e = "en-CA",
    labels: i = {},
    data: l,
    triggerElement: c,
    menuSettings: p,
    onGetActiveTotal: h,
    renderMenuIcon: y,
    renderCloseIcon: w,
    renderFilterLink: x,
    renderNotificationLink: E,
    renderNotificationIcon: C,
    className: k,
    classNames: D
  }) => {
    var I, O;
    const P = {
        ...uY,
        ...i
      },
      N = vt(null),
      [L, F] = rt(!1),
      [j, V] = rt(!1),
      K = vt(p || []),
      [G, Q] = rt(((O = (I = K.current) == null ? void 0 : I[0]) == null ? void 0 : O.filterId) ?? ""),
      [te, ie] = rt(),
      [Y, ee] = rt(),
      [oe, ne] = rt(!1),
      [se, ue] = rt(),
      W = vt([]),
      $ = K.current.map(ve => ve == null ? void 0 : ve.filterId),
      le = ve => {
        if (!ve) return !1;
        try {
          const Te = new Date(ve);
          return !isNaN(Te.getTime()) && ve === Te.toISOString() || ve.startsWith(Te.toISOString().slice(0, 10));
        } catch {
          return !1;
        }
      },
      H = ((ve = []) => {
        const Te = ["type", "date", "title", "message", "url", "id"];
        return ve.filter(ze => !!(ze != null && ze.date) && le(ze.date) && Te.every(Xe => !!(ze != null && ze[Xe])));
      })(l),
      ce = (H == null ? void 0 : H.filter(ve => $.includes(ve.type)).map(ve => ve == null ? void 0 : ve.id)) ?? [],
      de = ve => $.includes(ve),
      Ce = () => {
        var ve, Te;
        F(!1), V(!1), (Te = (ve = K.current) == null ? void 0 : ve[0]) != null && Te.filterId && Q(K.current[0].filterId);
      },
      Ee = () => {
        var ve, Te;
        !L && !j ? (V(!0), F(!0)) : j && !L && (V(!1), (Te = (ve = K.current) == null ? void 0 : ve[0]) != null && Te.filterId && Q(K.current[0].filterId)), c.current && (c.current.ariaExpanded = String(L));
      },
      fe = () => {
        const ve = H.filter(Te => ((te == null ? void 0 : te.filterId) === aM || K.current.length > 1 || de(Te.type)) && !W.current.includes(Te.id));
        se !== ve.length && ue(ve.length), ve.length > 0 && oe && !L && (xe(ce), ue(0), we(), ne(!1));
      },
      xe = ve => {
        const Te = ve.join(",");
        localStorage.setItem(t, Te);
      },
      we = () => {
        const ve = localStorage.getItem(t);
        if (ve && ve.length) {
          const Te = ve.split(",");
          W.current = Te;
        }
      };
    return Rt(() => {
      typeof h == "function" && h(se ?? 0);
    }, [se, h]), Rt(() => {
      ce.length && (we(), fe());
    }, [W, ce]), Rt(() => {
      L && ne(!0);
    }, [L]), Rt(() => {
      var ve;
      if (G) {
        const Te = (ve = K.current.filter(ze => ze.filterId === G)) == null ? void 0 : ve[0];
        Te && ie(Te);
      }
    }, [G]), Rt(() => {
      ((H == null ? void 0 : H.filter(ve => ve.type === G).length) ?? 0) && G || G === aM && ce.length ? ee(!0) : ee(!1);
    }, [G, ce]), Rt(() => {
      const ve = c == null ? void 0 : c.current;
      if (!ve) return;
      ve.ariaExpanded = String(L);
      const Te = () => {
        Ee();
      };
      return ve.addEventListener("click", Te), () => {
        ve.removeEventListener("click", Te);
      };
    }, [c, Ee]), /* @__PURE__ */_e.jsxs(_e.Fragment, {
      children: [te && /* @__PURE__ */_e.jsx("div", {
        "aria-live": "polite",
        className: Fm.srOnly,
        children: L ? P.a11yOpenLiveRegion.replace("{{ filter }}", te.filterName) : P.a11yClosedLiveRegion
      }), L && c.current && K.current.length > 0 && /* @__PURE__ */_e.jsx(e4.FocusTrap, {
        focusTrapOptions: {
          onDeactivate: () => {
            var ve;
            (ve = c.current) == null || ve.focus();
          },
          clickOutsideDeactivates: ve => {
            var Te;
            return (Te = c.current) != null && Te.contains(ve.target) ? F(!1) : Ce(), !0;
          },
          escapeDeactivates: () => (Ce(), !0)
        },
        children: /* @__PURE__ */_e.jsxs("div", {
          ref: N,
          id: "notificationsPopover",
          className: Ze(Fm.notifications, k),
          role: "dialog",
          "aria-modal": "true",
          "aria-labelledby": "notificationsHeading",
          children: [/* @__PURE__ */_e.jsx(rG, {
            setActiveFilterId: Q,
            activeFilterId: G,
            menuConfig: K.current,
            a11yMenu: P.a11yMenu,
            renderMenuIcon: y,
            menuClassNames: {
              wrapper: D == null ? void 0 : D.menuWrapper,
              container: D == null ? void 0 : D.menuContainer,
              item: D == null ? void 0 : D.menuItem,
              itemActive: D == null ? void 0 : D.menuItemActive,
              icon: D == null ? void 0 : D.menuItemIcon,
              type: D == null ? void 0 : D.menuItemType
            }
          }), /* @__PURE__ */_e.jsxs("div", {
            className: Ze(Fm.listContainer, D == null ? void 0 : D.listContainer),
            children: [/* @__PURE__ */_e.jsxs("div", {
              className: Ze(Fm.listHeader, D == null ? void 0 : D.listHeader),
              children: [(te == null ? void 0 : te.filterHeading) && /* @__PURE__ */_e.jsx("h2", {
                id: "notificationsHeading",
                className: Ze(Fm.listHeading, D == null ? void 0 : D.listHeading),
                children: te.filterHeading
              }), w && /* @__PURE__ */_e.jsx("div", {
                className: Ze(Fm.listClose, D == null ? void 0 : D.listClose),
                children: /* @__PURE__ */_e.jsx("button", {
                  type: "button",
                  className: Ze(Fm.listCloseButton, D == null ? void 0 : D.listCloseButton),
                  "aria-label": P.a11yCloseMenu,
                  onClick: Ce,
                  children: w("close")
                })
              })]
            }), /* @__PURE__ */_e.jsxs("div", {
              className: Ze(Fm.listBody, D == null ? void 0 : D.listBody),
              role: "tabpanel",
              id: "panelList",
              tabIndex: 0,
              "aria-labelledby": `tab-${G}`,
              children: [/* @__PURE__ */_e.jsxs("div", {
                className: Ze(Fm.listContent, D == null ? void 0 : D.listContent),
                role: "list",
                "aria-label": P.a11yList,
                children: [H && H.map(ve => /* @__PURE__ */_e.jsxs(Qv, {
                  children: [ve.type === xV && (G === xV || G === aM) && /* @__PURE__ */_e.jsx(GY, {
                    type: ve == null ? void 0 : ve.type,
                    date: ve == null ? void 0 : ve.date,
                    title: ve == null ? void 0 : ve.title,
                    message: ve == null ? void 0 : ve.message,
                    url: ve.url,
                    urlTarget: ve == null ? void 0 : ve.urlTarget,
                    id: ve == null ? void 0 : ve.id,
                    viewedIds: W.current,
                    locale: e,
                    renderNotificationLink: E,
                    renderNotificationIcon: C,
                    listItemClasses: {
                      wrapper: D == null ? void 0 : D.listItemWrapper,
                      active: D == null ? void 0 : D.listItemActive,
                      header: D == null ? void 0 : D.listItemHeader,
                      heading: D == null ? void 0 : D.listItemHeading,
                      icon: D == null ? void 0 : D.listItemIcon,
                      title: D == null ? void 0 : D.listItemTitle,
                      date: D == null ? void 0 : D.listItemDate,
                      message: D == null ? void 0 : D.listItemMessage,
                      anchor: D == null ? void 0 : D.listItemAnchor
                    },
                    handleClose: Ce
                  }), ve.type === SV && (G === SV || G === aM) && /* @__PURE__ */_e.jsx(JY, {
                    type: ve == null ? void 0 : ve.type,
                    date: ve == null ? void 0 : ve.date,
                    title: ve == null ? void 0 : ve.title,
                    heading: (ve == null ? void 0 : ve.heading) ?? "",
                    message: ve == null ? void 0 : ve.message,
                    url: ve.url,
                    urlTarget: ve == null ? void 0 : ve.urlTarget,
                    id: ve == null ? void 0 : ve.id,
                    viewedIds: W.current,
                    locale: e,
                    renderNotificationLink: E,
                    renderNotificationIcon: C,
                    listItemClasses: {
                      wrapper: D == null ? void 0 : D.listItemWrapper,
                      active: D == null ? void 0 : D.listItemActive,
                      header: D == null ? void 0 : D.listItemHeader,
                      heading: D == null ? void 0 : D.listItemHeading,
                      icon: D == null ? void 0 : D.listItemIcon,
                      title: D == null ? void 0 : D.listItemTitle,
                      date: D == null ? void 0 : D.listItemDate,
                      subHeading: D == null ? void 0 : D.listItemSubHeading,
                      message: D == null ? void 0 : D.listItemMessage,
                      anchor: D == null ? void 0 : D.listItemAnchor
                    },
                    handleClose: Ce
                  })]
                }, ve.id)), !Y && /* @__PURE__ */_e.jsx("div", {
                  className: Ze(Fm.missingNotifications, D == null ? void 0 : D.listMissing),
                  children: te == null ? void 0 : te.noResults
                })]
              }), te && te.filterLink && te.filterLinkText && /* @__PURE__ */_e.jsx("div", {
                className: Ze(Fm.listFooter, D == null ? void 0 : D.listFooter),
                children: typeof x == "function" && x(te, Ze(D == null ? void 0 : D.listFooterLink))
              })]
            })]
          })]
        })
      })]
    });
  };
function Dj(t, e) {
  return Dj = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (i, l) {
    return i.__proto__ = l, i;
  }, Dj(t, e);
}
function dG(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, Dj(t, e);
}
function m2(t) {
  return t && t.stopPropagation && t.stopPropagation(), t && t.preventDefault && t.preventDefault(), !1;
}
function v2(t) {
  return t == null ? [] : Array.isArray(t) ? t.slice() : [t];
}
function lM(t) {
  return t !== null && t.length === 1 ? t[0] : t.slice();
}
function uM(t) {
  Object.keys(t).forEach(e => {
    typeof document < "u" && document.addEventListener(e, t[e], !1);
  });
}
function Ix(t, e) {
  return Ij(function (i, l) {
    let c = i;
    return c <= l.min && (c = l.min), c >= l.max && (c = l.max), c;
  }(t, e), e);
}
function Ij(t, e) {
  const i = (t - e.min) % e.step;
  let l = t - i;
  return 2 * Math.abs(i) >= e.step && (l += i > 0 ? e.step : -e.step), parseFloat(l.toFixed(5));
}
let Mj = function (t) {
  function e(l) {
    var c;
    (c = t.call(this, l) || this).onKeyUp = () => {
      c.onEnd();
    }, c.onMouseUp = () => {
      c.onEnd(c.getMouseEventMap());
    }, c.onTouchEnd = y => {
      y.preventDefault(), c.onEnd(c.getTouchEventMap());
    }, c.onBlur = () => {
      c.setState({
        index: -1
      }, c.onEnd(c.getKeyDownEventMap()));
    }, c.onMouseMove = y => {
      c.setState({
        pending: !0
      });
      const w = c.getMousePosition(y),
        x = c.getDiffPosition(w[0]),
        E = c.getValueFromPosition(x);
      c.move(E);
    }, c.onTouchMove = y => {
      if (y.touches.length > 1) return;
      c.setState({
        pending: !0
      });
      const w = c.getTouchPosition(y);
      if (c.isScrolling === void 0) {
        const C = w[0] - c.startPosition[0],
          k = w[1] - c.startPosition[1];
        c.isScrolling = Math.abs(k) > Math.abs(C);
      }
      if (c.isScrolling) return void c.setState({
        index: -1
      });
      const x = c.getDiffPosition(w[0]),
        E = c.getValueFromPosition(x);
      c.move(E);
    }, c.onKeyDown = y => {
      if (!(y.ctrlKey || y.shiftKey || y.altKey || y.metaKey)) switch (c.setState({
        pending: !0
      }), y.key) {
        case "ArrowLeft":
        case "ArrowDown":
        case "Left":
        case "Down":
          y.preventDefault(), c.moveDownByStep();
          break;
        case "ArrowRight":
        case "ArrowUp":
        case "Right":
        case "Up":
          y.preventDefault(), c.moveUpByStep();
          break;
        case "Home":
          y.preventDefault(), c.move(c.props.min);
          break;
        case "End":
          y.preventDefault(), c.move(c.props.max);
          break;
        case "PageDown":
          y.preventDefault(), c.moveDownByStep(c.props.pageFn(c.props.step));
          break;
        case "PageUp":
          y.preventDefault(), c.moveUpByStep(c.props.pageFn(c.props.step));
      }
    }, c.onSliderMouseDown = y => {
      if (!c.props.disabled && y.button !== 2) {
        if (c.setState({
          pending: !0
        }), !c.props.snapDragDisabled) {
          const w = c.getMousePosition(y);
          c.forceValueFromPosition(w[0], x => {
            c.start(x, w[0]), uM(c.getMouseEventMap());
          });
        }
        m2(y);
      }
    }, c.onSliderClick = y => {
      if (!c.props.disabled && c.props.onSliderClick && !c.hasMoved) {
        const w = c.getMousePosition(y),
          x = Ix(c.calcValue(c.calcOffsetFromPosition(w[0])), c.props);
        c.props.onSliderClick(x);
      }
    }, c.createOnKeyDown = y => w => {
      c.props.disabled || (c.start(y), uM(c.getKeyDownEventMap()), m2(w));
    }, c.createOnMouseDown = y => w => {
      if (c.props.disabled || w.button === 2) return;
      c.setState({
        pending: !0
      });
      const x = c.getMousePosition(w);
      c.start(y, x[0]), uM(c.getMouseEventMap()), m2(w);
    }, c.createOnTouchStart = y => w => {
      if (c.props.disabled || w.touches.length > 1) return;
      c.setState({
        pending: !0
      });
      const x = c.getTouchPosition(w);
      c.startPosition = x, c.isScrolling = void 0, c.start(y, x[0]), uM(c.getTouchEventMap()), function (E) {
        E.stopPropagation && E.stopPropagation();
      }(w);
    }, c.handleResize = () => {
      const y = window.setTimeout(() => {
        c.pendingResizeTimeouts.shift(), c.resize();
      }, 0);
      c.pendingResizeTimeouts.push(y);
    }, c.renderThumb = (y, w) => {
      const x = c.props.thumbClassName + " " + c.props.thumbClassName + "-" + w + " " + (c.state.index === w ? c.props.thumbActiveClassName : ""),
        E = {
          ref: k => {
            c["thumb" + w] = k;
          },
          key: c.props.thumbClassName + "-" + w,
          className: x,
          style: y,
          onMouseDown: c.createOnMouseDown(w),
          onTouchStart: c.createOnTouchStart(w),
          onFocus: c.createOnKeyDown(w),
          tabIndex: 0,
          role: "slider",
          "aria-orientation": c.props.orientation,
          "aria-valuenow": c.state.value[w],
          "aria-valuemin": c.props.min,
          "aria-valuemax": c.props.max,
          "aria-label": Array.isArray(c.props.ariaLabel) ? c.props.ariaLabel[w] : c.props.ariaLabel,
          "aria-labelledby": Array.isArray(c.props.ariaLabelledby) ? c.props.ariaLabelledby[w] : c.props.ariaLabelledby,
          "aria-disabled": c.props.disabled
        },
        C = {
          index: w,
          value: lM(c.state.value),
          valueNow: c.state.value[w]
        };
      return c.props.ariaValuetext && (E["aria-valuetext"] = typeof c.props.ariaValuetext == "string" ? c.props.ariaValuetext : c.props.ariaValuetext(C)), c.props.renderThumb(E, C);
    }, c.renderTrack = (y, w, x) => {
      const E = {
          key: c.props.trackClassName + "-" + y,
          className: c.props.trackClassName + " " + c.props.trackClassName + "-" + y,
          style: c.buildTrackStyle(w, c.state.upperBound - x)
        },
        C = {
          index: y,
          value: lM(c.state.value)
        };
      return c.props.renderTrack(E, C);
    };
    let p = v2(l.value);
    p.length || (p = v2(l.defaultValue)), c.pendingResizeTimeouts = [];
    const h = [];
    for (let y = 0; y < p.length; y += 1) p[y] = Ix(p[y], l), h.push(y);
    return c.resizeObserver = null, c.resizeElementRef = Nt.createRef(), c.state = {
      index: -1,
      upperBound: 0,
      sliderLength: 0,
      value: p,
      zIndices: h
    }, c;
  }
  dG(e, t);
  var i = e.prototype;
  return i.componentDidMount = function () {
    typeof window < "u" && (this.resizeObserver = new ResizeObserver(this.handleResize), this.resizeObserver.observe(this.resizeElementRef.current), this.resize());
  }, e.getDerivedStateFromProps = function (l, c) {
    const p = v2(l.value);
    return p.length ? c.pending ? null : {
      value: p.map(h => Ix(h, l))
    } : null;
  }, i.componentDidUpdate = function () {
    this.state.upperBound === 0 && this.resize();
  }, i.componentWillUnmount = function () {
    this.clearPendingResizeTimeouts(), this.resizeObserver && this.resizeObserver.disconnect();
  }, i.onEnd = function (l) {
    l && function (c) {
      Object.keys(c).forEach(p => {
        typeof document < "u" && document.removeEventListener(p, c[p], !1);
      });
    }(l), this.hasMoved && this.fireChangeEvent("onAfterChange"), this.setState({
      pending: !1
    }), this.hasMoved = !1;
  }, i.getValue = function () {
    return lM(this.state.value);
  }, i.getClosestIndex = function (l) {
    let c = Number.MAX_VALUE,
      p = -1;
    const {
        value: h
      } = this.state,
      y = h.length;
    for (let w = 0; w < y; w += 1) {
      const x = this.calcOffset(h[w]),
        E = Math.abs(l - x);
      E < c && (c = E, p = w);
    }
    return p;
  }, i.getMousePosition = function (l) {
    return [l["page" + this.axisKey()], l["page" + this.orthogonalAxisKey()]];
  }, i.getTouchPosition = function (l) {
    const c = l.touches[0];
    return [c["page" + this.axisKey()], c["page" + this.orthogonalAxisKey()]];
  }, i.getKeyDownEventMap = function () {
    return {
      keydown: this.onKeyDown,
      keyup: this.onKeyUp,
      focusout: this.onBlur
    };
  }, i.getMouseEventMap = function () {
    return {
      mousemove: this.onMouseMove,
      mouseup: this.onMouseUp
    };
  }, i.getTouchEventMap = function () {
    return {
      touchmove: this.onTouchMove,
      touchend: this.onTouchEnd
    };
  }, i.getValueFromPosition = function (l) {
    const c = l / (this.state.sliderLength - this.state.thumbSize) * (this.props.max - this.props.min);
    return Ix(this.state.startValue + c, this.props);
  }, i.getDiffPosition = function (l) {
    let c = l - this.state.startPosition;
    return this.props.invert && (c *= -1), c;
  }, i.resize = function () {
    const {
      slider: l,
      thumb0: c
    } = this;
    if (!l || !c) return;
    const p = this.sizeKey(),
      h = l.getBoundingClientRect(),
      y = l[p],
      w = h[this.posMaxKey()],
      x = h[this.posMinKey()],
      E = c.getBoundingClientRect()[p.replace("client", "").toLowerCase()],
      C = y - E,
      k = Math.abs(w - x);
    this.state.upperBound === C && this.state.sliderLength === k && this.state.thumbSize === E || this.setState({
      upperBound: C,
      sliderLength: k,
      thumbSize: E
    });
  }, i.calcOffset = function (l) {
    const c = this.props.max - this.props.min;
    return c === 0 ? 0 : (l - this.props.min) / c * this.state.upperBound;
  }, i.calcValue = function (l) {
    return l / this.state.upperBound * (this.props.max - this.props.min) + this.props.min;
  }, i.calcOffsetFromPosition = function (l) {
    const {
        slider: c
      } = this,
      p = c.getBoundingClientRect(),
      h = p[this.posMaxKey()],
      y = p[this.posMinKey()];
    let w = l - (window["page" + this.axisKey() + "Offset"] + (this.props.invert ? h : y));
    return this.props.invert && (w = this.state.sliderLength - w), w -= this.state.thumbSize / 2, w;
  }, i.forceValueFromPosition = function (l, c) {
    const p = this.calcOffsetFromPosition(l),
      h = this.getClosestIndex(p),
      y = Ix(this.calcValue(p), this.props),
      w = this.state.value.slice();
    w[h] = y;
    for (let x = 0; x < w.length - 1; x += 1) if (w[x + 1] - w[x] < this.props.minDistance) return;
    this.fireChangeEvent("onBeforeChange"), this.hasMoved = !0, this.setState({
      value: w
    }, () => {
      c(h), this.fireChangeEvent("onChange");
    });
  }, i.clearPendingResizeTimeouts = function () {
    do {
      const l = this.pendingResizeTimeouts.shift();
      clearTimeout(l);
    } while (this.pendingResizeTimeouts.length);
  }, i.start = function (l, c) {
    const p = this["thumb" + l];
    p && p.focus();
    const {
      zIndices: h
    } = this.state;
    h.splice(h.indexOf(l), 1), h.push(l), this.setState(y => ({
      startValue: y.value[l],
      startPosition: c !== void 0 ? c : y.startPosition,
      index: l,
      zIndices: h
    }));
  }, i.moveUpByStep = function (l) {
    l === void 0 && (l = this.props.step);
    const c = this.state.value[this.state.index],
      p = Ix(this.props.invert && this.props.orientation === "horizontal" ? c - l : c + l, this.props);
    this.move(Math.min(p, this.props.max));
  }, i.moveDownByStep = function (l) {
    l === void 0 && (l = this.props.step);
    const c = this.state.value[this.state.index],
      p = Ix(this.props.invert && this.props.orientation === "horizontal" ? c + l : c - l, this.props);
    this.move(Math.max(p, this.props.min));
  }, i.move = function (l) {
    const c = this.state.value.slice(),
      {
        index: p
      } = this.state,
      {
        length: h
      } = c,
      y = c[p];
    if (l === y) return;
    this.hasMoved || this.fireChangeEvent("onBeforeChange"), this.hasMoved = !0;
    const {
      pearling: w,
      max: x,
      min: E,
      minDistance: C
    } = this.props;
    if (!w) {
      if (p > 0) {
        const k = c[p - 1];
        l < k + C && (l = k + C);
      }
      if (p < h - 1) {
        const k = c[p + 1];
        l > k - C && (l = k - C);
      }
    }
    c[p] = l, w && h > 1 && (l > y ? (this.pushSucceeding(c, C, p), function (k, D, I, O) {
      for (let P = 0; P < k; P += 1) {
        const N = O - P * I;
        D[k - 1 - P] > N && (D[k - 1 - P] = N);
      }
    }(h, c, C, x)) : l < y && (this.pushPreceding(c, C, p), function (k, D, I, O) {
      for (let P = 0; P < k; P += 1) {
        const N = O + P * I;
        D[P] < N && (D[P] = N);
      }
    }(h, c, C, E))), this.setState({
      value: c
    }, this.fireChangeEvent.bind(this, "onChange"));
  }, i.pushSucceeding = function (l, c, p) {
    let h, y;
    for (h = p, y = l[h] + c; l[h + 1] !== null && y > l[h + 1]; h += 1, y = l[h] + c) l[h + 1] = Ij(y, this.props);
  }, i.pushPreceding = function (l, c, p) {
    for (let h = p, y = l[h] - c; l[h - 1] !== null && y < l[h - 1]; h -= 1, y = l[h] - c) l[h - 1] = Ij(y, this.props);
  }, i.axisKey = function () {
    return this.props.orientation === "vertical" ? "Y" : "X";
  }, i.orthogonalAxisKey = function () {
    return this.props.orientation === "vertical" ? "X" : "Y";
  }, i.posMinKey = function () {
    return this.props.orientation === "vertical" ? this.props.invert ? "bottom" : "top" : this.props.invert ? "right" : "left";
  }, i.posMaxKey = function () {
    return this.props.orientation === "vertical" ? this.props.invert ? "top" : "bottom" : this.props.invert ? "left" : "right";
  }, i.sizeKey = function () {
    return this.props.orientation === "vertical" ? "clientHeight" : "clientWidth";
  }, i.fireChangeEvent = function (l) {
    this.props[l] && this.props[l](lM(this.state.value), this.state.index);
  }, i.buildThumbStyle = function (l, c) {
    const p = {
      position: "absolute",
      touchAction: "none",
      willChange: this.state.index >= 0 ? this.posMinKey() : void 0,
      zIndex: this.state.zIndices.indexOf(c) + 1
    };
    return p[this.posMinKey()] = l + "px", p;
  }, i.buildTrackStyle = function (l, c) {
    const p = {
      position: "absolute",
      willChange: this.state.index >= 0 ? this.posMinKey() + "," + this.posMaxKey() : void 0
    };
    return p[this.posMinKey()] = l, p[this.posMaxKey()] = c, p;
  }, i.buildMarkStyle = function (l) {
    var c;
    return (c = {
      position: "absolute"
    })[this.posMinKey()] = l, c;
  }, i.renderThumbs = function (l) {
    const {
        length: c
      } = l,
      p = [];
    for (let y = 0; y < c; y += 1) p[y] = this.buildThumbStyle(l[y], y);
    const h = [];
    for (let y = 0; y < c; y += 1) h[y] = this.renderThumb(p[y], y);
    return h;
  }, i.renderTracks = function (l) {
    const c = [],
      p = l.length - 1;
    c.push(this.renderTrack(0, 0, l[0]));
    for (let h = 0; h < p; h += 1) c.push(this.renderTrack(h + 1, l[h], l[h + 1]));
    return c.push(this.renderTrack(p + 1, l[p], this.state.upperBound)), c;
  }, i.renderMarks = function () {
    let {
      marks: l
    } = this.props;
    const c = this.props.max - this.props.min + 1;
    return typeof l == "boolean" ? l = Array.from({
      length: c
    }).map((p, h) => h) : typeof l == "number" && (l = Array.from({
      length: c
    }).map((p, h) => h).filter(p => p % l == 0)), l.map(parseFloat).sort((p, h) => p - h).map(p => {
      const h = this.calcOffset(p),
        y = {
          key: p,
          className: this.props.markClassName,
          style: this.buildMarkStyle(h)
        };
      return this.props.renderMark(y);
    });
  }, i.render = function () {
    const l = [],
      {
        value: c
      } = this.state,
      p = c.length;
    for (let x = 0; x < p; x += 1) l[x] = this.calcOffset(c[x], x);
    const h = this.props.withTracks ? this.renderTracks(l) : null,
      y = this.renderThumbs(l),
      w = this.props.marks ? this.renderMarks() : null;
    return Nt.createElement("div", {
      ref: x => {
        this.slider = x, this.resizeElementRef.current = x;
      },
      style: {
        position: "relative"
      },
      className: this.props.className + (this.props.disabled ? " disabled" : ""),
      onMouseDown: this.onSliderMouseDown,
      onClick: this.onSliderClick
    }, h, y, w);
  }, e;
}(Nt.Component);
Mj.displayName = "ReactSlider", Mj.defaultProps = {
  min: 0,
  max: 100,
  step: 1,
  pageFn: t => 10 * t,
  minDistance: 0,
  defaultValue: 0,
  orientation: "horizontal",
  className: "slider",
  thumbClassName: "thumb",
  thumbActiveClassName: "active",
  trackClassName: "track",
  markClassName: "mark",
  withTracks: !0,
  pearling: !1,
  disabled: !1,
  snapDragDisabled: !1,
  invert: !1,
  marks: [],
  renderThumb: t => Nt.createElement("div", t),
  renderTrack: t => Nt.createElement("div", t),
  renderMark: t => Nt.createElement("span", t)
};
var fG = Mj;
const pG = "_rangeInner_1wga2_24",
  hG = "_rangeText_1wga2_28",
  mG = "_rangeTrack_1wga2_32",
  vG = "_rangeThumb_1wga2_49",
  gG = "_rangeValue_1wga2_68",
  q1 = {
    rangeInner: pG,
    rangeText: hG,
    rangeTrack: mG,
    rangeThumb: vG,
    rangeValue: gG
  },
  yG = ({
    id: t,
    className: e,
    classNames: i,
    ranges: l = [0, 1e4],
    rangeText: c = "Price Range",
    value: p,
    handleValueLabel: h = w => /* @__PURE__ */_e.jsx("span", {
      children: w
    }),
    onHandleRangeChange: y
  }) => {
    const w = l ? l[0] : 0,
      x = l ? l[l.length - 1] : 1e4;
    return /* @__PURE__ */_e.jsxs("div", {
      className: vl(q1.rangeInner, e),
      children: [/* @__PURE__ */_e.jsx("div", {
        className: vl(q1.rangeText, i == null ? void 0 : i.rangeText),
        children: c
      }), /* @__PURE__ */_e.jsxs("div", {
        children: [/* @__PURE__ */_e.jsx(fG, {
          thumbClassName: vl(q1.rangeThumb, i == null ? void 0 : i.thumbClassName),
          trackClassName: vl(q1.rangeTrack, i == null ? void 0 : i.trackClassName),
          value: p,
          ariaLabelledby: [`${t}-first-slider-label`, `${t}-second-slider-label`],
          ariaValuetext: `thumb value between ${w}   and ${x}`,
          onChange: y,
          renderThumb: (E, C) => /* @__PURE__ */_e.jsx("div", {
            ...E,
            children: C.valueNow
          }),
          pearling: !0,
          min: w,
          max: x,
          minDistance: 10
        }), /* @__PURE__ */_e.jsx("span", {
          id: "first-slider-label",
          className: q1.rangeValue,
          children: h(p[0].toString())
        }), /* @__PURE__ */_e.jsx("span", {
          id: "second-slider-label",
          className: q1.rangeValue,
          children: h(p[1].toString())
        })]
      })]
    });
  },
  bG = "fr-CA",
  wG = "_formattedNum_1so9e_1",
  IV = {
    formattedNum: wG
  },
  _G = ({
    number: t,
    locale: e
  }) => {
    switch (e) {
      case bG:
        return /* @__PURE__ */_e.jsxs("span", {
          className: IV.formattedNum,
          children: [t, " $"]
        });
      default:
        return /* @__PURE__ */_e.jsxs("span", {
          className: IV.formattedNum,
          children: ["$", t]
        });
    }
  },
  xG = ({
    locale: t,
    rangeText: e = "Price Range",
    ...i
  }) => {
    const l = c => /* @__PURE__ */_e.jsx(_G, {
      number: c,
      locale: t
    });
    return /* @__PURE__ */_e.jsx(yG, {
      ...i,
      rangeText: e,
      handleValueLabel: l
    });
  };
var cd = "top",
  Hp = "bottom",
  $p = "right",
  dd = "left",
  vN = "auto",
  BR = [cd, Hp, $p, dd],
  SE = "start",
  sR = "end",
  SG = "clippingParents",
  t4 = "viewport",
  bT = "popper",
  EG = "reference",
  MV = /* @__PURE__ */BR.reduce(function (t, e) {
    return t.concat([e + "-" + SE, e + "-" + sR]);
  }, []),
  n4 = /* @__PURE__ */[].concat(BR, [vN]).reduce(function (t, e) {
    return t.concat([e, e + "-" + SE, e + "-" + sR]);
  }, []),
  CG = "beforeRead",
  kG = "read",
  TG = "afterRead",
  RG = "beforeMain",
  DG = "main",
  IG = "afterMain",
  MG = "beforeWrite",
  OG = "write",
  LG = "afterWrite",
  PG = [CG, kG, TG, RG, DG, IG, MG, OG, LG];
function Zv(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function lp(t) {
  if (t == null) return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function Jx(t) {
  var e = lp(t).Element;
  return t instanceof e || t instanceof Element;
}
function Vp(t) {
  var e = lp(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function gN(t) {
  if (typeof ShadowRoot > "u") return !1;
  var e = lp(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function AG(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function (i) {
    var l = e.styles[i] || {},
      c = e.attributes[i] || {},
      p = e.elements[i];
    !Vp(p) || !Zv(p) || (Object.assign(p.style, l), Object.keys(c).forEach(function (h) {
      var y = c[h];
      y === !1 ? p.removeAttribute(h) : p.setAttribute(h, y === !0 ? "" : y);
    }));
  });
}
function jG(t) {
  var e = t.state,
    i = {
      popper: {
        position: e.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
  return Object.assign(e.elements.popper.style, i.popper), e.styles = i, e.elements.arrow && Object.assign(e.elements.arrow.style, i.arrow), function () {
    Object.keys(e.elements).forEach(function (l) {
      var c = e.elements[l],
        p = e.attributes[l] || {},
        h = Object.keys(e.styles.hasOwnProperty(l) ? e.styles[l] : i[l]),
        y = h.reduce(function (w, x) {
          return w[x] = "", w;
        }, {});
      !Vp(c) || !Zv(c) || (Object.assign(c.style, y), Object.keys(p).forEach(function (w) {
        c.removeAttribute(w);
      }));
    });
  };
}
const r4 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: AG,
  effect: jG,
  requires: ["computeStyles"]
};
function Gv(t) {
  return t.split("-")[0];
}
var Yx = Math.max,
  yO = Math.min,
  EE = Math.round;
function Oj() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function (e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function i4() {
  return !/^((?!chrome|android).)*safari/i.test(Oj());
}
function CE(t, e, i) {
  e === void 0 && (e = !1), i === void 0 && (i = !1);
  var l = t.getBoundingClientRect(),
    c = 1,
    p = 1;
  e && Vp(t) && (c = t.offsetWidth > 0 && EE(l.width) / t.offsetWidth || 1, p = t.offsetHeight > 0 && EE(l.height) / t.offsetHeight || 1);
  var h = Jx(t) ? lp(t) : window,
    y = h.visualViewport,
    w = !i4() && i,
    x = (l.left + (w && y ? y.offsetLeft : 0)) / c,
    E = (l.top + (w && y ? y.offsetTop : 0)) / p,
    C = l.width / c,
    k = l.height / p;
  return {
    width: C,
    height: k,
    top: E,
    right: x + C,
    bottom: E + k,
    left: x,
    x,
    y: E
  };
}
function yN(t) {
  var e = CE(t),
    i = t.offsetWidth,
    l = t.offsetHeight;
  return Math.abs(e.width - i) <= 1 && (i = e.width), Math.abs(e.height - l) <= 1 && (l = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: i,
    height: l
  };
}
function a4(t, e) {
  var i = e.getRootNode && e.getRootNode();
  if (t.contains(e)) return !0;
  if (i && gN(i)) {
    var l = e;
    do {
      if (l && t.isSameNode(l)) return !0;
      l = l.parentNode || l.host;
    } while (l);
  }
  return !1;
}
function bb(t) {
  return lp(t).getComputedStyle(t);
}
function FG(t) {
  return ["table", "td", "th"].indexOf(Zv(t)) >= 0;
}
function sw(t) {
  return ((Jx(t) ? t.ownerDocument :
  // $FlowFixMe[prop-missing]
  t.document) || window.document).documentElement;
}
function XO(t) {
  return Zv(t) === "html" ? t :
  // this is a quicker (but less type safe) way to save quite some bytes from the bundle
  // $FlowFixMe[incompatible-return]
  // $FlowFixMe[prop-missing]
  t.assignedSlot ||
  // step into the shadow DOM of the parent of a slotted node
  t.parentNode || (
  // DOM Element detected
  gN(t) ? t.host : null) ||
  // ShadowRoot detected
  // $FlowFixMe[incompatible-call]: HTMLElement is a Node
  sw(t);
}
function OV(t) {
  return !Vp(t) ||
  // https://github.com/popperjs/popper-core/issues/837
  bb(t).position === "fixed" ? null : t.offsetParent;
}
function NG(t) {
  var e = /firefox/i.test(Oj()),
    i = /Trident/i.test(Oj());
  if (i && Vp(t)) {
    var l = bb(t);
    if (l.position === "fixed") return null;
  }
  var c = XO(t);
  for (gN(c) && (c = c.host); Vp(c) && ["html", "body"].indexOf(Zv(c)) < 0;) {
    var p = bb(c);
    if (p.transform !== "none" || p.perspective !== "none" || p.contain === "paint" || ["transform", "perspective"].indexOf(p.willChange) !== -1 || e && p.willChange === "filter" || e && p.filter && p.filter !== "none") return c;
    c = c.parentNode;
  }
  return null;
}
function UR(t) {
  for (var e = lp(t), i = OV(t); i && FG(i) && bb(i).position === "static";) i = OV(i);
  return i && (Zv(i) === "html" || Zv(i) === "body" && bb(i).position === "static") ? e : i || NG(t) || e;
}
function bN(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function UT(t, e, i) {
  return Yx(t, yO(e, i));
}
function zG(t, e, i) {
  var l = UT(t, e, i);
  return l > i ? i : l;
}
function o4() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function s4(t) {
  return Object.assign({}, o4(), t);
}
function l4(t, e) {
  return e.reduce(function (i, l) {
    return i[l] = t, i;
  }, {});
}
var VG = function (t, e) {
  return t = typeof t == "function" ? t(Object.assign({}, e.rects, {
    placement: e.placement
  })) : t, s4(typeof t != "number" ? t : l4(t, BR));
};
function BG(t) {
  var e,
    i = t.state,
    l = t.name,
    c = t.options,
    p = i.elements.arrow,
    h = i.modifiersData.popperOffsets,
    y = Gv(i.placement),
    w = bN(y),
    x = [dd, $p].indexOf(y) >= 0,
    E = x ? "height" : "width";
  if (!(!p || !h)) {
    var C = VG(c.padding, i),
      k = yN(p),
      D = w === "y" ? cd : dd,
      I = w === "y" ? Hp : $p,
      O = i.rects.reference[E] + i.rects.reference[w] - h[w] - i.rects.popper[E],
      P = h[w] - i.rects.reference[w],
      N = UR(p),
      L = N ? w === "y" ? N.clientHeight || 0 : N.clientWidth || 0 : 0,
      F = O / 2 - P / 2,
      j = C[D],
      V = L - k[E] - C[I],
      K = L / 2 - k[E] / 2 + F,
      G = UT(j, K, V),
      Q = w;
    i.modifiersData[l] = (e = {}, e[Q] = G, e.centerOffset = G - K, e);
  }
}
function UG(t) {
  var e = t.state,
    i = t.options,
    l = i.element,
    c = l === void 0 ? "[data-popper-arrow]" : l;
  c != null && (typeof c == "string" && (c = e.elements.popper.querySelector(c), !c) || a4(e.elements.popper, c) && (e.elements.arrow = c));
}
const HG = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: BG,
  effect: UG,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function kE(t) {
  return t.split("-")[1];
}
var $G = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function WG(t, e) {
  var i = t.x,
    l = t.y,
    c = e.devicePixelRatio || 1;
  return {
    x: EE(i * c) / c || 0,
    y: EE(l * c) / c || 0
  };
}
function LV(t) {
  var e,
    i = t.popper,
    l = t.popperRect,
    c = t.placement,
    p = t.variation,
    h = t.offsets,
    y = t.position,
    w = t.gpuAcceleration,
    x = t.adaptive,
    E = t.roundOffsets,
    C = t.isFixed,
    k = h.x,
    D = k === void 0 ? 0 : k,
    I = h.y,
    O = I === void 0 ? 0 : I,
    P = typeof E == "function" ? E({
      x: D,
      y: O
    }) : {
      x: D,
      y: O
    };
  D = P.x, O = P.y;
  var N = h.hasOwnProperty("x"),
    L = h.hasOwnProperty("y"),
    F = dd,
    j = cd,
    V = window;
  if (x) {
    var K = UR(i),
      G = "clientHeight",
      Q = "clientWidth";
    if (K === lp(i) && (K = sw(i), bb(K).position !== "static" && y === "absolute" && (G = "scrollHeight", Q = "scrollWidth")), K = K, c === cd || (c === dd || c === $p) && p === sR) {
      j = Hp;
      var te = C && K === V && V.visualViewport ? V.visualViewport.height :
      // $FlowFixMe[prop-missing]
      K[G];
      O -= te - l.height, O *= w ? 1 : -1;
    }
    if (c === dd || (c === cd || c === Hp) && p === sR) {
      F = $p;
      var ie = C && K === V && V.visualViewport ? V.visualViewport.width :
      // $FlowFixMe[prop-missing]
      K[Q];
      D -= ie - l.width, D *= w ? 1 : -1;
    }
  }
  var Y = Object.assign({
      position: y
    }, x && $G),
    ee = E === !0 ? WG({
      x: D,
      y: O
    }, lp(i)) : {
      x: D,
      y: O
    };
  if (D = ee.x, O = ee.y, w) {
    var oe;
    return Object.assign({}, Y, (oe = {}, oe[j] = L ? "0" : "", oe[F] = N ? "0" : "", oe.transform = (V.devicePixelRatio || 1) <= 1 ? "translate(" + D + "px, " + O + "px)" : "translate3d(" + D + "px, " + O + "px, 0)", oe));
  }
  return Object.assign({}, Y, (e = {}, e[j] = L ? O + "px" : "", e[F] = N ? D + "px" : "", e.transform = "", e));
}
function qG(t) {
  var e = t.state,
    i = t.options,
    l = i.gpuAcceleration,
    c = l === void 0 ? !0 : l,
    p = i.adaptive,
    h = p === void 0 ? !0 : p,
    y = i.roundOffsets,
    w = y === void 0 ? !0 : y,
    x = {
      placement: Gv(e.placement),
      variation: kE(e.placement),
      popper: e.elements.popper,
      popperRect: e.rects.popper,
      gpuAcceleration: c,
      isFixed: e.options.strategy === "fixed"
    };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, LV(Object.assign({}, x, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: h,
    roundOffsets: w
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, LV(Object.assign({}, x, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: w
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const YG = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: qG,
  data: {}
};
var cM = {
  passive: !0
};
function GG(t) {
  var e = t.state,
    i = t.instance,
    l = t.options,
    c = l.scroll,
    p = c === void 0 ? !0 : c,
    h = l.resize,
    y = h === void 0 ? !0 : h,
    w = lp(e.elements.popper),
    x = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return p && x.forEach(function (E) {
    E.addEventListener("scroll", i.update, cM);
  }), y && w.addEventListener("resize", i.update, cM), function () {
    p && x.forEach(function (E) {
      E.removeEventListener("scroll", i.update, cM);
    }), y && w.removeEventListener("resize", i.update, cM);
  };
}
const XG = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function () {},
  effect: GG,
  data: {}
};
var KG = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function UM(t) {
  return t.replace(/left|right|bottom|top/g, function (e) {
    return KG[e];
  });
}
var QG = {
  start: "end",
  end: "start"
};
function PV(t) {
  return t.replace(/start|end/g, function (e) {
    return QG[e];
  });
}
function wN(t) {
  var e = lp(t),
    i = e.pageXOffset,
    l = e.pageYOffset;
  return {
    scrollLeft: i,
    scrollTop: l
  };
}
function _N(t) {
  return CE(sw(t)).left + wN(t).scrollLeft;
}
function ZG(t, e) {
  var i = lp(t),
    l = sw(t),
    c = i.visualViewport,
    p = l.clientWidth,
    h = l.clientHeight,
    y = 0,
    w = 0;
  if (c) {
    p = c.width, h = c.height;
    var x = i4();
    (x || !x && e === "fixed") && (y = c.offsetLeft, w = c.offsetTop);
  }
  return {
    width: p,
    height: h,
    x: y + _N(t),
    y: w
  };
}
function JG(t) {
  var e,
    i = sw(t),
    l = wN(t),
    c = (e = t.ownerDocument) == null ? void 0 : e.body,
    p = Yx(i.scrollWidth, i.clientWidth, c ? c.scrollWidth : 0, c ? c.clientWidth : 0),
    h = Yx(i.scrollHeight, i.clientHeight, c ? c.scrollHeight : 0, c ? c.clientHeight : 0),
    y = -l.scrollLeft + _N(t),
    w = -l.scrollTop;
  return bb(c || i).direction === "rtl" && (y += Yx(i.clientWidth, c ? c.clientWidth : 0) - p), {
    width: p,
    height: h,
    x: y,
    y: w
  };
}
function xN(t) {
  var e = bb(t),
    i = e.overflow,
    l = e.overflowX,
    c = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(i + c + l);
}
function u4(t) {
  return ["html", "body", "#document"].indexOf(Zv(t)) >= 0 ? t.ownerDocument.body : Vp(t) && xN(t) ? t : u4(XO(t));
}
function HT(t, e) {
  var i;
  e === void 0 && (e = []);
  var l = u4(t),
    c = l === ((i = t.ownerDocument) == null ? void 0 : i.body),
    p = lp(l),
    h = c ? [p].concat(p.visualViewport || [], xN(l) ? l : []) : l,
    y = e.concat(h);
  return c ? y :
  // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  y.concat(HT(XO(h)));
}
function Lj(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function eX(t, e) {
  var i = CE(t, !1, e === "fixed");
  return i.top = i.top + t.clientTop, i.left = i.left + t.clientLeft, i.bottom = i.top + t.clientHeight, i.right = i.left + t.clientWidth, i.width = t.clientWidth, i.height = t.clientHeight, i.x = i.left, i.y = i.top, i;
}
function AV(t, e, i) {
  return e === t4 ? Lj(ZG(t, i)) : Jx(e) ? eX(e, i) : Lj(JG(sw(t)));
}
function tX(t) {
  var e = HT(XO(t)),
    i = ["absolute", "fixed"].indexOf(bb(t).position) >= 0,
    l = i && Vp(t) ? UR(t) : t;
  return Jx(l) ? e.filter(function (c) {
    return Jx(c) && a4(c, l) && Zv(c) !== "body";
  }) : [];
}
function nX(t, e, i, l) {
  var c = e === "clippingParents" ? tX(t) : [].concat(e),
    p = [].concat(c, [i]),
    h = p[0],
    y = p.reduce(function (w, x) {
      var E = AV(t, x, l);
      return w.top = Yx(E.top, w.top), w.right = yO(E.right, w.right), w.bottom = yO(E.bottom, w.bottom), w.left = Yx(E.left, w.left), w;
    }, AV(t, h, l));
  return y.width = y.right - y.left, y.height = y.bottom - y.top, y.x = y.left, y.y = y.top, y;
}
function c4(t) {
  var e = t.reference,
    i = t.element,
    l = t.placement,
    c = l ? Gv(l) : null,
    p = l ? kE(l) : null,
    h = e.x + e.width / 2 - i.width / 2,
    y = e.y + e.height / 2 - i.height / 2,
    w;
  switch (c) {
    case cd:
      w = {
        x: h,
        y: e.y - i.height
      };
      break;
    case Hp:
      w = {
        x: h,
        y: e.y + e.height
      };
      break;
    case $p:
      w = {
        x: e.x + e.width,
        y
      };
      break;
    case dd:
      w = {
        x: e.x - i.width,
        y
      };
      break;
    default:
      w = {
        x: e.x,
        y: e.y
      };
  }
  var x = c ? bN(c) : null;
  if (x != null) {
    var E = x === "y" ? "height" : "width";
    switch (p) {
      case SE:
        w[x] = w[x] - (e[E] / 2 - i[E] / 2);
        break;
      case sR:
        w[x] = w[x] + (e[E] / 2 - i[E] / 2);
        break;
    }
  }
  return w;
}
function lR(t, e) {
  e === void 0 && (e = {});
  var i = e,
    l = i.placement,
    c = l === void 0 ? t.placement : l,
    p = i.strategy,
    h = p === void 0 ? t.strategy : p,
    y = i.boundary,
    w = y === void 0 ? SG : y,
    x = i.rootBoundary,
    E = x === void 0 ? t4 : x,
    C = i.elementContext,
    k = C === void 0 ? bT : C,
    D = i.altBoundary,
    I = D === void 0 ? !1 : D,
    O = i.padding,
    P = O === void 0 ? 0 : O,
    N = s4(typeof P != "number" ? P : l4(P, BR)),
    L = k === bT ? EG : bT,
    F = t.rects.popper,
    j = t.elements[I ? L : k],
    V = nX(Jx(j) ? j : j.contextElement || sw(t.elements.popper), w, E, h),
    K = CE(t.elements.reference),
    G = c4({
      reference: K,
      element: F,
      placement: c
    }),
    Q = Lj(Object.assign({}, F, G)),
    te = k === bT ? Q : K,
    ie = {
      top: V.top - te.top + N.top,
      bottom: te.bottom - V.bottom + N.bottom,
      left: V.left - te.left + N.left,
      right: te.right - V.right + N.right
    },
    Y = t.modifiersData.offset;
  if (k === bT && Y) {
    var ee = Y[c];
    Object.keys(ie).forEach(function (oe) {
      var ne = [$p, Hp].indexOf(oe) >= 0 ? 1 : -1,
        se = [cd, Hp].indexOf(oe) >= 0 ? "y" : "x";
      ie[oe] += ee[se] * ne;
    });
  }
  return ie;
}
function rX(t, e) {
  e === void 0 && (e = {});
  var i = e,
    l = i.placement,
    c = i.boundary,
    p = i.rootBoundary,
    h = i.padding,
    y = i.flipVariations,
    w = i.allowedAutoPlacements,
    x = w === void 0 ? n4 : w,
    E = kE(l),
    C = E ? y ? MV : MV.filter(function (I) {
      return kE(I) === E;
    }) : BR,
    k = C.filter(function (I) {
      return x.indexOf(I) >= 0;
    });
  k.length === 0 && (k = C);
  var D = k.reduce(function (I, O) {
    return I[O] = lR(t, {
      placement: O,
      boundary: c,
      rootBoundary: p,
      padding: h
    })[Gv(O)], I;
  }, {});
  return Object.keys(D).sort(function (I, O) {
    return D[I] - D[O];
  });
}
function iX(t) {
  if (Gv(t) === vN) return [];
  var e = UM(t);
  return [PV(t), e, PV(e)];
}
function aX(t) {
  var e = t.state,
    i = t.options,
    l = t.name;
  if (!e.modifiersData[l]._skip) {
    for (var c = i.mainAxis, p = c === void 0 ? !0 : c, h = i.altAxis, y = h === void 0 ? !0 : h, w = i.fallbackPlacements, x = i.padding, E = i.boundary, C = i.rootBoundary, k = i.altBoundary, D = i.flipVariations, I = D === void 0 ? !0 : D, O = i.allowedAutoPlacements, P = e.options.placement, N = Gv(P), L = N === P, F = w || (L || !I ? [UM(P)] : iX(P)), j = [P].concat(F).reduce(function (Ee, fe) {
        return Ee.concat(Gv(fe) === vN ? rX(e, {
          placement: fe,
          boundary: E,
          rootBoundary: C,
          padding: x,
          flipVariations: I,
          allowedAutoPlacements: O
        }) : fe);
      }, []), V = e.rects.reference, K = e.rects.popper, G = /* @__PURE__ */new Map(), Q = !0, te = j[0], ie = 0; ie < j.length; ie++) {
      var Y = j[ie],
        ee = Gv(Y),
        oe = kE(Y) === SE,
        ne = [cd, Hp].indexOf(ee) >= 0,
        se = ne ? "width" : "height",
        ue = lR(e, {
          placement: Y,
          boundary: E,
          rootBoundary: C,
          altBoundary: k,
          padding: x
        }),
        W = ne ? oe ? $p : dd : oe ? Hp : cd;
      V[se] > K[se] && (W = UM(W));
      var $ = UM(W),
        le = [];
      if (p && le.push(ue[ee] <= 0), y && le.push(ue[W] <= 0, ue[$] <= 0), le.every(function (Ee) {
        return Ee;
      })) {
        te = Y, Q = !1;
        break;
      }
      G.set(Y, le);
    }
    if (Q) for (var H = I ? 3 : 1, ce = function (Ee) {
        var fe = j.find(function (xe) {
          var we = G.get(xe);
          if (we) return we.slice(0, Ee).every(function (ve) {
            return ve;
          });
        });
        if (fe) return te = fe, "break";
      }, de = H; de > 0; de--) {
      var Ce = ce(de);
      if (Ce === "break") break;
    }
    e.placement !== te && (e.modifiersData[l]._skip = !0, e.placement = te, e.reset = !0);
  }
}
const oX = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: aX,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function jV(t, e, i) {
  return i === void 0 && (i = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - i.y,
    right: t.right - e.width + i.x,
    bottom: t.bottom - e.height + i.y,
    left: t.left - e.width - i.x
  };
}
function FV(t) {
  return [cd, $p, Hp, dd].some(function (e) {
    return t[e] >= 0;
  });
}
function sX(t) {
  var e = t.state,
    i = t.name,
    l = e.rects.reference,
    c = e.rects.popper,
    p = e.modifiersData.preventOverflow,
    h = lR(e, {
      elementContext: "reference"
    }),
    y = lR(e, {
      altBoundary: !0
    }),
    w = jV(h, l),
    x = jV(y, c, p),
    E = FV(w),
    C = FV(x);
  e.modifiersData[i] = {
    referenceClippingOffsets: w,
    popperEscapeOffsets: x,
    isReferenceHidden: E,
    hasPopperEscaped: C
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": E,
    "data-popper-escaped": C
  });
}
const lX = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: sX
};
function uX(t, e, i) {
  var l = Gv(t),
    c = [dd, cd].indexOf(l) >= 0 ? -1 : 1,
    p = typeof i == "function" ? i(Object.assign({}, e, {
      placement: t
    })) : i,
    h = p[0],
    y = p[1];
  return h = h || 0, y = (y || 0) * c, [dd, $p].indexOf(l) >= 0 ? {
    x: y,
    y: h
  } : {
    x: h,
    y
  };
}
function cX(t) {
  var e = t.state,
    i = t.options,
    l = t.name,
    c = i.offset,
    p = c === void 0 ? [0, 0] : c,
    h = n4.reduce(function (E, C) {
      return E[C] = uX(C, e.rects, p), E;
    }, {}),
    y = h[e.placement],
    w = y.x,
    x = y.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += w, e.modifiersData.popperOffsets.y += x), e.modifiersData[l] = h;
}
const dX = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: cX
};
function fX(t) {
  var e = t.state,
    i = t.name;
  e.modifiersData[i] = c4({
    reference: e.rects.reference,
    element: e.rects.popper,
    placement: e.placement
  });
}
const pX = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: fX,
  data: {}
};
function hX(t) {
  return t === "x" ? "y" : "x";
}
function mX(t) {
  var e = t.state,
    i = t.options,
    l = t.name,
    c = i.mainAxis,
    p = c === void 0 ? !0 : c,
    h = i.altAxis,
    y = h === void 0 ? !1 : h,
    w = i.boundary,
    x = i.rootBoundary,
    E = i.altBoundary,
    C = i.padding,
    k = i.tether,
    D = k === void 0 ? !0 : k,
    I = i.tetherOffset,
    O = I === void 0 ? 0 : I,
    P = lR(e, {
      boundary: w,
      rootBoundary: x,
      padding: C,
      altBoundary: E
    }),
    N = Gv(e.placement),
    L = kE(e.placement),
    F = !L,
    j = bN(N),
    V = hX(j),
    K = e.modifiersData.popperOffsets,
    G = e.rects.reference,
    Q = e.rects.popper,
    te = typeof O == "function" ? O(Object.assign({}, e.rects, {
      placement: e.placement
    })) : O,
    ie = typeof te == "number" ? {
      mainAxis: te,
      altAxis: te
    } : Object.assign({
      mainAxis: 0,
      altAxis: 0
    }, te),
    Y = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null,
    ee = {
      x: 0,
      y: 0
    };
  if (K) {
    if (p) {
      var oe,
        ne = j === "y" ? cd : dd,
        se = j === "y" ? Hp : $p,
        ue = j === "y" ? "height" : "width",
        W = K[j],
        $ = W + P[ne],
        le = W - P[se],
        H = D ? -Q[ue] / 2 : 0,
        ce = L === SE ? G[ue] : Q[ue],
        de = L === SE ? -Q[ue] : -G[ue],
        Ce = e.elements.arrow,
        Ee = D && Ce ? yN(Ce) : {
          width: 0,
          height: 0
        },
        fe = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : o4(),
        xe = fe[ne],
        we = fe[se],
        ve = UT(0, G[ue], Ee[ue]),
        Te = F ? G[ue] / 2 - H - ve - xe - ie.mainAxis : ce - ve - xe - ie.mainAxis,
        ze = F ? -G[ue] / 2 + H + ve + we + ie.mainAxis : de + ve + we + ie.mainAxis,
        Xe = e.elements.arrow && UR(e.elements.arrow),
        ye = Xe ? j === "y" ? Xe.clientTop || 0 : Xe.clientLeft || 0 : 0,
        qe = (oe = Y == null ? void 0 : Y[j]) != null ? oe : 0,
        Ae = W + Te - qe - ye,
        Mt = W + ze - qe,
        Ft = UT(D ? yO($, Ae) : $, W, D ? Yx(le, Mt) : le);
      K[j] = Ft, ee[j] = Ft - W;
    }
    if (y) {
      var un,
        gt = j === "x" ? cd : dd,
        Pt = j === "x" ? Hp : $p,
        St = K[V],
        Dt = V === "y" ? "height" : "width",
        Kt = St + P[gt],
        hn = St - P[Pt],
        Ot = [cd, dd].indexOf(N) !== -1,
        Et = (un = Y == null ? void 0 : Y[V]) != null ? un : 0,
        Vt = Ot ? Kt : St - G[Dt] - Q[Dt] - Et + ie.altAxis,
        Xt = Ot ? St + G[Dt] + Q[Dt] - Et - ie.altAxis : hn,
        vn = D && Ot ? zG(Vt, St, Xt) : UT(D ? Vt : Kt, St, D ? Xt : hn);
      K[V] = vn, ee[V] = vn - St;
    }
    e.modifiersData[l] = ee;
  }
}
const vX = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: mX,
  requiresIfExists: ["offset"]
};
function gX(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function yX(t) {
  return t === lp(t) || !Vp(t) ? wN(t) : gX(t);
}
function bX(t) {
  var e = t.getBoundingClientRect(),
    i = EE(e.width) / t.offsetWidth || 1,
    l = EE(e.height) / t.offsetHeight || 1;
  return i !== 1 || l !== 1;
}
function wX(t, e, i) {
  i === void 0 && (i = !1);
  var l = Vp(e),
    c = Vp(e) && bX(e),
    p = sw(e),
    h = CE(t, c, i),
    y = {
      scrollLeft: 0,
      scrollTop: 0
    },
    w = {
      x: 0,
      y: 0
    };
  return (l || !l && !i) && ((Zv(e) !== "body" ||
  // https://github.com/popperjs/popper-core/issues/1078
  xN(p)) && (y = yX(e)), Vp(e) ? (w = CE(e, !0), w.x += e.clientLeft, w.y += e.clientTop) : p && (w.x = _N(p))), {
    x: h.left + y.scrollLeft - w.x,
    y: h.top + y.scrollTop - w.y,
    width: h.width,
    height: h.height
  };
}
function _X(t) {
  var e = /* @__PURE__ */new Map(),
    i = /* @__PURE__ */new Set(),
    l = [];
  t.forEach(function (p) {
    e.set(p.name, p);
  });
  function c(p) {
    i.add(p.name);
    var h = [].concat(p.requires || [], p.requiresIfExists || []);
    h.forEach(function (y) {
      if (!i.has(y)) {
        var w = e.get(y);
        w && c(w);
      }
    }), l.push(p);
  }
  return t.forEach(function (p) {
    i.has(p.name) || c(p);
  }), l;
}
function xX(t) {
  var e = _X(t);
  return PG.reduce(function (i, l) {
    return i.concat(e.filter(function (c) {
      return c.phase === l;
    }));
  }, []);
}
function SX(t) {
  var e;
  return function () {
    return e || (e = new Promise(function (i) {
      Promise.resolve().then(function () {
        e = void 0, i(t());
      });
    })), e;
  };
}
function EX(t) {
  var e = t.reduce(function (i, l) {
    var c = i[l.name];
    return i[l.name] = c ? Object.assign({}, c, l, {
      options: Object.assign({}, c.options, l.options),
      data: Object.assign({}, c.data, l.data)
    }) : l, i;
  }, {});
  return Object.keys(e).map(function (i) {
    return e[i];
  });
}
var NV = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function zV() {
  for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
  return !e.some(function (l) {
    return !(l && typeof l.getBoundingClientRect == "function");
  });
}
function CX(t) {
  t === void 0 && (t = {});
  var e = t,
    i = e.defaultModifiers,
    l = i === void 0 ? [] : i,
    c = e.defaultOptions,
    p = c === void 0 ? NV : c;
  return function (h, y, w) {
    w === void 0 && (w = p);
    var x = {
        placement: "bottom",
        orderedModifiers: [],
        options: Object.assign({}, NV, p),
        modifiersData: {},
        elements: {
          reference: h,
          popper: y
        },
        attributes: {},
        styles: {}
      },
      E = [],
      C = !1,
      k = {
        state: x,
        setOptions: function (O) {
          var P = typeof O == "function" ? O(x.options) : O;
          I(), x.options = Object.assign({}, p, x.options, P), x.scrollParents = {
            reference: Jx(h) ? HT(h) : h.contextElement ? HT(h.contextElement) : [],
            popper: HT(y)
          };
          var N = xX(EX([].concat(l, x.options.modifiers)));
          return x.orderedModifiers = N.filter(function (L) {
            return L.enabled;
          }), D(), k.update();
        },
        // Sync update – it will always be executed, even if not necessary. This
        // is useful for low frequency updates where sync behavior simplifies the
        // logic.
        // For high frequency updates (e.g. `resize` and `scroll` events), always
        // prefer the async Popper#update method
        forceUpdate: function () {
          if (!C) {
            var O = x.elements,
              P = O.reference,
              N = O.popper;
            if (zV(P, N)) {
              x.rects = {
                reference: wX(P, UR(N), x.options.strategy === "fixed"),
                popper: yN(N)
              }, x.reset = !1, x.placement = x.options.placement, x.orderedModifiers.forEach(function (Q) {
                return x.modifiersData[Q.name] = Object.assign({}, Q.data);
              });
              for (var L = 0; L < x.orderedModifiers.length; L++) {
                if (x.reset === !0) {
                  x.reset = !1, L = -1;
                  continue;
                }
                var F = x.orderedModifiers[L],
                  j = F.fn,
                  V = F.options,
                  K = V === void 0 ? {} : V,
                  G = F.name;
                typeof j == "function" && (x = j({
                  state: x,
                  options: K,
                  name: G,
                  instance: k
                }) || x);
              }
            }
          }
        },
        // Async and optimistically optimized update – it will not be executed if
        // not necessary (debounced to run at most once-per-tick)
        update: SX(function () {
          return new Promise(function (O) {
            k.forceUpdate(), O(x);
          });
        }),
        destroy: function () {
          I(), C = !0;
        }
      };
    if (!zV(h, y)) return k;
    k.setOptions(w).then(function (O) {
      !C && w.onFirstUpdate && w.onFirstUpdate(O);
    });
    function D() {
      x.orderedModifiers.forEach(function (O) {
        var P = O.name,
          N = O.options,
          L = N === void 0 ? {} : N,
          F = O.effect;
        if (typeof F == "function") {
          var j = F({
              state: x,
              name: P,
              instance: k,
              options: L
            }),
            V = function () {};
          E.push(j || V);
        }
      });
    }
    function I() {
      E.forEach(function (O) {
        return O();
      }), E = [];
    }
    return k;
  };
}
var kX = [XG, pX, YG, r4, dX, oX, vX, HG, lX],
  TX = /* @__PURE__ */CX({
    defaultModifiers: kX
  }),
  RX = "tippy-box",
  d4 = "tippy-content",
  DX = "tippy-backdrop",
  f4 = "tippy-arrow",
  p4 = "tippy-svg-arrow",
  Vx = {
    passive: !0,
    capture: !0
  },
  h4 = function () {
    return document.body;
  };
function IX(t, e) {
  return {}.hasOwnProperty.call(t, e);
}
function g2(t, e, i) {
  if (Array.isArray(t)) {
    var l = t[e];
    return l ?? (Array.isArray(i) ? i[e] : i);
  }
  return t;
}
function SN(t, e) {
  var i = {}.toString.call(t);
  return i.indexOf("[object") === 0 && i.indexOf(e + "]") > -1;
}
function m4(t, e) {
  return typeof t == "function" ? t.apply(void 0, e) : t;
}
function VV(t, e) {
  if (e === 0) return t;
  var i;
  return function (l) {
    clearTimeout(i), i = setTimeout(function () {
      t(l);
    }, e);
  };
}
function MX(t, e) {
  var i = Object.assign({}, t);
  return e.forEach(function (l) {
    delete i[l];
  }), i;
}
function OX(t) {
  return t.split(/\s+/).filter(Boolean);
}
function rE(t) {
  return [].concat(t);
}
function BV(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function LX(t) {
  return t.filter(function (e, i) {
    return t.indexOf(e) === i;
  });
}
function PX(t) {
  return t.split("-")[0];
}
function bO(t) {
  return [].slice.call(t);
}
function UV(t) {
  return Object.keys(t).reduce(function (e, i) {
    return t[i] !== void 0 && (e[i] = t[i]), e;
  }, {});
}
function $T() {
  return document.createElement("div");
}
function uR(t) {
  return ["Element", "Fragment"].some(function (e) {
    return SN(t, e);
  });
}
function AX(t) {
  return SN(t, "NodeList");
}
function jX(t) {
  return SN(t, "MouseEvent");
}
function FX(t) {
  return !!(t && t._tippy && t._tippy.reference === t);
}
function NX(t) {
  return uR(t) ? [t] : AX(t) ? bO(t) : Array.isArray(t) ? t : bO(document.querySelectorAll(t));
}
function y2(t, e) {
  t.forEach(function (i) {
    i && (i.style.transitionDuration = e + "ms");
  });
}
function HV(t, e) {
  t.forEach(function (i) {
    i && i.setAttribute("data-state", e);
  });
}
function zX(t) {
  var e,
    i = rE(t),
    l = i[0];
  return l != null && (e = l.ownerDocument) != null && e.body ? l.ownerDocument : document;
}
function VX(t, e) {
  var i = e.clientX,
    l = e.clientY;
  return t.every(function (c) {
    var p = c.popperRect,
      h = c.popperState,
      y = c.props,
      w = y.interactiveBorder,
      x = PX(h.placement),
      E = h.modifiersData.offset;
    if (!E) return !0;
    var C = x === "bottom" ? E.top.y : 0,
      k = x === "top" ? E.bottom.y : 0,
      D = x === "right" ? E.left.x : 0,
      I = x === "left" ? E.right.x : 0,
      O = p.top - l + C > w,
      P = l - p.bottom - k > w,
      N = p.left - i + D > w,
      L = i - p.right - I > w;
    return O || P || N || L;
  });
}
function b2(t, e, i) {
  var l = e + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function (c) {
    t[l](c, i);
  });
}
function $V(t, e) {
  for (var i = e; i;) {
    var l;
    if (t.contains(i)) return !0;
    i = i.getRootNode == null || (l = i.getRootNode()) == null ? void 0 : l.host;
  }
  return !1;
}
var Wv = {
    isTouch: !1
  },
  WV = 0;
function BX() {
  Wv.isTouch || (Wv.isTouch = !0, window.performance && document.addEventListener("mousemove", v4));
}
function v4() {
  var t = performance.now();
  t - WV < 20 && (Wv.isTouch = !1, document.removeEventListener("mousemove", v4)), WV = t;
}
function UX() {
  var t = document.activeElement;
  if (FX(t)) {
    var e = t._tippy;
    t.blur && !e.state.isVisible && t.blur();
  }
}
function HX() {
  document.addEventListener("touchstart", BX, Vx), window.addEventListener("blur", UX);
}
var $X = typeof window < "u" && typeof document < "u",
  WX = $X ?
  // @ts-ignore
  !!window.msCrypto : !1;
function Y1(t) {
  var e = t === "destroy" ? "n already-" : " ";
  return [t + "() was called on a" + e + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function qV(t) {
  var e = /[ \t]{2,}/g,
    i = /^[ \t]*/gm;
  return t.replace(e, " ").replace(i, "").trim();
}
function qX(t) {
  return qV(`
  %ctippy.js

  %c` + qV(t) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function g4(t) {
  return [qX(t),
  // title
  "color: #00C584; font-size: 1.3em; font-weight: bold;",
  // message
  "line-height: 1.5",
  // footer
  "color: #a6a095;"];
}
var cR;
process.env.NODE_ENV !== "production" && YX();
function YX() {
  cR = /* @__PURE__ */new Set();
}
function cb(t, e) {
  if (t && !cR.has(e)) {
    var i;
    cR.add(e), (i = console).warn.apply(i, g4(e));
  }
}
function Pj(t, e) {
  if (t && !cR.has(e)) {
    var i;
    cR.add(e), (i = console).error.apply(i, g4(e));
  }
}
function GX(t) {
  var e = !t,
    i = Object.prototype.toString.call(t) === "[object Object]" && !t.addEventListener;
  Pj(e, ["tippy() was passed", "`" + String(t) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), Pj(i, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var y4 = {
    animateFill: !1,
    followCursor: !1,
    inlinePositioning: !1,
    sticky: !1
  },
  XX = {
    allowHTML: !1,
    animation: "fade",
    arrow: !0,
    content: "",
    inertia: !1,
    maxWidth: 350,
    role: "tooltip",
    theme: "",
    zIndex: 9999
  },
  ap = Object.assign({
    appendTo: h4,
    aria: {
      content: "auto",
      expanded: "auto"
    },
    delay: 0,
    duration: [300, 250],
    getReferenceClientRect: null,
    hideOnClick: !0,
    ignoreAttributes: !1,
    interactive: !1,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: "",
    offset: [0, 10],
    onAfterUpdate: function () {},
    onBeforeUpdate: function () {},
    onCreate: function () {},
    onDestroy: function () {},
    onHidden: function () {},
    onHide: function () {},
    onMount: function () {},
    onShow: function () {},
    onShown: function () {},
    onTrigger: function () {},
    onUntrigger: function () {},
    onClickOutside: function () {},
    placement: "top",
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: !1,
    touch: !0,
    trigger: "mouseenter focus",
    triggerTarget: null
  }, y4, XX),
  KX = Object.keys(ap),
  QX = function (t) {
    process.env.NODE_ENV !== "production" && w4(t, []);
    var e = Object.keys(t);
    e.forEach(function (i) {
      ap[i] = t[i];
    });
  };
function b4(t) {
  var e = t.plugins || [],
    i = e.reduce(function (l, c) {
      var p = c.name,
        h = c.defaultValue;
      if (p) {
        var y;
        l[p] = t[p] !== void 0 ? t[p] : (y = ap[p]) != null ? y : h;
      }
      return l;
    }, {});
  return Object.assign({}, t, i);
}
function ZX(t, e) {
  var i = e ? Object.keys(b4(Object.assign({}, ap, {
      plugins: e
    }))) : KX,
    l = i.reduce(function (c, p) {
      var h = (t.getAttribute("data-tippy-" + p) || "").trim();
      if (!h) return c;
      if (p === "content") c[p] = h;else try {
        c[p] = JSON.parse(h);
      } catch {
        c[p] = h;
      }
      return c;
    }, {});
  return l;
}
function YV(t, e) {
  var i = Object.assign({}, e, {
    content: m4(e.content, [t])
  }, e.ignoreAttributes ? {} : ZX(t, e.plugins));
  return i.aria = Object.assign({}, ap.aria, i.aria), i.aria = {
    expanded: i.aria.expanded === "auto" ? e.interactive : i.aria.expanded,
    content: i.aria.content === "auto" ? e.interactive ? null : "describedby" : i.aria.content
  }, i;
}
function w4(t, e) {
  t === void 0 && (t = {}), e === void 0 && (e = []);
  var i = Object.keys(t);
  i.forEach(function (l) {
    var c = MX(ap, Object.keys(y4)),
      p = !IX(c, l);
    p && (p = e.filter(function (h) {
      return h.name === l;
    }).length === 0), cb(p, ["`" + l + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var JX = function () {
  return "innerHTML";
};
function Aj(t, e) {
  t[JX()] = e;
}
function GV(t) {
  var e = $T();
  return t === !0 ? e.className = f4 : (e.className = p4, uR(t) ? e.appendChild(t) : Aj(e, t)), e;
}
function XV(t, e) {
  uR(e.content) ? (Aj(t, ""), t.appendChild(e.content)) : typeof e.content != "function" && (e.allowHTML ? Aj(t, e.content) : t.textContent = e.content);
}
function jj(t) {
  var e = t.firstElementChild,
    i = bO(e.children);
  return {
    box: e,
    content: i.find(function (l) {
      return l.classList.contains(d4);
    }),
    arrow: i.find(function (l) {
      return l.classList.contains(f4) || l.classList.contains(p4);
    }),
    backdrop: i.find(function (l) {
      return l.classList.contains(DX);
    })
  };
}
function _4(t) {
  var e = $T(),
    i = $T();
  i.className = RX, i.setAttribute("data-state", "hidden"), i.setAttribute("tabindex", "-1");
  var l = $T();
  l.className = d4, l.setAttribute("data-state", "hidden"), XV(l, t.props), e.appendChild(i), i.appendChild(l), c(t.props, t.props);
  function c(p, h) {
    var y = jj(e),
      w = y.box,
      x = y.content,
      E = y.arrow;
    h.theme ? w.setAttribute("data-theme", h.theme) : w.removeAttribute("data-theme"), typeof h.animation == "string" ? w.setAttribute("data-animation", h.animation) : w.removeAttribute("data-animation"), h.inertia ? w.setAttribute("data-inertia", "") : w.removeAttribute("data-inertia"), w.style.maxWidth = typeof h.maxWidth == "number" ? h.maxWidth + "px" : h.maxWidth, h.role ? w.setAttribute("role", h.role) : w.removeAttribute("role"), (p.content !== h.content || p.allowHTML !== h.allowHTML) && XV(x, t.props), h.arrow ? E ? p.arrow !== h.arrow && (w.removeChild(E), w.appendChild(GV(h.arrow))) : w.appendChild(GV(h.arrow)) : E && w.removeChild(E);
  }
  return {
    popper: e,
    onUpdate: c
  };
}
_4.$$tippy = !0;
var eK = 1,
  dM = [],
  w2 = [];
function tK(t, e) {
  var i = YV(t, Object.assign({}, ap, b4(UV(e)))),
    l,
    c,
    p,
    h = !1,
    y = !1,
    w = !1,
    x = !1,
    E,
    C,
    k,
    D = [],
    I = VV(Ae, i.interactiveDebounce),
    O,
    P = eK++,
    N = null,
    L = LX(i.plugins),
    F = {
      // Is the instance currently enabled?
      isEnabled: !0,
      // Is the tippy currently showing and not transitioning out?
      isVisible: !1,
      // Has the instance been destroyed?
      isDestroyed: !1,
      // Is the tippy currently mounted to the DOM?
      isMounted: !1,
      // Has the tippy finished transitioning in?
      isShown: !1
    },
    j = {
      // properties
      id: P,
      reference: t,
      popper: $T(),
      popperInstance: N,
      props: i,
      state: F,
      plugins: L,
      // methods
      clearDelayTimeouts: Vt,
      setProps: Xt,
      setContent: vn,
      show: ot,
      hide: We,
      hideWithInteractivity: ht,
      enable: Ot,
      disable: Et,
      unmount: Ke,
      destroy: yt
    };
  if (!i.render) return process.env.NODE_ENV !== "production" && Pj(!0, "render() function has not been supplied."), j;
  var V = i.render(j),
    K = V.popper,
    G = V.onUpdate;
  K.setAttribute("data-tippy-root", ""), K.id = "tippy-" + j.id, j.popper = K, t._tippy = j, K._tippy = j;
  var Q = L.map(function (je) {
      return je.fn(j);
    }),
    te = t.hasAttribute("aria-expanded");
  return Xe(), H(), W(), $("onCreate", [j]), i.showOnCreate && Kt(), K.addEventListener("mouseenter", function () {
    j.props.interactive && j.state.isVisible && j.clearDelayTimeouts();
  }), K.addEventListener("mouseleave", function () {
    j.props.interactive && j.props.trigger.indexOf("mouseenter") >= 0 && ne().addEventListener("mousemove", I);
  }), j;
  function ie() {
    var je = j.props.touch;
    return Array.isArray(je) ? je : [je, 0];
  }
  function Y() {
    return ie()[0] === "hold";
  }
  function ee() {
    var je;
    return !!((je = j.props.render) != null && je.$$tippy);
  }
  function oe() {
    return O || t;
  }
  function ne() {
    var je = oe().parentNode;
    return je ? zX(je) : document;
  }
  function se() {
    return jj(K);
  }
  function ue(je) {
    return j.state.isMounted && !j.state.isVisible || Wv.isTouch || E && E.type === "focus" ? 0 : g2(j.props.delay, je ? 0 : 1, ap.delay);
  }
  function W(je) {
    je === void 0 && (je = !1), K.style.pointerEvents = j.props.interactive && !je ? "" : "none", K.style.zIndex = "" + j.props.zIndex;
  }
  function $(je, at, kt) {
    if (kt === void 0 && (kt = !0), Q.forEach(function (Ht) {
      Ht[je] && Ht[je].apply(Ht, at);
    }), kt) {
      var Bt;
      (Bt = j.props)[je].apply(Bt, at);
    }
  }
  function le() {
    var je = j.props.aria;
    if (je.content) {
      var at = "aria-" + je.content,
        kt = K.id,
        Bt = rE(j.props.triggerTarget || t);
      Bt.forEach(function (Ht) {
        var ln = Ht.getAttribute(at);
        if (j.state.isVisible) Ht.setAttribute(at, ln ? ln + " " + kt : kt);else {
          var en = ln && ln.replace(kt, "").trim();
          en ? Ht.setAttribute(at, en) : Ht.removeAttribute(at);
        }
      });
    }
  }
  function H() {
    if (!(te || !j.props.aria.expanded)) {
      var je = rE(j.props.triggerTarget || t);
      je.forEach(function (at) {
        j.props.interactive ? at.setAttribute("aria-expanded", j.state.isVisible && at === oe() ? "true" : "false") : at.removeAttribute("aria-expanded");
      });
    }
  }
  function ce() {
    ne().removeEventListener("mousemove", I), dM = dM.filter(function (je) {
      return je !== I;
    });
  }
  function de(je) {
    if (!(Wv.isTouch && (w || je.type === "mousedown"))) {
      var at = je.composedPath && je.composedPath()[0] || je.target;
      if (!(j.props.interactive && $V(K, at))) {
        if (rE(j.props.triggerTarget || t).some(function (kt) {
          return $V(kt, at);
        })) {
          if (Wv.isTouch || j.state.isVisible && j.props.trigger.indexOf("click") >= 0) return;
        } else $("onClickOutside", [j, je]);
        j.props.hideOnClick === !0 && (j.clearDelayTimeouts(), j.hide(), y = !0, setTimeout(function () {
          y = !1;
        }), j.state.isMounted || xe());
      }
    }
  }
  function Ce() {
    w = !0;
  }
  function Ee() {
    w = !1;
  }
  function fe() {
    var je = ne();
    je.addEventListener("mousedown", de, !0), je.addEventListener("touchend", de, Vx), je.addEventListener("touchstart", Ee, Vx), je.addEventListener("touchmove", Ce, Vx);
  }
  function xe() {
    var je = ne();
    je.removeEventListener("mousedown", de, !0), je.removeEventListener("touchend", de, Vx), je.removeEventListener("touchstart", Ee, Vx), je.removeEventListener("touchmove", Ce, Vx);
  }
  function we(je, at) {
    Te(je, function () {
      !j.state.isVisible && K.parentNode && K.parentNode.contains(K) && at();
    });
  }
  function ve(je, at) {
    Te(je, at);
  }
  function Te(je, at) {
    var kt = se().box;
    function Bt(Ht) {
      Ht.target === kt && (b2(kt, "remove", Bt), at());
    }
    if (je === 0) return at();
    b2(kt, "remove", C), b2(kt, "add", Bt), C = Bt;
  }
  function ze(je, at, kt) {
    kt === void 0 && (kt = !1);
    var Bt = rE(j.props.triggerTarget || t);
    Bt.forEach(function (Ht) {
      Ht.addEventListener(je, at, kt), D.push({
        node: Ht,
        eventType: je,
        handler: at,
        options: kt
      });
    });
  }
  function Xe() {
    Y() && (ze("touchstart", qe, {
      passive: !0
    }), ze("touchend", Mt, {
      passive: !0
    })), OX(j.props.trigger).forEach(function (je) {
      if (je !== "manual") switch (ze(je, qe), je) {
        case "mouseenter":
          ze("mouseleave", Mt);
          break;
        case "focus":
          ze(WX ? "focusout" : "blur", Ft);
          break;
        case "focusin":
          ze("focusout", Ft);
          break;
      }
    });
  }
  function ye() {
    D.forEach(function (je) {
      var at = je.node,
        kt = je.eventType,
        Bt = je.handler,
        Ht = je.options;
      at.removeEventListener(kt, Bt, Ht);
    }), D = [];
  }
  function qe(je) {
    var at,
      kt = !1;
    if (!(!j.state.isEnabled || un(je) || y)) {
      var Bt = ((at = E) == null ? void 0 : at.type) === "focus";
      E = je, O = je.currentTarget, H(), !j.state.isVisible && jX(je) && dM.forEach(function (Ht) {
        return Ht(je);
      }), je.type === "click" && (j.props.trigger.indexOf("mouseenter") < 0 || h) && j.props.hideOnClick !== !1 && j.state.isVisible ? kt = !0 : Kt(je), je.type === "click" && (h = !kt), kt && !Bt && hn(je);
    }
  }
  function Ae(je) {
    var at = je.target,
      kt = oe().contains(at) || K.contains(at);
    if (!(je.type === "mousemove" && kt)) {
      var Bt = Dt().concat(K).map(function (Ht) {
        var ln,
          en = Ht._tippy,
          Rr = (ln = en.popperInstance) == null ? void 0 : ln.state;
        return Rr ? {
          popperRect: Ht.getBoundingClientRect(),
          popperState: Rr,
          props: i
        } : null;
      }).filter(Boolean);
      VX(Bt, je) && (ce(), hn(je));
    }
  }
  function Mt(je) {
    var at = un(je) || j.props.trigger.indexOf("click") >= 0 && h;
    if (!at) {
      if (j.props.interactive) {
        j.hideWithInteractivity(je);
        return;
      }
      hn(je);
    }
  }
  function Ft(je) {
    j.props.trigger.indexOf("focusin") < 0 && je.target !== oe() || j.props.interactive && je.relatedTarget && K.contains(je.relatedTarget) || hn(je);
  }
  function un(je) {
    return Wv.isTouch ? Y() !== je.type.indexOf("touch") >= 0 : !1;
  }
  function gt() {
    Pt();
    var je = j.props,
      at = je.popperOptions,
      kt = je.placement,
      Bt = je.offset,
      Ht = je.getReferenceClientRect,
      ln = je.moveTransition,
      en = ee() ? jj(K).arrow : null,
      Rr = Ht ? {
        getBoundingClientRect: Ht,
        contextElement: Ht.contextElement || oe()
      } : t,
      Nr = {
        name: "$$tippy",
        enabled: !0,
        phase: "beforeWrite",
        requires: ["computeStyles"],
        fn: function (ll) {
          var yo = ll.state;
          if (ee()) {
            var _l = se(),
              Mo = _l.box;
            ["placement", "reference-hidden", "escaped"].forEach(function (bo) {
              bo === "placement" ? Mo.setAttribute("data-placement", yo.placement) : yo.attributes.popper["data-popper-" + bo] ? Mo.setAttribute("data-" + bo, "") : Mo.removeAttribute("data-" + bo);
            }), yo.attributes.popper = {};
          }
        }
      },
      Hi = [{
        name: "offset",
        options: {
          offset: Bt
        }
      }, {
        name: "preventOverflow",
        options: {
          padding: {
            top: 2,
            bottom: 2,
            left: 5,
            right: 5
          }
        }
      }, {
        name: "flip",
        options: {
          padding: 5
        }
      }, {
        name: "computeStyles",
        options: {
          adaptive: !ln
        }
      }, Nr];
    ee() && en && Hi.push({
      name: "arrow",
      options: {
        element: en,
        padding: 3
      }
    }), Hi.push.apply(Hi, (at == null ? void 0 : at.modifiers) || []), j.popperInstance = TX(Rr, K, Object.assign({}, at, {
      placement: kt,
      onFirstUpdate: k,
      modifiers: Hi
    }));
  }
  function Pt() {
    j.popperInstance && (j.popperInstance.destroy(), j.popperInstance = null);
  }
  function St() {
    var je = j.props.appendTo,
      at,
      kt = oe();
    j.props.interactive && je === h4 || je === "parent" ? at = kt.parentNode : at = m4(je, [kt]), at.contains(K) || at.appendChild(K), j.state.isMounted = !0, gt(), process.env.NODE_ENV !== "production" && cb(j.props.interactive && je === ap.appendTo && kt.nextElementSibling !== K, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function Dt() {
    return bO(K.querySelectorAll("[data-tippy-root]"));
  }
  function Kt(je) {
    j.clearDelayTimeouts(), je && $("onTrigger", [j, je]), fe();
    var at = ue(!0),
      kt = ie(),
      Bt = kt[0],
      Ht = kt[1];
    Wv.isTouch && Bt === "hold" && Ht && (at = Ht), at ? l = setTimeout(function () {
      j.show();
    }, at) : j.show();
  }
  function hn(je) {
    if (j.clearDelayTimeouts(), $("onUntrigger", [j, je]), !j.state.isVisible) {
      xe();
      return;
    }
    if (!(j.props.trigger.indexOf("mouseenter") >= 0 && j.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(je.type) >= 0 && h)) {
      var at = ue(!1);
      at ? c = setTimeout(function () {
        j.state.isVisible && j.hide();
      }, at) : p = requestAnimationFrame(function () {
        j.hide();
      });
    }
  }
  function Ot() {
    j.state.isEnabled = !0;
  }
  function Et() {
    j.hide(), j.state.isEnabled = !1;
  }
  function Vt() {
    clearTimeout(l), clearTimeout(c), cancelAnimationFrame(p);
  }
  function Xt(je) {
    if (process.env.NODE_ENV !== "production" && cb(j.state.isDestroyed, Y1("setProps")), !j.state.isDestroyed) {
      $("onBeforeUpdate", [j, je]), ye();
      var at = j.props,
        kt = YV(t, Object.assign({}, at, UV(je), {
          ignoreAttributes: !0
        }));
      j.props = kt, Xe(), at.interactiveDebounce !== kt.interactiveDebounce && (ce(), I = VV(Ae, kt.interactiveDebounce)), at.triggerTarget && !kt.triggerTarget ? rE(at.triggerTarget).forEach(function (Bt) {
        Bt.removeAttribute("aria-expanded");
      }) : kt.triggerTarget && t.removeAttribute("aria-expanded"), H(), W(), G && G(at, kt), j.popperInstance && (gt(), Dt().forEach(function (Bt) {
        requestAnimationFrame(Bt._tippy.popperInstance.forceUpdate);
      })), $("onAfterUpdate", [j, je]);
    }
  }
  function vn(je) {
    j.setProps({
      content: je
    });
  }
  function ot() {
    process.env.NODE_ENV !== "production" && cb(j.state.isDestroyed, Y1("show"));
    var je = j.state.isVisible,
      at = j.state.isDestroyed,
      kt = !j.state.isEnabled,
      Bt = Wv.isTouch && !j.props.touch,
      Ht = g2(j.props.duration, 0, ap.duration);
    if (!(je || at || kt || Bt) && !oe().hasAttribute("disabled") && ($("onShow", [j], !1), j.props.onShow(j) !== !1)) {
      if (j.state.isVisible = !0, ee() && (K.style.visibility = "visible"), W(), fe(), j.state.isMounted || (K.style.transition = "none"), ee()) {
        var ln = se(),
          en = ln.box,
          Rr = ln.content;
        y2([en, Rr], 0);
      }
      k = function () {
        var Nr;
        if (!(!j.state.isVisible || x)) {
          if (x = !0, K.offsetHeight, K.style.transition = j.props.moveTransition, ee() && j.props.animation) {
            var Hi = se(),
              ll = Hi.box,
              yo = Hi.content;
            y2([ll, yo], Ht), HV([ll, yo], "visible");
          }
          le(), H(), BV(w2, j), (Nr = j.popperInstance) == null || Nr.forceUpdate(), $("onMount", [j]), j.props.animation && ee() && ve(Ht, function () {
            j.state.isShown = !0, $("onShown", [j]);
          });
        }
      }, St();
    }
  }
  function We() {
    process.env.NODE_ENV !== "production" && cb(j.state.isDestroyed, Y1("hide"));
    var je = !j.state.isVisible,
      at = j.state.isDestroyed,
      kt = !j.state.isEnabled,
      Bt = g2(j.props.duration, 1, ap.duration);
    if (!(je || at || kt) && ($("onHide", [j], !1), j.props.onHide(j) !== !1)) {
      if (j.state.isVisible = !1, j.state.isShown = !1, x = !1, h = !1, ee() && (K.style.visibility = "hidden"), ce(), xe(), W(!0), ee()) {
        var Ht = se(),
          ln = Ht.box,
          en = Ht.content;
        j.props.animation && (y2([ln, en], Bt), HV([ln, en], "hidden"));
      }
      le(), H(), j.props.animation ? ee() && we(Bt, j.unmount) : j.unmount();
    }
  }
  function ht(je) {
    process.env.NODE_ENV !== "production" && cb(j.state.isDestroyed, Y1("hideWithInteractivity")), ne().addEventListener("mousemove", I), BV(dM, I), I(je);
  }
  function Ke() {
    process.env.NODE_ENV !== "production" && cb(j.state.isDestroyed, Y1("unmount")), j.state.isVisible && j.hide(), j.state.isMounted && (Pt(), Dt().forEach(function (je) {
      je._tippy.unmount();
    }), K.parentNode && K.parentNode.removeChild(K), w2 = w2.filter(function (je) {
      return je !== j;
    }), j.state.isMounted = !1, $("onHidden", [j]));
  }
  function yt() {
    process.env.NODE_ENV !== "production" && cb(j.state.isDestroyed, Y1("destroy")), !j.state.isDestroyed && (j.clearDelayTimeouts(), j.unmount(), ye(), delete t._tippy, j.state.isDestroyed = !0, $("onDestroy", [j]));
  }
}
function HR(t, e) {
  e === void 0 && (e = {});
  var i = ap.plugins.concat(e.plugins || []);
  process.env.NODE_ENV !== "production" && (GX(t), w4(e, i)), HX();
  var l = Object.assign({}, e, {
      plugins: i
    }),
    c = NX(t);
  if (process.env.NODE_ENV !== "production") {
    var p = uR(l.content),
      h = c.length > 1;
    cb(p && h, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var y = c.reduce(function (w, x) {
    var E = x && tK(x, l);
    return E && w.push(E), w;
  }, []);
  return uR(t) ? y[0] : y;
}
HR.defaultProps = ap;
HR.setDefaultProps = QX;
HR.currentInput = Wv;
Object.assign({}, r4, {
  effect: function (t) {
    var e = t.state,
      i = {
        popper: {
          position: e.options.strategy,
          left: "0",
          top: "0",
          margin: "0"
        },
        arrow: {
          position: "absolute"
        },
        reference: {}
      };
    Object.assign(e.elements.popper.style, i.popper), e.styles = i, e.elements.arrow && Object.assign(e.elements.arrow.style, i.arrow);
  }
});
HR.setDefaultProps({
  render: _4
});
var fM = {
    exports: {}
  },
  Qc = {},
  _2 = {
    exports: {}
  },
  KV = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var QV;
function nK() {
  return QV || (QV = 1, function (t) {
    function e($, le) {
      var H = $.length;
      $.push(le);
      e: for (; 0 < H;) {
        var ce = H - 1 >>> 1,
          de = $[ce];
        if (0 < c(de, le)) $[ce] = le, $[H] = de, H = ce;else break e;
      }
    }
    function i($) {
      return $.length === 0 ? null : $[0];
    }
    function l($) {
      if ($.length === 0) return null;
      var le = $[0],
        H = $.pop();
      if (H !== le) {
        $[0] = H;
        e: for (var ce = 0, de = $.length, Ce = de >>> 1; ce < Ce;) {
          var Ee = 2 * (ce + 1) - 1,
            fe = $[Ee],
            xe = Ee + 1,
            we = $[xe];
          if (0 > c(fe, H)) xe < de && 0 > c(we, fe) ? ($[ce] = we, $[xe] = H, ce = xe) : ($[ce] = fe, $[Ee] = H, ce = Ee);else if (xe < de && 0 > c(we, H)) $[ce] = we, $[xe] = H, ce = xe;else break e;
        }
      }
      return le;
    }
    function c($, le) {
      var H = $.sortIndex - le.sortIndex;
      return H !== 0 ? H : $.id - le.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var p = performance;
      t.unstable_now = function () {
        return p.now();
      };
    } else {
      var h = Date,
        y = h.now();
      t.unstable_now = function () {
        return h.now() - y;
      };
    }
    var w = [],
      x = [],
      E = 1,
      C = null,
      k = 3,
      D = !1,
      I = !1,
      O = !1,
      P = typeof setTimeout == "function" ? setTimeout : null,
      N = typeof clearTimeout == "function" ? clearTimeout : null,
      L = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function F($) {
      for (var le = i(x); le !== null;) {
        if (le.callback === null) l(x);else if (le.startTime <= $) l(x), le.sortIndex = le.expirationTime, e(w, le);else break;
        le = i(x);
      }
    }
    function j($) {
      if (O = !1, F($), !I) if (i(w) !== null) I = !0, ue(V);else {
        var le = i(x);
        le !== null && W(j, le.startTime - $);
      }
    }
    function V($, le) {
      I = !1, O && (O = !1, N(Q), Q = -1), D = !0;
      var H = k;
      try {
        for (F(le), C = i(w); C !== null && (!(C.expirationTime > le) || $ && !Y());) {
          var ce = C.callback;
          if (typeof ce == "function") {
            C.callback = null, k = C.priorityLevel;
            var de = ce(C.expirationTime <= le);
            le = t.unstable_now(), typeof de == "function" ? C.callback = de : C === i(w) && l(w), F(le);
          } else l(w);
          C = i(w);
        }
        if (C !== null) var Ce = !0;else {
          var Ee = i(x);
          Ee !== null && W(j, Ee.startTime - le), Ce = !1;
        }
        return Ce;
      } finally {
        C = null, k = H, D = !1;
      }
    }
    var K = !1,
      G = null,
      Q = -1,
      te = 5,
      ie = -1;
    function Y() {
      return !(t.unstable_now() - ie < te);
    }
    function ee() {
      if (G !== null) {
        var $ = t.unstable_now();
        ie = $;
        var le = !0;
        try {
          le = G(!0, $);
        } finally {
          le ? oe() : (K = !1, G = null);
        }
      } else K = !1;
    }
    var oe;
    if (typeof L == "function") oe = function () {
      L(ee);
    };else if (typeof MessageChannel < "u") {
      var ne = new MessageChannel(),
        se = ne.port2;
      ne.port1.onmessage = ee, oe = function () {
        se.postMessage(null);
      };
    } else oe = function () {
      P(ee, 0);
    };
    function ue($) {
      G = $, K || (K = !0, oe());
    }
    function W($, le) {
      Q = P(function () {
        $(t.unstable_now());
      }, le);
    }
    t.unstable_IdlePriority = 5, t.unstable_ImmediatePriority = 1, t.unstable_LowPriority = 4, t.unstable_NormalPriority = 3, t.unstable_Profiling = null, t.unstable_UserBlockingPriority = 2, t.unstable_cancelCallback = function ($) {
      $.callback = null;
    }, t.unstable_continueExecution = function () {
      I || D || (I = !0, ue(V));
    }, t.unstable_forceFrameRate = function ($) {
      0 > $ || 125 < $ ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : te = 0 < $ ? Math.floor(1e3 / $) : 5;
    }, t.unstable_getCurrentPriorityLevel = function () {
      return k;
    }, t.unstable_getFirstCallbackNode = function () {
      return i(w);
    }, t.unstable_next = function ($) {
      switch (k) {
        case 1:
        case 2:
        case 3:
          var le = 3;
          break;
        default:
          le = k;
      }
      var H = k;
      k = le;
      try {
        return $();
      } finally {
        k = H;
      }
    }, t.unstable_pauseExecution = function () {}, t.unstable_requestPaint = function () {}, t.unstable_runWithPriority = function ($, le) {
      switch ($) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          $ = 3;
      }
      var H = k;
      k = $;
      try {
        return le();
      } finally {
        k = H;
      }
    }, t.unstable_scheduleCallback = function ($, le, H) {
      var ce = t.unstable_now();
      switch (typeof H == "object" && H !== null ? (H = H.delay, H = typeof H == "number" && 0 < H ? ce + H : ce) : H = ce, $) {
        case 1:
          var de = -1;
          break;
        case 2:
          de = 250;
          break;
        case 5:
          de = 1073741823;
          break;
        case 4:
          de = 1e4;
          break;
        default:
          de = 5e3;
      }
      return de = H + de, $ = {
        id: E++,
        callback: le,
        priorityLevel: $,
        startTime: H,
        expirationTime: de,
        sortIndex: -1
      }, H > ce ? ($.sortIndex = H, e(x, $), i(w) === null && $ === i(x) && (O ? (N(Q), Q = -1) : O = !0, W(j, H - ce))) : ($.sortIndex = de, e(w, $), I || D || (I = !0, ue(V))), $;
    }, t.unstable_shouldYield = Y, t.unstable_wrapCallback = function ($) {
      var le = k;
      return function () {
        var H = k;
        k = le;
        try {
          return $.apply(this, arguments);
        } finally {
          k = H;
        }
      };
    };
  }(KV)), KV;
}
var ZV = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var JV;
function rK() {
  return JV || (JV = 1, function (t) {
    process.env.NODE_ENV !== "production" && function () {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var e = !1,
        i = 5;
      function l(ot, We) {
        var ht = ot.length;
        ot.push(We), h(ot, We, ht);
      }
      function c(ot) {
        return ot.length === 0 ? null : ot[0];
      }
      function p(ot) {
        if (ot.length === 0) return null;
        var We = ot[0],
          ht = ot.pop();
        return ht !== We && (ot[0] = ht, y(ot, ht, 0)), We;
      }
      function h(ot, We, ht) {
        for (var Ke = ht; Ke > 0;) {
          var yt = Ke - 1 >>> 1,
            je = ot[yt];
          if (w(je, We) > 0) ot[yt] = We, ot[Ke] = je, Ke = yt;else return;
        }
      }
      function y(ot, We, ht) {
        for (var Ke = ht, yt = ot.length, je = yt >>> 1; Ke < je;) {
          var at = (Ke + 1) * 2 - 1,
            kt = ot[at],
            Bt = at + 1,
            Ht = ot[Bt];
          if (w(kt, We) < 0) Bt < yt && w(Ht, kt) < 0 ? (ot[Ke] = Ht, ot[Bt] = We, Ke = Bt) : (ot[Ke] = kt, ot[at] = We, Ke = at);else if (Bt < yt && w(Ht, We) < 0) ot[Ke] = Ht, ot[Bt] = We, Ke = Bt;else return;
        }
      }
      function w(ot, We) {
        var ht = ot.sortIndex - We.sortIndex;
        return ht !== 0 ? ht : ot.id - We.id;
      }
      var x = 1,
        E = 2,
        C = 3,
        k = 4,
        D = 5,
        I = typeof performance == "object" && typeof performance.now == "function";
      if (I) {
        var O = performance;
        t.unstable_now = function () {
          return O.now();
        };
      } else {
        var P = Date,
          N = P.now();
        t.unstable_now = function () {
          return P.now() - N;
        };
      }
      var L = 1073741823,
        F = -1,
        j = 250,
        V = 5e3,
        K = 1e4,
        G = L,
        Q = [],
        te = [],
        ie = 1,
        Y = null,
        ee = C,
        oe = !1,
        ne = !1,
        se = !1,
        ue = typeof setTimeout == "function" ? setTimeout : null,
        W = typeof clearTimeout == "function" ? clearTimeout : null,
        $ = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function le(ot) {
        for (var We = c(te); We !== null;) {
          if (We.callback === null) p(te);else if (We.startTime <= ot) p(te), We.sortIndex = We.expirationTime, l(Q, We);else return;
          We = c(te);
        }
      }
      function H(ot) {
        if (se = !1, le(ot), !ne) if (c(Q) !== null) ne = !0, Ot(ce);else {
          var We = c(te);
          We !== null && Et(H, We.startTime - ot);
        }
      }
      function ce(ot, We) {
        ne = !1, se && (se = !1, Vt()), oe = !0;
        var ht = ee;
        try {
          var Ke;
          if (!e) return de(ot, We);
        } finally {
          Y = null, ee = ht, oe = !1;
        }
      }
      function de(ot, We) {
        var ht = We;
        for (le(ht), Y = c(Q); Y !== null && !(Y.expirationTime > ht && (!ot || un()));) {
          var Ke = Y.callback;
          if (typeof Ke == "function") {
            Y.callback = null, ee = Y.priorityLevel;
            var yt = Y.expirationTime <= ht,
              je = Ke(yt);
            ht = t.unstable_now(), typeof je == "function" ? Y.callback = je : Y === c(Q) && p(Q), le(ht);
          } else p(Q);
          Y = c(Q);
        }
        if (Y !== null) return !0;
        var at = c(te);
        return at !== null && Et(H, at.startTime - ht), !1;
      }
      function Ce(ot, We) {
        switch (ot) {
          case x:
          case E:
          case C:
          case k:
          case D:
            break;
          default:
            ot = C;
        }
        var ht = ee;
        ee = ot;
        try {
          return We();
        } finally {
          ee = ht;
        }
      }
      function Ee(ot) {
        var We;
        switch (ee) {
          case x:
          case E:
          case C:
            We = C;
            break;
          default:
            We = ee;
            break;
        }
        var ht = ee;
        ee = We;
        try {
          return ot();
        } finally {
          ee = ht;
        }
      }
      function fe(ot) {
        var We = ee;
        return function () {
          var ht = ee;
          ee = We;
          try {
            return ot.apply(this, arguments);
          } finally {
            ee = ht;
          }
        };
      }
      function xe(ot, We, ht) {
        var Ke = t.unstable_now(),
          yt;
        if (typeof ht == "object" && ht !== null) {
          var je = ht.delay;
          typeof je == "number" && je > 0 ? yt = Ke + je : yt = Ke;
        } else yt = Ke;
        var at;
        switch (ot) {
          case x:
            at = F;
            break;
          case E:
            at = j;
            break;
          case D:
            at = G;
            break;
          case k:
            at = K;
            break;
          case C:
          default:
            at = V;
            break;
        }
        var kt = yt + at,
          Bt = {
            id: ie++,
            callback: We,
            priorityLevel: ot,
            startTime: yt,
            expirationTime: kt,
            sortIndex: -1
          };
        return yt > Ke ? (Bt.sortIndex = yt, l(te, Bt), c(Q) === null && Bt === c(te) && (se ? Vt() : se = !0, Et(H, yt - Ke))) : (Bt.sortIndex = kt, l(Q, Bt), !ne && !oe && (ne = !0, Ot(ce))), Bt;
      }
      function we() {}
      function ve() {
        !ne && !oe && (ne = !0, Ot(ce));
      }
      function Te() {
        return c(Q);
      }
      function ze(ot) {
        ot.callback = null;
      }
      function Xe() {
        return ee;
      }
      var ye = !1,
        qe = null,
        Ae = -1,
        Mt = i,
        Ft = -1;
      function un() {
        var ot = t.unstable_now() - Ft;
        return !(ot < Mt);
      }
      function gt() {}
      function Pt(ot) {
        if (ot < 0 || ot > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        ot > 0 ? Mt = Math.floor(1e3 / ot) : Mt = i;
      }
      var St = function () {
          if (qe !== null) {
            var ot = t.unstable_now();
            Ft = ot;
            var We = !0,
              ht = !0;
            try {
              ht = qe(We, ot);
            } finally {
              ht ? Dt() : (ye = !1, qe = null);
            }
          } else ye = !1;
        },
        Dt;
      if (typeof $ == "function") Dt = function () {
        $(St);
      };else if (typeof MessageChannel < "u") {
        var Kt = new MessageChannel(),
          hn = Kt.port2;
        Kt.port1.onmessage = St, Dt = function () {
          hn.postMessage(null);
        };
      } else Dt = function () {
        ue(St, 0);
      };
      function Ot(ot) {
        qe = ot, ye || (ye = !0, Dt());
      }
      function Et(ot, We) {
        Ae = ue(function () {
          ot(t.unstable_now());
        }, We);
      }
      function Vt() {
        W(Ae), Ae = -1;
      }
      var Xt = gt,
        vn = null;
      t.unstable_IdlePriority = D, t.unstable_ImmediatePriority = x, t.unstable_LowPriority = k, t.unstable_NormalPriority = C, t.unstable_Profiling = vn, t.unstable_UserBlockingPriority = E, t.unstable_cancelCallback = ze, t.unstable_continueExecution = ve, t.unstable_forceFrameRate = Pt, t.unstable_getCurrentPriorityLevel = Xe, t.unstable_getFirstCallbackNode = Te, t.unstable_next = Ee, t.unstable_pauseExecution = we, t.unstable_requestPaint = Xt, t.unstable_runWithPriority = Ce, t.unstable_scheduleCallback = xe, t.unstable_shouldYield = un, t.unstable_wrapCallback = fe, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(ZV)), ZV;
}
var eB;
function x4() {
  return eB || (eB = 1, process.env.NODE_ENV === "production" ? _2.exports = nK() : _2.exports = rK()), _2.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tB;
function iK() {
  if (tB) return Qc;
  tB = 1;
  var t = Nt,
    e = x4();
  function i(r) {
    for (var o = "https://reactjs.org/docs/error-decoder.html?invariant=" + r, d = 1; d < arguments.length; d++) o += "&args[]=" + encodeURIComponent(arguments[d]);
    return "Minified React error #" + r + "; visit " + o + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var l = /* @__PURE__ */new Set(),
    c = {};
  function p(r, o) {
    h(r, o), h(r + "Capture", o);
  }
  function h(r, o) {
    for (c[r] = o, r = 0; r < o.length; r++) l.add(o[r]);
  }
  var y = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"),
    w = Object.prototype.hasOwnProperty,
    x = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
    E = {},
    C = {};
  function k(r) {
    return w.call(C, r) ? !0 : w.call(E, r) ? !1 : x.test(r) ? C[r] = !0 : (E[r] = !0, !1);
  }
  function D(r, o, d, g) {
    if (d !== null && d.type === 0) return !1;
    switch (typeof o) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return g ? !1 : d !== null ? !d.acceptsBooleans : (r = r.toLowerCase().slice(0, 5), r !== "data-" && r !== "aria-");
      default:
        return !1;
    }
  }
  function I(r, o, d, g) {
    if (o === null || typeof o > "u" || D(r, o, d, g)) return !0;
    if (g) return !1;
    if (d !== null) switch (d.type) {
      case 3:
        return !o;
      case 4:
        return o === !1;
      case 5:
        return isNaN(o);
      case 6:
        return isNaN(o) || 1 > o;
    }
    return !1;
  }
  function O(r, o, d, g, S, R, A) {
    this.acceptsBooleans = o === 2 || o === 3 || o === 4, this.attributeName = g, this.attributeNamespace = S, this.mustUseProperty = d, this.propertyName = r, this.type = o, this.sanitizeURL = R, this.removeEmptyString = A;
  }
  var P = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (r) {
    P[r] = new O(r, 0, !1, r, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (r) {
    var o = r[0];
    P[o] = new O(o, 1, !1, r[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (r) {
    P[r] = new O(r, 2, !1, r.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (r) {
    P[r] = new O(r, 2, !1, r, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (r) {
    P[r] = new O(r, 3, !1, r.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function (r) {
    P[r] = new O(r, 3, !0, r, null, !1, !1);
  }), ["capture", "download"].forEach(function (r) {
    P[r] = new O(r, 4, !1, r, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function (r) {
    P[r] = new O(r, 6, !1, r, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function (r) {
    P[r] = new O(r, 5, !1, r.toLowerCase(), null, !1, !1);
  });
  var N = /[\-:]([a-z])/g;
  function L(r) {
    return r[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (r) {
    var o = r.replace(N, L);
    P[o] = new O(o, 1, !1, r, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (r) {
    var o = r.replace(N, L);
    P[o] = new O(o, 1, !1, r, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function (r) {
    var o = r.replace(N, L);
    P[o] = new O(o, 1, !1, r, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function (r) {
    P[r] = new O(r, 1, !1, r.toLowerCase(), null, !1, !1);
  }), P.xlinkHref = new O("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function (r) {
    P[r] = new O(r, 1, !1, r.toLowerCase(), null, !0, !0);
  });
  function F(r, o, d, g) {
    var S = P.hasOwnProperty(o) ? P[o] : null;
    (S !== null ? S.type !== 0 : g || !(2 < o.length) || o[0] !== "o" && o[0] !== "O" || o[1] !== "n" && o[1] !== "N") && (I(o, d, S, g) && (d = null), g || S === null ? k(o) && (d === null ? r.removeAttribute(o) : r.setAttribute(o, "" + d)) : S.mustUseProperty ? r[S.propertyName] = d === null ? S.type === 3 ? !1 : "" : d : (o = S.attributeName, g = S.attributeNamespace, d === null ? r.removeAttribute(o) : (S = S.type, d = S === 3 || S === 4 && d === !0 ? "" : "" + d, g ? r.setAttributeNS(g, o, d) : r.setAttribute(o, d))));
  }
  var j = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
    V = Symbol.for("react.element"),
    K = Symbol.for("react.portal"),
    G = Symbol.for("react.fragment"),
    Q = Symbol.for("react.strict_mode"),
    te = Symbol.for("react.profiler"),
    ie = Symbol.for("react.provider"),
    Y = Symbol.for("react.context"),
    ee = Symbol.for("react.forward_ref"),
    oe = Symbol.for("react.suspense"),
    ne = Symbol.for("react.suspense_list"),
    se = Symbol.for("react.memo"),
    ue = Symbol.for("react.lazy"),
    W = Symbol.for("react.offscreen"),
    $ = Symbol.iterator;
  function le(r) {
    return r === null || typeof r != "object" ? null : (r = $ && r[$] || r["@@iterator"], typeof r == "function" ? r : null);
  }
  var H = Object.assign,
    ce;
  function de(r) {
    if (ce === void 0) try {
      throw Error();
    } catch (d) {
      var o = d.stack.trim().match(/\n( *(at )?)/);
      ce = o && o[1] || "";
    }
    return `
` + ce + r;
  }
  var Ce = !1;
  function Ee(r, o) {
    if (!r || Ce) return "";
    Ce = !0;
    var d = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (o) {
        if (o = function () {
          throw Error();
        }, Object.defineProperty(o.prototype, "props", {
          set: function () {
            throw Error();
          }
        }), typeof Reflect == "object" && Reflect.construct) {
          try {
            Reflect.construct(o, []);
          } catch (be) {
            var g = be;
          }
          Reflect.construct(r, [], o);
        } else {
          try {
            o.call();
          } catch (be) {
            g = be;
          }
          r.call(o.prototype);
        }
      } else {
        try {
          throw Error();
        } catch (be) {
          g = be;
        }
        r();
      }
    } catch (be) {
      if (be && g && typeof be.stack == "string") {
        for (var S = be.stack.split(`
`), R = g.stack.split(`
`), A = S.length - 1, q = R.length - 1; 1 <= A && 0 <= q && S[A] !== R[q];) q--;
        for (; 1 <= A && 0 <= q; A--, q--) if (S[A] !== R[q]) {
          if (A !== 1 || q !== 1) do if (A--, q--, 0 > q || S[A] !== R[q]) {
            var re = `
` + S[A].replace(" at new ", " at ");
            return r.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", r.displayName)), re;
          } while (1 <= A && 0 <= q);
          break;
        }
      }
    } finally {
      Ce = !1, Error.prepareStackTrace = d;
    }
    return (r = r ? r.displayName || r.name : "") ? de(r) : "";
  }
  function fe(r) {
    switch (r.tag) {
      case 5:
        return de(r.type);
      case 16:
        return de("Lazy");
      case 13:
        return de("Suspense");
      case 19:
        return de("SuspenseList");
      case 0:
      case 2:
      case 15:
        return r = Ee(r.type, !1), r;
      case 11:
        return r = Ee(r.type.render, !1), r;
      case 1:
        return r = Ee(r.type, !0), r;
      default:
        return "";
    }
  }
  function xe(r) {
    if (r == null) return null;
    if (typeof r == "function") return r.displayName || r.name || null;
    if (typeof r == "string") return r;
    switch (r) {
      case G:
        return "Fragment";
      case K:
        return "Portal";
      case te:
        return "Profiler";
      case Q:
        return "StrictMode";
      case oe:
        return "Suspense";
      case ne:
        return "SuspenseList";
    }
    if (typeof r == "object") switch (r.$$typeof) {
      case Y:
        return (r.displayName || "Context") + ".Consumer";
      case ie:
        return (r._context.displayName || "Context") + ".Provider";
      case ee:
        var o = r.render;
        return r = r.displayName, r || (r = o.displayName || o.name || "", r = r !== "" ? "ForwardRef(" + r + ")" : "ForwardRef"), r;
      case se:
        return o = r.displayName || null, o !== null ? o : xe(r.type) || "Memo";
      case ue:
        o = r._payload, r = r._init;
        try {
          return xe(r(o));
        } catch {}
    }
    return null;
  }
  function we(r) {
    var o = r.type;
    switch (r.tag) {
      case 24:
        return "Cache";
      case 9:
        return (o.displayName || "Context") + ".Consumer";
      case 10:
        return (o._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return r = o.render, r = r.displayName || r.name || "", o.displayName || (r !== "" ? "ForwardRef(" + r + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return o;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return xe(o);
      case 8:
        return o === Q ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof o == "function") return o.displayName || o.name || null;
        if (typeof o == "string") return o;
    }
    return null;
  }
  function ve(r) {
    switch (typeof r) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return r;
      case "object":
        return r;
      default:
        return "";
    }
  }
  function Te(r) {
    var o = r.type;
    return (r = r.nodeName) && r.toLowerCase() === "input" && (o === "checkbox" || o === "radio");
  }
  function ze(r) {
    var o = Te(r) ? "checked" : "value",
      d = Object.getOwnPropertyDescriptor(r.constructor.prototype, o),
      g = "" + r[o];
    if (!r.hasOwnProperty(o) && typeof d < "u" && typeof d.get == "function" && typeof d.set == "function") {
      var S = d.get,
        R = d.set;
      return Object.defineProperty(r, o, {
        configurable: !0,
        get: function () {
          return S.call(this);
        },
        set: function (A) {
          g = "" + A, R.call(this, A);
        }
      }), Object.defineProperty(r, o, {
        enumerable: d.enumerable
      }), {
        getValue: function () {
          return g;
        },
        setValue: function (A) {
          g = "" + A;
        },
        stopTracking: function () {
          r._valueTracker = null, delete r[o];
        }
      };
    }
  }
  function Xe(r) {
    r._valueTracker || (r._valueTracker = ze(r));
  }
  function ye(r) {
    if (!r) return !1;
    var o = r._valueTracker;
    if (!o) return !0;
    var d = o.getValue(),
      g = "";
    return r && (g = Te(r) ? r.checked ? "true" : "false" : r.value), r = g, r !== d ? (o.setValue(r), !0) : !1;
  }
  function qe(r) {
    if (r = r || (typeof document < "u" ? document : void 0), typeof r > "u") return null;
    try {
      return r.activeElement || r.body;
    } catch {
      return r.body;
    }
  }
  function Ae(r, o) {
    var d = o.checked;
    return H({}, o, {
      defaultChecked: void 0,
      defaultValue: void 0,
      value: void 0,
      checked: d ?? r._wrapperState.initialChecked
    });
  }
  function Mt(r, o) {
    var d = o.defaultValue == null ? "" : o.defaultValue,
      g = o.checked != null ? o.checked : o.defaultChecked;
    d = ve(o.value != null ? o.value : d), r._wrapperState = {
      initialChecked: g,
      initialValue: d,
      controlled: o.type === "checkbox" || o.type === "radio" ? o.checked != null : o.value != null
    };
  }
  function Ft(r, o) {
    o = o.checked, o != null && F(r, "checked", o, !1);
  }
  function un(r, o) {
    Ft(r, o);
    var d = ve(o.value),
      g = o.type;
    if (d != null) g === "number" ? (d === 0 && r.value === "" || r.value != d) && (r.value = "" + d) : r.value !== "" + d && (r.value = "" + d);else if (g === "submit" || g === "reset") {
      r.removeAttribute("value");
      return;
    }
    o.hasOwnProperty("value") ? Pt(r, o.type, d) : o.hasOwnProperty("defaultValue") && Pt(r, o.type, ve(o.defaultValue)), o.checked == null && o.defaultChecked != null && (r.defaultChecked = !!o.defaultChecked);
  }
  function gt(r, o, d) {
    if (o.hasOwnProperty("value") || o.hasOwnProperty("defaultValue")) {
      var g = o.type;
      if (!(g !== "submit" && g !== "reset" || o.value !== void 0 && o.value !== null)) return;
      o = "" + r._wrapperState.initialValue, d || o === r.value || (r.value = o), r.defaultValue = o;
    }
    d = r.name, d !== "" && (r.name = ""), r.defaultChecked = !!r._wrapperState.initialChecked, d !== "" && (r.name = d);
  }
  function Pt(r, o, d) {
    (o !== "number" || qe(r.ownerDocument) !== r) && (d == null ? r.defaultValue = "" + r._wrapperState.initialValue : r.defaultValue !== "" + d && (r.defaultValue = "" + d));
  }
  var St = Array.isArray;
  function Dt(r, o, d, g) {
    if (r = r.options, o) {
      o = {};
      for (var S = 0; S < d.length; S++) o["$" + d[S]] = !0;
      for (d = 0; d < r.length; d++) S = o.hasOwnProperty("$" + r[d].value), r[d].selected !== S && (r[d].selected = S), S && g && (r[d].defaultSelected = !0);
    } else {
      for (d = "" + ve(d), o = null, S = 0; S < r.length; S++) {
        if (r[S].value === d) {
          r[S].selected = !0, g && (r[S].defaultSelected = !0);
          return;
        }
        o !== null || r[S].disabled || (o = r[S]);
      }
      o !== null && (o.selected = !0);
    }
  }
  function Kt(r, o) {
    if (o.dangerouslySetInnerHTML != null) throw Error(i(91));
    return H({}, o, {
      value: void 0,
      defaultValue: void 0,
      children: "" + r._wrapperState.initialValue
    });
  }
  function hn(r, o) {
    var d = o.value;
    if (d == null) {
      if (d = o.children, o = o.defaultValue, d != null) {
        if (o != null) throw Error(i(92));
        if (St(d)) {
          if (1 < d.length) throw Error(i(93));
          d = d[0];
        }
        o = d;
      }
      o == null && (o = ""), d = o;
    }
    r._wrapperState = {
      initialValue: ve(d)
    };
  }
  function Ot(r, o) {
    var d = ve(o.value),
      g = ve(o.defaultValue);
    d != null && (d = "" + d, d !== r.value && (r.value = d), o.defaultValue == null && r.defaultValue !== d && (r.defaultValue = d)), g != null && (r.defaultValue = "" + g);
  }
  function Et(r) {
    var o = r.textContent;
    o === r._wrapperState.initialValue && o !== "" && o !== null && (r.value = o);
  }
  function Vt(r) {
    switch (r) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function Xt(r, o) {
    return r == null || r === "http://www.w3.org/1999/xhtml" ? Vt(o) : r === "http://www.w3.org/2000/svg" && o === "foreignObject" ? "http://www.w3.org/1999/xhtml" : r;
  }
  var vn,
    ot = function (r) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function (o, d, g, S) {
        MSApp.execUnsafeLocalFunction(function () {
          return r(o, d, g, S);
        });
      } : r;
    }(function (r, o) {
      if (r.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in r) r.innerHTML = o;else {
        for (vn = vn || document.createElement("div"), vn.innerHTML = "<svg>" + o.valueOf().toString() + "</svg>", o = vn.firstChild; r.firstChild;) r.removeChild(r.firstChild);
        for (; o.firstChild;) r.appendChild(o.firstChild);
      }
    });
  function We(r, o) {
    if (o) {
      var d = r.firstChild;
      if (d && d === r.lastChild && d.nodeType === 3) {
        d.nodeValue = o;
        return;
      }
    }
    r.textContent = o;
  }
  var ht = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    },
    Ke = ["Webkit", "ms", "Moz", "O"];
  Object.keys(ht).forEach(function (r) {
    Ke.forEach(function (o) {
      o = o + r.charAt(0).toUpperCase() + r.substring(1), ht[o] = ht[r];
    });
  });
  function yt(r, o, d) {
    return o == null || typeof o == "boolean" || o === "" ? "" : d || typeof o != "number" || o === 0 || ht.hasOwnProperty(r) && ht[r] ? ("" + o).trim() : o + "px";
  }
  function je(r, o) {
    r = r.style;
    for (var d in o) if (o.hasOwnProperty(d)) {
      var g = d.indexOf("--") === 0,
        S = yt(d, o[d], g);
      d === "float" && (d = "cssFloat"), g ? r.setProperty(d, S) : r[d] = S;
    }
  }
  var at = H({
    menuitem: !0
  }, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
  });
  function kt(r, o) {
    if (o) {
      if (at[r] && (o.children != null || o.dangerouslySetInnerHTML != null)) throw Error(i(137, r));
      if (o.dangerouslySetInnerHTML != null) {
        if (o.children != null) throw Error(i(60));
        if (typeof o.dangerouslySetInnerHTML != "object" || !("__html" in o.dangerouslySetInnerHTML)) throw Error(i(61));
      }
      if (o.style != null && typeof o.style != "object") throw Error(i(62));
    }
  }
  function Bt(r, o) {
    if (r.indexOf("-") === -1) return typeof o.is == "string";
    switch (r) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var Ht = null;
  function ln(r) {
    return r = r.target || r.srcElement || window, r.correspondingUseElement && (r = r.correspondingUseElement), r.nodeType === 3 ? r.parentNode : r;
  }
  var en = null,
    Rr = null,
    Nr = null;
  function Hi(r) {
    if (r = pt(r)) {
      if (typeof en != "function") throw Error(i(280));
      var o = r.stateNode;
      o && (o = Gn(o), en(r.stateNode, r.type, o));
    }
  }
  function ll(r) {
    Rr ? Nr ? Nr.push(r) : Nr = [r] : Rr = r;
  }
  function yo() {
    if (Rr) {
      var r = Rr,
        o = Nr;
      if (Nr = Rr = null, Hi(r), o) for (r = 0; r < o.length; r++) Hi(o[r]);
    }
  }
  function _l(r, o) {
    return r(o);
  }
  function Mo() {}
  var bo = !1;
  function Tu(r, o, d) {
    if (bo) return r(o, d);
    bo = !0;
    try {
      return _l(r, o, d);
    } finally {
      bo = !1, (Rr !== null || Nr !== null) && (Mo(), yo());
    }
  }
  function Ha(r, o) {
    var d = r.stateNode;
    if (d === null) return null;
    var g = Gn(d);
    if (g === null) return null;
    d = g[o];
    e: switch (o) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (g = !g.disabled) || (r = r.type, g = !(r === "button" || r === "input" || r === "select" || r === "textarea")), r = !g;
        break e;
      default:
        r = !1;
    }
    if (r) return null;
    if (d && typeof d != "function") throw Error(i(231, o, typeof d));
    return d;
  }
  var $i = !1;
  if (y) try {
    var oi = {};
    Object.defineProperty(oi, "passive", {
      get: function () {
        $i = !0;
      }
    }), window.addEventListener("test", oi, oi), window.removeEventListener("test", oi, oi);
  } catch {
    $i = !1;
  }
  function Oo(r, o, d, g, S, R, A, q, re) {
    var be = Array.prototype.slice.call(arguments, 3);
    try {
      o.apply(d, be);
    } catch (Le) {
      this.onError(Le);
    }
  }
  var $a = !1,
    Lo = null,
    Z = !1,
    Ne = null,
    Ye = {
      onError: function (r) {
        $a = !0, Lo = r;
      }
    };
  function xt(r, o, d, g, S, R, A, q, re) {
    $a = !1, Lo = null, Oo.apply(Ye, arguments);
  }
  function rn(r, o, d, g, S, R, A, q, re) {
    if (xt.apply(this, arguments), $a) {
      if ($a) {
        var be = Lo;
        $a = !1, Lo = null;
      } else throw Error(i(198));
      Z || (Z = !0, Ne = be);
    }
  }
  function $t(r) {
    var o = r,
      d = r;
    if (r.alternate) for (; o.return;) o = o.return;else {
      r = o;
      do o = r, (o.flags & 4098) !== 0 && (d = o.return), r = o.return; while (r);
    }
    return o.tag === 3 ? d : null;
  }
  function Ct(r) {
    if (r.tag === 13) {
      var o = r.memoizedState;
      if (o === null && (r = r.alternate, r !== null && (o = r.memoizedState)), o !== null) return o.dehydrated;
    }
    return null;
  }
  function qt(r) {
    if ($t(r) !== r) throw Error(i(188));
  }
  function yr(r) {
    var o = r.alternate;
    if (!o) {
      if (o = $t(r), o === null) throw Error(i(188));
      return o !== r ? null : r;
    }
    for (var d = r, g = o;;) {
      var S = d.return;
      if (S === null) break;
      var R = S.alternate;
      if (R === null) {
        if (g = S.return, g !== null) {
          d = g;
          continue;
        }
        break;
      }
      if (S.child === R.child) {
        for (R = S.child; R;) {
          if (R === d) return qt(S), r;
          if (R === g) return qt(S), o;
          R = R.sibling;
        }
        throw Error(i(188));
      }
      if (d.return !== g.return) d = S, g = R;else {
        for (var A = !1, q = S.child; q;) {
          if (q === d) {
            A = !0, d = S, g = R;
            break;
          }
          if (q === g) {
            A = !0, g = S, d = R;
            break;
          }
          q = q.sibling;
        }
        if (!A) {
          for (q = R.child; q;) {
            if (q === d) {
              A = !0, d = R, g = S;
              break;
            }
            if (q === g) {
              A = !0, g = R, d = S;
              break;
            }
            q = q.sibling;
          }
          if (!A) throw Error(i(189));
        }
      }
      if (d.alternate !== g) throw Error(i(190));
    }
    if (d.tag !== 3) throw Error(i(188));
    return d.stateNode.current === d ? r : o;
  }
  function Tn(r) {
    return r = yr(r), r !== null ? jn(r) : null;
  }
  function jn(r) {
    if (r.tag === 5 || r.tag === 6) return r;
    for (r = r.child; r !== null;) {
      var o = jn(r);
      if (o !== null) return o;
      r = r.sibling;
    }
    return null;
  }
  var Lr = e.unstable_scheduleCallback,
    Wa = e.unstable_cancelCallback,
    Ru = e.unstable_shouldYield,
    Wi = e.unstable_requestPaint,
    yn = e.unstable_now,
    Qt = e.unstable_getCurrentPriorityLevel,
    Es = e.unstable_ImmediatePriority,
    Wp = e.unstable_UserBlockingPriority,
    Du = e.unstable_NormalPriority,
    tg = e.unstable_LowPriority,
    qp = e.unstable_IdlePriority,
    Iu = null,
    qi = null;
  function ng(r) {
    if (qi && typeof qi.onCommitFiberRoot == "function") try {
      qi.onCommitFiberRoot(Iu, r, void 0, (r.current.flags & 128) === 128);
    } catch {}
  }
  var gi = Math.clz32 ? Math.clz32 : Yp,
    uw = Math.log,
    cw = Math.LN2;
  function Yp(r) {
    return r >>>= 0, r === 0 ? 32 : 31 - (uw(r) / cw | 0) | 0;
  }
  var xl = 64,
    Yi = 4194304;
  function Cs(r) {
    switch (r & -r) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return r & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return r & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return r;
    }
  }
  function ks(r, o) {
    var d = r.pendingLanes;
    if (d === 0) return 0;
    var g = 0,
      S = r.suspendedLanes,
      R = r.pingedLanes,
      A = d & 268435455;
    if (A !== 0) {
      var q = A & ~S;
      q !== 0 ? g = Cs(q) : (R &= A, R !== 0 && (g = Cs(R)));
    } else A = d & ~S, A !== 0 ? g = Cs(A) : R !== 0 && (g = Cs(R));
    if (g === 0) return 0;
    if (o !== 0 && o !== g && (o & S) === 0 && (S = g & -g, R = o & -o, S >= R || S === 16 && (R & 4194240) !== 0)) return o;
    if ((g & 4) !== 0 && (g |= d & 16), o = r.entangledLanes, o !== 0) for (r = r.entanglements, o &= g; 0 < o;) d = 31 - gi(o), S = 1 << d, g |= r[d], o &= ~S;
    return g;
  }
  function dw(r, o) {
    switch (r) {
      case 1:
      case 2:
      case 4:
        return o + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return o + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Gp(r, o) {
    for (var d = r.suspendedLanes, g = r.pingedLanes, S = r.expirationTimes, R = r.pendingLanes; 0 < R;) {
      var A = 31 - gi(R),
        q = 1 << A,
        re = S[A];
      re === -1 ? ((q & d) === 0 || (q & g) !== 0) && (S[A] = dw(q, o)) : re <= o && (r.expiredLanes |= q), R &= ~q;
    }
  }
  function Xp(r) {
    return r = r.pendingLanes & -1073741825, r !== 0 ? r : r & 1073741824 ? 1073741824 : 0;
  }
  function pd() {
    var r = xl;
    return xl <<= 1, (xl & 4194240) === 0 && (xl = 64), r;
  }
  function Kp(r) {
    for (var o = [], d = 0; 31 > d; d++) o.push(r);
    return o;
  }
  function Ts(r, o, d) {
    r.pendingLanes |= o, o !== 536870912 && (r.suspendedLanes = 0, r.pingedLanes = 0), r = r.eventTimes, o = 31 - gi(o), r[o] = d;
  }
  function fw(r, o) {
    var d = r.pendingLanes & ~o;
    r.pendingLanes = o, r.suspendedLanes = 0, r.pingedLanes = 0, r.expiredLanes &= o, r.mutableReadLanes &= o, r.entangledLanes &= o, o = r.entanglements;
    var g = r.eventTimes;
    for (r = r.expirationTimes; 0 < d;) {
      var S = 31 - gi(d),
        R = 1 << S;
      o[S] = 0, g[S] = -1, r[S] = -1, d &= ~R;
    }
  }
  function hd(r, o) {
    var d = r.entangledLanes |= o;
    for (r = r.entanglements; d;) {
      var g = 31 - gi(d),
        S = 1 << g;
      S & o | r[g] & o && (r[g] |= o), d &= ~S;
    }
  }
  var gn = 0;
  function Qp(r) {
    return r &= -r, 1 < r ? 4 < r ? (r & 268435455) !== 0 ? 16 : 536870912 : 4 : 1;
  }
  var bn,
    Zp,
    Jp,
    At,
    eh,
    Pr = !1,
    Po = [],
    yi = null,
    Ao = null,
    Un = null,
    Rn = /* @__PURE__ */new Map(),
    Mu = /* @__PURE__ */new Map(),
    br = [],
    bi = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function qa(r, o) {
    switch (r) {
      case "focusin":
      case "focusout":
        yi = null;
        break;
      case "dragenter":
      case "dragleave":
        Ao = null;
        break;
      case "mouseover":
      case "mouseout":
        Un = null;
        break;
      case "pointerover":
      case "pointerout":
        Rn.delete(o.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Mu.delete(o.pointerId);
    }
  }
  function Ou(r, o, d, g, S, R) {
    return r === null || r.nativeEvent !== R ? (r = {
      blockedOn: o,
      domEventName: d,
      eventSystemFlags: g,
      nativeEvent: R,
      targetContainers: [S]
    }, o !== null && (o = pt(o), o !== null && Zp(o)), r) : (r.eventSystemFlags |= g, o = r.targetContainers, S !== null && o.indexOf(S) === -1 && o.push(S), r);
  }
  function th(r, o, d, g, S) {
    switch (o) {
      case "focusin":
        return yi = Ou(yi, r, o, d, g, S), !0;
      case "dragenter":
        return Ao = Ou(Ao, r, o, d, g, S), !0;
      case "mouseover":
        return Un = Ou(Un, r, o, d, g, S), !0;
      case "pointerover":
        var R = S.pointerId;
        return Rn.set(R, Ou(Rn.get(R) || null, r, o, d, g, S)), !0;
      case "gotpointercapture":
        return R = S.pointerId, Mu.set(R, Ou(Mu.get(R) || null, r, o, d, g, S)), !0;
    }
    return !1;
  }
  function nh(r) {
    var o = Fs(r.target);
    if (o !== null) {
      var d = $t(o);
      if (d !== null) {
        if (o = d.tag, o === 13) {
          if (o = Ct(d), o !== null) {
            r.blockedOn = o, eh(r.priority, function () {
              Jp(d);
            });
            return;
          }
        } else if (o === 3 && d.stateNode.current.memoizedState.isDehydrated) {
          r.blockedOn = d.tag === 3 ? d.stateNode.containerInfo : null;
          return;
        }
      }
    }
    r.blockedOn = null;
  }
  function Lu(r) {
    if (r.blockedOn !== null) return !1;
    for (var o = r.targetContainers; 0 < o.length;) {
      var d = vd(r.domEventName, r.eventSystemFlags, o[0], r.nativeEvent);
      if (d === null) {
        d = r.nativeEvent;
        var g = new d.constructor(d.type, d);
        Ht = g, d.target.dispatchEvent(g), Ht = null;
      } else return o = pt(d), o !== null && Zp(o), r.blockedOn = d, !1;
      o.shift();
    }
    return !0;
  }
  function rg(r, o, d) {
    Lu(r) && d.delete(o);
  }
  function pw() {
    Pr = !1, yi !== null && Lu(yi) && (yi = null), Ao !== null && Lu(Ao) && (Ao = null), Un !== null && Lu(Un) && (Un = null), Rn.forEach(rg), Mu.forEach(rg);
  }
  function Pu(r, o) {
    r.blockedOn === o && (r.blockedOn = null, Pr || (Pr = !0, e.unstable_scheduleCallback(e.unstable_NormalPriority, pw)));
  }
  function jo(r) {
    function o(S) {
      return Pu(S, r);
    }
    if (0 < Po.length) {
      Pu(Po[0], r);
      for (var d = 1; d < Po.length; d++) {
        var g = Po[d];
        g.blockedOn === r && (g.blockedOn = null);
      }
    }
    for (yi !== null && Pu(yi, r), Ao !== null && Pu(Ao, r), Un !== null && Pu(Un, r), Rn.forEach(o), Mu.forEach(o), d = 0; d < br.length; d++) g = br[d], g.blockedOn === r && (g.blockedOn = null);
    for (; 0 < br.length && (d = br[0], d.blockedOn === null);) nh(d), d.blockedOn === null && br.shift();
  }
  var Rs = j.ReactCurrentBatchConfig,
    Ds = !0;
  function ig(r, o, d, g) {
    var S = gn,
      R = Rs.transition;
    Rs.transition = null;
    try {
      gn = 1, md(r, o, d, g);
    } finally {
      gn = S, Rs.transition = R;
    }
  }
  function ag(r, o, d, g) {
    var S = gn,
      R = Rs.transition;
    Rs.transition = null;
    try {
      gn = 4, md(r, o, d, g);
    } finally {
      gn = S, Rs.transition = R;
    }
  }
  function md(r, o, d, g) {
    if (Ds) {
      var S = vd(r, o, d, g);
      if (S === null) Pd(r, o, g, Au, d), qa(r, g);else if (th(S, r, o, d, g)) g.stopPropagation();else if (qa(r, g), o & 4 && -1 < bi.indexOf(r)) {
        for (; S !== null;) {
          var R = pt(S);
          if (R !== null && bn(R), R = vd(r, o, d, g), R === null && Pd(r, o, g, Au, d), R === S) break;
          S = R;
        }
        S !== null && g.stopPropagation();
      } else Pd(r, o, g, null, d);
    }
  }
  var Au = null;
  function vd(r, o, d, g) {
    if (Au = null, r = ln(g), r = Fs(r), r !== null) if (o = $t(r), o === null) r = null;else if (d = o.tag, d === 13) {
      if (r = Ct(o), r !== null) return r;
      r = null;
    } else if (d === 3) {
      if (o.stateNode.current.memoizedState.isDehydrated) return o.tag === 3 ? o.stateNode.containerInfo : null;
      r = null;
    } else o !== r && (r = null);
    return Au = r, null;
  }
  function gd(r) {
    switch (r) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (Qt()) {
          case Es:
            return 1;
          case Wp:
            return 4;
          case Du:
          case tg:
            return 16;
          case qp:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var Ya = null,
    yd = null,
    Sl = null;
  function rh() {
    if (Sl) return Sl;
    var r,
      o = yd,
      d = o.length,
      g,
      S = "value" in Ya ? Ya.value : Ya.textContent,
      R = S.length;
    for (r = 0; r < d && o[r] === S[r]; r++);
    var A = d - r;
    for (g = 1; g <= A && o[d - g] === S[R - g]; g++);
    return Sl = S.slice(r, 1 < g ? 1 - g : void 0);
  }
  function bd(r) {
    var o = r.keyCode;
    return "charCode" in r ? (r = r.charCode, r === 0 && o === 13 && (r = 13)) : r = o, r === 10 && (r = 13), 32 <= r || r === 13 ? r : 0;
  }
  function wd() {
    return !0;
  }
  function _d() {
    return !1;
  }
  function $r(r) {
    function o(d, g, S, R, A) {
      this._reactName = d, this._targetInst = S, this.type = g, this.nativeEvent = R, this.target = A, this.currentTarget = null;
      for (var q in r) r.hasOwnProperty(q) && (d = r[q], this[q] = d ? d(R) : R[q]);
      return this.isDefaultPrevented = (R.defaultPrevented != null ? R.defaultPrevented : R.returnValue === !1) ? wd : _d, this.isPropagationStopped = _d, this;
    }
    return H(o.prototype, {
      preventDefault: function () {
        this.defaultPrevented = !0;
        var d = this.nativeEvent;
        d && (d.preventDefault ? d.preventDefault() : typeof d.returnValue != "unknown" && (d.returnValue = !1), this.isDefaultPrevented = wd);
      },
      stopPropagation: function () {
        var d = this.nativeEvent;
        d && (d.stopPropagation ? d.stopPropagation() : typeof d.cancelBubble != "unknown" && (d.cancelBubble = !0), this.isPropagationStopped = wd);
      },
      persist: function () {},
      isPersistent: wd
    }), o;
  }
  var Is = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function (r) {
        return r.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    },
    xd = $r(Is),
    El = H({}, Is, {
      view: 0,
      detail: 0
    }),
    hw = $r(El),
    ih,
    wr,
    Ms,
    ju = H({}, El, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: uh,
      button: 0,
      buttons: 0,
      relatedTarget: function (r) {
        return r.relatedTarget === void 0 ? r.fromElement === r.srcElement ? r.toElement : r.fromElement : r.relatedTarget;
      },
      movementX: function (r) {
        return "movementX" in r ? r.movementX : (r !== Ms && (Ms && r.type === "mousemove" ? (ih = r.screenX - Ms.screenX, wr = r.screenY - Ms.screenY) : wr = ih = 0, Ms = r), ih);
      },
      movementY: function (r) {
        return "movementY" in r ? r.movementY : wr;
      }
    }),
    ah = $r(ju),
    mw = H({}, ju, {
      dataTransfer: 0
    }),
    Cl = $r(mw),
    oh = H({}, El, {
      relatedTarget: 0
    }),
    Sd = $r(oh),
    vw = H({}, Is, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }),
    gw = $r(vw),
    yw = H({}, Is, {
      clipboardData: function (r) {
        return "clipboardData" in r ? r.clipboardData : window.clipboardData;
      }
    }),
    og = $r(yw),
    sh = H({}, Is, {
      data: 0
    }),
    lh = $r(sh),
    sg = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    },
    lg = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    },
    bw = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
  function Ga(r) {
    var o = this.nativeEvent;
    return o.getModifierState ? o.getModifierState(r) : (r = bw[r]) ? !!o[r] : !1;
  }
  function uh() {
    return Ga;
  }
  var ch = H({}, El, {
      key: function (r) {
        if (r.key) {
          var o = sg[r.key] || r.key;
          if (o !== "Unidentified") return o;
        }
        return r.type === "keypress" ? (r = bd(r), r === 13 ? "Enter" : String.fromCharCode(r)) : r.type === "keydown" || r.type === "keyup" ? lg[r.keyCode] || "Unidentified" : "";
      },
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: uh,
      charCode: function (r) {
        return r.type === "keypress" ? bd(r) : 0;
      },
      keyCode: function (r) {
        return r.type === "keydown" || r.type === "keyup" ? r.keyCode : 0;
      },
      which: function (r) {
        return r.type === "keypress" ? bd(r) : r.type === "keydown" || r.type === "keyup" ? r.keyCode : 0;
      }
    }),
    dh = $r(ch),
    fh = H({}, ju, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }),
    ug = $r(fh),
    Ed = H({}, El, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: uh
    }),
    cg = $r(Ed),
    Wr = H({}, Is, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }),
    Xa = $r(Wr),
    er = H({}, ju, {
      deltaX: function (r) {
        return "deltaX" in r ? r.deltaX : "wheelDeltaX" in r ? -r.wheelDeltaX : 0;
      },
      deltaY: function (r) {
        return "deltaY" in r ? r.deltaY : "wheelDeltaY" in r ? -r.wheelDeltaY : "wheelDelta" in r ? -r.wheelDelta : 0;
      },
      deltaZ: 0,
      deltaMode: 0
    }),
    Ka = $r(er),
    ph = [9, 13, 27, 32],
    kl = y && "CompositionEvent" in window,
    Fu = null;
  y && "documentMode" in document && (Fu = document.documentMode);
  var Nu = y && "TextEvent" in window && !Fu,
    dg = y && (!kl || Fu && 8 < Fu && 11 >= Fu),
    fg = " ",
    Cd = !1;
  function pg(r, o) {
    switch (r) {
      case "keyup":
        return ph.indexOf(o.keyCode) !== -1;
      case "keydown":
        return o.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function hg(r) {
    return r = r.detail, typeof r == "object" && "data" in r ? r.data : null;
  }
  var Tl = !1;
  function mg(r, o) {
    switch (r) {
      case "compositionend":
        return hg(o);
      case "keypress":
        return o.which !== 32 ? null : (Cd = !0, fg);
      case "textInput":
        return r = o.data, r === fg && Cd ? null : r;
      default:
        return null;
    }
  }
  function ww(r, o) {
    if (Tl) return r === "compositionend" || !kl && pg(r, o) ? (r = rh(), Sl = yd = Ya = null, Tl = !1, r) : null;
    switch (r) {
      case "paste":
        return null;
      case "keypress":
        if (!(o.ctrlKey || o.altKey || o.metaKey) || o.ctrlKey && o.altKey) {
          if (o.char && 1 < o.char.length) return o.char;
          if (o.which) return String.fromCharCode(o.which);
        }
        return null;
      case "compositionend":
        return dg && o.locale !== "ko" ? null : o.data;
      default:
        return null;
    }
  }
  var _w = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function vg(r) {
    var o = r && r.nodeName && r.nodeName.toLowerCase();
    return o === "input" ? !!_w[r.type] : o === "textarea";
  }
  function hh(r, o, d, g) {
    ll(g), o = $u(o, "onChange"), 0 < o.length && (d = new xd("onChange", "change", null, d, g), r.push({
      event: d,
      listeners: o
    }));
  }
  var pa = null,
    Os = null;
  function gg(r) {
    As(r, 0);
  }
  function zu(r) {
    var o = Xi(r);
    if (ye(o)) return r;
  }
  function xw(r, o) {
    if (r === "change") return o;
  }
  var yg = !1;
  if (y) {
    var mh;
    if (y) {
      var vh = "oninput" in document;
      if (!vh) {
        var bg = document.createElement("div");
        bg.setAttribute("oninput", "return;"), vh = typeof bg.oninput == "function";
      }
      mh = vh;
    } else mh = !1;
    yg = mh && (!document.documentMode || 9 < document.documentMode);
  }
  function wg() {
    pa && (pa.detachEvent("onpropertychange", _g), Os = pa = null);
  }
  function _g(r) {
    if (r.propertyName === "value" && zu(Os)) {
      var o = [];
      hh(o, Os, r, ln(r)), Tu(gg, o);
    }
  }
  function Sw(r, o, d) {
    r === "focusin" ? (wg(), pa = o, Os = d, pa.attachEvent("onpropertychange", _g)) : r === "focusout" && wg();
  }
  function xg(r) {
    if (r === "selectionchange" || r === "keyup" || r === "keydown") return zu(Os);
  }
  function Ew(r, o) {
    if (r === "click") return zu(o);
  }
  function Sg(r, o) {
    if (r === "input" || r === "change") return zu(o);
  }
  function Cw(r, o) {
    return r === o && (r !== 0 || 1 / r === 1 / o) || r !== r && o !== o;
  }
  var Gi = typeof Object.is == "function" ? Object.is : Cw;
  function Vu(r, o) {
    if (Gi(r, o)) return !0;
    if (typeof r != "object" || r === null || typeof o != "object" || o === null) return !1;
    var d = Object.keys(r),
      g = Object.keys(o);
    if (d.length !== g.length) return !1;
    for (g = 0; g < d.length; g++) {
      var S = d[g];
      if (!w.call(o, S) || !Gi(r[S], o[S])) return !1;
    }
    return !0;
  }
  function Eg(r) {
    for (; r && r.firstChild;) r = r.firstChild;
    return r;
  }
  function kd(r, o) {
    var d = Eg(r);
    r = 0;
    for (var g; d;) {
      if (d.nodeType === 3) {
        if (g = r + d.textContent.length, r <= o && g >= o) return {
          node: d,
          offset: o - r
        };
        r = g;
      }
      e: {
        for (; d;) {
          if (d.nextSibling) {
            d = d.nextSibling;
            break e;
          }
          d = d.parentNode;
        }
        d = void 0;
      }
      d = Eg(d);
    }
  }
  function Fo(r, o) {
    return r && o ? r === o ? !0 : r && r.nodeType === 3 ? !1 : o && o.nodeType === 3 ? Fo(r, o.parentNode) : "contains" in r ? r.contains(o) : r.compareDocumentPosition ? !!(r.compareDocumentPosition(o) & 16) : !1 : !1;
  }
  function Bu() {
    for (var r = window, o = qe(); o instanceof r.HTMLIFrameElement;) {
      try {
        var d = typeof o.contentWindow.location.href == "string";
      } catch {
        d = !1;
      }
      if (d) r = o.contentWindow;else break;
      o = qe(r.document);
    }
    return o;
  }
  function Td(r) {
    var o = r && r.nodeName && r.nodeName.toLowerCase();
    return o && (o === "input" && (r.type === "text" || r.type === "search" || r.type === "tel" || r.type === "url" || r.type === "password") || o === "textarea" || r.contentEditable === "true");
  }
  function Rl(r) {
    var o = Bu(),
      d = r.focusedElem,
      g = r.selectionRange;
    if (o !== d && d && d.ownerDocument && Fo(d.ownerDocument.documentElement, d)) {
      if (g !== null && Td(d)) {
        if (o = g.start, r = g.end, r === void 0 && (r = o), "selectionStart" in d) d.selectionStart = o, d.selectionEnd = Math.min(r, d.value.length);else if (r = (o = d.ownerDocument || document) && o.defaultView || window, r.getSelection) {
          r = r.getSelection();
          var S = d.textContent.length,
            R = Math.min(g.start, S);
          g = g.end === void 0 ? R : Math.min(g.end, S), !r.extend && R > g && (S = g, g = R, R = S), S = kd(d, R);
          var A = kd(d, g);
          S && A && (r.rangeCount !== 1 || r.anchorNode !== S.node || r.anchorOffset !== S.offset || r.focusNode !== A.node || r.focusOffset !== A.offset) && (o = o.createRange(), o.setStart(S.node, S.offset), r.removeAllRanges(), R > g ? (r.addRange(o), r.extend(A.node, A.offset)) : (o.setEnd(A.node, A.offset), r.addRange(o)));
        }
      }
      for (o = [], r = d; r = r.parentNode;) r.nodeType === 1 && o.push({
        element: r,
        left: r.scrollLeft,
        top: r.scrollTop
      });
      for (typeof d.focus == "function" && d.focus(), d = 0; d < o.length; d++) r = o[d], r.element.scrollLeft = r.left, r.element.scrollTop = r.top;
    }
  }
  var kw = y && "documentMode" in document && 11 >= document.documentMode,
    Dl = null,
    gh = null,
    Uu = null,
    yh = !1;
  function bh(r, o, d) {
    var g = d.window === d ? d.document : d.nodeType === 9 ? d : d.ownerDocument;
    yh || Dl == null || Dl !== qe(g) || (g = Dl, "selectionStart" in g && Td(g) ? g = {
      start: g.selectionStart,
      end: g.selectionEnd
    } : (g = (g.ownerDocument && g.ownerDocument.defaultView || window).getSelection(), g = {
      anchorNode: g.anchorNode,
      anchorOffset: g.anchorOffset,
      focusNode: g.focusNode,
      focusOffset: g.focusOffset
    }), Uu && Vu(Uu, g) || (Uu = g, g = $u(gh, "onSelect"), 0 < g.length && (o = new xd("onSelect", "select", null, o, d), r.push({
      event: o,
      listeners: g
    }), o.target = Dl)));
  }
  function Rd(r, o) {
    var d = {};
    return d[r.toLowerCase()] = o.toLowerCase(), d["Webkit" + r] = "webkit" + o, d["Moz" + r] = "moz" + o, d;
  }
  var Ls = {
      animationend: Rd("Animation", "AnimationEnd"),
      animationiteration: Rd("Animation", "AnimationIteration"),
      animationstart: Rd("Animation", "AnimationStart"),
      transitionend: Rd("Transition", "TransitionEnd")
    },
    _r = {},
    wh = {};
  y && (wh = document.createElement("div").style, "AnimationEvent" in window || (delete Ls.animationend.animation, delete Ls.animationiteration.animation, delete Ls.animationstart.animation), "TransitionEvent" in window || delete Ls.transitionend.transition);
  function Dd(r) {
    if (_r[r]) return _r[r];
    if (!Ls[r]) return r;
    var o = Ls[r],
      d;
    for (d in o) if (o.hasOwnProperty(d) && d in wh) return _r[r] = o[d];
    return r;
  }
  var Cg = Dd("animationend"),
    kg = Dd("animationiteration"),
    Tg = Dd("animationstart"),
    Rg = Dd("transitionend"),
    _h = /* @__PURE__ */new Map(),
    Id = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function wi(r, o) {
    _h.set(r, o), p(o, [r]);
  }
  for (var xh = 0; xh < Id.length; xh++) {
    var Ps = Id[xh],
      Tw = Ps.toLowerCase(),
      Rw = Ps[0].toUpperCase() + Ps.slice(1);
    wi(Tw, "on" + Rw);
  }
  wi(Cg, "onAnimationEnd"), wi(kg, "onAnimationIteration"), wi(Tg, "onAnimationStart"), wi("dblclick", "onDoubleClick"), wi("focusin", "onFocus"), wi("focusout", "onBlur"), wi(Rg, "onTransitionEnd"), h("onMouseEnter", ["mouseout", "mouseover"]), h("onMouseLeave", ["mouseout", "mouseover"]), h("onPointerEnter", ["pointerout", "pointerover"]), h("onPointerLeave", ["pointerout", "pointerover"]), p("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), p("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), p("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), p("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), p("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), p("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var Hu = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),
    Sh = new Set("cancel close invalid load scroll toggle".split(" ").concat(Hu));
  function Md(r, o, d) {
    var g = r.type || "unknown-event";
    r.currentTarget = d, rn(g, o, void 0, r), r.currentTarget = null;
  }
  function As(r, o) {
    o = (o & 4) !== 0;
    for (var d = 0; d < r.length; d++) {
      var g = r[d],
        S = g.event;
      g = g.listeners;
      e: {
        var R = void 0;
        if (o) for (var A = g.length - 1; 0 <= A; A--) {
          var q = g[A],
            re = q.instance,
            be = q.currentTarget;
          if (q = q.listener, re !== R && S.isPropagationStopped()) break e;
          Md(S, q, be), R = re;
        } else for (A = 0; A < g.length; A++) {
          if (q = g[A], re = q.instance, be = q.currentTarget, q = q.listener, re !== R && S.isPropagationStopped()) break e;
          Md(S, q, be), R = re;
        }
      }
    }
    if (Z) throw r = Ne, Z = !1, Ne = null, r;
  }
  function mn(r, o) {
    var d = o[Yu];
    d === void 0 && (d = o[Yu] = /* @__PURE__ */new Set());
    var g = r + "__bubble";
    d.has(g) || (Dg(o, r, 2, !1), d.add(g));
  }
  function Od(r, o, d) {
    var g = 0;
    o && (g |= 4), Dg(d, r, g, o);
  }
  var Ld = "_reactListening" + Math.random().toString(36).slice(2);
  function Il(r) {
    if (!r[Ld]) {
      r[Ld] = !0, l.forEach(function (d) {
        d !== "selectionchange" && (Sh.has(d) || Od(d, !1, r), Od(d, !0, r));
      });
      var o = r.nodeType === 9 ? r : r.ownerDocument;
      o === null || o[Ld] || (o[Ld] = !0, Od("selectionchange", !1, o));
    }
  }
  function Dg(r, o, d, g) {
    switch (gd(o)) {
      case 1:
        var S = ig;
        break;
      case 4:
        S = ag;
        break;
      default:
        S = md;
    }
    d = S.bind(null, o, d, r), S = void 0, !$i || o !== "touchstart" && o !== "touchmove" && o !== "wheel" || (S = !0), g ? S !== void 0 ? r.addEventListener(o, d, {
      capture: !0,
      passive: S
    }) : r.addEventListener(o, d, !0) : S !== void 0 ? r.addEventListener(o, d, {
      passive: S
    }) : r.addEventListener(o, d, !1);
  }
  function Pd(r, o, d, g, S) {
    var R = g;
    if ((o & 1) === 0 && (o & 2) === 0 && g !== null) e: for (;;) {
      if (g === null) return;
      var A = g.tag;
      if (A === 3 || A === 4) {
        var q = g.stateNode.containerInfo;
        if (q === S || q.nodeType === 8 && q.parentNode === S) break;
        if (A === 4) for (A = g.return; A !== null;) {
          var re = A.tag;
          if ((re === 3 || re === 4) && (re = A.stateNode.containerInfo, re === S || re.nodeType === 8 && re.parentNode === S)) return;
          A = A.return;
        }
        for (; q !== null;) {
          if (A = Fs(q), A === null) return;
          if (re = A.tag, re === 5 || re === 6) {
            g = R = A;
            continue e;
          }
          q = q.parentNode;
        }
      }
      g = g.return;
    }
    Tu(function () {
      var be = R,
        Le = ln(d),
        Ve = [];
      e: {
        var Oe = _h.get(r);
        if (Oe !== void 0) {
          var et = xd,
            it = r;
          switch (r) {
            case "keypress":
              if (bd(d) === 0) break e;
            case "keydown":
            case "keyup":
              et = dh;
              break;
            case "focusin":
              it = "focus", et = Sd;
              break;
            case "focusout":
              it = "blur", et = Sd;
              break;
            case "beforeblur":
            case "afterblur":
              et = Sd;
              break;
            case "click":
              if (d.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              et = ah;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              et = Cl;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              et = cg;
              break;
            case Cg:
            case kg:
            case Tg:
              et = gw;
              break;
            case Rg:
              et = Xa;
              break;
            case "scroll":
              et = hw;
              break;
            case "wheel":
              et = Ka;
              break;
            case "copy":
            case "cut":
            case "paste":
              et = og;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              et = ug;
          }
          var st = (o & 4) !== 0,
            Kn = !st && r === "scroll",
            pe = st ? Oe !== null ? Oe + "Capture" : null : Oe;
          st = [];
          for (var ae = be, he; ae !== null;) {
            he = ae;
            var He = he.stateNode;
            if (he.tag === 5 && He !== null && (he = He, pe !== null && (He = Ha(ae, pe), He != null && st.push(Ml(ae, He, he)))), Kn) break;
            ae = ae.return;
          }
          0 < st.length && (Oe = new et(Oe, it, null, d, Le), Ve.push({
            event: Oe,
            listeners: st
          }));
        }
      }
      if ((o & 7) === 0) {
        e: {
          if (Oe = r === "mouseover" || r === "pointerover", et = r === "mouseout" || r === "pointerout", Oe && d !== Ht && (it = d.relatedTarget || d.fromElement) && (Fs(it) || it[Qa])) break e;
          if ((et || Oe) && (Oe = Le.window === Le ? Le : (Oe = Le.ownerDocument) ? Oe.defaultView || Oe.parentWindow : window, et ? (it = d.relatedTarget || d.toElement, et = be, it = it ? Fs(it) : null, it !== null && (Kn = $t(it), it !== Kn || it.tag !== 5 && it.tag !== 6) && (it = null)) : (et = null, it = be), et !== it)) {
            if (st = ah, He = "onMouseLeave", pe = "onMouseEnter", ae = "mouse", (r === "pointerout" || r === "pointerover") && (st = ug, He = "onPointerLeave", pe = "onPointerEnter", ae = "pointer"), Kn = et == null ? Oe : Xi(et), he = it == null ? Oe : Xi(it), Oe = new st(He, ae + "leave", et, d, Le), Oe.target = Kn, Oe.relatedTarget = he, He = null, Fs(Le) === be && (st = new st(pe, ae + "enter", it, d, Le), st.target = he, st.relatedTarget = Kn, He = st), Kn = He, et && it) t: {
              for (st = et, pe = it, ae = 0, he = st; he; he = No(he)) ae++;
              for (he = 0, He = pe; He; He = No(He)) he++;
              for (; 0 < ae - he;) st = No(st), ae--;
              for (; 0 < he - ae;) pe = No(pe), he--;
              for (; ae--;) {
                if (st === pe || pe !== null && st === pe.alternate) break t;
                st = No(st), pe = No(pe);
              }
              st = null;
            } else st = null;
            et !== null && Ig(Ve, Oe, et, st, !1), it !== null && Kn !== null && Ig(Ve, Kn, it, st, !0);
          }
        }
        e: {
          if (Oe = be ? Xi(be) : window, et = Oe.nodeName && Oe.nodeName.toLowerCase(), et === "select" || et === "input" && Oe.type === "file") var ut = xw;else if (vg(Oe)) {
            if (yg) ut = Sg;else {
              ut = xg;
              var bt = Sw;
            }
          } else (et = Oe.nodeName) && et.toLowerCase() === "input" && (Oe.type === "checkbox" || Oe.type === "radio") && (ut = Ew);
          if (ut && (ut = ut(r, be))) {
            hh(Ve, ut, d, Le);
            break e;
          }
          bt && bt(r, Oe, be), r === "focusout" && (bt = Oe._wrapperState) && bt.controlled && Oe.type === "number" && Pt(Oe, "number", Oe.value);
        }
        switch (bt = be ? Xi(be) : window, r) {
          case "focusin":
            (vg(bt) || bt.contentEditable === "true") && (Dl = bt, gh = be, Uu = null);
            break;
          case "focusout":
            Uu = gh = Dl = null;
            break;
          case "mousedown":
            yh = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            yh = !1, bh(Ve, d, Le);
            break;
          case "selectionchange":
            if (kw) break;
          case "keydown":
          case "keyup":
            bh(Ve, d, Le);
        }
        var wt;
        if (kl) e: {
          switch (r) {
            case "compositionstart":
              var It = "onCompositionStart";
              break e;
            case "compositionend":
              It = "onCompositionEnd";
              break e;
            case "compositionupdate":
              It = "onCompositionUpdate";
              break e;
          }
          It = void 0;
        } else Tl ? pg(r, d) && (It = "onCompositionEnd") : r === "keydown" && d.keyCode === 229 && (It = "onCompositionStart");
        It && (dg && d.locale !== "ko" && (Tl || It !== "onCompositionStart" ? It === "onCompositionEnd" && Tl && (wt = rh()) : (Ya = Le, yd = "value" in Ya ? Ya.value : Ya.textContent, Tl = !0)), bt = $u(be, It), 0 < bt.length && (It = new lh(It, r, null, d, Le), Ve.push({
          event: It,
          listeners: bt
        }), wt ? It.data = wt : (wt = hg(d), wt !== null && (It.data = wt)))), (wt = Nu ? mg(r, d) : ww(r, d)) && (be = $u(be, "onBeforeInput"), 0 < be.length && (Le = new lh("onBeforeInput", "beforeinput", null, d, Le), Ve.push({
          event: Le,
          listeners: be
        }), Le.data = wt));
      }
      As(Ve, o);
    });
  }
  function Ml(r, o, d) {
    return {
      instance: r,
      listener: o,
      currentTarget: d
    };
  }
  function $u(r, o) {
    for (var d = o + "Capture", g = []; r !== null;) {
      var S = r,
        R = S.stateNode;
      S.tag === 5 && R !== null && (S = R, R = Ha(r, d), R != null && g.unshift(Ml(r, R, S)), R = Ha(r, o), R != null && g.push(Ml(r, R, S))), r = r.return;
    }
    return g;
  }
  function No(r) {
    if (r === null) return null;
    do r = r.return; while (r && r.tag !== 5);
    return r || null;
  }
  function Ig(r, o, d, g, S) {
    for (var R = o._reactName, A = []; d !== null && d !== g;) {
      var q = d,
        re = q.alternate,
        be = q.stateNode;
      if (re !== null && re === g) break;
      q.tag === 5 && be !== null && (q = be, S ? (re = Ha(d, R), re != null && A.unshift(Ml(d, re, q))) : S || (re = Ha(d, R), re != null && A.push(Ml(d, re, q)))), d = d.return;
    }
    A.length !== 0 && r.push({
      event: o,
      listeners: A
    });
  }
  var Mg = /\r\n?/g,
    Dw = /\u0000|\uFFFD/g;
  function Og(r) {
    return (typeof r == "string" ? r : "" + r).replace(Mg, `
`).replace(Dw, "");
  }
  function Ad(r, o, d) {
    if (o = Og(o), Og(r) !== o && d) throw Error(i(425));
  }
  function zo() {}
  var Wu = null,
    js = null;
  function jd(r, o) {
    return r === "textarea" || r === "noscript" || typeof o.children == "string" || typeof o.children == "number" || typeof o.dangerouslySetInnerHTML == "object" && o.dangerouslySetInnerHTML !== null && o.dangerouslySetInnerHTML.__html != null;
  }
  var Fd = typeof setTimeout == "function" ? setTimeout : void 0,
    Eh = typeof clearTimeout == "function" ? clearTimeout : void 0,
    Lg = typeof Promise == "function" ? Promise : void 0,
    Ol = typeof queueMicrotask == "function" ? queueMicrotask : typeof Lg < "u" ? function (r) {
      return Lg.resolve(null).then(r).catch(Nd);
    } : Fd;
  function Nd(r) {
    setTimeout(function () {
      throw r;
    });
  }
  function Ll(r, o) {
    var d = o,
      g = 0;
    do {
      var S = d.nextSibling;
      if (r.removeChild(d), S && S.nodeType === 8) if (d = S.data, d === "/$") {
        if (g === 0) {
          r.removeChild(S), jo(o);
          return;
        }
        g--;
      } else d !== "$" && d !== "$?" && d !== "$!" || g++;
      d = S;
    } while (d);
    jo(o);
  }
  function ha(r) {
    for (; r != null; r = r.nextSibling) {
      var o = r.nodeType;
      if (o === 1 || o === 3) break;
      if (o === 8) {
        if (o = r.data, o === "$" || o === "$!" || o === "$?") break;
        if (o === "/$") return null;
      }
    }
    return r;
  }
  function Pg(r) {
    r = r.previousSibling;
    for (var o = 0; r;) {
      if (r.nodeType === 8) {
        var d = r.data;
        if (d === "$" || d === "$!" || d === "$?") {
          if (o === 0) return r;
          o--;
        } else d === "/$" && o++;
      }
      r = r.previousSibling;
    }
    return null;
  }
  var Vo = Math.random().toString(36).slice(2),
    ma = "__reactFiber$" + Vo,
    qu = "__reactProps$" + Vo,
    Qa = "__reactContainer$" + Vo,
    Yu = "__reactEvents$" + Vo,
    Pl = "__reactListeners$" + Vo,
    Iw = "__reactHandles$" + Vo;
  function Fs(r) {
    var o = r[ma];
    if (o) return o;
    for (var d = r.parentNode; d;) {
      if (o = d[Qa] || d[ma]) {
        if (d = o.alternate, o.child !== null || d !== null && d.child !== null) for (r = Pg(r); r !== null;) {
          if (d = r[ma]) return d;
          r = Pg(r);
        }
        return o;
      }
      r = d, d = r.parentNode;
    }
    return null;
  }
  function pt(r) {
    return r = r[ma] || r[Qa], !r || r.tag !== 5 && r.tag !== 6 && r.tag !== 13 && r.tag !== 3 ? null : r;
  }
  function Xi(r) {
    if (r.tag === 5 || r.tag === 6) return r.stateNode;
    throw Error(i(33));
  }
  function Gn(r) {
    return r[qu] || null;
  }
  var tn = [],
    _i = -1;
  function Ki(r) {
    return {
      current: r
    };
  }
  function Sn(r) {
    0 > _i || (r.current = tn[_i], tn[_i] = null, _i--);
  }
  function ft(r, o) {
    _i++, tn[_i] = r.current, r.current = o;
  }
  var qr = {},
    Hn = Ki(qr),
    or = Ki(!1),
    Yr = qr;
  function xi(r, o) {
    var d = r.type.contextTypes;
    if (!d) return qr;
    var g = r.stateNode;
    if (g && g.__reactInternalMemoizedUnmaskedChildContext === o) return g.__reactInternalMemoizedMaskedChildContext;
    var S = {},
      R;
    for (R in d) S[R] = o[R];
    return g && (r = r.stateNode, r.__reactInternalMemoizedUnmaskedChildContext = o, r.__reactInternalMemoizedMaskedChildContext = S), S;
  }
  function tr(r) {
    return r = r.childContextTypes, r != null;
  }
  function Al() {
    Sn(or), Sn(Hn);
  }
  function Ag(r, o, d) {
    if (Hn.current !== qr) throw Error(i(168));
    ft(Hn, o), ft(or, d);
  }
  function Gu(r, o, d) {
    var g = r.stateNode;
    if (o = o.childContextTypes, typeof g.getChildContext != "function") return d;
    g = g.getChildContext();
    for (var S in g) if (!(S in o)) throw Error(i(108, we(r) || "Unknown", S));
    return H({}, d, g);
  }
  function Gr(r) {
    return r = (r = r.stateNode) && r.__reactInternalMemoizedMergedChildContext || qr, Yr = Hn.current, ft(Hn, r), ft(or, or.current), !0;
  }
  function zd(r, o, d) {
    var g = r.stateNode;
    if (!g) throw Error(i(169));
    d ? (r = Gu(r, o, Yr), g.__reactInternalMemoizedMergedChildContext = r, Sn(or), Sn(Hn), ft(Hn, r)) : Sn(or), ft(or, d);
  }
  var va = null,
    jl = !1,
    Za = !1;
  function Vd(r) {
    va === null ? va = [r] : va.push(r);
  }
  function Bo(r) {
    jl = !0, Vd(r);
  }
  function ga() {
    if (!Za && va !== null) {
      Za = !0;
      var r = 0,
        o = gn;
      try {
        var d = va;
        for (gn = 1; r < d.length; r++) {
          var g = d[r];
          do g = g(!0); while (g !== null);
        }
        va = null, jl = !1;
      } catch (S) {
        throw va !== null && (va = va.slice(r + 1)), Lr(Es, ga), S;
      } finally {
        gn = o, Za = !1;
      }
    }
    return null;
  }
  var Uo = [],
    Ho = 0,
    $o = null,
    Ja = 0,
    nr = [],
    Si = 0,
    si = null,
    ya = 1,
    ba = "";
  function Ns(r, o) {
    Uo[Ho++] = Ja, Uo[Ho++] = $o, $o = r, Ja = o;
  }
  function jg(r, o, d) {
    nr[Si++] = ya, nr[Si++] = ba, nr[Si++] = si, si = r;
    var g = ya;
    r = ba;
    var S = 32 - gi(g) - 1;
    g &= ~(1 << S), d += 1;
    var R = 32 - gi(o) + S;
    if (30 < R) {
      var A = S - S % 5;
      R = (g & (1 << A) - 1).toString(32), g >>= A, S -= A, ya = 1 << 32 - gi(o) + S | d << S | g, ba = R + r;
    } else ya = 1 << R | d << S | g, ba = r;
  }
  function Bd(r) {
    r.return !== null && (Ns(r, 1), jg(r, 1, 0));
  }
  function Ud(r) {
    for (; r === $o;) $o = Uo[--Ho], Uo[Ho] = null, Ja = Uo[--Ho], Uo[Ho] = null;
    for (; r === si;) si = nr[--Si], nr[Si] = null, ba = nr[--Si], nr[Si] = null, ya = nr[--Si], nr[Si] = null;
  }
  var Xr = null,
    Kr = null,
    In = !1,
    Ei = null;
  function Ch(r, o) {
    var d = Li(5, null, null, 0);
    d.elementType = "DELETED", d.stateNode = o, d.return = r, o = r.deletions, o === null ? (r.deletions = [d], r.flags |= 16) : o.push(d);
  }
  function Fg(r, o) {
    switch (r.tag) {
      case 5:
        var d = r.type;
        return o = o.nodeType !== 1 || d.toLowerCase() !== o.nodeName.toLowerCase() ? null : o, o !== null ? (r.stateNode = o, Xr = r, Kr = ha(o.firstChild), !0) : !1;
      case 6:
        return o = r.pendingProps === "" || o.nodeType !== 3 ? null : o, o !== null ? (r.stateNode = o, Xr = r, Kr = null, !0) : !1;
      case 13:
        return o = o.nodeType !== 8 ? null : o, o !== null ? (d = si !== null ? {
          id: ya,
          overflow: ba
        } : null, r.memoizedState = {
          dehydrated: o,
          treeContext: d,
          retryLane: 1073741824
        }, d = Li(18, null, null, 0), d.stateNode = o, d.return = r, r.child = d, Xr = r, Kr = null, !0) : !1;
      default:
        return !1;
    }
  }
  function kh(r) {
    return (r.mode & 1) !== 0 && (r.flags & 128) === 0;
  }
  function Th(r) {
    if (In) {
      var o = Kr;
      if (o) {
        var d = o;
        if (!Fg(r, o)) {
          if (kh(r)) throw Error(i(418));
          o = ha(d.nextSibling);
          var g = Xr;
          o && Fg(r, o) ? Ch(g, d) : (r.flags = r.flags & -4097 | 2, In = !1, Xr = r);
        }
      } else {
        if (kh(r)) throw Error(i(418));
        r.flags = r.flags & -4097 | 2, In = !1, Xr = r;
      }
    }
  }
  function sr(r) {
    for (r = r.return; r !== null && r.tag !== 5 && r.tag !== 3 && r.tag !== 13;) r = r.return;
    Xr = r;
  }
  function Hd(r) {
    if (r !== Xr) return !1;
    if (!In) return sr(r), In = !0, !1;
    var o;
    if ((o = r.tag !== 3) && !(o = r.tag !== 5) && (o = r.type, o = o !== "head" && o !== "body" && !jd(r.type, r.memoizedProps)), o && (o = Kr)) {
      if (kh(r)) throw Xu(), Error(i(418));
      for (; o;) Ch(r, o), o = ha(o.nextSibling);
    }
    if (sr(r), r.tag === 13) {
      if (r = r.memoizedState, r = r !== null ? r.dehydrated : null, !r) throw Error(i(317));
      e: {
        for (r = r.nextSibling, o = 0; r;) {
          if (r.nodeType === 8) {
            var d = r.data;
            if (d === "/$") {
              if (o === 0) {
                Kr = ha(r.nextSibling);
                break e;
              }
              o--;
            } else d !== "$" && d !== "$!" && d !== "$?" || o++;
          }
          r = r.nextSibling;
        }
        Kr = null;
      }
    } else Kr = Xr ? ha(r.stateNode.nextSibling) : null;
    return !0;
  }
  function Xu() {
    for (var r = Kr; r;) r = ha(r.nextSibling);
  }
  function Wo() {
    Kr = Xr = null, In = !1;
  }
  function eo(r) {
    Ei === null ? Ei = [r] : Ei.push(r);
  }
  var Mw = j.ReactCurrentBatchConfig;
  function li(r, o) {
    if (r && r.defaultProps) {
      o = H({}, o), r = r.defaultProps;
      for (var d in r) o[d] === void 0 && (o[d] = r[d]);
      return o;
    }
    return o;
  }
  var $d = Ki(null),
    Wd = null,
    Qi = null,
    dr = null;
  function Ge() {
    dr = Qi = Wd = null;
  }
  function Ci(r) {
    var o = $d.current;
    Sn($d), r._currentValue = o;
  }
  function ui(r, o, d) {
    for (; r !== null;) {
      var g = r.alternate;
      if ((r.childLanes & o) !== o ? (r.childLanes |= o, g !== null && (g.childLanes |= o)) : g !== null && (g.childLanes & o) !== o && (g.childLanes |= o), r === d) break;
      r = r.return;
    }
  }
  function Fl(r, o) {
    Wd = r, dr = Qi = null, r = r.dependencies, r !== null && r.firstContext !== null && ((r.lanes & o) !== 0 && (Dr = !0), r.firstContext = null);
  }
  function ki(r) {
    var o = r._currentValue;
    if (dr !== r) if (r = {
      context: r,
      memoizedValue: o,
      next: null
    }, Qi === null) {
      if (Wd === null) throw Error(i(308));
      Qi = r, Wd.dependencies = {
        lanes: 0,
        firstContext: r
      };
    } else Qi = Qi.next = r;
    return o;
  }
  var zs = null;
  function Rh(r) {
    zs === null ? zs = [r] : zs.push(r);
  }
  function Ng(r, o, d, g) {
    var S = o.interleaved;
    return S === null ? (d.next = d, Rh(o)) : (d.next = S.next, S.next = d), o.interleaved = d, En(r, g);
  }
  function En(r, o) {
    r.lanes |= o;
    var d = r.alternate;
    for (d !== null && (d.lanes |= o), d = r, r = r.return; r !== null;) r.childLanes |= o, d = r.alternate, d !== null && (d.childLanes |= o), d = r, r = r.return;
    return d.tag === 3 ? d.stateNode : null;
  }
  var qo = !1;
  function Dh(r) {
    r.updateQueue = {
      baseState: r.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: {
        pending: null,
        interleaved: null,
        lanes: 0
      },
      effects: null
    };
  }
  function zg(r, o) {
    r = r.updateQueue, o.updateQueue === r && (o.updateQueue = {
      baseState: r.baseState,
      firstBaseUpdate: r.firstBaseUpdate,
      lastBaseUpdate: r.lastBaseUpdate,
      shared: r.shared,
      effects: r.effects
    });
  }
  function wa(r, o) {
    return {
      eventTime: r,
      lane: o,
      tag: 0,
      payload: null,
      callback: null,
      next: null
    };
  }
  function Ti(r, o, d) {
    var g = r.updateQueue;
    if (g === null) return null;
    if (g = g.shared, (on & 2) !== 0) {
      var S = g.pending;
      return S === null ? o.next = o : (o.next = S.next, S.next = o), g.pending = o, En(r, d);
    }
    return S = g.interleaved, S === null ? (o.next = o, Rh(g)) : (o.next = S.next, S.next = o), g.interleaved = o, En(r, d);
  }
  function to(r, o, d) {
    if (o = o.updateQueue, o !== null && (o = o.shared, (d & 4194240) !== 0)) {
      var g = o.lanes;
      g &= r.pendingLanes, d |= g, o.lanes = d, hd(r, d);
    }
  }
  function Vg(r, o) {
    var d = r.updateQueue,
      g = r.alternate;
    if (g !== null && (g = g.updateQueue, d === g)) {
      var S = null,
        R = null;
      if (d = d.firstBaseUpdate, d !== null) {
        do {
          var A = {
            eventTime: d.eventTime,
            lane: d.lane,
            tag: d.tag,
            payload: d.payload,
            callback: d.callback,
            next: null
          };
          R === null ? S = R = A : R = R.next = A, d = d.next;
        } while (d !== null);
        R === null ? S = R = o : R = R.next = o;
      } else S = R = o;
      d = {
        baseState: g.baseState,
        firstBaseUpdate: S,
        lastBaseUpdate: R,
        shared: g.shared,
        effects: g.effects
      }, r.updateQueue = d;
      return;
    }
    r = d.lastBaseUpdate, r === null ? d.firstBaseUpdate = o : r.next = o, d.lastBaseUpdate = o;
  }
  function qd(r, o, d, g) {
    var S = r.updateQueue;
    qo = !1;
    var R = S.firstBaseUpdate,
      A = S.lastBaseUpdate,
      q = S.shared.pending;
    if (q !== null) {
      S.shared.pending = null;
      var re = q,
        be = re.next;
      re.next = null, A === null ? R = be : A.next = be, A = re;
      var Le = r.alternate;
      Le !== null && (Le = Le.updateQueue, q = Le.lastBaseUpdate, q !== A && (q === null ? Le.firstBaseUpdate = be : q.next = be, Le.lastBaseUpdate = re));
    }
    if (R !== null) {
      var Ve = S.baseState;
      A = 0, Le = be = re = null, q = R;
      do {
        var Oe = q.lane,
          et = q.eventTime;
        if ((g & Oe) === Oe) {
          Le !== null && (Le = Le.next = {
            eventTime: et,
            lane: 0,
            tag: q.tag,
            payload: q.payload,
            callback: q.callback,
            next: null
          });
          e: {
            var it = r,
              st = q;
            switch (Oe = o, et = d, st.tag) {
              case 1:
                if (it = st.payload, typeof it == "function") {
                  Ve = it.call(et, Ve, Oe);
                  break e;
                }
                Ve = it;
                break e;
              case 3:
                it.flags = it.flags & -65537 | 128;
              case 0:
                if (it = st.payload, Oe = typeof it == "function" ? it.call(et, Ve, Oe) : it, Oe == null) break e;
                Ve = H({}, Ve, Oe);
                break e;
              case 2:
                qo = !0;
            }
          }
          q.callback !== null && q.lane !== 0 && (r.flags |= 64, Oe = S.effects, Oe === null ? S.effects = [q] : Oe.push(q));
        } else et = {
          eventTime: et,
          lane: Oe,
          tag: q.tag,
          payload: q.payload,
          callback: q.callback,
          next: null
        }, Le === null ? (be = Le = et, re = Ve) : Le = Le.next = et, A |= Oe;
        if (q = q.next, q === null) {
          if (q = S.shared.pending, q === null) break;
          Oe = q, q = Oe.next, Oe.next = null, S.lastBaseUpdate = Oe, S.shared.pending = null;
        }
      } while (!0);
      if (Le === null && (re = Ve), S.baseState = re, S.firstBaseUpdate = be, S.lastBaseUpdate = Le, o = S.shared.interleaved, o !== null) {
        S = o;
        do A |= S.lane, S = S.next; while (S !== o);
      } else R === null && (S.shared.lanes = 0);
      xo |= A, r.lanes = A, r.memoizedState = Ve;
    }
  }
  function Bg(r, o, d) {
    if (r = o.effects, o.effects = null, r !== null) for (o = 0; o < r.length; o++) {
      var g = r[o],
        S = g.callback;
      if (S !== null) {
        if (g.callback = null, g = d, typeof S != "function") throw Error(i(191, S));
        S.call(g);
      }
    }
  }
  var Ug = new t.Component().refs;
  function Ih(r, o, d, g) {
    o = r.memoizedState, d = d(g, o), d = d == null ? o : H({}, o, d), r.memoizedState = d, r.lanes === 0 && (r.updateQueue.baseState = d);
  }
  var Yd = {
    isMounted: function (r) {
      return (r = r._reactInternals) ? $t(r) === r : !1;
    },
    enqueueSetState: function (r, o, d) {
      r = r._reactInternals;
      var g = hr(),
        S = Ca(r),
        R = wa(g, S);
      R.payload = o, d != null && (R.callback = d), o = Ti(r, R, S), o !== null && (Oi(o, r, S, g), to(o, r, S));
    },
    enqueueReplaceState: function (r, o, d) {
      r = r._reactInternals;
      var g = hr(),
        S = Ca(r),
        R = wa(g, S);
      R.tag = 1, R.payload = o, d != null && (R.callback = d), o = Ti(r, R, S), o !== null && (Oi(o, r, S, g), to(o, r, S));
    },
    enqueueForceUpdate: function (r, o) {
      r = r._reactInternals;
      var d = hr(),
        g = Ca(r),
        S = wa(d, g);
      S.tag = 2, o != null && (S.callback = o), o = Ti(r, S, g), o !== null && (Oi(o, r, g, d), to(o, r, g));
    }
  };
  function Mh(r, o, d, g, S, R, A) {
    return r = r.stateNode, typeof r.shouldComponentUpdate == "function" ? r.shouldComponentUpdate(g, R, A) : o.prototype && o.prototype.isPureReactComponent ? !Vu(d, g) || !Vu(S, R) : !0;
  }
  function Oh(r, o, d) {
    var g = !1,
      S = qr,
      R = o.contextType;
    return typeof R == "object" && R !== null ? R = ki(R) : (S = tr(o) ? Yr : Hn.current, g = o.contextTypes, R = (g = g != null) ? xi(r, S) : qr), o = new o(d, R), r.memoizedState = o.state !== null && o.state !== void 0 ? o.state : null, o.updater = Yd, r.stateNode = o, o._reactInternals = r, g && (r = r.stateNode, r.__reactInternalMemoizedUnmaskedChildContext = S, r.__reactInternalMemoizedMaskedChildContext = R), o;
  }
  function Hg(r, o, d, g) {
    r = o.state, typeof o.componentWillReceiveProps == "function" && o.componentWillReceiveProps(d, g), typeof o.UNSAFE_componentWillReceiveProps == "function" && o.UNSAFE_componentWillReceiveProps(d, g), o.state !== r && Yd.enqueueReplaceState(o, o.state, null);
  }
  function Lh(r, o, d, g) {
    var S = r.stateNode;
    S.props = d, S.state = r.memoizedState, S.refs = Ug, Dh(r);
    var R = o.contextType;
    typeof R == "object" && R !== null ? S.context = ki(R) : (R = tr(o) ? Yr : Hn.current, S.context = xi(r, R)), S.state = r.memoizedState, R = o.getDerivedStateFromProps, typeof R == "function" && (Ih(r, o, R, d), S.state = r.memoizedState), typeof o.getDerivedStateFromProps == "function" || typeof S.getSnapshotBeforeUpdate == "function" || typeof S.UNSAFE_componentWillMount != "function" && typeof S.componentWillMount != "function" || (o = S.state, typeof S.componentWillMount == "function" && S.componentWillMount(), typeof S.UNSAFE_componentWillMount == "function" && S.UNSAFE_componentWillMount(), o !== S.state && Yd.enqueueReplaceState(S, S.state, null), qd(r, d, S, g), S.state = r.memoizedState), typeof S.componentDidMount == "function" && (r.flags |= 4194308);
  }
  function Ku(r, o, d) {
    if (r = d.ref, r !== null && typeof r != "function" && typeof r != "object") {
      if (d._owner) {
        if (d = d._owner, d) {
          if (d.tag !== 1) throw Error(i(309));
          var g = d.stateNode;
        }
        if (!g) throw Error(i(147, r));
        var S = g,
          R = "" + r;
        return o !== null && o.ref !== null && typeof o.ref == "function" && o.ref._stringRef === R ? o.ref : (o = function (A) {
          var q = S.refs;
          q === Ug && (q = S.refs = {}), A === null ? delete q[R] : q[R] = A;
        }, o._stringRef = R, o);
      }
      if (typeof r != "string") throw Error(i(284));
      if (!d._owner) throw Error(i(290, r));
    }
    return r;
  }
  function Gd(r, o) {
    throw r = Object.prototype.toString.call(o), Error(i(31, r === "[object Object]" ? "object with keys {" + Object.keys(o).join(", ") + "}" : r));
  }
  function $g(r) {
    var o = r._init;
    return o(r._payload);
  }
  function Wg(r) {
    function o(pe, ae) {
      if (r) {
        var he = pe.deletions;
        he === null ? (pe.deletions = [ae], pe.flags |= 16) : he.push(ae);
      }
    }
    function d(pe, ae) {
      if (!r) return null;
      for (; ae !== null;) o(pe, ae), ae = ae.sibling;
      return null;
    }
    function g(pe, ae) {
      for (pe = /* @__PURE__ */new Map(); ae !== null;) ae.key !== null ? pe.set(ae.key, ae) : pe.set(ae.index, ae), ae = ae.sibling;
      return pe;
    }
    function S(pe, ae) {
      return pe = Oa(pe, ae), pe.index = 0, pe.sibling = null, pe;
    }
    function R(pe, ae, he) {
      return pe.index = he, r ? (he = pe.alternate, he !== null ? (he = he.index, he < ae ? (pe.flags |= 2, ae) : he) : (pe.flags |= 2, ae)) : (pe.flags |= 1048576, ae);
    }
    function A(pe) {
      return r && pe.alternate === null && (pe.flags |= 2), pe;
    }
    function q(pe, ae, he, He) {
      return ae === null || ae.tag !== 6 ? (ae = yf(he, pe.mode, He), ae.return = pe, ae) : (ae = S(ae, he), ae.return = pe, ae);
    }
    function re(pe, ae, he, He) {
      var ut = he.type;
      return ut === G ? Le(pe, ae, he.props.children, He, he.key) : ae !== null && (ae.elementType === ut || typeof ut == "object" && ut !== null && ut.$$typeof === ue && $g(ut) === ae.type) ? (He = S(ae, he.props), He.ref = Ku(pe, ae, he), He.return = pe, He) : (He = Js(he.type, he.key, he.props, null, pe.mode, He), He.ref = Ku(pe, ae, he), He.return = pe, He);
    }
    function be(pe, ae, he, He) {
      return ae === null || ae.tag !== 4 || ae.stateNode.containerInfo !== he.containerInfo || ae.stateNode.implementation !== he.implementation ? (ae = bf(he, pe.mode, He), ae.return = pe, ae) : (ae = S(ae, he.children || []), ae.return = pe, ae);
    }
    function Le(pe, ae, he, He, ut) {
      return ae === null || ae.tag !== 7 ? (ae = oo(he, pe.mode, He, ut), ae.return = pe, ae) : (ae = S(ae, he), ae.return = pe, ae);
    }
    function Ve(pe, ae, he) {
      if (typeof ae == "string" && ae !== "" || typeof ae == "number") return ae = yf("" + ae, pe.mode, he), ae.return = pe, ae;
      if (typeof ae == "object" && ae !== null) {
        switch (ae.$$typeof) {
          case V:
            return he = Js(ae.type, ae.key, ae.props, null, pe.mode, he), he.ref = Ku(pe, null, ae), he.return = pe, he;
          case K:
            return ae = bf(ae, pe.mode, he), ae.return = pe, ae;
          case ue:
            var He = ae._init;
            return Ve(pe, He(ae._payload), he);
        }
        if (St(ae) || le(ae)) return ae = oo(ae, pe.mode, he, null), ae.return = pe, ae;
        Gd(pe, ae);
      }
      return null;
    }
    function Oe(pe, ae, he, He) {
      var ut = ae !== null ? ae.key : null;
      if (typeof he == "string" && he !== "" || typeof he == "number") return ut !== null ? null : q(pe, ae, "" + he, He);
      if (typeof he == "object" && he !== null) {
        switch (he.$$typeof) {
          case V:
            return he.key === ut ? re(pe, ae, he, He) : null;
          case K:
            return he.key === ut ? be(pe, ae, he, He) : null;
          case ue:
            return ut = he._init, Oe(pe, ae, ut(he._payload), He);
        }
        if (St(he) || le(he)) return ut !== null ? null : Le(pe, ae, he, He, null);
        Gd(pe, he);
      }
      return null;
    }
    function et(pe, ae, he, He, ut) {
      if (typeof He == "string" && He !== "" || typeof He == "number") return pe = pe.get(he) || null, q(ae, pe, "" + He, ut);
      if (typeof He == "object" && He !== null) {
        switch (He.$$typeof) {
          case V:
            return pe = pe.get(He.key === null ? he : He.key) || null, re(ae, pe, He, ut);
          case K:
            return pe = pe.get(He.key === null ? he : He.key) || null, be(ae, pe, He, ut);
          case ue:
            var bt = He._init;
            return et(pe, ae, he, bt(He._payload), ut);
        }
        if (St(He) || le(He)) return pe = pe.get(he) || null, Le(ae, pe, He, ut, null);
        Gd(ae, He);
      }
      return null;
    }
    function it(pe, ae, he, He) {
      for (var ut = null, bt = null, wt = ae, It = ae = 0, mr = null; wt !== null && It < he.length; It++) {
        wt.index > It ? (mr = wt, wt = null) : mr = wt.sibling;
        var cn = Oe(pe, wt, he[It], He);
        if (cn === null) {
          wt === null && (wt = mr);
          break;
        }
        r && wt && cn.alternate === null && o(pe, wt), ae = R(cn, ae, It), bt === null ? ut = cn : bt.sibling = cn, bt = cn, wt = mr;
      }
      if (It === he.length) return d(pe, wt), In && Ns(pe, It), ut;
      if (wt === null) {
        for (; It < he.length; It++) wt = Ve(pe, he[It], He), wt !== null && (ae = R(wt, ae, It), bt === null ? ut = wt : bt.sibling = wt, bt = wt);
        return In && Ns(pe, It), ut;
      }
      for (wt = g(pe, wt); It < he.length; It++) mr = et(wt, pe, It, he[It], He), mr !== null && (r && mr.alternate !== null && wt.delete(mr.key === null ? It : mr.key), ae = R(mr, ae, It), bt === null ? ut = mr : bt.sibling = mr, bt = mr);
      return r && wt.forEach(function (so) {
        return o(pe, so);
      }), In && Ns(pe, It), ut;
    }
    function st(pe, ae, he, He) {
      var ut = le(he);
      if (typeof ut != "function") throw Error(i(150));
      if (he = ut.call(he), he == null) throw Error(i(151));
      for (var bt = ut = null, wt = ae, It = ae = 0, mr = null, cn = he.next(); wt !== null && !cn.done; It++, cn = he.next()) {
        wt.index > It ? (mr = wt, wt = null) : mr = wt.sibling;
        var so = Oe(pe, wt, cn.value, He);
        if (so === null) {
          wt === null && (wt = mr);
          break;
        }
        r && wt && so.alternate === null && o(pe, wt), ae = R(so, ae, It), bt === null ? ut = so : bt.sibling = so, bt = so, wt = mr;
      }
      if (cn.done) return d(pe, wt), In && Ns(pe, It), ut;
      if (wt === null) {
        for (; !cn.done; It++, cn = he.next()) cn = Ve(pe, cn.value, He), cn !== null && (ae = R(cn, ae, It), bt === null ? ut = cn : bt.sibling = cn, bt = cn);
        return In && Ns(pe, It), ut;
      }
      for (wt = g(pe, wt); !cn.done; It++, cn = he.next()) cn = et(wt, pe, It, cn.value, He), cn !== null && (r && cn.alternate !== null && wt.delete(cn.key === null ? It : cn.key), ae = R(cn, ae, It), bt === null ? ut = cn : bt.sibling = cn, bt = cn);
      return r && wt.forEach(function (Pb) {
        return o(pe, Pb);
      }), In && Ns(pe, It), ut;
    }
    function Kn(pe, ae, he, He) {
      if (typeof he == "object" && he !== null && he.type === G && he.key === null && (he = he.props.children), typeof he == "object" && he !== null) {
        switch (he.$$typeof) {
          case V:
            e: {
              for (var ut = he.key, bt = ae; bt !== null;) {
                if (bt.key === ut) {
                  if (ut = he.type, ut === G) {
                    if (bt.tag === 7) {
                      d(pe, bt.sibling), ae = S(bt, he.props.children), ae.return = pe, pe = ae;
                      break e;
                    }
                  } else if (bt.elementType === ut || typeof ut == "object" && ut !== null && ut.$$typeof === ue && $g(ut) === bt.type) {
                    d(pe, bt.sibling), ae = S(bt, he.props), ae.ref = Ku(pe, bt, he), ae.return = pe, pe = ae;
                    break e;
                  }
                  d(pe, bt);
                  break;
                } else o(pe, bt);
                bt = bt.sibling;
              }
              he.type === G ? (ae = oo(he.props.children, pe.mode, He, he.key), ae.return = pe, pe = ae) : (He = Js(he.type, he.key, he.props, null, pe.mode, He), He.ref = Ku(pe, ae, he), He.return = pe, pe = He);
            }
            return A(pe);
          case K:
            e: {
              for (bt = he.key; ae !== null;) {
                if (ae.key === bt) {
                  if (ae.tag === 4 && ae.stateNode.containerInfo === he.containerInfo && ae.stateNode.implementation === he.implementation) {
                    d(pe, ae.sibling), ae = S(ae, he.children || []), ae.return = pe, pe = ae;
                    break e;
                  } else {
                    d(pe, ae);
                    break;
                  }
                } else o(pe, ae);
                ae = ae.sibling;
              }
              ae = bf(he, pe.mode, He), ae.return = pe, pe = ae;
            }
            return A(pe);
          case ue:
            return bt = he._init, Kn(pe, ae, bt(he._payload), He);
        }
        if (St(he)) return it(pe, ae, he, He);
        if (le(he)) return st(pe, ae, he, He);
        Gd(pe, he);
      }
      return typeof he == "string" && he !== "" || typeof he == "number" ? (he = "" + he, ae !== null && ae.tag === 6 ? (d(pe, ae.sibling), ae = S(ae, he), ae.return = pe, pe = ae) : (d(pe, ae), ae = yf(he, pe.mode, He), ae.return = pe, pe = ae), A(pe)) : d(pe, ae);
    }
    return Kn;
  }
  var Vs = Wg(!0),
    qg = Wg(!1),
    Nl = {},
    _a = Ki(Nl),
    Qu = Ki(Nl),
    Bs = Ki(Nl);
  function dt(r) {
    if (r === Nl) throw Error(i(174));
    return r;
  }
  function Wt(r, o) {
    switch (ft(Bs, o), ft(Qu, r), ft(_a, Nl), r = o.nodeType, r) {
      case 9:
      case 11:
        o = (o = o.documentElement) ? o.namespaceURI : Xt(null, "");
        break;
      default:
        r = r === 8 ? o.parentNode : o, o = r.namespaceURI || null, r = r.tagName, o = Xt(o, r);
    }
    Sn(_a), ft(_a, o);
  }
  function nn() {
    Sn(_a), Sn(Qu), Sn(Bs);
  }
  function Xn(r) {
    dt(Bs.current);
    var o = dt(_a.current),
      d = Xt(o, r.type);
    o !== d && (ft(Qu, r), ft(_a, d));
  }
  function Ri(r) {
    Qu.current === r && (Sn(_a), Sn(Qu));
  }
  var Mn = Ki(0);
  function Xd(r) {
    for (var o = r; o !== null;) {
      if (o.tag === 13) {
        var d = o.memoizedState;
        if (d !== null && (d = d.dehydrated, d === null || d.data === "$?" || d.data === "$!")) return o;
      } else if (o.tag === 19 && o.memoizedProps.revealOrder !== void 0) {
        if ((o.flags & 128) !== 0) return o;
      } else if (o.child !== null) {
        o.child.return = o, o = o.child;
        continue;
      }
      if (o === r) break;
      for (; o.sibling === null;) {
        if (o.return === null || o.return === r) return null;
        o = o.return;
      }
      o.sibling.return = o.return, o = o.sibling;
    }
    return null;
  }
  var Ph = [];
  function Ah() {
    for (var r = 0; r < Ph.length; r++) Ph[r]._workInProgressVersionPrimary = null;
    Ph.length = 0;
  }
  var zl = j.ReactCurrentDispatcher,
    De = j.ReactCurrentBatchConfig,
    On = 0,
    Je = null,
    Ln = null,
    Cn = null,
    xa = !1,
    Qr = !1,
    no = 0,
    Vl = 0;
  function rr() {
    throw Error(i(321));
  }
  function Zu(r, o) {
    if (o === null) return !1;
    for (var d = 0; d < o.length && d < r.length; d++) if (!Gi(r[d], o[d])) return !1;
    return !0;
  }
  function Ju(r, o, d, g, S, R) {
    if (On = R, Je = o, o.memoizedState = null, o.updateQueue = null, o.lanes = 0, zl.current = r === null || r.memoizedState === null ? Lw : Fh, r = d(g, S), Qr) {
      R = 0;
      do {
        if (Qr = !1, no = 0, 25 <= R) throw Error(i(301));
        R += 1, Cn = Ln = null, o.updateQueue = null, zl.current = Qg, r = d(g, S);
      } while (Qr);
    }
    if (zl.current = ql, o = Ln !== null && Ln.next !== null, On = 0, Cn = Ln = Je = null, xa = !1, o) throw Error(i(300));
    return r;
  }
  function ec() {
    var r = no !== 0;
    return no = 0, r;
  }
  function Di() {
    var r = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return Cn === null ? Je.memoizedState = Cn = r : Cn = Cn.next = r, Cn;
  }
  function Zr() {
    if (Ln === null) {
      var r = Je.alternate;
      r = r !== null ? r.memoizedState : null;
    } else r = Ln.next;
    var o = Cn === null ? Je.memoizedState : Cn.next;
    if (o !== null) Cn = o, Ln = r;else {
      if (r === null) throw Error(i(310));
      Ln = r, r = {
        memoizedState: Ln.memoizedState,
        baseState: Ln.baseState,
        baseQueue: Ln.baseQueue,
        queue: Ln.queue,
        next: null
      }, Cn === null ? Je.memoizedState = Cn = r : Cn = Cn.next = r;
    }
    return Cn;
  }
  function Us(r, o) {
    return typeof o == "function" ? o(r) : o;
  }
  function tc(r) {
    var o = Zr(),
      d = o.queue;
    if (d === null) throw Error(i(311));
    d.lastRenderedReducer = r;
    var g = Ln,
      S = g.baseQueue,
      R = d.pending;
    if (R !== null) {
      if (S !== null) {
        var A = S.next;
        S.next = R.next, R.next = A;
      }
      g.baseQueue = S = R, d.pending = null;
    }
    if (S !== null) {
      R = S.next, g = g.baseState;
      var q = A = null,
        re = null,
        be = R;
      do {
        var Le = be.lane;
        if ((On & Le) === Le) re !== null && (re = re.next = {
          lane: 0,
          action: be.action,
          hasEagerState: be.hasEagerState,
          eagerState: be.eagerState,
          next: null
        }), g = be.hasEagerState ? be.eagerState : r(g, be.action);else {
          var Ve = {
            lane: Le,
            action: be.action,
            hasEagerState: be.hasEagerState,
            eagerState: be.eagerState,
            next: null
          };
          re === null ? (q = re = Ve, A = g) : re = re.next = Ve, Je.lanes |= Le, xo |= Le;
        }
        be = be.next;
      } while (be !== null && be !== R);
      re === null ? A = g : re.next = q, Gi(g, o.memoizedState) || (Dr = !0), o.memoizedState = g, o.baseState = A, o.baseQueue = re, d.lastRenderedState = g;
    }
    if (r = d.interleaved, r !== null) {
      S = r;
      do R = S.lane, Je.lanes |= R, xo |= R, S = S.next; while (S !== r);
    } else S === null && (d.lanes = 0);
    return [o.memoizedState, d.dispatch];
  }
  function nc(r) {
    var o = Zr(),
      d = o.queue;
    if (d === null) throw Error(i(311));
    d.lastRenderedReducer = r;
    var g = d.dispatch,
      S = d.pending,
      R = o.memoizedState;
    if (S !== null) {
      d.pending = null;
      var A = S = S.next;
      do R = r(R, A.action), A = A.next; while (A !== S);
      Gi(R, o.memoizedState) || (Dr = !0), o.memoizedState = R, o.baseQueue === null && (o.baseState = R), d.lastRenderedState = R;
    }
    return [R, g];
  }
  function Kd() {}
  function Qd(r, o) {
    var d = Je,
      g = Zr(),
      S = o(),
      R = !Gi(g.memoizedState, S);
    if (R && (g.memoizedState = S, Dr = !0), g = g.queue, of(ef.bind(null, d, g, r), [r]), g.getSnapshot !== o || R || Cn !== null && Cn.memoizedState.tag & 1) {
      if (d.flags |= 2048, Sa(9, Jd.bind(null, d, g, S, o), void 0, null), pr === null) throw Error(i(349));
      (On & 30) !== 0 || Zd(d, o, S);
    }
    return S;
  }
  function Zd(r, o, d) {
    r.flags |= 16384, r = {
      getSnapshot: o,
      value: d
    }, o = Je.updateQueue, o === null ? (o = {
      lastEffect: null,
      stores: null
    }, Je.updateQueue = o, o.stores = [r]) : (d = o.stores, d === null ? o.stores = [r] : d.push(r));
  }
  function Jd(r, o, d, g) {
    o.value = d, o.getSnapshot = g, tf(o) && nf(r);
  }
  function ef(r, o, d) {
    return d(function () {
      tf(o) && nf(r);
    });
  }
  function tf(r) {
    var o = r.getSnapshot;
    r = r.value;
    try {
      var d = o();
      return !Gi(r, d);
    } catch {
      return !0;
    }
  }
  function nf(r) {
    var o = En(r, 1);
    o !== null && Oi(o, r, 1, -1);
  }
  function rc(r) {
    var o = Di();
    return typeof r == "function" && (r = r()), o.memoizedState = o.baseState = r, r = {
      pending: null,
      interleaved: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: Us,
      lastRenderedState: r
    }, o.queue = r, r = r.dispatch = Ow.bind(null, Je, r), [o.memoizedState, r];
  }
  function Sa(r, o, d, g) {
    return r = {
      tag: r,
      create: o,
      destroy: d,
      deps: g,
      next: null
    }, o = Je.updateQueue, o === null ? (o = {
      lastEffect: null,
      stores: null
    }, Je.updateQueue = o, o.lastEffect = r.next = r) : (d = o.lastEffect, d === null ? o.lastEffect = r.next = r : (g = d.next, d.next = r, r.next = g, o.lastEffect = r)), r;
  }
  function rf() {
    return Zr().memoizedState;
  }
  function Bl(r, o, d, g) {
    var S = Di();
    Je.flags |= r, S.memoizedState = Sa(1 | o, d, void 0, g === void 0 ? null : g);
  }
  function Ul(r, o, d, g) {
    var S = Zr();
    g = g === void 0 ? null : g;
    var R = void 0;
    if (Ln !== null) {
      var A = Ln.memoizedState;
      if (R = A.destroy, g !== null && Zu(g, A.deps)) {
        S.memoizedState = Sa(o, d, R, g);
        return;
      }
    }
    Je.flags |= r, S.memoizedState = Sa(1 | o, d, R, g);
  }
  function af(r, o) {
    return Bl(8390656, 8, r, o);
  }
  function of(r, o) {
    return Ul(2048, 8, r, o);
  }
  function Hl(r, o) {
    return Ul(4, 2, r, o);
  }
  function jh(r, o) {
    return Ul(4, 4, r, o);
  }
  function $l(r, o) {
    if (typeof o == "function") return r = r(), o(r), function () {
      o(null);
    };
    if (o != null) return r = r(), o.current = r, function () {
      o.current = null;
    };
  }
  function Yo(r, o, d) {
    return d = d != null ? d.concat([r]) : null, Ul(4, 4, $l.bind(null, o, r), d);
  }
  function Jr() {}
  function Yg(r, o) {
    var d = Zr();
    o = o === void 0 ? null : o;
    var g = d.memoizedState;
    return g !== null && o !== null && Zu(o, g[1]) ? g[0] : (d.memoizedState = [r, o], r);
  }
  function wn(r, o) {
    var d = Zr();
    o = o === void 0 ? null : o;
    var g = d.memoizedState;
    return g !== null && o !== null && Zu(o, g[1]) ? g[0] : (r = r(), d.memoizedState = [r, o], r);
  }
  function ic(r, o, d) {
    return (On & 21) === 0 ? (r.baseState && (r.baseState = !1, Dr = !0), r.memoizedState = d) : (Gi(d, o) || (d = pd(), Je.lanes |= d, xo |= d, r.baseState = !0), o);
  }
  function sf(r, o) {
    var d = gn;
    gn = d !== 0 && 4 > d ? d : 4, r(!0);
    var g = De.transition;
    De.transition = {};
    try {
      r(!1), o();
    } finally {
      gn = d, De.transition = g;
    }
  }
  function Wl() {
    return Zr().memoizedState;
  }
  function lf(r, o, d) {
    var g = Ca(r);
    if (d = {
      lane: g,
      action: d,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Gg(r)) Xg(o, d);else if (d = Ng(r, o, d, g), d !== null) {
      var S = hr();
      Oi(d, r, g, S), Kg(d, o, g);
    }
  }
  function Ow(r, o, d) {
    var g = Ca(r),
      S = {
        lane: g,
        action: d,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
    if (Gg(r)) Xg(o, S);else {
      var R = r.alternate;
      if (r.lanes === 0 && (R === null || R.lanes === 0) && (R = o.lastRenderedReducer, R !== null)) try {
        var A = o.lastRenderedState,
          q = R(A, d);
        if (S.hasEagerState = !0, S.eagerState = q, Gi(q, A)) {
          var re = o.interleaved;
          re === null ? (S.next = S, Rh(o)) : (S.next = re.next, re.next = S), o.interleaved = S;
          return;
        }
      } catch {} finally {}
      d = Ng(r, o, S, g), d !== null && (S = hr(), Oi(d, r, g, S), Kg(d, o, g));
    }
  }
  function Gg(r) {
    var o = r.alternate;
    return r === Je || o !== null && o === Je;
  }
  function Xg(r, o) {
    Qr = xa = !0;
    var d = r.pending;
    d === null ? o.next = o : (o.next = d.next, d.next = o), r.pending = o;
  }
  function Kg(r, o, d) {
    if ((d & 4194240) !== 0) {
      var g = o.lanes;
      g &= r.pendingLanes, d |= g, o.lanes = d, hd(r, d);
    }
  }
  var ql = {
      readContext: ki,
      useCallback: rr,
      useContext: rr,
      useEffect: rr,
      useImperativeHandle: rr,
      useInsertionEffect: rr,
      useLayoutEffect: rr,
      useMemo: rr,
      useReducer: rr,
      useRef: rr,
      useState: rr,
      useDebugValue: rr,
      useDeferredValue: rr,
      useTransition: rr,
      useMutableSource: rr,
      useSyncExternalStore: rr,
      useId: rr,
      unstable_isNewReconciler: !1
    },
    Lw = {
      readContext: ki,
      useCallback: function (r, o) {
        return Di().memoizedState = [r, o === void 0 ? null : o], r;
      },
      useContext: ki,
      useEffect: af,
      useImperativeHandle: function (r, o, d) {
        return d = d != null ? d.concat([r]) : null, Bl(4194308, 4, $l.bind(null, o, r), d);
      },
      useLayoutEffect: function (r, o) {
        return Bl(4194308, 4, r, o);
      },
      useInsertionEffect: function (r, o) {
        return Bl(4, 2, r, o);
      },
      useMemo: function (r, o) {
        var d = Di();
        return o = o === void 0 ? null : o, r = r(), d.memoizedState = [r, o], r;
      },
      useReducer: function (r, o, d) {
        var g = Di();
        return o = d !== void 0 ? d(o) : o, g.memoizedState = g.baseState = o, r = {
          pending: null,
          interleaved: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: r,
          lastRenderedState: o
        }, g.queue = r, r = r.dispatch = lf.bind(null, Je, r), [g.memoizedState, r];
      },
      useRef: function (r) {
        var o = Di();
        return r = {
          current: r
        }, o.memoizedState = r;
      },
      useState: rc,
      useDebugValue: Jr,
      useDeferredValue: function (r) {
        return Di().memoizedState = r;
      },
      useTransition: function () {
        var r = rc(!1),
          o = r[0];
        return r = sf.bind(null, r[1]), Di().memoizedState = r, [o, r];
      },
      useMutableSource: function () {},
      useSyncExternalStore: function (r, o, d) {
        var g = Je,
          S = Di();
        if (In) {
          if (d === void 0) throw Error(i(407));
          d = d();
        } else {
          if (d = o(), pr === null) throw Error(i(349));
          (On & 30) !== 0 || Zd(g, o, d);
        }
        S.memoizedState = d;
        var R = {
          value: d,
          getSnapshot: o
        };
        return S.queue = R, af(ef.bind(null, g, R, r), [r]), g.flags |= 2048, Sa(9, Jd.bind(null, g, R, d, o), void 0, null), d;
      },
      useId: function () {
        var r = Di(),
          o = pr.identifierPrefix;
        if (In) {
          var d = ba,
            g = ya;
          d = (g & ~(1 << 32 - gi(g) - 1)).toString(32) + d, o = ":" + o + "R" + d, d = no++, 0 < d && (o += "H" + d.toString(32)), o += ":";
        } else d = Vl++, o = ":" + o + "r" + d.toString(32) + ":";
        return r.memoizedState = o;
      },
      unstable_isNewReconciler: !1
    },
    Fh = {
      readContext: ki,
      useCallback: Yg,
      useContext: ki,
      useEffect: of,
      useImperativeHandle: Yo,
      useInsertionEffect: Hl,
      useLayoutEffect: jh,
      useMemo: wn,
      useReducer: tc,
      useRef: rf,
      useState: function () {
        return tc(Us);
      },
      useDebugValue: Jr,
      useDeferredValue: function (r) {
        var o = Zr();
        return ic(o, Ln.memoizedState, r);
      },
      useTransition: function () {
        var r = tc(Us)[0],
          o = Zr().memoizedState;
        return [r, o];
      },
      useMutableSource: Kd,
      useSyncExternalStore: Qd,
      useId: Wl,
      unstable_isNewReconciler: !1
    },
    Qg = {
      readContext: ki,
      useCallback: Yg,
      useContext: ki,
      useEffect: of,
      useImperativeHandle: Yo,
      useInsertionEffect: Hl,
      useLayoutEffect: jh,
      useMemo: wn,
      useReducer: nc,
      useRef: rf,
      useState: function () {
        return nc(Us);
      },
      useDebugValue: Jr,
      useDeferredValue: function (r) {
        var o = Zr();
        return Ln === null ? o.memoizedState = r : ic(o, Ln.memoizedState, r);
      },
      useTransition: function () {
        var r = nc(Us)[0],
          o = Zr().memoizedState;
        return [r, o];
      },
      useMutableSource: Kd,
      useSyncExternalStore: Qd,
      useId: Wl,
      unstable_isNewReconciler: !1
    };
  function Yl(r, o) {
    try {
      var d = "",
        g = o;
      do d += fe(g), g = g.return; while (g);
      var S = d;
    } catch (R) {
      S = `
Error generating stack: ` + R.message + `
` + R.stack;
    }
    return {
      value: r,
      source: o,
      stack: S,
      digest: null
    };
  }
  function Nh(r, o, d) {
    return {
      value: r,
      source: null,
      stack: d ?? null,
      digest: o ?? null
    };
  }
  function Gl(r, o) {
    try {
      console.error(o.value);
    } catch (d) {
      setTimeout(function () {
        throw d;
      });
    }
  }
  var Pw = typeof WeakMap == "function" ? WeakMap : Map;
  function zh(r, o, d) {
    d = wa(-1, d), d.tag = 3, d.payload = {
      element: null
    };
    var g = o.value;
    return d.callback = function () {
      Kl || (Kl = !0, Yh = g), Gl(r, o);
    }, d;
  }
  function Vh(r, o, d) {
    d = wa(-1, d), d.tag = 3;
    var g = r.type.getDerivedStateFromError;
    if (typeof g == "function") {
      var S = o.value;
      d.payload = function () {
        return g(S);
      }, d.callback = function () {
        Gl(r, o);
      };
    }
    var R = r.stateNode;
    return R !== null && typeof R.componentDidCatch == "function" && (d.callback = function () {
      Gl(r, o), typeof g != "function" && (So === null ? So = /* @__PURE__ */new Set([this]) : So.add(this));
      var A = o.stack;
      this.componentDidCatch(o.value, {
        componentStack: A !== null ? A : ""
      });
    }), d;
  }
  function Zg(r, o, d) {
    var g = r.pingCache;
    if (g === null) {
      g = r.pingCache = new Pw();
      var S = /* @__PURE__ */new Set();
      g.set(o, S);
    } else S = g.get(o), S === void 0 && (S = /* @__PURE__ */new Set(), g.set(o, S));
    S.has(d) || (S.add(d), r = Fw.bind(null, r, o, d), o.then(r, r));
  }
  function Go(r) {
    do {
      var o;
      if ((o = r.tag === 13) && (o = r.memoizedState, o = o !== null ? o.dehydrated !== null : !0), o) return r;
      r = r.return;
    } while (r !== null);
    return null;
  }
  function Xl(r, o, d, g, S) {
    return (r.mode & 1) === 0 ? (r === o ? r.flags |= 65536 : (r.flags |= 128, d.flags |= 131072, d.flags &= -52805, d.tag === 1 && (d.alternate === null ? d.tag = 17 : (o = wa(-1, 1), o.tag = 2, Ti(d, o, 1))), d.lanes |= 1), r) : (r.flags |= 65536, r.lanes = S, r);
  }
  var Hs = j.ReactCurrentOwner,
    Dr = !1;
  function _n(r, o, d, g) {
    o.child = r === null ? qg(o, null, d, g) : Vs(o, r.child, d, g);
  }
  function $s(r, o, d, g, S) {
    d = d.render;
    var R = o.ref;
    return Fl(o, S), g = Ju(r, o, d, g, R, S), d = ec(), r !== null && !Dr ? (o.updateQueue = r.updateQueue, o.flags &= -2053, r.lanes &= ~S, Ir(r, o, S)) : (In && d && Bd(o), o.flags |= 1, _n(r, o, g, S), o.child);
  }
  function jt(r, o, d, g, S) {
    if (r === null) {
      var R = d.type;
      return typeof R == "function" && !Zh(R) && R.defaultProps === void 0 && d.compare === null && d.defaultProps === void 0 ? (o.tag = 15, o.type = R, ac(r, o, R, g, S)) : (r = Js(d.type, null, g, o, o.mode, S), r.ref = o.ref, r.return = o, o.child = r);
    }
    if (R = r.child, (r.lanes & S) === 0) {
      var A = R.memoizedProps;
      if (d = d.compare, d = d !== null ? d : Vu, d(A, g) && r.ref === o.ref) return Ir(r, o, S);
    }
    return o.flags |= 1, r = Oa(R, g), r.ref = o.ref, r.return = o, o.child = r;
  }
  function ac(r, o, d, g, S) {
    if (r !== null) {
      var R = r.memoizedProps;
      if (Vu(R, g) && r.ref === o.ref) if (Dr = !1, o.pendingProps = g = R, (r.lanes & S) !== 0) (r.flags & 131072) !== 0 && (Dr = !0);else return o.lanes = r.lanes, Ir(r, o, S);
    }
    return uf(r, o, d, g, S);
  }
  function Bh(r, o, d) {
    var g = o.pendingProps,
      S = g.children,
      R = r !== null ? r.memoizedState : null;
    if (g.mode === "hidden") {
      if ((o.mode & 1) === 0) o.memoizedState = {
        baseLanes: 0,
        cachePool: null,
        transitions: null
      }, ft(Ys, ei), ei |= d;else {
        if ((d & 1073741824) === 0) return r = R !== null ? R.baseLanes | d : d, o.lanes = o.childLanes = 1073741824, o.memoizedState = {
          baseLanes: r,
          cachePool: null,
          transitions: null
        }, o.updateQueue = null, ft(Ys, ei), ei |= r, null;
        o.memoizedState = {
          baseLanes: 0,
          cachePool: null,
          transitions: null
        }, g = R !== null ? R.baseLanes : d, ft(Ys, ei), ei |= g;
      }
    } else R !== null ? (g = R.baseLanes | d, o.memoizedState = null) : g = d, ft(Ys, ei), ei |= g;
    return _n(r, o, S, d), o.child;
  }
  function Sb(r, o) {
    var d = o.ref;
    (r === null && d !== null || r !== null && r.ref !== d) && (o.flags |= 512, o.flags |= 2097152);
  }
  function uf(r, o, d, g, S) {
    var R = tr(d) ? Yr : Hn.current;
    return R = xi(o, R), Fl(o, S), d = Ju(r, o, d, g, R, S), g = ec(), r !== null && !Dr ? (o.updateQueue = r.updateQueue, o.flags &= -2053, r.lanes &= ~S, Ir(r, o, S)) : (In && g && Bd(o), o.flags |= 1, _n(r, o, d, S), o.child);
  }
  function oc(r, o, d, g, S) {
    if (tr(d)) {
      var R = !0;
      Gr(o);
    } else R = !1;
    if (Fl(o, S), o.stateNode === null) ss(r, o), Oh(o, d, g), Lh(o, d, g, S), g = !0;else if (r === null) {
      var A = o.stateNode,
        q = o.memoizedProps;
      A.props = q;
      var re = A.context,
        be = d.contextType;
      typeof be == "object" && be !== null ? be = ki(be) : (be = tr(d) ? Yr : Hn.current, be = xi(o, be));
      var Le = d.getDerivedStateFromProps,
        Ve = typeof Le == "function" || typeof A.getSnapshotBeforeUpdate == "function";
      Ve || typeof A.UNSAFE_componentWillReceiveProps != "function" && typeof A.componentWillReceiveProps != "function" || (q !== g || re !== be) && Hg(o, A, g, be), qo = !1;
      var Oe = o.memoizedState;
      A.state = Oe, qd(o, g, A, S), re = o.memoizedState, q !== g || Oe !== re || or.current || qo ? (typeof Le == "function" && (Ih(o, d, Le, g), re = o.memoizedState), (q = qo || Mh(o, d, q, g, Oe, re, be)) ? (Ve || typeof A.UNSAFE_componentWillMount != "function" && typeof A.componentWillMount != "function" || (typeof A.componentWillMount == "function" && A.componentWillMount(), typeof A.UNSAFE_componentWillMount == "function" && A.UNSAFE_componentWillMount()), typeof A.componentDidMount == "function" && (o.flags |= 4194308)) : (typeof A.componentDidMount == "function" && (o.flags |= 4194308), o.memoizedProps = g, o.memoizedState = re), A.props = g, A.state = re, A.context = be, g = q) : (typeof A.componentDidMount == "function" && (o.flags |= 4194308), g = !1);
    } else {
      A = o.stateNode, zg(r, o), q = o.memoizedProps, be = o.type === o.elementType ? q : li(o.type, q), A.props = be, Ve = o.pendingProps, Oe = A.context, re = d.contextType, typeof re == "object" && re !== null ? re = ki(re) : (re = tr(d) ? Yr : Hn.current, re = xi(o, re));
      var et = d.getDerivedStateFromProps;
      (Le = typeof et == "function" || typeof A.getSnapshotBeforeUpdate == "function") || typeof A.UNSAFE_componentWillReceiveProps != "function" && typeof A.componentWillReceiveProps != "function" || (q !== Ve || Oe !== re) && Hg(o, A, g, re), qo = !1, Oe = o.memoizedState, A.state = Oe, qd(o, g, A, S);
      var it = o.memoizedState;
      q !== Ve || Oe !== it || or.current || qo ? (typeof et == "function" && (Ih(o, d, et, g), it = o.memoizedState), (be = qo || Mh(o, d, be, g, Oe, it, re) || !1) ? (Le || typeof A.UNSAFE_componentWillUpdate != "function" && typeof A.componentWillUpdate != "function" || (typeof A.componentWillUpdate == "function" && A.componentWillUpdate(g, it, re), typeof A.UNSAFE_componentWillUpdate == "function" && A.UNSAFE_componentWillUpdate(g, it, re)), typeof A.componentDidUpdate == "function" && (o.flags |= 4), typeof A.getSnapshotBeforeUpdate == "function" && (o.flags |= 1024)) : (typeof A.componentDidUpdate != "function" || q === r.memoizedProps && Oe === r.memoizedState || (o.flags |= 4), typeof A.getSnapshotBeforeUpdate != "function" || q === r.memoizedProps && Oe === r.memoizedState || (o.flags |= 1024), o.memoizedProps = g, o.memoizedState = it), A.props = g, A.state = it, A.context = re, g = be) : (typeof A.componentDidUpdate != "function" || q === r.memoizedProps && Oe === r.memoizedState || (o.flags |= 4), typeof A.getSnapshotBeforeUpdate != "function" || q === r.memoizedProps && Oe === r.memoizedState || (o.flags |= 1024), g = !1);
    }
    return sc(r, o, d, g, R, S);
  }
  function sc(r, o, d, g, S, R) {
    Sb(r, o);
    var A = (o.flags & 128) !== 0;
    if (!g && !A) return S && zd(o, d, !1), Ir(r, o, R);
    g = o.stateNode, Hs.current = o;
    var q = A && typeof d.getDerivedStateFromError != "function" ? null : g.render();
    return o.flags |= 1, r !== null && A ? (o.child = Vs(o, r.child, null, R), o.child = Vs(o, null, q, R)) : _n(r, o, q, R), o.memoizedState = g.state, S && zd(o, d, !0), o.child;
  }
  function Km(r) {
    var o = r.stateNode;
    o.pendingContext ? Ag(r, o.pendingContext, o.pendingContext !== o.context) : o.context && Ag(r, o.context, !1), Wt(r, o.containerInfo);
  }
  function Qm(r, o, d, g, S) {
    return Wo(), eo(S), o.flags |= 256, _n(r, o, d, g), o.child;
  }
  var cf = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
  };
  function df(r) {
    return {
      baseLanes: r,
      cachePool: null,
      transitions: null
    };
  }
  function Zm(r, o, d) {
    var g = o.pendingProps,
      S = Mn.current,
      R = !1,
      A = (o.flags & 128) !== 0,
      q;
    if ((q = A) || (q = r !== null && r.memoizedState === null ? !1 : (S & 2) !== 0), q ? (R = !0, o.flags &= -129) : (r === null || r.memoizedState !== null) && (S |= 1), ft(Mn, S & 1), r === null) return Th(o), r = o.memoizedState, r !== null && (r = r.dehydrated, r !== null) ? ((o.mode & 1) === 0 ? o.lanes = 1 : r.data === "$!" ? o.lanes = 8 : o.lanes = 1073741824, null) : (A = g.children, r = g.fallback, R ? (g = o.mode, R = o.child, A = {
      mode: "hidden",
      children: A
    }, (g & 1) === 0 && R !== null ? (R.childLanes = 0, R.pendingProps = A) : R = jc(A, g, 0, null), r = oo(r, g, d, null), R.return = o, r.return = o, R.sibling = r, o.child = R, o.child.memoizedState = df(d), o.memoizedState = cf, r) : ff(o, A));
    if (S = r.memoizedState, S !== null && (q = S.dehydrated, q !== null)) return as(r, o, A, g, q, S, d);
    if (R) {
      R = g.fallback, A = o.mode, S = r.child, q = S.sibling;
      var re = {
        mode: "hidden",
        children: g.children
      };
      return (A & 1) === 0 && o.child !== S ? (g = o.child, g.childLanes = 0, g.pendingProps = re, o.deletions = null) : (g = Oa(S, re), g.subtreeFlags = S.subtreeFlags & 14680064), q !== null ? R = Oa(q, R) : (R = oo(R, A, d, null), R.flags |= 2), R.return = o, g.return = o, g.sibling = R, o.child = g, g = R, R = o.child, A = r.child.memoizedState, A = A === null ? df(d) : {
        baseLanes: A.baseLanes | d,
        cachePool: null,
        transitions: A.transitions
      }, R.memoizedState = A, R.childLanes = r.childLanes & ~d, o.memoizedState = cf, g;
    }
    return R = r.child, r = R.sibling, g = Oa(R, {
      mode: "visible",
      children: g.children
    }), (o.mode & 1) === 0 && (g.lanes = d), g.return = o, g.sibling = null, r !== null && (d = o.deletions, d === null ? (o.deletions = [r], o.flags |= 16) : d.push(r)), o.child = g, o.memoizedState = null, g;
  }
  function ff(r, o) {
    return o = jc({
      mode: "visible",
      children: o
    }, r.mode, 0, null), o.return = r, r.child = o;
  }
  function lc(r, o, d, g) {
    return g !== null && eo(g), Vs(o, r.child, null, d), r = ff(o, o.pendingProps.children), r.flags |= 2, o.memoizedState = null, r;
  }
  function as(r, o, d, g, S, R, A) {
    if (d) return o.flags & 256 ? (o.flags &= -257, g = Nh(Error(i(422))), lc(r, o, A, g)) : o.memoizedState !== null ? (o.child = r.child, o.flags |= 128, null) : (R = g.fallback, S = o.mode, g = jc({
      mode: "visible",
      children: g.children
    }, S, 0, null), R = oo(R, S, A, null), R.flags |= 2, g.return = o, R.return = o, g.sibling = R, o.child = g, (o.mode & 1) !== 0 && Vs(o, r.child, null, A), o.child.memoizedState = df(A), o.memoizedState = cf, R);
    if ((o.mode & 1) === 0) return lc(r, o, A, null);
    if (S.data === "$!") {
      if (g = S.nextSibling && S.nextSibling.dataset, g) var q = g.dgst;
      return g = q, R = Error(i(419)), g = Nh(R, g, void 0), lc(r, o, A, g);
    }
    if (q = (A & r.childLanes) !== 0, Dr || q) {
      if (g = pr, g !== null) {
        switch (A & -A) {
          case 4:
            S = 2;
            break;
          case 16:
            S = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            S = 32;
            break;
          case 536870912:
            S = 268435456;
            break;
          default:
            S = 0;
        }
        S = (S & (g.suspendedLanes | A)) !== 0 ? 0 : S, S !== 0 && S !== R.retryLane && (R.retryLane = S, En(r, S), Oi(g, r, S, -1));
      }
      return Kh(), g = Nh(Error(i(421))), lc(r, o, A, g);
    }
    return S.data === "$?" ? (o.flags |= 128, o.child = r.child, o = Rb.bind(null, r), S._reactRetry = o, null) : (r = R.treeContext, Kr = ha(S.nextSibling), Xr = o, In = !0, Ei = null, r !== null && (nr[Si++] = ya, nr[Si++] = ba, nr[Si++] = si, ya = r.id, ba = r.overflow, si = o), o = ff(o, g.children), o.flags |= 4096, o);
  }
  function Ii(r, o, d) {
    r.lanes |= o;
    var g = r.alternate;
    g !== null && (g.lanes |= o), ui(r.return, o, d);
  }
  function Zi(r, o, d, g, S) {
    var R = r.memoizedState;
    R === null ? r.memoizedState = {
      isBackwards: o,
      rendering: null,
      renderingStartTime: 0,
      last: g,
      tail: d,
      tailMode: S
    } : (R.isBackwards = o, R.rendering = null, R.renderingStartTime = 0, R.last = g, R.tail = d, R.tailMode = S);
  }
  function os(r, o, d) {
    var g = o.pendingProps,
      S = g.revealOrder,
      R = g.tail;
    if (_n(r, o, g.children, d), g = Mn.current, (g & 2) !== 0) g = g & 1 | 2, o.flags |= 128;else {
      if (r !== null && (r.flags & 128) !== 0) e: for (r = o.child; r !== null;) {
        if (r.tag === 13) r.memoizedState !== null && Ii(r, d, o);else if (r.tag === 19) Ii(r, d, o);else if (r.child !== null) {
          r.child.return = r, r = r.child;
          continue;
        }
        if (r === o) break e;
        for (; r.sibling === null;) {
          if (r.return === null || r.return === o) break e;
          r = r.return;
        }
        r.sibling.return = r.return, r = r.sibling;
      }
      g &= 1;
    }
    if (ft(Mn, g), (o.mode & 1) === 0) o.memoizedState = null;else switch (S) {
      case "forwards":
        for (d = o.child, S = null; d !== null;) r = d.alternate, r !== null && Xd(r) === null && (S = d), d = d.sibling;
        d = S, d === null ? (S = o.child, o.child = null) : (S = d.sibling, d.sibling = null), Zi(o, !1, S, d, R);
        break;
      case "backwards":
        for (d = null, S = o.child, o.child = null; S !== null;) {
          if (r = S.alternate, r !== null && Xd(r) === null) {
            o.child = S;
            break;
          }
          r = S.sibling, S.sibling = d, d = S, S = r;
        }
        Zi(o, !0, d, null, R);
        break;
      case "together":
        Zi(o, !1, null, null, void 0);
        break;
      default:
        o.memoizedState = null;
    }
    return o.child;
  }
  function ss(r, o) {
    (o.mode & 1) === 0 && r !== null && (r.alternate = null, o.alternate = null, o.flags |= 2);
  }
  function Ir(r, o, d) {
    if (r !== null && (o.dependencies = r.dependencies), xo |= o.lanes, (d & o.childLanes) === 0) return null;
    if (r !== null && o.child !== r.child) throw Error(i(153));
    if (o.child !== null) {
      for (r = o.child, d = Oa(r, r.pendingProps), o.child = d, d.return = o; r.sibling !== null;) r = r.sibling, d = d.sibling = Oa(r, r.pendingProps), d.return = o;
      d.sibling = null;
    }
    return o.child;
  }
  function zr(r, o, d) {
    switch (o.tag) {
      case 3:
        Km(o), Wo();
        break;
      case 5:
        Xn(o);
        break;
      case 1:
        tr(o.type) && Gr(o);
        break;
      case 4:
        Wt(o, o.stateNode.containerInfo);
        break;
      case 10:
        var g = o.type._context,
          S = o.memoizedProps.value;
        ft($d, g._currentValue), g._currentValue = S;
        break;
      case 13:
        if (g = o.memoizedState, g !== null) return g.dehydrated !== null ? (ft(Mn, Mn.current & 1), o.flags |= 128, null) : (d & o.child.childLanes) !== 0 ? Zm(r, o, d) : (ft(Mn, Mn.current & 1), r = Ir(r, o, d), r !== null ? r.sibling : null);
        ft(Mn, Mn.current & 1);
        break;
      case 19:
        if (g = (d & o.childLanes) !== 0, (r.flags & 128) !== 0) {
          if (g) return os(r, o, d);
          o.flags |= 128;
        }
        if (S = o.memoizedState, S !== null && (S.rendering = null, S.tail = null, S.lastEffect = null), ft(Mn, Mn.current), g) break;
        return null;
      case 22:
      case 23:
        return o.lanes = 0, Bh(r, o, d);
    }
    return Ir(r, o, d);
  }
  var la, Uh, Jg, Hh;
  la = function (r, o) {
    for (var d = o.child; d !== null;) {
      if (d.tag === 5 || d.tag === 6) r.appendChild(d.stateNode);else if (d.tag !== 4 && d.child !== null) {
        d.child.return = d, d = d.child;
        continue;
      }
      if (d === o) break;
      for (; d.sibling === null;) {
        if (d.return === null || d.return === o) return;
        d = d.return;
      }
      d.sibling.return = d.return, d = d.sibling;
    }
  }, Uh = function () {}, Jg = function (r, o, d, g) {
    var S = r.memoizedProps;
    if (S !== g) {
      r = o.stateNode, dt(_a.current);
      var R = null;
      switch (d) {
        case "input":
          S = Ae(r, S), g = Ae(r, g), R = [];
          break;
        case "select":
          S = H({}, S, {
            value: void 0
          }), g = H({}, g, {
            value: void 0
          }), R = [];
          break;
        case "textarea":
          S = Kt(r, S), g = Kt(r, g), R = [];
          break;
        default:
          typeof S.onClick != "function" && typeof g.onClick == "function" && (r.onclick = zo);
      }
      kt(d, g);
      var A;
      d = null;
      for (be in S) if (!g.hasOwnProperty(be) && S.hasOwnProperty(be) && S[be] != null) if (be === "style") {
        var q = S[be];
        for (A in q) q.hasOwnProperty(A) && (d || (d = {}), d[A] = "");
      } else be !== "dangerouslySetInnerHTML" && be !== "children" && be !== "suppressContentEditableWarning" && be !== "suppressHydrationWarning" && be !== "autoFocus" && (c.hasOwnProperty(be) ? R || (R = []) : (R = R || []).push(be, null));
      for (be in g) {
        var re = g[be];
        if (q = S != null ? S[be] : void 0, g.hasOwnProperty(be) && re !== q && (re != null || q != null)) if (be === "style") {
          if (q) {
            for (A in q) !q.hasOwnProperty(A) || re && re.hasOwnProperty(A) || (d || (d = {}), d[A] = "");
            for (A in re) re.hasOwnProperty(A) && q[A] !== re[A] && (d || (d = {}), d[A] = re[A]);
          } else d || (R || (R = []), R.push(be, d)), d = re;
        } else be === "dangerouslySetInnerHTML" ? (re = re ? re.__html : void 0, q = q ? q.__html : void 0, re != null && q !== re && (R = R || []).push(be, re)) : be === "children" ? typeof re != "string" && typeof re != "number" || (R = R || []).push(be, "" + re) : be !== "suppressContentEditableWarning" && be !== "suppressHydrationWarning" && (c.hasOwnProperty(be) ? (re != null && be === "onScroll" && mn("scroll", r), R || q === re || (R = [])) : (R = R || []).push(be, re));
      }
      d && (R = R || []).push("style", d);
      var be = R;
      (o.updateQueue = be) && (o.flags |= 4);
    }
  }, Hh = function (r, o, d, g) {
    d !== g && (o.flags |= 4);
  };
  function ul(r, o) {
    if (!In) switch (r.tailMode) {
      case "hidden":
        o = r.tail;
        for (var d = null; o !== null;) o.alternate !== null && (d = o), o = o.sibling;
        d === null ? r.tail = null : d.sibling = null;
        break;
      case "collapsed":
        d = r.tail;
        for (var g = null; d !== null;) d.alternate !== null && (g = d), d = d.sibling;
        g === null ? o || r.tail === null ? r.tail = null : r.tail.sibling = null : g.sibling = null;
    }
  }
  function fr(r) {
    var o = r.alternate !== null && r.alternate.child === r.child,
      d = 0,
      g = 0;
    if (o) for (var S = r.child; S !== null;) d |= S.lanes | S.childLanes, g |= S.subtreeFlags & 14680064, g |= S.flags & 14680064, S.return = r, S = S.sibling;else for (S = r.child; S !== null;) d |= S.lanes | S.childLanes, g |= S.subtreeFlags, g |= S.flags, S.return = r, S = S.sibling;
    return r.subtreeFlags |= g, r.childLanes = d, o;
  }
  function $h(r, o, d) {
    var g = o.pendingProps;
    switch (Ud(o), o.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return fr(o), null;
      case 1:
        return tr(o.type) && Al(), fr(o), null;
      case 3:
        return g = o.stateNode, nn(), Sn(or), Sn(Hn), Ah(), g.pendingContext && (g.context = g.pendingContext, g.pendingContext = null), (r === null || r.child === null) && (Hd(o) ? o.flags |= 4 : r === null || r.memoizedState.isDehydrated && (o.flags & 256) === 0 || (o.flags |= 1024, Ei !== null && (Pc(Ei), Ei = null))), Uh(r, o), fr(o), null;
      case 5:
        Ri(o);
        var S = dt(Bs.current);
        if (d = o.type, r !== null && o.stateNode != null) Jg(r, o, d, g, S), r.ref !== o.ref && (o.flags |= 512, o.flags |= 2097152);else {
          if (!g) {
            if (o.stateNode === null) throw Error(i(166));
            return fr(o), null;
          }
          if (r = dt(_a.current), Hd(o)) {
            g = o.stateNode, d = o.type;
            var R = o.memoizedProps;
            switch (g[ma] = o, g[qu] = R, r = (o.mode & 1) !== 0, d) {
              case "dialog":
                mn("cancel", g), mn("close", g);
                break;
              case "iframe":
              case "object":
              case "embed":
                mn("load", g);
                break;
              case "video":
              case "audio":
                for (S = 0; S < Hu.length; S++) mn(Hu[S], g);
                break;
              case "source":
                mn("error", g);
                break;
              case "img":
              case "image":
              case "link":
                mn("error", g), mn("load", g);
                break;
              case "details":
                mn("toggle", g);
                break;
              case "input":
                Mt(g, R), mn("invalid", g);
                break;
              case "select":
                g._wrapperState = {
                  wasMultiple: !!R.multiple
                }, mn("invalid", g);
                break;
              case "textarea":
                hn(g, R), mn("invalid", g);
            }
            kt(d, R), S = null;
            for (var A in R) if (R.hasOwnProperty(A)) {
              var q = R[A];
              A === "children" ? typeof q == "string" ? g.textContent !== q && (R.suppressHydrationWarning !== !0 && Ad(g.textContent, q, r), S = ["children", q]) : typeof q == "number" && g.textContent !== "" + q && (R.suppressHydrationWarning !== !0 && Ad(g.textContent, q, r), S = ["children", "" + q]) : c.hasOwnProperty(A) && q != null && A === "onScroll" && mn("scroll", g);
            }
            switch (d) {
              case "input":
                Xe(g), gt(g, R, !0);
                break;
              case "textarea":
                Xe(g), Et(g);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof R.onClick == "function" && (g.onclick = zo);
            }
            g = S, o.updateQueue = g, g !== null && (o.flags |= 4);
          } else {
            A = S.nodeType === 9 ? S : S.ownerDocument, r === "http://www.w3.org/1999/xhtml" && (r = Vt(d)), r === "http://www.w3.org/1999/xhtml" ? d === "script" ? (r = A.createElement("div"), r.innerHTML = "<script><\/script>", r = r.removeChild(r.firstChild)) : typeof g.is == "string" ? r = A.createElement(d, {
              is: g.is
            }) : (r = A.createElement(d), d === "select" && (A = r, g.multiple ? A.multiple = !0 : g.size && (A.size = g.size))) : r = A.createElementNS(r, d), r[ma] = o, r[qu] = g, la(r, o, !1, !1), o.stateNode = r;
            e: {
              switch (A = Bt(d, g), d) {
                case "dialog":
                  mn("cancel", r), mn("close", r), S = g;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  mn("load", r), S = g;
                  break;
                case "video":
                case "audio":
                  for (S = 0; S < Hu.length; S++) mn(Hu[S], r);
                  S = g;
                  break;
                case "source":
                  mn("error", r), S = g;
                  break;
                case "img":
                case "image":
                case "link":
                  mn("error", r), mn("load", r), S = g;
                  break;
                case "details":
                  mn("toggle", r), S = g;
                  break;
                case "input":
                  Mt(r, g), S = Ae(r, g), mn("invalid", r);
                  break;
                case "option":
                  S = g;
                  break;
                case "select":
                  r._wrapperState = {
                    wasMultiple: !!g.multiple
                  }, S = H({}, g, {
                    value: void 0
                  }), mn("invalid", r);
                  break;
                case "textarea":
                  hn(r, g), S = Kt(r, g), mn("invalid", r);
                  break;
                default:
                  S = g;
              }
              kt(d, S), q = S;
              for (R in q) if (q.hasOwnProperty(R)) {
                var re = q[R];
                R === "style" ? je(r, re) : R === "dangerouslySetInnerHTML" ? (re = re ? re.__html : void 0, re != null && ot(r, re)) : R === "children" ? typeof re == "string" ? (d !== "textarea" || re !== "") && We(r, re) : typeof re == "number" && We(r, "" + re) : R !== "suppressContentEditableWarning" && R !== "suppressHydrationWarning" && R !== "autoFocus" && (c.hasOwnProperty(R) ? re != null && R === "onScroll" && mn("scroll", r) : re != null && F(r, R, re, A));
              }
              switch (d) {
                case "input":
                  Xe(r), gt(r, g, !1);
                  break;
                case "textarea":
                  Xe(r), Et(r);
                  break;
                case "option":
                  g.value != null && r.setAttribute("value", "" + ve(g.value));
                  break;
                case "select":
                  r.multiple = !!g.multiple, R = g.value, R != null ? Dt(r, !!g.multiple, R, !1) : g.defaultValue != null && Dt(r, !!g.multiple, g.defaultValue, !0);
                  break;
                default:
                  typeof S.onClick == "function" && (r.onclick = zo);
              }
              switch (d) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  g = !!g.autoFocus;
                  break e;
                case "img":
                  g = !0;
                  break e;
                default:
                  g = !1;
              }
            }
            g && (o.flags |= 4);
          }
          o.ref !== null && (o.flags |= 512, o.flags |= 2097152);
        }
        return fr(o), null;
      case 6:
        if (r && o.stateNode != null) Hh(r, o, r.memoizedProps, g);else {
          if (typeof g != "string" && o.stateNode === null) throw Error(i(166));
          if (d = dt(Bs.current), dt(_a.current), Hd(o)) {
            if (g = o.stateNode, d = o.memoizedProps, g[ma] = o, (R = g.nodeValue !== d) && (r = Xr, r !== null)) switch (r.tag) {
              case 3:
                Ad(g.nodeValue, d, (r.mode & 1) !== 0);
                break;
              case 5:
                r.memoizedProps.suppressHydrationWarning !== !0 && Ad(g.nodeValue, d, (r.mode & 1) !== 0);
            }
            R && (o.flags |= 4);
          } else g = (d.nodeType === 9 ? d : d.ownerDocument).createTextNode(g), g[ma] = o, o.stateNode = g;
        }
        return fr(o), null;
      case 13:
        if (Sn(Mn), g = o.memoizedState, r === null || r.memoizedState !== null && r.memoizedState.dehydrated !== null) {
          if (In && Kr !== null && (o.mode & 1) !== 0 && (o.flags & 128) === 0) Xu(), Wo(), o.flags |= 98560, R = !1;else if (R = Hd(o), g !== null && g.dehydrated !== null) {
            if (r === null) {
              if (!R) throw Error(i(318));
              if (R = o.memoizedState, R = R !== null ? R.dehydrated : null, !R) throw Error(i(317));
              R[ma] = o;
            } else Wo(), (o.flags & 128) === 0 && (o.memoizedState = null), o.flags |= 4;
            fr(o), R = !1;
          } else Ei !== null && (Pc(Ei), Ei = null), R = !0;
          if (!R) return o.flags & 65536 ? o : null;
        }
        return (o.flags & 128) !== 0 ? (o.lanes = d, o) : (g = g !== null, g !== (r !== null && r.memoizedState !== null) && g && (o.child.flags |= 8192, (o.mode & 1) !== 0 && (r === null || (Mn.current & 1) !== 0 ? Zn === 0 && (Zn = 3) : Kh())), o.updateQueue !== null && (o.flags |= 4), fr(o), null);
      case 4:
        return nn(), Uh(r, o), r === null && Il(o.stateNode.containerInfo), fr(o), null;
      case 10:
        return Ci(o.type._context), fr(o), null;
      case 17:
        return tr(o.type) && Al(), fr(o), null;
      case 19:
        if (Sn(Mn), R = o.memoizedState, R === null) return fr(o), null;
        if (g = (o.flags & 128) !== 0, A = R.rendering, A === null) {
          if (g) ul(R, !1);else {
            if (Zn !== 0 || r !== null && (r.flags & 128) !== 0) for (r = o.child; r !== null;) {
              if (A = Xd(r), A !== null) {
                for (o.flags |= 128, ul(R, !1), g = A.updateQueue, g !== null && (o.updateQueue = g, o.flags |= 4), o.subtreeFlags = 0, g = d, d = o.child; d !== null;) R = d, r = g, R.flags &= 14680066, A = R.alternate, A === null ? (R.childLanes = 0, R.lanes = r, R.child = null, R.subtreeFlags = 0, R.memoizedProps = null, R.memoizedState = null, R.updateQueue = null, R.dependencies = null, R.stateNode = null) : (R.childLanes = A.childLanes, R.lanes = A.lanes, R.child = A.child, R.subtreeFlags = 0, R.deletions = null, R.memoizedProps = A.memoizedProps, R.memoizedState = A.memoizedState, R.updateQueue = A.updateQueue, R.type = A.type, r = A.dependencies, R.dependencies = r === null ? null : {
                  lanes: r.lanes,
                  firstContext: r.firstContext
                }), d = d.sibling;
                return ft(Mn, Mn.current & 1 | 2), o.child;
              }
              r = r.sibling;
            }
            R.tail !== null && yn() > ao && (o.flags |= 128, g = !0, ul(R, !1), o.lanes = 4194304);
          }
        } else {
          if (!g) if (r = Xd(A), r !== null) {
            if (o.flags |= 128, g = !0, d = r.updateQueue, d !== null && (o.updateQueue = d, o.flags |= 4), ul(R, !0), R.tail === null && R.tailMode === "hidden" && !A.alternate && !In) return fr(o), null;
          } else 2 * yn() - R.renderingStartTime > ao && d !== 1073741824 && (o.flags |= 128, g = !0, ul(R, !1), o.lanes = 4194304);
          R.isBackwards ? (A.sibling = o.child, o.child = A) : (d = R.last, d !== null ? d.sibling = A : o.child = A, R.last = A);
        }
        return R.tail !== null ? (o = R.tail, R.rendering = o, R.tail = o.sibling, R.renderingStartTime = yn(), o.sibling = null, d = Mn.current, ft(Mn, g ? d & 1 | 2 : d & 1), o) : (fr(o), null);
      case 22:
      case 23:
        return gf(), g = o.memoizedState !== null, r !== null && r.memoizedState !== null !== g && (o.flags |= 8192), g && (o.mode & 1) !== 0 ? (ei & 1073741824) !== 0 && (fr(o), o.subtreeFlags & 6 && (o.flags |= 8192)) : fr(o), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(i(156, o.tag));
  }
  function Eb(r, o) {
    switch (Ud(o), o.tag) {
      case 1:
        return tr(o.type) && Al(), r = o.flags, r & 65536 ? (o.flags = r & -65537 | 128, o) : null;
      case 3:
        return nn(), Sn(or), Sn(Hn), Ah(), r = o.flags, (r & 65536) !== 0 && (r & 128) === 0 ? (o.flags = r & -65537 | 128, o) : null;
      case 5:
        return Ri(o), null;
      case 13:
        if (Sn(Mn), r = o.memoizedState, r !== null && r.dehydrated !== null) {
          if (o.alternate === null) throw Error(i(340));
          Wo();
        }
        return r = o.flags, r & 65536 ? (o.flags = r & -65537 | 128, o) : null;
      case 19:
        return Sn(Mn), null;
      case 4:
        return nn(), null;
      case 10:
        return Ci(o.type._context), null;
      case 22:
      case 23:
        return gf(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var pf = !1,
    xr = !1,
    ey = typeof WeakSet == "function" ? WeakSet : Set,
    tt = null;
  function cl(r, o) {
    var d = r.ref;
    if (d !== null) if (typeof d == "function") try {
      d(null);
    } catch (g) {
      $n(r, o, g);
    } else d.current = null;
  }
  function Wh(r, o, d) {
    try {
      d();
    } catch (g) {
      $n(r, o, g);
    }
  }
  var Jm = !1;
  function Cb(r, o) {
    if (Wu = Ds, r = Bu(), Td(r)) {
      if ("selectionStart" in r) var d = {
        start: r.selectionStart,
        end: r.selectionEnd
      };else e: {
        d = (d = r.ownerDocument) && d.defaultView || window;
        var g = d.getSelection && d.getSelection();
        if (g && g.rangeCount !== 0) {
          d = g.anchorNode;
          var S = g.anchorOffset,
            R = g.focusNode;
          g = g.focusOffset;
          try {
            d.nodeType, R.nodeType;
          } catch {
            d = null;
            break e;
          }
          var A = 0,
            q = -1,
            re = -1,
            be = 0,
            Le = 0,
            Ve = r,
            Oe = null;
          t: for (;;) {
            for (var et; Ve !== d || S !== 0 && Ve.nodeType !== 3 || (q = A + S), Ve !== R || g !== 0 && Ve.nodeType !== 3 || (re = A + g), Ve.nodeType === 3 && (A += Ve.nodeValue.length), (et = Ve.firstChild) !== null;) Oe = Ve, Ve = et;
            for (;;) {
              if (Ve === r) break t;
              if (Oe === d && ++be === S && (q = A), Oe === R && ++Le === g && (re = A), (et = Ve.nextSibling) !== null) break;
              Ve = Oe, Oe = Ve.parentNode;
            }
            Ve = et;
          }
          d = q === -1 || re === -1 ? null : {
            start: q,
            end: re
          };
        } else d = null;
      }
      d = d || {
        start: 0,
        end: 0
      };
    } else d = null;
    for (js = {
      focusedElem: r,
      selectionRange: d
    }, Ds = !1, tt = o; tt !== null;) if (o = tt, r = o.child, (o.subtreeFlags & 1028) !== 0 && r !== null) r.return = o, tt = r;else for (; tt !== null;) {
      o = tt;
      try {
        var it = o.alternate;
        if ((o.flags & 1024) !== 0) switch (o.tag) {
          case 0:
          case 11:
          case 15:
            break;
          case 1:
            if (it !== null) {
              var st = it.memoizedProps,
                Kn = it.memoizedState,
                pe = o.stateNode,
                ae = pe.getSnapshotBeforeUpdate(o.elementType === o.type ? st : li(o.type, st), Kn);
              pe.__reactInternalSnapshotBeforeUpdate = ae;
            }
            break;
          case 3:
            var he = o.stateNode.containerInfo;
            he.nodeType === 1 ? he.textContent = "" : he.nodeType === 9 && he.documentElement && he.removeChild(he.documentElement);
            break;
          case 5:
          case 6:
          case 4:
          case 17:
            break;
          default:
            throw Error(i(163));
        }
      } catch (He) {
        $n(o, o.return, He);
      }
      if (r = o.sibling, r !== null) {
        r.return = o.return, tt = r;
        break;
      }
      tt = o.return;
    }
    return it = Jm, Jm = !1, it;
  }
  function du(r, o, d) {
    var g = o.updateQueue;
    if (g = g !== null ? g.lastEffect : null, g !== null) {
      var S = g = g.next;
      do {
        if ((S.tag & r) === r) {
          var R = S.destroy;
          S.destroy = void 0, R !== void 0 && Wh(o, d, R);
        }
        S = S.next;
      } while (S !== g);
    }
  }
  function uc(r, o) {
    if (o = o.updateQueue, o = o !== null ? o.lastEffect : null, o !== null) {
      var d = o = o.next;
      do {
        if ((d.tag & r) === r) {
          var g = d.create;
          d.destroy = g();
        }
        d = d.next;
      } while (d !== o);
    }
  }
  function fu(r) {
    var o = r.ref;
    if (o !== null) {
      var d = r.stateNode;
      switch (r.tag) {
        case 5:
          r = d;
          break;
        default:
          r = d;
      }
      typeof o == "function" ? o(r) : o.current = r;
    }
  }
  function Ws(r) {
    var o = r.alternate;
    o !== null && (r.alternate = null, Ws(o)), r.child = null, r.deletions = null, r.sibling = null, r.tag === 5 && (o = r.stateNode, o !== null && (delete o[ma], delete o[qu], delete o[Yu], delete o[Pl], delete o[Iw])), r.stateNode = null, r.return = null, r.dependencies = null, r.memoizedProps = null, r.memoizedState = null, r.pendingProps = null, r.stateNode = null, r.updateQueue = null;
  }
  function ro(r) {
    return r.tag === 5 || r.tag === 3 || r.tag === 4;
  }
  function io(r) {
    e: for (;;) {
      for (; r.sibling === null;) {
        if (r.return === null || ro(r.return)) return null;
        r = r.return;
      }
      for (r.sibling.return = r.return, r = r.sibling; r.tag !== 5 && r.tag !== 6 && r.tag !== 18;) {
        if (r.flags & 2 || r.child === null || r.tag === 4) continue e;
        r.child.return = r, r = r.child;
      }
      if (!(r.flags & 2)) return r.stateNode;
    }
  }
  function wo(r, o, d) {
    var g = r.tag;
    if (g === 5 || g === 6) r = r.stateNode, o ? d.nodeType === 8 ? d.parentNode.insertBefore(r, o) : d.insertBefore(r, o) : (d.nodeType === 8 ? (o = d.parentNode, o.insertBefore(r, d)) : (o = d, o.appendChild(r)), d = d._reactRootContainer, d != null || o.onclick !== null || (o.onclick = zo));else if (g !== 4 && (r = r.child, r !== null)) for (wo(r, o, d), r = r.sibling; r !== null;) wo(r, o, d), r = r.sibling;
  }
  function qs(r, o, d) {
    var g = r.tag;
    if (g === 5 || g === 6) r = r.stateNode, o ? d.insertBefore(r, o) : d.appendChild(r);else if (g !== 4 && (r = r.child, r !== null)) for (qs(r, o, d), r = r.sibling; r !== null;) qs(r, o, d), r = r.sibling;
  }
  var Nn = null,
    Vr = !1;
  function Xo(r, o, d) {
    for (d = d.child; d !== null;) ty(r, o, d), d = d.sibling;
  }
  function ty(r, o, d) {
    if (qi && typeof qi.onCommitFiberUnmount == "function") try {
      qi.onCommitFiberUnmount(Iu, d);
    } catch {}
    switch (d.tag) {
      case 5:
        xr || cl(d, o);
      case 6:
        var g = Nn,
          S = Vr;
        Nn = null, Xo(r, o, d), Nn = g, Vr = S, Nn !== null && (Vr ? (r = Nn, d = d.stateNode, r.nodeType === 8 ? r.parentNode.removeChild(d) : r.removeChild(d)) : Nn.removeChild(d.stateNode));
        break;
      case 18:
        Nn !== null && (Vr ? (r = Nn, d = d.stateNode, r.nodeType === 8 ? Ll(r.parentNode, d) : r.nodeType === 1 && Ll(r, d), jo(r)) : Ll(Nn, d.stateNode));
        break;
      case 4:
        g = Nn, S = Vr, Nn = d.stateNode.containerInfo, Vr = !0, Xo(r, o, d), Nn = g, Vr = S;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!xr && (g = d.updateQueue, g !== null && (g = g.lastEffect, g !== null))) {
          S = g = g.next;
          do {
            var R = S,
              A = R.destroy;
            R = R.tag, A !== void 0 && ((R & 2) !== 0 || (R & 4) !== 0) && Wh(d, o, A), S = S.next;
          } while (S !== g);
        }
        Xo(r, o, d);
        break;
      case 1:
        if (!xr && (cl(d, o), g = d.stateNode, typeof g.componentWillUnmount == "function")) try {
          g.props = d.memoizedProps, g.state = d.memoizedState, g.componentWillUnmount();
        } catch (q) {
          $n(d, o, q);
        }
        Xo(r, o, d);
        break;
      case 21:
        Xo(r, o, d);
        break;
      case 22:
        d.mode & 1 ? (xr = (g = xr) || d.memoizedState !== null, Xo(r, o, d), xr = g) : Xo(r, o, d);
        break;
      default:
        Xo(r, o, d);
    }
  }
  function ev(r) {
    var o = r.updateQueue;
    if (o !== null) {
      r.updateQueue = null;
      var d = r.stateNode;
      d === null && (d = r.stateNode = new ey()), o.forEach(function (g) {
        var S = Nw.bind(null, r, g);
        d.has(g) || (d.add(g), g.then(S, S));
      });
    }
  }
  function ri(r, o) {
    var d = o.deletions;
    if (d !== null) for (var g = 0; g < d.length; g++) {
      var S = d[g];
      try {
        var R = r,
          A = o,
          q = A;
        e: for (; q !== null;) {
          switch (q.tag) {
            case 5:
              Nn = q.stateNode, Vr = !1;
              break e;
            case 3:
              Nn = q.stateNode.containerInfo, Vr = !0;
              break e;
            case 4:
              Nn = q.stateNode.containerInfo, Vr = !0;
              break e;
          }
          q = q.return;
        }
        if (Nn === null) throw Error(i(160));
        ty(R, A, S), Nn = null, Vr = !1;
        var re = S.alternate;
        re !== null && (re.return = null), S.return = null;
      } catch (be) {
        $n(S, o, be);
      }
    }
    if (o.subtreeFlags & 12854) for (o = o.child; o !== null;) hf(o, r), o = o.sibling;
  }
  function hf(r, o) {
    var d = r.alternate,
      g = r.flags;
    switch (r.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (ri(o, r), ua(r), g & 4) {
          try {
            du(3, r, r.return), uc(3, r);
          } catch (st) {
            $n(r, r.return, st);
          }
          try {
            du(5, r, r.return);
          } catch (st) {
            $n(r, r.return, st);
          }
        }
        break;
      case 1:
        ri(o, r), ua(r), g & 512 && d !== null && cl(d, d.return);
        break;
      case 5:
        if (ri(o, r), ua(r), g & 512 && d !== null && cl(d, d.return), r.flags & 32) {
          var S = r.stateNode;
          try {
            We(S, "");
          } catch (st) {
            $n(r, r.return, st);
          }
        }
        if (g & 4 && (S = r.stateNode, S != null)) {
          var R = r.memoizedProps,
            A = d !== null ? d.memoizedProps : R,
            q = r.type,
            re = r.updateQueue;
          if (r.updateQueue = null, re !== null) try {
            q === "input" && R.type === "radio" && R.name != null && Ft(S, R), Bt(q, A);
            var be = Bt(q, R);
            for (A = 0; A < re.length; A += 2) {
              var Le = re[A],
                Ve = re[A + 1];
              Le === "style" ? je(S, Ve) : Le === "dangerouslySetInnerHTML" ? ot(S, Ve) : Le === "children" ? We(S, Ve) : F(S, Le, Ve, be);
            }
            switch (q) {
              case "input":
                un(S, R);
                break;
              case "textarea":
                Ot(S, R);
                break;
              case "select":
                var Oe = S._wrapperState.wasMultiple;
                S._wrapperState.wasMultiple = !!R.multiple;
                var et = R.value;
                et != null ? Dt(S, !!R.multiple, et, !1) : Oe !== !!R.multiple && (R.defaultValue != null ? Dt(S, !!R.multiple, R.defaultValue, !0) : Dt(S, !!R.multiple, R.multiple ? [] : "", !1));
            }
            S[qu] = R;
          } catch (st) {
            $n(r, r.return, st);
          }
        }
        break;
      case 6:
        if (ri(o, r), ua(r), g & 4) {
          if (r.stateNode === null) throw Error(i(162));
          S = r.stateNode, R = r.memoizedProps;
          try {
            S.nodeValue = R;
          } catch (st) {
            $n(r, r.return, st);
          }
        }
        break;
      case 3:
        if (ri(o, r), ua(r), g & 4 && d !== null && d.memoizedState.isDehydrated) try {
          jo(o.containerInfo);
        } catch (st) {
          $n(r, r.return, st);
        }
        break;
      case 4:
        ri(o, r), ua(r);
        break;
      case 13:
        ri(o, r), ua(r), S = r.child, S.flags & 8192 && (R = S.memoizedState !== null, S.stateNode.isHidden = R, !R || S.alternate !== null && S.alternate.memoizedState !== null || (fc = yn())), g & 4 && ev(r);
        break;
      case 22:
        if (Le = d !== null && d.memoizedState !== null, r.mode & 1 ? (xr = (be = xr) || Le, ri(o, r), xr = be) : ri(o, r), ua(r), g & 8192) {
          if (be = r.memoizedState !== null, (r.stateNode.isHidden = be) && !Le && (r.mode & 1) !== 0) for (tt = r, Le = r.child; Le !== null;) {
            for (Ve = tt = Le; tt !== null;) {
              switch (Oe = tt, et = Oe.child, Oe.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  du(4, Oe, Oe.return);
                  break;
                case 1:
                  cl(Oe, Oe.return);
                  var it = Oe.stateNode;
                  if (typeof it.componentWillUnmount == "function") {
                    g = Oe, d = Oe.return;
                    try {
                      o = g, it.props = o.memoizedProps, it.state = o.memoizedState, it.componentWillUnmount();
                    } catch (st) {
                      $n(g, d, st);
                    }
                  }
                  break;
                case 5:
                  cl(Oe, Oe.return);
                  break;
                case 22:
                  if (Oe.memoizedState !== null) {
                    tv(Ve);
                    continue;
                  }
              }
              et !== null ? (et.return = Oe, tt = et) : tv(Ve);
            }
            Le = Le.sibling;
          }
          e: for (Le = null, Ve = r;;) {
            if (Ve.tag === 5) {
              if (Le === null) {
                Le = Ve;
                try {
                  S = Ve.stateNode, be ? (R = S.style, typeof R.setProperty == "function" ? R.setProperty("display", "none", "important") : R.display = "none") : (q = Ve.stateNode, re = Ve.memoizedProps.style, A = re != null && re.hasOwnProperty("display") ? re.display : null, q.style.display = yt("display", A));
                } catch (st) {
                  $n(r, r.return, st);
                }
              }
            } else if (Ve.tag === 6) {
              if (Le === null) try {
                Ve.stateNode.nodeValue = be ? "" : Ve.memoizedProps;
              } catch (st) {
                $n(r, r.return, st);
              }
            } else if ((Ve.tag !== 22 && Ve.tag !== 23 || Ve.memoizedState === null || Ve === r) && Ve.child !== null) {
              Ve.child.return = Ve, Ve = Ve.child;
              continue;
            }
            if (Ve === r) break e;
            for (; Ve.sibling === null;) {
              if (Ve.return === null || Ve.return === r) break e;
              Le === Ve && (Le = null), Ve = Ve.return;
            }
            Le === Ve && (Le = null), Ve.sibling.return = Ve.return, Ve = Ve.sibling;
          }
        }
        break;
      case 19:
        ri(o, r), ua(r), g & 4 && ev(r);
        break;
      case 21:
        break;
      default:
        ri(o, r), ua(r);
    }
  }
  function ua(r) {
    var o = r.flags;
    if (o & 2) {
      try {
        e: {
          for (var d = r.return; d !== null;) {
            if (ro(d)) {
              var g = d;
              break e;
            }
            d = d.return;
          }
          throw Error(i(160));
        }
        switch (g.tag) {
          case 5:
            var S = g.stateNode;
            g.flags & 32 && (We(S, ""), g.flags &= -33);
            var R = io(r);
            qs(r, R, S);
            break;
          case 3:
          case 4:
            var A = g.stateNode.containerInfo,
              q = io(r);
            wo(r, q, A);
            break;
          default:
            throw Error(i(161));
        }
      } catch (re) {
        $n(r, r.return, re);
      }
      r.flags &= -3;
    }
    o & 4096 && (r.flags &= -4097);
  }
  function kb(r, o, d) {
    tt = r, cp(r);
  }
  function cp(r, o, d) {
    for (var g = (r.mode & 1) !== 0; tt !== null;) {
      var S = tt,
        R = S.child;
      if (S.tag === 22 && g) {
        var A = S.memoizedState !== null || pf;
        if (!A) {
          var q = S.alternate,
            re = q !== null && q.memoizedState !== null || xr;
          q = pf;
          var be = xr;
          if (pf = A, (xr = re) && !be) for (tt = S; tt !== null;) A = tt, re = A.child, A.tag === 22 && A.memoizedState !== null ? vf(S) : re !== null ? (re.return = A, tt = re) : vf(S);
          for (; R !== null;) tt = R, cp(R), R = R.sibling;
          tt = S, pf = q, xr = be;
        }
        mf(r);
      } else (S.subtreeFlags & 8772) !== 0 && R !== null ? (R.return = S, tt = R) : mf(r);
    }
  }
  function mf(r) {
    for (; tt !== null;) {
      var o = tt;
      if ((o.flags & 8772) !== 0) {
        var d = o.alternate;
        try {
          if ((o.flags & 8772) !== 0) switch (o.tag) {
            case 0:
            case 11:
            case 15:
              xr || uc(5, o);
              break;
            case 1:
              var g = o.stateNode;
              if (o.flags & 4 && !xr) if (d === null) g.componentDidMount();else {
                var S = o.elementType === o.type ? d.memoizedProps : li(o.type, d.memoizedProps);
                g.componentDidUpdate(S, d.memoizedState, g.__reactInternalSnapshotBeforeUpdate);
              }
              var R = o.updateQueue;
              R !== null && Bg(o, R, g);
              break;
            case 3:
              var A = o.updateQueue;
              if (A !== null) {
                if (d = null, o.child !== null) switch (o.child.tag) {
                  case 5:
                    d = o.child.stateNode;
                    break;
                  case 1:
                    d = o.child.stateNode;
                }
                Bg(o, A, d);
              }
              break;
            case 5:
              var q = o.stateNode;
              if (d === null && o.flags & 4) {
                d = q;
                var re = o.memoizedProps;
                switch (o.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    re.autoFocus && d.focus();
                    break;
                  case "img":
                    re.src && (d.src = re.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (o.memoizedState === null) {
                var be = o.alternate;
                if (be !== null) {
                  var Le = be.memoizedState;
                  if (Le !== null) {
                    var Ve = Le.dehydrated;
                    Ve !== null && jo(Ve);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(i(163));
          }
          xr || o.flags & 512 && fu(o);
        } catch (Oe) {
          $n(o, o.return, Oe);
        }
      }
      if (o === r) {
        tt = null;
        break;
      }
      if (d = o.sibling, d !== null) {
        d.return = o.return, tt = d;
        break;
      }
      tt = o.return;
    }
  }
  function tv(r) {
    for (; tt !== null;) {
      var o = tt;
      if (o === r) {
        tt = null;
        break;
      }
      var d = o.sibling;
      if (d !== null) {
        d.return = o.return, tt = d;
        break;
      }
      tt = o.return;
    }
  }
  function vf(r) {
    for (; tt !== null;) {
      var o = tt;
      try {
        switch (o.tag) {
          case 0:
          case 11:
          case 15:
            var d = o.return;
            try {
              uc(4, o);
            } catch (re) {
              $n(o, d, re);
            }
            break;
          case 1:
            var g = o.stateNode;
            if (typeof g.componentDidMount == "function") {
              var S = o.return;
              try {
                g.componentDidMount();
              } catch (re) {
                $n(o, S, re);
              }
            }
            var R = o.return;
            try {
              fu(o);
            } catch (re) {
              $n(o, R, re);
            }
            break;
          case 5:
            var A = o.return;
            try {
              fu(o);
            } catch (re) {
              $n(o, A, re);
            }
        }
      } catch (re) {
        $n(o, o.return, re);
      }
      if (o === r) {
        tt = null;
        break;
      }
      var q = o.sibling;
      if (q !== null) {
        q.return = o.return, tt = q;
        break;
      }
      tt = o.return;
    }
  }
  var cc = Math.ceil,
    _o = j.ReactCurrentDispatcher,
    dl = j.ReactCurrentOwner,
    ii = j.ReactCurrentBatchConfig,
    on = 0,
    pr = null,
    ir = null,
    Sr = 0,
    ei = 0,
    Ys = Ki(0),
    Zn = 0,
    ls = null,
    xo = 0,
    Lc = 0,
    qh = 0,
    dc = null,
    ti = null,
    fc = 0,
    ao = 1 / 0,
    Mi = null,
    Kl = !1,
    Yh = null,
    So = null,
    pc = !1,
    Ea = null,
    Gs = 0,
    Xs = 0,
    Ma = null,
    di = -1,
    us = 0;
  function hr() {
    return (on & 6) !== 0 ? yn() : di !== -1 ? di : di = yn();
  }
  function Ca(r) {
    return (r.mode & 1) === 0 ? 1 : (on & 2) !== 0 && Sr !== 0 ? Sr & -Sr : Mw.transition !== null ? (us === 0 && (us = pd()), us) : (r = gn, r !== 0 || (r = window.event, r = r === void 0 ? 16 : gd(r.type)), r);
  }
  function Oi(r, o, d, g) {
    if (50 < Xs) throw Xs = 0, Ma = null, Error(i(185));
    Ts(r, d, g), ((on & 2) === 0 || r !== pr) && (r === pr && ((on & 2) === 0 && (Lc |= d), Zn === 4 && Eo(r, Sr)), Mr(r, g), d === 1 && on === 0 && (o.mode & 1) === 0 && (ao = yn() + 500, jl && ga()));
  }
  function Mr(r, o) {
    var d = r.callbackNode;
    Gp(r, o);
    var g = ks(r, r === pr ? Sr : 0);
    if (g === 0) d !== null && Wa(d), r.callbackNode = null, r.callbackPriority = 0;else if (o = g & -g, r.callbackPriority !== o) {
      if (d != null && Wa(d), o === 1) r.tag === 0 ? Bo(ny.bind(null, r)) : Vd(ny.bind(null, r)), Ol(function () {
        (on & 6) === 0 && ga();
      }), d = null;else {
        switch (Qp(g)) {
          case 1:
            d = Es;
            break;
          case 4:
            d = Wp;
            break;
          case 16:
            d = Du;
            break;
          case 536870912:
            d = qp;
            break;
          default:
            d = Du;
        }
        d = ly(d, hc.bind(null, r));
      }
      r.callbackPriority = o, r.callbackNode = d;
    }
  }
  function hc(r, o) {
    if (di = -1, us = 0, (on & 6) !== 0) throw Error(i(327));
    var d = r.callbackNode;
    if (Zs() && r.callbackNode !== d) return null;
    var g = ks(r, r === pr ? Sr : 0);
    if (g === 0) return null;
    if ((g & 30) !== 0 || (g & r.expiredLanes) !== 0 || o) o = Ac(r, g);else {
      o = g;
      var S = on;
      on |= 2;
      var R = iy();
      (pr !== r || Sr !== o) && (Mi = null, ao = yn() + 500, Ks(r, o));
      do try {
        Aw();
        break;
      } catch (q) {
        ry(r, q);
      } while (!0);
      Ge(), _o.current = R, on = S, ir !== null ? o = 0 : (pr = null, Sr = 0, o = Zn);
    }
    if (o !== 0) {
      if (o === 2 && (S = Xp(r), S !== 0 && (g = S, o = mc(r, S))), o === 1) throw d = ls, Ks(r, 0), Eo(r, g), Mr(r, yn()), d;
      if (o === 6) Eo(r, g);else {
        if (S = r.current.alternate, (g & 30) === 0 && !Gh(S) && (o = Ac(r, g), o === 2 && (R = Xp(r), R !== 0 && (g = R, o = mc(r, R))), o === 1)) throw d = ls, Ks(r, 0), Eo(r, g), Mr(r, yn()), d;
        switch (r.finishedWork = S, r.finishedLanes = g, o) {
          case 0:
          case 1:
            throw Error(i(345));
          case 2:
            Qs(r, ti, Mi);
            break;
          case 3:
            if (Eo(r, g), (g & 130023424) === g && (o = fc + 500 - yn(), 10 < o)) {
              if (ks(r, 0) !== 0) break;
              if (S = r.suspendedLanes, (S & g) !== g) {
                hr(), r.pingedLanes |= r.suspendedLanes & S;
                break;
              }
              r.timeoutHandle = Fd(Qs.bind(null, r, ti, Mi), o);
              break;
            }
            Qs(r, ti, Mi);
            break;
          case 4:
            if (Eo(r, g), (g & 4194240) === g) break;
            for (o = r.eventTimes, S = -1; 0 < g;) {
              var A = 31 - gi(g);
              R = 1 << A, A = o[A], A > S && (S = A), g &= ~R;
            }
            if (g = S, g = yn() - g, g = (120 > g ? 120 : 480 > g ? 480 : 1080 > g ? 1080 : 1920 > g ? 1920 : 3e3 > g ? 3e3 : 4320 > g ? 4320 : 1960 * cc(g / 1960)) - g, 10 < g) {
              r.timeoutHandle = Fd(Qs.bind(null, r, ti, Mi), g);
              break;
            }
            Qs(r, ti, Mi);
            break;
          case 5:
            Qs(r, ti, Mi);
            break;
          default:
            throw Error(i(329));
        }
      }
    }
    return Mr(r, yn()), r.callbackNode === d ? hc.bind(null, r) : null;
  }
  function mc(r, o) {
    var d = dc;
    return r.current.memoizedState.isDehydrated && (Ks(r, o).flags |= 256), r = Ac(r, o), r !== 2 && (o = ti, ti = d, o !== null && Pc(o)), r;
  }
  function Pc(r) {
    ti === null ? ti = r : ti.push.apply(ti, r);
  }
  function Gh(r) {
    for (var o = r;;) {
      if (o.flags & 16384) {
        var d = o.updateQueue;
        if (d !== null && (d = d.stores, d !== null)) for (var g = 0; g < d.length; g++) {
          var S = d[g],
            R = S.getSnapshot;
          S = S.value;
          try {
            if (!Gi(R(), S)) return !1;
          } catch {
            return !1;
          }
        }
      }
      if (d = o.child, o.subtreeFlags & 16384 && d !== null) d.return = o, o = d;else {
        if (o === r) break;
        for (; o.sibling === null;) {
          if (o.return === null || o.return === r) return !0;
          o = o.return;
        }
        o.sibling.return = o.return, o = o.sibling;
      }
    }
    return !0;
  }
  function Eo(r, o) {
    for (o &= ~qh, o &= ~Lc, r.suspendedLanes |= o, r.pingedLanes &= ~o, r = r.expirationTimes; 0 < o;) {
      var d = 31 - gi(o),
        g = 1 << d;
      r[d] = -1, o &= ~g;
    }
  }
  function ny(r) {
    if ((on & 6) !== 0) throw Error(i(327));
    Zs();
    var o = ks(r, 0);
    if ((o & 1) === 0) return Mr(r, yn()), null;
    var d = Ac(r, o);
    if (r.tag !== 0 && d === 2) {
      var g = Xp(r);
      g !== 0 && (o = g, d = mc(r, g));
    }
    if (d === 1) throw d = ls, Ks(r, 0), Eo(r, o), Mr(r, yn()), d;
    if (d === 6) throw Error(i(345));
    return r.finishedWork = r.current.alternate, r.finishedLanes = o, Qs(r, ti, Mi), Mr(r, yn()), null;
  }
  function Xh(r, o) {
    var d = on;
    on |= 1;
    try {
      return r(o);
    } finally {
      on = d, on === 0 && (ao = yn() + 500, jl && ga());
    }
  }
  function Ko(r) {
    Ea !== null && Ea.tag === 0 && (on & 6) === 0 && Zs();
    var o = on;
    on |= 1;
    var d = ii.transition,
      g = gn;
    try {
      if (ii.transition = null, gn = 1, r) return r();
    } finally {
      gn = g, ii.transition = d, on = o, (on & 6) === 0 && ga();
    }
  }
  function gf() {
    ei = Ys.current, Sn(Ys);
  }
  function Ks(r, o) {
    r.finishedWork = null, r.finishedLanes = 0;
    var d = r.timeoutHandle;
    if (d !== -1 && (r.timeoutHandle = -1, Eh(d)), ir !== null) for (d = ir.return; d !== null;) {
      var g = d;
      switch (Ud(g), g.tag) {
        case 1:
          g = g.type.childContextTypes, g != null && Al();
          break;
        case 3:
          nn(), Sn(or), Sn(Hn), Ah();
          break;
        case 5:
          Ri(g);
          break;
        case 4:
          nn();
          break;
        case 13:
          Sn(Mn);
          break;
        case 19:
          Sn(Mn);
          break;
        case 10:
          Ci(g.type._context);
          break;
        case 22:
        case 23:
          gf();
      }
      d = d.return;
    }
    if (pr = r, ir = r = Oa(r.current, null), Sr = ei = o, Zn = 0, ls = null, qh = Lc = xo = 0, ti = dc = null, zs !== null) {
      for (o = 0; o < zs.length; o++) if (d = zs[o], g = d.interleaved, g !== null) {
        d.interleaved = null;
        var S = g.next,
          R = d.pending;
        if (R !== null) {
          var A = R.next;
          R.next = S, g.next = A;
        }
        d.pending = g;
      }
      zs = null;
    }
    return r;
  }
  function ry(r, o) {
    do {
      var d = ir;
      try {
        if (Ge(), zl.current = ql, xa) {
          for (var g = Je.memoizedState; g !== null;) {
            var S = g.queue;
            S !== null && (S.pending = null), g = g.next;
          }
          xa = !1;
        }
        if (On = 0, Cn = Ln = Je = null, Qr = !1, no = 0, dl.current = null, d === null || d.return === null) {
          Zn = 1, ls = o, ir = null;
          break;
        }
        e: {
          var R = r,
            A = d.return,
            q = d,
            re = o;
          if (o = Sr, q.flags |= 32768, re !== null && typeof re == "object" && typeof re.then == "function") {
            var be = re,
              Le = q,
              Ve = Le.tag;
            if ((Le.mode & 1) === 0 && (Ve === 0 || Ve === 11 || Ve === 15)) {
              var Oe = Le.alternate;
              Oe ? (Le.updateQueue = Oe.updateQueue, Le.memoizedState = Oe.memoizedState, Le.lanes = Oe.lanes) : (Le.updateQueue = null, Le.memoizedState = null);
            }
            var et = Go(A);
            if (et !== null) {
              et.flags &= -257, Xl(et, A, q, R, o), et.mode & 1 && Zg(R, be, o), o = et, re = be;
              var it = o.updateQueue;
              if (it === null) {
                var st = /* @__PURE__ */new Set();
                st.add(re), o.updateQueue = st;
              } else it.add(re);
              break e;
            } else {
              if ((o & 1) === 0) {
                Zg(R, be, o), Kh();
                break e;
              }
              re = Error(i(426));
            }
          } else if (In && q.mode & 1) {
            var Kn = Go(A);
            if (Kn !== null) {
              (Kn.flags & 65536) === 0 && (Kn.flags |= 256), Xl(Kn, A, q, R, o), eo(Yl(re, q));
              break e;
            }
          }
          R = re = Yl(re, q), Zn !== 4 && (Zn = 2), dc === null ? dc = [R] : dc.push(R), R = A;
          do {
            switch (R.tag) {
              case 3:
                R.flags |= 65536, o &= -o, R.lanes |= o;
                var pe = zh(R, re, o);
                Vg(R, pe);
                break e;
              case 1:
                q = re;
                var ae = R.type,
                  he = R.stateNode;
                if ((R.flags & 128) === 0 && (typeof ae.getDerivedStateFromError == "function" || he !== null && typeof he.componentDidCatch == "function" && (So === null || !So.has(he)))) {
                  R.flags |= 65536, o &= -o, R.lanes |= o;
                  var He = Vh(R, q, o);
                  Vg(R, He);
                  break e;
                }
            }
            R = R.return;
          } while (R !== null);
        }
        oy(d);
      } catch (ut) {
        o = ut, ir === d && d !== null && (ir = d = d.return);
        continue;
      }
      break;
    } while (!0);
  }
  function iy() {
    var r = _o.current;
    return _o.current = ql, r === null ? ql : r;
  }
  function Kh() {
    (Zn === 0 || Zn === 3 || Zn === 2) && (Zn = 4), pr === null || (xo & 268435455) === 0 && (Lc & 268435455) === 0 || Eo(pr, Sr);
  }
  function Ac(r, o) {
    var d = on;
    on |= 2;
    var g = iy();
    (pr !== r || Sr !== o) && (Mi = null, Ks(r, o));
    do try {
      Tb();
      break;
    } catch (S) {
      ry(r, S);
    } while (!0);
    if (Ge(), on = d, _o.current = g, ir !== null) throw Error(i(261));
    return pr = null, Sr = 0, Zn;
  }
  function Tb() {
    for (; ir !== null;) ay(ir);
  }
  function Aw() {
    for (; ir !== null && !Ru();) ay(ir);
  }
  function ay(r) {
    var o = sy(r.alternate, r, ei);
    r.memoizedProps = r.pendingProps, o === null ? oy(r) : ir = o, dl.current = null;
  }
  function oy(r) {
    var o = r;
    do {
      var d = o.alternate;
      if (r = o.return, (o.flags & 32768) === 0) {
        if (d = $h(d, o, ei), d !== null) {
          ir = d;
          return;
        }
      } else {
        if (d = Eb(d, o), d !== null) {
          d.flags &= 32767, ir = d;
          return;
        }
        if (r !== null) r.flags |= 32768, r.subtreeFlags = 0, r.deletions = null;else {
          Zn = 6, ir = null;
          return;
        }
      }
      if (o = o.sibling, o !== null) {
        ir = o;
        return;
      }
      ir = o = r;
    } while (o !== null);
    Zn === 0 && (Zn = 5);
  }
  function Qs(r, o, d) {
    var g = gn,
      S = ii.transition;
    try {
      ii.transition = null, gn = 1, jw(r, o, d, g);
    } finally {
      ii.transition = S, gn = g;
    }
    return null;
  }
  function jw(r, o, d, g) {
    do Zs(); while (Ea !== null);
    if ((on & 6) !== 0) throw Error(i(327));
    d = r.finishedWork;
    var S = r.finishedLanes;
    if (d === null) return null;
    if (r.finishedWork = null, r.finishedLanes = 0, d === r.current) throw Error(i(177));
    r.callbackNode = null, r.callbackPriority = 0;
    var R = d.lanes | d.childLanes;
    if (fw(r, R), r === pr && (ir = pr = null, Sr = 0), (d.subtreeFlags & 2064) === 0 && (d.flags & 2064) === 0 || pc || (pc = !0, ly(Du, function () {
      return Zs(), null;
    })), R = (d.flags & 15990) !== 0, (d.subtreeFlags & 15990) !== 0 || R) {
      R = ii.transition, ii.transition = null;
      var A = gn;
      gn = 1;
      var q = on;
      on |= 4, dl.current = null, Cb(r, d), hf(d, r), Rl(js), Ds = !!Wu, js = Wu = null, r.current = d, kb(d), Wi(), on = q, gn = A, ii.transition = R;
    } else r.current = d;
    if (pc && (pc = !1, Ea = r, Gs = S), R = r.pendingLanes, R === 0 && (So = null), ng(d.stateNode), Mr(r, yn()), o !== null) for (g = r.onRecoverableError, d = 0; d < o.length; d++) S = o[d], g(S.value, {
      componentStack: S.stack,
      digest: S.digest
    });
    if (Kl) throw Kl = !1, r = Yh, Yh = null, r;
    return (Gs & 1) !== 0 && r.tag !== 0 && Zs(), R = r.pendingLanes, (R & 1) !== 0 ? r === Ma ? Xs++ : (Xs = 0, Ma = r) : Xs = 0, ga(), null;
  }
  function Zs() {
    if (Ea !== null) {
      var r = Qp(Gs),
        o = ii.transition,
        d = gn;
      try {
        if (ii.transition = null, gn = 16 > r ? 16 : r, Ea === null) var g = !1;else {
          if (r = Ea, Ea = null, Gs = 0, (on & 6) !== 0) throw Error(i(331));
          var S = on;
          for (on |= 4, tt = r.current; tt !== null;) {
            var R = tt,
              A = R.child;
            if ((tt.flags & 16) !== 0) {
              var q = R.deletions;
              if (q !== null) {
                for (var re = 0; re < q.length; re++) {
                  var be = q[re];
                  for (tt = be; tt !== null;) {
                    var Le = tt;
                    switch (Le.tag) {
                      case 0:
                      case 11:
                      case 15:
                        du(8, Le, R);
                    }
                    var Ve = Le.child;
                    if (Ve !== null) Ve.return = Le, tt = Ve;else for (; tt !== null;) {
                      Le = tt;
                      var Oe = Le.sibling,
                        et = Le.return;
                      if (Ws(Le), Le === be) {
                        tt = null;
                        break;
                      }
                      if (Oe !== null) {
                        Oe.return = et, tt = Oe;
                        break;
                      }
                      tt = et;
                    }
                  }
                }
                var it = R.alternate;
                if (it !== null) {
                  var st = it.child;
                  if (st !== null) {
                    it.child = null;
                    do {
                      var Kn = st.sibling;
                      st.sibling = null, st = Kn;
                    } while (st !== null);
                  }
                }
                tt = R;
              }
            }
            if ((R.subtreeFlags & 2064) !== 0 && A !== null) A.return = R, tt = A;else e: for (; tt !== null;) {
              if (R = tt, (R.flags & 2048) !== 0) switch (R.tag) {
                case 0:
                case 11:
                case 15:
                  du(9, R, R.return);
              }
              var pe = R.sibling;
              if (pe !== null) {
                pe.return = R.return, tt = pe;
                break e;
              }
              tt = R.return;
            }
          }
          var ae = r.current;
          for (tt = ae; tt !== null;) {
            A = tt;
            var he = A.child;
            if ((A.subtreeFlags & 2064) !== 0 && he !== null) he.return = A, tt = he;else e: for (A = ae; tt !== null;) {
              if (q = tt, (q.flags & 2048) !== 0) try {
                switch (q.tag) {
                  case 0:
                  case 11:
                  case 15:
                    uc(9, q);
                }
              } catch (ut) {
                $n(q, q.return, ut);
              }
              if (q === A) {
                tt = null;
                break e;
              }
              var He = q.sibling;
              if (He !== null) {
                He.return = q.return, tt = He;
                break e;
              }
              tt = q.return;
            }
          }
          if (on = S, ga(), qi && typeof qi.onPostCommitFiberRoot == "function") try {
            qi.onPostCommitFiberRoot(Iu, r);
          } catch {}
          g = !0;
        }
        return g;
      } finally {
        gn = d, ii.transition = o;
      }
    }
    return !1;
  }
  function Qh(r, o, d) {
    o = Yl(d, o), o = zh(r, o, 1), r = Ti(r, o, 1), o = hr(), r !== null && (Ts(r, 1, o), Mr(r, o));
  }
  function $n(r, o, d) {
    if (r.tag === 3) Qh(r, r, d);else for (; o !== null;) {
      if (o.tag === 3) {
        Qh(o, r, d);
        break;
      } else if (o.tag === 1) {
        var g = o.stateNode;
        if (typeof o.type.getDerivedStateFromError == "function" || typeof g.componentDidCatch == "function" && (So === null || !So.has(g))) {
          r = Yl(d, r), r = Vh(o, r, 1), o = Ti(o, r, 1), r = hr(), o !== null && (Ts(o, 1, r), Mr(o, r));
          break;
        }
      }
      o = o.return;
    }
  }
  function Fw(r, o, d) {
    var g = r.pingCache;
    g !== null && g.delete(o), o = hr(), r.pingedLanes |= r.suspendedLanes & d, pr === r && (Sr & d) === d && (Zn === 4 || Zn === 3 && (Sr & 130023424) === Sr && 500 > yn() - fc ? Ks(r, 0) : qh |= d), Mr(r, o);
  }
  function nv(r, o) {
    o === 0 && ((r.mode & 1) === 0 ? o = 1 : (o = Yi, Yi <<= 1, (Yi & 130023424) === 0 && (Yi = 4194304)));
    var d = hr();
    r = En(r, o), r !== null && (Ts(r, o, d), Mr(r, d));
  }
  function Rb(r) {
    var o = r.memoizedState,
      d = 0;
    o !== null && (d = o.retryLane), nv(r, d);
  }
  function Nw(r, o) {
    var d = 0;
    switch (r.tag) {
      case 13:
        var g = r.stateNode,
          S = r.memoizedState;
        S !== null && (d = S.retryLane);
        break;
      case 19:
        g = r.stateNode;
        break;
      default:
        throw Error(i(314));
    }
    g !== null && g.delete(o), nv(r, d);
  }
  var sy;
  sy = function (r, o, d) {
    if (r !== null) {
      if (r.memoizedProps !== o.pendingProps || or.current) Dr = !0;else {
        if ((r.lanes & d) === 0 && (o.flags & 128) === 0) return Dr = !1, zr(r, o, d);
        Dr = (r.flags & 131072) !== 0;
      }
    } else Dr = !1, In && (o.flags & 1048576) !== 0 && jg(o, Ja, o.index);
    switch (o.lanes = 0, o.tag) {
      case 2:
        var g = o.type;
        ss(r, o), r = o.pendingProps;
        var S = xi(o, Hn.current);
        Fl(o, d), S = Ju(null, o, g, r, S, d);
        var R = ec();
        return o.flags |= 1, typeof S == "object" && S !== null && typeof S.render == "function" && S.$$typeof === void 0 ? (o.tag = 1, o.memoizedState = null, o.updateQueue = null, tr(g) ? (R = !0, Gr(o)) : R = !1, o.memoizedState = S.state !== null && S.state !== void 0 ? S.state : null, Dh(o), S.updater = Yd, o.stateNode = S, S._reactInternals = o, Lh(o, g, r, d), o = sc(null, o, g, !0, R, d)) : (o.tag = 0, In && R && Bd(o), _n(null, o, S, d), o = o.child), o;
      case 16:
        g = o.elementType;
        e: {
          switch (ss(r, o), r = o.pendingProps, S = g._init, g = S(g._payload), o.type = g, S = o.tag = Db(g), r = li(g, r), S) {
            case 0:
              o = uf(null, o, g, r, d);
              break e;
            case 1:
              o = oc(null, o, g, r, d);
              break e;
            case 11:
              o = $s(null, o, g, r, d);
              break e;
            case 14:
              o = jt(null, o, g, li(g.type, r), d);
              break e;
          }
          throw Error(i(306, g, ""));
        }
        return o;
      case 0:
        return g = o.type, S = o.pendingProps, S = o.elementType === g ? S : li(g, S), uf(r, o, g, S, d);
      case 1:
        return g = o.type, S = o.pendingProps, S = o.elementType === g ? S : li(g, S), oc(r, o, g, S, d);
      case 3:
        e: {
          if (Km(o), r === null) throw Error(i(387));
          g = o.pendingProps, R = o.memoizedState, S = R.element, zg(r, o), qd(o, g, null, d);
          var A = o.memoizedState;
          if (g = A.element, R.isDehydrated) {
            if (R = {
              element: g,
              isDehydrated: !1,
              cache: A.cache,
              pendingSuspenseBoundaries: A.pendingSuspenseBoundaries,
              transitions: A.transitions
            }, o.updateQueue.baseState = R, o.memoizedState = R, o.flags & 256) {
              S = Yl(Error(i(423)), o), o = Qm(r, o, g, d, S);
              break e;
            } else if (g !== S) {
              S = Yl(Error(i(424)), o), o = Qm(r, o, g, d, S);
              break e;
            } else for (Kr = ha(o.stateNode.containerInfo.firstChild), Xr = o, In = !0, Ei = null, d = qg(o, null, g, d), o.child = d; d;) d.flags = d.flags & -3 | 4096, d = d.sibling;
          } else {
            if (Wo(), g === S) {
              o = Ir(r, o, d);
              break e;
            }
            _n(r, o, g, d);
          }
          o = o.child;
        }
        return o;
      case 5:
        return Xn(o), r === null && Th(o), g = o.type, S = o.pendingProps, R = r !== null ? r.memoizedProps : null, A = S.children, jd(g, S) ? A = null : R !== null && jd(g, R) && (o.flags |= 32), Sb(r, o), _n(r, o, A, d), o.child;
      case 6:
        return r === null && Th(o), null;
      case 13:
        return Zm(r, o, d);
      case 4:
        return Wt(o, o.stateNode.containerInfo), g = o.pendingProps, r === null ? o.child = Vs(o, null, g, d) : _n(r, o, g, d), o.child;
      case 11:
        return g = o.type, S = o.pendingProps, S = o.elementType === g ? S : li(g, S), $s(r, o, g, S, d);
      case 7:
        return _n(r, o, o.pendingProps, d), o.child;
      case 8:
        return _n(r, o, o.pendingProps.children, d), o.child;
      case 12:
        return _n(r, o, o.pendingProps.children, d), o.child;
      case 10:
        e: {
          if (g = o.type._context, S = o.pendingProps, R = o.memoizedProps, A = S.value, ft($d, g._currentValue), g._currentValue = A, R !== null) if (Gi(R.value, A)) {
            if (R.children === S.children && !or.current) {
              o = Ir(r, o, d);
              break e;
            }
          } else for (R = o.child, R !== null && (R.return = o); R !== null;) {
            var q = R.dependencies;
            if (q !== null) {
              A = R.child;
              for (var re = q.firstContext; re !== null;) {
                if (re.context === g) {
                  if (R.tag === 1) {
                    re = wa(-1, d & -d), re.tag = 2;
                    var be = R.updateQueue;
                    if (be !== null) {
                      be = be.shared;
                      var Le = be.pending;
                      Le === null ? re.next = re : (re.next = Le.next, Le.next = re), be.pending = re;
                    }
                  }
                  R.lanes |= d, re = R.alternate, re !== null && (re.lanes |= d), ui(R.return, d, o), q.lanes |= d;
                  break;
                }
                re = re.next;
              }
            } else if (R.tag === 10) A = R.type === o.type ? null : R.child;else if (R.tag === 18) {
              if (A = R.return, A === null) throw Error(i(341));
              A.lanes |= d, q = A.alternate, q !== null && (q.lanes |= d), ui(A, d, o), A = R.sibling;
            } else A = R.child;
            if (A !== null) A.return = R;else for (A = R; A !== null;) {
              if (A === o) {
                A = null;
                break;
              }
              if (R = A.sibling, R !== null) {
                R.return = A.return, A = R;
                break;
              }
              A = A.return;
            }
            R = A;
          }
          _n(r, o, S.children, d), o = o.child;
        }
        return o;
      case 9:
        return S = o.type, g = o.pendingProps.children, Fl(o, d), S = ki(S), g = g(S), o.flags |= 1, _n(r, o, g, d), o.child;
      case 14:
        return g = o.type, S = li(g, o.pendingProps), S = li(g.type, S), jt(r, o, g, S, d);
      case 15:
        return ac(r, o, o.type, o.pendingProps, d);
      case 17:
        return g = o.type, S = o.pendingProps, S = o.elementType === g ? S : li(g, S), ss(r, o), o.tag = 1, tr(g) ? (r = !0, Gr(o)) : r = !1, Fl(o, d), Oh(o, g, S), Lh(o, g, S, d), sc(null, o, g, !0, r, d);
      case 19:
        return os(r, o, d);
      case 22:
        return Bh(r, o, d);
    }
    throw Error(i(156, o.tag));
  };
  function ly(r, o) {
    return Lr(r, o);
  }
  function zw(r, o, d, g) {
    this.tag = r, this.key = d, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = o, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = g, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Li(r, o, d, g) {
    return new zw(r, o, d, g);
  }
  function Zh(r) {
    return r = r.prototype, !(!r || !r.isReactComponent);
  }
  function Db(r) {
    if (typeof r == "function") return Zh(r) ? 1 : 0;
    if (r != null) {
      if (r = r.$$typeof, r === ee) return 11;
      if (r === se) return 14;
    }
    return 2;
  }
  function Oa(r, o) {
    var d = r.alternate;
    return d === null ? (d = Li(r.tag, o, r.key, r.mode), d.elementType = r.elementType, d.type = r.type, d.stateNode = r.stateNode, d.alternate = r, r.alternate = d) : (d.pendingProps = o, d.type = r.type, d.flags = 0, d.subtreeFlags = 0, d.deletions = null), d.flags = r.flags & 14680064, d.childLanes = r.childLanes, d.lanes = r.lanes, d.child = r.child, d.memoizedProps = r.memoizedProps, d.memoizedState = r.memoizedState, d.updateQueue = r.updateQueue, o = r.dependencies, d.dependencies = o === null ? null : {
      lanes: o.lanes,
      firstContext: o.firstContext
    }, d.sibling = r.sibling, d.index = r.index, d.ref = r.ref, d;
  }
  function Js(r, o, d, g, S, R) {
    var A = 2;
    if (g = r, typeof r == "function") Zh(r) && (A = 1);else if (typeof r == "string") A = 5;else e: switch (r) {
      case G:
        return oo(d.children, S, R, o);
      case Q:
        A = 8, S |= 8;
        break;
      case te:
        return r = Li(12, d, o, S | 2), r.elementType = te, r.lanes = R, r;
      case oe:
        return r = Li(13, d, o, S), r.elementType = oe, r.lanes = R, r;
      case ne:
        return r = Li(19, d, o, S), r.elementType = ne, r.lanes = R, r;
      case W:
        return jc(d, S, R, o);
      default:
        if (typeof r == "object" && r !== null) switch (r.$$typeof) {
          case ie:
            A = 10;
            break e;
          case Y:
            A = 9;
            break e;
          case ee:
            A = 11;
            break e;
          case se:
            A = 14;
            break e;
          case ue:
            A = 16, g = null;
            break e;
        }
        throw Error(i(130, r == null ? r : typeof r, ""));
    }
    return o = Li(A, d, o, S), o.elementType = r, o.type = g, o.lanes = R, o;
  }
  function oo(r, o, d, g) {
    return r = Li(7, r, g, o), r.lanes = d, r;
  }
  function jc(r, o, d, g) {
    return r = Li(22, r, g, o), r.elementType = W, r.lanes = d, r.stateNode = {
      isHidden: !1
    }, r;
  }
  function yf(r, o, d) {
    return r = Li(6, r, null, o), r.lanes = d, r;
  }
  function bf(r, o, d) {
    return o = Li(4, r.children !== null ? r.children : [], r.key, o), o.lanes = d, o.stateNode = {
      containerInfo: r.containerInfo,
      pendingChildren: null,
      implementation: r.implementation
    }, o;
  }
  function Ib(r, o, d, g, S) {
    this.tag = o, this.containerInfo = r, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = Kp(0), this.expirationTimes = Kp(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Kp(0), this.identifierPrefix = g, this.onRecoverableError = S, this.mutableSourceEagerHydrationData = null;
  }
  function dp(r, o, d, g, S, R, A, q, re) {
    return r = new Ib(r, o, d, q, re), o === 1 ? (o = 1, R === !0 && (o |= 8)) : o = 0, R = Li(3, null, null, o), r.current = R, R.stateNode = r, R.memoizedState = {
      element: g,
      isDehydrated: d,
      cache: null,
      transitions: null,
      pendingSuspenseBoundaries: null
    }, Dh(R), r;
  }
  function Mb(r, o, d) {
    var g = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      $$typeof: K,
      key: g == null ? null : "" + g,
      children: r,
      containerInfo: o,
      implementation: d
    };
  }
  function uy(r) {
    if (!r) return qr;
    r = r._reactInternals;
    e: {
      if ($t(r) !== r || r.tag !== 1) throw Error(i(170));
      var o = r;
      do {
        switch (o.tag) {
          case 3:
            o = o.stateNode.context;
            break e;
          case 1:
            if (tr(o.type)) {
              o = o.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        o = o.return;
      } while (o !== null);
      throw Error(i(171));
    }
    if (r.tag === 1) {
      var d = r.type;
      if (tr(d)) return Gu(r, d, o);
    }
    return o;
  }
  function cy(r, o, d, g, S, R, A, q, re) {
    return r = dp(d, g, !0, r, S, R, A, q, re), r.context = uy(null), d = r.current, g = hr(), S = Ca(d), R = wa(g, S), R.callback = o ?? null, Ti(d, R, S), r.current.lanes = S, Ts(r, S, g), Mr(r, g), r;
  }
  function Fc(r, o, d, g) {
    var S = o.current,
      R = hr(),
      A = Ca(S);
    return d = uy(d), o.context === null ? o.context = d : o.pendingContext = d, o = wa(R, A), o.payload = {
      element: r
    }, g = g === void 0 ? null : g, g !== null && (o.callback = g), r = Ti(S, o, A), r !== null && (Oi(r, S, A, R), to(r, S, A)), A;
  }
  function vc(r) {
    if (r = r.current, !r.child) return null;
    switch (r.child.tag) {
      case 5:
        return r.child.stateNode;
      default:
        return r.child.stateNode;
    }
  }
  function Jh(r, o) {
    if (r = r.memoizedState, r !== null && r.dehydrated !== null) {
      var d = r.retryLane;
      r.retryLane = d !== 0 && d < o ? d : o;
    }
  }
  function Ql(r, o) {
    Jh(r, o), (r = r.alternate) && Jh(r, o);
  }
  function fp() {
    return null;
  }
  var dy = typeof reportError == "function" ? reportError : function (r) {
    console.error(r);
  };
  function em(r) {
    this._internalRoot = r;
  }
  wf.prototype.render = em.prototype.render = function (r) {
    var o = this._internalRoot;
    if (o === null) throw Error(i(409));
    Fc(r, o, null, null);
  }, wf.prototype.unmount = em.prototype.unmount = function () {
    var r = this._internalRoot;
    if (r !== null) {
      this._internalRoot = null;
      var o = r.containerInfo;
      Ko(function () {
        Fc(null, r, null, null);
      }), o[Qa] = null;
    }
  };
  function wf(r) {
    this._internalRoot = r;
  }
  wf.prototype.unstable_scheduleHydration = function (r) {
    if (r) {
      var o = At();
      r = {
        blockedOn: null,
        target: r,
        priority: o
      };
      for (var d = 0; d < br.length && o !== 0 && o < br[d].priority; d++);
      br.splice(d, 0, r), d === 0 && nh(r);
    }
  };
  function tm(r) {
    return !(!r || r.nodeType !== 1 && r.nodeType !== 9 && r.nodeType !== 11);
  }
  function _f(r) {
    return !(!r || r.nodeType !== 1 && r.nodeType !== 9 && r.nodeType !== 11 && (r.nodeType !== 8 || r.nodeValue !== " react-mount-point-unstable "));
  }
  function rv() {}
  function Ob(r, o, d, g, S) {
    if (S) {
      if (typeof g == "function") {
        var R = g;
        g = function () {
          var be = vc(A);
          R.call(be);
        };
      }
      var A = cy(o, g, r, 0, null, !1, !1, "", rv);
      return r._reactRootContainer = A, r[Qa] = A.current, Il(r.nodeType === 8 ? r.parentNode : r), Ko(), A;
    }
    for (; S = r.lastChild;) r.removeChild(S);
    if (typeof g == "function") {
      var q = g;
      g = function () {
        var be = vc(re);
        q.call(be);
      };
    }
    var re = dp(r, 0, !1, null, null, !1, !1, "", rv);
    return r._reactRootContainer = re, r[Qa] = re.current, Il(r.nodeType === 8 ? r.parentNode : r), Ko(function () {
      Fc(o, re, d, g);
    }), re;
  }
  function xf(r, o, d, g, S) {
    var R = d._reactRootContainer;
    if (R) {
      var A = R;
      if (typeof S == "function") {
        var q = S;
        S = function () {
          var re = vc(A);
          q.call(re);
        };
      }
      Fc(o, A, r, S);
    } else A = Ob(d, o, r, S, g);
    return vc(A);
  }
  bn = function (r) {
    switch (r.tag) {
      case 3:
        var o = r.stateNode;
        if (o.current.memoizedState.isDehydrated) {
          var d = Cs(o.pendingLanes);
          d !== 0 && (hd(o, d | 1), Mr(o, yn()), (on & 6) === 0 && (ao = yn() + 500, ga()));
        }
        break;
      case 13:
        Ko(function () {
          var g = En(r, 1);
          if (g !== null) {
            var S = hr();
            Oi(g, r, 1, S);
          }
        }), Ql(r, 1);
    }
  }, Zp = function (r) {
    if (r.tag === 13) {
      var o = En(r, 134217728);
      if (o !== null) {
        var d = hr();
        Oi(o, r, 134217728, d);
      }
      Ql(r, 134217728);
    }
  }, Jp = function (r) {
    if (r.tag === 13) {
      var o = Ca(r),
        d = En(r, o);
      if (d !== null) {
        var g = hr();
        Oi(d, r, o, g);
      }
      Ql(r, o);
    }
  }, At = function () {
    return gn;
  }, eh = function (r, o) {
    var d = gn;
    try {
      return gn = r, o();
    } finally {
      gn = d;
    }
  }, en = function (r, o, d) {
    switch (o) {
      case "input":
        if (un(r, d), o = d.name, d.type === "radio" && o != null) {
          for (d = r; d.parentNode;) d = d.parentNode;
          for (d = d.querySelectorAll("input[name=" + JSON.stringify("" + o) + '][type="radio"]'), o = 0; o < d.length; o++) {
            var g = d[o];
            if (g !== r && g.form === r.form) {
              var S = Gn(g);
              if (!S) throw Error(i(90));
              ye(g), un(g, S);
            }
          }
        }
        break;
      case "textarea":
        Ot(r, d);
        break;
      case "select":
        o = d.value, o != null && Dt(r, !!d.multiple, o, !1);
    }
  }, _l = Xh, Mo = Ko;
  var Lb = {
      usingClientEntryPoint: !1,
      Events: [pt, Xi, Gn, ll, yo, Xh]
    },
    cs = {
      findFiberByHostInstance: Fs,
      bundleType: 0,
      version: "18.2.0",
      rendererPackageName: "react-dom"
    },
    gc = {
      bundleType: cs.bundleType,
      version: cs.version,
      rendererPackageName: cs.rendererPackageName,
      rendererConfig: cs.rendererConfig,
      overrideHookState: null,
      overrideHookStateDeletePath: null,
      overrideHookStateRenamePath: null,
      overrideProps: null,
      overridePropsDeletePath: null,
      overridePropsRenamePath: null,
      setErrorHandler: null,
      setSuspenseHandler: null,
      scheduleUpdate: null,
      currentDispatcherRef: j.ReactCurrentDispatcher,
      findHostInstanceByFiber: function (r) {
        return r = Tn(r), r === null ? null : r.stateNode;
      },
      findFiberByHostInstance: cs.findFiberByHostInstance || fp,
      findHostInstancesForRefresh: null,
      scheduleRefresh: null,
      scheduleRoot: null,
      setRefreshHandler: null,
      getCurrentFiber: null,
      reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
    };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Zl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Zl.isDisabled && Zl.supportsFiber) try {
      Iu = Zl.inject(gc), qi = Zl;
    } catch {}
  }
  return Qc.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Lb, Qc.createPortal = function (r, o) {
    var d = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!tm(o)) throw Error(i(200));
    return Mb(r, o, null, d);
  }, Qc.createRoot = function (r, o) {
    if (!tm(r)) throw Error(i(299));
    var d = !1,
      g = "",
      S = dy;
    return o != null && (o.unstable_strictMode === !0 && (d = !0), o.identifierPrefix !== void 0 && (g = o.identifierPrefix), o.onRecoverableError !== void 0 && (S = o.onRecoverableError)), o = dp(r, 1, !1, null, null, d, !1, g, S), r[Qa] = o.current, Il(r.nodeType === 8 ? r.parentNode : r), new em(o);
  }, Qc.findDOMNode = function (r) {
    if (r == null) return null;
    if (r.nodeType === 1) return r;
    var o = r._reactInternals;
    if (o === void 0) throw typeof r.render == "function" ? Error(i(188)) : (r = Object.keys(r).join(","), Error(i(268, r)));
    return r = Tn(o), r = r === null ? null : r.stateNode, r;
  }, Qc.flushSync = function (r) {
    return Ko(r);
  }, Qc.hydrate = function (r, o, d) {
    if (!_f(o)) throw Error(i(200));
    return xf(null, r, o, !0, d);
  }, Qc.hydrateRoot = function (r, o, d) {
    if (!tm(r)) throw Error(i(405));
    var g = d != null && d.hydratedSources || null,
      S = !1,
      R = "",
      A = dy;
    if (d != null && (d.unstable_strictMode === !0 && (S = !0), d.identifierPrefix !== void 0 && (R = d.identifierPrefix), d.onRecoverableError !== void 0 && (A = d.onRecoverableError)), o = cy(o, null, r, 1, d ?? null, S, !1, R, A), r[Qa] = o.current, Il(r), g) for (r = 0; r < g.length; r++) d = g[r], S = d._getVersion, S = S(d._source), o.mutableSourceEagerHydrationData == null ? o.mutableSourceEagerHydrationData = [d, S] : o.mutableSourceEagerHydrationData.push(d, S);
    return new wf(o);
  }, Qc.render = function (r, o, d) {
    if (!_f(o)) throw Error(i(200));
    return xf(null, r, o, !1, d);
  }, Qc.unmountComponentAtNode = function (r) {
    if (!_f(r)) throw Error(i(40));
    return r._reactRootContainer ? (Ko(function () {
      xf(null, null, r, !1, function () {
        r._reactRootContainer = null, r[Qa] = null;
      });
    }), !0) : !1;
  }, Qc.unstable_batchedUpdates = Xh, Qc.unstable_renderSubtreeIntoContainer = function (r, o, d, g) {
    if (!_f(d)) throw Error(i(200));
    if (r == null || r._reactInternals === void 0) throw Error(i(38));
    return xf(r, o, d, !1, g);
  }, Qc.version = "18.2.0-next-9e3b772b8-20220608", Qc;
}
var ep = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var nB;
function aK() {
  return nB || (nB = 1, process.env.NODE_ENV !== "production" && function () {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = Nt,
      e = x4(),
      i = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
      l = !1;
    function c(s) {
      l = s;
    }
    function p(s) {
      if (!l) {
        for (var u = arguments.length, v = new Array(u > 1 ? u - 1 : 0), _ = 1; _ < u; _++) v[_ - 1] = arguments[_];
        y("warn", s, v);
      }
    }
    function h(s) {
      if (!l) {
        for (var u = arguments.length, v = new Array(u > 1 ? u - 1 : 0), _ = 1; _ < u; _++) v[_ - 1] = arguments[_];
        y("error", s, v);
      }
    }
    function y(s, u, v) {
      {
        var _ = i.ReactDebugCurrentFrame,
          n = _.getStackAddendum();
        n !== "" && (u += "%s", v = v.concat([n]));
        var a = v.map(function (f) {
          return String(f);
        });
        a.unshift("Warning: " + u), Function.prototype.apply.call(console[s], console, a);
      }
    }
    var w = 0,
      x = 1,
      E = 2,
      C = 3,
      k = 4,
      D = 5,
      I = 6,
      O = 7,
      P = 8,
      N = 9,
      L = 10,
      F = 11,
      j = 12,
      V = 13,
      K = 14,
      G = 15,
      Q = 16,
      te = 17,
      ie = 18,
      Y = 19,
      ee = 21,
      oe = 22,
      ne = 23,
      se = 24,
      ue = 25,
      W = !0,
      $ = !1,
      le = !1,
      H = !1,
      ce = !1,
      de = !1,
      Ce = !0,
      Ee = !0,
      fe = !0,
      xe = /* @__PURE__ */new Set(),
      we = {},
      ve = {};
    function Te(s, u) {
      ze(s, u), ze(s + "Capture", u);
    }
    function ze(s, u) {
      we[s] && h("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", s), we[s] = u;
      {
        var v = s.toLowerCase();
        ve[v] = s, s === "onDoubleClick" && (ve.ondblclick = s);
      }
      for (var _ = 0; _ < u.length; _++) xe.add(u[_]);
    }
    var Xe = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u",
      ye = Object.prototype.hasOwnProperty;
    function qe(s) {
      {
        var u = typeof Symbol == "function" && Symbol.toStringTag,
          v = u && s[Symbol.toStringTag] || s.constructor.name || "Object";
        return v;
      }
    }
    function Ae(s) {
      try {
        return Mt(s), !1;
      } catch {
        return !0;
      }
    }
    function Mt(s) {
      return "" + s;
    }
    function Ft(s, u) {
      if (Ae(s)) return h("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", u, qe(s)), Mt(s);
    }
    function un(s) {
      if (Ae(s)) return h("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", qe(s)), Mt(s);
    }
    function gt(s, u) {
      if (Ae(s)) return h("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", u, qe(s)), Mt(s);
    }
    function Pt(s, u) {
      if (Ae(s)) return h("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", u, qe(s)), Mt(s);
    }
    function St(s) {
      if (Ae(s)) return h("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", qe(s)), Mt(s);
    }
    function Dt(s) {
      if (Ae(s)) return h("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", qe(s)), Mt(s);
    }
    var Kt = 0,
      hn = 1,
      Ot = 2,
      Et = 3,
      Vt = 4,
      Xt = 5,
      vn = 6,
      ot = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD",
      We = ot + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040",
      ht = new RegExp("^[" + ot + "][" + We + "]*$"),
      Ke = {},
      yt = {};
    function je(s) {
      return ye.call(yt, s) ? !0 : ye.call(Ke, s) ? !1 : ht.test(s) ? (yt[s] = !0, !0) : (Ke[s] = !0, h("Invalid attribute name: `%s`", s), !1);
    }
    function at(s, u, v) {
      return u !== null ? u.type === Kt : v ? !1 : s.length > 2 && (s[0] === "o" || s[0] === "O") && (s[1] === "n" || s[1] === "N");
    }
    function kt(s, u, v, _) {
      if (v !== null && v.type === Kt) return !1;
      switch (typeof u) {
        case "function":
        // $FlowIssue symbol is perfectly valid here
        case "symbol":
          return !0;
        case "boolean":
          {
            if (_) return !1;
            if (v !== null) return !v.acceptsBooleans;
            var n = s.toLowerCase().slice(0, 5);
            return n !== "data-" && n !== "aria-";
          }
        default:
          return !1;
      }
    }
    function Bt(s, u, v, _) {
      if (u === null || typeof u > "u" || kt(s, u, v, _)) return !0;
      if (_) return !1;
      if (v !== null) switch (v.type) {
        case Et:
          return !u;
        case Vt:
          return u === !1;
        case Xt:
          return isNaN(u);
        case vn:
          return isNaN(u) || u < 1;
      }
      return !1;
    }
    function Ht(s) {
      return en.hasOwnProperty(s) ? en[s] : null;
    }
    function ln(s, u, v, _, n, a, f) {
      this.acceptsBooleans = u === Ot || u === Et || u === Vt, this.attributeName = _, this.attributeNamespace = n, this.mustUseProperty = v, this.propertyName = s, this.type = u, this.sanitizeURL = a, this.removeEmptyString = f;
    }
    var en = {},
      Rr = ["children", "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue", "defaultChecked", "innerHTML", "suppressContentEditableWarning", "suppressHydrationWarning", "style"];
    Rr.forEach(function (s) {
      en[s] = new ln(s, Kt, !1,
      // mustUseProperty
      s,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (s) {
      var u = s[0],
        v = s[1];
      en[u] = new ln(u, hn, !1,
      // mustUseProperty
      v,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (s) {
      en[s] = new ln(s, Ot, !1,
      // mustUseProperty
      s.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (s) {
      en[s] = new ln(s, Ot, !1,
      // mustUseProperty
      s,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["allowFullScreen", "async",
    // Note: there is a special case that prevents it from being written to the DOM
    // on the client side because the browsers are inconsistent. Instead we call focus().
    "autoFocus", "autoPlay", "controls", "default", "defer", "disabled", "disablePictureInPicture", "disableRemotePlayback", "formNoValidate", "hidden", "loop", "noModule", "noValidate", "open", "playsInline", "readOnly", "required", "reversed", "scoped", "seamless",
    // Microdata
    "itemScope"].forEach(function (s) {
      en[s] = new ln(s, Et, !1,
      // mustUseProperty
      s.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["checked",
    // Note: `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`. We have special logic for handling this.
    "multiple", "muted", "selected"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
    ].forEach(function (s) {
      en[s] = new ln(s, Et, !0,
      // mustUseProperty
      s,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["capture", "download"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
    ].forEach(function (s) {
      en[s] = new ln(s, Vt, !1,
      // mustUseProperty
      s,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["cols", "rows", "size", "span"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
    ].forEach(function (s) {
      en[s] = new ln(s, vn, !1,
      // mustUseProperty
      s,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["rowSpan", "start"].forEach(function (s) {
      en[s] = new ln(s, Xt, !1,
      // mustUseProperty
      s.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    });
    var Nr = /[\-\:]([a-z])/g,
      Hi = function (s) {
        return s[1].toUpperCase();
      };
    ["accent-height", "alignment-baseline", "arabic-form", "baseline-shift", "cap-height", "clip-path", "clip-rule", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "dominant-baseline", "enable-background", "fill-opacity", "fill-rule", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "glyph-name", "glyph-orientation-horizontal", "glyph-orientation-vertical", "horiz-adv-x", "horiz-origin-x", "image-rendering", "letter-spacing", "lighting-color", "marker-end", "marker-mid", "marker-start", "overline-position", "overline-thickness", "paint-order", "panose-1", "pointer-events", "rendering-intent", "shape-rendering", "stop-color", "stop-opacity", "strikethrough-position", "strikethrough-thickness", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "text-anchor", "text-decoration", "text-rendering", "underline-position", "underline-thickness", "unicode-bidi", "unicode-range", "units-per-em", "v-alphabetic", "v-hanging", "v-ideographic", "v-mathematical", "vector-effect", "vert-adv-y", "vert-origin-x", "vert-origin-y", "word-spacing", "writing-mode", "xmlns:xlink", "x-height"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
    ].forEach(function (s) {
      var u = s.replace(Nr, Hi);
      en[u] = new ln(u, hn, !1,
      // mustUseProperty
      s, null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["xlink:actuate", "xlink:arcrole", "xlink:role", "xlink:show", "xlink:title", "xlink:type"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
    ].forEach(function (s) {
      var u = s.replace(Nr, Hi);
      en[u] = new ln(u, hn, !1,
      // mustUseProperty
      s, "http://www.w3.org/1999/xlink", !1,
      // sanitizeURL
      !1);
    }), ["xml:base", "xml:lang", "xml:space"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
    ].forEach(function (s) {
      var u = s.replace(Nr, Hi);
      en[u] = new ln(u, hn, !1,
      // mustUseProperty
      s, "http://www.w3.org/XML/1998/namespace", !1,
      // sanitizeURL
      !1);
    }), ["tabIndex", "crossOrigin"].forEach(function (s) {
      en[s] = new ln(s, hn, !1,
      // mustUseProperty
      s.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    });
    var ll = "xlinkHref";
    en[ll] = new ln("xlinkHref", hn, !1,
    // mustUseProperty
    "xlink:href", "http://www.w3.org/1999/xlink", !0,
    // sanitizeURL
    !1), ["src", "href", "action", "formAction"].forEach(function (s) {
      en[s] = new ln(s, hn, !1,
      // mustUseProperty
      s.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !0,
      // sanitizeURL
      !0);
    });
    var yo = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i,
      _l = !1;
    function Mo(s) {
      !_l && yo.test(s) && (_l = !0, h("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(s)));
    }
    function bo(s, u, v, _) {
      if (_.mustUseProperty) {
        var n = _.propertyName;
        return s[n];
      } else {
        Ft(v, u), _.sanitizeURL && Mo("" + v);
        var a = _.attributeName,
          f = null;
        if (_.type === Vt) {
          if (s.hasAttribute(a)) {
            var m = s.getAttribute(a);
            return m === "" ? !0 : Bt(u, v, _, !1) ? m : m === "" + v ? v : m;
          }
        } else if (s.hasAttribute(a)) {
          if (Bt(u, v, _, !1)) return s.getAttribute(a);
          if (_.type === Et) return v;
          f = s.getAttribute(a);
        }
        return Bt(u, v, _, !1) ? f === null ? v : f : f === "" + v ? v : f;
      }
    }
    function Tu(s, u, v, _) {
      {
        if (!je(u)) return;
        if (!s.hasAttribute(u)) return v === void 0 ? void 0 : null;
        var n = s.getAttribute(u);
        return Ft(v, u), n === "" + v ? v : n;
      }
    }
    function Ha(s, u, v, _) {
      var n = Ht(u);
      if (!at(u, n, _)) {
        if (Bt(u, v, n, _) && (v = null), _ || n === null) {
          if (je(u)) {
            var a = u;
            v === null ? s.removeAttribute(a) : (Ft(v, u), s.setAttribute(a, "" + v));
          }
          return;
        }
        var f = n.mustUseProperty;
        if (f) {
          var m = n.propertyName;
          if (v === null) {
            var b = n.type;
            s[m] = b === Et ? !1 : "";
          } else s[m] = v;
          return;
        }
        var T = n.attributeName,
          M = n.attributeNamespace;
        if (v === null) s.removeAttribute(T);else {
          var z = n.type,
            U;
          z === Et || z === Vt && v === !0 ? U = "" : (Ft(v, T), U = "" + v, n.sanitizeURL && Mo(U.toString())), M ? s.setAttributeNS(M, T, U) : s.setAttribute(T, U);
        }
      }
    }
    var $i = Symbol.for("react.element"),
      oi = Symbol.for("react.portal"),
      Oo = Symbol.for("react.fragment"),
      $a = Symbol.for("react.strict_mode"),
      Lo = Symbol.for("react.profiler"),
      Z = Symbol.for("react.provider"),
      Ne = Symbol.for("react.context"),
      Ye = Symbol.for("react.forward_ref"),
      xt = Symbol.for("react.suspense"),
      rn = Symbol.for("react.suspense_list"),
      $t = Symbol.for("react.memo"),
      Ct = Symbol.for("react.lazy"),
      qt = Symbol.for("react.scope"),
      yr = Symbol.for("react.debug_trace_mode"),
      Tn = Symbol.for("react.offscreen"),
      jn = Symbol.for("react.legacy_hidden"),
      Lr = Symbol.for("react.cache"),
      Wa = Symbol.for("react.tracing_marker"),
      Ru = Symbol.iterator,
      Wi = "@@iterator";
    function yn(s) {
      if (s === null || typeof s != "object") return null;
      var u = Ru && s[Ru] || s[Wi];
      return typeof u == "function" ? u : null;
    }
    var Qt = Object.assign,
      Es = 0,
      Wp,
      Du,
      tg,
      qp,
      Iu,
      qi,
      ng;
    function gi() {}
    gi.__reactDisabledLog = !0;
    function uw() {
      {
        if (Es === 0) {
          Wp = console.log, Du = console.info, tg = console.warn, qp = console.error, Iu = console.group, qi = console.groupCollapsed, ng = console.groupEnd;
          var s = {
            configurable: !0,
            enumerable: !0,
            value: gi,
            writable: !0
          };
          Object.defineProperties(console, {
            info: s,
            log: s,
            warn: s,
            error: s,
            group: s,
            groupCollapsed: s,
            groupEnd: s
          });
        }
        Es++;
      }
    }
    function cw() {
      {
        if (Es--, Es === 0) {
          var s = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Qt({}, s, {
              value: Wp
            }),
            info: Qt({}, s, {
              value: Du
            }),
            warn: Qt({}, s, {
              value: tg
            }),
            error: Qt({}, s, {
              value: qp
            }),
            group: Qt({}, s, {
              value: Iu
            }),
            groupCollapsed: Qt({}, s, {
              value: qi
            }),
            groupEnd: Qt({}, s, {
              value: ng
            })
          });
        }
        Es < 0 && h("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Yp = i.ReactCurrentDispatcher,
      xl;
    function Yi(s, u, v) {
      {
        if (xl === void 0) try {
          throw Error();
        } catch (n) {
          var _ = n.stack.trim().match(/\n( *(at )?)/);
          xl = _ && _[1] || "";
        }
        return `
` + xl + s;
      }
    }
    var Cs = !1,
      ks;
    {
      var dw = typeof WeakMap == "function" ? WeakMap : Map;
      ks = new dw();
    }
    function Gp(s, u) {
      if (!s || Cs) return "";
      {
        var v = ks.get(s);
        if (v !== void 0) return v;
      }
      var _;
      Cs = !0;
      var n = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var a;
      a = Yp.current, Yp.current = null, uw();
      try {
        if (u) {
          var f = function () {
            throw Error();
          };
          if (Object.defineProperty(f.prototype, "props", {
            set: function () {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(f, []);
            } catch (J) {
              _ = J;
            }
            Reflect.construct(s, [], f);
          } else {
            try {
              f.call();
            } catch (J) {
              _ = J;
            }
            s.call(f.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (J) {
            _ = J;
          }
          s();
        }
      } catch (J) {
        if (J && _ && typeof J.stack == "string") {
          for (var m = J.stack.split(`
`), b = _.stack.split(`
`), T = m.length - 1, M = b.length - 1; T >= 1 && M >= 0 && m[T] !== b[M];) M--;
          for (; T >= 1 && M >= 0; T--, M--) if (m[T] !== b[M]) {
            if (T !== 1 || M !== 1) do if (T--, M--, M < 0 || m[T] !== b[M]) {
              var z = `
` + m[T].replace(" at new ", " at ");
              return s.displayName && z.includes("<anonymous>") && (z = z.replace("<anonymous>", s.displayName)), typeof s == "function" && ks.set(s, z), z;
            } while (T >= 1 && M >= 0);
            break;
          }
        }
      } finally {
        Cs = !1, Yp.current = a, cw(), Error.prepareStackTrace = n;
      }
      var U = s ? s.displayName || s.name : "",
        X = U ? Yi(U) : "";
      return typeof s == "function" && ks.set(s, X), X;
    }
    function Xp(s, u, v) {
      return Gp(s, !0);
    }
    function pd(s, u, v) {
      return Gp(s, !1);
    }
    function Kp(s) {
      var u = s.prototype;
      return !!(u && u.isReactComponent);
    }
    function Ts(s, u, v) {
      if (s == null) return "";
      if (typeof s == "function") return Gp(s, Kp(s));
      if (typeof s == "string") return Yi(s);
      switch (s) {
        case xt:
          return Yi("Suspense");
        case rn:
          return Yi("SuspenseList");
      }
      if (typeof s == "object") switch (s.$$typeof) {
        case Ye:
          return pd(s.render);
        case $t:
          return Ts(s.type, u, v);
        case Ct:
          {
            var _ = s,
              n = _._payload,
              a = _._init;
            try {
              return Ts(a(n), u, v);
            } catch {}
          }
      }
      return "";
    }
    function fw(s) {
      switch (s._debugOwner && s._debugOwner.type, s._debugSource, s.tag) {
        case D:
          return Yi(s.type);
        case Q:
          return Yi("Lazy");
        case V:
          return Yi("Suspense");
        case Y:
          return Yi("SuspenseList");
        case w:
        case E:
        case G:
          return pd(s.type);
        case F:
          return pd(s.type.render);
        case x:
          return Xp(s.type);
        default:
          return "";
      }
    }
    function hd(s) {
      try {
        var u = "",
          v = s;
        do u += fw(v), v = v.return; while (v);
        return u;
      } catch (_) {
        return `
Error generating stack: ` + _.message + `
` + _.stack;
      }
    }
    function gn(s, u, v) {
      var _ = s.displayName;
      if (_) return _;
      var n = u.displayName || u.name || "";
      return n !== "" ? v + "(" + n + ")" : v;
    }
    function Qp(s) {
      return s.displayName || "Context";
    }
    function bn(s) {
      if (s == null) return null;
      if (typeof s.tag == "number" && h("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof s == "function") return s.displayName || s.name || null;
      if (typeof s == "string") return s;
      switch (s) {
        case Oo:
          return "Fragment";
        case oi:
          return "Portal";
        case Lo:
          return "Profiler";
        case $a:
          return "StrictMode";
        case xt:
          return "Suspense";
        case rn:
          return "SuspenseList";
      }
      if (typeof s == "object") switch (s.$$typeof) {
        case Ne:
          var u = s;
          return Qp(u) + ".Consumer";
        case Z:
          var v = s;
          return Qp(v._context) + ".Provider";
        case Ye:
          return gn(s, s.render, "ForwardRef");
        case $t:
          var _ = s.displayName || null;
          return _ !== null ? _ : bn(s.type) || "Memo";
        case Ct:
          {
            var n = s,
              a = n._payload,
              f = n._init;
            try {
              return bn(f(a));
            } catch {
              return null;
            }
          }
      }
      return null;
    }
    function Zp(s, u, v) {
      var _ = u.displayName || u.name || "";
      return s.displayName || (_ !== "" ? v + "(" + _ + ")" : v);
    }
    function Jp(s) {
      return s.displayName || "Context";
    }
    function At(s) {
      var u = s.tag,
        v = s.type;
      switch (u) {
        case se:
          return "Cache";
        case N:
          var _ = v;
          return Jp(_) + ".Consumer";
        case L:
          var n = v;
          return Jp(n._context) + ".Provider";
        case ie:
          return "DehydratedFragment";
        case F:
          return Zp(v, v.render, "ForwardRef");
        case O:
          return "Fragment";
        case D:
          return v;
        case k:
          return "Portal";
        case C:
          return "Root";
        case I:
          return "Text";
        case Q:
          return bn(v);
        case P:
          return v === $a ? "StrictMode" : "Mode";
        case oe:
          return "Offscreen";
        case j:
          return "Profiler";
        case ee:
          return "Scope";
        case V:
          return "Suspense";
        case Y:
          return "SuspenseList";
        case ue:
          return "TracingMarker";
        // The display name for this tags come from the user-provided type:
        case x:
        case w:
        case te:
        case E:
        case K:
        case G:
          if (typeof v == "function") return v.displayName || v.name || null;
          if (typeof v == "string") return v;
          break;
      }
      return null;
    }
    var eh = i.ReactDebugCurrentFrame,
      Pr = null,
      Po = !1;
    function yi() {
      {
        if (Pr === null) return null;
        var s = Pr._debugOwner;
        if (s !== null && typeof s < "u") return At(s);
      }
      return null;
    }
    function Ao() {
      return Pr === null ? "" : hd(Pr);
    }
    function Un() {
      eh.getCurrentStack = null, Pr = null, Po = !1;
    }
    function Rn(s) {
      eh.getCurrentStack = s === null ? null : Ao, Pr = s, Po = !1;
    }
    function Mu() {
      return Pr;
    }
    function br(s) {
      Po = s;
    }
    function bi(s) {
      return "" + s;
    }
    function qa(s) {
      switch (typeof s) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return s;
        case "object":
          return Dt(s), s;
        default:
          return "";
      }
    }
    var Ou = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function th(s, u) {
      Ou[u.type] || u.onChange || u.onInput || u.readOnly || u.disabled || u.value == null || h("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), u.onChange || u.readOnly || u.disabled || u.checked == null || h("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function nh(s) {
      var u = s.type,
        v = s.nodeName;
      return v && v.toLowerCase() === "input" && (u === "checkbox" || u === "radio");
    }
    function Lu(s) {
      return s._valueTracker;
    }
    function rg(s) {
      s._valueTracker = null;
    }
    function pw(s) {
      var u = "";
      return s && (nh(s) ? u = s.checked ? "true" : "false" : u = s.value), u;
    }
    function Pu(s) {
      var u = nh(s) ? "checked" : "value",
        v = Object.getOwnPropertyDescriptor(s.constructor.prototype, u);
      Dt(s[u]);
      var _ = "" + s[u];
      if (!(s.hasOwnProperty(u) || typeof v > "u" || typeof v.get != "function" || typeof v.set != "function")) {
        var n = v.get,
          a = v.set;
        Object.defineProperty(s, u, {
          configurable: !0,
          get: function () {
            return n.call(this);
          },
          set: function (m) {
            Dt(m), _ = "" + m, a.call(this, m);
          }
        }), Object.defineProperty(s, u, {
          enumerable: v.enumerable
        });
        var f = {
          getValue: function () {
            return _;
          },
          setValue: function (m) {
            Dt(m), _ = "" + m;
          },
          stopTracking: function () {
            rg(s), delete s[u];
          }
        };
        return f;
      }
    }
    function jo(s) {
      Lu(s) || (s._valueTracker = Pu(s));
    }
    function Rs(s) {
      if (!s) return !1;
      var u = Lu(s);
      if (!u) return !0;
      var v = u.getValue(),
        _ = pw(s);
      return _ !== v ? (u.setValue(_), !0) : !1;
    }
    function Ds(s) {
      if (s = s || (typeof document < "u" ? document : void 0), typeof s > "u") return null;
      try {
        return s.activeElement || s.body;
      } catch {
        return s.body;
      }
    }
    var ig = !1,
      ag = !1,
      md = !1,
      Au = !1;
    function vd(s) {
      var u = s.type === "checkbox" || s.type === "radio";
      return u ? s.checked != null : s.value != null;
    }
    function gd(s, u) {
      var v = s,
        _ = u.checked,
        n = Qt({}, u, {
          defaultChecked: void 0,
          defaultValue: void 0,
          value: void 0,
          checked: _ ?? v._wrapperState.initialChecked
        });
      return n;
    }
    function Ya(s, u) {
      th("input", u), u.checked !== void 0 && u.defaultChecked !== void 0 && !ag && (h("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", yi() || "A component", u.type), ag = !0), u.value !== void 0 && u.defaultValue !== void 0 && !ig && (h("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", yi() || "A component", u.type), ig = !0);
      var v = s,
        _ = u.defaultValue == null ? "" : u.defaultValue;
      v._wrapperState = {
        initialChecked: u.checked != null ? u.checked : u.defaultChecked,
        initialValue: qa(u.value != null ? u.value : _),
        controlled: vd(u)
      };
    }
    function yd(s, u) {
      var v = s,
        _ = u.checked;
      _ != null && Ha(v, "checked", _, !1);
    }
    function Sl(s, u) {
      var v = s;
      {
        var _ = vd(u);
        !v._wrapperState.controlled && _ && !Au && (h("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), Au = !0), v._wrapperState.controlled && !_ && !md && (h("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), md = !0);
      }
      yd(s, u);
      var n = qa(u.value),
        a = u.type;
      if (n != null) a === "number" ? (n === 0 && v.value === "" ||
      // We explicitly want to coerce to number here if possible.
      // eslint-disable-next-line
      v.value != n) && (v.value = bi(n)) : v.value !== bi(n) && (v.value = bi(n));else if (a === "submit" || a === "reset") {
        v.removeAttribute("value");
        return;
      }
      u.hasOwnProperty("value") ? _d(v, u.type, n) : u.hasOwnProperty("defaultValue") && _d(v, u.type, qa(u.defaultValue)), u.checked == null && u.defaultChecked != null && (v.defaultChecked = !!u.defaultChecked);
    }
    function rh(s, u, v) {
      var _ = s;
      if (u.hasOwnProperty("value") || u.hasOwnProperty("defaultValue")) {
        var n = u.type,
          a = n === "submit" || n === "reset";
        if (a && (u.value === void 0 || u.value === null)) return;
        var f = bi(_._wrapperState.initialValue);
        v || f !== _.value && (_.value = f), _.defaultValue = f;
      }
      var m = _.name;
      m !== "" && (_.name = ""), _.defaultChecked = !_.defaultChecked, _.defaultChecked = !!_._wrapperState.initialChecked, m !== "" && (_.name = m);
    }
    function bd(s, u) {
      var v = s;
      Sl(v, u), wd(v, u);
    }
    function wd(s, u) {
      var v = u.name;
      if (u.type === "radio" && v != null) {
        for (var _ = s; _.parentNode;) _ = _.parentNode;
        Ft(v, "name");
        for (var n = _.querySelectorAll("input[name=" + JSON.stringify("" + v) + '][type="radio"]'), a = 0; a < n.length; a++) {
          var f = n[a];
          if (!(f === s || f.form !== s.form)) {
            var m = Ef(f);
            if (!m) throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            Rs(f), Sl(f, m);
          }
        }
      }
    }
    function _d(s, u, v) {
      (u !== "number" || Ds(s.ownerDocument) !== s) && (v == null ? s.defaultValue = bi(s._wrapperState.initialValue) : s.defaultValue !== bi(v) && (s.defaultValue = bi(v)));
    }
    var $r = !1,
      Is = !1,
      xd = !1;
    function El(s, u) {
      u.value == null && (typeof u.children == "object" && u.children !== null ? t.Children.forEach(u.children, function (v) {
        v != null && (typeof v == "string" || typeof v == "number" || Is || (Is = !0, h("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }) : u.dangerouslySetInnerHTML != null && (xd || (xd = !0, h("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), u.selected != null && !$r && (h("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), $r = !0);
    }
    function hw(s, u) {
      u.value != null && s.setAttribute("value", bi(qa(u.value)));
    }
    var ih = Array.isArray;
    function wr(s) {
      return ih(s);
    }
    var Ms;
    Ms = !1;
    function ju() {
      var s = yi();
      return s ? `

Check the render method of \`` + s + "`." : "";
    }
    var ah = ["value", "defaultValue"];
    function mw(s) {
      {
        th("select", s);
        for (var u = 0; u < ah.length; u++) {
          var v = ah[u];
          if (s[v] != null) {
            var _ = wr(s[v]);
            s.multiple && !_ ? h("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", v, ju()) : !s.multiple && _ && h("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", v, ju());
          }
        }
      }
    }
    function Cl(s, u, v, _) {
      var n = s.options;
      if (u) {
        for (var a = v, f = {}, m = 0; m < a.length; m++) f["$" + a[m]] = !0;
        for (var b = 0; b < n.length; b++) {
          var T = f.hasOwnProperty("$" + n[b].value);
          n[b].selected !== T && (n[b].selected = T), T && _ && (n[b].defaultSelected = !0);
        }
      } else {
        for (var M = bi(qa(v)), z = null, U = 0; U < n.length; U++) {
          if (n[U].value === M) {
            n[U].selected = !0, _ && (n[U].defaultSelected = !0);
            return;
          }
          z === null && !n[U].disabled && (z = n[U]);
        }
        z !== null && (z.selected = !0);
      }
    }
    function oh(s, u) {
      return Qt({}, u, {
        value: void 0
      });
    }
    function Sd(s, u) {
      var v = s;
      mw(u), v._wrapperState = {
        wasMultiple: !!u.multiple
      }, u.value !== void 0 && u.defaultValue !== void 0 && !Ms && (h("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), Ms = !0);
    }
    function vw(s, u) {
      var v = s;
      v.multiple = !!u.multiple;
      var _ = u.value;
      _ != null ? Cl(v, !!u.multiple, _, !1) : u.defaultValue != null && Cl(v, !!u.multiple, u.defaultValue, !0);
    }
    function gw(s, u) {
      var v = s,
        _ = v._wrapperState.wasMultiple;
      v._wrapperState.wasMultiple = !!u.multiple;
      var n = u.value;
      n != null ? Cl(v, !!u.multiple, n, !1) : _ !== !!u.multiple && (u.defaultValue != null ? Cl(v, !!u.multiple, u.defaultValue, !0) : Cl(v, !!u.multiple, u.multiple ? [] : "", !1));
    }
    function yw(s, u) {
      var v = s,
        _ = u.value;
      _ != null && Cl(v, !!u.multiple, _, !1);
    }
    var og = !1;
    function sh(s, u) {
      var v = s;
      if (u.dangerouslySetInnerHTML != null) throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var _ = Qt({}, u, {
        value: void 0,
        defaultValue: void 0,
        children: bi(v._wrapperState.initialValue)
      });
      return _;
    }
    function lh(s, u) {
      var v = s;
      th("textarea", u), u.value !== void 0 && u.defaultValue !== void 0 && !og && (h("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", yi() || "A component"), og = !0);
      var _ = u.value;
      if (_ == null) {
        var n = u.children,
          a = u.defaultValue;
        if (n != null) {
          h("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (a != null) throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (wr(n)) {
              if (n.length > 1) throw new Error("<textarea> can only have at most one child.");
              n = n[0];
            }
            a = n;
          }
        }
        a == null && (a = ""), _ = a;
      }
      v._wrapperState = {
        initialValue: qa(_)
      };
    }
    function sg(s, u) {
      var v = s,
        _ = qa(u.value),
        n = qa(u.defaultValue);
      if (_ != null) {
        var a = bi(_);
        a !== v.value && (v.value = a), u.defaultValue == null && v.defaultValue !== a && (v.defaultValue = a);
      }
      n != null && (v.defaultValue = bi(n));
    }
    function lg(s, u) {
      var v = s,
        _ = v.textContent;
      _ === v._wrapperState.initialValue && _ !== "" && _ !== null && (v.value = _);
    }
    function bw(s, u) {
      sg(s, u);
    }
    var Ga = "http://www.w3.org/1999/xhtml",
      uh = "http://www.w3.org/1998/Math/MathML",
      ch = "http://www.w3.org/2000/svg";
    function dh(s) {
      switch (s) {
        case "svg":
          return ch;
        case "math":
          return uh;
        default:
          return Ga;
      }
    }
    function fh(s, u) {
      return s == null || s === Ga ? dh(u) : s === ch && u === "foreignObject" ? Ga : s;
    }
    var ug = function (s) {
        return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function (u, v, _, n) {
          MSApp.execUnsafeLocalFunction(function () {
            return s(u, v, _, n);
          });
        } : s;
      },
      Ed,
      cg = ug(function (s, u) {
        if (s.namespaceURI === ch && !("innerHTML" in s)) {
          Ed = Ed || document.createElement("div"), Ed.innerHTML = "<svg>" + u.valueOf().toString() + "</svg>";
          for (var v = Ed.firstChild; s.firstChild;) s.removeChild(s.firstChild);
          for (; v.firstChild;) s.appendChild(v.firstChild);
          return;
        }
        s.innerHTML = u;
      }),
      Wr = 1,
      Xa = 3,
      er = 8,
      Ka = 9,
      ph = 11,
      kl = function (s, u) {
        if (u) {
          var v = s.firstChild;
          if (v && v === s.lastChild && v.nodeType === Xa) {
            v.nodeValue = u;
            return;
          }
        }
        s.textContent = u;
      },
      Fu = {
        animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
        background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
        backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
        border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
        borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
        borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
        borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
        borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
        borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
        borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
        borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
        borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
        borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
        borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
        borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
        borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
        borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
        columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
        columns: ["columnCount", "columnWidth"],
        flex: ["flexBasis", "flexGrow", "flexShrink"],
        flexFlow: ["flexDirection", "flexWrap"],
        font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
        fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
        gap: ["columnGap", "rowGap"],
        grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
        gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
        gridColumn: ["gridColumnEnd", "gridColumnStart"],
        gridColumnGap: ["columnGap"],
        gridGap: ["columnGap", "rowGap"],
        gridRow: ["gridRowEnd", "gridRowStart"],
        gridRowGap: ["rowGap"],
        gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
        listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
        margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
        marker: ["markerEnd", "markerMid", "markerStart"],
        mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
        maskPosition: ["maskPositionX", "maskPositionY"],
        outline: ["outlineColor", "outlineStyle", "outlineWidth"],
        overflow: ["overflowX", "overflowY"],
        padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
        placeContent: ["alignContent", "justifyContent"],
        placeItems: ["alignItems", "justifyItems"],
        placeSelf: ["alignSelf", "justifySelf"],
        textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
        textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
        transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
        wordWrap: ["overflowWrap"]
      },
      Nu = {
        animationIterationCount: !0,
        aspectRatio: !0,
        borderImageOutset: !0,
        borderImageSlice: !0,
        borderImageWidth: !0,
        boxFlex: !0,
        boxFlexGroup: !0,
        boxOrdinalGroup: !0,
        columnCount: !0,
        columns: !0,
        flex: !0,
        flexGrow: !0,
        flexPositive: !0,
        flexShrink: !0,
        flexNegative: !0,
        flexOrder: !0,
        gridArea: !0,
        gridRow: !0,
        gridRowEnd: !0,
        gridRowSpan: !0,
        gridRowStart: !0,
        gridColumn: !0,
        gridColumnEnd: !0,
        gridColumnSpan: !0,
        gridColumnStart: !0,
        fontWeight: !0,
        lineClamp: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        tabSize: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
        // SVG-related properties
        fillOpacity: !0,
        floodOpacity: !0,
        stopOpacity: !0,
        strokeDasharray: !0,
        strokeDashoffset: !0,
        strokeMiterlimit: !0,
        strokeOpacity: !0,
        strokeWidth: !0
      };
    function dg(s, u) {
      return s + u.charAt(0).toUpperCase() + u.substring(1);
    }
    var fg = ["Webkit", "ms", "Moz", "O"];
    Object.keys(Nu).forEach(function (s) {
      fg.forEach(function (u) {
        Nu[dg(u, s)] = Nu[s];
      });
    });
    function Cd(s, u, v) {
      var _ = u == null || typeof u == "boolean" || u === "";
      return _ ? "" : !v && typeof u == "number" && u !== 0 && !(Nu.hasOwnProperty(s) && Nu[s]) ? u + "px" : (Pt(u, s), ("" + u).trim());
    }
    var pg = /([A-Z])/g,
      hg = /^ms-/;
    function Tl(s) {
      return s.replace(pg, "-$1").toLowerCase().replace(hg, "-ms-");
    }
    var mg = function () {};
    {
      var ww = /^(?:webkit|moz|o)[A-Z]/,
        _w = /^-ms-/,
        vg = /-(.)/g,
        hh = /;\s*$/,
        pa = {},
        Os = {},
        gg = !1,
        zu = !1,
        xw = function (s) {
          return s.replace(vg, function (u, v) {
            return v.toUpperCase();
          });
        },
        yg = function (s) {
          pa.hasOwnProperty(s) && pa[s] || (pa[s] = !0, h("Unsupported style property %s. Did you mean %s?", s,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          xw(s.replace(_w, "ms-"))));
        },
        mh = function (s) {
          pa.hasOwnProperty(s) && pa[s] || (pa[s] = !0, h("Unsupported vendor-prefixed style property %s. Did you mean %s?", s, s.charAt(0).toUpperCase() + s.slice(1)));
        },
        vh = function (s, u) {
          Os.hasOwnProperty(u) && Os[u] || (Os[u] = !0, h(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, s, u.replace(hh, "")));
        },
        bg = function (s, u) {
          gg || (gg = !0, h("`NaN` is an invalid value for the `%s` css style property.", s));
        },
        wg = function (s, u) {
          zu || (zu = !0, h("`Infinity` is an invalid value for the `%s` css style property.", s));
        };
      mg = function (s, u) {
        s.indexOf("-") > -1 ? yg(s) : ww.test(s) ? mh(s) : hh.test(u) && vh(s, u), typeof u == "number" && (isNaN(u) ? bg(s, u) : isFinite(u) || wg(s, u));
      };
    }
    var _g = mg;
    function Sw(s) {
      {
        var u = "",
          v = "";
        for (var _ in s) if (s.hasOwnProperty(_)) {
          var n = s[_];
          if (n != null) {
            var a = _.indexOf("--") === 0;
            u += v + (a ? _ : Tl(_)) + ":", u += Cd(_, n, a), v = ";";
          }
        }
        return u || null;
      }
    }
    function xg(s, u) {
      var v = s.style;
      for (var _ in u) if (u.hasOwnProperty(_)) {
        var n = _.indexOf("--") === 0;
        n || _g(_, u[_]);
        var a = Cd(_, u[_], n);
        _ === "float" && (_ = "cssFloat"), n ? v.setProperty(_, a) : v[_] = a;
      }
    }
    function Ew(s) {
      return s == null || typeof s == "boolean" || s === "";
    }
    function Sg(s) {
      var u = {};
      for (var v in s) for (var _ = Fu[v] || [v], n = 0; n < _.length; n++) u[_[n]] = v;
      return u;
    }
    function Cw(s, u) {
      {
        if (!u) return;
        var v = Sg(s),
          _ = Sg(u),
          n = {};
        for (var a in v) {
          var f = v[a],
            m = _[a];
          if (m && f !== m) {
            var b = f + "," + m;
            if (n[b]) continue;
            n[b] = !0, h("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", Ew(s[f]) ? "Removing" : "Updating", f, m);
          }
        }
      }
    }
    var Gi = {
        area: !0,
        base: !0,
        br: !0,
        col: !0,
        embed: !0,
        hr: !0,
        img: !0,
        input: !0,
        keygen: !0,
        link: !0,
        meta: !0,
        param: !0,
        source: !0,
        track: !0,
        wbr: !0
        // NOTE: menuitem's close tag should be omitted, but that causes problems.
      },
      Vu = Qt({
        menuitem: !0
      }, Gi),
      Eg = "__html";
    function kd(s, u) {
      if (u) {
        if (Vu[s] && (u.children != null || u.dangerouslySetInnerHTML != null)) throw new Error(s + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (u.dangerouslySetInnerHTML != null) {
          if (u.children != null) throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (typeof u.dangerouslySetInnerHTML != "object" || !(Eg in u.dangerouslySetInnerHTML)) throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!u.suppressContentEditableWarning && u.contentEditable && u.children != null && h("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), u.style != null && typeof u.style != "object") throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function Fo(s, u) {
      if (s.indexOf("-") === -1) return typeof u.is == "string";
      switch (s) {
        // These are reserved SVG and MathML elements.
        // We don't mind this list too much because we expect it to never grow.
        // The alternative is to track the namespace in a few places which is convoluted.
        // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var Bu = {
        // HTML
        accept: "accept",
        acceptcharset: "acceptCharset",
        "accept-charset": "acceptCharset",
        accesskey: "accessKey",
        action: "action",
        allowfullscreen: "allowFullScreen",
        alt: "alt",
        as: "as",
        async: "async",
        autocapitalize: "autoCapitalize",
        autocomplete: "autoComplete",
        autocorrect: "autoCorrect",
        autofocus: "autoFocus",
        autoplay: "autoPlay",
        autosave: "autoSave",
        capture: "capture",
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        challenge: "challenge",
        charset: "charSet",
        checked: "checked",
        children: "children",
        cite: "cite",
        class: "className",
        classid: "classID",
        classname: "className",
        cols: "cols",
        colspan: "colSpan",
        content: "content",
        contenteditable: "contentEditable",
        contextmenu: "contextMenu",
        controls: "controls",
        controlslist: "controlsList",
        coords: "coords",
        crossorigin: "crossOrigin",
        dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
        data: "data",
        datetime: "dateTime",
        default: "default",
        defaultchecked: "defaultChecked",
        defaultvalue: "defaultValue",
        defer: "defer",
        dir: "dir",
        disabled: "disabled",
        disablepictureinpicture: "disablePictureInPicture",
        disableremoteplayback: "disableRemotePlayback",
        download: "download",
        draggable: "draggable",
        enctype: "encType",
        enterkeyhint: "enterKeyHint",
        for: "htmlFor",
        form: "form",
        formmethod: "formMethod",
        formaction: "formAction",
        formenctype: "formEncType",
        formnovalidate: "formNoValidate",
        formtarget: "formTarget",
        frameborder: "frameBorder",
        headers: "headers",
        height: "height",
        hidden: "hidden",
        high: "high",
        href: "href",
        hreflang: "hrefLang",
        htmlfor: "htmlFor",
        httpequiv: "httpEquiv",
        "http-equiv": "httpEquiv",
        icon: "icon",
        id: "id",
        imagesizes: "imageSizes",
        imagesrcset: "imageSrcSet",
        innerhtml: "innerHTML",
        inputmode: "inputMode",
        integrity: "integrity",
        is: "is",
        itemid: "itemID",
        itemprop: "itemProp",
        itemref: "itemRef",
        itemscope: "itemScope",
        itemtype: "itemType",
        keyparams: "keyParams",
        keytype: "keyType",
        kind: "kind",
        label: "label",
        lang: "lang",
        list: "list",
        loop: "loop",
        low: "low",
        manifest: "manifest",
        marginwidth: "marginWidth",
        marginheight: "marginHeight",
        max: "max",
        maxlength: "maxLength",
        media: "media",
        mediagroup: "mediaGroup",
        method: "method",
        min: "min",
        minlength: "minLength",
        multiple: "multiple",
        muted: "muted",
        name: "name",
        nomodule: "noModule",
        nonce: "nonce",
        novalidate: "noValidate",
        open: "open",
        optimum: "optimum",
        pattern: "pattern",
        placeholder: "placeholder",
        playsinline: "playsInline",
        poster: "poster",
        preload: "preload",
        profile: "profile",
        radiogroup: "radioGroup",
        readonly: "readOnly",
        referrerpolicy: "referrerPolicy",
        rel: "rel",
        required: "required",
        reversed: "reversed",
        role: "role",
        rows: "rows",
        rowspan: "rowSpan",
        sandbox: "sandbox",
        scope: "scope",
        scoped: "scoped",
        scrolling: "scrolling",
        seamless: "seamless",
        selected: "selected",
        shape: "shape",
        size: "size",
        sizes: "sizes",
        span: "span",
        spellcheck: "spellCheck",
        src: "src",
        srcdoc: "srcDoc",
        srclang: "srcLang",
        srcset: "srcSet",
        start: "start",
        step: "step",
        style: "style",
        summary: "summary",
        tabindex: "tabIndex",
        target: "target",
        title: "title",
        type: "type",
        usemap: "useMap",
        value: "value",
        width: "width",
        wmode: "wmode",
        wrap: "wrap",
        // SVG
        about: "about",
        accentheight: "accentHeight",
        "accent-height": "accentHeight",
        accumulate: "accumulate",
        additive: "additive",
        alignmentbaseline: "alignmentBaseline",
        "alignment-baseline": "alignmentBaseline",
        allowreorder: "allowReorder",
        alphabetic: "alphabetic",
        amplitude: "amplitude",
        arabicform: "arabicForm",
        "arabic-form": "arabicForm",
        ascent: "ascent",
        attributename: "attributeName",
        attributetype: "attributeType",
        autoreverse: "autoReverse",
        azimuth: "azimuth",
        basefrequency: "baseFrequency",
        baselineshift: "baselineShift",
        "baseline-shift": "baselineShift",
        baseprofile: "baseProfile",
        bbox: "bbox",
        begin: "begin",
        bias: "bias",
        by: "by",
        calcmode: "calcMode",
        capheight: "capHeight",
        "cap-height": "capHeight",
        clip: "clip",
        clippath: "clipPath",
        "clip-path": "clipPath",
        clippathunits: "clipPathUnits",
        cliprule: "clipRule",
        "clip-rule": "clipRule",
        color: "color",
        colorinterpolation: "colorInterpolation",
        "color-interpolation": "colorInterpolation",
        colorinterpolationfilters: "colorInterpolationFilters",
        "color-interpolation-filters": "colorInterpolationFilters",
        colorprofile: "colorProfile",
        "color-profile": "colorProfile",
        colorrendering: "colorRendering",
        "color-rendering": "colorRendering",
        contentscripttype: "contentScriptType",
        contentstyletype: "contentStyleType",
        cursor: "cursor",
        cx: "cx",
        cy: "cy",
        d: "d",
        datatype: "datatype",
        decelerate: "decelerate",
        descent: "descent",
        diffuseconstant: "diffuseConstant",
        direction: "direction",
        display: "display",
        divisor: "divisor",
        dominantbaseline: "dominantBaseline",
        "dominant-baseline": "dominantBaseline",
        dur: "dur",
        dx: "dx",
        dy: "dy",
        edgemode: "edgeMode",
        elevation: "elevation",
        enablebackground: "enableBackground",
        "enable-background": "enableBackground",
        end: "end",
        exponent: "exponent",
        externalresourcesrequired: "externalResourcesRequired",
        fill: "fill",
        fillopacity: "fillOpacity",
        "fill-opacity": "fillOpacity",
        fillrule: "fillRule",
        "fill-rule": "fillRule",
        filter: "filter",
        filterres: "filterRes",
        filterunits: "filterUnits",
        floodopacity: "floodOpacity",
        "flood-opacity": "floodOpacity",
        floodcolor: "floodColor",
        "flood-color": "floodColor",
        focusable: "focusable",
        fontfamily: "fontFamily",
        "font-family": "fontFamily",
        fontsize: "fontSize",
        "font-size": "fontSize",
        fontsizeadjust: "fontSizeAdjust",
        "font-size-adjust": "fontSizeAdjust",
        fontstretch: "fontStretch",
        "font-stretch": "fontStretch",
        fontstyle: "fontStyle",
        "font-style": "fontStyle",
        fontvariant: "fontVariant",
        "font-variant": "fontVariant",
        fontweight: "fontWeight",
        "font-weight": "fontWeight",
        format: "format",
        from: "from",
        fx: "fx",
        fy: "fy",
        g1: "g1",
        g2: "g2",
        glyphname: "glyphName",
        "glyph-name": "glyphName",
        glyphorientationhorizontal: "glyphOrientationHorizontal",
        "glyph-orientation-horizontal": "glyphOrientationHorizontal",
        glyphorientationvertical: "glyphOrientationVertical",
        "glyph-orientation-vertical": "glyphOrientationVertical",
        glyphref: "glyphRef",
        gradienttransform: "gradientTransform",
        gradientunits: "gradientUnits",
        hanging: "hanging",
        horizadvx: "horizAdvX",
        "horiz-adv-x": "horizAdvX",
        horizoriginx: "horizOriginX",
        "horiz-origin-x": "horizOriginX",
        ideographic: "ideographic",
        imagerendering: "imageRendering",
        "image-rendering": "imageRendering",
        in2: "in2",
        in: "in",
        inlist: "inlist",
        intercept: "intercept",
        k1: "k1",
        k2: "k2",
        k3: "k3",
        k4: "k4",
        k: "k",
        kernelmatrix: "kernelMatrix",
        kernelunitlength: "kernelUnitLength",
        kerning: "kerning",
        keypoints: "keyPoints",
        keysplines: "keySplines",
        keytimes: "keyTimes",
        lengthadjust: "lengthAdjust",
        letterspacing: "letterSpacing",
        "letter-spacing": "letterSpacing",
        lightingcolor: "lightingColor",
        "lighting-color": "lightingColor",
        limitingconeangle: "limitingConeAngle",
        local: "local",
        markerend: "markerEnd",
        "marker-end": "markerEnd",
        markerheight: "markerHeight",
        markermid: "markerMid",
        "marker-mid": "markerMid",
        markerstart: "markerStart",
        "marker-start": "markerStart",
        markerunits: "markerUnits",
        markerwidth: "markerWidth",
        mask: "mask",
        maskcontentunits: "maskContentUnits",
        maskunits: "maskUnits",
        mathematical: "mathematical",
        mode: "mode",
        numoctaves: "numOctaves",
        offset: "offset",
        opacity: "opacity",
        operator: "operator",
        order: "order",
        orient: "orient",
        orientation: "orientation",
        origin: "origin",
        overflow: "overflow",
        overlineposition: "overlinePosition",
        "overline-position": "overlinePosition",
        overlinethickness: "overlineThickness",
        "overline-thickness": "overlineThickness",
        paintorder: "paintOrder",
        "paint-order": "paintOrder",
        panose1: "panose1",
        "panose-1": "panose1",
        pathlength: "pathLength",
        patterncontentunits: "patternContentUnits",
        patterntransform: "patternTransform",
        patternunits: "patternUnits",
        pointerevents: "pointerEvents",
        "pointer-events": "pointerEvents",
        points: "points",
        pointsatx: "pointsAtX",
        pointsaty: "pointsAtY",
        pointsatz: "pointsAtZ",
        prefix: "prefix",
        preservealpha: "preserveAlpha",
        preserveaspectratio: "preserveAspectRatio",
        primitiveunits: "primitiveUnits",
        property: "property",
        r: "r",
        radius: "radius",
        refx: "refX",
        refy: "refY",
        renderingintent: "renderingIntent",
        "rendering-intent": "renderingIntent",
        repeatcount: "repeatCount",
        repeatdur: "repeatDur",
        requiredextensions: "requiredExtensions",
        requiredfeatures: "requiredFeatures",
        resource: "resource",
        restart: "restart",
        result: "result",
        results: "results",
        rotate: "rotate",
        rx: "rx",
        ry: "ry",
        scale: "scale",
        security: "security",
        seed: "seed",
        shaperendering: "shapeRendering",
        "shape-rendering": "shapeRendering",
        slope: "slope",
        spacing: "spacing",
        specularconstant: "specularConstant",
        specularexponent: "specularExponent",
        speed: "speed",
        spreadmethod: "spreadMethod",
        startoffset: "startOffset",
        stddeviation: "stdDeviation",
        stemh: "stemh",
        stemv: "stemv",
        stitchtiles: "stitchTiles",
        stopcolor: "stopColor",
        "stop-color": "stopColor",
        stopopacity: "stopOpacity",
        "stop-opacity": "stopOpacity",
        strikethroughposition: "strikethroughPosition",
        "strikethrough-position": "strikethroughPosition",
        strikethroughthickness: "strikethroughThickness",
        "strikethrough-thickness": "strikethroughThickness",
        string: "string",
        stroke: "stroke",
        strokedasharray: "strokeDasharray",
        "stroke-dasharray": "strokeDasharray",
        strokedashoffset: "strokeDashoffset",
        "stroke-dashoffset": "strokeDashoffset",
        strokelinecap: "strokeLinecap",
        "stroke-linecap": "strokeLinecap",
        strokelinejoin: "strokeLinejoin",
        "stroke-linejoin": "strokeLinejoin",
        strokemiterlimit: "strokeMiterlimit",
        "stroke-miterlimit": "strokeMiterlimit",
        strokewidth: "strokeWidth",
        "stroke-width": "strokeWidth",
        strokeopacity: "strokeOpacity",
        "stroke-opacity": "strokeOpacity",
        suppresscontenteditablewarning: "suppressContentEditableWarning",
        suppresshydrationwarning: "suppressHydrationWarning",
        surfacescale: "surfaceScale",
        systemlanguage: "systemLanguage",
        tablevalues: "tableValues",
        targetx: "targetX",
        targety: "targetY",
        textanchor: "textAnchor",
        "text-anchor": "textAnchor",
        textdecoration: "textDecoration",
        "text-decoration": "textDecoration",
        textlength: "textLength",
        textrendering: "textRendering",
        "text-rendering": "textRendering",
        to: "to",
        transform: "transform",
        typeof: "typeof",
        u1: "u1",
        u2: "u2",
        underlineposition: "underlinePosition",
        "underline-position": "underlinePosition",
        underlinethickness: "underlineThickness",
        "underline-thickness": "underlineThickness",
        unicode: "unicode",
        unicodebidi: "unicodeBidi",
        "unicode-bidi": "unicodeBidi",
        unicoderange: "unicodeRange",
        "unicode-range": "unicodeRange",
        unitsperem: "unitsPerEm",
        "units-per-em": "unitsPerEm",
        unselectable: "unselectable",
        valphabetic: "vAlphabetic",
        "v-alphabetic": "vAlphabetic",
        values: "values",
        vectoreffect: "vectorEffect",
        "vector-effect": "vectorEffect",
        version: "version",
        vertadvy: "vertAdvY",
        "vert-adv-y": "vertAdvY",
        vertoriginx: "vertOriginX",
        "vert-origin-x": "vertOriginX",
        vertoriginy: "vertOriginY",
        "vert-origin-y": "vertOriginY",
        vhanging: "vHanging",
        "v-hanging": "vHanging",
        videographic: "vIdeographic",
        "v-ideographic": "vIdeographic",
        viewbox: "viewBox",
        viewtarget: "viewTarget",
        visibility: "visibility",
        vmathematical: "vMathematical",
        "v-mathematical": "vMathematical",
        vocab: "vocab",
        widths: "widths",
        wordspacing: "wordSpacing",
        "word-spacing": "wordSpacing",
        writingmode: "writingMode",
        "writing-mode": "writingMode",
        x1: "x1",
        x2: "x2",
        x: "x",
        xchannelselector: "xChannelSelector",
        xheight: "xHeight",
        "x-height": "xHeight",
        xlinkactuate: "xlinkActuate",
        "xlink:actuate": "xlinkActuate",
        xlinkarcrole: "xlinkArcrole",
        "xlink:arcrole": "xlinkArcrole",
        xlinkhref: "xlinkHref",
        "xlink:href": "xlinkHref",
        xlinkrole: "xlinkRole",
        "xlink:role": "xlinkRole",
        xlinkshow: "xlinkShow",
        "xlink:show": "xlinkShow",
        xlinktitle: "xlinkTitle",
        "xlink:title": "xlinkTitle",
        xlinktype: "xlinkType",
        "xlink:type": "xlinkType",
        xmlbase: "xmlBase",
        "xml:base": "xmlBase",
        xmllang: "xmlLang",
        "xml:lang": "xmlLang",
        xmlns: "xmlns",
        "xml:space": "xmlSpace",
        xmlnsxlink: "xmlnsXlink",
        "xmlns:xlink": "xmlnsXlink",
        xmlspace: "xmlSpace",
        y1: "y1",
        y2: "y2",
        y: "y",
        ychannelselector: "yChannelSelector",
        z: "z",
        zoomandpan: "zoomAndPan"
      },
      Td = {
        "aria-current": 0,
        // state
        "aria-description": 0,
        "aria-details": 0,
        "aria-disabled": 0,
        // state
        "aria-hidden": 0,
        // state
        "aria-invalid": 0,
        // state
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        // Widget Attributes
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        // Live Region Attributes
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        // Drag-and-Drop Attributes
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        // Relationship Attributes
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0
      },
      Rl = {},
      kw = new RegExp("^(aria)-[" + We + "]*$"),
      Dl = new RegExp("^(aria)[A-Z][" + We + "]*$");
    function gh(s, u) {
      {
        if (ye.call(Rl, u) && Rl[u]) return !0;
        if (Dl.test(u)) {
          var v = "aria-" + u.slice(4).toLowerCase(),
            _ = Td.hasOwnProperty(v) ? v : null;
          if (_ == null) return h("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", u), Rl[u] = !0, !0;
          if (u !== _) return h("Invalid ARIA attribute `%s`. Did you mean `%s`?", u, _), Rl[u] = !0, !0;
        }
        if (kw.test(u)) {
          var n = u.toLowerCase(),
            a = Td.hasOwnProperty(n) ? n : null;
          if (a == null) return Rl[u] = !0, !1;
          if (u !== a) return h("Unknown ARIA attribute `%s`. Did you mean `%s`?", u, a), Rl[u] = !0, !0;
        }
      }
      return !0;
    }
    function Uu(s, u) {
      {
        var v = [];
        for (var _ in u) {
          var n = gh(s, _);
          n || v.push(_);
        }
        var a = v.map(function (f) {
          return "`" + f + "`";
        }).join(", ");
        v.length === 1 ? h("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", a, s) : v.length > 1 && h("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", a, s);
      }
    }
    function yh(s, u) {
      Fo(s, u) || Uu(s, u);
    }
    var bh = !1;
    function Rd(s, u) {
      {
        if (s !== "input" && s !== "textarea" && s !== "select") return;
        u != null && u.value === null && !bh && (bh = !0, s === "select" && u.multiple ? h("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", s) : h("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", s));
      }
    }
    var Ls = function () {};
    {
      var _r = {},
        wh = /^on./,
        Dd = /^on[^A-Z]/,
        Cg = new RegExp("^(aria)-[" + We + "]*$"),
        kg = new RegExp("^(aria)[A-Z][" + We + "]*$");
      Ls = function (s, u, v, _) {
        if (ye.call(_r, u) && _r[u]) return !0;
        var n = u.toLowerCase();
        if (n === "onfocusin" || n === "onfocusout") return h("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), _r[u] = !0, !0;
        if (_ != null) {
          var a = _.registrationNameDependencies,
            f = _.possibleRegistrationNames;
          if (a.hasOwnProperty(u)) return !0;
          var m = f.hasOwnProperty(n) ? f[n] : null;
          if (m != null) return h("Invalid event handler property `%s`. Did you mean `%s`?", u, m), _r[u] = !0, !0;
          if (wh.test(u)) return h("Unknown event handler property `%s`. It will be ignored.", u), _r[u] = !0, !0;
        } else if (wh.test(u)) return Dd.test(u) && h("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", u), _r[u] = !0, !0;
        if (Cg.test(u) || kg.test(u)) return !0;
        if (n === "innerhtml") return h("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), _r[u] = !0, !0;
        if (n === "aria") return h("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), _r[u] = !0, !0;
        if (n === "is" && v !== null && v !== void 0 && typeof v != "string") return h("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof v), _r[u] = !0, !0;
        if (typeof v == "number" && isNaN(v)) return h("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", u), _r[u] = !0, !0;
        var b = Ht(u),
          T = b !== null && b.type === Kt;
        if (Bu.hasOwnProperty(n)) {
          var M = Bu[n];
          if (M !== u) return h("Invalid DOM property `%s`. Did you mean `%s`?", u, M), _r[u] = !0, !0;
        } else if (!T && u !== n) return h("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", u, n), _r[u] = !0, !0;
        return typeof v == "boolean" && kt(u, v, b, !1) ? (v ? h('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', v, u, u, v, u) : h('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', v, u, u, v, u, u, u), _r[u] = !0, !0) : T ? !0 : kt(u, v, b, !1) ? (_r[u] = !0, !1) : ((v === "false" || v === "true") && b !== null && b.type === Et && (h("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", v, u, v === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', u, v), _r[u] = !0), !0);
      };
    }
    var Tg = function (s, u, v) {
      {
        var _ = [];
        for (var n in u) {
          var a = Ls(s, n, u[n], v);
          a || _.push(n);
        }
        var f = _.map(function (m) {
          return "`" + m + "`";
        }).join(", ");
        _.length === 1 ? h("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", f, s) : _.length > 1 && h("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", f, s);
      }
    };
    function Rg(s, u, v) {
      Fo(s, u) || Tg(s, u, v);
    }
    var _h = 1,
      Id = 2,
      wi = 4,
      xh = _h | Id | wi,
      Ps = null;
    function Tw(s) {
      Ps !== null && h("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), Ps = s;
    }
    function Rw() {
      Ps === null && h("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), Ps = null;
    }
    function Hu(s) {
      return s === Ps;
    }
    function Sh(s) {
      var u = s.target || s.srcElement || window;
      return u.correspondingUseElement && (u = u.correspondingUseElement), u.nodeType === Xa ? u.parentNode : u;
    }
    var Md = null,
      As = null,
      mn = null;
    function Od(s) {
      var u = Nc(s);
      if (u) {
        if (typeof Md != "function") throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var v = u.stateNode;
        if (v) {
          var _ = Ef(v);
          Md(u.stateNode, u.type, _);
        }
      }
    }
    function Ld(s) {
      Md = s;
    }
    function Il(s) {
      As ? mn ? mn.push(s) : mn = [s] : As = s;
    }
    function Dg() {
      return As !== null || mn !== null;
    }
    function Pd() {
      if (As) {
        var s = As,
          u = mn;
        if (As = null, mn = null, Od(s), u) for (var v = 0; v < u.length; v++) Od(u[v]);
      }
    }
    var Ml = function (s, u) {
        return s(u);
      },
      $u = function () {},
      No = !1;
    function Ig() {
      var s = Dg();
      s && ($u(), Pd());
    }
    function Mg(s, u, v) {
      if (No) return s(u, v);
      No = !0;
      try {
        return Ml(s, u, v);
      } finally {
        No = !1, Ig();
      }
    }
    function Dw(s, u, v) {
      Ml = s, $u = v;
    }
    function Og(s) {
      return s === "button" || s === "input" || s === "select" || s === "textarea";
    }
    function Ad(s, u, v) {
      switch (s) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(v.disabled && Og(u));
        default:
          return !1;
      }
    }
    function zo(s, u) {
      var v = s.stateNode;
      if (v === null) return null;
      var _ = Ef(v);
      if (_ === null) return null;
      var n = _[u];
      if (Ad(u, s.type, _)) return null;
      if (n && typeof n != "function") throw new Error("Expected `" + u + "` listener to be a function, instead got a value of `" + typeof n + "` type.");
      return n;
    }
    var Wu = !1;
    if (Xe) try {
      var js = {};
      Object.defineProperty(js, "passive", {
        get: function () {
          Wu = !0;
        }
      }), window.addEventListener("test", js, js), window.removeEventListener("test", js, js);
    } catch {
      Wu = !1;
    }
    function jd(s, u, v, _, n, a, f, m, b) {
      var T = Array.prototype.slice.call(arguments, 3);
      try {
        u.apply(v, T);
      } catch (M) {
        this.onError(M);
      }
    }
    var Fd = jd;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var Eh = document.createElement("react");
      Fd = function (s, u, v, _, n, a, f, m, b) {
        if (typeof document > "u" || document === null) throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var T = document.createEvent("Event"),
          M = !1,
          z = !0,
          U = window.event,
          X = Object.getOwnPropertyDescriptor(window, "event");
        function J() {
          Eh.removeEventListener(Re, Se, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = U);
        }
        var me = Array.prototype.slice.call(arguments, 3);
        function Se() {
          M = !0, J(), u.apply(v, me), z = !1;
        }
        var Me,
          Pe = !1,
          $e = !1;
        function mt(Ue) {
          if (Me = Ue.error, Pe = !0, Me === null && Ue.colno === 0 && Ue.lineno === 0 && ($e = !0), Ue.defaultPrevented && Me != null && typeof Me == "object") try {
            Me._suppressLogging = !0;
          } catch {}
        }
        var Re = "react-" + (s || "invokeguardedcallback");
        if (window.addEventListener("error", mt), Eh.addEventListener(Re, Se, !1), T.initEvent(Re, !1, !1), Eh.dispatchEvent(T), X && Object.defineProperty(window, "event", X), M && z && (Pe ? $e && (Me = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : Me = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(Me)), window.removeEventListener("error", mt), !M) return J(), jd.apply(this, arguments);
      };
    }
    var Lg = Fd,
      Ol = !1,
      Nd = null,
      Ll = !1,
      ha = null,
      Pg = {
        onError: function (s) {
          Ol = !0, Nd = s;
        }
      };
    function Vo(s, u, v, _, n, a, f, m, b) {
      Ol = !1, Nd = null, Lg.apply(Pg, arguments);
    }
    function ma(s, u, v, _, n, a, f, m, b) {
      if (Vo.apply(this, arguments), Ol) {
        var T = Yu();
        Ll || (Ll = !0, ha = T);
      }
    }
    function qu() {
      if (Ll) {
        var s = ha;
        throw Ll = !1, ha = null, s;
      }
    }
    function Qa() {
      return Ol;
    }
    function Yu() {
      if (Ol) {
        var s = Nd;
        return Ol = !1, Nd = null, s;
      } else throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function Pl(s) {
      return s._reactInternals;
    }
    function Iw(s) {
      return s._reactInternals !== void 0;
    }
    function Fs(s, u) {
      s._reactInternals = u;
    }
    var pt = /*                      */
      0,
      Xi = /*                */
      1,
      Gn = /*                    */
      2,
      tn = /*                       */
      4,
      _i = /*                */
      16,
      Ki = /*                 */
      32,
      Sn = /*                     */
      64,
      ft = /*                   */
      128,
      qr = /*            */
      256,
      Hn = /*                          */
      512,
      or = /*                     */
      1024,
      Yr = /*                      */
      2048,
      xi = /*                    */
      4096,
      tr = /*                   */
      8192,
      Al = /*             */
      16384,
      Ag = /*               */
      32767,
      Gu = /*                   */
      32768,
      Gr = /*                */
      65536,
      zd = /* */
      131072,
      va = /*                       */
      1048576,
      jl = /*                    */
      2097152,
      Za = /*                 */
      4194304,
      Vd = /*                */
      8388608,
      Bo = /*               */
      16777216,
      ga = /*              */
      33554432,
      Uo =
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      tn | or | 0,
      Ho = Gn | tn | _i | Ki | Hn | xi | tr,
      $o = tn | Sn | Hn | tr,
      Ja = Yr | _i,
      nr = Za | Vd | jl,
      Si = i.ReactCurrentOwner;
    function si(s) {
      var u = s,
        v = s;
      if (s.alternate) for (; u.return;) u = u.return;else {
        var _ = u;
        do u = _, (u.flags & (Gn | xi)) !== pt && (v = u.return), _ = u.return; while (_);
      }
      return u.tag === C ? v : null;
    }
    function ya(s) {
      if (s.tag === V) {
        var u = s.memoizedState;
        if (u === null) {
          var v = s.alternate;
          v !== null && (u = v.memoizedState);
        }
        if (u !== null) return u.dehydrated;
      }
      return null;
    }
    function ba(s) {
      return s.tag === C ? s.stateNode.containerInfo : null;
    }
    function Ns(s) {
      return si(s) === s;
    }
    function jg(s) {
      {
        var u = Si.current;
        if (u !== null && u.tag === x) {
          var v = u,
            _ = v.stateNode;
          _._warnedAboutRefsInRender || h("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", At(v) || "A component"), _._warnedAboutRefsInRender = !0;
        }
      }
      var n = Pl(s);
      return n ? si(n) === n : !1;
    }
    function Bd(s) {
      if (si(s) !== s) throw new Error("Unable to find node on an unmounted component.");
    }
    function Ud(s) {
      var u = s.alternate;
      if (!u) {
        var v = si(s);
        if (v === null) throw new Error("Unable to find node on an unmounted component.");
        return v !== s ? null : s;
      }
      for (var _ = s, n = u;;) {
        var a = _.return;
        if (a === null) break;
        var f = a.alternate;
        if (f === null) {
          var m = a.return;
          if (m !== null) {
            _ = n = m;
            continue;
          }
          break;
        }
        if (a.child === f.child) {
          for (var b = a.child; b;) {
            if (b === _) return Bd(a), s;
            if (b === n) return Bd(a), u;
            b = b.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (_.return !== n.return) _ = a, n = f;else {
          for (var T = !1, M = a.child; M;) {
            if (M === _) {
              T = !0, _ = a, n = f;
              break;
            }
            if (M === n) {
              T = !0, n = a, _ = f;
              break;
            }
            M = M.sibling;
          }
          if (!T) {
            for (M = f.child; M;) {
              if (M === _) {
                T = !0, _ = f, n = a;
                break;
              }
              if (M === n) {
                T = !0, n = f, _ = a;
                break;
              }
              M = M.sibling;
            }
            if (!T) throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (_.alternate !== n) throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (_.tag !== C) throw new Error("Unable to find node on an unmounted component.");
      return _.stateNode.current === _ ? s : u;
    }
    function Xr(s) {
      var u = Ud(s);
      return u !== null ? Kr(u) : null;
    }
    function Kr(s) {
      if (s.tag === D || s.tag === I) return s;
      for (var u = s.child; u !== null;) {
        var v = Kr(u);
        if (v !== null) return v;
        u = u.sibling;
      }
      return null;
    }
    function In(s) {
      var u = Ud(s);
      return u !== null ? Ei(u) : null;
    }
    function Ei(s) {
      if (s.tag === D || s.tag === I) return s;
      for (var u = s.child; u !== null;) {
        if (u.tag !== k) {
          var v = Ei(u);
          if (v !== null) return v;
        }
        u = u.sibling;
      }
      return null;
    }
    var Ch = e.unstable_scheduleCallback,
      Fg = e.unstable_cancelCallback,
      kh = e.unstable_shouldYield,
      Th = e.unstable_requestPaint,
      sr = e.unstable_now,
      Hd = e.unstable_getCurrentPriorityLevel,
      Xu = e.unstable_ImmediatePriority,
      Wo = e.unstable_UserBlockingPriority,
      eo = e.unstable_NormalPriority,
      Mw = e.unstable_LowPriority,
      li = e.unstable_IdlePriority,
      $d = e.unstable_yieldValue,
      Wd = e.unstable_setDisableYieldValue,
      Qi = null,
      dr = null,
      Ge = null,
      Ci = !1,
      ui = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function Fl(s) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u") return !1;
      var u = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (u.isDisabled) return !0;
      if (!u.supportsFiber) return h("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        Ce && (s = Qt({}, s, {
          getLaneLabelMap: Dh,
          injectProfilingHooks: qo
        })), Qi = u.inject(s), dr = u;
      } catch (v) {
        h("React instrumentation encountered an error: %s.", v);
      }
      return !!u.checkDCE;
    }
    function ki(s, u) {
      if (dr && typeof dr.onScheduleFiberRoot == "function") try {
        dr.onScheduleFiberRoot(Qi, s, u);
      } catch (v) {
        Ci || (Ci = !0, h("React instrumentation encountered an error: %s", v));
      }
    }
    function zs(s, u) {
      if (dr && typeof dr.onCommitFiberRoot == "function") try {
        var v = (s.current.flags & ft) === ft;
        if (Ee) {
          var _;
          switch (u) {
            case as:
              _ = Xu;
              break;
            case Ii:
              _ = Wo;
              break;
            case Zi:
              _ = eo;
              break;
            case os:
              _ = li;
              break;
            default:
              _ = eo;
              break;
          }
          dr.onCommitFiberRoot(Qi, s, _, v);
        }
      } catch (n) {
        Ci || (Ci = !0, h("React instrumentation encountered an error: %s", n));
      }
    }
    function Rh(s) {
      if (dr && typeof dr.onPostCommitFiberRoot == "function") try {
        dr.onPostCommitFiberRoot(Qi, s);
      } catch (u) {
        Ci || (Ci = !0, h("React instrumentation encountered an error: %s", u));
      }
    }
    function Ng(s) {
      if (dr && typeof dr.onCommitFiberUnmount == "function") try {
        dr.onCommitFiberUnmount(Qi, s);
      } catch (u) {
        Ci || (Ci = !0, h("React instrumentation encountered an error: %s", u));
      }
    }
    function En(s) {
      if (typeof $d == "function" && (Wd(s), c(s)), dr && typeof dr.setStrictMode == "function") try {
        dr.setStrictMode(Qi, s);
      } catch (u) {
        Ci || (Ci = !0, h("React instrumentation encountered an error: %s", u));
      }
    }
    function qo(s) {
      Ge = s;
    }
    function Dh() {
      {
        for (var s = /* @__PURE__ */new Map(), u = 1, v = 0; v < zl; v++) {
          var _ = Yg(u);
          s.set(u, _), u *= 2;
        }
        return s;
      }
    }
    function zg(s) {
      Ge !== null && typeof Ge.markCommitStarted == "function" && Ge.markCommitStarted(s);
    }
    function wa() {
      Ge !== null && typeof Ge.markCommitStopped == "function" && Ge.markCommitStopped();
    }
    function Ti(s) {
      Ge !== null && typeof Ge.markComponentRenderStarted == "function" && Ge.markComponentRenderStarted(s);
    }
    function to() {
      Ge !== null && typeof Ge.markComponentRenderStopped == "function" && Ge.markComponentRenderStopped();
    }
    function Vg(s) {
      Ge !== null && typeof Ge.markComponentPassiveEffectMountStarted == "function" && Ge.markComponentPassiveEffectMountStarted(s);
    }
    function qd() {
      Ge !== null && typeof Ge.markComponentPassiveEffectMountStopped == "function" && Ge.markComponentPassiveEffectMountStopped();
    }
    function Bg(s) {
      Ge !== null && typeof Ge.markComponentPassiveEffectUnmountStarted == "function" && Ge.markComponentPassiveEffectUnmountStarted(s);
    }
    function Ug() {
      Ge !== null && typeof Ge.markComponentPassiveEffectUnmountStopped == "function" && Ge.markComponentPassiveEffectUnmountStopped();
    }
    function Ih(s) {
      Ge !== null && typeof Ge.markComponentLayoutEffectMountStarted == "function" && Ge.markComponentLayoutEffectMountStarted(s);
    }
    function Yd() {
      Ge !== null && typeof Ge.markComponentLayoutEffectMountStopped == "function" && Ge.markComponentLayoutEffectMountStopped();
    }
    function Mh(s) {
      Ge !== null && typeof Ge.markComponentLayoutEffectUnmountStarted == "function" && Ge.markComponentLayoutEffectUnmountStarted(s);
    }
    function Oh() {
      Ge !== null && typeof Ge.markComponentLayoutEffectUnmountStopped == "function" && Ge.markComponentLayoutEffectUnmountStopped();
    }
    function Hg(s, u, v) {
      Ge !== null && typeof Ge.markComponentErrored == "function" && Ge.markComponentErrored(s, u, v);
    }
    function Lh(s, u, v) {
      Ge !== null && typeof Ge.markComponentSuspended == "function" && Ge.markComponentSuspended(s, u, v);
    }
    function Ku(s) {
      Ge !== null && typeof Ge.markLayoutEffectsStarted == "function" && Ge.markLayoutEffectsStarted(s);
    }
    function Gd() {
      Ge !== null && typeof Ge.markLayoutEffectsStopped == "function" && Ge.markLayoutEffectsStopped();
    }
    function $g(s) {
      Ge !== null && typeof Ge.markPassiveEffectsStarted == "function" && Ge.markPassiveEffectsStarted(s);
    }
    function Wg() {
      Ge !== null && typeof Ge.markPassiveEffectsStopped == "function" && Ge.markPassiveEffectsStopped();
    }
    function Vs(s) {
      Ge !== null && typeof Ge.markRenderStarted == "function" && Ge.markRenderStarted(s);
    }
    function qg() {
      Ge !== null && typeof Ge.markRenderYielded == "function" && Ge.markRenderYielded();
    }
    function Nl() {
      Ge !== null && typeof Ge.markRenderStopped == "function" && Ge.markRenderStopped();
    }
    function _a(s) {
      Ge !== null && typeof Ge.markRenderScheduled == "function" && Ge.markRenderScheduled(s);
    }
    function Qu(s, u) {
      Ge !== null && typeof Ge.markForceUpdateScheduled == "function" && Ge.markForceUpdateScheduled(s, u);
    }
    function Bs(s, u) {
      Ge !== null && typeof Ge.markStateUpdateScheduled == "function" && Ge.markStateUpdateScheduled(s, u);
    }
    var dt = /*                         */
      0,
      Wt = /*                 */
      1,
      nn = /*                    */
      2,
      Xn = /*               */
      8,
      Ri = /*              */
      16,
      Mn = Math.clz32 ? Math.clz32 : Ah,
      Xd = Math.log,
      Ph = Math.LN2;
    function Ah(s) {
      var u = s >>> 0;
      return u === 0 ? 32 : 31 - (Xd(u) / Ph | 0) | 0;
    }
    var zl = 31,
      De = /*                        */
      0,
      On = /*                          */
      0,
      Je = /*                        */
      1,
      Ln = /*    */
      2,
      Cn = /*             */
      4,
      xa = /*            */
      8,
      Qr = /*                     */
      16,
      no = /*                */
      32,
      Vl = /*                       */
      4194240,
      rr = /*                        */
      64,
      Zu = /*                        */
      128,
      Ju = /*                        */
      256,
      ec = /*                        */
      512,
      Di = /*                        */
      1024,
      Zr = /*                        */
      2048,
      Us = /*                        */
      4096,
      tc = /*                        */
      8192,
      nc = /*                        */
      16384,
      Kd = /*                       */
      32768,
      Qd = /*                       */
      65536,
      Zd = /*                       */
      131072,
      Jd = /*                       */
      262144,
      ef = /*                       */
      524288,
      tf = /*                       */
      1048576,
      nf = /*                       */
      2097152,
      rc = /*                            */
      130023424,
      Sa = /*                             */
      4194304,
      rf = /*                             */
      8388608,
      Bl = /*                             */
      16777216,
      Ul = /*                             */
      33554432,
      af = /*                             */
      67108864,
      of = Sa,
      Hl = /*          */
      134217728,
      jh = /*                          */
      268435455,
      $l = /*               */
      268435456,
      Yo = /*                        */
      536870912,
      Jr = /*                   */
      1073741824;
    function Yg(s) {
      {
        if (s & Je) return "Sync";
        if (s & Ln) return "InputContinuousHydration";
        if (s & Cn) return "InputContinuous";
        if (s & xa) return "DefaultHydration";
        if (s & Qr) return "Default";
        if (s & no) return "TransitionHydration";
        if (s & Vl) return "Transition";
        if (s & rc) return "Retry";
        if (s & Hl) return "SelectiveHydration";
        if (s & $l) return "IdleHydration";
        if (s & Yo) return "Idle";
        if (s & Jr) return "Offscreen";
      }
    }
    var wn = -1,
      ic = rr,
      sf = Sa;
    function Wl(s) {
      switch (Go(s)) {
        case Je:
          return Je;
        case Ln:
          return Ln;
        case Cn:
          return Cn;
        case xa:
          return xa;
        case Qr:
          return Qr;
        case no:
          return no;
        case rr:
        case Zu:
        case Ju:
        case ec:
        case Di:
        case Zr:
        case Us:
        case tc:
        case nc:
        case Kd:
        case Qd:
        case Zd:
        case Jd:
        case ef:
        case tf:
        case nf:
          return s & Vl;
        case Sa:
        case rf:
        case Bl:
        case Ul:
        case af:
          return s & rc;
        case Hl:
          return Hl;
        case $l:
          return $l;
        case Yo:
          return Yo;
        case Jr:
          return Jr;
        default:
          return h("Should have found matching lanes. This is a bug in React."), s;
      }
    }
    function lf(s, u) {
      var v = s.pendingLanes;
      if (v === De) return De;
      var _ = De,
        n = s.suspendedLanes,
        a = s.pingedLanes,
        f = v & jh;
      if (f !== De) {
        var m = f & ~n;
        if (m !== De) _ = Wl(m);else {
          var b = f & a;
          b !== De && (_ = Wl(b));
        }
      } else {
        var T = v & ~n;
        T !== De ? _ = Wl(T) : a !== De && (_ = Wl(a));
      }
      if (_ === De) return De;
      if (u !== De && u !== _ &&
      // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (u & n) === De) {
        var M = Go(_),
          z = Go(u);
        if (
        // Tests whether the next lane is equal or lower priority than the wip
        // one. This works because the bits decrease in priority as you go left.
        M >= z ||
        // Default priority updates should not interrupt transition updates. The
        // only difference between default updates and transition updates is that
        // default updates do not support refresh transitions.
        M === Qr && (z & Vl) !== De) return u;
      }
      (_ & Cn) !== De && (_ |= v & Qr);
      var U = s.entangledLanes;
      if (U !== De) for (var X = s.entanglements, J = _ & U; J > 0;) {
        var me = Hs(J),
          Se = 1 << me;
        _ |= X[me], J &= ~Se;
      }
      return _;
    }
    function Ow(s, u) {
      for (var v = s.eventTimes, _ = wn; u > 0;) {
        var n = Hs(u),
          a = 1 << n,
          f = v[n];
        f > _ && (_ = f), u &= ~a;
      }
      return _;
    }
    function Gg(s, u) {
      switch (s) {
        case Je:
        case Ln:
        case Cn:
          return u + 250;
        case xa:
        case Qr:
        case no:
        case rr:
        case Zu:
        case Ju:
        case ec:
        case Di:
        case Zr:
        case Us:
        case tc:
        case nc:
        case Kd:
        case Qd:
        case Zd:
        case Jd:
        case ef:
        case tf:
        case nf:
          return u + 5e3;
        case Sa:
        case rf:
        case Bl:
        case Ul:
        case af:
          return wn;
        case Hl:
        case $l:
        case Yo:
        case Jr:
          return wn;
        default:
          return h("Should have found matching lanes. This is a bug in React."), wn;
      }
    }
    function Xg(s, u) {
      for (var v = s.pendingLanes, _ = s.suspendedLanes, n = s.pingedLanes, a = s.expirationTimes, f = v; f > 0;) {
        var m = Hs(f),
          b = 1 << m,
          T = a[m];
        T === wn ? ((b & _) === De || (b & n) !== De) && (a[m] = Gg(b, u)) : T <= u && (s.expiredLanes |= b), f &= ~b;
      }
    }
    function Kg(s) {
      return Wl(s.pendingLanes);
    }
    function ql(s) {
      var u = s.pendingLanes & -1073741825;
      return u !== De ? u : u & Jr ? Jr : De;
    }
    function Lw(s) {
      return (s & Je) !== De;
    }
    function Fh(s) {
      return (s & jh) !== De;
    }
    function Qg(s) {
      return (s & rc) === s;
    }
    function Yl(s) {
      var u = Je | Cn | Qr;
      return (s & u) === De;
    }
    function Nh(s) {
      return (s & Vl) === s;
    }
    function Gl(s, u) {
      var v = Ln | Cn | xa | Qr;
      return (u & v) !== De;
    }
    function Pw(s, u) {
      return (u & s.expiredLanes) !== De;
    }
    function zh(s) {
      return (s & Vl) !== De;
    }
    function Vh() {
      var s = ic;
      return ic <<= 1, (ic & Vl) === De && (ic = rr), s;
    }
    function Zg() {
      var s = sf;
      return sf <<= 1, (sf & rc) === De && (sf = Sa), s;
    }
    function Go(s) {
      return s & -s;
    }
    function Xl(s) {
      return Go(s);
    }
    function Hs(s) {
      return 31 - Mn(s);
    }
    function Dr(s) {
      return Hs(s);
    }
    function _n(s, u) {
      return (s & u) !== De;
    }
    function $s(s, u) {
      return (s & u) === u;
    }
    function jt(s, u) {
      return s | u;
    }
    function ac(s, u) {
      return s & ~u;
    }
    function Bh(s, u) {
      return s & u;
    }
    function Sb(s, u) {
      return s !== On && s < u ? s : u;
    }
    function uf(s) {
      for (var u = [], v = 0; v < zl; v++) u.push(s);
      return u;
    }
    function oc(s, u, v) {
      s.pendingLanes |= u, u !== Yo && (s.suspendedLanes = De, s.pingedLanes = De);
      var _ = s.eventTimes,
        n = Dr(u);
      _[n] = v;
    }
    function sc(s, u) {
      s.suspendedLanes |= u, s.pingedLanes &= ~u;
      for (var v = s.expirationTimes, _ = u; _ > 0;) {
        var n = Hs(_),
          a = 1 << n;
        v[n] = wn, _ &= ~a;
      }
    }
    function Km(s, u, v) {
      s.pingedLanes |= s.suspendedLanes & u;
    }
    function Qm(s, u) {
      var v = s.pendingLanes & ~u;
      s.pendingLanes = u, s.suspendedLanes = De, s.pingedLanes = De, s.expiredLanes &= u, s.mutableReadLanes &= u, s.entangledLanes &= u;
      for (var _ = s.entanglements, n = s.eventTimes, a = s.expirationTimes, f = v; f > 0;) {
        var m = Hs(f),
          b = 1 << m;
        _[m] = De, n[m] = wn, a[m] = wn, f &= ~b;
      }
    }
    function cf(s, u) {
      for (var v = s.entangledLanes |= u, _ = s.entanglements, n = v; n;) {
        var a = Hs(n),
          f = 1 << a;
        f & u |
        // Is this lane transitively entangled with the newly entangled lanes?
        _[a] & u && (_[a] |= u), n &= ~f;
      }
    }
    function df(s, u) {
      var v = Go(u),
        _;
      switch (v) {
        case Cn:
          _ = Ln;
          break;
        case Qr:
          _ = xa;
          break;
        case rr:
        case Zu:
        case Ju:
        case ec:
        case Di:
        case Zr:
        case Us:
        case tc:
        case nc:
        case Kd:
        case Qd:
        case Zd:
        case Jd:
        case ef:
        case tf:
        case nf:
        case Sa:
        case rf:
        case Bl:
        case Ul:
        case af:
          _ = no;
          break;
        case Yo:
          _ = $l;
          break;
        default:
          _ = On;
          break;
      }
      return (_ & (s.suspendedLanes | u)) !== On ? On : _;
    }
    function Zm(s, u, v) {
      if (ui) for (var _ = s.pendingUpdatersLaneMap; v > 0;) {
        var n = Dr(v),
          a = 1 << n,
          f = _[n];
        f.add(u), v &= ~a;
      }
    }
    function ff(s, u) {
      if (ui) for (var v = s.pendingUpdatersLaneMap, _ = s.memoizedUpdaters; u > 0;) {
        var n = Dr(u),
          a = 1 << n,
          f = v[n];
        f.size > 0 && (f.forEach(function (m) {
          var b = m.alternate;
          (b === null || !_.has(b)) && _.add(m);
        }), f.clear()), u &= ~a;
      }
    }
    function lc(s, u) {
      return null;
    }
    var as = Je,
      Ii = Cn,
      Zi = Qr,
      os = Yo,
      ss = On;
    function Ir() {
      return ss;
    }
    function zr(s) {
      ss = s;
    }
    function la(s, u) {
      var v = ss;
      try {
        return ss = s, u();
      } finally {
        ss = v;
      }
    }
    function Uh(s, u) {
      return s !== 0 && s < u ? s : u;
    }
    function Jg(s, u) {
      return s > u ? s : u;
    }
    function Hh(s, u) {
      return s !== 0 && s < u;
    }
    function ul(s) {
      var u = Go(s);
      return Hh(as, u) ? Hh(Ii, u) ? Fh(u) ? Zi : os : Ii : as;
    }
    function fr(s) {
      var u = s.current.memoizedState;
      return u.isDehydrated;
    }
    var $h;
    function Eb(s) {
      $h = s;
    }
    function pf(s) {
      $h(s);
    }
    var xr;
    function ey(s) {
      xr = s;
    }
    var tt;
    function cl(s) {
      tt = s;
    }
    var Wh;
    function Jm(s) {
      Wh = s;
    }
    var Cb;
    function du(s) {
      Cb = s;
    }
    var uc = !1,
      fu = [],
      Ws = null,
      ro = null,
      io = null,
      wo = /* @__PURE__ */new Map(),
      qs = /* @__PURE__ */new Map(),
      Nn = [],
      Vr = ["mousedown", "mouseup", "touchcancel", "touchend", "touchstart", "auxclick", "dblclick", "pointercancel", "pointerdown", "pointerup", "dragend", "dragstart", "drop", "compositionend", "compositionstart", "keydown", "keypress", "keyup", "input", "textInput",
      // Intentionally camelCase
      "copy", "cut", "paste", "click", "change", "contextmenu", "reset", "submit"];
    function Xo(s) {
      return Vr.indexOf(s) > -1;
    }
    function ty(s, u, v, _, n) {
      return {
        blockedOn: s,
        domEventName: u,
        eventSystemFlags: v,
        nativeEvent: n,
        targetContainers: [_]
      };
    }
    function ev(s, u) {
      switch (s) {
        case "focusin":
        case "focusout":
          Ws = null;
          break;
        case "dragenter":
        case "dragleave":
          ro = null;
          break;
        case "mouseover":
        case "mouseout":
          io = null;
          break;
        case "pointerover":
        case "pointerout":
          {
            var v = u.pointerId;
            wo.delete(v);
            break;
          }
        case "gotpointercapture":
        case "lostpointercapture":
          {
            var _ = u.pointerId;
            qs.delete(_);
            break;
          }
      }
    }
    function ri(s, u, v, _, n, a) {
      if (s === null || s.nativeEvent !== a) {
        var f = ty(u, v, _, n, a);
        if (u !== null) {
          var m = Nc(u);
          m !== null && xr(m);
        }
        return f;
      }
      s.eventSystemFlags |= _;
      var b = s.targetContainers;
      return n !== null && b.indexOf(n) === -1 && b.push(n), s;
    }
    function hf(s, u, v, _, n) {
      switch (u) {
        case "focusin":
          {
            var a = n;
            return Ws = ri(Ws, s, u, v, _, a), !0;
          }
        case "dragenter":
          {
            var f = n;
            return ro = ri(ro, s, u, v, _, f), !0;
          }
        case "mouseover":
          {
            var m = n;
            return io = ri(io, s, u, v, _, m), !0;
          }
        case "pointerover":
          {
            var b = n,
              T = b.pointerId;
            return wo.set(T, ri(wo.get(T) || null, s, u, v, _, b)), !0;
          }
        case "gotpointercapture":
          {
            var M = n,
              z = M.pointerId;
            return qs.set(z, ri(qs.get(z) || null, s, u, v, _, M)), !0;
          }
      }
      return !1;
    }
    function ua(s) {
      var u = hv(s.target);
      if (u !== null) {
        var v = si(u);
        if (v !== null) {
          var _ = v.tag;
          if (_ === V) {
            var n = ya(v);
            if (n !== null) {
              s.blockedOn = n, Cb(s.priority, function () {
                tt(v);
              });
              return;
            }
          } else if (_ === C) {
            var a = v.stateNode;
            if (fr(a)) {
              s.blockedOn = ba(v);
              return;
            }
          }
        }
      }
      s.blockedOn = null;
    }
    function kb(s) {
      for (var u = Wh(), v = {
          blockedOn: null,
          target: s,
          priority: u
        }, _ = 0; _ < Nn.length && Hh(u, Nn[_].priority); _++);
      Nn.splice(_, 0, v), _ === 0 && ua(v);
    }
    function cp(s) {
      if (s.blockedOn !== null) return !1;
      for (var u = s.targetContainers; u.length > 0;) {
        var v = u[0],
          _ = ls(s.domEventName, s.eventSystemFlags, v, s.nativeEvent);
        if (_ === null) {
          var n = s.nativeEvent,
            a = new n.constructor(n.type, n);
          Tw(a), n.target.dispatchEvent(a), Rw();
        } else {
          var f = Nc(_);
          return f !== null && xr(f), s.blockedOn = _, !1;
        }
        u.shift();
      }
      return !0;
    }
    function mf(s, u, v) {
      cp(s) && v.delete(u);
    }
    function tv() {
      uc = !1, Ws !== null && cp(Ws) && (Ws = null), ro !== null && cp(ro) && (ro = null), io !== null && cp(io) && (io = null), wo.forEach(mf), qs.forEach(mf);
    }
    function vf(s, u) {
      s.blockedOn === u && (s.blockedOn = null, uc || (uc = !0, e.unstable_scheduleCallback(e.unstable_NormalPriority, tv)));
    }
    function cc(s) {
      if (fu.length > 0) {
        vf(fu[0], s);
        for (var u = 1; u < fu.length; u++) {
          var v = fu[u];
          v.blockedOn === s && (v.blockedOn = null);
        }
      }
      Ws !== null && vf(Ws, s), ro !== null && vf(ro, s), io !== null && vf(io, s);
      var _ = function (m) {
        return vf(m, s);
      };
      wo.forEach(_), qs.forEach(_);
      for (var n = 0; n < Nn.length; n++) {
        var a = Nn[n];
        a.blockedOn === s && (a.blockedOn = null);
      }
      for (; Nn.length > 0;) {
        var f = Nn[0];
        if (f.blockedOn !== null) break;
        ua(f), f.blockedOn === null && Nn.shift();
      }
    }
    var _o = i.ReactCurrentBatchConfig,
      dl = !0;
    function ii(s) {
      dl = !!s;
    }
    function on() {
      return dl;
    }
    function pr(s, u, v) {
      var _ = xo(u),
        n;
      switch (_) {
        case as:
          n = ir;
          break;
        case Ii:
          n = Sr;
          break;
        case Zi:
        default:
          n = ei;
          break;
      }
      return n.bind(null, u, v, s);
    }
    function ir(s, u, v, _) {
      var n = Ir(),
        a = _o.transition;
      _o.transition = null;
      try {
        zr(as), ei(s, u, v, _);
      } finally {
        zr(n), _o.transition = a;
      }
    }
    function Sr(s, u, v, _) {
      var n = Ir(),
        a = _o.transition;
      _o.transition = null;
      try {
        zr(Ii), ei(s, u, v, _);
      } finally {
        zr(n), _o.transition = a;
      }
    }
    function ei(s, u, v, _) {
      dl && Ys(s, u, v, _);
    }
    function Ys(s, u, v, _) {
      var n = ls(s, u, v, _);
      if (n === null) {
        lS(s, u, _, Zn, v), ev(s, _);
        return;
      }
      if (hf(n, s, u, v, _)) {
        _.stopPropagation();
        return;
      }
      if (ev(s, _), u & wi && Xo(s)) {
        for (; n !== null;) {
          var a = Nc(n);
          a !== null && pf(a);
          var f = ls(s, u, v, _);
          if (f === null && lS(s, u, _, Zn, v), f === n) break;
          n = f;
        }
        n !== null && _.stopPropagation();
        return;
      }
      lS(s, u, _, null, v);
    }
    var Zn = null;
    function ls(s, u, v, _) {
      Zn = null;
      var n = Sh(_),
        a = hv(n);
      if (a !== null) {
        var f = si(a);
        if (f === null) a = null;else {
          var m = f.tag;
          if (m === V) {
            var b = ya(f);
            if (b !== null) return b;
            a = null;
          } else if (m === C) {
            var T = f.stateNode;
            if (fr(T)) return ba(f);
            a = null;
          } else f !== a && (a = null);
        }
      }
      return Zn = a, null;
    }
    function xo(s) {
      switch (s) {
        // Used by SimpleEventPlugin:
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        // Used by polyfills:
        // eslint-disable-next-line no-fallthrough
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        // Only enableCreateEventHandleAPI:
        // eslint-disable-next-line no-fallthrough
        case "beforeblur":
        case "afterblur":
        // Not used by React but could be by user code:
        // eslint-disable-next-line no-fallthrough
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return as;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        // Not used by React but could be by user code:
        // eslint-disable-next-line no-fallthrough
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return Ii;
        case "message":
          {
            var u = Hd();
            switch (u) {
              case Xu:
                return as;
              case Wo:
                return Ii;
              case eo:
              case Mw:
                return Zi;
              case li:
                return os;
              default:
                return Zi;
            }
          }
        default:
          return Zi;
      }
    }
    function Lc(s, u, v) {
      return s.addEventListener(u, v, !1), v;
    }
    function qh(s, u, v) {
      return s.addEventListener(u, v, !0), v;
    }
    function dc(s, u, v, _) {
      return s.addEventListener(u, v, {
        capture: !0,
        passive: _
      }), v;
    }
    function ti(s, u, v, _) {
      return s.addEventListener(u, v, {
        passive: _
      }), v;
    }
    var fc = null,
      ao = null,
      Mi = null;
    function Kl(s) {
      return fc = s, ao = pc(), !0;
    }
    function Yh() {
      fc = null, ao = null, Mi = null;
    }
    function So() {
      if (Mi) return Mi;
      var s,
        u = ao,
        v = u.length,
        _,
        n = pc(),
        a = n.length;
      for (s = 0; s < v && u[s] === n[s]; s++);
      var f = v - s;
      for (_ = 1; _ <= f && u[v - _] === n[a - _]; _++);
      var m = _ > 1 ? 1 - _ : void 0;
      return Mi = n.slice(s, m), Mi;
    }
    function pc() {
      return "value" in fc ? fc.value : fc.textContent;
    }
    function Ea(s) {
      var u,
        v = s.keyCode;
      return "charCode" in s ? (u = s.charCode, u === 0 && v === 13 && (u = 13)) : u = v, u === 10 && (u = 13), u >= 32 || u === 13 ? u : 0;
    }
    function Gs() {
      return !0;
    }
    function Xs() {
      return !1;
    }
    function Ma(s) {
      function u(v, _, n, a, f) {
        this._reactName = v, this._targetInst = n, this.type = _, this.nativeEvent = a, this.target = f, this.currentTarget = null;
        for (var m in s) if (s.hasOwnProperty(m)) {
          var b = s[m];
          b ? this[m] = b(a) : this[m] = a[m];
        }
        var T = a.defaultPrevented != null ? a.defaultPrevented : a.returnValue === !1;
        return T ? this.isDefaultPrevented = Gs : this.isDefaultPrevented = Xs, this.isPropagationStopped = Xs, this;
      }
      return Qt(u.prototype, {
        preventDefault: function () {
          this.defaultPrevented = !0;
          var v = this.nativeEvent;
          v && (v.preventDefault ? v.preventDefault() : typeof v.returnValue != "unknown" && (v.returnValue = !1), this.isDefaultPrevented = Gs);
        },
        stopPropagation: function () {
          var v = this.nativeEvent;
          v && (v.stopPropagation ? v.stopPropagation() : typeof v.cancelBubble != "unknown" && (v.cancelBubble = !0), this.isPropagationStopped = Gs);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function () {},
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: Gs
      }), u;
    }
    var di = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function (s) {
          return s.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
      },
      us = Ma(di),
      hr = Qt({}, di, {
        view: 0,
        detail: 0
      }),
      Ca = Ma(hr),
      Oi,
      Mr,
      hc;
    function mc(s) {
      s !== hc && (hc && s.type === "mousemove" ? (Oi = s.screenX - hc.screenX, Mr = s.screenY - hc.screenY) : (Oi = 0, Mr = 0), hc = s);
    }
    var Pc = Qt({}, hr, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: Zs,
        button: 0,
        buttons: 0,
        relatedTarget: function (s) {
          return s.relatedTarget === void 0 ? s.fromElement === s.srcElement ? s.toElement : s.fromElement : s.relatedTarget;
        },
        movementX: function (s) {
          return "movementX" in s ? s.movementX : (mc(s), Oi);
        },
        movementY: function (s) {
          return "movementY" in s ? s.movementY : Mr;
        }
      }),
      Gh = Ma(Pc),
      Eo = Qt({}, Pc, {
        dataTransfer: 0
      }),
      ny = Ma(Eo),
      Xh = Qt({}, hr, {
        relatedTarget: 0
      }),
      Ko = Ma(Xh),
      gf = Qt({}, di, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
      }),
      Ks = Ma(gf),
      ry = Qt({}, di, {
        clipboardData: function (s) {
          return "clipboardData" in s ? s.clipboardData : window.clipboardData;
        }
      }),
      iy = Ma(ry),
      Kh = Qt({}, di, {
        data: 0
      }),
      Ac = Ma(Kh),
      Tb = Ac,
      Aw = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
      },
      ay = {
        8: "Backspace",
        9: "Tab",
        12: "Clear",
        13: "Enter",
        16: "Shift",
        17: "Control",
        18: "Alt",
        19: "Pause",
        20: "CapsLock",
        27: "Escape",
        32: " ",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "ArrowLeft",
        38: "ArrowUp",
        39: "ArrowRight",
        40: "ArrowDown",
        45: "Insert",
        46: "Delete",
        112: "F1",
        113: "F2",
        114: "F3",
        115: "F4",
        116: "F5",
        117: "F6",
        118: "F7",
        119: "F8",
        120: "F9",
        121: "F10",
        122: "F11",
        123: "F12",
        144: "NumLock",
        145: "ScrollLock",
        224: "Meta"
      };
    function oy(s) {
      if (s.key) {
        var u = Aw[s.key] || s.key;
        if (u !== "Unidentified") return u;
      }
      if (s.type === "keypress") {
        var v = Ea(s);
        return v === 13 ? "Enter" : String.fromCharCode(v);
      }
      return s.type === "keydown" || s.type === "keyup" ? ay[s.keyCode] || "Unidentified" : "";
    }
    var Qs = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function jw(s) {
      var u = this,
        v = u.nativeEvent;
      if (v.getModifierState) return v.getModifierState(s);
      var _ = Qs[s];
      return _ ? !!v[_] : !1;
    }
    function Zs(s) {
      return jw;
    }
    var Qh = Qt({}, hr, {
        key: oy,
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: Zs,
        // Legacy Interface
        charCode: function (s) {
          return s.type === "keypress" ? Ea(s) : 0;
        },
        keyCode: function (s) {
          return s.type === "keydown" || s.type === "keyup" ? s.keyCode : 0;
        },
        which: function (s) {
          return s.type === "keypress" ? Ea(s) : s.type === "keydown" || s.type === "keyup" ? s.keyCode : 0;
        }
      }),
      $n = Ma(Qh),
      Fw = Qt({}, Pc, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
      }),
      nv = Ma(Fw),
      Rb = Qt({}, hr, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: Zs
      }),
      Nw = Ma(Rb),
      sy = Qt({}, di, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
      }),
      ly = Ma(sy),
      zw = Qt({}, Pc, {
        deltaX: function (s) {
          return "deltaX" in s ? s.deltaX :
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in s ? -s.wheelDeltaX : 0;
        },
        deltaY: function (s) {
          return "deltaY" in s ? s.deltaY :
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in s ? -s.wheelDeltaY :
          // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
          "wheelDelta" in s ? -s.wheelDelta : 0;
        },
        deltaZ: 0,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: 0
      }),
      Li = Ma(zw),
      Zh = [9, 13, 27, 32],
      Db = 229,
      Oa = Xe && "CompositionEvent" in window,
      Js = null;
    Xe && "documentMode" in document && (Js = document.documentMode);
    var oo = Xe && "TextEvent" in window && !Js,
      jc = Xe && (!Oa || Js && Js > 8 && Js <= 11),
      yf = 32,
      bf = String.fromCharCode(yf);
    function Ib() {
      Te("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), Te("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), Te("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), Te("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var dp = !1;
    function Mb(s) {
      return (s.ctrlKey || s.altKey || s.metaKey) &&
      // ctrlKey && altKey is equivalent to AltGr, and is not a command.
      !(s.ctrlKey && s.altKey);
    }
    function uy(s) {
      switch (s) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function cy(s, u) {
      return s === "keydown" && u.keyCode === Db;
    }
    function Fc(s, u) {
      switch (s) {
        case "keyup":
          return Zh.indexOf(u.keyCode) !== -1;
        case "keydown":
          return u.keyCode !== Db;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function vc(s) {
      var u = s.detail;
      return typeof u == "object" && "data" in u ? u.data : null;
    }
    function Jh(s) {
      return s.locale === "ko";
    }
    var Ql = !1;
    function fp(s, u, v, _, n) {
      var a, f;
      if (Oa ? a = uy(u) : Ql ? Fc(u, _) && (a = "onCompositionEnd") : cy(u, _) && (a = "onCompositionStart"), !a) return null;
      jc && !Jh(_) && (!Ql && a === "onCompositionStart" ? Ql = Kl(n) : a === "onCompositionEnd" && Ql && (f = So()));
      var m = uS(v, a);
      if (m.length > 0) {
        var b = new Ac(a, u, null, _, n);
        if (s.push({
          event: b,
          listeners: m
        }), f) b.data = f;else {
          var T = vc(_);
          T !== null && (b.data = T);
        }
      }
    }
    function dy(s, u) {
      switch (s) {
        case "compositionend":
          return vc(u);
        case "keypress":
          var v = u.which;
          return v !== yf ? null : (dp = !0, bf);
        case "textInput":
          var _ = u.data;
          return _ === bf && dp ? null : _;
        default:
          return null;
      }
    }
    function em(s, u) {
      if (Ql) {
        if (s === "compositionend" || !Oa && Fc(s, u)) {
          var v = So();
          return Yh(), Ql = !1, v;
        }
        return null;
      }
      switch (s) {
        case "paste":
          return null;
        case "keypress":
          if (!Mb(u)) {
            if (u.char && u.char.length > 1) return u.char;
            if (u.which) return String.fromCharCode(u.which);
          }
          return null;
        case "compositionend":
          return jc && !Jh(u) ? null : u.data;
        default:
          return null;
      }
    }
    function wf(s, u, v, _, n) {
      var a;
      if (oo ? a = dy(u, _) : a = em(u, _), !a) return null;
      var f = uS(v, "onBeforeInput");
      if (f.length > 0) {
        var m = new Tb("onBeforeInput", "beforeinput", null, _, n);
        s.push({
          event: m,
          listeners: f
        }), m.data = a;
      }
    }
    function tm(s, u, v, _, n, a, f) {
      fp(s, u, v, _, n), wf(s, u, v, _, n);
    }
    var _f = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function rv(s) {
      var u = s && s.nodeName && s.nodeName.toLowerCase();
      return u === "input" ? !!_f[s.type] : u === "textarea";
    }
    /**
     * Checks if an event is supported in the current execution environment.
     *
     * NOTE: This will not work correctly for non-generic events such as `change`,
     * `reset`, `load`, `error`, and `select`.
     *
     * Borrows from Modernizr.
     *
     * @param {string} eventNameSuffix Event name, e.g. "click".
     * @return {boolean} True if the event is supported.
     * @internal
     * @license Modernizr 3.0.0pre (Custom Build) | MIT
     */
    function Ob(s) {
      if (!Xe) return !1;
      var u = "on" + s,
        v = u in document;
      if (!v) {
        var _ = document.createElement("div");
        _.setAttribute(u, "return;"), v = typeof _[u] == "function";
      }
      return v;
    }
    function xf() {
      Te("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function Lb(s, u, v, _) {
      Il(_);
      var n = uS(u, "onChange");
      if (n.length > 0) {
        var a = new us("onChange", "change", null, v, _);
        s.push({
          event: a,
          listeners: n
        });
      }
    }
    var cs = null,
      gc = null;
    function Zl(s) {
      var u = s.nodeName && s.nodeName.toLowerCase();
      return u === "select" || u === "input" && s.type === "file";
    }
    function r(s) {
      var u = [];
      Lb(u, gc, s, Sh(s)), Mg(o, u);
    }
    function o(s) {
      tD(s, 0);
    }
    function d(s) {
      var u = zc(s);
      if (Rs(u)) return s;
    }
    function g(s, u) {
      if (s === "change") return u;
    }
    var S = !1;
    Xe && (S = Ob("input") && (!document.documentMode || document.documentMode > 9));
    function R(s, u) {
      cs = s, gc = u, cs.attachEvent("onpropertychange", q);
    }
    function A() {
      cs && (cs.detachEvent("onpropertychange", q), cs = null, gc = null);
    }
    function q(s) {
      s.propertyName === "value" && d(gc) && r(s);
    }
    function re(s, u, v) {
      s === "focusin" ? (A(), R(u, v)) : s === "focusout" && A();
    }
    function be(s, u) {
      if (s === "selectionchange" || s === "keyup" || s === "keydown") return d(gc);
    }
    function Le(s) {
      var u = s.nodeName;
      return u && u.toLowerCase() === "input" && (s.type === "checkbox" || s.type === "radio");
    }
    function Ve(s, u) {
      if (s === "click") return d(u);
    }
    function Oe(s, u) {
      if (s === "input" || s === "change") return d(u);
    }
    function et(s) {
      var u = s._wrapperState;
      !u || !u.controlled || s.type !== "number" || _d(s, "number", s.value);
    }
    function it(s, u, v, _, n, a, f) {
      var m = v ? zc(v) : window,
        b,
        T;
      if (Zl(m) ? b = g : rv(m) ? S ? b = Oe : (b = be, T = re) : Le(m) && (b = Ve), b) {
        var M = b(u, v);
        if (M) {
          Lb(s, M, _, n);
          return;
        }
      }
      T && T(u, m, v), u === "focusout" && et(m);
    }
    function st() {
      ze("onMouseEnter", ["mouseout", "mouseover"]), ze("onMouseLeave", ["mouseout", "mouseover"]), ze("onPointerEnter", ["pointerout", "pointerover"]), ze("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function Kn(s, u, v, _, n, a, f) {
      var m = u === "mouseover" || u === "pointerover",
        b = u === "mouseout" || u === "pointerout";
      if (m && !Hu(_)) {
        var T = _.relatedTarget || _.fromElement;
        if (T && (hv(T) || pv(T))) return;
      }
      if (!(!b && !m)) {
        var M;
        if (n.window === n) M = n;else {
          var z = n.ownerDocument;
          z ? M = z.defaultView || z.parentWindow : M = window;
        }
        var U, X;
        if (b) {
          var J = _.relatedTarget || _.toElement;
          if (U = v, X = J ? hv(J) : null, X !== null) {
            var me = si(X);
            (X !== me || X.tag !== D && X.tag !== I) && (X = null);
          }
        } else U = null, X = v;
        if (U !== X) {
          var Se = Gh,
            Me = "onMouseLeave",
            Pe = "onMouseEnter",
            $e = "mouse";
          (u === "pointerout" || u === "pointerover") && (Se = nv, Me = "onPointerLeave", Pe = "onPointerEnter", $e = "pointer");
          var mt = U == null ? M : zc(U),
            Re = X == null ? M : zc(X),
            Ue = new Se(Me, $e + "leave", U, _, n);
          Ue.target = mt, Ue.relatedTarget = Re;
          var Be = null,
            nt = hv(n);
          if (nt === v) {
            var ke = new Se(Pe, $e + "enter", X, _, n);
            ke.target = Re, ke.relatedTarget = mt, Be = ke;
          }
          iD(s, Ue, Be, U, X);
        }
      }
    }
    function pe(s, u) {
      return s === u && (s !== 0 || 1 / s === 1 / u) || s !== s && u !== u;
    }
    var ae = typeof Object.is == "function" ? Object.is : pe;
    function he(s, u) {
      if (ae(s, u)) return !0;
      if (typeof s != "object" || s === null || typeof u != "object" || u === null) return !1;
      var v = Object.keys(s),
        _ = Object.keys(u);
      if (v.length !== _.length) return !1;
      for (var n = 0; n < v.length; n++) {
        var a = v[n];
        if (!ye.call(u, a) || !ae(s[a], u[a])) return !1;
      }
      return !0;
    }
    function He(s) {
      for (; s && s.firstChild;) s = s.firstChild;
      return s;
    }
    function ut(s) {
      for (; s;) {
        if (s.nextSibling) return s.nextSibling;
        s = s.parentNode;
      }
    }
    function bt(s, u) {
      for (var v = He(s), _ = 0, n = 0; v;) {
        if (v.nodeType === Xa) {
          if (n = _ + v.textContent.length, _ <= u && n >= u) return {
            node: v,
            offset: u - _
          };
          _ = n;
        }
        v = He(ut(v));
      }
    }
    function wt(s) {
      var u = s.ownerDocument,
        v = u && u.defaultView || window,
        _ = v.getSelection && v.getSelection();
      if (!_ || _.rangeCount === 0) return null;
      var n = _.anchorNode,
        a = _.anchorOffset,
        f = _.focusNode,
        m = _.focusOffset;
      try {
        n.nodeType, f.nodeType;
      } catch {
        return null;
      }
      return It(s, n, a, f, m);
    }
    function It(s, u, v, _, n) {
      var a = 0,
        f = -1,
        m = -1,
        b = 0,
        T = 0,
        M = s,
        z = null;
      e: for (;;) {
        for (var U = null; M === u && (v === 0 || M.nodeType === Xa) && (f = a + v), M === _ && (n === 0 || M.nodeType === Xa) && (m = a + n), M.nodeType === Xa && (a += M.nodeValue.length), (U = M.firstChild) !== null;) z = M, M = U;
        for (;;) {
          if (M === s) break e;
          if (z === u && ++b === v && (f = a), z === _ && ++T === n && (m = a), (U = M.nextSibling) !== null) break;
          M = z, z = M.parentNode;
        }
        M = U;
      }
      return f === -1 || m === -1 ? null : {
        start: f,
        end: m
      };
    }
    function mr(s, u) {
      var v = s.ownerDocument || document,
        _ = v && v.defaultView || window;
      if (_.getSelection) {
        var n = _.getSelection(),
          a = s.textContent.length,
          f = Math.min(u.start, a),
          m = u.end === void 0 ? f : Math.min(u.end, a);
        if (!n.extend && f > m) {
          var b = m;
          m = f, f = b;
        }
        var T = bt(s, f),
          M = bt(s, m);
        if (T && M) {
          if (n.rangeCount === 1 && n.anchorNode === T.node && n.anchorOffset === T.offset && n.focusNode === M.node && n.focusOffset === M.offset) return;
          var z = v.createRange();
          z.setStart(T.node, T.offset), n.removeAllRanges(), f > m ? (n.addRange(z), n.extend(M.node, M.offset)) : (z.setEnd(M.node, M.offset), n.addRange(z));
        }
      }
    }
    function cn(s) {
      return s && s.nodeType === Xa;
    }
    function so(s, u) {
      return !s || !u ? !1 : s === u ? !0 : cn(s) ? !1 : cn(u) ? so(s, u.parentNode) : "contains" in s ? s.contains(u) : s.compareDocumentPosition ? !!(s.compareDocumentPosition(u) & 16) : !1;
    }
    function Pb(s) {
      return s && s.ownerDocument && so(s.ownerDocument.documentElement, s);
    }
    function cL(s) {
      try {
        return typeof s.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function QR() {
      for (var s = window, u = Ds(); u instanceof s.HTMLIFrameElement;) {
        if (cL(u)) s = u.contentWindow;else return u;
        u = Ds(s.document);
      }
      return u;
    }
    function iS(s) {
      var u = s && s.nodeName && s.nodeName.toLowerCase();
      return u && (u === "input" && (s.type === "text" || s.type === "search" || s.type === "tel" || s.type === "url" || s.type === "password") || u === "textarea" || s.contentEditable === "true");
    }
    function WE() {
      var s = QR();
      return {
        focusedElem: s,
        selectionRange: iS(s) ? fL(s) : null
      };
    }
    function dL(s) {
      var u = QR(),
        v = s.focusedElem,
        _ = s.selectionRange;
      if (u !== v && Pb(v)) {
        _ !== null && iS(v) && pL(v, _);
        for (var n = [], a = v; a = a.parentNode;) a.nodeType === Wr && n.push({
          element: a,
          left: a.scrollLeft,
          top: a.scrollTop
        });
        typeof v.focus == "function" && v.focus();
        for (var f = 0; f < n.length; f++) {
          var m = n[f];
          m.element.scrollLeft = m.left, m.element.scrollTop = m.top;
        }
      }
    }
    function fL(s) {
      var u;
      return "selectionStart" in s ? u = {
        start: s.selectionStart,
        end: s.selectionEnd
      } : u = wt(s), u || {
        start: 0,
        end: 0
      };
    }
    function pL(s, u) {
      var v = u.start,
        _ = u.end;
      _ === void 0 && (_ = v), "selectionStart" in s ? (s.selectionStart = v, s.selectionEnd = Math.min(_, s.value.length)) : mr(s, u);
    }
    var hL = Xe && "documentMode" in document && document.documentMode <= 11;
    function mL() {
      Te("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var Ab = null,
      iv = null,
      fy = null,
      py = !1;
    function qE(s) {
      if ("selectionStart" in s && iS(s)) return {
        start: s.selectionStart,
        end: s.selectionEnd
      };
      var u = s.ownerDocument && s.ownerDocument.defaultView || window,
        v = u.getSelection();
      return {
        anchorNode: v.anchorNode,
        anchorOffset: v.anchorOffset,
        focusNode: v.focusNode,
        focusOffset: v.focusOffset
      };
    }
    function vL(s) {
      return s.window === s ? s.document : s.nodeType === Ka ? s : s.ownerDocument;
    }
    function ZR(s, u, v) {
      var _ = vL(v);
      if (!(py || Ab == null || Ab !== Ds(_))) {
        var n = qE(Ab);
        if (!fy || !he(fy, n)) {
          fy = n;
          var a = uS(iv, "onSelect");
          if (a.length > 0) {
            var f = new us("onSelect", "select", null, u, v);
            s.push({
              event: f,
              listeners: a
            }), f.target = Ab;
          }
        }
      }
    }
    function JR(s, u, v, _, n, a, f) {
      var m = v ? zc(v) : window;
      switch (u) {
        // Track the input node that has focus.
        case "focusin":
          (rv(m) || m.contentEditable === "true") && (Ab = m, iv = v, fy = null);
          break;
        case "focusout":
          Ab = null, iv = null, fy = null;
          break;
        // Don't fire the event while the user is dragging. This matches the
        // semantics of the native select event.
        case "mousedown":
          py = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          py = !1, ZR(s, _, n);
          break;
        // Chrome and IE fire non-standard event when selection is changed (and
        // sometimes when it hasn't). IE's event fires out of order with respect
        // to key and input events on deletion, so we discard it.
        //
        // Firefox doesn't support selectionchange, so check selection status
        // after each key entry. The selection changes after keydown and before
        // keyup, but we check on keydown as well in the case of holding down a
        // key, when multiple keydown events are fired but only one keyup is.
        // This is also our approach for IE handling, for the reason above.
        case "selectionchange":
          if (hL) break;
        // falls through
        case "keydown":
        case "keyup":
          ZR(s, _, n);
      }
    }
    function aS(s, u) {
      var v = {};
      return v[s.toLowerCase()] = u.toLowerCase(), v["Webkit" + s] = "webkit" + u, v["Moz" + s] = "moz" + u, v;
    }
    var nm = {
        animationend: aS("Animation", "AnimationEnd"),
        animationiteration: aS("Animation", "AnimationIteration"),
        animationstart: aS("Animation", "AnimationStart"),
        transitionend: aS("Transition", "TransitionEnd")
      },
      av = {},
      oS = {};
    Xe && (oS = document.createElement("div").style, "AnimationEvent" in window || (delete nm.animationend.animation, delete nm.animationiteration.animation, delete nm.animationstart.animation), "TransitionEvent" in window || delete nm.transitionend.transition);
    function Vw(s) {
      if (av[s]) return av[s];
      if (!nm[s]) return s;
      var u = nm[s];
      for (var v in u) if (u.hasOwnProperty(v) && v in oS) return av[s] = u[v];
      return s;
    }
    var Bw = Vw("animationend"),
      YE = Vw("animationiteration"),
      GE = Vw("animationstart"),
      XE = Vw("transitionend"),
      KE = /* @__PURE__ */new Map(),
      QE = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
    function rm(s, u) {
      KE.set(s, u), Te(u, [s]);
    }
    function ov() {
      for (var s = 0; s < QE.length; s++) {
        var u = QE[s],
          v = u.toLowerCase(),
          _ = u[0].toUpperCase() + u.slice(1);
        rm(v, "on" + _);
      }
      rm(Bw, "onAnimationEnd"), rm(YE, "onAnimationIteration"), rm(GE, "onAnimationStart"), rm("dblclick", "onDoubleClick"), rm("focusin", "onFocus"), rm("focusout", "onBlur"), rm(XE, "onTransitionEnd");
    }
    function gL(s, u, v, _, n, a, f) {
      var m = KE.get(u);
      if (m !== void 0) {
        var b = us,
          T = u;
        switch (u) {
          case "keypress":
            if (Ea(_) === 0) return;
          /* falls through */
          case "keydown":
          case "keyup":
            b = $n;
            break;
          case "focusin":
            T = "focus", b = Ko;
            break;
          case "focusout":
            T = "blur", b = Ko;
            break;
          case "beforeblur":
          case "afterblur":
            b = Ko;
            break;
          case "click":
            if (_.button === 2) return;
          /* falls through */
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          // TODO: Disabled elements should not respond to mouse events
          /* falls through */
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            b = Gh;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            b = ny;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            b = Nw;
            break;
          case Bw:
          case YE:
          case GE:
            b = Ks;
            break;
          case XE:
            b = ly;
            break;
          case "scroll":
            b = Ca;
            break;
          case "wheel":
            b = Li;
            break;
          case "copy":
          case "cut":
          case "paste":
            b = iy;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            b = nv;
            break;
        }
        var M = (a & wi) !== 0;
        {
          var z = !M &&
            // TODO: ideally, we'd eventually add all events from
            // nonDelegatedEvents list in DOMPluginEventSystem.
            // Then we can remove this special list.
            // This is a breaking change that can wait until React 18.
            u === "scroll",
            U = Hw(v, m, _.type, M, z);
          if (U.length > 0) {
            var X = new b(m, T, null, _, n);
            s.push({
              event: X,
              listeners: U
            });
          }
        }
      }
    }
    ov(), st(), xf(), mL(), Ib();
    function yL(s, u, v, _, n, a, f) {
      gL(s, u, v, _, n, a);
      var m = (a & xh) === 0;
      m && (Kn(s, u, v, _, n), it(s, u, v, _, n), JR(s, u, v, _, n), tm(s, u, v, _, n));
    }
    var Uw = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"],
      hy = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(Uw));
    function sS(s, u, v) {
      var _ = s.type || "unknown-event";
      s.currentTarget = v, ma(_, u, void 0, s), s.currentTarget = null;
    }
    function eD(s, u, v) {
      var _;
      if (v) for (var n = u.length - 1; n >= 0; n--) {
        var a = u[n],
          f = a.instance,
          m = a.currentTarget,
          b = a.listener;
        if (f !== _ && s.isPropagationStopped()) return;
        sS(s, b, m), _ = f;
      } else for (var T = 0; T < u.length; T++) {
        var M = u[T],
          z = M.instance,
          U = M.currentTarget,
          X = M.listener;
        if (z !== _ && s.isPropagationStopped()) return;
        sS(s, X, U), _ = z;
      }
    }
    function tD(s, u) {
      for (var v = (u & wi) !== 0, _ = 0; _ < s.length; _++) {
        var n = s[_],
          a = n.event,
          f = n.listeners;
        eD(a, f, v);
      }
      qu();
    }
    function nD(s, u, v, _, n) {
      var a = Sh(v),
        f = [];
      yL(f, s, _, v, a, u), tD(f, u);
    }
    function Ji(s, u) {
      hy.has(s) || h('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', s);
      var v = !1,
        _ = vS(u),
        n = bL(s);
      _.has(n) || (Fb(u, s, Id, v), _.add(n));
    }
    function Pi(s, u, v) {
      hy.has(s) && !u && h('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', s);
      var _ = 0;
      u && (_ |= wi), Fb(v, s, _, u);
    }
    var jb = "_reactListening" + Math.random().toString(36).slice(2);
    function sv(s) {
      if (!s[jb]) {
        s[jb] = !0, xe.forEach(function (v) {
          v !== "selectionchange" && (hy.has(v) || Pi(v, !1, s), Pi(v, !0, s));
        });
        var u = s.nodeType === Ka ? s : s.ownerDocument;
        u !== null && (u[jb] || (u[jb] = !0, Pi("selectionchange", !1, u)));
      }
    }
    function Fb(s, u, v, _, n) {
      var a = pr(s, u, v),
        f = void 0;
      Wu && (u === "touchstart" || u === "touchmove" || u === "wheel") && (f = !0), s = s, _ ? f !== void 0 ? dc(s, u, a, f) : qh(s, u, a) : f !== void 0 ? ti(s, u, a, f) : Lc(s, u, a);
    }
    function ZE(s, u) {
      return s === u || s.nodeType === er && s.parentNode === u;
    }
    function lS(s, u, v, _, n) {
      var a = _;
      if ((u & _h) === 0 && (u & Id) === 0) {
        var f = n;
        if (_ !== null) {
          var m = _;
          e: for (;;) {
            if (m === null) return;
            var b = m.tag;
            if (b === C || b === k) {
              var T = m.stateNode.containerInfo;
              if (ZE(T, f)) break;
              if (b === k) for (var M = m.return; M !== null;) {
                var z = M.tag;
                if (z === C || z === k) {
                  var U = M.stateNode.containerInfo;
                  if (ZE(U, f)) return;
                }
                M = M.return;
              }
              for (; T !== null;) {
                var X = hv(T);
                if (X === null) return;
                var J = X.tag;
                if (J === D || J === I) {
                  m = a = X;
                  continue e;
                }
                T = T.parentNode;
              }
            }
            m = m.return;
          }
        }
      }
      Mg(function () {
        return nD(s, u, v, a);
      });
    }
    function my(s, u, v) {
      return {
        instance: s,
        listener: u,
        currentTarget: v
      };
    }
    function Hw(s, u, v, _, n, a) {
      for (var f = u !== null ? u + "Capture" : null, m = _ ? f : u, b = [], T = s, M = null; T !== null;) {
        var z = T,
          U = z.stateNode,
          X = z.tag;
        if (X === D && U !== null && (M = U, m !== null)) {
          var J = zo(T, m);
          J != null && b.push(my(T, J, M));
        }
        if (n) break;
        T = T.return;
      }
      return b;
    }
    function uS(s, u) {
      for (var v = u + "Capture", _ = [], n = s; n !== null;) {
        var a = n,
          f = a.stateNode,
          m = a.tag;
        if (m === D && f !== null) {
          var b = f,
            T = zo(n, v);
          T != null && _.unshift(my(n, T, b));
          var M = zo(n, u);
          M != null && _.push(my(n, M, b));
        }
        n = n.return;
      }
      return _;
    }
    function im(s) {
      if (s === null) return null;
      do s = s.return; while (s && s.tag !== D);
      return s || null;
    }
    function Nb(s, u) {
      for (var v = s, _ = u, n = 0, a = v; a; a = im(a)) n++;
      for (var f = 0, m = _; m; m = im(m)) f++;
      for (; n - f > 0;) v = im(v), n--;
      for (; f - n > 0;) _ = im(_), f--;
      for (var b = n; b--;) {
        if (v === _ || _ !== null && v === _.alternate) return v;
        v = im(v), _ = im(_);
      }
      return null;
    }
    function rD(s, u, v, _, n) {
      for (var a = u._reactName, f = [], m = v; m !== null && m !== _;) {
        var b = m,
          T = b.alternate,
          M = b.stateNode,
          z = b.tag;
        if (T !== null && T === _) break;
        if (z === D && M !== null) {
          var U = M;
          if (n) {
            var X = zo(m, a);
            X != null && f.unshift(my(m, X, U));
          } else if (!n) {
            var J = zo(m, a);
            J != null && f.push(my(m, J, U));
          }
        }
        m = m.return;
      }
      f.length !== 0 && s.push({
        event: u,
        listeners: f
      });
    }
    function iD(s, u, v, _, n) {
      var a = _ && n ? Nb(_, n) : null;
      _ !== null && rD(s, u, _, a, !1), n !== null && v !== null && rD(s, v, n, a, !0);
    }
    function bL(s, u) {
      return s + "__bubble";
    }
    var pu = !1,
      ds = "dangerouslySetInnerHTML",
      lv = "suppressContentEditableWarning",
      Sf = "suppressHydrationWarning",
      am = "autoFocus",
      uv = "children",
      yc = "style",
      pp = "__html",
      zb,
      Vb,
      cv,
      Bb,
      $w,
      Ww,
      JE;
    zb = {
      // There are working polyfills for <dialog>. Let people use it.
      dialog: !0,
      // Electron ships a custom <webview> tag to display external web content in
      // an isolated frame and process.
      // This tag is not present in non Electron environments such as JSDom which
      // is often used for testing purposes.
      // @see https://electronjs.org/docs/api/webview-tag
      webview: !0
    }, Vb = function (s, u) {
      yh(s, u), Rd(s, u), Rg(s, u, {
        registrationNameDependencies: we,
        possibleRegistrationNames: ve
      });
    }, Ww = Xe && !document.documentMode, cv = function (s, u, v) {
      if (!pu) {
        var _ = cS(v),
          n = cS(u);
        n !== _ && (pu = !0, h("Prop `%s` did not match. Server: %s Client: %s", s, JSON.stringify(n), JSON.stringify(_)));
      }
    }, Bb = function (s) {
      if (!pu) {
        pu = !0;
        var u = [];
        s.forEach(function (v) {
          u.push(v);
        }), h("Extra attributes from the server: %s", u);
      }
    }, $w = function (s, u) {
      u === !1 ? h("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", s, s, s) : h("Expected `%s` listener to be a function, instead got a value of `%s` type.", s, typeof u);
    }, JE = function (s, u) {
      var v = s.namespaceURI === Ga ? s.ownerDocument.createElement(s.tagName) : s.ownerDocument.createElementNS(s.namespaceURI, s.tagName);
      return v.innerHTML = u, v.innerHTML;
    };
    var aD = /\r\n?/g,
      wL = /\u0000|\uFFFD/g;
    function cS(s) {
      St(s);
      var u = typeof s == "string" ? s : "" + s;
      return u.replace(aD, `
`).replace(wL, "");
    }
    function vy(s, u, v, _) {
      var n = cS(u),
        a = cS(s);
      if (a !== n && (_ && (pu || (pu = !0, h('Text content did not match. Server: "%s" Client: "%s"', a, n))), v && W)) throw new Error("Text content does not match server-rendered HTML.");
    }
    function qw(s) {
      return s.nodeType === Ka ? s : s.ownerDocument;
    }
    function oD() {}
    function dS(s) {
      s.onclick = oD;
    }
    function fS(s, u, v, _, n) {
      for (var a in _) if (_.hasOwnProperty(a)) {
        var f = _[a];
        if (a === yc) f && Object.freeze(f), xg(u, f);else if (a === ds) {
          var m = f ? f[pp] : void 0;
          m != null && cg(u, m);
        } else if (a === uv) {
          if (typeof f == "string") {
            var b = s !== "textarea" || f !== "";
            b && kl(u, f);
          } else typeof f == "number" && kl(u, "" + f);
        } else a === lv || a === Sf || a === am || (we.hasOwnProperty(a) ? f != null && (typeof f != "function" && $w(a, f), a === "onScroll" && Ji("scroll", u)) : f != null && Ha(u, a, f, n));
      }
    }
    function _L(s, u, v, _) {
      for (var n = 0; n < u.length; n += 2) {
        var a = u[n],
          f = u[n + 1];
        a === yc ? xg(s, f) : a === ds ? cg(s, f) : a === uv ? kl(s, f) : Ha(s, a, f, _);
      }
    }
    function xL(s, u, v, _) {
      var n,
        a = qw(v),
        f,
        m = _;
      if (m === Ga && (m = dh(s)), m === Ga) {
        if (n = Fo(s, u), !n && s !== s.toLowerCase() && h("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", s), s === "script") {
          var b = a.createElement("div");
          b.innerHTML = "<script><\/script>";
          var T = b.firstChild;
          f = b.removeChild(T);
        } else if (typeof u.is == "string") f = a.createElement(s, {
          is: u.is
        });else if (f = a.createElement(s), s === "select") {
          var M = f;
          u.multiple ? M.multiple = !0 : u.size && (M.size = u.size);
        }
      } else f = a.createElementNS(m, s);
      return m === Ga && !n && Object.prototype.toString.call(f) === "[object HTMLUnknownElement]" && !ye.call(zb, s) && (zb[s] = !0, h("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", s)), f;
    }
    function SL(s, u) {
      return qw(u).createTextNode(s);
    }
    function EL(s, u, v, _) {
      var n = Fo(u, v);
      Vb(u, v);
      var a;
      switch (u) {
        case "dialog":
          Ji("cancel", s), Ji("close", s), a = v;
          break;
        case "iframe":
        case "object":
        case "embed":
          Ji("load", s), a = v;
          break;
        case "video":
        case "audio":
          for (var f = 0; f < Uw.length; f++) Ji(Uw[f], s);
          a = v;
          break;
        case "source":
          Ji("error", s), a = v;
          break;
        case "img":
        case "image":
        case "link":
          Ji("error", s), Ji("load", s), a = v;
          break;
        case "details":
          Ji("toggle", s), a = v;
          break;
        case "input":
          Ya(s, v), a = gd(s, v), Ji("invalid", s);
          break;
        case "option":
          El(s, v), a = v;
          break;
        case "select":
          Sd(s, v), a = oh(s, v), Ji("invalid", s);
          break;
        case "textarea":
          lh(s, v), a = sh(s, v), Ji("invalid", s);
          break;
        default:
          a = v;
      }
      switch (kd(u, a), fS(u, s, _, a, n), u) {
        case "input":
          jo(s), rh(s, v, !1);
          break;
        case "textarea":
          jo(s), lg(s);
          break;
        case "option":
          hw(s, v);
          break;
        case "select":
          vw(s, v);
          break;
        default:
          typeof a.onClick == "function" && dS(s);
          break;
      }
    }
    function CL(s, u, v, _, n) {
      Vb(u, _);
      var a = null,
        f,
        m;
      switch (u) {
        case "input":
          f = gd(s, v), m = gd(s, _), a = [];
          break;
        case "select":
          f = oh(s, v), m = oh(s, _), a = [];
          break;
        case "textarea":
          f = sh(s, v), m = sh(s, _), a = [];
          break;
        default:
          f = v, m = _, typeof f.onClick != "function" && typeof m.onClick == "function" && dS(s);
          break;
      }
      kd(u, m);
      var b,
        T,
        M = null;
      for (b in f) if (!(m.hasOwnProperty(b) || !f.hasOwnProperty(b) || f[b] == null)) if (b === yc) {
        var z = f[b];
        for (T in z) z.hasOwnProperty(T) && (M || (M = {}), M[T] = "");
      } else b === ds || b === uv || b === lv || b === Sf || b === am || (we.hasOwnProperty(b) ? a || (a = []) : (a = a || []).push(b, null));
      for (b in m) {
        var U = m[b],
          X = f != null ? f[b] : void 0;
        if (!(!m.hasOwnProperty(b) || U === X || U == null && X == null)) if (b === yc) {
          if (U && Object.freeze(U), X) {
            for (T in X) X.hasOwnProperty(T) && (!U || !U.hasOwnProperty(T)) && (M || (M = {}), M[T] = "");
            for (T in U) U.hasOwnProperty(T) && X[T] !== U[T] && (M || (M = {}), M[T] = U[T]);
          } else M || (a || (a = []), a.push(b, M)), M = U;
        } else if (b === ds) {
          var J = U ? U[pp] : void 0,
            me = X ? X[pp] : void 0;
          J != null && me !== J && (a = a || []).push(b, J);
        } else b === uv ? (typeof U == "string" || typeof U == "number") && (a = a || []).push(b, "" + U) : b === lv || b === Sf || (we.hasOwnProperty(b) ? (U != null && (typeof U != "function" && $w(b, U), b === "onScroll" && Ji("scroll", s)), !a && X !== U && (a = [])) : (a = a || []).push(b, U));
      }
      return M && (Cw(M, m[yc]), (a = a || []).push(yc, M)), a;
    }
    function kL(s, u, v, _, n) {
      v === "input" && n.type === "radio" && n.name != null && yd(s, n);
      var a = Fo(v, _),
        f = Fo(v, n);
      switch (_L(s, u, a, f), v) {
        case "input":
          Sl(s, n);
          break;
        case "textarea":
          sg(s, n);
          break;
        case "select":
          gw(s, n);
          break;
      }
    }
    function TL(s) {
      {
        var u = s.toLowerCase();
        return Bu.hasOwnProperty(u) && Bu[u] || null;
      }
    }
    function RL(s, u, v, _, n, a, f) {
      var m, b;
      switch (m = Fo(u, v), Vb(u, v), u) {
        case "dialog":
          Ji("cancel", s), Ji("close", s);
          break;
        case "iframe":
        case "object":
        case "embed":
          Ji("load", s);
          break;
        case "video":
        case "audio":
          for (var T = 0; T < Uw.length; T++) Ji(Uw[T], s);
          break;
        case "source":
          Ji("error", s);
          break;
        case "img":
        case "image":
        case "link":
          Ji("error", s), Ji("load", s);
          break;
        case "details":
          Ji("toggle", s);
          break;
        case "input":
          Ya(s, v), Ji("invalid", s);
          break;
        case "option":
          El(s, v);
          break;
        case "select":
          Sd(s, v), Ji("invalid", s);
          break;
        case "textarea":
          lh(s, v), Ji("invalid", s);
          break;
      }
      kd(u, v);
      {
        b = /* @__PURE__ */new Set();
        for (var M = s.attributes, z = 0; z < M.length; z++) {
          var U = M[z].name.toLowerCase();
          switch (U) {
            // Controlled attributes are not validated
            // TODO: Only ignore them on controlled tags.
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              b.add(M[z].name);
          }
        }
      }
      var X = null;
      for (var J in v) if (v.hasOwnProperty(J)) {
        var me = v[J];
        if (J === uv) typeof me == "string" ? s.textContent !== me && (v[Sf] !== !0 && vy(s.textContent, me, a, f), X = [uv, me]) : typeof me == "number" && s.textContent !== "" + me && (v[Sf] !== !0 && vy(s.textContent, me, a, f), X = [uv, "" + me]);else if (we.hasOwnProperty(J)) me != null && (typeof me != "function" && $w(J, me), J === "onScroll" && Ji("scroll", s));else if (f &&
        // Convince Flow we've calculated it (it's DEV-only in this method.)
        typeof m == "boolean") {
          var Se = void 0,
            Me = Ht(J);
          if (v[Sf] !== !0 && !(J === lv || J === Sf ||
          // Controlled attributes are not validated
          // TODO: Only ignore them on controlled tags.
          J === "value" || J === "checked" || J === "selected")) {
            if (J === ds) {
              var Pe = s.innerHTML,
                $e = me ? me[pp] : void 0;
              if ($e != null) {
                var mt = JE(s, $e);
                mt !== Pe && cv(J, Pe, mt);
              }
            } else if (J === yc) {
              if (b.delete(J), Ww) {
                var Re = Sw(me);
                Se = s.getAttribute("style"), Re !== Se && cv(J, Se, Re);
              }
            } else if (m) b.delete(J.toLowerCase()), Se = Tu(s, J, me), me !== Se && cv(J, Se, me);else if (!at(J, Me, m) && !Bt(J, me, Me, m)) {
              var Ue = !1;
              if (Me !== null) b.delete(Me.attributeName), Se = bo(s, J, me, Me);else {
                var Be = _;
                if (Be === Ga && (Be = dh(u)), Be === Ga) b.delete(J.toLowerCase());else {
                  var nt = TL(J);
                  nt !== null && nt !== J && (Ue = !0, b.delete(nt)), b.delete(J);
                }
                Se = Tu(s, J, me);
              }
              var ke = ce;
              !ke && me !== Se && !Ue && cv(J, Se, me);
            }
          }
        }
      }
      switch (f &&
      // $FlowFixMe - Should be inferred as not undefined.
      b.size > 0 && v[Sf] !== !0 && Bb(b), u) {
        case "input":
          jo(s), rh(s, v, !0);
          break;
        case "textarea":
          jo(s), lg(s);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof v.onClick == "function" && dS(s);
          break;
      }
      return X;
    }
    function DL(s, u, v) {
      var _ = s.nodeValue !== u;
      return _;
    }
    function eC(s, u) {
      {
        if (pu) return;
        pu = !0, h("Did not expect server HTML to contain a <%s> in <%s>.", u.nodeName.toLowerCase(), s.nodeName.toLowerCase());
      }
    }
    function Yw(s, u) {
      {
        if (pu) return;
        pu = !0, h('Did not expect server HTML to contain the text node "%s" in <%s>.', u.nodeValue, s.nodeName.toLowerCase());
      }
    }
    function Gw(s, u, v) {
      {
        if (pu) return;
        pu = !0, h("Expected server HTML to contain a matching <%s> in <%s>.", u, s.nodeName.toLowerCase());
      }
    }
    function Xw(s, u) {
      {
        if (u === "" || pu) return;
        pu = !0, h('Expected server HTML to contain a matching text node for "%s" in <%s>.', u, s.nodeName.toLowerCase());
      }
    }
    function tC(s, u, v) {
      switch (u) {
        case "input":
          bd(s, v);
          return;
        case "textarea":
          bw(s, v);
          return;
        case "select":
          yw(s, v);
          return;
      }
    }
    var Kw = function () {},
      om = function () {};
    {
      var Qw = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"],
        sD = ["applet", "caption", "html", "table", "td", "th", "marquee", "object", "template",
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject", "desc", "title"],
        lD = sD.concat(["button"]),
        IL = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"],
        uD = {
          current: null,
          formTag: null,
          aTagInScope: null,
          buttonTagInScope: null,
          nobrTagInScope: null,
          pTagInButtonScope: null,
          listItemTagAutoclosing: null,
          dlItemTagAutoclosing: null
        };
      om = function (s, u) {
        var v = Qt({}, s || uD),
          _ = {
            tag: u
          };
        return sD.indexOf(u) !== -1 && (v.aTagInScope = null, v.buttonTagInScope = null, v.nobrTagInScope = null), lD.indexOf(u) !== -1 && (v.pTagInButtonScope = null), Qw.indexOf(u) !== -1 && u !== "address" && u !== "div" && u !== "p" && (v.listItemTagAutoclosing = null, v.dlItemTagAutoclosing = null), v.current = _, u === "form" && (v.formTag = _), u === "a" && (v.aTagInScope = _), u === "button" && (v.buttonTagInScope = _), u === "nobr" && (v.nobrTagInScope = _), u === "p" && (v.pTagInButtonScope = _), u === "li" && (v.listItemTagAutoclosing = _), (u === "dd" || u === "dt") && (v.dlItemTagAutoclosing = _), v;
      };
      var cD = function (s, u) {
          switch (u) {
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
            case "select":
              return s === "option" || s === "optgroup" || s === "#text";
            case "optgroup":
              return s === "option" || s === "#text";
            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
            // but
            case "option":
              return s === "#text";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
            // No special behavior since these rules fall back to "in body" mode for
            // all except special table nodes which cause bad parsing behavior anyway.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
            case "tr":
              return s === "th" || s === "td" || s === "style" || s === "script" || s === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
            case "tbody":
            case "thead":
            case "tfoot":
              return s === "tr" || s === "style" || s === "script" || s === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
            case "colgroup":
              return s === "col" || s === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
            case "table":
              return s === "caption" || s === "colgroup" || s === "tbody" || s === "tfoot" || s === "thead" || s === "style" || s === "script" || s === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
            case "head":
              return s === "base" || s === "basefont" || s === "bgsound" || s === "link" || s === "meta" || s === "title" || s === "noscript" || s === "noframes" || s === "style" || s === "script" || s === "template";
            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
            case "html":
              return s === "head" || s === "body" || s === "frameset";
            case "frameset":
              return s === "frame";
            case "#document":
              return s === "html";
          }
          switch (s) {
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
              return u !== "h1" && u !== "h2" && u !== "h3" && u !== "h4" && u !== "h5" && u !== "h6";
            case "rp":
            case "rt":
              return IL.indexOf(u) === -1;
            case "body":
            case "caption":
            case "col":
            case "colgroup":
            case "frameset":
            case "frame":
            case "head":
            case "html":
            case "tbody":
            case "td":
            case "tfoot":
            case "th":
            case "thead":
            case "tr":
              return u == null;
          }
          return !0;
        },
        ML = function (s, u) {
          switch (s) {
            case "address":
            case "article":
            case "aside":
            case "blockquote":
            case "center":
            case "details":
            case "dialog":
            case "dir":
            case "div":
            case "dl":
            case "fieldset":
            case "figcaption":
            case "figure":
            case "footer":
            case "header":
            case "hgroup":
            case "main":
            case "menu":
            case "nav":
            case "ol":
            case "p":
            case "section":
            case "summary":
            case "ul":
            case "pre":
            case "listing":
            case "table":
            case "hr":
            case "xmp":
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
              return u.pTagInButtonScope;
            case "form":
              return u.formTag || u.pTagInButtonScope;
            case "li":
              return u.listItemTagAutoclosing;
            case "dd":
            case "dt":
              return u.dlItemTagAutoclosing;
            case "button":
              return u.buttonTagInScope;
            case "a":
              return u.aTagInScope;
            case "nobr":
              return u.nobrTagInScope;
          }
          return null;
        },
        dD = {};
      Kw = function (s, u, v) {
        v = v || uD;
        var _ = v.current,
          n = _ && _.tag;
        u != null && (s != null && h("validateDOMNesting: when childText is passed, childTag should be null"), s = "#text");
        var a = cD(s, n) ? null : _,
          f = a ? null : ML(s, v),
          m = a || f;
        if (m) {
          var b = m.tag,
            T = !!a + "|" + s + "|" + b;
          if (!dD[T]) {
            dD[T] = !0;
            var M = s,
              z = "";
            if (s === "#text" ? /\S/.test(u) ? M = "Text nodes" : (M = "Whitespace text nodes", z = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : M = "<" + s + ">", a) {
              var U = "";
              b === "table" && s === "tr" && (U += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), h("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", M, b, z, U);
            } else h("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", M, b);
          }
        }
      };
    }
    var Zw = "suppressHydrationWarning",
      gy = "$",
      yy = "/$",
      dv = "$?",
      sm = "$!",
      Jw = "style",
      nC = null,
      e_ = null;
    function rC(s) {
      var u,
        v,
        _ = s.nodeType;
      switch (_) {
        case Ka:
        case ph:
          {
            u = _ === Ka ? "#document" : "#fragment";
            var n = s.documentElement;
            v = n ? n.namespaceURI : fh(null, "");
            break;
          }
        default:
          {
            var a = _ === er ? s.parentNode : s,
              f = a.namespaceURI || null;
            u = a.tagName, v = fh(f, u);
            break;
          }
      }
      {
        var m = u.toLowerCase(),
          b = om(null, m);
        return {
          namespace: v,
          ancestorInfo: b
        };
      }
    }
    function OL(s, u, v) {
      {
        var _ = s,
          n = fh(_.namespace, u),
          a = om(_.ancestorInfo, u);
        return {
          namespace: n,
          ancestorInfo: a
        };
      }
    }
    function LL(s) {
      nC = on(), e_ = WE();
      var u = null;
      return ii(!1), u;
    }
    function $z(s) {
      dL(e_), ii(nC), nC = null, e_ = null;
    }
    function PL(s, u, v, _, n) {
      var a;
      {
        var f = _;
        if (Kw(s, null, f.ancestorInfo), typeof u.children == "string" || typeof u.children == "number") {
          var m = "" + u.children,
            b = om(f.ancestorInfo, s);
          Kw(null, m, b);
        }
        a = f.namespace;
      }
      var T = xL(s, u, v, a);
      return o_(n, T), mv(T, u), T;
    }
    function AL(s, u) {
      s.appendChild(u);
    }
    function jL(s, u, v, _, n) {
      switch (EL(s, u, v, _), u) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!v.autoFocus;
        case "img":
          return !0;
        default:
          return !1;
      }
    }
    function FL(s, u, v, _, n, a) {
      {
        var f = a;
        if (typeof _.children != typeof v.children && (typeof _.children == "string" || typeof _.children == "number")) {
          var m = "" + _.children,
            b = om(f.ancestorInfo, u);
          Kw(null, m, b);
        }
      }
      return CL(s, u, v, _);
    }
    function iC(s, u) {
      return s === "textarea" || s === "noscript" || typeof u.children == "string" || typeof u.children == "number" || typeof u.dangerouslySetInnerHTML == "object" && u.dangerouslySetInnerHTML !== null && u.dangerouslySetInnerHTML.__html != null;
    }
    function NL(s, u, v, _) {
      {
        var n = v;
        Kw(null, s, n.ancestorInfo);
      }
      var a = SL(s, u);
      return o_(_, a), a;
    }
    function aC() {
      var s = window.event;
      return s === void 0 ? Zi : xo(s.type);
    }
    var oC = typeof setTimeout == "function" ? setTimeout : void 0,
      zL = typeof clearTimeout == "function" ? clearTimeout : void 0,
      t_ = -1,
      fD = typeof Promise == "function" ? Promise : void 0,
      sC = typeof queueMicrotask == "function" ? queueMicrotask : typeof fD < "u" ? function (s) {
        return fD.resolve(null).then(s).catch(pD);
      } : oC;
    function pD(s) {
      setTimeout(function () {
        throw s;
      });
    }
    function VL(s, u, v, _) {
      switch (u) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          v.autoFocus && s.focus();
          return;
        case "img":
          {
            v.src && (s.src = v.src);
            return;
          }
      }
    }
    function BL(s, u, v, _, n, a) {
      kL(s, u, v, _, n), mv(s, n);
    }
    function hD(s) {
      kl(s, "");
    }
    function UL(s, u, v) {
      s.nodeValue = v;
    }
    function mD(s, u) {
      s.appendChild(u);
    }
    function HL(s, u) {
      var v;
      s.nodeType === er ? (v = s.parentNode, v.insertBefore(u, s)) : (v = s, v.appendChild(u));
      var _ = s._reactRootContainer;
      _ == null && v.onclick === null && dS(v);
    }
    function $L(s, u, v) {
      s.insertBefore(u, v);
    }
    function WL(s, u, v) {
      s.nodeType === er ? s.parentNode.insertBefore(u, v) : s.insertBefore(u, v);
    }
    function qL(s, u) {
      s.removeChild(u);
    }
    function YL(s, u) {
      s.nodeType === er ? s.parentNode.removeChild(u) : s.removeChild(u);
    }
    function lC(s, u) {
      var v = u,
        _ = 0;
      do {
        var n = v.nextSibling;
        if (s.removeChild(v), n && n.nodeType === er) {
          var a = n.data;
          if (a === yy) {
            if (_ === 0) {
              s.removeChild(n), cc(u);
              return;
            } else _--;
          } else (a === gy || a === dv || a === sm) && _++;
        }
        v = n;
      } while (v);
      cc(u);
    }
    function GL(s, u) {
      s.nodeType === er ? lC(s.parentNode, u) : s.nodeType === Wr && lC(s, u), cc(s);
    }
    function uC(s) {
      s = s;
      var u = s.style;
      typeof u.setProperty == "function" ? u.setProperty("display", "none", "important") : u.display = "none";
    }
    function XL(s) {
      s.nodeValue = "";
    }
    function KL(s, u) {
      s = s;
      var v = u[Jw],
        _ = v != null && v.hasOwnProperty("display") ? v.display : null;
      s.style.display = Cd("display", _);
    }
    function QL(s, u) {
      s.nodeValue = u;
    }
    function ZL(s) {
      s.nodeType === Wr ? s.textContent = "" : s.nodeType === Ka && s.documentElement && s.removeChild(s.documentElement);
    }
    function JL(s, u, v) {
      return s.nodeType !== Wr || u.toLowerCase() !== s.nodeName.toLowerCase() ? null : s;
    }
    function eP(s, u) {
      return u === "" || s.nodeType !== Xa ? null : s;
    }
    function tP(s) {
      return s.nodeType !== er ? null : s;
    }
    function vD(s) {
      return s.data === dv;
    }
    function cC(s) {
      return s.data === sm;
    }
    function gD(s) {
      var u = s.nextSibling && s.nextSibling.dataset,
        v,
        _,
        n;
      return u && (v = u.dgst, _ = u.msg, n = u.stck), {
        message: _,
        digest: v,
        stack: n
      };
    }
    function dC(s, u) {
      s._reactRetry = u;
    }
    function pS(s) {
      for (; s != null; s = s.nextSibling) {
        var u = s.nodeType;
        if (u === Wr || u === Xa) break;
        if (u === er) {
          var v = s.data;
          if (v === gy || v === sm || v === dv) break;
          if (v === yy) return null;
        }
      }
      return s;
    }
    function n_(s) {
      return pS(s.nextSibling);
    }
    function hS(s) {
      return pS(s.firstChild);
    }
    function r_(s) {
      return pS(s.firstChild);
    }
    function nP(s) {
      return pS(s.nextSibling);
    }
    function rP(s, u, v, _, n, a, f) {
      o_(a, s), mv(s, v);
      var m;
      {
        var b = n;
        m = b.namespace;
      }
      var T = (a.mode & Wt) !== dt;
      return RL(s, u, v, m, _, T, f);
    }
    function iP(s, u, v, _) {
      return o_(v, s), v.mode & Wt, DL(s, u);
    }
    function aP(s, u) {
      o_(u, s);
    }
    function oP(s) {
      for (var u = s.nextSibling, v = 0; u;) {
        if (u.nodeType === er) {
          var _ = u.data;
          if (_ === yy) {
            if (v === 0) return n_(u);
            v--;
          } else (_ === gy || _ === sm || _ === dv) && v++;
        }
        u = u.nextSibling;
      }
      return null;
    }
    function yD(s) {
      for (var u = s.previousSibling, v = 0; u;) {
        if (u.nodeType === er) {
          var _ = u.data;
          if (_ === gy || _ === sm || _ === dv) {
            if (v === 0) return u;
            v--;
          } else _ === yy && v++;
        }
        u = u.previousSibling;
      }
      return null;
    }
    function sP(s) {
      cc(s);
    }
    function bD(s) {
      cc(s);
    }
    function lP(s) {
      return s !== "head" && s !== "body";
    }
    function uP(s, u, v, _) {
      var n = !0;
      vy(u.nodeValue, v, _, n);
    }
    function cP(s, u, v, _, n, a) {
      if (u[Zw] !== !0) {
        var f = !0;
        vy(_.nodeValue, n, a, f);
      }
    }
    function dP(s, u) {
      u.nodeType === Wr ? eC(s, u) : u.nodeType === er || Yw(s, u);
    }
    function fP(s, u) {
      {
        var v = s.parentNode;
        v !== null && (u.nodeType === Wr ? eC(v, u) : u.nodeType === er || Yw(v, u));
      }
    }
    function pP(s, u, v, _, n) {
      (n || u[Zw] !== !0) && (_.nodeType === Wr ? eC(v, _) : _.nodeType === er || Yw(v, _));
    }
    function hP(s, u, v) {
      Gw(s, u);
    }
    function mP(s, u) {
      Xw(s, u);
    }
    function vP(s, u, v) {
      {
        var _ = s.parentNode;
        _ !== null && Gw(_, u);
      }
    }
    function gP(s, u) {
      {
        var v = s.parentNode;
        v !== null && Xw(v, u);
      }
    }
    function yP(s, u, v, _, n, a) {
      (a || u[Zw] !== !0) && Gw(v, _);
    }
    function bP(s, u, v, _, n) {
      (n || u[Zw] !== !0) && Xw(v, _);
    }
    function wP(s) {
      h("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", s.nodeName.toLowerCase());
    }
    function _P(s) {
      sv(s);
    }
    var Ub = Math.random().toString(36).slice(2),
      Hb = "__reactFiber$" + Ub,
      fv = "__reactProps$" + Ub,
      hp = "__reactContainer$" + Ub,
      i_ = "__reactEvents$" + Ub,
      a_ = "__reactListeners$" + Ub,
      fC = "__reactHandles$" + Ub;
    function xP(s) {
      delete s[Hb], delete s[fv], delete s[i_], delete s[a_], delete s[fC];
    }
    function o_(s, u) {
      u[Hb] = s;
    }
    function mS(s, u) {
      u[hp] = s;
    }
    function $b(s) {
      s[hp] = null;
    }
    function pv(s) {
      return !!s[hp];
    }
    function hv(s) {
      var u = s[Hb];
      if (u) return u;
      for (var v = s.parentNode; v;) {
        if (u = v[hp] || v[Hb], u) {
          var _ = u.alternate;
          if (u.child !== null || _ !== null && _.child !== null) for (var n = yD(s); n !== null;) {
            var a = n[Hb];
            if (a) return a;
            n = yD(n);
          }
          return u;
        }
        s = v, v = s.parentNode;
      }
      return null;
    }
    function Nc(s) {
      var u = s[Hb] || s[hp];
      return u && (u.tag === D || u.tag === I || u.tag === V || u.tag === C) ? u : null;
    }
    function zc(s) {
      if (s.tag === D || s.tag === I) return s.stateNode;
      throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function Ef(s) {
      return s[fv] || null;
    }
    function mv(s, u) {
      s[fv] = u;
    }
    function vS(s) {
      var u = s[i_];
      return u === void 0 && (u = s[i_] = /* @__PURE__ */new Set()), u;
    }
    var gS = {},
      wD = i.ReactDebugCurrentFrame;
    function s_(s) {
      if (s) {
        var u = s._owner,
          v = Ts(s.type, s._source, u ? u.type : null);
        wD.setExtraStackFrame(v);
      } else wD.setExtraStackFrame(null);
    }
    function Vc(s, u, v, _, n) {
      {
        var a = Function.call.bind(ye);
        for (var f in s) if (a(s, f)) {
          var m = void 0;
          try {
            if (typeof s[f] != "function") {
              var b = Error((_ || "React class") + ": " + v + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
              throw b.name = "Invariant Violation", b;
            }
            m = s[f](u, f, _, v, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
          } catch (T) {
            m = T;
          }
          m && !(m instanceof Error) && (s_(n), h("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", _ || "React class", v, f, typeof m), s_(null)), m instanceof Error && !(m.message in gS) && (gS[m.message] = !0, s_(n), h("Failed %s type: %s", v, m.message), s_(null));
        }
      }
    }
    var Wb = [],
      hu;
    hu = [];
    var Cf = -1;
    function kf(s) {
      return {
        current: s
      };
    }
    function ca(s, u) {
      if (Cf < 0) {
        h("Unexpected pop.");
        return;
      }
      u !== hu[Cf] && h("Unexpected Fiber popped."), s.current = Wb[Cf], Wb[Cf] = null, hu[Cf] = null, Cf--;
    }
    function ka(s, u, v) {
      Cf++, Wb[Cf] = s.current, hu[Cf] = v, s.current = u;
    }
    var fs;
    fs = {};
    var fi = {};
    Object.freeze(fi);
    var Tf = kf(fi),
      La = kf(!1),
      Rf = fi;
    function Jl(s, u, v) {
      return v && eu(u) ? Rf : Tf.current;
    }
    function yS(s, u, v) {
      {
        var _ = s.stateNode;
        _.__reactInternalMemoizedUnmaskedChildContext = u, _.__reactInternalMemoizedMaskedChildContext = v;
      }
    }
    function Df(s, u) {
      {
        var v = s.type,
          _ = v.contextTypes;
        if (!_) return fi;
        var n = s.stateNode;
        if (n && n.__reactInternalMemoizedUnmaskedChildContext === u) return n.__reactInternalMemoizedMaskedChildContext;
        var a = {};
        for (var f in _) a[f] = u[f];
        {
          var m = At(s) || "Unknown";
          Vc(_, a, "context", m);
        }
        return n && yS(s, u, a), a;
      }
    }
    function l_() {
      return La.current;
    }
    function eu(s) {
      {
        var u = s.childContextTypes;
        return u != null;
      }
    }
    function by(s) {
      ca(La, s), ca(Tf, s);
    }
    function Bc(s) {
      ca(La, s), ca(Tf, s);
    }
    function u_(s, u, v) {
      {
        if (Tf.current !== fi) throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        ka(Tf, u, s), ka(La, v, s);
      }
    }
    function bS(s, u, v) {
      {
        var _ = s.stateNode,
          n = u.childContextTypes;
        if (typeof _.getChildContext != "function") {
          {
            var a = At(s) || "Unknown";
            fs[a] || (fs[a] = !0, h("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", a, a));
          }
          return v;
        }
        var f = _.getChildContext();
        for (var m in f) if (!(m in n)) throw new Error((At(s) || "Unknown") + '.getChildContext(): key "' + m + '" is not defined in childContextTypes.');
        {
          var b = At(s) || "Unknown";
          Vc(n, f, "child context", b);
        }
        return Qt({}, v, f);
      }
    }
    function c_(s) {
      {
        var u = s.stateNode,
          v = u && u.__reactInternalMemoizedMergedChildContext || fi;
        return Rf = Tf.current, ka(Tf, v, s), ka(La, La.current, s), !0;
      }
    }
    function pC(s, u, v) {
      {
        var _ = s.stateNode;
        if (!_) throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (v) {
          var n = bS(s, u, Rf);
          _.__reactInternalMemoizedMergedChildContext = n, ca(La, s), ca(Tf, s), ka(Tf, n, s), ka(La, v, s);
        } else ca(La, s), ka(La, v, s);
      }
    }
    function wS(s) {
      {
        if (!Ns(s) || s.tag !== x) throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var u = s;
        do {
          switch (u.tag) {
            case C:
              return u.stateNode.context;
            case x:
              {
                var v = u.type;
                if (eu(v)) return u.stateNode.__reactInternalMemoizedMergedChildContext;
                break;
              }
          }
          u = u.return;
        } while (u !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var lm = 0,
      _S = 1,
      fl = null,
      qb = !1,
      If = !1;
    function xS(s) {
      fl === null ? fl = [s] : fl.push(s);
    }
    function hC(s) {
      qb = !0, xS(s);
    }
    function mC() {
      qb && vv();
    }
    function vv() {
      if (!If && fl !== null) {
        If = !0;
        var s = 0,
          u = Ir();
        try {
          var v = !0,
            _ = fl;
          for (zr(as); s < _.length; s++) {
            var n = _[s];
            do n = n(v); while (n !== null);
          }
          fl = null, qb = !1;
        } catch (a) {
          throw fl !== null && (fl = fl.slice(s + 1)), Ch(Xu, vv), a;
        } finally {
          zr(u), If = !1;
        }
      }
      return null;
    }
    var wy = [],
      bc = 0,
      um = null,
      cm = 0,
      tu = [],
      nu = 0,
      ps = null,
      Co = 1,
      ru = "";
    function dm(s) {
      return xy(), (s.flags & va) !== pt;
    }
    function fm(s) {
      return xy(), cm;
    }
    function SP() {
      var s = ru,
        u = Co,
        v = u & ~vC(u);
      return v.toString(32) + s;
    }
    function _y(s, u) {
      xy(), wy[bc++] = cm, wy[bc++] = um, um = s, cm = u;
    }
    function _D(s, u, v) {
      xy(), tu[nu++] = Co, tu[nu++] = ru, tu[nu++] = ps, ps = s;
      var _ = Co,
        n = ru,
        a = d_(_) - 1,
        f = _ & ~(1 << a),
        m = v + 1,
        b = d_(u) + a;
      if (b > 30) {
        var T = a - a % 5,
          M = (1 << T) - 1,
          z = (f & M).toString(32),
          U = f >> T,
          X = a - T,
          J = d_(u) + X,
          me = m << X,
          Se = me | U,
          Me = z + n;
        Co = 1 << J | Se, ru = Me;
      } else {
        var Pe = m << a,
          $e = Pe | f,
          mt = n;
        Co = 1 << b | $e, ru = mt;
      }
    }
    function pm(s) {
      xy();
      var u = s.return;
      if (u !== null) {
        var v = 1,
          _ = 0;
        _y(s, v), _D(s, v, _);
      }
    }
    function d_(s) {
      return 32 - Mn(s);
    }
    function vC(s) {
      return 1 << d_(s) - 1;
    }
    function Yb(s) {
      for (; s === um;) um = wy[--bc], wy[bc] = null, cm = wy[--bc], wy[bc] = null;
      for (; s === ps;) ps = tu[--nu], tu[nu] = null, ru = tu[--nu], tu[nu] = null, Co = tu[--nu], tu[nu] = null;
    }
    function EP() {
      return xy(), ps !== null ? {
        id: Co,
        overflow: ru
      } : null;
    }
    function gC(s, u) {
      xy(), tu[nu++] = Co, tu[nu++] = ru, tu[nu++] = ps, Co = u.id, ru = u.overflow, ps = s;
    }
    function xy() {
      Pa() || h("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var el = null,
      hs = null,
      Ai = !1,
      ms = !1,
      vs = null;
    function Sy() {
      Ai && h("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function hm() {
      ms = !0;
    }
    function CP() {
      return ms;
    }
    function xD(s) {
      var u = s.stateNode.containerInfo;
      return hs = r_(u), el = s, Ai = !0, vs = null, ms = !1, !0;
    }
    function kP(s, u, v) {
      return hs = nP(u), el = s, Ai = !0, vs = null, ms = !1, v !== null && gC(s, v), !0;
    }
    function SD(s, u) {
      switch (s.tag) {
        case C:
          {
            dP(s.stateNode.containerInfo, u);
            break;
          }
        case D:
          {
            var v = (s.mode & Wt) !== dt;
            pP(s.type, s.memoizedProps, s.stateNode, u,
            // TODO: Delete this argument when we remove the legacy root API.
            v);
            break;
          }
        case V:
          {
            var _ = s.memoizedState;
            _.dehydrated !== null && fP(_.dehydrated, u);
            break;
          }
      }
    }
    function ED(s, u) {
      SD(s, u);
      var v = VA();
      v.stateNode = u, v.return = s;
      var _ = s.deletions;
      _ === null ? (s.deletions = [v], s.flags |= _i) : _.push(v);
    }
    function SS(s, u) {
      {
        if (ms) return;
        switch (s.tag) {
          case C:
            {
              var v = s.stateNode.containerInfo;
              switch (u.tag) {
                case D:
                  var _ = u.type;
                  u.pendingProps, hP(v, _);
                  break;
                case I:
                  var n = u.pendingProps;
                  mP(v, n);
                  break;
              }
              break;
            }
          case D:
            {
              var a = s.type,
                f = s.memoizedProps,
                m = s.stateNode;
              switch (u.tag) {
                case D:
                  {
                    var b = u.type,
                      T = u.pendingProps,
                      M = (s.mode & Wt) !== dt;
                    yP(a, f, m, b, T,
                    // TODO: Delete this argument when we remove the legacy root API.
                    M);
                    break;
                  }
                case I:
                  {
                    var z = u.pendingProps,
                      U = (s.mode & Wt) !== dt;
                    bP(a, f, m, z,
                    // TODO: Delete this argument when we remove the legacy root API.
                    U);
                    break;
                  }
              }
              break;
            }
          case V:
            {
              var X = s.memoizedState,
                J = X.dehydrated;
              if (J !== null) switch (u.tag) {
                case D:
                  var me = u.type;
                  u.pendingProps, vP(J, me);
                  break;
                case I:
                  var Se = u.pendingProps;
                  gP(J, Se);
                  break;
              }
              break;
            }
          default:
            return;
        }
      }
    }
    function yC(s, u) {
      u.flags = u.flags & -4097 | Gn, SS(s, u);
    }
    function ES(s, u) {
      switch (s.tag) {
        case D:
          {
            var v = s.type;
            s.pendingProps;
            var _ = JL(u, v);
            return _ !== null ? (s.stateNode = _, el = s, hs = hS(_), !0) : !1;
          }
        case I:
          {
            var n = s.pendingProps,
              a = eP(u, n);
            return a !== null ? (s.stateNode = a, el = s, hs = null, !0) : !1;
          }
        case V:
          {
            var f = tP(u);
            if (f !== null) {
              var m = {
                dehydrated: f,
                treeContext: EP(),
                retryLane: Jr
              };
              s.memoizedState = m;
              var b = BA(f);
              return b.return = s, s.child = b, el = s, hs = null, !0;
            }
            return !1;
          }
        default:
          return !1;
      }
    }
    function CS(s) {
      return (s.mode & Wt) !== dt && (s.flags & ft) === pt;
    }
    function kS(s) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function f_(s) {
      if (Ai) {
        var u = hs;
        if (!u) {
          CS(s) && (SS(el, s), kS()), yC(el, s), Ai = !1, el = s;
          return;
        }
        var v = u;
        if (!ES(s, u)) {
          CS(s) && (SS(el, s), kS()), u = n_(v);
          var _ = el;
          if (!u || !ES(s, u)) {
            yC(el, s), Ai = !1, el = s;
            return;
          }
          ED(_, v);
        }
      }
    }
    function bC(s, u, v) {
      var _ = s.stateNode,
        n = !ms,
        a = rP(_, s.type, s.memoizedProps, u, v, s, n);
      return s.updateQueue = a, a !== null;
    }
    function wC(s) {
      var u = s.stateNode,
        v = s.memoizedProps,
        _ = iP(u, v, s);
      if (_) {
        var n = el;
        if (n !== null) switch (n.tag) {
          case C:
            {
              var a = n.stateNode.containerInfo,
                f = (n.mode & Wt) !== dt;
              uP(a, u, v,
              // TODO: Delete this argument when we remove the legacy root API.
              f);
              break;
            }
          case D:
            {
              var m = n.type,
                b = n.memoizedProps,
                T = n.stateNode,
                M = (n.mode & Wt) !== dt;
              cP(m, b, T, u, v,
              // TODO: Delete this argument when we remove the legacy root API.
              M);
              break;
            }
        }
      }
      return _;
    }
    function TP(s) {
      var u = s.memoizedState,
        v = u !== null ? u.dehydrated : null;
      if (!v) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      aP(v, s);
    }
    function RP(s) {
      var u = s.memoizedState,
        v = u !== null ? u.dehydrated : null;
      if (!v) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return oP(v);
    }
    function CD(s) {
      for (var u = s.return; u !== null && u.tag !== D && u.tag !== C && u.tag !== V;) u = u.return;
      el = u;
    }
    function TS(s) {
      if (s !== el) return !1;
      if (!Ai) return CD(s), Ai = !0, !1;
      if (s.tag !== C && (s.tag !== D || lP(s.type) && !iC(s.type, s.memoizedProps))) {
        var u = hs;
        if (u) if (CS(s)) p_(s), kS();else for (; u;) ED(s, u), u = n_(u);
      }
      return CD(s), s.tag === V ? hs = RP(s) : hs = el ? n_(s.stateNode) : null, !0;
    }
    function kD() {
      return Ai && hs !== null;
    }
    function p_(s) {
      for (var u = hs; u;) SD(s, u), u = n_(u);
    }
    function Gb() {
      el = null, hs = null, Ai = !1, ms = !1;
    }
    function _C() {
      vs !== null && (_I(vs), vs = null);
    }
    function Pa() {
      return Ai;
    }
    function RS(s) {
      vs === null ? vs = [s] : vs.push(s);
    }
    var tl = i.ReactCurrentBatchConfig,
      xC = null;
    function DP() {
      return tl.transition;
    }
    var Mf = {
      recordUnsafeLifecycleWarnings: function (s, u) {},
      flushPendingUnsafeLifecycleWarnings: function () {},
      recordLegacyContextWarning: function (s, u) {},
      flushLegacyContextWarning: function () {},
      discardPendingWarnings: function () {}
    };
    {
      var IP = function (s) {
          for (var u = null, v = s; v !== null;) v.mode & Xn && (u = v), v = v.return;
          return u;
        },
        nl = function (s) {
          var u = [];
          return s.forEach(function (v) {
            u.push(v);
          }), u.sort().join(", ");
        },
        h_ = [],
        Of = [],
        mm = [],
        vm = [],
        gm = [],
        ym = [],
        Lf = /* @__PURE__ */new Set();
      Mf.recordUnsafeLifecycleWarnings = function (s, u) {
        Lf.has(s.type) || (typeof u.componentWillMount == "function" &&
        // Don't warn about react-lifecycles-compat polyfilled components.
        u.componentWillMount.__suppressDeprecationWarning !== !0 && h_.push(s), s.mode & Xn && typeof u.UNSAFE_componentWillMount == "function" && Of.push(s), typeof u.componentWillReceiveProps == "function" && u.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && mm.push(s), s.mode & Xn && typeof u.UNSAFE_componentWillReceiveProps == "function" && vm.push(s), typeof u.componentWillUpdate == "function" && u.componentWillUpdate.__suppressDeprecationWarning !== !0 && gm.push(s), s.mode & Xn && typeof u.UNSAFE_componentWillUpdate == "function" && ym.push(s));
      }, Mf.flushPendingUnsafeLifecycleWarnings = function () {
        var s = /* @__PURE__ */new Set();
        h_.length > 0 && (h_.forEach(function (U) {
          s.add(At(U) || "Component"), Lf.add(U.type);
        }), h_ = []);
        var u = /* @__PURE__ */new Set();
        Of.length > 0 && (Of.forEach(function (U) {
          u.add(At(U) || "Component"), Lf.add(U.type);
        }), Of = []);
        var v = /* @__PURE__ */new Set();
        mm.length > 0 && (mm.forEach(function (U) {
          v.add(At(U) || "Component"), Lf.add(U.type);
        }), mm = []);
        var _ = /* @__PURE__ */new Set();
        vm.length > 0 && (vm.forEach(function (U) {
          _.add(At(U) || "Component"), Lf.add(U.type);
        }), vm = []);
        var n = /* @__PURE__ */new Set();
        gm.length > 0 && (gm.forEach(function (U) {
          n.add(At(U) || "Component"), Lf.add(U.type);
        }), gm = []);
        var a = /* @__PURE__ */new Set();
        if (ym.length > 0 && (ym.forEach(function (U) {
          a.add(At(U) || "Component"), Lf.add(U.type);
        }), ym = []), u.size > 0) {
          var f = nl(u);
          h(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, f);
        }
        if (_.size > 0) {
          var m = nl(_);
          h(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, m);
        }
        if (a.size > 0) {
          var b = nl(a);
          h(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, b);
        }
        if (s.size > 0) {
          var T = nl(s);
          p(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, T);
        }
        if (v.size > 0) {
          var M = nl(v);
          p(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, M);
        }
        if (n.size > 0) {
          var z = nl(n);
          p(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, z);
        }
      };
      var gv = /* @__PURE__ */new Map(),
        yv = /* @__PURE__ */new Set();
      Mf.recordLegacyContextWarning = function (s, u) {
        var v = IP(s);
        if (v === null) {
          h("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!yv.has(s.type)) {
          var _ = gv.get(v);
          (s.type.contextTypes != null || s.type.childContextTypes != null || u !== null && typeof u.getChildContext == "function") && (_ === void 0 && (_ = [], gv.set(v, _)), _.push(s));
        }
      }, Mf.flushLegacyContextWarning = function () {
        gv.forEach(function (s, u) {
          if (s.length !== 0) {
            var v = s[0],
              _ = /* @__PURE__ */new Set();
            s.forEach(function (a) {
              _.add(At(a) || "Component"), yv.add(a.type);
            });
            var n = nl(_);
            try {
              Rn(v), h(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, n);
            } finally {
              Un();
            }
          }
        });
      }, Mf.discardPendingWarnings = function () {
        h_ = [], Of = [], mm = [], vm = [], gm = [], ym = [], gv = /* @__PURE__ */new Map();
      };
    }
    function mu(s, u) {
      if (s && s.defaultProps) {
        var v = Qt({}, u),
          _ = s.defaultProps;
        for (var n in _) v[n] === void 0 && (v[n] = _[n]);
        return v;
      }
      return u;
    }
    var DS = kf(null),
      wc;
    wc = {};
    var Xb = null,
      bv = null,
      Kb = null,
      bm = !1;
    function Qb() {
      Xb = null, bv = null, Kb = null, bm = !1;
    }
    function m_() {
      bm = !0;
    }
    function v_() {
      bm = !1;
    }
    function SC(s, u, v) {
      ka(DS, u._currentValue, s), u._currentValue = v, u._currentRenderer !== void 0 && u._currentRenderer !== null && u._currentRenderer !== wc && h("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), u._currentRenderer = wc;
    }
    function IS(s, u) {
      var v = DS.current;
      ca(DS, u), s._currentValue = v;
    }
    function MS(s, u, v) {
      for (var _ = s; _ !== null;) {
        var n = _.alternate;
        if ($s(_.childLanes, u) ? n !== null && !$s(n.childLanes, u) && (n.childLanes = jt(n.childLanes, u)) : (_.childLanes = jt(_.childLanes, u), n !== null && (n.childLanes = jt(n.childLanes, u))), _ === v) break;
        _ = _.return;
      }
      _ !== v && h("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function EC(s, u, v) {
      CC(s, u, v);
    }
    function CC(s, u, v) {
      var _ = s.child;
      for (_ !== null && (_.return = s); _ !== null;) {
        var n = void 0,
          a = _.dependencies;
        if (a !== null) {
          n = _.child;
          for (var f = a.firstContext; f !== null;) {
            if (f.context === u) {
              if (_.tag === x) {
                var m = Xl(v),
                  b = Pf(wn, m);
                b.tag = y_;
                var T = _.updateQueue;
                if (T !== null) {
                  var M = T.shared,
                    z = M.pending;
                  z === null ? b.next = b : (b.next = z.next, z.next = b), M.pending = b;
                }
              }
              _.lanes = jt(_.lanes, v);
              var U = _.alternate;
              U !== null && (U.lanes = jt(U.lanes, v)), MS(_.return, v, s), a.lanes = jt(a.lanes, v);
              break;
            }
            f = f.next;
          }
        } else if (_.tag === L) n = _.type === s.type ? null : _.child;else if (_.tag === ie) {
          var X = _.return;
          if (X === null) throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          X.lanes = jt(X.lanes, v);
          var J = X.alternate;
          J !== null && (J.lanes = jt(J.lanes, v)), MS(X, v, s), n = _.sibling;
        } else n = _.child;
        if (n !== null) n.return = _;else for (n = _; n !== null;) {
          if (n === s) {
            n = null;
            break;
          }
          var me = n.sibling;
          if (me !== null) {
            me.return = n.return, n = me;
            break;
          }
          n = n.return;
        }
        _ = n;
      }
    }
    function Zb(s, u) {
      Xb = s, bv = null, Kb = null;
      var v = s.dependencies;
      if (v !== null) {
        var _ = v.firstContext;
        _ !== null && (_n(v.lanes, u) && x0(), v.firstContext = null);
      }
    }
    function ko(s) {
      bm && h("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var u = s._currentValue;
      if (Kb !== s) {
        var v = {
          context: s,
          memoizedValue: u,
          next: null
        };
        if (bv === null) {
          if (Xb === null) throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          bv = v, Xb.dependencies = {
            lanes: De,
            firstContext: v
          };
        } else bv = bv.next = v;
      }
      return u;
    }
    var Uc = null;
    function Aa(s) {
      Uc === null ? Uc = [s] : Uc.push(s);
    }
    function Ey() {
      if (Uc !== null) {
        for (var s = 0; s < Uc.length; s++) {
          var u = Uc[s],
            v = u.interleaved;
          if (v !== null) {
            u.interleaved = null;
            var _ = v.next,
              n = u.pending;
            if (n !== null) {
              var a = n.next;
              n.next = _, v.next = a;
            }
            u.pending = v;
          }
        }
        Uc = null;
      }
    }
    function OS(s, u, v, _) {
      var n = u.interleaved;
      return n === null ? (v.next = v, Aa(u)) : (v.next = n.next, n.next = v), u.interleaved = v, rl(s, _);
    }
    function MP(s, u, v, _) {
      var n = u.interleaved;
      n === null ? (v.next = v, Aa(u)) : (v.next = n.next, n.next = v), u.interleaved = v;
    }
    function TD(s, u, v, _) {
      var n = u.interleaved;
      return n === null ? (v.next = v, Aa(u)) : (v.next = n.next, n.next = v), u.interleaved = v, rl(s, _);
    }
    function vu(s, u) {
      return rl(s, u);
    }
    var OP = rl;
    function rl(s, u) {
      s.lanes = jt(s.lanes, u);
      var v = s.alternate;
      v !== null && (v.lanes = jt(v.lanes, u)), v === null && (s.flags & (Gn | xi)) !== pt && OI(s);
      for (var _ = s, n = s.return; n !== null;) n.childLanes = jt(n.childLanes, u), v = n.alternate, v !== null ? v.childLanes = jt(v.childLanes, u) : (n.flags & (Gn | xi)) !== pt && OI(s), _ = n, n = n.return;
      if (_.tag === C) {
        var a = _.stateNode;
        return a;
      } else return null;
    }
    var RD = 0,
      g_ = 1,
      y_ = 2,
      LS = 3,
      Cy = !1,
      b_,
      ky;
    b_ = !1, ky = null;
    function w_(s) {
      var u = {
        baseState: s.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: De
        },
        effects: null
      };
      s.updateQueue = u;
    }
    function __(s, u) {
      var v = u.updateQueue,
        _ = s.updateQueue;
      if (v === _) {
        var n = {
          baseState: _.baseState,
          firstBaseUpdate: _.firstBaseUpdate,
          lastBaseUpdate: _.lastBaseUpdate,
          shared: _.shared,
          effects: _.effects
        };
        u.updateQueue = n;
      }
    }
    function Pf(s, u) {
      var v = {
        eventTime: s,
        lane: u,
        tag: RD,
        payload: null,
        callback: null,
        next: null
      };
      return v;
    }
    function wm(s, u, v) {
      var _ = s.updateQueue;
      if (_ === null) return null;
      var n = _.shared;
      if (ky === n && !b_ && (h("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), b_ = !0), jv()) {
        var a = n.pending;
        return a === null ? u.next = u : (u.next = a.next, a.next = u), n.pending = u, OP(s, v);
      } else return TD(s, n, u, v);
    }
    function Hc(s, u, v) {
      var _ = u.updateQueue;
      if (_ !== null) {
        var n = _.shared;
        if (zh(v)) {
          var a = n.lanes;
          a = Bh(a, s.pendingLanes);
          var f = jt(a, v);
          n.lanes = f, cf(s, f);
        }
      }
    }
    function mp(s, u) {
      var v = s.updateQueue,
        _ = s.alternate;
      if (_ !== null) {
        var n = _.updateQueue;
        if (v === n) {
          var a = null,
            f = null,
            m = v.firstBaseUpdate;
          if (m !== null) {
            var b = m;
            do {
              var T = {
                eventTime: b.eventTime,
                lane: b.lane,
                tag: b.tag,
                payload: b.payload,
                callback: b.callback,
                next: null
              };
              f === null ? a = f = T : (f.next = T, f = T), b = b.next;
            } while (b !== null);
            f === null ? a = f = u : (f.next = u, f = u);
          } else a = f = u;
          v = {
            baseState: n.baseState,
            firstBaseUpdate: a,
            lastBaseUpdate: f,
            shared: n.shared,
            effects: n.effects
          }, s.updateQueue = v;
          return;
        }
      }
      var M = v.lastBaseUpdate;
      M === null ? v.firstBaseUpdate = u : M.next = u, v.lastBaseUpdate = u;
    }
    function PS(s, u, v, _, n, a) {
      switch (v.tag) {
        case g_:
          {
            var f = v.payload;
            if (typeof f == "function") {
              m_();
              var m = f.call(a, _, n);
              {
                if (s.mode & Xn) {
                  En(!0);
                  try {
                    f.call(a, _, n);
                  } finally {
                    En(!1);
                  }
                }
                v_();
              }
              return m;
            }
            return f;
          }
        case LS:
          s.flags = s.flags & -65537 | ft;
        // Intentional fallthrough
        case RD:
          {
            var b = v.payload,
              T;
            if (typeof b == "function") {
              m_(), T = b.call(a, _, n);
              {
                if (s.mode & Xn) {
                  En(!0);
                  try {
                    b.call(a, _, n);
                  } finally {
                    En(!1);
                  }
                }
                v_();
              }
            } else T = b;
            return T == null ? _ : Qt({}, _, T);
          }
        case y_:
          return Cy = !0, _;
      }
      return _;
    }
    function Jb(s, u, v, _) {
      var n = s.updateQueue;
      Cy = !1, ky = n.shared;
      var a = n.firstBaseUpdate,
        f = n.lastBaseUpdate,
        m = n.shared.pending;
      if (m !== null) {
        n.shared.pending = null;
        var b = m,
          T = b.next;
        b.next = null, f === null ? a = T : f.next = T, f = b;
        var M = s.alternate;
        if (M !== null) {
          var z = M.updateQueue,
            U = z.lastBaseUpdate;
          U !== f && (U === null ? z.firstBaseUpdate = T : U.next = T, z.lastBaseUpdate = b);
        }
      }
      if (a !== null) {
        var X = n.baseState,
          J = De,
          me = null,
          Se = null,
          Me = null,
          Pe = a;
        do {
          var $e = Pe.lane,
            mt = Pe.eventTime;
          if ($s(_, $e)) {
            if (Me !== null) {
              var Re = {
                eventTime: mt,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: On,
                tag: Pe.tag,
                payload: Pe.payload,
                callback: Pe.callback,
                next: null
              };
              Me = Me.next = Re;
            }
            X = PS(s, n, Pe, X, u, v);
            var Ue = Pe.callback;
            if (Ue !== null &&
            // If the update was already committed, we should not queue its
            // callback again.
            Pe.lane !== On) {
              s.flags |= Sn;
              var Be = n.effects;
              Be === null ? n.effects = [Pe] : Be.push(Pe);
            }
          } else {
            var nt = {
              eventTime: mt,
              lane: $e,
              tag: Pe.tag,
              payload: Pe.payload,
              callback: Pe.callback,
              next: null
            };
            Me === null ? (Se = Me = nt, me = X) : Me = Me.next = nt, J = jt(J, $e);
          }
          if (Pe = Pe.next, Pe === null) {
            if (m = n.shared.pending, m === null) break;
            var ke = m,
              Fe = ke.next;
            ke.next = null, Pe = Fe, n.lastBaseUpdate = ke, n.shared.pending = null;
          }
        } while (!0);
        Me === null && (me = X), n.baseState = me, n.firstBaseUpdate = Se, n.lastBaseUpdate = Me;
        var Ie = n.shared.interleaved;
        if (Ie !== null) {
          var Qe = Ie;
          do J = jt(J, Qe.lane), Qe = Qe.next; while (Qe !== Ie);
        } else a === null && (n.shared.lanes = De);
        L0(J), s.lanes = J, s.memoizedState = X;
      }
      ky = null;
    }
    function LP(s, u) {
      if (typeof s != "function") throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + s));
      s.call(u);
    }
    function x_() {
      Cy = !1;
    }
    function AS() {
      return Cy;
    }
    function kC(s, u, v) {
      var _ = u.effects;
      if (u.effects = null, _ !== null) for (var n = 0; n < _.length; n++) {
        var a = _[n],
          f = a.callback;
        f !== null && (a.callback = null, LP(f, v));
      }
    }
    var e0 = {},
      TC = new t.Component().refs,
      S_,
      jS,
      E_,
      C_,
      k_,
      FS,
      t0,
      NS,
      n0,
      T_;
    {
      S_ = /* @__PURE__ */new Set(), jS = /* @__PURE__ */new Set(), E_ = /* @__PURE__ */new Set(), C_ = /* @__PURE__ */new Set(), NS = /* @__PURE__ */new Set(), k_ = /* @__PURE__ */new Set(), n0 = /* @__PURE__ */new Set(), T_ = /* @__PURE__ */new Set();
      var zS = /* @__PURE__ */new Set();
      t0 = function (s, u) {
        if (!(s === null || typeof s == "function")) {
          var v = u + "_" + s;
          zS.has(v) || (zS.add(v), h("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", u, s));
        }
      }, FS = function (s, u) {
        if (u === void 0) {
          var v = bn(s) || "Component";
          k_.has(v) || (k_.add(v), h("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", v));
        }
      }, Object.defineProperty(e0, "_processChildContext", {
        enumerable: !1,
        value: function () {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(e0);
    }
    function R_(s, u, v, _) {
      var n = s.memoizedState,
        a = v(_, n);
      {
        if (s.mode & Xn) {
          En(!0);
          try {
            a = v(_, n);
          } finally {
            En(!1);
          }
        }
        FS(u, a);
      }
      var f = a == null ? n : Qt({}, n, a);
      if (s.memoizedState = f, s.lanes === De) {
        var m = s.updateQueue;
        m.baseState = f;
      }
    }
    var VS = {
      isMounted: jg,
      enqueueSetState: function (s, u, v) {
        var _ = Pl(s),
          n = es(),
          a = Jf(_),
          f = Pf(n, a);
        f.payload = u, v != null && (t0(v, "setState"), f.callback = v);
        var m = wm(_, f, a);
        m !== null && (Ba(m, _, a, n), Hc(m, _, a)), Bs(_, a);
      },
      enqueueReplaceState: function (s, u, v) {
        var _ = Pl(s),
          n = es(),
          a = Jf(_),
          f = Pf(n, a);
        f.tag = g_, f.payload = u, v != null && (t0(v, "replaceState"), f.callback = v);
        var m = wm(_, f, a);
        m !== null && (Ba(m, _, a, n), Hc(m, _, a)), Bs(_, a);
      },
      enqueueForceUpdate: function (s, u) {
        var v = Pl(s),
          _ = es(),
          n = Jf(v),
          a = Pf(_, n);
        a.tag = y_, u != null && (t0(u, "forceUpdate"), a.callback = u);
        var f = wm(v, a, n);
        f !== null && (Ba(f, v, n, _), Hc(f, v, n)), Qu(v, n);
      }
    };
    function BS(s, u, v, _, n, a, f) {
      var m = s.stateNode;
      if (typeof m.shouldComponentUpdate == "function") {
        var b = m.shouldComponentUpdate(_, a, f);
        {
          if (s.mode & Xn) {
            En(!0);
            try {
              b = m.shouldComponentUpdate(_, a, f);
            } finally {
              En(!1);
            }
          }
          b === void 0 && h("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", bn(u) || "Component");
        }
        return b;
      }
      return u.prototype && u.prototype.isPureReactComponent ? !he(v, _) || !he(n, a) : !0;
    }
    function RC(s, u, v) {
      var _ = s.stateNode;
      {
        var n = bn(u) || "Component",
          a = _.render;
        a || (u.prototype && typeof u.prototype.render == "function" ? h("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", n) : h("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", n)), _.getInitialState && !_.getInitialState.isReactClassApproved && !_.state && h("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", n), _.getDefaultProps && !_.getDefaultProps.isReactClassApproved && h("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", n), _.propTypes && h("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", n), _.contextType && h("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", n), _.contextTypes && h("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", n), u.contextType && u.contextTypes && !n0.has(u) && (n0.add(u), h("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", n)), typeof _.componentShouldUpdate == "function" && h("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", n), u.prototype && u.prototype.isPureReactComponent && typeof _.shouldComponentUpdate < "u" && h("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", bn(u) || "A pure component"), typeof _.componentDidUnmount == "function" && h("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", n), typeof _.componentDidReceiveProps == "function" && h("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", n), typeof _.componentWillRecieveProps == "function" && h("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", n), typeof _.UNSAFE_componentWillRecieveProps == "function" && h("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", n);
        var f = _.props !== v;
        _.props !== void 0 && f && h("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", n, n), _.defaultProps && h("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", n, n), typeof _.getSnapshotBeforeUpdate == "function" && typeof _.componentDidUpdate != "function" && !E_.has(u) && (E_.add(u), h("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", bn(u))), typeof _.getDerivedStateFromProps == "function" && h("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", n), typeof _.getDerivedStateFromError == "function" && h("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", n), typeof u.getSnapshotBeforeUpdate == "function" && h("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", n);
        var m = _.state;
        m && (typeof m != "object" || wr(m)) && h("%s.state: must be set to an object or null", n), typeof _.getChildContext == "function" && typeof u.childContextTypes != "object" && h("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", n);
      }
    }
    function DC(s, u) {
      u.updater = VS, s.stateNode = u, Fs(u, s), u._reactInternalInstance = e0;
    }
    function DD(s, u, v) {
      var _ = !1,
        n = fi,
        a = fi,
        f = u.contextType;
      if ("contextType" in u) {
        var m =
        // Allow null for conditional declaration
        f === null || f !== void 0 && f.$$typeof === Ne && f._context === void 0;
        if (!m && !T_.has(u)) {
          T_.add(u);
          var b = "";
          f === void 0 ? b = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof f != "object" ? b = " However, it is set to a " + typeof f + "." : f.$$typeof === Z ? b = " Did you accidentally pass the Context.Provider instead?" : f._context !== void 0 ? b = " Did you accidentally pass the Context.Consumer instead?" : b = " However, it is set to an object with keys {" + Object.keys(f).join(", ") + "}.", h("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", bn(u) || "Component", b);
        }
      }
      if (typeof f == "object" && f !== null) a = ko(f);else {
        n = Jl(s, u, !0);
        var T = u.contextTypes;
        _ = T != null, a = _ ? Df(s, n) : fi;
      }
      var M = new u(v, a);
      if (s.mode & Xn) {
        En(!0);
        try {
          M = new u(v, a);
        } finally {
          En(!1);
        }
      }
      var z = s.memoizedState = M.state !== null && M.state !== void 0 ? M.state : null;
      DC(s, M);
      {
        if (typeof u.getDerivedStateFromProps == "function" && z === null) {
          var U = bn(u) || "Component";
          jS.has(U) || (jS.add(U), h("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", U, M.state === null ? "null" : "undefined", U));
        }
        if (typeof u.getDerivedStateFromProps == "function" || typeof M.getSnapshotBeforeUpdate == "function") {
          var X = null,
            J = null,
            me = null;
          if (typeof M.componentWillMount == "function" && M.componentWillMount.__suppressDeprecationWarning !== !0 ? X = "componentWillMount" : typeof M.UNSAFE_componentWillMount == "function" && (X = "UNSAFE_componentWillMount"), typeof M.componentWillReceiveProps == "function" && M.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? J = "componentWillReceiveProps" : typeof M.UNSAFE_componentWillReceiveProps == "function" && (J = "UNSAFE_componentWillReceiveProps"), typeof M.componentWillUpdate == "function" && M.componentWillUpdate.__suppressDeprecationWarning !== !0 ? me = "componentWillUpdate" : typeof M.UNSAFE_componentWillUpdate == "function" && (me = "UNSAFE_componentWillUpdate"), X !== null || J !== null || me !== null) {
            var Se = bn(u) || "Component",
              Me = typeof u.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            C_.has(Se) || (C_.add(Se), h(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, Se, Me, X !== null ? `
  ` + X : "", J !== null ? `
  ` + J : "", me !== null ? `
  ` + me : ""));
          }
        }
      }
      return _ && yS(s, n, a), M;
    }
    function ID(s, u) {
      var v = u.state;
      typeof u.componentWillMount == "function" && u.componentWillMount(), typeof u.UNSAFE_componentWillMount == "function" && u.UNSAFE_componentWillMount(), v !== u.state && (h("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", At(s) || "Component"), VS.enqueueReplaceState(u, u.state, null));
    }
    function IC(s, u, v, _) {
      var n = u.state;
      if (typeof u.componentWillReceiveProps == "function" && u.componentWillReceiveProps(v, _), typeof u.UNSAFE_componentWillReceiveProps == "function" && u.UNSAFE_componentWillReceiveProps(v, _), u.state !== n) {
        {
          var a = At(s) || "Component";
          S_.has(a) || (S_.add(a), h("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", a));
        }
        VS.enqueueReplaceState(u, u.state, null);
      }
    }
    function MC(s, u, v, _) {
      RC(s, u, v);
      var n = s.stateNode;
      n.props = v, n.state = s.memoizedState, n.refs = TC, w_(s);
      var a = u.contextType;
      if (typeof a == "object" && a !== null) n.context = ko(a);else {
        var f = Jl(s, u, !0);
        n.context = Df(s, f);
      }
      {
        if (n.state === v) {
          var m = bn(u) || "Component";
          NS.has(m) || (NS.add(m), h("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", m));
        }
        s.mode & Xn && Mf.recordLegacyContextWarning(s, n), Mf.recordUnsafeLifecycleWarnings(s, n);
      }
      n.state = s.memoizedState;
      var b = u.getDerivedStateFromProps;
      if (typeof b == "function" && (R_(s, u, b, v), n.state = s.memoizedState), typeof u.getDerivedStateFromProps != "function" && typeof n.getSnapshotBeforeUpdate != "function" && (typeof n.UNSAFE_componentWillMount == "function" || typeof n.componentWillMount == "function") && (ID(s, n), Jb(s, v, n, _), n.state = s.memoizedState), typeof n.componentDidMount == "function") {
        var T = tn;
        T |= Za, (s.mode & Ri) !== dt && (T |= Bo), s.flags |= T;
      }
    }
    function MD(s, u, v, _) {
      var n = s.stateNode,
        a = s.memoizedProps;
      n.props = a;
      var f = n.context,
        m = u.contextType,
        b = fi;
      if (typeof m == "object" && m !== null) b = ko(m);else {
        var T = Jl(s, u, !0);
        b = Df(s, T);
      }
      var M = u.getDerivedStateFromProps,
        z = typeof M == "function" || typeof n.getSnapshotBeforeUpdate == "function";
      !z && (typeof n.UNSAFE_componentWillReceiveProps == "function" || typeof n.componentWillReceiveProps == "function") && (a !== v || f !== b) && IC(s, n, v, b), x_();
      var U = s.memoizedState,
        X = n.state = U;
      if (Jb(s, v, n, _), X = s.memoizedState, a === v && U === X && !l_() && !AS()) {
        if (typeof n.componentDidMount == "function") {
          var J = tn;
          J |= Za, (s.mode & Ri) !== dt && (J |= Bo), s.flags |= J;
        }
        return !1;
      }
      typeof M == "function" && (R_(s, u, M, v), X = s.memoizedState);
      var me = AS() || BS(s, u, a, v, U, X, b);
      if (me) {
        if (!z && (typeof n.UNSAFE_componentWillMount == "function" || typeof n.componentWillMount == "function") && (typeof n.componentWillMount == "function" && n.componentWillMount(), typeof n.UNSAFE_componentWillMount == "function" && n.UNSAFE_componentWillMount()), typeof n.componentDidMount == "function") {
          var Se = tn;
          Se |= Za, (s.mode & Ri) !== dt && (Se |= Bo), s.flags |= Se;
        }
      } else {
        if (typeof n.componentDidMount == "function") {
          var Me = tn;
          Me |= Za, (s.mode & Ri) !== dt && (Me |= Bo), s.flags |= Me;
        }
        s.memoizedProps = v, s.memoizedState = X;
      }
      return n.props = v, n.state = X, n.context = b, me;
    }
    function OC(s, u, v, _, n) {
      var a = u.stateNode;
      __(s, u);
      var f = u.memoizedProps,
        m = u.type === u.elementType ? f : mu(u.type, f);
      a.props = m;
      var b = u.pendingProps,
        T = a.context,
        M = v.contextType,
        z = fi;
      if (typeof M == "object" && M !== null) z = ko(M);else {
        var U = Jl(u, v, !0);
        z = Df(u, U);
      }
      var X = v.getDerivedStateFromProps,
        J = typeof X == "function" || typeof a.getSnapshotBeforeUpdate == "function";
      !J && (typeof a.UNSAFE_componentWillReceiveProps == "function" || typeof a.componentWillReceiveProps == "function") && (f !== b || T !== z) && IC(u, a, _, z), x_();
      var me = u.memoizedState,
        Se = a.state = me;
      if (Jb(u, _, a, n), Se = u.memoizedState, f === b && me === Se && !l_() && !AS()) return typeof a.componentDidUpdate == "function" && (f !== s.memoizedProps || me !== s.memoizedState) && (u.flags |= tn), typeof a.getSnapshotBeforeUpdate == "function" && (f !== s.memoizedProps || me !== s.memoizedState) && (u.flags |= or), !1;
      typeof X == "function" && (R_(u, v, X, _), Se = u.memoizedState);
      var Me = AS() || BS(u, v, m, _, me, Se, z) ||
      // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      le;
      return Me ? (!J && (typeof a.UNSAFE_componentWillUpdate == "function" || typeof a.componentWillUpdate == "function") && (typeof a.componentWillUpdate == "function" && a.componentWillUpdate(_, Se, z), typeof a.UNSAFE_componentWillUpdate == "function" && a.UNSAFE_componentWillUpdate(_, Se, z)), typeof a.componentDidUpdate == "function" && (u.flags |= tn), typeof a.getSnapshotBeforeUpdate == "function" && (u.flags |= or)) : (typeof a.componentDidUpdate == "function" && (f !== s.memoizedProps || me !== s.memoizedState) && (u.flags |= tn), typeof a.getSnapshotBeforeUpdate == "function" && (f !== s.memoizedProps || me !== s.memoizedState) && (u.flags |= or), u.memoizedProps = _, u.memoizedState = Se), a.props = _, a.state = Se, a.context = z, Me;
    }
    var LC,
      PC,
      D_,
      I_,
      M_,
      US = function (s, u) {};
    LC = !1, PC = !1, D_ = {}, I_ = {}, M_ = {}, US = function (s, u) {
      if (!(s === null || typeof s != "object") && !(!s._store || s._store.validated || s.key != null)) {
        if (typeof s._store != "object") throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        s._store.validated = !0;
        var v = At(u) || "Component";
        I_[v] || (I_[v] = !0, h('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function Ty(s, u, v) {
      var _ = v.ref;
      if (_ !== null && typeof _ != "function" && typeof _ != "object") {
        if ((s.mode & Xn || de) &&
        // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(v._owner && v._self && v._owner.stateNode !== v._self)) {
          var n = At(s) || "Component";
          D_[n] || (h('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', _), D_[n] = !0);
        }
        if (v._owner) {
          var a = v._owner,
            f;
          if (a) {
            var m = a;
            if (m.tag !== x) throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            f = m.stateNode;
          }
          if (!f) throw new Error("Missing owner for string ref " + _ + ". This error is likely caused by a bug in React. Please file an issue.");
          var b = f;
          gt(_, "ref");
          var T = "" + _;
          if (u !== null && u.ref !== null && typeof u.ref == "function" && u.ref._stringRef === T) return u.ref;
          var M = function (z) {
            var U = b.refs;
            U === TC && (U = b.refs = {}), z === null ? delete U[T] : U[T] = z;
          };
          return M._stringRef = T, M;
        } else {
          if (typeof _ != "string") throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!v._owner) throw new Error("Element ref was specified as a string (" + _ + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return _;
    }
    function O_(s, u) {
      var v = Object.prototype.toString.call(u);
      throw new Error("Objects are not valid as a React child (found: " + (v === "[object Object]" ? "object with keys {" + Object.keys(u).join(", ") + "}" : v) + "). If you meant to render a collection of children, use an array instead.");
    }
    function wv(s) {
      {
        var u = At(s) || "Component";
        if (M_[u]) return;
        M_[u] = !0, h("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function L_(s) {
      var u = s._payload,
        v = s._init;
      return v(u);
    }
    function P_(s) {
      function u(Re, Ue) {
        if (s) {
          var Be = Re.deletions;
          Be === null ? (Re.deletions = [Ue], Re.flags |= _i) : Be.push(Ue);
        }
      }
      function v(Re, Ue) {
        if (!s) return null;
        for (var Be = Ue; Be !== null;) u(Re, Be), Be = Be.sibling;
        return null;
      }
      function _(Re, Ue) {
        for (var Be = /* @__PURE__ */new Map(), nt = Ue; nt !== null;) nt.key !== null ? Be.set(nt.key, nt) : Be.set(nt.index, nt), nt = nt.sibling;
        return Be;
      }
      function n(Re, Ue) {
        var Be = ts(Re, Ue);
        return Be.index = 0, Be.sibling = null, Be;
      }
      function a(Re, Ue, Be) {
        if (Re.index = Be, !s) return Re.flags |= va, Ue;
        var nt = Re.alternate;
        if (nt !== null) {
          var ke = nt.index;
          return ke < Ue ? (Re.flags |= Gn, Ue) : ke;
        } else return Re.flags |= Gn, Ue;
      }
      function f(Re) {
        return s && Re.alternate === null && (Re.flags |= Gn), Re;
      }
      function m(Re, Ue, Be, nt) {
        if (Ue === null || Ue.tag !== I) {
          var ke = qk(Be, Re.mode, nt);
          return ke.return = Re, ke;
        } else {
          var Fe = n(Ue, Be);
          return Fe.return = Re, Fe;
        }
      }
      function b(Re, Ue, Be, nt) {
        var ke = Be.type;
        if (ke === Oo) return M(Re, Ue, Be.props.children, nt, Be.key);
        if (Ue !== null && (Ue.elementType === ke ||
        // Keep this check inline so it only runs on the false path:
        PI(Ue, Be) ||
        // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof ke == "object" && ke !== null && ke.$$typeof === Ct && L_(ke) === Ue.type)) {
          var Fe = n(Ue, Be.props);
          return Fe.ref = Ty(Re, Ue, Be), Fe.return = Re, Fe._debugSource = Be._source, Fe._debugOwner = Be._owner, Fe;
        }
        var Ie = Om(Be, Re.mode, nt);
        return Ie.ref = Ty(Re, Ue, Be), Ie.return = Re, Ie;
      }
      function T(Re, Ue, Be, nt) {
        if (Ue === null || Ue.tag !== k || Ue.stateNode.containerInfo !== Be.containerInfo || Ue.stateNode.implementation !== Be.implementation) {
          var ke = M1(Be, Re.mode, nt);
          return ke.return = Re, ke;
        } else {
          var Fe = n(Ue, Be.children || []);
          return Fe.return = Re, Fe;
        }
      }
      function M(Re, Ue, Be, nt, ke) {
        if (Ue === null || Ue.tag !== O) {
          var Fe = zv(Be, Re.mode, nt, ke);
          return Fe.return = Re, Fe;
        } else {
          var Ie = n(Ue, Be);
          return Ie.return = Re, Ie;
        }
      }
      function z(Re, Ue, Be) {
        if (typeof Ue == "string" && Ue !== "" || typeof Ue == "number") {
          var nt = qk("" + Ue, Re.mode, Be);
          return nt.return = Re, nt;
        }
        if (typeof Ue == "object" && Ue !== null) {
          switch (Ue.$$typeof) {
            case $i:
              {
                var ke = Om(Ue, Re.mode, Be);
                return ke.ref = Ty(Re, null, Ue), ke.return = Re, ke;
              }
            case oi:
              {
                var Fe = M1(Ue, Re.mode, Be);
                return Fe.return = Re, Fe;
              }
            case Ct:
              {
                var Ie = Ue._payload,
                  Qe = Ue._init;
                return z(Re, Qe(Ie), Be);
              }
          }
          if (wr(Ue) || yn(Ue)) {
            var Tt = zv(Ue, Re.mode, Be, null);
            return Tt.return = Re, Tt;
          }
          O_(Re, Ue);
        }
        return typeof Ue == "function" && wv(Re), null;
      }
      function U(Re, Ue, Be, nt) {
        var ke = Ue !== null ? Ue.key : null;
        if (typeof Be == "string" && Be !== "" || typeof Be == "number") return ke !== null ? null : m(Re, Ue, "" + Be, nt);
        if (typeof Be == "object" && Be !== null) {
          switch (Be.$$typeof) {
            case $i:
              return Be.key === ke ? b(Re, Ue, Be, nt) : null;
            case oi:
              return Be.key === ke ? T(Re, Ue, Be, nt) : null;
            case Ct:
              {
                var Fe = Be._payload,
                  Ie = Be._init;
                return U(Re, Ue, Ie(Fe), nt);
              }
          }
          if (wr(Be) || yn(Be)) return ke !== null ? null : M(Re, Ue, Be, nt, null);
          O_(Re, Be);
        }
        return typeof Be == "function" && wv(Re), null;
      }
      function X(Re, Ue, Be, nt, ke) {
        if (typeof nt == "string" && nt !== "" || typeof nt == "number") {
          var Fe = Re.get(Be) || null;
          return m(Ue, Fe, "" + nt, ke);
        }
        if (typeof nt == "object" && nt !== null) {
          switch (nt.$$typeof) {
            case $i:
              {
                var Ie = Re.get(nt.key === null ? Be : nt.key) || null;
                return b(Ue, Ie, nt, ke);
              }
            case oi:
              {
                var Qe = Re.get(nt.key === null ? Be : nt.key) || null;
                return T(Ue, Qe, nt, ke);
              }
            case Ct:
              var Tt = nt._payload,
                _t = nt._init;
              return X(Re, Ue, Be, _t(Tt), ke);
          }
          if (wr(nt) || yn(nt)) {
            var an = Re.get(Be) || null;
            return M(Ue, an, nt, ke, null);
          }
          O_(Ue, nt);
        }
        return typeof nt == "function" && wv(Ue), null;
      }
      function J(Re, Ue, Be) {
        {
          if (typeof Re != "object" || Re === null) return Ue;
          switch (Re.$$typeof) {
            case $i:
            case oi:
              US(Re, Be);
              var nt = Re.key;
              if (typeof nt != "string") break;
              if (Ue === null) {
                Ue = /* @__PURE__ */new Set(), Ue.add(nt);
                break;
              }
              if (!Ue.has(nt)) {
                Ue.add(nt);
                break;
              }
              h("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", nt);
              break;
            case Ct:
              var ke = Re._payload,
                Fe = Re._init;
              J(Fe(ke), Ue, Be);
              break;
          }
        }
        return Ue;
      }
      function me(Re, Ue, Be, nt) {
        for (var ke = null, Fe = 0; Fe < Be.length; Fe++) {
          var Ie = Be[Fe];
          ke = J(Ie, ke, Re);
        }
        for (var Qe = null, Tt = null, _t = Ue, an = 0, Gt = 0, Pn = null; _t !== null && Gt < Be.length; Gt++) {
          _t.index > Gt ? (Pn = _t, _t = null) : Pn = _t.sibling;
          var Fn = U(Re, _t, Be[Gt], nt);
          if (Fn === null) {
            _t === null && (_t = Pn);
            break;
          }
          s && _t && Fn.alternate === null && u(Re, _t), an = a(Fn, an, Gt), Tt === null ? Qe = Fn : Tt.sibling = Fn, Tt = Fn, _t = Pn;
        }
        if (Gt === Be.length) {
          if (v(Re, _t), Pa()) {
            var kr = Gt;
            _y(Re, kr);
          }
          return Qe;
        }
        if (_t === null) {
          for (; Gt < Be.length; Gt++) {
            var qn = z(Re, Be[Gt], nt);
            qn !== null && (an = a(qn, an, Gt), Tt === null ? Qe = qn : Tt.sibling = qn, Tt = qn);
          }
          if (Pa()) {
            var Tr = Gt;
            _y(Re, Tr);
          }
          return Qe;
        }
        for (var ai = _(Re, _t); Gt < Be.length; Gt++) {
          var Br = X(ai, Re, Gt, Be[Gt], nt);
          Br !== null && (s && Br.alternate !== null && ai.delete(Br.key === null ? Gt : Br.key), an = a(Br, an, Gt), Tt === null ? Qe = Br : Tt.sibling = Br, Tt = Br);
        }
        if (s && ai.forEach(function (Ro) {
          return u(Re, Ro);
        }), Pa()) {
          var ho = Gt;
          _y(Re, ho);
        }
        return Qe;
      }
      function Se(Re, Ue, Be, nt) {
        var ke = yn(Be);
        if (typeof ke != "function") throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" &&
          // $FlowFixMe Flow doesn't know about toStringTag
          Be[Symbol.toStringTag] === "Generator" && (PC || h("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), PC = !0), Be.entries === ke && (LC || h("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), LC = !0);
          var Fe = ke.call(Be);
          if (Fe) for (var Ie = null, Qe = Fe.next(); !Qe.done; Qe = Fe.next()) {
            var Tt = Qe.value;
            Ie = J(Tt, Ie, Re);
          }
        }
        var _t = ke.call(Be);
        if (_t == null) throw new Error("An iterable object provided no iterator.");
        for (var an = null, Gt = null, Pn = Ue, Fn = 0, kr = 0, qn = null, Tr = _t.next(); Pn !== null && !Tr.done; kr++, Tr = _t.next()) {
          Pn.index > kr ? (qn = Pn, Pn = null) : qn = Pn.sibling;
          var ai = U(Re, Pn, Tr.value, nt);
          if (ai === null) {
            Pn === null && (Pn = qn);
            break;
          }
          s && Pn && ai.alternate === null && u(Re, Pn), Fn = a(ai, Fn, kr), Gt === null ? an = ai : Gt.sibling = ai, Gt = ai, Pn = qn;
        }
        if (Tr.done) {
          if (v(Re, Pn), Pa()) {
            var Br = kr;
            _y(Re, Br);
          }
          return an;
        }
        if (Pn === null) {
          for (; !Tr.done; kr++, Tr = _t.next()) {
            var ho = z(Re, Tr.value, nt);
            ho !== null && (Fn = a(ho, Fn, kr), Gt === null ? an = ho : Gt.sibling = ho, Gt = ho);
          }
          if (Pa()) {
            var Ro = kr;
            _y(Re, Ro);
          }
          return an;
        }
        for (var ns = _(Re, Pn); !Tr.done; kr++, Tr = _t.next()) {
          var ta = X(ns, Re, kr, Tr.value, nt);
          ta !== null && (s && ta.alternate !== null && ns.delete(ta.key === null ? kr : ta.key), Fn = a(ta, Fn, kr), Gt === null ? an = ta : Gt.sibling = ta, Gt = ta);
        }
        if (s && ns.forEach(function (z0) {
          return u(Re, z0);
        }), Pa()) {
          var Pm = kr;
          _y(Re, Pm);
        }
        return an;
      }
      function Me(Re, Ue, Be, nt) {
        if (Ue !== null && Ue.tag === I) {
          v(Re, Ue.sibling);
          var ke = n(Ue, Be);
          return ke.return = Re, ke;
        }
        v(Re, Ue);
        var Fe = qk(Be, Re.mode, nt);
        return Fe.return = Re, Fe;
      }
      function Pe(Re, Ue, Be, nt) {
        for (var ke = Be.key, Fe = Ue; Fe !== null;) {
          if (Fe.key === ke) {
            var Ie = Be.type;
            if (Ie === Oo) {
              if (Fe.tag === O) {
                v(Re, Fe.sibling);
                var Qe = n(Fe, Be.props.children);
                return Qe.return = Re, Qe._debugSource = Be._source, Qe._debugOwner = Be._owner, Qe;
              }
            } else if (Fe.elementType === Ie ||
            // Keep this check inline so it only runs on the false path:
            PI(Fe, Be) ||
            // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof Ie == "object" && Ie !== null && Ie.$$typeof === Ct && L_(Ie) === Fe.type) {
              v(Re, Fe.sibling);
              var Tt = n(Fe, Be.props);
              return Tt.ref = Ty(Re, Fe, Be), Tt.return = Re, Tt._debugSource = Be._source, Tt._debugOwner = Be._owner, Tt;
            }
            v(Re, Fe);
            break;
          } else u(Re, Fe);
          Fe = Fe.sibling;
        }
        if (Be.type === Oo) {
          var _t = zv(Be.props.children, Re.mode, nt, Be.key);
          return _t.return = Re, _t;
        } else {
          var an = Om(Be, Re.mode, nt);
          return an.ref = Ty(Re, Ue, Be), an.return = Re, an;
        }
      }
      function $e(Re, Ue, Be, nt) {
        for (var ke = Be.key, Fe = Ue; Fe !== null;) {
          if (Fe.key === ke) {
            if (Fe.tag === k && Fe.stateNode.containerInfo === Be.containerInfo && Fe.stateNode.implementation === Be.implementation) {
              v(Re, Fe.sibling);
              var Ie = n(Fe, Be.children || []);
              return Ie.return = Re, Ie;
            } else {
              v(Re, Fe);
              break;
            }
          } else u(Re, Fe);
          Fe = Fe.sibling;
        }
        var Qe = M1(Be, Re.mode, nt);
        return Qe.return = Re, Qe;
      }
      function mt(Re, Ue, Be, nt) {
        var ke = typeof Be == "object" && Be !== null && Be.type === Oo && Be.key === null;
        if (ke && (Be = Be.props.children), typeof Be == "object" && Be !== null) {
          switch (Be.$$typeof) {
            case $i:
              return f(Pe(Re, Ue, Be, nt));
            case oi:
              return f($e(Re, Ue, Be, nt));
            case Ct:
              var Fe = Be._payload,
                Ie = Be._init;
              return mt(Re, Ue, Ie(Fe), nt);
          }
          if (wr(Be)) return me(Re, Ue, Be, nt);
          if (yn(Be)) return Se(Re, Ue, Be, nt);
          O_(Re, Be);
        }
        return typeof Be == "string" && Be !== "" || typeof Be == "number" ? f(Me(Re, Ue, "" + Be, nt)) : (typeof Be == "function" && wv(Re), v(Re, Ue));
      }
      return mt;
    }
    var Ry = P_(!0),
      AC = P_(!1);
    function r0(s, u) {
      if (s !== null && u.child !== s.child) throw new Error("Resuming work not yet implemented.");
      if (u.child !== null) {
        var v = u.child,
          _ = ts(v, v.pendingProps);
        for (u.child = _, _.return = u; v.sibling !== null;) v = v.sibling, _ = _.sibling = ts(v, v.pendingProps), _.return = u;
        _.sibling = null;
      }
    }
    function OD(s, u) {
      for (var v = s.child; v !== null;) Uk(v, u), v = v.sibling;
    }
    var A_ = {},
      _v = kf(A_),
      _m = kf(A_),
      Af = kf(A_);
    function xv(s) {
      if (s === A_) throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return s;
    }
    function j_() {
      var s = xv(Af.current);
      return s;
    }
    function i0(s, u) {
      ka(Af, u, s), ka(_m, s, s), ka(_v, A_, s);
      var v = rC(u);
      ca(_v, s), ka(_v, v, s);
    }
    function Dy(s) {
      ca(_v, s), ca(_m, s), ca(Af, s);
    }
    function F_() {
      var s = xv(_v.current);
      return s;
    }
    function Iy(s) {
      xv(Af.current);
      var u = xv(_v.current),
        v = OL(u, s.type);
      u !== v && (ka(_m, s, s), ka(_v, v, s));
    }
    function N_(s) {
      _m.current === s && (ca(_v, s), ca(_m, s));
    }
    var LD = 0,
      HS = 1,
      PD = 1,
      a0 = 2,
      $c = kf(LD);
    function My(s, u) {
      return (s & u) !== 0;
    }
    function pl(s) {
      return s & HS;
    }
    function z_(s, u) {
      return s & HS | u;
    }
    function o0(s, u) {
      return s | u;
    }
    function vp(s, u) {
      ka($c, u, s);
    }
    function s0(s) {
      ca($c, s);
    }
    function Sv(s, u) {
      var v = s.memoizedState;
      return v !== null ? v.dehydrated !== null : (s.memoizedProps, !0);
    }
    function xm(s) {
      for (var u = s; u !== null;) {
        if (u.tag === V) {
          var v = u.memoizedState;
          if (v !== null) {
            var _ = v.dehydrated;
            if (_ === null || vD(_) || cC(_)) return u;
          }
        } else if (u.tag === Y &&
        // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        u.memoizedProps.revealOrder !== void 0) {
          var n = (u.flags & ft) !== pt;
          if (n) return u;
        } else if (u.child !== null) {
          u.child.return = u, u = u.child;
          continue;
        }
        if (u === s) return null;
        for (; u.sibling === null;) {
          if (u.return === null || u.return === s) return null;
          u = u.return;
        }
        u.sibling.return = u.return, u = u.sibling;
      }
      return null;
    }
    var gu = /*   */
      0,
      ja = /* */
      1,
      Ta = /*  */
      2,
      Er = /*    */
      4,
      Ui = /*   */
      8,
      lo = [];
    function Qo() {
      for (var s = 0; s < lo.length; s++) {
        var u = lo[s];
        u._workInProgressVersionPrimary = null;
      }
      lo.length = 0;
    }
    function jC(s, u) {
      var v = u._getVersion,
        _ = v(u._source);
      s.mutableSourceEagerHydrationData == null ? s.mutableSourceEagerHydrationData = [u, _] : s.mutableSourceEagerHydrationData.push(u, _);
    }
    var Zt = i.ReactCurrentDispatcher,
      V_ = i.ReactCurrentBatchConfig,
      Jt,
      gp;
    Jt = /* @__PURE__ */new Set();
    var Sm = De,
      Or = null,
      ea = null,
      zn = null,
      Fa = !1,
      Ra = !1,
      Ev = 0,
      B_ = 0,
      U_ = 25,
      ct = null,
      Wc = null,
      lt = -1,
      yu = !1;
    function vr() {
      {
        var s = ct;
        Wc === null ? Wc = [s] : Wc.push(s);
      }
    }
    function Ut() {
      {
        var s = ct;
        Wc !== null && (lt++, Wc[lt] !== s && Yt(s));
      }
    }
    function Cr(s) {
      s != null && !wr(s) && h("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", ct, typeof s);
    }
    function Yt(s) {
      {
        var u = At(Or);
        if (!Jt.has(u) && (Jt.add(u), Wc !== null)) {
          for (var v = "", _ = 30, n = 0; n <= lt; n++) {
            for (var a = Wc[n], f = n === lt ? s : a, m = n + 1 + ". " + a; m.length < _;) m += " ";
            m += f + `
`, v += m;
          }
          h(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, u, v);
        }
      }
    }
    function uo() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function FC(s, u) {
      if (yu) return !1;
      if (u === null) return h("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", ct), !1;
      s.length !== u.length && h(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, ct, "[" + u.join(", ") + "]", "[" + s.join(", ") + "]");
      for (var v = 0; v < u.length && v < s.length; v++) if (!ae(s[v], u[v])) return !1;
      return !0;
    }
    function co(s, u, v, _, n, a) {
      Sm = a, Or = u, Wc = s !== null ? s._debugHookTypes : null, lt = -1, yu = s !== null && s.type !== u.type, u.memoizedState = null, u.updateQueue = null, u.lanes = De, s !== null && s.memoizedState !== null ? Zt.current = qC : Wc !== null ? Zt.current = WC : Zt.current = $C;
      var f = v(_, n);
      if (Ra) {
        var m = 0;
        do {
          if (Ra = !1, Ev = 0, m >= U_) throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          m += 1, yu = !1, ea = null, zn = null, u.updateQueue = null, lt = -1, Zt.current = nx, f = v(_, n);
        } while (Ra);
      }
      Zt.current = tx, u._debugHookTypes = Wc;
      var b = ea !== null && ea.next !== null;
      if (Sm = De, Or = null, ea = null, zn = null, ct = null, Wc = null, lt = -1, s !== null && (s.flags & nr) !== (u.flags & nr) &&
      // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (s.mode & Wt) !== dt && h("Internal React error: Expected static flag was missing. Please notify the React team."), Fa = !1, b) throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return f;
    }
    function Cv() {
      var s = Ev !== 0;
      return Ev = 0, s;
    }
    function Oy(s, u, v) {
      u.updateQueue = s.updateQueue, (u.mode & Ri) !== dt ? u.flags &= -50333701 : u.flags &= -2053, s.lanes = ac(s.lanes, v);
    }
    function Ly() {
      if (Zt.current = tx, Fa) {
        for (var s = Or.memoizedState; s !== null;) {
          var u = s.queue;
          u !== null && (u.pending = null), s = s.next;
        }
        Fa = !1;
      }
      Sm = De, Or = null, ea = null, zn = null, Wc = null, lt = -1, ct = null, AD = !1, Ra = !1, Ev = 0;
    }
    function jf() {
      var s = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return zn === null ? Or.memoizedState = zn = s : zn = zn.next = s, zn;
    }
    function _c() {
      var s;
      if (ea === null) {
        var u = Or.alternate;
        u !== null ? s = u.memoizedState : s = null;
      } else s = ea.next;
      var v;
      if (zn === null ? v = Or.memoizedState : v = zn.next, v !== null) zn = v, v = zn.next, ea = s;else {
        if (s === null) throw new Error("Rendered more hooks than during the previous render.");
        ea = s;
        var _ = {
          memoizedState: ea.memoizedState,
          baseState: ea.baseState,
          baseQueue: ea.baseQueue,
          queue: ea.queue,
          next: null
        };
        zn === null ? Or.memoizedState = zn = _ : zn = zn.next = _;
      }
      return zn;
    }
    function Ff() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function bu(s, u) {
      return typeof u == "function" ? u(s) : u;
    }
    function $S(s, u, v) {
      var _ = jf(),
        n;
      v !== void 0 ? n = v(u) : n = u, _.memoizedState = _.baseState = n;
      var a = {
        pending: null,
        interleaved: null,
        lanes: De,
        dispatch: null,
        lastRenderedReducer: s,
        lastRenderedState: n
      };
      _.queue = a;
      var f = a.dispatch = jD.bind(null, Or, a);
      return [_.memoizedState, f];
    }
    function H_(s, u, v) {
      var _ = _c(),
        n = _.queue;
      if (n === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      n.lastRenderedReducer = s;
      var a = ea,
        f = a.baseQueue,
        m = n.pending;
      if (m !== null) {
        if (f !== null) {
          var b = f.next,
            T = m.next;
          f.next = T, m.next = b;
        }
        a.baseQueue !== f && h("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), a.baseQueue = f = m, n.pending = null;
      }
      if (f !== null) {
        var M = f.next,
          z = a.baseState,
          U = null,
          X = null,
          J = null,
          me = M;
        do {
          var Se = me.lane;
          if ($s(Sm, Se)) {
            if (J !== null) {
              var Me = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: On,
                action: me.action,
                hasEagerState: me.hasEagerState,
                eagerState: me.eagerState,
                next: null
              };
              J = J.next = Me;
            }
            if (me.hasEagerState) z = me.eagerState;else {
              var Pe = me.action;
              z = s(z, Pe);
            }
          } else {
            var $e = {
              lane: Se,
              action: me.action,
              hasEagerState: me.hasEagerState,
              eagerState: me.eagerState,
              next: null
            };
            J === null ? (X = J = $e, U = z) : J = J.next = $e, Or.lanes = jt(Or.lanes, Se), L0(Se);
          }
          me = me.next;
        } while (me !== null && me !== M);
        J === null ? U = z : J.next = X, ae(z, _.memoizedState) || x0(), _.memoizedState = z, _.baseState = U, _.baseQueue = J, n.lastRenderedState = z;
      }
      var mt = n.interleaved;
      if (mt !== null) {
        var Re = mt;
        do {
          var Ue = Re.lane;
          Or.lanes = jt(Or.lanes, Ue), L0(Ue), Re = Re.next;
        } while (Re !== mt);
      } else f === null && (n.lanes = De);
      var Be = n.dispatch;
      return [_.memoizedState, Be];
    }
    function $_(s, u, v) {
      var _ = _c(),
        n = _.queue;
      if (n === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      n.lastRenderedReducer = s;
      var a = n.dispatch,
        f = n.pending,
        m = _.memoizedState;
      if (f !== null) {
        n.pending = null;
        var b = f.next,
          T = b;
        do {
          var M = T.action;
          m = s(m, M), T = T.next;
        } while (T !== b);
        ae(m, _.memoizedState) || x0(), _.memoizedState = m, _.baseQueue === null && (_.baseState = m), n.lastRenderedState = m;
      }
      return [m, a];
    }
    function W_(s, u, v) {
      var _ = Or,
        n = jf(),
        a,
        f = Pa();
      if (f) {
        if (v === void 0) throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        a = v(), gp || a !== v() && (h("The result of getServerSnapshot should be cached to avoid an infinite loop"), gp = !0);
      } else {
        if (a = u(), !gp) {
          var m = u();
          ae(a, m) || (h("The result of getSnapshot should be cached to avoid an infinite loop"), gp = !0);
        }
        var b = Zy();
        if (b === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Gl(b, Sm) || PP(_, u, a);
      }
      n.memoizedState = a;
      var T = {
        value: a,
        getSnapshot: u
      };
      return n.queue = T, f0(WS.bind(null, _, T, s), [s]), _.flags |= Yr, u0(ja | Ui, AP.bind(null, _, T, a, u), void 0, null), a;
    }
    function l0(s, u, v) {
      var _ = Or,
        n = _c(),
        a = u();
      if (!gp) {
        var f = u();
        ae(a, f) || (h("The result of getSnapshot should be cached to avoid an infinite loop"), gp = !0);
      }
      var m = n.memoizedState,
        b = !ae(m, a);
      b && (n.memoizedState = a, x0());
      var T = n.queue;
      if (Tv(WS.bind(null, _, T, s), [s]), T.getSnapshot !== u || b ||
      // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      zn !== null && zn.memoizedState.tag & ja) {
        _.flags |= Yr, u0(ja | Ui, AP.bind(null, _, T, a, u), void 0, null);
        var M = Zy();
        if (M === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Gl(M, Sm) || PP(_, u, a);
      }
      return a;
    }
    function PP(s, u, v) {
      s.flags |= Al;
      var _ = {
          getSnapshot: u,
          value: v
        },
        n = Or.updateQueue;
      if (n === null) n = Ff(), Or.updateQueue = n, n.stores = [_];else {
        var a = n.stores;
        a === null ? n.stores = [_] : a.push(_);
      }
    }
    function AP(s, u, v, _) {
      u.value = v, u.getSnapshot = _, q_(u) && NC(s);
    }
    function WS(s, u, v) {
      var _ = function () {
        q_(u) && NC(s);
      };
      return v(_);
    }
    function q_(s) {
      var u = s.getSnapshot,
        v = s.value;
      try {
        var _ = u();
        return !ae(v, _);
      } catch {
        return !0;
      }
    }
    function NC(s) {
      var u = vu(s, Je);
      u !== null && Ba(u, s, Je, wn);
    }
    function Y_(s) {
      var u = jf();
      typeof s == "function" && (s = s()), u.memoizedState = u.baseState = s;
      var v = {
        pending: null,
        interleaved: null,
        lanes: De,
        dispatch: null,
        lastRenderedReducer: bu,
        lastRenderedState: s
      };
      u.queue = v;
      var _ = v.dispatch = jP.bind(null, Or, v);
      return [u.memoizedState, _];
    }
    function qS(s) {
      return H_(bu);
    }
    function YS(s) {
      return $_(bu);
    }
    function u0(s, u, v, _) {
      var n = {
          tag: s,
          create: u,
          destroy: v,
          deps: _,
          // Circular
          next: null
        },
        a = Or.updateQueue;
      if (a === null) a = Ff(), Or.updateQueue = a, a.lastEffect = n.next = n;else {
        var f = a.lastEffect;
        if (f === null) a.lastEffect = n.next = n;else {
          var m = f.next;
          f.next = n, n.next = m, a.lastEffect = n;
        }
      }
      return n;
    }
    function c0(s) {
      var u = jf();
      {
        var v = {
          current: s
        };
        return u.memoizedState = v, v;
      }
    }
    function d0(s) {
      var u = _c();
      return u.memoizedState;
    }
    function Py(s, u, v, _) {
      var n = jf(),
        a = _ === void 0 ? null : _;
      Or.flags |= s, n.memoizedState = u0(ja | u, v, void 0, a);
    }
    function kv(s, u, v, _) {
      var n = _c(),
        a = _ === void 0 ? null : _,
        f = void 0;
      if (ea !== null) {
        var m = ea.memoizedState;
        if (f = m.destroy, a !== null) {
          var b = m.deps;
          if (FC(a, b)) {
            n.memoizedState = u0(u, v, f, a);
            return;
          }
        }
      }
      Or.flags |= s, n.memoizedState = u0(ja | u, v, f, a);
    }
    function f0(s, u) {
      return (Or.mode & Ri) !== dt ? Py(ga | Yr | Vd, Ui, s, u) : Py(Yr | Vd, Ui, s, u);
    }
    function Tv(s, u) {
      return kv(Yr, Ui, s, u);
    }
    function Ay(s, u) {
      return Py(tn, Ta, s, u);
    }
    function jy(s, u) {
      return kv(tn, Ta, s, u);
    }
    function p0(s, u) {
      var v = tn;
      return v |= Za, (Or.mode & Ri) !== dt && (v |= Bo), Py(v, Er, s, u);
    }
    function Rv(s, u) {
      return kv(tn, Er, s, u);
    }
    function GS(s, u) {
      if (typeof u == "function") {
        var v = u,
          _ = s();
        return v(_), function () {
          v(null);
        };
      } else if (u != null) {
        var n = u;
        n.hasOwnProperty("current") || h("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(n).join(", ") + "}");
        var a = s();
        return n.current = a, function () {
          n.current = null;
        };
      }
    }
    function h0(s, u, v) {
      typeof u != "function" && h("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", u !== null ? typeof u : "null");
      var _ = v != null ? v.concat([s]) : null,
        n = tn;
      return n |= Za, (Or.mode & Ri) !== dt && (n |= Bo), Py(n, Er, GS.bind(null, u, s), _);
    }
    function m0(s, u, v) {
      typeof u != "function" && h("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", u !== null ? typeof u : "null");
      var _ = v != null ? v.concat([s]) : null;
      return kv(tn, Er, GS.bind(null, u, s), _);
    }
    function XS(s, u) {}
    var G_ = XS;
    function X_(s, u) {
      var v = jf(),
        _ = u === void 0 ? null : u;
      return v.memoizedState = [s, _], s;
    }
    function Fy(s, u) {
      var v = _c(),
        _ = u === void 0 ? null : u,
        n = v.memoizedState;
      if (n !== null && _ !== null) {
        var a = n[1];
        if (FC(_, a)) return n[0];
      }
      return v.memoizedState = [s, _], s;
    }
    function zC(s, u) {
      var v = jf(),
        _ = u === void 0 ? null : u,
        n = s();
      return v.memoizedState = [n, _], n;
    }
    function Ny(s, u) {
      var v = _c(),
        _ = u === void 0 ? null : u,
        n = v.memoizedState;
      if (n !== null && _ !== null) {
        var a = n[1];
        if (FC(_, a)) return n[0];
      }
      var f = s();
      return v.memoizedState = [f, _], f;
    }
    function K_(s) {
      var u = jf();
      return u.memoizedState = s, s;
    }
    function Q_(s) {
      var u = _c(),
        v = ea,
        _ = v.memoizedState;
      return Z_(u, _, s);
    }
    function KS(s) {
      var u = _c();
      if (ea === null) return u.memoizedState = s, s;
      var v = ea.memoizedState;
      return Z_(u, v, s);
    }
    function Z_(s, u, v) {
      var _ = !Yl(Sm);
      if (_) {
        if (!ae(v, u)) {
          var n = Vh();
          Or.lanes = jt(Or.lanes, n), L0(n), s.baseState = !0;
        }
        return u;
      } else return s.baseState && (s.baseState = !1, x0()), s.memoizedState = v, v;
    }
    function VC(s, u, v) {
      var _ = Ir();
      zr(Uh(_, Ii)), s(!0);
      var n = V_.transition;
      V_.transition = {};
      var a = V_.transition;
      V_.transition._updatedFibers = /* @__PURE__ */new Set();
      try {
        s(!1), u();
      } finally {
        if (zr(_), V_.transition = n, n === null && a._updatedFibers) {
          var f = a._updatedFibers.size;
          f > 10 && p("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), a._updatedFibers.clear();
        }
      }
    }
    function QS() {
      var s = Y_(!1),
        u = s[0],
        v = s[1],
        _ = VC.bind(null, v),
        n = jf();
      return n.memoizedState = _, [u, _];
    }
    function BC() {
      var s = qS(),
        u = s[0],
        v = _c(),
        _ = v.memoizedState;
      return [u, _];
    }
    function UC() {
      var s = YS(),
        u = s[0],
        v = _c(),
        _ = v.memoizedState;
      return [u, _];
    }
    var AD = !1;
    function HC() {
      return AD;
    }
    function ZS() {
      var s = jf(),
        u = Zy(),
        v = u.identifierPrefix,
        _;
      if (Pa()) {
        var n = SP();
        _ = ":" + v + "R" + n;
        var a = Ev++;
        a > 0 && (_ += "H" + a.toString(32)), _ += ":";
      } else {
        var f = B_++;
        _ = ":" + v + "r" + f.toString(32) + ":";
      }
      return s.memoizedState = _, _;
    }
    function J_() {
      var s = _c(),
        u = s.memoizedState;
      return u;
    }
    function jD(s, u, v) {
      typeof arguments[3] == "function" && h("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var _ = Jf(s),
        n = {
          lane: _,
          action: v,
          hasEagerState: !1,
          eagerState: null,
          next: null
        };
      if (JS(s)) ex(u, n);else {
        var a = OS(s, u, n, _);
        if (a !== null) {
          var f = es();
          Ba(a, s, _, f), FD(a, u, _);
        }
      }
      ND(s, _);
    }
    function jP(s, u, v) {
      typeof arguments[3] == "function" && h("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var _ = Jf(s),
        n = {
          lane: _,
          action: v,
          hasEagerState: !1,
          eagerState: null,
          next: null
        };
      if (JS(s)) ex(u, n);else {
        var a = s.alternate;
        if (s.lanes === De && (a === null || a.lanes === De)) {
          var f = u.lastRenderedReducer;
          if (f !== null) {
            var m;
            m = Zt.current, Zt.current = qc;
            try {
              var b = u.lastRenderedState,
                T = f(b, v);
              if (n.hasEagerState = !0, n.eagerState = T, ae(T, b)) {
                MP(s, u, n, _);
                return;
              }
            } catch {} finally {
              Zt.current = m;
            }
          }
        }
        var M = OS(s, u, n, _);
        if (M !== null) {
          var z = es();
          Ba(M, s, _, z), FD(M, u, _);
        }
      }
      ND(s, _);
    }
    function JS(s) {
      var u = s.alternate;
      return s === Or || u !== null && u === Or;
    }
    function ex(s, u) {
      Ra = Fa = !0;
      var v = s.pending;
      v === null ? u.next = u : (u.next = v.next, v.next = u), s.pending = u;
    }
    function FD(s, u, v) {
      if (zh(v)) {
        var _ = u.lanes;
        _ = Bh(_, s.pendingLanes);
        var n = jt(_, v);
        u.lanes = n, cf(s, n);
      }
    }
    function ND(s, u, v) {
      Bs(s, u);
    }
    var tx = {
        readContext: ko,
        useCallback: uo,
        useContext: uo,
        useEffect: uo,
        useImperativeHandle: uo,
        useInsertionEffect: uo,
        useLayoutEffect: uo,
        useMemo: uo,
        useReducer: uo,
        useRef: uo,
        useState: uo,
        useDebugValue: uo,
        useDeferredValue: uo,
        useTransition: uo,
        useMutableSource: uo,
        useSyncExternalStore: uo,
        useId: uo,
        unstable_isNewReconciler: $
      },
      $C = null,
      WC = null,
      qC = null,
      nx = null,
      Nf = null,
      qc = null,
      rx = null;
    {
      var e1 = function () {
          h("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        },
        xn = function () {
          h("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
        };
      $C = {
        readContext: function (s) {
          return ko(s);
        },
        useCallback: function (s, u) {
          return ct = "useCallback", vr(), Cr(u), X_(s, u);
        },
        useContext: function (s) {
          return ct = "useContext", vr(), ko(s);
        },
        useEffect: function (s, u) {
          return ct = "useEffect", vr(), Cr(u), f0(s, u);
        },
        useImperativeHandle: function (s, u, v) {
          return ct = "useImperativeHandle", vr(), Cr(v), h0(s, u, v);
        },
        useInsertionEffect: function (s, u) {
          return ct = "useInsertionEffect", vr(), Cr(u), Ay(s, u);
        },
        useLayoutEffect: function (s, u) {
          return ct = "useLayoutEffect", vr(), Cr(u), p0(s, u);
        },
        useMemo: function (s, u) {
          ct = "useMemo", vr(), Cr(u);
          var v = Zt.current;
          Zt.current = Nf;
          try {
            return zC(s, u);
          } finally {
            Zt.current = v;
          }
        },
        useReducer: function (s, u, v) {
          ct = "useReducer", vr();
          var _ = Zt.current;
          Zt.current = Nf;
          try {
            return $S(s, u, v);
          } finally {
            Zt.current = _;
          }
        },
        useRef: function (s) {
          return ct = "useRef", vr(), c0(s);
        },
        useState: function (s) {
          ct = "useState", vr();
          var u = Zt.current;
          Zt.current = Nf;
          try {
            return Y_(s);
          } finally {
            Zt.current = u;
          }
        },
        useDebugValue: function (s, u) {
          return ct = "useDebugValue", vr(), void 0;
        },
        useDeferredValue: function (s) {
          return ct = "useDeferredValue", vr(), K_(s);
        },
        useTransition: function () {
          return ct = "useTransition", vr(), QS();
        },
        useMutableSource: function (s, u, v) {
          return ct = "useMutableSource", vr(), void 0;
        },
        useSyncExternalStore: function (s, u, v) {
          return ct = "useSyncExternalStore", vr(), W_(s, u, v);
        },
        useId: function () {
          return ct = "useId", vr(), ZS();
        },
        unstable_isNewReconciler: $
      }, WC = {
        readContext: function (s) {
          return ko(s);
        },
        useCallback: function (s, u) {
          return ct = "useCallback", Ut(), X_(s, u);
        },
        useContext: function (s) {
          return ct = "useContext", Ut(), ko(s);
        },
        useEffect: function (s, u) {
          return ct = "useEffect", Ut(), f0(s, u);
        },
        useImperativeHandle: function (s, u, v) {
          return ct = "useImperativeHandle", Ut(), h0(s, u, v);
        },
        useInsertionEffect: function (s, u) {
          return ct = "useInsertionEffect", Ut(), Ay(s, u);
        },
        useLayoutEffect: function (s, u) {
          return ct = "useLayoutEffect", Ut(), p0(s, u);
        },
        useMemo: function (s, u) {
          ct = "useMemo", Ut();
          var v = Zt.current;
          Zt.current = Nf;
          try {
            return zC(s, u);
          } finally {
            Zt.current = v;
          }
        },
        useReducer: function (s, u, v) {
          ct = "useReducer", Ut();
          var _ = Zt.current;
          Zt.current = Nf;
          try {
            return $S(s, u, v);
          } finally {
            Zt.current = _;
          }
        },
        useRef: function (s) {
          return ct = "useRef", Ut(), c0(s);
        },
        useState: function (s) {
          ct = "useState", Ut();
          var u = Zt.current;
          Zt.current = Nf;
          try {
            return Y_(s);
          } finally {
            Zt.current = u;
          }
        },
        useDebugValue: function (s, u) {
          return ct = "useDebugValue", Ut(), void 0;
        },
        useDeferredValue: function (s) {
          return ct = "useDeferredValue", Ut(), K_(s);
        },
        useTransition: function () {
          return ct = "useTransition", Ut(), QS();
        },
        useMutableSource: function (s, u, v) {
          return ct = "useMutableSource", Ut(), void 0;
        },
        useSyncExternalStore: function (s, u, v) {
          return ct = "useSyncExternalStore", Ut(), W_(s, u, v);
        },
        useId: function () {
          return ct = "useId", Ut(), ZS();
        },
        unstable_isNewReconciler: $
      }, qC = {
        readContext: function (s) {
          return ko(s);
        },
        useCallback: function (s, u) {
          return ct = "useCallback", Ut(), Fy(s, u);
        },
        useContext: function (s) {
          return ct = "useContext", Ut(), ko(s);
        },
        useEffect: function (s, u) {
          return ct = "useEffect", Ut(), Tv(s, u);
        },
        useImperativeHandle: function (s, u, v) {
          return ct = "useImperativeHandle", Ut(), m0(s, u, v);
        },
        useInsertionEffect: function (s, u) {
          return ct = "useInsertionEffect", Ut(), jy(s, u);
        },
        useLayoutEffect: function (s, u) {
          return ct = "useLayoutEffect", Ut(), Rv(s, u);
        },
        useMemo: function (s, u) {
          ct = "useMemo", Ut();
          var v = Zt.current;
          Zt.current = qc;
          try {
            return Ny(s, u);
          } finally {
            Zt.current = v;
          }
        },
        useReducer: function (s, u, v) {
          ct = "useReducer", Ut();
          var _ = Zt.current;
          Zt.current = qc;
          try {
            return H_(s, u, v);
          } finally {
            Zt.current = _;
          }
        },
        useRef: function (s) {
          return ct = "useRef", Ut(), d0();
        },
        useState: function (s) {
          ct = "useState", Ut();
          var u = Zt.current;
          Zt.current = qc;
          try {
            return qS(s);
          } finally {
            Zt.current = u;
          }
        },
        useDebugValue: function (s, u) {
          return ct = "useDebugValue", Ut(), G_();
        },
        useDeferredValue: function (s) {
          return ct = "useDeferredValue", Ut(), Q_(s);
        },
        useTransition: function () {
          return ct = "useTransition", Ut(), BC();
        },
        useMutableSource: function (s, u, v) {
          return ct = "useMutableSource", Ut(), void 0;
        },
        useSyncExternalStore: function (s, u, v) {
          return ct = "useSyncExternalStore", Ut(), l0(s, u);
        },
        useId: function () {
          return ct = "useId", Ut(), J_();
        },
        unstable_isNewReconciler: $
      }, nx = {
        readContext: function (s) {
          return ko(s);
        },
        useCallback: function (s, u) {
          return ct = "useCallback", Ut(), Fy(s, u);
        },
        useContext: function (s) {
          return ct = "useContext", Ut(), ko(s);
        },
        useEffect: function (s, u) {
          return ct = "useEffect", Ut(), Tv(s, u);
        },
        useImperativeHandle: function (s, u, v) {
          return ct = "useImperativeHandle", Ut(), m0(s, u, v);
        },
        useInsertionEffect: function (s, u) {
          return ct = "useInsertionEffect", Ut(), jy(s, u);
        },
        useLayoutEffect: function (s, u) {
          return ct = "useLayoutEffect", Ut(), Rv(s, u);
        },
        useMemo: function (s, u) {
          ct = "useMemo", Ut();
          var v = Zt.current;
          Zt.current = rx;
          try {
            return Ny(s, u);
          } finally {
            Zt.current = v;
          }
        },
        useReducer: function (s, u, v) {
          ct = "useReducer", Ut();
          var _ = Zt.current;
          Zt.current = rx;
          try {
            return $_(s, u, v);
          } finally {
            Zt.current = _;
          }
        },
        useRef: function (s) {
          return ct = "useRef", Ut(), d0();
        },
        useState: function (s) {
          ct = "useState", Ut();
          var u = Zt.current;
          Zt.current = rx;
          try {
            return YS(s);
          } finally {
            Zt.current = u;
          }
        },
        useDebugValue: function (s, u) {
          return ct = "useDebugValue", Ut(), G_();
        },
        useDeferredValue: function (s) {
          return ct = "useDeferredValue", Ut(), KS(s);
        },
        useTransition: function () {
          return ct = "useTransition", Ut(), UC();
        },
        useMutableSource: function (s, u, v) {
          return ct = "useMutableSource", Ut(), void 0;
        },
        useSyncExternalStore: function (s, u, v) {
          return ct = "useSyncExternalStore", Ut(), l0(s, u);
        },
        useId: function () {
          return ct = "useId", Ut(), J_();
        },
        unstable_isNewReconciler: $
      }, Nf = {
        readContext: function (s) {
          return e1(), ko(s);
        },
        useCallback: function (s, u) {
          return ct = "useCallback", xn(), vr(), X_(s, u);
        },
        useContext: function (s) {
          return ct = "useContext", xn(), vr(), ko(s);
        },
        useEffect: function (s, u) {
          return ct = "useEffect", xn(), vr(), f0(s, u);
        },
        useImperativeHandle: function (s, u, v) {
          return ct = "useImperativeHandle", xn(), vr(), h0(s, u, v);
        },
        useInsertionEffect: function (s, u) {
          return ct = "useInsertionEffect", xn(), vr(), Ay(s, u);
        },
        useLayoutEffect: function (s, u) {
          return ct = "useLayoutEffect", xn(), vr(), p0(s, u);
        },
        useMemo: function (s, u) {
          ct = "useMemo", xn(), vr();
          var v = Zt.current;
          Zt.current = Nf;
          try {
            return zC(s, u);
          } finally {
            Zt.current = v;
          }
        },
        useReducer: function (s, u, v) {
          ct = "useReducer", xn(), vr();
          var _ = Zt.current;
          Zt.current = Nf;
          try {
            return $S(s, u, v);
          } finally {
            Zt.current = _;
          }
        },
        useRef: function (s) {
          return ct = "useRef", xn(), vr(), c0(s);
        },
        useState: function (s) {
          ct = "useState", xn(), vr();
          var u = Zt.current;
          Zt.current = Nf;
          try {
            return Y_(s);
          } finally {
            Zt.current = u;
          }
        },
        useDebugValue: function (s, u) {
          return ct = "useDebugValue", xn(), vr(), void 0;
        },
        useDeferredValue: function (s) {
          return ct = "useDeferredValue", xn(), vr(), K_(s);
        },
        useTransition: function () {
          return ct = "useTransition", xn(), vr(), QS();
        },
        useMutableSource: function (s, u, v) {
          return ct = "useMutableSource", xn(), vr(), void 0;
        },
        useSyncExternalStore: function (s, u, v) {
          return ct = "useSyncExternalStore", xn(), vr(), W_(s, u, v);
        },
        useId: function () {
          return ct = "useId", xn(), vr(), ZS();
        },
        unstable_isNewReconciler: $
      }, qc = {
        readContext: function (s) {
          return e1(), ko(s);
        },
        useCallback: function (s, u) {
          return ct = "useCallback", xn(), Ut(), Fy(s, u);
        },
        useContext: function (s) {
          return ct = "useContext", xn(), Ut(), ko(s);
        },
        useEffect: function (s, u) {
          return ct = "useEffect", xn(), Ut(), Tv(s, u);
        },
        useImperativeHandle: function (s, u, v) {
          return ct = "useImperativeHandle", xn(), Ut(), m0(s, u, v);
        },
        useInsertionEffect: function (s, u) {
          return ct = "useInsertionEffect", xn(), Ut(), jy(s, u);
        },
        useLayoutEffect: function (s, u) {
          return ct = "useLayoutEffect", xn(), Ut(), Rv(s, u);
        },
        useMemo: function (s, u) {
          ct = "useMemo", xn(), Ut();
          var v = Zt.current;
          Zt.current = qc;
          try {
            return Ny(s, u);
          } finally {
            Zt.current = v;
          }
        },
        useReducer: function (s, u, v) {
          ct = "useReducer", xn(), Ut();
          var _ = Zt.current;
          Zt.current = qc;
          try {
            return H_(s, u, v);
          } finally {
            Zt.current = _;
          }
        },
        useRef: function (s) {
          return ct = "useRef", xn(), Ut(), d0();
        },
        useState: function (s) {
          ct = "useState", xn(), Ut();
          var u = Zt.current;
          Zt.current = qc;
          try {
            return qS(s);
          } finally {
            Zt.current = u;
          }
        },
        useDebugValue: function (s, u) {
          return ct = "useDebugValue", xn(), Ut(), G_();
        },
        useDeferredValue: function (s) {
          return ct = "useDeferredValue", xn(), Ut(), Q_(s);
        },
        useTransition: function () {
          return ct = "useTransition", xn(), Ut(), BC();
        },
        useMutableSource: function (s, u, v) {
          return ct = "useMutableSource", xn(), Ut(), void 0;
        },
        useSyncExternalStore: function (s, u, v) {
          return ct = "useSyncExternalStore", xn(), Ut(), l0(s, u);
        },
        useId: function () {
          return ct = "useId", xn(), Ut(), J_();
        },
        unstable_isNewReconciler: $
      }, rx = {
        readContext: function (s) {
          return e1(), ko(s);
        },
        useCallback: function (s, u) {
          return ct = "useCallback", xn(), Ut(), Fy(s, u);
        },
        useContext: function (s) {
          return ct = "useContext", xn(), Ut(), ko(s);
        },
        useEffect: function (s, u) {
          return ct = "useEffect", xn(), Ut(), Tv(s, u);
        },
        useImperativeHandle: function (s, u, v) {
          return ct = "useImperativeHandle", xn(), Ut(), m0(s, u, v);
        },
        useInsertionEffect: function (s, u) {
          return ct = "useInsertionEffect", xn(), Ut(), jy(s, u);
        },
        useLayoutEffect: function (s, u) {
          return ct = "useLayoutEffect", xn(), Ut(), Rv(s, u);
        },
        useMemo: function (s, u) {
          ct = "useMemo", xn(), Ut();
          var v = Zt.current;
          Zt.current = qc;
          try {
            return Ny(s, u);
          } finally {
            Zt.current = v;
          }
        },
        useReducer: function (s, u, v) {
          ct = "useReducer", xn(), Ut();
          var _ = Zt.current;
          Zt.current = qc;
          try {
            return $_(s, u, v);
          } finally {
            Zt.current = _;
          }
        },
        useRef: function (s) {
          return ct = "useRef", xn(), Ut(), d0();
        },
        useState: function (s) {
          ct = "useState", xn(), Ut();
          var u = Zt.current;
          Zt.current = qc;
          try {
            return YS(s);
          } finally {
            Zt.current = u;
          }
        },
        useDebugValue: function (s, u) {
          return ct = "useDebugValue", xn(), Ut(), G_();
        },
        useDeferredValue: function (s) {
          return ct = "useDeferredValue", xn(), Ut(), KS(s);
        },
        useTransition: function () {
          return ct = "useTransition", xn(), Ut(), UC();
        },
        useMutableSource: function (s, u, v) {
          return ct = "useMutableSource", xn(), Ut(), void 0;
        },
        useSyncExternalStore: function (s, u, v) {
          return ct = "useSyncExternalStore", xn(), Ut(), l0(s, u);
        },
        useId: function () {
          return ct = "useId", xn(), Ut(), J_();
        },
        unstable_isNewReconciler: $
      };
    }
    var gs = e.unstable_now,
      ix = 0,
      v0 = -1,
      Dn = -1,
      zf = -1,
      t1 = !1,
      zy = !1;
    function g0() {
      return t1;
    }
    function n1() {
      zy = !0;
    }
    function YC() {
      t1 = !1, zy = !1;
    }
    function r1() {
      t1 = zy, zy = !1;
    }
    function GC() {
      return ix;
    }
    function zD() {
      ix = gs();
    }
    function XC(s) {
      Dn = gs(), s.actualStartTime < 0 && (s.actualStartTime = gs());
    }
    function VD(s) {
      Dn = -1;
    }
    function ax(s, u) {
      if (Dn >= 0) {
        var v = gs() - Dn;
        s.actualDuration += v, u && (s.selfBaseDuration = v), Dn = -1;
      }
    }
    function Vf(s) {
      if (v0 >= 0) {
        var u = gs() - v0;
        v0 = -1;
        for (var v = s.return; v !== null;) {
          switch (v.tag) {
            case C:
              var _ = v.stateNode;
              _.effectDuration += u;
              return;
            case j:
              var n = v.stateNode;
              n.effectDuration += u;
              return;
          }
          v = v.return;
        }
      }
    }
    function ox(s) {
      if (zf >= 0) {
        var u = gs() - zf;
        zf = -1;
        for (var v = s.return; v !== null;) {
          switch (v.tag) {
            case C:
              var _ = v.stateNode;
              _ !== null && (_.passiveEffectDuration += u);
              return;
            case j:
              var n = v.stateNode;
              n !== null && (n.passiveEffectDuration += u);
              return;
          }
          v = v.return;
        }
      }
    }
    function Bf() {
      v0 = gs();
    }
    function y0() {
      zf = gs();
    }
    function Yc(s) {
      for (var u = s.child; u;) s.actualDuration += u.actualDuration, u = u.sibling;
    }
    function Em(s, u) {
      return {
        value: s,
        source: u,
        stack: hd(u),
        digest: null
      };
    }
    function Gc(s, u, v) {
      return {
        value: s,
        source: null,
        stack: v ?? null,
        digest: u ?? null
      };
    }
    function KC(s, u) {
      return !0;
    }
    function sx(s, u) {
      try {
        var v = KC(s, u);
        if (v === !1) return;
        var _ = u.value,
          n = u.source,
          a = u.stack,
          f = a !== null ? a : "";
        if (_ != null && _._suppressLogging) {
          if (s.tag === x) return;
          console.error(_);
        }
        var m = n ? At(n) : null,
          b = m ? "The above error occurred in the <" + m + "> component:" : "The above error occurred in one of your React components:",
          T;
        if (s.tag === C) T = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;else {
          var M = At(s) || "Anonymous";
          T = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + M + ".");
        }
        var z = b + `
` + f + `

` + ("" + T);
        console.error(z);
      } catch (U) {
        setTimeout(function () {
          throw U;
        });
      }
    }
    var Vy = typeof WeakMap == "function" ? WeakMap : Map;
    function i1(s, u, v) {
      var _ = Pf(wn, v);
      _.tag = LS, _.payload = {
        element: null
      };
      var n = u.value;
      return _.callback = function () {
        IA(n), sx(s, u);
      }, _;
    }
    function QC(s, u, v) {
      var _ = Pf(wn, v);
      _.tag = LS;
      var n = s.type.getDerivedStateFromError;
      if (typeof n == "function") {
        var a = u.value;
        _.payload = function () {
          return n(a);
        }, _.callback = function () {
          nb(s), sx(s, u);
        };
      }
      var f = s.stateNode;
      return f !== null && typeof f.componentDidCatch == "function" && (_.callback = function () {
        nb(s), sx(s, u), typeof n != "function" && Mm(this);
        var m = u.value,
          b = u.stack;
        this.componentDidCatch(m, {
          componentStack: b !== null ? b : ""
        }), typeof n != "function" && (_n(s.lanes, Je) || h("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", At(s) || "Unknown"));
      }), _;
    }
    function a1(s, u, v) {
      var _ = s.pingCache,
        n;
      if (_ === null ? (_ = s.pingCache = new Vy(), n = /* @__PURE__ */new Set(), _.set(u, n)) : (n = _.get(u), n === void 0 && (n = /* @__PURE__ */new Set(), _.set(u, n))), !n.has(v)) {
        n.add(v);
        var a = MA.bind(null, s, u, v);
        ui && Cx(s, v), u.then(a, a);
      }
    }
    function FP(s, u, v, _) {
      var n = s.updateQueue;
      if (n === null) {
        var a = /* @__PURE__ */new Set();
        a.add(v), s.updateQueue = a;
      } else n.add(v);
    }
    function BD(s, u) {
      var v = s.tag;
      if ((s.mode & Wt) === dt && (v === w || v === F || v === G)) {
        var _ = s.alternate;
        _ ? (s.updateQueue = _.updateQueue, s.memoizedState = _.memoizedState, s.lanes = _.lanes) : (s.updateQueue = null, s.memoizedState = null);
      }
    }
    function o1(s) {
      var u = s;
      do {
        if (u.tag === V && Sv(u)) return u;
        u = u.return;
      } while (u !== null);
      return null;
    }
    function ZC(s, u, v, _, n) {
      if ((s.mode & Wt) === dt) {
        if (s === u) s.flags |= Gr;else {
          if (s.flags |= ft, v.flags |= zd, v.flags &= -52805, v.tag === x) {
            var a = v.alternate;
            if (a === null) v.tag = te;else {
              var f = Pf(wn, Je);
              f.tag = y_, wm(v, f, Je);
            }
          }
          v.lanes = jt(v.lanes, Je);
        }
        return s;
      }
      return s.flags |= Gr, s.lanes = n, s;
    }
    function NP(s, u, v, _, n) {
      if (v.flags |= Gu, ui && Cx(s, n), _ !== null && typeof _ == "object" && typeof _.then == "function") {
        var a = _;
        BD(v), Pa() && v.mode & Wt && hm();
        var f = o1(u);
        if (f !== null) {
          f.flags &= -257, ZC(f, u, v, s, n), f.mode & Wt && a1(s, a, n), FP(f, s, a);
          return;
        } else {
          if (!Lw(n)) {
            a1(s, a, n), x1();
            return;
          }
          var m = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          _ = m;
        }
      } else if (Pa() && v.mode & Wt) {
        hm();
        var b = o1(u);
        if (b !== null) {
          (b.flags & Gr) === pt && (b.flags |= qr), ZC(b, u, v, s, n), RS(Em(_, v));
          return;
        }
      }
      _ = Em(_, v), CA(_);
      var T = u;
      do {
        switch (T.tag) {
          case C:
            {
              var M = _;
              T.flags |= Gr;
              var z = Xl(n);
              T.lanes = jt(T.lanes, z);
              var U = i1(T, M, z);
              mp(T, U);
              return;
            }
          case x:
            var X = _,
              J = T.type,
              me = T.stateNode;
            if ((T.flags & ft) === pt && (typeof J.getDerivedStateFromError == "function" || me !== null && typeof me.componentDidCatch == "function" && !TI(me))) {
              T.flags |= Gr;
              var Se = Xl(n);
              T.lanes = jt(T.lanes, Se);
              var Me = QC(T, X, Se);
              mp(T, Me);
              return;
            }
            break;
        }
        T = T.return;
      } while (T !== null);
    }
    function zP() {
      return null;
    }
    var b0 = i.ReactCurrentOwner,
      Xc = !1,
      JC,
      lx,
      By,
      xc,
      ux,
      Uf,
      cx,
      w0;
    JC = {}, lx = {}, By = {}, xc = {}, ux = {}, Uf = !1, cx = {}, w0 = {};
    function il(s, u, v, _) {
      s === null ? u.child = AC(u, null, v, _) : u.child = Ry(u, s.child, v, _);
    }
    function Uy(s, u, v, _) {
      u.child = Ry(u, s.child, null, _), u.child = Ry(u, null, v, _);
    }
    function s1(s, u, v, _, n) {
      if (u.type !== u.elementType) {
        var a = v.propTypes;
        a && Vc(a, _,
        // Resolved props
        "prop", bn(v));
      }
      var f = v.render,
        m = u.ref,
        b,
        T;
      Zb(u, n), Ti(u);
      {
        if (b0.current = u, br(!0), b = co(s, u, f, _, m, n), T = Cv(), u.mode & Xn) {
          En(!0);
          try {
            b = co(s, u, f, _, m, n), T = Cv();
          } finally {
            En(!1);
          }
        }
        br(!1);
      }
      return to(), s !== null && !Xc ? (Oy(s, u, n), yp(s, u, n)) : (Pa() && T && pm(u), u.flags |= Xi, il(s, u, b, n), u.child);
    }
    function dx(s, u, v, _, n) {
      if (s === null) {
        var a = v.type;
        if (FI(a) && v.compare === null &&
        // SimpleMemoComponent codepath doesn't resolve outer props either.
        v.defaultProps === void 0) {
          var f = a;
          return f = kp(a), u.tag = G, u.type = f, sk(u, a), hl(s, u, f, _, n);
        }
        {
          var m = a.propTypes;
          m && Vc(m, _,
          // Resolved props
          "prop", bn(a));
        }
        var b = Hk(v.type, null, _, u, u.mode, n);
        return b.ref = u.ref, b.return = u, u.child = b, b;
      }
      {
        var T = v.type,
          M = T.propTypes;
        M && Vc(M, _,
        // Resolved props
        "prop", bn(T));
      }
      var z = s.child,
        U = Hy(s, n);
      if (!U) {
        var X = z.memoizedProps,
          J = v.compare;
        if (J = J !== null ? J : he, J(X, _) && s.ref === u.ref) return yp(s, u, n);
      }
      u.flags |= Xi;
      var me = ts(z, _);
      return me.ref = u.ref, me.return = u, u.child = me, me;
    }
    function hl(s, u, v, _, n) {
      if (u.type !== u.elementType) {
        var a = u.elementType;
        if (a.$$typeof === Ct) {
          var f = a,
            m = f._payload,
            b = f._init;
          try {
            a = b(m);
          } catch {
            a = null;
          }
          var T = a && a.propTypes;
          T && Vc(T, _,
          // Resolved (SimpleMemoComponent has no defaultProps)
          "prop", bn(a));
        }
      }
      if (s !== null) {
        var M = s.memoizedProps;
        if (he(M, _) && s.ref === u.ref &&
        // Prevent bailout if the implementation changed due to hot reload.
        u.type === s.type) if (Xc = !1, u.pendingProps = _ = M, Hy(s, n)) (s.flags & zd) !== pt && (Xc = !0);else return u.lanes = s.lanes, yp(s, u, n);
      }
      return tk(s, u, v, _, n);
    }
    function UD(s, u, v) {
      var _ = u.pendingProps,
        n = _.children,
        a = s !== null ? s.memoizedState : null;
      if (_.mode === "hidden" || H) {
        if ((u.mode & Wt) === dt) {
          var f = {
            baseLanes: De,
            cachePool: null,
            transitions: null
          };
          u.memoizedState = f, O0(u, v);
        } else if (_n(v, Jr)) {
          var m = {
            baseLanes: De,
            cachePool: null,
            transitions: null
          };
          u.memoizedState = m;
          var b = a !== null ? a.baseLanes : v;
          O0(u, b);
        } else {
          var T = null,
            M;
          if (a !== null) {
            var z = a.baseLanes;
            M = jt(z, v);
          } else M = v;
          u.lanes = u.childLanes = Jr;
          var U = {
            baseLanes: M,
            cachePool: T,
            transitions: null
          };
          return u.memoizedState = U, u.updateQueue = null, O0(u, M), null;
        }
      } else {
        var X;
        a !== null ? (X = jt(a.baseLanes, v), u.memoizedState = null) : X = v, O0(u, X);
      }
      return il(s, u, n, v), u.child;
    }
    function HD(s, u, v) {
      var _ = u.pendingProps;
      return il(s, u, _, v), u.child;
    }
    function $D(s, u, v) {
      var _ = u.pendingProps.children;
      return il(s, u, _, v), u.child;
    }
    function WD(s, u, v) {
      {
        u.flags |= tn;
        {
          var _ = u.stateNode;
          _.effectDuration = 0, _.passiveEffectDuration = 0;
        }
      }
      var n = u.pendingProps,
        a = n.children;
      return il(s, u, a, v), u.child;
    }
    function ek(s, u) {
      var v = u.ref;
      (s === null && v !== null || s !== null && s.ref !== v) && (u.flags |= Hn, u.flags |= jl);
    }
    function tk(s, u, v, _, n) {
      if (u.type !== u.elementType) {
        var a = v.propTypes;
        a && Vc(a, _,
        // Resolved props
        "prop", bn(v));
      }
      var f;
      {
        var m = Jl(u, v, !0);
        f = Df(u, m);
      }
      var b, T;
      Zb(u, n), Ti(u);
      {
        if (b0.current = u, br(!0), b = co(s, u, v, _, f, n), T = Cv(), u.mode & Xn) {
          En(!0);
          try {
            b = co(s, u, v, _, f, n), T = Cv();
          } finally {
            En(!1);
          }
        }
        br(!1);
      }
      return to(), s !== null && !Xc ? (Oy(s, u, n), yp(s, u, n)) : (Pa() && T && pm(u), u.flags |= Xi, il(s, u, b, n), u.child);
    }
    function qD(s, u, v, _, n) {
      {
        switch (WA(u)) {
          case !1:
            {
              var a = u.stateNode,
                f = u.type,
                m = new f(u.memoizedProps, a.context),
                b = m.state;
              a.updater.enqueueSetState(a, b, null);
              break;
            }
          case !0:
            {
              u.flags |= ft, u.flags |= Gr;
              var T = new Error("Simulated error coming from DevTools"),
                M = Xl(n);
              u.lanes = jt(u.lanes, M);
              var z = QC(u, Em(T, u), M);
              mp(u, z);
              break;
            }
        }
        if (u.type !== u.elementType) {
          var U = v.propTypes;
          U && Vc(U, _,
          // Resolved props
          "prop", bn(v));
        }
      }
      var X;
      eu(v) ? (X = !0, c_(u)) : X = !1, Zb(u, n);
      var J = u.stateNode,
        me;
      J === null ? (u1(s, u), DD(u, v, _), MC(u, v, _, n), me = !0) : s === null ? me = MD(u, v, _, n) : me = OC(s, u, v, _, n);
      var Se = nk(s, u, v, me, X, n);
      {
        var Me = u.stateNode;
        me && Me.props !== _ && (Uf || h("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", At(u) || "a component"), Uf = !0);
      }
      return Se;
    }
    function nk(s, u, v, _, n, a) {
      ek(s, u);
      var f = (u.flags & ft) !== pt;
      if (!_ && !f) return n && pC(u, v, !1), yp(s, u, a);
      var m = u.stateNode;
      b0.current = u;
      var b;
      if (f && typeof v.getDerivedStateFromError != "function") b = null, VD();else {
        Ti(u);
        {
          if (br(!0), b = m.render(), u.mode & Xn) {
            En(!0);
            try {
              m.render();
            } finally {
              En(!1);
            }
          }
          br(!1);
        }
        to();
      }
      return u.flags |= Xi, s !== null && f ? Uy(s, u, b, a) : il(s, u, b, a), u.memoizedState = m.state, n && pC(u, v, !0), u.child;
    }
    function rk(s) {
      var u = s.stateNode;
      u.pendingContext ? u_(s, u.pendingContext, u.pendingContext !== u.context) : u.context && u_(s, u.context, !1), i0(s, u.containerInfo);
    }
    function ik(s, u, v) {
      if (rk(u), s === null) throw new Error("Should have a current fiber. This is a bug in React.");
      var _ = u.pendingProps,
        n = u.memoizedState,
        a = n.element;
      __(s, u), Jb(u, _, null, v);
      var f = u.memoizedState;
      u.stateNode;
      var m = f.element;
      if (n.isDehydrated) {
        var b = {
            element: m,
            isDehydrated: !1,
            cache: f.cache,
            pendingSuspenseBoundaries: f.pendingSuspenseBoundaries,
            transitions: f.transitions
          },
          T = u.updateQueue;
        if (T.baseState = b, u.memoizedState = b, u.flags & qr) {
          var M = Em(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), u);
          return ak(s, u, m, v, M);
        } else if (m !== a) {
          var z = Em(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), u);
          return ak(s, u, m, v, z);
        } else {
          xD(u);
          var U = AC(u, null, m, v);
          u.child = U;
          for (var X = U; X;) X.flags = X.flags & -3 | xi, X = X.sibling;
        }
      } else {
        if (Gb(), m === a) return yp(s, u, v);
        il(s, u, m, v);
      }
      return u.child;
    }
    function ak(s, u, v, _, n) {
      return Gb(), RS(n), u.flags |= qr, il(s, u, v, _), u.child;
    }
    function ok(s, u, v) {
      Iy(u), s === null && f_(u);
      var _ = u.type,
        n = u.pendingProps,
        a = s !== null ? s.memoizedProps : null,
        f = n.children,
        m = iC(_, n);
      return m ? f = null : a !== null && iC(_, a) && (u.flags |= Ki), ek(s, u), il(s, u, f, v), u.child;
    }
    function YD(s, u) {
      return s === null && f_(u), null;
    }
    function VP(s, u, v, _) {
      u1(s, u);
      var n = u.pendingProps,
        a = v,
        f = a._payload,
        m = a._init,
        b = m(f);
      u.type = b;
      var T = u.tag = FA(b),
        M = mu(b, n),
        z;
      switch (T) {
        case w:
          return sk(u, b), u.type = b = kp(b), z = tk(null, u, b, M, _), z;
        case x:
          return u.type = b = Su(b), z = qD(null, u, b, M, _), z;
        case F:
          return u.type = b = Nv(b), z = s1(null, u, b, M, _), z;
        case K:
          {
            if (u.type !== u.elementType) {
              var U = b.propTypes;
              U && Vc(U, M,
              // Resolved for outer only
              "prop", bn(b));
            }
            return z = dx(null, u, b, mu(b.type, M),
            // The inner type can have defaults too
            _), z;
          }
      }
      var X = "";
      throw b !== null && typeof b == "object" && b.$$typeof === Ct && (X = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + b + ". " + ("Lazy element type must resolve to a class or function." + X));
    }
    function GD(s, u, v, _, n) {
      u1(s, u), u.tag = x;
      var a;
      return eu(v) ? (a = !0, c_(u)) : a = !1, Zb(u, n), DD(u, v, _), MC(u, v, _, n), nk(null, u, v, !0, a, n);
    }
    function BP(s, u, v, _) {
      u1(s, u);
      var n = u.pendingProps,
        a;
      {
        var f = Jl(u, v, !1);
        a = Df(u, f);
      }
      Zb(u, _);
      var m, b;
      Ti(u);
      {
        if (v.prototype && typeof v.prototype.render == "function") {
          var T = bn(v) || "Unknown";
          JC[T] || (h("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", T, T), JC[T] = !0);
        }
        u.mode & Xn && Mf.recordLegacyContextWarning(u, null), br(!0), b0.current = u, m = co(null, u, v, n, a, _), b = Cv(), br(!1);
      }
      if (to(), u.flags |= Xi, typeof m == "object" && m !== null && typeof m.render == "function" && m.$$typeof === void 0) {
        var M = bn(v) || "Unknown";
        lx[M] || (h("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", M, M, M), lx[M] = !0);
      }
      if (
      // Run these checks in production only if the flag is off.
      // Eventually we'll delete this branch altogether.
      typeof m == "object" && m !== null && typeof m.render == "function" && m.$$typeof === void 0) {
        {
          var z = bn(v) || "Unknown";
          lx[z] || (h("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", z, z, z), lx[z] = !0);
        }
        u.tag = x, u.memoizedState = null, u.updateQueue = null;
        var U = !1;
        return eu(v) ? (U = !0, c_(u)) : U = !1, u.memoizedState = m.state !== null && m.state !== void 0 ? m.state : null, w_(u), DC(u, m), MC(u, v, n, _), nk(null, u, v, !0, U, _);
      } else {
        if (u.tag = w, u.mode & Xn) {
          En(!0);
          try {
            m = co(null, u, v, n, a, _), b = Cv();
          } finally {
            En(!1);
          }
        }
        return Pa() && b && pm(u), il(null, u, m, _), sk(u, v), u.child;
      }
    }
    function sk(s, u) {
      {
        if (u && u.childContextTypes && h("%s(...): childContextTypes cannot be defined on a function component.", u.displayName || u.name || "Component"), s.ref !== null) {
          var v = "",
            _ = yi();
          _ && (v += `

Check the render method of \`` + _ + "`.");
          var n = _ || "",
            a = s._debugSource;
          a && (n = a.fileName + ":" + a.lineNumber), ux[n] || (ux[n] = !0, h("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", v));
        }
        if (typeof u.getDerivedStateFromProps == "function") {
          var f = bn(u) || "Unknown";
          xc[f] || (h("%s: Function components do not support getDerivedStateFromProps.", f), xc[f] = !0);
        }
        if (typeof u.contextType == "object" && u.contextType !== null) {
          var m = bn(u) || "Unknown";
          By[m] || (h("%s: Function components do not support contextType.", m), By[m] = !0);
        }
      }
    }
    var lk = {
      dehydrated: null,
      treeContext: null,
      retryLane: On
    };
    function uk(s) {
      return {
        baseLanes: s,
        cachePool: zP(),
        transitions: null
      };
    }
    function UP(s, u) {
      var v = null;
      return {
        baseLanes: jt(s.baseLanes, u),
        cachePool: v,
        transitions: s.transitions
      };
    }
    function ck(s, u, v, _) {
      if (u !== null) {
        var n = u.memoizedState;
        if (n === null) return !1;
      }
      return My(s, a0);
    }
    function dk(s, u) {
      return ac(s.childLanes, u);
    }
    function l1(s, u, v) {
      var _ = u.pendingProps;
      UI(u) && (u.flags |= ft);
      var n = $c.current,
        a = !1,
        f = (u.flags & ft) !== pt;
      if (f || ck(n, s) ? (a = !0, u.flags &= -129) : (s === null || s.memoizedState !== null) && (n = o0(n, PD)), n = pl(n), vp(u, n), s === null) {
        f_(u);
        var m = u.memoizedState;
        if (m !== null) {
          var b = m.dehydrated;
          if (b !== null) return WP(u, b);
        }
        var T = _.children,
          M = _.fallback;
        if (a) {
          var z = HP(u, T, M, v),
            U = u.child;
          return U.memoizedState = uk(v), u.memoizedState = lk, z;
        } else return fk(u, T);
      } else {
        var X = s.memoizedState;
        if (X !== null) {
          var J = X.dehydrated;
          if (J !== null) return qP(s, u, f, _, J, X, v);
        }
        if (a) {
          var me = _.fallback,
            Se = _.children,
            Me = $P(s, u, Se, me, v),
            Pe = u.child,
            $e = s.child.memoizedState;
          return Pe.memoizedState = $e === null ? uk(v) : UP($e, v), Pe.childLanes = dk(s, v), u.memoizedState = lk, Me;
        } else {
          var mt = _.children,
            Re = mk(s, u, mt, v);
          return u.memoizedState = null, Re;
        }
      }
    }
    function fk(s, u, v) {
      var _ = s.mode,
        n = {
          mode: "visible",
          children: u
        },
        a = pk(n, _);
      return a.return = s, s.child = a, a;
    }
    function HP(s, u, v, _) {
      var n = s.mode,
        a = s.child,
        f = {
          mode: "hidden",
          children: u
        },
        m,
        b;
      return (n & Wt) === dt && a !== null ? (m = a, m.childLanes = De, m.pendingProps = f, s.mode & nn && (m.actualDuration = 0, m.actualStartTime = -1, m.selfBaseDuration = 0, m.treeBaseDuration = 0), b = zv(v, n, _, null)) : (m = pk(f, n), b = zv(v, n, _, null)), m.return = s, b.return = s, m.sibling = b, s.child = m, b;
    }
    function pk(s, u, v) {
      return Lm(s, u, De, null);
    }
    function hk(s, u) {
      return ts(s, u);
    }
    function mk(s, u, v, _) {
      var n = s.child,
        a = n.sibling,
        f = hk(n, {
          mode: "visible",
          children: v
        });
      if ((u.mode & Wt) === dt && (f.lanes = _), f.return = u, f.sibling = null, a !== null) {
        var m = u.deletions;
        m === null ? (u.deletions = [a], u.flags |= _i) : m.push(a);
      }
      return u.child = f, f;
    }
    function $P(s, u, v, _, n) {
      var a = u.mode,
        f = s.child,
        m = f.sibling,
        b = {
          mode: "hidden",
          children: v
        },
        T;
      if (
      // In legacy mode, we commit the primary tree as if it successfully
      // completed, even though it's in an inconsistent state.
      (a & Wt) === dt &&
      // Make sure we're on the second pass, i.e. the primary child fragment was
      // already cloned. In legacy mode, the only case where this isn't true is
      // when DevTools forces us to display a fallback; we skip the first render
      // pass entirely and go straight to rendering the fallback. (In Concurrent
      // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
      // only codepath.)
      u.child !== f) {
        var M = u.child;
        T = M, T.childLanes = De, T.pendingProps = b, u.mode & nn && (T.actualDuration = 0, T.actualStartTime = -1, T.selfBaseDuration = f.selfBaseDuration, T.treeBaseDuration = f.treeBaseDuration), u.deletions = null;
      } else T = hk(f, b), T.subtreeFlags = f.subtreeFlags & nr;
      var z;
      return m !== null ? z = ts(m, _) : (z = zv(_, a, n, null), z.flags |= Gn), z.return = u, T.return = u, T.sibling = z, u.child = T, z;
    }
    function _0(s, u, v, _) {
      _ !== null && RS(_), Ry(u, s.child, null, v);
      var n = u.pendingProps,
        a = n.children,
        f = fk(u, a);
      return f.flags |= Gn, u.memoizedState = null, f;
    }
    function XD(s, u, v, _, n) {
      var a = u.mode,
        f = {
          mode: "visible",
          children: v
        },
        m = pk(f, a),
        b = zv(_, a, n, null);
      return b.flags |= Gn, m.return = u, b.return = u, m.sibling = b, u.child = m, (u.mode & Wt) !== dt && Ry(u, s.child, null, n), b;
    }
    function WP(s, u, v) {
      return (s.mode & Wt) === dt ? (h("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), s.lanes = Je) : cC(u) ? s.lanes = xa : s.lanes = Jr, null;
    }
    function qP(s, u, v, _, n, a, f) {
      if (v) {
        if (u.flags & qr) {
          u.flags &= -257;
          var m = Gc(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return _0(s, u, f, m);
        } else {
          if (u.memoizedState !== null) return u.child = s.child, u.flags |= ft, null;
          var b = _.children,
            T = _.fallback,
            M = XD(s, u, b, T, f),
            z = u.child;
          return z.memoizedState = uk(f), u.memoizedState = lk, M;
        }
      } else {
        if (Sy(), (u.mode & Wt) === dt) return _0(s, u, f,
        // TODO: When we delete legacy mode, we should make this error argument
        // required — every concurrent mode path that causes hydration to
        // de-opt to client rendering should have an error message.
        null);
        if (cC(n)) {
          var U, X, J;
          {
            var me = gD(n);
            U = me.digest, X = me.message, J = me.stack;
          }
          var Se;
          X ? Se = new Error(X) : Se = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var Me = Gc(Se, U, J);
          return _0(s, u, f, Me);
        }
        var Pe = _n(f, s.childLanes);
        if (Xc || Pe) {
          var $e = Zy();
          if ($e !== null) {
            var mt = df($e, f);
            if (mt !== On && mt !== a.retryLane) {
              a.retryLane = mt;
              var Re = wn;
              vu(s, mt), Ba($e, s, mt, Re);
            }
          }
          x1();
          var Ue = Gc(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return _0(s, u, f, Ue);
        } else if (vD(n)) {
          u.flags |= ft, u.child = s.child;
          var Be = DI.bind(null, s);
          return dC(n, Be), null;
        } else {
          kP(u, n, a.treeContext);
          var nt = _.children,
            ke = fk(u, nt);
          return ke.flags |= xi, ke;
        }
      }
    }
    function fx(s, u, v) {
      s.lanes = jt(s.lanes, u);
      var _ = s.alternate;
      _ !== null && (_.lanes = jt(_.lanes, u)), MS(s.return, u, v);
    }
    function YP(s, u, v) {
      for (var _ = u; _ !== null;) {
        if (_.tag === V) {
          var n = _.memoizedState;
          n !== null && fx(_, v, s);
        } else if (_.tag === Y) fx(_, v, s);else if (_.child !== null) {
          _.child.return = _, _ = _.child;
          continue;
        }
        if (_ === s) return;
        for (; _.sibling === null;) {
          if (_.return === null || _.return === s) return;
          _ = _.return;
        }
        _.sibling.return = _.return, _ = _.sibling;
      }
    }
    function GP(s) {
      for (var u = s, v = null; u !== null;) {
        var _ = u.alternate;
        _ !== null && xm(_) === null && (v = u), u = u.sibling;
      }
      return v;
    }
    function XP(s) {
      if (s !== void 0 && s !== "forwards" && s !== "backwards" && s !== "together" && !cx[s]) if (cx[s] = !0, typeof s == "string") switch (s.toLowerCase()) {
        case "together":
        case "forwards":
        case "backwards":
          {
            h('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', s, s.toLowerCase());
            break;
          }
        case "forward":
        case "backward":
          {
            h('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', s, s.toLowerCase());
            break;
          }
        default:
          h('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', s);
          break;
      } else h('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', s);
    }
    function KD(s, u) {
      s !== void 0 && !w0[s] && (s !== "collapsed" && s !== "hidden" ? (w0[s] = !0, h('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', s)) : u !== "forwards" && u !== "backwards" && (w0[s] = !0, h('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', s)));
    }
    function QD(s, u) {
      {
        var v = wr(s),
          _ = !v && typeof yn(s) == "function";
        if (v || _) {
          var n = v ? "array" : "iterable";
          return h("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", n, u, n), !1;
        }
      }
      return !0;
    }
    function KP(s, u) {
      if ((u === "forwards" || u === "backwards") && s !== void 0 && s !== null && s !== !1) if (wr(s)) {
        for (var v = 0; v < s.length; v++) if (!QD(s[v], v)) return;
      } else {
        var _ = yn(s);
        if (typeof _ == "function") {
          var n = _.call(s);
          if (n) for (var a = n.next(), f = 0; !a.done; a = n.next()) {
            if (!QD(a.value, f)) return;
            f++;
          }
        } else h('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', u);
      }
    }
    function vk(s, u, v, _, n) {
      var a = s.memoizedState;
      a === null ? s.memoizedState = {
        isBackwards: u,
        rendering: null,
        renderingStartTime: 0,
        last: _,
        tail: v,
        tailMode: n
      } : (a.isBackwards = u, a.rendering = null, a.renderingStartTime = 0, a.last = _, a.tail = v, a.tailMode = n);
    }
    function ZD(s, u, v) {
      var _ = u.pendingProps,
        n = _.revealOrder,
        a = _.tail,
        f = _.children;
      XP(n), KD(a, n), KP(f, n), il(s, u, f, v);
      var m = $c.current,
        b = My(m, a0);
      if (b) m = z_(m, a0), u.flags |= ft;else {
        var T = s !== null && (s.flags & ft) !== pt;
        T && YP(u, u.child, v), m = pl(m);
      }
      if (vp(u, m), (u.mode & Wt) === dt) u.memoizedState = null;else switch (n) {
        case "forwards":
          {
            var M = GP(u.child),
              z;
            M === null ? (z = u.child, u.child = null) : (z = M.sibling, M.sibling = null), vk(u, !1,
            // isBackwards
            z, M, a);
            break;
          }
        case "backwards":
          {
            var U = null,
              X = u.child;
            for (u.child = null; X !== null;) {
              var J = X.alternate;
              if (J !== null && xm(J) === null) {
                u.child = X;
                break;
              }
              var me = X.sibling;
              X.sibling = U, U = X, X = me;
            }
            vk(u, !0,
            // isBackwards
            U, null,
            // last
            a);
            break;
          }
        case "together":
          {
            vk(u, !1,
            // isBackwards
            null,
            // tail
            null,
            // last
            void 0);
            break;
          }
        default:
          u.memoizedState = null;
      }
      return u.child;
    }
    function JD(s, u, v) {
      i0(u, u.stateNode.containerInfo);
      var _ = u.pendingProps;
      return s === null ? u.child = Ry(u, null, _, v) : il(s, u, _, v), u.child;
    }
    var eI = !1;
    function gk(s, u, v) {
      var _ = u.type,
        n = _._context,
        a = u.pendingProps,
        f = u.memoizedProps,
        m = a.value;
      {
        "value" in a || eI || (eI = !0, h("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var b = u.type.propTypes;
        b && Vc(b, a, "prop", "Context.Provider");
      }
      if (SC(u, n, m), f !== null) {
        var T = f.value;
        if (ae(T, m)) {
          if (f.children === a.children && !l_()) return yp(s, u, v);
        } else EC(u, n, v);
      }
      var M = a.children;
      return il(s, u, M, v), u.child;
    }
    var yk = !1;
    function QP(s, u, v) {
      var _ = u.type;
      _._context === void 0 ? _ !== _.Consumer && (yk || (yk = !0, h("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : _ = _._context;
      var n = u.pendingProps,
        a = n.children;
      typeof a != "function" && h("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), Zb(u, v);
      var f = ko(_);
      Ti(u);
      var m;
      return b0.current = u, br(!0), m = a(f), br(!1), to(), u.flags |= Xi, il(s, u, m, v), u.child;
    }
    function x0() {
      Xc = !0;
    }
    function u1(s, u) {
      (u.mode & Wt) === dt && s !== null && (s.alternate = null, u.alternate = null, u.flags |= Gn);
    }
    function yp(s, u, v) {
      return s !== null && (u.dependencies = s.dependencies), VD(), L0(u.lanes), _n(v, u.childLanes) ? (r0(s, u), u.child) : null;
    }
    function ZP(s, u, v) {
      {
        var _ = u.return;
        if (_ === null) throw new Error("Cannot swap the root fiber.");
        if (s.alternate = null, u.alternate = null, v.index = u.index, v.sibling = u.sibling, v.return = u.return, v.ref = u.ref, u === _.child) _.child = v;else {
          var n = _.child;
          if (n === null) throw new Error("Expected parent to have a child.");
          for (; n.sibling !== u;) if (n = n.sibling, n === null) throw new Error("Expected to find the previous sibling.");
          n.sibling = v;
        }
        var a = _.deletions;
        return a === null ? (_.deletions = [s], _.flags |= _i) : a.push(s), v.flags |= Gn, v;
      }
    }
    function Hy(s, u) {
      var v = s.lanes;
      return !!_n(v, u);
    }
    function c1(s, u, v) {
      switch (u.tag) {
        case C:
          rk(u), u.stateNode, Gb();
          break;
        case D:
          Iy(u);
          break;
        case x:
          {
            var _ = u.type;
            eu(_) && c_(u);
            break;
          }
        case k:
          i0(u, u.stateNode.containerInfo);
          break;
        case L:
          {
            var n = u.memoizedProps.value,
              a = u.type._context;
            SC(u, a, n);
            break;
          }
        case j:
          {
            var f = _n(v, u.childLanes);
            f && (u.flags |= tn);
            {
              var m = u.stateNode;
              m.effectDuration = 0, m.passiveEffectDuration = 0;
            }
          }
          break;
        case V:
          {
            var b = u.memoizedState;
            if (b !== null) {
              if (b.dehydrated !== null) return vp(u, pl($c.current)), u.flags |= ft, null;
              var T = u.child,
                M = T.childLanes;
              if (_n(v, M)) return l1(s, u, v);
              vp(u, pl($c.current));
              var z = yp(s, u, v);
              return z !== null ? z.sibling : null;
            } else vp(u, pl($c.current));
            break;
          }
        case Y:
          {
            var U = (s.flags & ft) !== pt,
              X = _n(v, u.childLanes);
            if (U) {
              if (X) return ZD(s, u, v);
              u.flags |= ft;
            }
            var J = u.memoizedState;
            if (J !== null && (J.rendering = null, J.tail = null, J.lastEffect = null), vp(u, $c.current), X) break;
            return null;
          }
        case oe:
        case ne:
          return u.lanes = De, UD(s, u, v);
      }
      return yp(s, u, v);
    }
    function bp(s, u, v) {
      if (u._debugNeedsRemount && s !== null) return ZP(s, u, Hk(u.type, u.key, u.pendingProps, u._debugOwner || null, u.mode, u.lanes));
      if (s !== null) {
        var _ = s.memoizedProps,
          n = u.pendingProps;
        if (_ !== n || l_() ||
        // Force a re-render if the implementation changed due to hot reload:
        u.type !== s.type) Xc = !0;else {
          var a = Hy(s, v);
          if (!a &&
          // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (u.flags & ft) === pt) return Xc = !1, c1(s, u, v);
          (s.flags & zd) !== pt ? Xc = !0 : Xc = !1;
        }
      } else if (Xc = !1, Pa() && dm(u)) {
        var f = u.index,
          m = fm();
        _D(u, m, f);
      }
      switch (u.lanes = De, u.tag) {
        case E:
          return BP(s, u, u.type, v);
        case Q:
          {
            var b = u.elementType;
            return VP(s, u, b, v);
          }
        case w:
          {
            var T = u.type,
              M = u.pendingProps,
              z = u.elementType === T ? M : mu(T, M);
            return tk(s, u, T, z, v);
          }
        case x:
          {
            var U = u.type,
              X = u.pendingProps,
              J = u.elementType === U ? X : mu(U, X);
            return qD(s, u, U, J, v);
          }
        case C:
          return ik(s, u, v);
        case D:
          return ok(s, u, v);
        case I:
          return YD(s, u);
        case V:
          return l1(s, u, v);
        case k:
          return JD(s, u, v);
        case F:
          {
            var me = u.type,
              Se = u.pendingProps,
              Me = u.elementType === me ? Se : mu(me, Se);
            return s1(s, u, me, Me, v);
          }
        case O:
          return HD(s, u, v);
        case P:
          return $D(s, u, v);
        case j:
          return WD(s, u, v);
        case L:
          return gk(s, u, v);
        case N:
          return QP(s, u, v);
        case K:
          {
            var Pe = u.type,
              $e = u.pendingProps,
              mt = mu(Pe, $e);
            if (u.type !== u.elementType) {
              var Re = Pe.propTypes;
              Re && Vc(Re, mt,
              // Resolved for outer only
              "prop", bn(Pe));
            }
            return mt = mu(Pe.type, mt), dx(s, u, Pe, mt, v);
          }
        case G:
          return hl(s, u, u.type, u.pendingProps, v);
        case te:
          {
            var Ue = u.type,
              Be = u.pendingProps,
              nt = u.elementType === Ue ? Be : mu(Ue, Be);
            return GD(s, u, Ue, nt, v);
          }
        case Y:
          return ZD(s, u, v);
        case ee:
          break;
        case oe:
          return UD(s, u, v);
      }
      throw new Error("Unknown unit of work tag (" + u.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function S0(s) {
      s.flags |= tn;
    }
    function d1(s) {
      s.flags |= Hn, s.flags |= jl;
    }
    var tI, f1, $y, bk;
    tI = function (s, u, v, _) {
      for (var n = u.child; n !== null;) {
        if (n.tag === D || n.tag === I) AL(s, n.stateNode);else if (n.tag !== k && n.child !== null) {
          n.child.return = n, n = n.child;
          continue;
        }
        if (n === u) return;
        for (; n.sibling === null;) {
          if (n.return === null || n.return === u) return;
          n = n.return;
        }
        n.sibling.return = n.return, n = n.sibling;
      }
    }, f1 = function (s, u) {}, $y = function (s, u, v, _, n) {
      var a = s.memoizedProps;
      if (a !== _) {
        var f = u.stateNode,
          m = F_(),
          b = FL(f, v, a, _, n, m);
        u.updateQueue = b, b && S0(u);
      }
    }, bk = function (s, u, v, _) {
      v !== _ && S0(u);
    };
    function E0(s, u) {
      if (!Pa()) switch (s.tailMode) {
        case "hidden":
          {
            for (var v = s.tail, _ = null; v !== null;) v.alternate !== null && (_ = v), v = v.sibling;
            _ === null ? s.tail = null : _.sibling = null;
            break;
          }
        case "collapsed":
          {
            for (var n = s.tail, a = null; n !== null;) n.alternate !== null && (a = n), n = n.sibling;
            a === null ? !u && s.tail !== null ? s.tail.sibling = null : s.tail = null : a.sibling = null;
            break;
          }
      }
    }
    function Zo(s) {
      var u = s.alternate !== null && s.alternate.child === s.child,
        v = De,
        _ = pt;
      if (u) {
        if ((s.mode & nn) !== dt) {
          for (var n = s.selfBaseDuration, a = s.child; a !== null;) v = jt(v, jt(a.lanes, a.childLanes)), _ |= a.subtreeFlags & nr, _ |= a.flags & nr, n += a.treeBaseDuration, a = a.sibling;
          s.treeBaseDuration = n;
        } else for (var f = s.child; f !== null;) v = jt(v, jt(f.lanes, f.childLanes)), _ |= f.subtreeFlags & nr, _ |= f.flags & nr, f.return = s, f = f.sibling;
        s.subtreeFlags |= _;
      } else {
        if ((s.mode & nn) !== dt) {
          for (var m = s.actualDuration, b = s.selfBaseDuration, T = s.child; T !== null;) v = jt(v, jt(T.lanes, T.childLanes)), _ |= T.subtreeFlags, _ |= T.flags, m += T.actualDuration, b += T.treeBaseDuration, T = T.sibling;
          s.actualDuration = m, s.treeBaseDuration = b;
        } else for (var M = s.child; M !== null;) v = jt(v, jt(M.lanes, M.childLanes)), _ |= M.subtreeFlags, _ |= M.flags, M.return = s, M = M.sibling;
        s.subtreeFlags |= _;
      }
      return s.childLanes = v, u;
    }
    function nI(s, u, v) {
      if (kD() && (u.mode & Wt) !== dt && (u.flags & ft) === pt) return p_(u), Gb(), u.flags |= qr | Gu | Gr, !1;
      var _ = TS(u);
      if (v !== null && v.dehydrated !== null) {
        if (s === null) {
          if (!_) throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (TP(u), Zo(u), (u.mode & nn) !== dt) {
            var n = v !== null;
            if (n) {
              var a = u.child;
              a !== null && (u.treeBaseDuration -= a.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (Gb(), (u.flags & ft) === pt && (u.memoizedState = null), u.flags |= tn, Zo(u), (u.mode & nn) !== dt) {
            var f = v !== null;
            if (f) {
              var m = u.child;
              m !== null && (u.treeBaseDuration -= m.treeBaseDuration);
            }
          }
          return !1;
        }
      } else return _C(), !0;
    }
    function wk(s, u, v) {
      var _ = u.pendingProps;
      switch (Yb(u), u.tag) {
        case E:
        case Q:
        case G:
        case w:
        case F:
        case O:
        case P:
        case j:
        case N:
        case K:
          return Zo(u), null;
        case x:
          {
            var n = u.type;
            return eu(n) && by(u), Zo(u), null;
          }
        case C:
          {
            var a = u.stateNode;
            if (Dy(u), Bc(u), Qo(), a.pendingContext && (a.context = a.pendingContext, a.pendingContext = null), s === null || s.child === null) {
              var f = TS(u);
              if (f) S0(u);else if (s !== null) {
                var m = s.memoizedState;
                (!m.isDehydrated ||
                // Check if we reverted to client rendering (e.g. due to an error)
                (u.flags & qr) !== pt) && (u.flags |= or, _C());
              }
            }
            return f1(s, u), Zo(u), null;
          }
        case D:
          {
            N_(u);
            var b = j_(),
              T = u.type;
            if (s !== null && u.stateNode != null) $y(s, u, T, _, b), s.ref !== u.ref && d1(u);else {
              if (!_) {
                if (u.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                return Zo(u), null;
              }
              var M = F_(),
                z = TS(u);
              if (z) bC(u, b, M) && S0(u);else {
                var U = PL(T, _, b, M, u);
                tI(U, u, !1, !1), u.stateNode = U, jL(U, T, _, b) && S0(u);
              }
              u.ref !== null && d1(u);
            }
            return Zo(u), null;
          }
        case I:
          {
            var X = _;
            if (s && u.stateNode != null) {
              var J = s.memoizedProps;
              bk(s, u, J, X);
            } else {
              if (typeof X != "string" && u.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              var me = j_(),
                Se = F_(),
                Me = TS(u);
              Me ? wC(u) && S0(u) : u.stateNode = NL(X, me, Se, u);
            }
            return Zo(u), null;
          }
        case V:
          {
            s0(u);
            var Pe = u.memoizedState;
            if (s === null || s.memoizedState !== null && s.memoizedState.dehydrated !== null) {
              var $e = nI(s, u, Pe);
              if (!$e) return u.flags & Gr ? u : null;
            }
            if ((u.flags & ft) !== pt) return u.lanes = v, (u.mode & nn) !== dt && Yc(u), u;
            var mt = Pe !== null,
              Re = s !== null && s.memoizedState !== null;
            if (mt !== Re && mt) {
              var Ue = u.child;
              if (Ue.flags |= tr, (u.mode & Wt) !== dt) {
                var Be = s === null && (u.memoizedProps.unstable_avoidThisFallback !== !0 || !0);
                Be || My($c.current, PD) ? EI() : x1();
              }
            }
            var nt = u.updateQueue;
            if (nt !== null && (u.flags |= tn), Zo(u), (u.mode & nn) !== dt && mt) {
              var ke = u.child;
              ke !== null && (u.treeBaseDuration -= ke.treeBaseDuration);
            }
            return null;
          }
        case k:
          return Dy(u), f1(s, u), s === null && _P(u.stateNode.containerInfo), Zo(u), null;
        case L:
          var Fe = u.type._context;
          return IS(Fe, u), Zo(u), null;
        case te:
          {
            var Ie = u.type;
            return eu(Ie) && by(u), Zo(u), null;
          }
        case Y:
          {
            s0(u);
            var Qe = u.memoizedState;
            if (Qe === null) return Zo(u), null;
            var Tt = (u.flags & ft) !== pt,
              _t = Qe.rendering;
            if (_t === null) {
              if (Tt) E0(Qe, !1);else {
                var an = xx() && (s === null || (s.flags & ft) === pt);
                if (!an) for (var Gt = u.child; Gt !== null;) {
                  var Pn = xm(Gt);
                  if (Pn !== null) {
                    Tt = !0, u.flags |= ft, E0(Qe, !1);
                    var Fn = Pn.updateQueue;
                    return Fn !== null && (u.updateQueue = Fn, u.flags |= tn), u.subtreeFlags = pt, OD(u, v), vp(u, z_($c.current, a0)), u.child;
                  }
                  Gt = Gt.sibling;
                }
                Qe.tail !== null && sr() > kk() && (u.flags |= ft, Tt = !0, E0(Qe, !1), u.lanes = of);
              }
            } else {
              if (!Tt) {
                var kr = xm(_t);
                if (kr !== null) {
                  u.flags |= ft, Tt = !0;
                  var qn = kr.updateQueue;
                  if (qn !== null && (u.updateQueue = qn, u.flags |= tn), E0(Qe, !0), Qe.tail === null && Qe.tailMode === "hidden" && !_t.alternate && !Pa()) return Zo(u), null;
                } else sr() * 2 - Qe.renderingStartTime > kk() && v !== Jr && (u.flags |= ft, Tt = !0, E0(Qe, !1), u.lanes = of);
              }
              if (Qe.isBackwards) _t.sibling = u.child, u.child = _t;else {
                var Tr = Qe.last;
                Tr !== null ? Tr.sibling = _t : u.child = _t, Qe.last = _t;
              }
            }
            if (Qe.tail !== null) {
              var ai = Qe.tail;
              Qe.rendering = ai, Qe.tail = ai.sibling, Qe.renderingStartTime = sr(), ai.sibling = null;
              var Br = $c.current;
              return Tt ? Br = z_(Br, a0) : Br = pl(Br), vp(u, Br), ai;
            }
            return Zo(u), null;
          }
        case ee:
          break;
        case oe:
        case ne:
          {
            Ik(u);
            var ho = u.memoizedState,
              Ro = ho !== null;
            if (s !== null) {
              var ns = s.memoizedState,
                ta = ns !== null;
              ta !== Ro && (u.flags |= tr);
            }
            return !Ro || (u.mode & Wt) === dt ? Zo(u) : _n(Wn, Jr) && (Zo(u), u.subtreeFlags & (Gn | tn) && (u.flags |= tr)), null;
          }
        case se:
          return null;
        case ue:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + u.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function px(s, u, v) {
      switch (Yb(u), u.tag) {
        case x:
          {
            var _ = u.type;
            eu(_) && by(u);
            var n = u.flags;
            return n & Gr ? (u.flags = n & -65537 | ft, (u.mode & nn) !== dt && Yc(u), u) : null;
          }
        case C:
          {
            u.stateNode, Dy(u), Bc(u), Qo();
            var a = u.flags;
            return (a & Gr) !== pt && (a & ft) === pt ? (u.flags = a & -65537 | ft, u) : null;
          }
        case D:
          return N_(u), null;
        case V:
          {
            s0(u);
            var f = u.memoizedState;
            if (f !== null && f.dehydrated !== null) {
              if (u.alternate === null) throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
              Gb();
            }
            var m = u.flags;
            return m & Gr ? (u.flags = m & -65537 | ft, (u.mode & nn) !== dt && Yc(u), u) : null;
          }
        case Y:
          return s0(u), null;
        case k:
          return Dy(u), null;
        case L:
          var b = u.type._context;
          return IS(b, u), null;
        case oe:
        case ne:
          return Ik(u), null;
        case se:
          return null;
        default:
          return null;
      }
    }
    function ys(s, u, v) {
      switch (Yb(u), u.tag) {
        case x:
          {
            var _ = u.type.childContextTypes;
            _ != null && by(u);
            break;
          }
        case C:
          {
            u.stateNode, Dy(u), Bc(u), Qo();
            break;
          }
        case D:
          {
            N_(u);
            break;
          }
        case k:
          Dy(u);
          break;
        case V:
          s0(u);
          break;
        case Y:
          s0(u);
          break;
        case L:
          var n = u.type._context;
          IS(n, u);
          break;
        case oe:
        case ne:
          Ik(u);
          break;
      }
    }
    var rI = null;
    rI = /* @__PURE__ */new Set();
    var hx = !1,
      al = !1,
      iI = typeof WeakSet == "function" ? WeakSet : Set,
      dn = null,
      Cm = null,
      Na = null;
    function JP(s) {
      Vo(null, function () {
        throw s;
      }), Yu();
    }
    var fn = function (s, u) {
      if (u.props = s.memoizedProps, u.state = s.memoizedState, s.mode & nn) try {
        Bf(), u.componentWillUnmount();
      } finally {
        Vf(s);
      } else u.componentWillUnmount();
    };
    function Wy(s, u) {
      try {
        Iv(Er, s);
      } catch (v) {
        Fi(s, u, v);
      }
    }
    function Dv(s, u, v) {
      try {
        fn(s, v);
      } catch (_) {
        Fi(s, u, _);
      }
    }
    function eA(s, u, v) {
      try {
        v.componentDidMount();
      } catch (_) {
        Fi(s, u, _);
      }
    }
    function aI(s, u) {
      try {
        uI(s);
      } catch (v) {
        Fi(s, u, v);
      }
    }
    function qy(s, u) {
      var v = s.ref;
      if (v !== null) if (typeof v == "function") {
        var _;
        try {
          if (Ee && fe && s.mode & nn) try {
            Bf(), _ = v(null);
          } finally {
            Vf(s);
          } else _ = v(null);
        } catch (n) {
          Fi(s, u, n);
        }
        typeof _ == "function" && h("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", At(s));
      } else v.current = null;
    }
    function C0(s, u, v) {
      try {
        v();
      } catch (_) {
        Fi(s, u, _);
      }
    }
    var oI = !1;
    function sI(s, u) {
      LL(s.containerInfo), dn = u, k0();
      var v = oI;
      return oI = !1, v;
    }
    function k0() {
      for (; dn !== null;) {
        var s = dn,
          u = s.child;
        (s.subtreeFlags & Uo) !== pt && u !== null ? (u.return = s, dn = u) : p1();
      }
    }
    function p1() {
      for (; dn !== null;) {
        var s = dn;
        Rn(s);
        try {
          lI(s);
        } catch (v) {
          Fi(s, s.return, v);
        }
        Un();
        var u = s.sibling;
        if (u !== null) {
          u.return = s.return, dn = u;
          return;
        }
        dn = s.return;
      }
    }
    function lI(s) {
      var u = s.alternate,
        v = s.flags;
      if ((v & or) !== pt) {
        switch (Rn(s), s.tag) {
          case w:
          case F:
          case G:
            break;
          case x:
            {
              if (u !== null) {
                var _ = u.memoizedProps,
                  n = u.memoizedState,
                  a = s.stateNode;
                s.type === s.elementType && !Uf && (a.props !== s.memoizedProps && h("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", At(s) || "instance"), a.state !== s.memoizedState && h("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", At(s) || "instance"));
                var f = a.getSnapshotBeforeUpdate(s.elementType === s.type ? _ : mu(s.type, _), n);
                {
                  var m = rI;
                  f === void 0 && !m.has(s.type) && (m.add(s.type), h("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", At(s)));
                }
                a.__reactInternalSnapshotBeforeUpdate = f;
              }
              break;
            }
          case C:
            {
              {
                var b = s.stateNode;
                ZL(b.containerInfo);
              }
              break;
            }
          case D:
          case I:
          case k:
          case te:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        Un();
      }
    }
    function Hf(s, u, v) {
      var _ = u.updateQueue,
        n = _ !== null ? _.lastEffect : null;
      if (n !== null) {
        var a = n.next,
          f = a;
        do {
          if ((f.tag & s) === s) {
            var m = f.destroy;
            f.destroy = void 0, m !== void 0 && ((s & Ui) !== gu ? Bg(u) : (s & Er) !== gu && Mh(u), (s & Ta) !== gu && A0(!0), C0(u, v, m), (s & Ta) !== gu && A0(!1), (s & Ui) !== gu ? Ug() : (s & Er) !== gu && Oh());
          }
          f = f.next;
        } while (f !== a);
      }
    }
    function Iv(s, u) {
      var v = u.updateQueue,
        _ = v !== null ? v.lastEffect : null;
      if (_ !== null) {
        var n = _.next,
          a = n;
        do {
          if ((a.tag & s) === s) {
            (s & Ui) !== gu ? Vg(u) : (s & Er) !== gu && Ih(u);
            var f = a.create;
            (s & Ta) !== gu && A0(!0), a.destroy = f(), (s & Ta) !== gu && A0(!1), (s & Ui) !== gu ? qd() : (s & Er) !== gu && Yd();
            {
              var m = a.destroy;
              if (m !== void 0 && typeof m != "function") {
                var b = void 0;
                (a.tag & Er) !== pt ? b = "useLayoutEffect" : (a.tag & Ta) !== pt ? b = "useInsertionEffect" : b = "useEffect";
                var T = void 0;
                m === null ? T = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof m.then == "function" ? T = `

It looks like you wrote ` + b + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + b + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : T = " You returned: " + m, h("%s must not return anything besides a function, which is used for clean-up.%s", b, T);
              }
            }
          }
          a = a.next;
        } while (a !== n);
      }
    }
    function tA(s, u) {
      if ((u.flags & tn) !== pt) switch (u.tag) {
        case j:
          {
            var v = u.stateNode.passiveEffectDuration,
              _ = u.memoizedProps,
              n = _.id,
              a = _.onPostCommit,
              f = GC(),
              m = u.alternate === null ? "mount" : "update";
            g0() && (m = "nested-update"), typeof a == "function" && a(n, m, v, f);
            var b = u.return;
            e: for (; b !== null;) {
              switch (b.tag) {
                case C:
                  var T = b.stateNode;
                  T.passiveEffectDuration += v;
                  break e;
                case j:
                  var M = b.stateNode;
                  M.passiveEffectDuration += v;
                  break e;
              }
              b = b.return;
            }
            break;
          }
      }
    }
    function nA(s, u, v, _) {
      if ((v.flags & $o) !== pt) switch (v.tag) {
        case w:
        case F:
        case G:
          {
            if (!al) if (v.mode & nn) try {
              Bf(), Iv(Er | ja, v);
            } finally {
              Vf(v);
            } else Iv(Er | ja, v);
            break;
          }
        case x:
          {
            var n = v.stateNode;
            if (v.flags & tn && !al) if (u === null) {
              if (v.type === v.elementType && !Uf && (n.props !== v.memoizedProps && h("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", At(v) || "instance"), n.state !== v.memoizedState && h("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", At(v) || "instance")), v.mode & nn) try {
                Bf(), n.componentDidMount();
              } finally {
                Vf(v);
              } else n.componentDidMount();
            } else {
              var a = v.elementType === v.type ? u.memoizedProps : mu(v.type, u.memoizedProps),
                f = u.memoizedState;
              if (v.type === v.elementType && !Uf && (n.props !== v.memoizedProps && h("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", At(v) || "instance"), n.state !== v.memoizedState && h("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", At(v) || "instance")), v.mode & nn) try {
                Bf(), n.componentDidUpdate(a, f, n.__reactInternalSnapshotBeforeUpdate);
              } finally {
                Vf(v);
              } else n.componentDidUpdate(a, f, n.__reactInternalSnapshotBeforeUpdate);
            }
            var m = v.updateQueue;
            m !== null && (v.type === v.elementType && !Uf && (n.props !== v.memoizedProps && h("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", At(v) || "instance"), n.state !== v.memoizedState && h("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", At(v) || "instance")), kC(v, m, n));
            break;
          }
        case C:
          {
            var b = v.updateQueue;
            if (b !== null) {
              var T = null;
              if (v.child !== null) switch (v.child.tag) {
                case D:
                  T = v.child.stateNode;
                  break;
                case x:
                  T = v.child.stateNode;
                  break;
              }
              kC(v, b, T);
            }
            break;
          }
        case D:
          {
            var M = v.stateNode;
            if (u === null && v.flags & tn) {
              var z = v.type,
                U = v.memoizedProps;
              VL(M, z, U);
            }
            break;
          }
        case I:
          break;
        case k:
          break;
        case j:
          {
            {
              var X = v.memoizedProps,
                J = X.onCommit,
                me = X.onRender,
                Se = v.stateNode.effectDuration,
                Me = GC(),
                Pe = u === null ? "mount" : "update";
              g0() && (Pe = "nested-update"), typeof me == "function" && me(v.memoizedProps.id, Pe, v.actualDuration, v.treeBaseDuration, v.actualStartTime, Me);
              {
                typeof J == "function" && J(v.memoizedProps.id, Pe, Se, Me), kI(v);
                var $e = v.return;
                e: for (; $e !== null;) {
                  switch ($e.tag) {
                    case C:
                      var mt = $e.stateNode;
                      mt.effectDuration += Se;
                      break e;
                    case j:
                      var Re = $e.stateNode;
                      Re.effectDuration += Se;
                      break e;
                  }
                  $e = $e.return;
                }
              }
            }
            break;
          }
        case V:
          {
            aA(s, v);
            break;
          }
        case Y:
        case te:
        case ee:
        case oe:
        case ne:
        case ue:
          break;
        default:
          throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
      }
      al || v.flags & Hn && uI(v);
    }
    function $f(s) {
      switch (s.tag) {
        case w:
        case F:
        case G:
          {
            if (s.mode & nn) try {
              Bf(), Wy(s, s.return);
            } finally {
              Vf(s);
            } else Wy(s, s.return);
            break;
          }
        case x:
          {
            var u = s.stateNode;
            typeof u.componentDidMount == "function" && eA(s, s.return, u), aI(s, s.return);
            break;
          }
        case D:
          {
            aI(s, s.return);
            break;
          }
      }
    }
    function Mv(s, u) {
      for (var v = null, _ = s;;) {
        if (_.tag === D) {
          if (v === null) {
            v = _;
            try {
              var n = _.stateNode;
              u ? uC(n) : KL(_.stateNode, _.memoizedProps);
            } catch (f) {
              Fi(s, s.return, f);
            }
          }
        } else if (_.tag === I) {
          if (v === null) try {
            var a = _.stateNode;
            u ? XL(a) : QL(a, _.memoizedProps);
          } catch (f) {
            Fi(s, s.return, f);
          }
        } else if (!((_.tag === oe || _.tag === ne) && _.memoizedState !== null && _ !== s) && _.child !== null) {
          _.child.return = _, _ = _.child;
          continue;
        }
        if (_ === s) return;
        for (; _.sibling === null;) {
          if (_.return === null || _.return === s) return;
          v === _ && (v = null), _ = _.return;
        }
        v === _ && (v = null), _.sibling.return = _.return, _ = _.sibling;
      }
    }
    function uI(s) {
      var u = s.ref;
      if (u !== null) {
        var v = s.stateNode,
          _;
        switch (s.tag) {
          case D:
            _ = v;
            break;
          default:
            _ = v;
        }
        if (typeof u == "function") {
          var n;
          if (s.mode & nn) try {
            Bf(), n = u(_);
          } finally {
            Vf(s);
          } else n = u(_);
          typeof n == "function" && h("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", At(s));
        } else u.hasOwnProperty("current") || h("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", At(s)), u.current = _;
      }
    }
    function rA(s) {
      var u = s.alternate;
      u !== null && (u.return = null), s.return = null;
    }
    function cI(s) {
      var u = s.alternate;
      u !== null && (s.alternate = null, cI(u));
      {
        if (s.child = null, s.deletions = null, s.sibling = null, s.tag === D) {
          var v = s.stateNode;
          v !== null && xP(v);
        }
        s.stateNode = null, s._debugOwner = null, s.return = null, s.dependencies = null, s.memoizedProps = null, s.memoizedState = null, s.pendingProps = null, s.stateNode = null, s.updateQueue = null;
      }
    }
    function iA(s) {
      for (var u = s.return; u !== null;) {
        if (_k(u)) return u;
        u = u.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function _k(s) {
      return s.tag === D || s.tag === C || s.tag === k;
    }
    function dI(s) {
      var u = s;
      e: for (;;) {
        for (; u.sibling === null;) {
          if (u.return === null || _k(u.return)) return null;
          u = u.return;
        }
        for (u.sibling.return = u.return, u = u.sibling; u.tag !== D && u.tag !== I && u.tag !== ie;) {
          if (u.flags & Gn || u.child === null || u.tag === k) continue e;
          u.child.return = u, u = u.child;
        }
        if (!(u.flags & Gn)) return u.stateNode;
      }
    }
    function fI(s) {
      var u = iA(s);
      switch (u.tag) {
        case D:
          {
            var v = u.stateNode;
            u.flags & Ki && (hD(v), u.flags &= -33);
            var _ = dI(s);
            h1(s, _, v);
            break;
          }
        case C:
        case k:
          {
            var n = u.stateNode.containerInfo,
              a = dI(s);
            xk(s, a, n);
            break;
          }
        // eslint-disable-next-line-no-fallthrough
        default:
          throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function xk(s, u, v) {
      var _ = s.tag,
        n = _ === D || _ === I;
      if (n) {
        var a = s.stateNode;
        u ? WL(v, a, u) : HL(v, a);
      } else if (_ !== k) {
        var f = s.child;
        if (f !== null) {
          xk(f, u, v);
          for (var m = f.sibling; m !== null;) xk(m, u, v), m = m.sibling;
        }
      }
    }
    function h1(s, u, v) {
      var _ = s.tag,
        n = _ === D || _ === I;
      if (n) {
        var a = s.stateNode;
        u ? $L(v, a, u) : mD(v, a);
      } else if (_ !== k) {
        var f = s.child;
        if (f !== null) {
          h1(f, u, v);
          for (var m = f.sibling; m !== null;) h1(m, u, v), m = m.sibling;
        }
      }
    }
    var bs = null,
      Wf = !1;
    function Sk(s, u, v) {
      {
        var _ = u;
        e: for (; _ !== null;) {
          switch (_.tag) {
            case D:
              {
                bs = _.stateNode, Wf = !1;
                break e;
              }
            case C:
              {
                bs = _.stateNode.containerInfo, Wf = !0;
                break e;
              }
            case k:
              {
                bs = _.stateNode.containerInfo, Wf = !0;
                break e;
              }
          }
          _ = _.return;
        }
        if (bs === null) throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        ws(s, u, v), bs = null, Wf = !1;
      }
      rA(v);
    }
    function wp(s, u, v) {
      for (var _ = v.child; _ !== null;) ws(s, u, _), _ = _.sibling;
    }
    function ws(s, u, v) {
      switch (Ng(v), v.tag) {
        case D:
          al || qy(v, u);
        // eslint-disable-next-line-no-fallthrough
        case I:
          {
            {
              var _ = bs,
                n = Wf;
              bs = null, wp(s, u, v), bs = _, Wf = n, bs !== null && (Wf ? YL(bs, v.stateNode) : qL(bs, v.stateNode));
            }
            return;
          }
        case ie:
          {
            bs !== null && (Wf ? GL(bs, v.stateNode) : lC(bs, v.stateNode));
            return;
          }
        case k:
          {
            {
              var a = bs,
                f = Wf;
              bs = v.stateNode.containerInfo, Wf = !0, wp(s, u, v), bs = a, Wf = f;
            }
            return;
          }
        case w:
        case F:
        case K:
        case G:
          {
            if (!al) {
              var m = v.updateQueue;
              if (m !== null) {
                var b = m.lastEffect;
                if (b !== null) {
                  var T = b.next,
                    M = T;
                  do {
                    var z = M,
                      U = z.destroy,
                      X = z.tag;
                    U !== void 0 && ((X & Ta) !== gu ? C0(v, u, U) : (X & Er) !== gu && (Mh(v), v.mode & nn ? (Bf(), C0(v, u, U), Vf(v)) : C0(v, u, U), Oh())), M = M.next;
                  } while (M !== T);
                }
              }
            }
            wp(s, u, v);
            return;
          }
        case x:
          {
            if (!al) {
              qy(v, u);
              var J = v.stateNode;
              typeof J.componentWillUnmount == "function" && Dv(v, u, J);
            }
            wp(s, u, v);
            return;
          }
        case ee:
          {
            wp(s, u, v);
            return;
          }
        case oe:
          {
            if (
            // TODO: Remove this dead flag
            v.mode & Wt) {
              var me = al;
              al = me || v.memoizedState !== null, wp(s, u, v), al = me;
            } else wp(s, u, v);
            break;
          }
        default:
          {
            wp(s, u, v);
            return;
          }
      }
    }
    function qf(s) {
      s.memoizedState;
    }
    function aA(s, u) {
      var v = u.memoizedState;
      if (v === null) {
        var _ = u.alternate;
        if (_ !== null) {
          var n = _.memoizedState;
          if (n !== null) {
            var a = n.dehydrated;
            a !== null && bD(a);
          }
        }
      }
    }
    function km(s) {
      var u = s.updateQueue;
      if (u !== null) {
        s.updateQueue = null;
        var v = s.stateNode;
        v === null && (v = s.stateNode = new iI()), u.forEach(function (_) {
          var n = Ni.bind(null, s, _);
          if (!v.has(_)) {
            if (v.add(_), ui) if (Cm !== null && Na !== null) Cx(Na, Cm);else throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            _.then(n, n);
          }
        });
      }
    }
    function pI(s, u, v) {
      Cm = v, Na = s, Rn(u), hI(u, s), Rn(u), Cm = null, Na = null;
    }
    function Yf(s, u, v) {
      var _ = u.deletions;
      if (_ !== null) for (var n = 0; n < _.length; n++) {
        var a = _[n];
        try {
          Sk(s, u, a);
        } catch (b) {
          Fi(a, u, b);
        }
      }
      var f = Mu();
      if (u.subtreeFlags & Ho) for (var m = u.child; m !== null;) Rn(m), hI(m, s), m = m.sibling;
      Rn(f);
    }
    function hI(s, u, v) {
      var _ = s.alternate,
        n = s.flags;
      switch (s.tag) {
        case w:
        case F:
        case K:
        case G:
          {
            if (Yf(u, s), Gf(s), n & tn) {
              try {
                Hf(Ta | ja, s, s.return), Iv(Ta | ja, s);
              } catch (Ie) {
                Fi(s, s.return, Ie);
              }
              if (s.mode & nn) {
                try {
                  Bf(), Hf(Er | ja, s, s.return);
                } catch (Ie) {
                  Fi(s, s.return, Ie);
                }
                Vf(s);
              } else try {
                Hf(Er | ja, s, s.return);
              } catch (Ie) {
                Fi(s, s.return, Ie);
              }
            }
            return;
          }
        case x:
          {
            Yf(u, s), Gf(s), n & Hn && _ !== null && qy(_, _.return);
            return;
          }
        case D:
          {
            Yf(u, s), Gf(s), n & Hn && _ !== null && qy(_, _.return);
            {
              if (s.flags & Ki) {
                var a = s.stateNode;
                try {
                  hD(a);
                } catch (Ie) {
                  Fi(s, s.return, Ie);
                }
              }
              if (n & tn) {
                var f = s.stateNode;
                if (f != null) {
                  var m = s.memoizedProps,
                    b = _ !== null ? _.memoizedProps : m,
                    T = s.type,
                    M = s.updateQueue;
                  if (s.updateQueue = null, M !== null) try {
                    BL(f, M, T, b, m, s);
                  } catch (Ie) {
                    Fi(s, s.return, Ie);
                  }
                }
              }
            }
            return;
          }
        case I:
          {
            if (Yf(u, s), Gf(s), n & tn) {
              if (s.stateNode === null) throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
              var z = s.stateNode,
                U = s.memoizedProps,
                X = _ !== null ? _.memoizedProps : U;
              try {
                UL(z, X, U);
              } catch (Ie) {
                Fi(s, s.return, Ie);
              }
            }
            return;
          }
        case C:
          {
            if (Yf(u, s), Gf(s), n & tn && _ !== null) {
              var J = _.memoizedState;
              if (J.isDehydrated) try {
                sP(u.containerInfo);
              } catch (Ie) {
                Fi(s, s.return, Ie);
              }
            }
            return;
          }
        case k:
          {
            Yf(u, s), Gf(s);
            return;
          }
        case V:
          {
            Yf(u, s), Gf(s);
            var me = s.child;
            if (me.flags & tr) {
              var Se = me.stateNode,
                Me = me.memoizedState,
                Pe = Me !== null;
              if (Se.isHidden = Pe, Pe) {
                var $e = me.alternate !== null && me.alternate.memoizedState !== null;
                $e || Jy();
              }
            }
            if (n & tn) {
              try {
                qf(s);
              } catch (Ie) {
                Fi(s, s.return, Ie);
              }
              km(s);
            }
            return;
          }
        case oe:
          {
            var mt = _ !== null && _.memoizedState !== null;
            if (
            // TODO: Remove this dead flag
            s.mode & Wt) {
              var Re = al;
              al = Re || mt, Yf(u, s), al = Re;
            } else Yf(u, s);
            if (Gf(s), n & tr) {
              var Ue = s.stateNode,
                Be = s.memoizedState,
                nt = Be !== null,
                ke = s;
              if (Ue.isHidden = nt, nt && !mt && (ke.mode & Wt) !== dt) {
                dn = ke;
                for (var Fe = ke.child; Fe !== null;) dn = Fe, _p(Fe), Fe = Fe.sibling;
              }
              Mv(ke, nt);
            }
            return;
          }
        case Y:
          {
            Yf(u, s), Gf(s), n & tn && km(s);
            return;
          }
        case ee:
          return;
        default:
          {
            Yf(u, s), Gf(s);
            return;
          }
      }
    }
    function Gf(s) {
      var u = s.flags;
      if (u & Gn) {
        try {
          fI(s);
        } catch (v) {
          Fi(s, s.return, v);
        }
        s.flags &= -3;
      }
      u & xi && (s.flags &= -4097);
    }
    function oA(s, u, v) {
      Cm = v, Na = u, dn = s, Kc(s, u, v), Cm = null, Na = null;
    }
    function Kc(s, u, v) {
      for (var _ = (s.mode & Wt) !== dt; dn !== null;) {
        var n = dn,
          a = n.child;
        if (n.tag === oe && _) {
          var f = n.memoizedState !== null,
            m = f || hx;
          if (m) {
            m1(s, u, v);
            continue;
          } else {
            var b = n.alternate,
              T = b !== null && b.memoizedState !== null,
              M = T || al,
              z = hx,
              U = al;
            hx = m, al = M, al && !U && (dn = n, vI(n));
            for (var X = a; X !== null;) dn = X, Kc(X,
            // New root; bubble back up to here and stop.
            u, v), X = X.sibling;
            dn = n, hx = z, al = U, m1(s, u, v);
            continue;
          }
        }
        (n.subtreeFlags & $o) !== pt && a !== null ? (a.return = n, dn = a) : m1(s, u, v);
      }
    }
    function m1(s, u, v) {
      for (; dn !== null;) {
        var _ = dn;
        if ((_.flags & $o) !== pt) {
          var n = _.alternate;
          Rn(_);
          try {
            nA(u, n, _, v);
          } catch (f) {
            Fi(_, _.return, f);
          }
          Un();
        }
        if (_ === s) {
          dn = null;
          return;
        }
        var a = _.sibling;
        if (a !== null) {
          a.return = _.return, dn = a;
          return;
        }
        dn = _.return;
      }
    }
    function _p(s) {
      for (; dn !== null;) {
        var u = dn,
          v = u.child;
        switch (u.tag) {
          case w:
          case F:
          case K:
          case G:
            {
              if (u.mode & nn) try {
                Bf(), Hf(Er, u, u.return);
              } finally {
                Vf(u);
              } else Hf(Er, u, u.return);
              break;
            }
          case x:
            {
              qy(u, u.return);
              var _ = u.stateNode;
              typeof _.componentWillUnmount == "function" && Dv(u, u.return, _);
              break;
            }
          case D:
            {
              qy(u, u.return);
              break;
            }
          case oe:
            {
              var n = u.memoizedState !== null;
              if (n) {
                mI(s);
                continue;
              }
              break;
            }
        }
        v !== null ? (v.return = u, dn = v) : mI(s);
      }
    }
    function mI(s) {
      for (; dn !== null;) {
        var u = dn;
        if (u === s) {
          dn = null;
          return;
        }
        var v = u.sibling;
        if (v !== null) {
          v.return = u.return, dn = v;
          return;
        }
        dn = u.return;
      }
    }
    function vI(s) {
      for (; dn !== null;) {
        var u = dn,
          v = u.child;
        if (u.tag === oe) {
          var _ = u.memoizedState !== null;
          if (_) {
            v1(s);
            continue;
          }
        }
        v !== null ? (v.return = u, dn = v) : v1(s);
      }
    }
    function v1(s) {
      for (; dn !== null;) {
        var u = dn;
        Rn(u);
        try {
          $f(u);
        } catch (_) {
          Fi(u, u.return, _);
        }
        if (Un(), u === s) {
          dn = null;
          return;
        }
        var v = u.sibling;
        if (v !== null) {
          v.return = u.return, dn = v;
          return;
        }
        dn = u.return;
      }
    }
    function sA(s, u, v, _) {
      dn = u, gI(u, s, v, _);
    }
    function gI(s, u, v, _) {
      for (; dn !== null;) {
        var n = dn,
          a = n.child;
        (n.subtreeFlags & Ja) !== pt && a !== null ? (a.return = n, dn = a) : lA(s, u, v, _);
      }
    }
    function lA(s, u, v, _) {
      for (; dn !== null;) {
        var n = dn;
        if ((n.flags & Yr) !== pt) {
          Rn(n);
          try {
            yI(u, n, v, _);
          } catch (f) {
            Fi(n, n.return, f);
          }
          Un();
        }
        if (n === s) {
          dn = null;
          return;
        }
        var a = n.sibling;
        if (a !== null) {
          a.return = n.return, dn = a;
          return;
        }
        dn = n.return;
      }
    }
    function yI(s, u, v, _) {
      switch (u.tag) {
        case w:
        case F:
        case G:
          {
            if (u.mode & nn) {
              y0();
              try {
                Iv(Ui | ja, u);
              } finally {
                ox(u);
              }
            } else Iv(Ui | ja, u);
            break;
          }
      }
    }
    function uA(s) {
      dn = s, cA();
    }
    function cA() {
      for (; dn !== null;) {
        var s = dn,
          u = s.child;
        if ((dn.flags & _i) !== pt) {
          var v = s.deletions;
          if (v !== null) {
            for (var _ = 0; _ < v.length; _++) {
              var n = v[_];
              dn = n, pA(n, s);
            }
            {
              var a = s.alternate;
              if (a !== null) {
                var f = a.child;
                if (f !== null) {
                  a.child = null;
                  do {
                    var m = f.sibling;
                    f.sibling = null, f = m;
                  } while (f !== null);
                }
              }
            }
            dn = s;
          }
        }
        (s.subtreeFlags & Ja) !== pt && u !== null ? (u.return = s, dn = u) : dA();
      }
    }
    function dA() {
      for (; dn !== null;) {
        var s = dn;
        (s.flags & Yr) !== pt && (Rn(s), fA(s), Un());
        var u = s.sibling;
        if (u !== null) {
          u.return = s.return, dn = u;
          return;
        }
        dn = s.return;
      }
    }
    function fA(s) {
      switch (s.tag) {
        case w:
        case F:
        case G:
          {
            s.mode & nn ? (y0(), Hf(Ui | ja, s, s.return), ox(s)) : Hf(Ui | ja, s, s.return);
            break;
          }
      }
    }
    function pA(s, u) {
      for (; dn !== null;) {
        var v = dn;
        Rn(v), mA(v, u), Un();
        var _ = v.child;
        _ !== null ? (_.return = v, dn = _) : hA(s);
      }
    }
    function hA(s) {
      for (; dn !== null;) {
        var u = dn,
          v = u.sibling,
          _ = u.return;
        if (cI(u), u === s) {
          dn = null;
          return;
        }
        if (v !== null) {
          v.return = _, dn = v;
          return;
        }
        dn = _;
      }
    }
    function mA(s, u) {
      switch (s.tag) {
        case w:
        case F:
        case G:
          {
            s.mode & nn ? (y0(), Hf(Ui, s, u), ox(s)) : Hf(Ui, s, u);
            break;
          }
      }
    }
    function vA(s) {
      switch (s.tag) {
        case w:
        case F:
        case G:
          {
            try {
              Iv(Er | ja, s);
            } catch (v) {
              Fi(s, s.return, v);
            }
            break;
          }
        case x:
          {
            var u = s.stateNode;
            try {
              u.componentDidMount();
            } catch (v) {
              Fi(s, s.return, v);
            }
            break;
          }
      }
    }
    function gA(s) {
      switch (s.tag) {
        case w:
        case F:
        case G:
          {
            try {
              Iv(Ui | ja, s);
            } catch (u) {
              Fi(s, s.return, u);
            }
            break;
          }
      }
    }
    function yA(s) {
      switch (s.tag) {
        case w:
        case F:
        case G:
          {
            try {
              Hf(Er | ja, s, s.return);
            } catch (v) {
              Fi(s, s.return, v);
            }
            break;
          }
        case x:
          {
            var u = s.stateNode;
            typeof u.componentWillUnmount == "function" && Dv(s, s.return, u);
            break;
          }
      }
    }
    function bA(s) {
      switch (s.tag) {
        case w:
        case F:
        case G:
          try {
            Hf(Ui | ja, s, s.return);
          } catch (u) {
            Fi(s, s.return, u);
          }
      }
    }
    if (typeof Symbol == "function" && Symbol.for) {
      var mx = Symbol.for;
      mx("selector.component"), mx("selector.has_pseudo_class"), mx("selector.role"), mx("selector.test_id"), mx("selector.text");
    }
    var wA = [];
    function _A() {
      wA.forEach(function (s) {
        return s();
      });
    }
    var xA = i.ReactCurrentActQueue;
    function vx(s) {
      {
        var u =
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0,
          v = typeof jest < "u";
        return v && u !== !1;
      }
    }
    function bI() {
      {
        var s =
        // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
        typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0;
        return !s && xA.current !== null && h("The current testing environment is not configured to support act(...)"), s;
      }
    }
    var SA = Math.ceil,
      Ek = i.ReactCurrentDispatcher,
      Ck = i.ReactCurrentOwner,
      _s = i.ReactCurrentBatchConfig,
      Xf = i.ReactCurrentActQueue,
      fo = /*             */
      0,
      g1 = /*               */
      1,
      Ar = /*                */
      2,
      za = /*                */
      4,
      ji = 0,
      T0 = 1,
      Da = 2,
      iu = 3,
      Sc = 4,
      R0 = 5,
      Tm = 6,
      cr = fo,
      Jo = null,
      da = null,
      po = De,
      Wn = De,
      ol = kf(De),
      lr = ji,
      Ia = null,
      Ec = De,
      Yy = De,
      Va = De,
      Rm = null,
      sl = null,
      Gy = 0,
      gx = 500,
      D0 = 1 / 0,
      wu = 500,
      Kf = null;
    function I0() {
      D0 = sr() + wu;
    }
    function kk() {
      return D0;
    }
    var y1 = !1,
      Qf = null,
      xp = null,
      Ov = !1,
      Zf = null,
      Xy = De,
      Lv = [],
      Dm = null,
      Pv = 50,
      Im = 0,
      yx = null,
      bx = !1,
      b1 = !1,
      wx = 50,
      Av = 0,
      M0 = null,
      Ky = wn,
      w1 = De,
      Qy = !1;
    function Zy() {
      return Jo;
    }
    function es() {
      return (cr & (Ar | za)) !== fo ? sr() : (Ky !== wn || (Ky = sr()), Ky);
    }
    function Jf(s) {
      var u = s.mode;
      if ((u & Wt) === dt) return Je;
      if ((cr & Ar) !== fo && po !== De) return Xl(po);
      var v = DP() !== xC;
      if (v) {
        if (_s.transition !== null) {
          var _ = _s.transition;
          _._updatedFibers || (_._updatedFibers = /* @__PURE__ */new Set()), _._updatedFibers.add(s);
        }
        return w1 === On && (w1 = Vh()), w1;
      }
      var n = Ir();
      if (n !== On) return n;
      var a = aC();
      return a;
    }
    function wI(s) {
      var u = s.mode;
      return (u & Wt) === dt ? Je : Zg();
    }
    function Ba(s, u, v, _) {
      II(), Qy && h("useInsertionEffect must not schedule updates."), bx && (b1 = !0), oc(s, v, _), (cr & Ar) !== De && s === Jo ? Pk(u) : (ui && Zm(s, u, v), Ak(u), s === Jo && ((cr & Ar) === fo && (Yy = jt(Yy, v)), lr === Sc && Sp(s, po)), _u(s, _), v === Je && cr === fo && (u.mode & Wt) === dt &&
      // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !Xf.isBatchingLegacy && (I0(), mC()));
    }
    function au(s, u, v) {
      var _ = s.current;
      _.lanes = u, oc(s, u, v), _u(s, v);
    }
    function jv(s) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (cr & Ar) !== fo
      );
    }
    function _u(s, u) {
      var v = s.callbackNode;
      Xg(s, u);
      var _ = lf(s, s === Jo ? po : De);
      if (_ === De) {
        v !== null && LI(v), s.callbackNode = null, s.callbackPriority = On;
        return;
      }
      var n = Go(_),
        a = s.callbackPriority;
      if (a === n &&
      // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(Xf.current !== null && v !== D1)) {
        v == null && a !== Je && h("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      v != null && LI(v);
      var f;
      if (n === Je) s.tag === lm ? (Xf.isBatchingLegacy !== null && (Xf.didScheduleLegacyUpdate = !0), hC(Rk.bind(null, s))) : xS(Rk.bind(null, s)), Xf.current !== null ? Xf.current.push(vv) : sC(function () {
        (cr & (Ar | za)) === fo && vv();
      }), f = null;else {
        var m;
        switch (ul(_)) {
          case as:
            m = Xu;
            break;
          case Ii:
            m = Wo;
            break;
          case Zi:
            m = eo;
            break;
          case os:
            m = li;
            break;
          default:
            m = eo;
            break;
        }
        f = kx(m, To.bind(null, s));
      }
      s.callbackPriority = n, s.callbackNode = f;
    }
    function To(s, u) {
      if (YC(), Ky = wn, w1 = De, (cr & (Ar | za)) !== fo) throw new Error("Should not already be working.");
      var v = s.callbackNode,
        _ = Cp();
      if (_ && s.callbackNode !== v) return null;
      var n = lf(s, s === Jo ? po : De);
      if (n === De) return null;
      var a = !Gl(s, n) && !Pw(s, n) && !u,
        f = a ? kA(s, n) : S1(s, n);
      if (f !== ji) {
        if (f === Da) {
          var m = ql(s);
          m !== De && (n = m, f = Tk(s, m));
        }
        if (f === T0) {
          var b = Ia;
          throw ou(s, De), Sp(s, n), _u(s, sr()), b;
        }
        if (f === Tm) Sp(s, n);else {
          var T = !Gl(s, n),
            M = s.current.alternate;
          if (T && !xI(M)) {
            if (f = S1(s, n), f === Da) {
              var z = ql(s);
              z !== De && (n = z, f = Tk(s, z));
            }
            if (f === T0) {
              var U = Ia;
              throw ou(s, De), Sp(s, n), _u(s, sr()), U;
            }
          }
          s.finishedWork = M, s.finishedLanes = n, xu(s, f, n);
        }
      }
      return _u(s, sr()), s.callbackNode === v ? To.bind(null, s) : null;
    }
    function Tk(s, u) {
      var v = Rm;
      if (fr(s)) {
        var _ = ou(s, u);
        _.flags |= qr, wP(s.containerInfo);
      }
      var n = S1(s, u);
      if (n !== Da) {
        var a = sl;
        sl = v, a !== null && _I(a);
      }
      return n;
    }
    function _I(s) {
      sl === null ? sl = s : sl.push.apply(sl, s);
    }
    function xu(s, u, v) {
      switch (u) {
        case ji:
        case T0:
          throw new Error("Root did not complete. This is a bug in React.");
        // Flow knows about invariant, so it complains if I add a break
        // statement, but eslint doesn't know about invariant, so it complains
        // if I do. eslint-disable-next-line no-fallthrough
        case Da:
          {
            eb(s, sl, Kf);
            break;
          }
        case iu:
          {
            if (Sp(s, v), Qg(v) &&
            // do not delay if we're inside an act() scope
            !P0()) {
              var _ = Gy + gx - sr();
              if (_ > 10) {
                var n = lf(s, De);
                if (n !== De) break;
                var a = s.suspendedLanes;
                if (!$s(a, v)) {
                  es(), Km(s, a);
                  break;
                }
                s.timeoutHandle = oC(eb.bind(null, s, sl, Kf), _);
                break;
              }
            }
            eb(s, sl, Kf);
            break;
          }
        case Sc:
          {
            if (Sp(s, v), Nh(v)) break;
            if (!P0()) {
              var f = Ow(s, v),
                m = f,
                b = sr() - m,
                T = OA(b) - b;
              if (T > 10) {
                s.timeoutHandle = oC(eb.bind(null, s, sl, Kf), T);
                break;
              }
            }
            eb(s, sl, Kf);
            break;
          }
        case R0:
          {
            eb(s, sl, Kf);
            break;
          }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function xI(s) {
      for (var u = s;;) {
        if (u.flags & Al) {
          var v = u.updateQueue;
          if (v !== null) {
            var _ = v.stores;
            if (_ !== null) for (var n = 0; n < _.length; n++) {
              var a = _[n],
                f = a.getSnapshot,
                m = a.value;
              try {
                if (!ae(f(), m)) return !1;
              } catch {
                return !1;
              }
            }
          }
        }
        var b = u.child;
        if (u.subtreeFlags & Al && b !== null) {
          b.return = u, u = b;
          continue;
        }
        if (u === s) return !0;
        for (; u.sibling === null;) {
          if (u.return === null || u.return === s) return !0;
          u = u.return;
        }
        u.sibling.return = u.return, u = u.sibling;
      }
      return !0;
    }
    function Sp(s, u) {
      u = ac(u, Va), u = ac(u, Yy), sc(s, u);
    }
    function Rk(s) {
      if (r1(), (cr & (Ar | za)) !== fo) throw new Error("Should not already be working.");
      Cp();
      var u = lf(s, De);
      if (!_n(u, Je)) return _u(s, sr()), null;
      var v = S1(s, u);
      if (s.tag !== lm && v === Da) {
        var _ = ql(s);
        _ !== De && (u = _, v = Tk(s, _));
      }
      if (v === T0) {
        var n = Ia;
        throw ou(s, De), Sp(s, u), _u(s, sr()), n;
      }
      if (v === Tm) throw new Error("Root did not complete. This is a bug in React.");
      var a = s.current.alternate;
      return s.finishedWork = a, s.finishedLanes = u, eb(s, sl, Kf), _u(s, sr()), null;
    }
    function EA(s, u) {
      u !== De && (cf(s, jt(u, Je)), _u(s, sr()), (cr & (Ar | za)) === fo && (I0(), vv()));
    }
    function Dk(s, u) {
      var v = cr;
      cr |= g1;
      try {
        return s(u);
      } finally {
        cr = v, cr === fo &&
        // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !Xf.isBatchingLegacy && (I0(), mC());
      }
    }
    function Fv(s, u, v, _, n) {
      var a = Ir(),
        f = _s.transition;
      try {
        return _s.transition = null, zr(as), s(u, v, _, n);
      } finally {
        zr(a), _s.transition = f, cr === fo && I0();
      }
    }
    function Ep(s) {
      Zf !== null && Zf.tag === lm && (cr & (Ar | za)) === fo && Cp();
      var u = cr;
      cr |= g1;
      var v = _s.transition,
        _ = Ir();
      try {
        return _s.transition = null, zr(as), s ? s() : void 0;
      } finally {
        zr(_), _s.transition = v, cr = u, (cr & (Ar | za)) === fo && vv();
      }
    }
    function SI() {
      return (cr & (Ar | za)) !== fo;
    }
    function O0(s, u) {
      ka(ol, Wn, s), Wn = jt(Wn, u);
    }
    function Ik(s) {
      Wn = ol.current, ca(ol, s);
    }
    function ou(s, u) {
      s.finishedWork = null, s.finishedLanes = De;
      var v = s.timeoutHandle;
      if (v !== t_ && (s.timeoutHandle = t_, zL(v)), da !== null) for (var _ = da.return; _ !== null;) {
        var n = _.alternate;
        ys(n, _), _ = _.return;
      }
      Jo = s;
      var a = ts(s.current, null);
      return da = a, po = Wn = u, lr = ji, Ia = null, Ec = De, Yy = De, Va = De, Rm = null, sl = null, Ey(), Mf.discardPendingWarnings(), a;
    }
    function Mk(s, u) {
      do {
        var v = da;
        try {
          if (Qb(), Ly(), Un(), Ck.current = null, v === null || v.return === null) {
            lr = T0, Ia = u, da = null;
            return;
          }
          if (Ee && v.mode & nn && ax(v, !0), Ce) if (to(), u !== null && typeof u == "object" && typeof u.then == "function") {
            var _ = u;
            Lh(v, _, po);
          } else Hg(v, u, po);
          NP(s, v.return, v, u, po), CI(v);
        } catch (n) {
          u = n, da === v && v !== null ? (v = v.return, da = v) : v = da;
          continue;
        }
        return;
      } while (!0);
    }
    function _x() {
      var s = Ek.current;
      return Ek.current = tx, s === null ? tx : s;
    }
    function _1(s) {
      Ek.current = s;
    }
    function Jy() {
      Gy = sr();
    }
    function L0(s) {
      Ec = jt(s, Ec);
    }
    function EI() {
      lr === ji && (lr = iu);
    }
    function x1() {
      (lr === ji || lr === iu || lr === Da) && (lr = Sc), Jo !== null && (Fh(Ec) || Fh(Yy)) && Sp(Jo, po);
    }
    function CA(s) {
      lr !== Sc && (lr = Da), Rm === null ? Rm = [s] : Rm.push(s);
    }
    function xx() {
      return lr === ji;
    }
    function S1(s, u) {
      var v = cr;
      cr |= Ar;
      var _ = _x();
      if (Jo !== s || po !== u) {
        if (ui) {
          var n = s.memoizedUpdaters;
          n.size > 0 && (Cx(s, po), n.clear()), ff(s, u);
        }
        Kf = lc(), ou(s, u);
      }
      Vs(u);
      do try {
        Ok();
        break;
      } catch (a) {
        Mk(s, a);
      } while (!0);
      if (Qb(), cr = v, _1(_), da !== null) throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return Nl(), Jo = null, po = De, lr;
    }
    function Ok() {
      for (; da !== null;) Sx(da);
    }
    function kA(s, u) {
      var v = cr;
      cr |= Ar;
      var _ = _x();
      if (Jo !== s || po !== u) {
        if (ui) {
          var n = s.memoizedUpdaters;
          n.size > 0 && (Cx(s, po), n.clear()), ff(s, u);
        }
        Kf = lc(), I0(), ou(s, u);
      }
      Vs(u);
      do try {
        TA();
        break;
      } catch (a) {
        Mk(s, a);
      } while (!0);
      return Qb(), _1(_), cr = v, da !== null ? (qg(), ji) : (Nl(), Jo = null, po = De, lr);
    }
    function TA() {
      for (; da !== null && !kh();) Sx(da);
    }
    function Sx(s) {
      var u = s.alternate;
      Rn(s);
      var v;
      (s.mode & nn) !== dt ? (XC(s), v = k1(u, s, Wn), ax(s, !0)) : v = k1(u, s, Wn), Un(), s.memoizedProps = s.pendingProps, v === null ? CI(s) : da = v, Ck.current = null;
    }
    function CI(s) {
      var u = s;
      do {
        var v = u.alternate,
          _ = u.return;
        if ((u.flags & Gu) === pt) {
          Rn(u);
          var n = void 0;
          if ((u.mode & nn) === dt ? n = wk(v, u, Wn) : (XC(u), n = wk(v, u, Wn), ax(u, !1)), Un(), n !== null) {
            da = n;
            return;
          }
        } else {
          var a = px(v, u);
          if (a !== null) {
            a.flags &= Ag, da = a;
            return;
          }
          if ((u.mode & nn) !== dt) {
            ax(u, !1);
            for (var f = u.actualDuration, m = u.child; m !== null;) f += m.actualDuration, m = m.sibling;
            u.actualDuration = f;
          }
          if (_ !== null) _.flags |= Gu, _.subtreeFlags = pt, _.deletions = null;else {
            lr = Tm, da = null;
            return;
          }
        }
        var b = u.sibling;
        if (b !== null) {
          da = b;
          return;
        }
        u = _, da = u;
      } while (u !== null);
      lr === ji && (lr = R0);
    }
    function eb(s, u, v) {
      var _ = Ir(),
        n = _s.transition;
      try {
        _s.transition = null, zr(as), RA(s, u, v, _);
      } finally {
        _s.transition = n, zr(_);
      }
      return null;
    }
    function RA(s, u, v, _) {
      do Cp(); while (Zf !== null);
      if (LA(), (cr & (Ar | za)) !== fo) throw new Error("Should not already be working.");
      var n = s.finishedWork,
        a = s.finishedLanes;
      if (zg(a), n === null) return wa(), null;
      if (a === De && h("root.finishedLanes should not be empty during a commit. This is a bug in React."), s.finishedWork = null, s.finishedLanes = De, n === s.current) throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      s.callbackNode = null, s.callbackPriority = On;
      var f = jt(n.lanes, n.childLanes);
      Qm(s, f), s === Jo && (Jo = null, da = null, po = De), ((n.subtreeFlags & Ja) !== pt || (n.flags & Ja) !== pt) && (Ov || (Ov = !0, Dm = v, kx(eo, function () {
        return Cp(), null;
      })));
      var m = (n.subtreeFlags & (Uo | Ho | $o | Ja)) !== pt,
        b = (n.flags & (Uo | Ho | $o | Ja)) !== pt;
      if (m || b) {
        var T = _s.transition;
        _s.transition = null;
        var M = Ir();
        zr(as);
        var z = cr;
        cr |= za, Ck.current = null, sI(s, n), zD(), pI(s, n, a), $z(s.containerInfo), s.current = n, Ku(a), oA(n, s, a), Gd(), Th(), cr = z, zr(M), _s.transition = T;
      } else s.current = n, zD();
      var U = Ov;
      if (Ov ? (Ov = !1, Zf = s, Xy = a) : (Av = 0, M0 = null), f = s.pendingLanes, f === De && (xp = null), U || MI(s.current, !1), zs(n.stateNode, _), ui && s.memoizedUpdaters.clear(), _A(), _u(s, sr()), u !== null) for (var X = s.onRecoverableError, J = 0; J < u.length; J++) {
        var me = u[J],
          Se = me.stack,
          Me = me.digest;
        X(me.value, {
          componentStack: Se,
          digest: Me
        });
      }
      if (y1) {
        y1 = !1;
        var Pe = Qf;
        throw Qf = null, Pe;
      }
      return _n(Xy, Je) && s.tag !== lm && Cp(), f = s.pendingLanes, _n(f, Je) ? (n1(), s === yx ? Im++ : (Im = 0, yx = s)) : Im = 0, vv(), wa(), null;
    }
    function Cp() {
      if (Zf !== null) {
        var s = ul(Xy),
          u = Jg(Zi, s),
          v = _s.transition,
          _ = Ir();
        try {
          return _s.transition = null, zr(u), tb();
        } finally {
          zr(_), _s.transition = v;
        }
      }
      return !1;
    }
    function kI(s) {
      Lv.push(s), Ov || (Ov = !0, kx(eo, function () {
        return Cp(), null;
      }));
    }
    function tb() {
      if (Zf === null) return !1;
      var s = Dm;
      Dm = null;
      var u = Zf,
        v = Xy;
      if (Zf = null, Xy = De, (cr & (Ar | za)) !== fo) throw new Error("Cannot flush passive effects while already rendering.");
      bx = !0, b1 = !1, $g(v);
      var _ = cr;
      cr |= za, uA(u.current), sA(u, u.current, v, s);
      {
        var n = Lv;
        Lv = [];
        for (var a = 0; a < n.length; a++) {
          var f = n[a];
          tA(u, f);
        }
      }
      Wg(), MI(u.current, !0), cr = _, vv(), b1 ? u === M0 ? Av++ : (Av = 0, M0 = u) : Av = 0, bx = !1, b1 = !1, Rh(u);
      {
        var m = u.current.stateNode;
        m.effectDuration = 0, m.passiveEffectDuration = 0;
      }
      return !0;
    }
    function TI(s) {
      return xp !== null && xp.has(s);
    }
    function Mm(s) {
      xp === null ? xp = /* @__PURE__ */new Set([s]) : xp.add(s);
    }
    function DA(s) {
      y1 || (y1 = !0, Qf = s);
    }
    var IA = DA;
    function Lk(s, u, v) {
      var _ = Em(v, u),
        n = i1(s, _, Je),
        a = wm(s, n, Je),
        f = es();
      a !== null && (oc(a, Je, f), _u(a, f));
    }
    function Fi(s, u, v) {
      if (JP(v), A0(!1), s.tag === C) {
        Lk(s, s, v);
        return;
      }
      var _ = null;
      for (_ = u; _ !== null;) {
        if (_.tag === C) {
          Lk(_, s, v);
          return;
        } else if (_.tag === x) {
          var n = _.type,
            a = _.stateNode;
          if (typeof n.getDerivedStateFromError == "function" || typeof a.componentDidCatch == "function" && !TI(a)) {
            var f = Em(v, s),
              m = QC(_, f, Je),
              b = wm(_, m, Je),
              T = es();
            b !== null && (oc(b, Je, T), _u(b, T));
            return;
          }
        }
        _ = _.return;
      }
      h(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, v);
    }
    function MA(s, u, v) {
      var _ = s.pingCache;
      _ !== null && _.delete(u);
      var n = es();
      Km(s, v), jk(s), Jo === s && $s(po, v) && (lr === Sc || lr === iu && Qg(po) && sr() - Gy < gx ? ou(s, De) : Va = jt(Va, v)), _u(s, n);
    }
    function RI(s, u) {
      u === On && (u = wI(s));
      var v = es(),
        _ = vu(s, u);
      _ !== null && (oc(_, u, v), _u(_, v));
    }
    function DI(s) {
      var u = s.memoizedState,
        v = On;
      u !== null && (v = u.retryLane), RI(s, v);
    }
    function Ni(s, u) {
      var v = On,
        _;
      switch (s.tag) {
        case V:
          _ = s.stateNode;
          var n = s.memoizedState;
          n !== null && (v = n.retryLane);
          break;
        case Y:
          _ = s.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      _ !== null && _.delete(u), RI(s, v);
    }
    function OA(s) {
      return s < 120 ? 120 : s < 480 ? 480 : s < 1080 ? 1080 : s < 1920 ? 1920 : s < 3e3 ? 3e3 : s < 4320 ? 4320 : SA(s / 1960) * 1960;
    }
    function II() {
      if (Im > Pv) throw Im = 0, yx = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      Av > wx && (Av = 0, M0 = null, h("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function LA() {
      Mf.flushLegacyContextWarning(), Mf.flushPendingUnsafeLifecycleWarnings();
    }
    function MI(s, u) {
      Rn(s), E1(s, Bo, yA), u && E1(s, ga, bA), E1(s, Bo, vA), u && E1(s, ga, gA), Un();
    }
    function E1(s, u, v) {
      for (var _ = s, n = null; _ !== null;) {
        var a = _.subtreeFlags & u;
        _ !== n && _.child !== null && a !== pt ? _ = _.child : ((_.flags & u) !== pt && v(_), _.sibling !== null ? _ = _.sibling : _ = n = _.return);
      }
    }
    var C1 = null;
    function OI(s) {
      {
        if ((cr & Ar) !== fo || !(s.mode & Wt)) return;
        var u = s.tag;
        if (u !== E && u !== C && u !== x && u !== w && u !== F && u !== K && u !== G) return;
        var v = At(s) || "ReactComponent";
        if (C1 !== null) {
          if (C1.has(v)) return;
          C1.add(v);
        } else C1 = /* @__PURE__ */new Set([v]);
        var _ = Pr;
        try {
          Rn(s), h("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          _ ? Rn(s) : Un();
        }
      }
    }
    var k1;
    {
      var T1 = null;
      k1 = function (s, u, v) {
        var _ = O1(T1, u);
        try {
          return bp(s, u, v);
        } catch (a) {
          if (CP() || a !== null && typeof a == "object" && typeof a.then == "function") throw a;
          if (Qb(), Ly(), ys(s, u), O1(u, _), u.mode & nn && XC(u), Vo(null, bp, null, s, u, v), Qa()) {
            var n = Yu();
            typeof n == "object" && n !== null && n._suppressLogging && typeof a == "object" && a !== null && !a._suppressLogging && (a._suppressLogging = !0);
          }
          throw a;
        }
      };
    }
    var Ex = !1,
      R1;
    R1 = /* @__PURE__ */new Set();
    function Pk(s) {
      if (Po && !HC()) switch (s.tag) {
        case w:
        case F:
        case G:
          {
            var u = da && At(da) || "Unknown",
              v = u;
            if (!R1.has(v)) {
              R1.add(v);
              var _ = At(s) || "Unknown";
              h("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", _, u, u);
            }
            break;
          }
        case x:
          {
            Ex || (h("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), Ex = !0);
            break;
          }
      }
    }
    function Cx(s, u) {
      if (ui) {
        var v = s.memoizedUpdaters;
        v.forEach(function (_) {
          Zm(s, _, u);
        });
      }
    }
    var D1 = {};
    function kx(s, u) {
      {
        var v = Xf.current;
        return v !== null ? (v.push(u), D1) : Ch(s, u);
      }
    }
    function LI(s) {
      if (s !== D1) return Fg(s);
    }
    function P0() {
      return Xf.current !== null;
    }
    function Ak(s) {
      {
        if (s.mode & Wt) {
          if (!bI()) return;
        } else if (!vx() || cr !== fo || s.tag !== w && s.tag !== F && s.tag !== G) return;
        if (Xf.current === null) {
          var u = Pr;
          try {
            Rn(s), h(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, At(s));
          } finally {
            u ? Rn(s) : Un();
          }
        }
      }
    }
    function jk(s) {
      s.tag !== lm && bI() && Xf.current === null && h(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function A0(s) {
      Qy = s;
    }
    var Cc = null,
      j0 = null,
      PA = function (s) {
        Cc = s;
      };
    function kp(s) {
      {
        if (Cc === null) return s;
        var u = Cc(s);
        return u === void 0 ? s : u.current;
      }
    }
    function Su(s) {
      return kp(s);
    }
    function Nv(s) {
      {
        if (Cc === null) return s;
        var u = Cc(s);
        if (u === void 0) {
          if (s != null && typeof s.render == "function") {
            var v = kp(s.render);
            if (s.render !== v) {
              var _ = {
                $$typeof: Ye,
                render: v
              };
              return s.displayName !== void 0 && (_.displayName = s.displayName), _;
            }
          }
          return s;
        }
        return u.current;
      }
    }
    function PI(s, u) {
      {
        if (Cc === null) return !1;
        var v = s.elementType,
          _ = u.type,
          n = !1,
          a = typeof _ == "object" && _ !== null ? _.$$typeof : null;
        switch (s.tag) {
          case x:
            {
              typeof _ == "function" && (n = !0);
              break;
            }
          case w:
            {
              (typeof _ == "function" || a === Ct) && (n = !0);
              break;
            }
          case F:
            {
              (a === Ye || a === Ct) && (n = !0);
              break;
            }
          case K:
          case G:
            {
              (a === $t || a === Ct) && (n = !0);
              break;
            }
          default:
            return !1;
        }
        if (n) {
          var f = Cc(v);
          if (f !== void 0 && f === Cc(_)) return !0;
        }
        return !1;
      }
    }
    function nb(s) {
      {
        if (Cc === null || typeof WeakSet != "function") return;
        j0 === null && (j0 = /* @__PURE__ */new WeakSet()), j0.add(s);
      }
    }
    var Fk = function (s, u) {
        {
          if (Cc === null) return;
          var v = u.staleFamilies,
            _ = u.updatedFamilies;
          Cp(), Ep(function () {
            I1(s.current, _, v);
          });
        }
      },
      Nk = function (s, u) {
        {
          if (s.context !== fi) return;
          Cp(), Ep(function () {
            F0(u, s, null, null);
          });
        }
      };
    function I1(s, u, v) {
      {
        var _ = s.alternate,
          n = s.child,
          a = s.sibling,
          f = s.tag,
          m = s.type,
          b = null;
        switch (f) {
          case w:
          case G:
          case x:
            b = m;
            break;
          case F:
            b = m.render;
            break;
        }
        if (Cc === null) throw new Error("Expected resolveFamily to be set during hot reload.");
        var T = !1,
          M = !1;
        if (b !== null) {
          var z = Cc(b);
          z !== void 0 && (v.has(z) ? M = !0 : u.has(z) && (f === x ? M = !0 : T = !0));
        }
        if (j0 !== null && (j0.has(s) || _ !== null && j0.has(_)) && (M = !0), M && (s._debugNeedsRemount = !0), M || T) {
          var U = vu(s, Je);
          U !== null && Ba(U, s, Je, wn);
        }
        n !== null && !M && I1(n, u, v), a !== null && I1(a, u, v);
      }
    }
    var AI = function (s, u) {
      {
        var v = /* @__PURE__ */new Set(),
          _ = new Set(u.map(function (n) {
            return n.current;
          }));
        return zk(s.current, _, v), v;
      }
    };
    function zk(s, u, v) {
      {
        var _ = s.child,
          n = s.sibling,
          a = s.tag,
          f = s.type,
          m = null;
        switch (a) {
          case w:
          case G:
          case x:
            m = f;
            break;
          case F:
            m = f.render;
            break;
        }
        var b = !1;
        m !== null && u.has(m) && (b = !0), b ? AA(s, v) : _ !== null && zk(_, u, v), n !== null && zk(n, u, v);
      }
    }
    function AA(s, u) {
      {
        var v = Vk(s, u);
        if (v) return;
        for (var _ = s;;) {
          switch (_.tag) {
            case D:
              u.add(_.stateNode);
              return;
            case k:
              u.add(_.stateNode.containerInfo);
              return;
            case C:
              u.add(_.stateNode.containerInfo);
              return;
          }
          if (_.return === null) throw new Error("Expected to reach root first.");
          _ = _.return;
        }
      }
    }
    function Vk(s, u) {
      for (var v = s, _ = !1;;) {
        if (v.tag === D) _ = !0, u.add(v.stateNode);else if (v.child !== null) {
          v.child.return = v, v = v.child;
          continue;
        }
        if (v === s) return _;
        for (; v.sibling === null;) {
          if (v.return === null || v.return === s) return _;
          v = v.return;
        }
        v.sibling.return = v.return, v = v.sibling;
      }
      return !1;
    }
    var Bk;
    {
      Bk = !1;
      try {
        var jI = Object.preventExtensions({});
      } catch {
        Bk = !0;
      }
    }
    function jA(s, u, v, _) {
      this.tag = s, this.key = v, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = u, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = _, this.flags = pt, this.subtreeFlags = pt, this.deletions = null, this.lanes = De, this.childLanes = De, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !Bk && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var kc = function (s, u, v, _) {
      return new jA(s, u, v, _);
    };
    function Tx(s) {
      var u = s.prototype;
      return !!(u && u.isReactComponent);
    }
    function FI(s) {
      return typeof s == "function" && !Tx(s) && s.defaultProps === void 0;
    }
    function FA(s) {
      if (typeof s == "function") return Tx(s) ? x : w;
      if (s != null) {
        var u = s.$$typeof;
        if (u === Ye) return F;
        if (u === $t) return K;
      }
      return E;
    }
    function ts(s, u) {
      var v = s.alternate;
      v === null ? (v = kc(s.tag, u, s.key, s.mode), v.elementType = s.elementType, v.type = s.type, v.stateNode = s.stateNode, v._debugSource = s._debugSource, v._debugOwner = s._debugOwner, v._debugHookTypes = s._debugHookTypes, v.alternate = s, s.alternate = v) : (v.pendingProps = u, v.type = s.type, v.flags = pt, v.subtreeFlags = pt, v.deletions = null, v.actualDuration = 0, v.actualStartTime = -1), v.flags = s.flags & nr, v.childLanes = s.childLanes, v.lanes = s.lanes, v.child = s.child, v.memoizedProps = s.memoizedProps, v.memoizedState = s.memoizedState, v.updateQueue = s.updateQueue;
      var _ = s.dependencies;
      switch (v.dependencies = _ === null ? null : {
        lanes: _.lanes,
        firstContext: _.firstContext
      }, v.sibling = s.sibling, v.index = s.index, v.ref = s.ref, v.selfBaseDuration = s.selfBaseDuration, v.treeBaseDuration = s.treeBaseDuration, v._debugNeedsRemount = s._debugNeedsRemount, v.tag) {
        case E:
        case w:
        case G:
          v.type = kp(s.type);
          break;
        case x:
          v.type = Su(s.type);
          break;
        case F:
          v.type = Nv(s.type);
          break;
      }
      return v;
    }
    function Uk(s, u) {
      s.flags &= nr | Gn;
      var v = s.alternate;
      if (v === null) s.childLanes = De, s.lanes = u, s.child = null, s.subtreeFlags = pt, s.memoizedProps = null, s.memoizedState = null, s.updateQueue = null, s.dependencies = null, s.stateNode = null, s.selfBaseDuration = 0, s.treeBaseDuration = 0;else {
        s.childLanes = v.childLanes, s.lanes = v.lanes, s.child = v.child, s.subtreeFlags = pt, s.deletions = null, s.memoizedProps = v.memoizedProps, s.memoizedState = v.memoizedState, s.updateQueue = v.updateQueue, s.type = v.type;
        var _ = v.dependencies;
        s.dependencies = _ === null ? null : {
          lanes: _.lanes,
          firstContext: _.firstContext
        }, s.selfBaseDuration = v.selfBaseDuration, s.treeBaseDuration = v.treeBaseDuration;
      }
      return s;
    }
    function NA(s, u, v) {
      var _;
      return s === _S ? (_ = Wt, u === !0 && (_ |= Xn, _ |= Ri)) : _ = dt, ui && (_ |= nn), kc(C, null, null, _);
    }
    function Hk(s, u, v, _, n, a) {
      var f = E,
        m = s;
      if (typeof s == "function") Tx(s) ? (f = x, m = Su(m)) : m = kp(m);else if (typeof s == "string") f = D;else e: switch (s) {
        case Oo:
          return zv(v.children, n, a, u);
        case $a:
          f = P, n |= Xn, (n & Wt) !== dt && (n |= Ri);
          break;
        case Lo:
          return zA(v, n, a, u);
        case xt:
          return $k(v, n, a, u);
        case rn:
          return Wk(v, n, a, u);
        case Tn:
          return Lm(v, n, a, u);
        case jn:
        // eslint-disable-next-line no-fallthrough
        case qt:
        // eslint-disable-next-line no-fallthrough
        case Lr:
        // eslint-disable-next-line no-fallthrough
        case Wa:
        // eslint-disable-next-line no-fallthrough
        case yr:
        // eslint-disable-next-line no-fallthrough
        default:
          {
            if (typeof s == "object" && s !== null) switch (s.$$typeof) {
              case Z:
                f = L;
                break e;
              case Ne:
                f = N;
                break e;
              case Ye:
                f = F, m = Nv(m);
                break e;
              case $t:
                f = K;
                break e;
              case Ct:
                f = Q, m = null;
                break e;
            }
            var b = "";
            {
              (s === void 0 || typeof s == "object" && s !== null && Object.keys(s).length === 0) && (b += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
              var T = _ ? At(_) : null;
              T && (b += `

Check the render method of \`` + T + "`.");
            }
            throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (s == null ? s : typeof s) + "." + b));
          }
      }
      var M = kc(f, v, u, n);
      return M.elementType = s, M.type = m, M.lanes = a, M._debugOwner = _, M;
    }
    function Om(s, u, v) {
      var _ = null;
      _ = s._owner;
      var n = s.type,
        a = s.key,
        f = s.props,
        m = Hk(n, a, f, _, u, v);
      return m._debugSource = s._source, m._debugOwner = s._owner, m;
    }
    function zv(s, u, v, _) {
      var n = kc(O, s, _, u);
      return n.lanes = v, n;
    }
    function zA(s, u, v, _) {
      typeof s.id != "string" && h('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof s.id);
      var n = kc(j, s, _, u | nn);
      return n.elementType = Lo, n.lanes = v, n.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, n;
    }
    function $k(s, u, v, _) {
      var n = kc(V, s, _, u);
      return n.elementType = xt, n.lanes = v, n;
    }
    function Wk(s, u, v, _) {
      var n = kc(Y, s, _, u);
      return n.elementType = rn, n.lanes = v, n;
    }
    function Lm(s, u, v, _) {
      var n = kc(oe, s, _, u);
      n.elementType = Tn, n.lanes = v;
      var a = {
        isHidden: !1
      };
      return n.stateNode = a, n;
    }
    function qk(s, u, v) {
      var _ = kc(I, s, null, u);
      return _.lanes = v, _;
    }
    function VA() {
      var s = kc(D, null, null, dt);
      return s.elementType = "DELETED", s;
    }
    function BA(s) {
      var u = kc(ie, null, null, dt);
      return u.stateNode = s, u;
    }
    function M1(s, u, v) {
      var _ = s.children !== null ? s.children : [],
        n = kc(k, _, s.key, u);
      return n.lanes = v, n.stateNode = {
        containerInfo: s.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: s.implementation
      }, n;
    }
    function O1(s, u) {
      return s === null && (s = kc(E, null, null, dt)), s.tag = u.tag, s.key = u.key, s.elementType = u.elementType, s.type = u.type, s.stateNode = u.stateNode, s.return = u.return, s.child = u.child, s.sibling = u.sibling, s.index = u.index, s.ref = u.ref, s.pendingProps = u.pendingProps, s.memoizedProps = u.memoizedProps, s.updateQueue = u.updateQueue, s.memoizedState = u.memoizedState, s.dependencies = u.dependencies, s.mode = u.mode, s.flags = u.flags, s.subtreeFlags = u.subtreeFlags, s.deletions = u.deletions, s.lanes = u.lanes, s.childLanes = u.childLanes, s.alternate = u.alternate, s.actualDuration = u.actualDuration, s.actualStartTime = u.actualStartTime, s.selfBaseDuration = u.selfBaseDuration, s.treeBaseDuration = u.treeBaseDuration, s._debugSource = u._debugSource, s._debugOwner = u._debugOwner, s._debugNeedsRemount = u._debugNeedsRemount, s._debugHookTypes = u._debugHookTypes, s;
    }
    function UA(s, u, v, _, n) {
      this.tag = u, this.containerInfo = s, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = t_, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = On, this.eventTimes = uf(De), this.expirationTimes = uf(wn), this.pendingLanes = De, this.suspendedLanes = De, this.pingedLanes = De, this.expiredLanes = De, this.mutableReadLanes = De, this.finishedLanes = De, this.entangledLanes = De, this.entanglements = uf(De), this.identifierPrefix = _, this.onRecoverableError = n, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */new Set();
        for (var a = this.pendingUpdatersLaneMap = [], f = 0; f < zl; f++) a.push(/* @__PURE__ */new Set());
      }
      switch (u) {
        case _S:
          this._debugRootType = v ? "hydrateRoot()" : "createRoot()";
          break;
        case lm:
          this._debugRootType = v ? "hydrate()" : "render()";
          break;
      }
    }
    function NI(s, u, v, _, n, a, f, m, b, T) {
      var M = new UA(s, u, v, m, b),
        z = NA(u, a);
      M.current = z, z.stateNode = M;
      {
        var U = {
          element: _,
          isDehydrated: v,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        z.memoizedState = U;
      }
      return w_(z), M;
    }
    var Rx = "18.2.0";
    function zI(s, u, v) {
      var _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return un(_), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: oi,
        key: _ == null ? null : "" + _,
        children: s,
        containerInfo: u,
        implementation: v
      };
    }
    var Yk, L1;
    Yk = !1, L1 = {};
    function P1(s) {
      if (!s) return fi;
      var u = Pl(s),
        v = wS(u);
      if (u.tag === x) {
        var _ = u.type;
        if (eu(_)) return bS(u, _, v);
      }
      return v;
    }
    function HA(s, u) {
      {
        var v = Pl(s);
        if (v === void 0) {
          if (typeof s.render == "function") throw new Error("Unable to find node on an unmounted component.");
          var _ = Object.keys(s).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + _);
        }
        var n = Xr(v);
        if (n === null) return null;
        if (n.mode & Xn) {
          var a = At(v) || "Component";
          if (!L1[a]) {
            L1[a] = !0;
            var f = Pr;
            try {
              Rn(n), v.mode & Xn ? h("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", u, u, a) : h("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", u, u, a);
            } finally {
              f ? Rn(f) : Un();
            }
          }
        }
        return n.stateNode;
      }
    }
    function A1(s, u, v, _, n, a, f, m) {
      var b = !1,
        T = null;
      return NI(s, u, b, T, v, _, n, a, f);
    }
    function j1(s, u, v, _, n, a, f, m, b, T) {
      var M = !0,
        z = NI(v, _, M, s, n, a, f, m, b);
      z.context = P1(null);
      var U = z.current,
        X = es(),
        J = Jf(U),
        me = Pf(X, J);
      return me.callback = u ?? null, wm(U, me, J), au(z, J, X), z;
    }
    function F0(s, u, v, _) {
      ki(u, s);
      var n = u.current,
        a = es(),
        f = Jf(n);
      _a(f);
      var m = P1(v);
      u.context === null ? u.context = m : u.pendingContext = m, Po && Pr !== null && !Yk && (Yk = !0, h(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, At(Pr) || "Unknown"));
      var b = Pf(a, f);
      b.payload = {
        element: s
      }, _ = _ === void 0 ? null : _, _ !== null && (typeof _ != "function" && h("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", _), b.callback = _);
      var T = wm(n, b, f);
      return T !== null && (Ba(T, n, f, a), Hc(T, n, f)), f;
    }
    function F1(s) {
      var u = s.current;
      if (!u.child) return null;
      switch (u.child.tag) {
        case D:
          return u.child.stateNode;
        default:
          return u.child.stateNode;
      }
    }
    function VI(s) {
      switch (s.tag) {
        case C:
          {
            var u = s.stateNode;
            if (fr(u)) {
              var v = Kg(u);
              EA(u, v);
            }
            break;
          }
        case V:
          {
            Ep(function () {
              var n = vu(s, Je);
              if (n !== null) {
                var a = es();
                Ba(n, s, Je, a);
              }
            });
            var _ = Je;
            rb(s, _);
            break;
          }
      }
    }
    function Gk(s, u) {
      var v = s.memoizedState;
      v !== null && v.dehydrated !== null && (v.retryLane = Sb(v.retryLane, u));
    }
    function rb(s, u) {
      Gk(s, u);
      var v = s.alternate;
      v && Gk(v, u);
    }
    function N1(s) {
      if (s.tag === V) {
        var u = Hl,
          v = vu(s, u);
        if (v !== null) {
          var _ = es();
          Ba(v, s, u, _);
        }
        rb(s, u);
      }
    }
    function $A(s) {
      if (s.tag === V) {
        var u = Jf(s),
          v = vu(s, u);
        if (v !== null) {
          var _ = es();
          Ba(v, s, u, _);
        }
        rb(s, u);
      }
    }
    function Xk(s) {
      var u = In(s);
      return u === null ? null : u.stateNode;
    }
    var z1 = function (s) {
      return null;
    };
    function WA(s) {
      return z1(s);
    }
    var BI = function (s) {
      return !1;
    };
    function UI(s) {
      return BI(s);
    }
    var Kk = null,
      HI = null,
      Qk = null,
      $I = null,
      Zk = null,
      Jk = null,
      eT = null,
      tT = null,
      nT = null;
    {
      var rT = function (s, u, v) {
          var _ = u[v],
            n = wr(s) ? s.slice() : Qt({}, s);
          return v + 1 === u.length ? (wr(n) ? n.splice(_, 1) : delete n[_], n) : (n[_] = rT(s[_], u, v + 1), n);
        },
        iT = function (s, u) {
          return rT(s, u, 0);
        },
        aT = function (s, u, v, _) {
          var n = u[_],
            a = wr(s) ? s.slice() : Qt({}, s);
          if (_ + 1 === u.length) {
            var f = v[_];
            a[f] = a[n], wr(a) ? a.splice(n, 1) : delete a[n];
          } else a[n] = aT(
          // $FlowFixMe number or string is fine here
          s[n], u, v, _ + 1);
          return a;
        },
        oT = function (s, u, v) {
          if (u.length !== v.length) {
            p("copyWithRename() expects paths of the same length");
            return;
          } else for (var _ = 0; _ < v.length - 1; _++) if (u[_] !== v[_]) {
            p("copyWithRename() expects paths to be the same except for the deepest key");
            return;
          }
          return aT(s, u, v, 0);
        },
        sT = function (s, u, v, _) {
          if (v >= u.length) return _;
          var n = u[v],
            a = wr(s) ? s.slice() : Qt({}, s);
          return a[n] = sT(s[n], u, v + 1, _), a;
        },
        lT = function (s, u, v) {
          return sT(s, u, 0, v);
        },
        V1 = function (s, u) {
          for (var v = s.memoizedState; v !== null && u > 0;) v = v.next, u--;
          return v;
        };
      Kk = function (s, u, v, _) {
        var n = V1(s, u);
        if (n !== null) {
          var a = lT(n.memoizedState, v, _);
          n.memoizedState = a, n.baseState = a, s.memoizedProps = Qt({}, s.memoizedProps);
          var f = vu(s, Je);
          f !== null && Ba(f, s, Je, wn);
        }
      }, HI = function (s, u, v) {
        var _ = V1(s, u);
        if (_ !== null) {
          var n = iT(_.memoizedState, v);
          _.memoizedState = n, _.baseState = n, s.memoizedProps = Qt({}, s.memoizedProps);
          var a = vu(s, Je);
          a !== null && Ba(a, s, Je, wn);
        }
      }, Qk = function (s, u, v, _) {
        var n = V1(s, u);
        if (n !== null) {
          var a = oT(n.memoizedState, v, _);
          n.memoizedState = a, n.baseState = a, s.memoizedProps = Qt({}, s.memoizedProps);
          var f = vu(s, Je);
          f !== null && Ba(f, s, Je, wn);
        }
      }, $I = function (s, u, v) {
        s.pendingProps = lT(s.memoizedProps, u, v), s.alternate && (s.alternate.pendingProps = s.pendingProps);
        var _ = vu(s, Je);
        _ !== null && Ba(_, s, Je, wn);
      }, Zk = function (s, u) {
        s.pendingProps = iT(s.memoizedProps, u), s.alternate && (s.alternate.pendingProps = s.pendingProps);
        var v = vu(s, Je);
        v !== null && Ba(v, s, Je, wn);
      }, Jk = function (s, u, v) {
        s.pendingProps = oT(s.memoizedProps, u, v), s.alternate && (s.alternate.pendingProps = s.pendingProps);
        var _ = vu(s, Je);
        _ !== null && Ba(_, s, Je, wn);
      }, eT = function (s) {
        var u = vu(s, Je);
        u !== null && Ba(u, s, Je, wn);
      }, tT = function (s) {
        z1 = s;
      }, nT = function (s) {
        BI = s;
      };
    }
    function WI(s) {
      var u = Xr(s);
      return u === null ? null : u.stateNode;
    }
    function qI(s) {
      return null;
    }
    function YI() {
      return Pr;
    }
    function uT(s) {
      var u = s.findFiberByHostInstance,
        v = i.ReactCurrentDispatcher;
      return Fl({
        bundleType: s.bundleType,
        version: s.version,
        rendererPackageName: s.rendererPackageName,
        rendererConfig: s.rendererConfig,
        overrideHookState: Kk,
        overrideHookStateDeletePath: HI,
        overrideHookStateRenamePath: Qk,
        overrideProps: $I,
        overridePropsDeletePath: Zk,
        overridePropsRenamePath: Jk,
        setErrorHandler: tT,
        setSuspenseHandler: nT,
        scheduleUpdate: eT,
        currentDispatcherRef: v,
        findHostInstanceByFiber: WI,
        findFiberByHostInstance: u || qI,
        // React Refresh
        findHostInstancesForRefresh: AI,
        scheduleRefresh: Fk,
        scheduleRoot: Nk,
        setRefreshHandler: PA,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: YI,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: Rx
      });
    }
    var GI = typeof reportError == "function" ?
    // In modern browsers, reportError will dispatch an error event,
    // emulating an uncaught JavaScript error.
    reportError : function (s) {
      console.error(s);
    };
    function cT(s) {
      this._internalRoot = s;
    }
    B1.prototype.render = cT.prototype.render = function (s) {
      var u = this._internalRoot;
      if (u === null) throw new Error("Cannot update an unmounted root.");
      {
        typeof arguments[1] == "function" ? h("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : U1(arguments[1]) ? h("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && h("You passed a second argument to root.render(...) but it only accepts one argument.");
        var v = u.containerInfo;
        if (v.nodeType !== er) {
          var _ = Xk(u.current);
          _ && _.parentNode !== v && h("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      F0(s, u, null, null);
    }, B1.prototype.unmount = cT.prototype.unmount = function () {
      typeof arguments[0] == "function" && h("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var s = this._internalRoot;
      if (s !== null) {
        this._internalRoot = null;
        var u = s.containerInfo;
        SI() && h("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), Ep(function () {
          F0(null, s, null, null);
        }), $b(u);
      }
    };
    function qA(s, u) {
      if (!U1(s)) throw new Error("createRoot(...): Target container is not a DOM element.");
      KI(s);
      var v = !1,
        _ = !1,
        n = "",
        a = GI;
      u != null && (u.hydrate ? p("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof u == "object" && u !== null && u.$$typeof === $i && h(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), u.unstable_strictMode === !0 && (v = !0), u.identifierPrefix !== void 0 && (n = u.identifierPrefix), u.onRecoverableError !== void 0 && (a = u.onRecoverableError), u.transitionCallbacks !== void 0 && u.transitionCallbacks);
      var f = A1(s, _S, null, v, _, n, a);
      mS(f.current, s);
      var m = s.nodeType === er ? s.parentNode : s;
      return sv(m), new cT(f);
    }
    function B1(s) {
      this._internalRoot = s;
    }
    function XI(s) {
      s && kb(s);
    }
    B1.prototype.unstable_scheduleHydration = XI;
    function dT(s, u, v) {
      if (!U1(s)) throw new Error("hydrateRoot(...): Target container is not a DOM element.");
      KI(s), u === void 0 && h("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var _ = v ?? null,
        n = v != null && v.hydratedSources || null,
        a = !1,
        f = !1,
        m = "",
        b = GI;
      v != null && (v.unstable_strictMode === !0 && (a = !0), v.identifierPrefix !== void 0 && (m = v.identifierPrefix), v.onRecoverableError !== void 0 && (b = v.onRecoverableError));
      var T = j1(u, null, s, _S, _, a, f, m, b);
      if (mS(T.current, s), sv(s), n) for (var M = 0; M < n.length; M++) {
        var z = n[M];
        jC(T, z);
      }
      return new B1(T);
    }
    function U1(s) {
      return !!(s && (s.nodeType === Wr || s.nodeType === Ka || s.nodeType === ph));
    }
    function Vv(s) {
      return !!(s && (s.nodeType === Wr || s.nodeType === Ka || s.nodeType === ph || s.nodeType === er && s.nodeValue === " react-mount-point-unstable "));
    }
    function KI(s) {
      s.nodeType === Wr && s.tagName && s.tagName.toUpperCase() === "BODY" && h("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), pv(s) && (s._reactRootContainer ? h("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : h("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    var YA = i.ReactCurrentOwner,
      Dx;
    Dx = function (s) {
      if (s._reactRootContainer && s.nodeType !== er) {
        var u = Xk(s._reactRootContainer.current);
        u && u.parentNode !== s && h("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var v = !!s._reactRootContainer,
        _ = ib(s),
        n = !!(_ && Nc(_));
      n && !v && h("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), s.nodeType === Wr && s.tagName && s.tagName.toUpperCase() === "BODY" && h("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function ib(s) {
      return s ? s.nodeType === Ka ? s.documentElement : s.firstChild : null;
    }
    function fT() {}
    function GA(s, u, v, _, n) {
      if (n) {
        if (typeof _ == "function") {
          var a = _;
          _ = function () {
            var U = F1(f);
            a.call(U);
          };
        }
        var f = j1(u, _, s, lm, null,
        // hydrationCallbacks
        !1,
        // isStrictMode
        !1,
        // concurrentUpdatesByDefaultOverride,
        "",
        // identifierPrefix
        fT);
        s._reactRootContainer = f, mS(f.current, s);
        var m = s.nodeType === er ? s.parentNode : s;
        return sv(m), Ep(), f;
      } else {
        for (var b; b = s.lastChild;) s.removeChild(b);
        if (typeof _ == "function") {
          var T = _;
          _ = function () {
            var U = F1(M);
            T.call(U);
          };
        }
        var M = A1(s, lm, null,
        // hydrationCallbacks
        !1,
        // isStrictMode
        !1,
        // concurrentUpdatesByDefaultOverride,
        "",
        // identifierPrefix
        fT);
        s._reactRootContainer = M, mS(M.current, s);
        var z = s.nodeType === er ? s.parentNode : s;
        return sv(z), Ep(function () {
          F0(u, M, v, _);
        }), M;
      }
    }
    function QI(s, u) {
      s !== null && typeof s != "function" && h("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", u, s);
    }
    function N0(s, u, v, _, n) {
      Dx(v), QI(n === void 0 ? null : n, "render");
      var a = v._reactRootContainer,
        f;
      if (!a) f = GA(v, u, s, n, _);else {
        if (f = a, typeof n == "function") {
          var m = n;
          n = function () {
            var b = F1(f);
            m.call(b);
          };
        }
        F0(u, f, s, n);
      }
      return F1(f);
    }
    function ZI(s) {
      {
        var u = YA.current;
        if (u !== null && u.stateNode !== null) {
          var v = u.stateNode._warnedAboutRefsInRender;
          v || h("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", bn(u.type) || "A component"), u.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return s == null ? null : s.nodeType === Wr ? s : HA(s, "findDOMNode");
    }
    function XA(s, u, v) {
      if (h("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Vv(u)) throw new Error("Target container is not a DOM element.");
      {
        var _ = pv(u) && u._reactRootContainer === void 0;
        _ && h("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
      }
      return N0(null, s, u, !0, v);
    }
    function KA(s, u, v) {
      if (h("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Vv(u)) throw new Error("Target container is not a DOM element.");
      {
        var _ = pv(u) && u._reactRootContainer === void 0;
        _ && h("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return N0(null, s, u, !1, v);
    }
    function H1(s, u, v, _) {
      if (h("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Vv(v)) throw new Error("Target container is not a DOM element.");
      if (s == null || !Iw(s)) throw new Error("parentComponent must be a valid React Component");
      return N0(s, u, v, !1, _);
    }
    function QA(s) {
      if (!Vv(s)) throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var u = pv(s) && s._reactRootContainer === void 0;
        u && h("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (s._reactRootContainer) {
        {
          var v = ib(s),
            _ = v && !Nc(v);
          _ && h("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return Ep(function () {
          N0(null, null, s, !1, function () {
            s._reactRootContainer = null, $b(s);
          });
        }), !0;
      } else {
        {
          var n = ib(s),
            a = !!(n && Nc(n)),
            f = s.nodeType === Wr && Vv(s.parentNode) && !!s.parentNode._reactRootContainer;
          a && h("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", f ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    Eb(VI), ey(N1), cl($A), Jm(Ir), du(la), (typeof Map != "function" ||
    // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" ||
    // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && h("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), Ld(tC), Dw(Dk, Fv, Ep);
    function ZA(s, u) {
      var v = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!U1(u)) throw new Error("Target container is not a DOM element.");
      return zI(s, u, null, v);
    }
    function JA(s, u, v, _) {
      return H1(s, u, v, _);
    }
    var pT = {
      usingClientEntryPoint: !1,
      // Keep in sync with ReactTestUtils.js.
      // This is an array for better minification.
      Events: [Nc, zc, Ef, Il, Pd, Dk]
    };
    function e2(s, u) {
      return pT.usingClientEntryPoint || h('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), qA(s, u);
    }
    function t2(s, u, v) {
      return pT.usingClientEntryPoint || h('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), dT(s, u, v);
    }
    function n2(s) {
      return SI() && h("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), Ep(s);
    }
    var hT = uT({
      findFiberByHostInstance: hv,
      bundleType: 1,
      version: Rx,
      rendererPackageName: "react-dom"
    });
    if (!hT && Xe && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var JI = window.location.protocol;
      /^(https?|file):$/.test(JI) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (JI === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    ep.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = pT, ep.createPortal = ZA, ep.createRoot = e2, ep.findDOMNode = ZI, ep.flushSync = n2, ep.hydrate = XA, ep.hydrateRoot = t2, ep.render = KA, ep.unmountComponentAtNode = QA, ep.unstable_batchedUpdates = Dk, ep.unstable_renderSubtreeIntoContainer = JA, ep.version = Rx, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), ep;
}
var rB;
function oK() {
  if (rB) return fM.exports;
  rB = 1;
  function t() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
      if (process.env.NODE_ENV !== "production") throw new Error("^_^");
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(t);
      } catch (e) {
        console.error(e);
      }
    }
  }
  return process.env.NODE_ENV === "production" ? (t(), fM.exports = iK()) : fM.exports = aK(), fM.exports;
}
var sK = oK();
function S4(t, e) {
  if (t == null) return {};
  var i = {},
    l = Object.keys(t),
    c,
    p;
  for (p = 0; p < l.length; p++) c = l[p], !(e.indexOf(c) >= 0) && (i[c] = t[c]);
  return i;
}
var E4 = typeof window < "u" && typeof document < "u";
function Fj(t, e) {
  t && (typeof t == "function" && t(e), {}.hasOwnProperty.call(t, "current") && (t.current = e));
}
function iB() {
  return E4 && document.createElement("div");
}
function lK(t) {
  var e = {
    "data-placement": t.placement
  };
  return t.referenceHidden && (e["data-reference-hidden"] = ""), t.escaped && (e["data-escaped"] = ""), e;
}
function C4(t, e) {
  if (t === e) return !0;
  if (typeof t == "object" && t != null && typeof e == "object" && e != null) {
    if (Object.keys(t).length !== Object.keys(e).length) return !1;
    for (var i in t) if (e.hasOwnProperty(i)) {
      if (!C4(t[i], e[i])) return !1;
    } else return !1;
    return !0;
  } else return !1;
}
function uK(t) {
  var e = [];
  return t.forEach(function (i) {
    e.find(function (l) {
      return C4(i, l);
    }) || e.push(i);
  }), e;
}
function cK(t, e) {
  var i, l;
  return Object.assign({}, e, {
    popperOptions: Object.assign({}, t.popperOptions, e.popperOptions, {
      modifiers: uK([].concat(((i = t.popperOptions) == null ? void 0 : i.modifiers) || [], ((l = e.popperOptions) == null ? void 0 : l.modifiers) || []))
    })
  });
}
var x2 = E4 ? NR : Rt;
function dK(t) {
  var e = vt();
  return e.current || (e.current = typeof t == "function" ? t() : t), e.current;
}
function aB(t, e, i) {
  i.split(/\s+/).forEach(function (l) {
    l && t.classList[e](l);
  });
}
var fK = {
  name: "className",
  defaultValue: "",
  fn: function (t) {
    var e = t.popper.firstElementChild,
      i = function () {
        var p;
        return !!((p = t.props.render) != null && p.$$tippy);
      };
    function l() {
      if (t.props.className && !i()) {
        process.env.NODE_ENV !== "production" && console.warn(["@tippyjs/react: Cannot use `className` prop in conjunction with", "`render` prop. Place the className on the element you are", "rendering."].join(" "));
        return;
      }
      aB(e, "add", t.props.className);
    }
    function c() {
      i() && aB(e, "remove", t.props.className);
    }
    return {
      onCreate: l,
      onBeforeUpdate: c,
      onAfterUpdate: l
    };
  }
};
function pK(t) {
  function e(i) {
    var l = i.children,
      c = i.content,
      p = i.visible,
      h = i.singleton,
      y = i.render,
      w = i.reference,
      x = i.disabled,
      E = x === void 0 ? !1 : x,
      C = i.ignoreAttributes,
      k = C === void 0 ? !0 : C;
    i.__source, i.__self;
    var D = S4(i, ["children", "content", "visible", "singleton", "render", "reference", "disabled", "ignoreAttributes", "__source", "__self"]),
      I = p !== void 0,
      O = h !== void 0,
      P = rt(!1),
      N = P[0],
      L = P[1],
      F = rt({}),
      j = F[0],
      V = F[1],
      K = rt(),
      G = K[0],
      Q = K[1],
      te = dK(function () {
        return {
          container: iB(),
          renders: 1
        };
      }),
      ie = Object.assign({
        ignoreAttributes: k
      }, D, {
        content: te.container
      });
    I && (process.env.NODE_ENV !== "production" && ["trigger", "hideOnClick", "showOnCreate"].forEach(function (ne) {
      ie[ne] !== void 0 && console.warn(["@tippyjs/react: Cannot specify `" + ne + "` prop in", "controlled mode (`visible` prop)"].join(" "));
    }), ie.trigger = "manual", ie.hideOnClick = !1), O && (E = !0);
    var Y = ie,
      ee = ie.plugins || [];
    y && (Y = Object.assign({}, ie, {
      plugins: O && h.data != null ? [].concat(ee, [{
        fn: function () {
          return {
            onTrigger: function (ne, se) {
              var ue = h.data.children.find(function (W) {
                var $ = W.instance;
                return $.reference === se.currentTarget;
              });
              ne.state.$$activeSingletonInstance = ue.instance, Q(ue.content);
            }
          };
        }
      }]) : ee,
      render: function () {
        return {
          popper: te.container
        };
      }
    }));
    var oe = [w].concat(l ? [l.type] : []);
    return x2(function () {
      var ne = w;
      w && w.hasOwnProperty("current") && (ne = w.current);
      var se = t(ne || te.ref || iB(), Object.assign({}, Y, {
        plugins: [fK].concat(ie.plugins || [])
      }));
      return te.instance = se, E && se.disable(), p && se.show(), O && h.hook({
        instance: se,
        content: c,
        props: Y,
        setSingletonContent: Q
      }), L(!0), function () {
        se.destroy(), h == null || h.cleanup(se);
      };
    }, oe), x2(function () {
      var ne;
      if (te.renders === 1) {
        te.renders++;
        return;
      }
      var se = te.instance;
      se.setProps(cK(se.props, Y)), (ne = se.popperInstance) == null || ne.forceUpdate(), E ? se.disable() : se.enable(), I && (p ? se.show() : se.hide()), O && h.hook({
        instance: se,
        content: c,
        props: Y,
        setSingletonContent: Q
      });
    }), x2(function () {
      var ne;
      if (y) {
        var se = te.instance;
        se.setProps({
          popperOptions: Object.assign({}, se.props.popperOptions, {
            modifiers: [].concat((((ne = se.props.popperOptions) == null ? void 0 : ne.modifiers) || []).filter(function (ue) {
              var W = ue.name;
              return W !== "$$tippyReact";
            }), [{
              name: "$$tippyReact",
              enabled: !0,
              phase: "beforeWrite",
              requires: ["computeStyles"],
              fn: function (ue) {
                var W,
                  $ = ue.state,
                  le = (W = $.modifiersData) == null ? void 0 : W.hide;
                (j.placement !== $.placement || j.referenceHidden !== (le == null ? void 0 : le.isReferenceHidden) || j.escaped !== (le == null ? void 0 : le.hasPopperEscaped)) && V({
                  placement: $.placement,
                  referenceHidden: le == null ? void 0 : le.isReferenceHidden,
                  escaped: le == null ? void 0 : le.hasPopperEscaped
                }), $.attributes.popper = {};
              }
            }])
          })
        });
      }
    }, [j.placement, j.referenceHidden, j.escaped].concat(oe)), /* @__PURE__ */Nt.createElement(Nt.Fragment, null, l ? /* @__PURE__ */FR(l, {
      ref: function (ne) {
        te.ref = ne, Fj(l.ref, ne);
      }
    }) : null, N && /* @__PURE__ */sK.createPortal(y ? y(lK(j), G, te.instance) : c, te.container));
  }
  return e;
}
var hK = function (t, e) {
    return /* @__PURE__ */Qn(function (i, l) {
      var c = i.children,
        p = S4(i, ["children"]);
      return (
        // If I spread them separately here, Babel adds the _extends ponyfill for
        // some reason
        /* @__PURE__ */
        Nt.createElement(t, Object.assign({}, e, p), c ? /* @__PURE__ */FR(c, {
          ref: function (h) {
            Fj(l, h), Fj(c.ref, h);
          }
        }) : null)
      );
    });
  },
  mK = /* @__PURE__ */hK(/* @__PURE__ */pK(HR));
const vK = /* @__PURE__ */new Set(["key", "ref", "children", "dangerouslySetInnerHTML"]),
  gK = (t, e) => {
    if (!t) return null;
    const i = c => {
        const {
          className: p,
          ...h
        } = c;
        return {
          safeData: Object.fromEntries(Object.entries(h).filter(([y]) => !vK.has(y))),
          dataClassName: p
        };
      },
      l = (c, p, h) => Nt.cloneElement(c, {
        ...p,
        className: Ze(h, c.props.className)
      });
    if (typeof t == "function") {
      const c = t(e);
      if (Nt.isValidElement(c)) {
        const {
          safeData: p,
          dataClassName: h
        } = i(e);
        return l(c, p, h);
      }
      if (Nt.Children.count(c)) {
        const p = Nt.Children.toArray(c).filter(w => Nt.isValidElement(w)),
          {
            safeData: h,
            dataClassName: y
          } = i(e);
        return p.map((w, x) => l(w, {
          key: w.key || x,
          ...h
        }, y));
      }
      return c;
    }
    if (Nt.isValidElement(t)) {
      const {
        safeData: c,
        dataClassName: p
      } = i(e);
      return l(t, c, p);
    }
    if (Nt.Children.count(t)) {
      const c = Nt.Children.toArray(t).filter(y => Nt.isValidElement(y)),
        {
          safeData: p,
          dataClassName: h
        } = i(e);
      return c.map((y, w) => l(y, {
        key: y.key || w,
        ...p
      }, h));
    }
    return null;
  },
  yK = "_popover_fibcz_2",
  bK = "_selectedValue_fibcz_15",
  wK = "_popoverInput_fibcz_30",
  _K = "_popoverInputValue_fibcz_42",
  xK = "_dropdownIcon_fibcz_64",
  SK = "_dropdownIconDisabled_fibcz_76",
  Rp = {
    popover: yK,
    selectedValue: bK,
    popoverInput: wK,
    popoverInputValue: _K,
    dropdownIcon: xK,
    dropdownIconDisabled: SK
  },
  EK = {
    noResults: "No results found",
    a11yOpenMenu: "Open menu",
    a11yCloseMenu: "Close menu",
    a11ySelectedLiveRegion: 'Selected option changed to "{{ label }}"'
  },
  CK = ({
    id: t,
    isDisabled: e = !1,
    errorMessage: i,
    className: l,
    classNames: c,
    iconOptions: p,
    label: h,
    labels: y = {},
    value: w,
    children: x,
    onChange: E,
    onClose: C = () => !0,
    defaultCloseIcon: k = !0,
    helperText: D,
    isLoading: I = !1
  }) => {
    const O = {
        ...EK,
        ...y
      },
      P = vt(null),
      [N, L] = rt(!1),
      [F, j] = rt(!1);
    Rt(() => {
      let G = null;
      if (N && P != null && P.current) return G = P.current, j(!0), $O(P.current, {
        reserveScrollBarGap: !0,
        allowTouchMove: Q => {
          let te = Q;
          for (; te && te.parentElement;) {
            if (te.hasAttribute("body-scroll-lock-ignore")) return !0;
            te = te.parentElement;
          }
          return !1;
        }
      }), () => {
        G && aR(G);
      };
    }, [N]);
    const V = () => C() === !1 ? !1 : (L(!1), j(!1), !0),
      K = () => {
        L(!N);
      };
    return /* @__PURE__ */_e.jsx(AE, {
      ref: P,
      className: vl(Rp.popover, N && !I && [c == null ? void 0 : c.inputWrapperOpen], (!!w || I) && [Rp.selectedValue, c == null ? void 0 : c.inputWrapperSelected], l, F && Rp.popoverFocus),
      classNames: {
        label: vl(c == null ? void 0 : c.inputLabel),
        helperText: c == null ? void 0 : c.inputHelperText,
        errorText: vl(!e && i && (c == null ? void 0 : c.inputErrorText)),
        focus: vl(F && (c == null ? void 0 : c.inputWrapperFocus)),
        error: vl(!e && i && [Rp.popoverError, c == null ? void 0 : c.inputWrapperError]),
        disabled: vl(e && [Rp.popoverInputDisabled, c == null ? void 0 : c.inputWrapperDisabled])
      },
      errorMessage: i,
      messageId: `${t}-message`,
      isDisabled: e,
      helperText: D,
      isFocused: F && !I,
      children: /* @__PURE__ */_e.jsxs("div", {
        className: vl(c == null ? void 0 : c.inputContainer),
        children: [/* @__PURE__ */_e.jsxs("button", {
          disabled: e,
          type: "button",
          "aria-label": N && !I ? O.a11yCloseMenu : O.a11yOpenMenu,
          "aria-describedby": D || i ? `${t}-message` : void 0,
          onFocusCapture: () => {
            j(!0);
          },
          onBlurCapture: () => {
            j(!1);
          },
          className: vl(Rp.popoverInput, I && (c == null ? void 0 : c.inputLoader), c == null ? void 0 : c.inputToggleButton),
          id: `${t}-input`,
          onClick: K,
          onKeyDown: G => {
            (G.key === "Enter" || G.key === " " || G.key === "Spacebar") && (G.preventDefault(), K());
          },
          children: [/* @__PURE__ */_e.jsx("label", {
            id: `${t}-label`,
            children: h
          }), /* @__PURE__ */_e.jsx("span", {
            className: vl(Rp.popoverInputValue, c == null ? void 0 : c.value),
            children: w
          }), I && /* @__PURE__ */_e.jsx(FE, {
            className: c == null ? void 0 : c.loader,
            size: hb.small,
            status: Um.loading,
            align: jE.vertical,
            responsive: !1
          }), !e && !I && /* @__PURE__ */_e.jsxs("span", {
            "aria-hidden": "true",
            className: vl(c == null ? void 0 : c.icon, i ? [Rp.dropdownIcon, Rp.dropdownIconError, c == null ? void 0 : c.iconError] : Rp.dropdownIcon),
            children: [N && ((p == null ? void 0 : p.open) || /* @__PURE__ */_e.jsx(_e.Fragment, {
              children: "▲"
            })), !N && ((p == null ? void 0 : p.close) || /* @__PURE__ */_e.jsx(_e.Fragment, {
              children: "▼"
            }))]
          }), e && /* @__PURE__ */_e.jsx("span", {
            "aria-hidden": "true",
            className: vl(Rp.dropdownIcon, Rp.dropdownIconDisabled, c == null ? void 0 : c.icon, c == null ? void 0 : c.iconDisabled),
            children: (p == null ? void 0 : p.disabled) || /* @__PURE__ */_e.jsx(_e.Fragment, {
              children: "×"
            })
          })]
        }), N && /* @__PURE__ */_e.jsx(mK, {
          reference: P.current,
          visible: N,
          interactive: !0,
          appendTo: P.current || void 0,
          placement: "bottom-start",
          popperOptions: {
            strategy: "absolute",
            modifiers: [{
              name: "flip",
              enabled: !1
            }, {
              name: "offset",
              enabled: !1
            }, {
              name: "preventOverflow",
              enabled: !0,
              options: {
                padding: 0,
                boundary: typeof window < "u" ? window : "scrollParent"
              }
            }, {
              name: "maxHeight",
              enabled: !0,
              phase: "afterMain",
              requiresIfExists: ["offset"],
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              fn({
                state: G
              }) {
                const Q = window.innerHeight - G.elements.popper.getBoundingClientRect().top - 16;
                G.styles.popper = {
                  ...G.styles.popper,
                  maxHeight: `${Q}px`,
                  width: "100%",
                  boxShadow: "-5px 9px 16px rgba(0, 0, 0, 0.29)"
                };
              }
            }]
          },
          render: G => {
            const Q = {
              isOpen: N,
              handleClose: V,
              handleUpdateValue: te => {
                E(te), V();
              }
            };
            return /* @__PURE__ */_e.jsx(e4.FocusTrap, {
              active: N,
              paused: !N,
              focusTrapOptions: {
                allowOutsideClick: te => {
                  var ie;
                  return (ie = te.target.closest("label")) != null && ie.contains(P.current) ? !0 : C() === !1 ? (te.stopPropagation(), !1) : (V(), !0);
                },
                clickOutsideDeactivates: !0,
                onDeactivate: V
              },
              children: /* @__PURE__ */_e.jsx("div", {
                ...G,
                className: vl(c == null ? void 0 : c.popover),
                children: /* @__PURE__ */_e.jsxs("div", {
                  className: vl(c == null ? void 0 : c.popoverContainer, N && [c == null ? void 0 : c.popoverContainerOpen]),
                  children: [k && /* @__PURE__ */_e.jsx("button", {
                    type: "button",
                    className: vl(c == null ? void 0 : c.closeButton),
                    id: t,
                    onClick: V,
                    children: /* @__PURE__ */_e.jsx(Qv, {
                      children: k
                    })
                  }), gK(x, Q)]
                })
              })
            });
          }
        })]
      })
    });
  },
  kK = "_wrapper_tdghy_1",
  TK = "_input_tdghy_17",
  RK = "_error_tdghy_101",
  DK = "_disabled_tdghy_126",
  IK = "_label_tdghy_143",
  MK = "_helperText_tdghy_154",
  G1 = {
    wrapper: kK,
    input: TK,
    error: RK,
    disabled: DK,
    label: IK,
    helperText: MK
  },
  k4 = Qn(({
    id: t,
    label: e,
    name: i,
    value: l,
    isSelected: c = !1,
    isError: p = !1,
    isRequired: h = !1,
    isDisabled: y = !1,
    helperText: w,
    selectedOption: x,
    onChange: E,
    className: C,
    classNames: k,
    isInteractive: D = !0,
    renderLabel: I
  }, O) => {
    const [P, N] = rt(c),
      L = {
        label: e,
        id: t,
        value: l
      },
      F = {
        label: x == null ? void 0 : x.label,
        id: x == null ? void 0 : x.id,
        value: x == null ? void 0 : x.value
      },
      j = Ze(G1.wrapper, C, !P && p && Ze(G1.error, k == null ? void 0 : k.error), y && Ze(G1.disabled, k == null ? void 0 : k.disabled), k == null ? void 0 : k.wrapper),
      V = Q => {
        L.id !== F.id && (N(!0), E == null || E(Q, !0, L));
      },
      K = Q => {
        L.id !== F.id ? (N(!0), E == null || E(Q, !0, L)) : L.id === F.id && (N(!1), E == null || E(Q, !1, void 0));
      },
      G = Q => {
        ["Space", "Enter"].includes(Q.code) && (L.id !== F.id ? (N(!0), E == null || E(Q, !0, L)) : L.id === F.id && (N(!1), E == null || E(Q, !1, void 0)));
      };
    return Rt(() => {
      L.id !== F.id ? N(!1) : (L.id === F.id || c) && N(!0);
    }, [x, c]), /* @__PURE__ */_e.jsxs("div", {
      className: j,
      children: [/* @__PURE__ */_e.jsx("input", {
        ref: O,
        className: Ze(G1.input, k == null ? void 0 : k.input),
        type: "radio",
        id: t,
        name: i,
        value: l,
        checked: !y && (L.id === F.id || c || !F && P),
        onChange: V,
        onClick: K,
        onKeyUp: G,
        required: h,
        disabled: D ? y : !0,
        "aria-describedby": w ? `${t}-message` : void 0
      }), /* @__PURE__ */_e.jsx("span", {
        "aria-hidden": "true"
      }), /* @__PURE__ */_e.jsx("label", {
        htmlFor: t,
        className: Ze(G1.label, k == null ? void 0 : k.label),
        children: I ? I(L) : e
      }), w && /* @__PURE__ */_e.jsx("div", {
        id: `${t}-message`,
        className: Ze(G1.helperText, k == null ? void 0 : k.helperText),
        children: w
      })]
    });
  }),
  OK = "_fieldset_kog2t_1",
  LK = "_hideLabel_kog2t_9",
  PK = "_label_kog2t_21",
  AK = "_stacked_kog2t_32",
  jK = "_options_kog2t_32",
  FK = "_inline_kog2t_40",
  NK = "_wrapper_kog2t_49",
  Nm = {
    fieldset: OK,
    hideLabel: LK,
    label: PK,
    stacked: AK,
    options: jK,
    inline: FK,
    wrapper: NK
  },
  zK = ({
    id: t,
    name: e,
    description: i,
    displayStacked: l = !1,
    options: c,
    label: p,
    hideLabel: h = !1,
    selectedOption: y,
    errorMessage: w,
    onChange: x,
    allowDeselect: E = !0,
    className: C,
    classNames: k,
    renderLabel: D
  }) => {
    const [I, O] = rt(y),
      P = (N, L, F) => {
        (E || F) && (O(F), x == null || x(N, L, F));
      };
    return /* @__PURE__ */_e.jsx("div", {
      id: t,
      className: Ze(l ? Nm.stacked : Nm.inline, {
        [C]: C
      }),
      children: /* @__PURE__ */_e.jsxs("fieldset", {
        className: Ze(Nm.fieldset, k == null ? void 0 : k.fieldset),
        "aria-describedby": Ze(i ? `${t}-description` : void 0, w ? `${t}-error` : void 0),
        children: [/* @__PURE__ */_e.jsxs("div", {
          className: Ze((i || !h) && Nm.label, k == null ? void 0 : k.groupLabel),
          children: [/* @__PURE__ */_e.jsx("legend", {
            className: Ze(h && Nm.hideLabel),
            children: p
          }), i && /* @__PURE__ */_e.jsx("span", {
            id: `${t}-description`,
            className: Ze(Nm.description, k == null ? void 0 : k.description),
            children: i
          })]
        }), /* @__PURE__ */_e.jsx("div", {
          className: Ze(Nm.options, k == null ? void 0 : k.options),
          children: c.map(N => /* @__PURE__ */_e.jsx(k4, {
            label: N.label,
            id: N.id,
            name: e,
            value: N.value,
            isSelected: I === N,
            isDisabled: N.isDisabled,
            isRequired: N.isRequired,
            isError: !!w && I === void 0,
            helperText: N.helperText,
            selectedOption: I,
            onChange: P,
            renderLabel: D,
            classNames: {
              wrapper: Ze(Nm.wrapper, k == null ? void 0 : k.wrapper),
              label: Ze(k == null ? void 0 : k.label),
              input: Ze(k == null ? void 0 : k.input),
              error: Ze(Nm.error, k == null ? void 0 : k.error),
              disabled: Ze(Nm.disabled, k == null ? void 0 : k.disabled),
              helperText: Ze(Nm.helperText, k == null ? void 0 : k.helperText)
            }
          }, N.id))
        }), !!w && I === void 0 && /* @__PURE__ */_e.jsx("div", {
          role: "alert",
          id: `${t}-error`,
          className: Ze(k == null ? void 0 : k.errorMessage),
          children: /* @__PURE__ */_e.jsx("span", {
            children: w
          })
        })]
      })
    });
  },
  VK = "_container_1bg47_1",
  BK = "_col_1bg47_7",
  oB = {
    container: VK,
    col: BK
  },
  R_e = ({
    columns: t,
    renderComponent: e
  }) => /* @__PURE__ */_e.jsx("div", {
    className: oB.container,
    children: t == null ? void 0 : t.map((i, l) => {
      var c;
      return /* @__PURE__ */_e.jsx("div", {
        className: oB.col,
        style: {
          "--_mobile-cols": i.columnSizes.mobile.value,
          "--_tablet-cols": i.columnSizes.tablet.value,
          "--_desktop-cols": i.columnSizes.desktop.value
        },
        children: (c = i.components) == null ? void 0 : c.map((p, h) => e(p, h))
      }, l);
    })
  }),
  UK = "_rating_1poqx_1",
  HK = "_ratingText_1poqx_14",
  sB = {
    rating: UK,
    ratingText: HK
  },
  $K = ({
    rating: t = 0,
    ratingText: e,
    maximum: i = 5,
    simple: l = !1,
    classNames: c,
    renderSolidIcon: p = /* @__PURE__ */_e.jsx(_e.Fragment, {
      children: "★"
    }),
    renderPartialIcon: h = /* @__PURE__ */_e.jsx(_e.Fragment, {
      children: "½"
    }),
    renderOutlineIcon: y = /* @__PURE__ */_e.jsx(_e.Fragment, {
      children: "☆"
    })
  }) => {
    const w = i <= 0 ? 0 : Math.floor(i);
    let x = t >= w ? w : t;
    return x = x < 0 ? 0 : x, /* @__PURE__ */_e.jsxs("div", {
      className: Ze(sB.rating, c == null ? void 0 : c.container),
      children: [w > 0 && [...Array(Math.floor(l ? 1 : x))].map((E, C) => /* @__PURE__ */_e.jsx(Qv, {
        children: p
      }, `${C}-solid`)), w > 0 && !l && x % 1 !== 0 && /* @__PURE__ */_e.jsx(_e.Fragment, {
        children: h
      }), w > 0 && !l && Math.round(x) < w && [...Array(w > 0 ? w - Math.ceil(x) : 1)].map((E, C) => /* @__PURE__ */_e.jsx(Qv, {
        children: y
      }, `${C}-outline`)), /* @__PURE__ */_e.jsx("span", {
        className: Ze(sB.ratingText, c == null ? void 0 : c.rating),
        children: e ?? x.toFixed(1)
      })]
    });
  },
  T4 = "Tabs",
  R4 = "TabsList",
  D4 = "TabsTrigger",
  I4 = "TabsContent",
  [WK, D_e] = OE(T4, [GO]),
  M4 = GO(),
  [qK, zE] = WK(T4),
  O4 = Qn((t, e) => {
    const {
        __scopeTabs: i,
        loop: l = !0,
        ...c
      } = t,
      p = zE(R4, i),
      h = M4(i);
    return /* @__PURE__ */_e.jsx(hN, {
      asChild: !0,
      ...h,
      orientation: p.orientation,
      dir: p.dir,
      loop: l,
      children: /* @__PURE__ */_e.jsx(sa.div, {
        role: "tablist",
        "aria-orientation": p.orientation,
        ...c,
        ref: e
      })
    });
  });
O4.displayName = R4;
function L4(t, e) {
  return `${t}-trigger-${e}`;
}
function P4(t, e) {
  return `${t}-content-${e}`;
}
const A4 = Qn((t, e) => {
  const {
      __scopeTabs: i,
      value: l,
      children: c,
      ...p
    } = t,
    h = zE(I4, i),
    y = L4(h.baseId, l),
    w = P4(h.baseId, l),
    x = l === h.value,
    E = vt(x);
  return Rt(() => {
    const C = requestAnimationFrame(() => E.current = !1);
    return () => cancelAnimationFrame(C);
  }, []), /* @__PURE__ */_e.jsx(sa.div, {
    "data-state": x ? "active" : "inactive",
    "data-orientation": h.orientation,
    role: "tabpanel",
    "aria-labelledby": y,
    hidden: !x,
    id: w,
    tabIndex: 0,
    ...p,
    ref: e,
    style: {
      animationDuration: E.current ? "0s" : void 0
    },
    children: c
  });
});
A4.displayName = I4;
const j4 = Qn((t, e) => {
  const {
      __scopeTabs: i,
      value: l,
      disabled: c = !1,
      ...p
    } = t,
    h = zE(D4, i),
    y = M4(i),
    w = L4(h.baseId, l),
    x = P4(h.baseId, l),
    E = l === h.value;
  return /* @__PURE__ */_e.jsx($5, {
    asChild: !0,
    ...y,
    focusable: !c,
    active: E,
    children: /* @__PURE__ */_e.jsx(sa.button, {
      type: "button",
      role: "tab",
      "aria-selected": E,
      "aria-controls": x,
      "data-state": E ? "active" : "inactive",
      "data-disabled": c ? "" : void 0,
      disabled: c,
      id: w,
      ...p,
      ref: e,
      onMouseDown: zp(t.onMouseDown, C => {
        !c && C.button === 0 && C.ctrlKey === !1 ? h.onValueChange(l) : C.preventDefault();
      }),
      onKeyDown: zp(t.onKeyDown, C => {
        [" ", "Enter"].includes(C.key) && h.onValueChange(l);
      }),
      onFocus: zp(t.onFocus, () => {
        const C = h.activationMode !== "manual";
        !E && !c && C && h.onValueChange(l);
      })
    })
  });
});
j4.displayName = D4;
const YK = Qn((t, e) => {
    const {
        __scopeTabs: i,
        value: l,
        onValueChange: c,
        defaultValue: p,
        orientation: h = "horizontal",
        dir: y,
        activationMode: w = "automatic",
        ...x
      } = t,
      E = dN(y),
      [C, k] = PE({
        prop: l,
        onChange: c,
        defaultProp: p ?? ""
      });
    return /* @__PURE__ */_e.jsx(qK, {
      scope: i,
      baseId: ME(),
      value: C,
      onValueChange: k,
      orientation: h,
      dir: E,
      activationMode: w,
      children: /* @__PURE__ */_e.jsx(sa.div, {
        dir: E,
        "data-orientation": h,
        ...x,
        ref: e
      })
    });
  }),
  GK = "_tag_11kiq_1",
  XK = {
    tag: GK
  },
  F4 = ({
    icon: t,
    label: e,
    className: i
  }) => /* @__PURE__ */_e.jsx(_e.Fragment, {
    children: e && /* @__PURE__ */_e.jsxs("span", {
      className: Ze(XK.tag, i),
      children: [t && t, e]
    })
  }),
  KK = "_wrapper_184bp_1",
  QK = "_input_184bp_14",
  ZK = "_inputIcon_184bp_26",
  S2 = {
    wrapper: KK,
    input: QK,
    inputIcon: ZK
  },
  JK = Qn(({
    id: t,
    label: e,
    name: i,
    disabled: l = !1,
    readOnly: c = !1,
    onChange: p,
    onBlur: h,
    onFocus: y,
    errorMessage: w,
    value: x,
    showCounter: E = !0,
    renderCounterText: C,
    required: k,
    iconOptions: D,
    className: I,
    classNames: O,
    ...P
  }, N) => {
    const [L, F] = rt(x ?? ""),
      [j, V] = rt(!1),
      K = vt(null),
      [G, Q] = rt(!0),
      te = pn((ne, se) => {
        if (!(!E || !se)) return C ? C(ne, se) : "{{ count }}/{{ maxLength }}".replace("{{ count }}", ne.toString()).replace("{{ maxLength }}", se.toString());
      }, [E, P.maxLength]),
      ie = ne => {
        const se = ne.target.value;
        F(se), p == null || p(ne, se, ne.target.validity.valid), Q(ne.target.validity.valid);
      },
      Y = ne => {
        V(!1), h == null || h(ne);
      },
      ee = ne => {
        V(!0), y == null || y(ne);
      },
      oe = ci(() => !c && (j ||
      // The input is currently focused
      L ||
      // There is a value present
      !G) || c && !!L && !!e, [c, j, L, G, e]);
    return Rt(() => {
      F(x ?? "");
    }, [x]), jR(N, () => K.current, []), /* @__PURE__ */_e.jsx(AE, {
      id: t,
      isLabel: !0,
      label: e || "<Label is required>",
      errorMessage: w,
      helperText: te(L.length, P.maxLength),
      messageId: `${t}-message`,
      className: I,
      classNames: {
        label: Ze(O == null ? void 0 : O.inputLabel, l && (O == null ? void 0 : O.inputLabelDisabled), oe && (O == null ? void 0 : O.inputFocus)),
        helperText: O == null ? void 0 : O.inputHelperText,
        errorText: Ze((w || !G) && (O == null ? void 0 : O.inputErrorText))
      },
      children: /* @__PURE__ */_e.jsxs("div", {
        className: Ze(S2.wrapper, O == null ? void 0 : O.inputWrapper, w && (O == null ? void 0 : O.inputError)),
        children: [/* @__PURE__ */_e.jsx("textarea", {
          id: t,
          ref: K,
          className: Ze(S2.input, O == null ? void 0 : O.input, L && (O == null ? void 0 : O.value)),
          name: i || t,
          value: L,
          disabled: l,
          readOnly: c,
          onChange: ie,
          onFocus: ee,
          onBlur: Y,
          required: k,
          ...P,
          ...((E || w) && {
            "aria-describedby": `${t}-message`
          })
        }), /* @__PURE__ */_e.jsx("span", {
          role: "presentation",
          className: Ze(O == null ? void 0 : O.inputBorder)
        }), l && /* @__PURE__ */_e.jsx("div", {
          "aria-hidden": "true",
          className: Ze(S2.inputIcon, O == null ? void 0 : O.iconDisable),
          children: D != null && D.disabled ? D.disabled : /* @__PURE__ */_e.jsx(_e.Fragment, {
            children: "×"
          })
        })]
      })
    });
  }),
  eQ = {
    noResults: "No results found",
    searchLabel: "Search",
    clearSelection: "Clear the selection",
    a11ySelectedLiveRegion: 'Selected option changed to "{{ label }}"',
    a11yNoResultsLiveRegion: "No results found"
  },
  tQ = "_wrapper_1dw9q_1",
  nQ = "_input_1dw9q_13",
  rQ = "_listBox_1dw9q_17",
  iQ = "_listBoxOpen_1dw9q_26",
  aQ = "_overlay_1dw9q_31",
  oQ = "_listItem_1dw9q_39",
  sQ = "_noResults_1dw9q_48",
  lQ = "_srOnly_1dw9q_52",
  Zc = {
    wrapper: tQ,
    input: nQ,
    listBox: rQ,
    listBoxOpen: iQ,
    overlay: aQ,
    listItem: oQ,
    noResults: sQ,
    srOnly: lQ
  },
  uQ = Qn(({
    id: t,
    label: e,
    isLoading: i = !1,
    loaderConfig: l,
    isReadOnly: c,
    isDisabled: p,
    isInlineMode: h = !1,
    helperText: y,
    errorMessage: w,
    iconOptions: x,
    data: E,
    selectedItem: C = null,
    initialSelectedItem: k = null,
    environment: D,
    children: I,
    className: O,
    classNames: P,
    onFocus: N,
    onBlur: L,
    onChange: F,
    onInput: j,
    onOpenTypeahead: V,
    renderCustomListItem: K,
    labels: G,
    onSearch: Q,
    template: te = "default"
  }, ie) => {
    const Y = {
        ...eQ,
        ...G
      },
      [ee, oe] = rt(E),
      ne = vt(null),
      se = vt(null),
      ue = vt(null),
      W = typeof window < "u",
      [$, le] = rt(!1),
      [H, ce] = rt(""),
      [de, Ce] = rt(k),
      [Ee, fe] = rt(!1),
      [xe, we] = rt(!1),
      ve = vt(),
      Te = vt(),
      ze = Ke => Ke.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
      Xe = (Ke, yt) => {
        if (!yt) return Ke;
        const je = ze(yt),
          at = new RegExp(`(${je})`, "ig");
        return Ke.split(at).map((kt, Bt) => (at.lastIndex = 0, Bt % 2 === 1 ? /* @__PURE__ */_e.jsx("span", {
          className: P == null ? void 0 : P.listItemHighlightedText,
          children: kt
        }, `filter-group-${Bt}`) : kt));
      },
      ye = Ke => Ke ? Ke.label : "",
      qe = Ke => Ke && Ke.reduce((yt, je) => (yt.push(...je.items), yt), []),
      Ae = pn(Ke => Ke != null && Ke.trim() ? E.map(yt => ({
        title: (yt == null ? void 0 : yt.title) ?? "",
        items: yt.items.filter(je => {
          var at, kt;
          return ((at = je == null ? void 0 : je.label) == null ? void 0 : at.toLowerCase().includes(Ke == null ? void 0 : Ke.toLowerCase())) || ((kt = je == null ? void 0 : je.value) == null ? void 0 : kt.toLowerCase().includes(Ke == null ? void 0 : Ke.toLowerCase()));
        })
      })).filter(yt => yt.items.length > 0) : E, [E]),
      Mt = (Ke, yt) => {
        const {
          type: je,
          changes: at
        } = yt;
        return je === iE.stateChangeTypes.InputKeyDownEscape ? {
          ...at,
          selectedItem: null
        } : je === iE.stateChangeTypes.InputBlur ? {
          ...at,
          inputValue: ye(at.selectedItem || null)
        } : at;
      },
      Ft = qe(ee),
      {
        setHighlightedIndex: un,
        inputValue: gt,
        highlightedIndex: Pt,
        getMenuProps: St,
        getInputProps: Dt,
        getItemProps: Kt,
        reset: hn,
        setInputValue: Ot
      } = iE({
        id: t,
        labelId: t,
        stateReducer: Mt,
        items: Ft,
        itemToString: ye,
        initialSelectedItem: k,
        isOpen: xe && $,
        onStateChange: Ke => {
          var yt;
          c || i || p || ((Ke == null ? void 0 : Ke.isOpen) !== void 0 && $ && we(Ke.isOpen), Ke.type === iE.stateChangeTypes.InputBlur && (L == null || L()), Ke.inputValue && Ke.inputValue === ((yt = Ke.selectedItem) == null ? void 0 : yt.label) && oe(E));
        },
        onIsOpenChange: Ke => {
          const {
            matches: yt
          } = window.matchMedia(`(max-width: ${rd.breakpoint.sm.value})`);
          ne != null && ne.current && (Ke.isOpen && yt ? ($O(ne.current), V == null || V(ne.current)) : aR(ne.current));
        },
        onInputValueChange: async Ke => {
          const yt = Ke.inputValue ?? "",
            je = j == null ? void 0 : j(yt);
          try {
            const at = await Promise.resolve(je);
            Array.isArray(at) ? oe(at) : oe(Ae(yt));
          } catch (at) {
            console.error("Typeahead: Failed to resolve onInput:", at), oe(Ae(yt));
          }
          yt === "" ? (le(!1), we(!1)) : Ke != null && Ke.isOpen && we(Ke.isOpen);
        },
        onSelectedItemChange: Ke => {
          var yt;
          Te.current = void 0, (yt = se.current) == null || yt.focus();
          const je = Ke.selectedItem ?? null;
          Ce(je), je && (F == null || F(je)), ce((je == null ? void 0 : je.label) ?? ""), je === null && hn();
        },
        environment: D ? {
          addEventListener: D.addEventListener.bind(D),
          removeEventListener: D.removeEventListener.bind(D),
          document: (D == null ? void 0 : D.document) ?? document,
          Node: D.Node
        } : W ? window : void 0
      }),
      Et = Ke => Ke.reduce((yt, je, at) => (yt.sections.push(/* @__PURE__ */_e.jsx("ul", {
        role: "group",
        className: P == null ? void 0 : P.listItemGroup,
        children: je.items.map((kt, Bt) => {
          yt.itemIndex += 1;
          const Ht = typeof de == "object" && (de == null ? void 0 : de.id) === kt.id,
            ln = {
              item: kt,
              index: yt.itemIndex,
              className: Ze(Zc.listItem, P == null ? void 0 : P.listItem, Ht && (P == null ? void 0 : P.listItemSelected), Pt === yt.itemIndex && (P == null ? void 0 : P.listItemActive)),
              "aria-selected": Ht,
              // Add this event to help limit the section heading accessibility fix
              onClick: en => {
                en.stopPropagation();
              }
            };
          return K ? K(`item-${yt.itemIndex}`, (de == null ? void 0 : de.id) ?? "", at, kt, Bt, Kt, ln, je, P) : /* @__PURE__ */_e.jsxs(Qv, {
            children: [je.displayTitle && Bt === 0 && (je == null ? void 0 : je.title) && /* @__PURE__ */_e.jsx("li", {
              "aria-hidden": "true",
              id: `separator-${at}`,
              role: "separator",
              className: P == null ? void 0 : P.listHeading,
              children: je.title
            }, `heading-${at}`), /* @__PURE__ */_e.jsx("li", {
              ...Kt(ln),
              children: Xe(kt.label, gt)
            }, `item-${yt.itemIndex}`)]
          }, `fragment-${yt.itemIndex}`);
        })
      }, `${t}-group-${at}`)), yt), {
        sections: [],
        itemIndex: -1
      }).sections,
      Vt = Ke => {
        var yt;
        fe(!1);
        const je = Ke == null ? void 0 : Ke.target,
          at = Ke == null ? void 0 : Ke.relatedTarget;
        !((yt = je == null ? void 0 : je.value) != null && yt.trim()) && de && Ot(de.label), L == null || L(), (!at || ve.current === "mouse") && (Te.current = void 0);
      },
      Xt = () => {
        fe(!0), N == null || N();
      },
      vn = ci(() => !i && (!c && Ee || c && de && !!e), [c, Ee, de, e, i]),
      ot = Ke => {
        var yt;
        Ke.type === "mousedown" && Ke.preventDefault(), hn(), Ce(null), fe(!0), (yt = se.current) == null || yt.focus(), Te.current = void 0, L == null || L();
      },
      We = Ke => {
        Te.current = Ke.shiftKey ? `Shift+${Ke.key}` : Ke.key, ve.current = "keyboard";
      },
      ht = () => ve.current = "mouse";
    return Rt(() => {
      var Ke, yt;
      E && gt && (oe(Ae(gt)), gt && !k && Te != null && Te.current && (Te.current !== "Tab" ? (Ke = se.current) == null || Ke.focus() : Te.current === "Tab" && ((yt = ue.current) == null || yt.focus())));
    }, [E, gt]), Rt(() => {
      C !== null && Ce(C);
    }, [C]), Rt(() => {
      E.length && le(ee.some(Ke => Ke.items.length > 0));
    }, [E, ee]), Rt(() => (se != null && se.current && (window.addEventListener("mousedown", ht), se.current.addEventListener("keydown", We)), () => {
      var Ke;
      window.removeEventListener("mousedown", ht), (Ke = se.current) == null || Ke.removeEventListener("keydown", We);
    }), []), /* @__PURE__ */_e.jsx(_e.Fragment, {
      children: /* @__PURE__ */_e.jsxs(AE, {
        ref: ie,
        label: e,
        id: t,
        messageId: `${t}-message`,
        helperText: y,
        errorMessage: w,
        isDisabled: p,
        isFocused: Ee && !i,
        classNames: {
          label: Ze(P == null ? void 0 : P.inputLabel, te === "search" && (x == null ? void 0 : x.input) && !vn && !gt && (P == null ? void 0 : P.inputLabelIconSearch), (vn || de || gt) && [Zc.inputFocus, P == null ? void 0 : P.inputFocus]),
          helperText: P == null ? void 0 : P.inputHelperText,
          errorText: Ze(!p && w && (P == null ? void 0 : P.inputErrorText)),
          disabled: Ze(p && [P == null ? void 0 : P.inputWrapperDisabled])
        },
        children: [/* @__PURE__ */_e.jsxs("div", {
          className: Ze(Zc.wrapper, O, w && [Zc.inputError, P == null ? void 0 : P.inputError], i && (P == null ? void 0 : P.inputWrapperLoading)),
          children: [te === "search" && (x == null ? void 0 : x.input) && /* @__PURE__ */_e.jsx("div", {
            className: Ze(P == null ? void 0 : P.inputIcon, (vn || gt) && (P == null ? void 0 : P.inputIconHide), !vn && !gt && (P == null ? void 0 : P.inputIconShow)),
            children: x.input
          }), /* @__PURE__ */_e.jsx("input", {
            ...Dt({
              ref: se,
              id: t,
              readOnly: i || c,
              "aria-controls": $ || gt.length ? `${t}-menu` : void 0,
              "aria-activedescendant": xe && Pt !== -1 ? `${t}-item-${Pt}` : void 0,
              "aria-describedby": y || w ? `${t}-message ${t}-live` : void 0,
              className: Ze(Zc == null ? void 0 : Zc.input, P == null ? void 0 : P.input),
              disabled: p,
              onFocus: Xt,
              onBlur: Vt,
              onKeyUp: Ke => {
                (Ke.code === "Enter" || Ke.code === "NumpadEnter") && (Ke.stopPropagation(), de && !w && (Q == null || Q(de)), $ || hn());
              },
              "aria-labelledby": void 0
            })
          }), /* @__PURE__ */_e.jsx("span", {
            role: "presentation",
            className: Ze(Zc.border, P == null ? void 0 : P.inputBorder)
          }), gt.length > 0 && !i && (x == null ? void 0 : x.clear) && !c && /* @__PURE__ */_e.jsx("button", {
            ref: ue,
            tabIndex: de || !$ ? 0 : -1,
            type: "button",
            className: P == null ? void 0 : P.iconClear,
            onClick: ot,
            onMouseDown: ot,
            "aria-label": Y.clearSelection,
            children: x.clear
          }), !i && te === "search" && (x == null ? void 0 : x.search) && /* @__PURE__ */_e.jsx("button", {
            type: "button",
            className: P == null ? void 0 : P.iconSearch,
            onClick: de && !w && Q ? () => Q(de) : void 0,
            "aria-label": Y == null ? void 0 : Y.searchLabel,
            children: x.search
          }), p && /* @__PURE__ */_e.jsx("span", {
            "aria-hidden": "true",
            className: P == null ? void 0 : P.inputIconDisabled,
            children: (x == null ? void 0 : x.disabled) || /* @__PURE__ */_e.jsx(_e.Fragment, {
              children: "×"
            })
          }), i && /* @__PURE__ */_e.jsx(FE, {
            className: P == null ? void 0 : P.loader,
            size: hb.small,
            status: Um.loading,
            align: jE.vertical,
            responsive: !1,
            ...l
          })]
        }), I, /* @__PURE__ */_e.jsx("div", {
          id: `${t}-live`,
          className: Zc.srOnly,
          "aria-live": "polite",
          "aria-atomic": "true",
          role: "status",
          children: H && Y != null && Y.a11ySelectedLiveRegion ? Y.a11ySelectedLiveRegion.replace("{{ label }}", H) : Y.a11yNoResultsLiveRegion
        }), /* @__PURE__ */_e.jsx("div", {
          ...St({
            ref: ne,
            "aria-hidden": !xe,
            onClick: Ke => {
              var yt, je;
              const at = ((yt = Ke.nativeEvent.target) == null ? void 0 : yt.id) || "";
              if (!at.startsWith("separator-")) return;
              const kt = parseInt(at.replace("separator-", ""), 10);
              if (kt !== null) {
                let Bt = 0;
                ((Ht, ln) => {
                  var en;
                  for (let Rr = 0; Rr < ln; Rr++) (en = Ht[Rr]) != null && en.items && (Bt += Ht[Rr].items.length);
                })(ee, kt), un(Bt);
              }
              (je = se.current) == null || je.focus();
            }
          }),
          className: Ze(Zc.listBox, P == null ? void 0 : P.listBox, xe && typeof $ == "boolean" && [Zc == null ? void 0 : Zc.listBoxOpen, P == null ? void 0 : P.listBoxOpen], {
            [Zc == null ? void 0 : Zc.overlay]: !h
          }),
          children: xe && ($ ? Et(ee) : !i && /* @__PURE__ */_e.jsx("div", {
            className: Ze(Zc.noResults, P == null ? void 0 : P.noResults),
            role: "option",
            "aria-disabled": "true",
            children: Y.noResults
          }))
        })]
      })
    });
  }),
  N4 = (t = "en-CA") => {
    var e;
    return ((e = t == null ? void 0 : t.split("-")) == null ? void 0 : e[0]) || "en";
  };
function KO(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function cQ(t) {
  if (t.__esModule) return t;
  var e = t.default;
  if (typeof e == "function") {
    var i = function l() {
      return this instanceof l ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    i.prototype = e.prototype;
  } else i = {};
  return Object.defineProperty(i, "__esModule", {
    value: !0
  }), Object.keys(t).forEach(function (l) {
    var c = Object.getOwnPropertyDescriptor(t, l);
    Object.defineProperty(i, l, c.get ? c : {
      enumerable: !0,
      get: function () {
        return t[l];
      }
    });
  }), i;
}
var pM = {
    exports: {}
  },
  wT = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lB;
function dQ() {
  if (lB) return wT;
  lB = 1;
  var t = Nt,
    e = Symbol.for("react.element"),
    i = Symbol.for("react.fragment"),
    l = Object.prototype.hasOwnProperty,
    c = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
    p = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    };
  function h(y, w, x) {
    var E,
      C = {},
      k = null,
      D = null;
    x !== void 0 && (k = "" + x), w.key !== void 0 && (k = "" + w.key), w.ref !== void 0 && (D = w.ref);
    for (E in w) l.call(w, E) && !p.hasOwnProperty(E) && (C[E] = w[E]);
    if (y && y.defaultProps) for (E in w = y.defaultProps, w) C[E] === void 0 && (C[E] = w[E]);
    return {
      $$typeof: e,
      type: y,
      key: k,
      ref: D,
      props: C,
      _owner: c.current
    };
  }
  return wT.Fragment = i, wT.jsx = h, wT.jsxs = h, wT;
}
var _T = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var uB;
function fQ() {
  return uB || (uB = 1, process.env.NODE_ENV !== "production" && function () {
    var t = Nt,
      e = Symbol.for("react.element"),
      i = Symbol.for("react.portal"),
      l = Symbol.for("react.fragment"),
      c = Symbol.for("react.strict_mode"),
      p = Symbol.for("react.profiler"),
      h = Symbol.for("react.provider"),
      y = Symbol.for("react.context"),
      w = Symbol.for("react.forward_ref"),
      x = Symbol.for("react.suspense"),
      E = Symbol.for("react.suspense_list"),
      C = Symbol.for("react.memo"),
      k = Symbol.for("react.lazy"),
      D = Symbol.for("react.offscreen"),
      I = Symbol.iterator,
      O = "@@iterator";
    function P(Z) {
      if (Z === null || typeof Z != "object") return null;
      var Ne = I && Z[I] || Z[O];
      return typeof Ne == "function" ? Ne : null;
    }
    var N = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function L(Z) {
      {
        for (var Ne = arguments.length, Ye = new Array(Ne > 1 ? Ne - 1 : 0), xt = 1; xt < Ne; xt++) Ye[xt - 1] = arguments[xt];
        F("error", Z, Ye);
      }
    }
    function F(Z, Ne, Ye) {
      {
        var xt = N.ReactDebugCurrentFrame,
          rn = xt.getStackAddendum();
        rn !== "" && (Ne += "%s", Ye = Ye.concat([rn]));
        var $t = Ye.map(function (Ct) {
          return String(Ct);
        });
        $t.unshift("Warning: " + Ne), Function.prototype.apply.call(console[Z], console, $t);
      }
    }
    var j = !1,
      V = !1,
      K = !1,
      G = !1,
      Q = !1,
      te;
    te = Symbol.for("react.module.reference");
    function ie(Z) {
      return !!(typeof Z == "string" || typeof Z == "function" || Z === l || Z === p || Q || Z === c || Z === x || Z === E || G || Z === D || j || V || K || typeof Z == "object" && Z !== null && (Z.$$typeof === k || Z.$$typeof === C || Z.$$typeof === h || Z.$$typeof === y || Z.$$typeof === w ||
      // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Z.$$typeof === te || Z.getModuleId !== void 0));
    }
    function Y(Z, Ne, Ye) {
      var xt = Z.displayName;
      if (xt) return xt;
      var rn = Ne.displayName || Ne.name || "";
      return rn !== "" ? Ye + "(" + rn + ")" : Ye;
    }
    function ee(Z) {
      return Z.displayName || "Context";
    }
    function oe(Z) {
      if (Z == null) return null;
      if (typeof Z.tag == "number" && L("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof Z == "function") return Z.displayName || Z.name || null;
      if (typeof Z == "string") return Z;
      switch (Z) {
        case l:
          return "Fragment";
        case i:
          return "Portal";
        case p:
          return "Profiler";
        case c:
          return "StrictMode";
        case x:
          return "Suspense";
        case E:
          return "SuspenseList";
      }
      if (typeof Z == "object") switch (Z.$$typeof) {
        case y:
          var Ne = Z;
          return ee(Ne) + ".Consumer";
        case h:
          var Ye = Z;
          return ee(Ye._context) + ".Provider";
        case w:
          return Y(Z, Z.render, "ForwardRef");
        case C:
          var xt = Z.displayName || null;
          return xt !== null ? xt : oe(Z.type) || "Memo";
        case k:
          {
            var rn = Z,
              $t = rn._payload,
              Ct = rn._init;
            try {
              return oe(Ct($t));
            } catch {
              return null;
            }
          }
      }
      return null;
    }
    var ne = Object.assign,
      se = 0,
      ue,
      W,
      $,
      le,
      H,
      ce,
      de;
    function Ce() {}
    Ce.__reactDisabledLog = !0;
    function Ee() {
      {
        if (se === 0) {
          ue = console.log, W = console.info, $ = console.warn, le = console.error, H = console.group, ce = console.groupCollapsed, de = console.groupEnd;
          var Z = {
            configurable: !0,
            enumerable: !0,
            value: Ce,
            writable: !0
          };
          Object.defineProperties(console, {
            info: Z,
            log: Z,
            warn: Z,
            error: Z,
            group: Z,
            groupCollapsed: Z,
            groupEnd: Z
          });
        }
        se++;
      }
    }
    function fe() {
      {
        if (se--, se === 0) {
          var Z = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ne({}, Z, {
              value: ue
            }),
            info: ne({}, Z, {
              value: W
            }),
            warn: ne({}, Z, {
              value: $
            }),
            error: ne({}, Z, {
              value: le
            }),
            group: ne({}, Z, {
              value: H
            }),
            groupCollapsed: ne({}, Z, {
              value: ce
            }),
            groupEnd: ne({}, Z, {
              value: de
            })
          });
        }
        se < 0 && L("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var xe = N.ReactCurrentDispatcher,
      we;
    function ve(Z, Ne, Ye) {
      {
        if (we === void 0) try {
          throw Error();
        } catch (rn) {
          var xt = rn.stack.trim().match(/\n( *(at )?)/);
          we = xt && xt[1] || "";
        }
        return `
` + we + Z;
      }
    }
    var Te = !1,
      ze;
    {
      var Xe = typeof WeakMap == "function" ? WeakMap : Map;
      ze = new Xe();
    }
    function ye(Z, Ne) {
      if (!Z || Te) return "";
      {
        var Ye = ze.get(Z);
        if (Ye !== void 0) return Ye;
      }
      var xt;
      Te = !0;
      var rn = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var $t;
      $t = xe.current, xe.current = null, Ee();
      try {
        if (Ne) {
          var Ct = function () {
            throw Error();
          };
          if (Object.defineProperty(Ct.prototype, "props", {
            set: function () {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Ct, []);
            } catch (Wi) {
              xt = Wi;
            }
            Reflect.construct(Z, [], Ct);
          } else {
            try {
              Ct.call();
            } catch (Wi) {
              xt = Wi;
            }
            Z.call(Ct.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Wi) {
            xt = Wi;
          }
          Z();
        }
      } catch (Wi) {
        if (Wi && xt && typeof Wi.stack == "string") {
          for (var qt = Wi.stack.split(`
`), yr = xt.stack.split(`
`), Tn = qt.length - 1, jn = yr.length - 1; Tn >= 1 && jn >= 0 && qt[Tn] !== yr[jn];) jn--;
          for (; Tn >= 1 && jn >= 0; Tn--, jn--) if (qt[Tn] !== yr[jn]) {
            if (Tn !== 1 || jn !== 1) do if (Tn--, jn--, jn < 0 || qt[Tn] !== yr[jn]) {
              var Lr = `
` + qt[Tn].replace(" at new ", " at ");
              return Z.displayName && Lr.includes("<anonymous>") && (Lr = Lr.replace("<anonymous>", Z.displayName)), typeof Z == "function" && ze.set(Z, Lr), Lr;
            } while (Tn >= 1 && jn >= 0);
            break;
          }
        }
      } finally {
        Te = !1, xe.current = $t, fe(), Error.prepareStackTrace = rn;
      }
      var Wa = Z ? Z.displayName || Z.name : "",
        Ru = Wa ? ve(Wa) : "";
      return typeof Z == "function" && ze.set(Z, Ru), Ru;
    }
    function qe(Z, Ne, Ye) {
      return ye(Z, !1);
    }
    function Ae(Z) {
      var Ne = Z.prototype;
      return !!(Ne && Ne.isReactComponent);
    }
    function Mt(Z, Ne, Ye) {
      if (Z == null) return "";
      if (typeof Z == "function") return ye(Z, Ae(Z));
      if (typeof Z == "string") return ve(Z);
      switch (Z) {
        case x:
          return ve("Suspense");
        case E:
          return ve("SuspenseList");
      }
      if (typeof Z == "object") switch (Z.$$typeof) {
        case w:
          return qe(Z.render);
        case C:
          return Mt(Z.type, Ne, Ye);
        case k:
          {
            var xt = Z,
              rn = xt._payload,
              $t = xt._init;
            try {
              return Mt($t(rn), Ne, Ye);
            } catch {}
          }
      }
      return "";
    }
    var Ft = Object.prototype.hasOwnProperty,
      un = {},
      gt = N.ReactDebugCurrentFrame;
    function Pt(Z) {
      if (Z) {
        var Ne = Z._owner,
          Ye = Mt(Z.type, Z._source, Ne ? Ne.type : null);
        gt.setExtraStackFrame(Ye);
      } else gt.setExtraStackFrame(null);
    }
    function St(Z, Ne, Ye, xt, rn) {
      {
        var $t = Function.call.bind(Ft);
        for (var Ct in Z) if ($t(Z, Ct)) {
          var qt = void 0;
          try {
            if (typeof Z[Ct] != "function") {
              var yr = Error((xt || "React class") + ": " + Ye + " type `" + Ct + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Z[Ct] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
              throw yr.name = "Invariant Violation", yr;
            }
            qt = Z[Ct](Ne, Ct, xt, Ye, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
          } catch (Tn) {
            qt = Tn;
          }
          qt && !(qt instanceof Error) && (Pt(rn), L("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", xt || "React class", Ye, Ct, typeof qt), Pt(null)), qt instanceof Error && !(qt.message in un) && (un[qt.message] = !0, Pt(rn), L("Failed %s type: %s", Ye, qt.message), Pt(null));
        }
      }
    }
    var Dt = Array.isArray;
    function Kt(Z) {
      return Dt(Z);
    }
    function hn(Z) {
      {
        var Ne = typeof Symbol == "function" && Symbol.toStringTag,
          Ye = Ne && Z[Symbol.toStringTag] || Z.constructor.name || "Object";
        return Ye;
      }
    }
    function Ot(Z) {
      try {
        return Et(Z), !1;
      } catch {
        return !0;
      }
    }
    function Et(Z) {
      return "" + Z;
    }
    function Vt(Z) {
      if (Ot(Z)) return L("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", hn(Z)), Et(Z);
    }
    var Xt = N.ReactCurrentOwner,
      vn = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      },
      ot,
      We;
    function ht(Z) {
      if (Ft.call(Z, "ref")) {
        var Ne = Object.getOwnPropertyDescriptor(Z, "ref").get;
        if (Ne && Ne.isReactWarning) return !1;
      }
      return Z.ref !== void 0;
    }
    function Ke(Z) {
      if (Ft.call(Z, "key")) {
        var Ne = Object.getOwnPropertyDescriptor(Z, "key").get;
        if (Ne && Ne.isReactWarning) return !1;
      }
      return Z.key !== void 0;
    }
    function yt(Z, Ne) {
      typeof Z.ref == "string" && Xt.current;
    }
    function je(Z, Ne) {
      {
        var Ye = function () {
          ot || (ot = !0, L("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ne));
        };
        Ye.isReactWarning = !0, Object.defineProperty(Z, "key", {
          get: Ye,
          configurable: !0
        });
      }
    }
    function at(Z, Ne) {
      {
        var Ye = function () {
          We || (We = !0, L("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ne));
        };
        Ye.isReactWarning = !0, Object.defineProperty(Z, "ref", {
          get: Ye,
          configurable: !0
        });
      }
    }
    var kt = function (Z, Ne, Ye, xt, rn, $t, Ct) {
      var qt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: Z,
        key: Ne,
        ref: Ye,
        props: Ct,
        // Record the component responsible for creating this element.
        _owner: $t
      };
      return qt._store = {}, Object.defineProperty(qt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(qt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: xt
      }), Object.defineProperty(qt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: rn
      }), Object.freeze && (Object.freeze(qt.props), Object.freeze(qt)), qt;
    };
    function Bt(Z, Ne, Ye, xt, rn) {
      {
        var $t,
          Ct = {},
          qt = null,
          yr = null;
        Ye !== void 0 && (Vt(Ye), qt = "" + Ye), Ke(Ne) && (Vt(Ne.key), qt = "" + Ne.key), ht(Ne) && (yr = Ne.ref, yt(Ne, rn));
        for ($t in Ne) Ft.call(Ne, $t) && !vn.hasOwnProperty($t) && (Ct[$t] = Ne[$t]);
        if (Z && Z.defaultProps) {
          var Tn = Z.defaultProps;
          for ($t in Tn) Ct[$t] === void 0 && (Ct[$t] = Tn[$t]);
        }
        if (qt || yr) {
          var jn = typeof Z == "function" ? Z.displayName || Z.name || "Unknown" : Z;
          qt && je(Ct, jn), yr && at(Ct, jn);
        }
        return kt(Z, qt, yr, rn, xt, Xt.current, Ct);
      }
    }
    var Ht = N.ReactCurrentOwner,
      ln = N.ReactDebugCurrentFrame;
    function en(Z) {
      if (Z) {
        var Ne = Z._owner,
          Ye = Mt(Z.type, Z._source, Ne ? Ne.type : null);
        ln.setExtraStackFrame(Ye);
      } else ln.setExtraStackFrame(null);
    }
    var Rr;
    Rr = !1;
    function Nr(Z) {
      return typeof Z == "object" && Z !== null && Z.$$typeof === e;
    }
    function Hi() {
      {
        if (Ht.current) {
          var Z = oe(Ht.current.type);
          if (Z) return `

Check the render method of \`` + Z + "`.";
        }
        return "";
      }
    }
    function ll(Z) {
      return "";
    }
    var yo = {};
    function _l(Z) {
      {
        var Ne = Hi();
        if (!Ne) {
          var Ye = typeof Z == "string" ? Z : Z.displayName || Z.name;
          Ye && (Ne = `

Check the top-level render call using <` + Ye + ">.");
        }
        return Ne;
      }
    }
    function Mo(Z, Ne) {
      {
        if (!Z._store || Z._store.validated || Z.key != null) return;
        Z._store.validated = !0;
        var Ye = _l(Ne);
        if (yo[Ye]) return;
        yo[Ye] = !0;
        var xt = "";
        Z && Z._owner && Z._owner !== Ht.current && (xt = " It was passed a child from " + oe(Z._owner.type) + "."), en(Z), L('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Ye, xt), en(null);
      }
    }
    function bo(Z, Ne) {
      {
        if (typeof Z != "object") return;
        if (Kt(Z)) for (var Ye = 0; Ye < Z.length; Ye++) {
          var xt = Z[Ye];
          Nr(xt) && Mo(xt, Ne);
        } else if (Nr(Z)) Z._store && (Z._store.validated = !0);else if (Z) {
          var rn = P(Z);
          if (typeof rn == "function" && rn !== Z.entries) for (var $t = rn.call(Z), Ct; !(Ct = $t.next()).done;) Nr(Ct.value) && Mo(Ct.value, Ne);
        }
      }
    }
    function Tu(Z) {
      {
        var Ne = Z.type;
        if (Ne == null || typeof Ne == "string") return;
        var Ye;
        if (typeof Ne == "function") Ye = Ne.propTypes;else if (typeof Ne == "object" && (Ne.$$typeof === w ||
        // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Ne.$$typeof === C)) Ye = Ne.propTypes;else return;
        if (Ye) {
          var xt = oe(Ne);
          St(Ye, Z.props, "prop", xt, Z);
        } else if (Ne.PropTypes !== void 0 && !Rr) {
          Rr = !0;
          var rn = oe(Ne);
          L("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", rn || "Unknown");
        }
        typeof Ne.getDefaultProps == "function" && !Ne.getDefaultProps.isReactClassApproved && L("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ha(Z) {
      {
        for (var Ne = Object.keys(Z.props), Ye = 0; Ye < Ne.length; Ye++) {
          var xt = Ne[Ye];
          if (xt !== "children" && xt !== "key") {
            en(Z), L("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", xt), en(null);
            break;
          }
        }
        Z.ref !== null && (en(Z), L("Invalid attribute `ref` supplied to `React.Fragment`."), en(null));
      }
    }
    function $i(Z, Ne, Ye, xt, rn, $t) {
      {
        var Ct = ie(Z);
        if (!Ct) {
          var qt = "";
          (Z === void 0 || typeof Z == "object" && Z !== null && Object.keys(Z).length === 0) && (qt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var yr = ll();
          yr ? qt += yr : qt += Hi();
          var Tn;
          Z === null ? Tn = "null" : Kt(Z) ? Tn = "array" : Z !== void 0 && Z.$$typeof === e ? (Tn = "<" + (oe(Z.type) || "Unknown") + " />", qt = " Did you accidentally export a JSX literal instead of a component?") : Tn = typeof Z, L("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Tn, qt);
        }
        var jn = Bt(Z, Ne, Ye, rn, $t);
        if (jn == null) return jn;
        if (Ct) {
          var Lr = Ne.children;
          if (Lr !== void 0) if (xt) {
            if (Kt(Lr)) {
              for (var Wa = 0; Wa < Lr.length; Wa++) bo(Lr[Wa], Z);
              Object.freeze && Object.freeze(Lr);
            } else L("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
          } else bo(Lr, Z);
        }
        return Z === l ? Ha(jn) : Tu(jn), jn;
      }
    }
    function oi(Z, Ne, Ye) {
      return $i(Z, Ne, Ye, !0);
    }
    function Oo(Z, Ne, Ye) {
      return $i(Z, Ne, Ye, !1);
    }
    var $a = Oo,
      Lo = oi;
    _T.Fragment = l, _T.jsx = $a, _T.jsxs = Lo;
  }()), _T;
}
var cB;
function pQ() {
  return cB || (cB = 1, process.env.NODE_ENV === "production" ? pM.exports = dQ() : pM.exports = fQ()), pM.exports;
}
var B = pQ();
function z4(t) {
  var e,
    i,
    l = "";
  if (typeof t == "string" || typeof t == "number") l += t;else if (typeof t == "object") if (Array.isArray(t)) for (e = 0; e < t.length; e++) t[e] && (i = z4(t[e])) && (l && (l += " "), l += i);else for (e in t) t[e] && (l && (l += " "), l += e);
  return l;
}
function hQ() {
  for (var t, e, i = 0, l = ""; i < arguments.length;) (t = arguments[i++]) && (e = z4(t)) && (l && (l += " "), l += e);
  return l;
}
var sn = function (e) {
  var i,
    l = e.iconPrefix,
    c = l === void 0 ? "wvi-icon" : l,
    p = e.name,
    h = e.className,
    y = e.title,
    w = e.hidden,
    x = w === void 0 ? !0 : w,
    E = e.fixedWidth,
    C = e.rotate,
    k = e.size,
    D = e.animate;
  return Nt.createElement("span", {
    className: hQ(c, c + "-" + p, h, (i = {}, i[c + "--" + k] = k, i[c + "--fw"] = E, i[c + "--r-" + C] = C, i[c + "--" + D] = D, i)),
    "aria-label": y,
    "aria-hidden": x
  });
};
sn.displayName = "Icon";
function V4(t) {
  var e,
    i,
    l = "";
  if (typeof t == "string" || typeof t == "number") l += t;else if (typeof t == "object") if (Array.isArray(t)) {
    var c = t.length;
    for (e = 0; e < c; e++) t[e] && (i = V4(t[e])) && (l && (l += " "), l += i);
  } else for (i in t) t[i] && (l && (l += " "), l += i);
  return l;
}
function ge() {
  for (var t, e, i = 0, l = "", c = arguments.length; i < c; i++) (t = arguments[i]) && (e = V4(t)) && (l && (l += " "), l += e);
  return l;
}
const mQ = "_button_vauy9_1",
  vQ = "_expandCollapseButton_vauy9_1",
  gQ = "_icon_vauy9_6",
  yQ = "_heading_vauy9_37",
  bQ = "_image_vauy9_44",
  wQ = "_trigger_vauy9_72",
  _Q = "_headings_vauy9_90",
  xQ = "_label_vauy9_102",
  SQ = "_description_vauy9_109",
  EQ = "_item_vauy9_117",
  CQ = "_content_vauy9_124",
  kQ = "_borderlessTop_vauy9_171",
  TQ = "_contentParagraph_vauy9_191",
  sd = {
    button: mQ,
    expandCollapseButton: vQ,
    icon: gQ,
    heading: yQ,
    image: bQ,
    trigger: wQ,
    headings: _Q,
    label: xQ,
    description: SQ,
    item: EQ,
    content: CQ,
    borderlessTop: kQ,
    contentParagraph: TQ
  },
  rS = t => {
    const {
      ...e
    } = t;
    return /* @__PURE__ */B.jsx(TH, {
      ...e
    });
  },
  RQ = t => {
    const {
      className: e,
      children: i,
      disabled: l,
      image: c,
      ...p
    } = t;
    return /* @__PURE__ */B.jsx(wH, {
      className: ge(sd.heading, e),
      children: /* @__PURE__ */B.jsxs(kH, {
        "data-slot": "accordion-trigger",
        className: ge(sd.trigger, sd.button),
        ...p,
        children: [c && /* @__PURE__ */B.jsx("img", {
          src: c,
          className: sd.image
        }), /* @__PURE__ */B.jsx(B4, {
          className: sd.headings,
          children: i
        }), !l && /* @__PURE__ */B.jsx(sn, {
          name: "chevron-down",
          className: sd.icon,
          "aria-hidden": !0
        })]
      })
    });
  },
  B4 = t => {
    const {
      className: e,
      children: i,
      ...l
    } = t;
    return /* @__PURE__ */B.jsx(sa.div, {
      className: e,
      ...l,
      children: i
    });
  },
  DQ = t => {
    const {
      children: e,
      className: i,
      ...l
    } = t;
    return /* @__PURE__ */B.jsx(sa.h4, {
      className: ge(sd.label, i),
      ...l,
      children: e
    });
  },
  IQ = t => {
    const {
      children: e,
      ...i
    } = t;
    return /* @__PURE__ */B.jsx(sa.p, {
      className: sd.description,
      ...i,
      children: e
    });
  },
  MQ = t => {
    const {
      value: e,
      className: i,
      borderlessTop: l,
      ...c
    } = t;
    return /* @__PURE__ */B.jsx(SH, {
      "data-slot": "accordion-item",
      value: e,
      className: ge(sd.item, l && sd.borderlessTop, i),
      ...c
    });
  },
  OQ = t => {
    const {
        className: e,
        children: i,
        ...l
      } = t,
      c = typeof i == "string" ? /* @__PURE__ */B.jsx(sa.p, {
        className: ge(sd.contentParagraph, e),
        children: i
      }) : i;
    return /* @__PURE__ */B.jsx(bH, {
      "data-slot": "accordion-content",
      className: ge(sd.content, e),
      ...l,
      children: c
    });
  },
  LQ = t => {
    const {
      className: e,
      expandText: i = "Expand all",
      collapseText: l = "Collapse all",
      ...c
    } = t;
    return /* @__PURE__ */B.jsx(t9, {
      expandText: i,
      collapseText: l,
      ...c,
      className: ge(sd.expandCollapseButton, e),
      children: /* @__PURE__ */B.jsx(sn, {
        name: "double-chevron-down-micro",
        className: sd.icon,
        "aria-hidden": !0
      })
    });
  };
rS.Content = OQ;
rS.Description = IQ;
rS.Heading = B4;
rS.Item = MQ;
rS.Label = DQ;
rS.Trigger = RQ;
rS.ExpandCollapseButton = LQ;
const I_e = {
    success: "success",
    error: "error",
    warning: "warning",
    info: "info",
    general: "general"
  },
  PQ = {
    light: "light",
    dark: "dark"
  },
  AQ = "_heading_14fgq_1",
  jQ = "_eyebrow_14fgq_9",
  FQ = "_xl_14fgq_18",
  NQ = "_lg_14fgq_24",
  zQ = "_md_14fgq_30",
  VQ = "_sm_14fgq_36",
  BQ = "_xs_14fgq_42",
  UQ = "_micro_14fgq_48",
  HQ = "_standard_14fgq_55",
  $Q = "_nano_14fgq_61",
  WQ = "_left_14fgq_67",
  qQ = "_center_14fgq_71",
  YQ = "_right_14fgq_75",
  GQ = "_italic_14fgq_79",
  XQ = "_bold_14fgq_83",
  E2 = {
    heading: AQ,
    eyebrow: jQ,
    xl: FQ,
    lg: NQ,
    md: zQ,
    sm: VQ,
    xs: BQ,
    micro: UQ,
    standard: HQ,
    nano: $Q,
    left: WQ,
    center: qQ,
    right: YQ,
    italic: GQ,
    bold: XQ
  },
  cu = ({
    id: t,
    className: e,
    size: i,
    align: l,
    Tag: c,
    children: p
  }) => {
    const h = ge(E2.heading, {
      [E2[i ?? ""]]: i,
      [E2[l ?? ""]]: l
    }, e);
    return /* @__PURE__ */B.jsx(Sq, {
      id: t,
      Tag: c,
      className: h,
      children: p
    });
  };
cu.displayName = "Heading";
const M_e = {
    xl: "xl",
    lg: "lg",
    md: "md",
    sm: "sm",
    xs: "xs",
    micro: "micro",
    eyebrow: "eyebrow"
  },
  KQ = (t = "info") => {
    switch (t) {
      case "error":
        return "error-solid";
      case "success":
        return "success-solid";
      case "warning":
        return "alert-solid";
      case "info":
      case "general":
      default:
        return "info-solid";
    }
  },
  QQ = "_link_zwv9e_1",
  ZQ = "_inverse_zwv9e_10",
  JQ = "_linkIcon_zwv9e_22",
  eZ = "_dark_zwv9e_33",
  tZ = "_disabled_zwv9e_53",
  nZ = "_sm_zwv9e_61",
  rZ = "_md_zwv9e_61",
  iZ = "_lg_zwv9e_64",
  B0 = {
    link: QQ,
    inverse: ZQ,
    linkIcon: JQ,
    dark: eZ,
    disabled: tZ,
    sm: nZ,
    md: rZ,
    lg: iZ
  },
  fd = ({
    href: t,
    children: e,
    className: i,
    renderLink: l = (C, {
      children: k,
      ...D
    }) => /* @__PURE__ */B.jsx("a", {
      href: C,
      ...D,
      children: k
    }),
    icon: c,
    variant: p = "primary",
    size: h = "lg",
    noStyle: y = !1,
    disabled: w,
    theme: x,
    ...E
  }) => {
    const C = /* @__PURE__ */B.jsxs(B.Fragment, {
      children: [e, c && !y && /* @__PURE__ */B.jsx(sn, {
        name: c,
        className: B0.linkIcon
      })]
    });
    return l(t, {
      children: C,
      className: ge(i, {
        [B0.link]: !y,
        [B0[p]]: p && B0[p],
        [B0[h]]: h && B0[h],
        [B0.disabled]: w,
        [B0[x ?? ""]]: x
      }),
      ...E
    });
  };
fd.displayName = "Link";
const aZ = "_alert_1pdyx_134",
  oZ = "_alertIcon_1pdyx_145",
  sZ = "_warning_1pdyx_148",
  lZ = "_info_1pdyx_152",
  uZ = "_general_1pdyx_152",
  cZ = "_success_1pdyx_156",
  dZ = "_error_1pdyx_160",
  fZ = "_alertHeadingContainer_1pdyx_164",
  pZ = "_alertBody_1pdyx_173",
  hZ = "_alertHeading_1pdyx_164",
  mZ = "_alertChildren_1pdyx_181",
  vZ = "_alertClose_1pdyx_188",
  gZ = "_dismissible_1pdyx_205",
  yZ = "_dark_1pdyx_208",
  bZ = "_noChildren_1pdyx_218",
  wZ = "_buttonLink_1pdyx_218",
  Dp = {
    alert: aZ,
    alertIcon: oZ,
    warning: sZ,
    info: lZ,
    general: uZ,
    success: cZ,
    error: dZ,
    alertHeadingContainer: fZ,
    alertBody: pZ,
    alertHeading: hZ,
    alertChildren: mZ,
    alertClose: vZ,
    dismissible: gZ,
    dark: yZ,
    noChildren: bZ,
    buttonLink: wZ
  },
  U4 = Qn(({
    className: t,
    classNames: e = {},
    heading: i,
    headingAs: l = "p",
    headingSize: c = "sm",
    children: p,
    variant: h = "warning",
    dismissible: y = !0,
    theme: w = PQ.light,
    dismissibleLabel: x = "Close alert",
    noIcon: E = !1,
    icon: C,
    renderLink: k,
    link: D,
    ...I
  }, O) => {
    const P = {
        body: Dp.alertBody,
        dismissibleButton: Dp.alertClose,
        ...e
      },
      N = ge(Dp.alert, Dp[h], t, {
        [Dp.dismissible]: y,
        [Dp.noChildren]: !p,
        [Dp[w]]: !!w
      });
    return /* @__PURE__ */B.jsxs(DH, {
      ref: O,
      className: N,
      classNames: P,
      dismissible: y,
      dismissibleLabel: x,
      dismissibleIcon: /* @__PURE__ */B.jsx(sn, {
        name: "close"
      }),
      ...I,
      children: [/* @__PURE__ */B.jsxs("div", {
        className: Dp.alertHeadingContainer,
        children: [!E && /* @__PURE__ */B.jsx(sn, {
          className: Dp.alertIcon,
          name: h === "general" && C ? C : KQ(h)
        }), /* @__PURE__ */B.jsx(cu, {
          Tag: l,
          size: c,
          align: "left",
          className: Dp.alertHeading,
          children: i
        })]
      }), !!p && /* @__PURE__ */B.jsx("div", {
        className: Dp.alertChildren,
        children: p
      }), !!D && /* @__PURE__ */B.jsx(fd, {
        renderLink: k,
        href: D.href,
        className: Dp.buttonLink,
        icon: "arrow-right-micro",
        size: "md",
        theme: w,
        children: D.linkText
      })]
    });
  });
U4.displayName = "Alert";
const _Z = "_btn_8pdej_1",
  xZ = "_btnIcon_8pdej_17",
  SZ = "_disabled_8pdej_26",
  EZ = "_primary_8pdej_42",
  CZ = "_iconOnly_8pdej_54",
  kZ = "_outline_8pdej_55",
  TZ = "_utility_8pdej_56",
  RZ = "_inverse_8pdej_83",
  DZ = "_actionOutline_8pdej_88",
  IZ = "_actionInverseFilled_8pdej_120",
  MZ = "_actionInverse_8pdej_120",
  OZ = "_action_8pdej_88",
  LZ = "_noStyle_8pdej_236",
  PZ = "_center_8pdej_245",
  AZ = "_right_8pdej_249",
  jZ = "_sm_8pdej_253",
  FZ = "_lg_8pdej_259",
  NZ = "_xl_8pdej_265",
  ob = {
    btn: _Z,
    btnIcon: xZ,
    disabled: SZ,
    primary: EZ,
    iconOnly: CZ,
    outline: kZ,
    utility: TZ,
    inverse: RZ,
    actionOutline: DZ,
    actionInverseFilled: IZ,
    actionInverse: MZ,
    action: OZ,
    noStyle: LZ,
    center: PZ,
    right: AZ,
    sm: jZ,
    lg: FZ,
    xl: NZ
  },
  op = Qn((t, e) => {
    const {
        className: i,
        variant: l = "primary",
        defaultStyle: c = !0,
        disabled: p,
        icon: h,
        iconPlacement: y = "left",
        align: w = "left",
        size: x = "md",
        children: E,
        ...C
      } = t,
      k = {
        className: ge(i, {
          [ob.disabled]: p,
          [ob.btn]: c && l !== "noStyle",
          [ob[l]]: l && ob[l],
          [ob[x]]: x && ob[x]
        }),
        disabled: p,
        leftSection: h && y === "left" ? /* @__PURE__ */B.jsx(sn, {
          name: h,
          className: ob.btnIcon
        }) : void 0,
        children: l === "iconOnly" ? null : E,
        rightSection: h && y === "right" ? /* @__PURE__ */B.jsx(sn, {
          name: h,
          className: ob.btnIcon
        }) : void 0,
        ...C
      };
    return w === "center" || w === "right" ? /* @__PURE__ */B.jsx("div", {
      className: ob[w],
      children: /* @__PURE__ */B.jsx(_j, {
        ref: e,
        ...k
      })
    }) : /* @__PURE__ */B.jsx(_j, {
      ref: e,
      ...k
    });
  });
op.displayName = "Button";
const O_e = {
    solid: "solid",
    transparent: "transparent"
  },
  L_e = {
    light: "light",
    dark: "dark"
  },
  Ym = ({
    wrapperClassName: t,
    source: e,
    alt: i,
    src: l,
    srcSet: c,
    sizes: p,
    ...h
  }) => {
    const y = ci(() => {
        var C;
        return (C = e == null ? void 0 : e.sources) == null ? void 0 : C.slice().reverse();
      }, [e]),
      w = (e == null ? void 0 : e.src) || l,
      x = (e == null ? void 0 : e.srcSet) || c,
      E = (e == null ? void 0 : e.sizes) || p;
    return /* @__PURE__ */B.jsxs("picture", {
      children: [y && y.map((C, k) => /* @__PURE__ */B.jsx("source", {
        media: C.media,
        srcSet: C.srcSet
      }, k)), /* @__PURE__ */B.jsx("img", {
        className: t,
        src: w,
        srcSet: x,
        sizes: E,
        alt: i,
        ...h
      })]
    });
  },
  zZ = "_theme_1odt6_1",
  VZ = "_ratingText_1odt6_5",
  BZ = "_dark_1odt6_9",
  xT = {
    theme: zZ,
    ratingText: VZ,
    dark: BZ
  },
  wO = ({
    rating: t = 0,
    ratingText: e,
    maximum: i = 5,
    simple: l = !1,
    theme: c = "light",
    classNames: p
  }) => {
    const h = {
      container: ge(p == null ? void 0 : p.container, xT.theme, xT == null ? void 0 : xT[c]),
      rating: ge(p == null ? void 0 : p.rating, xT.ratingText)
    };
    return /* @__PURE__ */B.jsx($K, {
      rating: t,
      ratingText: e,
      maximum: i,
      simple: l,
      classNames: h,
      renderSolidIcon: /* @__PURE__ */B.jsx(sn, {
        name: "rating-solid"
      }),
      renderPartialIcon: /* @__PURE__ */B.jsx(sn, {
        name: "rating-partial"
      }),
      renderOutlineIcon: /* @__PURE__ */B.jsx(sn, {
        name: "rating"
      })
    });
  },
  UZ = "_hotelCard_t455t_1",
  HZ = "_cardLink_t455t_9",
  $Z = "_hotelCardImage_t455t_37",
  WZ = "_hotelCardContainer_t455t_52",
  qZ = "_hotelCardHeading_t455t_57",
  YZ = "_hotelCardSubHeading_t455t_65",
  GZ = "_hotelCardDetails_t455t_88",
  XZ = "_hotelCardRatingsContainer_t455t_93",
  KZ = "_hotelCardDetailsLink_t455t_98",
  Uv = {
    hotelCard: UZ,
    cardLink: HZ,
    hotelCardImage: $Z,
    hotelCardContainer: WZ,
    hotelCardHeading: qZ,
    hotelCardSubHeading: YZ,
    hotelCardDetails: GZ,
    hotelCardRatingsContainer: XZ,
    hotelCardDetailsLink: KZ
  },
  P_e = ({
    image: t,
    header: e,
    subheader: i,
    link: l,
    stars: c,
    labels: p,
    headerAs: h = "h2",
    className: y,
    renderLink: w,
    theme: x = "light"
  }) => {
    var E, C, k;
    return /* @__PURE__ */B.jsxs("div", {
      className: ge(Uv.hotelCard, y),
      "data-theme": x,
      children: [t && /* @__PURE__ */B.jsx("div", {
        className: Uv.hotelCardImage,
        children: /* @__PURE__ */B.jsx(Ym, {
          src: (E = t == null ? void 0 : t.source) == null ? void 0 : E.src,
          srcSet: (C = t == null ? void 0 : t.source) == null ? void 0 : C.srcSet,
          sizes: (k = t == null ? void 0 : t.source) == null ? void 0 : k.sizes,
          alt: t.alt,
          source: t.source,
          loading: "lazy"
        })
      }), /* @__PURE__ */B.jsxs("div", {
        className: Uv.hotelCardContainer,
        children: [/* @__PURE__ */B.jsxs("div", {
          className: Uv.hotelCardBody,
          children: [e && /* @__PURE__ */B.jsx(cu, {
            size: "eyebrow",
            className: Uv.hotelCardHeading,
            Tag: i ? "div" : h,
            children: e
          }), i && /* @__PURE__ */B.jsx(cu, {
            className: Uv.hotelCardSubHeading,
            Tag: h,
            size: "md",
            children: i
          }), /* @__PURE__ */B.jsx("div", {
            className: ge(Uv.hotelCardDetails),
            children: /* @__PURE__ */B.jsx("span", {
              children: p == null ? void 0 : p.allInc
            })
          }), c && /* @__PURE__ */B.jsx("div", {
            className: Uv.hotelCardRatingsContainer,
            children: /* @__PURE__ */B.jsx(wO, {
              rating: c,
              theme: x
            })
          })]
        }), !!l && /* @__PURE__ */B.jsx("div", {
          className: Uv.hotelCardDetailsLink,
          children: /* @__PURE__ */B.jsx(fd, {
            className: Uv.cardLink,
            href: l.href,
            variant: x,
            target: l == null ? void 0 : l.target,
            renderLink: w,
            icon: (l == null ? void 0 : l.icon) ?? "arrow-right",
            children: l == null ? void 0 : l.children
          })
        })]
      })]
    });
  },
  QZ = "_info_v0v6h_1",
  ZZ = "_transparent_v0v6h_13",
  JZ = "_cardLink_v0v6h_21",
  eJ = "_infoCardLink_v0v6h_45",
  tJ = "_linkSrOnly_v0v6h_60",
  nJ = "_infoContent_v0v6h_71",
  rJ = "_infoHeading_v0v6h_79",
  iJ = "_defaultHeaderSize_v0v6h_83",
  aJ = "_horizontal_v0v6h_83",
  oJ = "_infoIcon_v0v6h_88",
  sJ = "_infoImage_v0v6h_101",
  lJ = "_infoDesc_v0v6h_107",
  uJ = "_infoFooter_v0v6h_110",
  cJ = "_infoLink_v0v6h_118",
  dJ = "_infoPrice_v0v6h_135",
  fJ = "_horizontalNoIcon_v0v6h_145",
  pJ = "_from_v0v6h_193",
  hJ = "_to_v0v6h_194",
  mJ = "_connector_v0v6h_198",
  vJ = "_label_v0v6h_206",
  gJ = "_price_v0v6h_216",
  yJ = "_message_v0v6h_229",
  bJ = "_pricing_v0v6h_234",
  fa = {
    info: QZ,
    transparent: ZZ,
    cardLink: JZ,
    infoCardLink: eJ,
    linkSrOnly: tJ,
    infoContent: nJ,
    infoHeading: rJ,
    defaultHeaderSize: iJ,
    horizontal: aJ,
    default: "_default_v0v6h_83",
    infoIcon: oJ,
    infoImage: sJ,
    infoDesc: lJ,
    infoFooter: uJ,
    infoLink: cJ,
    infoPrice: dJ,
    horizontalNoIcon: fJ,
    from: pJ,
    to: hJ,
    connector: mJ,
    label: vJ,
    price: gJ,
    message: yJ,
    pricing: bJ
  },
  dR = (t, e = "en-CA") => {
    if (t == null || t === "") return null;
    const i = Number(t);
    if (Number.isNaN(i)) return t.toString();
    const l = i % 1 !== 0;
    return new Intl.NumberFormat(e, {
      style: "currency",
      currency: "CAD",
      currencyDisplay: "narrowSymbol",
      minimumFractionDigits: l ? 2 : 0,
      maximumFractionDigits: 2
    }).formatToParts(i).map((p, h) => p.type === "currency" ? /* @__PURE__ */B.jsx("sup", {
      children: p.value
    }, h) : p.type === "fraction" || p.type === "decimal" ? /* @__PURE__ */B.jsx("sup", {
      children: p.value
    }, h) : /* @__PURE__ */B.jsx("span", {
      children: p.value
    }, h));
  },
  wJ = {
    default: "default",
    horizontal: "horizontal",
    horizontalNoIcon: "horizontalNoIcon"
  },
  A_e = ({
    icon: t,
    image: e,
    header: i,
    headerAs: l = "h2",
    variant: c,
    content: p,
    link: h,
    renderLink: y,
    className: w,
    classNames: x,
    labels: E,
    fromPrice: C,
    toPrice: k,
    theme: D = "light",
    backgroundType: I,
    priceMessage: O,
    linkSrOnly: P = !1,
    locale: N = "en-CA"
  }) => {
    var F, j, V;
    const L = c ?? "default";
    return /* @__PURE__ */B.jsxs("div", {
      className: ge(fa.info, w, I && fa[I], {
        [fa[L]]: L,
        [fa.defaultHeaderSize]: l === "h2"
      }),
      "data-theme": D,
      children: [/* @__PURE__ */B.jsxs("div", {
        className: ge(fa.infoContent, x == null ? void 0 : x.cardContent),
        children: [t && (!e || !e.source) && c !== wJ.horizontalNoIcon && /* @__PURE__ */B.jsx(sn, {
          name: t,
          className: ge(fa.infoIcon, x == null ? void 0 : x.cardIcon)
        }), e && (e == null ? void 0 : e.source) && /* @__PURE__ */B.jsx("div", {
          className: ge(fa.infoImage, x == null ? void 0 : x.cardImage),
          children: /* @__PURE__ */B.jsx(Ym, {
            src: (F = e == null ? void 0 : e.source) == null ? void 0 : F.src,
            srcSet: (j = e == null ? void 0 : e.source) == null ? void 0 : j.srcSet,
            sizes: (V = e == null ? void 0 : e.source) == null ? void 0 : V.sizes,
            source: e.source,
            alt: e.alt,
            loading: "lazy"
          })
        }), i && /* @__PURE__ */B.jsx(cu, {
          Tag: l,
          className: ge(fa.infoHeading, x == null ? void 0 : x.cardHeading),
          children: i
        }), Array.isArray(p) && p.length > 0 ? /* @__PURE__ */B.jsx("ul", {
          children: p.map((K, G) => /* @__PURE__ */B.jsx("li", {
            children: K
          }, G))
        }) : p ? /* @__PURE__ */B.jsx("div", {
          className: fa == null ? void 0 : fa.infoDesc,
          children: p
        }) : null, (C || k || O) && /* @__PURE__ */B.jsxs("div", {
          className: fa == null ? void 0 : fa.infoPrice,
          children: [(C || C && k) && /* @__PURE__ */B.jsxs("div", {
            className: fa.pricing,
            children: [C && /* @__PURE__ */B.jsxs("div", {
              className: fa.from,
              children: [/* @__PURE__ */B.jsx("span", {
                className: fa.label,
                children: k ? E == null ? void 0 : E.from : E == null ? void 0 : E.price
              }), /* @__PURE__ */B.jsx("span", {
                className: fa.price,
                children: dR(C, N)
              })]
            }), k && /* @__PURE__ */B.jsxs(B.Fragment, {
              children: [/* @__PURE__ */B.jsx("span", {
                className: fa.connector,
                children: "–"
              }), /* @__PURE__ */B.jsxs("div", {
                className: fa.to,
                children: [/* @__PURE__ */B.jsx("span", {
                  className: fa.label,
                  children: E == null ? void 0 : E.to
                }), /* @__PURE__ */B.jsx("span", {
                  className: fa.price,
                  children: dR(k, N)
                })]
              })]
            })]
          }), O && /* @__PURE__ */B.jsx("div", {
            className: fa.message,
            children: O
          })]
        })]
      }), !!h && /* @__PURE__ */B.jsx("div", {
        className: fa.infoFooter,
        children: /* @__PURE__ */B.jsx(fd, {
          icon: (h == null ? void 0 : h.icon) ?? "arrow-right-micro",
          href: h.href,
          target: h == null ? void 0 : h.target,
          className: ge(fa.cardLink, P && fa.linkSrOnly),
          theme: D,
          renderLink: y,
          children: /* @__PURE__ */B.jsx("span", {
            children: h == null ? void 0 : h.children
          })
        })
      })]
    });
  },
  _J = "_card_q8ft8_1",
  xJ = "_cardLink_q8ft8_15",
  SJ = "_cardCtaBtn_q8ft8_40",
  EJ = "_subTextWrapper_q8ft8_46",
  CJ = "_tag_q8ft8_51",
  kJ = "_icon_q8ft8_63",
  TJ = "_price_q8ft8_77",
  RJ = "_priceValue_q8ft8_83",
  DJ = "_priceSubtext_q8ft8_96",
  IJ = "_priceDescription_q8ft8_100",
  MJ = "_priceDiscount_q8ft8_107",
  OJ = "_priceContent_q8ft8_119",
  LJ = "_LPC_q8ft8_125",
  tp = {
    card: _J,
    cardLink: xJ,
    cardCtaBtn: SJ,
    subTextWrapper: EJ,
    tag: CJ,
    icon: kJ,
    price: TJ,
    priceValue: RJ,
    priceSubtext: DJ,
    priceDescription: IJ,
    priceDiscount: MJ,
    priceContent: OJ,
    LPC: LJ
  },
  j_e = ({
    link: t,
    price: e,
    tag: i,
    locale: l = "en-CA",
    ariaLabel: c
  }) => /* @__PURE__ */B.jsxs("div", {
    "aria-label": c,
    className: tp.card,
    children: [/* @__PURE__ */B.jsx("span", {
      children: /* @__PURE__ */B.jsx(F4, {
        className: tp.tag,
        label: i,
        icon: /* @__PURE__ */B.jsx(sn, {
          className: tp.icon,
          name: "deal-solid",
          size: "md"
        })
      })
    }), /* @__PURE__ */B.jsxs("div", {
      className: tp.subTextWrapper,
      children: [/* @__PURE__ */B.jsx("div", {
        className: tp.priceSubtext,
        children: e.subtext
      }), /* @__PURE__ */B.jsxs("div", {
        className: tp.price,
        children: [/* @__PURE__ */B.jsx("span", {
          className: tp.priceDescription,
          children: e.description
        }), /* @__PURE__ */B.jsxs("div", {
          className: tp.priceContent,
          children: [/* @__PURE__ */B.jsx("span", {
            className: tp.priceDiscount,
            children: dR(e.discount, l)
          }), /* @__PURE__ */B.jsx("span", {
            className: tp.priceValue,
            children: dR(e.value, l)
          })]
        })]
      }), t && /* @__PURE__ */B.jsx("div", {
        className: tp.cardCtaBtn,
        children: /* @__PURE__ */B.jsx(fd, {
          icon: (t == null ? void 0 : t.icon) ?? "arrow-right-micro",
          target: t == null ? void 0 : t.target,
          ...t,
          size: "md",
          className: ge(tp.cardLink, tp.LPC)
        })
      })]
    })]
  }),
  PJ = "_tag_1eozx_1",
  AJ = "_tagIcon_1eozx_11",
  dB = {
    tag: PJ,
    tagIcon: AJ
  },
  jJ = ({
    icon: t = "deal-solid",
    label: e,
    className: i
  }) => /* @__PURE__ */B.jsx(F4, {
    className: ge(dB.tag, i),
    label: e,
    icon: /* @__PURE__ */B.jsx(sn, {
      className: dB.tagIcon,
      name: t
    })
  }),
  FJ = "_merchCard_glrgo_1",
  NJ = "_merchCardLink_glrgo_13",
  zJ = "_merchCardImage_glrgo_52",
  VJ = "_merchCardBody_glrgo_67",
  BJ = "_merchCardContentContainer_glrgo_73",
  UJ = "_merchCardHeading_glrgo_82",
  HJ = "_merchCardSubheading_glrgo_98",
  $J = "_merchCardRatingsContainer_glrgo_110",
  WJ = "_merchCardDetailsDays_glrgo_114",
  qJ = "_merchCardDetailsDaysInfo_glrgo_119",
  YJ = "_merchCardDetailsPrice_glrgo_126",
  GJ = "_merchCardDetailsSave_glrgo_137",
  XJ = "_merchCardDetailsAmount_glrgo_143",
  KJ = "_merchCardDetailsPrevAmount_glrgo_157",
  Tc = {
    merchCard: FJ,
    merchCardLink: NJ,
    merchCardImage: zJ,
    merchCardBody: VJ,
    merchCardContentContainer: BJ,
    merchCardHeading: UJ,
    merchCardSubheading: HJ,
    merchCardRatingsContainer: $J,
    merchCardDetailsDays: WJ,
    merchCardDetailsDaysInfo: qJ,
    merchCardDetailsPrice: YJ,
    merchCardDetailsSave: GJ,
    merchCardDetailsAmount: XJ,
    merchCardDetailsPrevAmount: KJ
  },
  QJ = {
    adultsOnly: "Adults only",
    departure: "Dep.",
    return: "Ret.",
    perAdult: "Per adult",
    taxAndFees: "Taxes and fees incl.",
    from: "Toronto",
    dayOfWeek: "Thursday",
    departureDate: "Dec 9, 2024",
    returnDate: "Dec 16, 2024",
    allInc: "All inclusive",
    was: "was"
  },
  ZJ = ({
    labels: t,
    image: e,
    header: i,
    link: l,
    className: c,
    subheader: p,
    stars: h,
    minAge: y,
    days: w,
    save: x,
    regPrice: E,
    price: C,
    locale: k = "en-CA",
    headerAs: D = "h2",
    theme: I = "light",
    renderLink: O
  }) => {
    var N, L, F, j;
    const P = {
      ...QJ,
      ...t
    };
    return /* @__PURE__ */B.jsxs("div", {
      className: ge(Tc.merchCard, c),
      "data-theme": I,
      children: [((N = e == null ? void 0 : e.source) == null ? void 0 : N.src) && /* @__PURE__ */B.jsx("div", {
        className: Tc.merchCardImage,
        children: /* @__PURE__ */B.jsx(Ym, {
          src: (L = e == null ? void 0 : e.source) == null ? void 0 : L.src,
          srcSet: (F = e == null ? void 0 : e.source) == null ? void 0 : F.srcSet,
          sizes: (j = e == null ? void 0 : e.source) == null ? void 0 : j.sizes,
          source: e == null ? void 0 : e.source,
          alt: e.alt || i,
          loading: "lazy"
        })
      }), /* @__PURE__ */B.jsxs("div", {
        className: Tc.merchCardBody,
        children: [/* @__PURE__ */B.jsxs("div", {
          children: [/* @__PURE__ */B.jsx(cu, {
            className: Tc.merchCardHeading,
            Tag: D,
            children: i
          }), (p || w) && /* @__PURE__ */B.jsx(cu, {
            Tag: "div",
            size: "md",
            className: Tc.merchCardSubheading,
            children: p
          }), h && /* @__PURE__ */B.jsx(wO, {
            rating: h,
            theme: I,
            classNames: {
              container: Tc.merchCardRatingsContainer
            }
          })]
        }), typeof y == "number" && y >= 16 && /* @__PURE__ */B.jsx("p", {
          children: `${P.adultsOnly} ${y}`
        }), C && x && /* @__PURE__ */B.jsx(jJ, {
          className: Tc.merchCardDetailsSave,
          label: x
        }), /* @__PURE__ */B.jsxs("div", {
          className: Tc.merchCardContentContainer,
          children: [w && /* @__PURE__ */B.jsx("div", {
            className: Tc.merchCardDetailsDays,
            children: /* @__PURE__ */B.jsxs("div", {
              className: Tc.merchCardDetailsDaysInfo,
              children: [/* @__PURE__ */B.jsx("span", {
                children: P == null ? void 0 : P.departureDate
              }), /* @__PURE__ */B.jsx("span", {
                children: w
              }), (P == null ? void 0 : P.allInc) && /* @__PURE__ */B.jsx("span", {
                children: P.allInc
              })]
            })
          }), C !== void 0 && /* @__PURE__ */B.jsxs("div", {
            className: Tc.merchCardDetailsPrice,
            children: [E !== void 0 && x && /* @__PURE__ */B.jsx("div", {
              className: Tc.merchCardDetailsPrevAmount,
              children: /* @__PURE__ */B.jsx(aE, {
                renderCurrencyAsSup: !1,
                number: E,
                locale: k
              })
            }), /* @__PURE__ */B.jsx("div", {
              className: Tc.merchCardDetailsAmount,
              children: /* @__PURE__ */B.jsx(aE, {
                renderCurrencyAsSup: !0,
                number: C,
                locale: k
              })
            }), /* @__PURE__ */B.jsxs("div", {
              className: Tc.merchCardDetailsDaysInfo,
              children: [/* @__PURE__ */B.jsx("span", {
                children: P.perAdult
              }), /* @__PURE__ */B.jsx("span", {
                children: P.taxAndFees
              })]
            })]
          })]
        })]
      }), !!l && /* @__PURE__ */B.jsx(fd, {
        className: Tc.merchCardLink,
        href: l.href,
        target: l.target ?? "_blank",
        renderLink: O,
        children: /* @__PURE__ */B.jsx("span", {
          children: l == null ? void 0 : l.children
        })
      })]
    });
  },
  JJ = "_header_8t6ye_1",
  eee = "_headerImage_8t6ye_5",
  tee = "_headerHeading_8t6ye_18",
  nee = "_headerContent_8t6ye_28",
  ree = "_headerLogo_8t6ye_37",
  iee = "_headerBody_8t6ye_82",
  X1 = {
    header: JJ,
    headerImage: eee,
    headerHeading: tee,
    headerContent: nee,
    headerLogo: ree,
    headerBody: iee
  },
  F_e = ({
    image: t,
    logo: e,
    header: i,
    content: l,
    headerAs: c = "h1",
    className: p,
    role: h
  }) => {
    var y, w, x;
    return /* @__PURE__ */B.jsxs("div", {
      role: h,
      className: ge(X1.header, p),
      children: [t && /* @__PURE__ */B.jsxs("div", {
        className: X1.headerImage,
        children: [/* @__PURE__ */B.jsx(Ym, {
          src: (y = t == null ? void 0 : t.source) == null ? void 0 : y.src,
          srcSet: (w = t == null ? void 0 : t.source) == null ? void 0 : w.srcSet,
          sizes: (x = t == null ? void 0 : t.source) == null ? void 0 : x.sizes,
          alt: t.alt ?? "",
          source: t.source,
          loading: "lazy"
        }), !!e && /* @__PURE__ */B.jsx("div", {
          className: X1.headerLogo,
          children: /* @__PURE__ */B.jsx(Ym, {
            src: e.src,
            alt: e == null ? void 0 : e.alt,
            loading: "lazy"
          })
        })]
      }), /* @__PURE__ */B.jsxs("div", {
        className: X1.headerBody,
        children: [/* @__PURE__ */B.jsx(cu, {
          size: "md",
          Tag: c,
          className: X1.headerHeading,
          children: i
        }), /* @__PURE__ */B.jsx("div", {
          className: X1.headerContent,
          children: l
        })]
      })]
    });
  },
  aee = "_primary_erzcl_1",
  oee = "_cardLink_erzcl_31",
  see = "_transparent_erzcl_38",
  lee = "_primaryImage_erzcl_45",
  uee = "_primaryBody_erzcl_58",
  cee = "_primaryHeading_erzcl_67",
  dee = "_primaryContent_erzcl_72",
  fee = "_primarySubheading_erzcl_75",
  pee = "_primaryHeader_erzcl_78",
  hee = "_primaryFooter_erzcl_82",
  mee = "_primaryButton_erzcl_91",
  vee = "_primaryLogo_erzcl_94",
  gee = "_square_erzcl_112",
  yee = "_landscape_erzcl_116",
  bee = "_wide_erzcl_119",
  wee = "_logoOffset_erzcl_128",
  _ee = "_hasLimit_erzcl_140",
  xee = "_evenSplit_erzcl_199",
  See = "_clickable_erzcl_279",
  Rc = {
    primary: aee,
    cardLink: oee,
    transparent: see,
    primaryImage: lee,
    primaryBody: uee,
    primaryHeading: cee,
    primaryContent: dee,
    primarySubheading: fee,
    primaryHeader: pee,
    primaryFooter: hee,
    primaryButton: mee,
    primaryLogo: vee,
    square: gee,
    landscape: yee,
    wide: bee,
    logoOffset: wee,
    hasLimit: _ee,
    evenSplit: xee,
    clickable: See
  },
  N_e = {
    default: "default",
    evenSplit: "evenSplit",
    logoOffset: "logoOffset"
  },
  fB = {
    link: "link",
    button: "button"
  },
  Eee = (t, e) => {
    if (!t || !e || e === 0) return;
    const i = t / e;
    return i === 1 ? "square" : i <= 2 && i > 1 ? "landscape" : (i > 2, "wide");
  },
  z_e = ({
    image: t,
    logo: e,
    subheading: i,
    header: l,
    variant: c,
    content: p,
    contentLimit: h,
    link: y,
    headerAs: w = "h1",
    backgroundType: x,
    ctaVariant: E,
    className: C,
    renderLink: k,
    theme: D = "light"
  }) => {
    var O, P, N;
    const I = Eee(Number(e == null ? void 0 : e.width), Number(e == null ? void 0 : e.height));
    return /* @__PURE__ */B.jsxs("div", {
      className: ge(Rc.primary, C, c && Rc[c], x && Rc[x]),
      "data-theme": D,
      children: [t && /* @__PURE__ */B.jsx("div", {
        className: Rc.primaryImage,
        children: /* @__PURE__ */B.jsx(Ym, {
          src: (O = t == null ? void 0 : t.source) == null ? void 0 : O.src,
          srcSet: (P = t == null ? void 0 : t.source) == null ? void 0 : P.srcSet,
          sizes: (N = t == null ? void 0 : t.source) == null ? void 0 : N.sizes,
          alt: t.alt,
          source: t.source,
          loading: "lazy"
        })
      }), /* @__PURE__ */B.jsxs("div", {
        className: Rc.primaryBody,
        children: [/* @__PURE__ */B.jsxs("div", {
          className: Rc.primaryHeader,
          children: [!!i && /* @__PURE__ */B.jsx(cu, {
            Tag: "div",
            size: "eyebrow",
            className: Rc.primarySubheading,
            children: i
          }), !!l && /* @__PURE__ */B.jsx(cu, {
            size: "md",
            Tag: w,
            className: Rc.primaryHeading,
            children: l
          }), !!p && /* @__PURE__ */B.jsx("div", {
            className: ge(Rc.primaryContent, {
              [Rc.hasLimit]: h
            }),
            children: p
          })]
        }), /* @__PURE__ */B.jsxs("div", {
          className: Rc.primaryFooter,
          children: [!!y && /* @__PURE__ */B.jsx("div", {
            children: E === fB.button ? /* @__PURE__ */B.jsx(op, {
              as: "a",
              size: "md",
              variant: "action",
              href: y.href,
              renderLink: k,
              className: Rc.cardLink,
              children: y == null ? void 0 : y.children
            }) : /* @__PURE__ */B.jsx(fd, {
              renderLink: k,
              icon: (y == null ? void 0 : y.icon) ?? "arrow-right-micro",
              href: y.href,
              target: y == null ? void 0 : y.target,
              variant: D,
              className: Rc.cardLink,
              children: y == null ? void 0 : y.children
            })
          }), !!e && E !== fB.button && /* @__PURE__ */B.jsx("div", {
            className: ge(Rc.primaryLogo, I && Rc[I]),
            children: /* @__PURE__ */B.jsx(Ym, {
              src: e.src,
              alt: e == null ? void 0 : e.alt,
              loading: "lazy"
            })
          })]
        })]
      })]
    });
  },
  EN = {
    openModalLabel: "Gallery",
    firstSlideMessage: "This is the first slide",
    lastSlideMessage: "This is the last slide",
    prevSlideMessage: "Previous slide",
    nextSlideMessage: "Next slide",
    paginationBulletMessage: "Go to slide {{index}}",
    slideLabelMessage: "{{index}}/{{slidesLength}}",
    closeModal: "Close",
    playVideo: "Play video",
    viewImage: "View image"
  },
  pB = {
    "10:4": "10:4",
    "16:9": "16:9",
    "1:1": "1:1"
  },
  Cee = (t, e) => {
    let i, l;
    switch (t) {
      case "10:4":
        i = 10 / 4, l = e || "t_WVI-ar10x4";
        break;
      case "16:9":
        i = 16 / 9, l = e || "t_WVI-ar16x9";
        break;
      case "1:1":
        i = 1, l = e || "t_WVI-ar1x1";
        break;
      case "2:3":
        i = 2 / 3, l = e || "t_WVI-ar2x3";
        break;
      case "3:2":
        i = 3 / 2, l = e || "t_WVI-ar3x2";
        break;
      default:
        {
          try {
            const p = /^(\d+(?:\.\d+)?):(\d+(?:\.\d+)?)$/.exec(t);
            if (p) {
              const [, h, y] = p;
              i = parseFloat(h) / parseFloat(y);
            } else console.warn(`Invalid aspect ratio format: ${t}`), i = 16 / 9;
          } catch {
            console.warn(`Unable to parse provided aspect ratio: ${t}.  Expected format is "number:number"`), i = 16 / 9;
          }
          l = e || "t_WVI-ar16x9";
          break;
        }
    }
    return [i, l];
  },
  H4 = (t, {
    className: e,
    wrapperClassName: i
  }) => /* @__PURE__ */B.jsx(Ym, {
    wrapperClassName: i,
    title: t.title,
    source: t.source,
    src: t.src,
    className: e,
    alt: t.alt ?? "Image",
    loading: "lazy"
  });
function hB(t) {
  return t !== null && typeof t == "object" && "constructor" in t && t.constructor === Object;
}
function CN(t, e) {
  t === void 0 && (t = {}), e === void 0 && (e = {});
  const i = ["__proto__", "constructor", "prototype"];
  Object.keys(e).filter(l => i.indexOf(l) < 0).forEach(l => {
    typeof t[l] > "u" ? t[l] = e[l] : hB(e[l]) && hB(t[l]) && Object.keys(e[l]).length > 0 && CN(t[l], e[l]);
  });
}
const $4 = {
  body: {},
  addEventListener() {},
  removeEventListener() {},
  activeElement: {
    blur() {},
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {}
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {},
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function Gm() {
  const t = typeof document < "u" ? document : {};
  return CN(t, $4), t;
}
const kee = {
  document: $4,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {},
    pushState() {},
    go() {},
    back() {}
  },
  CustomEvent: function () {
    return this;
  },
  addEventListener() {},
  removeEventListener() {},
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {},
  Date() {},
  screen: {},
  setTimeout() {},
  clearTimeout() {},
  matchMedia() {
    return {};
  },
  requestAnimationFrame(t) {
    return typeof setTimeout > "u" ? (t(), null) : setTimeout(t, 0);
  },
  cancelAnimationFrame(t) {
    typeof setTimeout > "u" || clearTimeout(t);
  }
};
function wl() {
  const t = typeof window < "u" ? window : {};
  return CN(t, kee), t;
}
function Tee(t) {
  return t === void 0 && (t = ""), t.trim().split(" ").filter(e => !!e.trim());
}
function Ree(t) {
  const e = t;
  Object.keys(e).forEach(i => {
    try {
      e[i] = null;
    } catch {}
    try {
      delete e[i];
    } catch {}
  });
}
function kN(t, e) {
  return e === void 0 && (e = 0), setTimeout(t, e);
}
function _O() {
  return Date.now();
}
function Dee(t) {
  const e = wl();
  let i;
  return e.getComputedStyle && (i = e.getComputedStyle(t, null)), !i && t.currentStyle && (i = t.currentStyle), i || (i = t.style), i;
}
function Nj(t, e) {
  e === void 0 && (e = "x");
  const i = wl();
  let l, c, p;
  const h = Dee(t);
  return i.WebKitCSSMatrix ? (c = h.transform || h.webkitTransform, c.split(",").length > 6 && (c = c.split(", ").map(y => y.replace(",", ".")).join(", ")), p = new i.WebKitCSSMatrix(c === "none" ? "" : c)) : (p = h.MozTransform || h.OTransform || h.MsTransform || h.msTransform || h.transform || h.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), l = p.toString().split(",")), e === "x" && (i.WebKitCSSMatrix ? c = p.m41 : l.length === 16 ? c = parseFloat(l[12]) : c = parseFloat(l[4])), e === "y" && (i.WebKitCSSMatrix ? c = p.m42 : l.length === 16 ? c = parseFloat(l[13]) : c = parseFloat(l[5])), c || 0;
}
function hM(t) {
  return typeof t == "object" && t !== null && t.constructor && Object.prototype.toString.call(t).slice(8, -1) === "Object";
}
function Iee(t) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? t instanceof HTMLElement : t && (t.nodeType === 1 || t.nodeType === 11);
}
function rp() {
  const t = Object(arguments.length <= 0 ? void 0 : arguments[0]),
    e = ["__proto__", "constructor", "prototype"];
  for (let i = 1; i < arguments.length; i += 1) {
    const l = i < 0 || arguments.length <= i ? void 0 : arguments[i];
    if (l != null && !Iee(l)) {
      const c = Object.keys(Object(l)).filter(p => e.indexOf(p) < 0);
      for (let p = 0, h = c.length; p < h; p += 1) {
        const y = c[p],
          w = Object.getOwnPropertyDescriptor(l, y);
        w !== void 0 && w.enumerable && (hM(t[y]) && hM(l[y]) ? l[y].__swiper__ ? t[y] = l[y] : rp(t[y], l[y]) : !hM(t[y]) && hM(l[y]) ? (t[y] = {}, l[y].__swiper__ ? t[y] = l[y] : rp(t[y], l[y])) : t[y] = l[y]);
      }
    }
  }
  return t;
}
function mM(t, e, i) {
  t.style.setProperty(e, i);
}
function W4(t) {
  let {
    swiper: e,
    targetPosition: i,
    side: l
  } = t;
  const c = wl(),
    p = -e.translate;
  let h = null,
    y;
  const w = e.params.speed;
  e.wrapperEl.style.scrollSnapType = "none", c.cancelAnimationFrame(e.cssModeFrameID);
  const x = i > p ? "next" : "prev",
    E = (k, D) => x === "next" && k >= D || x === "prev" && k <= D,
    C = () => {
      y = (/* @__PURE__ */new Date()).getTime(), h === null && (h = y);
      const k = Math.max(Math.min((y - h) / w, 1), 0),
        D = 0.5 - Math.cos(k * Math.PI) / 2;
      let I = p + D * (i - p);
      if (E(I, i) && (I = i), e.wrapperEl.scrollTo({
        [l]: I
      }), E(I, i)) {
        e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
          e.wrapperEl.style.overflow = "", e.wrapperEl.scrollTo({
            [l]: I
          });
        }), c.cancelAnimationFrame(e.cssModeFrameID);
        return;
      }
      e.cssModeFrameID = c.requestAnimationFrame(C);
    };
  C();
}
function Np(t, e) {
  e === void 0 && (e = "");
  const i = wl(),
    l = [...t.children];
  return i.HTMLSlotElement && t instanceof HTMLSlotElement && l.push(...t.assignedElements()), e ? l.filter(c => c.matches(e)) : l;
}
function Mee(t, e) {
  const i = [e];
  for (; i.length > 0;) {
    const l = i.shift();
    if (t === l) return !0;
    i.push(...l.children, ...(l.shadowRoot ? l.shadowRoot.children : []), ...(l.assignedElements ? l.assignedElements() : []));
  }
}
function Oee(t, e) {
  const i = wl();
  let l = e.contains(t);
  return !l && i.HTMLSlotElement && e instanceof HTMLSlotElement && (l = [...e.assignedElements()].includes(t), l || (l = Mee(t, e))), l;
}
function xO(t) {
  try {
    console.warn(t);
    return;
  } catch {}
}
function fR(t, e) {
  e === void 0 && (e = []);
  const i = document.createElement(t);
  return i.classList.add(...(Array.isArray(e) ? e : Tee(e))), i;
}
function zj(t) {
  const e = wl(),
    i = Gm(),
    l = t.getBoundingClientRect(),
    c = i.body,
    p = t.clientTop || c.clientTop || 0,
    h = t.clientLeft || c.clientLeft || 0,
    y = t === e ? e.scrollY : t.scrollTop,
    w = t === e ? e.scrollX : t.scrollLeft;
  return {
    top: l.top + y - p,
    left: l.left + w - h
  };
}
function Lee(t, e) {
  const i = [];
  for (; t.previousElementSibling;) {
    const l = t.previousElementSibling;
    e ? l.matches(e) && i.push(l) : i.push(l), t = l;
  }
  return i;
}
function Pee(t, e) {
  const i = [];
  for (; t.nextElementSibling;) {
    const l = t.nextElementSibling;
    e ? l.matches(e) && i.push(l) : i.push(l), t = l;
  }
  return i;
}
function Z0(t, e) {
  return wl().getComputedStyle(t, null).getPropertyValue(e);
}
function pR(t) {
  let e = t,
    i;
  if (e) {
    for (i = 0; (e = e.previousSibling) !== null;) e.nodeType === 1 && (i += 1);
    return i;
  }
}
function Gx(t, e) {
  const i = [];
  let l = t.parentElement;
  for (; l;) e ? l.matches(e) && i.push(l) : i.push(l), l = l.parentElement;
  return i;
}
function Aee(t, e) {
  function i(l) {
    l.target === t && (e.call(t, l), t.removeEventListener("transitionend", i));
  }
  e && t.addEventListener("transitionend", i);
}
function Vj(t, e, i) {
  const l = wl();
  return t[e === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(l.getComputedStyle(t, null).getPropertyValue(e === "width" ? "margin-right" : "margin-top")) + parseFloat(l.getComputedStyle(t, null).getPropertyValue(e === "width" ? "margin-left" : "margin-bottom"));
}
function aa(t) {
  return (Array.isArray(t) ? t : [t]).filter(e => !!e);
}
function hR(t, e) {
  e === void 0 && (e = ""), typeof trustedTypes < "u" ? t.innerHTML = trustedTypes.createPolicy("html", {
    createHTML: i => i
  }).createHTML(e) : t.innerHTML = e;
}
function q4(t) {
  let {
    swiper: e,
    extendParams: i,
    on: l,
    emit: c
  } = t;
  const p = Gm(),
    h = wl();
  e.keyboard = {
    enabled: !1
  }, i({
    keyboard: {
      enabled: !1,
      onlyInViewport: !0,
      pageUpDown: !0
    }
  });
  function y(E) {
    if (!e.enabled) return;
    const {
      rtlTranslate: C
    } = e;
    let k = E;
    k.originalEvent && (k = k.originalEvent);
    const D = k.keyCode || k.charCode,
      I = e.params.keyboard.pageUpDown,
      O = I && D === 33,
      P = I && D === 34,
      N = D === 37,
      L = D === 39,
      F = D === 38,
      j = D === 40;
    if (!e.allowSlideNext && (e.isHorizontal() && L || e.isVertical() && j || P) || !e.allowSlidePrev && (e.isHorizontal() && N || e.isVertical() && F || O)) return !1;
    if (!(k.shiftKey || k.altKey || k.ctrlKey || k.metaKey) && !(p.activeElement && (p.activeElement.isContentEditable || p.activeElement.nodeName && (p.activeElement.nodeName.toLowerCase() === "input" || p.activeElement.nodeName.toLowerCase() === "textarea")))) {
      if (e.params.keyboard.onlyInViewport && (O || P || N || L || F || j)) {
        let V = !1;
        if (Gx(e.el, `.${e.params.slideClass}, swiper-slide`).length > 0 && Gx(e.el, `.${e.params.slideActiveClass}`).length === 0) return;
        const K = e.el,
          G = K.clientWidth,
          Q = K.clientHeight,
          te = h.innerWidth,
          ie = h.innerHeight,
          Y = zj(K);
        C && (Y.left -= K.scrollLeft);
        const ee = [[Y.left, Y.top], [Y.left + G, Y.top], [Y.left, Y.top + Q], [Y.left + G, Y.top + Q]];
        for (let oe = 0; oe < ee.length; oe += 1) {
          const ne = ee[oe];
          if (ne[0] >= 0 && ne[0] <= te && ne[1] >= 0 && ne[1] <= ie) {
            if (ne[0] === 0 && ne[1] === 0) continue;
            V = !0;
          }
        }
        if (!V) return;
      }
      e.isHorizontal() ? ((O || P || N || L) && (k.preventDefault ? k.preventDefault() : k.returnValue = !1), ((P || L) && !C || (O || N) && C) && e.slideNext(), ((O || N) && !C || (P || L) && C) && e.slidePrev()) : ((O || P || F || j) && (k.preventDefault ? k.preventDefault() : k.returnValue = !1), (P || j) && e.slideNext(), (O || F) && e.slidePrev()), c("keyPress", D);
    }
  }
  function w() {
    e.keyboard.enabled || (p.addEventListener("keydown", y), e.keyboard.enabled = !0);
  }
  function x() {
    e.keyboard.enabled && (p.removeEventListener("keydown", y), e.keyboard.enabled = !1);
  }
  l("init", () => {
    e.params.keyboard.enabled && w();
  }), l("destroy", () => {
    e.keyboard.enabled && x();
  }), Object.assign(e.keyboard, {
    enable: w,
    disable: x
  });
}
function jee(t, e, i, l) {
  return t.params.createElements && Object.keys(l).forEach(c => {
    if (!i[c] && i.auto === !0) {
      let p = Np(t.el, `.${l[c]}`)[0];
      p || (p = fR("div", l[c]), p.className = l[c], t.el.append(p)), i[c] = p, e[c] = p;
    }
  }), i;
}
function K0(t) {
  return t === void 0 && (t = ""), `.${t.trim().replace(/([\.:!+\/()[\]])/g, "\\$1").replace(/ /g, ".")}`;
}
function Y4(t) {
  let {
    swiper: e,
    extendParams: i,
    on: l,
    emit: c
  } = t;
  const p = "swiper-pagination";
  i({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: L => L,
      formatFractionTotal: L => L,
      bulletClass: `${p}-bullet`,
      bulletActiveClass: `${p}-bullet-active`,
      modifierClass: `${p}-`,
      currentClass: `${p}-current`,
      totalClass: `${p}-total`,
      hiddenClass: `${p}-hidden`,
      progressbarFillClass: `${p}-progressbar-fill`,
      progressbarOppositeClass: `${p}-progressbar-opposite`,
      clickableClass: `${p}-clickable`,
      lockClass: `${p}-lock`,
      horizontalClass: `${p}-horizontal`,
      verticalClass: `${p}-vertical`,
      paginationDisabledClass: `${p}-disabled`
    }
  }), e.pagination = {
    el: null,
    bullets: []
  };
  let h,
    y = 0;
  function w() {
    return !e.params.pagination.el || !e.pagination.el || Array.isArray(e.pagination.el) && e.pagination.el.length === 0;
  }
  function x(L, F) {
    const {
      bulletActiveClass: j
    } = e.params.pagination;
    L && (L = L[`${F === "prev" ? "previous" : "next"}ElementSibling`], L && (L.classList.add(`${j}-${F}`), L = L[`${F === "prev" ? "previous" : "next"}ElementSibling`], L && L.classList.add(`${j}-${F}-${F}`)));
  }
  function E(L, F, j) {
    if (L = L % j, F = F % j, F === L + 1) return "next";
    if (F === L - 1) return "previous";
  }
  function C(L) {
    const F = L.target.closest(K0(e.params.pagination.bulletClass));
    if (!F) return;
    L.preventDefault();
    const j = pR(F) * e.params.slidesPerGroup;
    if (e.params.loop) {
      if (e.realIndex === j) return;
      const V = E(e.realIndex, j, e.slides.length);
      V === "next" ? e.slideNext() : V === "previous" ? e.slidePrev() : e.slideToLoop(j);
    } else e.slideTo(j);
  }
  function k() {
    const L = e.rtl,
      F = e.params.pagination;
    if (w()) return;
    let j = e.pagination.el;
    j = aa(j);
    let V, K;
    const G = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
      Q = e.params.loop ? Math.ceil(G / e.params.slidesPerGroup) : e.snapGrid.length;
    if (e.params.loop ? (K = e.previousRealIndex || 0, V = e.params.slidesPerGroup > 1 ? Math.floor(e.realIndex / e.params.slidesPerGroup) : e.realIndex) : typeof e.snapIndex < "u" ? (V = e.snapIndex, K = e.previousSnapIndex) : (K = e.previousIndex || 0, V = e.activeIndex || 0), F.type === "bullets" && e.pagination.bullets && e.pagination.bullets.length > 0) {
      const te = e.pagination.bullets;
      let ie, Y, ee;
      if (F.dynamicBullets && (h = Vj(te[0], e.isHorizontal() ? "width" : "height"), j.forEach(oe => {
        oe.style[e.isHorizontal() ? "width" : "height"] = `${h * (F.dynamicMainBullets + 4)}px`;
      }), F.dynamicMainBullets > 1 && K !== void 0 && (y += V - (K || 0), y > F.dynamicMainBullets - 1 ? y = F.dynamicMainBullets - 1 : y < 0 && (y = 0)), ie = Math.max(V - y, 0), Y = ie + (Math.min(te.length, F.dynamicMainBullets) - 1), ee = (Y + ie) / 2), te.forEach(oe => {
        const ne = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map(se => `${F.bulletActiveClass}${se}`)].map(se => typeof se == "string" && se.includes(" ") ? se.split(" ") : se).flat();
        oe.classList.remove(...ne);
      }), j.length > 1) te.forEach(oe => {
        const ne = pR(oe);
        ne === V ? oe.classList.add(...F.bulletActiveClass.split(" ")) : e.isElement && oe.setAttribute("part", "bullet"), F.dynamicBullets && (ne >= ie && ne <= Y && oe.classList.add(...`${F.bulletActiveClass}-main`.split(" ")), ne === ie && x(oe, "prev"), ne === Y && x(oe, "next"));
      });else {
        const oe = te[V];
        if (oe && oe.classList.add(...F.bulletActiveClass.split(" ")), e.isElement && te.forEach((ne, se) => {
          ne.setAttribute("part", se === V ? "bullet-active" : "bullet");
        }), F.dynamicBullets) {
          const ne = te[ie],
            se = te[Y];
          for (let ue = ie; ue <= Y; ue += 1) te[ue] && te[ue].classList.add(...`${F.bulletActiveClass}-main`.split(" "));
          x(ne, "prev"), x(se, "next");
        }
      }
      if (F.dynamicBullets) {
        const oe = Math.min(te.length, F.dynamicMainBullets + 4),
          ne = (h * oe - h) / 2 - ee * h,
          se = L ? "right" : "left";
        te.forEach(ue => {
          ue.style[e.isHorizontal() ? se : "top"] = `${ne}px`;
        });
      }
    }
    j.forEach((te, ie) => {
      if (F.type === "fraction" && (te.querySelectorAll(K0(F.currentClass)).forEach(Y => {
        Y.textContent = F.formatFractionCurrent(V + 1);
      }), te.querySelectorAll(K0(F.totalClass)).forEach(Y => {
        Y.textContent = F.formatFractionTotal(Q);
      })), F.type === "progressbar") {
        let Y;
        F.progressbarOpposite ? Y = e.isHorizontal() ? "vertical" : "horizontal" : Y = e.isHorizontal() ? "horizontal" : "vertical";
        const ee = (V + 1) / Q;
        let oe = 1,
          ne = 1;
        Y === "horizontal" ? oe = ee : ne = ee, te.querySelectorAll(K0(F.progressbarFillClass)).forEach(se => {
          se.style.transform = `translate3d(0,0,0) scaleX(${oe}) scaleY(${ne})`, se.style.transitionDuration = `${e.params.speed}ms`;
        });
      }
      F.type === "custom" && F.renderCustom ? (hR(te, F.renderCustom(e, V + 1, Q)), ie === 0 && c("paginationRender", te)) : (ie === 0 && c("paginationRender", te), c("paginationUpdate", te)), e.params.watchOverflow && e.enabled && te.classList[e.isLocked ? "add" : "remove"](F.lockClass);
    });
  }
  function D() {
    const L = e.params.pagination;
    if (w()) return;
    const F = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.grid && e.params.grid.rows > 1 ? e.slides.length / Math.ceil(e.params.grid.rows) : e.slides.length;
    let j = e.pagination.el;
    j = aa(j);
    let V = "";
    if (L.type === "bullets") {
      let K = e.params.loop ? Math.ceil(F / e.params.slidesPerGroup) : e.snapGrid.length;
      e.params.freeMode && e.params.freeMode.enabled && K > F && (K = F);
      for (let G = 0; G < K; G += 1) L.renderBullet ? V += L.renderBullet.call(e, G, L.bulletClass) : V += `<${L.bulletElement} ${e.isElement ? 'part="bullet"' : ""} class="${L.bulletClass}"></${L.bulletElement}>`;
    }
    L.type === "fraction" && (L.renderFraction ? V = L.renderFraction.call(e, L.currentClass, L.totalClass) : V = `<span class="${L.currentClass}"></span> / <span class="${L.totalClass}"></span>`), L.type === "progressbar" && (L.renderProgressbar ? V = L.renderProgressbar.call(e, L.progressbarFillClass) : V = `<span class="${L.progressbarFillClass}"></span>`), e.pagination.bullets = [], j.forEach(K => {
      L.type !== "custom" && hR(K, V || ""), L.type === "bullets" && e.pagination.bullets.push(...K.querySelectorAll(K0(L.bulletClass)));
    }), L.type !== "custom" && c("paginationRender", j[0]);
  }
  function I() {
    e.params.pagination = jee(e, e.originalParams.pagination, e.params.pagination, {
      el: "swiper-pagination"
    });
    const L = e.params.pagination;
    if (!L.el) return;
    let F;
    typeof L.el == "string" && e.isElement && (F = e.el.querySelector(L.el)), !F && typeof L.el == "string" && (F = [...document.querySelectorAll(L.el)]), F || (F = L.el), !(!F || F.length === 0) && (e.params.uniqueNavElements && typeof L.el == "string" && Array.isArray(F) && F.length > 1 && (F = [...e.el.querySelectorAll(L.el)], F.length > 1 && (F = F.find(j => Gx(j, ".swiper")[0] === e.el))), Array.isArray(F) && F.length === 1 && (F = F[0]), Object.assign(e.pagination, {
      el: F
    }), F = aa(F), F.forEach(j => {
      L.type === "bullets" && L.clickable && j.classList.add(...(L.clickableClass || "").split(" ")), j.classList.add(L.modifierClass + L.type), j.classList.add(e.isHorizontal() ? L.horizontalClass : L.verticalClass), L.type === "bullets" && L.dynamicBullets && (j.classList.add(`${L.modifierClass}${L.type}-dynamic`), y = 0, L.dynamicMainBullets < 1 && (L.dynamicMainBullets = 1)), L.type === "progressbar" && L.progressbarOpposite && j.classList.add(L.progressbarOppositeClass), L.clickable && j.addEventListener("click", C), e.enabled || j.classList.add(L.lockClass);
    }));
  }
  function O() {
    const L = e.params.pagination;
    if (w()) return;
    let F = e.pagination.el;
    F && (F = aa(F), F.forEach(j => {
      j.classList.remove(L.hiddenClass), j.classList.remove(L.modifierClass + L.type), j.classList.remove(e.isHorizontal() ? L.horizontalClass : L.verticalClass), L.clickable && (j.classList.remove(...(L.clickableClass || "").split(" ")), j.removeEventListener("click", C));
    })), e.pagination.bullets && e.pagination.bullets.forEach(j => j.classList.remove(...L.bulletActiveClass.split(" ")));
  }
  l("changeDirection", () => {
    if (!e.pagination || !e.pagination.el) return;
    const L = e.params.pagination;
    let {
      el: F
    } = e.pagination;
    F = aa(F), F.forEach(j => {
      j.classList.remove(L.horizontalClass, L.verticalClass), j.classList.add(e.isHorizontal() ? L.horizontalClass : L.verticalClass);
    });
  }), l("init", () => {
    e.params.pagination.enabled === !1 ? N() : (I(), D(), k());
  }), l("activeIndexChange", () => {
    typeof e.snapIndex > "u" && k();
  }), l("snapIndexChange", () => {
    k();
  }), l("snapGridLengthChange", () => {
    D(), k();
  }), l("destroy", () => {
    O();
  }), l("enable disable", () => {
    let {
      el: L
    } = e.pagination;
    L && (L = aa(L), L.forEach(F => F.classList[e.enabled ? "remove" : "add"](e.params.pagination.lockClass)));
  }), l("lock unlock", () => {
    k();
  }), l("click", (L, F) => {
    const j = F.target,
      V = aa(e.pagination.el);
    if (e.params.pagination.el && e.params.pagination.hideOnClick && V && V.length > 0 && !j.classList.contains(e.params.pagination.bulletClass)) {
      if (e.navigation && (e.navigation.nextEl && j === e.navigation.nextEl || e.navigation.prevEl && j === e.navigation.prevEl)) return;
      const K = V[0].classList.contains(e.params.pagination.hiddenClass);
      c(K === !0 ? "paginationShow" : "paginationHide"), V.forEach(G => G.classList.toggle(e.params.pagination.hiddenClass));
    }
  });
  const P = () => {
      e.el.classList.remove(e.params.pagination.paginationDisabledClass);
      let {
        el: L
      } = e.pagination;
      L && (L = aa(L), L.forEach(F => F.classList.remove(e.params.pagination.paginationDisabledClass))), I(), D(), k();
    },
    N = () => {
      e.el.classList.add(e.params.pagination.paginationDisabledClass);
      let {
        el: L
      } = e.pagination;
      L && (L = aa(L), L.forEach(F => F.classList.add(e.params.pagination.paginationDisabledClass))), O();
    };
  Object.assign(e.pagination, {
    enable: P,
    disable: N,
    render: D,
    update: k,
    init: I,
    destroy: O
  });
}
function G4(t) {
  let {
    swiper: e,
    extendParams: i,
    on: l,
    emit: c
  } = t;
  const p = wl();
  i({
    zoom: {
      enabled: !1,
      limitToOriginalSize: !1,
      maxRatio: 3,
      minRatio: 1,
      panOnMouseMove: !1,
      toggle: !0,
      containerClass: "swiper-zoom-container",
      zoomedSlideClass: "swiper-slide-zoomed"
    }
  }), e.zoom = {
    enabled: !1
  };
  let h = 1,
    y = !1,
    w = !1,
    x = {
      x: 0,
      y: 0
    };
  const E = -3;
  let C, k;
  const D = [],
    I = {
      originX: 0,
      originY: 0,
      slideEl: void 0,
      slideWidth: void 0,
      slideHeight: void 0,
      imageEl: void 0,
      imageWrapEl: void 0,
      maxRatio: 3
    },
    O = {
      isTouched: void 0,
      isMoved: void 0,
      currentX: void 0,
      currentY: void 0,
      minX: void 0,
      minY: void 0,
      maxX: void 0,
      maxY: void 0,
      width: void 0,
      height: void 0,
      startX: void 0,
      startY: void 0,
      touchesStart: {},
      touchesCurrent: {}
    },
    P = {
      x: void 0,
      y: void 0,
      prevPositionX: void 0,
      prevPositionY: void 0,
      prevTime: void 0
    };
  let N = 1;
  Object.defineProperty(e.zoom, "scale", {
    get() {
      return N;
    },
    set(fe) {
      if (N !== fe) {
        const xe = I.imageEl,
          we = I.slideEl;
        c("zoomChange", fe, xe, we);
      }
      N = fe;
    }
  });
  function L() {
    if (D.length < 2) return 1;
    const fe = D[0].pageX,
      xe = D[0].pageY,
      we = D[1].pageX,
      ve = D[1].pageY;
    return Math.sqrt((we - fe) ** 2 + (ve - xe) ** 2);
  }
  function F() {
    const fe = e.params.zoom,
      xe = I.imageWrapEl.getAttribute("data-swiper-zoom") || fe.maxRatio;
    if (fe.limitToOriginalSize && I.imageEl && I.imageEl.naturalWidth) {
      const we = I.imageEl.naturalWidth / I.imageEl.offsetWidth;
      return Math.min(we, xe);
    }
    return xe;
  }
  function j() {
    if (D.length < 2) return {
      x: null,
      y: null
    };
    const fe = I.imageEl.getBoundingClientRect();
    return [(D[0].pageX + (D[1].pageX - D[0].pageX) / 2 - fe.x - p.scrollX) / h, (D[0].pageY + (D[1].pageY - D[0].pageY) / 2 - fe.y - p.scrollY) / h];
  }
  function V() {
    return e.isElement ? "swiper-slide" : `.${e.params.slideClass}`;
  }
  function K(fe) {
    const xe = V();
    return !!(fe.target.matches(xe) || e.slides.filter(we => we.contains(fe.target)).length > 0);
  }
  function G(fe) {
    const xe = `.${e.params.zoom.containerClass}`;
    return !!(fe.target.matches(xe) || [...e.hostEl.querySelectorAll(xe)].filter(we => we.contains(fe.target)).length > 0);
  }
  function Q(fe) {
    if (fe.pointerType === "mouse" && D.splice(0, D.length), !K(fe)) return;
    const xe = e.params.zoom;
    if (C = !1, k = !1, D.push(fe), !(D.length < 2)) {
      if (C = !0, I.scaleStart = L(), !I.slideEl) {
        I.slideEl = fe.target.closest(`.${e.params.slideClass}, swiper-slide`), I.slideEl || (I.slideEl = e.slides[e.activeIndex]);
        let we = I.slideEl.querySelector(`.${xe.containerClass}`);
        if (we && (we = we.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), I.imageEl = we, we ? I.imageWrapEl = Gx(I.imageEl, `.${xe.containerClass}`)[0] : I.imageWrapEl = void 0, !I.imageWrapEl) {
          I.imageEl = void 0;
          return;
        }
        I.maxRatio = F();
      }
      if (I.imageEl) {
        const [we, ve] = j();
        I.originX = we, I.originY = ve, I.imageEl.style.transitionDuration = "0ms";
      }
      y = !0;
    }
  }
  function te(fe) {
    if (!K(fe)) return;
    const xe = e.params.zoom,
      we = e.zoom,
      ve = D.findIndex(Te => Te.pointerId === fe.pointerId);
    ve >= 0 && (D[ve] = fe), !(D.length < 2) && (k = !0, I.scaleMove = L(), I.imageEl && (we.scale = I.scaleMove / I.scaleStart * h, we.scale > I.maxRatio && (we.scale = I.maxRatio - 1 + (we.scale - I.maxRatio + 1) ** 0.5), we.scale < xe.minRatio && (we.scale = xe.minRatio + 1 - (xe.minRatio - we.scale + 1) ** 0.5), I.imageEl.style.transform = `translate3d(0,0,0) scale(${we.scale})`));
  }
  function ie(fe) {
    if (!K(fe) || fe.pointerType === "mouse" && fe.type === "pointerout") return;
    const xe = e.params.zoom,
      we = e.zoom,
      ve = D.findIndex(Te => Te.pointerId === fe.pointerId);
    ve >= 0 && D.splice(ve, 1), !(!C || !k) && (C = !1, k = !1, I.imageEl && (we.scale = Math.max(Math.min(we.scale, I.maxRatio), xe.minRatio), I.imageEl.style.transitionDuration = `${e.params.speed}ms`, I.imageEl.style.transform = `translate3d(0,0,0) scale(${we.scale})`, h = we.scale, y = !1, we.scale > 1 && I.slideEl ? I.slideEl.classList.add(`${xe.zoomedSlideClass}`) : we.scale <= 1 && I.slideEl && I.slideEl.classList.remove(`${xe.zoomedSlideClass}`), we.scale === 1 && (I.originX = 0, I.originY = 0, I.slideEl = void 0)));
  }
  let Y;
  function ee() {
    e.touchEventsData.preventTouchMoveFromPointerMove = !1;
  }
  function oe() {
    clearTimeout(Y), e.touchEventsData.preventTouchMoveFromPointerMove = !0, Y = setTimeout(() => {
      e.destroyed || ee();
    });
  }
  function ne(fe) {
    const xe = e.device;
    if (!I.imageEl || O.isTouched) return;
    xe.android && fe.cancelable && fe.preventDefault(), O.isTouched = !0;
    const we = D.length > 0 ? D[0] : fe;
    O.touchesStart.x = we.pageX, O.touchesStart.y = we.pageY;
  }
  function se(fe) {
    const we = fe.pointerType === "mouse" && e.params.zoom.panOnMouseMove;
    if (!K(fe) || !G(fe)) return;
    const ve = e.zoom;
    if (!I.imageEl) return;
    if (!O.isTouched || !I.slideEl) {
      we && $(fe);
      return;
    }
    if (we) {
      $(fe);
      return;
    }
    O.isMoved || (O.width = I.imageEl.offsetWidth || I.imageEl.clientWidth, O.height = I.imageEl.offsetHeight || I.imageEl.clientHeight, O.startX = Nj(I.imageWrapEl, "x") || 0, O.startY = Nj(I.imageWrapEl, "y") || 0, I.slideWidth = I.slideEl.offsetWidth, I.slideHeight = I.slideEl.offsetHeight, I.imageWrapEl.style.transitionDuration = "0ms");
    const Te = O.width * ve.scale,
      ze = O.height * ve.scale;
    if (O.minX = Math.min(I.slideWidth / 2 - Te / 2, 0), O.maxX = -O.minX, O.minY = Math.min(I.slideHeight / 2 - ze / 2, 0), O.maxY = -O.minY, O.touchesCurrent.x = D.length > 0 ? D[0].pageX : fe.pageX, O.touchesCurrent.y = D.length > 0 ? D[0].pageY : fe.pageY, Math.max(Math.abs(O.touchesCurrent.x - O.touchesStart.x), Math.abs(O.touchesCurrent.y - O.touchesStart.y)) > 5 && (e.allowClick = !1), !O.isMoved && !y) {
      if (e.isHorizontal() && (Math.floor(O.minX) === Math.floor(O.startX) && O.touchesCurrent.x < O.touchesStart.x || Math.floor(O.maxX) === Math.floor(O.startX) && O.touchesCurrent.x > O.touchesStart.x)) {
        O.isTouched = !1, ee();
        return;
      }
      if (!e.isHorizontal() && (Math.floor(O.minY) === Math.floor(O.startY) && O.touchesCurrent.y < O.touchesStart.y || Math.floor(O.maxY) === Math.floor(O.startY) && O.touchesCurrent.y > O.touchesStart.y)) {
        O.isTouched = !1, ee();
        return;
      }
    }
    fe.cancelable && fe.preventDefault(), fe.stopPropagation(), oe(), O.isMoved = !0;
    const ye = (ve.scale - h) / (I.maxRatio - e.params.zoom.minRatio),
      {
        originX: qe,
        originY: Ae
      } = I;
    O.currentX = O.touchesCurrent.x - O.touchesStart.x + O.startX + ye * (O.width - qe * 2), O.currentY = O.touchesCurrent.y - O.touchesStart.y + O.startY + ye * (O.height - Ae * 2), O.currentX < O.minX && (O.currentX = O.minX + 1 - (O.minX - O.currentX + 1) ** 0.8), O.currentX > O.maxX && (O.currentX = O.maxX - 1 + (O.currentX - O.maxX + 1) ** 0.8), O.currentY < O.minY && (O.currentY = O.minY + 1 - (O.minY - O.currentY + 1) ** 0.8), O.currentY > O.maxY && (O.currentY = O.maxY - 1 + (O.currentY - O.maxY + 1) ** 0.8), P.prevPositionX || (P.prevPositionX = O.touchesCurrent.x), P.prevPositionY || (P.prevPositionY = O.touchesCurrent.y), P.prevTime || (P.prevTime = Date.now()), P.x = (O.touchesCurrent.x - P.prevPositionX) / (Date.now() - P.prevTime) / 2, P.y = (O.touchesCurrent.y - P.prevPositionY) / (Date.now() - P.prevTime) / 2, Math.abs(O.touchesCurrent.x - P.prevPositionX) < 2 && (P.x = 0), Math.abs(O.touchesCurrent.y - P.prevPositionY) < 2 && (P.y = 0), P.prevPositionX = O.touchesCurrent.x, P.prevPositionY = O.touchesCurrent.y, P.prevTime = Date.now(), I.imageWrapEl.style.transform = `translate3d(${O.currentX}px, ${O.currentY}px,0)`;
  }
  function ue() {
    const fe = e.zoom;
    if (D.length = 0, !I.imageEl) return;
    if (!O.isTouched || !O.isMoved) {
      O.isTouched = !1, O.isMoved = !1;
      return;
    }
    O.isTouched = !1, O.isMoved = !1;
    let xe = 300,
      we = 300;
    const ve = P.x * xe,
      Te = O.currentX + ve,
      ze = P.y * we,
      Xe = O.currentY + ze;
    P.x !== 0 && (xe = Math.abs((Te - O.currentX) / P.x)), P.y !== 0 && (we = Math.abs((Xe - O.currentY) / P.y));
    const ye = Math.max(xe, we);
    O.currentX = Te, O.currentY = Xe;
    const qe = O.width * fe.scale,
      Ae = O.height * fe.scale;
    O.minX = Math.min(I.slideWidth / 2 - qe / 2, 0), O.maxX = -O.minX, O.minY = Math.min(I.slideHeight / 2 - Ae / 2, 0), O.maxY = -O.minY, O.currentX = Math.max(Math.min(O.currentX, O.maxX), O.minX), O.currentY = Math.max(Math.min(O.currentY, O.maxY), O.minY), I.imageWrapEl.style.transitionDuration = `${ye}ms`, I.imageWrapEl.style.transform = `translate3d(${O.currentX}px, ${O.currentY}px,0)`;
  }
  function W() {
    const fe = e.zoom;
    I.slideEl && e.activeIndex !== e.slides.indexOf(I.slideEl) && (I.imageEl && (I.imageEl.style.transform = "translate3d(0,0,0) scale(1)"), I.imageWrapEl && (I.imageWrapEl.style.transform = "translate3d(0,0,0)"), I.slideEl.classList.remove(`${e.params.zoom.zoomedSlideClass}`), fe.scale = 1, h = 1, I.slideEl = void 0, I.imageEl = void 0, I.imageWrapEl = void 0, I.originX = 0, I.originY = 0);
  }
  function $(fe) {
    if (h <= 1 || !I.imageWrapEl || !K(fe) || !G(fe)) return;
    const xe = p.getComputedStyle(I.imageWrapEl).transform,
      we = new p.DOMMatrix(xe);
    if (!w) {
      w = !0, x.x = fe.clientX, x.y = fe.clientY, O.startX = we.e, O.startY = we.f, O.width = I.imageEl.offsetWidth || I.imageEl.clientWidth, O.height = I.imageEl.offsetHeight || I.imageEl.clientHeight, I.slideWidth = I.slideEl.offsetWidth, I.slideHeight = I.slideEl.offsetHeight;
      return;
    }
    const ve = (fe.clientX - x.x) * E,
      Te = (fe.clientY - x.y) * E,
      ze = O.width * h,
      Xe = O.height * h,
      ye = I.slideWidth,
      qe = I.slideHeight,
      Ae = Math.min(ye / 2 - ze / 2, 0),
      Mt = -Ae,
      Ft = Math.min(qe / 2 - Xe / 2, 0),
      un = -Ft,
      gt = Math.max(Math.min(O.startX + ve, Mt), Ae),
      Pt = Math.max(Math.min(O.startY + Te, un), Ft);
    I.imageWrapEl.style.transitionDuration = "0ms", I.imageWrapEl.style.transform = `translate3d(${gt}px, ${Pt}px, 0)`, x.x = fe.clientX, x.y = fe.clientY, O.startX = gt, O.startY = Pt, O.currentX = gt, O.currentY = Pt;
  }
  function le(fe) {
    const xe = e.zoom,
      we = e.params.zoom;
    if (!I.slideEl) {
      fe && fe.target && (I.slideEl = fe.target.closest(`.${e.params.slideClass}, swiper-slide`)), I.slideEl || (e.params.virtual && e.params.virtual.enabled && e.virtual ? I.slideEl = Np(e.slidesEl, `.${e.params.slideActiveClass}`)[0] : I.slideEl = e.slides[e.activeIndex]);
      let ot = I.slideEl.querySelector(`.${we.containerClass}`);
      ot && (ot = ot.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), I.imageEl = ot, ot ? I.imageWrapEl = Gx(I.imageEl, `.${we.containerClass}`)[0] : I.imageWrapEl = void 0;
    }
    if (!I.imageEl || !I.imageWrapEl) return;
    e.params.cssMode && (e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.touchAction = "none"), I.slideEl.classList.add(`${we.zoomedSlideClass}`);
    let ve, Te, ze, Xe, ye, qe, Ae, Mt, Ft, un, gt, Pt, St, Dt, Kt, hn, Ot, Et;
    typeof O.touchesStart.x > "u" && fe ? (ve = fe.pageX, Te = fe.pageY) : (ve = O.touchesStart.x, Te = O.touchesStart.y);
    const Vt = h,
      Xt = typeof fe == "number" ? fe : null;
    h === 1 && Xt && (ve = void 0, Te = void 0, O.touchesStart.x = void 0, O.touchesStart.y = void 0);
    const vn = F();
    xe.scale = Xt || vn, h = Xt || vn, fe && !(h === 1 && Xt) ? (Ot = I.slideEl.offsetWidth, Et = I.slideEl.offsetHeight, ze = zj(I.slideEl).left + p.scrollX, Xe = zj(I.slideEl).top + p.scrollY, ye = ze + Ot / 2 - ve, qe = Xe + Et / 2 - Te, Ft = I.imageEl.offsetWidth || I.imageEl.clientWidth, un = I.imageEl.offsetHeight || I.imageEl.clientHeight, gt = Ft * xe.scale, Pt = un * xe.scale, St = Math.min(Ot / 2 - gt / 2, 0), Dt = Math.min(Et / 2 - Pt / 2, 0), Kt = -St, hn = -Dt, Vt > 0 && Xt && typeof O.currentX == "number" && typeof O.currentY == "number" ? (Ae = O.currentX * xe.scale / Vt, Mt = O.currentY * xe.scale / Vt) : (Ae = ye * xe.scale, Mt = qe * xe.scale), Ae < St && (Ae = St), Ae > Kt && (Ae = Kt), Mt < Dt && (Mt = Dt), Mt > hn && (Mt = hn)) : (Ae = 0, Mt = 0), Xt && xe.scale === 1 && (I.originX = 0, I.originY = 0), O.currentX = Ae, O.currentY = Mt, I.imageWrapEl.style.transitionDuration = "300ms", I.imageWrapEl.style.transform = `translate3d(${Ae}px, ${Mt}px,0)`, I.imageEl.style.transitionDuration = "300ms", I.imageEl.style.transform = `translate3d(0,0,0) scale(${xe.scale})`;
  }
  function H() {
    const fe = e.zoom,
      xe = e.params.zoom;
    if (!I.slideEl) {
      e.params.virtual && e.params.virtual.enabled && e.virtual ? I.slideEl = Np(e.slidesEl, `.${e.params.slideActiveClass}`)[0] : I.slideEl = e.slides[e.activeIndex];
      let we = I.slideEl.querySelector(`.${xe.containerClass}`);
      we && (we = we.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), I.imageEl = we, we ? I.imageWrapEl = Gx(I.imageEl, `.${xe.containerClass}`)[0] : I.imageWrapEl = void 0;
    }
    !I.imageEl || !I.imageWrapEl || (e.params.cssMode && (e.wrapperEl.style.overflow = "", e.wrapperEl.style.touchAction = ""), fe.scale = 1, h = 1, O.currentX = void 0, O.currentY = void 0, O.touchesStart.x = void 0, O.touchesStart.y = void 0, I.imageWrapEl.style.transitionDuration = "300ms", I.imageWrapEl.style.transform = "translate3d(0,0,0)", I.imageEl.style.transitionDuration = "300ms", I.imageEl.style.transform = "translate3d(0,0,0) scale(1)", I.slideEl.classList.remove(`${xe.zoomedSlideClass}`), I.slideEl = void 0, I.originX = 0, I.originY = 0, e.params.zoom.panOnMouseMove && (x = {
      x: 0,
      y: 0
    }, w && (w = !1, O.startX = 0, O.startY = 0)));
  }
  function ce(fe) {
    const xe = e.zoom;
    xe.scale && xe.scale !== 1 ? H() : le(fe);
  }
  function de() {
    const fe = e.params.passiveListeners ? {
        passive: !0,
        capture: !1
      } : !1,
      xe = e.params.passiveListeners ? {
        passive: !1,
        capture: !0
      } : !0;
    return {
      passiveListener: fe,
      activeListenerWithCapture: xe
    };
  }
  function Ce() {
    const fe = e.zoom;
    if (fe.enabled) return;
    fe.enabled = !0;
    const {
      passiveListener: xe,
      activeListenerWithCapture: we
    } = de();
    e.wrapperEl.addEventListener("pointerdown", Q, xe), e.wrapperEl.addEventListener("pointermove", te, we), ["pointerup", "pointercancel", "pointerout"].forEach(ve => {
      e.wrapperEl.addEventListener(ve, ie, xe);
    }), e.wrapperEl.addEventListener("pointermove", se, we);
  }
  function Ee() {
    const fe = e.zoom;
    if (!fe.enabled) return;
    fe.enabled = !1;
    const {
      passiveListener: xe,
      activeListenerWithCapture: we
    } = de();
    e.wrapperEl.removeEventListener("pointerdown", Q, xe), e.wrapperEl.removeEventListener("pointermove", te, we), ["pointerup", "pointercancel", "pointerout"].forEach(ve => {
      e.wrapperEl.removeEventListener(ve, ie, xe);
    }), e.wrapperEl.removeEventListener("pointermove", se, we);
  }
  l("init", () => {
    e.params.zoom.enabled && Ce();
  }), l("destroy", () => {
    Ee();
  }), l("touchStart", (fe, xe) => {
    e.zoom.enabled && ne(xe);
  }), l("touchEnd", (fe, xe) => {
    e.zoom.enabled && ue();
  }), l("doubleTap", (fe, xe) => {
    !e.animating && e.params.zoom.enabled && e.zoom.enabled && e.params.zoom.toggle && ce(xe);
  }), l("transitionEnd", () => {
    e.zoom.enabled && e.params.zoom.enabled && W();
  }), l("slideChange", () => {
    e.zoom.enabled && e.params.zoom.enabled && e.params.cssMode && W();
  }), Object.assign(e.zoom, {
    enable: Ce,
    disable: Ee,
    in: le,
    out: H,
    toggle: ce
  });
}
function X4(t) {
  let {
    swiper: e,
    extendParams: i,
    on: l
  } = t;
  i({
    controller: {
      control: void 0,
      inverse: !1,
      by: "slide"
      // or 'container'
    }
  }), e.controller = {
    control: void 0
  };
  function c(x, E) {
    const C = /* @__PURE__ */function () {
      let O, P, N;
      return (L, F) => {
        for (P = -1, O = L.length; O - P > 1;) N = O + P >> 1, L[N] <= F ? P = N : O = N;
        return O;
      };
    }();
    this.x = x, this.y = E, this.lastIndex = x.length - 1;
    let k, D;
    return this.interpolate = function (O) {
      return O ? (D = C(this.x, O), k = D - 1, (O - this.x[k]) * (this.y[D] - this.y[k]) / (this.x[D] - this.x[k]) + this.y[k]) : 0;
    }, this;
  }
  function p(x) {
    e.controller.spline = e.params.loop ? new c(e.slidesGrid, x.slidesGrid) : new c(e.snapGrid, x.snapGrid);
  }
  function h(x, E) {
    const C = e.controller.control;
    let k, D;
    const I = e.constructor;
    function O(P) {
      if (P.destroyed) return;
      const N = e.rtlTranslate ? -e.translate : e.translate;
      e.params.controller.by === "slide" && (p(P), D = -e.controller.spline.interpolate(-N)), (!D || e.params.controller.by === "container") && (k = (P.maxTranslate() - P.minTranslate()) / (e.maxTranslate() - e.minTranslate()), (Number.isNaN(k) || !Number.isFinite(k)) && (k = 1), D = (N - e.minTranslate()) * k + P.minTranslate()), e.params.controller.inverse && (D = P.maxTranslate() - D), P.updateProgress(D), P.setTranslate(D, e), P.updateActiveIndex(), P.updateSlidesClasses();
    }
    if (Array.isArray(C)) for (let P = 0; P < C.length; P += 1) C[P] !== E && C[P] instanceof I && O(C[P]);else C instanceof I && E !== C && O(C);
  }
  function y(x, E) {
    const C = e.constructor,
      k = e.controller.control;
    let D;
    function I(O) {
      O.destroyed || (O.setTransition(x, e), x !== 0 && (O.transitionStart(), O.params.autoHeight && kN(() => {
        O.updateAutoHeight();
      }), Aee(O.wrapperEl, () => {
        k && O.transitionEnd();
      })));
    }
    if (Array.isArray(k)) for (D = 0; D < k.length; D += 1) k[D] !== E && k[D] instanceof C && I(k[D]);else k instanceof C && E !== k && I(k);
  }
  function w() {
    e.controller.control && e.controller.spline && (e.controller.spline = void 0, delete e.controller.spline);
  }
  l("beforeInit", () => {
    if (typeof window < "u" && (
    // eslint-disable-line
    typeof e.params.controller.control == "string" || e.params.controller.control instanceof HTMLElement)) {
      (typeof e.params.controller.control == "string" ? [...document.querySelectorAll(e.params.controller.control)] : [e.params.controller.control]).forEach(E => {
        if (e.controller.control || (e.controller.control = []), E && E.swiper) e.controller.control.push(E.swiper);else if (E) {
          const C = `${e.params.eventsPrefix}init`,
            k = D => {
              e.controller.control.push(D.detail[0]), e.update(), E.removeEventListener(C, k);
            };
          E.addEventListener(C, k);
        }
      });
      return;
    }
    e.controller.control = e.params.controller.control;
  }), l("update", () => {
    w();
  }), l("resize", () => {
    w();
  }), l("observerUpdate", () => {
    w();
  }), l("setTranslate", (x, E, C) => {
    !e.controller.control || e.controller.control.destroyed || e.controller.setTranslate(E, C);
  }), l("setTransition", (x, E, C) => {
    !e.controller.control || e.controller.control.destroyed || e.controller.setTransition(E, C);
  }), Object.assign(e.controller, {
    setTranslate: h,
    setTransition: y
  });
}
function K4(t) {
  let {
    swiper: e,
    extendParams: i,
    on: l
  } = t;
  i({
    a11y: {
      enabled: !0,
      notificationClass: "swiper-notification",
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
      firstSlideMessage: "This is the first slide",
      lastSlideMessage: "This is the last slide",
      paginationBulletMessage: "Go to slide {{index}}",
      slideLabelMessage: "{{index}} / {{slidesLength}}",
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      containerRole: null,
      itemRoleDescriptionMessage: null,
      slideRole: "group",
      id: null,
      scrollOnFocus: !0
    }
  }), e.a11y = {
    clicked: !1
  };
  let c = null,
    p,
    h,
    y = (/* @__PURE__ */new Date()).getTime();
  function w(W) {
    const $ = c;
    $.length !== 0 && hR($, W);
  }
  function x(W) {
    const $ = () => Math.round(16 * Math.random()).toString(16);
    return "x".repeat(W).replace(/x/g, $);
  }
  function E(W) {
    W = aa(W), W.forEach($ => {
      $.setAttribute("tabIndex", "0");
    });
  }
  function C(W) {
    W = aa(W), W.forEach($ => {
      $.setAttribute("tabIndex", "-1");
    });
  }
  function k(W, $) {
    W = aa(W), W.forEach(le => {
      le.setAttribute("role", $);
    });
  }
  function D(W, $) {
    W = aa(W), W.forEach(le => {
      le.setAttribute("aria-roledescription", $);
    });
  }
  function I(W, $) {
    W = aa(W), W.forEach(le => {
      le.setAttribute("aria-controls", $);
    });
  }
  function O(W, $) {
    W = aa(W), W.forEach(le => {
      le.setAttribute("aria-label", $);
    });
  }
  function P(W, $) {
    W = aa(W), W.forEach(le => {
      le.setAttribute("id", $);
    });
  }
  function N(W, $) {
    W = aa(W), W.forEach(le => {
      le.setAttribute("aria-live", $);
    });
  }
  function L(W) {
    W = aa(W), W.forEach($ => {
      $.setAttribute("aria-disabled", !0);
    });
  }
  function F(W) {
    W = aa(W), W.forEach($ => {
      $.setAttribute("aria-disabled", !1);
    });
  }
  function j(W) {
    if (W.keyCode !== 13 && W.keyCode !== 32) return;
    const $ = e.params.a11y,
      le = W.target;
    if (!(e.pagination && e.pagination.el && (le === e.pagination.el || e.pagination.el.contains(W.target)) && !W.target.matches(K0(e.params.pagination.bulletClass)))) {
      if (e.navigation && e.navigation.prevEl && e.navigation.nextEl) {
        const H = aa(e.navigation.prevEl);
        aa(e.navigation.nextEl).includes(le) && (e.isEnd && !e.params.loop || e.slideNext(), e.isEnd ? w($.lastSlideMessage) : w($.nextSlideMessage)), H.includes(le) && (e.isBeginning && !e.params.loop || e.slidePrev(), e.isBeginning ? w($.firstSlideMessage) : w($.prevSlideMessage));
      }
      e.pagination && le.matches(K0(e.params.pagination.bulletClass)) && le.click();
    }
  }
  function V() {
    if (e.params.loop || e.params.rewind || !e.navigation) return;
    const {
      nextEl: W,
      prevEl: $
    } = e.navigation;
    $ && (e.isBeginning ? (L($), C($)) : (F($), E($))), W && (e.isEnd ? (L(W), C(W)) : (F(W), E(W)));
  }
  function K() {
    return e.pagination && e.pagination.bullets && e.pagination.bullets.length;
  }
  function G() {
    return K() && e.params.pagination.clickable;
  }
  function Q() {
    const W = e.params.a11y;
    K() && e.pagination.bullets.forEach($ => {
      e.params.pagination.clickable && (E($), e.params.pagination.renderBullet || (k($, "button"), O($, W.paginationBulletMessage.replace(/\{\{index\}\}/, pR($) + 1)))), $.matches(K0(e.params.pagination.bulletActiveClass)) ? $.setAttribute("aria-current", "true") : $.removeAttribute("aria-current");
    });
  }
  const te = (W, $, le) => {
      E(W), W.tagName !== "BUTTON" && (k(W, "button"), W.addEventListener("keydown", j)), O(W, le), I(W, $);
    },
    ie = W => {
      h && h !== W.target && !h.contains(W.target) && (p = !0), e.a11y.clicked = !0;
    },
    Y = () => {
      p = !1, requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          e.destroyed || (e.a11y.clicked = !1);
        });
      });
    },
    ee = W => {
      y = (/* @__PURE__ */new Date()).getTime();
    },
    oe = W => {
      if (e.a11y.clicked || !e.params.a11y.scrollOnFocus || (/* @__PURE__ */new Date()).getTime() - y < 100) return;
      const $ = W.target.closest(`.${e.params.slideClass}, swiper-slide`);
      if (!$ || !e.slides.includes($)) return;
      h = $;
      const le = e.slides.indexOf($) === e.activeIndex,
        H = e.params.watchSlidesProgress && e.visibleSlides && e.visibleSlides.includes($);
      le || H || W.sourceCapabilities && W.sourceCapabilities.firesTouchEvents || (e.isHorizontal() ? e.el.scrollLeft = 0 : e.el.scrollTop = 0, requestAnimationFrame(() => {
        p || (e.params.loop ? e.slideToLoop(e.getSlideIndexWhenGrid(parseInt($.getAttribute("data-swiper-slide-index"))), 0) : e.slideTo(e.getSlideIndexWhenGrid(e.slides.indexOf($)), 0), p = !1);
      }));
    },
    ne = () => {
      const W = e.params.a11y;
      W.itemRoleDescriptionMessage && D(e.slides, W.itemRoleDescriptionMessage), W.slideRole && k(e.slides, W.slideRole);
      const $ = e.slides.length;
      W.slideLabelMessage && e.slides.forEach((le, H) => {
        const ce = e.params.loop ? parseInt(le.getAttribute("data-swiper-slide-index"), 10) : H,
          de = W.slideLabelMessage.replace(/\{\{index\}\}/, ce + 1).replace(/\{\{slidesLength\}\}/, $);
        O(le, de);
      });
    },
    se = () => {
      const W = e.params.a11y;
      e.el.append(c);
      const $ = e.el;
      W.containerRoleDescriptionMessage && D($, W.containerRoleDescriptionMessage), W.containerMessage && O($, W.containerMessage), W.containerRole && k($, W.containerRole);
      const le = e.wrapperEl,
        H = W.id || le.getAttribute("id") || `swiper-wrapper-${x(16)}`,
        ce = e.params.autoplay && e.params.autoplay.enabled ? "off" : "polite";
      P(le, H), N(le, ce), ne();
      let {
        nextEl: de,
        prevEl: Ce
      } = e.navigation ? e.navigation : {};
      de = aa(de), Ce = aa(Ce), de && de.forEach(fe => te(fe, H, W.nextSlideMessage)), Ce && Ce.forEach(fe => te(fe, H, W.prevSlideMessage)), G() && aa(e.pagination.el).forEach(xe => {
        xe.addEventListener("keydown", j);
      }), Gm().addEventListener("visibilitychange", ee), e.el.addEventListener("focus", oe, !0), e.el.addEventListener("focus", oe, !0), e.el.addEventListener("pointerdown", ie, !0), e.el.addEventListener("pointerup", Y, !0);
    };
  function ue() {
    c && c.remove();
    let {
      nextEl: W,
      prevEl: $
    } = e.navigation ? e.navigation : {};
    W = aa(W), $ = aa($), W && W.forEach(H => H.removeEventListener("keydown", j)), $ && $.forEach(H => H.removeEventListener("keydown", j)), G() && aa(e.pagination.el).forEach(ce => {
      ce.removeEventListener("keydown", j);
    }), Gm().removeEventListener("visibilitychange", ee), e.el && typeof e.el != "string" && (e.el.removeEventListener("focus", oe, !0), e.el.removeEventListener("pointerdown", ie, !0), e.el.removeEventListener("pointerup", Y, !0));
  }
  l("beforeInit", () => {
    c = fR("span", e.params.a11y.notificationClass), c.setAttribute("aria-live", "assertive"), c.setAttribute("aria-atomic", "true");
  }), l("afterInit", () => {
    e.params.a11y.enabled && se();
  }), l("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
    e.params.a11y.enabled && ne();
  }), l("fromEdge toEdge afterInit lock unlock", () => {
    e.params.a11y.enabled && V();
  }), l("paginationUpdate", () => {
    e.params.a11y.enabled && Q();
  }), l("destroy", () => {
    e.params.a11y.enabled && ue();
  });
}
let C2;
function Fee() {
  const t = wl(),
    e = Gm();
  return {
    smoothScroll: e.documentElement && e.documentElement.style && "scrollBehavior" in e.documentElement.style,
    touch: !!("ontouchstart" in t || t.DocumentTouch && e instanceof t.DocumentTouch)
  };
}
function Q4() {
  return C2 || (C2 = Fee()), C2;
}
let k2;
function Nee(t) {
  let {
    userAgent: e
  } = t === void 0 ? {} : t;
  const i = Q4(),
    l = wl(),
    c = l.navigator.platform,
    p = e || l.navigator.userAgent,
    h = {
      ios: !1,
      android: !1
    },
    y = l.screen.width,
    w = l.screen.height,
    x = p.match(/(Android);?[\s\/]+([\d.]+)?/);
  let E = p.match(/(iPad).*OS\s([\d_]+)/);
  const C = p.match(/(iPod)(.*OS\s([\d_]+))?/),
    k = !E && p.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
    D = c === "Win32";
  let I = c === "MacIntel";
  const O = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !E && I && i.touch && O.indexOf(`${y}x${w}`) >= 0 && (E = p.match(/(Version)\/([\d.]+)/), E || (E = [0, 1, "13_0_0"]), I = !1), x && !D && (h.os = "android", h.android = !0), (E || k || C) && (h.os = "ios", h.ios = !0), h;
}
function Z4(t) {
  return t === void 0 && (t = {}), k2 || (k2 = Nee(t)), k2;
}
let T2;
function zee() {
  const t = wl(),
    e = Z4();
  let i = !1;
  function l() {
    const y = t.navigator.userAgent.toLowerCase();
    return y.indexOf("safari") >= 0 && y.indexOf("chrome") < 0 && y.indexOf("android") < 0;
  }
  if (l()) {
    const y = String(t.navigator.userAgent);
    if (y.includes("Version/")) {
      const [w, x] = y.split("Version/")[1].split(" ")[0].split(".").map(E => Number(E));
      i = w < 16 || w === 16 && x < 2;
    }
  }
  const c = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent),
    p = l(),
    h = p || c && e.ios;
  return {
    isSafari: i || p,
    needPerspectiveFix: i,
    need3dFix: h,
    isWebView: c
  };
}
function J4() {
  return T2 || (T2 = zee()), T2;
}
function Vee(t) {
  let {
    swiper: e,
    on: i,
    emit: l
  } = t;
  const c = wl();
  let p = null,
    h = null;
  const y = () => {
      !e || e.destroyed || !e.initialized || (l("beforeResize"), l("resize"));
    },
    w = () => {
      !e || e.destroyed || !e.initialized || (p = new ResizeObserver(C => {
        h = c.requestAnimationFrame(() => {
          const {
            width: k,
            height: D
          } = e;
          let I = k,
            O = D;
          C.forEach(P => {
            let {
              contentBoxSize: N,
              contentRect: L,
              target: F
            } = P;
            F && F !== e.el || (I = L ? L.width : (N[0] || N).inlineSize, O = L ? L.height : (N[0] || N).blockSize);
          }), (I !== k || O !== D) && y();
        });
      }), p.observe(e.el));
    },
    x = () => {
      h && c.cancelAnimationFrame(h), p && p.unobserve && e.el && (p.unobserve(e.el), p = null);
    },
    E = () => {
      !e || e.destroyed || !e.initialized || l("orientationchange");
    };
  i("init", () => {
    if (e.params.resizeObserver && typeof c.ResizeObserver < "u") {
      w();
      return;
    }
    c.addEventListener("resize", y), c.addEventListener("orientationchange", E);
  }), i("destroy", () => {
    x(), c.removeEventListener("resize", y), c.removeEventListener("orientationchange", E);
  });
}
function Bee(t) {
  let {
    swiper: e,
    extendParams: i,
    on: l,
    emit: c
  } = t;
  const p = [],
    h = wl(),
    y = function (E, C) {
      C === void 0 && (C = {});
      const k = h.MutationObserver || h.WebkitMutationObserver,
        D = new k(I => {
          if (e.__preventObserver__) return;
          if (I.length === 1) {
            c("observerUpdate", I[0]);
            return;
          }
          const O = function () {
            c("observerUpdate", I[0]);
          };
          h.requestAnimationFrame ? h.requestAnimationFrame(O) : h.setTimeout(O, 0);
        });
      D.observe(E, {
        attributes: typeof C.attributes > "u" ? !0 : C.attributes,
        childList: e.isElement || (typeof C.childList > "u" ? !0 : C).childList,
        characterData: typeof C.characterData > "u" ? !0 : C.characterData
      }), p.push(D);
    },
    w = () => {
      if (e.params.observer) {
        if (e.params.observeParents) {
          const E = Gx(e.hostEl);
          for (let C = 0; C < E.length; C += 1) y(E[C]);
        }
        y(e.hostEl, {
          childList: e.params.observeSlideChildren
        }), y(e.wrapperEl, {
          attributes: !1
        });
      }
    },
    x = () => {
      p.forEach(E => {
        E.disconnect();
      }), p.splice(0, p.length);
    };
  i({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), l("init", w), l("destroy", x);
}
var Uee = {
  on(t, e, i) {
    const l = this;
    if (!l.eventsListeners || l.destroyed || typeof e != "function") return l;
    const c = i ? "unshift" : "push";
    return t.split(" ").forEach(p => {
      l.eventsListeners[p] || (l.eventsListeners[p] = []), l.eventsListeners[p][c](e);
    }), l;
  },
  once(t, e, i) {
    const l = this;
    if (!l.eventsListeners || l.destroyed || typeof e != "function") return l;
    function c() {
      l.off(t, c), c.__emitterProxy && delete c.__emitterProxy;
      for (var p = arguments.length, h = new Array(p), y = 0; y < p; y++) h[y] = arguments[y];
      e.apply(l, h);
    }
    return c.__emitterProxy = e, l.on(t, c, i);
  },
  onAny(t, e) {
    const i = this;
    if (!i.eventsListeners || i.destroyed || typeof t != "function") return i;
    const l = e ? "unshift" : "push";
    return i.eventsAnyListeners.indexOf(t) < 0 && i.eventsAnyListeners[l](t), i;
  },
  offAny(t) {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsAnyListeners) return e;
    const i = e.eventsAnyListeners.indexOf(t);
    return i >= 0 && e.eventsAnyListeners.splice(i, 1), e;
  },
  off(t, e) {
    const i = this;
    return !i.eventsListeners || i.destroyed || !i.eventsListeners || t.split(" ").forEach(l => {
      typeof e > "u" ? i.eventsListeners[l] = [] : i.eventsListeners[l] && i.eventsListeners[l].forEach((c, p) => {
        (c === e || c.__emitterProxy && c.__emitterProxy === e) && i.eventsListeners[l].splice(p, 1);
      });
    }), i;
  },
  emit() {
    const t = this;
    if (!t.eventsListeners || t.destroyed || !t.eventsListeners) return t;
    let e, i, l;
    for (var c = arguments.length, p = new Array(c), h = 0; h < c; h++) p[h] = arguments[h];
    return typeof p[0] == "string" || Array.isArray(p[0]) ? (e = p[0], i = p.slice(1, p.length), l = t) : (e = p[0].events, i = p[0].data, l = p[0].context || t), i.unshift(l), (Array.isArray(e) ? e : e.split(" ")).forEach(w => {
      t.eventsAnyListeners && t.eventsAnyListeners.length && t.eventsAnyListeners.forEach(x => {
        x.apply(l, [w, ...i]);
      }), t.eventsListeners && t.eventsListeners[w] && t.eventsListeners[w].forEach(x => {
        x.apply(l, i);
      });
    }), t;
  }
};
function Hee() {
  const t = this;
  let e, i;
  const l = t.el;
  typeof t.params.width < "u" && t.params.width !== null ? e = t.params.width : e = l.clientWidth, typeof t.params.height < "u" && t.params.height !== null ? i = t.params.height : i = l.clientHeight, !(e === 0 && t.isHorizontal() || i === 0 && t.isVertical()) && (e = e - parseInt(Z0(l, "padding-left") || 0, 10) - parseInt(Z0(l, "padding-right") || 0, 10), i = i - parseInt(Z0(l, "padding-top") || 0, 10) - parseInt(Z0(l, "padding-bottom") || 0, 10), Number.isNaN(e) && (e = 0), Number.isNaN(i) && (i = 0), Object.assign(t, {
    width: e,
    height: i,
    size: t.isHorizontal() ? e : i
  }));
}
function $ee() {
  const t = this;
  function e(ie, Y) {
    return parseFloat(ie.getPropertyValue(t.getDirectionLabel(Y)) || 0);
  }
  const i = t.params,
    {
      wrapperEl: l,
      slidesEl: c,
      size: p,
      rtlTranslate: h,
      wrongRTL: y
    } = t,
    w = t.virtual && i.virtual.enabled,
    x = w ? t.virtual.slides.length : t.slides.length,
    E = Np(c, `.${t.params.slideClass}, swiper-slide`),
    C = w ? t.virtual.slides.length : E.length;
  let k = [];
  const D = [],
    I = [];
  let O = i.slidesOffsetBefore;
  typeof O == "function" && (O = i.slidesOffsetBefore.call(t));
  let P = i.slidesOffsetAfter;
  typeof P == "function" && (P = i.slidesOffsetAfter.call(t));
  const N = t.snapGrid.length,
    L = t.slidesGrid.length;
  let F = i.spaceBetween,
    j = -O,
    V = 0,
    K = 0;
  if (typeof p > "u") return;
  typeof F == "string" && F.indexOf("%") >= 0 ? F = parseFloat(F.replace("%", "")) / 100 * p : typeof F == "string" && (F = parseFloat(F)), t.virtualSize = -F, E.forEach(ie => {
    h ? ie.style.marginLeft = "" : ie.style.marginRight = "", ie.style.marginBottom = "", ie.style.marginTop = "";
  }), i.centeredSlides && i.cssMode && (mM(l, "--swiper-centered-offset-before", ""), mM(l, "--swiper-centered-offset-after", ""));
  const G = i.grid && i.grid.rows > 1 && t.grid;
  G ? t.grid.initSlides(E) : t.grid && t.grid.unsetSlides();
  let Q;
  const te = i.slidesPerView === "auto" && i.breakpoints && Object.keys(i.breakpoints).filter(ie => typeof i.breakpoints[ie].slidesPerView < "u").length > 0;
  for (let ie = 0; ie < C; ie += 1) {
    Q = 0;
    let Y;
    if (E[ie] && (Y = E[ie]), G && t.grid.updateSlide(ie, Y, E), !(E[ie] && Z0(Y, "display") === "none")) {
      if (i.slidesPerView === "auto") {
        te && (E[ie].style[t.getDirectionLabel("width")] = "");
        const ee = getComputedStyle(Y),
          oe = Y.style.transform,
          ne = Y.style.webkitTransform;
        if (oe && (Y.style.transform = "none"), ne && (Y.style.webkitTransform = "none"), i.roundLengths) Q = t.isHorizontal() ? Vj(Y, "width") : Vj(Y, "height");else {
          const se = e(ee, "width"),
            ue = e(ee, "padding-left"),
            W = e(ee, "padding-right"),
            $ = e(ee, "margin-left"),
            le = e(ee, "margin-right"),
            H = ee.getPropertyValue("box-sizing");
          if (H && H === "border-box") Q = se + $ + le;else {
            const {
              clientWidth: ce,
              offsetWidth: de
            } = Y;
            Q = se + ue + W + $ + le + (de - ce);
          }
        }
        oe && (Y.style.transform = oe), ne && (Y.style.webkitTransform = ne), i.roundLengths && (Q = Math.floor(Q));
      } else Q = (p - (i.slidesPerView - 1) * F) / i.slidesPerView, i.roundLengths && (Q = Math.floor(Q)), E[ie] && (E[ie].style[t.getDirectionLabel("width")] = `${Q}px`);
      E[ie] && (E[ie].swiperSlideSize = Q), I.push(Q), i.centeredSlides ? (j = j + Q / 2 + V / 2 + F, V === 0 && ie !== 0 && (j = j - p / 2 - F), ie === 0 && (j = j - p / 2 - F), Math.abs(j) < 1 / 1e3 && (j = 0), i.roundLengths && (j = Math.floor(j)), K % i.slidesPerGroup === 0 && k.push(j), D.push(j)) : (i.roundLengths && (j = Math.floor(j)), (K - Math.min(t.params.slidesPerGroupSkip, K)) % t.params.slidesPerGroup === 0 && k.push(j), D.push(j), j = j + Q + F), t.virtualSize += Q + F, V = Q, K += 1;
    }
  }
  if (t.virtualSize = Math.max(t.virtualSize, p) + P, h && y && (i.effect === "slide" || i.effect === "coverflow") && (l.style.width = `${t.virtualSize + F}px`), i.setWrapperSize && (l.style[t.getDirectionLabel("width")] = `${t.virtualSize + F}px`), G && t.grid.updateWrapperSize(Q, k), !i.centeredSlides) {
    const ie = [];
    for (let Y = 0; Y < k.length; Y += 1) {
      let ee = k[Y];
      i.roundLengths && (ee = Math.floor(ee)), k[Y] <= t.virtualSize - p && ie.push(ee);
    }
    k = ie, Math.floor(t.virtualSize - p) - Math.floor(k[k.length - 1]) > 1 && k.push(t.virtualSize - p);
  }
  if (w && i.loop) {
    const ie = I[0] + F;
    if (i.slidesPerGroup > 1) {
      const Y = Math.ceil((t.virtual.slidesBefore + t.virtual.slidesAfter) / i.slidesPerGroup),
        ee = ie * i.slidesPerGroup;
      for (let oe = 0; oe < Y; oe += 1) k.push(k[k.length - 1] + ee);
    }
    for (let Y = 0; Y < t.virtual.slidesBefore + t.virtual.slidesAfter; Y += 1) i.slidesPerGroup === 1 && k.push(k[k.length - 1] + ie), D.push(D[D.length - 1] + ie), t.virtualSize += ie;
  }
  if (k.length === 0 && (k = [0]), F !== 0) {
    const ie = t.isHorizontal() && h ? "marginLeft" : t.getDirectionLabel("marginRight");
    E.filter((Y, ee) => !i.cssMode || i.loop ? !0 : ee !== E.length - 1).forEach(Y => {
      Y.style[ie] = `${F}px`;
    });
  }
  if (i.centeredSlides && i.centeredSlidesBounds) {
    let ie = 0;
    I.forEach(ee => {
      ie += ee + (F || 0);
    }), ie -= F;
    const Y = ie > p ? ie - p : 0;
    k = k.map(ee => ee <= 0 ? -O : ee > Y ? Y + P : ee);
  }
  if (i.centerInsufficientSlides) {
    let ie = 0;
    I.forEach(ee => {
      ie += ee + (F || 0);
    }), ie -= F;
    const Y = (i.slidesOffsetBefore || 0) + (i.slidesOffsetAfter || 0);
    if (ie + Y < p) {
      const ee = (p - ie - Y) / 2;
      k.forEach((oe, ne) => {
        k[ne] = oe - ee;
      }), D.forEach((oe, ne) => {
        D[ne] = oe + ee;
      });
    }
  }
  if (Object.assign(t, {
    slides: E,
    snapGrid: k,
    slidesGrid: D,
    slidesSizesGrid: I
  }), i.centeredSlides && i.cssMode && !i.centeredSlidesBounds) {
    mM(l, "--swiper-centered-offset-before", `${-k[0]}px`), mM(l, "--swiper-centered-offset-after", `${t.size / 2 - I[I.length - 1] / 2}px`);
    const ie = -t.snapGrid[0],
      Y = -t.slidesGrid[0];
    t.snapGrid = t.snapGrid.map(ee => ee + ie), t.slidesGrid = t.slidesGrid.map(ee => ee + Y);
  }
  if (C !== x && t.emit("slidesLengthChange"), k.length !== N && (t.params.watchOverflow && t.checkOverflow(), t.emit("snapGridLengthChange")), D.length !== L && t.emit("slidesGridLengthChange"), i.watchSlidesProgress && t.updateSlidesOffset(), t.emit("slidesUpdated"), !w && !i.cssMode && (i.effect === "slide" || i.effect === "fade")) {
    const ie = `${i.containerModifierClass}backface-hidden`,
      Y = t.el.classList.contains(ie);
    C <= i.maxBackfaceHiddenSlides ? Y || t.el.classList.add(ie) : Y && t.el.classList.remove(ie);
  }
}
function Wee(t) {
  const e = this,
    i = [],
    l = e.virtual && e.params.virtual.enabled;
  let c = 0,
    p;
  typeof t == "number" ? e.setTransition(t) : t === !0 && e.setTransition(e.params.speed);
  const h = y => l ? e.slides[e.getSlideIndexByData(y)] : e.slides[y];
  if (e.params.slidesPerView !== "auto" && e.params.slidesPerView > 1) {
    if (e.params.centeredSlides) (e.visibleSlides || []).forEach(y => {
      i.push(y);
    });else for (p = 0; p < Math.ceil(e.params.slidesPerView); p += 1) {
      const y = e.activeIndex + p;
      if (y > e.slides.length && !l) break;
      i.push(h(y));
    }
  } else i.push(h(e.activeIndex));
  for (p = 0; p < i.length; p += 1) if (typeof i[p] < "u") {
    const y = i[p].offsetHeight;
    c = y > c ? y : c;
  }
  (c || c === 0) && (e.wrapperEl.style.height = `${c}px`);
}
function qee() {
  const t = this,
    e = t.slides,
    i = t.isElement ? t.isHorizontal() ? t.wrapperEl.offsetLeft : t.wrapperEl.offsetTop : 0;
  for (let l = 0; l < e.length; l += 1) e[l].swiperSlideOffset = (t.isHorizontal() ? e[l].offsetLeft : e[l].offsetTop) - i - t.cssOverflowAdjustment();
}
const mB = (t, e, i) => {
  e && !t.classList.contains(i) ? t.classList.add(i) : !e && t.classList.contains(i) && t.classList.remove(i);
};
function Yee(t) {
  t === void 0 && (t = this && this.translate || 0);
  const e = this,
    i = e.params,
    {
      slides: l,
      rtlTranslate: c,
      snapGrid: p
    } = e;
  if (l.length === 0) return;
  typeof l[0].swiperSlideOffset > "u" && e.updateSlidesOffset();
  let h = -t;
  c && (h = t), e.visibleSlidesIndexes = [], e.visibleSlides = [];
  let y = i.spaceBetween;
  typeof y == "string" && y.indexOf("%") >= 0 ? y = parseFloat(y.replace("%", "")) / 100 * e.size : typeof y == "string" && (y = parseFloat(y));
  for (let w = 0; w < l.length; w += 1) {
    const x = l[w];
    let E = x.swiperSlideOffset;
    i.cssMode && i.centeredSlides && (E -= l[0].swiperSlideOffset);
    const C = (h + (i.centeredSlides ? e.minTranslate() : 0) - E) / (x.swiperSlideSize + y),
      k = (h - p[0] + (i.centeredSlides ? e.minTranslate() : 0) - E) / (x.swiperSlideSize + y),
      D = -(h - E),
      I = D + e.slidesSizesGrid[w],
      O = D >= 0 && D <= e.size - e.slidesSizesGrid[w],
      P = D >= 0 && D < e.size - 1 || I > 1 && I <= e.size || D <= 0 && I >= e.size;
    P && (e.visibleSlides.push(x), e.visibleSlidesIndexes.push(w)), mB(x, P, i.slideVisibleClass), mB(x, O, i.slideFullyVisibleClass), x.progress = c ? -C : C, x.originalProgress = c ? -k : k;
  }
}
function Gee(t) {
  const e = this;
  if (typeof t > "u") {
    const E = e.rtlTranslate ? -1 : 1;
    t = e && e.translate && e.translate * E || 0;
  }
  const i = e.params,
    l = e.maxTranslate() - e.minTranslate();
  let {
    progress: c,
    isBeginning: p,
    isEnd: h,
    progressLoop: y
  } = e;
  const w = p,
    x = h;
  if (l === 0) c = 0, p = !0, h = !0;else {
    c = (t - e.minTranslate()) / l;
    const E = Math.abs(t - e.minTranslate()) < 1,
      C = Math.abs(t - e.maxTranslate()) < 1;
    p = E || c <= 0, h = C || c >= 1, E && (c = 0), C && (c = 1);
  }
  if (i.loop) {
    const E = e.getSlideIndexByData(0),
      C = e.getSlideIndexByData(e.slides.length - 1),
      k = e.slidesGrid[E],
      D = e.slidesGrid[C],
      I = e.slidesGrid[e.slidesGrid.length - 1],
      O = Math.abs(t);
    O >= k ? y = (O - k) / I : y = (O + I - D) / I, y > 1 && (y -= 1);
  }
  Object.assign(e, {
    progress: c,
    progressLoop: y,
    isBeginning: p,
    isEnd: h
  }), (i.watchSlidesProgress || i.centeredSlides && i.autoHeight) && e.updateSlidesProgress(t), p && !w && e.emit("reachBeginning toEdge"), h && !x && e.emit("reachEnd toEdge"), (w && !p || x && !h) && e.emit("fromEdge"), e.emit("progress", c);
}
const R2 = (t, e, i) => {
  e && !t.classList.contains(i) ? t.classList.add(i) : !e && t.classList.contains(i) && t.classList.remove(i);
};
function Xee() {
  const t = this,
    {
      slides: e,
      params: i,
      slidesEl: l,
      activeIndex: c
    } = t,
    p = t.virtual && i.virtual.enabled,
    h = t.grid && i.grid && i.grid.rows > 1,
    y = C => Np(l, `.${i.slideClass}${C}, swiper-slide${C}`)[0];
  let w, x, E;
  if (p) {
    if (i.loop) {
      let C = c - t.virtual.slidesBefore;
      C < 0 && (C = t.virtual.slides.length + C), C >= t.virtual.slides.length && (C -= t.virtual.slides.length), w = y(`[data-swiper-slide-index="${C}"]`);
    } else w = y(`[data-swiper-slide-index="${c}"]`);
  } else h ? (w = e.find(C => C.column === c), E = e.find(C => C.column === c + 1), x = e.find(C => C.column === c - 1)) : w = e[c];
  w && (h || (E = Pee(w, `.${i.slideClass}, swiper-slide`)[0], i.loop && !E && (E = e[0]), x = Lee(w, `.${i.slideClass}, swiper-slide`)[0], i.loop && !x === 0 && (x = e[e.length - 1]))), e.forEach(C => {
    R2(C, C === w, i.slideActiveClass), R2(C, C === E, i.slideNextClass), R2(C, C === x, i.slidePrevClass);
  }), t.emitSlidesClasses();
}
const HM = (t, e) => {
    if (!t || t.destroyed || !t.params) return;
    const i = () => t.isElement ? "swiper-slide" : `.${t.params.slideClass}`,
      l = e.closest(i());
    if (l) {
      let c = l.querySelector(`.${t.params.lazyPreloaderClass}`);
      !c && t.isElement && (l.shadowRoot ? c = l.shadowRoot.querySelector(`.${t.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
        l.shadowRoot && (c = l.shadowRoot.querySelector(`.${t.params.lazyPreloaderClass}`), c && c.remove());
      })), c && c.remove();
    }
  },
  D2 = (t, e) => {
    if (!t.slides[e]) return;
    const i = t.slides[e].querySelector('[loading="lazy"]');
    i && i.removeAttribute("loading");
  },
  Bj = t => {
    if (!t || t.destroyed || !t.params) return;
    let e = t.params.lazyPreloadPrevNext;
    const i = t.slides.length;
    if (!i || !e || e < 0) return;
    e = Math.min(e, i);
    const l = t.params.slidesPerView === "auto" ? t.slidesPerViewDynamic() : Math.ceil(t.params.slidesPerView),
      c = t.activeIndex;
    if (t.params.grid && t.params.grid.rows > 1) {
      const h = c,
        y = [h - e];
      y.push(...Array.from({
        length: e
      }).map((w, x) => h + l + x)), t.slides.forEach((w, x) => {
        y.includes(w.column) && D2(t, x);
      });
      return;
    }
    const p = c + l - 1;
    if (t.params.rewind || t.params.loop) for (let h = c - e; h <= p + e; h += 1) {
      const y = (h % i + i) % i;
      (y < c || y > p) && D2(t, y);
    } else for (let h = Math.max(c - e, 0); h <= Math.min(p + e, i - 1); h += 1) h !== c && (h > p || h < c) && D2(t, h);
  };
function Kee(t) {
  const {
      slidesGrid: e,
      params: i
    } = t,
    l = t.rtlTranslate ? t.translate : -t.translate;
  let c;
  for (let p = 0; p < e.length; p += 1) typeof e[p + 1] < "u" ? l >= e[p] && l < e[p + 1] - (e[p + 1] - e[p]) / 2 ? c = p : l >= e[p] && l < e[p + 1] && (c = p + 1) : l >= e[p] && (c = p);
  return i.normalizeSlideIndex && (c < 0 || typeof c > "u") && (c = 0), c;
}
function Qee(t) {
  const e = this,
    i = e.rtlTranslate ? e.translate : -e.translate,
    {
      snapGrid: l,
      params: c,
      activeIndex: p,
      realIndex: h,
      snapIndex: y
    } = e;
  let w = t,
    x;
  const E = D => {
    let I = D - e.virtual.slidesBefore;
    return I < 0 && (I = e.virtual.slides.length + I), I >= e.virtual.slides.length && (I -= e.virtual.slides.length), I;
  };
  if (typeof w > "u" && (w = Kee(e)), l.indexOf(i) >= 0) x = l.indexOf(i);else {
    const D = Math.min(c.slidesPerGroupSkip, w);
    x = D + Math.floor((w - D) / c.slidesPerGroup);
  }
  if (x >= l.length && (x = l.length - 1), w === p && !e.params.loop) {
    x !== y && (e.snapIndex = x, e.emit("snapIndexChange"));
    return;
  }
  if (w === p && e.params.loop && e.virtual && e.params.virtual.enabled) {
    e.realIndex = E(w);
    return;
  }
  const C = e.grid && c.grid && c.grid.rows > 1;
  let k;
  if (e.virtual && c.virtual.enabled && c.loop) k = E(w);else if (C) {
    const D = e.slides.find(O => O.column === w);
    let I = parseInt(D.getAttribute("data-swiper-slide-index"), 10);
    Number.isNaN(I) && (I = Math.max(e.slides.indexOf(D), 0)), k = Math.floor(I / c.grid.rows);
  } else if (e.slides[w]) {
    const D = e.slides[w].getAttribute("data-swiper-slide-index");
    D ? k = parseInt(D, 10) : k = w;
  } else k = w;
  Object.assign(e, {
    previousSnapIndex: y,
    snapIndex: x,
    previousRealIndex: h,
    realIndex: k,
    previousIndex: p,
    activeIndex: w
  }), e.initialized && Bj(e), e.emit("activeIndexChange"), e.emit("snapIndexChange"), (e.initialized || e.params.runCallbacksOnInit) && (h !== k && e.emit("realIndexChange"), e.emit("slideChange"));
}
function Zee(t, e) {
  const i = this,
    l = i.params;
  let c = t.closest(`.${l.slideClass}, swiper-slide`);
  !c && i.isElement && e && e.length > 1 && e.includes(t) && [...e.slice(e.indexOf(t) + 1, e.length)].forEach(y => {
    !c && y.matches && y.matches(`.${l.slideClass}, swiper-slide`) && (c = y);
  });
  let p = !1,
    h;
  if (c) {
    for (let y = 0; y < i.slides.length; y += 1) if (i.slides[y] === c) {
      p = !0, h = y;
      break;
    }
  }
  if (c && p) i.clickedSlide = c, i.virtual && i.params.virtual.enabled ? i.clickedIndex = parseInt(c.getAttribute("data-swiper-slide-index"), 10) : i.clickedIndex = h;else {
    i.clickedSlide = void 0, i.clickedIndex = void 0;
    return;
  }
  l.slideToClickedSlide && i.clickedIndex !== void 0 && i.clickedIndex !== i.activeIndex && i.slideToClickedSlide();
}
var Jee = {
  updateSize: Hee,
  updateSlides: $ee,
  updateAutoHeight: Wee,
  updateSlidesOffset: qee,
  updateSlidesProgress: Yee,
  updateProgress: Gee,
  updateSlidesClasses: Xee,
  updateActiveIndex: Qee,
  updateClickedSlide: Zee
};
function ete(t) {
  t === void 0 && (t = this.isHorizontal() ? "x" : "y");
  const e = this,
    {
      params: i,
      rtlTranslate: l,
      translate: c,
      wrapperEl: p
    } = e;
  if (i.virtualTranslate) return l ? -c : c;
  if (i.cssMode) return c;
  let h = Nj(p, t);
  return h += e.cssOverflowAdjustment(), l && (h = -h), h || 0;
}
function tte(t, e) {
  const i = this,
    {
      rtlTranslate: l,
      params: c,
      wrapperEl: p,
      progress: h
    } = i;
  let y = 0,
    w = 0;
  const x = 0;
  i.isHorizontal() ? y = l ? -t : t : w = t, c.roundLengths && (y = Math.floor(y), w = Math.floor(w)), i.previousTranslate = i.translate, i.translate = i.isHorizontal() ? y : w, c.cssMode ? p[i.isHorizontal() ? "scrollLeft" : "scrollTop"] = i.isHorizontal() ? -y : -w : c.virtualTranslate || (i.isHorizontal() ? y -= i.cssOverflowAdjustment() : w -= i.cssOverflowAdjustment(), p.style.transform = `translate3d(${y}px, ${w}px, ${x}px)`);
  let E;
  const C = i.maxTranslate() - i.minTranslate();
  C === 0 ? E = 0 : E = (t - i.minTranslate()) / C, E !== h && i.updateProgress(t), i.emit("setTranslate", i.translate, e);
}
function nte() {
  return -this.snapGrid[0];
}
function rte() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function ite(t, e, i, l, c) {
  t === void 0 && (t = 0), e === void 0 && (e = this.params.speed), i === void 0 && (i = !0), l === void 0 && (l = !0);
  const p = this,
    {
      params: h,
      wrapperEl: y
    } = p;
  if (p.animating && h.preventInteractionOnTransition) return !1;
  const w = p.minTranslate(),
    x = p.maxTranslate();
  let E;
  if (l && t > w ? E = w : l && t < x ? E = x : E = t, p.updateProgress(E), h.cssMode) {
    const C = p.isHorizontal();
    if (e === 0) y[C ? "scrollLeft" : "scrollTop"] = -E;else {
      if (!p.support.smoothScroll) return W4({
        swiper: p,
        targetPosition: -E,
        side: C ? "left" : "top"
      }), !0;
      y.scrollTo({
        [C ? "left" : "top"]: -E,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return e === 0 ? (p.setTransition(0), p.setTranslate(E), i && (p.emit("beforeTransitionStart", e, c), p.emit("transitionEnd"))) : (p.setTransition(e), p.setTranslate(E), i && (p.emit("beforeTransitionStart", e, c), p.emit("transitionStart")), p.animating || (p.animating = !0, p.onTranslateToWrapperTransitionEnd || (p.onTranslateToWrapperTransitionEnd = function (k) {
    !p || p.destroyed || k.target === this && (p.wrapperEl.removeEventListener("transitionend", p.onTranslateToWrapperTransitionEnd), p.onTranslateToWrapperTransitionEnd = null, delete p.onTranslateToWrapperTransitionEnd, p.animating = !1, i && p.emit("transitionEnd"));
  }), p.wrapperEl.addEventListener("transitionend", p.onTranslateToWrapperTransitionEnd))), !0;
}
var ate = {
  getTranslate: ete,
  setTranslate: tte,
  minTranslate: nte,
  maxTranslate: rte,
  translateTo: ite
};
function ote(t, e) {
  const i = this;
  i.params.cssMode || (i.wrapperEl.style.transitionDuration = `${t}ms`, i.wrapperEl.style.transitionDelay = t === 0 ? "0ms" : ""), i.emit("setTransition", t, e);
}
function e$(t) {
  let {
    swiper: e,
    runCallbacks: i,
    direction: l,
    step: c
  } = t;
  const {
    activeIndex: p,
    previousIndex: h
  } = e;
  let y = l;
  y || (p > h ? y = "next" : p < h ? y = "prev" : y = "reset"), e.emit(`transition${c}`), i && y === "reset" ? e.emit(`slideResetTransition${c}`) : i && p !== h && (e.emit(`slideChangeTransition${c}`), y === "next" ? e.emit(`slideNextTransition${c}`) : e.emit(`slidePrevTransition${c}`));
}
function ste(t, e) {
  t === void 0 && (t = !0);
  const i = this,
    {
      params: l
    } = i;
  l.cssMode || (l.autoHeight && i.updateAutoHeight(), e$({
    swiper: i,
    runCallbacks: t,
    direction: e,
    step: "Start"
  }));
}
function lte(t, e) {
  t === void 0 && (t = !0);
  const i = this,
    {
      params: l
    } = i;
  i.animating = !1, !l.cssMode && (i.setTransition(0), e$({
    swiper: i,
    runCallbacks: t,
    direction: e,
    step: "End"
  }));
}
var ute = {
  setTransition: ote,
  transitionStart: ste,
  transitionEnd: lte
};
function cte(t, e, i, l, c) {
  t === void 0 && (t = 0), i === void 0 && (i = !0), typeof t == "string" && (t = parseInt(t, 10));
  const p = this;
  let h = t;
  h < 0 && (h = 0);
  const {
    params: y,
    snapGrid: w,
    slidesGrid: x,
    previousIndex: E,
    activeIndex: C,
    rtlTranslate: k,
    wrapperEl: D,
    enabled: I
  } = p;
  if (!I && !l && !c || p.destroyed || p.animating && y.preventInteractionOnTransition) return !1;
  typeof e > "u" && (e = p.params.speed);
  const O = Math.min(p.params.slidesPerGroupSkip, h);
  let P = O + Math.floor((h - O) / p.params.slidesPerGroup);
  P >= w.length && (P = w.length - 1);
  const N = -w[P];
  if (y.normalizeSlideIndex) for (let G = 0; G < x.length; G += 1) {
    const Q = -Math.floor(N * 100),
      te = Math.floor(x[G] * 100),
      ie = Math.floor(x[G + 1] * 100);
    typeof x[G + 1] < "u" ? Q >= te && Q < ie - (ie - te) / 2 ? h = G : Q >= te && Q < ie && (h = G + 1) : Q >= te && (h = G);
  }
  if (p.initialized && h !== C && (!p.allowSlideNext && (k ? N > p.translate && N > p.minTranslate() : N < p.translate && N < p.minTranslate()) || !p.allowSlidePrev && N > p.translate && N > p.maxTranslate() && (C || 0) !== h)) return !1;
  h !== (E || 0) && i && p.emit("beforeSlideChangeStart"), p.updateProgress(N);
  let L;
  h > C ? L = "next" : h < C ? L = "prev" : L = "reset";
  const F = p.virtual && p.params.virtual.enabled;
  if (!(F && c) && (k && -N === p.translate || !k && N === p.translate)) return p.updateActiveIndex(h), y.autoHeight && p.updateAutoHeight(), p.updateSlidesClasses(), y.effect !== "slide" && p.setTranslate(N), L !== "reset" && (p.transitionStart(i, L), p.transitionEnd(i, L)), !1;
  if (y.cssMode) {
    const G = p.isHorizontal(),
      Q = k ? N : -N;
    if (e === 0) F && (p.wrapperEl.style.scrollSnapType = "none", p._immediateVirtual = !0), F && !p._cssModeVirtualInitialSet && p.params.initialSlide > 0 ? (p._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
      D[G ? "scrollLeft" : "scrollTop"] = Q;
    })) : D[G ? "scrollLeft" : "scrollTop"] = Q, F && requestAnimationFrame(() => {
      p.wrapperEl.style.scrollSnapType = "", p._immediateVirtual = !1;
    });else {
      if (!p.support.smoothScroll) return W4({
        swiper: p,
        targetPosition: Q,
        side: G ? "left" : "top"
      }), !0;
      D.scrollTo({
        [G ? "left" : "top"]: Q,
        behavior: "smooth"
      });
    }
    return !0;
  }
  const K = J4().isSafari;
  return F && !c && K && p.isElement && p.virtual.update(!1, !1, h), p.setTransition(e), p.setTranslate(N), p.updateActiveIndex(h), p.updateSlidesClasses(), p.emit("beforeTransitionStart", e, l), p.transitionStart(i, L), e === 0 ? p.transitionEnd(i, L) : p.animating || (p.animating = !0, p.onSlideToWrapperTransitionEnd || (p.onSlideToWrapperTransitionEnd = function (Q) {
    !p || p.destroyed || Q.target === this && (p.wrapperEl.removeEventListener("transitionend", p.onSlideToWrapperTransitionEnd), p.onSlideToWrapperTransitionEnd = null, delete p.onSlideToWrapperTransitionEnd, p.transitionEnd(i, L));
  }), p.wrapperEl.addEventListener("transitionend", p.onSlideToWrapperTransitionEnd)), !0;
}
function dte(t, e, i, l) {
  t === void 0 && (t = 0), i === void 0 && (i = !0), typeof t == "string" && (t = parseInt(t, 10));
  const c = this;
  if (c.destroyed) return;
  typeof e > "u" && (e = c.params.speed);
  const p = c.grid && c.params.grid && c.params.grid.rows > 1;
  let h = t;
  if (c.params.loop) if (c.virtual && c.params.virtual.enabled) h = h + c.virtual.slidesBefore;else {
    let y;
    if (p) {
      const k = h * c.params.grid.rows;
      y = c.slides.find(D => D.getAttribute("data-swiper-slide-index") * 1 === k).column;
    } else y = c.getSlideIndexByData(h);
    const w = p ? Math.ceil(c.slides.length / c.params.grid.rows) : c.slides.length,
      {
        centeredSlides: x
      } = c.params;
    let E = c.params.slidesPerView;
    E === "auto" ? E = c.slidesPerViewDynamic() : (E = Math.ceil(parseFloat(c.params.slidesPerView, 10)), x && E % 2 === 0 && (E = E + 1));
    let C = w - y < E;
    if (x && (C = C || y < Math.ceil(E / 2)), l && x && c.params.slidesPerView !== "auto" && !p && (C = !1), C) {
      const k = x ? y < c.activeIndex ? "prev" : "next" : y - c.activeIndex - 1 < c.params.slidesPerView ? "next" : "prev";
      c.loopFix({
        direction: k,
        slideTo: !0,
        activeSlideIndex: k === "next" ? y + 1 : y - w + 1,
        slideRealIndex: k === "next" ? c.realIndex : void 0
      });
    }
    if (p) {
      const k = h * c.params.grid.rows;
      h = c.slides.find(D => D.getAttribute("data-swiper-slide-index") * 1 === k).column;
    } else h = c.getSlideIndexByData(h);
  }
  return requestAnimationFrame(() => {
    c.slideTo(h, e, i, l);
  }), c;
}
function fte(t, e, i) {
  e === void 0 && (e = !0);
  const l = this,
    {
      enabled: c,
      params: p,
      animating: h
    } = l;
  if (!c || l.destroyed) return l;
  typeof t > "u" && (t = l.params.speed);
  let y = p.slidesPerGroup;
  p.slidesPerView === "auto" && p.slidesPerGroup === 1 && p.slidesPerGroupAuto && (y = Math.max(l.slidesPerViewDynamic("current", !0), 1));
  const w = l.activeIndex < p.slidesPerGroupSkip ? 1 : y,
    x = l.virtual && p.virtual.enabled;
  if (p.loop) {
    if (h && !x && p.loopPreventsSliding) return !1;
    if (l.loopFix({
      direction: "next"
    }), l._clientLeft = l.wrapperEl.clientLeft, l.activeIndex === l.slides.length - 1 && p.cssMode) return requestAnimationFrame(() => {
      l.slideTo(l.activeIndex + w, t, e, i);
    }), !0;
  }
  return p.rewind && l.isEnd ? l.slideTo(0, t, e, i) : l.slideTo(l.activeIndex + w, t, e, i);
}
function pte(t, e, i) {
  e === void 0 && (e = !0);
  const l = this,
    {
      params: c,
      snapGrid: p,
      slidesGrid: h,
      rtlTranslate: y,
      enabled: w,
      animating: x
    } = l;
  if (!w || l.destroyed) return l;
  typeof t > "u" && (t = l.params.speed);
  const E = l.virtual && c.virtual.enabled;
  if (c.loop) {
    if (x && !E && c.loopPreventsSliding) return !1;
    l.loopFix({
      direction: "prev"
    }), l._clientLeft = l.wrapperEl.clientLeft;
  }
  const C = y ? l.translate : -l.translate;
  function k(L) {
    return L < 0 ? -Math.floor(Math.abs(L)) : Math.floor(L);
  }
  const D = k(C),
    I = p.map(L => k(L)),
    O = c.freeMode && c.freeMode.enabled;
  let P = p[I.indexOf(D) - 1];
  if (typeof P > "u" && (c.cssMode || O)) {
    let L;
    p.forEach((F, j) => {
      D >= F && (L = j);
    }), typeof L < "u" && (P = O ? p[L] : p[L > 0 ? L - 1 : L]);
  }
  let N = 0;
  if (typeof P < "u" && (N = h.indexOf(P), N < 0 && (N = l.activeIndex - 1), c.slidesPerView === "auto" && c.slidesPerGroup === 1 && c.slidesPerGroupAuto && (N = N - l.slidesPerViewDynamic("previous", !0) + 1, N = Math.max(N, 0))), c.rewind && l.isBeginning) {
    const L = l.params.virtual && l.params.virtual.enabled && l.virtual ? l.virtual.slides.length - 1 : l.slides.length - 1;
    return l.slideTo(L, t, e, i);
  } else if (c.loop && l.activeIndex === 0 && c.cssMode) return requestAnimationFrame(() => {
    l.slideTo(N, t, e, i);
  }), !0;
  return l.slideTo(N, t, e, i);
}
function hte(t, e, i) {
  e === void 0 && (e = !0);
  const l = this;
  if (!l.destroyed) return typeof t > "u" && (t = l.params.speed), l.slideTo(l.activeIndex, t, e, i);
}
function mte(t, e, i, l) {
  e === void 0 && (e = !0), l === void 0 && (l = 0.5);
  const c = this;
  if (c.destroyed) return;
  typeof t > "u" && (t = c.params.speed);
  let p = c.activeIndex;
  const h = Math.min(c.params.slidesPerGroupSkip, p),
    y = h + Math.floor((p - h) / c.params.slidesPerGroup),
    w = c.rtlTranslate ? c.translate : -c.translate;
  if (w >= c.snapGrid[y]) {
    const x = c.snapGrid[y],
      E = c.snapGrid[y + 1];
    w - x > (E - x) * l && (p += c.params.slidesPerGroup);
  } else {
    const x = c.snapGrid[y - 1],
      E = c.snapGrid[y];
    w - x <= (E - x) * l && (p -= c.params.slidesPerGroup);
  }
  return p = Math.max(p, 0), p = Math.min(p, c.slidesGrid.length - 1), c.slideTo(p, t, e, i);
}
function vte() {
  const t = this;
  if (t.destroyed) return;
  const {
      params: e,
      slidesEl: i
    } = t,
    l = e.slidesPerView === "auto" ? t.slidesPerViewDynamic() : e.slidesPerView;
  let c = t.getSlideIndexWhenGrid(t.clickedIndex),
    p;
  const h = t.isElement ? "swiper-slide" : `.${e.slideClass}`,
    y = t.grid && t.params.grid && t.params.grid.rows > 1;
  if (e.loop) {
    if (t.animating) return;
    p = parseInt(t.clickedSlide.getAttribute("data-swiper-slide-index"), 10), e.centeredSlides ? t.slideToLoop(p) : c > (y ? (t.slides.length - l) / 2 - (t.params.grid.rows - 1) : t.slides.length - l) ? (t.loopFix(), c = t.getSlideIndex(Np(i, `${h}[data-swiper-slide-index="${p}"]`)[0]), kN(() => {
      t.slideTo(c);
    })) : t.slideTo(c);
  } else t.slideTo(c);
}
var gte = {
  slideTo: cte,
  slideToLoop: dte,
  slideNext: fte,
  slidePrev: pte,
  slideReset: hte,
  slideToClosest: mte,
  slideToClickedSlide: vte
};
function yte(t, e) {
  const i = this,
    {
      params: l,
      slidesEl: c
    } = i;
  if (!l.loop || i.virtual && i.params.virtual.enabled) return;
  const p = () => {
      Np(c, `.${l.slideClass}, swiper-slide`).forEach((D, I) => {
        D.setAttribute("data-swiper-slide-index", I);
      });
    },
    h = () => {
      const k = Np(c, `.${l.slideBlankClass}`);
      k.forEach(D => {
        D.remove();
      }), k.length > 0 && (i.recalcSlides(), i.updateSlides());
    },
    y = i.grid && l.grid && l.grid.rows > 1;
  l.loopAddBlankSlides && (l.slidesPerGroup > 1 || y) && h();
  const w = l.slidesPerGroup * (y ? l.grid.rows : 1),
    x = i.slides.length % w !== 0,
    E = y && i.slides.length % l.grid.rows !== 0,
    C = k => {
      for (let D = 0; D < k; D += 1) {
        const I = i.isElement ? fR("swiper-slide", [l.slideBlankClass]) : fR("div", [l.slideClass, l.slideBlankClass]);
        i.slidesEl.append(I);
      }
    };
  if (x) {
    if (l.loopAddBlankSlides) {
      const k = w - i.slides.length % w;
      C(k), i.recalcSlides(), i.updateSlides();
    } else xO("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    p();
  } else if (E) {
    if (l.loopAddBlankSlides) {
      const k = l.grid.rows - i.slides.length % l.grid.rows;
      C(k), i.recalcSlides(), i.updateSlides();
    } else xO("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    p();
  } else p();
  i.loopFix({
    slideRealIndex: t,
    direction: l.centeredSlides ? void 0 : "next",
    initial: e
  });
}
function bte(t) {
  let {
    slideRealIndex: e,
    slideTo: i = !0,
    direction: l,
    setTranslate: c,
    activeSlideIndex: p,
    initial: h,
    byController: y,
    byMousewheel: w
  } = t === void 0 ? {} : t;
  const x = this;
  if (!x.params.loop) return;
  x.emit("beforeLoopFix");
  const {
      slides: E,
      allowSlidePrev: C,
      allowSlideNext: k,
      slidesEl: D,
      params: I
    } = x,
    {
      centeredSlides: O,
      initialSlide: P
    } = I;
  if (x.allowSlidePrev = !0, x.allowSlideNext = !0, x.virtual && I.virtual.enabled) {
    i && (!I.centeredSlides && x.snapIndex === 0 ? x.slideTo(x.virtual.slides.length, 0, !1, !0) : I.centeredSlides && x.snapIndex < I.slidesPerView ? x.slideTo(x.virtual.slides.length + x.snapIndex, 0, !1, !0) : x.snapIndex === x.snapGrid.length - 1 && x.slideTo(x.virtual.slidesBefore, 0, !1, !0)), x.allowSlidePrev = C, x.allowSlideNext = k, x.emit("loopFix");
    return;
  }
  let N = I.slidesPerView;
  N === "auto" ? N = x.slidesPerViewDynamic() : (N = Math.ceil(parseFloat(I.slidesPerView, 10)), O && N % 2 === 0 && (N = N + 1));
  const L = I.slidesPerGroupAuto ? N : I.slidesPerGroup;
  let F = O ? Math.max(L, Math.ceil(N / 2)) : L;
  F % L !== 0 && (F += L - F % L), F += I.loopAdditionalSlides, x.loopedSlides = F;
  const j = x.grid && I.grid && I.grid.rows > 1;
  E.length < N + F || x.params.effect === "cards" && E.length < N + F * 2 ? xO("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : j && I.grid.fill === "row" && xO("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
  const V = [],
    K = [],
    G = j ? Math.ceil(E.length / I.grid.rows) : E.length,
    Q = h && G - P < N && !O;
  let te = Q ? P : x.activeIndex;
  typeof p > "u" ? p = x.getSlideIndex(E.find(ue => ue.classList.contains(I.slideActiveClass))) : te = p;
  const ie = l === "next" || !l,
    Y = l === "prev" || !l;
  let ee = 0,
    oe = 0;
  const se = (j ? E[p].column : p) + (O && typeof c > "u" ? -N / 2 + 0.5 : 0);
  if (se < F) {
    ee = Math.max(F - se, L);
    for (let ue = 0; ue < F - se; ue += 1) {
      const W = ue - Math.floor(ue / G) * G;
      if (j) {
        const $ = G - W - 1;
        for (let le = E.length - 1; le >= 0; le -= 1) E[le].column === $ && V.push(le);
      } else V.push(G - W - 1);
    }
  } else if (se + N > G - F) {
    oe = Math.max(se - (G - F * 2), L), Q && (oe = Math.max(oe, N - G + P + 1));
    for (let ue = 0; ue < oe; ue += 1) {
      const W = ue - Math.floor(ue / G) * G;
      j ? E.forEach(($, le) => {
        $.column === W && K.push(le);
      }) : K.push(W);
    }
  }
  if (x.__preventObserver__ = !0, requestAnimationFrame(() => {
    x.__preventObserver__ = !1;
  }), x.params.effect === "cards" && E.length < N + F * 2 && (K.includes(p) && K.splice(K.indexOf(p), 1), V.includes(p) && V.splice(V.indexOf(p), 1)), Y && V.forEach(ue => {
    E[ue].swiperLoopMoveDOM = !0, D.prepend(E[ue]), E[ue].swiperLoopMoveDOM = !1;
  }), ie && K.forEach(ue => {
    E[ue].swiperLoopMoveDOM = !0, D.append(E[ue]), E[ue].swiperLoopMoveDOM = !1;
  }), x.recalcSlides(), I.slidesPerView === "auto" ? x.updateSlides() : j && (V.length > 0 && Y || K.length > 0 && ie) && x.slides.forEach((ue, W) => {
    x.grid.updateSlide(W, ue, x.slides);
  }), I.watchSlidesProgress && x.updateSlidesOffset(), i) {
    if (V.length > 0 && Y) {
      if (typeof e > "u") {
        const ue = x.slidesGrid[te],
          $ = x.slidesGrid[te + ee] - ue;
        w ? x.setTranslate(x.translate - $) : (x.slideTo(te + Math.ceil(ee), 0, !1, !0), c && (x.touchEventsData.startTranslate = x.touchEventsData.startTranslate - $, x.touchEventsData.currentTranslate = x.touchEventsData.currentTranslate - $));
      } else if (c) {
        const ue = j ? V.length / I.grid.rows : V.length;
        x.slideTo(x.activeIndex + ue, 0, !1, !0), x.touchEventsData.currentTranslate = x.translate;
      }
    } else if (K.length > 0 && ie) if (typeof e > "u") {
      const ue = x.slidesGrid[te],
        $ = x.slidesGrid[te - oe] - ue;
      w ? x.setTranslate(x.translate - $) : (x.slideTo(te - oe, 0, !1, !0), c && (x.touchEventsData.startTranslate = x.touchEventsData.startTranslate - $, x.touchEventsData.currentTranslate = x.touchEventsData.currentTranslate - $));
    } else {
      const ue = j ? K.length / I.grid.rows : K.length;
      x.slideTo(x.activeIndex - ue, 0, !1, !0);
    }
  }
  if (x.allowSlidePrev = C, x.allowSlideNext = k, x.controller && x.controller.control && !y) {
    const ue = {
      slideRealIndex: e,
      direction: l,
      setTranslate: c,
      activeSlideIndex: p,
      byController: !0
    };
    Array.isArray(x.controller.control) ? x.controller.control.forEach(W => {
      !W.destroyed && W.params.loop && W.loopFix({
        ...ue,
        slideTo: W.params.slidesPerView === I.slidesPerView ? i : !1
      });
    }) : x.controller.control instanceof x.constructor && x.controller.control.params.loop && x.controller.control.loopFix({
      ...ue,
      slideTo: x.controller.control.params.slidesPerView === I.slidesPerView ? i : !1
    });
  }
  x.emit("loopFix");
}
function wte() {
  const t = this,
    {
      params: e,
      slidesEl: i
    } = t;
  if (!e.loop || !i || t.virtual && t.params.virtual.enabled) return;
  t.recalcSlides();
  const l = [];
  t.slides.forEach(c => {
    const p = typeof c.swiperSlideIndex > "u" ? c.getAttribute("data-swiper-slide-index") * 1 : c.swiperSlideIndex;
    l[p] = c;
  }), t.slides.forEach(c => {
    c.removeAttribute("data-swiper-slide-index");
  }), l.forEach(c => {
    i.append(c);
  }), t.recalcSlides(), t.slideTo(t.realIndex, 0);
}
var _te = {
  loopCreate: yte,
  loopFix: bte,
  loopDestroy: wte
};
function xte(t) {
  const e = this;
  if (!e.params.simulateTouch || e.params.watchOverflow && e.isLocked || e.params.cssMode) return;
  const i = e.params.touchEventsTarget === "container" ? e.el : e.wrapperEl;
  e.isElement && (e.__preventObserver__ = !0), i.style.cursor = "move", i.style.cursor = t ? "grabbing" : "grab", e.isElement && requestAnimationFrame(() => {
    e.__preventObserver__ = !1;
  });
}
function Ste() {
  const t = this;
  t.params.watchOverflow && t.isLocked || t.params.cssMode || (t.isElement && (t.__preventObserver__ = !0), t[t.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", t.isElement && requestAnimationFrame(() => {
    t.__preventObserver__ = !1;
  }));
}
var Ete = {
  setGrabCursor: xte,
  unsetGrabCursor: Ste
};
function Cte(t, e) {
  e === void 0 && (e = this);
  function i(l) {
    if (!l || l === Gm() || l === wl()) return null;
    l.assignedSlot && (l = l.assignedSlot);
    const c = l.closest(t);
    return !c && !l.getRootNode ? null : c || i(l.getRootNode().host);
  }
  return i(e);
}
function vB(t, e, i) {
  const l = wl(),
    {
      params: c
    } = t,
    p = c.edgeSwipeDetection,
    h = c.edgeSwipeThreshold;
  return p && (i <= h || i >= l.innerWidth - h) ? p === "prevent" ? (e.preventDefault(), !0) : !1 : !0;
}
function kte(t) {
  const e = this,
    i = Gm();
  let l = t;
  l.originalEvent && (l = l.originalEvent);
  const c = e.touchEventsData;
  if (l.type === "pointerdown") {
    if (c.pointerId !== null && c.pointerId !== l.pointerId) return;
    c.pointerId = l.pointerId;
  } else l.type === "touchstart" && l.targetTouches.length === 1 && (c.touchId = l.targetTouches[0].identifier);
  if (l.type === "touchstart") {
    vB(e, l, l.targetTouches[0].pageX);
    return;
  }
  const {
    params: p,
    touches: h,
    enabled: y
  } = e;
  if (!y || !p.simulateTouch && l.pointerType === "mouse" || e.animating && p.preventInteractionOnTransition) return;
  !e.animating && p.cssMode && p.loop && e.loopFix();
  let w = l.target;
  if (p.touchEventsTarget === "wrapper" && !Oee(w, e.wrapperEl) || "which" in l && l.which === 3 || "button" in l && l.button > 0 || c.isTouched && c.isMoved) return;
  const x = !!p.noSwipingClass && p.noSwipingClass !== "",
    E = l.composedPath ? l.composedPath() : l.path;
  x && l.target && l.target.shadowRoot && E && (w = E[0]);
  const C = p.noSwipingSelector ? p.noSwipingSelector : `.${p.noSwipingClass}`,
    k = !!(l.target && l.target.shadowRoot);
  if (p.noSwiping && (k ? Cte(C, w) : w.closest(C))) {
    e.allowClick = !0;
    return;
  }
  if (p.swipeHandler && !w.closest(p.swipeHandler)) return;
  h.currentX = l.pageX, h.currentY = l.pageY;
  const D = h.currentX,
    I = h.currentY;
  if (!vB(e, l, D)) return;
  Object.assign(c, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), h.startX = D, h.startY = I, c.touchStartTime = _O(), e.allowClick = !0, e.updateSize(), e.swipeDirection = void 0, p.threshold > 0 && (c.allowThresholdMove = !1);
  let O = !0;
  w.matches(c.focusableElements) && (O = !1, w.nodeName === "SELECT" && (c.isTouched = !1)), i.activeElement && i.activeElement.matches(c.focusableElements) && i.activeElement !== w && (l.pointerType === "mouse" || l.pointerType !== "mouse" && !w.matches(c.focusableElements)) && i.activeElement.blur();
  const P = O && e.allowTouchMove && p.touchStartPreventDefault;
  (p.touchStartForcePreventDefault || P) && !w.isContentEditable && l.preventDefault(), p.freeMode && p.freeMode.enabled && e.freeMode && e.animating && !p.cssMode && e.freeMode.onTouchStart(), e.emit("touchStart", l);
}
function Tte(t) {
  const e = Gm(),
    i = this,
    l = i.touchEventsData,
    {
      params: c,
      touches: p,
      rtlTranslate: h,
      enabled: y
    } = i;
  if (!y || !c.simulateTouch && t.pointerType === "mouse") return;
  let w = t;
  if (w.originalEvent && (w = w.originalEvent), w.type === "pointermove" && (l.touchId !== null || w.pointerId !== l.pointerId)) return;
  let x;
  if (w.type === "touchmove") {
    if (x = [...w.changedTouches].find(V => V.identifier === l.touchId), !x || x.identifier !== l.touchId) return;
  } else x = w;
  if (!l.isTouched) {
    l.startMoving && l.isScrolling && i.emit("touchMoveOpposite", w);
    return;
  }
  const E = x.pageX,
    C = x.pageY;
  if (w.preventedByNestedSwiper) {
    p.startX = E, p.startY = C;
    return;
  }
  if (!i.allowTouchMove) {
    w.target.matches(l.focusableElements) || (i.allowClick = !1), l.isTouched && (Object.assign(p, {
      startX: E,
      startY: C,
      currentX: E,
      currentY: C
    }), l.touchStartTime = _O());
    return;
  }
  if (c.touchReleaseOnEdges && !c.loop) if (i.isVertical()) {
    if (C < p.startY && i.translate <= i.maxTranslate() || C > p.startY && i.translate >= i.minTranslate()) {
      l.isTouched = !1, l.isMoved = !1;
      return;
    }
  } else {
    if (h && (E > p.startX && -i.translate <= i.maxTranslate() || E < p.startX && -i.translate >= i.minTranslate())) return;
    if (!h && (E < p.startX && i.translate <= i.maxTranslate() || E > p.startX && i.translate >= i.minTranslate())) return;
  }
  if (e.activeElement && e.activeElement.matches(l.focusableElements) && e.activeElement !== w.target && w.pointerType !== "mouse" && e.activeElement.blur(), e.activeElement && w.target === e.activeElement && w.target.matches(l.focusableElements)) {
    l.isMoved = !0, i.allowClick = !1;
    return;
  }
  l.allowTouchCallbacks && i.emit("touchMove", w), p.previousX = p.currentX, p.previousY = p.currentY, p.currentX = E, p.currentY = C;
  const k = p.currentX - p.startX,
    D = p.currentY - p.startY;
  if (i.params.threshold && Math.sqrt(k ** 2 + D ** 2) < i.params.threshold) return;
  if (typeof l.isScrolling > "u") {
    let V;
    i.isHorizontal() && p.currentY === p.startY || i.isVertical() && p.currentX === p.startX ? l.isScrolling = !1 : k * k + D * D >= 25 && (V = Math.atan2(Math.abs(D), Math.abs(k)) * 180 / Math.PI, l.isScrolling = i.isHorizontal() ? V > c.touchAngle : 90 - V > c.touchAngle);
  }
  if (l.isScrolling && i.emit("touchMoveOpposite", w), typeof l.startMoving > "u" && (p.currentX !== p.startX || p.currentY !== p.startY) && (l.startMoving = !0), l.isScrolling || w.type === "touchmove" && l.preventTouchMoveFromPointerMove) {
    l.isTouched = !1;
    return;
  }
  if (!l.startMoving) return;
  i.allowClick = !1, !c.cssMode && w.cancelable && w.preventDefault(), c.touchMoveStopPropagation && !c.nested && w.stopPropagation();
  let I = i.isHorizontal() ? k : D,
    O = i.isHorizontal() ? p.currentX - p.previousX : p.currentY - p.previousY;
  c.oneWayMovement && (I = Math.abs(I) * (h ? 1 : -1), O = Math.abs(O) * (h ? 1 : -1)), p.diff = I, I *= c.touchRatio, h && (I = -I, O = -O);
  const P = i.touchesDirection;
  i.swipeDirection = I > 0 ? "prev" : "next", i.touchesDirection = O > 0 ? "prev" : "next";
  const N = i.params.loop && !c.cssMode,
    L = i.touchesDirection === "next" && i.allowSlideNext || i.touchesDirection === "prev" && i.allowSlidePrev;
  if (!l.isMoved) {
    if (N && L && i.loopFix({
      direction: i.swipeDirection
    }), l.startTranslate = i.getTranslate(), i.setTransition(0), i.animating) {
      const V = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0,
        detail: {
          bySwiperTouchMove: !0
        }
      });
      i.wrapperEl.dispatchEvent(V);
    }
    l.allowMomentumBounce = !1, c.grabCursor && (i.allowSlideNext === !0 || i.allowSlidePrev === !0) && i.setGrabCursor(!0), i.emit("sliderFirstMove", w);
  }
  if ((/* @__PURE__ */new Date()).getTime(), c._loopSwapReset !== !1 && l.isMoved && l.allowThresholdMove && P !== i.touchesDirection && N && L && Math.abs(I) >= 1) {
    Object.assign(p, {
      startX: E,
      startY: C,
      currentX: E,
      currentY: C,
      startTranslate: l.currentTranslate
    }), l.loopSwapReset = !0, l.startTranslate = l.currentTranslate;
    return;
  }
  i.emit("sliderMove", w), l.isMoved = !0, l.currentTranslate = I + l.startTranslate;
  let F = !0,
    j = c.resistanceRatio;
  if (c.touchReleaseOnEdges && (j = 0), I > 0 ? (N && L && l.allowThresholdMove && l.currentTranslate > (c.centeredSlides ? i.minTranslate() - i.slidesSizesGrid[i.activeIndex + 1] - (c.slidesPerView !== "auto" && i.slides.length - c.slidesPerView >= 2 ? i.slidesSizesGrid[i.activeIndex + 1] + i.params.spaceBetween : 0) - i.params.spaceBetween : i.minTranslate()) && i.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), l.currentTranslate > i.minTranslate() && (F = !1, c.resistance && (l.currentTranslate = i.minTranslate() - 1 + (-i.minTranslate() + l.startTranslate + I) ** j))) : I < 0 && (N && L && l.allowThresholdMove && l.currentTranslate < (c.centeredSlides ? i.maxTranslate() + i.slidesSizesGrid[i.slidesSizesGrid.length - 1] + i.params.spaceBetween + (c.slidesPerView !== "auto" && i.slides.length - c.slidesPerView >= 2 ? i.slidesSizesGrid[i.slidesSizesGrid.length - 1] + i.params.spaceBetween : 0) : i.maxTranslate()) && i.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: i.slides.length - (c.slidesPerView === "auto" ? i.slidesPerViewDynamic() : Math.ceil(parseFloat(c.slidesPerView, 10)))
  }), l.currentTranslate < i.maxTranslate() && (F = !1, c.resistance && (l.currentTranslate = i.maxTranslate() + 1 - (i.maxTranslate() - l.startTranslate - I) ** j))), F && (w.preventedByNestedSwiper = !0), !i.allowSlideNext && i.swipeDirection === "next" && l.currentTranslate < l.startTranslate && (l.currentTranslate = l.startTranslate), !i.allowSlidePrev && i.swipeDirection === "prev" && l.currentTranslate > l.startTranslate && (l.currentTranslate = l.startTranslate), !i.allowSlidePrev && !i.allowSlideNext && (l.currentTranslate = l.startTranslate), c.threshold > 0) if (Math.abs(I) > c.threshold || l.allowThresholdMove) {
    if (!l.allowThresholdMove) {
      l.allowThresholdMove = !0, p.startX = p.currentX, p.startY = p.currentY, l.currentTranslate = l.startTranslate, p.diff = i.isHorizontal() ? p.currentX - p.startX : p.currentY - p.startY;
      return;
    }
  } else {
    l.currentTranslate = l.startTranslate;
    return;
  }
  !c.followFinger || c.cssMode || ((c.freeMode && c.freeMode.enabled && i.freeMode || c.watchSlidesProgress) && (i.updateActiveIndex(), i.updateSlidesClasses()), c.freeMode && c.freeMode.enabled && i.freeMode && i.freeMode.onTouchMove(), i.updateProgress(l.currentTranslate), i.setTranslate(l.currentTranslate));
}
function Rte(t) {
  const e = this,
    i = e.touchEventsData;
  let l = t;
  l.originalEvent && (l = l.originalEvent);
  let c;
  if (l.type === "touchend" || l.type === "touchcancel") {
    if (c = [...l.changedTouches].find(V => V.identifier === i.touchId), !c || c.identifier !== i.touchId) return;
  } else {
    if (i.touchId !== null || l.pointerId !== i.pointerId) return;
    c = l;
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(l.type) && !(["pointercancel", "contextmenu"].includes(l.type) && (e.browser.isSafari || e.browser.isWebView))) return;
  i.pointerId = null, i.touchId = null;
  const {
    params: h,
    touches: y,
    rtlTranslate: w,
    slidesGrid: x,
    enabled: E
  } = e;
  if (!E || !h.simulateTouch && l.pointerType === "mouse") return;
  if (i.allowTouchCallbacks && e.emit("touchEnd", l), i.allowTouchCallbacks = !1, !i.isTouched) {
    i.isMoved && h.grabCursor && e.setGrabCursor(!1), i.isMoved = !1, i.startMoving = !1;
    return;
  }
  h.grabCursor && i.isMoved && i.isTouched && (e.allowSlideNext === !0 || e.allowSlidePrev === !0) && e.setGrabCursor(!1);
  const C = _O(),
    k = C - i.touchStartTime;
  if (e.allowClick) {
    const V = l.path || l.composedPath && l.composedPath();
    e.updateClickedSlide(V && V[0] || l.target, V), e.emit("tap click", l), k < 300 && C - i.lastClickTime < 300 && e.emit("doubleTap doubleClick", l);
  }
  if (i.lastClickTime = _O(), kN(() => {
    e.destroyed || (e.allowClick = !0);
  }), !i.isTouched || !i.isMoved || !e.swipeDirection || y.diff === 0 && !i.loopSwapReset || i.currentTranslate === i.startTranslate && !i.loopSwapReset) {
    i.isTouched = !1, i.isMoved = !1, i.startMoving = !1;
    return;
  }
  i.isTouched = !1, i.isMoved = !1, i.startMoving = !1;
  let D;
  if (h.followFinger ? D = w ? e.translate : -e.translate : D = -i.currentTranslate, h.cssMode) return;
  if (h.freeMode && h.freeMode.enabled) {
    e.freeMode.onTouchEnd({
      currentPos: D
    });
    return;
  }
  const I = D >= -e.maxTranslate() && !e.params.loop;
  let O = 0,
    P = e.slidesSizesGrid[0];
  for (let V = 0; V < x.length; V += V < h.slidesPerGroupSkip ? 1 : h.slidesPerGroup) {
    const K = V < h.slidesPerGroupSkip - 1 ? 1 : h.slidesPerGroup;
    typeof x[V + K] < "u" ? (I || D >= x[V] && D < x[V + K]) && (O = V, P = x[V + K] - x[V]) : (I || D >= x[V]) && (O = V, P = x[x.length - 1] - x[x.length - 2]);
  }
  let N = null,
    L = null;
  h.rewind && (e.isBeginning ? L = h.virtual && h.virtual.enabled && e.virtual ? e.virtual.slides.length - 1 : e.slides.length - 1 : e.isEnd && (N = 0));
  const F = (D - x[O]) / P,
    j = O < h.slidesPerGroupSkip - 1 ? 1 : h.slidesPerGroup;
  if (k > h.longSwipesMs) {
    if (!h.longSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.swipeDirection === "next" && (F >= h.longSwipesRatio ? e.slideTo(h.rewind && e.isEnd ? N : O + j) : e.slideTo(O)), e.swipeDirection === "prev" && (F > 1 - h.longSwipesRatio ? e.slideTo(O + j) : L !== null && F < 0 && Math.abs(F) > h.longSwipesRatio ? e.slideTo(L) : e.slideTo(O));
  } else {
    if (!h.shortSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.navigation && (l.target === e.navigation.nextEl || l.target === e.navigation.prevEl) ? l.target === e.navigation.nextEl ? e.slideTo(O + j) : e.slideTo(O) : (e.swipeDirection === "next" && e.slideTo(N !== null ? N : O + j), e.swipeDirection === "prev" && e.slideTo(L !== null ? L : O));
  }
}
function gB() {
  const t = this,
    {
      params: e,
      el: i
    } = t;
  if (i && i.offsetWidth === 0) return;
  e.breakpoints && t.setBreakpoint();
  const {
      allowSlideNext: l,
      allowSlidePrev: c,
      snapGrid: p
    } = t,
    h = t.virtual && t.params.virtual.enabled;
  t.allowSlideNext = !0, t.allowSlidePrev = !0, t.updateSize(), t.updateSlides(), t.updateSlidesClasses();
  const y = h && e.loop;
  (e.slidesPerView === "auto" || e.slidesPerView > 1) && t.isEnd && !t.isBeginning && !t.params.centeredSlides && !y ? t.slideTo(t.slides.length - 1, 0, !1, !0) : t.params.loop && !h ? t.slideToLoop(t.realIndex, 0, !1, !0) : t.slideTo(t.activeIndex, 0, !1, !0), t.autoplay && t.autoplay.running && t.autoplay.paused && (clearTimeout(t.autoplay.resizeTimeout), t.autoplay.resizeTimeout = setTimeout(() => {
    t.autoplay && t.autoplay.running && t.autoplay.paused && t.autoplay.resume();
  }, 500)), t.allowSlidePrev = c, t.allowSlideNext = l, t.params.watchOverflow && p !== t.snapGrid && t.checkOverflow();
}
function Dte(t) {
  const e = this;
  e.enabled && (e.allowClick || (e.params.preventClicks && t.preventDefault(), e.params.preventClicksPropagation && e.animating && (t.stopPropagation(), t.stopImmediatePropagation())));
}
function Ite() {
  const t = this,
    {
      wrapperEl: e,
      rtlTranslate: i,
      enabled: l
    } = t;
  if (!l) return;
  t.previousTranslate = t.translate, t.isHorizontal() ? t.translate = -e.scrollLeft : t.translate = -e.scrollTop, t.translate === 0 && (t.translate = 0), t.updateActiveIndex(), t.updateSlidesClasses();
  let c;
  const p = t.maxTranslate() - t.minTranslate();
  p === 0 ? c = 0 : c = (t.translate - t.minTranslate()) / p, c !== t.progress && t.updateProgress(i ? -t.translate : t.translate), t.emit("setTranslate", t.translate, !1);
}
function Mte(t) {
  const e = this;
  HM(e, t.target), !(e.params.cssMode || e.params.slidesPerView !== "auto" && !e.params.autoHeight) && e.update();
}
function Ote() {
  const t = this;
  t.documentTouchHandlerProceeded || (t.documentTouchHandlerProceeded = !0, t.params.touchReleaseOnEdges && (t.el.style.touchAction = "auto"));
}
const t$ = (t, e) => {
  const i = Gm(),
    {
      params: l,
      el: c,
      wrapperEl: p,
      device: h
    } = t,
    y = !!l.nested,
    w = e === "on" ? "addEventListener" : "removeEventListener",
    x = e;
  !c || typeof c == "string" || (i[w]("touchstart", t.onDocumentTouchStart, {
    passive: !1,
    capture: y
  }), c[w]("touchstart", t.onTouchStart, {
    passive: !1
  }), c[w]("pointerdown", t.onTouchStart, {
    passive: !1
  }), i[w]("touchmove", t.onTouchMove, {
    passive: !1,
    capture: y
  }), i[w]("pointermove", t.onTouchMove, {
    passive: !1,
    capture: y
  }), i[w]("touchend", t.onTouchEnd, {
    passive: !0
  }), i[w]("pointerup", t.onTouchEnd, {
    passive: !0
  }), i[w]("pointercancel", t.onTouchEnd, {
    passive: !0
  }), i[w]("touchcancel", t.onTouchEnd, {
    passive: !0
  }), i[w]("pointerout", t.onTouchEnd, {
    passive: !0
  }), i[w]("pointerleave", t.onTouchEnd, {
    passive: !0
  }), i[w]("contextmenu", t.onTouchEnd, {
    passive: !0
  }), (l.preventClicks || l.preventClicksPropagation) && c[w]("click", t.onClick, !0), l.cssMode && p[w]("scroll", t.onScroll), l.updateOnWindowResize ? t[x](h.ios || h.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", gB, !0) : t[x]("observerUpdate", gB, !0), c[w]("load", t.onLoad, {
    capture: !0
  }));
};
function Lte() {
  const t = this,
    {
      params: e
    } = t;
  t.onTouchStart = kte.bind(t), t.onTouchMove = Tte.bind(t), t.onTouchEnd = Rte.bind(t), t.onDocumentTouchStart = Ote.bind(t), e.cssMode && (t.onScroll = Ite.bind(t)), t.onClick = Dte.bind(t), t.onLoad = Mte.bind(t), t$(t, "on");
}
function Pte() {
  t$(this, "off");
}
var Ate = {
  attachEvents: Lte,
  detachEvents: Pte
};
const yB = (t, e) => t.grid && e.grid && e.grid.rows > 1;
function jte() {
  const t = this,
    {
      realIndex: e,
      initialized: i,
      params: l,
      el: c
    } = t,
    p = l.breakpoints;
  if (!p || p && Object.keys(p).length === 0) return;
  const h = Gm(),
    y = l.breakpointsBase === "window" || !l.breakpointsBase ? l.breakpointsBase : "container",
    w = ["window", "container"].includes(l.breakpointsBase) || !l.breakpointsBase ? t.el : h.querySelector(l.breakpointsBase),
    x = t.getBreakpoint(p, y, w);
  if (!x || t.currentBreakpoint === x) return;
  const C = (x in p ? p[x] : void 0) || t.originalParams,
    k = yB(t, l),
    D = yB(t, C),
    I = t.params.grabCursor,
    O = C.grabCursor,
    P = l.enabled;
  k && !D ? (c.classList.remove(`${l.containerModifierClass}grid`, `${l.containerModifierClass}grid-column`), t.emitContainerClasses()) : !k && D && (c.classList.add(`${l.containerModifierClass}grid`), (C.grid.fill && C.grid.fill === "column" || !C.grid.fill && l.grid.fill === "column") && c.classList.add(`${l.containerModifierClass}grid-column`), t.emitContainerClasses()), I && !O ? t.unsetGrabCursor() : !I && O && t.setGrabCursor(), ["navigation", "pagination", "scrollbar"].forEach(K => {
    if (typeof C[K] > "u") return;
    const G = l[K] && l[K].enabled,
      Q = C[K] && C[K].enabled;
    G && !Q && t[K].disable(), !G && Q && t[K].enable();
  });
  const N = C.direction && C.direction !== l.direction,
    L = l.loop && (C.slidesPerView !== l.slidesPerView || N),
    F = l.loop;
  N && i && t.changeDirection(), rp(t.params, C);
  const j = t.params.enabled,
    V = t.params.loop;
  Object.assign(t, {
    allowTouchMove: t.params.allowTouchMove,
    allowSlideNext: t.params.allowSlideNext,
    allowSlidePrev: t.params.allowSlidePrev
  }), P && !j ? t.disable() : !P && j && t.enable(), t.currentBreakpoint = x, t.emit("_beforeBreakpoint", C), i && (L ? (t.loopDestroy(), t.loopCreate(e), t.updateSlides()) : !F && V ? (t.loopCreate(e), t.updateSlides()) : F && !V && t.loopDestroy()), t.emit("breakpoint", C);
}
function Fte(t, e, i) {
  if (e === void 0 && (e = "window"), !t || e === "container" && !i) return;
  let l = !1;
  const c = wl(),
    p = e === "window" ? c.innerHeight : i.clientHeight,
    h = Object.keys(t).map(y => {
      if (typeof y == "string" && y.indexOf("@") === 0) {
        const w = parseFloat(y.substr(1));
        return {
          value: p * w,
          point: y
        };
      }
      return {
        value: y,
        point: y
      };
    });
  h.sort((y, w) => parseInt(y.value, 10) - parseInt(w.value, 10));
  for (let y = 0; y < h.length; y += 1) {
    const {
      point: w,
      value: x
    } = h[y];
    e === "window" ? c.matchMedia(`(min-width: ${x}px)`).matches && (l = w) : x <= i.clientWidth && (l = w);
  }
  return l || "max";
}
var Nte = {
  setBreakpoint: jte,
  getBreakpoint: Fte
};
function zte(t, e) {
  const i = [];
  return t.forEach(l => {
    typeof l == "object" ? Object.keys(l).forEach(c => {
      l[c] && i.push(e + c);
    }) : typeof l == "string" && i.push(e + l);
  }), i;
}
function Vte() {
  const t = this,
    {
      classNames: e,
      params: i,
      rtl: l,
      el: c,
      device: p
    } = t,
    h = zte(["initialized", i.direction, {
      "free-mode": t.params.freeMode && i.freeMode.enabled
    }, {
      autoheight: i.autoHeight
    }, {
      rtl: l
    }, {
      grid: i.grid && i.grid.rows > 1
    }, {
      "grid-column": i.grid && i.grid.rows > 1 && i.grid.fill === "column"
    }, {
      android: p.android
    }, {
      ios: p.ios
    }, {
      "css-mode": i.cssMode
    }, {
      centered: i.cssMode && i.centeredSlides
    }, {
      "watch-progress": i.watchSlidesProgress
    }], i.containerModifierClass);
  e.push(...h), c.classList.add(...e), t.emitContainerClasses();
}
function Bte() {
  const t = this,
    {
      el: e,
      classNames: i
    } = t;
  !e || typeof e == "string" || (e.classList.remove(...i), t.emitContainerClasses());
}
var Ute = {
  addClasses: Vte,
  removeClasses: Bte
};
function Hte() {
  const t = this,
    {
      isLocked: e,
      params: i
    } = t,
    {
      slidesOffsetBefore: l
    } = i;
  if (l) {
    const c = t.slides.length - 1,
      p = t.slidesGrid[c] + t.slidesSizesGrid[c] + l * 2;
    t.isLocked = t.size > p;
  } else t.isLocked = t.snapGrid.length === 1;
  i.allowSlideNext === !0 && (t.allowSlideNext = !t.isLocked), i.allowSlidePrev === !0 && (t.allowSlidePrev = !t.isLocked), e && e !== t.isLocked && (t.isEnd = !1), e !== t.isLocked && t.emit(t.isLocked ? "lock" : "unlock");
}
var $te = {
    checkOverflow: Hte
  },
  Uj = {
    init: !0,
    direction: "horizontal",
    oneWayMovement: !1,
    swiperElementNodeName: "SWIPER-CONTAINER",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: !1,
    updateOnWindowResize: !0,
    resizeObserver: !0,
    nested: !1,
    createElements: !1,
    eventsPrefix: "swiper",
    enabled: !0,
    focusableElements: "input, select, option, textarea, button, video, label",
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: !1,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: !1,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: !1,
    // Set wrapper width
    setWrapperSize: !1,
    // Virtual Translate
    virtualTranslate: !1,
    // Effects
    effect: "slide",
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: void 0,
    breakpointsBase: "window",
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: !1,
    centeredSlides: !1,
    centeredSlidesBounds: !1,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: !0,
    centerInsufficientSlides: !1,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: !0,
    // Round length
    roundLengths: !1,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: !0,
    shortSwipes: !0,
    longSwipes: !0,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: !0,
    allowTouchMove: !0,
    threshold: 5,
    touchMoveStopPropagation: !1,
    touchStartPreventDefault: !0,
    touchStartForcePreventDefault: !1,
    touchReleaseOnEdges: !1,
    // Unique Navigation Elements
    uniqueNavElements: !0,
    // Resistance
    resistance: !0,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: !1,
    // Cursor
    grabCursor: !1,
    // Clicks
    preventClicks: !0,
    preventClicksPropagation: !0,
    slideToClickedSlide: !1,
    // loop
    loop: !1,
    loopAddBlankSlides: !0,
    loopAdditionalSlides: 0,
    loopPreventsSliding: !0,
    // rewind
    rewind: !1,
    // Swiping/no swiping
    allowSlidePrev: !0,
    allowSlideNext: !0,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: !0,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: !0,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: "swiper-",
    // NEW
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-blank",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideFullyVisibleClass: "swiper-slide-fully-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: !0,
    // Internals
    _emitClasses: !1
  };
function Wte(t, e) {
  return function (l) {
    l === void 0 && (l = {});
    const c = Object.keys(l)[0],
      p = l[c];
    if (typeof p != "object" || p === null) {
      rp(e, l);
      return;
    }
    if (t[c] === !0 && (t[c] = {
      enabled: !0
    }), c === "navigation" && t[c] && t[c].enabled && !t[c].prevEl && !t[c].nextEl && (t[c].auto = !0), ["pagination", "scrollbar"].indexOf(c) >= 0 && t[c] && t[c].enabled && !t[c].el && (t[c].auto = !0), !(c in t && "enabled" in p)) {
      rp(e, l);
      return;
    }
    typeof t[c] == "object" && !("enabled" in t[c]) && (t[c].enabled = !0), t[c] || (t[c] = {
      enabled: !1
    }), rp(e, l);
  };
}
const I2 = {
    eventsEmitter: Uee,
    update: Jee,
    translate: ate,
    transition: ute,
    slide: gte,
    loop: _te,
    grabCursor: Ete,
    events: Ate,
    breakpoints: Nte,
    checkOverflow: $te,
    classes: Ute
  },
  M2 = {};
let TN = class ub {
  constructor() {
    let e, i;
    for (var l = arguments.length, c = new Array(l), p = 0; p < l; p++) c[p] = arguments[p];
    c.length === 1 && c[0].constructor && Object.prototype.toString.call(c[0]).slice(8, -1) === "Object" ? i = c[0] : [e, i] = c, i || (i = {}), i = rp({}, i), e && !i.el && (i.el = e);
    const h = Gm();
    if (i.el && typeof i.el == "string" && h.querySelectorAll(i.el).length > 1) {
      const E = [];
      return h.querySelectorAll(i.el).forEach(C => {
        const k = rp({}, i, {
          el: C
        });
        E.push(new ub(k));
      }), E;
    }
    const y = this;
    y.__swiper__ = !0, y.support = Q4(), y.device = Z4({
      userAgent: i.userAgent
    }), y.browser = J4(), y.eventsListeners = {}, y.eventsAnyListeners = [], y.modules = [...y.__modules__], i.modules && Array.isArray(i.modules) && y.modules.push(...i.modules);
    const w = {};
    y.modules.forEach(E => {
      E({
        params: i,
        swiper: y,
        extendParams: Wte(i, w),
        on: y.on.bind(y),
        once: y.once.bind(y),
        off: y.off.bind(y),
        emit: y.emit.bind(y)
      });
    });
    const x = rp({}, Uj, w);
    return y.params = rp({}, x, M2, i), y.originalParams = rp({}, y.params), y.passedParams = rp({}, i), y.params && y.params.on && Object.keys(y.params.on).forEach(E => {
      y.on(E, y.params.on[E]);
    }), y.params && y.params.onAny && y.onAny(y.params.onAny), Object.assign(y, {
      enabled: y.params.enabled,
      el: e,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return y.params.direction === "horizontal";
      },
      isVertical() {
        return y.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: y.params.allowSlideNext,
      allowSlidePrev: y.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: y.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: y.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), y.emit("_swiper"), y.params.init && y.init(), y;
  }
  getDirectionLabel(e) {
    return this.isHorizontal() ? e : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[e];
  }
  getSlideIndex(e) {
    const {
        slidesEl: i,
        params: l
      } = this,
      c = Np(i, `.${l.slideClass}, swiper-slide`),
      p = pR(c[0]);
    return pR(e) - p;
  }
  getSlideIndexByData(e) {
    return this.getSlideIndex(this.slides.find(i => i.getAttribute("data-swiper-slide-index") * 1 === e));
  }
  getSlideIndexWhenGrid(e) {
    return this.grid && this.params.grid && this.params.grid.rows > 1 && (this.params.grid.fill === "column" ? e = Math.floor(e / this.params.grid.rows) : this.params.grid.fill === "row" && (e = e % Math.ceil(this.slides.length / this.params.grid.rows))), e;
  }
  recalcSlides() {
    const e = this,
      {
        slidesEl: i,
        params: l
      } = e;
    e.slides = Np(i, `.${l.slideClass}, swiper-slide`);
  }
  enable() {
    const e = this;
    e.enabled || (e.enabled = !0, e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
  }
  disable() {
    const e = this;
    e.enabled && (e.enabled = !1, e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
  }
  setProgress(e, i) {
    const l = this;
    e = Math.min(Math.max(e, 0), 1);
    const c = l.minTranslate(),
      h = (l.maxTranslate() - c) * e + c;
    l.translateTo(h, typeof i > "u" ? 0 : i), l.updateActiveIndex(), l.updateSlidesClasses();
  }
  emitContainerClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const i = e.el.className.split(" ").filter(l => l.indexOf("swiper") === 0 || l.indexOf(e.params.containerModifierClass) === 0);
    e.emit("_containerClasses", i.join(" "));
  }
  getSlideClasses(e) {
    const i = this;
    return i.destroyed ? "" : e.className.split(" ").filter(l => l.indexOf("swiper-slide") === 0 || l.indexOf(i.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const i = [];
    e.slides.forEach(l => {
      const c = e.getSlideClasses(l);
      i.push({
        slideEl: l,
        classNames: c
      }), e.emit("_slideClass", l, c);
    }), e.emit("_slideClasses", i);
  }
  slidesPerViewDynamic(e, i) {
    e === void 0 && (e = "current"), i === void 0 && (i = !1);
    const l = this,
      {
        params: c,
        slides: p,
        slidesGrid: h,
        slidesSizesGrid: y,
        size: w,
        activeIndex: x
      } = l;
    let E = 1;
    if (typeof c.slidesPerView == "number") return c.slidesPerView;
    if (c.centeredSlides) {
      let C = p[x] ? Math.ceil(p[x].swiperSlideSize) : 0,
        k;
      for (let D = x + 1; D < p.length; D += 1) p[D] && !k && (C += Math.ceil(p[D].swiperSlideSize), E += 1, C > w && (k = !0));
      for (let D = x - 1; D >= 0; D -= 1) p[D] && !k && (C += p[D].swiperSlideSize, E += 1, C > w && (k = !0));
    } else if (e === "current") for (let C = x + 1; C < p.length; C += 1) (i ? h[C] + y[C] - h[x] < w : h[C] - h[x] < w) && (E += 1);else for (let C = x - 1; C >= 0; C -= 1) h[x] - h[C] < w && (E += 1);
    return E;
  }
  update() {
    const e = this;
    if (!e || e.destroyed) return;
    const {
      snapGrid: i,
      params: l
    } = e;
    l.breakpoints && e.setBreakpoint(), [...e.el.querySelectorAll('[loading="lazy"]')].forEach(h => {
      h.complete && HM(e, h);
    }), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses();
    function c() {
      const h = e.rtlTranslate ? e.translate * -1 : e.translate,
        y = Math.min(Math.max(h, e.maxTranslate()), e.minTranslate());
      e.setTranslate(y), e.updateActiveIndex(), e.updateSlidesClasses();
    }
    let p;
    if (l.freeMode && l.freeMode.enabled && !l.cssMode) c(), l.autoHeight && e.updateAutoHeight();else {
      if ((l.slidesPerView === "auto" || l.slidesPerView > 1) && e.isEnd && !l.centeredSlides) {
        const h = e.virtual && l.virtual.enabled ? e.virtual.slides : e.slides;
        p = e.slideTo(h.length - 1, 0, !1, !0);
      } else p = e.slideTo(e.activeIndex, 0, !1, !0);
      p || c();
    }
    l.watchOverflow && i !== e.snapGrid && e.checkOverflow(), e.emit("update");
  }
  changeDirection(e, i) {
    i === void 0 && (i = !0);
    const l = this,
      c = l.params.direction;
    return e || (e = c === "horizontal" ? "vertical" : "horizontal"), e === c || e !== "horizontal" && e !== "vertical" || (l.el.classList.remove(`${l.params.containerModifierClass}${c}`), l.el.classList.add(`${l.params.containerModifierClass}${e}`), l.emitContainerClasses(), l.params.direction = e, l.slides.forEach(p => {
      e === "vertical" ? p.style.width = "" : p.style.height = "";
    }), l.emit("changeDirection"), i && l.update()), l;
  }
  changeLanguageDirection(e) {
    const i = this;
    i.rtl && e === "rtl" || !i.rtl && e === "ltr" || (i.rtl = e === "rtl", i.rtlTranslate = i.params.direction === "horizontal" && i.rtl, i.rtl ? (i.el.classList.add(`${i.params.containerModifierClass}rtl`), i.el.dir = "rtl") : (i.el.classList.remove(`${i.params.containerModifierClass}rtl`), i.el.dir = "ltr"), i.update());
  }
  mount(e) {
    const i = this;
    if (i.mounted) return !0;
    let l = e || i.params.el;
    if (typeof l == "string" && (l = document.querySelector(l)), !l) return !1;
    l.swiper = i, l.parentNode && l.parentNode.host && l.parentNode.host.nodeName === i.params.swiperElementNodeName.toUpperCase() && (i.isElement = !0);
    const c = () => `.${(i.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let h = l && l.shadowRoot && l.shadowRoot.querySelector ? l.shadowRoot.querySelector(c()) : Np(l, c())[0];
    return !h && i.params.createElements && (h = fR("div", i.params.wrapperClass), l.append(h), Np(l, `.${i.params.slideClass}`).forEach(y => {
      h.append(y);
    })), Object.assign(i, {
      el: l,
      wrapperEl: h,
      slidesEl: i.isElement && !l.parentNode.host.slideSlots ? l.parentNode.host : h,
      hostEl: i.isElement ? l.parentNode.host : l,
      mounted: !0,
      // RTL
      rtl: l.dir.toLowerCase() === "rtl" || Z0(l, "direction") === "rtl",
      rtlTranslate: i.params.direction === "horizontal" && (l.dir.toLowerCase() === "rtl" || Z0(l, "direction") === "rtl"),
      wrongRTL: Z0(h, "display") === "-webkit-box"
    }), !0;
  }
  init(e) {
    const i = this;
    if (i.initialized || i.mount(e) === !1) return i;
    i.emit("beforeInit"), i.params.breakpoints && i.setBreakpoint(), i.addClasses(), i.updateSize(), i.updateSlides(), i.params.watchOverflow && i.checkOverflow(), i.params.grabCursor && i.enabled && i.setGrabCursor(), i.params.loop && i.virtual && i.params.virtual.enabled ? i.slideTo(i.params.initialSlide + i.virtual.slidesBefore, 0, i.params.runCallbacksOnInit, !1, !0) : i.slideTo(i.params.initialSlide, 0, i.params.runCallbacksOnInit, !1, !0), i.params.loop && i.loopCreate(void 0, !0), i.attachEvents();
    const c = [...i.el.querySelectorAll('[loading="lazy"]')];
    return i.isElement && c.push(...i.hostEl.querySelectorAll('[loading="lazy"]')), c.forEach(p => {
      p.complete ? HM(i, p) : p.addEventListener("load", h => {
        HM(i, h.target);
      });
    }), Bj(i), i.initialized = !0, Bj(i), i.emit("init"), i.emit("afterInit"), i;
  }
  destroy(e, i) {
    e === void 0 && (e = !0), i === void 0 && (i = !0);
    const l = this,
      {
        params: c,
        el: p,
        wrapperEl: h,
        slides: y
      } = l;
    return typeof l.params > "u" || l.destroyed || (l.emit("beforeDestroy"), l.initialized = !1, l.detachEvents(), c.loop && l.loopDestroy(), i && (l.removeClasses(), p && typeof p != "string" && p.removeAttribute("style"), h && h.removeAttribute("style"), y && y.length && y.forEach(w => {
      w.classList.remove(c.slideVisibleClass, c.slideFullyVisibleClass, c.slideActiveClass, c.slideNextClass, c.slidePrevClass), w.removeAttribute("style"), w.removeAttribute("data-swiper-slide-index");
    })), l.emit("destroy"), Object.keys(l.eventsListeners).forEach(w => {
      l.off(w);
    }), e !== !1 && (l.el && typeof l.el != "string" && (l.el.swiper = null), Ree(l)), l.destroyed = !0), null;
  }
  static extendDefaults(e) {
    rp(M2, e);
  }
  static get extendedDefaults() {
    return M2;
  }
  static get defaults() {
    return Uj;
  }
  static installModule(e) {
    ub.prototype.__modules__ || (ub.prototype.__modules__ = []);
    const i = ub.prototype.__modules__;
    typeof e == "function" && i.indexOf(e) < 0 && i.push(e);
  }
  static use(e) {
    return Array.isArray(e) ? (e.forEach(i => ub.installModule(i)), ub) : (ub.installModule(e), ub);
  }
};
Object.keys(I2).forEach(t => {
  Object.keys(I2[t]).forEach(e => {
    TN.prototype[e] = I2[t][e];
  });
});
TN.use([Vee, Bee]);
const n$ = ["eventsPrefix", "injectStyles", "injectStylesUrls", "modules", "init", "_direction", "oneWayMovement", "swiperElementNodeName", "touchEventsTarget", "initialSlide", "_speed", "cssMode", "updateOnWindowResize", "resizeObserver", "nested", "focusableElements", "_enabled", "_width", "_height", "preventInteractionOnTransition", "userAgent", "url", "_edgeSwipeDetection", "_edgeSwipeThreshold", "_freeMode", "_autoHeight", "setWrapperSize", "virtualTranslate", "_effect", "breakpoints", "breakpointsBase", "_spaceBetween", "_slidesPerView", "maxBackfaceHiddenSlides", "_grid", "_slidesPerGroup", "_slidesPerGroupSkip", "_slidesPerGroupAuto", "_centeredSlides", "_centeredSlidesBounds", "_slidesOffsetBefore", "_slidesOffsetAfter", "normalizeSlideIndex", "_centerInsufficientSlides", "_watchOverflow", "roundLengths", "touchRatio", "touchAngle", "simulateTouch", "_shortSwipes", "_longSwipes", "longSwipesRatio", "longSwipesMs", "_followFinger", "allowTouchMove", "_threshold", "touchMoveStopPropagation", "touchStartPreventDefault", "touchStartForcePreventDefault", "touchReleaseOnEdges", "uniqueNavElements", "_resistance", "_resistanceRatio", "_watchSlidesProgress", "_grabCursor", "preventClicks", "preventClicksPropagation", "_slideToClickedSlide", "_loop", "loopAdditionalSlides", "loopAddBlankSlides", "loopPreventsSliding", "_rewind", "_allowSlidePrev", "_allowSlideNext", "_swipeHandler", "_noSwiping", "noSwipingClass", "noSwipingSelector", "passiveListeners", "containerModifierClass", "slideClass", "slideActiveClass", "slideVisibleClass", "slideFullyVisibleClass", "slideNextClass", "slidePrevClass", "slideBlankClass", "wrapperClass", "lazyPreloaderClass", "lazyPreloadPrevNext", "runCallbacksOnInit", "observer", "observeParents", "observeSlideChildren",
// modules
"a11y", "_autoplay", "_controller", "coverflowEffect", "cubeEffect", "fadeEffect", "flipEffect", "creativeEffect", "cardsEffect", "hashNavigation", "history", "keyboard", "mousewheel", "_navigation", "_pagination", "parallax", "_scrollbar", "_thumbs", "virtual", "zoom", "control"];
function eS(t) {
  return typeof t == "object" && t !== null && t.constructor && Object.prototype.toString.call(t).slice(8, -1) === "Object" && !t.__swiper__;
}
function hE(t, e) {
  const i = ["__proto__", "constructor", "prototype"];
  Object.keys(e).filter(l => i.indexOf(l) < 0).forEach(l => {
    typeof t[l] > "u" ? t[l] = e[l] : eS(e[l]) && eS(t[l]) && Object.keys(e[l]).length > 0 ? e[l].__swiper__ ? t[l] = e[l] : hE(t[l], e[l]) : t[l] = e[l];
  });
}
function r$(t) {
  return t === void 0 && (t = {}), t.navigation && typeof t.navigation.nextEl > "u" && typeof t.navigation.prevEl > "u";
}
function i$(t) {
  return t === void 0 && (t = {}), t.pagination && typeof t.pagination.el > "u";
}
function a$(t) {
  return t === void 0 && (t = {}), t.scrollbar && typeof t.scrollbar.el > "u";
}
function o$(t) {
  t === void 0 && (t = "");
  const e = t.split(" ").map(l => l.trim()).filter(l => !!l),
    i = [];
  return e.forEach(l => {
    i.indexOf(l) < 0 && i.push(l);
  }), i.join(" ");
}
function qte(t) {
  return t === void 0 && (t = ""), t ? t.includes("swiper-wrapper") ? t : `swiper-wrapper ${t}` : "swiper-wrapper";
}
function Yte(t) {
  let {
    swiper: e,
    slides: i,
    passedParams: l,
    changedParams: c,
    nextEl: p,
    prevEl: h,
    scrollbarEl: y,
    paginationEl: w
  } = t;
  const x = c.filter(te => te !== "children" && te !== "direction" && te !== "wrapperClass"),
    {
      params: E,
      pagination: C,
      navigation: k,
      scrollbar: D,
      virtual: I,
      thumbs: O
    } = e;
  let P, N, L, F, j, V, K, G;
  c.includes("thumbs") && l.thumbs && l.thumbs.swiper && !l.thumbs.swiper.destroyed && E.thumbs && (!E.thumbs.swiper || E.thumbs.swiper.destroyed) && (P = !0), c.includes("controller") && l.controller && l.controller.control && E.controller && !E.controller.control && (N = !0), c.includes("pagination") && l.pagination && (l.pagination.el || w) && (E.pagination || E.pagination === !1) && C && !C.el && (L = !0), c.includes("scrollbar") && l.scrollbar && (l.scrollbar.el || y) && (E.scrollbar || E.scrollbar === !1) && D && !D.el && (F = !0), c.includes("navigation") && l.navigation && (l.navigation.prevEl || h) && (l.navigation.nextEl || p) && (E.navigation || E.navigation === !1) && k && !k.prevEl && !k.nextEl && (j = !0);
  const Q = te => {
    e[te] && (e[te].destroy(), te === "navigation" ? (e.isElement && (e[te].prevEl.remove(), e[te].nextEl.remove()), E[te].prevEl = void 0, E[te].nextEl = void 0, e[te].prevEl = void 0, e[te].nextEl = void 0) : (e.isElement && e[te].el.remove(), E[te].el = void 0, e[te].el = void 0));
  };
  c.includes("loop") && e.isElement && (E.loop && !l.loop ? V = !0 : !E.loop && l.loop ? K = !0 : G = !0), x.forEach(te => {
    if (eS(E[te]) && eS(l[te])) Object.assign(E[te], l[te]), (te === "navigation" || te === "pagination" || te === "scrollbar") && "enabled" in l[te] && !l[te].enabled && Q(te);else {
      const ie = l[te];
      (ie === !0 || ie === !1) && (te === "navigation" || te === "pagination" || te === "scrollbar") ? ie === !1 && Q(te) : E[te] = l[te];
    }
  }), x.includes("controller") && !N && e.controller && e.controller.control && E.controller && E.controller.control && (e.controller.control = E.controller.control), c.includes("children") && i && I && E.virtual.enabled ? (I.slides = i, I.update(!0)) : c.includes("virtual") && I && E.virtual.enabled && (i && (I.slides = i), I.update(!0)), c.includes("children") && i && E.loop && (G = !0), P && O.init() && O.update(!0), N && (e.controller.control = E.controller.control), L && (e.isElement && (!w || typeof w == "string") && (w = document.createElement("div"), w.classList.add("swiper-pagination"), w.part.add("pagination"), e.el.appendChild(w)), w && (E.pagination.el = w), C.init(), C.render(), C.update()), F && (e.isElement && (!y || typeof y == "string") && (y = document.createElement("div"), y.classList.add("swiper-scrollbar"), y.part.add("scrollbar"), e.el.appendChild(y)), y && (E.scrollbar.el = y), D.init(), D.updateSize(), D.setTranslate()), j && (e.isElement && ((!p || typeof p == "string") && (p = document.createElement("div"), p.classList.add("swiper-button-next"), hR(p, e.hostEl.constructor.nextButtonSvg), p.part.add("button-next"), e.el.appendChild(p)), (!h || typeof h == "string") && (h = document.createElement("div"), h.classList.add("swiper-button-prev"), hR(h, e.hostEl.constructor.prevButtonSvg), h.part.add("button-prev"), e.el.appendChild(h))), p && (E.navigation.nextEl = p), h && (E.navigation.prevEl = h), k.init(), k.update()), c.includes("allowSlideNext") && (e.allowSlideNext = l.allowSlideNext), c.includes("allowSlidePrev") && (e.allowSlidePrev = l.allowSlidePrev), c.includes("direction") && e.changeDirection(l.direction, !1), (V || G) && e.loopDestroy(), (K || G) && e.loopCreate(), e.update();
}
function Gte(t, e) {
  t === void 0 && (t = {}), e === void 0 && (e = !0);
  const i = {
      on: {}
    },
    l = {},
    c = {};
  hE(i, Uj), i._emitClasses = !0, i.init = !1;
  const p = {},
    h = n$.map(w => w.replace(/_/, "")),
    y = Object.assign({}, t);
  return Object.keys(y).forEach(w => {
    typeof t[w] > "u" || (h.indexOf(w) >= 0 ? eS(t[w]) ? (i[w] = {}, c[w] = {}, hE(i[w], t[w]), hE(c[w], t[w])) : (i[w] = t[w], c[w] = t[w]) : w.search(/on[A-Z]/) === 0 && typeof t[w] == "function" ? e ? l[`${w[2].toLowerCase()}${w.substr(3)}`] = t[w] : i.on[`${w[2].toLowerCase()}${w.substr(3)}`] = t[w] : p[w] = t[w]);
  }), ["navigation", "pagination", "scrollbar"].forEach(w => {
    i[w] === !0 && (i[w] = {}), i[w] === !1 && delete i[w];
  }), {
    params: i,
    passedParams: c,
    rest: p,
    events: l
  };
}
function Xte(t, e) {
  let {
    el: i,
    nextEl: l,
    prevEl: c,
    paginationEl: p,
    scrollbarEl: h,
    swiper: y
  } = t;
  r$(e) && l && c && (y.params.navigation.nextEl = l, y.originalParams.navigation.nextEl = l, y.params.navigation.prevEl = c, y.originalParams.navigation.prevEl = c), i$(e) && p && (y.params.pagination.el = p, y.originalParams.pagination.el = p), a$(e) && h && (y.params.scrollbar.el = h, y.originalParams.scrollbar.el = h), y.init(i);
}
function Kte(t, e, i, l, c) {
  const p = [];
  if (!e) return p;
  const h = w => {
    p.indexOf(w) < 0 && p.push(w);
  };
  if (i && l) {
    const w = l.map(c),
      x = i.map(c);
    w.join("") !== x.join("") && h("children"), l.length !== i.length && h("children");
  }
  return n$.filter(w => w[0] === "_").map(w => w.replace(/_/, "")).forEach(w => {
    if (w in t && w in e) if (eS(t[w]) && eS(e[w])) {
      const x = Object.keys(t[w]),
        E = Object.keys(e[w]);
      x.length !== E.length ? h(w) : (x.forEach(C => {
        t[w][C] !== e[w][C] && h(w);
      }), E.forEach(C => {
        t[w][C] !== e[w][C] && h(w);
      }));
    } else t[w] !== e[w] && h(w);
  }), p;
}
const Qte = t => {
  !t || t.destroyed || !t.params.virtual || t.params.virtual && !t.params.virtual.enabled || (t.updateSlides(), t.updateProgress(), t.updateSlidesClasses(), t.emit("_virtualUpdated"), t.parallax && t.params.parallax && t.params.parallax.enabled && t.parallax.setTranslate());
};
function SO() {
  return SO = Object.assign ? Object.assign.bind() : function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var i = arguments[e];
      for (var l in i) Object.prototype.hasOwnProperty.call(i, l) && (t[l] = i[l]);
    }
    return t;
  }, SO.apply(this, arguments);
}
function s$(t) {
  return t.type && t.type.displayName && t.type.displayName.includes("SwiperSlide");
}
function l$(t) {
  const e = [];
  return Nt.Children.toArray(t).forEach(i => {
    s$(i) ? e.push(i) : i.props && i.props.children && l$(i.props.children).forEach(l => e.push(l));
  }), e;
}
function Zte(t) {
  const e = [],
    i = {
      "container-start": [],
      "container-end": [],
      "wrapper-start": [],
      "wrapper-end": []
    };
  return Nt.Children.toArray(t).forEach(l => {
    if (s$(l)) e.push(l);else if (l.props && l.props.slot && i[l.props.slot]) i[l.props.slot].push(l);else if (l.props && l.props.children) {
      const c = l$(l.props.children);
      c.length > 0 ? c.forEach(p => e.push(p)) : i["container-end"].push(l);
    } else i["container-end"].push(l);
  }), {
    slides: e,
    slots: i
  };
}
function Jte(t, e, i) {
  if (!i) return null;
  const l = E => {
      let C = E;
      return E < 0 ? C = e.length + E : C >= e.length && (C = C - e.length), C;
    },
    c = t.isHorizontal() ? {
      [t.rtlTranslate ? "right" : "left"]: `${i.offset}px`
    } : {
      top: `${i.offset}px`
    },
    {
      from: p,
      to: h
    } = i,
    y = t.params.loop ? -e.length : 0,
    w = t.params.loop ? e.length * 2 : e.length,
    x = [];
  for (let E = y; E < w; E += 1) E >= p && E <= h && x.push(e[l(E)]);
  return x.map((E, C) => /* @__PURE__ */Nt.cloneElement(E, {
    swiper: t,
    style: c,
    key: E.props.virtualIndex || E.key || `slide-${C}`
  }));
}
function WT(t, e) {
  return typeof window > "u" ? Rt(t, e) : NR(t, e);
}
const bB = /* @__PURE__ */Up(null),
  ene = /* @__PURE__ */Up(null),
  RN = /* @__PURE__ */Qn(function (t, e) {
    let {
        className: i,
        tag: l = "div",
        wrapperTag: c = "div",
        children: p,
        onSwiper: h,
        ...y
      } = t === void 0 ? {} : t,
      w = !1;
    const [x, E] = rt("swiper"),
      [C, k] = rt(null),
      [D, I] = rt(!1),
      O = vt(!1),
      P = vt(null),
      N = vt(null),
      L = vt(null),
      F = vt(null),
      j = vt(null),
      V = vt(null),
      K = vt(null),
      G = vt(null),
      {
        params: Q,
        passedParams: te,
        rest: ie,
        events: Y
      } = Gte(y),
      {
        slides: ee,
        slots: oe
      } = Zte(p),
      ne = () => {
        I(!D);
      };
    Object.assign(Q.on, {
      _containerClasses(le, H) {
        E(H);
      }
    });
    const se = () => {
      Object.assign(Q.on, Y), w = !0;
      const le = {
        ...Q
      };
      if (delete le.wrapperClass, N.current = new TN(le), N.current.virtual && N.current.params.virtual.enabled) {
        N.current.virtual.slides = ee;
        const H = {
          cache: !1,
          slides: ee,
          renderExternal: k,
          renderExternalUpdate: !1
        };
        hE(N.current.params.virtual, H), hE(N.current.originalParams.virtual, H);
      }
    };
    P.current || se(), N.current && N.current.on("_beforeBreakpoint", ne);
    const ue = () => {
        w || !Y || !N.current || Object.keys(Y).forEach(le => {
          N.current.on(le, Y[le]);
        });
      },
      W = () => {
        !Y || !N.current || Object.keys(Y).forEach(le => {
          N.current.off(le, Y[le]);
        });
      };
    Rt(() => () => {
      N.current && N.current.off("_beforeBreakpoint", ne);
    }), Rt(() => {
      !O.current && N.current && (N.current.emitSlidesClasses(), O.current = !0);
    }), WT(() => {
      if (e && (e.current = P.current), !!P.current) return N.current.destroyed && se(), Xte({
        el: P.current,
        nextEl: j.current,
        prevEl: V.current,
        paginationEl: K.current,
        scrollbarEl: G.current,
        swiper: N.current
      }, Q), h && !N.current.destroyed && h(N.current), () => {
        N.current && !N.current.destroyed && N.current.destroy(!0, !1);
      };
    }, []), WT(() => {
      ue();
      const le = Kte(te, L.current, ee, F.current, H => H.key);
      return L.current = te, F.current = ee, le.length && N.current && !N.current.destroyed && Yte({
        swiper: N.current,
        slides: ee,
        passedParams: te,
        changedParams: le,
        nextEl: j.current,
        prevEl: V.current,
        scrollbarEl: G.current,
        paginationEl: K.current
      }), () => {
        W();
      };
    }), WT(() => {
      Qte(N.current);
    }, [C]);
    function $() {
      return Q.virtual ? Jte(N.current, ee, C) : ee.map((le, H) => /* @__PURE__ */Nt.cloneElement(le, {
        swiper: N.current,
        swiperSlideIndex: H
      }));
    }
    return /* @__PURE__ */Nt.createElement(l, SO({
      ref: P,
      className: o$(`${x}${i ? ` ${i}` : ""}`)
    }, ie), /* @__PURE__ */Nt.createElement(ene.Provider, {
      value: N.current
    }, oe["container-start"], /* @__PURE__ */Nt.createElement(c, {
      className: qte(Q.wrapperClass)
    }, oe["wrapper-start"], $(), oe["wrapper-end"]), r$(Q) && /* @__PURE__ */Nt.createElement(Nt.Fragment, null, /* @__PURE__ */Nt.createElement("div", {
      ref: V,
      className: "swiper-button-prev"
    }), /* @__PURE__ */Nt.createElement("div", {
      ref: j,
      className: "swiper-button-next"
    })), a$(Q) && /* @__PURE__ */Nt.createElement("div", {
      ref: G,
      className: "swiper-scrollbar"
    }), i$(Q) && /* @__PURE__ */Nt.createElement("div", {
      ref: K,
      className: "swiper-pagination"
    }), oe["container-end"]));
  });
RN.displayName = "Swiper";
const DN = /* @__PURE__ */Qn(function (t, e) {
  let {
    tag: i = "div",
    children: l,
    className: c = "",
    swiper: p,
    zoom: h,
    lazy: y,
    virtualIndex: w,
    swiperSlideIndex: x,
    ...E
  } = t === void 0 ? {} : t;
  const C = vt(null),
    [k, D] = rt("swiper-slide"),
    [I, O] = rt(!1);
  function P(j, V, K) {
    V === C.current && D(K);
  }
  WT(() => {
    if (typeof x < "u" && (C.current.swiperSlideIndex = x), e && (e.current = C.current), !(!C.current || !p)) {
      if (p.destroyed) {
        k !== "swiper-slide" && D("swiper-slide");
        return;
      }
      return p.on("_slideClass", P), () => {
        p && p.off("_slideClass", P);
      };
    }
  }), WT(() => {
    p && C.current && !p.destroyed && D(p.getSlideClasses(C.current));
  }, [p]);
  const N = {
      isActive: k.indexOf("swiper-slide-active") >= 0,
      isVisible: k.indexOf("swiper-slide-visible") >= 0,
      isPrev: k.indexOf("swiper-slide-prev") >= 0,
      isNext: k.indexOf("swiper-slide-next") >= 0
    },
    L = () => typeof l == "function" ? l(N) : l,
    F = () => {
      O(!0);
    };
  return /* @__PURE__ */Nt.createElement(i, SO({
    ref: C,
    className: o$(`${k}${c ? ` ${c}` : ""}`),
    "data-swiper-slide-index": w,
    onLoad: F
  }, E), h && /* @__PURE__ */Nt.createElement(bB.Provider, {
    value: N
  }, /* @__PURE__ */Nt.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof h == "number" ? h : void 0
  }, L(), y && !I && /* @__PURE__ */Nt.createElement("div", {
    className: "swiper-lazy-preloader"
  }))), !h && /* @__PURE__ */Nt.createElement(bB.Provider, {
    value: N
  }, L(), y && !I && /* @__PURE__ */Nt.createElement("div", {
    className: "swiper-lazy-preloader"
  })));
});
DN.displayName = "SwiperSlide";
const tne = "_galleryContainer_1hn1o_1",
  nne = "_footerContainer_1hn1o_5",
  rne = "_swiperSlide_1hn1o_12",
  ine = "_swiper_1hn1o_8",
  ane = "_slideImage_1hn1o_30",
  one = "_navigationButton_1hn1o_53",
  sne = "_navigationButtonPrev_1hn1o_87",
  lne = "_navigationButtonNext_1hn1o_91",
  une = "_navigationButtonIcon_1hn1o_102",
  cne = "_navigationButtonDisabled_1hn1o_107",
  dne = "_pagination_1hn1o_139",
  Dc = {
    galleryContainer: tne,
    footerContainer: nne,
    swiperSlide: rne,
    swiper: ine,
    slideImage: ane,
    navigationButton: one,
    navigationButtonPrev: sne,
    navigationButtonNext: lne,
    navigationButtonIcon: une,
    navigationButtonDisabled: cne,
    pagination: dne
  },
  fne = ({
    setSwiperInstance: t,
    className: e,
    classNames: i,
    labels: l,
    images: c,
    aspectRatio: p = 16 / 9,
    cloudinaryNamedTransformation: h = "t_WVI-ar16x9",
    cloudinaryTransformation: y,
    renderImage: w = H4,
    onSlideClick: x,
    modalMode: E = !1,
    showPagination: C,
    swiperProps: k = {},
    children: D
  }) => {
    var se, ue, W, $, le, H, ce, de, Ce, Ee, fe, xe;
    const I = vt(null),
      O = vt(null),
      P = vt(null),
      N = vt(null),
      L = () => {
        var we, ve, Te, ze;
        (ze = (Te = (ve = (we = N.current) == null ? void 0 : we.swiper) == null ? void 0 : ve.keyboard) == null ? void 0 : Te.enable) == null || ze.call(Te);
      },
      F = () => {
        var we, ve, Te, ze;
        (ze = (Te = (ve = (we = N.current) == null ? void 0 : we.swiper) == null ? void 0 : ve.keyboard) == null ? void 0 : Te.disable) == null || ze.call(Te);
      },
      [j, V] = rt(0),
      [K, G] = rt(!1),
      {
        onSlideChange: Q,
        ...te
      } = k,
      ie = (te == null ? void 0 : te.slidesPerView) ?? 1,
      Y = (te == null ? void 0 : te.spaceBetween) || 32;
    Rt(() => {
      const we = ve => {
        const Te = O.current;
        !I.current || !Te || ve.key === "Tab" && I.current.contains(document.activeElement) && (!ve.shiftKey && Te.activeIndex < c.length - 1 ? (Te.slideNext(), ve.preventDefault()) : ve.shiftKey && Te.activeIndex > 0 && (Te.slidePrev(), ve.preventDefault()));
      };
      return document.addEventListener("keydown", we), () => document.removeEventListener("keydown", we);
    }, [j, c.length]);
    const ee = {
        ...EN,
        ...l
      },
      [oe, ne] = rt(!1);
    return Rt(() => {
      const we = () => {
        ne(window.matchMedia("(min-width: 992px)").matches);
      };
      return we(), window.addEventListener("resize", we), () => {
        window.removeEventListener("resize", we);
      };
    }, []), /* @__PURE__ */B.jsxs("div", {
      className: ge(Dc.galleryContainer, e),
      "data-zoom": K,
      children: [/* @__PURE__ */B.jsxs("div", {
        className: i == null ? void 0 : i.swiperContainer,
        children: [/* @__PURE__ */B.jsxs(RN, {
          ref: N,
          onSwiper: we => {
            O.current = we, t == null || t(we);
          },
          className: ge(Dc.swiper, i == null ? void 0 : i.swiper),
          onSlideChange: we => {
            Q == null || Q(we), V(we.activeIndex);
          },
          modules: [K4, X4, Y4].concat(E ? G4 : q4),
          pagination: C ? {
            el: P.current,
            dynamicBullets: !0,
            dynamicMainBullets: 3,
            clickable: !0,
            type: "bullets"
          } : !1,
          a11y: {
            firstSlideMessage: ee.firstSlideMessage,
            lastSlideMessage: ee.lastSlideMessage,
            prevSlideMessage: ee.prevSlideMessage,
            nextSlideMessage: ee.nextSlideMessage,
            paginationBulletMessage: ee.paginationBulletMessage,
            slideLabelMessage: ee.slideLabelMessage
          },
          keyboard: {
            enabled: !0
          },
          ...(E ? {
            zoom: {
              maxRatio: 1.5,
              limitToOriginalSize: !0
            }
          } : {}),
          onZoomChange: (we, ve) => {
            G(ve > 1);
          },
          grabCursor: !0,
          slidesPerView: ie,
          spaceBetween: Y,
          onMouseEnter: L,
          onMouseLeave: F,
          onFocus: L,
          ...te,
          children: [c.map((we, ve) => /* @__PURE__ */B.jsx(DN, {
            zoom: E && !oe,
            onClick: x,
            className: E ? Dc.swiperSlide : void 0,
            children: w(we, {
              className: Dc.slideImage,
              aspectRatio: p,
              namedTransformation: h,
              transformation: y
            })
          }, we.id || ve)), D]
        }), c.length > 1 && /* @__PURE__ */B.jsxs(B.Fragment, {
          children: [/* @__PURE__ */B.jsx("button", {
            type: "button",
            className: ge(Dc.navigationButton, Dc.navigationButtonPrev, i == null ? void 0 : i.navigationButton, i == null ? void 0 : i.navigationButtonPrev, {
              [Dc.navigationButtonDisabled]: (se = O.current) == null ? void 0 : se.isBeginning,
              [(i == null ? void 0 : i.navigationButtonDisabled) ?? ""]: (ue = O.current) == null ? void 0 : ue.isBeginning
            }),
            "aria-label": ee.prevSlideMessage,
            "aria-disabled": (W = O.current) == null ? void 0 : W.isBeginning,
            "aria-hidden": ($ = O.current) == null ? void 0 : $.isBeginning,
            disabled: (le = O.current) == null ? void 0 : le.isBeginning,
            onClick: we => {
              var ve;
              we.stopPropagation(), (ve = O.current) == null || ve.slidePrev();
            },
            children: /* @__PURE__ */B.jsx(sn, {
              name: "chevron-left",
              className: ge(Dc.navigationButtonIcon, i == null ? void 0 : i.navigationButtonIcon)
            })
          }), /* @__PURE__ */B.jsx("button", {
            type: "button",
            className: ge(Dc.navigationButton, Dc.navigationButtonNext, i == null ? void 0 : i.navigationButton, i == null ? void 0 : i.navigationButtonNext, {
              [Dc.navigationButtonDisabled]: (H = O.current) == null ? void 0 : H.isEnd,
              [(i == null ? void 0 : i.navigationButtonDisabled) ?? ""]: (ce = O.current) == null ? void 0 : ce.isEnd
            }),
            "aria-label": ee.nextSlideMessage,
            "aria-disabled": (de = O.current) == null ? void 0 : de.isEnd,
            "aria-hidden": (Ce = O.current) == null ? void 0 : Ce.isEnd,
            disabled: (Ee = O.current) == null ? void 0 : Ee.isEnd,
            onClick: we => {
              var ve;
              we.stopPropagation(), (ve = O.current) == null || ve.slideNext();
            },
            children: /* @__PURE__ */B.jsx(sn, {
              name: "chevron-right",
              className: ge(Dc.navigationButtonIcon, i == null ? void 0 : i.navigationButtonIcon)
            })
          })]
        })]
      }), (E || C) && /* @__PURE__ */B.jsxs("div", {
        className: Dc.footerContainer,
        children: [E && /* @__PURE__ */B.jsx("span", {
          className: Dc.slideLabelMessage,
          style: {
            "--_slidesPerView": ie,
            "--_spaceBetween": `${Y}px`
          },
          children: (xe = (fe = ee.slideLabelMessage) == null ? void 0 : fe.replace("{{index}}", `${j + 1}`)) == null ? void 0 : xe.replace("{{slidesLength}}", `${c.length}`)
        }), C && /* @__PURE__ */B.jsx("div", {
          ref: P,
          className: ge("swiper-pagination", Dc.pagination, i == null ? void 0 : i.pagination)
        })]
      })]
    });
  },
  pne = "_tagsContainer_1n07c_1",
  hne = "_tag_1n07c_1",
  mne = "_tagLabel_1n07c_25",
  vne = "_tagIcon_1n07c_28",
  gne = "_tagImage_1n07c_35",
  yne = "_tagContent_1n07c_43",
  Mx = {
    tagsContainer: pne,
    tag: hne,
    tagLabel: mne,
    tagIcon: vne,
    tagImage: gne,
    tagContent: yne
  },
  u$ = ({
    tags: t,
    className: e
  }) => /* @__PURE__ */B.jsx("div", {
    className: ge(Mx.tagsContainer, e),
    children: t == null ? void 0 : t.map((i, l) => {
      var p, h, y, w, x, E, C, k, D;
      const c = !!((p = i == null ? void 0 : i.image) != null && p.source);
      return /* @__PURE__ */B.jsxs("div", {
        className: Mx.tag,
        children: [/* @__PURE__ */B.jsxs("span", {
          className: Mx.tagLabel,
          children: [i.icon && (!i.image || !i.image.source) && /* @__PURE__ */B.jsx(sn, {
            className: Mx.tagIcon,
            name: i == null ? void 0 : i.icon
          }), c && /* @__PURE__ */B.jsx("span", {
            className: ge(Mx.tagIcon, Mx.tagImage),
            children: /* @__PURE__ */B.jsx(Ym, {
              src: (y = (h = i.image) == null ? void 0 : h.source) == null ? void 0 : y.src,
              srcSet: (x = (w = i.image) == null ? void 0 : w.source) == null ? void 0 : x.srcSet,
              sizes: (C = (E = i.image) == null ? void 0 : E.source) == null ? void 0 : C.sizes,
              source: (k = i.image) == null ? void 0 : k.source,
              alt: ((D = i.image) == null ? void 0 : D.alt) ?? "",
              loading: "lazy"
            })
          }), /* @__PURE__ */B.jsx("strong", {
            children: i.label
          })]
        }), (i == null ? void 0 : i.content) && /* @__PURE__ */B.jsx("div", {
          className: Mx.tagContent,
          children: i.content
        })]
      }, l);
    })
  }),
  bne = "_galleryWrapper_1geny_2",
  wne = "_galleryButton_1geny_7",
  _ne = "_galleryIconCircle_1geny_26",
  xne = "_galleryIcon_1geny_26",
  Sne = "_slideCount_1geny_45",
  Ene = "_modal_1geny_57",
  Cne = "_modalNav_1geny_98",
  kne = "_closeButton_1geny_102",
  Tne = "_modalCloseButton_1geny_111",
  Rne = "_modalGalleryContainer_1geny_120",
  Dne = "_swiperContainer_1geny_138",
  Ine = "_swiper_1geny_138",
  Mne = "_navigationButton_1geny_145",
  One = "_embedded_1geny_164",
  Lne = "_loader_1geny_168",
  Pne = "_spinning_1geny_1",
  Ox = {
    galleryWrapper: bne,
    default: "_default_1geny_2",
    galleryButton: wne,
    galleryIconCircle: _ne,
    galleryIcon: xne,
    slideCount: Sne,
    modal: Ene,
    modalNav: Cne,
    closeButton: kne,
    modalCloseButton: Tne,
    modalGalleryContainer: Rne,
    swiperContainer: Dne,
    swiper: Ine,
    navigationButton: Mne,
    embedded: One,
    loader: Lne,
    spinning: Pne
  },
  Ane = kF(() => import("./GalleryModal-BnY2NczV.js").then(t => ({
    default: t.GalleryModal
  }))),
  jne = ({
    labels: t,
    tags: e,
    images: i = [],
    renderImage: l,
    className: c,
    modalImages: p,
    variant: h = "default",
    isClickDisabled: y = !1,
    isNested: w = !1,
    aspectRatio: x = pB["16:9"],
    cloudinaryNamedTransformation: E,
    cloudinaryTransformation: C,
    modalAspectRatio: k,
    modalCloudinaryNamedTransformation: D,
    modalCloudinaryTransformation: I,
    onImageChange: O,
    initialImage: P
  }) => {
    const N = {
        ...EN,
        ...t
      },
      L = p || i,
      F = {
        firstSlideMessage: N.firstSlideMessage,
        lastSlideMessage: N.lastSlideMessage,
        prevSlideMessage: N.prevSlideMessage,
        nextSlideMessage: N.nextSlideMessage,
        paginationBulletMessage: N.paginationBulletMessage,
        slideLabelMessage: N.slideLabelMessage
      },
      {
        isXs: j,
        isSm: V
      } = WO(),
      [K, G] = rt(!1),
      [Q, te] = rt(0),
      [ie, Y] = Cee(j || V ? pB["1:1"] : x, E);
    return /* @__PURE__ */B.jsxs(B.Fragment, {
      children: [/* @__PURE__ */B.jsxs(fne, {
        labels: F,
        images: i,
        aspectRatio: ie,
        cloudinaryNamedTransformation: Y,
        cloudinaryTransformation: C,
        renderImage: l || H4,
        ...(h === "clickable" && !y ? {
          onSlideClick: () => G(!0)
        } : {}),
        modalMode: !1,
        className: ge(Ox.galleryWrapper, h && Ox[h], c),
        showPagination: h !== "embedded",
        swiperProps: {
          enabled: i.length > 1,
          onSlideChange: ee => {
            te(ee.activeIndex), O == null || O(ee.activeIndex);
          },
          initialSlide: P
        },
        children: [e && e.length > 0 && /* @__PURE__ */B.jsx(u$, {
          tags: e
        }), i.length > 1 && h === "default" && /* @__PURE__ */B.jsxs("button", {
          slot: "container-start",
          type: "button",
          "aria-label": N.openModalLabel,
          className: Ox.galleryButton,
          onClick: () => {
            G(!0);
          },
          children: [K ? /* @__PURE__ */B.jsx("span", {
            className: Ox.loader
          }) : /* @__PURE__ */B.jsx("span", {
            className: Ox.galleryIconCircle,
            children: /* @__PURE__ */B.jsx(sn, {
              className: Ox.galleryIcon,
              name: "copy-micro"
            })
          }), N.openModalLabel]
        }), i.length > 1 && h === "clickable" && /* @__PURE__ */B.jsx("span", {
          slot: "container-start",
          className: Ox.slideCount,
          children: `${Q + 1}/${i.length}`
        })]
      }, i == null ? void 0 : i.length), h !== "embedded" && K && /* @__PURE__ */B.jsx(TF, {
        fallback: null,
        children: /* @__PURE__ */B.jsx(Ane, {
          labels: N,
          images: L,
          isOpen: K,
          onClose: ee => {
            w && ee && ee.stopPropagation(), G(!1);
          },
          initialSlide: Q,
          aspectRatio: k,
          cloudinaryNamedTransformation: D,
          cloudinaryTransformation: I,
          isNested: w
        })
      })]
    });
  },
  Fne = "_galleryWrapper_ywarp_1",
  Nne = "_galleryButton_ywarp_4",
  zne = "_gallery_ywarp_1",
  Vne = "_galleryVideo_ywarp_80",
  Bne = "_galleryVideoIcon_ywarp_90",
  Une = "_galleryIconCircle_ywarp_129",
  Hne = "_galleryIcon_ywarp_129",
  U0 = {
    galleryWrapper: Fne,
    galleryButton: Nne,
    gallery: zne,
    galleryVideo: Vne,
    galleryVideoIcon: Bne,
    galleryIconCircle: Une,
    galleryIcon: Hne
  },
  $ne = kF(() => import("./GalleryModal-BnY2NczV.js").then(t => ({
    default: t.GalleryModal
  }))),
  V_e = ({
    labels: t,
    images: e = [],
    tags: i,
    modalImages: l,
    modalAspectRatio: c,
    modalCloudinaryNamedTransformation: p,
    modalCloudinaryTransformation: h,
    className: y
  }) => {
    const w = l || e,
      [x, E] = rt(!1),
      [C, k] = rt(0),
      D = {
        ...EN,
        ...t
      };
    return /* @__PURE__ */B.jsxs("div", {
      className: ge(U0.galleryWrapper, y),
      children: [/* @__PURE__ */B.jsx("div", {
        className: U0.gallery,
        children: e.map((I, O) => {
          var N, L, F;
          const P = I.type === "video";
          return /* @__PURE__ */B.jsxs("div", {
            className: ge(P && U0.galleryVideo),
            onClick: () => {
              E(!0), k(O);
            },
            onKeyDown: j => {
              (j.key === "Enter" || j.key === " ") && (j.preventDefault(), E(!0), k(O));
            },
            role: "button",
            "aria-label": P ? D.playVideo : `${D.viewImage} ${O + 1}`,
            tabIndex: 0,
            children: [/* @__PURE__ */B.jsx(Ym, {
              src: P ? I.poster : (N = I.source) == null ? void 0 : N.src,
              srcSet: P || (L = I.source) == null ? void 0 : L.srcSet,
              sizes: P || (F = I.source) == null ? void 0 : F.sizes,
              source: P ? void 0 : I.source,
              alt: I.alt ?? `Image ${O + 1}`,
              loading: "lazy"
            }), P && /* @__PURE__ */B.jsx(sn, {
              name: "play-micro",
              className: U0.galleryVideoIcon
            })]
          }, I.id ?? `${I.type}-${O}`);
        })
      }), i && i.length > 0 && /* @__PURE__ */B.jsx(u$, {
        tags: i
      }), e.length > 0 && /* @__PURE__ */B.jsxs("button", {
        type: "button",
        className: U0.galleryButton,
        onClick: () => E(!0),
        children: [x ? /* @__PURE__ */B.jsx("span", {
          className: U0.loader
        }) : /* @__PURE__ */B.jsx("span", {
          className: U0.galleryIconCircle,
          children: /* @__PURE__ */B.jsx(sn, {
            className: U0.galleryIcon,
            name: "copy-micro"
          })
        }), D.openModalLabel]
      }), x && /* @__PURE__ */B.jsx(TF, {
        fallback: null,
        children: /* @__PURE__ */B.jsx($ne, {
          labels: D,
          images: w,
          isOpen: x,
          onClose: () => E(!1),
          initialSlide: C,
          aspectRatio: c,
          cloudinaryNamedTransformation: p,
          cloudinaryTransformation: h
        })
      })]
    });
  },
  Wne = "_roomCard_p2my2_1",
  qne = "_cardLink_p2my2_9",
  Yne = "_roomCardGallery_p2my2_37",
  Gne = "_roomCardImage_p2my2_40",
  Xne = "_roomCardContainer_p2my2_43",
  Kne = "_roomCardHeading_p2my2_48",
  Qne = "_roomCardInc_p2my2_66",
  Zne = "_roomCardDetails_p2my2_71",
  Jne = "_roomCardDetailsIcon_p2my2_93",
  ere = "_roomCardExtra_p2my2_101",
  tre = "_roomCardDetailsLink_p2my2_122",
  nre = "_roomCardSubTitle_p2my2_126",
  rre = "_galleryButton_p2my2_130",
  ire = "_galleryIconCircle_p2my2_144",
  are = "_galleryIcon_p2my2_144",
  ore = "_modal_p2my2_163",
  sre = "_modalGalleryContainer_p2my2_191",
  lre = "_modalHeader_p2my2_199",
  ure = "_closeButton_p2my2_206",
  Jc = {
    roomCard: Wne,
    cardLink: qne,
    roomCardGallery: Yne,
    roomCardImage: Gne,
    roomCardContainer: Xne,
    roomCardHeading: Kne,
    roomCardInc: Qne,
    roomCardDetails: Zne,
    roomCardDetailsIcon: Jne,
    roomCardExtra: ere,
    roomCardDetailsLink: tre,
    roomCardSubTitle: nre,
    galleryButton: rre,
    galleryIconCircle: ire,
    galleryIcon: are,
    modal: ore,
    modalGalleryContainer: sre,
    modalHeader: lre,
    closeButton: ure
  },
  cre = kF(() => import("./RoomCardModal-Bdy5XjgW.js").then(t => ({
    default: t.RoomCardModal
  }))),
  B_e = ({
    images: t,
    header: e,
    link: i,
    labels: l,
    roomDetails: c,
    modalImages: p,
    headerAs: h = "h2",
    className: y,
    theme: w = "light"
  }) => {
    const [x, E] = rt(!1),
      [C, k] = rt(0),
      D = p || t;
    return /* @__PURE__ */B.jsxs(B.Fragment, {
      children: [/* @__PURE__ */B.jsxs("div", {
        className: ge(Jc.roomCard, y),
        "data-theme": w,
        children: [t && t.length > 0 && /* @__PURE__ */B.jsxs("div", {
          className: Jc.roomCardImage,
          children: [/* @__PURE__ */B.jsx(jne, {
            images: t,
            variant: "embedded",
            className: Jc.roomCardGallery,
            onImageChange: k
          }), !!i && /* @__PURE__ */B.jsx("button", {
            type: "button",
            "aria-label": l == null ? void 0 : l.openModalLabel,
            className: Jc.galleryButton,
            onClick: () => E(!0),
            children: /* @__PURE__ */B.jsx("span", {
              className: Jc.galleryIconCircle,
              children: /* @__PURE__ */B.jsx(sn, {
                hidden: !0,
                className: Jc.galleryIcon,
                name: "copy-micro"
              })
            })
          })]
        }), /* @__PURE__ */B.jsxs("div", {
          className: Jc.roomCardContainer,
          children: [/* @__PURE__ */B.jsxs("div", {
            className: Jc.roomCardBody,
            children: [e && /* @__PURE__ */B.jsx(cu, {
              size: "sm",
              className: Jc.roomCardHeading,
              Tag: h,
              children: e
            }), /* @__PURE__ */B.jsx("div", {
              className: ge(Jc.roomCardInc),
              children: /* @__PURE__ */B.jsx("span", {
                children: l == null ? void 0 : l.allInc
              })
            }), (c == null ? void 0 : c.primary) && c.primary.length > 0 && /* @__PURE__ */B.jsx("div", {
              className: Jc.roomCardDetails,
              children: /* @__PURE__ */B.jsx("ul", {
                children: c.primary.map((I, O) => /* @__PURE__ */B.jsxs("li", {
                  children: [I.icon && /* @__PURE__ */B.jsx(sn, {
                    name: I.icon,
                    title: I.label,
                    className: Jc.roomCardDetailsIcon
                  }), I.label]
                }, O))
              })
            })]
          }), !!i && /* @__PURE__ */B.jsx("div", {
            className: Jc.roomCardDetailsLink,
            children: /* @__PURE__ */B.jsx(fd, {
              className: Jc.cardLink,
              href: i.href,
              target: i == null ? void 0 : i.target,
              variant: w,
              size: "md",
              onClick: I => {
                I.preventDefault(), E(!0);
              },
              icon: (i == null ? void 0 : i.icon) ?? "arrow-right-micro",
              children: i == null ? void 0 : i.children
            })
          })]
        })]
      }), x && D && /* @__PURE__ */B.jsx(TF, {
        fallback: null,
        children: /* @__PURE__ */B.jsx(cre, {
          labels: {
            ...l,
            closeModal: (l == null ? void 0 : l.closeModal) ?? "Close"
          },
          roomDetails: c,
          header: e,
          images: D,
          isOpen: x,
          initialImage: C,
          onClose: () => E(!1)
        })
      })]
    });
  },
  dre = "_theme_zs1r0_1",
  fre = "_themeUi_zs1r0_9",
  pre = "_themeLabel_zs1r0_19",
  hre = "_themeHelperText_zs1r0_26",
  mre = "_themeError_zs1r0_33",
  vre = "_themeErrorMsg_zs1r0_44",
  gre = "_themeDisabled_zs1r0_47",
  H0 = {
    theme: dre,
    themeUi: fre,
    themeLabel: pre,
    themeHelperText: hre,
    themeError: mre,
    themeErrorMsg: vre,
    themeDisabled: gre
  },
  Hj = ({
    id: t,
    label: e,
    helperText: i,
    isDisabled: l = !1,
    isSelected: c = !1,
    onChange: p,
    className: h,
    classNames: y,
    isRequired: w = !1,
    errorMessage: x,
    isError: E = !1
  }) => {
    const C = (k, D, I) => {
      p == null || p(k, D, I);
    };
    return /* @__PURE__ */B.jsx(v9, {
      id: t,
      label: e,
      helperText: i,
      isDisabled: l,
      isSelected: c,
      onChange: C,
      className: ge(H0.theme, h),
      classNames: {
        disabled: ge(H0.themeDisabled, y == null ? void 0 : y.disabled),
        error: ge(H0.themeError, y == null ? void 0 : y.error),
        wrapper: ge(H0.themeWrapper, y == null ? void 0 : y.wrapper),
        labelWrapper: y == null ? void 0 : y.labelWrapper,
        label: ge(H0.themeLabel, y == null ? void 0 : y.label),
        helperText: ge(H0.themeHelperText, y == null ? void 0 : y.helperText),
        errorMsg: ge(H0.themeErrorMsg, y == null ? void 0 : y.errorMsg),
        ui: ge(H0.themeUi, y == null ? void 0 : y.ui)
      },
      isRequired: w,
      errorMessage: l ? "" : x,
      isError: l ? !1 : E
    });
  },
  K1 = {
    default: "default",
    extended: "extended",
    noControls: "no-controls"
  },
  yre = "_pagination_c5x11_1",
  bre = "_paginationBtn_c5x11_13",
  wre = "_text_c5x11_32",
  _re = "_btnIcon_c5x11_46",
  xre = "_text__label_c5x11_53",
  Sre = "_active_c5x11_57",
  Ere = "_paginationList_c5x11_72",
  Cre = "_paginationList__Mobile_c5x11_131",
  ml = {
    pagination: yre,
    paginationBtn: bre,
    text: wre,
    btnIcon: _re,
    text__label: xre,
    active: Sre,
    paginationList: Ere,
    paginationList__Mobile: Cre
  },
  kre = {
    first: "First",
    back: "Back",
    last: "Last",
    next: "Next",
    of: "of"
  },
  Tre = ({
    labels: t,
    variant: e = K1.default,
    totalItems: i,
    currentPageIndex: l,
    visibleRange: c = {
      start: 1,
      end: 4
    },
    handleSlideTo: p,
    theme: h = "light",
    pageSize: y = 10
  }) => {
    const w = {
        ...kre,
        ...t
      },
      x = ci(() => {
        if (e === K1.noControls && c) return c;
        const P = c.end - c.start + 1,
          N = Math.floor(P / 2);
        let L = Math.max(1, l - N),
          F = L + P - 1;
        return F > i && (F = i, L = Math.max(1, F - P + 1)), L < 1 && (L = 1, F = P), {
          start: L,
          end: F
        };
      }, [c, l, i, e]),
      E = Math.ceil(i / y),
      C = Array.from({
        length: E
      }, (P, N) => ({
        key: N + 1,
        label: N + 1
      })),
      k = l === 1,
      D = l === E,
      I = e !== K1.noControls,
      O = e === K1.extended;
    return /* @__PURE__ */B.jsxs("nav", {
      className: ml.pagination,
      "data-variant": e,
      "data-theme": h,
      children: [O && /* @__PURE__ */B.jsxs(vM, {
        className: ml.text,
        onClick: () => p(1),
        disabled: k,
        children: [/* @__PURE__ */B.jsx(sn, {
          name: "ends-start-micro",
          className: ml.btnIcon
        }), /* @__PURE__ */B.jsx("span", {
          className: ml.text__label,
          children: w.first
        })]
      }), I && /* @__PURE__ */B.jsxs(vM, {
        className: ml.text,
        onClick: () => p(l - 1),
        disabled: k,
        children: [/* @__PURE__ */B.jsx(sn, {
          name: e !== K1.extended && k ? "nope" : "chevron-left-micro",
          className: ml.btnIcon
        }), " ", /* @__PURE__ */B.jsx("span", {
          className: ml.text__label,
          children: w.back
        })]
      }), /* @__PURE__ */B.jsxs("ul", {
        className: ml.paginationList,
        children: [/* @__PURE__ */B.jsx(Rre, {
          items: C.slice(x.start - 1, x.end),
          currentPageIndex: l,
          handleSlideTo: p
        }), /* @__PURE__ */B.jsxs("li", {
          className: ml.paginationList__Mobile,
          children: [l, " ", w.of, " ", E]
        })]
      }), I && /* @__PURE__ */B.jsxs(vM, {
        className: ml.text,
        onClick: () => p(l + 1),
        disabled: D,
        children: [/* @__PURE__ */B.jsx("span", {
          className: ml.text__label,
          children: w.next
        }), /* @__PURE__ */B.jsx(sn, {
          name: e !== K1.extended && D ? "nope" : "chevron-right-micro",
          className: ml.btnIcon
        })]
      }), O && /* @__PURE__ */B.jsxs(vM, {
        className: ml.text,
        onClick: () => p(E),
        disabled: D,
        children: [/* @__PURE__ */B.jsx("span", {
          className: ml.text__label,
          children: w.last
        }), /* @__PURE__ */B.jsx(sn, {
          name: "ends-end-micro",
          className: ml.btnIcon
        })]
      })]
    });
  },
  vM = ({
    children: t,
    onClick: e,
    disabled: i,
    className: l,
    ...c
  }) => /* @__PURE__ */B.jsx("button", {
    className: ge(ml.paginationBtn, l),
    type: "button",
    onClick: e,
    disabled: i,
    ...c,
    children: t
  }),
  Rre = ({
    items: t,
    currentPageIndex: e,
    handleSlideTo: i
  }) => t.map(l => {
    const c = e === l.key;
    return /* @__PURE__ */B.jsx("li", {
      children: /* @__PURE__ */B.jsx("button", {
        className: ge(ml.paginationBtn, {
          [ml.active]: c
        }),
        type: "button",
        onClick: () => i(l.key),
        children: l.label
      })
    }, l.key);
  }),
  Dre = "_paginationWrapper_13g7w_1",
  Ire = {
    paginationWrapper: Dre
  },
  Mre = {
    first: "First",
    last: "Last",
    back: "Prev",
    next: "Next",
    of: "of"
  },
  U_e = ({
    labels: t,
    cardsPerPage: e = 3,
    items: i,
    colWidth: l = "220px",
    paginationVariant: c = "default",
    numberOfPaginationToDisplay: p = 5,
    theme: h = "light"
  }) => {
    var Q;
    const y = {
        ...Mre,
        ...t
      },
      {
        isXs: w,
        isSm: x,
        isMd: E
      } = WO(),
      [C, k] = rt(1),
      [D, I] = rt([]),
      [O, P] = rt({
        start: 1,
        end: p
      }),
      N = vt(0),
      L = ci(() => w ? 3 : p, [w, p]),
      F = Math.min(C, D.length || 1),
      j = pn(() => w ? 1 : x ? 2 : E ? 3 : e, [w, x, E, e]),
      V = pn(() => {
        const te = j(),
          ie = [];
        for (let oe = 0; oe < i.length; oe += te) ie.push(i.slice(oe, oe + te));
        I(ie);
        const Y = N.current,
          ee = Math.floor(Y / te) + 1;
        ee > ie.length ? k(1) : k(ee);
      }, [i, j]),
      K = pn((te, ie, Y) => {
        let ee = te - Math.floor(Y / 2);
        ee = Math.max(ee, 1);
        let oe = ee + (Y - 1);
        return oe > ie && (oe = ie, ee = Math.max(oe - (Y - 1), 1)), {
          start: ee,
          end: oe
        };
      }, []);
    Rt(() => {
      const te = j();
      N.current = (C - 1) * te, V();
    }, [i, w, x, E, V, j, C]), Rt(() => {
      P(K(C, D.length, L));
    }, [C, D.length, L, K]);
    const G = D.length;
    return /* @__PURE__ */B.jsxs("div", {
      className: Ire.paginationWrapper,
      children: [G > 0 && /* @__PURE__ */B.jsx(NE, {
        cols: j(),
        minWidth: l,
        children: (Q = D[C - 1]) == null ? void 0 : Q.map(te => /* @__PURE__ */B.jsx(gb, {
          children: te.content
        }, te.id))
      }), G > 1 && /* @__PURE__ */B.jsx(Tre, {
        totalItems: i.length,
        currentPageIndex: F,
        handleSlideTo: k,
        variant: c,
        visibleRange: O,
        labels: y,
        pageSize: j(),
        theme: h
      })]
    });
  },
  Ore = "_wrapper_a4qu4_1",
  Lre = {
    wrapper: Ore
  },
  H_e = ({
    items: t,
    itemsPerRow: e = 3
  }) => /* @__PURE__ */B.jsx(NE, {
    cols: e,
    className: Lre.wrapper,
    children: t.map(i => /* @__PURE__ */B.jsx(gb, {
      children: i.content
    }, i.id))
  }),
  Pre = t => {
    switch (t) {
      case 2:
        return {
          0: {
            slidesPerView: 1.1,
            spaceBetween: 16
          },
          576: {
            slidesPerView: 2,
            spaceBetween: 16
          },
          769: {
            slidesPerView: 2,
            spaceBetween: 16
          }
        };
      case 3:
        return {
          0: {
            slidesPerView: 1.1,
            spaceBetween: 16
          },
          576: {
            slidesPerView: 2,
            spaceBetween: 16
          },
          769: {
            slidesPerView: 3,
            spaceBetween: 16
          }
        };
      case 4:
        return {
          0: {
            slidesPerView: 1.1,
            spaceBetween: 16
          },
          576: {
            slidesPerView: 2,
            spaceBetween: 16
          },
          769: {
            slidesPerView: 4,
            spaceBetween: 16
          }
        };
      default:
        return {
          0: {
            slidesPerView: 1.1,
            spaceBetween: 16
          },
          576: {
            slidesPerView: 1,
            spaceBetween: 16
          },
          769: {
            slidesPerView: 1,
            spaceBetween: 16
          }
        };
    }
  },
  Are = "_sliderContainer_knerz_1",
  jre = "_paddingForNavigationButton_knerz_9",
  Fre = "_hide_knerz_14",
  Nre = "_desktopOnly_knerz_18",
  zre = "_swiper_knerz_5",
  Vre = "_swiperPadding_knerz_33",
  Bre = "_swiperSlide_knerz_37",
  Ure = "_slideImage_knerz_41",
  Hre = "_navigationButton_knerz_46",
  $re = "_navigationButtonPrev_knerz_63",
  Wre = "_navigationButtonNext_knerz_71",
  qre = "_active_knerz_87",
  Yre = "_navigationButtonIcon_knerz_91",
  Gre = "_pagination_knerz_100",
  Xre = "_slideLabelMessage_knerz_125",
  Ic = {
    sliderContainer: Are,
    paddingForNavigationButton: jre,
    hide: Fre,
    desktopOnly: Nre,
    swiper: zre,
    swiperPadding: Vre,
    swiperSlide: Bre,
    slideImage: Ure,
    navigationButton: Hre,
    navigationButtonPrev: $re,
    navigationButtonNext: Wre,
    active: qre,
    navigationButtonIcon: Yre,
    pagination: Gre,
    slideLabelMessage: Xre
  },
  Kre = {
    firstSlideMessage: "This is the first slide",
    lastSlideMessage: "This is the last slide",
    prevSlideMessage: "Previous slide",
    nextSlideMessage: "Next slide",
    paginationBulletMessage: "Go to slide {{index}}",
    slideLabelMessage: "{{index}} of {{slidesLength}}"
  },
  $_e = ({
    id: t,
    slides: e,
    link: i,
    theme: l,
    renderLink: c,
    labels: p,
    className: h,
    slidesPerView: y = 3,
    breakpoints: w = Pre(y),
    navigationType: x,
    paginationType: E
  }) => {
    const C = {
        ...Kre,
        ...p
      },
      k = vt(null),
      [D, I] = rt(!0),
      [O, P] = rt(!1),
      N = vt(null),
      L = () => {
        var V, K, G, Q;
        (Q = (G = (K = (V = N.current) == null ? void 0 : V.swiper) == null ? void 0 : K.keyboard) == null ? void 0 : G.enable) == null || Q.call(G);
      },
      F = () => {
        var V, K, G, Q;
        (Q = (G = (K = (V = N.current) == null ? void 0 : V.swiper) == null ? void 0 : K.keyboard) == null ? void 0 : G.disable) == null || Q.call(G);
      },
      j = (V, K) => typeof V == "function" ? V({
        theme: K
      }) : V;
    return /* @__PURE__ */B.jsx(B.Fragment, {
      children: e.length > 1 ? /* @__PURE__ */B.jsxs("div", {
        className: ge(Ic.sliderContainer, Ic.paddingForNavigationButton, x && Ic[x], h),
        onMouseEnter: L,
        onMouseLeave: F,
        onFocus: L,
        onBlur: F,
        "data-theme": l,
        children: [/* @__PURE__ */B.jsxs(B.Fragment, {
          children: [/* @__PURE__ */B.jsx("button", {
            className: ge(Ic.navigationButton, Ic.navigationButtonPrev),
            type: "button",
            "aria-label": C.prevSlideMessage,
            "aria-disabled": D,
            onClick: () => {
              var V;
              return (V = k.current) == null ? void 0 : V.slidePrev();
            },
            disabled: D,
            children: /* @__PURE__ */B.jsx(sn, {
              name: "chevron-left",
              className: Ic.navigationButtonIcon
            })
          }, "navigationButtonPrev"), /* @__PURE__ */B.jsx("button", {
            id: t,
            className: ge(Ic.navigationButton, Ic.navigationButtonNext),
            type: "button",
            "aria-label": C.nextSlideMessage,
            "aria-disabled": O,
            disabled: O,
            onClick: () => {
              var V;
              return (V = k.current) == null ? void 0 : V.slideNext();
            },
            children: /* @__PURE__ */B.jsx(sn, {
              name: "chevron-right",
              className: Ic.navigationButtonIcon
            })
          }, "navigationButtonNext")]
        }), /* @__PURE__ */B.jsx("div", {
          children: /* @__PURE__ */B.jsx(RN, {
            onSwiper: V => {
              k.current = V, I(V.isBeginning), P(V.isEnd);
            },
            onSlideChange: V => {
              I(V.isBeginning), P(V.isEnd);
            },
            ref: N,
            className: ge(Ic.swiper, Ic.swiperPadding),
            modules: [K4, X4, q4, Y4, G4],
            pagination: {
              el: `.swiper-pagination-${t}`,
              dynamicBullets: !0,
              dynamicMainBullets: 3,
              clickable: !0,
              type: "bullets"
            },
            a11y: {
              firstSlideMessage: C.firstSlideMessage,
              lastSlideMessage: C.lastSlideMessage,
              prevSlideMessage: C.prevSlideMessage,
              nextSlideMessage: C.nextSlideMessage,
              paginationBulletMessage: C.paginationBulletMessage,
              slideLabelMessage: C.slideLabelMessage
            },
            keyboard: {
              enabled: !1
            },
            centeredSlides: !1,
            grabCursor: !0,
            slidesPerView: y,
            breakpoints: w,
            children: e.map((V, K) => /* @__PURE__ */B.jsx(DN, {
              className: Ic.swiperSlide,
              children: j(V.view)
            }, V.id || K))
          }, t)
        }), /* @__PURE__ */B.jsx("div", {
          className: ge("swiper-pagination", `swiper-pagination-${t}`, Ic.pagination, E && Ic[E])
        })]
      }) : /* @__PURE__ */B.jsxs(B.Fragment, {
        children: [/* @__PURE__ */B.jsx(NE, {
          cols: 3,
          children: /* @__PURE__ */B.jsx(gb, {
            children: e.map(V => j(V.view, l))
          })
        }), !!i && /* @__PURE__ */B.jsx(fd, {
          renderLink: c,
          icon: "arrow-right-micro",
          href: i.href,
          variant: l,
          className: Ic.cardLink,
          children: i == null ? void 0 : i.children
        })]
      })
    });
  };
var $M = {
  exports: {}
};
/*! Case - v1.6.2 - 2020-03-24
* Copyright (c) 2020 Nathan Bubna; Licensed MIT, GPL */
var Qre = $M.exports,
  wB;
function Zre() {
  return wB || (wB = 1, function (t) {
    (function () {
      var e = function (D, I) {
          return I = I || "", D.replace(/(^|-)/g, "$1\\u" + I).replace(/,/g, "\\u" + I);
        },
        i = e("20-26,28-2F,3A-40,5B-60,7B-7E,A0-BF,D7,F7", "00"),
        l = "a-z" + e("DF-F6,F8-FF", "00"),
        c = "A-Z" + e("C0-D6,D8-DE", "00"),
        p = "A|An|And|As|At|But|By|En|For|If|In|Of|On|Or|The|To|Vs?\\.?|Via",
        h = function (D, I, O, P) {
          return D = D || i, I = I || l, O = O || c, P = P || p, {
            capitalize: new RegExp("(^|[" + D + "])([" + I + "])", "g"),
            pascal: new RegExp("(^|[" + D + "])+([" + I + O + "])", "g"),
            fill: new RegExp("[" + D + "]+(.|$)", "g"),
            sentence: new RegExp('(^\\s*|[\\?\\!\\.]+"?\\s+"?|,\\s+")([' + I + "])", "g"),
            improper: new RegExp("\\b(" + P + ")\\b", "g"),
            relax: new RegExp("([^" + O + "])([" + O + "]*)([" + O + "])(?=[^" + O + "]|$)", "g"),
            upper: new RegExp("^[^" + I + "]+$"),
            hole: /[^\s]\s[^\s]/,
            apostrophe: /'/g,
            room: new RegExp("[" + D + "]")
          };
        },
        y = h(),
        w = {
          re: y,
          unicodes: e,
          regexps: h,
          types: [],
          up: String.prototype.toUpperCase,
          low: String.prototype.toLowerCase,
          cap: function (D) {
            return w.up.call(D.charAt(0)) + D.slice(1);
          },
          decap: function (D) {
            return w.low.call(D.charAt(0)) + D.slice(1);
          },
          deapostrophe: function (D) {
            return D.replace(y.apostrophe, "");
          },
          fill: function (D, I, O) {
            return I != null && (D = D.replace(y.fill, function (P, N) {
              return N ? I + N : "";
            })), O && (D = w.deapostrophe(D)), D;
          },
          prep: function (D, I, O, P) {
            if (D = D == null ? "" : D + "", !P && y.upper.test(D) && (D = w.low.call(D)), !I && !y.hole.test(D)) {
              var N = w.fill(D, " ");
              y.hole.test(N) && (D = N);
            }
            return !O && !y.room.test(D) && (D = D.replace(y.relax, w.relax)), D;
          },
          relax: function (D, I, O, P) {
            return I + " " + (O ? O + " " : "") + P;
          }
        },
        x = {
          _: w,
          of: function (D) {
            for (var I = 0, O = w.types.length; I < O; I++) if (x[w.types[I]].apply(x, arguments) === D) return w.types[I];
          },
          flip: function (D) {
            return D.replace(/\w/g, function (I) {
              return (I == w.up.call(I) ? w.low : w.up).call(I);
            });
          },
          random: function (D) {
            return D.replace(/\w/g, function (I) {
              return (Math.round(Math.random()) ? w.up : w.low).call(I);
            });
          },
          type: function (D, I) {
            x[D] = I, w.types.push(D);
          }
        },
        E = {
          lower: function (D, I, O) {
            return w.fill(w.low.call(w.prep(D, I)), I, O);
          },
          snake: function (D) {
            return x.lower(D, "_", !0);
          },
          constant: function (D) {
            return x.upper(D, "_", !0);
          },
          camel: function (D) {
            return w.decap(x.pascal(D));
          },
          kebab: function (D) {
            return x.lower(D, "-", !0);
          },
          upper: function (D, I, O) {
            return w.fill(w.up.call(w.prep(D, I, !1, !0)), I, O);
          },
          capital: function (D, I, O) {
            return w.fill(w.prep(D).replace(y.capitalize, function (P, N, L) {
              return N + w.up.call(L);
            }), I, O);
          },
          header: function (D) {
            return x.capital(D, "-", !0);
          },
          pascal: function (D) {
            return w.fill(w.prep(D, !1, !0).replace(y.pascal, function (I, O, P) {
              return w.up.call(P);
            }), "", !0);
          },
          title: function (D) {
            return x.capital(D).replace(y.improper, function (I, O, P, N) {
              return P > 0 && P < N.lastIndexOf(" ") ? w.low.call(I) : I;
            });
          },
          sentence: function (D, I, O) {
            return D = x.lower(D).replace(y.sentence, function (P, N, L) {
              return N + w.up.call(L);
            }), I && I.forEach(function (P) {
              D = D.replace(new RegExp("\\b" + x.lower(P) + "\\b", "g"), w.cap);
            }), O && O.forEach(function (P) {
              D = D.replace(new RegExp("(\\b" + x.lower(P) + "\\. +)(\\w)"), function (N, L, F) {
                return L + w.low.call(F);
              });
            }), D;
          }
        };
      E.squish = E.pascal, x.default = x;
      for (var C in E) x.type(C, E[C]);
      var k = typeof k == "function" ? k : function () {};
      k(t.exports ? t.exports = x : this.Case = x);
    }).call(Qre);
  }($M)), $M.exports;
}
var oE = Zre();
const gl = {
    color: {
      white: {
        value: "#FFFFFF"
      },
      teal: {
        500: {
          value: "#00AAA6"
        }
      },
      gray: {
        400: {
          value: "#DBDCDC"
        },
        500: {
          value: "#F0F0F0"
        }
      }
    }
  },
  Jre = "_container_q5fpq_1",
  eie = "_inputBorder_q5fpq_5",
  tie = "_inputHelperText_q5fpq_13",
  nie = "_inputErrorText_q5fpq_22",
  rie = "_input_q5fpq_5",
  iie = "_inputWrapperFocus_q5fpq_31",
  aie = "_inputWrapperOpen_q5fpq_38",
  oie = "_listBox_q5fpq_44",
  sie = "_inputWrapperError_q5fpq_48",
  lie = "_inputLabel_q5fpq_54",
  uie = "_inputWrapperDisabled_q5fpq_58",
  cie = "_inputWrapperSelected_q5fpq_87",
  die = "_value_q5fpq_98",
  fie = "_loader_q5fpq_106",
  pie = "_icon_q5fpq_112",
  hie = "_iconError_q5fpq_120",
  mie = "_iconDisabled_q5fpq_124",
  vie = "_listHeading_q5fpq_142",
  gie = "_listItem_q5fpq_156",
  yie = "_itemGroup_q5fpq_162",
  bie = "_itemActive_q5fpq_167",
  wie = "_itemDisabled_q5fpq_167",
  _ie = "_itemSelected_q5fpq_167",
  xie = "_noResults_q5fpq_184",
  Sie = "_inputLoader_q5fpq_190",
  Eie = "_themeDefault_q5fpq_194",
  Cie = "_themeGrey_q5fpq_203",
  na = {
    container: Jre,
    inputBorder: eie,
    inputHelperText: tie,
    inputErrorText: nie,
    input: rie,
    inputWrapperFocus: iie,
    inputWrapperOpen: aie,
    listBox: oie,
    inputWrapperError: sie,
    inputLabel: lie,
    inputWrapperDisabled: uie,
    inputWrapperSelected: cie,
    value: die,
    loader: fie,
    icon: pie,
    iconError: hie,
    iconDisabled: mie,
    listHeading: vie,
    listItem: gie,
    itemGroup: yie,
    itemActive: bie,
    itemDisabled: wie,
    itemSelected: _ie,
    noResults: xie,
    inputLoader: Sie,
    themeDefault: Eie,
    themeGrey: Cie
  },
  qT = ({
    id: t,
    data: e,
    isDisabled: i,
    errorMessage: l,
    initialSelectedItem: c,
    hideDisplayValue: p,
    selectedItem: h,
    iconOptions: y,
    isAutoCloseMenu: w,
    environment: x,
    children: E,
    className: C,
    classNames: k,
    onFocus: D,
    onBlur: I,
    onChange: O,
    onOpenDropdown: P,
    label: N,
    labels: L,
    helperText: F,
    renderCustomListItem: j,
    renderCustomItemContent: V,
    renderCustomLabel: K,
    theme: G = "default",
    isLoading: Q
  }) => /* @__PURE__ */B.jsx(vq, {
    id: t,
    label: N,
    data: e,
    isDisabled: i,
    errorMessage: l,
    initialSelectedItem: c ?? h,
    hideDisplayValue: p,
    selectedItem: h,
    iconOptions: {
      open: (y == null ? void 0 : y.open) || /* @__PURE__ */B.jsx(sn, {
        name: "chevron-up"
      }),
      close: (y == null ? void 0 : y.close) || /* @__PURE__ */B.jsx(sn, {
        name: "chevron-down"
      }),
      disabled: (y == null ? void 0 : y.disabled) || /* @__PURE__ */B.jsx(sn, {
        name: "nope"
      })
    },
    isAutoCloseMenu: w,
    environment: x,
    children: E,
    className: ge(na.container, C),
    classNames: {
      icon: ge(na.icon, k == null ? void 0 : k.icon),
      iconDisabled: ge(na.iconDisabled, k == null ? void 0 : k.iconDisabled),
      iconError: ge(na.iconError, k == null ? void 0 : k.iconError),
      inputToggleButton: ge(na.input, G && na[`theme${oE.pascal(G)}`], k == null ? void 0 : k.inputToggleButton),
      inputWrapperFocus: ge(na.inputWrapperFocus, k == null ? void 0 : k.inputWrapperFocus),
      inputWrapperOpen: ge(na.inputWrapperOpen, k == null ? void 0 : k.inputWrapperOpen),
      inputWrapperSelected: ge(na.inputWrapperSelected, k == null ? void 0 : k.inputWrapperSelected),
      inputWrapperError: ge(na.inputWrapperError, k == null ? void 0 : k.inputWrapperError),
      inputWrapperDisabled: ge(na.inputWrapperDisabled, k == null ? void 0 : k.inputWrapperDisabled),
      inputLabel: ge(na.inputLabel, k == null ? void 0 : k.inputLabel),
      inputBorder: ge(na.inputBorder, k == null ? void 0 : k.inputBorder),
      inputLoader: ge(na.inputLoader, k == null ? void 0 : k.inputLoader),
      inputErrorText: ge(na.inputHelperText, na.inputErrorText, k == null ? void 0 : k.inputErrorText),
      inputHelperText: ge(na.inputHelperText, k == null ? void 0 : k.inputHelperText),
      value: ge(na.value, k == null ? void 0 : k.value),
      loader: ge(na.loader, k == null ? void 0 : k.loader),
      listBox: ge(na.listBox, k == null ? void 0 : k.listBox),
      listHeading: ge(na.listHeading, k == null ? void 0 : k.listHeading),
      listItem: ge(na.listItem, k == null ? void 0 : k.listItem),
      itemActive: ge(na.itemActive, k == null ? void 0 : k.itemActive),
      itemDisabled: ge(na.itemDisabled, k == null ? void 0 : k.itemDisabled),
      itemGroup: ge(na.itemGroup, k == null ? void 0 : k.itemGroup),
      itemSelected: ge(na.itemSelected, k == null ? void 0 : k.itemSelected),
      noResults: ge(na.noResults, k == null ? void 0 : k.noResults)
    },
    onFocus: D,
    onBlur: I,
    onChange: O,
    onOpenDropdown: P,
    labels: L,
    helperText: F,
    renderCustomListItem: j,
    renderCustomItemContent: V,
    renderCustomLabel: K,
    isLoading: Q,
    loaderConfig: {
      strokeColor: gl.color.teal[500].value,
      trackColor: gl.color.gray[500].value
    }
  }),
  su = [];
for (let t = 0; t < 256; ++t) su.push((t + 256).toString(16).slice(1));
function kie(t, e = 0) {
  return (su[t[e + 0]] + su[t[e + 1]] + su[t[e + 2]] + su[t[e + 3]] + "-" + su[t[e + 4]] + su[t[e + 5]] + "-" + su[t[e + 6]] + su[t[e + 7]] + "-" + su[t[e + 8]] + su[t[e + 9]] + "-" + su[t[e + 10]] + su[t[e + 11]] + su[t[e + 12]] + su[t[e + 13]] + su[t[e + 14]] + su[t[e + 15]]).toLowerCase();
}
let O2;
const Tie = new Uint8Array(16);
function Rie() {
  if (!O2) {
    if (typeof crypto > "u" || !crypto.getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    O2 = crypto.getRandomValues.bind(crypto);
  }
  return O2(Tie);
}
const Die = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto),
  _B = {
    randomUUID: Die
  };
function xB(t, e, i) {
  var c;
  if (_B.randomUUID && !t) return _B.randomUUID();
  t = t || {};
  const l = t.random ?? ((c = t.rng) == null ? void 0 : c.call(t)) ?? Rie();
  if (l.length < 16) throw new Error("Random bytes length must be >= 16");
  return l[6] = l[6] & 15 | 64, l[8] = l[8] & 63 | 128, kie(l);
}
const Iie = "_footer_4gsp9_2",
  Mie = "_footer__section__container_4gsp9_10",
  Oie = "_footer__sections_4gsp9_35",
  Lie = "_footer__body_4gsp9_61",
  Pie = "_noLogo_4gsp9_78",
  Aie = "_footer__logo_4gsp9_87",
  jie = "_footer__corporateLogo_4gsp9_98",
  Fie = "_logoImage_4gsp9_106",
  Nie = "_footer__corporateMessage_4gsp9_110",
  zie = "_footer__section_4gsp9_10",
  Vie = "_footer__section__title_4gsp9_143",
  Bie = "_footer__copyright_4gsp9_152",
  Uie = "_footer__bottomContainer_4gsp9_167",
  Hie = "_footer__bottom_4gsp9_167",
  $ie = "_footer__lang_4gsp9_195",
  Wie = "_footer__links_4gsp9_205",
  qie = "_langToggle__current_4gsp9_222",
  Yie = "_langToggle__alternative_4gsp9_228",
  Gie = "_tab__label_4gsp9_232",
  Xie = "_tab_4gsp9_232",
  Kie = "_tab__label__chevron_4gsp9_255",
  Qie = "_tab__content_4gsp9_314",
  mo = {
    footer: Iie,
    footer__section__container: Mie,
    footer__sections: Oie,
    footer__body: Lie,
    noLogo: Pie,
    footer__logo: Aie,
    footer__corporateLogo: jie,
    logoImage: Fie,
    footer__corporateMessage: Nie,
    footer__section: zie,
    footer__section__title: Vie,
    footer__copyright: Bie,
    footer__bottomContainer: Uie,
    footer__bottom: Hie,
    footer__lang: $ie,
    footer__links: Wie,
    langToggle__current: qie,
    langToggle__alternative: Yie,
    tab__label: Gie,
    tab: Xie,
    tab__label__chevron: Kie,
    tab__content: Qie
  },
  SB = ({
    renderLinks: t,
    columnData: e
  }) => {
    var i;
    return /* @__PURE__ */B.jsxs("div", {
      className: ge(mo.footer__section, mo.tab),
      children: [/* @__PURE__ */B.jsx("input", {
        type: "checkbox",
        id: e.id
      }), /* @__PURE__ */B.jsxs("label", {
        htmlFor: e.id,
        className: ge(mo.footer__section__title, mo.tab__label),
        children: [e.title, /* @__PURE__ */B.jsx("span", {
          className: mo.tab__label__chevron
        })]
      }), /* @__PURE__ */B.jsx("div", {
        className: mo.tab__content,
        children: /* @__PURE__ */B.jsx("ul", {
          children: (i = e.links) == null ? void 0 : i.map(l => /* @__PURE__ */B.jsx("li", {
            children: t(l, mo.footer__links)
          }, l.id))
        })
      })]
    }, `column-section-${e.id}`);
  },
  W_e = ({
    className: t,
    classNames: e,
    columns: i,
    copyrightText: l,
    altLangPages: c,
    locale: p,
    langLabel: h = "Language preference",
    renderLanguageToggle: y,
    renderLinks: w = (C, k) => /* @__PURE__ */B.jsx("a", {
      className: k,
      href: C.href,
      target: C.target,
      children: C.title
    }),
    renderImage: x = C => /* @__PURE__ */B.jsx("img", {
      ...C
    }),
    logoData: E
  }) => /* @__PURE__ */B.jsxs("footer", {
    className: ge(mo.footer, t, e == null ? void 0 : e.footer),
    children: [(!!(i != null && i.length) || (E == null ? void 0 : E.logoImage) || (E == null ? void 0 : E.logoMessage)) && /* @__PURE__ */B.jsxs("div", {
      className: ge(mo.footer__body, e == null ? void 0 : e.footerBody, !(E != null && E.logoImage) && !(E != null && E.logoMessage) && mo.noLogo),
      children: [!!(i != null && i.length) && /* @__PURE__ */B.jsx("div", {
        className: mo.footer__sections,
        children: i == null ? void 0 : i.map(C => Array.isArray(C) ? /* @__PURE__ */B.jsx("div", {
          className: mo.footer__section__container,
          children: C.map(k => /* @__PURE__ */B.jsx(SB, {
            renderLinks: w,
            columnData: k
          }, k.id))
        }, xB()) : /* @__PURE__ */B.jsx("div", {
          className: mo.footer__section__container,
          children: /* @__PURE__ */B.jsx(SB, {
            renderLinks: w,
            columnData: C
          }, C.id)
        }, xB()))
      }), ((E == null ? void 0 : E.logoImage) || (E == null ? void 0 : E.logoMessage)) && /* @__PURE__ */B.jsxs("div", {
        className: mo.footer__logo,
        children: [(E == null ? void 0 : E.logoImage) && /* @__PURE__ */B.jsx("div", {
          className: mo.footer__corporateLogo,
          children: x({
            ...E.logoImage,
            className: mo.logoImage
          })
        }), (E == null ? void 0 : E.logoMessage) && /* @__PURE__ */B.jsx("div", {
          className: mo.footer__corporateMessage,
          children: E.logoMessage
        })]
      })]
    }), /* @__PURE__ */B.jsx("div", {
      className: ge(mo.footer__bottomContainer, e == null ? void 0 : e.footerBottomContainer),
      children: /* @__PURE__ */B.jsxs("div", {
        className: ge(mo.footer__bottom, e == null ? void 0 : e.footerBottom),
        children: [l && /* @__PURE__ */B.jsx("div", {
          className: mo.footer__copyright,
          children: /* @__PURE__ */B.jsx("p", {
            children: l
          })
        }), y && /* @__PURE__ */B.jsx("div", {
          className: mo.footer__lang,
          children: y(c, {
            classNames: {
              currentLanguage: mo.langToggle__current,
              altLanguage: mo.langToggle__alternative
            },
            locale: p,
            select: {
              label: h
            }
          })
        })]
      })
    })]
  }),
  Zie = "_headerContainer_1p01n_8",
  Jie = "_headerTop_1p01n_12",
  eae = "_wrapper_1p01n_27",
  tae = "_header_1p01n_8",
  nae = "_headerWrapper_1p01n_40",
  rae = "_imageContainer_1p01n_44",
  iae = "_image_1p01n_44",
  aae = "_imageContainerMobile_1p01n_71",
  oae = "_imageContainerDesktop_1p01n_75",
  sae = "_imageContainerMobileImage_1p01n_99",
  lae = "_nav_1p01n_104",
  uae = "_ul_1p01n_115",
  cae = "_li_1p01n_141",
  dae = "_navLink_1p01n_147",
  fae = "_navLinkText_1p01n_161",
  pae = "_menu_1p01n_181",
  hae = "_menuButton_1p01n_186",
  mae = "_menuIcon_1p01n_200",
  vae = "_backToHome_1p01n_218",
  gae = "_backToHomeMessage_1p01n_223",
  yae = "_backToHomeIcon_1p01n_237",
  bae = "_backToHomeText_1p01n_241",
  ni = {
    headerContainer: Zie,
    headerTop: Jie,
    wrapper: eae,
    header: tae,
    headerWrapper: nae,
    imageContainer: rae,
    image: iae,
    imageContainerMobile: aae,
    imageContainerDesktop: oae,
    imageContainerMobileImage: sae,
    nav: lae,
    ul: uae,
    li: cae,
    navLink: dae,
    navLinkText: fae,
    menu: pae,
    menuButton: hae,
    menuIcon: mae,
    backToHome: vae,
    backToHomeMessage: gae,
    backToHomeIcon: yae,
    backToHomeText: bae
  },
  wae = t => {
    const e = /* @__PURE__ */new Map();
    return Nt.Children.forEach(t, i => {
      var c, p, h;
      if (!Nt.isValidElement(i)) return;
      const l = (c = i == null ? void 0 : i.props) == null ? void 0 : c.slot;
      if (l) {
        const {
            ...y
          } = i.props,
          w = sH(i.type, {
            ...y,
            key: (p = e.get(l)) != null && p.length ? `${l}-${(h = e.get(l)) == null ? void 0 : h.length}` : `${l}-0`
          });
        e.has(l) ? e.set(l, [...e.get(l), w]) : e.set(l, [w]);
      }
    }), {
      get(i, l) {
        const c = e.get(i);
        return c ? l ? l(c) : c : null;
      }
    };
  },
  _ae = (t = 0, e = !1) => ({
    open: {
      opacity: 1,
      visibility: "visible",
      transition: {
        delay: t,
        type: "spring",
        stiffness: 220,
        damping: 40
      }
    },
    closed: {
      opacity: e ? 1 : 0,
      visibility: e ? "visible" : "hidden",
      transition: e ? void 0 : {
        delay: 0.2,
        type: "spring",
        stiffness: 800,
        damping: 40
      }
    }
  }),
  xae = (t = !1) => ({
    open: {
      y: 0,
      opacity: 1,
      transition: {
        y: {
          stiffness: 1e3,
          velocity: -100
        }
      }
    },
    closed: {
      y: t ? 0 : 20,
      opacity: t ? 1 : 0,
      transition: {
        y: {
          stiffness: 1e3
        }
      }
    }
  }),
  Sae = {
    brand: "wvi",
    url: "https://hotelinfoservice.sunwingtravelgroup.com",
    options: {}
  },
  Eae = (t, e, i) => {
    const {
        url: l,
        brand: c,
        options: p
      } = {
        ...Sae,
        ...i
      },
      h = N4(t),
      y = `${l}/${c}/${h}/hotelNameCode/${e}`;
    return fetch(y, p).then(w => w.json());
  };
var ld = function () {
  return ld = Object.assign || function (e) {
    for (var i, l = 1, c = arguments.length; l < c; l++) {
      i = arguments[l];
      for (var p in i) Object.prototype.hasOwnProperty.call(i, p) && (e[p] = i[p]);
    }
    return e;
  }, ld.apply(this, arguments);
};
function EO(t, e) {
  var i = {};
  for (var l in t) Object.prototype.hasOwnProperty.call(t, l) && e.indexOf(l) < 0 && (i[l] = t[l]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function") for (var c = 0, l = Object.getOwnPropertySymbols(t); c < l.length; c++) e.indexOf(l[c]) < 0 && Object.prototype.propertyIsEnumerable.call(t, l[c]) && (i[l[c]] = t[l[c]]);
  return i;
}
function Cae() {
  for (var t = 0, e = 0, i = arguments.length; e < i; e++) t += arguments[e].length;
  for (var l = Array(t), c = 0, e = 0; e < i; e++) for (var p = arguments[e], h = 0, y = p.length; h < y; h++, c++) l[c] = p[h];
  return l;
}
function kae(t, e, i) {
  if (i || arguments.length === 2) for (var l = 0, c = e.length, p; l < c; l++) (p || !(l in e)) && (p || (p = Array.prototype.slice.call(e, 0, l)), p[l] = e[l]);
  return t.concat(p || Array.prototype.slice.call(e));
}
var WM = "right-scroll-bar-position",
  qM = "width-before-scroll-bar",
  Tae = "with-scroll-bars-hidden",
  Rae = "--removed-body-scroll-bar-size";
function L2(t, e) {
  return typeof t == "function" ? t(e) : t && (t.current = e), t;
}
function Dae(t, e) {
  var i = rt(function () {
    return {
      // value
      value: t,
      // last callback
      callback: e,
      // "memoized" public interface
      facade: {
        get current() {
          return i.value;
        },
        set current(l) {
          var c = i.value;
          c !== l && (i.value = l, i.callback(l, c));
        }
      }
    };
  })[0];
  return i.callback = e, i.facade;
}
var Iae = typeof window < "u" ? Bn.useLayoutEffect : Bn.useEffect,
  EB = /* @__PURE__ */new WeakMap();
function c$(t, e) {
  var i = Dae(null, function (l) {
    return t.forEach(function (c) {
      return L2(c, l);
    });
  });
  return Iae(function () {
    var l = EB.get(i);
    if (l) {
      var c = new Set(l),
        p = new Set(t),
        h = i.current;
      c.forEach(function (y) {
        p.has(y) || L2(y, null);
      }), p.forEach(function (y) {
        c.has(y) || L2(y, h);
      });
    }
    EB.set(i, t);
  }, [t]), i;
}
function d$(t) {
  return t;
}
function f$(t, e) {
  e === void 0 && (e = d$);
  var i = [],
    l = !1,
    c = {
      read: function () {
        if (l) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
        return i.length ? i[i.length - 1] : t;
      },
      useMedium: function (p) {
        var h = e(p, l);
        return i.push(h), function () {
          i = i.filter(function (y) {
            return y !== h;
          });
        };
      },
      assignSyncMedium: function (p) {
        for (l = !0; i.length;) {
          var h = i;
          i = [], h.forEach(p);
        }
        i = {
          push: function (y) {
            return p(y);
          },
          filter: function () {
            return i;
          }
        };
      },
      assignMedium: function (p) {
        l = !0;
        var h = [];
        if (i.length) {
          var y = i;
          i = [], y.forEach(p), h = i;
        }
        var w = function () {
            var E = h;
            h = [], E.forEach(p);
          },
          x = function () {
            return Promise.resolve().then(w);
          };
        x(), i = {
          push: function (E) {
            h.push(E), x();
          },
          filter: function (E) {
            return h = h.filter(E), i;
          }
        };
      }
    };
  return c;
}
function IN(t, e) {
  return e === void 0 && (e = d$), f$(t, e);
}
function MN(t) {
  t === void 0 && (t = {});
  var e = f$(null);
  return e.options = ld({
    async: !0,
    ssr: !1
  }, t), e;
}
var p$ = function (t) {
  var e = t.sideCar,
    i = EO(t, ["sideCar"]);
  if (!e) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var l = e.read();
  if (!l) throw new Error("Sidecar medium not found");
  return Bn.createElement(l, ld({}, i));
};
p$.isSideCarExport = !0;
function ON(t, e) {
  return t.useMedium(e), p$;
}
var h$ = MN(),
  P2 = function () {},
  LN = Bn.forwardRef(function (t, e) {
    var i = Bn.useRef(null),
      l = Bn.useState({
        onScrollCapture: P2,
        onWheelCapture: P2,
        onTouchMoveCapture: P2
      }),
      c = l[0],
      p = l[1],
      h = t.forwardProps,
      y = t.children,
      w = t.className,
      x = t.removeScrollBar,
      E = t.enabled,
      C = t.shards,
      k = t.sideCar,
      D = t.noRelative,
      I = t.noIsolation,
      O = t.inert,
      P = t.allowPinchZoom,
      N = t.as,
      L = N === void 0 ? "div" : N,
      F = t.gapMode,
      j = EO(t, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]),
      V = k,
      K = c$([i, e]),
      G = ld(ld({}, j), c);
    return Bn.createElement(Bn.Fragment, null, E && Bn.createElement(V, {
      sideCar: h$,
      removeScrollBar: x,
      shards: C,
      noRelative: D,
      noIsolation: I,
      inert: O,
      setCallbacks: p,
      allowPinchZoom: !!P,
      lockRef: i,
      gapMode: F
    }), h ? Bn.cloneElement(Bn.Children.only(y), ld(ld({}, G), {
      ref: K
    })) : Bn.createElement(L, ld({}, G, {
      className: w,
      ref: K
    }), y));
  });
LN.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
LN.classNames = {
  fullWidth: qM,
  zeroRight: WM
};
function CO() {
  return CO = Object.assign ? Object.assign.bind() : function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var i = arguments[e];
      for (var l in i) ({}).hasOwnProperty.call(i, l) && (t[l] = i[l]);
    }
    return t;
  }, CO.apply(null, arguments);
}
var gM = {
    exports: {}
  },
  yM = {
    exports: {}
  },
  mi = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var CB;
function Mae() {
  if (CB) return mi;
  CB = 1;
  var t = typeof Symbol == "function" && Symbol.for,
    e = t ? Symbol.for("react.element") : 60103,
    i = t ? Symbol.for("react.portal") : 60106,
    l = t ? Symbol.for("react.fragment") : 60107,
    c = t ? Symbol.for("react.strict_mode") : 60108,
    p = t ? Symbol.for("react.profiler") : 60114,
    h = t ? Symbol.for("react.provider") : 60109,
    y = t ? Symbol.for("react.context") : 60110,
    w = t ? Symbol.for("react.async_mode") : 60111,
    x = t ? Symbol.for("react.concurrent_mode") : 60111,
    E = t ? Symbol.for("react.forward_ref") : 60112,
    C = t ? Symbol.for("react.suspense") : 60113,
    k = t ? Symbol.for("react.suspense_list") : 60120,
    D = t ? Symbol.for("react.memo") : 60115,
    I = t ? Symbol.for("react.lazy") : 60116,
    O = t ? Symbol.for("react.block") : 60121,
    P = t ? Symbol.for("react.fundamental") : 60117,
    N = t ? Symbol.for("react.responder") : 60118,
    L = t ? Symbol.for("react.scope") : 60119;
  function F(V) {
    if (typeof V == "object" && V !== null) {
      var K = V.$$typeof;
      switch (K) {
        case e:
          switch (V = V.type, V) {
            case w:
            case x:
            case l:
            case p:
            case c:
            case C:
              return V;
            default:
              switch (V = V && V.$$typeof, V) {
                case y:
                case E:
                case I:
                case D:
                case h:
                  return V;
                default:
                  return K;
              }
          }
        case i:
          return K;
      }
    }
  }
  function j(V) {
    return F(V) === x;
  }
  return mi.AsyncMode = w, mi.ConcurrentMode = x, mi.ContextConsumer = y, mi.ContextProvider = h, mi.Element = e, mi.ForwardRef = E, mi.Fragment = l, mi.Lazy = I, mi.Memo = D, mi.Portal = i, mi.Profiler = p, mi.StrictMode = c, mi.Suspense = C, mi.isAsyncMode = function (V) {
    return j(V) || F(V) === w;
  }, mi.isConcurrentMode = j, mi.isContextConsumer = function (V) {
    return F(V) === y;
  }, mi.isContextProvider = function (V) {
    return F(V) === h;
  }, mi.isElement = function (V) {
    return typeof V == "object" && V !== null && V.$$typeof === e;
  }, mi.isForwardRef = function (V) {
    return F(V) === E;
  }, mi.isFragment = function (V) {
    return F(V) === l;
  }, mi.isLazy = function (V) {
    return F(V) === I;
  }, mi.isMemo = function (V) {
    return F(V) === D;
  }, mi.isPortal = function (V) {
    return F(V) === i;
  }, mi.isProfiler = function (V) {
    return F(V) === p;
  }, mi.isStrictMode = function (V) {
    return F(V) === c;
  }, mi.isSuspense = function (V) {
    return F(V) === C;
  }, mi.isValidElementType = function (V) {
    return typeof V == "string" || typeof V == "function" || V === l || V === x || V === p || V === c || V === C || V === k || typeof V == "object" && V !== null && (V.$$typeof === I || V.$$typeof === D || V.$$typeof === h || V.$$typeof === y || V.$$typeof === E || V.$$typeof === P || V.$$typeof === N || V.$$typeof === L || V.$$typeof === O);
  }, mi.typeOf = F, mi;
}
var vi = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var kB;
function Oae() {
  return kB || (kB = 1, process.env.NODE_ENV !== "production" && function () {
    var t = typeof Symbol == "function" && Symbol.for,
      e = t ? Symbol.for("react.element") : 60103,
      i = t ? Symbol.for("react.portal") : 60106,
      l = t ? Symbol.for("react.fragment") : 60107,
      c = t ? Symbol.for("react.strict_mode") : 60108,
      p = t ? Symbol.for("react.profiler") : 60114,
      h = t ? Symbol.for("react.provider") : 60109,
      y = t ? Symbol.for("react.context") : 60110,
      w = t ? Symbol.for("react.async_mode") : 60111,
      x = t ? Symbol.for("react.concurrent_mode") : 60111,
      E = t ? Symbol.for("react.forward_ref") : 60112,
      C = t ? Symbol.for("react.suspense") : 60113,
      k = t ? Symbol.for("react.suspense_list") : 60120,
      D = t ? Symbol.for("react.memo") : 60115,
      I = t ? Symbol.for("react.lazy") : 60116,
      O = t ? Symbol.for("react.block") : 60121,
      P = t ? Symbol.for("react.fundamental") : 60117,
      N = t ? Symbol.for("react.responder") : 60118,
      L = t ? Symbol.for("react.scope") : 60119;
    function F(ye) {
      return typeof ye == "string" || typeof ye == "function" ||
      // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      ye === l || ye === x || ye === p || ye === c || ye === C || ye === k || typeof ye == "object" && ye !== null && (ye.$$typeof === I || ye.$$typeof === D || ye.$$typeof === h || ye.$$typeof === y || ye.$$typeof === E || ye.$$typeof === P || ye.$$typeof === N || ye.$$typeof === L || ye.$$typeof === O);
    }
    function j(ye) {
      if (typeof ye == "object" && ye !== null) {
        var qe = ye.$$typeof;
        switch (qe) {
          case e:
            var Ae = ye.type;
            switch (Ae) {
              case w:
              case x:
              case l:
              case p:
              case c:
              case C:
                return Ae;
              default:
                var Mt = Ae && Ae.$$typeof;
                switch (Mt) {
                  case y:
                  case E:
                  case I:
                  case D:
                  case h:
                    return Mt;
                  default:
                    return qe;
                }
            }
          case i:
            return qe;
        }
      }
    }
    var V = w,
      K = x,
      G = y,
      Q = h,
      te = e,
      ie = E,
      Y = l,
      ee = I,
      oe = D,
      ne = i,
      se = p,
      ue = c,
      W = C,
      $ = !1;
    function le(ye) {
      return $ || ($ = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), H(ye) || j(ye) === w;
    }
    function H(ye) {
      return j(ye) === x;
    }
    function ce(ye) {
      return j(ye) === y;
    }
    function de(ye) {
      return j(ye) === h;
    }
    function Ce(ye) {
      return typeof ye == "object" && ye !== null && ye.$$typeof === e;
    }
    function Ee(ye) {
      return j(ye) === E;
    }
    function fe(ye) {
      return j(ye) === l;
    }
    function xe(ye) {
      return j(ye) === I;
    }
    function we(ye) {
      return j(ye) === D;
    }
    function ve(ye) {
      return j(ye) === i;
    }
    function Te(ye) {
      return j(ye) === p;
    }
    function ze(ye) {
      return j(ye) === c;
    }
    function Xe(ye) {
      return j(ye) === C;
    }
    vi.AsyncMode = V, vi.ConcurrentMode = K, vi.ContextConsumer = G, vi.ContextProvider = Q, vi.Element = te, vi.ForwardRef = ie, vi.Fragment = Y, vi.Lazy = ee, vi.Memo = oe, vi.Portal = ne, vi.Profiler = se, vi.StrictMode = ue, vi.Suspense = W, vi.isAsyncMode = le, vi.isConcurrentMode = H, vi.isContextConsumer = ce, vi.isContextProvider = de, vi.isElement = Ce, vi.isForwardRef = Ee, vi.isFragment = fe, vi.isLazy = xe, vi.isMemo = we, vi.isPortal = ve, vi.isProfiler = Te, vi.isStrictMode = ze, vi.isSuspense = Xe, vi.isValidElementType = F, vi.typeOf = j;
  }()), vi;
}
var TB;
function m$() {
  return TB || (TB = 1, process.env.NODE_ENV === "production" ? yM.exports = Mae() : yM.exports = Oae()), yM.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var A2, RB;
function Lae() {
  if (RB) return A2;
  RB = 1;
  var t = Object.getOwnPropertySymbols,
    e = Object.prototype.hasOwnProperty,
    i = Object.prototype.propertyIsEnumerable;
  function l(p) {
    if (p == null) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(p);
  }
  function c() {
    try {
      if (!Object.assign) return !1;
      var p = new String("abc");
      if (p[5] = "de", Object.getOwnPropertyNames(p)[0] === "5") return !1;
      for (var h = {}, y = 0; y < 10; y++) h["_" + String.fromCharCode(y)] = y;
      var w = Object.getOwnPropertyNames(h).map(function (E) {
        return h[E];
      });
      if (w.join("") !== "0123456789") return !1;
      var x = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (E) {
        x[E] = E;
      }), Object.keys(Object.assign({}, x)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return A2 = c() ? Object.assign : function (p, h) {
    for (var y, w = l(p), x, E = 1; E < arguments.length; E++) {
      y = Object(arguments[E]);
      for (var C in y) e.call(y, C) && (w[C] = y[C]);
      if (t) {
        x = t(y);
        for (var k = 0; k < x.length; k++) i.call(y, x[k]) && (w[x[k]] = y[x[k]]);
      }
    }
    return w;
  }, A2;
}
var j2, DB;
function PN() {
  if (DB) return j2;
  DB = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return j2 = t, j2;
}
var F2, IB;
function v$() {
  return IB || (IB = 1, F2 = Function.call.bind(Object.prototype.hasOwnProperty)), F2;
}
var N2, MB;
function Pae() {
  if (MB) return N2;
  MB = 1;
  var t = function () {};
  if (process.env.NODE_ENV !== "production") {
    var e = /* @__PURE__ */PN(),
      i = {},
      l = /* @__PURE__ */v$();
    t = function (p) {
      var h = "Warning: " + p;
      typeof console < "u" && console.error(h);
      try {
        throw new Error(h);
      } catch {}
    };
  }
  function c(p, h, y, w, x) {
    if (process.env.NODE_ENV !== "production") {
      for (var E in p) if (l(p, E)) {
        var C;
        try {
          if (typeof p[E] != "function") {
            var k = Error((w || "React class") + ": " + y + " type `" + E + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof p[E] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
            throw k.name = "Invariant Violation", k;
          }
          C = p[E](h, E, w, y, null, e);
        } catch (I) {
          C = I;
        }
        if (C && !(C instanceof Error) && t((w || "React class") + ": type specification of " + y + " `" + E + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof C + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), C instanceof Error && !(C.message in i)) {
          i[C.message] = !0;
          var D = x ? x() : "";
          t("Failed " + y + " type: " + C.message + (D ?? ""));
        }
      }
    }
  }
  return c.resetWarningCache = function () {
    process.env.NODE_ENV !== "production" && (i = {});
  }, N2 = c, N2;
}
var z2, OB;
function Aae() {
  if (OB) return z2;
  OB = 1;
  var t = m$(),
    e = Lae(),
    i = /* @__PURE__ */PN(),
    l = /* @__PURE__ */v$(),
    c = /* @__PURE__ */Pae(),
    p = function () {};
  process.env.NODE_ENV !== "production" && (p = function (y) {
    var w = "Warning: " + y;
    typeof console < "u" && console.error(w);
    try {
      throw new Error(w);
    } catch {}
  });
  function h() {
    return null;
  }
  return z2 = function (y, w) {
    var x = typeof Symbol == "function" && Symbol.iterator,
      E = "@@iterator";
    function C(H) {
      var ce = H && (x && H[x] || H[E]);
      if (typeof ce == "function") return ce;
    }
    var k = "<<anonymous>>",
      D = {
        array: N("array"),
        bigint: N("bigint"),
        bool: N("boolean"),
        func: N("function"),
        number: N("number"),
        object: N("object"),
        string: N("string"),
        symbol: N("symbol"),
        any: L(),
        arrayOf: F,
        element: j(),
        elementType: V(),
        instanceOf: K,
        node: ie(),
        objectOf: Q,
        oneOf: G,
        oneOfType: te,
        shape: ee,
        exact: oe
      };
    function I(H, ce) {
      return H === ce ? H !== 0 || 1 / H === 1 / ce : H !== H && ce !== ce;
    }
    function O(H, ce) {
      this.message = H, this.data = ce && typeof ce == "object" ? ce : {}, this.stack = "";
    }
    O.prototype = Error.prototype;
    function P(H) {
      if (process.env.NODE_ENV !== "production") var ce = {},
        de = 0;
      function Ce(fe, xe, we, ve, Te, ze, Xe) {
        if (ve = ve || k, ze = ze || we, Xe !== i) {
          if (w) {
            var ye = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            throw ye.name = "Invariant Violation", ye;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var qe = ve + ":" + we;
            !ce[qe] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            de < 3 && (p("You are manually calling a React.PropTypes validation function for the `" + ze + "` prop on `" + ve + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), ce[qe] = !0, de++);
          }
        }
        return xe[we] == null ? fe ? xe[we] === null ? new O("The " + Te + " `" + ze + "` is marked as required " + ("in `" + ve + "`, but its value is `null`.")) : new O("The " + Te + " `" + ze + "` is marked as required in " + ("`" + ve + "`, but its value is `undefined`.")) : null : H(xe, we, ve, Te, ze);
      }
      var Ee = Ce.bind(null, !1);
      return Ee.isRequired = Ce.bind(null, !0), Ee;
    }
    function N(H) {
      function ce(de, Ce, Ee, fe, xe, we) {
        var ve = de[Ce],
          Te = ue(ve);
        if (Te !== H) {
          var ze = W(ve);
          return new O("Invalid " + fe + " `" + xe + "` of type " + ("`" + ze + "` supplied to `" + Ee + "`, expected ") + ("`" + H + "`."), {
            expectedType: H
          });
        }
        return null;
      }
      return P(ce);
    }
    function L() {
      return P(h);
    }
    function F(H) {
      function ce(de, Ce, Ee, fe, xe) {
        if (typeof H != "function") return new O("Property `" + xe + "` of component `" + Ee + "` has invalid PropType notation inside arrayOf.");
        var we = de[Ce];
        if (!Array.isArray(we)) {
          var ve = ue(we);
          return new O("Invalid " + fe + " `" + xe + "` of type " + ("`" + ve + "` supplied to `" + Ee + "`, expected an array."));
        }
        for (var Te = 0; Te < we.length; Te++) {
          var ze = H(we, Te, Ee, fe, xe + "[" + Te + "]", i);
          if (ze instanceof Error) return ze;
        }
        return null;
      }
      return P(ce);
    }
    function j() {
      function H(ce, de, Ce, Ee, fe) {
        var xe = ce[de];
        if (!y(xe)) {
          var we = ue(xe);
          return new O("Invalid " + Ee + " `" + fe + "` of type " + ("`" + we + "` supplied to `" + Ce + "`, expected a single ReactElement."));
        }
        return null;
      }
      return P(H);
    }
    function V() {
      function H(ce, de, Ce, Ee, fe) {
        var xe = ce[de];
        if (!t.isValidElementType(xe)) {
          var we = ue(xe);
          return new O("Invalid " + Ee + " `" + fe + "` of type " + ("`" + we + "` supplied to `" + Ce + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return P(H);
    }
    function K(H) {
      function ce(de, Ce, Ee, fe, xe) {
        if (!(de[Ce] instanceof H)) {
          var we = H.name || k,
            ve = le(de[Ce]);
          return new O("Invalid " + fe + " `" + xe + "` of type " + ("`" + ve + "` supplied to `" + Ee + "`, expected ") + ("instance of `" + we + "`."));
        }
        return null;
      }
      return P(ce);
    }
    function G(H) {
      if (!Array.isArray(H)) return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? p("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).") : p("Invalid argument supplied to oneOf, expected an array.")), h;
      function ce(de, Ce, Ee, fe, xe) {
        for (var we = de[Ce], ve = 0; ve < H.length; ve++) if (I(we, H[ve])) return null;
        var Te = JSON.stringify(H, function (Xe, ye) {
          var qe = W(ye);
          return qe === "symbol" ? String(ye) : ye;
        });
        return new O("Invalid " + fe + " `" + xe + "` of value `" + String(we) + "` " + ("supplied to `" + Ee + "`, expected one of " + Te + "."));
      }
      return P(ce);
    }
    function Q(H) {
      function ce(de, Ce, Ee, fe, xe) {
        if (typeof H != "function") return new O("Property `" + xe + "` of component `" + Ee + "` has invalid PropType notation inside objectOf.");
        var we = de[Ce],
          ve = ue(we);
        if (ve !== "object") return new O("Invalid " + fe + " `" + xe + "` of type " + ("`" + ve + "` supplied to `" + Ee + "`, expected an object."));
        for (var Te in we) if (l(we, Te)) {
          var ze = H(we, Te, Ee, fe, xe + "." + Te, i);
          if (ze instanceof Error) return ze;
        }
        return null;
      }
      return P(ce);
    }
    function te(H) {
      if (!Array.isArray(H)) return process.env.NODE_ENV !== "production" && p("Invalid argument supplied to oneOfType, expected an instance of array."), h;
      for (var ce = 0; ce < H.length; ce++) {
        var de = H[ce];
        if (typeof de != "function") return p("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + $(de) + " at index " + ce + "."), h;
      }
      function Ce(Ee, fe, xe, we, ve) {
        for (var Te = [], ze = 0; ze < H.length; ze++) {
          var Xe = H[ze],
            ye = Xe(Ee, fe, xe, we, ve, i);
          if (ye == null) return null;
          ye.data && l(ye.data, "expectedType") && Te.push(ye.data.expectedType);
        }
        var qe = Te.length > 0 ? ", expected one of type [" + Te.join(", ") + "]" : "";
        return new O("Invalid " + we + " `" + ve + "` supplied to " + ("`" + xe + "`" + qe + "."));
      }
      return P(Ce);
    }
    function ie() {
      function H(ce, de, Ce, Ee, fe) {
        return ne(ce[de]) ? null : new O("Invalid " + Ee + " `" + fe + "` supplied to " + ("`" + Ce + "`, expected a ReactNode."));
      }
      return P(H);
    }
    function Y(H, ce, de, Ce, Ee) {
      return new O((H || "React class") + ": " + ce + " type `" + de + "." + Ce + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Ee + "`.");
    }
    function ee(H) {
      function ce(de, Ce, Ee, fe, xe) {
        var we = de[Ce],
          ve = ue(we);
        if (ve !== "object") return new O("Invalid " + fe + " `" + xe + "` of type `" + ve + "` " + ("supplied to `" + Ee + "`, expected `object`."));
        for (var Te in H) {
          var ze = H[Te];
          if (typeof ze != "function") return Y(Ee, fe, xe, Te, W(ze));
          var Xe = ze(we, Te, Ee, fe, xe + "." + Te, i);
          if (Xe) return Xe;
        }
        return null;
      }
      return P(ce);
    }
    function oe(H) {
      function ce(de, Ce, Ee, fe, xe) {
        var we = de[Ce],
          ve = ue(we);
        if (ve !== "object") return new O("Invalid " + fe + " `" + xe + "` of type `" + ve + "` " + ("supplied to `" + Ee + "`, expected `object`."));
        var Te = e({}, de[Ce], H);
        for (var ze in Te) {
          var Xe = H[ze];
          if (l(H, ze) && typeof Xe != "function") return Y(Ee, fe, xe, ze, W(Xe));
          if (!Xe) return new O("Invalid " + fe + " `" + xe + "` key `" + ze + "` supplied to `" + Ee + "`.\nBad object: " + JSON.stringify(de[Ce], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(H), null, "  "));
          var ye = Xe(we, ze, Ee, fe, xe + "." + ze, i);
          if (ye) return ye;
        }
        return null;
      }
      return P(ce);
    }
    function ne(H) {
      switch (typeof H) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !H;
        case "object":
          if (Array.isArray(H)) return H.every(ne);
          if (H === null || y(H)) return !0;
          var ce = C(H);
          if (ce) {
            var de = ce.call(H),
              Ce;
            if (ce !== H.entries) {
              for (; !(Ce = de.next()).done;) if (!ne(Ce.value)) return !1;
            } else for (; !(Ce = de.next()).done;) {
              var Ee = Ce.value;
              if (Ee && !ne(Ee[1])) return !1;
            }
          } else return !1;
          return !0;
        default:
          return !1;
      }
    }
    function se(H, ce) {
      return H === "symbol" ? !0 : ce ? ce["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && ce instanceof Symbol : !1;
    }
    function ue(H) {
      var ce = typeof H;
      return Array.isArray(H) ? "array" : H instanceof RegExp ? "object" : se(ce, H) ? "symbol" : ce;
    }
    function W(H) {
      if (typeof H > "u" || H === null) return "" + H;
      var ce = ue(H);
      if (ce === "object") {
        if (H instanceof Date) return "date";
        if (H instanceof RegExp) return "regexp";
      }
      return ce;
    }
    function $(H) {
      var ce = W(H);
      switch (ce) {
        case "array":
        case "object":
          return "an " + ce;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + ce;
        default:
          return ce;
      }
    }
    function le(H) {
      return !H.constructor || !H.constructor.name ? k : H.constructor.name;
    }
    return D.checkPropTypes = c, D.resetWarningCache = c.resetWarningCache, D.PropTypes = D, D;
  }, z2;
}
var V2, LB;
function jae() {
  if (LB) return V2;
  LB = 1;
  var t = /* @__PURE__ */PN();
  function e() {}
  function i() {}
  return i.resetWarningCache = e, V2 = function () {
    function l(h, y, w, x, E, C) {
      if (C !== t) {
        var k = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw k.name = "Invariant Violation", k;
      }
    }
    l.isRequired = l;
    function c() {
      return l;
    }
    var p = {
      array: l,
      bigint: l,
      bool: l,
      func: l,
      number: l,
      object: l,
      string: l,
      symbol: l,
      any: l,
      arrayOf: c,
      element: l,
      elementType: l,
      instanceOf: c,
      node: l,
      objectOf: c,
      oneOf: c,
      oneOfType: c,
      shape: c,
      exact: c,
      checkPropTypes: i,
      resetWarningCache: e
    };
    return p.PropTypes = p, p;
  }, V2;
}
var PB;
function AN() {
  if (PB) return gM.exports;
  if (PB = 1, process.env.NODE_ENV !== "production") {
    var t = m$(),
      e = !0;
    gM.exports = /* @__PURE__ */Aae()(t.isElement, e);
  } else gM.exports = /* @__PURE__ */jae()();
  return gM.exports;
}
var ia = /* @__PURE__ */AN();
const g$ = /* @__PURE__ */KO(ia);
var $j = "data-focus-lock",
  y$ = "data-focus-lock-disabled",
  Fae = "data-no-focus-lock",
  Nae = "data-autofocus-inside",
  zae = "data-no-autofocus",
  B2 = {
    width: "1px",
    height: "0px",
    padding: 0,
    overflow: "hidden",
    position: "fixed",
    top: "1px",
    left: "1px"
  };
process.env.NODE_ENV !== "production" && g$.node;
var b$ = IN({}, function (t) {
    var e = t.target,
      i = t.currentTarget;
    return {
      target: e,
      currentTarget: i
    };
  }),
  w$ = IN(),
  Vae = IN(),
  _$ = MN({
    async: !0,
    ssr: typeof document < "u"
  }),
  Bae = /* @__PURE__ */Up(void 0),
  Uae = [],
  x$ = /* @__PURE__ */Qn(function (e, i) {
    var l,
      c = rt(),
      p = c[0],
      h = c[1],
      y = vt(),
      w = vt(!1),
      x = vt(null),
      E = rt({}),
      C = E[1],
      k = e.children,
      D = e.disabled,
      I = D === void 0 ? !1 : D,
      O = e.noFocusGuards,
      P = O === void 0 ? !1 : O,
      N = e.persistentFocus,
      L = N === void 0 ? !1 : N,
      F = e.crossFrame,
      j = F === void 0 ? !0 : F,
      V = e.autoFocus,
      K = V === void 0 ? !0 : V,
      G = e.allowTextSelection,
      Q = e.group,
      te = e.className,
      ie = e.whiteList,
      Y = e.hasPositiveIndices,
      ee = e.shards,
      oe = ee === void 0 ? Uae : ee,
      ne = e.as,
      se = ne === void 0 ? "div" : ne,
      ue = e.lockProps,
      W = ue === void 0 ? {} : ue,
      $ = e.sideCar,
      le = e.returnFocus,
      H = le === void 0 ? !1 : le,
      ce = e.focusOptions,
      de = e.onActivation,
      Ce = e.onDeactivation,
      Ee = rt({}),
      fe = Ee[0],
      xe = pn(function (un) {
        var gt = un.captureFocusRestore;
        if (!x.current) {
          var Pt,
            St = (Pt = document) == null ? void 0 : Pt.activeElement;
          x.current = St, St !== document.body && (x.current = gt(St));
        }
        y.current && de && de(y.current), w.current = !0, C();
      }, [de]),
      we = pn(function () {
        w.current = !1, Ce && Ce(y.current), C();
      }, [Ce]),
      ve = pn(function (un) {
        var gt = x.current;
        if (gt) {
          var Pt = (typeof gt == "function" ? gt() : gt) || document.body,
            St = typeof H == "function" ? H(Pt) : H;
          if (St) {
            var Dt = typeof St == "object" ? St : void 0;
            x.current = null, un ? Promise.resolve().then(function () {
              return Pt.focus(Dt);
            }) : Pt.focus(Dt);
          }
        }
      }, [H]),
      Te = pn(function (un) {
        w.current && b$.useMedium(un);
      }, []),
      ze = w$.useMedium,
      Xe = pn(function (un) {
        y.current !== un && (y.current = un, h(un));
      }, []);
    process.env.NODE_ENV !== "production" && (typeof G < "u" && console.warn("React-Focus-Lock: allowTextSelection is deprecated and enabled by default"), Rt(function () {
      !y.current && typeof se != "string" && console.error("FocusLock: could not obtain ref to internal node");
    }, []));
    var ye = CO((l = {}, l[y$] = I && "disabled", l[$j] = Q, l), W),
      qe = P !== !0,
      Ae = qe && P !== "tail",
      Mt = c$([i, Xe]),
      Ft = ci(function () {
        return {
          observed: y,
          shards: oe,
          enabled: !I,
          active: w.current
        };
      }, [I, w.current, oe, p]);
    return /* @__PURE__ */Nt.createElement(Qv, null, qe && [/* @__PURE__ */Nt.createElement("div", {
      key: "guard-first",
      "data-focus-guard": !0,
      tabIndex: I ? -1 : 0,
      style: B2
    }), Y ? /* @__PURE__ */Nt.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": !0,
      tabIndex: I ? -1 : 1,
      style: B2
    }) : null], !I && /* @__PURE__ */Nt.createElement($, {
      id: fe,
      sideCar: _$,
      observed: p,
      disabled: I,
      persistentFocus: L,
      crossFrame: j,
      autoFocus: K,
      whiteList: ie,
      shards: oe,
      onActivation: xe,
      onDeactivation: we,
      returnFocus: ve,
      focusOptions: ce,
      noFocusGuards: P
    }), /* @__PURE__ */Nt.createElement(se, CO({
      ref: Mt
    }, ye, {
      className: te,
      onBlur: ze,
      onFocus: Te
    }), /* @__PURE__ */Nt.createElement(Bae.Provider, {
      value: Ft
    }, k)), Ae && /* @__PURE__ */Nt.createElement("div", {
      "data-focus-guard": !0,
      tabIndex: I ? -1 : 0,
      style: B2
    }));
  });
x$.propTypes = process.env.NODE_ENV !== "production" ? {
  children: ia.node,
  disabled: ia.bool,
  returnFocus: ia.oneOfType([ia.bool, ia.object, ia.func]),
  focusOptions: ia.object,
  noFocusGuards: ia.bool,
  hasPositiveIndices: ia.bool,
  allowTextSelection: ia.bool,
  autoFocus: ia.bool,
  persistentFocus: ia.bool,
  crossFrame: ia.bool,
  group: ia.string,
  className: ia.string,
  whiteList: ia.func,
  shards: ia.arrayOf(ia.any),
  as: ia.oneOfType([ia.string, ia.func, ia.object]),
  lockProps: ia.object,
  onActivation: ia.func,
  onDeactivation: ia.func,
  sideCar: ia.any.isRequired
} : {};
function jN(t) {
  setTimeout(t, 1);
}
var Hae = function (e) {
    return e && "current" in e ? e.current : e;
  },
  S$ = MN(),
  E$ = "data-focus-on-hidden",
  $ae = {
    preventScroll: !0
  },
  Wae = Bn.forwardRef(function (t, e) {
    var i = Bn.useState(!1),
      l = i[0],
      c = i[1],
      p = t.children,
      h = t.autoFocus,
      y = t.shards,
      w = t.crossFrame,
      x = t.enabled,
      E = x === void 0 ? !0 : x,
      C = t.scrollLock,
      k = C === void 0 ? !0 : C,
      D = t.focusLock,
      I = D === void 0 ? !0 : D,
      O = t.returnFocus,
      P = O === void 0 ? !0 : O,
      N = t.inert,
      L = t.allowPinchZoom,
      F = t.sideCar,
      j = t.className,
      V = t.shouldIgnore,
      K = t.preventScrollOnFocus,
      G = t.style,
      Q = t.as,
      te = t.gapMode,
      ie = EO(t, ["children", "autoFocus", "shards", "crossFrame", "enabled", "scrollLock", "focusLock", "returnFocus", "inert", "allowPinchZoom", "sideCar", "className", "shouldIgnore", "preventScrollOnFocus", "style", "as", "gapMode"]),
      Y = F,
      ee = l.onActivation,
      oe = l.onDeactivation,
      ne = EO(l, ["onActivation", "onDeactivation"]),
      se = ld(ld({}, ne), {
        as: Q,
        style: G,
        sideCar: F,
        shards: y,
        allowPinchZoom: L,
        gapMode: te,
        inert: N,
        enabled: E && k
      });
    return Bn.createElement(Bn.Fragment, null, Bn.createElement(x$, {
      ref: e,
      sideCar: F,
      disabled: !(l && E && I),
      returnFocus: P,
      autoFocus: h,
      shards: y,
      crossFrame: w,
      onActivation: ee,
      onDeactivation: oe,
      className: j,
      whiteList: V,
      lockProps: se,
      focusOptions: K ? $ae : void 0,
      as: LN
    }, p), E && Bn.createElement(Y, ld({}, ie, {
      sideCar: S$,
      setLockProps: c,
      shards: y
    })));
  });
function Wj(t, e) {
  return Wj = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (i, l) {
    return i.__proto__ = l, i;
  }, Wj(t, e);
}
function qae(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, Wj(t, e);
}
function mR(t) {
  "@babel/helpers - typeof";

  return mR = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (e) {
    return typeof e;
  } : function (e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, mR(t);
}
function Yae(t, e) {
  if (mR(t) != "object" || !t) return t;
  var i = t[Symbol.toPrimitive];
  if (i !== void 0) {
    var l = i.call(t, e);
    if (mR(l) != "object") return l;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Gae(t) {
  var e = Yae(t, "string");
  return mR(e) == "symbol" ? e : e + "";
}
function Xae(t, e, i) {
  return (e = Gae(e)) in t ? Object.defineProperty(t, e, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = i, t;
}
function Kae(t, e) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof t != "function") throw new Error("Expected reducePropsToState to be a function.");
    if (typeof e != "function") throw new Error("Expected handleStateChangeOnClient to be a function.");
  }
  function i(l) {
    return l.displayName || l.name || "Component";
  }
  return function (c) {
    if (process.env.NODE_ENV !== "production" && typeof c != "function") throw new Error("Expected WrappedComponent to be a React component.");
    var p = [],
      h;
    function y() {
      h = t(p.map(function (x) {
        return x.props;
      })), e(h);
    }
    var w = /* @__PURE__ */function (x) {
      qae(E, x);
      function E() {
        return x.apply(this, arguments) || this;
      }
      E.peek = function () {
        return h;
      };
      var C = E.prototype;
      return C.componentDidMount = function () {
        p.push(this), y();
      }, C.componentDidUpdate = function () {
        y();
      }, C.componentWillUnmount = function () {
        var D = p.indexOf(this);
        p.splice(D, 1), y();
      }, C.render = function () {
        return /* @__PURE__ */Nt.createElement(c, this.props);
      }, E;
    }(OW);
    return Xae(w, "displayName", "SideEffect(" + i(c) + ")"), w;
  };
}
var eg = function (t) {
    for (var e = Array(t.length), i = 0; i < t.length; ++i) e[i] = t[i];
    return e;
  },
  tS = function (t) {
    return Array.isArray(t) ? t : [t];
  },
  C$ = function (t) {
    return Array.isArray(t) ? t[0] : t;
  },
  Qae = function (t) {
    if (t.nodeType !== Node.ELEMENT_NODE) return !1;
    var e = window.getComputedStyle(t, null);
    return !e || !e.getPropertyValue ? !1 : e.getPropertyValue("display") === "none" || e.getPropertyValue("visibility") === "hidden";
  },
  k$ = function (t) {
    return t.parentNode && t.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ?
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    t.parentNode.host : t.parentNode;
  },
  T$ = function (t) {
    return t === document || t && t.nodeType === Node.DOCUMENT_NODE;
  },
  Zae = function (t) {
    return t.hasAttribute("inert");
  },
  Jae = function (t, e) {
    return !t || T$(t) || !Qae(t) && !Zae(t) && e(k$(t));
  },
  R$ = function (t, e) {
    var i = t.get(e);
    if (i !== void 0) return i;
    var l = Jae(e, R$.bind(void 0, t));
    return t.set(e, l), l;
  },
  eoe = function (t, e) {
    return t && !T$(t) ? roe(t) ? e(k$(t)) : !1 : !0;
  },
  D$ = function (t, e) {
    var i = t.get(e);
    if (i !== void 0) return i;
    var l = eoe(e, D$.bind(void 0, t));
    return t.set(e, l), l;
  },
  I$ = function (t) {
    return t.dataset;
  },
  toe = function (t) {
    return t.tagName === "BUTTON";
  },
  M$ = function (t) {
    return t.tagName === "INPUT";
  },
  O$ = function (t) {
    return M$(t) && t.type === "radio";
  },
  noe = function (t) {
    return !((M$(t) || toe(t)) && (t.type === "hidden" || t.disabled));
  },
  roe = function (t) {
    var e = t.getAttribute(zae);
    return ![!0, "true", ""].includes(e);
  },
  FN = function (t) {
    var e;
    return !!(t && !((e = I$(t)) === null || e === void 0) && e.focusGuard);
  },
  qj = function (t) {
    return !FN(t);
  },
  ioe = function (t) {
    return !!t;
  },
  aoe = function (t, e) {
    var i = Math.max(0, t.tabIndex),
      l = Math.max(0, e.tabIndex),
      c = i - l,
      p = t.index - e.index;
    if (c) {
      if (!i) return 1;
      if (!l) return -1;
    }
    return c || p;
  },
  ooe = function (t) {
    return t.tabIndex < 0 && !t.hasAttribute("tabindex") ? 0 : t.tabIndex;
  },
  NN = function (t, e, i) {
    return eg(t).map(function (l, c) {
      var p = ooe(l);
      return {
        node: l,
        index: c,
        tabIndex: i && p === -1 ? (l.dataset || {}).focusGuard ? 0 : -1 : p
      };
    }).filter(function (l) {
      return !e || l.tabIndex >= 0;
    }).sort(aoe);
  },
  soe = ["button:enabled", "select:enabled", "textarea:enabled", "input:enabled",
  // elements with explicit roles will also use explicit tabindex
  // '[role="button"]',
  "a[href]", "area[href]", "summary", "iframe", "object", "embed", "audio[controls]", "video[controls]", "[tabindex]", "[contenteditable]", "[autofocus]"],
  zN = soe.join(","),
  loe = "".concat(zN, ", [data-focus-guard]"),
  L$ = function (t, e) {
    return eg((t.shadowRoot || t).children).reduce(function (i, l) {
      return i.concat(l.matches(e ? loe : zN) ? [l] : [], L$(l));
    }, []);
  },
  uoe = function (t, e) {
    var i;
    return t instanceof HTMLIFrameElement && !((i = t.contentDocument) === null || i === void 0) && i.body ? TE([t.contentDocument.body], e) : [t];
  },
  TE = function (t, e) {
    return t.reduce(function (i, l) {
      var c,
        p = L$(l, e),
        h = (c = []).concat.apply(c, p.map(function (y) {
          return uoe(y, e);
        }));
      return i.concat(
      // add all tabbables inside and within shadow DOMs in DOM order
      h,
      // add if node is tabbable itself
      l.parentNode ? eg(l.parentNode.querySelectorAll(zN)).filter(function (y) {
        return y === l;
      }) : []);
    }, []);
  },
  coe = function (t) {
    var e = t.querySelectorAll("[".concat(Nae, "]"));
    return eg(e).map(function (i) {
      return TE([i]);
    }).reduce(function (i, l) {
      return i.concat(l);
    }, []);
  },
  VN = function (t, e) {
    return eg(t).filter(function (i) {
      return R$(e, i);
    }).filter(function (i) {
      return noe(i);
    });
  },
  AB = function (t, e) {
    return e === void 0 && (e = /* @__PURE__ */new Map()), eg(t).filter(function (i) {
      return D$(e, i);
    });
  },
  BN = function (t, e, i) {
    return NN(VN(TE(t, i), e), !0, i);
  },
  vR = function (t, e) {
    return NN(VN(TE(t), e), !1);
  },
  doe = function (t, e) {
    return VN(coe(t), e);
  },
  Xx = function (t, e) {
    return t.shadowRoot ? Xx(t.shadowRoot, e) : Object.getPrototypeOf(t).contains !== void 0 && Object.getPrototypeOf(t).contains.call(t, e) ? !0 : eg(t.children).some(function (i) {
      var l;
      if (i instanceof HTMLIFrameElement) {
        var c = (l = i.contentDocument) === null || l === void 0 ? void 0 : l.body;
        return c ? Xx(c, e) : !1;
      }
      return Xx(i, e);
    });
  },
  foe = function (t) {
    for (var e = /* @__PURE__ */new Set(), i = t.length, l = 0; l < i; l += 1) for (var c = l + 1; c < i; c += 1) {
      var p = t[l].compareDocumentPosition(t[c]);
      (p & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0 && e.add(c), (p & Node.DOCUMENT_POSITION_CONTAINS) > 0 && e.add(l);
    }
    return t.filter(function (h, y) {
      return !e.has(y);
    });
  },
  P$ = function (t) {
    return t.parentNode ? P$(t.parentNode) : t;
  },
  UN = function (t) {
    var e = tS(t);
    return e.filter(Boolean).reduce(function (i, l) {
      var c = l.getAttribute($j);
      return i.push.apply(i, c ? foe(eg(P$(l).querySelectorAll("[".concat($j, '="').concat(c, '"]:not([').concat(y$, '="disabled"])')))) : [l]), i;
    }, []);
  },
  poe = function (t) {
    try {
      return t();
    } catch {
      return;
    }
  },
  gR = function (t) {
    if (t === void 0 && (t = document), !(!t || !t.activeElement)) {
      var e = t.activeElement;
      return e.shadowRoot ? gR(e.shadowRoot) : e instanceof HTMLIFrameElement && poe(function () {
        return e.contentWindow.document;
      }) ? gR(e.contentWindow.document) : e;
    }
  },
  hoe = function (t, e) {
    return t === e;
  },
  moe = function (t, e) {
    return !!eg(t.querySelectorAll("iframe")).some(function (i) {
      return hoe(i, e);
    });
  },
  A$ = function (t, e) {
    return e === void 0 && (e = gR(C$(t).ownerDocument)), !e || e.dataset && e.dataset.focusGuard ? !1 : UN(t).some(function (i) {
      return Xx(i, e) || moe(i, e);
    });
  },
  voe = function (t) {
    t === void 0 && (t = document);
    var e = gR(t);
    return e ? eg(t.querySelectorAll("[".concat(Fae, "]"))).some(function (i) {
      return Xx(i, e);
    }) : !1;
  },
  goe = function (t, e) {
    return e.filter(O$).filter(function (i) {
      return i.name === t.name;
    }).filter(function (i) {
      return i.checked;
    })[0] || t;
  },
  HN = function (t, e) {
    return O$(t) && t.name ? goe(t, e) : t;
  },
  yoe = function (t) {
    var e = /* @__PURE__ */new Set();
    return t.forEach(function (i) {
      return e.add(HN(i, t));
    }), t.filter(function (i) {
      return e.has(i);
    });
  },
  jB = function (t) {
    return t[0] && t.length > 1 ? HN(t[0], t) : t[0];
  },
  FB = function (t, e) {
    return t.indexOf(HN(e, t));
  },
  Yj = "NEW_FOCUS",
  boe = function (t, e, i, l, c) {
    var p = t.length,
      h = t[0],
      y = t[p - 1],
      w = FN(l);
    if (!(l && t.indexOf(l) >= 0)) {
      var x = l !== void 0 ? i.indexOf(l) : -1,
        E = c ? i.indexOf(c) : x,
        C = c ? t.indexOf(c) : -1;
      if (x === -1) return C !== -1 ? C : Yj;
      if (C === -1) return Yj;
      var k = x - E,
        D = i.indexOf(h),
        I = i.indexOf(y),
        O = yoe(i),
        P = l !== void 0 ? O.indexOf(l) : -1,
        N = c ? O.indexOf(c) : P,
        L = O.filter(function (Q) {
          return Q.tabIndex >= 0;
        }),
        F = l !== void 0 ? L.indexOf(l) : -1,
        j = c ? L.indexOf(c) : F,
        V = F >= 0 && j >= 0 ?
        // old/new are tabbables, measure distance in tabbable space
        j - F :
        // or else measure in focusable space
        N - P;
      if (!k && C >= 0 || e.length === 0) return C;
      var K = FB(t, e[0]),
        G = FB(t, e[e.length - 1]);
      if (x <= D && w && Math.abs(k) > 1) return G;
      if (x >= I && w && Math.abs(k) > 1) return K;
      if (k && Math.abs(V) > 1) return C;
      if (x <= D) return G;
      if (x > I) return K;
      if (k) return Math.abs(k) > 1 ? C : (p + C + k) % p;
    }
  },
  woe = function (t) {
    return function (e) {
      var i,
        l = (i = I$(e)) === null || i === void 0 ? void 0 : i.autofocus;
      return (
        // @ts-expect-error
        e.autofocus ||
        //
        l !== void 0 && l !== "false" ||
        //
        t.indexOf(e) >= 0
      );
    };
  },
  NB = function (t, e, i) {
    var l = t.map(function (p) {
        var h = p.node;
        return h;
      }),
      c = AB(l.filter(woe(i)));
    return c && c.length ? jB(c) : jB(AB(e));
  },
  Gj = function (t, e) {
    return e === void 0 && (e = []), e.push(t), t.parentNode && Gj(t.parentNode.host || t.parentNode, e), e;
  },
  U2 = function (t, e) {
    for (var i = Gj(t), l = Gj(e), c = 0; c < i.length; c += 1) {
      var p = i[c];
      if (l.indexOf(p) >= 0) return p;
    }
    return !1;
  },
  j$ = function (t, e, i) {
    var l = tS(t),
      c = tS(e),
      p = l[0],
      h = !1;
    return c.filter(Boolean).forEach(function (y) {
      h = U2(h || y, y) || h, i.filter(Boolean).forEach(function (w) {
        var x = U2(p, w);
        x && (!h || Xx(x, h) ? h = x : h = U2(x, h));
      });
    }), h;
  },
  zB = function (t, e) {
    return t.reduce(function (i, l) {
      return i.concat(doe(l, e));
    }, []);
  },
  _oe = function (t, e) {
    var i = /* @__PURE__ */new Map();
    return e.forEach(function (l) {
      return i.set(l.node, l);
    }), t.map(function (l) {
      return i.get(l);
    }).filter(ioe);
  },
  xoe = function (t, e) {
    var i = gR(tS(t).length > 0 ? document : C$(t).ownerDocument),
      l = UN(t).filter(qj),
      c = j$(i || t, t, l),
      p = /* @__PURE__ */new Map(),
      h = vR(l, p),
      y = h.filter(function (I) {
        var O = I.node;
        return qj(O);
      });
    if (y[0]) {
      var w = vR([c], p).map(function (I) {
          var O = I.node;
          return O;
        }),
        x = _oe(w, y),
        E = x.map(function (I) {
          var O = I.node;
          return O;
        }),
        C = x.filter(function (I) {
          var O = I.tabIndex;
          return O >= 0;
        }).map(function (I) {
          var O = I.node;
          return O;
        }),
        k = boe(E, C, w, i, e);
      if (k === Yj) {
        var D =
        // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        NB(h, C, zB(l, p)) || NB(h, E, zB(l, p));
        if (D) return {
          node: D
        };
        console.warn("focus-lock: cannot find any node to move focus into");
        return;
      }
      return k === void 0 ? k : x[k];
    }
  },
  Soe = function (t) {
    var e = UN(t).filter(qj),
      i = j$(t, t, e),
      l = NN(TE([i], !0), !0, !0),
      c = TE(e, !1);
    return l.map(function (p) {
      var h = p.node,
        y = p.index;
      return {
        node: h,
        index: y,
        lockItem: c.indexOf(h) >= 0,
        guard: FN(h)
      };
    });
  },
  $N = function (t, e) {
    t && ("focus" in t && t.focus(e), "contentWindow" in t && t.contentWindow && t.contentWindow.focus());
  },
  H2 = 0,
  $2 = !1,
  F$ = function (t, e, i) {
    i === void 0 && (i = {});
    var l = xoe(t, e);
    if (!$2 && l) {
      if (H2 > 2) {
        console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting"), $2 = !0, setTimeout(function () {
          $2 = !1;
        }, 1);
        return;
      }
      H2++, $N(l.node, i.focusOptions), H2--;
    }
  };
function ST(t) {
  if (!t) return null;
  if (typeof WeakRef > "u") return function () {
    return t || null;
  };
  var e = t ? new WeakRef(t) : null;
  return function () {
    return (e == null ? void 0 : e.deref()) || null;
  };
}
var Eoe = function (t) {
    if (!t) return null;
    for (var e = [], i = t; i && i !== document.body;) e.push({
      current: ST(i),
      parent: ST(i.parentElement),
      left: ST(i.previousElementSibling),
      right: ST(i.nextElementSibling)
    }), i = i.parentElement;
    return {
      element: ST(t),
      stack: e,
      ownerDocument: t.ownerDocument
    };
  },
  Coe = function (t) {
    var e, i, l, c, p;
    if (t) for (var h = t.stack, y = t.ownerDocument, w = /* @__PURE__ */new Map(), x = 0, E = h; x < E.length; x++) {
      var C = E[x],
        k = (e = C.parent) === null || e === void 0 ? void 0 : e.call(C);
      if (k && y.contains(k)) {
        for (var D = (i = C.left) === null || i === void 0 ? void 0 : i.call(C), I = C.current(), O = k.contains(I) ? I : void 0, P = (l = C.right) === null || l === void 0 ? void 0 : l.call(C), N = BN([k], w), L =
          // that is element itself
          (p = (c = O ?? (
          // or something in it's place
          D == null ? void 0 : D.nextElementSibling)) !== null && c !== void 0 ? c :
          // or somebody to the right, still close enough
          P) !== null && p !== void 0 ? p :
          // or somebody to the left, something?
          D; L;) {
          for (var F = 0, j = N; F < j.length; F++) {
            var V = j[F];
            if (L != null && L.contains(V.node)) return V.node;
          }
          L = L.nextElementSibling;
        }
        if (N.length) return N[0].node;
      }
    }
  },
  N$ = function (t) {
    var e = Eoe(t);
    return function () {
      return Coe(e);
    };
  },
  koe = function (t, e, i) {
    if (!t || !e) return console.error("no element or scope given"), {};
    var l = tS(e);
    if (l.every(function (h) {
      return !Xx(h, t);
    })) return console.error("Active element is not contained in the scope"), {};
    var c = i ? BN(l, /* @__PURE__ */new Map()) : vR(l, /* @__PURE__ */new Map()),
      p = c.findIndex(function (h) {
        var y = h.node;
        return y === t;
      });
    if (p !== -1) return {
      prev: c[p - 1],
      next: c[p + 1],
      first: c[0],
      last: c[c.length - 1]
    };
  },
  Toe = function (t, e) {
    var i = e ? BN(tS(t), /* @__PURE__ */new Map()) : vR(tS(t), /* @__PURE__ */new Map());
    return {
      first: i[0],
      last: i[i.length - 1]
    };
  },
  Roe = function (t) {
    return Object.assign({
      scope: document.body,
      cycle: !0,
      onlyTabbable: !0
    }, t);
  },
  z$ = function (t, e, i) {
    e === void 0 && (e = {});
    var l = Roe(e),
      c = koe(t, l.scope, l.onlyTabbable);
    if (c) {
      var p = i(c, l.cycle);
      p && $N(p.node, l.focusOptions);
    }
  },
  Doe = function (t, e) {
    e === void 0 && (e = {}), z$(t, e, function (i, l) {
      var c = i.next,
        p = i.first;
      return c || l && p;
    });
  },
  Ioe = function (t, e) {
    e === void 0 && (e = {}), z$(t, e, function (i, l) {
      var c = i.prev,
        p = i.last;
      return c || l && p;
    });
  },
  V$ = function (t, e, i) {
    var l,
      c = Toe(t, (l = e.onlyTabbable) !== null && l !== void 0 ? l : !0),
      p = c[i];
    p && $N(p.node, e.focusOptions);
  },
  Moe = function (t, e) {
    e === void 0 && (e = {}), V$(t, e, "first");
  },
  Ooe = function (t, e) {
    e === void 0 && (e = {}), V$(t, e, "last");
  },
  B$ = function () {
    return document && document.activeElement === document.body;
  },
  Loe = function () {
    return B$() || voe();
  },
  mE = null,
  nd = null,
  VB = function () {
    return null;
  },
  vE = null,
  yR = !1,
  WN = !1,
  Poe = function () {
    return !0;
  },
  Aoe = function (e) {
    return (mE.whiteList || Poe)(e);
  },
  joe = function (e, i) {
    vE = {
      observerNode: e,
      portaledElement: i
    };
  },
  Foe = function (e) {
    return vE && vE.portaledElement === e;
  };
function BB(t, e, i, l) {
  var c = null,
    p = t;
  do {
    var h = l[p];
    if (h.guard) h.node.dataset.focusAutoGuard && (c = h);else if (h.lockItem) {
      if (p !== t) return;
      c = null;
    } else break;
  } while ((p += i) !== e);
  c && (c.node.tabIndex = 0);
}
var Noe = function (e) {
    return e ? !!yR : yR === "meanwhile";
  },
  zoe = function t(e, i, l) {
    return i && (i.host === e && (!i.activeElement || l.contains(i.activeElement)) || i.parentNode && t(e, i.parentNode, l));
  },
  Voe = function (e, i) {
    return i.some(function (l) {
      return zoe(e, l, l);
    });
  },
  U$ = function (e) {
    return vR(e, /* @__PURE__ */new Map());
  },
  Boe = function (e) {
    return !U$([e.parentNode]).some(function (i) {
      return i.node === e;
    });
  },
  kO = function () {
    var e = !1;
    if (mE) {
      var i = mE,
        l = i.observed,
        c = i.persistentFocus,
        p = i.autoFocus,
        h = i.shards,
        y = i.crossFrame,
        w = i.focusOptions,
        x = i.noFocusGuards,
        E = l || vE && vE.portaledElement;
      if (B$() && nd && nd !== document.body && (!document.body.contains(nd) || Boe(nd))) {
        var C = VB();
        C && C.focus();
      }
      var k = document && document.activeElement;
      if (E) {
        var D = [E].concat(h.map(Hae).filter(Boolean)),
          I = function () {
            if (!Noe(y) || !x || !nd || WN) return !1;
            var F = U$(D),
              j = F.findIndex(function (V) {
                var K = V.node;
                return K === nd;
              });
            return j === 0 || j === F.length - 1;
          };
        if ((!k || Aoe(k)) && (c || I() || !Loe() || !nd && p) && (E && !(A$(D) || k && Voe(k, D) || Foe(k)) && (document && !nd && k && !p ? (k.blur && k.blur(), document.body.focus()) : (e = F$(D, nd, {
          focusOptions: w
        }), vE = {})), nd = document && document.activeElement, nd !== document.body && (VB = N$(nd)), yR = !1), document && k !== document.activeElement && document.querySelector("[data-focus-auto-guard]")) {
          var O = document && document.activeElement,
            P = Soe(D),
            N = P.map(function (L) {
              var F = L.node;
              return F;
            }).indexOf(O);
          N > -1 && (P.filter(function (L) {
            var F = L.guard,
              j = L.node;
            return F && j.dataset.focusAutoGuard;
          }).forEach(function (L) {
            var F = L.node;
            return F.removeAttribute("tabIndex");
          }), BB(N, P.length, 1, P), BB(N, -1, -1, P));
        }
      }
    }
    return e;
  },
  H$ = function (e) {
    kO() && e && (e.stopPropagation(), e.preventDefault());
  },
  qN = function () {
    return jN(kO);
  },
  Uoe = function (e) {
    var i = e.target,
      l = e.currentTarget;
    l.contains(i) || joe(l, i);
  },
  Hoe = function () {
    return null;
  };
process.env.NODE_ENV !== "production" && g$.node.isRequired;
var $$ = function () {
    WN = !0;
  },
  W$ = function () {
    WN = !1, yR = "just", jN(function () {
      yR = "meanwhile";
    });
  },
  $oe = function () {
    document.addEventListener("focusin", H$), document.addEventListener("focusout", qN), window.addEventListener("focus", $$), window.addEventListener("blur", W$);
  },
  Woe = function () {
    document.removeEventListener("focusin", H$), document.removeEventListener("focusout", qN), window.removeEventListener("focus", $$), window.removeEventListener("blur", W$);
  };
function qoe(t) {
  return t.filter(function (e) {
    var i = e.disabled;
    return !i;
  });
}
var q$ = {
  moveFocusInside: F$,
  focusInside: A$,
  focusNextElement: Doe,
  focusPrevElement: Ioe,
  focusFirstElement: Moe,
  focusLastElement: Ooe,
  captureFocusRestore: N$
};
function Yoe(t) {
  var e = t.slice(-1)[0];
  e && !mE && $oe();
  var i = mE,
    l = i && e && e.id === i.id;
  mE = e, i && !l && (i.onDeactivation(), t.filter(function (c) {
    var p = c.id;
    return p === i.id;
  }).length || i.returnFocus(!e)), e ? (nd = null, (!l || i.observed !== e.observed) && e.onActivation(q$), kO(), jN(kO)) : (Woe(), nd = null);
}
b$.assignSyncMedium(Uoe);
w$.assignMedium(qN);
Vae.assignMedium(function (t) {
  return t(q$);
});
const Goe = Kae(qoe, Yoe)(Hoe);
ON(_$, Goe);
var Xoe = function () {
  if (typeof __webpack_nonce__ < "u") return __webpack_nonce__;
};
function Koe() {
  if (!document) return null;
  var t = document.createElement("style");
  t.type = "text/css";
  var e = Xoe();
  return e && t.setAttribute("nonce", e), t;
}
function Qoe(t, e) {
  t.styleSheet ? t.styleSheet.cssText = e : t.appendChild(document.createTextNode(e));
}
function Zoe(t) {
  var e = document.head || document.getElementsByTagName("head")[0];
  e.appendChild(t);
}
var Joe = function () {
    var t = 0,
      e = null;
    return {
      add: function (i) {
        t == 0 && (e = Koe()) && (Qoe(e, i), Zoe(e)), t++;
      },
      remove: function () {
        t--, !t && e && (e.parentNode && e.parentNode.removeChild(e), e = null);
      }
    };
  },
  ese = function () {
    var t = Joe();
    return function (e, i) {
      Bn.useEffect(function () {
        return t.add(e), function () {
          t.remove();
        };
      }, [e && i]);
    };
  },
  YN = function () {
    var t = ese(),
      e = function (i) {
        var l = i.styles,
          c = i.dynamic;
        return t(l, c), null;
      };
    return e;
  },
  tse = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
  },
  W2 = function (t) {
    return parseInt(t || "", 10) || 0;
  },
  nse = function (t) {
    var e = window.getComputedStyle(document.body),
      i = e[t === "padding" ? "paddingLeft" : "marginLeft"],
      l = e[t === "padding" ? "paddingTop" : "marginTop"],
      c = e[t === "padding" ? "paddingRight" : "marginRight"];
    return [W2(i), W2(l), W2(c)];
  },
  rse = function (t) {
    if (t === void 0 && (t = "margin"), typeof window > "u") return tse;
    var e = nse(t),
      i = document.documentElement.clientWidth,
      l = window.innerWidth;
    return {
      left: e[0],
      top: e[1],
      right: e[2],
      gap: Math.max(0, l - i + e[2] - e[0])
    };
  },
  ise = YN(),
  gE = "data-scroll-locked",
  ase = function (t, e, i, l) {
    var c = t.left,
      p = t.top,
      h = t.right,
      y = t.gap;
    return i === void 0 && (i = "margin"), `
  .`.concat(Tae, ` {
   overflow: hidden `).concat(l, `;
   padding-right: `).concat(y, "px ").concat(l, `;
  }
  body[`).concat(gE, `] {
    overflow: hidden `).concat(l, `;
    overscroll-behavior: contain;
    `).concat([e && "position: relative ".concat(l, ";"), i === "margin" && `
    padding-left: `.concat(c, `px;
    padding-top: `).concat(p, `px;
    padding-right: `).concat(h, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(y, "px ").concat(l, `;
    `), i === "padding" && "padding-right: ".concat(y, "px ").concat(l, ";")].filter(Boolean).join(""), `
  }
  
  .`).concat(WM, ` {
    right: `).concat(y, "px ").concat(l, `;
  }
  
  .`).concat(qM, ` {
    margin-right: `).concat(y, "px ").concat(l, `;
  }
  
  .`).concat(WM, " .").concat(WM, ` {
    right: 0 `).concat(l, `;
  }
  
  .`).concat(qM, " .").concat(qM, ` {
    margin-right: 0 `).concat(l, `;
  }
  
  body[`).concat(gE, `] {
    `).concat(Rae, ": ").concat(y, `px;
  }
`);
  },
  UB = function () {
    var t = parseInt(document.body.getAttribute(gE) || "0", 10);
    return isFinite(t) ? t : 0;
  },
  ose = function () {
    Bn.useEffect(function () {
      return document.body.setAttribute(gE, (UB() + 1).toString()), function () {
        var t = UB() - 1;
        t <= 0 ? document.body.removeAttribute(gE) : document.body.setAttribute(gE, t.toString());
      };
    }, []);
  },
  sse = function (t) {
    var e = t.noRelative,
      i = t.noImportant,
      l = t.gapMode,
      c = l === void 0 ? "margin" : l;
    ose();
    var p = Bn.useMemo(function () {
      return rse(c);
    }, [c]);
    return Bn.createElement(ise, {
      styles: ase(p, !e, c, i ? "" : "!important")
    });
  },
  Xj = !1;
if (typeof window < "u") try {
  var bM = Object.defineProperty({}, "passive", {
    get: function () {
      return Xj = !0, !0;
    }
  });
  window.addEventListener("test", bM, bM), window.removeEventListener("test", bM, bM);
} catch {
  Xj = !1;
}
var Q1 = Xj ? {
    passive: !1
  } : !1,
  lse = function (t) {
    return t.tagName === "TEXTAREA";
  },
  Y$ = function (t, e) {
    if (!(t instanceof Element)) return !1;
    var i = window.getComputedStyle(t);
    return (
      // not-not-scrollable
      i[e] !== "hidden" &&
      // contains scroll inside self
      !(i.overflowY === i.overflowX && !lse(t) && i[e] === "visible")
    );
  },
  use = function (t) {
    return Y$(t, "overflowY");
  },
  cse = function (t) {
    return Y$(t, "overflowX");
  },
  HB = function (t, e) {
    var i = e.ownerDocument,
      l = e;
    do {
      typeof ShadowRoot < "u" && l instanceof ShadowRoot && (l = l.host);
      var c = G$(t, l);
      if (c) {
        var p = X$(t, l),
          h = p[1],
          y = p[2];
        if (h > y) return !0;
      }
      l = l.parentNode;
    } while (l && l !== i.body);
    return !1;
  },
  dse = function (t) {
    var e = t.scrollTop,
      i = t.scrollHeight,
      l = t.clientHeight;
    return [e, i, l];
  },
  fse = function (t) {
    var e = t.scrollLeft,
      i = t.scrollWidth,
      l = t.clientWidth;
    return [e, i, l];
  },
  G$ = function (t, e) {
    return t === "v" ? use(e) : cse(e);
  },
  X$ = function (t, e) {
    return t === "v" ? dse(e) : fse(e);
  },
  pse = function (t, e) {
    return t === "h" && e === "rtl" ? -1 : 1;
  },
  hse = function (t, e, i, l, c) {
    var p = pse(t, window.getComputedStyle(e).direction),
      h = p * l,
      y = i.target,
      w = e.contains(y),
      x = !1,
      E = h > 0,
      C = 0,
      k = 0;
    do {
      if (!y) break;
      var D = X$(t, y),
        I = D[0],
        O = D[1],
        P = D[2],
        N = O - P - p * I;
      (I || N) && G$(t, y) && (C += N, k += I);
      var L = y.parentNode;
      y = L && L.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? L.host : L;
    } while (
    // portaled content
    !w && y !== document.body ||
    // self content
    w && (e.contains(y) || e === y));
    return (E && Math.abs(C) < 1 || !E && Math.abs(k) < 1) && (x = !0), x;
  },
  wM = function (t) {
    return "changedTouches" in t ? [t.changedTouches[0].clientX, t.changedTouches[0].clientY] : [0, 0];
  },
  $B = function (t) {
    return [t.deltaX, t.deltaY];
  },
  WB = function (t) {
    return t && "current" in t ? t.current : t;
  },
  mse = function (t, e) {
    return t[0] === e[0] && t[1] === e[1];
  },
  vse = function (t) {
    return `
  .block-interactivity-`.concat(t, ` {pointer-events: none;}
  .allow-interactivity-`).concat(t, ` {pointer-events: all;}
`);
  },
  gse = 0,
  Z1 = [];
function yse(t) {
  var e = Bn.useRef([]),
    i = Bn.useRef([0, 0]),
    l = Bn.useRef(),
    c = Bn.useState(gse++)[0],
    p = Bn.useState(YN)[0],
    h = Bn.useRef(t);
  Bn.useEffect(function () {
    h.current = t;
  }, [t]), Bn.useEffect(function () {
    if (t.inert) {
      document.body.classList.add("block-interactivity-".concat(c));
      var O = kae([t.lockRef.current], (t.shards || []).map(WB), !0).filter(Boolean);
      return O.forEach(function (P) {
        return P.classList.add("allow-interactivity-".concat(c));
      }), function () {
        document.body.classList.remove("block-interactivity-".concat(c)), O.forEach(function (P) {
          return P.classList.remove("allow-interactivity-".concat(c));
        });
      };
    }
  }, [t.inert, t.lockRef.current, t.shards]);
  var y = Bn.useCallback(function (O, P) {
      if ("touches" in O && O.touches.length === 2 || O.type === "wheel" && O.ctrlKey) return !h.current.allowPinchZoom;
      var N = wM(O),
        L = i.current,
        F = "deltaX" in O ? O.deltaX : L[0] - N[0],
        j = "deltaY" in O ? O.deltaY : L[1] - N[1],
        V,
        K = O.target,
        G = Math.abs(F) > Math.abs(j) ? "h" : "v";
      if ("touches" in O && G === "h" && K.type === "range") return !1;
      var Q = HB(G, K);
      if (!Q) return !0;
      if (Q ? V = G : (V = G === "v" ? "h" : "v", Q = HB(G, K)), !Q) return !1;
      if (!l.current && "changedTouches" in O && (F || j) && (l.current = V), !V) return !0;
      var te = l.current || V;
      return hse(te, P, O, te === "h" ? F : j);
    }, []),
    w = Bn.useCallback(function (O) {
      var P = O;
      if (!(!Z1.length || Z1[Z1.length - 1] !== p)) {
        var N = "deltaY" in P ? $B(P) : wM(P),
          L = e.current.filter(function (V) {
            return V.name === P.type && (V.target === P.target || P.target === V.shadowParent) && mse(V.delta, N);
          })[0];
        if (L && L.should) {
          P.cancelable && P.preventDefault();
          return;
        }
        if (!L) {
          var F = (h.current.shards || []).map(WB).filter(Boolean).filter(function (V) {
              return V.contains(P.target);
            }),
            j = F.length > 0 ? y(P, F[0]) : !h.current.noIsolation;
          j && P.cancelable && P.preventDefault();
        }
      }
    }, []),
    x = Bn.useCallback(function (O, P, N, L) {
      var F = {
        name: O,
        delta: P,
        target: N,
        should: L,
        shadowParent: bse(N)
      };
      e.current.push(F), setTimeout(function () {
        e.current = e.current.filter(function (j) {
          return j !== F;
        });
      }, 1);
    }, []),
    E = Bn.useCallback(function (O) {
      i.current = wM(O), l.current = void 0;
    }, []),
    C = Bn.useCallback(function (O) {
      x(O.type, $B(O), O.target, y(O, t.lockRef.current));
    }, []),
    k = Bn.useCallback(function (O) {
      x(O.type, wM(O), O.target, y(O, t.lockRef.current));
    }, []);
  Bn.useEffect(function () {
    return Z1.push(p), t.setCallbacks({
      onScrollCapture: C,
      onWheelCapture: C,
      onTouchMoveCapture: k
    }), document.addEventListener("wheel", w, Q1), document.addEventListener("touchmove", w, Q1), document.addEventListener("touchstart", E, Q1), function () {
      Z1 = Z1.filter(function (O) {
        return O !== p;
      }), document.removeEventListener("wheel", w, Q1), document.removeEventListener("touchmove", w, Q1), document.removeEventListener("touchstart", E, Q1);
    };
  }, []);
  var D = t.removeScrollBar,
    I = t.inert;
  return Bn.createElement(Bn.Fragment, null, I ? Bn.createElement(p, {
    styles: vse(c)
  }) : null, D ? Bn.createElement(sse, {
    noRelative: t.noRelative,
    gapMode: t.gapMode
  }) : null);
}
function bse(t) {
  for (var e = null; t !== null;) t instanceof ShadowRoot && (e = t.host, t = t.host), t = t.parentNode;
  return e;
}
ON(h$, yse);
var wse = function (t) {
    if (typeof document > "u") return null;
    var e = Array.isArray(t) ? t[0] : t;
    return e.ownerDocument.body;
  },
  J1 = /* @__PURE__ */new WeakMap(),
  _M = /* @__PURE__ */new WeakMap(),
  xM = {},
  q2 = 0,
  K$ = function (t) {
    return t && (t.host || K$(t.parentNode));
  },
  _se = function (t, e) {
    return e.map(function (i) {
      if (t.contains(i)) return i;
      var l = K$(i);
      return l && t.contains(l) ? l : (console.error("aria-hidden", i, "in not contained inside", t, ". Doing nothing"), null);
    }).filter(function (i) {
      return !!i;
    });
  },
  xse = function (t, e, i, l) {
    var c = _se(e, Array.isArray(t) ? t : [t]);
    xM[i] || (xM[i] = /* @__PURE__ */new WeakMap());
    var p = xM[i],
      h = [],
      y = /* @__PURE__ */new Set(),
      w = new Set(c),
      x = function (C) {
        !C || y.has(C) || (y.add(C), x(C.parentNode));
      };
    c.forEach(x);
    var E = function (C) {
      !C || w.has(C) || Array.prototype.forEach.call(C.children, function (k) {
        if (y.has(k)) E(k);else try {
          var D = k.getAttribute(l),
            I = D !== null && D !== "false",
            O = (J1.get(k) || 0) + 1,
            P = (p.get(k) || 0) + 1;
          J1.set(k, O), p.set(k, P), h.push(k), O === 1 && I && _M.set(k, !0), P === 1 && k.setAttribute(i, "true"), I || k.setAttribute(l, "true");
        } catch (N) {
          console.error("aria-hidden: cannot operate on ", k, N);
        }
      });
    };
    return E(e), y.clear(), q2++, function () {
      h.forEach(function (C) {
        var k = J1.get(C) - 1,
          D = p.get(C) - 1;
        J1.set(C, k), p.set(C, D), k || (_M.has(C) || C.removeAttribute(l), _M.delete(C)), D || C.removeAttribute(i);
      }), q2--, q2 || (J1 = /* @__PURE__ */new WeakMap(), J1 = /* @__PURE__ */new WeakMap(), _M = /* @__PURE__ */new WeakMap(), xM = {});
    };
  },
  Sse = function (t, e, i) {
    var l = Array.from(Array.isArray(t) ? t : [t]),
      c = e || wse(t);
    return c ? (l.push.apply(l, Array.from(c.querySelectorAll("[aria-live], script"))), xse(l, c, i, "aria-hidden")) : function () {
      return null;
    };
  },
  Ese = YN(),
  Cse = `
 [` + E$ + `] {
   pointer-events: none !important;
 }
`,
  kse = function () {
    return Bn.createElement(Ese, {
      styles: Cse
    });
  },
  qB = function (t) {
    return "current" in t ? t.current : t;
  };
function Tse(t) {
  var e = t.setLockProps,
    i = t.onEscapeKey,
    l = t.onClickOutside,
    c = t.shards,
    p = t.onActivation,
    h = t.onDeactivation,
    y = t.noIsolation,
    w = rt(void 0),
    x = w[0],
    E = w[1],
    C = vt(null),
    k = vt(0);
  return Bn.useEffect(function () {
    var D = function (N) {
        N.defaultPrevented || (N.code === "Escape" || N.key === "Escape" || N.keyCode === 27) && i && i(N);
      },
      I = function (N) {
        N.defaultPrevented || N.target === C.current || N instanceof MouseEvent && N.button !== 0 || c && c.map(qB).some(function (L) {
          return L && L.contains(N.target) || L === N.target;
        }) || l && l(N);
      },
      O = function (N) {
        I(N), k.current = N.touches.length;
      },
      P = function (N) {
        k.current = N.touches.length;
      };
    if (x) return x.ownerDocument.addEventListener("keydown", D), x.ownerDocument.addEventListener("mousedown", I), x.ownerDocument.addEventListener("touchstart", O), x.ownerDocument.addEventListener("touchend", P), function () {
      x.ownerDocument.removeEventListener("keydown", D), x.ownerDocument.removeEventListener("mousedown", I), x.ownerDocument.removeEventListener("touchstart", O), x.ownerDocument.removeEventListener("touchend", P);
    };
  }, [x, l, i]), Rt(function () {
    if (x) return p && p(x), function () {
      h && h();
    };
  }, [!!x]), Rt(function () {
    var D = function () {
        return null;
      },
      I = !1,
      O = function (N) {
        y || (D = Sse(Cae([N], (c || []).map(qB)), N.ownerDocument.body, E$)), E(function () {
          return N;
        });
      },
      P = function () {
        D(), I || E(null);
      };
    return e({
      onMouseDown: function (N) {
        C.current = N.target;
      },
      onTouchStart: function (N) {
        C.current = N.target;
      },
      onActivation: O,
      onDeactivation: P
    }), function () {
      I = !0, e(!1);
    };
  }, []), Bn.createElement(kse, null);
}
const Rse = ON(S$, Tse);
var Dse = function (t) {
    return Bn.createElement(Rse, ld({}, t));
  },
  GN = Bn.forwardRef(function (t, e) {
    return Bn.createElement(Wae, ld({}, t, {
      ref: e,
      sideCar: Dse
    }));
  });
const Q$ = Up({});
function Ise(t) {
  const e = vt(null);
  return e.current === null && (e.current = t()), e.current;
}
const XN = typeof window < "u",
  Mse = XN ? NR : Rt,
  KN = /* @__PURE__ */Up(null);
function QN(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function ZN(t, e) {
  const i = t.indexOf(e);
  i > -1 && t.splice(i, 1);
}
const wb = (t, e, i) => i > e ? e : i < t ? t : i;
function Kj(t, e) {
  return e ? `${t}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${e}` : t;
}
let VE = () => {},
  _b = () => {};
process.env.NODE_ENV !== "production" && (VE = (t, e, i) => {
  !t && typeof console < "u" && console.warn(Kj(e, i));
}, _b = (t, e, i) => {
  if (!t) throw new Error(Kj(e, i));
});
const xb = {},
  Z$ = t => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(t);
function J$(t) {
  return typeof t == "object" && t !== null;
}
const e6 = t => /^0[^.\s]+$/u.test(t);
// @__NO_SIDE_EFFECTS__
function JN(t) {
  let e;
  return () => (e === void 0 && (e = t()), e);
}
const Bp = /* @__NO_SIDE_EFFECTS__ */t => t,
  Ose = (t, e) => i => e(t(i)),
  $R = (...t) => t.reduce(Ose),
  bR = /* @__NO_SIDE_EFFECTS__ */(t, e, i) => {
    const l = e - t;
    return l === 0 ? 1 : (i - t) / l;
  };
class ez {
  constructor() {
    this.subscriptions = [];
  }
  add(e) {
    return QN(this.subscriptions, e), () => ZN(this.subscriptions, e);
  }
  notify(e, i, l) {
    const c = this.subscriptions.length;
    if (c) if (c === 1) this.subscriptions[0](e, i, l);else for (let p = 0; p < c; p++) {
      const h = this.subscriptions[p];
      h && h(e, i, l);
    }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const qm = /* @__NO_SIDE_EFFECTS__ */t => t * 1e3,
  Xv = /* @__NO_SIDE_EFFECTS__ */t => t / 1e3;
function t6(t, e) {
  return e ? t * (1e3 / e) : 0;
}
const YB = /* @__PURE__ */new Set();
function QO(t, e, i) {
  t || YB.has(e) || (console.warn(Kj(e, i)), YB.add(e));
}
const n6 = (t, e, i) => (((1 - 3 * i + 3 * e) * t + (3 * i - 6 * e)) * t + 3 * e) * t,
  Lse = 1e-7,
  Pse = 12;
function Ase(t, e, i, l, c) {
  let p,
    h,
    y = 0;
  do h = e + (i - e) / 2, p = n6(h, l, c) - t, p > 0 ? i = h : e = h; while (Math.abs(p) > Lse && ++y < Pse);
  return h;
}
function WR(t, e, i, l) {
  if (t === e && i === l) return Bp;
  const c = p => Ase(p, 0, 1, t, i);
  return p => p === 0 || p === 1 ? p : n6(c(p), e, l);
}
const r6 = t => e => e <= 0.5 ? t(2 * e) / 2 : (2 - t(2 * (1 - e))) / 2,
  i6 = t => e => 1 - t(1 - e),
  a6 = /* @__PURE__ */WR(0.33, 1.53, 0.69, 0.99),
  tz = /* @__PURE__ */i6(a6),
  o6 = /* @__PURE__ */r6(tz),
  s6 = t => (t *= 2) < 1 ? 0.5 * tz(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1))),
  nz = t => 1 - Math.sin(Math.acos(t)),
  l6 = i6(nz),
  u6 = r6(nz),
  jse = /* @__PURE__ */WR(0.42, 0, 1, 1),
  Fse = /* @__PURE__ */WR(0, 0, 0.58, 1),
  c6 = /* @__PURE__ */WR(0.42, 0, 0.58, 1),
  Nse = t => Array.isArray(t) && typeof t[0] != "number",
  d6 = t => Array.isArray(t) && typeof t[0] == "number",
  GB = {
    linear: Bp,
    easeIn: jse,
    easeInOut: c6,
    easeOut: Fse,
    circIn: nz,
    circInOut: u6,
    circOut: l6,
    backIn: tz,
    backInOut: o6,
    backOut: a6,
    anticipate: s6
  },
  zse = t => typeof t == "string",
  XB = t => {
    if (d6(t)) {
      _b(t.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
      const [e, i, l, c] = t;
      return WR(e, i, l, c);
    } else if (zse(t)) return _b(GB[t] !== void 0, `Invalid easing type '${t}'`, "invalid-easing-type"), GB[t];
    return t;
  },
  SM = ["setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
  ];
function Vse(t, e) {
  let i = /* @__PURE__ */new Set(),
    l = /* @__PURE__ */new Set(),
    c = !1,
    p = !1;
  const h = /* @__PURE__ */new WeakSet();
  let y = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function w(E) {
    h.has(E) && (x.schedule(E), t()), E(y);
  }
  const x = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (E, C = !1, k = !1) => {
      const I = k && c ? i : l;
      return C && h.add(E), I.has(E) || I.add(E), E;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: E => {
      l.delete(E), h.delete(E);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: E => {
      if (y = E, c) {
        p = !0;
        return;
      }
      c = !0, [i, l] = [l, i], i.forEach(w), i.clear(), c = !1, p && (p = !1, x.process(E));
    }
  };
  return x;
}
const Bse = 40;
function f6(t, e) {
  let i = !1,
    l = !0;
  const c = {
      delta: 0,
      timestamp: 0,
      isProcessing: !1
    },
    p = () => i = !0,
    h = SM.reduce((F, j) => (F[j] = Vse(p), F), {}),
    {
      setup: y,
      read: w,
      resolveKeyframes: x,
      preUpdate: E,
      update: C,
      preRender: k,
      render: D,
      postRender: I
    } = h,
    O = () => {
      const F = xb.useManualTiming ? c.timestamp : performance.now();
      i = !1, xb.useManualTiming || (c.delta = l ? 1e3 / 60 : Math.max(Math.min(F - c.timestamp, Bse), 1)), c.timestamp = F, c.isProcessing = !0, y.process(c), w.process(c), x.process(c), E.process(c), C.process(c), k.process(c), D.process(c), I.process(c), c.isProcessing = !1, i && e && (l = !1, t(O));
    },
    P = () => {
      i = !0, l = !0, c.isProcessing || t(O);
    };
  return {
    schedule: SM.reduce((F, j) => {
      const V = h[j];
      return F[j] = (K, G = !1, Q = !1) => (i || P(), V.schedule(K, G, Q)), F;
    }, {}),
    cancel: F => {
      for (let j = 0; j < SM.length; j++) h[SM[j]].cancel(F);
    },
    state: c,
    steps: h
  };
}
const {
  schedule: Ua,
  cancel: aw,
  state: lu,
  steps: Y2
} = /* @__PURE__ */f6(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Bp, !0);
let YM;
function Use() {
  YM = void 0;
}
const ud = {
    now: () => (YM === void 0 && ud.set(lu.isProcessing || xb.useManualTiming ? lu.timestamp : performance.now()), YM),
    set: t => {
      YM = t, queueMicrotask(Use);
    }
  },
  p6 = t => e => typeof e == "string" && e.startsWith(t),
  rz = /* @__PURE__ */p6("--"),
  Hse = /* @__PURE__ */p6("var(--"),
  iz = t => Hse(t) ? $se.test(t.split("/*")[0].trim()) : !1,
  $se = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu,
  BE = {
    test: t => typeof t == "number",
    parse: parseFloat,
    transform: t => t
  },
  wR = {
    ...BE,
    transform: t => wb(0, 1, t)
  },
  EM = {
    ...BE,
    default: 1
  },
  YT = t => Math.round(t * 1e5) / 1e5,
  az = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function Wse(t) {
  return t == null;
}
const qse = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu,
  oz = (t, e) => i => !!(typeof i == "string" && qse.test(i) && i.startsWith(t) || e && !Wse(i) && Object.prototype.hasOwnProperty.call(i, e)),
  h6 = (t, e, i) => l => {
    if (typeof l != "string") return l;
    const [c, p, h, y] = l.match(az);
    return {
      [t]: parseFloat(c),
      [e]: parseFloat(p),
      [i]: parseFloat(h),
      alpha: y !== void 0 ? parseFloat(y) : 1
    };
  },
  Yse = t => wb(0, 255, t),
  G2 = {
    ...BE,
    transform: t => Math.round(Yse(t))
  },
  $x = {
    test: /* @__PURE__ */oz("rgb", "red"),
    parse: /* @__PURE__ */h6("red", "green", "blue"),
    transform: ({
      red: t,
      green: e,
      blue: i,
      alpha: l = 1
    }) => "rgba(" + G2.transform(t) + ", " + G2.transform(e) + ", " + G2.transform(i) + ", " + YT(wR.transform(l)) + ")"
  };
function Gse(t) {
  let e = "",
    i = "",
    l = "",
    c = "";
  return t.length > 5 ? (e = t.substring(1, 3), i = t.substring(3, 5), l = t.substring(5, 7), c = t.substring(7, 9)) : (e = t.substring(1, 2), i = t.substring(2, 3), l = t.substring(3, 4), c = t.substring(4, 5), e += e, i += i, l += l, c += c), {
    red: parseInt(e, 16),
    green: parseInt(i, 16),
    blue: parseInt(l, 16),
    alpha: c ? parseInt(c, 16) / 255 : 1
  };
}
const Qj = {
    test: /* @__PURE__ */oz("#"),
    parse: Gse,
    transform: $x.transform
  },
  qR = /* @__NO_SIDE_EFFECTS__ */t => ({
    test: e => typeof e == "string" && e.endsWith(t) && e.split(" ").length === 1,
    parse: parseFloat,
    transform: e => `${e}${t}`
  }),
  G0 = /* @__PURE__ */qR("deg"),
  Kv = /* @__PURE__ */qR("%"),
  Yn = /* @__PURE__ */qR("px"),
  Xse = /* @__PURE__ */qR("vh"),
  Kse = /* @__PURE__ */qR("vw"),
  KB = {
    ...Kv,
    parse: t => Kv.parse(t) / 100,
    transform: t => Kv.transform(t * 100)
  },
  sE = {
    test: /* @__PURE__ */oz("hsl", "hue"),
    parse: /* @__PURE__ */h6("hue", "saturation", "lightness"),
    transform: ({
      hue: t,
      saturation: e,
      lightness: i,
      alpha: l = 1
    }) => "hsla(" + Math.round(t) + ", " + Kv.transform(YT(e)) + ", " + Kv.transform(YT(i)) + ", " + YT(wR.transform(l)) + ")"
  },
  Ss = {
    test: t => $x.test(t) || Qj.test(t) || sE.test(t),
    parse: t => $x.test(t) ? $x.parse(t) : sE.test(t) ? sE.parse(t) : Qj.parse(t),
    transform: t => typeof t == "string" ? t : t.hasOwnProperty("red") ? $x.transform(t) : sE.transform(t),
    getAnimatableNone: t => {
      const e = Ss.parse(t);
      return e.alpha = 0, Ss.transform(e);
    }
  },
  Qse = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function Zse(t) {
  var e, i;
  return isNaN(t) && typeof t == "string" && (((e = t.match(az)) == null ? void 0 : e.length) || 0) + (((i = t.match(Qse)) == null ? void 0 : i.length) || 0) > 0;
}
const m6 = "number",
  v6 = "color",
  Jse = "var",
  ele = "var(",
  QB = "${}",
  tle = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function _R(t) {
  const e = t.toString(),
    i = [],
    l = {
      color: [],
      number: [],
      var: []
    },
    c = [];
  let p = 0;
  const y = e.replace(tle, w => (Ss.test(w) ? (l.color.push(p), c.push(v6), i.push(Ss.parse(w))) : w.startsWith(ele) ? (l.var.push(p), c.push(Jse), i.push(w)) : (l.number.push(p), c.push(m6), i.push(parseFloat(w))), ++p, QB)).split(QB);
  return {
    values: i,
    split: y,
    indexes: l,
    types: c
  };
}
function g6(t) {
  return _R(t).values;
}
function y6(t) {
  const {
      split: e,
      types: i
    } = _R(t),
    l = e.length;
  return c => {
    let p = "";
    for (let h = 0; h < l; h++) if (p += e[h], c[h] !== void 0) {
      const y = i[h];
      y === m6 ? p += YT(c[h]) : y === v6 ? p += Ss.transform(c[h]) : p += c[h];
    }
    return p;
  };
}
const nle = t => typeof t == "number" ? 0 : Ss.test(t) ? Ss.getAnimatableNone(t) : t;
function rle(t) {
  const e = g6(t);
  return y6(t)(e.map(nle));
}
const ow = {
  test: Zse,
  parse: g6,
  createTransformer: y6,
  getAnimatableNone: rle
};
function X2(t, e, i) {
  return i < 0 && (i += 1), i > 1 && (i -= 1), i < 1 / 6 ? t + (e - t) * 6 * i : i < 1 / 2 ? e : i < 2 / 3 ? t + (e - t) * (2 / 3 - i) * 6 : t;
}
function ile({
  hue: t,
  saturation: e,
  lightness: i,
  alpha: l
}) {
  t /= 360, e /= 100, i /= 100;
  let c = 0,
    p = 0,
    h = 0;
  if (!e) c = p = h = i;else {
    const y = i < 0.5 ? i * (1 + e) : i + e - i * e,
      w = 2 * i - y;
    c = X2(w, y, t + 1 / 3), p = X2(w, y, t), h = X2(w, y, t - 1 / 3);
  }
  return {
    red: Math.round(c * 255),
    green: Math.round(p * 255),
    blue: Math.round(h * 255),
    alpha: l
  };
}
function TO(t, e) {
  return i => i > 0 ? e : t;
}
const go = (t, e, i) => t + (e - t) * i,
  K2 = (t, e, i) => {
    const l = t * t,
      c = i * (e * e - l) + l;
    return c < 0 ? 0 : Math.sqrt(c);
  },
  ale = [Qj, $x, sE],
  ole = t => ale.find(e => e.test(t));
function ZB(t) {
  const e = ole(t);
  if (VE(!!e, `'${t}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable"), !e) return !1;
  let i = e.parse(t);
  return e === sE && (i = ile(i)), i;
}
const JB = (t, e) => {
    const i = ZB(t),
      l = ZB(e);
    if (!i || !l) return TO(t, e);
    const c = {
      ...i
    };
    return p => (c.red = K2(i.red, l.red, p), c.green = K2(i.green, l.green, p), c.blue = K2(i.blue, l.blue, p), c.alpha = go(i.alpha, l.alpha, p), $x.transform(c));
  },
  Zj = /* @__PURE__ */new Set(["none", "hidden"]);
function sle(t, e) {
  return Zj.has(t) ? i => i <= 0 ? t : e : i => i >= 1 ? e : t;
}
function lle(t, e) {
  return i => go(t, e, i);
}
function sz(t) {
  return typeof t == "number" ? lle : typeof t == "string" ? iz(t) ? TO : Ss.test(t) ? JB : dle : Array.isArray(t) ? b6 : typeof t == "object" ? Ss.test(t) ? JB : ule : TO;
}
function b6(t, e) {
  const i = [...t],
    l = i.length,
    c = t.map((p, h) => sz(p)(p, e[h]));
  return p => {
    for (let h = 0; h < l; h++) i[h] = c[h](p);
    return i;
  };
}
function ule(t, e) {
  const i = {
      ...t,
      ...e
    },
    l = {};
  for (const c in i) t[c] !== void 0 && e[c] !== void 0 && (l[c] = sz(t[c])(t[c], e[c]));
  return c => {
    for (const p in l) i[p] = l[p](c);
    return i;
  };
}
function cle(t, e) {
  const i = [],
    l = {
      color: 0,
      var: 0,
      number: 0
    };
  for (let c = 0; c < e.values.length; c++) {
    const p = e.types[c],
      h = t.indexes[p][l[p]],
      y = t.values[h] ?? 0;
    i[c] = y, l[p]++;
  }
  return i;
}
const dle = (t, e) => {
  const i = ow.createTransformer(e),
    l = _R(t),
    c = _R(e);
  return l.indexes.var.length === c.indexes.var.length && l.indexes.color.length === c.indexes.color.length && l.indexes.number.length >= c.indexes.number.length ? Zj.has(t) && !c.values.length || Zj.has(e) && !l.values.length ? sle(t, e) : $R(b6(cle(l, c), c.values), i) : (VE(!0, `Complex values '${t}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different"), TO(t, e));
};
function w6(t, e, i) {
  return typeof t == "number" && typeof e == "number" && typeof i == "number" ? go(t, e, i) : sz(t)(t, e);
}
const fle = t => {
    const e = ({
      timestamp: i
    }) => t(i);
    return {
      start: (i = !0) => Ua.update(e, i),
      stop: () => aw(e),
      /**
       * If we're processing this frame we can use the
       * framelocked timestamp to keep things in sync.
       */
      now: () => lu.isProcessing ? lu.timestamp : ud.now()
    };
  },
  _6 = (t, e, i = 10) => {
    let l = "";
    const c = Math.max(Math.round(e / i), 2);
    for (let p = 0; p < c; p++) l += Math.round(t(p / (c - 1)) * 1e4) / 1e4 + ", ";
    return `linear(${l.substring(0, l.length - 2)})`;
  },
  RO = 2e4;
function lz(t) {
  let e = 0;
  const i = 50;
  let l = t.next(e);
  for (; !l.done && e < RO;) e += i, l = t.next(e);
  return e >= RO ? 1 / 0 : e;
}
function ple(t, e = 100, i) {
  const l = i({
      ...t,
      keyframes: [0, e]
    }),
    c = Math.min(lz(l), RO);
  return {
    type: "keyframes",
    ease: p => l.next(c * p).value / e,
    duration: /* @__PURE__ */Xv(c)
  };
}
const hle = 5;
function x6(t, e, i) {
  const l = Math.max(e - hle, 0);
  return t6(i - t(l), e - l);
}
const vo = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1,
    velocity: 0,
    // Default duration/bounce-based options
    duration: 800,
    // in ms
    bounce: 0.3,
    visualDuration: 0.3,
    // in seconds
    // Rest thresholds
    restSpeed: {
      granular: 0.01,
      default: 2
    },
    restDelta: {
      granular: 5e-3,
      default: 0.5
    },
    // Limits
    minDuration: 0.01,
    // in seconds
    maxDuration: 10,
    // in seconds
    minDamping: 0.05,
    maxDamping: 1
  },
  e3 = 1e-3;
function mle({
  duration: t = vo.duration,
  bounce: e = vo.bounce,
  velocity: i = vo.velocity,
  mass: l = vo.mass
}) {
  let c, p;
  VE(t <= /* @__PURE__ */qm(vo.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
  let h = 1 - e;
  h = wb(vo.minDamping, vo.maxDamping, h), t = wb(vo.minDuration, vo.maxDuration, /* @__PURE__ */Xv(t)), h < 1 ? (c = x => {
    const E = x * h,
      C = E * t,
      k = E - i,
      D = Jj(x, h),
      I = Math.exp(-C);
    return e3 - k / D * I;
  }, p = x => {
    const C = x * h * t,
      k = C * i + i,
      D = Math.pow(h, 2) * Math.pow(x, 2) * t,
      I = Math.exp(-C),
      O = Jj(Math.pow(x, 2), h);
    return (-c(x) + e3 > 0 ? -1 : 1) * ((k - D) * I) / O;
  }) : (c = x => {
    const E = Math.exp(-x * t),
      C = (x - i) * t + 1;
    return -1e-3 + E * C;
  }, p = x => {
    const E = Math.exp(-x * t),
      C = (i - x) * (t * t);
    return E * C;
  });
  const y = 5 / t,
    w = gle(c, p, y);
  if (t = /* @__PURE__ */qm(t), isNaN(w)) return {
    stiffness: vo.stiffness,
    damping: vo.damping,
    duration: t
  };
  {
    const x = Math.pow(w, 2) * l;
    return {
      stiffness: x,
      damping: h * 2 * Math.sqrt(l * x),
      duration: t
    };
  }
}
const vle = 12;
function gle(t, e, i) {
  let l = i;
  for (let c = 1; c < vle; c++) l = l - t(l) / e(l);
  return l;
}
function Jj(t, e) {
  return t * Math.sqrt(1 - e * e);
}
const yle = ["duration", "bounce"],
  ble = ["stiffness", "damping", "mass"];
function t3(t, e) {
  return e.some(i => t[i] !== void 0);
}
function wle(t) {
  let e = {
    velocity: vo.velocity,
    stiffness: vo.stiffness,
    damping: vo.damping,
    mass: vo.mass,
    isResolvedFromDuration: !1,
    ...t
  };
  if (!t3(t, ble) && t3(t, yle)) if (t.visualDuration) {
    const i = t.visualDuration,
      l = 2 * Math.PI / (i * 1.2),
      c = l * l,
      p = 2 * wb(0.05, 1, 1 - (t.bounce || 0)) * Math.sqrt(c);
    e = {
      ...e,
      mass: vo.mass,
      stiffness: c,
      damping: p
    };
  } else {
    const i = mle(t);
    e = {
      ...e,
      ...i,
      mass: vo.mass
    }, e.isResolvedFromDuration = !0;
  }
  return e;
}
function DO(t = vo.visualDuration, e = vo.bounce) {
  const i = typeof t != "object" ? {
    visualDuration: t,
    keyframes: [0, 1],
    bounce: e
  } : t;
  let {
    restSpeed: l,
    restDelta: c
  } = i;
  const p = i.keyframes[0],
    h = i.keyframes[i.keyframes.length - 1],
    y = {
      done: !1,
      value: p
    },
    {
      stiffness: w,
      damping: x,
      mass: E,
      duration: C,
      velocity: k,
      isResolvedFromDuration: D
    } = wle({
      ...i,
      velocity: - /* @__PURE__ */Xv(i.velocity || 0)
    }),
    I = k || 0,
    O = x / (2 * Math.sqrt(w * E)),
    P = h - p,
    N = /* @__PURE__ */Xv(Math.sqrt(w / E)),
    L = Math.abs(P) < 5;
  l || (l = L ? vo.restSpeed.granular : vo.restSpeed.default), c || (c = L ? vo.restDelta.granular : vo.restDelta.default);
  let F;
  if (O < 1) {
    const V = Jj(N, O);
    F = K => {
      const G = Math.exp(-O * N * K);
      return h - G * ((I + O * N * P) / V * Math.sin(V * K) + P * Math.cos(V * K));
    };
  } else if (O === 1) F = V => h - Math.exp(-N * V) * (P + (I + N * P) * V);else {
    const V = N * Math.sqrt(O * O - 1);
    F = K => {
      const G = Math.exp(-O * N * K),
        Q = Math.min(V * K, 300);
      return h - G * ((I + O * N * P) * Math.sinh(Q) + V * P * Math.cosh(Q)) / V;
    };
  }
  const j = {
    calculatedDuration: D && C || null,
    next: V => {
      const K = F(V);
      if (D) y.done = V >= C;else {
        let G = V === 0 ? I : 0;
        O < 1 && (G = V === 0 ? /* @__PURE__ */qm(I) : x6(F, V, K));
        const Q = Math.abs(G) <= l,
          te = Math.abs(h - K) <= c;
        y.done = Q && te;
      }
      return y.value = y.done ? h : K, y;
    },
    toString: () => {
      const V = Math.min(lz(j), RO),
        K = _6(G => j.next(V * G).value, V, 30);
      return V + "ms " + K;
    },
    toTransition: () => {}
  };
  return j;
}
DO.applyToOptions = t => {
  const e = ple(t, 100, DO);
  return t.ease = e.ease, t.duration = /* @__PURE__ */qm(e.duration), t.type = "keyframes", t;
};
function eF({
  keyframes: t,
  velocity: e = 0,
  power: i = 0.8,
  timeConstant: l = 325,
  bounceDamping: c = 10,
  bounceStiffness: p = 500,
  modifyTarget: h,
  min: y,
  max: w,
  restDelta: x = 0.5,
  restSpeed: E
}) {
  const C = t[0],
    k = {
      done: !1,
      value: C
    },
    D = Q => y !== void 0 && Q < y || w !== void 0 && Q > w,
    I = Q => y === void 0 ? w : w === void 0 || Math.abs(y - Q) < Math.abs(w - Q) ? y : w;
  let O = i * e;
  const P = C + O,
    N = h === void 0 ? P : h(P);
  N !== P && (O = N - C);
  const L = Q => -O * Math.exp(-Q / l),
    F = Q => N + L(Q),
    j = Q => {
      const te = L(Q),
        ie = F(Q);
      k.done = Math.abs(te) <= x, k.value = k.done ? N : ie;
    };
  let V, K;
  const G = Q => {
    D(k.value) && (V = Q, K = DO({
      keyframes: [k.value, I(k.value)],
      velocity: x6(F, Q, k.value),
      // TODO: This should be passing * 1000
      damping: c,
      stiffness: p,
      restDelta: x,
      restSpeed: E
    }));
  };
  return G(0), {
    calculatedDuration: null,
    next: Q => {
      let te = !1;
      return !K && V === void 0 && (te = !0, j(Q), G(Q)), V !== void 0 && Q >= V ? K.next(Q - V) : (!te && j(Q), k);
    }
  };
}
function _le(t, e, i) {
  const l = [],
    c = i || xb.mix || w6,
    p = t.length - 1;
  for (let h = 0; h < p; h++) {
    let y = c(t[h], t[h + 1]);
    if (e) {
      const w = Array.isArray(e) ? e[h] || Bp : e;
      y = $R(w, y);
    }
    l.push(y);
  }
  return l;
}
function xle(t, e, {
  clamp: i = !0,
  ease: l,
  mixer: c
} = {}) {
  const p = t.length;
  if (_b(p === e.length, "Both input and output ranges must be the same length", "range-length"), p === 1) return () => e[0];
  if (p === 2 && e[0] === e[1]) return () => e[1];
  const h = t[0] === t[1];
  t[0] > t[p - 1] && (t = [...t].reverse(), e = [...e].reverse());
  const y = _le(e, l, c),
    w = y.length,
    x = E => {
      if (h && E < t[0]) return e[0];
      let C = 0;
      if (w > 1) for (; C < t.length - 2 && !(E < t[C + 1]); C++);
      const k = /* @__PURE__ */bR(t[C], t[C + 1], E);
      return y[C](k);
    };
  return i ? E => x(wb(t[0], t[p - 1], E)) : x;
}
function Sle(t, e) {
  const i = t[t.length - 1];
  for (let l = 1; l <= e; l++) {
    const c = /* @__PURE__ */bR(0, e, l);
    t.push(go(i, 1, c));
  }
}
function Ele(t) {
  const e = [0];
  return Sle(e, t.length - 1), e;
}
function Cle(t, e) {
  return t.map(i => i * e);
}
function kle(t, e) {
  return t.map(() => e || c6).splice(0, t.length - 1);
}
function lE({
  duration: t = 300,
  keyframes: e,
  times: i,
  ease: l = "easeInOut"
}) {
  const c = Nse(l) ? l.map(XB) : XB(l),
    p = {
      done: !1,
      value: e[0]
    },
    h = Cle(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    i && i.length === e.length ? i : Ele(e), t),
    y = xle(h, e, {
      ease: Array.isArray(c) ? c : kle(e, c)
    });
  return {
    calculatedDuration: t,
    next: w => (p.value = y(w), p.done = w >= t, p)
  };
}
const Tle = t => t !== null;
function uz(t, {
  repeat: e,
  repeatType: i = "loop"
}, l, c = 1) {
  const p = t.filter(Tle),
    y = c < 0 || e && i !== "loop" && e % 2 === 1 ? 0 : p.length - 1;
  return !y || l === void 0 ? p[y] : l;
}
const Rle = {
  decay: eF,
  inertia: eF,
  tween: lE,
  keyframes: lE,
  spring: DO
};
function S6(t) {
  typeof t.type == "string" && (t.type = Rle[t.type]);
}
class cz {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise(e => {
      this.resolve = e;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(e, i) {
    return this.finished.then(e, i);
  }
}
const Dle = t => t / 100;
class dz extends cz {
  constructor(e) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.stop = () => {
      var l, c;
      const {
        motionValue: i
      } = this.options;
      i && i.updatedAt !== ud.now() && this.tick(ud.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), (c = (l = this.options).onStop) == null || c.call(l));
    }, this.options = e, this.initAnimation(), this.play(), e.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const {
      options: e
    } = this;
    S6(e);
    const {
      type: i = lE,
      repeat: l = 0,
      repeatDelay: c = 0,
      repeatType: p,
      velocity: h = 0
    } = e;
    let {
      keyframes: y
    } = e;
    const w = i || lE;
    process.env.NODE_ENV !== "production" && w !== lE && _b(y.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${y}`, "spring-two-frames"), w !== lE && typeof y[0] != "number" && (this.mixKeyframes = $R(Dle, w6(y[0], y[1])), y = [0, 100]);
    const x = w({
      ...e,
      keyframes: y
    });
    p === "mirror" && (this.mirroredGenerator = w({
      ...e,
      keyframes: [...y].reverse(),
      velocity: -h
    })), x.calculatedDuration === null && (x.calculatedDuration = lz(x));
    const {
      calculatedDuration: E
    } = x;
    this.calculatedDuration = E, this.resolvedDuration = E + c, this.totalDuration = this.resolvedDuration * (l + 1) - c, this.generator = x;
  }
  updateTime(e) {
    const i = Math.round(e - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = i;
  }
  tick(e, i = !1) {
    const {
      generator: l,
      totalDuration: c,
      mixKeyframes: p,
      mirroredGenerator: h,
      resolvedDuration: y,
      calculatedDuration: w
    } = this;
    if (this.startTime === null) return l.next(0);
    const {
      delay: x = 0,
      keyframes: E,
      repeat: C,
      repeatType: k,
      repeatDelay: D,
      type: I,
      onUpdate: O,
      finalKeyframe: P
    } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, e) : this.speed < 0 && (this.startTime = Math.min(e - c / this.speed, this.startTime)), i ? this.currentTime = e : this.updateTime(e);
    const N = this.currentTime - x * (this.playbackSpeed >= 0 ? 1 : -1),
      L = this.playbackSpeed >= 0 ? N < 0 : N > c;
    this.currentTime = Math.max(N, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = c);
    let F = this.currentTime,
      j = l;
    if (C) {
      const Q = Math.min(this.currentTime, c) / y;
      let te = Math.floor(Q),
        ie = Q % 1;
      !ie && Q >= 1 && (ie = 1), ie === 1 && te--, te = Math.min(te, C + 1), !!(te % 2) && (k === "reverse" ? (ie = 1 - ie, D && (ie -= D / y)) : k === "mirror" && (j = h)), F = wb(0, 1, ie) * y;
    }
    const V = L ? {
      done: !1,
      value: E[0]
    } : j.next(F);
    p && (V.value = p(V.value));
    let {
      done: K
    } = V;
    !L && w !== null && (K = this.playbackSpeed >= 0 ? this.currentTime >= c : this.currentTime <= 0);
    const G = this.holdTime === null && (this.state === "finished" || this.state === "running" && K);
    return G && I !== eF && (V.value = uz(E, this.options, P, this.speed)), O && O(V.value), G && this.finish(), V;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(e, i) {
    return this.finished.then(e, i);
  }
  get duration() {
    return /* @__PURE__ */Xv(this.calculatedDuration);
  }
  get time() {
    return /* @__PURE__ */Xv(this.currentTime);
  }
  set time(e) {
    var i;
    e = /* @__PURE__ */qm(e), this.currentTime = e, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = e : this.driver && (this.startTime = this.driver.now() - e / this.playbackSpeed), (i = this.driver) == null || i.start(!1);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(e) {
    this.updateTime(ud.now());
    const i = this.playbackSpeed !== e;
    this.playbackSpeed = e, i && (this.time = /* @__PURE__ */Xv(this.currentTime));
  }
  play() {
    var c, p;
    if (this.isStopped) return;
    const {
      driver: e = fle,
      startTime: i
    } = this.options;
    this.driver || (this.driver = e(h => this.tick(h))), (p = (c = this.options).onPlay) == null || p.call(c);
    const l = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = l) : this.holdTime !== null ? this.startTime = l - this.holdTime : this.startTime || (this.startTime = i ?? l), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(ud.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    var e, i;
    this.notifyFinished(), this.teardown(), this.state = "finished", (i = (e = this.options).onComplete) == null || i.call(e);
  }
  cancel() {
    var e, i;
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), (i = (e = this.options).onCancel) == null || i.call(e);
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(e) {
    return this.startTime = 0, this.tick(e, !0);
  }
  attachTimeline(e) {
    var i;
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), (i = this.driver) == null || i.stop(), e.observe(this);
  }
}
function Ile(t) {
  for (let e = 1; e < t.length; e++) t[e] ?? (t[e] = t[e - 1]);
}
const Wx = t => t * 180 / Math.PI,
  tF = t => {
    const e = Wx(Math.atan2(t[1], t[0]));
    return nF(e);
  },
  Mle = {
    x: 4,
    y: 5,
    translateX: 4,
    translateY: 5,
    scaleX: 0,
    scaleY: 3,
    scale: t => (Math.abs(t[0]) + Math.abs(t[3])) / 2,
    rotate: tF,
    rotateZ: tF,
    skewX: t => Wx(Math.atan(t[1])),
    skewY: t => Wx(Math.atan(t[2])),
    skew: t => (Math.abs(t[1]) + Math.abs(t[2])) / 2
  },
  nF = t => (t = t % 360, t < 0 && (t += 360), t),
  n3 = tF,
  r3 = t => Math.sqrt(t[0] * t[0] + t[1] * t[1]),
  i3 = t => Math.sqrt(t[4] * t[4] + t[5] * t[5]),
  Ole = {
    x: 12,
    y: 13,
    z: 14,
    translateX: 12,
    translateY: 13,
    translateZ: 14,
    scaleX: r3,
    scaleY: i3,
    scale: t => (r3(t) + i3(t)) / 2,
    rotateX: t => nF(Wx(Math.atan2(t[6], t[5]))),
    rotateY: t => nF(Wx(Math.atan2(-t[2], t[0]))),
    rotateZ: n3,
    rotate: n3,
    skewX: t => Wx(Math.atan(t[4])),
    skewY: t => Wx(Math.atan(t[1])),
    skew: t => (Math.abs(t[1]) + Math.abs(t[4])) / 2
  };
function rF(t) {
  return t.includes("scale") ? 1 : 0;
}
function iF(t, e) {
  if (!t || t === "none") return rF(e);
  const i = t.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let l, c;
  if (i) l = Ole, c = i;else {
    const y = t.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    l = Mle, c = y;
  }
  if (!c) return rF(e);
  const p = l[e],
    h = c[1].split(",").map(Ple);
  return typeof p == "function" ? p(h) : h[p];
}
const Lle = (t, e) => {
  const {
    transform: i = "none"
  } = getComputedStyle(t);
  return iF(i, e);
};
function Ple(t) {
  return parseFloat(t.trim());
}
const UE = ["transformPerspective", "x", "y", "z", "translateX", "translateY", "translateZ", "scale", "scaleX", "scaleY", "rotate", "rotateX", "rotateY", "rotateZ", "skew", "skewX", "skewY"],
  HE = new Set(UE),
  a3 = t => t === BE || t === Yn,
  Ale = /* @__PURE__ */new Set(["x", "y", "z"]),
  jle = UE.filter(t => !Ale.has(t));
function Fle(t) {
  const e = [];
  return jle.forEach(i => {
    const l = t.getValue(i);
    l !== void 0 && (e.push([i, l.get()]), l.set(i.startsWith("scale") ? 1 : 0));
  }), e;
}
const Kx = {
  // Dimensions
  width: ({
    x: t
  }, {
    paddingLeft: e = "0",
    paddingRight: i = "0"
  }) => t.max - t.min - parseFloat(e) - parseFloat(i),
  height: ({
    y: t
  }, {
    paddingTop: e = "0",
    paddingBottom: i = "0"
  }) => t.max - t.min - parseFloat(e) - parseFloat(i),
  top: (t, {
    top: e
  }) => parseFloat(e),
  left: (t, {
    left: e
  }) => parseFloat(e),
  bottom: ({
    y: t
  }, {
    top: e
  }) => parseFloat(e) + (t.max - t.min),
  right: ({
    x: t
  }, {
    left: e
  }) => parseFloat(e) + (t.max - t.min),
  // Transform
  x: (t, {
    transform: e
  }) => iF(e, "x"),
  y: (t, {
    transform: e
  }) => iF(e, "y")
};
Kx.translateX = Kx.x;
Kx.translateY = Kx.y;
const Qx = /* @__PURE__ */new Set();
let aF = !1,
  oF = !1,
  sF = !1;
function E6() {
  if (oF) {
    const t = Array.from(Qx).filter(l => l.needsMeasurement),
      e = new Set(t.map(l => l.element)),
      i = /* @__PURE__ */new Map();
    e.forEach(l => {
      const c = Fle(l);
      c.length && (i.set(l, c), l.render());
    }), t.forEach(l => l.measureInitialState()), e.forEach(l => {
      l.render();
      const c = i.get(l);
      c && c.forEach(([p, h]) => {
        var y;
        (y = l.getValue(p)) == null || y.set(h);
      });
    }), t.forEach(l => l.measureEndState()), t.forEach(l => {
      l.suspendedScrollY !== void 0 && window.scrollTo(0, l.suspendedScrollY);
    });
  }
  oF = !1, aF = !1, Qx.forEach(t => t.complete(sF)), Qx.clear();
}
function C6() {
  Qx.forEach(t => {
    t.readKeyframes(), t.needsMeasurement && (oF = !0);
  });
}
function Nle() {
  sF = !0, C6(), E6(), sF = !1;
}
class fz {
  constructor(e, i, l, c, p, h = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...e], this.onComplete = i, this.name = l, this.motionValue = c, this.element = p, this.isAsync = h;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (Qx.add(this), aF || (aF = !0, Ua.read(C6), Ua.resolveKeyframes(E6))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const {
      unresolvedKeyframes: e,
      name: i,
      element: l,
      motionValue: c
    } = this;
    if (e[0] === null) {
      const p = c == null ? void 0 : c.get(),
        h = e[e.length - 1];
      if (p !== void 0) e[0] = p;else if (l && i) {
        const y = l.readValue(i, h);
        y != null && (e[0] = y);
      }
      e[0] === void 0 && (e[0] = h), c && p === void 0 && c.set(e[0]);
    }
    Ile(e);
  }
  setFinalKeyframe() {}
  measureInitialState() {}
  renderEndStyles() {}
  measureEndState() {}
  complete(e = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, e), Qx.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (Qx.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const zle = t => t.startsWith("--");
function Vle(t, e, i) {
  zle(e) ? t.style.setProperty(e, i) : t.style[e] = i;
}
const Ble = /* @__PURE__ */JN(() => window.ScrollTimeline !== void 0),
  Ule = {};
function Hle(t, e) {
  const i = /* @__PURE__ */JN(t);
  return () => Ule[e] ?? i();
}
const k6 = /* @__PURE__ */Hle(() => {
    try {
      document.createElement("div").animate({
        opacity: 0
      }, {
        easing: "linear(0, 1)"
      });
    } catch {
      return !1;
    }
    return !0;
  }, "linearEasing"),
  LT = ([t, e, i, l]) => `cubic-bezier(${t}, ${e}, ${i}, ${l})`,
  o3 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /* @__PURE__ */LT([0, 0.65, 0.55, 1]),
    circOut: /* @__PURE__ */LT([0.55, 0, 1, 0.45]),
    backIn: /* @__PURE__ */LT([0.31, 0.01, 0.66, -0.59]),
    backOut: /* @__PURE__ */LT([0.33, 1.53, 0.69, 0.99])
  };
function T6(t, e) {
  if (t) return typeof t == "function" ? k6() ? _6(t, e) : "ease-out" : d6(t) ? LT(t) : Array.isArray(t) ? t.map(i => T6(i, e) || o3.easeOut) : o3[t];
}
function $le(t, e, i, {
  delay: l = 0,
  duration: c = 300,
  repeat: p = 0,
  repeatType: h = "loop",
  ease: y = "easeOut",
  times: w
} = {}, x = void 0) {
  const E = {
    [e]: i
  };
  w && (E.offset = w);
  const C = T6(y, c);
  Array.isArray(C) && (E.easing = C);
  const k = {
    delay: l,
    duration: c,
    easing: Array.isArray(C) ? "linear" : C,
    fill: "both",
    iterations: p + 1,
    direction: h === "reverse" ? "alternate" : "normal"
  };
  return x && (k.pseudoElement = x), t.animate(E, k);
}
function R6(t) {
  return typeof t == "function" && "applyToOptions" in t;
}
function Wle({
  type: t,
  ...e
}) {
  return R6(t) && k6() ? t.applyToOptions(e) : (e.duration ?? (e.duration = 300), e.ease ?? (e.ease = "easeOut"), e);
}
class qle extends cz {
  constructor(e) {
    if (super(), this.finishedTime = null, this.isStopped = !1, !e) return;
    const {
      element: i,
      name: l,
      keyframes: c,
      pseudoElement: p,
      allowFlatten: h = !1,
      finalKeyframe: y,
      onComplete: w
    } = e;
    this.isPseudoElement = !!p, this.allowFlatten = h, this.options = e, _b(typeof e.type != "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
    const x = Wle(e);
    this.animation = $le(i, l, c, x, p), x.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !p) {
        const E = uz(c, this.options, y, this.speed);
        this.updateMotionValue ? this.updateMotionValue(E) : Vle(i, l, E), this.animation.cancel();
      }
      w == null || w(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    var e, i;
    (i = (e = this.animation).finish) == null || i.call(e);
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {}
  }
  stop() {
    if (this.isStopped) return;
    this.isStopped = !0;
    const {
      state: e
    } = this;
    e === "idle" || e === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    var e, i;
    this.isPseudoElement || (i = (e = this.animation).commitStyles) == null || i.call(e);
  }
  get duration() {
    var i, l;
    const e = ((l = (i = this.animation.effect) == null ? void 0 : i.getComputedTiming) == null ? void 0 : l.call(i).duration) || 0;
    return /* @__PURE__ */Xv(Number(e));
  }
  get time() {
    return /* @__PURE__ */Xv(Number(this.animation.currentTime) || 0);
  }
  set time(e) {
    this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */qm(e);
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(e) {
    e < 0 && (this.finishedTime = null), this.animation.playbackRate = e;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return Number(this.animation.startTime);
  }
  set startTime(e) {
    this.animation.startTime = e;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({
    timeline: e,
    observe: i
  }) {
    var l;
    return this.allowFlatten && ((l = this.animation.effect) == null || l.updateTiming({
      easing: "linear"
    })), this.animation.onfinish = null, e && Ble() ? (this.animation.timeline = e, Bp) : i(this);
  }
}
const D6 = {
  anticipate: s6,
  backInOut: o6,
  circInOut: u6
};
function Yle(t) {
  return t in D6;
}
function Gle(t) {
  typeof t.ease == "string" && Yle(t.ease) && (t.ease = D6[t.ease]);
}
const s3 = 10;
class Xle extends qle {
  constructor(e) {
    Gle(e), S6(e), super(e), e.startTime && (this.startTime = e.startTime), this.options = e;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read commited styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(e) {
    const {
      motionValue: i,
      onUpdate: l,
      onComplete: c,
      element: p,
      ...h
    } = this.options;
    if (!i) return;
    if (e !== void 0) {
      i.set(e);
      return;
    }
    const y = new dz({
        ...h,
        autoplay: !1
      }),
      w = /* @__PURE__ */qm(this.finishedTime ?? this.time);
    i.setWithVelocity(y.sample(w - s3).value, y.sample(w).value, s3), y.stop();
  }
}
const l3 = (t, e) => e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && (
// It's animatable if we have a string
ow.test(t) || t === "0") &&
// And it contains numbers and/or colors
!t.startsWith("url("));
function Kle(t) {
  const e = t[0];
  if (t.length === 1) return !0;
  for (let i = 0; i < t.length; i++) if (t[i] !== e) return !0;
}
function Qle(t, e, i, l) {
  const c = t[0];
  if (c === null) return !1;
  if (e === "display" || e === "visibility") return !0;
  const p = t[t.length - 1],
    h = l3(c, e),
    y = l3(p, e);
  return VE(h === y, `You are trying to animate ${e} from "${c}" to "${p}". "${h ? p : c}" is not an animatable value.`, "value-not-animatable"), !h || !y ? !1 : Kle(t) || (i === "spring" || R6(i)) && l;
}
function lF(t) {
  t.duration = 0, t.type;
}
const Zle = /* @__PURE__ */new Set(["opacity", "clipPath", "filter", "transform"
  // TODO: Could be re-enabled now we have support for linear() easing
  // "background-color"
  ]),
  Jle = /* @__PURE__ */JN(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function eue(t) {
  var E;
  const {
    motionValue: e,
    name: i,
    repeatDelay: l,
    repeatType: c,
    damping: p,
    type: h
  } = t;
  if (!(((E = e == null ? void 0 : e.owner) == null ? void 0 : E.current) instanceof HTMLElement)) return !1;
  const {
    onUpdate: w,
    transformTemplate: x
  } = e.owner.getProps();
  return Jle() && i && Zle.has(i) && (i !== "transform" || !x) &&
  /**
  * If we're outputting values to onUpdate then we can't use WAAPI as there's
  * no way to read the value from WAAPI every frame.
  */
  !w && !l && c !== "mirror" && p !== 0 && h !== "inertia";
}
const tue = 40;
class nue extends cz {
  constructor({
    autoplay: e = !0,
    delay: i = 0,
    type: l = "keyframes",
    repeat: c = 0,
    repeatDelay: p = 0,
    repeatType: h = "loop",
    keyframes: y,
    name: w,
    motionValue: x,
    element: E,
    ...C
  }) {
    var I;
    super(), this.stop = () => {
      var O, P;
      this._animation && (this._animation.stop(), (O = this.stopTimeline) == null || O.call(this)), (P = this.keyframeResolver) == null || P.cancel();
    }, this.createdAt = ud.now();
    const k = {
        autoplay: e,
        delay: i,
        type: l,
        repeat: c,
        repeatDelay: p,
        repeatType: h,
        name: w,
        motionValue: x,
        element: E,
        ...C
      },
      D = (E == null ? void 0 : E.KeyframeResolver) || fz;
    this.keyframeResolver = new D(y, (O, P, N) => this.onKeyframesResolved(O, P, k, !N), w, x, E), (I = this.keyframeResolver) == null || I.scheduleResolve();
  }
  onKeyframesResolved(e, i, l, c) {
    this.keyframeResolver = void 0;
    const {
      name: p,
      type: h,
      velocity: y,
      delay: w,
      isHandoff: x,
      onUpdate: E
    } = l;
    this.resolvedAt = ud.now(), Qle(e, p, h, y) || ((xb.instantAnimations || !w) && (E == null || E(uz(e, l, i))), e[0] = e[e.length - 1], lF(l), l.repeat = 0);
    const k = {
        startTime: c ? this.resolvedAt ? this.resolvedAt - this.createdAt > tue ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
        finalKeyframe: i,
        ...l,
        keyframes: e
      },
      D = !x && eue(k) ? new Xle({
        ...k,
        element: k.motionValue.owner.current
      }) : new dz(k);
    D.finished.then(() => this.notifyFinished()).catch(Bp), this.pendingTimeline && (this.stopTimeline = D.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = D;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(e, i) {
    return this.finished.finally(e).then(() => {});
  }
  get animation() {
    var e;
    return this._animation || ((e = this.keyframeResolver) == null || e.resume(), Nle()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get time() {
    return this.animation.time;
  }
  set time(e) {
    this.animation.time = e;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(e) {
    this.animation.speed = e;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(e) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(e) : this.pendingTimeline = e, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    var e;
    this._animation && this.animation.cancel(), (e = this.keyframeResolver) == null || e.cancel();
  }
}
const rue =
// eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function iue(t) {
  const e = rue.exec(t);
  if (!e) return [,];
  const [, i, l, c] = e;
  return [`--${i ?? l}`, c];
}
const aue = 4;
function I6(t, e, i = 1) {
  _b(i <= aue, `Max CSS variable fallback depth detected in property "${t}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
  const [l, c] = iue(t);
  if (!l) return;
  const p = window.getComputedStyle(e).getPropertyValue(l);
  if (p) {
    const h = p.trim();
    return Z$(h) ? parseFloat(h) : h;
  }
  return iz(c) ? I6(c, e, i + 1) : c;
}
function pz(t, e) {
  return (t == null ? void 0 : t[e]) ?? (t == null ? void 0 : t.default) ?? t;
}
const M6 = /* @__PURE__ */new Set(["width", "height", "top", "left", "right", "bottom", ...UE]),
  oue = {
    test: t => t === "auto",
    parse: t => t
  },
  O6 = t => e => e.test(t),
  L6 = [BE, Yn, Kv, G0, Kse, Xse, oue],
  u3 = t => L6.find(O6(t));
function sue(t) {
  return typeof t == "number" ? t === 0 : t !== null ? t === "none" || t === "0" || e6(t) : !0;
}
const lue = /* @__PURE__ */new Set(["brightness", "contrast", "saturate", "opacity"]);
function uue(t) {
  const [e, i] = t.slice(0, -1).split("(");
  if (e === "drop-shadow") return t;
  const [l] = i.match(az) || [];
  if (!l) return t;
  const c = i.replace(l, "");
  let p = lue.has(e) ? 1 : 0;
  return l !== i && (p *= 100), e + "(" + p + c + ")";
}
const cue = /\b([a-z-]*)\(.*?\)/gu,
  uF = {
    ...ow,
    getAnimatableNone: t => {
      const e = t.match(cue);
      return e ? e.map(uue).join(" ") : t;
    }
  },
  c3 = {
    ...BE,
    transform: Math.round
  },
  due = {
    rotate: G0,
    rotateX: G0,
    rotateY: G0,
    rotateZ: G0,
    scale: EM,
    scaleX: EM,
    scaleY: EM,
    scaleZ: EM,
    skew: G0,
    skewX: G0,
    skewY: G0,
    distance: Yn,
    translateX: Yn,
    translateY: Yn,
    translateZ: Yn,
    x: Yn,
    y: Yn,
    z: Yn,
    perspective: Yn,
    transformPerspective: Yn,
    opacity: wR,
    originX: KB,
    originY: KB,
    originZ: Yn
  },
  hz = {
    // Border props
    borderWidth: Yn,
    borderTopWidth: Yn,
    borderRightWidth: Yn,
    borderBottomWidth: Yn,
    borderLeftWidth: Yn,
    borderRadius: Yn,
    radius: Yn,
    borderTopLeftRadius: Yn,
    borderTopRightRadius: Yn,
    borderBottomRightRadius: Yn,
    borderBottomLeftRadius: Yn,
    // Positioning props
    width: Yn,
    maxWidth: Yn,
    height: Yn,
    maxHeight: Yn,
    top: Yn,
    right: Yn,
    bottom: Yn,
    left: Yn,
    // Spacing props
    padding: Yn,
    paddingTop: Yn,
    paddingRight: Yn,
    paddingBottom: Yn,
    paddingLeft: Yn,
    margin: Yn,
    marginTop: Yn,
    marginRight: Yn,
    marginBottom: Yn,
    marginLeft: Yn,
    // Misc
    backgroundPositionX: Yn,
    backgroundPositionY: Yn,
    ...due,
    zIndex: c3,
    // SVG
    fillOpacity: wR,
    strokeOpacity: wR,
    numOctaves: c3
  },
  fue = {
    ...hz,
    // Color props
    color: Ss,
    backgroundColor: Ss,
    outlineColor: Ss,
    fill: Ss,
    stroke: Ss,
    // Border props
    borderColor: Ss,
    borderTopColor: Ss,
    borderRightColor: Ss,
    borderBottomColor: Ss,
    borderLeftColor: Ss,
    filter: uF,
    WebkitFilter: uF
  },
  P6 = t => fue[t];
function A6(t, e) {
  let i = P6(t);
  return i !== uF && (i = ow), i.getAnimatableNone ? i.getAnimatableNone(e) : void 0;
}
const pue = /* @__PURE__ */new Set(["auto", "none", "0"]);
function hue(t, e, i) {
  let l = 0,
    c;
  for (; l < t.length && !c;) {
    const p = t[l];
    typeof p == "string" && !pue.has(p) && _R(p).values.length && (c = t[l]), l++;
  }
  if (c && i) for (const p of e) t[p] = A6(i, c);
}
class mue extends fz {
  constructor(e, i, l, c, p) {
    super(e, i, l, c, p, !0);
  }
  readKeyframes() {
    const {
      unresolvedKeyframes: e,
      element: i,
      name: l
    } = this;
    if (!i || !i.current) return;
    super.readKeyframes();
    for (let w = 0; w < e.length; w++) {
      let x = e[w];
      if (typeof x == "string" && (x = x.trim(), iz(x))) {
        const E = I6(x, i.current);
        E !== void 0 && (e[w] = E), w === e.length - 1 && (this.finalKeyframe = x);
      }
    }
    if (this.resolveNoneKeyframes(), !M6.has(l) || e.length !== 2) return;
    const [c, p] = e,
      h = u3(c),
      y = u3(p);
    if (h !== y) if (a3(h) && a3(y)) for (let w = 0; w < e.length; w++) {
      const x = e[w];
      typeof x == "string" && (e[w] = parseFloat(x));
    } else Kx[l] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const {
        unresolvedKeyframes: e,
        name: i
      } = this,
      l = [];
    for (let c = 0; c < e.length; c++) (e[c] === null || sue(e[c])) && l.push(c);
    l.length && hue(e, l, i);
  }
  measureInitialState() {
    const {
      element: e,
      unresolvedKeyframes: i,
      name: l
    } = this;
    if (!e || !e.current) return;
    l === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = Kx[l](e.measureViewportBox(), window.getComputedStyle(e.current)), i[0] = this.measuredOrigin;
    const c = i[i.length - 1];
    c !== void 0 && e.getValue(l, c).jump(c, !1);
  }
  measureEndState() {
    var y;
    const {
      element: e,
      name: i,
      unresolvedKeyframes: l
    } = this;
    if (!e || !e.current) return;
    const c = e.getValue(i);
    c && c.jump(this.measuredOrigin, !1);
    const p = l.length - 1,
      h = l[p];
    l[p] = Kx[i](e.measureViewportBox(), window.getComputedStyle(e.current)), h !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = h), (y = this.removedTransforms) != null && y.length && this.removedTransforms.forEach(([w, x]) => {
      e.getValue(w).set(x);
    }), this.resolveNoneKeyframes();
  }
}
function vue(t, e, i) {
  if (t instanceof EventTarget) return [t];
  if (typeof t == "string") {
    let l = document;
    const c = (i == null ? void 0 : i[t]) ?? l.querySelectorAll(t);
    return c ? Array.from(c) : [];
  }
  return Array.from(t);
}
const j6 = (t, e) => e && typeof t == "number" ? e.transform(t) : t;
function gue(t) {
  return J$(t) && "offsetHeight" in t;
}
const d3 = 30,
  yue = t => !isNaN(parseFloat(t));
class bue {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(e, i = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = l => {
      var p;
      const c = ud.now();
      if (this.updatedAt !== c && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(l), this.current !== this.prev && ((p = this.events.change) == null || p.notify(this.current), this.dependents)) for (const h of this.dependents) h.dirty();
    }, this.hasAnimated = !1, this.setCurrent(e), this.owner = i.owner;
  }
  setCurrent(e) {
    this.current = e, this.updatedAt = ud.now(), this.canTrackVelocity === null && e !== void 0 && (this.canTrackVelocity = yue(this.current));
  }
  setPrevFrameValue(e = this.current) {
    this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(e) {
    return process.env.NODE_ENV !== "production" && QO(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", e);
  }
  on(e, i) {
    this.events[e] || (this.events[e] = new ez());
    const l = this.events[e].add(i);
    return e === "change" ? () => {
      l(), Ua.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : l;
  }
  clearListeners() {
    for (const e in this.events) this.events[e].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(e, i) {
    this.passiveEffect = e, this.stopPassiveEffect = i;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(e) {
    this.passiveEffect ? this.passiveEffect(e, this.updateAndNotify) : this.updateAndNotify(e);
  }
  setWithVelocity(e, i, l) {
    this.set(i), this.prev = void 0, this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt - l;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(e, i = !0) {
    this.updateAndNotify(e), this.prev = e, this.prevUpdatedAt = this.prevFrameValue = void 0, i && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    var e;
    (e = this.events.change) == null || e.notify(this.current);
  }
  addDependent(e) {
    this.dependents || (this.dependents = /* @__PURE__ */new Set()), this.dependents.add(e);
  }
  removeDependent(e) {
    this.dependents && this.dependents.delete(e);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const e = ud.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || e - this.updatedAt > d3) return 0;
    const i = Math.min(this.updatedAt - this.prevUpdatedAt, d3);
    return t6(parseFloat(this.current) - parseFloat(this.prevFrameValue), i);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(e) {
    return this.stop(), new Promise(i => {
      this.hasAnimated = !0, this.animation = e(i), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    var e, i;
    (e = this.dependents) == null || e.clear(), (i = this.events.destroy) == null || i.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function RE(t, e) {
  return new bue(t, e);
}
const {
    schedule: mz
  } = /* @__PURE__ */f6(queueMicrotask, !1),
  Bm = {
    x: !1,
    y: !1
  };
function F6() {
  return Bm.x || Bm.y;
}
function wue(t) {
  return t === "x" || t === "y" ? Bm[t] ? null : (Bm[t] = !0, () => {
    Bm[t] = !1;
  }) : Bm.x || Bm.y ? null : (Bm.x = Bm.y = !0, () => {
    Bm.x = Bm.y = !1;
  });
}
function N6(t, e) {
  const i = vue(t),
    l = new AbortController(),
    c = {
      passive: !0,
      ...e,
      signal: l.signal
    };
  return [i, c, () => l.abort()];
}
function f3(t) {
  return !(t.pointerType === "touch" || F6());
}
function _ue(t, e, i = {}) {
  const [l, c, p] = N6(t, i),
    h = y => {
      if (!f3(y)) return;
      const {
          target: w
        } = y,
        x = e(w, y);
      if (typeof x != "function" || !w) return;
      const E = C => {
        f3(C) && (x(C), w.removeEventListener("pointerleave", E));
      };
      w.addEventListener("pointerleave", E, c);
    };
  return l.forEach(y => {
    y.addEventListener("pointerenter", h, c);
  }), p;
}
const z6 = (t, e) => e ? t === e ? !0 : z6(t, e.parentElement) : !1,
  vz = t => t.pointerType === "mouse" ? typeof t.button != "number" || t.button <= 0 : t.isPrimary !== !1,
  xue = /* @__PURE__ */new Set(["BUTTON", "INPUT", "SELECT", "TEXTAREA", "A"]);
function Sue(t) {
  return xue.has(t.tagName) || t.tabIndex !== -1;
}
const GM = /* @__PURE__ */new WeakSet();
function p3(t) {
  return e => {
    e.key === "Enter" && t(e);
  };
}
function Q2(t, e) {
  t.dispatchEvent(new PointerEvent("pointer" + e, {
    isPrimary: !0,
    bubbles: !0
  }));
}
const Eue = (t, e) => {
  const i = t.currentTarget;
  if (!i) return;
  const l = p3(() => {
    if (GM.has(i)) return;
    Q2(i, "down");
    const c = p3(() => {
        Q2(i, "up");
      }),
      p = () => Q2(i, "cancel");
    i.addEventListener("keyup", c, e), i.addEventListener("blur", p, e);
  });
  i.addEventListener("keydown", l, e), i.addEventListener("blur", () => i.removeEventListener("keydown", l), e);
};
function h3(t) {
  return vz(t) && !F6();
}
function Cue(t, e, i = {}) {
  const [l, c, p] = N6(t, i),
    h = y => {
      const w = y.currentTarget;
      if (!h3(y)) return;
      GM.add(w);
      const x = e(w, y),
        E = (D, I) => {
          window.removeEventListener("pointerup", C), window.removeEventListener("pointercancel", k), GM.has(w) && GM.delete(w), h3(D) && typeof x == "function" && x(D, {
            success: I
          });
        },
        C = D => {
          E(D, w === window || w === document || i.useGlobalTarget || z6(w, D.target));
        },
        k = D => {
          E(D, !1);
        };
      window.addEventListener("pointerup", C, c), window.addEventListener("pointercancel", k, c);
    };
  return l.forEach(y => {
    (i.useGlobalTarget ? window : y).addEventListener("pointerdown", h, c), gue(y) && (y.addEventListener("focus", x => Eue(x, c)), !Sue(y) && !y.hasAttribute("tabindex") && (y.tabIndex = 0));
  }), p;
}
function V6(t) {
  return J$(t) && "ownerSVGElement" in t;
}
function kue(t) {
  return V6(t) && t.tagName === "svg";
}
const Cu = t => !!(t && t.getVelocity),
  Tue = [...L6, Ss, ow],
  Rue = t => Tue.find(O6(t)),
  B6 = Up({
    transformPagePoint: t => t,
    isStatic: !1,
    reducedMotion: "never"
  });
function Due(t = !0) {
  const e = bl(KN);
  if (e === null) return [!0, null];
  const {
      isPresent: i,
      onExitComplete: l,
      register: c
    } = e,
    p = ME();
  Rt(() => {
    if (t) return c(p);
  }, [t]);
  const h = pn(() => t && l && l(p), [p, l, t]);
  return !i && l ? [!1, h] : [!0];
}
const U6 = Up({
    strict: !1
  }),
  m3 = {
    animation: ["animate", "variants", "whileHover", "whileTap", "exit", "whileInView", "whileFocus", "whileDrag"],
    exit: ["exit"],
    drag: ["drag", "dragControls"],
    focus: ["whileFocus"],
    hover: ["whileHover", "onHoverStart", "onHoverEnd"],
    tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
    pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
    inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
    layout: ["layout", "layoutId"]
  },
  DE = {};
for (const t in m3) DE[t] = {
  isEnabled: e => m3[t].some(i => !!e[i])
};
function Iue(t) {
  for (const e in t) DE[e] = {
    ...DE[e],
    ...t[e]
  };
}
const Mue = /* @__PURE__ */new Set(["animate", "exit", "variants", "initial", "style", "values", "variants", "transition", "transformTemplate", "custom", "inherit", "onBeforeLayoutMeasure", "onAnimationStart", "onAnimationComplete", "onUpdate", "onDragStart", "onDrag", "onDragEnd", "onMeasureDragConstraints", "onDirectionLock", "onDragTransitionEnd", "_dragX", "_dragY", "onHoverStart", "onHoverEnd", "onViewportEnter", "onViewportLeave", "globalTapTarget", "ignoreStrict", "viewport"]);
function IO(t) {
  return t.startsWith("while") || t.startsWith("drag") && t !== "draggable" || t.startsWith("layout") || t.startsWith("onTap") || t.startsWith("onPan") || t.startsWith("onLayout") || Mue.has(t);
}
let H6 = t => !IO(t);
function Oue(t) {
  typeof t == "function" && (H6 = e => e.startsWith("on") ? !IO(e) : t(e));
}
try {
  Oue(require("@emotion/is-prop-valid").default);
} catch {}
function Lue(t, e, i) {
  const l = {};
  for (const c in t) c === "values" && typeof t.values == "object" || (H6(c) || i === !0 && IO(c) || !e && !IO(c) ||
  // If trying to use native HTML drag events, forward drag listeners
  t.draggable && c.startsWith("onDrag")) && (l[c] = t[c]);
  return l;
}
const ZO = /* @__PURE__ */Up({});
function JO(t) {
  return t !== null && typeof t == "object" && typeof t.start == "function";
}
function xR(t) {
  return typeof t == "string" || Array.isArray(t);
}
const gz = ["animate", "whileInView", "whileFocus", "whileHover", "whileTap", "whileDrag", "exit"],
  yz = ["initial", ...gz];
function eL(t) {
  return JO(t.animate) || yz.some(e => xR(t[e]));
}
function $6(t) {
  return !!(eL(t) || t.variants);
}
function Pue(t, e) {
  if (eL(t)) {
    const {
      initial: i,
      animate: l
    } = t;
    return {
      initial: i === !1 || xR(i) ? i : void 0,
      animate: xR(l) ? l : void 0
    };
  }
  return t.inherit !== !1 ? e : {};
}
function Aue(t) {
  const {
    initial: e,
    animate: i
  } = Pue(t, bl(ZO));
  return ci(() => ({
    initial: e,
    animate: i
  }), [v3(e), v3(i)]);
}
function v3(t) {
  return Array.isArray(t) ? t.join(" ") : t;
}
const SR = {};
function jue(t) {
  for (const e in t) SR[e] = t[e], rz(e) && (SR[e].isCSSVariable = !0);
}
function W6(t, {
  layout: e,
  layoutId: i
}) {
  return HE.has(t) || t.startsWith("origin") || (e || i !== void 0) && (!!SR[t] || t === "opacity");
}
const Fue = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
  },
  Nue = UE.length;
function zue(t, e, i) {
  let l = "",
    c = !0;
  for (let p = 0; p < Nue; p++) {
    const h = UE[p],
      y = t[h];
    if (y === void 0) continue;
    let w = !0;
    if (typeof y == "number" ? w = y === (h.startsWith("scale") ? 1 : 0) : w = parseFloat(y) === 0, !w || i) {
      const x = j6(y, hz[h]);
      if (!w) {
        c = !1;
        const E = Fue[h] || h;
        l += `${E}(${x}) `;
      }
      i && (e[h] = x);
    }
  }
  return l = l.trim(), i ? l = i(e, c ? "" : l) : c && (l = "none"), l;
}
function bz(t, e, i) {
  const {
    style: l,
    vars: c,
    transformOrigin: p
  } = t;
  let h = !1,
    y = !1;
  for (const w in e) {
    const x = e[w];
    if (HE.has(w)) {
      h = !0;
      continue;
    } else if (rz(w)) {
      c[w] = x;
      continue;
    } else {
      const E = j6(x, hz[w]);
      w.startsWith("origin") ? (y = !0, p[w] = E) : l[w] = E;
    }
  }
  if (e.transform || (h || i ? l.transform = zue(e, t.transform, i) : l.transform && (l.transform = "none")), y) {
    const {
      originX: w = "50%",
      originY: x = "50%",
      originZ: E = 0
    } = p;
    l.transformOrigin = `${w} ${x} ${E}`;
  }
}
const wz = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function q6(t, e, i) {
  for (const l in e) !Cu(e[l]) && !W6(l, i) && (t[l] = e[l]);
}
function Vue({
  transformTemplate: t
}, e) {
  return ci(() => {
    const i = wz();
    return bz(i, e, t), Object.assign({}, i.vars, i.style);
  }, [e]);
}
function Bue(t, e) {
  const i = t.style || {},
    l = {};
  return q6(l, i, t), Object.assign(l, Vue(t, e)), l;
}
function Uue(t, e) {
  const i = {},
    l = Bue(t, e);
  return t.drag && t.dragListener !== !1 && (i.draggable = !1, l.userSelect = l.WebkitUserSelect = l.WebkitTouchCallout = "none", l.touchAction = t.drag === !0 ? "none" : `pan-${t.drag === "x" ? "y" : "x"}`), t.tabIndex === void 0 && (t.onTap || t.onTapStart || t.whileTap) && (i.tabIndex = 0), i.style = l, i;
}
const Hue = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
  },
  $ue = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
  };
function Wue(t, e, i = 1, l = 0, c = !0) {
  t.pathLength = 1;
  const p = c ? Hue : $ue;
  t[p.offset] = Yn.transform(-l);
  const h = Yn.transform(e),
    y = Yn.transform(i);
  t[p.array] = `${h} ${y}`;
}
function Y6(t, {
  attrX: e,
  attrY: i,
  attrScale: l,
  pathLength: c,
  pathSpacing: p = 1,
  pathOffset: h = 0,
  // This is object creation, which we try to avoid per-frame.
  ...y
}, w, x, E) {
  if (bz(t, y, x), w) {
    t.style.viewBox && (t.attrs.viewBox = t.style.viewBox);
    return;
  }
  t.attrs = t.style, t.style = {};
  const {
    attrs: C,
    style: k
  } = t;
  C.transform && (k.transform = C.transform, delete C.transform), (k.transform || C.transformOrigin) && (k.transformOrigin = C.transformOrigin ?? "50% 50%", delete C.transformOrigin), k.transform && (k.transformBox = (E == null ? void 0 : E.transformBox) ?? "fill-box", delete C.transformBox), e !== void 0 && (C.x = e), i !== void 0 && (C.y = i), l !== void 0 && (C.scale = l), c !== void 0 && Wue(C, c, p, h, !1);
}
const G6 = () => ({
    ...wz(),
    attrs: {}
  }),
  X6 = t => typeof t == "string" && t.toLowerCase() === "svg";
function que(t, e, i, l) {
  const c = ci(() => {
    const p = G6();
    return Y6(p, e, X6(l), t.transformTemplate, t.style), {
      ...p.attrs,
      style: {
        ...p.style
      }
    };
  }, [e]);
  if (t.style) {
    const p = {};
    q6(p, t.style, t), c.style = {
      ...p,
      ...c.style
    };
  }
  return c;
}
const Yue = ["animate", "circle", "defs", "desc", "ellipse", "g", "image", "line", "filter", "marker", "mask", "metadata", "path", "pattern", "polygon", "polyline", "rect", "stop", "switch", "symbol", "svg", "text", "tspan", "use", "view"];
function _z(t) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof t != "string" ||
    /**
    * If it contains a dash, the element is a custom HTML webcomponent.
    */
    t.includes("-") ? !1 : (
    /**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */
    !!(Yue.indexOf(t) > -1 ||
    /**
    * If it contains a capital letter, it's an SVG component
    */
    /[A-Z]/u.test(t)))
  );
}
function Gue(t, e, i, {
  latestValues: l
}, c, p = !1) {
  const y = (_z(t) ? que : Uue)(e, l, c, t),
    w = Lue(e, typeof t == "string", p),
    x = t !== Qv ? {
      ...w,
      ...y,
      ref: i
    } : {},
    {
      children: E
    } = e,
    C = ci(() => Cu(E) ? E.get() : E, [E]);
  return sH(t, {
    ...x,
    children: C
  });
}
function g3(t) {
  const e = [{}, {}];
  return t == null || t.values.forEach((i, l) => {
    e[0][l] = i.get(), e[1][l] = i.getVelocity();
  }), e;
}
function xz(t, e, i, l) {
  if (typeof e == "function") {
    const [c, p] = g3(l);
    e = e(i !== void 0 ? i : t.custom, c, p);
  }
  if (typeof e == "string" && (e = t.variants && t.variants[e]), typeof e == "function") {
    const [c, p] = g3(l);
    e = e(i !== void 0 ? i : t.custom, c, p);
  }
  return e;
}
function XM(t) {
  return Cu(t) ? t.get() : t;
}
function Xue({
  scrapeMotionValuesFromProps: t,
  createRenderState: e
}, i, l, c) {
  return {
    latestValues: Kue(i, l, c, t),
    renderState: e()
  };
}
function Kue(t, e, i, l) {
  const c = {},
    p = l(t, {});
  for (const k in p) c[k] = XM(p[k]);
  let {
    initial: h,
    animate: y
  } = t;
  const w = eL(t),
    x = $6(t);
  e && x && !w && t.inherit !== !1 && (h === void 0 && (h = e.initial), y === void 0 && (y = e.animate));
  let E = i ? i.initial === !1 : !1;
  E = E || h === !1;
  const C = E ? y : h;
  if (C && typeof C != "boolean" && !JO(C)) {
    const k = Array.isArray(C) ? C : [C];
    for (let D = 0; D < k.length; D++) {
      const I = xz(t, k[D]);
      if (I) {
        const {
          transitionEnd: O,
          transition: P,
          ...N
        } = I;
        for (const L in N) {
          let F = N[L];
          if (Array.isArray(F)) {
            const j = E ? F.length - 1 : 0;
            F = F[j];
          }
          F !== null && (c[L] = F);
        }
        for (const L in O) c[L] = O[L];
      }
    }
  }
  return c;
}
const K6 = t => (e, i) => {
  const l = bl(ZO),
    c = bl(KN),
    p = () => Xue(t, e, l, c);
  return i ? p() : Ise(p);
};
function Sz(t, e, i) {
  var p;
  const {
      style: l
    } = t,
    c = {};
  for (const h in l) (Cu(l[h]) || e.style && Cu(e.style[h]) || W6(h, t) || ((p = i == null ? void 0 : i.getValue(h)) == null ? void 0 : p.liveStyle) !== void 0) && (c[h] = l[h]);
  return c;
}
const Que = /* @__PURE__ */K6({
  scrapeMotionValuesFromProps: Sz,
  createRenderState: wz
});
function Q6(t, e, i) {
  const l = Sz(t, e, i);
  for (const c in t) if (Cu(t[c]) || Cu(e[c])) {
    const p = UE.indexOf(c) !== -1 ? "attr" + c.charAt(0).toUpperCase() + c.substring(1) : c;
    l[p] = t[c];
  }
  return l;
}
const Zue = /* @__PURE__ */K6({
    scrapeMotionValuesFromProps: Q6,
    createRenderState: G6
  }),
  Jue = Symbol.for("motionComponentSymbol");
function uE(t) {
  return t && typeof t == "object" && Object.prototype.hasOwnProperty.call(t, "current");
}
function ece(t, e, i) {
  return pn(l => {
    l && t.onMount && t.onMount(l), e && (l ? e.mount(l) : e.unmount()), i && (typeof i == "function" ? i(l) : uE(i) && (i.current = l));
  },
  /**
   * Only pass a new ref callback to React if we've received a visual element
   * factory. Otherwise we'll be mounting/remounting every time externalRef
   * or other dependencies change.
   */
  [e]);
}
const Ez = t => t.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(),
  tce = "framerAppearId",
  Z6 = "data-" + Ez(tce),
  J6 = Up({});
function nce(t, e, i, l, c) {
  var O, P;
  const {
      visualElement: p
    } = bl(ZO),
    h = bl(U6),
    y = bl(KN),
    w = bl(B6).reducedMotion,
    x = vt(null);
  l = l || h.renderer, !x.current && l && (x.current = l(t, {
    visualState: e,
    parent: p,
    props: i,
    presenceContext: y,
    blockInitialAnimation: y ? y.initial === !1 : !1,
    reducedMotionConfig: w
  }));
  const E = x.current,
    C = bl(J6);
  E && !E.projection && c && (E.type === "html" || E.type === "svg") && rce(x.current, i, c, C);
  const k = vt(!1);
  LW(() => {
    E && k.current && E.update(i, y);
  });
  const D = i[Z6],
    I = vt(!!D && !((O = window.MotionHandoffIsComplete) != null && O.call(window, D)) && ((P = window.MotionHasOptimisedAnimation) == null ? void 0 : P.call(window, D)));
  return Mse(() => {
    E && (k.current = !0, window.MotionIsMounted = !0, E.updateFeatures(), E.scheduleRenderMicrotask(), I.current && E.animationState && E.animationState.animateChanges());
  }), Rt(() => {
    E && (!I.current && E.animationState && E.animationState.animateChanges(), I.current && (queueMicrotask(() => {
      var N;
      (N = window.MotionHandoffMarkAsComplete) == null || N.call(window, D);
    }), I.current = !1), E.enteringChildren = void 0);
  }), E;
}
function rce(t, e, i, l) {
  const {
    layoutId: c,
    layout: p,
    drag: h,
    dragConstraints: y,
    layoutScroll: w,
    layoutRoot: x,
    layoutCrossfade: E
  } = e;
  t.projection = new i(t.latestValues, e["data-framer-portal-id"] ? void 0 : e8(t.parent)), t.projection.setOptions({
    layoutId: c,
    layout: p,
    alwaysMeasureLayout: !!h || y && uE(y),
    visualElement: t,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof p == "string" ? p : "both",
    initialPromotionConfig: l,
    crossfade: E,
    layoutScroll: w,
    layoutRoot: x
  });
}
function e8(t) {
  if (t) return t.options.allowProjection !== !1 ? t.projection : e8(t.parent);
}
function Z2(t, {
  forwardMotionProps: e = !1
} = {}, i, l) {
  i && Iue(i);
  const c = _z(t) ? Zue : Que;
  function p(y, w) {
    let x;
    const E = {
        ...bl(B6),
        ...y,
        layoutId: ice(y)
      },
      {
        isStatic: C
      } = E,
      k = Aue(y),
      D = c(y, C);
    if (!C && XN) {
      ace(E, i);
      const I = oce(E);
      x = I.MeasureLayout, k.visualElement = nce(t, D, E, l, I.ProjectionNode);
    }
    return B.jsxs(ZO.Provider, {
      value: k,
      children: [x && k.visualElement ? B.jsx(x, {
        visualElement: k.visualElement,
        ...E
      }) : null, Gue(t, y, ece(D, k.visualElement, w), D, C, e)]
    });
  }
  p.displayName = `motion.${typeof t == "string" ? t : `create(${t.displayName ?? t.name ?? ""})`}`;
  const h = Qn(p);
  return h[Jue] = t, h;
}
function ice({
  layoutId: t
}) {
  const e = bl(Q$).id;
  return e && t !== void 0 ? e + "-" + t : t;
}
function ace(t, e) {
  const i = bl(U6).strict;
  if (process.env.NODE_ENV !== "production" && e && i) {
    const l = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    t.ignoreStrict ? VE(!1, l, "lazy-strict-mode") : _b(!1, l, "lazy-strict-mode");
  }
}
function oce(t) {
  const {
    drag: e,
    layout: i
  } = DE;
  if (!e && !i) return {};
  const l = {
    ...e,
    ...i
  };
  return {
    MeasureLayout: e != null && e.isEnabled(t) || i != null && i.isEnabled(t) ? l.MeasureLayout : void 0,
    ProjectionNode: l.ProjectionNode
  };
}
function sce(t, e) {
  if (typeof Proxy > "u") return Z2;
  const i = /* @__PURE__ */new Map(),
    l = (p, h) => Z2(p, h, t, e),
    c = (p, h) => (process.env.NODE_ENV !== "production" && QO(!1, "motion() is deprecated. Use motion.create() instead."), l(p, h));
  return new Proxy(c, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (p, h) => h === "create" ? l : (i.has(h) || i.set(h, Z2(h, void 0, t, e)), i.get(h))
  });
}
function t8({
  top: t,
  left: e,
  right: i,
  bottom: l
}) {
  return {
    x: {
      min: e,
      max: i
    },
    y: {
      min: t,
      max: l
    }
  };
}
function lce({
  x: t,
  y: e
}) {
  return {
    top: e.min,
    right: t.max,
    bottom: e.max,
    left: t.min
  };
}
function uce(t, e) {
  if (!e) return t;
  const i = e({
      x: t.left,
      y: t.top
    }),
    l = e({
      x: t.right,
      y: t.bottom
    });
  return {
    top: i.y,
    left: i.x,
    bottom: l.y,
    right: l.x
  };
}
function J2(t) {
  return t === void 0 || t === 1;
}
function cF({
  scale: t,
  scaleX: e,
  scaleY: i
}) {
  return !J2(t) || !J2(e) || !J2(i);
}
function Bx(t) {
  return cF(t) || n8(t) || t.z || t.rotate || t.rotateX || t.rotateY || t.skewX || t.skewY;
}
function n8(t) {
  return y3(t.x) || y3(t.y);
}
function y3(t) {
  return t && t !== "0%";
}
function MO(t, e, i) {
  const l = t - i,
    c = e * l;
  return i + c;
}
function b3(t, e, i, l, c) {
  return c !== void 0 && (t = MO(t, c, l)), MO(t, i, l) + e;
}
function dF(t, e = 0, i = 1, l, c) {
  t.min = b3(t.min, e, i, l, c), t.max = b3(t.max, e, i, l, c);
}
function r8(t, {
  x: e,
  y: i
}) {
  dF(t.x, e.translate, e.scale, e.originPoint), dF(t.y, i.translate, i.scale, i.originPoint);
}
const w3 = 0.999999999999,
  _3 = 1.0000000000001;
function cce(t, e, i, l = !1) {
  const c = i.length;
  if (!c) return;
  e.x = e.y = 1;
  let p, h;
  for (let y = 0; y < c; y++) {
    p = i[y], h = p.projectionDelta;
    const {
      visualElement: w
    } = p.options;
    w && w.props.style && w.props.style.display === "contents" || (l && p.options.layoutScroll && p.scroll && p !== p.root && dE(t, {
      x: -p.scroll.offset.x,
      y: -p.scroll.offset.y
    }), h && (e.x *= h.x.scale, e.y *= h.y.scale, r8(t, h)), l && Bx(p.latestValues) && dE(t, p.latestValues));
  }
  e.x < _3 && e.x > w3 && (e.x = 1), e.y < _3 && e.y > w3 && (e.y = 1);
}
function cE(t, e) {
  t.min = t.min + e, t.max = t.max + e;
}
function x3(t, e, i, l, c = 0.5) {
  const p = go(t.min, t.max, c);
  dF(t, e, i, p, l);
}
function dE(t, e) {
  x3(t.x, e.x, e.scaleX, e.scale, e.originX), x3(t.y, e.y, e.scaleY, e.scale, e.originY);
}
function i8(t, e) {
  return t8(uce(t.getBoundingClientRect(), e));
}
function dce(t, e, i) {
  const l = i8(t, i),
    {
      scroll: c
    } = e;
  return c && (cE(l.x, c.offset.x), cE(l.y, c.offset.y)), l;
}
const S3 = () => ({
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0
  }),
  fE = () => ({
    x: S3(),
    y: S3()
  }),
  E3 = () => ({
    min: 0,
    max: 0
  }),
  is = () => ({
    x: E3(),
    y: E3()
  }),
  OO = {
    current: null
  },
  Cz = {
    current: !1
  };
function a8() {
  if (Cz.current = !0, !!XN) if (window.matchMedia) {
    const t = window.matchMedia("(prefers-reduced-motion)"),
      e = () => OO.current = t.matches;
    t.addEventListener("change", e), e();
  } else OO.current = !1;
}
const fce = /* @__PURE__ */new WeakMap();
function pce(t, e, i) {
  for (const l in e) {
    const c = e[l],
      p = i[l];
    if (Cu(c)) t.addValue(l, c);else if (Cu(p)) t.addValue(l, RE(c, {
      owner: t
    }));else if (p !== c) if (t.hasValue(l)) {
      const h = t.getValue(l);
      h.liveStyle === !0 ? h.jump(c) : h.hasAnimated || h.set(c);
    } else {
      const h = t.getStaticValue(l);
      t.addValue(l, RE(h !== void 0 ? h : c, {
        owner: t
      }));
    }
  }
  for (const l in i) e[l] === void 0 && t.removeValue(l);
  return e;
}
const C3 = ["AnimationStart", "AnimationComplete", "Update", "BeforeLayoutMeasure", "LayoutMeasure", "LayoutAnimationStart", "LayoutAnimationComplete"];
class hce {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(e, i, l) {
    return {};
  }
  constructor({
    parent: e,
    props: i,
    presenceContext: l,
    reducedMotionConfig: c,
    blockInitialAnimation: p,
    visualState: h
  }, y = {}) {
    this.current = null, this.children = /* @__PURE__ */new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */new Map(), this.KeyframeResolver = fz, this.features = {}, this.valueSubscriptions = /* @__PURE__ */new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const k = ud.now();
      this.renderScheduledAt < k && (this.renderScheduledAt = k, Ua.render(this.render, !1, !0));
    };
    const {
      latestValues: w,
      renderState: x
    } = h;
    this.latestValues = w, this.baseTarget = {
      ...w
    }, this.initialValues = i.initial ? {
      ...w
    } : {}, this.renderState = x, this.parent = e, this.props = i, this.presenceContext = l, this.depth = e ? e.depth + 1 : 0, this.reducedMotionConfig = c, this.options = y, this.blockInitialAnimation = !!p, this.isControllingVariants = eL(i), this.isVariantNode = $6(i), this.isVariantNode && (this.variantChildren = /* @__PURE__ */new Set()), this.manuallyAnimateOnMount = !!(e && e.current);
    const {
      willChange: E,
      ...C
    } = this.scrapeMotionValuesFromProps(i, {}, this);
    for (const k in C) {
      const D = C[k];
      w[k] !== void 0 && Cu(D) && D.set(w[k]);
    }
  }
  mount(e) {
    var i;
    this.current = e, fce.set(e, this), this.projection && !this.projection.instance && this.projection.mount(e), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((l, c) => this.bindToMotionValue(c, l)), Cz.current || a8(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : OO.current, process.env.NODE_ENV !== "production" && QO(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), (i = this.parent) == null || i.addChild(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    var e;
    this.projection && this.projection.unmount(), aw(this.notifyUpdate), aw(this.render), this.valueSubscriptions.forEach(i => i()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), (e = this.parent) == null || e.removeChild(this);
    for (const i in this.events) this.events[i].clear();
    for (const i in this.features) {
      const l = this.features[i];
      l && (l.unmount(), l.isMounted = !1);
    }
    this.current = null;
  }
  addChild(e) {
    this.children.add(e), this.enteringChildren ?? (this.enteringChildren = /* @__PURE__ */new Set()), this.enteringChildren.add(e);
  }
  removeChild(e) {
    this.children.delete(e), this.enteringChildren && this.enteringChildren.delete(e);
  }
  bindToMotionValue(e, i) {
    this.valueSubscriptions.has(e) && this.valueSubscriptions.get(e)();
    const l = HE.has(e);
    l && this.onBindTransform && this.onBindTransform();
    const c = i.on("change", h => {
      this.latestValues[e] = h, this.props.onUpdate && Ua.preRender(this.notifyUpdate), l && this.projection && (this.projection.isTransformDirty = !0), this.scheduleRender();
    });
    let p;
    window.MotionCheckAppearSync && (p = window.MotionCheckAppearSync(this, e, i)), this.valueSubscriptions.set(e, () => {
      c(), p && p(), i.owner && i.stop();
    });
  }
  sortNodePosition(e) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== e.type ? 0 : this.sortInstanceNodePosition(this.current, e.current);
  }
  updateFeatures() {
    let e = "animation";
    for (e in DE) {
      const i = DE[e];
      if (!i) continue;
      const {
        isEnabled: l,
        Feature: c
      } = i;
      if (!this.features[e] && c && l(this.props) && (this.features[e] = new c(this)), this.features[e]) {
        const p = this.features[e];
        p.isMounted ? p.update() : (p.mount(), p.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : is();
  }
  getStaticValue(e) {
    return this.latestValues[e];
  }
  setStaticValue(e, i) {
    this.latestValues[e] = i;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(e, i) {
    (e.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = e, this.prevPresenceContext = this.presenceContext, this.presenceContext = i;
    for (let l = 0; l < C3.length; l++) {
      const c = C3[l];
      this.propEventSubscriptions[c] && (this.propEventSubscriptions[c](), delete this.propEventSubscriptions[c]);
      const p = "on" + c,
        h = e[p];
      h && (this.propEventSubscriptions[c] = this.on(c, h));
    }
    this.prevMotionValues = pce(this, this.scrapeMotionValuesFromProps(e, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(e) {
    return this.props.variants ? this.props.variants[e] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(e) {
    const i = this.getClosestVariantNode();
    if (i) return i.variantChildren && i.variantChildren.add(e), () => i.variantChildren.delete(e);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(e, i) {
    const l = this.values.get(e);
    i !== l && (l && this.removeValue(e), this.bindToMotionValue(e, i), this.values.set(e, i), this.latestValues[e] = i.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(e) {
    this.values.delete(e);
    const i = this.valueSubscriptions.get(e);
    i && (i(), this.valueSubscriptions.delete(e)), delete this.latestValues[e], this.removeValueFromRenderState(e, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(e) {
    return this.values.has(e);
  }
  getValue(e, i) {
    if (this.props.values && this.props.values[e]) return this.props.values[e];
    let l = this.values.get(e);
    return l === void 0 && i !== void 0 && (l = RE(i === null ? void 0 : i, {
      owner: this
    }), this.addValue(e, l)), l;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(e, i) {
    let l = this.latestValues[e] !== void 0 || !this.current ? this.latestValues[e] : this.getBaseTargetFromProps(this.props, e) ?? this.readValueFromInstance(this.current, e, this.options);
    return l != null && (typeof l == "string" && (Z$(l) || e6(l)) ? l = parseFloat(l) : !Rue(l) && ow.test(i) && (l = A6(e, i)), this.setBaseTarget(e, Cu(l) ? l.get() : l)), Cu(l) ? l.get() : l;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(e, i) {
    this.baseTarget[e] = i;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(e) {
    var p;
    const {
      initial: i
    } = this.props;
    let l;
    if (typeof i == "string" || typeof i == "object") {
      const h = xz(this.props, i, (p = this.presenceContext) == null ? void 0 : p.custom);
      h && (l = h[e]);
    }
    if (i && l !== void 0) return l;
    const c = this.getBaseTargetFromProps(this.props, e);
    return c !== void 0 && !Cu(c) ? c : this.initialValues[e] !== void 0 && l === void 0 ? void 0 : this.baseTarget[e];
  }
  on(e, i) {
    return this.events[e] || (this.events[e] = new ez()), this.events[e].add(i);
  }
  notify(e, ...i) {
    this.events[e] && this.events[e].notify(...i);
  }
  scheduleRenderMicrotask() {
    mz.render(this.render);
  }
}
class o8 extends hce {
  constructor() {
    super(...arguments), this.KeyframeResolver = mue;
  }
  sortInstanceNodePosition(e, i) {
    return e.compareDocumentPosition(i) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(e, i) {
    return e.style ? e.style[i] : void 0;
  }
  removeValueFromRenderState(e, {
    vars: i,
    style: l
  }) {
    delete i[e], delete l[e];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const {
      children: e
    } = this.props;
    Cu(e) && (this.childSubscription = e.on("change", i => {
      this.current && (this.current.textContent = `${i}`);
    }));
  }
}
function s8(t, {
  style: e,
  vars: i
}, l, c) {
  const p = t.style;
  let h;
  for (h in e) p[h] = e[h];
  c == null || c.applyProjectionStyles(p, l);
  for (h in i) p.setProperty(h, i[h]);
}
function mce(t) {
  return window.getComputedStyle(t);
}
class vce extends o8 {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = s8;
  }
  readValueFromInstance(e, i) {
    var l;
    if (HE.has(i)) return (l = this.projection) != null && l.isProjecting ? rF(i) : Lle(e, i);
    {
      const c = mce(e),
        p = (rz(i) ? c.getPropertyValue(i) : c[i]) || 0;
      return typeof p == "string" ? p.trim() : p;
    }
  }
  measureInstanceViewportBox(e, {
    transformPagePoint: i
  }) {
    return i8(e, i);
  }
  build(e, i, l) {
    bz(e, i, l.transformTemplate);
  }
  scrapeMotionValuesFromProps(e, i, l) {
    return Sz(e, i, l);
  }
}
const l8 = /* @__PURE__ */new Set(["baseFrequency", "diffuseConstant", "kernelMatrix", "kernelUnitLength", "keySplines", "keyTimes", "limitingConeAngle", "markerHeight", "markerWidth", "numOctaves", "targetX", "targetY", "surfaceScale", "specularConstant", "specularExponent", "stdDeviation", "tableValues", "viewBox", "gradientTransform", "pathLength", "startOffset", "textLength", "lengthAdjust"]);
function gce(t, e, i, l) {
  s8(t, e, void 0, l);
  for (const c in e.attrs) t.setAttribute(l8.has(c) ? c : Ez(c), e.attrs[c]);
}
class yce extends o8 {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = is;
  }
  getBaseTargetFromProps(e, i) {
    return e[i];
  }
  readValueFromInstance(e, i) {
    if (HE.has(i)) {
      const l = P6(i);
      return l && l.default || 0;
    }
    return i = l8.has(i) ? i : Ez(i), e.getAttribute(i);
  }
  scrapeMotionValuesFromProps(e, i, l) {
    return Q6(e, i, l);
  }
  build(e, i, l) {
    Y6(e, i, this.isSVGTag, l.transformTemplate, l.style);
  }
  renderInstance(e, i, l, c) {
    gce(e, i, l, c);
  }
  mount(e) {
    this.isSVGTag = X6(e.tagName), super.mount(e);
  }
}
const bce = (t, e) => _z(t) ? new yce(e) : new vce(e, {
  allowProjection: t !== Qv
});
function yE(t, e, i) {
  const l = t.getProps();
  return xz(l, e, i !== void 0 ? i : l.custom, t);
}
const fF = t => Array.isArray(t);
function wce(t, e, i) {
  t.hasValue(e) ? t.getValue(e).set(i) : t.addValue(e, RE(i));
}
function _ce(t) {
  return fF(t) ? t[t.length - 1] || 0 : t;
}
function xce(t, e) {
  const i = yE(t, e);
  let {
    transitionEnd: l = {},
    transition: c = {},
    ...p
  } = i || {};
  p = {
    ...p,
    ...l
  };
  for (const h in p) {
    const y = _ce(p[h]);
    wce(t, h, y);
  }
}
function Sce(t) {
  return !!(Cu(t) && t.add);
}
function pF(t, e) {
  const i = t.getValue("willChange");
  if (Sce(i)) return i.add(e);
  if (!i && xb.WillChange) {
    const l = new xb.WillChange("auto");
    t.addValue("willChange", l), l.add(e);
  }
}
function u8(t) {
  return t.props[Z6];
}
const Ece = t => t !== null;
function Cce(t, {
  repeat: e,
  repeatType: i = "loop"
}, l) {
  const c = t.filter(Ece),
    p = e && i !== "loop" && e % 2 === 1 ? 0 : c.length - 1;
  return c[p];
}
const kce = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
  },
  Tce = t => ({
    type: "spring",
    stiffness: 550,
    damping: t === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10
  }),
  Rce = {
    type: "keyframes",
    duration: 0.8
  },
  Dce = {
    type: "keyframes",
    ease: [0.25, 0.1, 0.35, 1],
    duration: 0.3
  },
  Ice = (t, {
    keyframes: e
  }) => e.length > 2 ? Rce : HE.has(t) ? t.startsWith("scale") ? Tce(e[1]) : kce : Dce;
function Mce({
  when: t,
  delay: e,
  delayChildren: i,
  staggerChildren: l,
  staggerDirection: c,
  repeat: p,
  repeatType: h,
  repeatDelay: y,
  from: w,
  elapsed: x,
  ...E
}) {
  return !!Object.keys(E).length;
}
const kz = (t, e, i, l = {}, c, p) => h => {
  const y = pz(l, t) || {},
    w = y.delay || l.delay || 0;
  let {
    elapsed: x = 0
  } = l;
  x = x - /* @__PURE__ */qm(w);
  const E = {
    keyframes: Array.isArray(i) ? i : [null, i],
    ease: "easeOut",
    velocity: e.getVelocity(),
    ...y,
    delay: -x,
    onUpdate: k => {
      e.set(k), y.onUpdate && y.onUpdate(k);
    },
    onComplete: () => {
      h(), y.onComplete && y.onComplete();
    },
    name: t,
    motionValue: e,
    element: p ? void 0 : c
  };
  Mce(y) || Object.assign(E, Ice(t, E)), E.duration && (E.duration = /* @__PURE__ */qm(E.duration)), E.repeatDelay && (E.repeatDelay = /* @__PURE__ */qm(E.repeatDelay)), E.from !== void 0 && (E.keyframes[0] = E.from);
  let C = !1;
  if ((E.type === !1 || E.duration === 0 && !E.repeatDelay) && (lF(E), E.delay === 0 && (C = !0)), (xb.instantAnimations || xb.skipAnimations) && (C = !0, lF(E), E.delay = 0), E.allowFlatten = !y.type && !y.ease, C && !p && e.get() !== void 0) {
    const k = Cce(E.keyframes, y);
    if (k !== void 0) {
      Ua.update(() => {
        E.onUpdate(k), E.onComplete();
      });
      return;
    }
  }
  return y.isSync ? new dz(E) : new nue(E);
};
function Oce({
  protectedKeys: t,
  needsAnimating: e
}, i) {
  const l = t.hasOwnProperty(i) && e[i] !== !0;
  return e[i] = !1, l;
}
function c8(t, e, {
  delay: i = 0,
  transitionOverride: l,
  type: c
} = {}) {
  let {
    transition: p = t.getDefaultTransition(),
    transitionEnd: h,
    ...y
  } = e;
  l && (p = l);
  const w = [],
    x = c && t.animationState && t.animationState.getState()[c];
  for (const E in y) {
    const C = t.getValue(E, t.latestValues[E] ?? null),
      k = y[E];
    if (k === void 0 || x && Oce(x, E)) continue;
    const D = {
        delay: i,
        ...pz(p || {}, E)
      },
      I = C.get();
    if (I !== void 0 && !C.isAnimating && !Array.isArray(k) && k === I && !D.velocity) continue;
    let O = !1;
    if (window.MotionHandoffAnimation) {
      const N = u8(t);
      if (N) {
        const L = window.MotionHandoffAnimation(N, E, Ua);
        L !== null && (D.startTime = L, O = !0);
      }
    }
    pF(t, E), C.start(kz(E, C, k, t.shouldReduceMotion && M6.has(E) ? {
      type: !1
    } : D, t, O));
    const P = C.animation;
    P && w.push(P);
  }
  return h && Promise.all(w).then(() => {
    Ua.update(() => {
      h && xce(t, h);
    });
  }), w;
}
function d8(t, e, i, l = 0, c = 1) {
  const p = Array.from(t).sort((x, E) => x.sortNodePosition(E)).indexOf(e),
    h = t.size,
    y = (h - 1) * l;
  return typeof i == "function" ? i(p, h) : c === 1 ? p * l : y - p * l;
}
function hF(t, e, i = {}) {
  var w;
  const l = yE(t, e, i.type === "exit" ? (w = t.presenceContext) == null ? void 0 : w.custom : void 0);
  let {
    transition: c = t.getDefaultTransition() || {}
  } = l || {};
  i.transitionOverride && (c = i.transitionOverride);
  const p = l ? () => Promise.all(c8(t, l, i)) : () => Promise.resolve(),
    h = t.variantChildren && t.variantChildren.size ? (x = 0) => {
      const {
        delayChildren: E = 0,
        staggerChildren: C,
        staggerDirection: k
      } = c;
      return Lce(t, e, x, E, C, k, i);
    } : () => Promise.resolve(),
    {
      when: y
    } = c;
  if (y) {
    const [x, E] = y === "beforeChildren" ? [p, h] : [h, p];
    return x().then(() => E());
  } else return Promise.all([p(), h(i.delay)]);
}
function Lce(t, e, i = 0, l = 0, c = 0, p = 1, h) {
  const y = [];
  for (const w of t.variantChildren) w.notify("AnimationStart", e), y.push(hF(w, e, {
    ...h,
    delay: i + (typeof l == "function" ? 0 : l) + d8(t.variantChildren, w, l, c, p)
  }).then(() => w.notify("AnimationComplete", e)));
  return Promise.all(y);
}
function Pce(t, e, i = {}) {
  t.notify("AnimationStart", e);
  let l;
  if (Array.isArray(e)) {
    const c = e.map(p => hF(t, p, i));
    l = Promise.all(c);
  } else if (typeof e == "string") l = hF(t, e, i);else {
    const c = typeof e == "function" ? yE(t, e, i.custom) : e;
    l = Promise.all(c8(t, c, i));
  }
  return l.then(() => {
    t.notify("AnimationComplete", e);
  });
}
function f8(t, e) {
  if (!Array.isArray(e)) return !1;
  const i = e.length;
  if (i !== t.length) return !1;
  for (let l = 0; l < i; l++) if (e[l] !== t[l]) return !1;
  return !0;
}
const Ace = yz.length;
function p8(t) {
  if (!t) return;
  if (!t.isControllingVariants) {
    const i = t.parent ? p8(t.parent) || {} : {};
    return t.props.initial !== void 0 && (i.initial = t.props.initial), i;
  }
  const e = {};
  for (let i = 0; i < Ace; i++) {
    const l = yz[i],
      c = t.props[l];
    (xR(c) || c === !1) && (e[l] = c);
  }
  return e;
}
const jce = [...gz].reverse(),
  Fce = gz.length;
function Nce(t) {
  return e => Promise.all(e.map(({
    animation: i,
    options: l
  }) => Pce(t, i, l)));
}
function zce(t) {
  let e = Nce(t),
    i = k3(),
    l = !0;
  const c = w => (x, E) => {
    var k;
    const C = yE(t, E, w === "exit" ? (k = t.presenceContext) == null ? void 0 : k.custom : void 0);
    if (C) {
      const {
        transition: D,
        transitionEnd: I,
        ...O
      } = C;
      x = {
        ...x,
        ...O,
        ...I
      };
    }
    return x;
  };
  function p(w) {
    e = w(t);
  }
  function h(w) {
    const {
        props: x
      } = t,
      E = p8(t.parent) || {},
      C = [],
      k = /* @__PURE__ */new Set();
    let D = {},
      I = 1 / 0;
    for (let P = 0; P < Fce; P++) {
      const N = jce[P],
        L = i[N],
        F = x[N] !== void 0 ? x[N] : E[N],
        j = xR(F),
        V = N === w ? L.isActive : null;
      V === !1 && (I = P);
      let K = F === E[N] && F !== x[N] && j;
      if (K && l && t.manuallyAnimateOnMount && (K = !1), L.protectedKeys = {
        ...D
      },
      // If it isn't active and hasn't *just* been set as inactive
      !L.isActive && V === null ||
      // If we didn't and don't have any defined prop for this animation type
      !F && !L.prevProp ||
      // Or if the prop doesn't define an animation
      JO(F) || typeof F == "boolean") continue;
      const G = Vce(L.prevProp, F);
      let Q = G ||
        // If we're making this variant active, we want to always make it active
        N === w && L.isActive && !K && j ||
        // If we removed a higher-priority variant (i is in reverse order)
        P > I && j,
        te = !1;
      const ie = Array.isArray(F) ? F : [F];
      let Y = ie.reduce(c(N), {});
      V === !1 && (Y = {});
      const {
          prevResolvedValues: ee = {}
        } = L,
        oe = {
          ...ee,
          ...Y
        },
        ne = W => {
          Q = !0, k.has(W) && (te = !0, k.delete(W)), L.needsAnimating[W] = !0;
          const $ = t.getValue(W);
          $ && ($.liveStyle = !1);
        };
      for (const W in oe) {
        const $ = Y[W],
          le = ee[W];
        if (D.hasOwnProperty(W)) continue;
        let H = !1;
        fF($) && fF(le) ? H = !f8($, le) : H = $ !== le, H ? $ != null ? ne(W) : k.add(W) : $ !== void 0 && k.has(W) ? ne(W) : L.protectedKeys[W] = !0;
      }
      L.prevProp = F, L.prevResolvedValues = Y, L.isActive && (D = {
        ...D,
        ...Y
      }), l && t.blockInitialAnimation && (Q = !1);
      const se = K && G;
      Q && (!se || te) && C.push(...ie.map(W => {
        const $ = {
          type: N
        };
        if (typeof W == "string" && l && !se && t.manuallyAnimateOnMount && t.parent) {
          const {
              parent: le
            } = t,
            H = yE(le, W);
          if (le.enteringChildren && H) {
            const {
              delayChildren: ce
            } = H.transition || {};
            $.delay = d8(le.enteringChildren, t, ce);
          }
        }
        return {
          animation: W,
          options: $
        };
      }));
    }
    if (k.size) {
      const P = {};
      if (typeof x.initial != "boolean") {
        const N = yE(t, Array.isArray(x.initial) ? x.initial[0] : x.initial);
        N && N.transition && (P.transition = N.transition);
      }
      k.forEach(N => {
        const L = t.getBaseTarget(N),
          F = t.getValue(N);
        F && (F.liveStyle = !0), P[N] = L ?? null;
      }), C.push({
        animation: P
      });
    }
    let O = !!C.length;
    return l && (x.initial === !1 || x.initial === x.animate) && !t.manuallyAnimateOnMount && (O = !1), l = !1, O ? e(C) : Promise.resolve();
  }
  function y(w, x) {
    var C;
    if (i[w].isActive === x) return Promise.resolve();
    (C = t.variantChildren) == null || C.forEach(k => {
      var D;
      return (D = k.animationState) == null ? void 0 : D.setActive(w, x);
    }), i[w].isActive = x;
    const E = h(w);
    for (const k in i) i[k].protectedKeys = {};
    return E;
  }
  return {
    animateChanges: h,
    setActive: y,
    setAnimateFunction: p,
    getState: () => i,
    reset: () => {
      i = k3(), l = !0;
    }
  };
}
function Vce(t, e) {
  return typeof e == "string" ? e !== t : Array.isArray(e) ? !f8(e, t) : !1;
}
function Lx(t = !1) {
  return {
    isActive: t,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function k3() {
  return {
    animate: Lx(!0),
    whileInView: Lx(),
    whileHover: Lx(),
    whileTap: Lx(),
    whileDrag: Lx(),
    whileFocus: Lx(),
    exit: Lx()
  };
}
class lw {
  constructor(e) {
    this.isMounted = !1, this.node = e;
  }
  update() {}
}
class Bce extends lw {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(e) {
    super(e), e.animationState || (e.animationState = zce(e));
  }
  updateAnimationControlsSubscription() {
    const {
      animate: e
    } = this.node.getProps();
    JO(e) && (this.unmountControls = e.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const {
        animate: e
      } = this.node.getProps(),
      {
        animate: i
      } = this.node.prevProps || {};
    e !== i && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var e;
    this.node.animationState.reset(), (e = this.unmountControls) == null || e.call(this);
  }
}
let Uce = 0;
class Hce extends lw {
  constructor() {
    super(...arguments), this.id = Uce++;
  }
  update() {
    if (!this.node.presenceContext) return;
    const {
        isPresent: e,
        onExitComplete: i
      } = this.node.presenceContext,
      {
        isPresent: l
      } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || e === l) return;
    const c = this.node.animationState.setActive("exit", !e);
    i && !e && c.then(() => {
      i(this.id);
    });
  }
  mount() {
    const {
      register: e,
      onExitComplete: i
    } = this.node.presenceContext || {};
    i && i(this.id), e && (this.unmount = e(this.id));
  }
  unmount() {}
}
const $ce = {
  animation: {
    Feature: Bce
  },
  exit: {
    Feature: Hce
  }
};
function ER(t, e, i, l = {
  passive: !0
}) {
  return t.addEventListener(e, i, l), () => t.removeEventListener(e, i);
}
function YR(t) {
  return {
    point: {
      x: t.pageX,
      y: t.pageY
    }
  };
}
const Wce = t => e => vz(e) && t(e, YR(e));
function GT(t, e, i, l) {
  return ER(t, e, Wce(i), l);
}
const h8 = 1e-4,
  qce = 1 - h8,
  Yce = 1 + h8,
  m8 = 0.01,
  Gce = 0 - m8,
  Xce = 0 + m8;
function Mc(t) {
  return t.max - t.min;
}
function Kce(t, e, i) {
  return Math.abs(t - e) <= i;
}
function T3(t, e, i, l = 0.5) {
  t.origin = l, t.originPoint = go(e.min, e.max, t.origin), t.scale = Mc(i) / Mc(e), t.translate = go(i.min, i.max, t.origin) - t.originPoint, (t.scale >= qce && t.scale <= Yce || isNaN(t.scale)) && (t.scale = 1), (t.translate >= Gce && t.translate <= Xce || isNaN(t.translate)) && (t.translate = 0);
}
function XT(t, e, i, l) {
  T3(t.x, e.x, i.x, l ? l.originX : void 0), T3(t.y, e.y, i.y, l ? l.originY : void 0);
}
function R3(t, e, i) {
  t.min = i.min + e.min, t.max = t.min + Mc(e);
}
function Qce(t, e, i) {
  R3(t.x, e.x, i.x), R3(t.y, e.y, i.y);
}
function D3(t, e, i) {
  t.min = e.min - i.min, t.max = t.min + Mc(e);
}
function KT(t, e, i) {
  D3(t.x, e.x, i.x), D3(t.y, e.y, i.y);
}
function Lp(t) {
  return [t("x"), t("y")];
}
const v8 = ({
    current: t
  }) => t ? t.ownerDocument.defaultView : null,
  I3 = (t, e) => Math.abs(t - e);
function Zce(t, e) {
  const i = I3(t.x, e.x),
    l = I3(t.y, e.y);
  return Math.sqrt(i ** 2 + l ** 2);
}
class g8 {
  constructor(e, i, {
    transformPagePoint: l,
    contextWindow: c = window,
    dragSnapToOrigin: p = !1,
    distanceThreshold: h = 3
  } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
      const k = tj(this.lastMoveEventInfo, this.history),
        D = this.startEvent !== null,
        I = Zce(k.offset, {
          x: 0,
          y: 0
        }) >= this.distanceThreshold;
      if (!D && !I) return;
      const {
          point: O
        } = k,
        {
          timestamp: P
        } = lu;
      this.history.push({
        ...O,
        timestamp: P
      });
      const {
        onStart: N,
        onMove: L
      } = this.handlers;
      D || (N && N(this.lastMoveEvent, k), this.startEvent = this.lastMoveEvent), L && L(this.lastMoveEvent, k);
    }, this.handlePointerMove = (k, D) => {
      this.lastMoveEvent = k, this.lastMoveEventInfo = ej(D, this.transformPagePoint), Ua.update(this.updatePoint, !0);
    }, this.handlePointerUp = (k, D) => {
      this.end();
      const {
        onEnd: I,
        onSessionEnd: O,
        resumeAnimation: P
      } = this.handlers;
      if (this.dragSnapToOrigin && P && P(), !(this.lastMoveEvent && this.lastMoveEventInfo)) return;
      const N = tj(k.type === "pointercancel" ? this.lastMoveEventInfo : ej(D, this.transformPagePoint), this.history);
      this.startEvent && I && I(k, N), O && O(k, N);
    }, !vz(e)) return;
    this.dragSnapToOrigin = p, this.handlers = i, this.transformPagePoint = l, this.distanceThreshold = h, this.contextWindow = c || window;
    const y = YR(e),
      w = ej(y, this.transformPagePoint),
      {
        point: x
      } = w,
      {
        timestamp: E
      } = lu;
    this.history = [{
      ...x,
      timestamp: E
    }];
    const {
      onSessionStart: C
    } = i;
    C && C(e, tj(w, this.history)), this.removeListeners = $R(GT(this.contextWindow, "pointermove", this.handlePointerMove), GT(this.contextWindow, "pointerup", this.handlePointerUp), GT(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(e) {
    this.handlers = e;
  }
  end() {
    this.removeListeners && this.removeListeners(), aw(this.updatePoint);
  }
}
function ej(t, e) {
  return e ? {
    point: e(t.point)
  } : t;
}
function M3(t, e) {
  return {
    x: t.x - e.x,
    y: t.y - e.y
  };
}
function tj({
  point: t
}, e) {
  return {
    point: t,
    delta: M3(t, y8(e)),
    offset: M3(t, Jce(e)),
    velocity: ede(e, 0.1)
  };
}
function Jce(t) {
  return t[0];
}
function y8(t) {
  return t[t.length - 1];
}
function ede(t, e) {
  if (t.length < 2) return {
    x: 0,
    y: 0
  };
  let i = t.length - 1,
    l = null;
  const c = y8(t);
  for (; i >= 0 && (l = t[i], !(c.timestamp - l.timestamp > /* @__PURE__ */qm(e)));) i--;
  if (!l) return {
    x: 0,
    y: 0
  };
  const p = /* @__PURE__ */Xv(c.timestamp - l.timestamp);
  if (p === 0) return {
    x: 0,
    y: 0
  };
  const h = {
    x: (c.x - l.x) / p,
    y: (c.y - l.y) / p
  };
  return h.x === 1 / 0 && (h.x = 0), h.y === 1 / 0 && (h.y = 0), h;
}
function tde(t, {
  min: e,
  max: i
}, l) {
  return e !== void 0 && t < e ? t = l ? go(e, t, l.min) : Math.max(t, e) : i !== void 0 && t > i && (t = l ? go(i, t, l.max) : Math.min(t, i)), t;
}
function O3(t, e, i) {
  return {
    min: e !== void 0 ? t.min + e : void 0,
    max: i !== void 0 ? t.max + i - (t.max - t.min) : void 0
  };
}
function nde(t, {
  top: e,
  left: i,
  bottom: l,
  right: c
}) {
  return {
    x: O3(t.x, i, c),
    y: O3(t.y, e, l)
  };
}
function L3(t, e) {
  let i = e.min - t.min,
    l = e.max - t.max;
  return e.max - e.min < t.max - t.min && ([i, l] = [l, i]), {
    min: i,
    max: l
  };
}
function rde(t, e) {
  return {
    x: L3(t.x, e.x),
    y: L3(t.y, e.y)
  };
}
function ide(t, e) {
  let i = 0.5;
  const l = Mc(t),
    c = Mc(e);
  return c > l ? i = /* @__PURE__ */bR(e.min, e.max - l, t.min) : l > c && (i = /* @__PURE__ */bR(t.min, t.max - c, e.min)), wb(0, 1, i);
}
function ade(t, e) {
  const i = {};
  return e.min !== void 0 && (i.min = e.min - t.min), e.max !== void 0 && (i.max = e.max - t.min), i;
}
const mF = 0.35;
function ode(t = mF) {
  return t === !1 ? t = 0 : t === !0 && (t = mF), {
    x: P3(t, "left", "right"),
    y: P3(t, "top", "bottom")
  };
}
function P3(t, e, i) {
  return {
    min: A3(t, e),
    max: A3(t, i)
  };
}
function A3(t, e) {
  return typeof t == "number" ? t : t[e] || 0;
}
const sde = /* @__PURE__ */new WeakMap();
class lde {
  constructor(e) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = {
      x: 0,
      y: 0
    }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = is(), this.latestPointerEvent = null, this.latestPanInfo = null, this.visualElement = e;
  }
  start(e, {
    snapToCursor: i = !1,
    distanceThreshold: l
  } = {}) {
    const {
      presenceContext: c
    } = this.visualElement;
    if (c && c.isPresent === !1) return;
    const p = C => {
        const {
          dragSnapToOrigin: k
        } = this.getProps();
        k ? this.pauseAnimation() : this.stopAnimation(), i && this.snapToCursor(YR(C).point);
      },
      h = (C, k) => {
        const {
          drag: D,
          dragPropagation: I,
          onDragStart: O
        } = this.getProps();
        if (D && !I && (this.openDragLock && this.openDragLock(), this.openDragLock = wue(D), !this.openDragLock)) return;
        this.latestPointerEvent = C, this.latestPanInfo = k, this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), Lp(N => {
          let L = this.getAxisMotionValue(N).get() || 0;
          if (Kv.test(L)) {
            const {
              projection: F
            } = this.visualElement;
            if (F && F.layout) {
              const j = F.layout.layoutBox[N];
              j && (L = Mc(j) * (parseFloat(L) / 100));
            }
          }
          this.originPoint[N] = L;
        }), O && Ua.postRender(() => O(C, k)), pF(this.visualElement, "transform");
        const {
          animationState: P
        } = this.visualElement;
        P && P.setActive("whileDrag", !0);
      },
      y = (C, k) => {
        this.latestPointerEvent = C, this.latestPanInfo = k;
        const {
          dragPropagation: D,
          dragDirectionLock: I,
          onDirectionLock: O,
          onDrag: P
        } = this.getProps();
        if (!D && !this.openDragLock) return;
        const {
          offset: N
        } = k;
        if (I && this.currentDirection === null) {
          this.currentDirection = ude(N), this.currentDirection !== null && O && O(this.currentDirection);
          return;
        }
        this.updateAxis("x", k.point, N), this.updateAxis("y", k.point, N), this.visualElement.render(), P && P(C, k);
      },
      w = (C, k) => {
        this.latestPointerEvent = C, this.latestPanInfo = k, this.stop(C, k), this.latestPointerEvent = null, this.latestPanInfo = null;
      },
      x = () => Lp(C => {
        var k;
        return this.getAnimationState(C) === "paused" && ((k = this.getAxisMotionValue(C).animation) == null ? void 0 : k.play());
      }),
      {
        dragSnapToOrigin: E
      } = this.getProps();
    this.panSession = new g8(e, {
      onSessionStart: p,
      onStart: h,
      onMove: y,
      onSessionEnd: w,
      resumeAnimation: x
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: E,
      distanceThreshold: l,
      contextWindow: v8(this.visualElement)
    });
  }
  /**
   * @internal
   */
  stop(e, i) {
    const l = e || this.latestPointerEvent,
      c = i || this.latestPanInfo,
      p = this.isDragging;
    if (this.cancel(), !p || !c || !l) return;
    const {
      velocity: h
    } = c;
    this.startAnimation(h);
    const {
      onDragEnd: y
    } = this.getProps();
    y && Ua.postRender(() => y(l, c));
  }
  /**
   * @internal
   */
  cancel() {
    this.isDragging = !1;
    const {
      projection: e,
      animationState: i
    } = this.visualElement;
    e && (e.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const {
      dragPropagation: l
    } = this.getProps();
    !l && this.openDragLock && (this.openDragLock(), this.openDragLock = null), i && i.setActive("whileDrag", !1);
  }
  updateAxis(e, i, l) {
    const {
      drag: c
    } = this.getProps();
    if (!l || !CM(e, c, this.currentDirection)) return;
    const p = this.getAxisMotionValue(e);
    let h = this.originPoint[e] + l[e];
    this.constraints && this.constraints[e] && (h = tde(h, this.constraints[e], this.elastic[e])), p.set(h);
  }
  resolveConstraints() {
    var p;
    const {
        dragConstraints: e,
        dragElastic: i
      } = this.getProps(),
      l = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (p = this.visualElement.projection) == null ? void 0 : p.layout,
      c = this.constraints;
    e && uE(e) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : e && l ? this.constraints = nde(l.layoutBox, e) : this.constraints = !1, this.elastic = ode(i), c !== this.constraints && l && this.constraints && !this.hasMutatedConstraints && Lp(h => {
      this.constraints !== !1 && this.getAxisMotionValue(h) && (this.constraints[h] = ade(l.layoutBox[h], this.constraints[h]));
    });
  }
  resolveRefConstraints() {
    const {
      dragConstraints: e,
      onMeasureDragConstraints: i
    } = this.getProps();
    if (!e || !uE(e)) return !1;
    const l = e.current;
    _b(l !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
    const {
      projection: c
    } = this.visualElement;
    if (!c || !c.layout) return !1;
    const p = dce(l, c.root, this.visualElement.getTransformPagePoint());
    let h = rde(c.layout.layoutBox, p);
    if (i) {
      const y = i(lce(h));
      this.hasMutatedConstraints = !!y, y && (h = t8(y));
    }
    return h;
  }
  startAnimation(e) {
    const {
        drag: i,
        dragMomentum: l,
        dragElastic: c,
        dragTransition: p,
        dragSnapToOrigin: h,
        onDragTransitionEnd: y
      } = this.getProps(),
      w = this.constraints || {},
      x = Lp(E => {
        if (!CM(E, i, this.currentDirection)) return;
        let C = w && w[E] || {};
        h && (C = {
          min: 0,
          max: 0
        });
        const k = c ? 200 : 1e6,
          D = c ? 40 : 1e7,
          I = {
            type: "inertia",
            velocity: l ? e[E] : 0,
            bounceStiffness: k,
            bounceDamping: D,
            timeConstant: 750,
            restDelta: 1,
            restSpeed: 10,
            ...p,
            ...C
          };
        return this.startAxisValueAnimation(E, I);
      });
    return Promise.all(x).then(y);
  }
  startAxisValueAnimation(e, i) {
    const l = this.getAxisMotionValue(e);
    return pF(this.visualElement, e), l.start(kz(e, l, 0, i, this.visualElement, !1));
  }
  stopAnimation() {
    Lp(e => this.getAxisMotionValue(e).stop());
  }
  pauseAnimation() {
    Lp(e => {
      var i;
      return (i = this.getAxisMotionValue(e).animation) == null ? void 0 : i.pause();
    });
  }
  getAnimationState(e) {
    var i;
    return (i = this.getAxisMotionValue(e).animation) == null ? void 0 : i.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(e) {
    const i = `_drag${e.toUpperCase()}`,
      l = this.visualElement.getProps(),
      c = l[i];
    return c || this.visualElement.getValue(e, (l.initial ? l.initial[e] : void 0) || 0);
  }
  snapToCursor(e) {
    Lp(i => {
      const {
        drag: l
      } = this.getProps();
      if (!CM(i, l, this.currentDirection)) return;
      const {
          projection: c
        } = this.visualElement,
        p = this.getAxisMotionValue(i);
      if (c && c.layout) {
        const {
          min: h,
          max: y
        } = c.layout.layoutBox[i];
        p.set(e[i] - go(h, y, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current) return;
    const {
        drag: e,
        dragConstraints: i
      } = this.getProps(),
      {
        projection: l
      } = this.visualElement;
    if (!uE(i) || !l || !this.constraints) return;
    this.stopAnimation();
    const c = {
      x: 0,
      y: 0
    };
    Lp(h => {
      const y = this.getAxisMotionValue(h);
      if (y && this.constraints !== !1) {
        const w = y.get();
        c[h] = ide({
          min: w,
          max: w
        }, this.constraints[h]);
      }
    });
    const {
      transformTemplate: p
    } = this.visualElement.getProps();
    this.visualElement.current.style.transform = p ? p({}, "") : "none", l.root && l.root.updateScroll(), l.updateLayout(), this.resolveConstraints(), Lp(h => {
      if (!CM(h, e, null)) return;
      const y = this.getAxisMotionValue(h),
        {
          min: w,
          max: x
        } = this.constraints[h];
      y.set(go(w, x, c[h]));
    });
  }
  addListeners() {
    if (!this.visualElement.current) return;
    sde.set(this.visualElement, this);
    const e = this.visualElement.current,
      i = GT(e, "pointerdown", w => {
        const {
          drag: x,
          dragListener: E = !0
        } = this.getProps();
        x && E && this.start(w);
      }),
      l = () => {
        const {
          dragConstraints: w
        } = this.getProps();
        uE(w) && w.current && (this.constraints = this.resolveRefConstraints());
      },
      {
        projection: c
      } = this.visualElement,
      p = c.addEventListener("measure", l);
    c && !c.layout && (c.root && c.root.updateScroll(), c.updateLayout()), Ua.read(l);
    const h = ER(window, "resize", () => this.scalePositionWithinConstraints()),
      y = c.addEventListener("didUpdate", ({
        delta: w,
        hasLayoutChanged: x
      }) => {
        this.isDragging && x && (Lp(E => {
          const C = this.getAxisMotionValue(E);
          C && (this.originPoint[E] += w[E].translate, C.set(C.get() + w[E].translate));
        }), this.visualElement.render());
      });
    return () => {
      h(), i(), p(), y && y();
    };
  }
  getProps() {
    const e = this.visualElement.getProps(),
      {
        drag: i = !1,
        dragDirectionLock: l = !1,
        dragPropagation: c = !1,
        dragConstraints: p = !1,
        dragElastic: h = mF,
        dragMomentum: y = !0
      } = e;
    return {
      ...e,
      drag: i,
      dragDirectionLock: l,
      dragPropagation: c,
      dragConstraints: p,
      dragElastic: h,
      dragMomentum: y
    };
  }
}
function CM(t, e, i) {
  return (e === !0 || e === t) && (i === null || i === t);
}
function ude(t, e = 10) {
  let i = null;
  return Math.abs(t.y) > e ? i = "y" : Math.abs(t.x) > e && (i = "x"), i;
}
class cde extends lw {
  constructor(e) {
    super(e), this.removeGroupControls = Bp, this.removeListeners = Bp, this.controls = new lde(e);
  }
  mount() {
    const {
      dragControls: e
    } = this.node.getProps();
    e && (this.removeGroupControls = e.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Bp;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const j3 = t => (e, i) => {
  t && Ua.postRender(() => t(e, i));
};
class dde extends lw {
  constructor() {
    super(...arguments), this.removePointerDownListener = Bp;
  }
  onPointerDown(e) {
    this.session = new g8(e, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: v8(this.node)
    });
  }
  createPanHandlers() {
    const {
      onPanSessionStart: e,
      onPanStart: i,
      onPan: l,
      onPanEnd: c
    } = this.node.getProps();
    return {
      onSessionStart: j3(e),
      onStart: j3(i),
      onMove: l,
      onEnd: (p, h) => {
        delete this.session, c && Ua.postRender(() => c(p, h));
      }
    };
  }
  mount() {
    this.removePointerDownListener = GT(this.node.current, "pointerdown", e => this.onPointerDown(e));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const KM = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function F3(t, e) {
  return e.max === e.min ? 0 : t / (e.max - e.min) * 100;
}
const ET = {
    correct: (t, e) => {
      if (!e.target) return t;
      if (typeof t == "string") if (Yn.test(t)) t = parseFloat(t);else return t;
      const i = F3(t, e.target.x),
        l = F3(t, e.target.y);
      return `${i}% ${l}%`;
    }
  },
  fde = {
    correct: (t, {
      treeScale: e,
      projectionDelta: i
    }) => {
      const l = t,
        c = ow.parse(t);
      if (c.length > 5) return l;
      const p = ow.createTransformer(t),
        h = typeof c[0] != "number" ? 1 : 0,
        y = i.x.scale * e.x,
        w = i.y.scale * e.y;
      c[0 + h] /= y, c[1 + h] /= w;
      const x = go(y, w, 0.5);
      return typeof c[2 + h] == "number" && (c[2 + h] /= x), typeof c[3 + h] == "number" && (c[3 + h] /= x), p(c);
    }
  };
let nj = !1;
class pde extends oH {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const {
        visualElement: e,
        layoutGroup: i,
        switchLayoutGroup: l,
        layoutId: c
      } = this.props,
      {
        projection: p
      } = e;
    jue(hde), p && (i.group && i.group.add(p), l && l.register && c && l.register(p), nj && p.root.didUpdate(), p.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), p.setOptions({
      ...p.options,
      onExitComplete: () => this.safeToRemove()
    })), KM.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(e) {
    const {
        layoutDependency: i,
        visualElement: l,
        drag: c,
        isPresent: p
      } = this.props,
      {
        projection: h
      } = l;
    return h && (h.isPresent = p, nj = !0, c || e.layoutDependency !== i || i === void 0 || e.isPresent !== p ? h.willUpdate() : this.safeToRemove(), e.isPresent !== p && (p ? h.promote() : h.relegate() || Ua.postRender(() => {
      const y = h.getStack();
      (!y || !y.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const {
      projection: e
    } = this.props.visualElement;
    e && (e.root.didUpdate(), mz.postRender(() => {
      !e.currentAnimation && e.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const {
        visualElement: e,
        layoutGroup: i,
        switchLayoutGroup: l
      } = this.props,
      {
        projection: c
      } = e;
    nj = !0, c && (c.scheduleCheckAfterUnmount(), i && i.group && i.group.remove(c), l && l.deregister && l.deregister(c));
  }
  safeToRemove() {
    const {
      safeToRemove: e
    } = this.props;
    e && e();
  }
  render() {
    return null;
  }
}
function b8(t) {
  const [e, i] = Due(),
    l = bl(Q$);
  return B.jsx(pde, {
    ...t,
    layoutGroup: l,
    switchLayoutGroup: bl(J6),
    isPresent: e,
    safeToRemove: i
  });
}
const hde = {
  borderRadius: {
    ...ET,
    applyTo: ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomLeftRadius", "borderBottomRightRadius"]
  },
  borderTopLeftRadius: ET,
  borderTopRightRadius: ET,
  borderBottomLeftRadius: ET,
  borderBottomRightRadius: ET,
  boxShadow: fde
};
function mde(t, e, i) {
  const l = Cu(t) ? t : RE(t);
  return l.start(kz("", l, e, i)), l.animation;
}
const vde = (t, e) => t.depth - e.depth;
class gde {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(e) {
    QN(this.children, e), this.isDirty = !0;
  }
  remove(e) {
    ZN(this.children, e), this.isDirty = !0;
  }
  forEach(e) {
    this.isDirty && this.children.sort(vde), this.isDirty = !1, this.children.forEach(e);
  }
}
function yde(t, e) {
  const i = ud.now(),
    l = ({
      timestamp: c
    }) => {
      const p = c - i;
      p >= e && (aw(l), t(p - e));
    };
  return Ua.setup(l, !0), () => aw(l);
}
const w8 = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"],
  bde = w8.length,
  N3 = t => typeof t == "string" ? parseFloat(t) : t,
  z3 = t => typeof t == "number" || Yn.test(t);
function wde(t, e, i, l, c, p) {
  c ? (t.opacity = go(0, i.opacity ?? 1, _de(l)), t.opacityExit = go(e.opacity ?? 1, 0, xde(l))) : p && (t.opacity = go(e.opacity ?? 1, i.opacity ?? 1, l));
  for (let h = 0; h < bde; h++) {
    const y = `border${w8[h]}Radius`;
    let w = V3(e, y),
      x = V3(i, y);
    if (w === void 0 && x === void 0) continue;
    w || (w = 0), x || (x = 0), w === 0 || x === 0 || z3(w) === z3(x) ? (t[y] = Math.max(go(N3(w), N3(x), l), 0), (Kv.test(x) || Kv.test(w)) && (t[y] += "%")) : t[y] = x;
  }
  (e.rotate || i.rotate) && (t.rotate = go(e.rotate || 0, i.rotate || 0, l));
}
function V3(t, e) {
  return t[e] !== void 0 ? t[e] : t.borderRadius;
}
const _de = /* @__PURE__ */_8(0, 0.5, l6),
  xde = /* @__PURE__ */_8(0.5, 0.95, Bp);
function _8(t, e, i) {
  return l => l < t ? 0 : l > e ? 1 : i(/* @__PURE__ */bR(t, e, l));
}
function B3(t, e) {
  t.min = e.min, t.max = e.max;
}
function Ip(t, e) {
  B3(t.x, e.x), B3(t.y, e.y);
}
function U3(t, e) {
  t.translate = e.translate, t.scale = e.scale, t.originPoint = e.originPoint, t.origin = e.origin;
}
function H3(t, e, i, l, c) {
  return t -= e, t = MO(t, 1 / i, l), c !== void 0 && (t = MO(t, 1 / c, l)), t;
}
function Sde(t, e = 0, i = 1, l = 0.5, c, p = t, h = t) {
  if (Kv.test(e) && (e = parseFloat(e), e = go(h.min, h.max, e / 100) - h.min), typeof e != "number") return;
  let y = go(p.min, p.max, l);
  t === p && (y -= e), t.min = H3(t.min, e, i, y, c), t.max = H3(t.max, e, i, y, c);
}
function $3(t, e, [i, l, c], p, h) {
  Sde(t, e[i], e[l], e[c], e.scale, p, h);
}
const Ede = ["x", "scaleX", "originX"],
  Cde = ["y", "scaleY", "originY"];
function W3(t, e, i, l) {
  $3(t.x, e, Ede, i ? i.x : void 0, l ? l.x : void 0), $3(t.y, e, Cde, i ? i.y : void 0, l ? l.y : void 0);
}
function q3(t) {
  return t.translate === 0 && t.scale === 1;
}
function x8(t) {
  return q3(t.x) && q3(t.y);
}
function Y3(t, e) {
  return t.min === e.min && t.max === e.max;
}
function kde(t, e) {
  return Y3(t.x, e.x) && Y3(t.y, e.y);
}
function G3(t, e) {
  return Math.round(t.min) === Math.round(e.min) && Math.round(t.max) === Math.round(e.max);
}
function S8(t, e) {
  return G3(t.x, e.x) && G3(t.y, e.y);
}
function X3(t) {
  return Mc(t.x) / Mc(t.y);
}
function K3(t, e) {
  return t.translate === e.translate && t.scale === e.scale && t.originPoint === e.originPoint;
}
class Tde {
  constructor() {
    this.members = [];
  }
  add(e) {
    QN(this.members, e), e.scheduleRender();
  }
  remove(e) {
    if (ZN(this.members, e), e === this.prevLead && (this.prevLead = void 0), e === this.lead) {
      const i = this.members[this.members.length - 1];
      i && this.promote(i);
    }
  }
  relegate(e) {
    const i = this.members.findIndex(c => e === c);
    if (i === 0) return !1;
    let l;
    for (let c = i; c >= 0; c--) {
      const p = this.members[c];
      if (p.isPresent !== !1) {
        l = p;
        break;
      }
    }
    return l ? (this.promote(l), !0) : !1;
  }
  promote(e, i) {
    const l = this.lead;
    if (e !== l && (this.prevLead = l, this.lead = e, e.show(), l)) {
      l.instance && l.scheduleRender(), e.scheduleRender(), e.resumeFrom = l, i && (e.resumeFrom.preserveOpacity = !0), l.snapshot && (e.snapshot = l.snapshot, e.snapshot.latestValues = l.animationValues || l.latestValues), e.root && e.root.isUpdating && (e.isLayoutDirty = !0);
      const {
        crossfade: c
      } = e.options;
      c === !1 && l.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach(e => {
      const {
        options: i,
        resumingFrom: l
      } = e;
      i.onExitComplete && i.onExitComplete(), l && l.options.onExitComplete && l.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach(e => {
      e.instance && e.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function Rde(t, e, i) {
  let l = "";
  const c = t.x.translate / e.x,
    p = t.y.translate / e.y,
    h = (i == null ? void 0 : i.z) || 0;
  if ((c || p || h) && (l = `translate3d(${c}px, ${p}px, ${h}px) `), (e.x !== 1 || e.y !== 1) && (l += `scale(${1 / e.x}, ${1 / e.y}) `), i) {
    const {
      transformPerspective: x,
      rotate: E,
      rotateX: C,
      rotateY: k,
      skewX: D,
      skewY: I
    } = i;
    x && (l = `perspective(${x}px) ${l}`), E && (l += `rotate(${E}deg) `), C && (l += `rotateX(${C}deg) `), k && (l += `rotateY(${k}deg) `), D && (l += `skewX(${D}deg) `), I && (l += `skewY(${I}deg) `);
  }
  const y = t.x.scale * e.x,
    w = t.y.scale * e.y;
  return (y !== 1 || w !== 1) && (l += `scale(${y}, ${w})`), l || "none";
}
const rj = ["", "X", "Y", "Z"],
  Dde = 1e3;
let Ide = 0;
function ij(t, e, i, l) {
  const {
    latestValues: c
  } = e;
  c[t] && (i[t] = c[t], e.setStaticValue(t, 0), l && (l[t] = 0));
}
function E8(t) {
  if (t.hasCheckedOptimisedAppear = !0, t.root === t) return;
  const {
    visualElement: e
  } = t.options;
  if (!e) return;
  const i = u8(e);
  if (window.MotionHasOptimisedAnimation(i, "transform")) {
    const {
      layout: c,
      layoutId: p
    } = t.options;
    window.MotionCancelOptimisedAnimation(i, "transform", Ua, !(c || p));
  }
  const {
    parent: l
  } = t;
  l && !l.hasCheckedOptimisedAppear && E8(l);
}
function C8({
  attachResizeListener: t,
  defaultParent: e,
  measureScroll: i,
  checkIsScrollRoot: l,
  resetTransform: c
}) {
  return class {
    constructor(h = {}, y = e == null ? void 0 : e()) {
      this.id = Ide++, this.animationId = 0, this.animationCommitId = 0, this.children = /* @__PURE__ */new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = {
        x: 1,
        y: 1
      }, this.eventHandlers = /* @__PURE__ */new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(Lde), this.nodes.forEach(Fde), this.nodes.forEach(Nde), this.nodes.forEach(Pde);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */new Map(), this.latestValues = h, this.root = y ? y.root || y : this, this.path = y ? [...y.path, y] : [], this.parent = y, this.depth = y ? y.depth + 1 : 0;
      for (let w = 0; w < this.path.length; w++) this.path[w].shouldResetTransform = !0;
      this.root === this && (this.nodes = new gde());
    }
    addEventListener(h, y) {
      return this.eventHandlers.has(h) || this.eventHandlers.set(h, new ez()), this.eventHandlers.get(h).add(y);
    }
    notifyListeners(h, ...y) {
      const w = this.eventHandlers.get(h);
      w && w.notify(...y);
    }
    hasListeners(h) {
      return this.eventHandlers.has(h);
    }
    /**
     * Lifecycles
     */
    mount(h) {
      if (this.instance) return;
      this.isSVG = V6(h) && !kue(h), this.instance = h;
      const {
        layoutId: y,
        layout: w,
        visualElement: x
      } = this.options;
      if (x && !x.current && x.mount(h), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (w || y) && (this.isLayoutDirty = !0), t) {
        let E,
          C = 0;
        const k = () => this.root.updateBlockedByResize = !1;
        Ua.read(() => {
          C = window.innerWidth;
        }), t(h, () => {
          const D = window.innerWidth;
          D !== C && (C = D, this.root.updateBlockedByResize = !0, E && E(), E = yde(k, 250), KM.hasAnimatedSinceResize && (KM.hasAnimatedSinceResize = !1, this.nodes.forEach(J3)));
        });
      }
      y && this.root.registerSharedNode(y, this), this.options.animate !== !1 && x && (y || w) && this.addEventListener("didUpdate", ({
        delta: E,
        hasLayoutChanged: C,
        hasRelativeLayoutChanged: k,
        layout: D
      }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const I = this.options.transition || x.getDefaultTransition() || Hde,
          {
            onLayoutAnimationStart: O,
            onLayoutAnimationComplete: P
          } = x.getProps(),
          N = !this.targetLayout || !S8(this.targetLayout, D),
          L = !C && k;
        if (this.options.layoutRoot || this.resumeFrom || L || C && (N || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0);
          const F = {
            ...pz(I, "layout"),
            onPlay: O,
            onComplete: P
          };
          (x.shouldReduceMotion || this.options.layoutRoot) && (F.delay = 0, F.type = !1), this.startAnimation(F), this.setAnimationOrigin(E, L);
        } else C || J3(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = D;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const h = this.getStack();
      h && h.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), aw(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(zde), this.animationId++);
    }
    getTransformTemplate() {
      const {
        visualElement: h
      } = this.options;
      return h && h.getProps().transformTemplate;
    }
    willUpdate(h = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && E8(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty) return;
      this.isLayoutDirty = !0;
      for (let E = 0; E < this.path.length; E++) {
        const C = this.path[E];
        C.shouldResetTransform = !0, C.updateScroll("snapshot"), C.options.layoutRoot && C.willUpdate(!1);
      }
      const {
        layoutId: y,
        layout: w
      } = this.options;
      if (y === void 0 && !w) return;
      const x = this.getTransformTemplate();
      this.prevTransformTemplateValue = x ? x(this.latestValues, "") : void 0, this.updateSnapshot(), h && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(Q3);
        return;
      }
      if (this.animationId <= this.animationCommitId) {
        this.nodes.forEach(Z3);
        return;
      }
      this.animationCommitId = this.animationId, this.isUpdating ? (this.isUpdating = !1, this.nodes.forEach(jde), this.nodes.forEach(Mde), this.nodes.forEach(Ode)) : this.nodes.forEach(Z3), this.clearAllSnapshots();
      const y = ud.now();
      lu.delta = wb(0, 1e3 / 60, y - lu.timestamp), lu.timestamp = y, lu.isProcessing = !0, Y2.update.process(lu), Y2.preRender.process(lu), Y2.render.process(lu), lu.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, mz.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(Ade), this.sharedNodes.forEach(Vde);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, Ua.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      Ua.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !Mc(this.snapshot.measuredBox.x) && !Mc(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty)) return;
      if (this.resumeFrom && !this.resumeFrom.instance) for (let w = 0; w < this.path.length; w++) this.path[w].updateScroll();
      const h = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = is(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const {
        visualElement: y
      } = this.options;
      y && y.notify("LayoutMeasure", this.layout.layoutBox, h ? h.layoutBox : void 0);
    }
    updateScroll(h = "measure") {
      let y = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === h && (y = !1), y && this.instance) {
        const w = l(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: h,
          isRoot: w,
          offset: i(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : w
        };
      }
    }
    resetTransform() {
      if (!c) return;
      const h = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout,
        y = this.projectionDelta && !x8(this.projectionDelta),
        w = this.getTransformTemplate(),
        x = w ? w(this.latestValues, "") : void 0,
        E = x !== this.prevTransformTemplateValue;
      h && this.instance && (y || Bx(this.latestValues) || E) && (c(this.instance, x), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(h = !0) {
      const y = this.measurePageBox();
      let w = this.removeElementScroll(y);
      return h && (w = this.removeTransform(w)), $de(w), {
        animationId: this.root.animationId,
        measuredBox: y,
        layoutBox: w,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var x;
      const {
        visualElement: h
      } = this.options;
      if (!h) return is();
      const y = h.measureViewportBox();
      if (!(((x = this.scroll) == null ? void 0 : x.wasRoot) || this.path.some(Wde))) {
        const {
          scroll: E
        } = this.root;
        E && (cE(y.x, E.offset.x), cE(y.y, E.offset.y));
      }
      return y;
    }
    removeElementScroll(h) {
      var w;
      const y = is();
      if (Ip(y, h), (w = this.scroll) != null && w.wasRoot) return y;
      for (let x = 0; x < this.path.length; x++) {
        const E = this.path[x],
          {
            scroll: C,
            options: k
          } = E;
        E !== this.root && C && k.layoutScroll && (C.wasRoot && Ip(y, h), cE(y.x, C.offset.x), cE(y.y, C.offset.y));
      }
      return y;
    }
    applyTransform(h, y = !1) {
      const w = is();
      Ip(w, h);
      for (let x = 0; x < this.path.length; x++) {
        const E = this.path[x];
        !y && E.options.layoutScroll && E.scroll && E !== E.root && dE(w, {
          x: -E.scroll.offset.x,
          y: -E.scroll.offset.y
        }), Bx(E.latestValues) && dE(w, E.latestValues);
      }
      return Bx(this.latestValues) && dE(w, this.latestValues), w;
    }
    removeTransform(h) {
      const y = is();
      Ip(y, h);
      for (let w = 0; w < this.path.length; w++) {
        const x = this.path[w];
        if (!x.instance || !Bx(x.latestValues)) continue;
        cF(x.latestValues) && x.updateSnapshot();
        const E = is(),
          C = x.measurePageBox();
        Ip(E, C), W3(y, x.latestValues, x.snapshot ? x.snapshot.layoutBox : void 0, E);
      }
      return Bx(this.latestValues) && W3(y, this.latestValues), y;
    }
    setTargetDelta(h) {
      this.targetDelta = h, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(h) {
      this.options = {
        ...this.options,
        ...h,
        crossfade: h.crossfade !== void 0 ? h.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== lu.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(h = !1) {
      var k;
      const y = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = y.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = y.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = y.isSharedProjectionDirty);
      const w = !!this.resumingFrom || this !== y;
      if (!(h || w && this.isSharedProjectionDirty || this.isProjectionDirty || (k = this.parent) != null && k.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize)) return;
      const {
        layout: E,
        layoutId: C
      } = this.options;
      if (!(!this.layout || !(E || C))) {
        if (this.resolvedRelativeTargetAt = lu.timestamp, !this.targetDelta && !this.relativeTarget) {
          const D = this.getClosestProjectingParent();
          D && D.layout && this.animationProgress !== 1 ? (this.relativeParent = D, this.forceRelativeParentToResolveTarget(), this.relativeTarget = is(), this.relativeTargetOrigin = is(), KT(this.relativeTargetOrigin, this.layout.layoutBox, D.layout.layoutBox), Ip(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = is(), this.targetWithTransforms = is()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), Qce(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : Ip(this.target, this.layout.layoutBox), r8(this.target, this.targetDelta)) : Ip(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget)) {
          this.attemptToResolveRelativeTarget = !1;
          const D = this.getClosestProjectingParent();
          D && !!D.resumingFrom == !!this.resumingFrom && !D.options.layoutScroll && D.target && this.animationProgress !== 1 ? (this.relativeParent = D, this.forceRelativeParentToResolveTarget(), this.relativeTarget = is(), this.relativeTargetOrigin = is(), KT(this.relativeTargetOrigin, this.target, D.target), Ip(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || cF(this.parent.latestValues) || n8(this.parent.latestValues))) return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var I;
      const h = this.getLead(),
        y = !!this.resumingFrom || this !== h;
      let w = !0;
      if ((this.isProjectionDirty || (I = this.parent) != null && I.isProjectionDirty) && (w = !1), y && (this.isSharedProjectionDirty || this.isTransformDirty) && (w = !1), this.resolvedRelativeTargetAt === lu.timestamp && (w = !1), w) return;
      const {
        layout: x,
        layoutId: E
      } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(x || E)) return;
      Ip(this.layoutCorrected, this.layout.layoutBox);
      const C = this.treeScale.x,
        k = this.treeScale.y;
      cce(this.layoutCorrected, this.treeScale, this.path, y), h.layout && !h.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (h.target = h.layout.layoutBox, h.targetWithTransforms = is());
      const {
        target: D
      } = h;
      if (!D) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (U3(this.prevProjectionDelta.x, this.projectionDelta.x), U3(this.prevProjectionDelta.y, this.projectionDelta.y)), XT(this.projectionDelta, this.layoutCorrected, D, this.latestValues), (this.treeScale.x !== C || this.treeScale.y !== k || !K3(this.projectionDelta.x, this.prevProjectionDelta.x) || !K3(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", D));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(h = !0) {
      var y;
      if ((y = this.options.visualElement) == null || y.scheduleRender(), h) {
        const w = this.getStack();
        w && w.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = fE(), this.projectionDelta = fE(), this.projectionDeltaWithTransform = fE();
    }
    setAnimationOrigin(h, y = !1) {
      const w = this.snapshot,
        x = w ? w.latestValues : {},
        E = {
          ...this.latestValues
        },
        C = fE();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !y;
      const k = is(),
        D = w ? w.source : void 0,
        I = this.layout ? this.layout.source : void 0,
        O = D !== I,
        P = this.getStack(),
        N = !P || P.members.length <= 1,
        L = !!(O && !N && this.options.crossfade === !0 && !this.path.some(Ude));
      this.animationProgress = 0;
      let F;
      this.mixTargetDelta = j => {
        const V = j / 1e3;
        eU(C.x, h.x, V), eU(C.y, h.y, V), this.setTargetDelta(C), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (KT(k, this.layout.layoutBox, this.relativeParent.layout.layoutBox), Bde(this.relativeTarget, this.relativeTargetOrigin, k, V), F && kde(this.relativeTarget, F) && (this.isProjectionDirty = !1), F || (F = is()), Ip(F, this.relativeTarget)), O && (this.animationValues = E, wde(E, x, this.latestValues, V, L, N)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = V;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(h) {
      var y, w, x;
      this.notifyListeners("animationStart"), (y = this.currentAnimation) == null || y.stop(), (x = (w = this.resumingFrom) == null ? void 0 : w.currentAnimation) == null || x.stop(), this.pendingAnimation && (aw(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = Ua.update(() => {
        KM.hasAnimatedSinceResize = !0, this.motionValue || (this.motionValue = RE(0)), this.currentAnimation = mde(this.motionValue, [0, 1e3], {
          ...h,
          velocity: 0,
          isSync: !0,
          onUpdate: E => {
            this.mixTargetDelta(E), h.onUpdate && h.onUpdate(E);
          },
          onStop: () => {},
          onComplete: () => {
            h.onComplete && h.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const h = this.getStack();
      h && h.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(Dde), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const h = this.getLead();
      let {
        targetWithTransforms: y,
        target: w,
        layout: x,
        latestValues: E
      } = h;
      if (!(!y || !w || !x)) {
        if (this !== h && this.layout && x && k8(this.options.animationType, this.layout.layoutBox, x.layoutBox)) {
          w = this.target || is();
          const C = Mc(this.layout.layoutBox.x);
          w.x.min = h.target.x.min, w.x.max = w.x.min + C;
          const k = Mc(this.layout.layoutBox.y);
          w.y.min = h.target.y.min, w.y.max = w.y.min + k;
        }
        Ip(y, w), dE(y, E), XT(this.projectionDeltaWithTransform, this.layoutCorrected, y, E);
      }
    }
    registerSharedNode(h, y) {
      this.sharedNodes.has(h) || this.sharedNodes.set(h, new Tde()), this.sharedNodes.get(h).add(y);
      const x = y.options.initialPromotionConfig;
      y.promote({
        transition: x ? x.transition : void 0,
        preserveFollowOpacity: x && x.shouldPreserveFollowOpacity ? x.shouldPreserveFollowOpacity(y) : void 0
      });
    }
    isLead() {
      const h = this.getStack();
      return h ? h.lead === this : !0;
    }
    getLead() {
      var y;
      const {
        layoutId: h
      } = this.options;
      return h ? ((y = this.getStack()) == null ? void 0 : y.lead) || this : this;
    }
    getPrevLead() {
      var y;
      const {
        layoutId: h
      } = this.options;
      return h ? (y = this.getStack()) == null ? void 0 : y.prevLead : void 0;
    }
    getStack() {
      const {
        layoutId: h
      } = this.options;
      if (h) return this.root.sharedNodes.get(h);
    }
    promote({
      needsReset: h,
      transition: y,
      preserveFollowOpacity: w
    } = {}) {
      const x = this.getStack();
      x && x.promote(this, w), h && (this.projectionDelta = void 0, this.needsReset = !0), y && this.setOptions({
        transition: y
      });
    }
    relegate() {
      const h = this.getStack();
      return h ? h.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const {
        visualElement: h
      } = this.options;
      if (!h) return;
      let y = !1;
      const {
        latestValues: w
      } = h;
      if ((w.z || w.rotate || w.rotateX || w.rotateY || w.rotateZ || w.skewX || w.skewY) && (y = !0), !y) return;
      const x = {};
      w.z && ij("z", h, x, this.animationValues);
      for (let E = 0; E < rj.length; E++) ij(`rotate${rj[E]}`, h, x, this.animationValues), ij(`skew${rj[E]}`, h, x, this.animationValues);
      h.render();
      for (const E in x) h.setStaticValue(E, x[E]), this.animationValues && (this.animationValues[E] = x[E]);
      h.scheduleRender();
    }
    applyProjectionStyles(h, y) {
      if (!this.instance || this.isSVG) return;
      if (!this.isVisible) {
        h.visibility = "hidden";
        return;
      }
      const w = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = !1, h.visibility = "", h.opacity = "", h.pointerEvents = XM(y == null ? void 0 : y.pointerEvents) || "", h.transform = w ? w(this.latestValues, "") : "none";
        return;
      }
      const x = this.getLead();
      if (!this.projectionDelta || !this.layout || !x.target) {
        this.options.layoutId && (h.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, h.pointerEvents = XM(y == null ? void 0 : y.pointerEvents) || ""), this.hasProjected && !Bx(this.latestValues) && (h.transform = w ? w({}, "") : "none", this.hasProjected = !1);
        return;
      }
      h.visibility = "";
      const E = x.animationValues || x.latestValues;
      this.applyTransformsToTarget();
      let C = Rde(this.projectionDeltaWithTransform, this.treeScale, E);
      w && (C = w(E, C)), h.transform = C;
      const {
        x: k,
        y: D
      } = this.projectionDelta;
      h.transformOrigin = `${k.origin * 100}% ${D.origin * 100}% 0`, x.animationValues ? h.opacity = x === this ? E.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : E.opacityExit : h.opacity = x === this ? E.opacity !== void 0 ? E.opacity : "" : E.opacityExit !== void 0 ? E.opacityExit : 0;
      for (const I in SR) {
        if (E[I] === void 0) continue;
        const {
            correct: O,
            applyTo: P,
            isCSSVariable: N
          } = SR[I],
          L = C === "none" ? E[I] : O(E[I], x);
        if (P) {
          const F = P.length;
          for (let j = 0; j < F; j++) h[P[j]] = L;
        } else N ? this.options.visualElement.renderState.vars[I] = L : h[I] = L;
      }
      this.options.layoutId && (h.pointerEvents = x === this ? XM(y == null ? void 0 : y.pointerEvents) || "" : "none");
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach(h => {
        var y;
        return (y = h.currentAnimation) == null ? void 0 : y.stop();
      }), this.root.nodes.forEach(Q3), this.root.sharedNodes.clear();
    }
  };
}
function Mde(t) {
  t.updateLayout();
}
function Ode(t) {
  var i;
  const e = ((i = t.resumeFrom) == null ? void 0 : i.snapshot) || t.snapshot;
  if (t.isLead() && t.layout && e && t.hasListeners("didUpdate")) {
    const {
        layoutBox: l,
        measuredBox: c
      } = t.layout,
      {
        animationType: p
      } = t.options,
      h = e.source !== t.layout.source;
    p === "size" ? Lp(C => {
      const k = h ? e.measuredBox[C] : e.layoutBox[C],
        D = Mc(k);
      k.min = l[C].min, k.max = k.min + D;
    }) : k8(p, e.layoutBox, l) && Lp(C => {
      const k = h ? e.measuredBox[C] : e.layoutBox[C],
        D = Mc(l[C]);
      k.max = k.min + D, t.relativeTarget && !t.currentAnimation && (t.isProjectionDirty = !0, t.relativeTarget[C].max = t.relativeTarget[C].min + D);
    });
    const y = fE();
    XT(y, l, e.layoutBox);
    const w = fE();
    h ? XT(w, t.applyTransform(c, !0), e.measuredBox) : XT(w, l, e.layoutBox);
    const x = !x8(y);
    let E = !1;
    if (!t.resumeFrom) {
      const C = t.getClosestProjectingParent();
      if (C && !C.resumeFrom) {
        const {
          snapshot: k,
          layout: D
        } = C;
        if (k && D) {
          const I = is();
          KT(I, e.layoutBox, k.layoutBox);
          const O = is();
          KT(O, l, D.layoutBox), S8(I, O) || (E = !0), C.options.layoutRoot && (t.relativeTarget = O, t.relativeTargetOrigin = I, t.relativeParent = C);
        }
      }
    }
    t.notifyListeners("didUpdate", {
      layout: l,
      snapshot: e,
      delta: w,
      layoutDelta: y,
      hasLayoutChanged: x,
      hasRelativeLayoutChanged: E
    });
  } else if (t.isLead()) {
    const {
      onExitComplete: l
    } = t.options;
    l && l();
  }
  t.options.transition = void 0;
}
function Lde(t) {
  t.parent && (t.isProjecting() || (t.isProjectionDirty = t.parent.isProjectionDirty), t.isSharedProjectionDirty || (t.isSharedProjectionDirty = !!(t.isProjectionDirty || t.parent.isProjectionDirty || t.parent.isSharedProjectionDirty)), t.isTransformDirty || (t.isTransformDirty = t.parent.isTransformDirty));
}
function Pde(t) {
  t.isProjectionDirty = t.isSharedProjectionDirty = t.isTransformDirty = !1;
}
function Ade(t) {
  t.clearSnapshot();
}
function Q3(t) {
  t.clearMeasurements();
}
function Z3(t) {
  t.isLayoutDirty = !1;
}
function jde(t) {
  const {
    visualElement: e
  } = t.options;
  e && e.getProps().onBeforeLayoutMeasure && e.notify("BeforeLayoutMeasure"), t.resetTransform();
}
function J3(t) {
  t.finishAnimation(), t.targetDelta = t.relativeTarget = t.target = void 0, t.isProjectionDirty = !0;
}
function Fde(t) {
  t.resolveTargetDelta();
}
function Nde(t) {
  t.calcProjection();
}
function zde(t) {
  t.resetSkewAndRotation();
}
function Vde(t) {
  t.removeLeadSnapshot();
}
function eU(t, e, i) {
  t.translate = go(e.translate, 0, i), t.scale = go(e.scale, 1, i), t.origin = e.origin, t.originPoint = e.originPoint;
}
function tU(t, e, i, l) {
  t.min = go(e.min, i.min, l), t.max = go(e.max, i.max, l);
}
function Bde(t, e, i, l) {
  tU(t.x, e.x, i.x, l), tU(t.y, e.y, i.y, l);
}
function Ude(t) {
  return t.animationValues && t.animationValues.opacityExit !== void 0;
}
const Hde = {
    duration: 0.45,
    ease: [0.4, 0, 0.1, 1]
  },
  nU = t => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(t),
  rU = nU("applewebkit/") && !nU("chrome/") ? Math.round : Bp;
function iU(t) {
  t.min = rU(t.min), t.max = rU(t.max);
}
function $de(t) {
  iU(t.x), iU(t.y);
}
function k8(t, e, i) {
  return t === "position" || t === "preserve-aspect" && !Kce(X3(e), X3(i), 0.2);
}
function Wde(t) {
  var e;
  return t !== t.root && ((e = t.scroll) == null ? void 0 : e.wasRoot);
}
const qde = C8({
    attachResizeListener: (t, e) => ER(t, "resize", e),
    measureScroll: () => ({
      x: document.documentElement.scrollLeft || document.body.scrollLeft,
      y: document.documentElement.scrollTop || document.body.scrollTop
    }),
    checkIsScrollRoot: () => !0
  }),
  aj = {
    current: void 0
  },
  T8 = C8({
    measureScroll: t => ({
      x: t.scrollLeft,
      y: t.scrollTop
    }),
    defaultParent: () => {
      if (!aj.current) {
        const t = new qde({});
        t.mount(window), t.setOptions({
          layoutScroll: !0
        }), aj.current = t;
      }
      return aj.current;
    },
    resetTransform: (t, e) => {
      t.style.transform = e !== void 0 ? e : "none";
    },
    checkIsScrollRoot: t => window.getComputedStyle(t).position === "fixed"
  }),
  Yde = {
    pan: {
      Feature: dde
    },
    drag: {
      Feature: cde,
      ProjectionNode: T8,
      MeasureLayout: b8
    }
  };
function aU(t, e, i) {
  const {
    props: l
  } = t;
  t.animationState && l.whileHover && t.animationState.setActive("whileHover", i === "Start");
  const c = "onHover" + i,
    p = l[c];
  p && Ua.postRender(() => p(e, YR(e)));
}
class Gde extends lw {
  mount() {
    const {
      current: e
    } = this.node;
    e && (this.unmount = _ue(e, (i, l) => (aU(this.node, l, "Start"), c => aU(this.node, c, "End"))));
  }
  unmount() {}
}
class Xde extends lw {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let e = !1;
    try {
      e = this.node.current.matches(":focus-visible");
    } catch {
      e = !0;
    }
    !e || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = $R(ER(this.node.current, "focus", () => this.onFocus()), ER(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {}
}
function oU(t, e, i) {
  const {
    props: l
  } = t;
  if (t.current instanceof HTMLButtonElement && t.current.disabled) return;
  t.animationState && l.whileTap && t.animationState.setActive("whileTap", i === "Start");
  const c = "onTap" + (i === "End" ? "" : i),
    p = l[c];
  p && Ua.postRender(() => p(e, YR(e)));
}
class Kde extends lw {
  mount() {
    const {
      current: e
    } = this.node;
    e && (this.unmount = Cue(e, (i, l) => (oU(this.node, l, "Start"), (c, {
      success: p
    }) => oU(this.node, c, p ? "End" : "Cancel")), {
      useGlobalTarget: this.node.props.globalTapTarget
    }));
  }
  unmount() {}
}
const vF = /* @__PURE__ */new WeakMap(),
  oj = /* @__PURE__ */new WeakMap(),
  Qde = t => {
    const e = vF.get(t.target);
    e && e(t);
  },
  Zde = t => {
    t.forEach(Qde);
  };
function Jde({
  root: t,
  ...e
}) {
  const i = t || document;
  oj.has(i) || oj.set(i, {});
  const l = oj.get(i),
    c = JSON.stringify(e);
  return l[c] || (l[c] = new IntersectionObserver(Zde, {
    root: t,
    ...e
  })), l[c];
}
function efe(t, e, i) {
  const l = Jde(e);
  return vF.set(t, i), l.observe(t), () => {
    vF.delete(t), l.unobserve(t);
  };
}
const tfe = {
  some: 0,
  all: 1
};
class nfe extends lw {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const {
        viewport: e = {}
      } = this.node.getProps(),
      {
        root: i,
        margin: l,
        amount: c = "some",
        once: p
      } = e,
      h = {
        root: i ? i.current : void 0,
        rootMargin: l,
        threshold: typeof c == "number" ? c : tfe[c]
      },
      y = w => {
        const {
          isIntersecting: x
        } = w;
        if (this.isInView === x || (this.isInView = x, p && !x && this.hasEnteredView)) return;
        x && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", x);
        const {
            onViewportEnter: E,
            onViewportLeave: C
          } = this.node.getProps(),
          k = x ? E : C;
        k && k(w);
      };
    return efe(this.node.current, h, y);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u") return;
    const {
      props: e,
      prevProps: i
    } = this.node;
    ["amount", "margin", "root"].some(rfe(e, i)) && this.startObserver();
  }
  unmount() {}
}
function rfe({
  viewport: t = {}
}, {
  viewport: e = {}
} = {}) {
  return i => t[i] !== e[i];
}
const ife = {
    inView: {
      Feature: nfe
    },
    tap: {
      Feature: Kde
    },
    focus: {
      Feature: Xde
    },
    hover: {
      Feature: Gde
    }
  },
  afe = {
    layout: {
      ProjectionNode: T8,
      MeasureLayout: b8
    }
  },
  ofe = {
    ...$ce,
    ...ife,
    ...Yde,
    ...afe
  },
  CR = /* @__PURE__ */sce(ofe, bce);
function R8() {
  !Cz.current && a8();
  const [t] = rt(OO.current);
  return process.env.NODE_ENV !== "production" && QO(t !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), t;
}
const sfe = "_closeButton_1nq2h_1",
  lfe = "_closeMenu_1nq2h_13",
  ufe = "_title_1nq2h_19",
  kM = {
    closeButton: sfe,
    closeMenu: lfe,
    title: ufe
  },
  Tz = {
    backToHome: "Back to home",
    travelAdvisories: "Travel advisories",
    menu: "Menu",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    openGatewayMenu: "Open gateway menu",
    changeGateway: "Change gateway",
    gatewayHeader: "Gateway",
    closeModal: "Close",
    searchLabel: "Search",
    searchHotelsLabel: "Search Hotels",
    profileOpenMenu: "Open account profile menu",
    profileCloseLabel: "Close",
    profileToggleDropdown: "Toggle account profile dropdown menu",
    profileGreeting: "Hi,",
    profileMobileMenuTitle: "Account profile",
    lang: "Language preference",
    menuTitle: "Menu"
  },
  cfe = {
    label: "Calgary",
    value: "YYC"
  },
  D8 = ({
    id: t,
    title: e,
    labels: i = Tz,
    isOpen: l,
    handleClose: c
  }) => {
    const p = R8();
    return /* @__PURE__ */B.jsxs(CR.div, {
      className: kM.container,
      initial: !1,
      variants: {
        ..._ae(0.2, p)
      },
      animate: l ? "open" : "closed",
      children: [/* @__PURE__ */B.jsx("div", {
        className: kM.closeMenu,
        children: /* @__PURE__ */B.jsx("button", {
          type: "button",
          className: kM.closeButton,
          "aria-label": i.closeMenu,
          "aria-controls": t,
          onClick: c,
          children: /* @__PURE__ */B.jsx(sn, {
            name: "close",
            size: "3xl",
            title: i.closeMenu,
            hidden: !0
          })
        })
      }), /* @__PURE__ */B.jsx("div", {
        className: kM.title,
        children: e
      })]
    });
  },
  dfe = "_menuContainer_9e536_1",
  ffe = "_backdrop_9e536_6",
  pfe = "_wrapper_9e536_17",
  hfe = "_wrapperOpen_9e536_46",
  mfe = "_container_9e536_51",
  vfe = "_gatewayWrapper_9e536_58",
  gfe = "_mainNav_9e536_62",
  yfe = "_divider_9e536_73",
  bfe = "_mainNavDivider_9e536_79",
  wfe = "_langToggleContainer_9e536_84",
  _fe = "_iconDown_9e536_89",
  xfe = "_iconGlobe_9e536_90",
  Sfe = "_currentLanguage_9e536_94",
  Eu = {
    menuContainer: dfe,
    backdrop: ffe,
    wrapper: pfe,
    wrapperOpen: hfe,
    container: mfe,
    gatewayWrapper: vfe,
    mainNav: gfe,
    divider: yfe,
    mainNavDivider: bfe,
    langToggleContainer: wfe,
    iconDown: _fe,
    iconGlobe: xfe,
    currentLanguage: Sfe
  },
  Efe = "_subMenuContainer_ched8_1",
  Cfe = "_dropdownContainer_ched8_10",
  kfe = "_dropdownContainerOpen_ched8_17",
  Tfe = "_dropdownToggle_ched8_29",
  Rfe = "_dropdownToggleLabel_ched8_44",
  Dfe = "_navLink_ched8_49",
  Ife = "_iconExternal_ched8_61",
  Mfe = "_iconChevron_ched8_62",
  Ofe = "_subNavLink_ched8_72",
  np = {
    subMenuContainer: Efe,
    dropdownContainer: Cfe,
    dropdownContainerOpen: kfe,
    dropdownToggle: Tfe,
    dropdownToggleLabel: Rfe,
    navLink: Dfe,
    iconExternal: Ife,
    iconChevron: Mfe,
    subNavLink: Ofe
  },
  Lfe = t => "href" in t || "url" in t,
  Pfe = {
    open: {
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.05
      }
    },
    closed: {
      overflow: "hidden",
      transition: {
        delay: 0.4,
        staggerChildren: 0.05,
        staggerDirection: 1
      }
    }
  },
  Afe = ({
    isMenuOpened: t,
    menuLinks: e,
    renderLinks: i
  }) => {
    const [l, c] = Nt.useState([]),
      p = h => () => {
        const y = new Set(l);
        y.has(h) ? y.delete(h) : y.add(h), c(Array.from(y));
      };
    return /* @__PURE__ */B.jsx(CR.ul, {
      className: np.subMenuContainer,
      initial: !1,
      variants: Pfe,
      animate: t ? "open" : "closed",
      children: e == null ? void 0 : e.map((h, y) => {
        var w;
        return /* @__PURE__ */B.jsx("li", {
          className: np.navList,
          children: Lfe(h) ? /* @__PURE__ */B.jsx(B.Fragment, {
            children: i == null ? void 0 : i({
              ...h,
              className: ge(h.className, np.navLink),
              children: /* @__PURE__ */B.jsxs(B.Fragment, {
                children: [h.linkText, (h == null ? void 0 : h.iconName) && /* @__PURE__ */B.jsx(sn, {
                  size: "xs",
                  name: h.iconName,
                  className: np.iconExternal
                })]
              })
            })
          }) : /* @__PURE__ */B.jsxs(B.Fragment, {
            children: [h.displayTitle && /* @__PURE__ */B.jsxs("button", {
              type: "button",
              className: np.dropdownToggle,
              "aria-label": h.displayTitle,
              "aria-haspopup": !0,
              "aria-expanded": t,
              onClick: p(y),
              children: [/* @__PURE__ */B.jsx("span", {
                className: np.dropdownToggleLabel,
                children: h.displayTitle
              }), /* @__PURE__ */B.jsx(sn, {
                name: l.includes(y) ? "chevron-up" : "chevron-down",
                className: np.iconChevron,
                size: "3xl"
              })]
            }), /* @__PURE__ */B.jsx("ul", {
              className: ge(np.dropdownContainer, l.includes(y) && np.dropdownContainerOpen),
              children: (w = h.menuItems) == null ? void 0 : w.map((x, E) => /* @__PURE__ */B.jsx("li", {
                children: i == null ? void 0 : i({
                  ...x,
                  className: ge(x.className, np.subNavLink),
                  children: x.linkText
                })
              }, `header-menu-subnav-li-${E}`))
            })]
          })
        }, `header-menu-nav-li-${y}`);
      })
    });
  },
  jfe = ({
    children: t,
    className: e
  }) => e ? /* @__PURE__ */B.jsx("span", {
    className: e,
    children: t
  }) : t,
  I8 = ({
    links: t,
    classNames: e,
    renderLinks: i
  }) => /* @__PURE__ */B.jsx("ul", {
    className: e == null ? void 0 : e.ul,
    children: t == null ? void 0 : t.map((l, c) => {
      var p;
      return /* @__PURE__ */B.jsx("li", {
        className: e == null ? void 0 : e.li,
        children: i == null ? void 0 : i({
          ...l,
          className: typeof (e == null ? void 0 : e.renderLink) != "string" ? (p = e == null ? void 0 : e.renderLink) == null ? void 0 : p.call(e, l) : e.renderLink,
          children: /* @__PURE__ */B.jsxs(jfe, {
            className: e == null ? void 0 : e.linkText,
            children: [l.linkText, (l == null ? void 0 : l.iconName) && /* @__PURE__ */B.jsx(sn, {
              size: "xs",
              name: l.iconName,
              className: e == null ? void 0 : e.icon
            })]
          })
        })
      }, `nav-main-link-${c}`);
    })
  }),
  M8 = [{
    label: "AB",
    name: "Alberta",
    gateways: [{
      label: "Calgary",
      value: "YYC"
    }, {
      label: "Edmonton",
      value: "YEG"
    }, {
      label: "Fort McMurray",
      value: "YMM"
    }, {
      label: "Grande Prairie",
      value: "YQU"
    }, {
      label: "Lethbridge",
      value: "YQL"
    }, {
      label: "Medicine Hat",
      value: "YXH"
    }]
  }, {
    label: "BC",
    name: "British Columbia",
    gateways: [{
      label: "Abbotsford",
      value: "YXX"
    }, {
      label: "Comox",
      value: "YQQ"
    }, {
      label: "Cranbook",
      value: "YXC"
    }, {
      label: "Fort Saint John",
      value: "YXJ"
    }, {
      label: "Kamloops",
      value: "YKA"
    }, {
      label: "Kelowna",
      value: "YLW"
    }, {
      label: "Nanaimo",
      value: "YCD"
    }, {
      label: "Penticton",
      value: "YYF"
    }, {
      label: "Prince George",
      value: "YXS"
    }, {
      label: "Terrace",
      value: "YXT"
    }, {
      label: "Vancouver",
      value: "YVR"
    }, {
      label: "Victoria",
      value: "YYJ"
    }]
  }, {
    label: "MB",
    name: "Manitoba",
    gateways: [{
      label: "Winnipeg",
      value: "YWG"
    }]
  }, {
    label: "NL",
    name: "Newfoundland and Labrador",
    gateways: [{
      label: "St. John's",
      value: "YYT"
    }]
  }, {
    label: "NS",
    name: "Nova Scotia",
    gateways: [{
      label: "Halifax",
      value: "YHZ"
    }]
  }, {
    label: "NT",
    name: "Northwest Territories",
    gateways: [{
      label: "Yellowknife",
      value: "YZF"
    }]
  }, {
    label: "ON",
    name: "Ontario",
    gateways: [{
      label: "Hamilton",
      value: "HAM"
    }, {
      label: "London",
      value: "YXU"
    }, {
      label: "Ottawa",
      value: "YOW"
    }, {
      label: "Thunder Bay",
      value: "YQT"
    }, {
      label: "Toronto",
      value: "YYZ"
    }]
  }, {
    label: "SK",
    name: "Saskatchewan",
    gateways: [{
      label: "Regina",
      value: "YQR"
    }, {
      label: "Saskatoon",
      value: "YKE"
    }]
  }],
  Ffe = "_menu_1leia_1",
  Nfe = "_menuOpen_1leia_18",
  zfe = "_container_1leia_23",
  Vfe = "_gatewayCityContainer_1leia_39",
  Bfe = "_province_1leia_44",
  Ufe = "_provinceLabel_1leia_47",
  Hfe = "_currentGateway_1leia_69",
  $0 = {
    menu: Ffe,
    menuOpen: Nfe,
    container: zfe,
    gatewayCityContainer: Vfe,
    province: Bfe,
    provinceLabel: Ufe,
    currentGateway: Hfe
  },
  $fe = {
    open: {
      overflow: "auto"
    },
    closed: {
      overflow: "hidden",
      transition: {
        staggerChildren: 0.05,
        staggerDirection: -1
      }
    }
  },
  Wfe = ({
    id: t,
    labels: e,
    gatewaysGroup: i,
    currentGateway: l,
    isOpened: c,
    handleChangeGateway: p,
    handleGatewayMenu: h
  }) => {
    const [y, w] = rt(!1),
      x = () => {
        w(!1), h(!1);
      },
      E = k => {
        p(k), x();
      },
      C = R8();
    return Rt(() => {
      c && setTimeout(() => {
        w(c);
      }, 50);
    }, [c]), /* @__PURE__ */B.jsxs(GN, {
      enabled: y,
      shouldIgnore: k => !(k.id === "gatsby-focus-wrapper" && k.tabIndex === -1),
      onClickOutside: x,
      onEscapeKey: x,
      className: ge($0.menu, c && $0.menuOpen),
      children: [/* @__PURE__ */B.jsx(D8, {
        id: t,
        title: e.gatewayHeader,
        labels: {
          closeMenu: e.closeMenu,
          closeModal: e.closeModal
        },
        isOpen: c,
        handleClose: x
      }), /* @__PURE__ */B.jsx(CR.ul, {
        className: $0.container,
        id: t,
        initial: !1,
        variants: $fe,
        animate: c ? "open" : "closed",
        children: i.map(k => /* @__PURE__ */B.jsxs(CR.li, {
          className: $0.province,
          variants: {
            ...xae(C || void 0)
          },
          children: [/* @__PURE__ */B.jsx("span", {
            className: $0.provinceLabel,
            children: k.label
          }), /* @__PURE__ */B.jsx("ul", {
            className: $0.gatewayCityContainer,
            children: k.gateways.map(D => /* @__PURE__ */B.jsx("li", {
              children: l.value === D.value ? /* @__PURE__ */B.jsx("span", {
                className: $0.currentGateway,
                children: D.label
              }) : /* @__PURE__ */B.jsx("button", {
                type: "button",
                className: $0.gatewayCity,
                onClick: () => E(D),
                value: D.value,
                children: D.label
              })
            }, D.value))
          })]
        }, k.label))
      })]
    });
  },
  qfe = "_gatewaySwitcher_1m1hp_1",
  Yfe = "_gatewaySwitcherButton_1m1hp_7",
  Gfe = "_gatewayIcon_1m1hp_24",
  sj = {
    gatewaySwitcher: qfe,
    gatewaySwitcherButton: Yfe,
    gatewayIcon: Gfe
  },
  Xfe = ({
    labels: t,
    currentGateway: e = cfe,
    handleChangeGateway: i
  }) => {
    const l = vt(null),
      [c, p] = rt(!1),
      h = y => {
        p(y), !y && l.current && setTimeout(() => {
          var w;
          (w = l.current) == null || w.focus();
        }, 0);
      };
    return /* @__PURE__ */B.jsxs(B.Fragment, {
      children: [/* @__PURE__ */B.jsxs("div", {
        className: sj.gatewaySwitcher,
        children: [/* @__PURE__ */B.jsx("span", {
          children: e.label
        }), /* @__PURE__ */B.jsxs("button", {
          type: "button",
          className: sj.gatewaySwitcherButton,
          onClick: () => h(!0),
          "aria-label": t.openGatewayMenu,
          "aria-expanded": c,
          "aria-controls": "main-menu-gateway-nav",
          ref: l,
          children: [/* @__PURE__ */B.jsx("span", {
            children: t.changeGateway
          }), /* @__PURE__ */B.jsx(sn, {
            name: "chevron-right",
            className: sj.gatewayIcon,
            hidden: !0
          })]
        })]
      }), /* @__PURE__ */B.jsx(Wfe, {
        id: "main-menu-gateway-nav",
        labels: {
          closeMenu: t.closeMenu,
          gatewayHeader: t.gatewayHeader,
          closeModal: t.closeModal
        },
        gatewaysGroup: M8,
        currentGateway: e,
        isOpened: c,
        handleChangeGateway: i,
        handleGatewayMenu: h
      })]
    });
  };
function Kfe(t, e, i) {
  var l = i || {},
    c = l.noTrailing,
    p = c === void 0 ? !1 : c,
    h = l.noLeading,
    y = h === void 0 ? !1 : h,
    w = l.debounceMode,
    x = w === void 0 ? void 0 : w,
    E,
    C = !1,
    k = 0;
  function D() {
    E && clearTimeout(E);
  }
  function I(P) {
    var N = P || {},
      L = N.upcomingOnly,
      F = L === void 0 ? !1 : L;
    D(), C = !F;
  }
  function O() {
    for (var P = arguments.length, N = new Array(P), L = 0; L < P; L++) N[L] = arguments[L];
    var F = this,
      j = Date.now() - k;
    if (C) return;
    function V() {
      k = Date.now(), e.apply(F, N);
    }
    function K() {
      E = void 0;
    }
    !y && x && !E && V(), D(), x === void 0 && j > t ? y ? (k = Date.now(), p || (E = setTimeout(x ? K : V, t))) : V() : p !== !0 && (E = setTimeout(x ? K : V, x === void 0 ? t - j : t));
  }
  return O.cancel = I, O;
}
function Qfe(t, e, i) {
  var l = {},
    c = l.atBegin,
    p = c === void 0 ? !1 : c;
  return Kfe(t, e, {
    debounceMode: p !== !1
  });
}
const Zfe = "_wrapper_fo5ch_1",
  Jfe = "_loading_fo5ch_5",
  epe = "_input_fo5ch_5",
  tpe = "_error_fo5ch_8",
  npe = "_themeDefault_fo5ch_11",
  rpe = "_themeGrey_fo5ch_14",
  ipe = "_search_fo5ch_17",
  ape = "_iconClear_fo5ch_17",
  ope = "_iconSearch_fo5ch_20",
  spe = "_inputWrapperDisabled_fo5ch_24",
  lpe = "_inputLabel_fo5ch_28",
  upe = "_inputIconDisabled_fo5ch_34",
  cpe = "_inputIcon_fo5ch_34",
  dpe = "_inputIconHide_fo5ch_70",
  fpe = "_inputIconShow_fo5ch_73",
  ppe = "_srOnly_fo5ch_77",
  hpe = "_border_fo5ch_107",
  mpe = "_inputError_fo5ch_117",
  vpe = "_inputErrorText_fo5ch_123",
  gpe = "_animate_fo5ch_152",
  ype = "_inputLabelLoading_fo5ch_156",
  bpe = "_inputLabelDisabled_fo5ch_160",
  wpe = "_inputFocus_fo5ch_163",
  _pe = "_inputLabelError_fo5ch_176",
  xpe = "_inputIconPadding_fo5ch_179",
  Spe = "_inputLabelIconSearch_fo5ch_182",
  Epe = "_loader_fo5ch_186",
  Cpe = "_helperText_fo5ch_194",
  kpe = "_listBox_fo5ch_206",
  Tpe = "_listBoxOpen_fo5ch_218",
  Rpe = "_listItemGroup_fo5ch_221",
  Dpe = "_listItem_fo5ch_221",
  Ipe = "_listItemActive_fo5ch_234",
  Mpe = "_listItemSelected_fo5ch_237",
  Ope = "_listItemHighlightedText_fo5ch_242",
  Lpe = "_listHeading_fo5ch_246",
  Ppe = "_noResults_fo5ch_257",
  Ur = {
    wrapper: Zfe,
    loading: Jfe,
    input: epe,
    error: tpe,
    themeDefault: npe,
    themeGrey: rpe,
    search: ipe,
    iconClear: ape,
    iconSearch: ope,
    inputWrapperDisabled: spe,
    inputLabel: lpe,
    inputIconDisabled: upe,
    inputIcon: cpe,
    inputIconHide: dpe,
    inputIconShow: fpe,
    srOnly: ppe,
    border: hpe,
    inputError: mpe,
    inputErrorText: vpe,
    animate: gpe,
    inputLabelLoading: ype,
    inputLabelDisabled: bpe,
    inputFocus: wpe,
    inputLabelError: _pe,
    inputIconPadding: xpe,
    inputLabelIconSearch: Spe,
    loader: Epe,
    helperText: Cpe,
    listBox: kpe,
    listBoxOpen: Tpe,
    listItemGroup: Rpe,
    listItem: Dpe,
    listItemActive: Ipe,
    listItemSelected: Mpe,
    listItemHighlightedText: Ope,
    listHeading: Lpe,
    noResults: Ppe
  },
  Ape = ({
    id: t,
    isLoading: e,
    isReadOnly: i,
    isDisabled: l,
    isInlineMode: c,
    helperText: p,
    errorMessage: h,
    iconOptions: y,
    data: w,
    selectedItem: x,
    initialSelectedItem: E,
    environment: C,
    children: k,
    className: D,
    classNames: I,
    onFocus: O,
    onBlur: P,
    onChange: N,
    onInput: L,
    onOpenTypeahead: F,
    renderCustomListItem: j,
    label: V,
    labels: K,
    onSearch: G,
    theme: Q = "default",
    template: te = "default"
  }) => {
    const [ie, Y] = rt(!1);
    return /* @__PURE__ */B.jsx(uQ, {
      id: t,
      label: V,
      isLoading: e,
      loaderConfig: {
        strokeColor: gl.color.teal[500].value,
        trackColor: gl.color.gray[500].value
      },
      isReadOnly: i,
      isDisabled: l,
      helperText: p,
      errorMessage: h,
      iconOptions: {
        input: y == null ? void 0 : y.input,
        clear: (y == null ? void 0 : y.clear) || /* @__PURE__ */B.jsx(sn, {
          name: "close-micro"
        }),
        search: (y == null ? void 0 : y.search) || /* @__PURE__ */B.jsx(sn, {
          name: "search"
        }),
        disabled: (y == null ? void 0 : y.disabled) || /* @__PURE__ */B.jsx(sn, {
          name: "nope"
        })
      },
      data: w,
      selectedItem: x,
      initialSelectedItem: E,
      environment: C,
      children: k,
      className: ge(Ur.wrapper, Ur[`theme${oE.pascal(Q)}`], Ur[te], D),
      classNames: {
        iconClear: ge(Ur.iconClear, I == null ? void 0 : I.iconClear),
        iconSearch: ge(Ur.iconSearch, I == null ? void 0 : I.iconSearch),
        input: ge(Ur.input, I == null ? void 0 : I.input),
        inputBorder: ge(Ur.border, I == null ? void 0 : I.inputBorder),
        inputIcon: ge(Ur.inputIcon, I == null ? void 0 : I.inputIcon),
        inputIconHide: ge(Ur.inputIconHide, I == null ? void 0 : I.inputIconHide),
        inputIconShow: ge(Ur.inputIconShow, I == null ? void 0 : I.inputIconShow),
        inputIconDisabled: ge(Ur.inputIconDisabled, I == null ? void 0 : I.inputIconDisabled),
        inputLabel: ge(Ur.inputLabel, h && Ur.inputLabelError, e && Ur.inputLabelLoading, I == null ? void 0 : I.inputLabel, ie && Ur.animate),
        inputFocus: ge(Ur.inputFocus, I == null ? void 0 : I.inputFocus),
        inputError: ge(Ur.inputError, I == null ? void 0 : I.inputError),
        inputLabelIconSearch: ge(Ur.inputIconPadding, te === "search" && Ur.inputLabelIconSearch, I == null ? void 0 : I.inputLabelIconSearch),
        inputErrorText: ge(Ur.helperText, Ur.inputErrorText, I == null ? void 0 : I.inputErrorText),
        inputHelperText: ge(Ur.helperText, I == null ? void 0 : I.inputHelperText),
        inputWrapperLoading: ge(Ur.loading, I == null ? void 0 : I.inputWrapperLoading),
        inputWrapperDisabled: ge(Ur.inputWrapperDisabled, I == null ? void 0 : I.inputWrapperDisabled),
        loader: ge(Ur.loader, I == null ? void 0 : I.loader),
        listBox: ge(Ur.listBox, I == null ? void 0 : I.listBox),
        listBoxOpen: ge(Ur.listBoxOpen, I == null ? void 0 : I.listBoxOpen),
        listHeading: ge(Ur.listHeading, I == null ? void 0 : I.listHeading),
        listItem: ge(Ur.listItem, I == null ? void 0 : I.listItem),
        listItemActive: ge(Ur.listItemActive, I == null ? void 0 : I.listItemActive),
        listItemSelected: ge(Ur.listItemSelected, I == null ? void 0 : I.listItemSelected),
        listItemHighlightedText: ge(Ur.listItemHighlightedText, I == null ? void 0 : I.listItemHighlightedText),
        listItemGroup: ge(Ur.listItemGroup, I == null ? void 0 : I.listItemGroup),
        noResults: ge(Ur.noResults, I == null ? void 0 : I.noResults)
      },
      onFocus: () => {
        O == null || O(), Y(!0);
      },
      onBlur: P,
      onChange: N,
      onInput: L,
      onOpenTypeahead: F,
      renderCustomListItem: j,
      isInlineMode: c,
      labels: K,
      onSearch: G,
      template: te
    });
  };
var CT = {
    exports: {}
  },
  sU;
function jpe() {
  if (sU) return CT.exports;
  sU = 1;
  var t = {
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      Ấ: "A",
      Ắ: "A",
      Ẳ: "A",
      Ẵ: "A",
      Ặ: "A",
      Æ: "AE",
      Ầ: "A",
      Ằ: "A",
      Ȃ: "A",
      Ả: "A",
      Ạ: "A",
      Ẩ: "A",
      Ẫ: "A",
      Ậ: "A",
      Ç: "C",
      Ḉ: "C",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      Ế: "E",
      Ḗ: "E",
      Ề: "E",
      Ḕ: "E",
      Ḝ: "E",
      Ȇ: "E",
      Ẻ: "E",
      Ẽ: "E",
      Ẹ: "E",
      Ể: "E",
      Ễ: "E",
      Ệ: "E",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      Ḯ: "I",
      Ȋ: "I",
      Ỉ: "I",
      Ị: "I",
      Ð: "D",
      Ñ: "N",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      Ố: "O",
      Ṍ: "O",
      Ṓ: "O",
      Ȏ: "O",
      Ỏ: "O",
      Ọ: "O",
      Ổ: "O",
      Ỗ: "O",
      Ộ: "O",
      Ờ: "O",
      Ở: "O",
      Ỡ: "O",
      Ớ: "O",
      Ợ: "O",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      Ủ: "U",
      Ụ: "U",
      Ử: "U",
      Ữ: "U",
      Ự: "U",
      Ý: "Y",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      ấ: "a",
      ắ: "a",
      ẳ: "a",
      ẵ: "a",
      ặ: "a",
      æ: "ae",
      ầ: "a",
      ằ: "a",
      ȃ: "a",
      ả: "a",
      ạ: "a",
      ẩ: "a",
      ẫ: "a",
      ậ: "a",
      ç: "c",
      ḉ: "c",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      ế: "e",
      ḗ: "e",
      ề: "e",
      ḕ: "e",
      ḝ: "e",
      ȇ: "e",
      ẻ: "e",
      ẽ: "e",
      ẹ: "e",
      ể: "e",
      ễ: "e",
      ệ: "e",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      ḯ: "i",
      ȋ: "i",
      ỉ: "i",
      ị: "i",
      ð: "d",
      ñ: "n",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      ố: "o",
      ṍ: "o",
      ṓ: "o",
      ȏ: "o",
      ỏ: "o",
      ọ: "o",
      ổ: "o",
      ỗ: "o",
      ộ: "o",
      ờ: "o",
      ở: "o",
      ỡ: "o",
      ớ: "o",
      ợ: "o",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      ủ: "u",
      ụ: "u",
      ử: "u",
      ữ: "u",
      ự: "u",
      ý: "y",
      ÿ: "y",
      Ā: "A",
      ā: "a",
      Ă: "A",
      ă: "a",
      Ą: "A",
      ą: "a",
      Ć: "C",
      ć: "c",
      Ĉ: "C",
      ĉ: "c",
      Ċ: "C",
      ċ: "c",
      Č: "C",
      č: "c",
      C̆: "C",
      c̆: "c",
      Ď: "D",
      ď: "d",
      Đ: "D",
      đ: "d",
      Ē: "E",
      ē: "e",
      Ĕ: "E",
      ĕ: "e",
      Ė: "E",
      ė: "e",
      Ę: "E",
      ę: "e",
      Ě: "E",
      ě: "e",
      Ĝ: "G",
      Ǵ: "G",
      ĝ: "g",
      ǵ: "g",
      Ğ: "G",
      ğ: "g",
      Ġ: "G",
      ġ: "g",
      Ģ: "G",
      ģ: "g",
      Ĥ: "H",
      ĥ: "h",
      Ħ: "H",
      ħ: "h",
      Ḫ: "H",
      ḫ: "h",
      Ĩ: "I",
      ĩ: "i",
      Ī: "I",
      ī: "i",
      Ĭ: "I",
      ĭ: "i",
      Į: "I",
      į: "i",
      İ: "I",
      ı: "i",
      Ĳ: "IJ",
      ĳ: "ij",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      Ḱ: "K",
      ḱ: "k",
      K̆: "K",
      k̆: "k",
      Ĺ: "L",
      ĺ: "l",
      Ļ: "L",
      ļ: "l",
      Ľ: "L",
      ľ: "l",
      Ŀ: "L",
      ŀ: "l",
      Ł: "l",
      ł: "l",
      Ḿ: "M",
      ḿ: "m",
      M̆: "M",
      m̆: "m",
      Ń: "N",
      ń: "n",
      Ņ: "N",
      ņ: "n",
      Ň: "N",
      ň: "n",
      ŉ: "n",
      N̆: "N",
      n̆: "n",
      Ō: "O",
      ō: "o",
      Ŏ: "O",
      ŏ: "o",
      Ő: "O",
      ő: "o",
      Œ: "OE",
      œ: "oe",
      P̆: "P",
      p̆: "p",
      Ŕ: "R",
      ŕ: "r",
      Ŗ: "R",
      ŗ: "r",
      Ř: "R",
      ř: "r",
      R̆: "R",
      r̆: "r",
      Ȓ: "R",
      ȓ: "r",
      Ś: "S",
      ś: "s",
      Ŝ: "S",
      ŝ: "s",
      Ş: "S",
      Ș: "S",
      ș: "s",
      ş: "s",
      Š: "S",
      š: "s",
      Ţ: "T",
      ţ: "t",
      ț: "t",
      Ț: "T",
      Ť: "T",
      ť: "t",
      Ŧ: "T",
      ŧ: "t",
      T̆: "T",
      t̆: "t",
      Ũ: "U",
      ũ: "u",
      Ū: "U",
      ū: "u",
      Ŭ: "U",
      ŭ: "u",
      Ů: "U",
      ů: "u",
      Ű: "U",
      ű: "u",
      Ų: "U",
      ų: "u",
      Ȗ: "U",
      ȗ: "u",
      V̆: "V",
      v̆: "v",
      Ŵ: "W",
      ŵ: "w",
      Ẃ: "W",
      ẃ: "w",
      X̆: "X",
      x̆: "x",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Y̆: "Y",
      y̆: "y",
      Ź: "Z",
      ź: "z",
      Ż: "Z",
      ż: "z",
      Ž: "Z",
      ž: "z",
      ſ: "s",
      ƒ: "f",
      Ơ: "O",
      ơ: "o",
      Ư: "U",
      ư: "u",
      Ǎ: "A",
      ǎ: "a",
      Ǐ: "I",
      ǐ: "i",
      Ǒ: "O",
      ǒ: "o",
      Ǔ: "U",
      ǔ: "u",
      Ǖ: "U",
      ǖ: "u",
      Ǘ: "U",
      ǘ: "u",
      Ǚ: "U",
      ǚ: "u",
      Ǜ: "U",
      ǜ: "u",
      Ứ: "U",
      ứ: "u",
      Ṹ: "U",
      ṹ: "u",
      Ǻ: "A",
      ǻ: "a",
      Ǽ: "AE",
      ǽ: "ae",
      Ǿ: "O",
      ǿ: "o",
      Þ: "TH",
      þ: "th",
      Ṕ: "P",
      ṕ: "p",
      Ṥ: "S",
      ṥ: "s",
      X́: "X",
      x́: "x",
      Ѓ: "Г",
      ѓ: "г",
      Ќ: "К",
      ќ: "к",
      A̋: "A",
      a̋: "a",
      E̋: "E",
      e̋: "e",
      I̋: "I",
      i̋: "i",
      Ǹ: "N",
      ǹ: "n",
      Ồ: "O",
      ồ: "o",
      Ṑ: "O",
      ṑ: "o",
      Ừ: "U",
      ừ: "u",
      Ẁ: "W",
      ẁ: "w",
      Ỳ: "Y",
      ỳ: "y",
      Ȁ: "A",
      ȁ: "a",
      Ȅ: "E",
      ȅ: "e",
      Ȉ: "I",
      ȉ: "i",
      Ȍ: "O",
      ȍ: "o",
      Ȑ: "R",
      ȑ: "r",
      Ȕ: "U",
      ȕ: "u",
      B̌: "B",
      b̌: "b",
      Č̣: "C",
      č̣: "c",
      Ê̌: "E",
      ê̌: "e",
      F̌: "F",
      f̌: "f",
      Ǧ: "G",
      ǧ: "g",
      Ȟ: "H",
      ȟ: "h",
      J̌: "J",
      ǰ: "j",
      Ǩ: "K",
      ǩ: "k",
      M̌: "M",
      m̌: "m",
      P̌: "P",
      p̌: "p",
      Q̌: "Q",
      q̌: "q",
      Ř̩: "R",
      ř̩: "r",
      Ṧ: "S",
      ṧ: "s",
      V̌: "V",
      v̌: "v",
      W̌: "W",
      w̌: "w",
      X̌: "X",
      x̌: "x",
      Y̌: "Y",
      y̌: "y",
      A̧: "A",
      a̧: "a",
      B̧: "B",
      b̧: "b",
      Ḑ: "D",
      ḑ: "d",
      Ȩ: "E",
      ȩ: "e",
      Ɛ̧: "E",
      ɛ̧: "e",
      Ḩ: "H",
      ḩ: "h",
      I̧: "I",
      i̧: "i",
      Ɨ̧: "I",
      ɨ̧: "i",
      M̧: "M",
      m̧: "m",
      O̧: "O",
      o̧: "o",
      Q̧: "Q",
      q̧: "q",
      U̧: "U",
      u̧: "u",
      X̧: "X",
      x̧: "x",
      Z̧: "Z",
      z̧: "z",
      й: "и",
      Й: "И",
      ё: "е",
      Ё: "Е"
    },
    e = Object.keys(t).join("|"),
    i = new RegExp(e, "g"),
    l = new RegExp(e, "");
  function c(y) {
    return t[y];
  }
  var p = function (y) {
      return y.replace(i, c);
    },
    h = function (y) {
      return !!y.match(l);
    };
  return CT.exports = p, CT.exports.has = h, CT.exports.remove = p, CT.exports;
}
var Fpe = jpe();
const Npe = /* @__PURE__ */KO(Fpe),
  zpe = t => t.split("/").map(e => {
    let i = e;
    return i = Npe(i), i = i.replace(/^\s+|\s+$/g, ""), i = i.replace(/[-,;_=\s]+/g, "-"), i = i.replace(/[^-\w\s]/g, ""), i = i.toLowerCase(), i;
  }).join("/"),
  Vpe = (t = "en", e, i, l) => `/${t}/hotels${e && `/${e}`}${i && `/${i}`}/${l}`,
  Bpe = (t, e, i, l) => zpe(Vpe(N4(t), e, i, l)),
  Upe = "Something went wrong. Please try again.",
  Hpe = "_hotelSearch_yzx1w_1",
  $pe = {
    hotelSearch: Hpe
  },
  Wpe = ({
    locale: t,
    handleHotelSearch: e,
    labels: i,
    gatewayConfig: l,
    defaultErrorMessage: c = Upe
  }) => {
    const [p, h] = rt([]),
      [y, w] = rt(!1),
      [x, E] = rt(),
      [C, k] = rt(),
      D = Qfe(500, async O => {
        if (O.length > 2) {
          w(!0), E(void 0);
          try {
            const P = await Eae(t, O, {
              brand: "vwq",
              ...l
            });
            h(P.map(N => ({
              label: N.HotelName,
              value: `${N.RegionName}|${N.DestinationName}`,
              id: N.HotelCode
            })));
          } catch {
            E(c);
          } finally {
            w(!1);
          }
        }
      }),
      I = O => {
        var L;
        k(O);
        const [P, N] = ((L = O == null ? void 0 : O.value) == null ? void 0 : L.split("|")) || [];
        e == null || e(Bpe(t, P, N, O == null ? void 0 : O.label));
      };
    return /* @__PURE__ */B.jsx(B.Fragment, {
      children: /* @__PURE__ */B.jsx("div", {
        className: $pe.hotelSearch,
        children: /* @__PURE__ */B.jsx(Ape, {
          id: "hotel-search",
          template: "search",
          iconOptions: {
            input: /* @__PURE__ */B.jsx(sn, {
              name: "hotel"
            }),
            clear: /* @__PURE__ */B.jsx(sn, {
              name: "unavailable-micro"
            }),
            search: /* @__PURE__ */B.jsx(sn, {
              name: "search"
            })
          },
          data: [{
            title: "Hotels",
            displayTitle: !1,
            items: p
          }],
          isLoading: y,
          isInlineMode: !0,
          errorMessage: x,
          label: i.searchHotelsLabel,
          labels: i,
          selectedItem: C,
          onInput: O => D(O),
          onChange: I
        })
      })
    });
  },
  qpe = ({
    labels: t,
    locale: e,
    menuButtonProps: i,
    menuId: l = "main-menu-nav",
    menuLinks: c,
    mainLinks: p,
    defaultErrorMessage: h,
    renderLinks: y,
    altLangPages: w = [],
    renderLanguageToggle: x,
    currentGateway: E,
    handleChangeGateway: C,
    handleHotelSearch: k,
    disableHotelSearch: D,
    gatewayConfig: I,
    className: O
  }) => {
    const [P, N] = rt(!1),
      L = {
        ...Tz,
        ...t
      },
      F = () => {
        N(!P);
      };
    return /* @__PURE__ */B.jsxs("nav", {
      "aria-label": L.menuTitle,
      className: ge(Eu.menuContainer, O),
      children: [/* @__PURE__ */B.jsx("button", {
        ...i,
        type: "button",
        onClick: F,
        "aria-label": L.openMenu,
        "aria-expanded": P,
        "aria-controls": l
      }), /* @__PURE__ */B.jsx("div", {
        className: ge(P && Eu.backdrop)
      }), /* @__PURE__ */B.jsx("div", {
        id: l,
        className: ge(Eu.wrapper, P && Eu.wrapperOpen),
        children: /* @__PURE__ */B.jsxs(GN, {
          autoFocus: !1,
          enabled: P,
          shouldIgnore: j => !(j.id === "gatsby-focus-wrapper" && j.tabIndex === -1),
          onClickOutside: F,
          onEscapeKey: F,
          className: Eu.container,
          gapMode: "padding",
          children: [/* @__PURE__ */B.jsx(D8, {
            id: l,
            title: L.menuTitle,
            isOpen: P,
            handleClose: F
          }), !D && /* @__PURE__ */B.jsx(Wpe, {
            locale: e,
            handleHotelSearch: k,
            labels: L,
            defaultErrorMessage: h,
            gatewayConfig: I
          }), p && /* @__PURE__ */B.jsxs(B.Fragment, {
            children: [/* @__PURE__ */B.jsx(I8, {
              links: p,
              renderLinks: y,
              classNames: {
                ul: Eu.mainNav,
                linkText: Eu.linkText,
                li: np.navList,
                renderLink: np.navLink,
                icon: np.iconExternal
              }
            }), /* @__PURE__ */B.jsx("span", {
              className: ge(Eu.divider, Eu.mainNavDivider)
            })]
          }), /* @__PURE__ */B.jsx(Afe, {
            renderLinks: y,
            menuLinks: c,
            isMenuOpened: P
          }), /* @__PURE__ */B.jsx("span", {
            className: Eu.divider
          }), /* @__PURE__ */B.jsx(CR.div, {
            initial: !1,
            className: Eu.gatewayWrapper,
            animate: P ? "open" : "closed",
            children: /* @__PURE__ */B.jsx(Xfe, {
              labels: {
                closeMenu: L.closeMenu,
                openGatewayMenu: L.openGatewayMenu,
                changeGateway: L.changeGateway,
                gatewayHeader: L.gatewayHeader,
                closeModal: L.closeModal
              },
              currentGateway: E,
              handleChangeGateway: C
            })
          }), /* @__PURE__ */B.jsx("span", {
            className: Eu.divider
          }), x && /* @__PURE__ */B.jsx("div", {
            className: Eu.langToggleContainer,
            children: x(w, {
              classNames: {
                iconDown: Eu.iconDown,
                iconGlobe: Eu.iconGlobe,
                currentLanguage: Eu.currentLanguage
              },
              locale: e,
              select: {
                label: L.lang
              }
            })
          })]
        })
      })]
    });
  },
  Y_e = ({
    labels: t,
    classNames: e,
    backToHome: i,
    logoOnly: l = !1,
    logo: c,
    logoLink: p,
    renderLinkLogo: h,
    renderLanguageToggle: y,
    locale: w,
    altLangPages: x,
    links: E,
    renderLinks: C,
    menuLinks: k,
    checkActiveLink: D,
    currentGateway: I,
    handleChangeGateway: O,
    handleHotelSearch: P,
    disableHotelSearch: N,
    gatewayConfig: L,
    defaultErrorMessage: F,
    children: j
  }) => {
    const V = {
        ...Tz,
        ...t
      },
      K = wae(j);
    return /* @__PURE__ */B.jsxs("header", {
      className: ge(ni.headerContainer, e == null ? void 0 : e.header),
      children: [(i == null ? void 0 : i.url) && /* @__PURE__ */B.jsx("div", {
        className: ge(ni.backToHome, e == null ? void 0 : e.backToHomeContainer),
        children: C({
          href: i == null ? void 0 : i.url,
          target: "_self",
          className: ni.backToHomeMessage,
          children: /* @__PURE__ */B.jsxs(B.Fragment, {
            children: [/* @__PURE__ */B.jsx(sn, {
              name: "arrow-left",
              className: ni.backToHomeIcon,
              hidden: !0
            }), /* @__PURE__ */B.jsx("span", {
              className: ni.backToHomeText,
              children: (i == null ? void 0 : i.label) || V.backToHome
            })]
          })
        })
      }), /* @__PURE__ */B.jsx("div", {
        className: ni.headerTop,
        children: /* @__PURE__ */B.jsxs("div", {
          className: ge(ni.wrapper, e == null ? void 0 : e.headerTopWrapper),
          children: [!l && /* @__PURE__ */B.jsx(B.Fragment, {
            children: K.get("profile", G => /* @__PURE__ */B.jsx(B.Fragment, {
              children: G
            }))
          }), K.get("notifications", G => /* @__PURE__ */B.jsx(B.Fragment, {
            children: G
          }))]
        })
      }), /* @__PURE__ */B.jsx("div", {
        className: ni.header,
        children: /* @__PURE__ */B.jsxs("div", {
          className: ge(ni.headerWrapper, e == null ? void 0 : e.headerWrapper),
          children: [p && (c == null ? void 0 : c.desktop) && h({
            href: p,
            target: "_self",
            className: ge(ni.imageContainer, ni.imageContainerDesktop, e == null ? void 0 : e.logo)
          }, {
            ...c.desktop,
            className: ge(ni.image, c.desktop.className),
            width: c.desktop.width,
            height: c.desktop.height,
            src: c.desktop.src,
            alt: c.desktop.alt
          }), !p && (c == null ? void 0 : c.desktop) && /* @__PURE__ */B.jsx("div", {
            className: ge(ni.imageContainer, ni.imageContainerDesktop, e == null ? void 0 : e.logo),
            children: /* @__PURE__ */B.jsx("img", {
              className: ge(ni.image, c.desktop.className),
              src: c.desktop.src,
              alt: c.desktop.alt,
              width: c.desktop.width,
              height: c.desktop.height
            })
          }), p && (c == null ? void 0 : c.mobile) && h({
            href: p,
            target: "_self",
            className: ge(ni.imageContainer, ni.imageContainerMobile, e == null ? void 0 : e.logoMobile)
          }, {
            ...c.mobile,
            className: ge(ni.image, ni.imageContainerMobileImage, c.mobile.className),
            width: c.mobile.width,
            height: c.mobile.height,
            src: c.mobile.src,
            alt: c.mobile.alt
          }), !p && (c == null ? void 0 : c.mobile) && /* @__PURE__ */B.jsx("div", {
            className: ge(ni.imageContainer, ni.imageContainerMobile, e == null ? void 0 : e.logoMobile),
            children: /* @__PURE__ */B.jsx("img", {
              className: ge(ni.image, ni.imageContainerMobileImage, c.mobile.className),
              src: c.mobile.src,
              alt: c.mobile.alt,
              width: c.mobile.width,
              height: c.mobile.height
            })
          }), /* @__PURE__ */B.jsx("nav", {
            className: ni.nav,
            children: !l && /* @__PURE__ */B.jsxs(B.Fragment, {
              children: [/* @__PURE__ */B.jsx(I8, {
                links: E,
                renderLinks: C,
                classNames: {
                  ul: ni.ul,
                  li: ni.li,
                  linkText: ni.navLinkText,
                  icon: ni.header__nav__link__icon,
                  renderLink: G => ge(ni.navLink, {
                    [ni.active]: D(G.href)
                  })
                }
              }), k && /* @__PURE__ */B.jsx("div", {
                className: ni.menu,
                children: /* @__PURE__ */B.jsx(qpe, {
                  labels: V,
                  locale: w,
                  altLangPages: x,
                  defaultErrorMessage: F,
                  renderLanguageToggle: y,
                  renderLinks: C,
                  mainLinks: E,
                  menuLinks: k,
                  menuButtonProps: {
                    className: ni.menuButton,
                    children: /* @__PURE__ */B.jsx(sn, {
                      className: ni.menuIcon,
                      name: "menu"
                    })
                  },
                  currentGateway: I,
                  handleChangeGateway: O,
                  handleHotelSearch: P,
                  disableHotelSearch: N,
                  gatewayConfig: L,
                  className: e == null ? void 0 : e.menuContainer
                })
              })]
            })
          })]
        })
      }), K.get("widget", G => /* @__PURE__ */B.jsx(B.Fragment, {
        children: G
      }))]
    });
  },
  Ype = "_container_jq81d_1",
  Gpe = "_currentLanguageLabel_jq81d_9",
  Xpe = "_currentLanguage_jq81d_9",
  Kpe = "_dropDown_jq81d_20",
  Qpe = "_footerChevron_jq81d_44",
  Zpe = "_footerLangIcon_jq81d_62",
  sb = {
    container: Ype,
    currentLanguageLabel: Gpe,
    currentLanguage: Xpe,
    dropDown: Kpe,
    footerChevron: Qpe,
    footerLangIcon: Zpe
  },
  G_e = ({
    altLangPages: t,
    classNames: e,
    locale: i = "en-CA",
    renderLanguageSwitcher: l,
    variant: c = "toggle",
    navigationSwitcher: p,
    select: h = {
      label: "Language preference"
    }
  }) => {
    var k;
    const y = ((k = i == null ? void 0 : i.toLowerCase()) == null ? void 0 : k.substring(0, 2)) || "en",
      [w, x] = rt(y);
    let E = null;
    const C = D => (D == null ? void 0 : D.toLowerCase()) === "fr" ? "Français" : "English";
    if (c === "drop-down") {
      const D = I => {
        const {
          path: O
        } = I.target.options[I.target.selectedIndex].dataset;
        x(I.target.value), p(O, I.target.value);
      };
      E = /* @__PURE__ */B.jsxs(B.Fragment, {
        children: [/* @__PURE__ */B.jsx("label", {
          htmlFor: h.id,
          className: sb.currentLanguageLabel,
          children: h.label
        }), /* @__PURE__ */B.jsx("select", {
          className: ge(sb.currentLanguage, sb.dropDown, e == null ? void 0 : e.currentLanguage),
          onChange: D,
          id: h.id,
          value: w,
          children: t == null ? void 0 : t.map(({
            id: I,
            path: O,
            lang: P
          }) => {
            const N = P === w;
            return /* @__PURE__ */B.jsx("option", {
              "data-path": O,
              value: P,
              selected: N,
              children: C(P)
            }, I);
          })
        }), /* @__PURE__ */B.jsx(sn, {
          name: "globe",
          className: ge(sb.footerLangIcon, sb.dropDown, e == null ? void 0 : e.iconGlobe)
        }), /* @__PURE__ */B.jsx(sn, {
          name: "chevron-down",
          className: ge(sb.footerChevron, sb.dropDown, e == null ? void 0 : e.iconDown)
        })]
      });
    } else c === "toggle" && (E = t == null ? void 0 : t.map(({
      id: D,
      path: I,
      lang: O
    }) => {
      var N, L;
      const P = C(O);
      return ((N = i == null ? void 0 : i.toLowerCase()) == null ? void 0 : N.substring(0, 2)) === ((L = O == null ? void 0 : O.toLowerCase()) == null ? void 0 : L.substring(0, 2)) ? /* @__PURE__ */B.jsx("span", {
        "data-id": D,
        className: ge(e == null ? void 0 : e.currentLanguage, sb.currentLanguage),
        children: P
      }, D) : l ? l(D, I, O, e == null ? void 0 : e.altLanguage, P) : /* @__PURE__ */B.jsx("a", {
        className: e == null ? void 0 : e.altLanguage,
        href: I,
        children: P
      }, D);
    }));
    return /* @__PURE__ */B.jsx("div", {
      className: ge(sb.container, e == null ? void 0 : e.container),
      children: E
    });
  },
  Jpe = "_listContainer_7anjf_2",
  ehe = "_groupedList_7anjf_3",
  the = "_subList_7anjf_4",
  nhe = "_listItems_7anjf_9",
  rhe = "_sortItems_7anjf_10",
  ihe = "_subItemUrl_7anjf_26",
  ahe = "_chevronList_7anjf_31",
  ohe = "_bulletList_7anjf_31",
  she = "_numberedList_7anjf_31",
  lhe = "_chevronIcon_7anjf_72",
  uhe = "_groupedHeading_7anjf_108",
  W0 = {
    listContainer: Jpe,
    groupedList: ehe,
    subList: the,
    listItems: nhe,
    sortItems: rhe,
    subItemUrl: ihe,
    chevronList: ahe,
    bulletList: ohe,
    numberedList: she,
    chevronIcon: lhe,
    groupedHeading: uhe
  },
  X_e = ({
    list: t,
    listType: e = "chevron",
    renderLink: i
  }) => {
    const l = y => y.reduce((w, x) => {
        const E = x.text[0].toUpperCase();
        return w[E] ? w[E].list.push(x) : w[E] = {
          startingLetter: E,
          list: [x]
        }, w;
      }, {}),
      c = [...t].sort((y, w) => y.text.localeCompare(w.text)),
      p = e === "groupedByLetter" ? l(c) : null,
      h = e === "numbered" ? "ol" : "ul";
    return e === "groupedByLetter" && p ? /* @__PURE__ */B.jsx("ul", {
      className: W0.groupedList,
      children: Object.values(p).map(y => /* @__PURE__ */B.jsxs("li", {
        className: W0.item,
        children: [/* @__PURE__ */B.jsx(cu, {
          Tag: "h4",
          className: W0.groupedHeading,
          children: y.startingLetter
        }), /* @__PURE__ */B.jsx("ul", {
          className: W0.subList,
          children: y.list.map((w, x) => /* @__PURE__ */B.jsx("li", {
            children: /* @__PURE__ */B.jsx(fd, {
              href: w.href,
              target: w.target,
              renderLink: i,
              size: "md",
              children: w.text
            })
          }, `${w}-${x}`))
        })]
      }, y.startingLetter))
    }) : /* @__PURE__ */B.jsx(h, {
      className: ge(W0.listContainer, {
        [W0[`${e}List`]]: !0
      }),
      children: (e === "chevron" ? t : c).map((y, w) => /* @__PURE__ */B.jsx("li", {
        className: W0.listItem,
        children: /* @__PURE__ */B.jsxs(fd, {
          href: y.href,
          target: y.target,
          renderLink: i,
          size: "md",
          children: [y.text, e === "chevron" && /* @__PURE__ */B.jsx("span", {
            className: W0.chevronIcon,
            children: /* @__PURE__ */B.jsx(sn, {
              name: "chevron-right-micro",
              size: "md"
            })
          })]
        })
      }, `${y}-${w}`))
    });
  },
  che = "_themeTransparentWrapper_7rryr_2",
  dhe = "_inputLabel_7rryr_2",
  fhe = "_inputFocus_7rryr_5",
  phe = "_helperText_7rryr_8",
  hhe = "_themeDefaultWrapper_7rryr_12",
  mhe = "_themeGreyWrapper_7rryr_13",
  vhe = "_inputLabelError_7rryr_20",
  ghe = "_container_7rryr_25",
  yhe = "_error_7rryr_29",
  bhe = "_themeDefault_7rryr_12",
  whe = "_themeGrey_7rryr_13",
  _he = "_themeTransparent_7rryr_2",
  xhe = "_input_7rryr_2",
  She = "_border_7rryr_59",
  Ehe = "_inputError_7rryr_62",
  Che = "_inputButton_7rryr_65",
  khe = "_iconClear_7rryr_70",
  The = "_inputIcon_7rryr_73",
  Rhe = "_loading_7rryr_77",
  Dhe = "_inputButtonActive_7rryr_118",
  Ihe = "_show_7rryr_155",
  Mhe = "_hide_7rryr_158",
  Ohe = "_inputLabelDisabled_7rryr_195",
  Lhe = "_inputLoader_7rryr_210",
  Phe = "_textError_7rryr_231",
  jr = {
    themeTransparentWrapper: che,
    inputLabel: dhe,
    inputFocus: fhe,
    helperText: phe,
    themeDefaultWrapper: hhe,
    themeGreyWrapper: mhe,
    inputLabelError: vhe,
    container: ghe,
    error: yhe,
    themeDefault: bhe,
    themeGrey: whe,
    themeTransparent: _he,
    input: xhe,
    border: She,
    inputError: Ehe,
    inputButton: Che,
    iconClear: khe,
    inputIcon: The,
    loading: Rhe,
    inputButtonActive: Dhe,
    show: Ihe,
    hide: Mhe,
    inputLabelDisabled: Ohe,
    inputLoader: Lhe,
    textError: Phe
  },
  Ahe = Qn(({
    id: t,
    label: e,
    name: i,
    helperText: l,
    value: c,
    errorMessage: p,
    type: h = "text",
    readOnly: y,
    required: w,
    disabled: x,
    enableClearButton: E,
    displayClearLabel: C,
    labels: k,
    theme: D = "default",
    iconOptions: I,
    maskOptions: O,
    isLoading: P,
    className: N,
    classNames: L,
    onChange: F,
    onBlur: j,
    onFocus: V,
    onKeyUp: K,
    onAccept: G,
    ...Q
  }, te) => {
    const ie = vt(null),
      Y = vt(null);
    return jR(te, () => h === "mask" ? Y.current : ie.current, []), h === "mask" ? /* @__PURE__ */B.jsx(Bq, {
      ref: Y,
      type: "text",
      id: t,
      label: e,
      name: i,
      helperText: l,
      value: c,
      errorMessage: p,
      readOnly: y,
      required: w,
      disabled: x,
      enableClearButton: E,
      displayClearLabel: C,
      labels: k,
      iconOptions: {
        clear: (I == null ? void 0 : I.clear) || /* @__PURE__ */B.jsx(sn, {
          name: "close"
        }),
        disabled: (I == null ? void 0 : I.disabled) || /* @__PURE__ */B.jsx(sn, {
          name: "nope"
        })
      },
      isLoading: P,
      loaderConfig: {
        strokeColor: D === "transparent" ? gl.color.white.value : gl.color.teal[500].value,
        trackColor: D === "transparent" ? gl.color.white.value : gl.color.gray[500].value
      },
      maskOptions: O,
      onAccept: G,
      className: ge(jr.container, jr[`theme${oE.pascal(D)}`], N),
      classNames: {
        wrapper: ge(jr[`theme${oE.pascal(D)}Wrapper`], p && jr.inputLabelError, L == null ? void 0 : L.wrapper),
        input: ge(jr.input, P && jr.loading, L == null ? void 0 : L.input),
        inputBorder: ge(jr.border, L == null ? void 0 : L.inputBorder),
        inputButton: ge(jr.inputButton, L == null ? void 0 : L.inputButton),
        inputError: ge(jr.inputError, L == null ? void 0 : L.inputError),
        inputErrorText: ge(jr.textError, L == null ? void 0 : L.inputErrorText),
        inputFocus: ge(jr.inputFocus, L == null ? void 0 : L.inputFocus),
        inputHelperText: ge(jr.helperText, L == null ? void 0 : L.inputHelperText),
        inputLabel: ge(jr.inputLabel, L == null ? void 0 : L.inputLabel),
        inputLabelDisabled: ge(jr.inputLabelDisabled, L == null ? void 0 : L.inputLabelDisabled),
        iconClear: ge(jr.iconClear, L == null ? void 0 : L.iconClear),
        iconDisable: ge(jr.inputIcon, L == null ? void 0 : L.iconDisable),
        loader: ge(jr.inputLoader, L == null ? void 0 : L.loader),
        value: L == null ? void 0 : L.value
      },
      ...Q
    }) : /* @__PURE__ */B.jsx(L5, {
      ref: ie,
      id: t,
      label: e,
      name: i,
      helperText: l,
      value: c,
      errorMessage: p,
      type: h,
      readOnly: y,
      required: w,
      disabled: x,
      enableClearButton: E,
      displayClearLabel: C,
      labels: k,
      iconOptions: {
        clear: (I == null ? void 0 : I.clear) || /* @__PURE__ */B.jsx(sn, {
          name: "close"
        }),
        disabled: (I == null ? void 0 : I.disabled) || /* @__PURE__ */B.jsx(sn, {
          name: "nope"
        })
      },
      isLoading: P,
      loaderConfig: {
        strokeColor: D === "transparent" ? gl.color.white.value : gl.color.teal[500].value,
        trackColor: D === "transparent" ? gl.color.white.value : gl.color.gray[500].value
      },
      className: ge(jr.container, jr[`theme${oE.pascal(D)}`], P && jr.loading, N),
      classNames: {
        wrapper: ge(jr[`theme${oE.pascal(D)}Wrapper`], p && jr.inputLabelError, L == null ? void 0 : L.wrapper),
        input: ge(jr.input, P && jr.loading, L == null ? void 0 : L.input),
        inputBorder: ge(jr.border, L == null ? void 0 : L.inputBorder),
        inputButton: ge(jr.inputButton, L == null ? void 0 : L.inputButton),
        inputError: ge(jr.inputError, L == null ? void 0 : L.inputError),
        inputErrorText: ge(jr.textError, L == null ? void 0 : L.inputErrorText),
        inputFocus: ge(jr.inputFocus, L == null ? void 0 : L.inputFocus),
        inputHelperText: ge(jr.helperText, L == null ? void 0 : L.inputHelperText),
        inputLabel: ge(jr.inputLabel, L == null ? void 0 : L.inputLabel),
        inputLabelDisabled: ge(jr.inputLabelDisabled, L == null ? void 0 : L.inputLabelDisabled),
        iconClear: ge(jr.iconClear, L == null ? void 0 : L.iconClear),
        iconDisable: ge(jr.inputIcon, L == null ? void 0 : L.iconDisable),
        loader: ge(jr.inputLoader, L == null ? void 0 : L.loader),
        value: L == null ? void 0 : L.value
      },
      onChange: F,
      onBlur: j,
      onFocus: V,
      onKeyUp: K,
      ...Q
    });
  }),
  jhe = "_button_f18wy_134",
  Fhe = "_bookendButton_f18wy_134",
  Nhe = "_trigger_f18wy_134",
  zhe = "_scrollButton_f18wy_134",
  Vhe = "_tabsContainer_f18wy_140",
  Bhe = "_tabsWrapper_f18wy_145",
  Uhe = "_tabsContentWrapper_f18wy_152",
  Hhe = "_tablist_f18wy_156",
  $he = "_triggerText_f18wy_216",
  Whe = "_white_f18wy_250",
  qhe = "_grey_f18wy_254",
  Yhe = "_gray_f18wy_255",
  Ghe = "_bookend_f18wy_134",
  Xhe = "_bookendContent_f18wy_270",
  Khe = "_bookendTitle_f18wy_291",
  Qhe = "_bookendSubtitle_f18wy_297",
  Zhe = "_border_f18wy_304",
  Jhe = "_icon_f18wy_308",
  eme = "_asNavigation_f18wy_317",
  yl = {
    button: jhe,
    bookendButton: Fhe,
    trigger: Nhe,
    scrollButton: zhe,
    tabsContainer: Vhe,
    tabsWrapper: Bhe,
    tabsContentWrapper: Uhe,
    tablist: Hhe,
    triggerText: $he,
    white: Whe,
    grey: qhe,
    gray: Yhe,
    bookend: Ghe,
    bookendContent: Xhe,
    bookendTitle: Khe,
    bookendSubtitle: Qhe,
    border: Zhe,
    icon: Jhe,
    asNavigation: eme
  },
  gF = ({
    title: t,
    subTitle: e,
    ...i
  }) => /* @__PURE__ */B.jsx(sa.button, {
    className: yl.bookendButton,
    "data-state": i.disabled ? "inactive" : "active",
    ...i,
    children: /* @__PURE__ */B.jsxs(sa.div, {
      className: yl.bookendContent,
      children: [/* @__PURE__ */B.jsx("span", {
        className: yl.bookendTitle,
        children: t
      }), e && /* @__PURE__ */B.jsx("span", {
        className: yl.bookendSubtitle,
        children: e
      })]
    })
  }),
  tme = ({
    backgroundColor: t = "white",
    border: e = !1,
    leftTitle: i,
    leftSubHeading: l,
    rightSubHeading: c,
    rightTitle: p,
    ...h
  }) => {
    const y = zE("Tabs", h.__scopeTabs),
      [w, x] = rt(!0),
      [E, C] = rt(!1),
      k = () => {
        const O = Array.from(document.querySelectorAll(`[id^="${y.baseId}-trigger-"]`)).map(N => ({
            value: N.id.split("-").pop(),
            disabled: N.hasAttribute("disabled")
          })),
          P = O.findIndex(N => N.value === y.value);
        return {
          tabInfo: O,
          currentIndex: P
        };
      };
    Rt(() => {
      const {
          tabInfo: I,
          currentIndex: O
        } = k(),
        P = I.slice(0, O).reverse().findIndex(L => !L.disabled);
      C(P !== -1);
      const N = I.slice(O + 1).findIndex(L => !L.disabled);
      x(N !== -1);
    }, [y.value, y.baseId]);
    const D = I => {
      if (!y.value) return;
      const {
        tabInfo: O,
        currentIndex: P
      } = k();
      if (I === "next") {
        const N = O.slice(P + 1).find(L => !L.disabled);
        N && y.onValueChange(N.value);
      } else {
        const N = O.slice(0, P).reverse().find(L => !L.disabled);
        N && y.onValueChange(N.value);
      }
    };
    return /* @__PURE__ */B.jsxs(sa.div, {
      ...h,
      className: ge(yl.bookend, yl[t], e && yl.border),
      children: [/* @__PURE__ */B.jsx(gF, {
        title: i,
        subTitle: l,
        onClick: () => D("previous"),
        disabled: !E
      }), /* @__PURE__ */B.jsx(gF, {
        title: p,
        subTitle: c,
        onClick: () => D("next"),
        disabled: !w
      })]
    });
  },
  nme = ({
    backgroundColor: t = "white",
    asNav: e = !1,
    label: i,
    ...l
  }) => {
    const p = dN() === "rtl",
      h = vt(null),
      [y, w] = rt(!1),
      x = zE("TabsList", l.__scopeTabs),
      [E, C] = rt(!0),
      [k, D] = rt(!1),
      I = () => {
        const P = h.current;
        if (!P) return;
        const N = P.querySelector('[data-state="active"]');
        if (!N) return;
        const L = N.offsetLeft;
        P.scrollLeft = L - (P.clientWidth - N.offsetWidth) / 2;
      };
    Rt(() => {
      const P = h.current;
      if (!P) return;
      const N = new ResizeObserver(() => {
        const L = P.scrollWidth > P.clientWidth;
        w(L), L && I();
      });
      return N.observe(P), () => N.disconnect();
    }, []), Rt(() => {
      const P = document.querySelectorAll(`[id^="${x.baseId}-trigger-"]`),
        N = Array.from(P).map(F => F.id.split(`${x.baseId}-trigger-`).pop()).filter(Boolean),
        L = N.indexOf(x.value);
      D(L > 0), C(L < N.length - 1), requestAnimationFrame(I);
    }, [x.value, x.baseId]);
    const O = P => {
      if (!x.value) return;
      const N = document.querySelectorAll(`[id^="${x.baseId}-trigger-"]`),
        L = Array.from(N).map(K => K.id.split(`${x.baseId}-trigger-`).pop()).filter(Boolean),
        F = L.indexOf(x.value),
        j = P === "next" ? Math.min(F + 1, L.length - 1) : Math.max(F - 1, 0),
        V = L[j];
      x.onValueChange(V);
    };
    return /* @__PURE__ */B.jsxs("div", {
      className: ge(yl.tabsWrapper, yl[t], e && yl.asNavigation),
      children: [y && /* @__PURE__ */B.jsx(sa.button, {
        onClick: () => O("previous"),
        className: yl.scrollButton,
        disabled: !k,
        "data-state": k ? "active" : "inactive",
        "aria-label": p ? "Next tab" : "Previous tab",
        children: /* @__PURE__ */B.jsx(sn, {
          name: p ? "chevron-right" : "chevron-left",
          "aria-hidden": !0
        })
      }), /* @__PURE__ */B.jsx(O4, {
        ...l,
        className: yl.tablist,
        ref: h,
        "aria-label": i
      }), y && /* @__PURE__ */B.jsx(sa.button, {
        onClick: () => O("next"),
        className: yl.scrollButton,
        disabled: !E,
        "data-state": E ? "active" : "inactive",
        "aria-label": p ? "Previous tab" : "Next tab",
        children: /* @__PURE__ */B.jsx(sn, {
          name: p ? "chevron-left" : "chevron-right",
          "aria-hidden": !0
        })
      })]
    });
  },
  rme = ({
    children: t,
    icon: e,
    ...i
  }) => /* @__PURE__ */B.jsxs(j4, {
    ...i,
    className: ge(yl.button, yl.trigger),
    children: [e && /* @__PURE__ */B.jsx(sn, {
      name: e,
      className: yl.icon,
      "aria-hidden": !0
    }), /* @__PURE__ */B.jsx("span", {
      className: yl.triggerText,
      children: t
    })]
  }),
  ime = ({
    __scopeTabs: t,
    disableAutoScroll: e = !1,
    scrollOffset: i = "100px",
    ...l
  }) => {
    const c = zE("TabsContent", t),
      p = vt(null),
      h = vt(!0);
    return Rt(() => {
      if (h.current) {
        h.current = !1;
        return;
      }
      !c.value || !p.current || e || (p.current.style.scrollMarginTop = i, setTimeout(() => {
        var y;
        (y = p.current) == null || y.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }, 100));
    }, [c.value, e, i]), /* @__PURE__ */B.jsx(A4, {
      ref: p,
      ...l
    });
  },
  mb = ({
    isSticky: t = !0,
    ...e
  }) => /* @__PURE__ */B.jsx(sa.div, {
    className: yl.tabsContainer,
    "data-sticky": t,
    children: /* @__PURE__ */B.jsx(T7, {
      dir: e.dir ?? "ltr",
      children: /* @__PURE__ */B.jsx(YK, {
        ...e
      })
    })
  });
mb.List = nme;
mb.Trigger = rme;
mb.Content = ime;
mb.Bookend = tme;
mb.BookendButton = gF;
var QM = {
    exports: {}
  },
  ame = QM.exports,
  lU;
function O8() {
  return lU || (lU = 1, function (t, e) {
    (function (i, l) {
      t.exports = l();
    })(ame, function () {
      var i = 1e3,
        l = 6e4,
        c = 36e5,
        p = "millisecond",
        h = "second",
        y = "minute",
        w = "hour",
        x = "day",
        E = "week",
        C = "month",
        k = "quarter",
        D = "year",
        I = "date",
        O = "Invalid Date",
        P = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,
        N = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
        L = {
          name: "en",
          weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
          months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
          ordinal: function (ne) {
            var se = ["th", "st", "nd", "rd"],
              ue = ne % 100;
            return "[" + ne + (se[(ue - 20) % 10] || se[ue] || se[0]) + "]";
          }
        },
        F = function (ne, se, ue) {
          var W = String(ne);
          return !W || W.length >= se ? ne : "" + Array(se + 1 - W.length).join(ue) + ne;
        },
        j = {
          s: F,
          z: function (ne) {
            var se = -ne.utcOffset(),
              ue = Math.abs(se),
              W = Math.floor(ue / 60),
              $ = ue % 60;
            return (se <= 0 ? "+" : "-") + F(W, 2, "0") + ":" + F($, 2, "0");
          },
          m: function ne(se, ue) {
            if (se.date() < ue.date()) return -ne(ue, se);
            var W = 12 * (ue.year() - se.year()) + (ue.month() - se.month()),
              $ = se.clone().add(W, C),
              le = ue - $ < 0,
              H = se.clone().add(W + (le ? -1 : 1), C);
            return +(-(W + (ue - $) / (le ? $ - H : H - $)) || 0);
          },
          a: function (ne) {
            return ne < 0 ? Math.ceil(ne) || 0 : Math.floor(ne);
          },
          p: function (ne) {
            return {
              M: C,
              y: D,
              w: E,
              d: x,
              D: I,
              h: w,
              m: y,
              s: h,
              ms: p,
              Q: k
            }[ne] || String(ne || "").toLowerCase().replace(/s$/, "");
          },
          u: function (ne) {
            return ne === void 0;
          }
        },
        V = "en",
        K = {};
      K[V] = L;
      var G = "$isDayjsObject",
        Q = function (ne) {
          return ne instanceof ee || !(!ne || !ne[G]);
        },
        te = function ne(se, ue, W) {
          var $;
          if (!se) return V;
          if (typeof se == "string") {
            var le = se.toLowerCase();
            K[le] && ($ = le), ue && (K[le] = ue, $ = le);
            var H = se.split("-");
            if (!$ && H.length > 1) return ne(H[0]);
          } else {
            var ce = se.name;
            K[ce] = se, $ = ce;
          }
          return !W && $ && (V = $), $ || !W && V;
        },
        ie = function (ne, se) {
          if (Q(ne)) return ne.clone();
          var ue = typeof se == "object" ? se : {};
          return ue.date = ne, ue.args = arguments, new ee(ue);
        },
        Y = j;
      Y.l = te, Y.i = Q, Y.w = function (ne, se) {
        return ie(ne, {
          locale: se.$L,
          utc: se.$u,
          x: se.$x,
          $offset: se.$offset
        });
      };
      var ee = function () {
          function ne(ue) {
            this.$L = te(ue.locale, null, !0), this.parse(ue), this.$x = this.$x || ue.x || {}, this[G] = !0;
          }
          var se = ne.prototype;
          return se.parse = function (ue) {
            this.$d = function (W) {
              var $ = W.date,
                le = W.utc;
              if ($ === null) return /* @__PURE__ */new Date(NaN);
              if (Y.u($)) return /* @__PURE__ */new Date();
              if ($ instanceof Date) return new Date($);
              if (typeof $ == "string" && !/Z$/i.test($)) {
                var H = $.match(P);
                if (H) {
                  var ce = H[2] - 1 || 0,
                    de = (H[7] || "0").substring(0, 3);
                  return le ? new Date(Date.UTC(H[1], ce, H[3] || 1, H[4] || 0, H[5] || 0, H[6] || 0, de)) : new Date(H[1], ce, H[3] || 1, H[4] || 0, H[5] || 0, H[6] || 0, de);
                }
              }
              return new Date($);
            }(ue), this.init();
          }, se.init = function () {
            var ue = this.$d;
            this.$y = ue.getFullYear(), this.$M = ue.getMonth(), this.$D = ue.getDate(), this.$W = ue.getDay(), this.$H = ue.getHours(), this.$m = ue.getMinutes(), this.$s = ue.getSeconds(), this.$ms = ue.getMilliseconds();
          }, se.$utils = function () {
            return Y;
          }, se.isValid = function () {
            return this.$d.toString() !== O;
          }, se.isSame = function (ue, W) {
            var $ = ie(ue);
            return this.startOf(W) <= $ && $ <= this.endOf(W);
          }, se.isAfter = function (ue, W) {
            return ie(ue) < this.startOf(W);
          }, se.isBefore = function (ue, W) {
            return this.endOf(W) < ie(ue);
          }, se.$g = function (ue, W, $) {
            return Y.u(ue) ? this[W] : this.set($, ue);
          }, se.unix = function () {
            return Math.floor(this.valueOf() / 1e3);
          }, se.valueOf = function () {
            return this.$d.getTime();
          }, se.startOf = function (ue, W) {
            var $ = this,
              le = !!Y.u(W) || W,
              H = Y.p(ue),
              ce = function (Te, ze) {
                var Xe = Y.w($.$u ? Date.UTC($.$y, ze, Te) : new Date($.$y, ze, Te), $);
                return le ? Xe : Xe.endOf(x);
              },
              de = function (Te, ze) {
                return Y.w($.toDate()[Te].apply($.toDate("s"), (le ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(ze)), $);
              },
              Ce = this.$W,
              Ee = this.$M,
              fe = this.$D,
              xe = "set" + (this.$u ? "UTC" : "");
            switch (H) {
              case D:
                return le ? ce(1, 0) : ce(31, 11);
              case C:
                return le ? ce(1, Ee) : ce(0, Ee + 1);
              case E:
                var we = this.$locale().weekStart || 0,
                  ve = (Ce < we ? Ce + 7 : Ce) - we;
                return ce(le ? fe - ve : fe + (6 - ve), Ee);
              case x:
              case I:
                return de(xe + "Hours", 0);
              case w:
                return de(xe + "Minutes", 1);
              case y:
                return de(xe + "Seconds", 2);
              case h:
                return de(xe + "Milliseconds", 3);
              default:
                return this.clone();
            }
          }, se.endOf = function (ue) {
            return this.startOf(ue, !1);
          }, se.$set = function (ue, W) {
            var $,
              le = Y.p(ue),
              H = "set" + (this.$u ? "UTC" : ""),
              ce = ($ = {}, $[x] = H + "Date", $[I] = H + "Date", $[C] = H + "Month", $[D] = H + "FullYear", $[w] = H + "Hours", $[y] = H + "Minutes", $[h] = H + "Seconds", $[p] = H + "Milliseconds", $)[le],
              de = le === x ? this.$D + (W - this.$W) : W;
            if (le === C || le === D) {
              var Ce = this.clone().set(I, 1);
              Ce.$d[ce](de), Ce.init(), this.$d = Ce.set(I, Math.min(this.$D, Ce.daysInMonth())).$d;
            } else ce && this.$d[ce](de);
            return this.init(), this;
          }, se.set = function (ue, W) {
            return this.clone().$set(ue, W);
          }, se.get = function (ue) {
            return this[Y.p(ue)]();
          }, se.add = function (ue, W) {
            var $,
              le = this;
            ue = Number(ue);
            var H = Y.p(W),
              ce = function (Ee) {
                var fe = ie(le);
                return Y.w(fe.date(fe.date() + Math.round(Ee * ue)), le);
              };
            if (H === C) return this.set(C, this.$M + ue);
            if (H === D) return this.set(D, this.$y + ue);
            if (H === x) return ce(1);
            if (H === E) return ce(7);
            var de = ($ = {}, $[y] = l, $[w] = c, $[h] = i, $)[H] || 1,
              Ce = this.$d.getTime() + ue * de;
            return Y.w(Ce, this);
          }, se.subtract = function (ue, W) {
            return this.add(-1 * ue, W);
          }, se.format = function (ue) {
            var W = this,
              $ = this.$locale();
            if (!this.isValid()) return $.invalidDate || O;
            var le = ue || "YYYY-MM-DDTHH:mm:ssZ",
              H = Y.z(this),
              ce = this.$H,
              de = this.$m,
              Ce = this.$M,
              Ee = $.weekdays,
              fe = $.months,
              xe = $.meridiem,
              we = function (ze, Xe, ye, qe) {
                return ze && (ze[Xe] || ze(W, le)) || ye[Xe].slice(0, qe);
              },
              ve = function (ze) {
                return Y.s(ce % 12 || 12, ze, "0");
              },
              Te = xe || function (ze, Xe, ye) {
                var qe = ze < 12 ? "AM" : "PM";
                return ye ? qe.toLowerCase() : qe;
              };
            return le.replace(N, function (ze, Xe) {
              return Xe || function (ye) {
                switch (ye) {
                  case "YY":
                    return String(W.$y).slice(-2);
                  case "YYYY":
                    return Y.s(W.$y, 4, "0");
                  case "M":
                    return Ce + 1;
                  case "MM":
                    return Y.s(Ce + 1, 2, "0");
                  case "MMM":
                    return we($.monthsShort, Ce, fe, 3);
                  case "MMMM":
                    return we(fe, Ce);
                  case "D":
                    return W.$D;
                  case "DD":
                    return Y.s(W.$D, 2, "0");
                  case "d":
                    return String(W.$W);
                  case "dd":
                    return we($.weekdaysMin, W.$W, Ee, 2);
                  case "ddd":
                    return we($.weekdaysShort, W.$W, Ee, 3);
                  case "dddd":
                    return Ee[W.$W];
                  case "H":
                    return String(ce);
                  case "HH":
                    return Y.s(ce, 2, "0");
                  case "h":
                    return ve(1);
                  case "hh":
                    return ve(2);
                  case "a":
                    return Te(ce, de, !0);
                  case "A":
                    return Te(ce, de, !1);
                  case "m":
                    return String(de);
                  case "mm":
                    return Y.s(de, 2, "0");
                  case "s":
                    return String(W.$s);
                  case "ss":
                    return Y.s(W.$s, 2, "0");
                  case "SSS":
                    return Y.s(W.$ms, 3, "0");
                  case "Z":
                    return H;
                }
                return null;
              }(ze) || H.replace(":", "");
            });
          }, se.utcOffset = function () {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
          }, se.diff = function (ue, W, $) {
            var le,
              H = this,
              ce = Y.p(W),
              de = ie(ue),
              Ce = (de.utcOffset() - this.utcOffset()) * l,
              Ee = this - de,
              fe = function () {
                return Y.m(H, de);
              };
            switch (ce) {
              case D:
                le = fe() / 12;
                break;
              case C:
                le = fe();
                break;
              case k:
                le = fe() / 3;
                break;
              case E:
                le = (Ee - Ce) / 6048e5;
                break;
              case x:
                le = (Ee - Ce) / 864e5;
                break;
              case w:
                le = Ee / c;
                break;
              case y:
                le = Ee / l;
                break;
              case h:
                le = Ee / i;
                break;
              default:
                le = Ee;
            }
            return $ ? le : Y.a(le);
          }, se.daysInMonth = function () {
            return this.endOf(C).$D;
          }, se.$locale = function () {
            return K[this.$L];
          }, se.locale = function (ue, W) {
            if (!ue) return this.$L;
            var $ = this.clone(),
              le = te(ue, W, !0);
            return le && ($.$L = le), $;
          }, se.clone = function () {
            return Y.w(this.$d, this);
          }, se.toDate = function () {
            return new Date(this.valueOf());
          }, se.toJSON = function () {
            return this.isValid() ? this.toISOString() : null;
          }, se.toISOString = function () {
            return this.$d.toISOString();
          }, se.toString = function () {
            return this.$d.toUTCString();
          }, ne;
        }(),
        oe = ee.prototype;
      return ie.prototype = oe, [["$ms", p], ["$s", h], ["$m", y], ["$H", w], ["$W", x], ["$M", C], ["$y", D], ["$D", I]].forEach(function (ne) {
        oe[ne[1]] = function (se) {
          return this.$g(se, ne[0], ne[1]);
        };
      }), ie.extend = function (ne, se) {
        return ne.$i || (ne(se, ee, ie), ne.$i = !0), ie;
      }, ie.locale = te, ie.isDayjs = Q, ie.unix = function (ne) {
        return ie(1e3 * ne);
      }, ie.en = K[V], ie.Ls = K, ie.p = {}, ie;
    });
  }(QM)), QM.exports;
}
var ome = O8();
const LO = /* @__PURE__ */KO(ome),
  sme = "_loadMore_wh702_32",
  lme = {
    loadMore: sme
  },
  ume = {
    loadAll: "Load all",
    loadMore: "Load more"
  },
  cme = ({
    labels: t,
    numberToShow: e = 6,
    moreToShow: i = 6,
    cardsPerRow: l = 3,
    children: c
  }) => {
    const [p, h] = rt(e),
      y = {
        ...ume,
        ...t
      },
      w = Nt.Children.count(c);
    Rt(() => {
      h(e);
    }, [c, e]);
    const x = w > e && p < w,
      E = w - p <= i,
      C = () => {
        const k = Math.min(p + i, w);
        h(k);
      };
    return /* @__PURE__ */B.jsxs(B.Fragment, {
      children: [/* @__PURE__ */B.jsx(NE, {
        cols: l,
        "aria-live": "polite",
        children: Nt.Children.map(c, (k, D) => {
          if (D < p) {
            const I = typeof k == "function" ? k({
              index: D,
              totalItems: w,
              isVisible: !0
            }) : k;
            return /* @__PURE__ */B.jsx(gb, {
              children: I
            }, D);
          }
          return null;
        })
      }), x && /* @__PURE__ */B.jsx(op, {
        variant: "utility",
        className: lme.loadMore,
        icon: "double-chevron-down-micro",
        iconPlacement: "right",
        onClick: C,
        "aria-controls": "cards-grid",
        "aria-label": E ? `${y.loadAll}. Showing ${p} of ${w} items.` : `${y.loadMore}. Showing ${p} of ${w} items.`,
        children: E ? y.loadAll : y.loadMore
      })]
    });
  },
  uU = {
    localeEn: "en-CA",
    localeFr: "fr-CA"
  },
  L8 = t => t ? t === "en-CA" || t === "fr-CA" ? t : t in uU ? uU[t] : (console.warn(`Invalid locale provided: ${t}. Falling back to en-CA.`), "en-CA") : "en-CA",
  dme = t => t.reduce((e, i) => {
    const {
        Destination: {
          Name: l,
          CountryName: c
        }
      } = i,
      p = {
        label: l,
        value: l,
        countryName: c
      },
      h = e.find(y => y.title === c);
    return h ? h.items.some(y => y.value === p.value) || (h.items.push(p), h.items.sort((y, w) => (y.label || "").localeCompare(w.label || ""))) : e.push({
      title: c,
      items: [p]
    }), e;
  }, []).sort((e, i) => (e.title || "").localeCompare(i.title || "")),
  fme = (t, e, i) => {
    let l = [...e];
    const c = p => {
      const h = i.find(y => y.title === p);
      return h ? h.items : [];
    };
    if (t.isGroupTitle) {
      const p = t.title;
      if (!p) return l;
      const h = c(p);
      l.filter(w => w.countryName === p && !w.isGroupTitle).length === h.length && h.length > 0 ? (l = l.filter(w => w.countryName !== p), l = l.filter(w => !(w.isGroupTitle && (w.title === p || w.label === p)))) : (l = l.filter(w => w.countryName !== p), l = l.filter(w => !(w.isGroupTitle && (w.title === p || w.label === p))), h.length > 0 ? (l.push(...h), l.push({
        label: p,
        title: p,
        value: p,
        isGroupTitle: !0
      })) : l.push({
        label: p,
        value: p,
        countryName: p
      }));
    } else if (t.countryName) {
      e.some(w => w.value === t.value) ? l = l.filter(w => w.value !== t.value) : l.push(t);
      const h = c(t.countryName),
        y = l.filter(w => w.countryName === t.countryName && !w.isGroupTitle);
      l = l.filter(w => !(w.isGroupTitle && (w.title === t.countryName || w.label === t.countryName))), y.length === h.length && h.length > 0 && l.push({
        label: t.countryName,
        title: t.countryName,
        value: t.countryName,
        isGroupTitle: !0
      });
    }
    return l;
  },
  pme = (t, e) => [...new Set(t.filter(l => {
    var c;
    return ((c = l.AccommodationInfo) == null ? void 0 : c.StarRating) != null;
  }).map(l => Math.floor(l.AccommodationInfo.StarRating)))].sort((l, c) => c - l).map(l => ({
    id: l.toString(),
    label: e === "fr-CA" ? l === 5 ? l.toString() : `${l.toString()} et en haut` : e === "en-CA" ? l === 5 ? l.toString() : `${l.toString()} & up` : l.toString(),
    value: l
  })),
  hme = t => [{
    label: t.priceLowToHigh,
    value: "priceLowToHigh",
    id: "priceLowToHigh"
  }, {
    label: t.priceHighToLow,
    value: "priceHighToLow",
    id: "priceHighToLow"
  }, {
    label: t.starRatingLowToHigh,
    value: "starRatingLowToHigh",
    id: "starRatingLowToHigh"
  }, {
    label: t.starRatingHighToLow,
    value: "starRatingHighToLow",
    id: "starRatingHighToLow"
  }, {
    label: t.hotelAz,
    value: "hotelAz",
    id: "hotelAz"
  }, {
    label: t.hotelZa,
    value: "hotelZa",
    id: "hotelZa"
  }, {
    label: t.departureEarliest,
    value: "departureEarliest",
    id: "departureEarliest"
  }],
  mme = (t, e) => {
    if (!e || e.length === 0) return t;
    const i = e.filter(l => !l.isGroupTitle);
    return i.length === 0 ? t : t.filter(({
      Destination: {
        Name: l
      }
    }) => i.some(({
      label: c
    }) => l === c));
  },
  vme = (t, e) => e ? t.filter(({
    Price: i
  }) => i >= e[0] && i <= e[1]) : t,
  gme = (t, e) => e ? t.filter(i => i.AccommodationInfo && Math.floor(i.AccommodationInfo.StarRating) >= Number(e.value)) : t,
  yme = (t, e) => {
    switch (e) {
      case "priceHighToLow":
        return t.sort((i, l) => l.Price - i.Price);
      case "starRatingLowToHigh":
        return t.filter(i => i.AccommodationInfo).sort((i, l) => i.AccommodationInfo.StarRating - l.AccommodationInfo.StarRating);
      case "starRatingHighToLow":
        return t.filter(i => i.AccommodationInfo).sort((i, l) => l.AccommodationInfo.StarRating - i.AccommodationInfo.StarRating);
      case "hotelAz":
        return t.filter(i => i.AccommodationInfo).sort((i, l) => i.AccommodationInfo.AccommodationName.localeCompare(l.AccommodationInfo.AccommodationName));
      case "hotelZa":
        return t.filter(i => i.AccommodationInfo).sort((i, l) => l.AccommodationInfo.AccommodationName.localeCompare(i.AccommodationInfo.AccommodationName));
      case "departureEarliest":
        return t.sort((i, l) => new Date(i.DepartureDate).getTime() - new Date(l.DepartureDate).getTime());
      case "priceLowToHigh":
      default:
        return t.sort((i, l) => i.Price - l.Price);
    }
  },
  P8 = t => {
    if (t) return [...t].sort((e, i) => e.Price - i.Price);
  };
var ZM = {
    exports: {}
  },
  bme = ZM.exports,
  cU;
function wme() {
  return cU || (cU = 1, function (t, e) {
    (function (i, l) {
      t.exports = l(O8());
    })(bme, function (i) {
      function l(h) {
        return h && typeof h == "object" && "default" in h ? h : {
          default: h
        };
      }
      var c = l(i),
        p = {
          name: "fr",
          weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
          weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
          weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
          months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
          monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
          weekStart: 1,
          yearStart: 4,
          formats: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
          },
          relativeTime: {
            future: "dans %s",
            past: "il y a %s",
            s: "quelques secondes",
            m: "une minute",
            mm: "%d minutes",
            h: "une heure",
            hh: "%d heures",
            d: "un jour",
            dd: "%d jours",
            M: "un mois",
            MM: "%d mois",
            y: "un an",
            yy: "%d ans"
          },
          ordinal: function (h) {
            return "" + h + (h === 1 ? "er" : "");
          }
        };
      return c.default.locale(p, null, !0), p;
    });
  }(ZM)), ZM.exports;
}
wme();
const _me = t => {
    var h, y, w, x;
    const [e, i] = rt(t),
      [l, c] = rt(!1);
    let p = 0;
    return Rt(() => {
      var k, D, I, O, P, N, L, F;
      const E = {
          destinations: (e == null ? void 0 : e.destinationSelections.map(j => ({
            title: j.title,
            value: j.value,
            countryName: j.countryName
          }))) || [],
          priceValue: (e == null ? void 0 : e.priceValue) || null,
          starRating: {
            id: (k = e == null ? void 0 : e.starRatingSelection) == null ? void 0 : k.id,
            value: (D = e == null ? void 0 : e.starRatingSelection) == null ? void 0 : D.value
          },
          sortingOption: {
            id: (I = e == null ? void 0 : e.sortingOptionSelection) == null ? void 0 : I.id,
            value: (O = e == null ? void 0 : e.sortingOptionSelection) == null ? void 0 : O.value
          }
        },
        C = {
          destinations: (t == null ? void 0 : t.destinationSelections.map(j => ({
            title: j.title,
            value: j.value,
            countryName: j.countryName
          }))) || [],
          priceValue: (t == null ? void 0 : t.priceValue) || null,
          starRating: {
            id: (P = t == null ? void 0 : t.starRatingSelection) == null ? void 0 : P.id,
            value: (N = t == null ? void 0 : t.starRatingSelection) == null ? void 0 : N.value
          },
          sortingOption: {
            id: (L = t == null ? void 0 : t.sortingOptionSelection) == null ? void 0 : L.id,
            value: (F = t == null ? void 0 : t.sortingOptionSelection) == null ? void 0 : F.value
          }
        };
      JSON.stringify(E) !== JSON.stringify(C) ? c(!0) : c(!1);
    }, [e, t]), t && (t.destinationSelections.length !== 0 && JSON.stringify(t.destinationSelections) !== JSON.stringify(e == null ? void 0 : e.destinationSelections) && (p += 1), JSON.stringify(t.priceValue) !== JSON.stringify(e == null ? void 0 : e.priceValue) && (p += 1), ((h = t.starRatingSelection) == null ? void 0 : h.value) !== ((y = e == null ? void 0 : e.starRatingSelection) == null ? void 0 : y.value) && (p += 1), ((w = t.sortingOptionSelection) == null ? void 0 : w.value) !== ((x = e == null ? void 0 : e.sortingOptionSelection) == null ? void 0 : x.value) && (p += 1)), {
      hasFiltersChanged: l,
      setAppliedFilters: i,
      numberOfFilters: p,
      appliedFilters: e
    };
  },
  xme = "_groupLabel_11as3_1",
  Sme = "_description_11as3_8",
  Eme = "_errorMessage_11as3_14",
  Cme = "_inline_11as3_21",
  kme = "_fieldset_11as3_21",
  Tme = "_wrapper_11as3_21",
  Rme = "_options_11as3_26",
  Px = {
    groupLabel: xme,
    description: Sme,
    errorMessage: Eme,
    inline: Cme,
    fieldset: kme,
    wrapper: Tme,
    options: Rme
  },
  Dme = "_theme_1onx1_1",
  Ime = "_input_1onx1_12",
  Mme = "_error_1onx1_50",
  Ome = "_disabled_1onx1_74",
  Lme = "_label_1onx1_85",
  Pme = "_helperText_1onx1_92",
  Pp = {
    theme: Dme,
    input: Ime,
    error: Mme,
    disabled: Ome,
    label: Lme,
    helperText: Pme
  },
  Ame = ({
    id: t,
    name: e,
    description: i,
    displayStacked: l = !1,
    options: c,
    label: p,
    hideLabel: h = !1,
    selectedOption: y,
    errorMessage: w,
    onChange: x,
    allowDeselect: E,
    className: C,
    classNames: k,
    renderLabel: D
  }) => {
    const [I, O] = rt(y),
      P = (N, L, F) => {
        O(F), x == null || x(N, L, F);
      };
    return /* @__PURE__ */B.jsx(zK, {
      id: t,
      name: e,
      description: i,
      displayStacked: l,
      options: c,
      label: p,
      hideLabel: h,
      selectedOption: I,
      onChange: P,
      allowDeselect: E,
      errorMessage: w,
      className: ge(l ? k == null ? void 0 : k.stacked : [Px.inline, k == null ? void 0 : k.inline], C),
      classNames: {
        fieldset: ge(Px.fieldset, k == null ? void 0 : k.fieldset),
        groupLabel: ge(Px.groupLabel, k == null ? void 0 : k.groupLabel),
        description: ge(Px.description, k == null ? void 0 : k.description),
        options: ge(Px.options, k == null ? void 0 : k.options),
        errorMessage: ge(Px.errorMessage, k == null ? void 0 : k.errorMessage),
        wrapper: ge(Pp.theme, Px.wrapper, k == null ? void 0 : k.wrapper),
        label: ge(Pp.label, k == null ? void 0 : k.label),
        input: ge(Pp.input, k == null ? void 0 : k.input),
        error: ge(Pp.error, k == null ? void 0 : k.error),
        disabled: ge(Pp.disabled, k == null ? void 0 : k.disabled),
        helperText: ge(Pp.helperText, k == null ? void 0 : k.helperText)
      },
      renderLabel: D
    });
  },
  lj = Qn(({
    id: t,
    label: e,
    value: i,
    name: l,
    isSelected: c,
    isError: p,
    isRequired: h,
    isDisabled: y,
    helperText: w,
    selectedOption: x,
    onChange: E,
    className: C,
    classNames: k,
    isInteractive: D
  }, I) => /* @__PURE__ */B.jsx(k4, {
    ref: I,
    id: t,
    label: e,
    name: l,
    value: i,
    isSelected: c,
    isError: p,
    isRequired: h,
    isDisabled: y,
    helperText: w,
    selectedOption: x,
    onChange: E,
    className: C,
    classNames: {
      wrapper: ge(Pp.theme, k == null ? void 0 : k.wrapper),
      label: ge(Pp.label, k == null ? void 0 : k.label),
      input: ge(Pp.input, k == null ? void 0 : k.input),
      error: ge(Pp.error, k == null ? void 0 : k.error),
      disabled: ge(Pp.disabled, k == null ? void 0 : k.disabled),
      helperText: ge(Pp.helperText, k == null ? void 0 : k.helperText)
    },
    isInteractive: D
  })),
  jme = "_container_cx5xx_1",
  Fme = "_inputHelperText_cx5xx_7",
  Nme = "_input_cx5xx_7",
  zme = "_inputWrapperFocus_cx5xx_20",
  Vme = "_inputWrapperOpen_cx5xx_25",
  Bme = "_listBox_cx5xx_29",
  Ume = "_inputWrapperError_cx5xx_33",
  Hme = "_inputLabel_cx5xx_39",
  $me = "_inputWrapperSelected_cx5xx_39",
  Wme = "_inputErrorText_cx5xx_43",
  qme = "_inputWrapperDisabled_cx5xx_50",
  Yme = "_value_cx5xx_90",
  Gme = "_loader_cx5xx_98",
  Xme = "_icon_cx5xx_104",
  Kme = "_iconError_cx5xx_112",
  Qme = "_iconDisabled_cx5xx_116",
  Zme = "_listHeading_cx5xx_132",
  Jme = "_listItem_cx5xx_138",
  eve = "_itemGroup_cx5xx_144",
  tve = "_itemActive_cx5xx_149",
  nve = "_itemDisabled_cx5xx_149",
  rve = "_noResults_cx5xx_161",
  ive = "_inputLoader_cx5xx_165",
  ave = "_labelWrapper_cx5xx_169",
  ove = "_checkboxWrapper_cx5xx_174",
  sve = "_clearAllBtn_cx5xx_178",
  ra = {
    container: jme,
    inputHelperText: Fme,
    input: Nme,
    inputWrapperFocus: zme,
    inputWrapperOpen: Vme,
    listBox: Bme,
    inputWrapperError: Ume,
    inputLabel: Hme,
    inputWrapperSelected: $me,
    inputErrorText: Wme,
    inputWrapperDisabled: qme,
    value: Yme,
    loader: Gme,
    icon: Xme,
    iconError: Kme,
    iconDisabled: Qme,
    listHeading: Zme,
    listItem: Jme,
    itemGroup: eve,
    itemActive: tve,
    itemDisabled: nve,
    noResults: rve,
    inputLoader: ive,
    labelWrapper: ave,
    checkboxWrapper: ove,
    clearAllBtn: sve
  },
  lve = ({
    id: t,
    data: e,
    isDisabled: i,
    errorMessage: l,
    initialSelectedItem: c,
    selectedItem: p,
    iconOptions: h,
    isAutoCloseMenu: y,
    environment: w,
    className: x,
    classNames: E,
    onFocus: C,
    onBlur: k,
    onSelectChange: D,
    onOpenDropdown: I,
    label: O,
    labels: P,
    helperText: N,
    values: L,
    onReset: F,
    clearAllOption: j,
    handleClearAll: V,
    resetTrigger: K,
    isLoading: G,
    children: Q
  }) => /* @__PURE__ */B.jsx(lY, {
    id: t,
    label: O,
    data: e,
    isDisabled: i,
    errorMessage: l,
    initialSelectedItem: c,
    selectedItem: p,
    iconOptions: {
      open: (h == null ? void 0 : h.open) || /* @__PURE__ */B.jsx(sn, {
        name: "chevron-up"
      }),
      close: (h == null ? void 0 : h.close) || /* @__PURE__ */B.jsx(sn, {
        name: "chevron-down"
      }),
      disabled: (h == null ? void 0 : h.disabled) || /* @__PURE__ */B.jsx(sn, {
        name: "nope"
      })
    },
    isAutoCloseMenu: y,
    environment: w,
    className: ge(ra.container, x),
    classNames: {
      icon: ge(ra.icon, E == null ? void 0 : E.icon),
      iconDisabled: ge(ra.iconDisabled, E == null ? void 0 : E.iconDisabled),
      iconError: ge(ra.iconError, E == null ? void 0 : E.iconError),
      inputToggleButton: ge(ra.input, E == null ? void 0 : E.inputToggleButton),
      inputWrapperFocus: ge(ra.inputWrapperFocus, E == null ? void 0 : E.inputWrapperFocus),
      inputWrapperOpen: ge(ra.inputWrapperOpen, E == null ? void 0 : E.inputWrapperOpen),
      inputWrapperSelected: ge(ra.inputWrapperSelected, E == null ? void 0 : E.inputWrapperSelected),
      inputWrapperError: ge(ra.inputWrapperError, E == null ? void 0 : E.inputWrapperError),
      inputWrapperDisabled: ge(ra.inputWrapperDisabled, E == null ? void 0 : E.inputWrapperDisabled),
      inputLabel: ge(ra.inputLabel, E == null ? void 0 : E.inputLabel),
      inputLoader: ge(ra.inputLoader, E == null ? void 0 : E.inputLoader),
      inputErrorText: ge(ra.inputErrorText, E == null ? void 0 : E.inputErrorText),
      inputHelperText: ge(ra.inputHelperText, E == null ? void 0 : E.inputHelperText),
      value: ge(ra.value, E == null ? void 0 : E.value),
      loader: ge(ra.loader, E == null ? void 0 : E.loader),
      listBox: ge(ra.listBox, E == null ? void 0 : E.listBox),
      listHeading: ge(ra.listHeading, E == null ? void 0 : E.listHeading),
      listItem: ge(ra.listItem, E == null ? void 0 : E.listItem),
      itemActive: ge(ra.itemActive, E == null ? void 0 : E.itemActive),
      itemDisabled: ge(ra.itemDisabled, E == null ? void 0 : E.itemDisabled),
      itemGroup: ge(ra.itemGroup, E == null ? void 0 : E.itemGroup),
      itemSelected: E == null ? void 0 : E.itemSelected,
      clearAllBtn: ge(ra.clearAllBtn, E == null ? void 0 : E.clearAllBtn),
      noResults: ge(ra.noResults, E == null ? void 0 : E.noResults)
    },
    onFocus: C,
    onBlur: k,
    onOpenDropdown: I,
    onSelectChange: D,
    labels: P,
    helperText: N,
    values: L,
    handleClearAll: V,
    resetTrigger: K,
    onReset: F,
    clearAllOption: j,
    isLoading: G,
    loaderConfig: {
      strokeColor: gl.color.teal[500].value,
      trackColor: gl.color.gray[500].value
    },
    renderCustomListItem: (te, ie, Y, ee) => {
      const oe = ee["aria-selected"] === !0;
      return /* @__PURE__ */B.jsx("li", {
        ...Y(ee),
        children: /* @__PURE__ */B.jsx(Hj, {
          id: `${te}-checkbox`,
          className: ge(ra.checkboxWrapper),
          classNames: {
            labelWrapper: ra.labelWrapper,
            wrapper: ra.innerCheckboxWrapper
          },
          onChange: () => D && D(ie),
          isDisabled: !1,
          isSelected: oe,
          label: ie.label
        })
      }, te);
    },
    children: Q
  }),
  uve = "_container_15kve_1",
  cve = "_popover_15kve_7",
  dve = "_inputWrapperOpen_15kve_13",
  fve = "_popoverContainer_15kve_17",
  pve = "_inputContainer_15kve_63",
  hve = "_icon_15kve_70",
  mve = "_inputWrapperFocus_15kve_79",
  vve = "_inputWrapperError_15kve_89",
  gve = "_inputLabel_15kve_95",
  yve = "_inputWrapperSelected_15kve_95",
  bve = "_inputWrapperDisabled_15kve_99",
  wve = "_inputHelperText_15kve_106",
  _ve = "_input_15kve_13",
  xve = "_inputErrorText_15kve_151",
  Sve = "_value_15kve_158",
  Eve = "_loader_15kve_166",
  Cve = "_iconError_15kve_180",
  kve = "_iconDisabled_15kve_184",
  rs = {
    container: uve,
    popover: cve,
    inputWrapperOpen: dve,
    popoverContainer: fve,
    inputContainer: pve,
    icon: hve,
    inputWrapperFocus: mve,
    inputWrapperError: vve,
    inputLabel: gve,
    inputWrapperSelected: yve,
    inputWrapperDisabled: bve,
    inputHelperText: wve,
    input: _ve,
    inputErrorText: xve,
    value: Sve,
    loader: Eve,
    iconError: Cve,
    iconDisabled: kve
  },
  Tve = ({
    className: t,
    classNames: e,
    id: i,
    readOnly: l,
    iconOptions: c,
    value: p,
    children: h,
    onChange: y,
    onClose: w,
    defaultCloseIcon: x,
    ...E
  }) => /* @__PURE__ */B.jsx(CK, {
    ...E,
    className: ge(rs.container, t),
    classNames: {
      icon: ge(rs.icon, e == null ? void 0 : e.icon),
      iconDisabled: ge(rs.iconDisabled, e == null ? void 0 : e.iconDisabled),
      iconError: ge(rs.iconError, e == null ? void 0 : e.iconError),
      inputContainer: ge(rs.inputContainer, e == null ? void 0 : e.inputContainer),
      inputToggleButton: ge(rs.input, e == null ? void 0 : e.inputToggleButton),
      inputWrapperFocus: ge(rs.inputWrapperFocus, e == null ? void 0 : e.inputWrapperFocus),
      inputWrapperOpen: ge(rs.inputWrapperOpen, e == null ? void 0 : e.inputWrapperOpen),
      inputWrapperSelected: ge(rs.inputWrapperSelected, e == null ? void 0 : e.inputWrapperSelected),
      inputWrapperError: ge(rs.inputWrapperError, e == null ? void 0 : e.inputWrapperError),
      inputWrapperDisabled: ge(rs.inputWrapperDisabled, e == null ? void 0 : e.inputWrapperDisabled),
      inputLabel: ge(rs.inputLabel, e == null ? void 0 : e.inputLabel),
      inputLoader: ge(rs.inputLoader, e == null ? void 0 : e.inputLoader),
      inputErrorText: ge(rs.inputErrorText, e == null ? void 0 : e.inputErrorText),
      inputHelperText: ge(rs.inputHelperText, e == null ? void 0 : e.inputHelperText),
      value: ge(rs.value, e == null ? void 0 : e.value),
      loader: ge(rs.loader, e == null ? void 0 : e.loader),
      popover: ge(rs.popover, e == null ? void 0 : e.popover),
      popoverContainer: ge(rs.popoverContainer, e == null ? void 0 : e.popoverContainer),
      popoverContainerOpen: ge(rs.popoverContainerOpen, e == null ? void 0 : e.popoverContainerOpen),
      closeButton: ge(rs.closeButton, e == null ? void 0 : e.closeButton),
      ...e
    },
    id: i,
    readOnly: l,
    iconOptions: {
      open: (c == null ? void 0 : c.open) ?? /* @__PURE__ */B.jsx(sn, {
        name: "chevron-up"
      }),
      close: (c == null ? void 0 : c.close) ?? /* @__PURE__ */B.jsx(sn, {
        name: "chevron-down"
      }),
      disabled: (c == null ? void 0 : c.disabled) ?? /* @__PURE__ */B.jsx(sn, {
        name: "nope"
      })
    },
    value: p,
    children: h,
    onChange: y,
    onClose: w,
    defaultCloseIcon: x
  }),
  Rve = "_range_1hjp6_2",
  Dve = "_rangeText_1hjp6_10",
  Ive = "_rangeValue_1hjp6_13",
  kT = {
    range: Rve,
    rangeText: Dve,
    rangeValue: Ive
  },
  dU = ({
    id: t,
    className: e,
    classNames: i,
    ranges: l,
    locale: c,
    rangeText: p,
    onHandleRangeChange: h,
    value: y,
    initialValue: w
  }) => {
    const [x, E] = rt(w || [l ? l[0] : 0, l ? l[1] : 1e4]),
      C = k => {
        E(k);
        const [D, I] = k,
          O = l ? l[0] : 0,
          P = l ? l[1] : 1e4;
        return h(D, I, O, P, y);
      };
    return /* @__PURE__ */B.jsx(xG, {
      className: ge(kT.range, e),
      classNames: {
        rangeText: ge(kT.rangeText, i == null ? void 0 : i.rangeText),
        rangeValue: ge(kT.rangeValue, i == null ? void 0 : i.rangeValue),
        thumbClassName: ge(kT.thumbClassName, i == null ? void 0 : i.thumbClassName),
        trackClassName: ge(kT.trackClassName, i == null ? void 0 : i.trackClassName)
      },
      id: t,
      ranges: l,
      locale: c,
      rangeText: p,
      value: x,
      onHandleRangeChange: C
    });
  },
  Mve = "_filters_l6jdz_2",
  Ove = "_priceRange_l6jdz_34",
  Lve = "_priceRangeInner_l6jdz_38",
  Pve = "_priceRangeText_l6jdz_42",
  Ave = "_filtersDropdownWrapper_l6jdz_48",
  jve = "_radioItem_l6jdz_55",
  Fve = "_radioButton_l6jdz_62",
  Nve = "_reset_l6jdz_66",
  zve = "_starContainer_l6jdz_90",
  Vve = "_applyButton_l6jdz_98",
  Bve = "_mobileFilters_l6jdz_102",
  Uve = "_mobileFiltersWrapperInner_l6jdz_106",
  Hve = "_button_l6jdz_114",
  $ve = "_buttonText_l6jdz_129",
  Wve = "_mobileFiltersWrapper_l6jdz_106",
  qve = "_gatewayDropdown_l6jdz_142",
  Yve = "_filtersMenu_l6jdz_188",
  Gve = "_header_l6jdz_197",
  Xve = "_closeButton_l6jdz_215",
  Kve = "_inputWrapperOpen_l6jdz_241",
  Qve = "_inputBorder_l6jdz_241",
  Zve = "_filtersSortDropdownList_l6jdz_244",
  Jve = "_inputToggleButton_l6jdz_254",
  ege = "_destinations_l6jdz_261",
  tge = "_country_l6jdz_275",
  nge = "_clear_l6jdz_278",
  rge = "_rangeInput_l6jdz_304",
  ige = "_starRating_l6jdz_93",
  age = "_formControl_l6jdz_321",
  oge = "_formControlInner_l6jdz_333",
  sge = "_apply_l6jdz_98",
  An = {
    filters: Mve,
    priceRange: Ove,
    priceRangeInner: Lve,
    priceRangeText: Pve,
    filtersDropdownWrapper: Ave,
    radioItem: jve,
    radioButton: Fve,
    reset: Nve,
    starContainer: zve,
    applyButton: Vve,
    mobileFilters: Bve,
    mobileFiltersWrapperInner: Uve,
    button: Hve,
    buttonText: $ve,
    mobileFiltersWrapper: Wve,
    gatewayDropdown: qve,
    filtersMenu: Yve,
    header: Gve,
    closeButton: Xve,
    inputWrapperOpen: Kve,
    inputBorder: Qve,
    filtersSortDropdownList: Zve,
    inputToggleButton: Jve,
    destinations: ege,
    country: tge,
    clear: nge,
    rangeInput: rge,
    starRating: ige,
    formControl: age,
    formControlInner: oge,
    apply: sge
  },
  lge = ({
    id: t,
    offers: e,
    locale: i,
    setMatchingOffers: l,
    isMobile: c = !1,
    labels: p = {}
  }) => {
    const [h, y] = rt([]),
      [w, x] = rt(null),
      [E, C] = rt(null),
      [k, D] = rt(!1),
      [I, O] = rt(!1),
      [P, N] = rt(!1),
      [L, F] = rt(!1),
      [j, V] = rt(0),
      K = vt(null),
      G = vt(null),
      Q = Nt.useMemo(() => dme(e), [e]),
      te = (p == null ? void 0 : p.destinations) || "Destinations",
      ie = pn(ye => {
        y(fme(ye, h, Q));
      }, [h, Q]),
      Y = pn(() => {
        y([]);
      }, []),
      ee = Nt.useMemo(() => e.map(ye => ye.Price).sort((ye, qe) => ye - qe), [e]),
      oe = Nt.useMemo(() => [ee[0], ee[ee.length - 1]], [ee]),
      ne = pn((ye, qe) => {
        const Ae = [ye, qe];
        return JSON.stringify(Ae) === JSON.stringify(oe) ? (x(null), null) : (x(Ae), Ae);
      }, [oe]),
      se = pn(() => {
        x(null), C(null);
      }, []),
      ue = Nt.useMemo(() => pme(e, i), [e, i]),
      [W, $] = rt(ue[ue.length - 1]),
      le = Nt.useMemo(() => ({
        priceLowToHigh: (p == null ? void 0 : p.priceLowToHigh) || "Price low to high",
        priceHighToLow: (p == null ? void 0 : p.priceHighToLow) || "Price high to low",
        starRatingLowToHigh: (p == null ? void 0 : p.starRatingLowToHigh) || "Star rating low to high",
        starRatingHighToLow: (p == null ? void 0 : p.starRatingHighToLow) || "Star rating high to low",
        hotelAz: (p == null ? void 0 : p.hotelNameAToZ) || "Hotel name a to z",
        hotelZa: (p == null ? void 0 : p.hotelNameZToA) || "Hotel name z to a",
        departureEarliest: (p == null ? void 0 : p.departureDateEarliest) || "Departure date earliest available"
      }), [p]),
      H = Nt.useMemo(() => hme(le), [le]),
      [ce, de] = rt(H[0]),
      Ce = ye => {
        ye !== W && $(ye);
      },
      {
        hasFiltersChanged: Ee,
        setAppliedFilters: fe,
        numberOfFilters: xe
      } = _me({
        destinationSelections: h,
        starRatingSelection: W,
        priceValue: w,
        sortingOptionSelection: ce
      }),
      we = (ye, qe) => {
        var Mt;
        let Ae = ye ? [...ye] : [];
        Ae = mme(Ae, qe.destinationSelections), Ae = vme(Ae, qe.priceValue), Ae = gme(Ae, qe.starRatingSelection), Ae = yme(Ae, ((Mt = qe.sortingOptionSelection) == null ? void 0 : Mt.id) || "priceLowToHigh"), l(Ae), C(qe.priceValue), D(!0), ce.id !== H[0].id ? O(!0) : O(!1), W.id !== ue[ue.length - 1].id ? N(!0) : N(!1);
      },
      ve = ye => {
        x(null), $((ue == null ? void 0 : ue[(ue == null ? void 0 : ue.length) - 1]) || {
          id: "",
          value: 0,
          label: ""
        }), N(!1), de(H[0]), O(!1), V(qe => qe + 1), y([]), l(P8(ye) || []), D(!1), C(null);
      },
      Te = pn(() => {
        F(!1), G.current && G.current.close(), K.current && setTimeout(() => {
          var ye;
          (ye = K.current) == null || ye.focus();
        }, 0);
      }, []),
      ze = () => {
        L ? Te() : (F(!0), G.current && G.current.showModal());
      },
      Xe = ye => {
        ye.target === ye.currentTarget && Te();
      };
    return Rt(() => {
      E && x(E);
    }, [E]), Rt(() => {
      c || F(!1);
    }, [c]), c ? /* @__PURE__ */B.jsxs("div", {
      className: An.mobileFilters,
      children: [/* @__PURE__ */B.jsx("div", {
        className: An.mobileFiltersWrapper,
        children: /* @__PURE__ */B.jsx("div", {
          className: An.mobileFiltersWrapperInner,
          children: e.length > 6 && /* @__PURE__ */B.jsxs(op, {
            variant: "utility",
            className: An.button,
            onClick: ze,
            "aria-label": p == null ? void 0 : p.openMenu,
            "aria-expanded": L,
            "aria-controls": "main-menu-nav",
            ref: K,
            children: [/* @__PURE__ */B.jsx("span", {
              className: An.buttonText,
              children: p == null ? void 0 : p.sortAndFilter
            }), /* @__PURE__ */B.jsx(sn, {
              name: "filter"
            })]
          })
        })
      }), e.length > 6 && /* @__PURE__ */B.jsx("dialog", {
        "aria-label": "filters",
        className: An.filters,
        ref: G,
        onClick: Xe,
        onClose: Xe,
        children: L && /* @__PURE__ */B.jsxs("div", {
          className: An.filtersMenu,
          children: [/* @__PURE__ */B.jsxs("div", {
            className: An.header,
            children: [/* @__PURE__ */B.jsx(cu, {
              Tag: "h4",
              color: "rock",
              children: p == null ? void 0 : p.sortAndFilter
            }), /* @__PURE__ */B.jsx("button", {
              className: An.closeButton,
              type: "button",
              "aria-label": "close",
              onClick: Te,
              children: /* @__PURE__ */B.jsx(sn, {
                name: "close"
              })
            })]
          }), /* @__PURE__ */B.jsx("div", {
            className: An.filtersDropdownWrapper,
            children: /* @__PURE__ */B.jsx(qT, {
              id: `sortingFilter-${t}`,
              classNames: {
                listBox: An.filtersSortDropdownList,
                inputWrapperOpen: An.inputWrapperOpen,
                inputToggleButton: An.inputToggleButton,
                inputBorder: An.inputBorder
              },
              label: p.sortBy,
              renderCustomLabel: (ye, qe) => ce.id === H[0].id && !I ? `${qe}: ${ye == null ? void 0 : ye.label}` : qe,
              initialSelectedItem: H[0],
              hideDisplayValue: ce.id === H[0].id && !I,
              selectedItem: ce ?? H[0],
              onChange: ye => {
                if (!ye) return;
                const qe = ye;
                qe !== ce && de(qe);
              },
              data: [{
                items: H
              }],
              renderCustomListItem: (ye, qe, Ae, Mt, Ft) => Ae ? /* @__PURE__ */B.jsxs("li", {
                ...Mt(Ft),
                className: ge(An.radioItem, Ft.className),
                children: [/* @__PURE__ */B.jsx(lj, {
                  id: `${ye}-radio`,
                  name: "radio-dropdown",
                  value: Ae.value !== void 0 ? Ae.value : 0,
                  isSelected: (ce == null ? void 0 : ce.id) === Ae.id,
                  selectedOption: ce ? {
                    id: ce.id,
                    value: ce.value,
                    label: ce.label
                  } : void 0,
                  classNames: {
                    wrapper: An.radioButton
                  },
                  isInteractive: !1
                }, `${ye}-radio`), Ae.label]
              }, ye) : null
            }, `sortingFilter-mobile-${j}`)
          }), /* @__PURE__ */B.jsxs("div", {
            className: An.destinations,
            children: [/* @__PURE__ */B.jsx(cu, {
              Tag: "h3",
              className: An.destinationsTitle,
              children: te
            }), Q.map((ye, qe) => /* @__PURE__ */B.jsxs("div", {
              children: [/* @__PURE__ */B.jsx(Hj, {
                id: ye.title || `mobile-destination-title-${qe}`,
                name: "mobile-destination",
                className: An.country,
                classNames: {
                  labelWrapper: An.labelWrapper,
                  wrapper: An.innerCheckboxWrapper
                },
                onChange: () => ie({
                  label: ye.title,
                  title: ye.title,
                  value: ye.title || "",
                  isGroupTitle: !0
                }),
                isDisabled: !1,
                isSelected: h.some(Ae => (Ae == null ? void 0 : Ae.value) === ye.title),
                label: ye.title
              }, `country-${ye.title}`), ye.items.map(Ae => {
                if ((Ae == null ? void 0 : Ae.label) !== (Ae == null ? void 0 : Ae.countryName)) return /* @__PURE__ */B.jsx(Hj, {
                  id: Ae.label || "mobile-destination-label",
                  className: An.checkboxWrapper,
                  classNames: {
                    labelWrapper: An.labelWrapper,
                    wrapper: An.innerCheckboxWrapper
                  },
                  onChange: () => ie(Ae),
                  isDisabled: !1,
                  isSelected: h.some(Mt => Mt.value === Ae.value),
                  label: Ae.label
                }, `destination-${Ae.value}`);
              })]
            }, ye.title || qe)), /* @__PURE__ */B.jsx("button", {
              type: "button",
              className: An.clear,
              onClick: () => y([]),
              children: p == null ? void 0 : p.clearAll
            })]
          }), /* @__PURE__ */B.jsx("div", {
            className: An.priceRange,
            children: /* @__PURE__ */B.jsxs("div", {
              className: An.priceRangeInner,
              children: [/* @__PURE__ */B.jsxs("div", {
                "aria-describedby": "priceRange",
                className: An.priceRangeText,
                children: [p == null ? void 0 : p.pricePerPerson, " ", i === "fr-CA" ? /* @__PURE__ */B.jsx(aE, {
                  number: "CA",
                  locale: i
                }) : /* @__PURE__ */B.jsx(aE, {
                  number: "CAD",
                  locale: i
                })]
              }), /* @__PURE__ */B.jsx("div", {
                children: /* @__PURE__ */B.jsx(dU, {
                  className: An.rangeInput,
                  id: `priceRangeInput-${t}`,
                  ranges: oe,
                  rangeText: "",
                  locale: i,
                  value: w || oe,
                  initialValue: w || void 0,
                  onHandleRangeChange: ne
                }, `priceRange-mobile-${j}`)
              })]
            })
          }), /* @__PURE__ */B.jsxs("div", {
            className: An.starRating,
            children: [/* @__PURE__ */B.jsx(cu, {
              Tag: "h3",
              className: An.starRatingTitle,
              children: p == null ? void 0 : p.starRating
            }), /* @__PURE__ */B.jsx(Ame, {
              id: `${t}-star-rating-mobile`,
              className: An.starRatingRadioButton,
              name: `${t}-star-rating-mobile`,
              label: (p == null ? void 0 : p.starRating) || "Star Rating",
              hideLabel: !0,
              renderLabel: ye => /* @__PURE__ */B.jsx(wO, {
                rating: ye.value,
                ratingText: ye == null ? void 0 : ye.label,
                classNames: {
                  container: An.starContainer
                }
              }, `star-rating-${ye.value}-rating`),
              options: ue.map(ye => ({
                label: ye.label,
                value: ye.value,
                id: ye.id
              })),
              selectedOption: W,
              onChange: (ye, qe, Ae) => {
                Ce(Ae);
              },
              allowDeselect: !1,
              classNames: {
                wrapper: An.radioButton
              }
            }, `star-rating-mobile-${j}`)]
          }), /* @__PURE__ */B.jsx("div", {
            className: An.formControl,
            children: /* @__PURE__ */B.jsxs("div", {
              className: An.formControlInner,
              children: [/* @__PURE__ */B.jsx(op, {
                variant: "action",
                className: An.apply,
                onClick: () => {
                  fe({
                    destinationSelections: h,
                    starRatingSelection: W,
                    priceValue: w,
                    sortingOptionSelection: ce
                  }), we(e, {
                    destinationSelections: h,
                    starRatingSelection: W,
                    priceValue: w,
                    sortingOptionSelection: ce
                  }), Te();
                },
                disabled: !Ee,
                children: `${p == null ? void 0 : p.apply} ${xe > 0 ? `(${xe})` : ""}`
              }), /* @__PURE__ */B.jsx(op, {
                variant: "noStyle",
                onClick: () => {
                  fe({
                    destinationSelections: [],
                    starRatingSelection: ue == null ? void 0 : ue[(ue == null ? void 0 : ue.length) - 1],
                    priceValue: null,
                    sortingOptionSelection: H[0]
                  }), ve(e), se();
                },
                className: An.reset,
                disabled: !k,
                children: p == null ? void 0 : p.reset
              })]
            })
          })]
        })
      })]
    }) : /* @__PURE__ */B.jsxs("div", {
      className: An.filters,
      children: [/* @__PURE__ */B.jsx(lve, {
        id: `destinations-${t}`,
        label: (p == null ? void 0 : p.destinations) || "Destinations",
        labels: p,
        data: Q,
        values: h,
        onSelectChange: ie,
        handleClearAll: Y,
        resetTrigger: j
      }), /* @__PURE__ */B.jsx(Tve, {
        defaultCloseIcon: !1,
        value: w !== null ? i === "fr-CA" ? `${w[0]} $ - ${w[1]} $` : `$${w[0]} - $${w[1]}` : "",
        label: (p == null ? void 0 : p.priceRange) || "Price Range",
        id: `priceRange-${t}`,
        className: w !== null ? An.priceRangeActive : An.priceRange,
        onChange: ye => {
          const qe = ye.split(",").map(Number);
          x(qe);
        },
        children: /* @__PURE__ */B.jsxs("div", {
          className: An.priceRangeInner,
          children: [/* @__PURE__ */B.jsxs("div", {
            "aria-describedby": "priceRange",
            className: An.priceRangeText,
            children: [p == null ? void 0 : p.pricePerPerson, " ", i === "fr-CA" ? /* @__PURE__ */B.jsx(aE, {
              number: "CA",
              locale: i
            }) : /* @__PURE__ */B.jsx(aE, {
              number: "CAD",
              locale: i
            })]
          }), /* @__PURE__ */B.jsx(dU, {
            id: `priceRangeInput-${t}`,
            ranges: oe,
            rangeText: "",
            locale: i,
            value: w || oe,
            initialValue: w || void 0,
            onHandleRangeChange: ne
          }, `priceRange-${j}`)]
        })
      }), /* @__PURE__ */B.jsx("div", {
        className: An.filtersDropdownWrapper,
        children: /* @__PURE__ */B.jsx(qT, {
          id: `starRating-${t}`,
          label: p.starRating,
          initialSelectedItem: ue[ue.length - 1],
          hideDisplayValue: W.id === ue[ue.length - 1].id && !P,
          selectedItem: W,
          onChange: ye => {
            if (!ye) return;
            const qe = ye;
            qe !== W && $(qe);
          },
          data: [{
            items: ue
          }],
          renderCustomItemContent: ye => String(ye == null ? void 0 : ye.label),
          renderCustomListItem: (ye, qe, Ae, Mt, Ft) => Ae ? /* @__PURE__ */B.jsxs("li", {
            ...Mt(Ft),
            className: ge(An.radioItem, Ft.className),
            children: [/* @__PURE__ */B.jsx(lj, {
              id: `${Ae.value}-radio`,
              name: "radio-dropdown",
              value: (Ae == null ? void 0 : Ae.value) ?? 0,
              isSelected: (W == null ? void 0 : W.id) === Ae.id,
              selectedOption: W ? {
                id: W.id,
                value: W.value,
                label: W.label
              } : void 0,
              classNames: {
                wrapper: An.radioButton
              },
              isInteractive: !1
            }, `${Ae.value}-radio`), /* @__PURE__ */B.jsx(wO, {
              rating: Ae.value,
              ratingText: Ae.label,
              classNames: {
                container: An.starContainer
              }
            }, `${Ae.value}-rating`)]
          }, `${ye}${qe}`) : null
        }, `starRating-${j}`)
      }), /* @__PURE__ */B.jsx("div", {
        className: An.filtersDropdownWrapper,
        children: /* @__PURE__ */B.jsx(qT, {
          id: `sortingFilter-${t}`,
          label: p.sortBy,
          renderCustomLabel: (ye, qe) => ce.id === H[0].id && !I ? `${qe}: ${ye == null ? void 0 : ye.label}` : qe,
          initialSelectedItem: H[0],
          hideDisplayValue: ce.id === H[0].id && !I,
          selectedItem: ce ?? void 0,
          onChange: ye => {
            if (!ye) return;
            const qe = ye;
            qe !== ce && de(qe);
          },
          data: [{
            items: H
          }],
          renderCustomListItem: (ye, qe, Ae, Mt, Ft) => /* @__PURE__ */B.jsxs("li", {
            ...Mt(Ft),
            className: ge(An.radioItem, Ft.className),
            children: [/* @__PURE__ */B.jsx(lj, {
              id: `${Ae.value}-radio`,
              name: "radio-dropdown",
              value: Ae.value !== void 0 ? Ae.value : 0,
              isSelected: (ce == null ? void 0 : ce.id) === Ae.id,
              selectedOption: ce ? {
                id: ce.id,
                value: ce.value,
                label: ce.label
              } : void 0,
              classNames: {
                wrapper: An.radioButton
              },
              isInteractive: !1
            }, `${Ae.value}-radio`), Ae.label]
          }, `${ye}${qe}`)
        }, `sorting-${j}`)
      }), /* @__PURE__ */B.jsx(op, {
        className: An.applyButton,
        onClick: () => {
          const ye = {
            destinationSelections: h,
            starRatingSelection: W,
            priceValue: w,
            sortingOptionSelection: ce
          };
          fe(ye), we(e, ye);
        },
        disabled: !Ee,
        children: `${p == null ? void 0 : p.apply}${xe > 0 ? ` (${xe})` : ""}`
      }), /* @__PURE__ */B.jsx(op, {
        variant: "noStyle",
        onClick: () => {
          fe({
            destinationSelections: [],
            starRatingSelection: ue == null ? void 0 : ue[(ue == null ? void 0 : ue.length) - 1],
            priceValue: null,
            sortingOptionSelection: H[0]
          }), ve(e), se();
        },
        className: An.reset,
        disabled: !k,
        children: p == null ? void 0 : p.reset
      })]
    });
  },
  uge = "_renderCards_uq13q_1",
  cge = "_disclaimer_uq13q_5",
  fU = {
    renderCards: uge,
    disclaimer: cge
  },
  A8 = t => t ? LO(t).isValid() : !1,
  dge = (t, e) => {
    if (!A8(t)) return "Date unavailable";
    const i = LO(t);
    return L8(e) === "fr-CA" ? i.locale("fr").format("D MMM YYYY") : i.format("MMM D, YYYY");
  },
  pU = ({
    id: t,
    index: e,
    offers: i,
    locale: l = "localeEn",
    labels: c,
    isMobile: p,
    numberToShow: h = 6,
    moreToShow: y = 6,
    cardsPerRow: w = 3,
    renderLink: x,
    noResults: E,
    theme: C = "light"
  }) => {
    const k = i.filter(N => A8(N.DepartureDate) ? LO(N.DepartureDate).isAfter(LO().startOf("day")) : (console.warn("Invalid departure date for offer:", N.DepartureDate), !1)),
      [D, I] = rt(P8(k)),
      O = L8(l),
      P = !D || D.length === 0;
    return /* @__PURE__ */B.jsxs(B.Fragment, {
      children: [(i.length > 6 || p) && /* @__PURE__ */B.jsx(lge, {
        id: `filter-${t}-${e}`,
        offers: k || [],
        locale: O,
        setMatchingOffers: I,
        isMobile: p,
        labels: c
      }), /* @__PURE__ */B.jsx("div", {
        id: `travel-deals${e !== 0 ? `-${e}` : ""}`,
        className: fU.renderCards,
        children: !P && /* @__PURE__ */B.jsx(cme, {
          numberToShow: h,
          moreToShow: y,
          cardsPerRow: w,
          labels: {
            loadAll: c == null ? void 0 : c.loadAll,
            loadMore: c == null ? void 0 : c.loadMore
          },
          children: (D || []).filter(N => N).map((N, L) => {
            var V, K, G;
            const F = N.Duration ? `${N.Duration} ${c == null ? void 0 : c.days}` : "";
            let j = N.DeepLink;
            if (p) try {
              const Q = new URL(N.DeepLink, window.location.origin);
              Q.searchParams.set("isMobile", "true"), Q.searchParams.get("alias") === "drv" && Q.searchParams.set("alias", "mrv"), j = Q.toString();
            } catch (Q) {
              console.warn("Failed to parse DeepLink URL:", N.DeepLink, Q), j = N.DeepLink;
            }
            return /* @__PURE__ */B.jsx(ZJ, {
              theme: C,
              header: `${N.Destination.Name}, ${N.Destination.CountryName}`,
              subheader: (V = N.AccommodationInfo) == null ? void 0 : V.AccommodationName,
              stars: (K = N.AccommodationInfo) != null && K.StarRating ? parseFloat(N.AccommodationInfo.StarRating.toString()) : void 0,
              days: F,
              regPrice: N.RegPrice,
              price: N.Price,
              save: N.SaveUpto ? `${c == null ? void 0 : c.saveUpTo} ${N.SaveUpto}%` : void 0,
              locale: O,
              labels: {
                allInc: N.MealPlan || (c == null ? void 0 : c.allInc) || "All inclusive",
                departureDate: dge(N.DepartureDate, l),
                adultsOnly: (c == null ? void 0 : c.adultsOnly) || "Adults only",
                departure: (c == null ? void 0 : c.departure) || "Dep.",
                return: (c == null ? void 0 : c.return) || "Ret.",
                perAdult: (c == null ? void 0 : c.perAdult) || "Per adult",
                taxAndFees: (c == null ? void 0 : c.taxAndFees) || "Taxes and fees incl.",
                was: (c == null ? void 0 : c.was) || "was",
                from: (c == null ? void 0 : c.from) || "From",
                dayOfWeek: (c == null ? void 0 : c.dayOfWeek) || "Day",
                returnDate: (c == null ? void 0 : c.returnDate) || "Return Date"
              },
              link: {
                href: j,
                children: "View details",
                target: "_blank"
              },
              renderLink: x,
              image: N.image || {
                source: {
                  src: "",
                  srcSet: "",
                  sizes: ""
                },
                alt: "Hotel image"
              }
            }, ((G = N.AccommodationInfo) == null ? void 0 : G.AccommodationCode) ?? L);
          })
        })
      }), P ? E : /* @__PURE__ */B.jsx("p", {
        className: fU.disclaimer,
        children: c == null ? void 0 : c.adModuleDisclaimer
      })]
    });
  },
  hU = ({
    index: t,
    gateways: e,
    defaultGateway: i,
    selectedGateway: l,
    setGateway: c,
    onGatewayChange: p,
    labels: h
  }) => {
    const y = l !== void 0,
      [w, x] = rt(i);
    Rt(() => {
      y || x(i);
    }, [i, y]);
    const E = y ? l : w,
      C = [{
        items: e ? e.map(D => ({
          id: D.Code,
          label: D.Name,
          value: D.Code
        })) : []
      }],
      k = D => {
        if (D && D.value !== (E == null ? void 0 : E.Code)) {
          const I = e == null ? void 0 : e.find(O => O.Code === D.value);
          I && (p != null && p(I.Code, I.Name) || (c(I), y || x(I)));
        }
      };
    return /* @__PURE__ */B.jsx(qT, {
      id: `gateways-${t}`,
      className: An.gatewayDropdown,
      data: C,
      label: h.from,
      selectedItem: E ? {
        id: E.Code,
        label: E.Name,
        value: E.Code
      } : void 0,
      onChange: k
    });
  },
  fge = "_cardsGatewayListContainer_1ck5m_1",
  pge = "_tabs_1ck5m_7",
  hge = "_tabGatewayListContainer_1ck5m_62",
  mge = "_gatewayList_1ck5m_72",
  vge = "_cardGatewayList_1ck5m_73",
  eE = {
    cardsGatewayListContainer: fge,
    tabs: pge,
    tabGatewayListContainer: hge,
    gatewayList: mge,
    cardGatewayList: vge
  },
  gge = {
    from: "From",
    loadAll: "Load all",
    loadMore: "Load more",
    adModuleDisclaimer: "The prices shown reflect rates of the day and are subject to change at any time without prior notice. To confirm availability and final pricing you MUST proceed to Step 3. The price shown at Step 3 constitutes the final guaranteed price and prevails over any other price.",
    days: "days",
    saveUpTo: "Save up to",
    oneWay: "One way",
    roundTrip: "Round trip",
    adultsOnly: "Adults only",
    departure: "Departure",
    return: "Return",
    perAdult: "Per adult",
    taxAndFees: "Tax and fees",
    dayOfWeek: "Day of week",
    departureDate: "Departure date",
    returnDate: "Return date",
    allInc: "All inclusive",
    was: "Was",
    apply: "Apply",
    reset: "Reset",
    sortAndFilter: "Sort and filter",
    destinations: "Destinations",
    clearAll: "Clear all",
    priceRange: "Price range",
    pricePerPerson: "Price per person",
    starRating: "Star rating",
    sortBy: "Sort by",
    priceLowToHigh: "Price: Low to High",
    priceHighToLow: "Price: High to Low",
    starRatingLowToHigh: "Star Rating: Low to High",
    starRatingHighToLow: "Star Rating: High to Low",
    hotelNameAToZ: "Hotel Name: A to Z",
    hotelNameZToA: "Hotel Name: Z to A",
    departureDateEarliest: "Departure Date: Earliest"
  },
  Ax = M8.reduce((t, e) => [...t, ...e.gateways], []),
  K_e = ({
    labels: t = {},
    data: e,
    locale: i = "localeEn",
    numberToShow: l = 6,
    moreToShow: c = 6,
    noResults: p,
    onGatewayChange: h,
    defaultGateway: y
  }) => {
    var P, N, L;
    const w = ci(() => ({
        ...gge,
        ...t
      }), [t]),
      x = ci(() => {
        var K;
        if (!(e != null && e.length)) return {
          Code: "",
          Name: ""
        };
        if (typeof window < "u") {
          const G = window.location.pathname,
            Q = w.from.toLowerCase(),
            te = new RegExp(`\\/${Q}-([^/]+)`, "i"),
            ie = G.match(te);
          if (ie) {
            const Y = decodeURIComponent(ie[1]),
              ee = Ax.find(oe => oe.label.toLowerCase() === Y.toLowerCase());
            if (ee && e.some(oe => {
              var ne;
              return ((ne = oe == null ? void 0 : oe.Gateway) == null ? void 0 : ne.Code) === ee.value;
            })) return {
              Code: ee.value,
              Name: ee.label
            };
          }
        }
        if (y != null && y.Code && y != null && y.Name) {
          const G = Ax.some(te => te.value === y.Code),
            Q = e.some(te => {
              var ie;
              return ((ie = te == null ? void 0 : te.Gateway) == null ? void 0 : ie.Code) === y.Code;
            });
          if (G && Q) return y;
        }
        const F = Ax.find(G => G.value === "YYC" || G.label.toLowerCase().includes("calgary"));
        if (F && e.some(G => {
          var Q;
          return ((Q = G == null ? void 0 : G.Gateway) == null ? void 0 : Q.Code) === F.value;
        })) return {
          Code: F.value,
          Name: F.label
        };
        const j = (K = e[0]) == null ? void 0 : K.Gateway;
        return Ax.some(G => G.value === (j == null ? void 0 : j.Code)) ? j : {
          Code: Ax[0].value,
          Name: Ax[0].label
        };
      }, [e, y, w.from]),
      [E, C] = rt(x);
    Rt(() => {
      C(x);
    }, [x]);
    const k = ci(() => e != null && e.length ? e.filter(F => !!F).reduce((F, j) => {
        const V = Ax.find(K => {
          var G;
          return K.value === ((G = j == null ? void 0 : j.Gateway) == null ? void 0 : G.Code);
        });
        return V && !F.some(K => K.Code === V.value) && F.push({
          Code: V.value,
          Name: V.label
        }), F;
      }, []) : [], [e]),
      D = ci(() => {
        if (e != null && e.length) return e.find(F => {
          var j;
          return ((j = F == null ? void 0 : F.Gateway) == null ? void 0 : j.Code) === E.Code;
        }) || e[0];
      }, [e, E.Code]),
      I = F => {
        C(F);
      },
      O = D7();
    return (P = D == null ? void 0 : D.PromotionGroups) != null && P.length ? /* @__PURE__ */B.jsx(B.Fragment, {
      children: D.PromotionGroups.length === 1 ? /* @__PURE__ */B.jsxs("div", {
        className: eE.cardsGatewayListContainer,
        children: [/* @__PURE__ */B.jsx("div", {
          className: eE.cardGatewayList,
          children: /* @__PURE__ */B.jsx(hU, {
            index: 0,
            gateways: k,
            selectedGateway: E,
            labels: w,
            setGateway: I,
            onGatewayChange: h
          })
        }), /* @__PURE__ */B.jsx(pU, {
          id: `${D.PromotionGroups[0].title}-${(N = D == null ? void 0 : D.Gateway) == null ? void 0 : N.Code}`,
          index: 0,
          offers: (L = D.PromotionGroups[0]) == null ? void 0 : L.Offers,
          locale: i,
          labels: w,
          isMobile: O,
          numberToShow: l,
          moreToShow: c,
          cardsPerRow: 3,
          noResults: p
        }, `${D.PromotionGroups[0].title}-${E.Code}`)]
      }) : /* @__PURE__ */B.jsxs(mb, {
        defaultValue: D == null ? void 0 : D.PromotionGroups[0].title,
        className: ge(eE.tabs),
        isSticky: !1,
        children: [/* @__PURE__ */B.jsxs("div", {
          className: eE.tabGatewayListContainer,
          children: [/* @__PURE__ */B.jsx(mb.List, {
            className: eE.tabWrapper,
            backgroundColor: "grey",
            children: D.PromotionGroups.map(F => {
              var j;
              return /* @__PURE__ */B.jsx(mb.Trigger, {
                value: `${F.title}`,
                children: F.title
              }, `${F.title}-${(j = D == null ? void 0 : D.Gateway) == null ? void 0 : j.Code}`);
            })
          }), /* @__PURE__ */B.jsx("div", {
            className: eE.gatewayList,
            children: /* @__PURE__ */B.jsx(hU, {
              index: 1,
              gateways: k,
              selectedGateway: E,
              labels: w,
              setGateway: I,
              onGatewayChange: h
            })
          })]
        }), D.PromotionGroups.map((F, j) => {
          var V;
          return /* @__PURE__ */B.jsx(mb.Content, {
            value: `${F.title}`,
            children: /* @__PURE__ */B.jsx(pU, {
              id: `${F.title}-${(V = D == null ? void 0 : D.Gateway) == null ? void 0 : V.Code}`,
              index: j,
              offers: F.Offers,
              locale: i,
              labels: w,
              isMobile: O,
              numberToShow: l,
              moreToShow: c,
              cardsPerRow: 3,
              noResults: p
            })
          }, `${F.title}-${E.Code}`);
        })]
      })
    }) : p;
  };
var TM = {
    exports: {}
  },
  q0 = {},
  RM = {
    exports: {}
  },
  ed = {},
  DM = {
    exports: {}
  },
  uj = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var mU;
function yge() {
  return mU || (mU = 1, function (t) {
    function e($, le) {
      var H = $.length;
      $.push(le);
      e: for (; 0 < H;) {
        var ce = H - 1 >>> 1,
          de = $[ce];
        if (0 < c(de, le)) $[ce] = le, $[H] = de, H = ce;else break e;
      }
    }
    function i($) {
      return $.length === 0 ? null : $[0];
    }
    function l($) {
      if ($.length === 0) return null;
      var le = $[0],
        H = $.pop();
      if (H !== le) {
        $[0] = H;
        e: for (var ce = 0, de = $.length, Ce = de >>> 1; ce < Ce;) {
          var Ee = 2 * (ce + 1) - 1,
            fe = $[Ee],
            xe = Ee + 1,
            we = $[xe];
          if (0 > c(fe, H)) xe < de && 0 > c(we, fe) ? ($[ce] = we, $[xe] = H, ce = xe) : ($[ce] = fe, $[Ee] = H, ce = Ee);else if (xe < de && 0 > c(we, H)) $[ce] = we, $[xe] = H, ce = xe;else break e;
        }
      }
      return le;
    }
    function c($, le) {
      var H = $.sortIndex - le.sortIndex;
      return H !== 0 ? H : $.id - le.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var p = performance;
      t.unstable_now = function () {
        return p.now();
      };
    } else {
      var h = Date,
        y = h.now();
      t.unstable_now = function () {
        return h.now() - y;
      };
    }
    var w = [],
      x = [],
      E = 1,
      C = null,
      k = 3,
      D = !1,
      I = !1,
      O = !1,
      P = typeof setTimeout == "function" ? setTimeout : null,
      N = typeof clearTimeout == "function" ? clearTimeout : null,
      L = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function F($) {
      for (var le = i(x); le !== null;) {
        if (le.callback === null) l(x);else if (le.startTime <= $) l(x), le.sortIndex = le.expirationTime, e(w, le);else break;
        le = i(x);
      }
    }
    function j($) {
      if (O = !1, F($), !I) if (i(w) !== null) I = !0, ue(V);else {
        var le = i(x);
        le !== null && W(j, le.startTime - $);
      }
    }
    function V($, le) {
      I = !1, O && (O = !1, N(Q), Q = -1), D = !0;
      var H = k;
      try {
        for (F(le), C = i(w); C !== null && (!(C.expirationTime > le) || $ && !Y());) {
          var ce = C.callback;
          if (typeof ce == "function") {
            C.callback = null, k = C.priorityLevel;
            var de = ce(C.expirationTime <= le);
            le = t.unstable_now(), typeof de == "function" ? C.callback = de : C === i(w) && l(w), F(le);
          } else l(w);
          C = i(w);
        }
        if (C !== null) var Ce = !0;else {
          var Ee = i(x);
          Ee !== null && W(j, Ee.startTime - le), Ce = !1;
        }
        return Ce;
      } finally {
        C = null, k = H, D = !1;
      }
    }
    var K = !1,
      G = null,
      Q = -1,
      te = 5,
      ie = -1;
    function Y() {
      return !(t.unstable_now() - ie < te);
    }
    function ee() {
      if (G !== null) {
        var $ = t.unstable_now();
        ie = $;
        var le = !0;
        try {
          le = G(!0, $);
        } finally {
          le ? oe() : (K = !1, G = null);
        }
      } else K = !1;
    }
    var oe;
    if (typeof L == "function") oe = function () {
      L(ee);
    };else if (typeof MessageChannel < "u") {
      var ne = new MessageChannel(),
        se = ne.port2;
      ne.port1.onmessage = ee, oe = function () {
        se.postMessage(null);
      };
    } else oe = function () {
      P(ee, 0);
    };
    function ue($) {
      G = $, K || (K = !0, oe());
    }
    function W($, le) {
      Q = P(function () {
        $(t.unstable_now());
      }, le);
    }
    t.unstable_IdlePriority = 5, t.unstable_ImmediatePriority = 1, t.unstable_LowPriority = 4, t.unstable_NormalPriority = 3, t.unstable_Profiling = null, t.unstable_UserBlockingPriority = 2, t.unstable_cancelCallback = function ($) {
      $.callback = null;
    }, t.unstable_continueExecution = function () {
      I || D || (I = !0, ue(V));
    }, t.unstable_forceFrameRate = function ($) {
      0 > $ || 125 < $ ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : te = 0 < $ ? Math.floor(1e3 / $) : 5;
    }, t.unstable_getCurrentPriorityLevel = function () {
      return k;
    }, t.unstable_getFirstCallbackNode = function () {
      return i(w);
    }, t.unstable_next = function ($) {
      switch (k) {
        case 1:
        case 2:
        case 3:
          var le = 3;
          break;
        default:
          le = k;
      }
      var H = k;
      k = le;
      try {
        return $();
      } finally {
        k = H;
      }
    }, t.unstable_pauseExecution = function () {}, t.unstable_requestPaint = function () {}, t.unstable_runWithPriority = function ($, le) {
      switch ($) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          $ = 3;
      }
      var H = k;
      k = $;
      try {
        return le();
      } finally {
        k = H;
      }
    }, t.unstable_scheduleCallback = function ($, le, H) {
      var ce = t.unstable_now();
      switch (typeof H == "object" && H !== null ? (H = H.delay, H = typeof H == "number" && 0 < H ? ce + H : ce) : H = ce, $) {
        case 1:
          var de = -1;
          break;
        case 2:
          de = 250;
          break;
        case 5:
          de = 1073741823;
          break;
        case 4:
          de = 1e4;
          break;
        default:
          de = 5e3;
      }
      return de = H + de, $ = {
        id: E++,
        callback: le,
        priorityLevel: $,
        startTime: H,
        expirationTime: de,
        sortIndex: -1
      }, H > ce ? ($.sortIndex = H, e(x, $), i(w) === null && $ === i(x) && (O ? (N(Q), Q = -1) : O = !0, W(j, H - ce))) : ($.sortIndex = de, e(w, $), I || D || (I = !0, ue(V))), $;
    }, t.unstable_shouldYield = Y, t.unstable_wrapCallback = function ($) {
      var le = k;
      return function () {
        var H = k;
        k = le;
        try {
          return $.apply(this, arguments);
        } finally {
          k = H;
        }
      };
    };
  }(uj)), uj;
}
var cj = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vU;
function bge() {
  return vU || (vU = 1, function (t) {
    process.env.NODE_ENV !== "production" && function () {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var e = !1,
        i = 5;
      function l(We, ht) {
        var Ke = We.length;
        We.push(ht), h(We, ht, Ke);
      }
      function c(We) {
        return We.length === 0 ? null : We[0];
      }
      function p(We) {
        if (We.length === 0) return null;
        var ht = We[0],
          Ke = We.pop();
        return Ke !== ht && (We[0] = Ke, y(We, Ke, 0)), ht;
      }
      function h(We, ht, Ke) {
        for (var yt = Ke; yt > 0;) {
          var je = yt - 1 >>> 1,
            at = We[je];
          if (w(at, ht) > 0) We[je] = ht, We[yt] = at, yt = je;else return;
        }
      }
      function y(We, ht, Ke) {
        for (var yt = Ke, je = We.length, at = je >>> 1; yt < at;) {
          var kt = (yt + 1) * 2 - 1,
            Bt = We[kt],
            Ht = kt + 1,
            ln = We[Ht];
          if (w(Bt, ht) < 0) Ht < je && w(ln, Bt) < 0 ? (We[yt] = ln, We[Ht] = ht, yt = Ht) : (We[yt] = Bt, We[kt] = ht, yt = kt);else if (Ht < je && w(ln, ht) < 0) We[yt] = ln, We[Ht] = ht, yt = Ht;else return;
        }
      }
      function w(We, ht) {
        var Ke = We.sortIndex - ht.sortIndex;
        return Ke !== 0 ? Ke : We.id - ht.id;
      }
      var x = 1,
        E = 2,
        C = 3,
        k = 4,
        D = 5;
      function I(We, ht) {}
      var O = typeof performance == "object" && typeof performance.now == "function";
      if (O) {
        var P = performance;
        t.unstable_now = function () {
          return P.now();
        };
      } else {
        var N = Date,
          L = N.now();
        t.unstable_now = function () {
          return N.now() - L;
        };
      }
      var F = 1073741823,
        j = -1,
        V = 250,
        K = 5e3,
        G = 1e4,
        Q = F,
        te = [],
        ie = [],
        Y = 1,
        ee = null,
        oe = C,
        ne = !1,
        se = !1,
        ue = !1,
        W = typeof setTimeout == "function" ? setTimeout : null,
        $ = typeof clearTimeout == "function" ? clearTimeout : null,
        le = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function H(We) {
        for (var ht = c(ie); ht !== null;) {
          if (ht.callback === null) p(ie);else if (ht.startTime <= We) p(ie), ht.sortIndex = ht.expirationTime, l(te, ht);else return;
          ht = c(ie);
        }
      }
      function ce(We) {
        if (ue = !1, H(We), !se) if (c(te) !== null) se = !0, Et(de);else {
          var ht = c(ie);
          ht !== null && Vt(ce, ht.startTime - We);
        }
      }
      function de(We, ht) {
        se = !1, ue && (ue = !1, Xt()), ne = !0;
        var Ke = oe;
        try {
          var yt;
          if (!e) return Ce(We, ht);
        } finally {
          ee = null, oe = Ke, ne = !1;
        }
      }
      function Ce(We, ht) {
        var Ke = ht;
        for (H(Ke), ee = c(te); ee !== null && !(ee.expirationTime > Ke && (!We || gt()));) {
          var yt = ee.callback;
          if (typeof yt == "function") {
            ee.callback = null, oe = ee.priorityLevel;
            var je = ee.expirationTime <= Ke,
              at = yt(je);
            Ke = t.unstable_now(), typeof at == "function" ? ee.callback = at : ee === c(te) && p(te), H(Ke);
          } else p(te);
          ee = c(te);
        }
        if (ee !== null) return !0;
        var kt = c(ie);
        return kt !== null && Vt(ce, kt.startTime - Ke), !1;
      }
      function Ee(We, ht) {
        switch (We) {
          case x:
          case E:
          case C:
          case k:
          case D:
            break;
          default:
            We = C;
        }
        var Ke = oe;
        oe = We;
        try {
          return ht();
        } finally {
          oe = Ke;
        }
      }
      function fe(We) {
        var ht;
        switch (oe) {
          case x:
          case E:
          case C:
            ht = C;
            break;
          default:
            ht = oe;
            break;
        }
        var Ke = oe;
        oe = ht;
        try {
          return We();
        } finally {
          oe = Ke;
        }
      }
      function xe(We) {
        var ht = oe;
        return function () {
          var Ke = oe;
          oe = ht;
          try {
            return We.apply(this, arguments);
          } finally {
            oe = Ke;
          }
        };
      }
      function we(We, ht, Ke) {
        var yt = t.unstable_now(),
          je;
        if (typeof Ke == "object" && Ke !== null) {
          var at = Ke.delay;
          typeof at == "number" && at > 0 ? je = yt + at : je = yt;
        } else je = yt;
        var kt;
        switch (We) {
          case x:
            kt = j;
            break;
          case E:
            kt = V;
            break;
          case D:
            kt = Q;
            break;
          case k:
            kt = G;
            break;
          case C:
          default:
            kt = K;
            break;
        }
        var Bt = je + kt,
          Ht = {
            id: Y++,
            callback: ht,
            priorityLevel: We,
            startTime: je,
            expirationTime: Bt,
            sortIndex: -1
          };
        return je > yt ? (Ht.sortIndex = je, l(ie, Ht), c(te) === null && Ht === c(ie) && (ue ? Xt() : ue = !0, Vt(ce, je - yt))) : (Ht.sortIndex = Bt, l(te, Ht), !se && !ne && (se = !0, Et(de))), Ht;
      }
      function ve() {}
      function Te() {
        !se && !ne && (se = !0, Et(de));
      }
      function ze() {
        return c(te);
      }
      function Xe(We) {
        We.callback = null;
      }
      function ye() {
        return oe;
      }
      var qe = !1,
        Ae = null,
        Mt = -1,
        Ft = i,
        un = -1;
      function gt() {
        var We = t.unstable_now() - un;
        return !(We < Ft);
      }
      function Pt() {}
      function St(We) {
        if (We < 0 || We > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        We > 0 ? Ft = Math.floor(1e3 / We) : Ft = i;
      }
      var Dt = function () {
          if (Ae !== null) {
            var We = t.unstable_now();
            un = We;
            var ht = !0,
              Ke = !0;
            try {
              Ke = Ae(ht, We);
            } finally {
              Ke ? Kt() : (qe = !1, Ae = null);
            }
          } else qe = !1;
        },
        Kt;
      if (typeof le == "function") Kt = function () {
        le(Dt);
      };else if (typeof MessageChannel < "u") {
        var hn = new MessageChannel(),
          Ot = hn.port2;
        hn.port1.onmessage = Dt, Kt = function () {
          Ot.postMessage(null);
        };
      } else Kt = function () {
        W(Dt, 0);
      };
      function Et(We) {
        Ae = We, qe || (qe = !0, Kt());
      }
      function Vt(We, ht) {
        Mt = W(function () {
          We(t.unstable_now());
        }, ht);
      }
      function Xt() {
        $(Mt), Mt = -1;
      }
      var vn = Pt,
        ot = null;
      t.unstable_IdlePriority = D, t.unstable_ImmediatePriority = x, t.unstable_LowPriority = k, t.unstable_NormalPriority = C, t.unstable_Profiling = ot, t.unstable_UserBlockingPriority = E, t.unstable_cancelCallback = Xe, t.unstable_continueExecution = Te, t.unstable_forceFrameRate = St, t.unstable_getCurrentPriorityLevel = ye, t.unstable_getFirstCallbackNode = ze, t.unstable_next = fe, t.unstable_pauseExecution = ve, t.unstable_requestPaint = vn, t.unstable_runWithPriority = Ee, t.unstable_scheduleCallback = we, t.unstable_shouldYield = gt, t.unstable_wrapCallback = xe, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(cj)), cj;
}
var gU;
function j8() {
  return gU || (gU = 1, process.env.NODE_ENV === "production" ? DM.exports = yge() : DM.exports = bge()), DM.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yU;
function wge() {
  if (yU) return ed;
  yU = 1;
  var t = Nt,
    e = j8();
  function i(r) {
    for (var o = "https://reactjs.org/docs/error-decoder.html?invariant=" + r, d = 1; d < arguments.length; d++) o += "&args[]=" + encodeURIComponent(arguments[d]);
    return "Minified React error #" + r + "; visit " + o + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var l = /* @__PURE__ */new Set(),
    c = {};
  function p(r, o) {
    h(r, o), h(r + "Capture", o);
  }
  function h(r, o) {
    for (c[r] = o, r = 0; r < o.length; r++) l.add(o[r]);
  }
  var y = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"),
    w = Object.prototype.hasOwnProperty,
    x = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
    E = {},
    C = {};
  function k(r) {
    return w.call(C, r) ? !0 : w.call(E, r) ? !1 : x.test(r) ? C[r] = !0 : (E[r] = !0, !1);
  }
  function D(r, o, d, g) {
    if (d !== null && d.type === 0) return !1;
    switch (typeof o) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return g ? !1 : d !== null ? !d.acceptsBooleans : (r = r.toLowerCase().slice(0, 5), r !== "data-" && r !== "aria-");
      default:
        return !1;
    }
  }
  function I(r, o, d, g) {
    if (o === null || typeof o > "u" || D(r, o, d, g)) return !0;
    if (g) return !1;
    if (d !== null) switch (d.type) {
      case 3:
        return !o;
      case 4:
        return o === !1;
      case 5:
        return isNaN(o);
      case 6:
        return isNaN(o) || 1 > o;
    }
    return !1;
  }
  function O(r, o, d, g, S, R, A) {
    this.acceptsBooleans = o === 2 || o === 3 || o === 4, this.attributeName = g, this.attributeNamespace = S, this.mustUseProperty = d, this.propertyName = r, this.type = o, this.sanitizeURL = R, this.removeEmptyString = A;
  }
  var P = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (r) {
    P[r] = new O(r, 0, !1, r, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (r) {
    var o = r[0];
    P[o] = new O(o, 1, !1, r[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (r) {
    P[r] = new O(r, 2, !1, r.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (r) {
    P[r] = new O(r, 2, !1, r, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (r) {
    P[r] = new O(r, 3, !1, r.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function (r) {
    P[r] = new O(r, 3, !0, r, null, !1, !1);
  }), ["capture", "download"].forEach(function (r) {
    P[r] = new O(r, 4, !1, r, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function (r) {
    P[r] = new O(r, 6, !1, r, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function (r) {
    P[r] = new O(r, 5, !1, r.toLowerCase(), null, !1, !1);
  });
  var N = /[\-:]([a-z])/g;
  function L(r) {
    return r[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (r) {
    var o = r.replace(N, L);
    P[o] = new O(o, 1, !1, r, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (r) {
    var o = r.replace(N, L);
    P[o] = new O(o, 1, !1, r, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function (r) {
    var o = r.replace(N, L);
    P[o] = new O(o, 1, !1, r, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function (r) {
    P[r] = new O(r, 1, !1, r.toLowerCase(), null, !1, !1);
  }), P.xlinkHref = new O("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function (r) {
    P[r] = new O(r, 1, !1, r.toLowerCase(), null, !0, !0);
  });
  function F(r, o, d, g) {
    var S = P.hasOwnProperty(o) ? P[o] : null;
    (S !== null ? S.type !== 0 : g || !(2 < o.length) || o[0] !== "o" && o[0] !== "O" || o[1] !== "n" && o[1] !== "N") && (I(o, d, S, g) && (d = null), g || S === null ? k(o) && (d === null ? r.removeAttribute(o) : r.setAttribute(o, "" + d)) : S.mustUseProperty ? r[S.propertyName] = d === null ? S.type === 3 ? !1 : "" : d : (o = S.attributeName, g = S.attributeNamespace, d === null ? r.removeAttribute(o) : (S = S.type, d = S === 3 || S === 4 && d === !0 ? "" : "" + d, g ? r.setAttributeNS(g, o, d) : r.setAttribute(o, d))));
  }
  var j = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
    V = Symbol.for("react.element"),
    K = Symbol.for("react.portal"),
    G = Symbol.for("react.fragment"),
    Q = Symbol.for("react.strict_mode"),
    te = Symbol.for("react.profiler"),
    ie = Symbol.for("react.provider"),
    Y = Symbol.for("react.context"),
    ee = Symbol.for("react.forward_ref"),
    oe = Symbol.for("react.suspense"),
    ne = Symbol.for("react.suspense_list"),
    se = Symbol.for("react.memo"),
    ue = Symbol.for("react.lazy"),
    W = Symbol.for("react.offscreen"),
    $ = Symbol.iterator;
  function le(r) {
    return r === null || typeof r != "object" ? null : (r = $ && r[$] || r["@@iterator"], typeof r == "function" ? r : null);
  }
  var H = Object.assign,
    ce;
  function de(r) {
    if (ce === void 0) try {
      throw Error();
    } catch (d) {
      var o = d.stack.trim().match(/\n( *(at )?)/);
      ce = o && o[1] || "";
    }
    return `
` + ce + r;
  }
  var Ce = !1;
  function Ee(r, o) {
    if (!r || Ce) return "";
    Ce = !0;
    var d = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (o) {
        if (o = function () {
          throw Error();
        }, Object.defineProperty(o.prototype, "props", {
          set: function () {
            throw Error();
          }
        }), typeof Reflect == "object" && Reflect.construct) {
          try {
            Reflect.construct(o, []);
          } catch (be) {
            var g = be;
          }
          Reflect.construct(r, [], o);
        } else {
          try {
            o.call();
          } catch (be) {
            g = be;
          }
          r.call(o.prototype);
        }
      } else {
        try {
          throw Error();
        } catch (be) {
          g = be;
        }
        r();
      }
    } catch (be) {
      if (be && g && typeof be.stack == "string") {
        for (var S = be.stack.split(`
`), R = g.stack.split(`
`), A = S.length - 1, q = R.length - 1; 1 <= A && 0 <= q && S[A] !== R[q];) q--;
        for (; 1 <= A && 0 <= q; A--, q--) if (S[A] !== R[q]) {
          if (A !== 1 || q !== 1) do if (A--, q--, 0 > q || S[A] !== R[q]) {
            var re = `
` + S[A].replace(" at new ", " at ");
            return r.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", r.displayName)), re;
          } while (1 <= A && 0 <= q);
          break;
        }
      }
    } finally {
      Ce = !1, Error.prepareStackTrace = d;
    }
    return (r = r ? r.displayName || r.name : "") ? de(r) : "";
  }
  function fe(r) {
    switch (r.tag) {
      case 5:
        return de(r.type);
      case 16:
        return de("Lazy");
      case 13:
        return de("Suspense");
      case 19:
        return de("SuspenseList");
      case 0:
      case 2:
      case 15:
        return r = Ee(r.type, !1), r;
      case 11:
        return r = Ee(r.type.render, !1), r;
      case 1:
        return r = Ee(r.type, !0), r;
      default:
        return "";
    }
  }
  function xe(r) {
    if (r == null) return null;
    if (typeof r == "function") return r.displayName || r.name || null;
    if (typeof r == "string") return r;
    switch (r) {
      case G:
        return "Fragment";
      case K:
        return "Portal";
      case te:
        return "Profiler";
      case Q:
        return "StrictMode";
      case oe:
        return "Suspense";
      case ne:
        return "SuspenseList";
    }
    if (typeof r == "object") switch (r.$$typeof) {
      case Y:
        return (r.displayName || "Context") + ".Consumer";
      case ie:
        return (r._context.displayName || "Context") + ".Provider";
      case ee:
        var o = r.render;
        return r = r.displayName, r || (r = o.displayName || o.name || "", r = r !== "" ? "ForwardRef(" + r + ")" : "ForwardRef"), r;
      case se:
        return o = r.displayName || null, o !== null ? o : xe(r.type) || "Memo";
      case ue:
        o = r._payload, r = r._init;
        try {
          return xe(r(o));
        } catch {}
    }
    return null;
  }
  function we(r) {
    var o = r.type;
    switch (r.tag) {
      case 24:
        return "Cache";
      case 9:
        return (o.displayName || "Context") + ".Consumer";
      case 10:
        return (o._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return r = o.render, r = r.displayName || r.name || "", o.displayName || (r !== "" ? "ForwardRef(" + r + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return o;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return xe(o);
      case 8:
        return o === Q ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof o == "function") return o.displayName || o.name || null;
        if (typeof o == "string") return o;
    }
    return null;
  }
  function ve(r) {
    switch (typeof r) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return r;
      case "object":
        return r;
      default:
        return "";
    }
  }
  function Te(r) {
    var o = r.type;
    return (r = r.nodeName) && r.toLowerCase() === "input" && (o === "checkbox" || o === "radio");
  }
  function ze(r) {
    var o = Te(r) ? "checked" : "value",
      d = Object.getOwnPropertyDescriptor(r.constructor.prototype, o),
      g = "" + r[o];
    if (!r.hasOwnProperty(o) && typeof d < "u" && typeof d.get == "function" && typeof d.set == "function") {
      var S = d.get,
        R = d.set;
      return Object.defineProperty(r, o, {
        configurable: !0,
        get: function () {
          return S.call(this);
        },
        set: function (A) {
          g = "" + A, R.call(this, A);
        }
      }), Object.defineProperty(r, o, {
        enumerable: d.enumerable
      }), {
        getValue: function () {
          return g;
        },
        setValue: function (A) {
          g = "" + A;
        },
        stopTracking: function () {
          r._valueTracker = null, delete r[o];
        }
      };
    }
  }
  function Xe(r) {
    r._valueTracker || (r._valueTracker = ze(r));
  }
  function ye(r) {
    if (!r) return !1;
    var o = r._valueTracker;
    if (!o) return !0;
    var d = o.getValue(),
      g = "";
    return r && (g = Te(r) ? r.checked ? "true" : "false" : r.value), r = g, r !== d ? (o.setValue(r), !0) : !1;
  }
  function qe(r) {
    if (r = r || (typeof document < "u" ? document : void 0), typeof r > "u") return null;
    try {
      return r.activeElement || r.body;
    } catch {
      return r.body;
    }
  }
  function Ae(r, o) {
    var d = o.checked;
    return H({}, o, {
      defaultChecked: void 0,
      defaultValue: void 0,
      value: void 0,
      checked: d ?? r._wrapperState.initialChecked
    });
  }
  function Mt(r, o) {
    var d = o.defaultValue == null ? "" : o.defaultValue,
      g = o.checked != null ? o.checked : o.defaultChecked;
    d = ve(o.value != null ? o.value : d), r._wrapperState = {
      initialChecked: g,
      initialValue: d,
      controlled: o.type === "checkbox" || o.type === "radio" ? o.checked != null : o.value != null
    };
  }
  function Ft(r, o) {
    o = o.checked, o != null && F(r, "checked", o, !1);
  }
  function un(r, o) {
    Ft(r, o);
    var d = ve(o.value),
      g = o.type;
    if (d != null) g === "number" ? (d === 0 && r.value === "" || r.value != d) && (r.value = "" + d) : r.value !== "" + d && (r.value = "" + d);else if (g === "submit" || g === "reset") {
      r.removeAttribute("value");
      return;
    }
    o.hasOwnProperty("value") ? Pt(r, o.type, d) : o.hasOwnProperty("defaultValue") && Pt(r, o.type, ve(o.defaultValue)), o.checked == null && o.defaultChecked != null && (r.defaultChecked = !!o.defaultChecked);
  }
  function gt(r, o, d) {
    if (o.hasOwnProperty("value") || o.hasOwnProperty("defaultValue")) {
      var g = o.type;
      if (!(g !== "submit" && g !== "reset" || o.value !== void 0 && o.value !== null)) return;
      o = "" + r._wrapperState.initialValue, d || o === r.value || (r.value = o), r.defaultValue = o;
    }
    d = r.name, d !== "" && (r.name = ""), r.defaultChecked = !!r._wrapperState.initialChecked, d !== "" && (r.name = d);
  }
  function Pt(r, o, d) {
    (o !== "number" || qe(r.ownerDocument) !== r) && (d == null ? r.defaultValue = "" + r._wrapperState.initialValue : r.defaultValue !== "" + d && (r.defaultValue = "" + d));
  }
  var St = Array.isArray;
  function Dt(r, o, d, g) {
    if (r = r.options, o) {
      o = {};
      for (var S = 0; S < d.length; S++) o["$" + d[S]] = !0;
      for (d = 0; d < r.length; d++) S = o.hasOwnProperty("$" + r[d].value), r[d].selected !== S && (r[d].selected = S), S && g && (r[d].defaultSelected = !0);
    } else {
      for (d = "" + ve(d), o = null, S = 0; S < r.length; S++) {
        if (r[S].value === d) {
          r[S].selected = !0, g && (r[S].defaultSelected = !0);
          return;
        }
        o !== null || r[S].disabled || (o = r[S]);
      }
      o !== null && (o.selected = !0);
    }
  }
  function Kt(r, o) {
    if (o.dangerouslySetInnerHTML != null) throw Error(i(91));
    return H({}, o, {
      value: void 0,
      defaultValue: void 0,
      children: "" + r._wrapperState.initialValue
    });
  }
  function hn(r, o) {
    var d = o.value;
    if (d == null) {
      if (d = o.children, o = o.defaultValue, d != null) {
        if (o != null) throw Error(i(92));
        if (St(d)) {
          if (1 < d.length) throw Error(i(93));
          d = d[0];
        }
        o = d;
      }
      o == null && (o = ""), d = o;
    }
    r._wrapperState = {
      initialValue: ve(d)
    };
  }
  function Ot(r, o) {
    var d = ve(o.value),
      g = ve(o.defaultValue);
    d != null && (d = "" + d, d !== r.value && (r.value = d), o.defaultValue == null && r.defaultValue !== d && (r.defaultValue = d)), g != null && (r.defaultValue = "" + g);
  }
  function Et(r) {
    var o = r.textContent;
    o === r._wrapperState.initialValue && o !== "" && o !== null && (r.value = o);
  }
  function Vt(r) {
    switch (r) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function Xt(r, o) {
    return r == null || r === "http://www.w3.org/1999/xhtml" ? Vt(o) : r === "http://www.w3.org/2000/svg" && o === "foreignObject" ? "http://www.w3.org/1999/xhtml" : r;
  }
  var vn,
    ot = function (r) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function (o, d, g, S) {
        MSApp.execUnsafeLocalFunction(function () {
          return r(o, d, g, S);
        });
      } : r;
    }(function (r, o) {
      if (r.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in r) r.innerHTML = o;else {
        for (vn = vn || document.createElement("div"), vn.innerHTML = "<svg>" + o.valueOf().toString() + "</svg>", o = vn.firstChild; r.firstChild;) r.removeChild(r.firstChild);
        for (; o.firstChild;) r.appendChild(o.firstChild);
      }
    });
  function We(r, o) {
    if (o) {
      var d = r.firstChild;
      if (d && d === r.lastChild && d.nodeType === 3) {
        d.nodeValue = o;
        return;
      }
    }
    r.textContent = o;
  }
  var ht = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    },
    Ke = ["Webkit", "ms", "Moz", "O"];
  Object.keys(ht).forEach(function (r) {
    Ke.forEach(function (o) {
      o = o + r.charAt(0).toUpperCase() + r.substring(1), ht[o] = ht[r];
    });
  });
  function yt(r, o, d) {
    return o == null || typeof o == "boolean" || o === "" ? "" : d || typeof o != "number" || o === 0 || ht.hasOwnProperty(r) && ht[r] ? ("" + o).trim() : o + "px";
  }
  function je(r, o) {
    r = r.style;
    for (var d in o) if (o.hasOwnProperty(d)) {
      var g = d.indexOf("--") === 0,
        S = yt(d, o[d], g);
      d === "float" && (d = "cssFloat"), g ? r.setProperty(d, S) : r[d] = S;
    }
  }
  var at = H({
    menuitem: !0
  }, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
  });
  function kt(r, o) {
    if (o) {
      if (at[r] && (o.children != null || o.dangerouslySetInnerHTML != null)) throw Error(i(137, r));
      if (o.dangerouslySetInnerHTML != null) {
        if (o.children != null) throw Error(i(60));
        if (typeof o.dangerouslySetInnerHTML != "object" || !("__html" in o.dangerouslySetInnerHTML)) throw Error(i(61));
      }
      if (o.style != null && typeof o.style != "object") throw Error(i(62));
    }
  }
  function Bt(r, o) {
    if (r.indexOf("-") === -1) return typeof o.is == "string";
    switch (r) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var Ht = null;
  function ln(r) {
    return r = r.target || r.srcElement || window, r.correspondingUseElement && (r = r.correspondingUseElement), r.nodeType === 3 ? r.parentNode : r;
  }
  var en = null,
    Rr = null,
    Nr = null;
  function Hi(r) {
    if (r = pt(r)) {
      if (typeof en != "function") throw Error(i(280));
      var o = r.stateNode;
      o && (o = Gn(o), en(r.stateNode, r.type, o));
    }
  }
  function ll(r) {
    Rr ? Nr ? Nr.push(r) : Nr = [r] : Rr = r;
  }
  function yo() {
    if (Rr) {
      var r = Rr,
        o = Nr;
      if (Nr = Rr = null, Hi(r), o) for (r = 0; r < o.length; r++) Hi(o[r]);
    }
  }
  function _l(r, o) {
    return r(o);
  }
  function Mo() {}
  var bo = !1;
  function Tu(r, o, d) {
    if (bo) return r(o, d);
    bo = !0;
    try {
      return _l(r, o, d);
    } finally {
      bo = !1, (Rr !== null || Nr !== null) && (Mo(), yo());
    }
  }
  function Ha(r, o) {
    var d = r.stateNode;
    if (d === null) return null;
    var g = Gn(d);
    if (g === null) return null;
    d = g[o];
    e: switch (o) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (g = !g.disabled) || (r = r.type, g = !(r === "button" || r === "input" || r === "select" || r === "textarea")), r = !g;
        break e;
      default:
        r = !1;
    }
    if (r) return null;
    if (d && typeof d != "function") throw Error(i(231, o, typeof d));
    return d;
  }
  var $i = !1;
  if (y) try {
    var oi = {};
    Object.defineProperty(oi, "passive", {
      get: function () {
        $i = !0;
      }
    }), window.addEventListener("test", oi, oi), window.removeEventListener("test", oi, oi);
  } catch {
    $i = !1;
  }
  function Oo(r, o, d, g, S, R, A, q, re) {
    var be = Array.prototype.slice.call(arguments, 3);
    try {
      o.apply(d, be);
    } catch (Le) {
      this.onError(Le);
    }
  }
  var $a = !1,
    Lo = null,
    Z = !1,
    Ne = null,
    Ye = {
      onError: function (r) {
        $a = !0, Lo = r;
      }
    };
  function xt(r, o, d, g, S, R, A, q, re) {
    $a = !1, Lo = null, Oo.apply(Ye, arguments);
  }
  function rn(r, o, d, g, S, R, A, q, re) {
    if (xt.apply(this, arguments), $a) {
      if ($a) {
        var be = Lo;
        $a = !1, Lo = null;
      } else throw Error(i(198));
      Z || (Z = !0, Ne = be);
    }
  }
  function $t(r) {
    var o = r,
      d = r;
    if (r.alternate) for (; o.return;) o = o.return;else {
      r = o;
      do o = r, (o.flags & 4098) !== 0 && (d = o.return), r = o.return; while (r);
    }
    return o.tag === 3 ? d : null;
  }
  function Ct(r) {
    if (r.tag === 13) {
      var o = r.memoizedState;
      if (o === null && (r = r.alternate, r !== null && (o = r.memoizedState)), o !== null) return o.dehydrated;
    }
    return null;
  }
  function qt(r) {
    if ($t(r) !== r) throw Error(i(188));
  }
  function yr(r) {
    var o = r.alternate;
    if (!o) {
      if (o = $t(r), o === null) throw Error(i(188));
      return o !== r ? null : r;
    }
    for (var d = r, g = o;;) {
      var S = d.return;
      if (S === null) break;
      var R = S.alternate;
      if (R === null) {
        if (g = S.return, g !== null) {
          d = g;
          continue;
        }
        break;
      }
      if (S.child === R.child) {
        for (R = S.child; R;) {
          if (R === d) return qt(S), r;
          if (R === g) return qt(S), o;
          R = R.sibling;
        }
        throw Error(i(188));
      }
      if (d.return !== g.return) d = S, g = R;else {
        for (var A = !1, q = S.child; q;) {
          if (q === d) {
            A = !0, d = S, g = R;
            break;
          }
          if (q === g) {
            A = !0, g = S, d = R;
            break;
          }
          q = q.sibling;
        }
        if (!A) {
          for (q = R.child; q;) {
            if (q === d) {
              A = !0, d = R, g = S;
              break;
            }
            if (q === g) {
              A = !0, g = R, d = S;
              break;
            }
            q = q.sibling;
          }
          if (!A) throw Error(i(189));
        }
      }
      if (d.alternate !== g) throw Error(i(190));
    }
    if (d.tag !== 3) throw Error(i(188));
    return d.stateNode.current === d ? r : o;
  }
  function Tn(r) {
    return r = yr(r), r !== null ? jn(r) : null;
  }
  function jn(r) {
    if (r.tag === 5 || r.tag === 6) return r;
    for (r = r.child; r !== null;) {
      var o = jn(r);
      if (o !== null) return o;
      r = r.sibling;
    }
    return null;
  }
  var Lr = e.unstable_scheduleCallback,
    Wa = e.unstable_cancelCallback,
    Ru = e.unstable_shouldYield,
    Wi = e.unstable_requestPaint,
    yn = e.unstable_now,
    Qt = e.unstable_getCurrentPriorityLevel,
    Es = e.unstable_ImmediatePriority,
    Wp = e.unstable_UserBlockingPriority,
    Du = e.unstable_NormalPriority,
    tg = e.unstable_LowPriority,
    qp = e.unstable_IdlePriority,
    Iu = null,
    qi = null;
  function ng(r) {
    if (qi && typeof qi.onCommitFiberRoot == "function") try {
      qi.onCommitFiberRoot(Iu, r, void 0, (r.current.flags & 128) === 128);
    } catch {}
  }
  var gi = Math.clz32 ? Math.clz32 : Yp,
    uw = Math.log,
    cw = Math.LN2;
  function Yp(r) {
    return r >>>= 0, r === 0 ? 32 : 31 - (uw(r) / cw | 0) | 0;
  }
  var xl = 64,
    Yi = 4194304;
  function Cs(r) {
    switch (r & -r) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return r & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return r & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return r;
    }
  }
  function ks(r, o) {
    var d = r.pendingLanes;
    if (d === 0) return 0;
    var g = 0,
      S = r.suspendedLanes,
      R = r.pingedLanes,
      A = d & 268435455;
    if (A !== 0) {
      var q = A & ~S;
      q !== 0 ? g = Cs(q) : (R &= A, R !== 0 && (g = Cs(R)));
    } else A = d & ~S, A !== 0 ? g = Cs(A) : R !== 0 && (g = Cs(R));
    if (g === 0) return 0;
    if (o !== 0 && o !== g && (o & S) === 0 && (S = g & -g, R = o & -o, S >= R || S === 16 && (R & 4194240) !== 0)) return o;
    if ((g & 4) !== 0 && (g |= d & 16), o = r.entangledLanes, o !== 0) for (r = r.entanglements, o &= g; 0 < o;) d = 31 - gi(o), S = 1 << d, g |= r[d], o &= ~S;
    return g;
  }
  function dw(r, o) {
    switch (r) {
      case 1:
      case 2:
      case 4:
        return o + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return o + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Gp(r, o) {
    for (var d = r.suspendedLanes, g = r.pingedLanes, S = r.expirationTimes, R = r.pendingLanes; 0 < R;) {
      var A = 31 - gi(R),
        q = 1 << A,
        re = S[A];
      re === -1 ? ((q & d) === 0 || (q & g) !== 0) && (S[A] = dw(q, o)) : re <= o && (r.expiredLanes |= q), R &= ~q;
    }
  }
  function Xp(r) {
    return r = r.pendingLanes & -1073741825, r !== 0 ? r : r & 1073741824 ? 1073741824 : 0;
  }
  function pd() {
    var r = xl;
    return xl <<= 1, (xl & 4194240) === 0 && (xl = 64), r;
  }
  function Kp(r) {
    for (var o = [], d = 0; 31 > d; d++) o.push(r);
    return o;
  }
  function Ts(r, o, d) {
    r.pendingLanes |= o, o !== 536870912 && (r.suspendedLanes = 0, r.pingedLanes = 0), r = r.eventTimes, o = 31 - gi(o), r[o] = d;
  }
  function fw(r, o) {
    var d = r.pendingLanes & ~o;
    r.pendingLanes = o, r.suspendedLanes = 0, r.pingedLanes = 0, r.expiredLanes &= o, r.mutableReadLanes &= o, r.entangledLanes &= o, o = r.entanglements;
    var g = r.eventTimes;
    for (r = r.expirationTimes; 0 < d;) {
      var S = 31 - gi(d),
        R = 1 << S;
      o[S] = 0, g[S] = -1, r[S] = -1, d &= ~R;
    }
  }
  function hd(r, o) {
    var d = r.entangledLanes |= o;
    for (r = r.entanglements; d;) {
      var g = 31 - gi(d),
        S = 1 << g;
      S & o | r[g] & o && (r[g] |= o), d &= ~S;
    }
  }
  var gn = 0;
  function Qp(r) {
    return r &= -r, 1 < r ? 4 < r ? (r & 268435455) !== 0 ? 16 : 536870912 : 4 : 1;
  }
  var bn,
    Zp,
    Jp,
    At,
    eh,
    Pr = !1,
    Po = [],
    yi = null,
    Ao = null,
    Un = null,
    Rn = /* @__PURE__ */new Map(),
    Mu = /* @__PURE__ */new Map(),
    br = [],
    bi = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function qa(r, o) {
    switch (r) {
      case "focusin":
      case "focusout":
        yi = null;
        break;
      case "dragenter":
      case "dragleave":
        Ao = null;
        break;
      case "mouseover":
      case "mouseout":
        Un = null;
        break;
      case "pointerover":
      case "pointerout":
        Rn.delete(o.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Mu.delete(o.pointerId);
    }
  }
  function Ou(r, o, d, g, S, R) {
    return r === null || r.nativeEvent !== R ? (r = {
      blockedOn: o,
      domEventName: d,
      eventSystemFlags: g,
      nativeEvent: R,
      targetContainers: [S]
    }, o !== null && (o = pt(o), o !== null && Zp(o)), r) : (r.eventSystemFlags |= g, o = r.targetContainers, S !== null && o.indexOf(S) === -1 && o.push(S), r);
  }
  function th(r, o, d, g, S) {
    switch (o) {
      case "focusin":
        return yi = Ou(yi, r, o, d, g, S), !0;
      case "dragenter":
        return Ao = Ou(Ao, r, o, d, g, S), !0;
      case "mouseover":
        return Un = Ou(Un, r, o, d, g, S), !0;
      case "pointerover":
        var R = S.pointerId;
        return Rn.set(R, Ou(Rn.get(R) || null, r, o, d, g, S)), !0;
      case "gotpointercapture":
        return R = S.pointerId, Mu.set(R, Ou(Mu.get(R) || null, r, o, d, g, S)), !0;
    }
    return !1;
  }
  function nh(r) {
    var o = Fs(r.target);
    if (o !== null) {
      var d = $t(o);
      if (d !== null) {
        if (o = d.tag, o === 13) {
          if (o = Ct(d), o !== null) {
            r.blockedOn = o, eh(r.priority, function () {
              Jp(d);
            });
            return;
          }
        } else if (o === 3 && d.stateNode.current.memoizedState.isDehydrated) {
          r.blockedOn = d.tag === 3 ? d.stateNode.containerInfo : null;
          return;
        }
      }
    }
    r.blockedOn = null;
  }
  function Lu(r) {
    if (r.blockedOn !== null) return !1;
    for (var o = r.targetContainers; 0 < o.length;) {
      var d = vd(r.domEventName, r.eventSystemFlags, o[0], r.nativeEvent);
      if (d === null) {
        d = r.nativeEvent;
        var g = new d.constructor(d.type, d);
        Ht = g, d.target.dispatchEvent(g), Ht = null;
      } else return o = pt(d), o !== null && Zp(o), r.blockedOn = d, !1;
      o.shift();
    }
    return !0;
  }
  function rg(r, o, d) {
    Lu(r) && d.delete(o);
  }
  function pw() {
    Pr = !1, yi !== null && Lu(yi) && (yi = null), Ao !== null && Lu(Ao) && (Ao = null), Un !== null && Lu(Un) && (Un = null), Rn.forEach(rg), Mu.forEach(rg);
  }
  function Pu(r, o) {
    r.blockedOn === o && (r.blockedOn = null, Pr || (Pr = !0, e.unstable_scheduleCallback(e.unstable_NormalPriority, pw)));
  }
  function jo(r) {
    function o(S) {
      return Pu(S, r);
    }
    if (0 < Po.length) {
      Pu(Po[0], r);
      for (var d = 1; d < Po.length; d++) {
        var g = Po[d];
        g.blockedOn === r && (g.blockedOn = null);
      }
    }
    for (yi !== null && Pu(yi, r), Ao !== null && Pu(Ao, r), Un !== null && Pu(Un, r), Rn.forEach(o), Mu.forEach(o), d = 0; d < br.length; d++) g = br[d], g.blockedOn === r && (g.blockedOn = null);
    for (; 0 < br.length && (d = br[0], d.blockedOn === null);) nh(d), d.blockedOn === null && br.shift();
  }
  var Rs = j.ReactCurrentBatchConfig,
    Ds = !0;
  function ig(r, o, d, g) {
    var S = gn,
      R = Rs.transition;
    Rs.transition = null;
    try {
      gn = 1, md(r, o, d, g);
    } finally {
      gn = S, Rs.transition = R;
    }
  }
  function ag(r, o, d, g) {
    var S = gn,
      R = Rs.transition;
    Rs.transition = null;
    try {
      gn = 4, md(r, o, d, g);
    } finally {
      gn = S, Rs.transition = R;
    }
  }
  function md(r, o, d, g) {
    if (Ds) {
      var S = vd(r, o, d, g);
      if (S === null) Pd(r, o, g, Au, d), qa(r, g);else if (th(S, r, o, d, g)) g.stopPropagation();else if (qa(r, g), o & 4 && -1 < bi.indexOf(r)) {
        for (; S !== null;) {
          var R = pt(S);
          if (R !== null && bn(R), R = vd(r, o, d, g), R === null && Pd(r, o, g, Au, d), R === S) break;
          S = R;
        }
        S !== null && g.stopPropagation();
      } else Pd(r, o, g, null, d);
    }
  }
  var Au = null;
  function vd(r, o, d, g) {
    if (Au = null, r = ln(g), r = Fs(r), r !== null) if (o = $t(r), o === null) r = null;else if (d = o.tag, d === 13) {
      if (r = Ct(o), r !== null) return r;
      r = null;
    } else if (d === 3) {
      if (o.stateNode.current.memoizedState.isDehydrated) return o.tag === 3 ? o.stateNode.containerInfo : null;
      r = null;
    } else o !== r && (r = null);
    return Au = r, null;
  }
  function gd(r) {
    switch (r) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (Qt()) {
          case Es:
            return 1;
          case Wp:
            return 4;
          case Du:
          case tg:
            return 16;
          case qp:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var Ya = null,
    yd = null,
    Sl = null;
  function rh() {
    if (Sl) return Sl;
    var r,
      o = yd,
      d = o.length,
      g,
      S = "value" in Ya ? Ya.value : Ya.textContent,
      R = S.length;
    for (r = 0; r < d && o[r] === S[r]; r++);
    var A = d - r;
    for (g = 1; g <= A && o[d - g] === S[R - g]; g++);
    return Sl = S.slice(r, 1 < g ? 1 - g : void 0);
  }
  function bd(r) {
    var o = r.keyCode;
    return "charCode" in r ? (r = r.charCode, r === 0 && o === 13 && (r = 13)) : r = o, r === 10 && (r = 13), 32 <= r || r === 13 ? r : 0;
  }
  function wd() {
    return !0;
  }
  function _d() {
    return !1;
  }
  function $r(r) {
    function o(d, g, S, R, A) {
      this._reactName = d, this._targetInst = S, this.type = g, this.nativeEvent = R, this.target = A, this.currentTarget = null;
      for (var q in r) r.hasOwnProperty(q) && (d = r[q], this[q] = d ? d(R) : R[q]);
      return this.isDefaultPrevented = (R.defaultPrevented != null ? R.defaultPrevented : R.returnValue === !1) ? wd : _d, this.isPropagationStopped = _d, this;
    }
    return H(o.prototype, {
      preventDefault: function () {
        this.defaultPrevented = !0;
        var d = this.nativeEvent;
        d && (d.preventDefault ? d.preventDefault() : typeof d.returnValue != "unknown" && (d.returnValue = !1), this.isDefaultPrevented = wd);
      },
      stopPropagation: function () {
        var d = this.nativeEvent;
        d && (d.stopPropagation ? d.stopPropagation() : typeof d.cancelBubble != "unknown" && (d.cancelBubble = !0), this.isPropagationStopped = wd);
      },
      persist: function () {},
      isPersistent: wd
    }), o;
  }
  var Is = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function (r) {
        return r.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    },
    xd = $r(Is),
    El = H({}, Is, {
      view: 0,
      detail: 0
    }),
    hw = $r(El),
    ih,
    wr,
    Ms,
    ju = H({}, El, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: uh,
      button: 0,
      buttons: 0,
      relatedTarget: function (r) {
        return r.relatedTarget === void 0 ? r.fromElement === r.srcElement ? r.toElement : r.fromElement : r.relatedTarget;
      },
      movementX: function (r) {
        return "movementX" in r ? r.movementX : (r !== Ms && (Ms && r.type === "mousemove" ? (ih = r.screenX - Ms.screenX, wr = r.screenY - Ms.screenY) : wr = ih = 0, Ms = r), ih);
      },
      movementY: function (r) {
        return "movementY" in r ? r.movementY : wr;
      }
    }),
    ah = $r(ju),
    mw = H({}, ju, {
      dataTransfer: 0
    }),
    Cl = $r(mw),
    oh = H({}, El, {
      relatedTarget: 0
    }),
    Sd = $r(oh),
    vw = H({}, Is, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }),
    gw = $r(vw),
    yw = H({}, Is, {
      clipboardData: function (r) {
        return "clipboardData" in r ? r.clipboardData : window.clipboardData;
      }
    }),
    og = $r(yw),
    sh = H({}, Is, {
      data: 0
    }),
    lh = $r(sh),
    sg = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    },
    lg = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    },
    bw = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
  function Ga(r) {
    var o = this.nativeEvent;
    return o.getModifierState ? o.getModifierState(r) : (r = bw[r]) ? !!o[r] : !1;
  }
  function uh() {
    return Ga;
  }
  var ch = H({}, El, {
      key: function (r) {
        if (r.key) {
          var o = sg[r.key] || r.key;
          if (o !== "Unidentified") return o;
        }
        return r.type === "keypress" ? (r = bd(r), r === 13 ? "Enter" : String.fromCharCode(r)) : r.type === "keydown" || r.type === "keyup" ? lg[r.keyCode] || "Unidentified" : "";
      },
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: uh,
      charCode: function (r) {
        return r.type === "keypress" ? bd(r) : 0;
      },
      keyCode: function (r) {
        return r.type === "keydown" || r.type === "keyup" ? r.keyCode : 0;
      },
      which: function (r) {
        return r.type === "keypress" ? bd(r) : r.type === "keydown" || r.type === "keyup" ? r.keyCode : 0;
      }
    }),
    dh = $r(ch),
    fh = H({}, ju, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }),
    ug = $r(fh),
    Ed = H({}, El, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: uh
    }),
    cg = $r(Ed),
    Wr = H({}, Is, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }),
    Xa = $r(Wr),
    er = H({}, ju, {
      deltaX: function (r) {
        return "deltaX" in r ? r.deltaX : "wheelDeltaX" in r ? -r.wheelDeltaX : 0;
      },
      deltaY: function (r) {
        return "deltaY" in r ? r.deltaY : "wheelDeltaY" in r ? -r.wheelDeltaY : "wheelDelta" in r ? -r.wheelDelta : 0;
      },
      deltaZ: 0,
      deltaMode: 0
    }),
    Ka = $r(er),
    ph = [9, 13, 27, 32],
    kl = y && "CompositionEvent" in window,
    Fu = null;
  y && "documentMode" in document && (Fu = document.documentMode);
  var Nu = y && "TextEvent" in window && !Fu,
    dg = y && (!kl || Fu && 8 < Fu && 11 >= Fu),
    fg = " ",
    Cd = !1;
  function pg(r, o) {
    switch (r) {
      case "keyup":
        return ph.indexOf(o.keyCode) !== -1;
      case "keydown":
        return o.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function hg(r) {
    return r = r.detail, typeof r == "object" && "data" in r ? r.data : null;
  }
  var Tl = !1;
  function mg(r, o) {
    switch (r) {
      case "compositionend":
        return hg(o);
      case "keypress":
        return o.which !== 32 ? null : (Cd = !0, fg);
      case "textInput":
        return r = o.data, r === fg && Cd ? null : r;
      default:
        return null;
    }
  }
  function ww(r, o) {
    if (Tl) return r === "compositionend" || !kl && pg(r, o) ? (r = rh(), Sl = yd = Ya = null, Tl = !1, r) : null;
    switch (r) {
      case "paste":
        return null;
      case "keypress":
        if (!(o.ctrlKey || o.altKey || o.metaKey) || o.ctrlKey && o.altKey) {
          if (o.char && 1 < o.char.length) return o.char;
          if (o.which) return String.fromCharCode(o.which);
        }
        return null;
      case "compositionend":
        return dg && o.locale !== "ko" ? null : o.data;
      default:
        return null;
    }
  }
  var _w = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function vg(r) {
    var o = r && r.nodeName && r.nodeName.toLowerCase();
    return o === "input" ? !!_w[r.type] : o === "textarea";
  }
  function hh(r, o, d, g) {
    ll(g), o = $u(o, "onChange"), 0 < o.length && (d = new xd("onChange", "change", null, d, g), r.push({
      event: d,
      listeners: o
    }));
  }
  var pa = null,
    Os = null;
  function gg(r) {
    As(r, 0);
  }
  function zu(r) {
    var o = Xi(r);
    if (ye(o)) return r;
  }
  function xw(r, o) {
    if (r === "change") return o;
  }
  var yg = !1;
  if (y) {
    var mh;
    if (y) {
      var vh = "oninput" in document;
      if (!vh) {
        var bg = document.createElement("div");
        bg.setAttribute("oninput", "return;"), vh = typeof bg.oninput == "function";
      }
      mh = vh;
    } else mh = !1;
    yg = mh && (!document.documentMode || 9 < document.documentMode);
  }
  function wg() {
    pa && (pa.detachEvent("onpropertychange", _g), Os = pa = null);
  }
  function _g(r) {
    if (r.propertyName === "value" && zu(Os)) {
      var o = [];
      hh(o, Os, r, ln(r)), Tu(gg, o);
    }
  }
  function Sw(r, o, d) {
    r === "focusin" ? (wg(), pa = o, Os = d, pa.attachEvent("onpropertychange", _g)) : r === "focusout" && wg();
  }
  function xg(r) {
    if (r === "selectionchange" || r === "keyup" || r === "keydown") return zu(Os);
  }
  function Ew(r, o) {
    if (r === "click") return zu(o);
  }
  function Sg(r, o) {
    if (r === "input" || r === "change") return zu(o);
  }
  function Cw(r, o) {
    return r === o && (r !== 0 || 1 / r === 1 / o) || r !== r && o !== o;
  }
  var Gi = typeof Object.is == "function" ? Object.is : Cw;
  function Vu(r, o) {
    if (Gi(r, o)) return !0;
    if (typeof r != "object" || r === null || typeof o != "object" || o === null) return !1;
    var d = Object.keys(r),
      g = Object.keys(o);
    if (d.length !== g.length) return !1;
    for (g = 0; g < d.length; g++) {
      var S = d[g];
      if (!w.call(o, S) || !Gi(r[S], o[S])) return !1;
    }
    return !0;
  }
  function Eg(r) {
    for (; r && r.firstChild;) r = r.firstChild;
    return r;
  }
  function kd(r, o) {
    var d = Eg(r);
    r = 0;
    for (var g; d;) {
      if (d.nodeType === 3) {
        if (g = r + d.textContent.length, r <= o && g >= o) return {
          node: d,
          offset: o - r
        };
        r = g;
      }
      e: {
        for (; d;) {
          if (d.nextSibling) {
            d = d.nextSibling;
            break e;
          }
          d = d.parentNode;
        }
        d = void 0;
      }
      d = Eg(d);
    }
  }
  function Fo(r, o) {
    return r && o ? r === o ? !0 : r && r.nodeType === 3 ? !1 : o && o.nodeType === 3 ? Fo(r, o.parentNode) : "contains" in r ? r.contains(o) : r.compareDocumentPosition ? !!(r.compareDocumentPosition(o) & 16) : !1 : !1;
  }
  function Bu() {
    for (var r = window, o = qe(); o instanceof r.HTMLIFrameElement;) {
      try {
        var d = typeof o.contentWindow.location.href == "string";
      } catch {
        d = !1;
      }
      if (d) r = o.contentWindow;else break;
      o = qe(r.document);
    }
    return o;
  }
  function Td(r) {
    var o = r && r.nodeName && r.nodeName.toLowerCase();
    return o && (o === "input" && (r.type === "text" || r.type === "search" || r.type === "tel" || r.type === "url" || r.type === "password") || o === "textarea" || r.contentEditable === "true");
  }
  function Rl(r) {
    var o = Bu(),
      d = r.focusedElem,
      g = r.selectionRange;
    if (o !== d && d && d.ownerDocument && Fo(d.ownerDocument.documentElement, d)) {
      if (g !== null && Td(d)) {
        if (o = g.start, r = g.end, r === void 0 && (r = o), "selectionStart" in d) d.selectionStart = o, d.selectionEnd = Math.min(r, d.value.length);else if (r = (o = d.ownerDocument || document) && o.defaultView || window, r.getSelection) {
          r = r.getSelection();
          var S = d.textContent.length,
            R = Math.min(g.start, S);
          g = g.end === void 0 ? R : Math.min(g.end, S), !r.extend && R > g && (S = g, g = R, R = S), S = kd(d, R);
          var A = kd(d, g);
          S && A && (r.rangeCount !== 1 || r.anchorNode !== S.node || r.anchorOffset !== S.offset || r.focusNode !== A.node || r.focusOffset !== A.offset) && (o = o.createRange(), o.setStart(S.node, S.offset), r.removeAllRanges(), R > g ? (r.addRange(o), r.extend(A.node, A.offset)) : (o.setEnd(A.node, A.offset), r.addRange(o)));
        }
      }
      for (o = [], r = d; r = r.parentNode;) r.nodeType === 1 && o.push({
        element: r,
        left: r.scrollLeft,
        top: r.scrollTop
      });
      for (typeof d.focus == "function" && d.focus(), d = 0; d < o.length; d++) r = o[d], r.element.scrollLeft = r.left, r.element.scrollTop = r.top;
    }
  }
  var kw = y && "documentMode" in document && 11 >= document.documentMode,
    Dl = null,
    gh = null,
    Uu = null,
    yh = !1;
  function bh(r, o, d) {
    var g = d.window === d ? d.document : d.nodeType === 9 ? d : d.ownerDocument;
    yh || Dl == null || Dl !== qe(g) || (g = Dl, "selectionStart" in g && Td(g) ? g = {
      start: g.selectionStart,
      end: g.selectionEnd
    } : (g = (g.ownerDocument && g.ownerDocument.defaultView || window).getSelection(), g = {
      anchorNode: g.anchorNode,
      anchorOffset: g.anchorOffset,
      focusNode: g.focusNode,
      focusOffset: g.focusOffset
    }), Uu && Vu(Uu, g) || (Uu = g, g = $u(gh, "onSelect"), 0 < g.length && (o = new xd("onSelect", "select", null, o, d), r.push({
      event: o,
      listeners: g
    }), o.target = Dl)));
  }
  function Rd(r, o) {
    var d = {};
    return d[r.toLowerCase()] = o.toLowerCase(), d["Webkit" + r] = "webkit" + o, d["Moz" + r] = "moz" + o, d;
  }
  var Ls = {
      animationend: Rd("Animation", "AnimationEnd"),
      animationiteration: Rd("Animation", "AnimationIteration"),
      animationstart: Rd("Animation", "AnimationStart"),
      transitionend: Rd("Transition", "TransitionEnd")
    },
    _r = {},
    wh = {};
  y && (wh = document.createElement("div").style, "AnimationEvent" in window || (delete Ls.animationend.animation, delete Ls.animationiteration.animation, delete Ls.animationstart.animation), "TransitionEvent" in window || delete Ls.transitionend.transition);
  function Dd(r) {
    if (_r[r]) return _r[r];
    if (!Ls[r]) return r;
    var o = Ls[r],
      d;
    for (d in o) if (o.hasOwnProperty(d) && d in wh) return _r[r] = o[d];
    return r;
  }
  var Cg = Dd("animationend"),
    kg = Dd("animationiteration"),
    Tg = Dd("animationstart"),
    Rg = Dd("transitionend"),
    _h = /* @__PURE__ */new Map(),
    Id = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function wi(r, o) {
    _h.set(r, o), p(o, [r]);
  }
  for (var xh = 0; xh < Id.length; xh++) {
    var Ps = Id[xh],
      Tw = Ps.toLowerCase(),
      Rw = Ps[0].toUpperCase() + Ps.slice(1);
    wi(Tw, "on" + Rw);
  }
  wi(Cg, "onAnimationEnd"), wi(kg, "onAnimationIteration"), wi(Tg, "onAnimationStart"), wi("dblclick", "onDoubleClick"), wi("focusin", "onFocus"), wi("focusout", "onBlur"), wi(Rg, "onTransitionEnd"), h("onMouseEnter", ["mouseout", "mouseover"]), h("onMouseLeave", ["mouseout", "mouseover"]), h("onPointerEnter", ["pointerout", "pointerover"]), h("onPointerLeave", ["pointerout", "pointerover"]), p("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), p("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), p("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), p("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), p("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), p("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var Hu = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),
    Sh = new Set("cancel close invalid load scroll toggle".split(" ").concat(Hu));
  function Md(r, o, d) {
    var g = r.type || "unknown-event";
    r.currentTarget = d, rn(g, o, void 0, r), r.currentTarget = null;
  }
  function As(r, o) {
    o = (o & 4) !== 0;
    for (var d = 0; d < r.length; d++) {
      var g = r[d],
        S = g.event;
      g = g.listeners;
      e: {
        var R = void 0;
        if (o) for (var A = g.length - 1; 0 <= A; A--) {
          var q = g[A],
            re = q.instance,
            be = q.currentTarget;
          if (q = q.listener, re !== R && S.isPropagationStopped()) break e;
          Md(S, q, be), R = re;
        } else for (A = 0; A < g.length; A++) {
          if (q = g[A], re = q.instance, be = q.currentTarget, q = q.listener, re !== R && S.isPropagationStopped()) break e;
          Md(S, q, be), R = re;
        }
      }
    }
    if (Z) throw r = Ne, Z = !1, Ne = null, r;
  }
  function mn(r, o) {
    var d = o[Yu];
    d === void 0 && (d = o[Yu] = /* @__PURE__ */new Set());
    var g = r + "__bubble";
    d.has(g) || (Dg(o, r, 2, !1), d.add(g));
  }
  function Od(r, o, d) {
    var g = 0;
    o && (g |= 4), Dg(d, r, g, o);
  }
  var Ld = "_reactListening" + Math.random().toString(36).slice(2);
  function Il(r) {
    if (!r[Ld]) {
      r[Ld] = !0, l.forEach(function (d) {
        d !== "selectionchange" && (Sh.has(d) || Od(d, !1, r), Od(d, !0, r));
      });
      var o = r.nodeType === 9 ? r : r.ownerDocument;
      o === null || o[Ld] || (o[Ld] = !0, Od("selectionchange", !1, o));
    }
  }
  function Dg(r, o, d, g) {
    switch (gd(o)) {
      case 1:
        var S = ig;
        break;
      case 4:
        S = ag;
        break;
      default:
        S = md;
    }
    d = S.bind(null, o, d, r), S = void 0, !$i || o !== "touchstart" && o !== "touchmove" && o !== "wheel" || (S = !0), g ? S !== void 0 ? r.addEventListener(o, d, {
      capture: !0,
      passive: S
    }) : r.addEventListener(o, d, !0) : S !== void 0 ? r.addEventListener(o, d, {
      passive: S
    }) : r.addEventListener(o, d, !1);
  }
  function Pd(r, o, d, g, S) {
    var R = g;
    if ((o & 1) === 0 && (o & 2) === 0 && g !== null) e: for (;;) {
      if (g === null) return;
      var A = g.tag;
      if (A === 3 || A === 4) {
        var q = g.stateNode.containerInfo;
        if (q === S || q.nodeType === 8 && q.parentNode === S) break;
        if (A === 4) for (A = g.return; A !== null;) {
          var re = A.tag;
          if ((re === 3 || re === 4) && (re = A.stateNode.containerInfo, re === S || re.nodeType === 8 && re.parentNode === S)) return;
          A = A.return;
        }
        for (; q !== null;) {
          if (A = Fs(q), A === null) return;
          if (re = A.tag, re === 5 || re === 6) {
            g = R = A;
            continue e;
          }
          q = q.parentNode;
        }
      }
      g = g.return;
    }
    Tu(function () {
      var be = R,
        Le = ln(d),
        Ve = [];
      e: {
        var Oe = _h.get(r);
        if (Oe !== void 0) {
          var et = xd,
            it = r;
          switch (r) {
            case "keypress":
              if (bd(d) === 0) break e;
            case "keydown":
            case "keyup":
              et = dh;
              break;
            case "focusin":
              it = "focus", et = Sd;
              break;
            case "focusout":
              it = "blur", et = Sd;
              break;
            case "beforeblur":
            case "afterblur":
              et = Sd;
              break;
            case "click":
              if (d.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              et = ah;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              et = Cl;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              et = cg;
              break;
            case Cg:
            case kg:
            case Tg:
              et = gw;
              break;
            case Rg:
              et = Xa;
              break;
            case "scroll":
              et = hw;
              break;
            case "wheel":
              et = Ka;
              break;
            case "copy":
            case "cut":
            case "paste":
              et = og;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              et = ug;
          }
          var st = (o & 4) !== 0,
            Kn = !st && r === "scroll",
            pe = st ? Oe !== null ? Oe + "Capture" : null : Oe;
          st = [];
          for (var ae = be, he; ae !== null;) {
            he = ae;
            var He = he.stateNode;
            if (he.tag === 5 && He !== null && (he = He, pe !== null && (He = Ha(ae, pe), He != null && st.push(Ml(ae, He, he)))), Kn) break;
            ae = ae.return;
          }
          0 < st.length && (Oe = new et(Oe, it, null, d, Le), Ve.push({
            event: Oe,
            listeners: st
          }));
        }
      }
      if ((o & 7) === 0) {
        e: {
          if (Oe = r === "mouseover" || r === "pointerover", et = r === "mouseout" || r === "pointerout", Oe && d !== Ht && (it = d.relatedTarget || d.fromElement) && (Fs(it) || it[Qa])) break e;
          if ((et || Oe) && (Oe = Le.window === Le ? Le : (Oe = Le.ownerDocument) ? Oe.defaultView || Oe.parentWindow : window, et ? (it = d.relatedTarget || d.toElement, et = be, it = it ? Fs(it) : null, it !== null && (Kn = $t(it), it !== Kn || it.tag !== 5 && it.tag !== 6) && (it = null)) : (et = null, it = be), et !== it)) {
            if (st = ah, He = "onMouseLeave", pe = "onMouseEnter", ae = "mouse", (r === "pointerout" || r === "pointerover") && (st = ug, He = "onPointerLeave", pe = "onPointerEnter", ae = "pointer"), Kn = et == null ? Oe : Xi(et), he = it == null ? Oe : Xi(it), Oe = new st(He, ae + "leave", et, d, Le), Oe.target = Kn, Oe.relatedTarget = he, He = null, Fs(Le) === be && (st = new st(pe, ae + "enter", it, d, Le), st.target = he, st.relatedTarget = Kn, He = st), Kn = He, et && it) t: {
              for (st = et, pe = it, ae = 0, he = st; he; he = No(he)) ae++;
              for (he = 0, He = pe; He; He = No(He)) he++;
              for (; 0 < ae - he;) st = No(st), ae--;
              for (; 0 < he - ae;) pe = No(pe), he--;
              for (; ae--;) {
                if (st === pe || pe !== null && st === pe.alternate) break t;
                st = No(st), pe = No(pe);
              }
              st = null;
            } else st = null;
            et !== null && Ig(Ve, Oe, et, st, !1), it !== null && Kn !== null && Ig(Ve, Kn, it, st, !0);
          }
        }
        e: {
          if (Oe = be ? Xi(be) : window, et = Oe.nodeName && Oe.nodeName.toLowerCase(), et === "select" || et === "input" && Oe.type === "file") var ut = xw;else if (vg(Oe)) {
            if (yg) ut = Sg;else {
              ut = xg;
              var bt = Sw;
            }
          } else (et = Oe.nodeName) && et.toLowerCase() === "input" && (Oe.type === "checkbox" || Oe.type === "radio") && (ut = Ew);
          if (ut && (ut = ut(r, be))) {
            hh(Ve, ut, d, Le);
            break e;
          }
          bt && bt(r, Oe, be), r === "focusout" && (bt = Oe._wrapperState) && bt.controlled && Oe.type === "number" && Pt(Oe, "number", Oe.value);
        }
        switch (bt = be ? Xi(be) : window, r) {
          case "focusin":
            (vg(bt) || bt.contentEditable === "true") && (Dl = bt, gh = be, Uu = null);
            break;
          case "focusout":
            Uu = gh = Dl = null;
            break;
          case "mousedown":
            yh = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            yh = !1, bh(Ve, d, Le);
            break;
          case "selectionchange":
            if (kw) break;
          case "keydown":
          case "keyup":
            bh(Ve, d, Le);
        }
        var wt;
        if (kl) e: {
          switch (r) {
            case "compositionstart":
              var It = "onCompositionStart";
              break e;
            case "compositionend":
              It = "onCompositionEnd";
              break e;
            case "compositionupdate":
              It = "onCompositionUpdate";
              break e;
          }
          It = void 0;
        } else Tl ? pg(r, d) && (It = "onCompositionEnd") : r === "keydown" && d.keyCode === 229 && (It = "onCompositionStart");
        It && (dg && d.locale !== "ko" && (Tl || It !== "onCompositionStart" ? It === "onCompositionEnd" && Tl && (wt = rh()) : (Ya = Le, yd = "value" in Ya ? Ya.value : Ya.textContent, Tl = !0)), bt = $u(be, It), 0 < bt.length && (It = new lh(It, r, null, d, Le), Ve.push({
          event: It,
          listeners: bt
        }), wt ? It.data = wt : (wt = hg(d), wt !== null && (It.data = wt)))), (wt = Nu ? mg(r, d) : ww(r, d)) && (be = $u(be, "onBeforeInput"), 0 < be.length && (Le = new lh("onBeforeInput", "beforeinput", null, d, Le), Ve.push({
          event: Le,
          listeners: be
        }), Le.data = wt));
      }
      As(Ve, o);
    });
  }
  function Ml(r, o, d) {
    return {
      instance: r,
      listener: o,
      currentTarget: d
    };
  }
  function $u(r, o) {
    for (var d = o + "Capture", g = []; r !== null;) {
      var S = r,
        R = S.stateNode;
      S.tag === 5 && R !== null && (S = R, R = Ha(r, d), R != null && g.unshift(Ml(r, R, S)), R = Ha(r, o), R != null && g.push(Ml(r, R, S))), r = r.return;
    }
    return g;
  }
  function No(r) {
    if (r === null) return null;
    do r = r.return; while (r && r.tag !== 5);
    return r || null;
  }
  function Ig(r, o, d, g, S) {
    for (var R = o._reactName, A = []; d !== null && d !== g;) {
      var q = d,
        re = q.alternate,
        be = q.stateNode;
      if (re !== null && re === g) break;
      q.tag === 5 && be !== null && (q = be, S ? (re = Ha(d, R), re != null && A.unshift(Ml(d, re, q))) : S || (re = Ha(d, R), re != null && A.push(Ml(d, re, q)))), d = d.return;
    }
    A.length !== 0 && r.push({
      event: o,
      listeners: A
    });
  }
  var Mg = /\r\n?/g,
    Dw = /\u0000|\uFFFD/g;
  function Og(r) {
    return (typeof r == "string" ? r : "" + r).replace(Mg, `
`).replace(Dw, "");
  }
  function Ad(r, o, d) {
    if (o = Og(o), Og(r) !== o && d) throw Error(i(425));
  }
  function zo() {}
  var Wu = null,
    js = null;
  function jd(r, o) {
    return r === "textarea" || r === "noscript" || typeof o.children == "string" || typeof o.children == "number" || typeof o.dangerouslySetInnerHTML == "object" && o.dangerouslySetInnerHTML !== null && o.dangerouslySetInnerHTML.__html != null;
  }
  var Fd = typeof setTimeout == "function" ? setTimeout : void 0,
    Eh = typeof clearTimeout == "function" ? clearTimeout : void 0,
    Lg = typeof Promise == "function" ? Promise : void 0,
    Ol = typeof queueMicrotask == "function" ? queueMicrotask : typeof Lg < "u" ? function (r) {
      return Lg.resolve(null).then(r).catch(Nd);
    } : Fd;
  function Nd(r) {
    setTimeout(function () {
      throw r;
    });
  }
  function Ll(r, o) {
    var d = o,
      g = 0;
    do {
      var S = d.nextSibling;
      if (r.removeChild(d), S && S.nodeType === 8) if (d = S.data, d === "/$") {
        if (g === 0) {
          r.removeChild(S), jo(o);
          return;
        }
        g--;
      } else d !== "$" && d !== "$?" && d !== "$!" || g++;
      d = S;
    } while (d);
    jo(o);
  }
  function ha(r) {
    for (; r != null; r = r.nextSibling) {
      var o = r.nodeType;
      if (o === 1 || o === 3) break;
      if (o === 8) {
        if (o = r.data, o === "$" || o === "$!" || o === "$?") break;
        if (o === "/$") return null;
      }
    }
    return r;
  }
  function Pg(r) {
    r = r.previousSibling;
    for (var o = 0; r;) {
      if (r.nodeType === 8) {
        var d = r.data;
        if (d === "$" || d === "$!" || d === "$?") {
          if (o === 0) return r;
          o--;
        } else d === "/$" && o++;
      }
      r = r.previousSibling;
    }
    return null;
  }
  var Vo = Math.random().toString(36).slice(2),
    ma = "__reactFiber$" + Vo,
    qu = "__reactProps$" + Vo,
    Qa = "__reactContainer$" + Vo,
    Yu = "__reactEvents$" + Vo,
    Pl = "__reactListeners$" + Vo,
    Iw = "__reactHandles$" + Vo;
  function Fs(r) {
    var o = r[ma];
    if (o) return o;
    for (var d = r.parentNode; d;) {
      if (o = d[Qa] || d[ma]) {
        if (d = o.alternate, o.child !== null || d !== null && d.child !== null) for (r = Pg(r); r !== null;) {
          if (d = r[ma]) return d;
          r = Pg(r);
        }
        return o;
      }
      r = d, d = r.parentNode;
    }
    return null;
  }
  function pt(r) {
    return r = r[ma] || r[Qa], !r || r.tag !== 5 && r.tag !== 6 && r.tag !== 13 && r.tag !== 3 ? null : r;
  }
  function Xi(r) {
    if (r.tag === 5 || r.tag === 6) return r.stateNode;
    throw Error(i(33));
  }
  function Gn(r) {
    return r[qu] || null;
  }
  var tn = [],
    _i = -1;
  function Ki(r) {
    return {
      current: r
    };
  }
  function Sn(r) {
    0 > _i || (r.current = tn[_i], tn[_i] = null, _i--);
  }
  function ft(r, o) {
    _i++, tn[_i] = r.current, r.current = o;
  }
  var qr = {},
    Hn = Ki(qr),
    or = Ki(!1),
    Yr = qr;
  function xi(r, o) {
    var d = r.type.contextTypes;
    if (!d) return qr;
    var g = r.stateNode;
    if (g && g.__reactInternalMemoizedUnmaskedChildContext === o) return g.__reactInternalMemoizedMaskedChildContext;
    var S = {},
      R;
    for (R in d) S[R] = o[R];
    return g && (r = r.stateNode, r.__reactInternalMemoizedUnmaskedChildContext = o, r.__reactInternalMemoizedMaskedChildContext = S), S;
  }
  function tr(r) {
    return r = r.childContextTypes, r != null;
  }
  function Al() {
    Sn(or), Sn(Hn);
  }
  function Ag(r, o, d) {
    if (Hn.current !== qr) throw Error(i(168));
    ft(Hn, o), ft(or, d);
  }
  function Gu(r, o, d) {
    var g = r.stateNode;
    if (o = o.childContextTypes, typeof g.getChildContext != "function") return d;
    g = g.getChildContext();
    for (var S in g) if (!(S in o)) throw Error(i(108, we(r) || "Unknown", S));
    return H({}, d, g);
  }
  function Gr(r) {
    return r = (r = r.stateNode) && r.__reactInternalMemoizedMergedChildContext || qr, Yr = Hn.current, ft(Hn, r), ft(or, or.current), !0;
  }
  function zd(r, o, d) {
    var g = r.stateNode;
    if (!g) throw Error(i(169));
    d ? (r = Gu(r, o, Yr), g.__reactInternalMemoizedMergedChildContext = r, Sn(or), Sn(Hn), ft(Hn, r)) : Sn(or), ft(or, d);
  }
  var va = null,
    jl = !1,
    Za = !1;
  function Vd(r) {
    va === null ? va = [r] : va.push(r);
  }
  function Bo(r) {
    jl = !0, Vd(r);
  }
  function ga() {
    if (!Za && va !== null) {
      Za = !0;
      var r = 0,
        o = gn;
      try {
        var d = va;
        for (gn = 1; r < d.length; r++) {
          var g = d[r];
          do g = g(!0); while (g !== null);
        }
        va = null, jl = !1;
      } catch (S) {
        throw va !== null && (va = va.slice(r + 1)), Lr(Es, ga), S;
      } finally {
        gn = o, Za = !1;
      }
    }
    return null;
  }
  var Uo = [],
    Ho = 0,
    $o = null,
    Ja = 0,
    nr = [],
    Si = 0,
    si = null,
    ya = 1,
    ba = "";
  function Ns(r, o) {
    Uo[Ho++] = Ja, Uo[Ho++] = $o, $o = r, Ja = o;
  }
  function jg(r, o, d) {
    nr[Si++] = ya, nr[Si++] = ba, nr[Si++] = si, si = r;
    var g = ya;
    r = ba;
    var S = 32 - gi(g) - 1;
    g &= ~(1 << S), d += 1;
    var R = 32 - gi(o) + S;
    if (30 < R) {
      var A = S - S % 5;
      R = (g & (1 << A) - 1).toString(32), g >>= A, S -= A, ya = 1 << 32 - gi(o) + S | d << S | g, ba = R + r;
    } else ya = 1 << R | d << S | g, ba = r;
  }
  function Bd(r) {
    r.return !== null && (Ns(r, 1), jg(r, 1, 0));
  }
  function Ud(r) {
    for (; r === $o;) $o = Uo[--Ho], Uo[Ho] = null, Ja = Uo[--Ho], Uo[Ho] = null;
    for (; r === si;) si = nr[--Si], nr[Si] = null, ba = nr[--Si], nr[Si] = null, ya = nr[--Si], nr[Si] = null;
  }
  var Xr = null,
    Kr = null,
    In = !1,
    Ei = null;
  function Ch(r, o) {
    var d = Li(5, null, null, 0);
    d.elementType = "DELETED", d.stateNode = o, d.return = r, o = r.deletions, o === null ? (r.deletions = [d], r.flags |= 16) : o.push(d);
  }
  function Fg(r, o) {
    switch (r.tag) {
      case 5:
        var d = r.type;
        return o = o.nodeType !== 1 || d.toLowerCase() !== o.nodeName.toLowerCase() ? null : o, o !== null ? (r.stateNode = o, Xr = r, Kr = ha(o.firstChild), !0) : !1;
      case 6:
        return o = r.pendingProps === "" || o.nodeType !== 3 ? null : o, o !== null ? (r.stateNode = o, Xr = r, Kr = null, !0) : !1;
      case 13:
        return o = o.nodeType !== 8 ? null : o, o !== null ? (d = si !== null ? {
          id: ya,
          overflow: ba
        } : null, r.memoizedState = {
          dehydrated: o,
          treeContext: d,
          retryLane: 1073741824
        }, d = Li(18, null, null, 0), d.stateNode = o, d.return = r, r.child = d, Xr = r, Kr = null, !0) : !1;
      default:
        return !1;
    }
  }
  function kh(r) {
    return (r.mode & 1) !== 0 && (r.flags & 128) === 0;
  }
  function Th(r) {
    if (In) {
      var o = Kr;
      if (o) {
        var d = o;
        if (!Fg(r, o)) {
          if (kh(r)) throw Error(i(418));
          o = ha(d.nextSibling);
          var g = Xr;
          o && Fg(r, o) ? Ch(g, d) : (r.flags = r.flags & -4097 | 2, In = !1, Xr = r);
        }
      } else {
        if (kh(r)) throw Error(i(418));
        r.flags = r.flags & -4097 | 2, In = !1, Xr = r;
      }
    }
  }
  function sr(r) {
    for (r = r.return; r !== null && r.tag !== 5 && r.tag !== 3 && r.tag !== 13;) r = r.return;
    Xr = r;
  }
  function Hd(r) {
    if (r !== Xr) return !1;
    if (!In) return sr(r), In = !0, !1;
    var o;
    if ((o = r.tag !== 3) && !(o = r.tag !== 5) && (o = r.type, o = o !== "head" && o !== "body" && !jd(r.type, r.memoizedProps)), o && (o = Kr)) {
      if (kh(r)) throw Xu(), Error(i(418));
      for (; o;) Ch(r, o), o = ha(o.nextSibling);
    }
    if (sr(r), r.tag === 13) {
      if (r = r.memoizedState, r = r !== null ? r.dehydrated : null, !r) throw Error(i(317));
      e: {
        for (r = r.nextSibling, o = 0; r;) {
          if (r.nodeType === 8) {
            var d = r.data;
            if (d === "/$") {
              if (o === 0) {
                Kr = ha(r.nextSibling);
                break e;
              }
              o--;
            } else d !== "$" && d !== "$!" && d !== "$?" || o++;
          }
          r = r.nextSibling;
        }
        Kr = null;
      }
    } else Kr = Xr ? ha(r.stateNode.nextSibling) : null;
    return !0;
  }
  function Xu() {
    for (var r = Kr; r;) r = ha(r.nextSibling);
  }
  function Wo() {
    Kr = Xr = null, In = !1;
  }
  function eo(r) {
    Ei === null ? Ei = [r] : Ei.push(r);
  }
  var Mw = j.ReactCurrentBatchConfig;
  function li(r, o) {
    if (r && r.defaultProps) {
      o = H({}, o), r = r.defaultProps;
      for (var d in r) o[d] === void 0 && (o[d] = r[d]);
      return o;
    }
    return o;
  }
  var $d = Ki(null),
    Wd = null,
    Qi = null,
    dr = null;
  function Ge() {
    dr = Qi = Wd = null;
  }
  function Ci(r) {
    var o = $d.current;
    Sn($d), r._currentValue = o;
  }
  function ui(r, o, d) {
    for (; r !== null;) {
      var g = r.alternate;
      if ((r.childLanes & o) !== o ? (r.childLanes |= o, g !== null && (g.childLanes |= o)) : g !== null && (g.childLanes & o) !== o && (g.childLanes |= o), r === d) break;
      r = r.return;
    }
  }
  function Fl(r, o) {
    Wd = r, dr = Qi = null, r = r.dependencies, r !== null && r.firstContext !== null && ((r.lanes & o) !== 0 && (Dr = !0), r.firstContext = null);
  }
  function ki(r) {
    var o = r._currentValue;
    if (dr !== r) if (r = {
      context: r,
      memoizedValue: o,
      next: null
    }, Qi === null) {
      if (Wd === null) throw Error(i(308));
      Qi = r, Wd.dependencies = {
        lanes: 0,
        firstContext: r
      };
    } else Qi = Qi.next = r;
    return o;
  }
  var zs = null;
  function Rh(r) {
    zs === null ? zs = [r] : zs.push(r);
  }
  function Ng(r, o, d, g) {
    var S = o.interleaved;
    return S === null ? (d.next = d, Rh(o)) : (d.next = S.next, S.next = d), o.interleaved = d, En(r, g);
  }
  function En(r, o) {
    r.lanes |= o;
    var d = r.alternate;
    for (d !== null && (d.lanes |= o), d = r, r = r.return; r !== null;) r.childLanes |= o, d = r.alternate, d !== null && (d.childLanes |= o), d = r, r = r.return;
    return d.tag === 3 ? d.stateNode : null;
  }
  var qo = !1;
  function Dh(r) {
    r.updateQueue = {
      baseState: r.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: {
        pending: null,
        interleaved: null,
        lanes: 0
      },
      effects: null
    };
  }
  function zg(r, o) {
    r = r.updateQueue, o.updateQueue === r && (o.updateQueue = {
      baseState: r.baseState,
      firstBaseUpdate: r.firstBaseUpdate,
      lastBaseUpdate: r.lastBaseUpdate,
      shared: r.shared,
      effects: r.effects
    });
  }
  function wa(r, o) {
    return {
      eventTime: r,
      lane: o,
      tag: 0,
      payload: null,
      callback: null,
      next: null
    };
  }
  function Ti(r, o, d) {
    var g = r.updateQueue;
    if (g === null) return null;
    if (g = g.shared, (on & 2) !== 0) {
      var S = g.pending;
      return S === null ? o.next = o : (o.next = S.next, S.next = o), g.pending = o, En(r, d);
    }
    return S = g.interleaved, S === null ? (o.next = o, Rh(g)) : (o.next = S.next, S.next = o), g.interleaved = o, En(r, d);
  }
  function to(r, o, d) {
    if (o = o.updateQueue, o !== null && (o = o.shared, (d & 4194240) !== 0)) {
      var g = o.lanes;
      g &= r.pendingLanes, d |= g, o.lanes = d, hd(r, d);
    }
  }
  function Vg(r, o) {
    var d = r.updateQueue,
      g = r.alternate;
    if (g !== null && (g = g.updateQueue, d === g)) {
      var S = null,
        R = null;
      if (d = d.firstBaseUpdate, d !== null) {
        do {
          var A = {
            eventTime: d.eventTime,
            lane: d.lane,
            tag: d.tag,
            payload: d.payload,
            callback: d.callback,
            next: null
          };
          R === null ? S = R = A : R = R.next = A, d = d.next;
        } while (d !== null);
        R === null ? S = R = o : R = R.next = o;
      } else S = R = o;
      d = {
        baseState: g.baseState,
        firstBaseUpdate: S,
        lastBaseUpdate: R,
        shared: g.shared,
        effects: g.effects
      }, r.updateQueue = d;
      return;
    }
    r = d.lastBaseUpdate, r === null ? d.firstBaseUpdate = o : r.next = o, d.lastBaseUpdate = o;
  }
  function qd(r, o, d, g) {
    var S = r.updateQueue;
    qo = !1;
    var R = S.firstBaseUpdate,
      A = S.lastBaseUpdate,
      q = S.shared.pending;
    if (q !== null) {
      S.shared.pending = null;
      var re = q,
        be = re.next;
      re.next = null, A === null ? R = be : A.next = be, A = re;
      var Le = r.alternate;
      Le !== null && (Le = Le.updateQueue, q = Le.lastBaseUpdate, q !== A && (q === null ? Le.firstBaseUpdate = be : q.next = be, Le.lastBaseUpdate = re));
    }
    if (R !== null) {
      var Ve = S.baseState;
      A = 0, Le = be = re = null, q = R;
      do {
        var Oe = q.lane,
          et = q.eventTime;
        if ((g & Oe) === Oe) {
          Le !== null && (Le = Le.next = {
            eventTime: et,
            lane: 0,
            tag: q.tag,
            payload: q.payload,
            callback: q.callback,
            next: null
          });
          e: {
            var it = r,
              st = q;
            switch (Oe = o, et = d, st.tag) {
              case 1:
                if (it = st.payload, typeof it == "function") {
                  Ve = it.call(et, Ve, Oe);
                  break e;
                }
                Ve = it;
                break e;
              case 3:
                it.flags = it.flags & -65537 | 128;
              case 0:
                if (it = st.payload, Oe = typeof it == "function" ? it.call(et, Ve, Oe) : it, Oe == null) break e;
                Ve = H({}, Ve, Oe);
                break e;
              case 2:
                qo = !0;
            }
          }
          q.callback !== null && q.lane !== 0 && (r.flags |= 64, Oe = S.effects, Oe === null ? S.effects = [q] : Oe.push(q));
        } else et = {
          eventTime: et,
          lane: Oe,
          tag: q.tag,
          payload: q.payload,
          callback: q.callback,
          next: null
        }, Le === null ? (be = Le = et, re = Ve) : Le = Le.next = et, A |= Oe;
        if (q = q.next, q === null) {
          if (q = S.shared.pending, q === null) break;
          Oe = q, q = Oe.next, Oe.next = null, S.lastBaseUpdate = Oe, S.shared.pending = null;
        }
      } while (!0);
      if (Le === null && (re = Ve), S.baseState = re, S.firstBaseUpdate = be, S.lastBaseUpdate = Le, o = S.shared.interleaved, o !== null) {
        S = o;
        do A |= S.lane, S = S.next; while (S !== o);
      } else R === null && (S.shared.lanes = 0);
      xo |= A, r.lanes = A, r.memoizedState = Ve;
    }
  }
  function Bg(r, o, d) {
    if (r = o.effects, o.effects = null, r !== null) for (o = 0; o < r.length; o++) {
      var g = r[o],
        S = g.callback;
      if (S !== null) {
        if (g.callback = null, g = d, typeof S != "function") throw Error(i(191, S));
        S.call(g);
      }
    }
  }
  var Ug = new t.Component().refs;
  function Ih(r, o, d, g) {
    o = r.memoizedState, d = d(g, o), d = d == null ? o : H({}, o, d), r.memoizedState = d, r.lanes === 0 && (r.updateQueue.baseState = d);
  }
  var Yd = {
    isMounted: function (r) {
      return (r = r._reactInternals) ? $t(r) === r : !1;
    },
    enqueueSetState: function (r, o, d) {
      r = r._reactInternals;
      var g = hr(),
        S = Ca(r),
        R = wa(g, S);
      R.payload = o, d != null && (R.callback = d), o = Ti(r, R, S), o !== null && (Oi(o, r, S, g), to(o, r, S));
    },
    enqueueReplaceState: function (r, o, d) {
      r = r._reactInternals;
      var g = hr(),
        S = Ca(r),
        R = wa(g, S);
      R.tag = 1, R.payload = o, d != null && (R.callback = d), o = Ti(r, R, S), o !== null && (Oi(o, r, S, g), to(o, r, S));
    },
    enqueueForceUpdate: function (r, o) {
      r = r._reactInternals;
      var d = hr(),
        g = Ca(r),
        S = wa(d, g);
      S.tag = 2, o != null && (S.callback = o), o = Ti(r, S, g), o !== null && (Oi(o, r, g, d), to(o, r, g));
    }
  };
  function Mh(r, o, d, g, S, R, A) {
    return r = r.stateNode, typeof r.shouldComponentUpdate == "function" ? r.shouldComponentUpdate(g, R, A) : o.prototype && o.prototype.isPureReactComponent ? !Vu(d, g) || !Vu(S, R) : !0;
  }
  function Oh(r, o, d) {
    var g = !1,
      S = qr,
      R = o.contextType;
    return typeof R == "object" && R !== null ? R = ki(R) : (S = tr(o) ? Yr : Hn.current, g = o.contextTypes, R = (g = g != null) ? xi(r, S) : qr), o = new o(d, R), r.memoizedState = o.state !== null && o.state !== void 0 ? o.state : null, o.updater = Yd, r.stateNode = o, o._reactInternals = r, g && (r = r.stateNode, r.__reactInternalMemoizedUnmaskedChildContext = S, r.__reactInternalMemoizedMaskedChildContext = R), o;
  }
  function Hg(r, o, d, g) {
    r = o.state, typeof o.componentWillReceiveProps == "function" && o.componentWillReceiveProps(d, g), typeof o.UNSAFE_componentWillReceiveProps == "function" && o.UNSAFE_componentWillReceiveProps(d, g), o.state !== r && Yd.enqueueReplaceState(o, o.state, null);
  }
  function Lh(r, o, d, g) {
    var S = r.stateNode;
    S.props = d, S.state = r.memoizedState, S.refs = Ug, Dh(r);
    var R = o.contextType;
    typeof R == "object" && R !== null ? S.context = ki(R) : (R = tr(o) ? Yr : Hn.current, S.context = xi(r, R)), S.state = r.memoizedState, R = o.getDerivedStateFromProps, typeof R == "function" && (Ih(r, o, R, d), S.state = r.memoizedState), typeof o.getDerivedStateFromProps == "function" || typeof S.getSnapshotBeforeUpdate == "function" || typeof S.UNSAFE_componentWillMount != "function" && typeof S.componentWillMount != "function" || (o = S.state, typeof S.componentWillMount == "function" && S.componentWillMount(), typeof S.UNSAFE_componentWillMount == "function" && S.UNSAFE_componentWillMount(), o !== S.state && Yd.enqueueReplaceState(S, S.state, null), qd(r, d, S, g), S.state = r.memoizedState), typeof S.componentDidMount == "function" && (r.flags |= 4194308);
  }
  function Ku(r, o, d) {
    if (r = d.ref, r !== null && typeof r != "function" && typeof r != "object") {
      if (d._owner) {
        if (d = d._owner, d) {
          if (d.tag !== 1) throw Error(i(309));
          var g = d.stateNode;
        }
        if (!g) throw Error(i(147, r));
        var S = g,
          R = "" + r;
        return o !== null && o.ref !== null && typeof o.ref == "function" && o.ref._stringRef === R ? o.ref : (o = function (A) {
          var q = S.refs;
          q === Ug && (q = S.refs = {}), A === null ? delete q[R] : q[R] = A;
        }, o._stringRef = R, o);
      }
      if (typeof r != "string") throw Error(i(284));
      if (!d._owner) throw Error(i(290, r));
    }
    return r;
  }
  function Gd(r, o) {
    throw r = Object.prototype.toString.call(o), Error(i(31, r === "[object Object]" ? "object with keys {" + Object.keys(o).join(", ") + "}" : r));
  }
  function $g(r) {
    var o = r._init;
    return o(r._payload);
  }
  function Wg(r) {
    function o(pe, ae) {
      if (r) {
        var he = pe.deletions;
        he === null ? (pe.deletions = [ae], pe.flags |= 16) : he.push(ae);
      }
    }
    function d(pe, ae) {
      if (!r) return null;
      for (; ae !== null;) o(pe, ae), ae = ae.sibling;
      return null;
    }
    function g(pe, ae) {
      for (pe = /* @__PURE__ */new Map(); ae !== null;) ae.key !== null ? pe.set(ae.key, ae) : pe.set(ae.index, ae), ae = ae.sibling;
      return pe;
    }
    function S(pe, ae) {
      return pe = Oa(pe, ae), pe.index = 0, pe.sibling = null, pe;
    }
    function R(pe, ae, he) {
      return pe.index = he, r ? (he = pe.alternate, he !== null ? (he = he.index, he < ae ? (pe.flags |= 2, ae) : he) : (pe.flags |= 2, ae)) : (pe.flags |= 1048576, ae);
    }
    function A(pe) {
      return r && pe.alternate === null && (pe.flags |= 2), pe;
    }
    function q(pe, ae, he, He) {
      return ae === null || ae.tag !== 6 ? (ae = yf(he, pe.mode, He), ae.return = pe, ae) : (ae = S(ae, he), ae.return = pe, ae);
    }
    function re(pe, ae, he, He) {
      var ut = he.type;
      return ut === G ? Le(pe, ae, he.props.children, He, he.key) : ae !== null && (ae.elementType === ut || typeof ut == "object" && ut !== null && ut.$$typeof === ue && $g(ut) === ae.type) ? (He = S(ae, he.props), He.ref = Ku(pe, ae, he), He.return = pe, He) : (He = Js(he.type, he.key, he.props, null, pe.mode, He), He.ref = Ku(pe, ae, he), He.return = pe, He);
    }
    function be(pe, ae, he, He) {
      return ae === null || ae.tag !== 4 || ae.stateNode.containerInfo !== he.containerInfo || ae.stateNode.implementation !== he.implementation ? (ae = bf(he, pe.mode, He), ae.return = pe, ae) : (ae = S(ae, he.children || []), ae.return = pe, ae);
    }
    function Le(pe, ae, he, He, ut) {
      return ae === null || ae.tag !== 7 ? (ae = oo(he, pe.mode, He, ut), ae.return = pe, ae) : (ae = S(ae, he), ae.return = pe, ae);
    }
    function Ve(pe, ae, he) {
      if (typeof ae == "string" && ae !== "" || typeof ae == "number") return ae = yf("" + ae, pe.mode, he), ae.return = pe, ae;
      if (typeof ae == "object" && ae !== null) {
        switch (ae.$$typeof) {
          case V:
            return he = Js(ae.type, ae.key, ae.props, null, pe.mode, he), he.ref = Ku(pe, null, ae), he.return = pe, he;
          case K:
            return ae = bf(ae, pe.mode, he), ae.return = pe, ae;
          case ue:
            var He = ae._init;
            return Ve(pe, He(ae._payload), he);
        }
        if (St(ae) || le(ae)) return ae = oo(ae, pe.mode, he, null), ae.return = pe, ae;
        Gd(pe, ae);
      }
      return null;
    }
    function Oe(pe, ae, he, He) {
      var ut = ae !== null ? ae.key : null;
      if (typeof he == "string" && he !== "" || typeof he == "number") return ut !== null ? null : q(pe, ae, "" + he, He);
      if (typeof he == "object" && he !== null) {
        switch (he.$$typeof) {
          case V:
            return he.key === ut ? re(pe, ae, he, He) : null;
          case K:
            return he.key === ut ? be(pe, ae, he, He) : null;
          case ue:
            return ut = he._init, Oe(pe, ae, ut(he._payload), He);
        }
        if (St(he) || le(he)) return ut !== null ? null : Le(pe, ae, he, He, null);
        Gd(pe, he);
      }
      return null;
    }
    function et(pe, ae, he, He, ut) {
      if (typeof He == "string" && He !== "" || typeof He == "number") return pe = pe.get(he) || null, q(ae, pe, "" + He, ut);
      if (typeof He == "object" && He !== null) {
        switch (He.$$typeof) {
          case V:
            return pe = pe.get(He.key === null ? he : He.key) || null, re(ae, pe, He, ut);
          case K:
            return pe = pe.get(He.key === null ? he : He.key) || null, be(ae, pe, He, ut);
          case ue:
            var bt = He._init;
            return et(pe, ae, he, bt(He._payload), ut);
        }
        if (St(He) || le(He)) return pe = pe.get(he) || null, Le(ae, pe, He, ut, null);
        Gd(ae, He);
      }
      return null;
    }
    function it(pe, ae, he, He) {
      for (var ut = null, bt = null, wt = ae, It = ae = 0, mr = null; wt !== null && It < he.length; It++) {
        wt.index > It ? (mr = wt, wt = null) : mr = wt.sibling;
        var cn = Oe(pe, wt, he[It], He);
        if (cn === null) {
          wt === null && (wt = mr);
          break;
        }
        r && wt && cn.alternate === null && o(pe, wt), ae = R(cn, ae, It), bt === null ? ut = cn : bt.sibling = cn, bt = cn, wt = mr;
      }
      if (It === he.length) return d(pe, wt), In && Ns(pe, It), ut;
      if (wt === null) {
        for (; It < he.length; It++) wt = Ve(pe, he[It], He), wt !== null && (ae = R(wt, ae, It), bt === null ? ut = wt : bt.sibling = wt, bt = wt);
        return In && Ns(pe, It), ut;
      }
      for (wt = g(pe, wt); It < he.length; It++) mr = et(wt, pe, It, he[It], He), mr !== null && (r && mr.alternate !== null && wt.delete(mr.key === null ? It : mr.key), ae = R(mr, ae, It), bt === null ? ut = mr : bt.sibling = mr, bt = mr);
      return r && wt.forEach(function (so) {
        return o(pe, so);
      }), In && Ns(pe, It), ut;
    }
    function st(pe, ae, he, He) {
      var ut = le(he);
      if (typeof ut != "function") throw Error(i(150));
      if (he = ut.call(he), he == null) throw Error(i(151));
      for (var bt = ut = null, wt = ae, It = ae = 0, mr = null, cn = he.next(); wt !== null && !cn.done; It++, cn = he.next()) {
        wt.index > It ? (mr = wt, wt = null) : mr = wt.sibling;
        var so = Oe(pe, wt, cn.value, He);
        if (so === null) {
          wt === null && (wt = mr);
          break;
        }
        r && wt && so.alternate === null && o(pe, wt), ae = R(so, ae, It), bt === null ? ut = so : bt.sibling = so, bt = so, wt = mr;
      }
      if (cn.done) return d(pe, wt), In && Ns(pe, It), ut;
      if (wt === null) {
        for (; !cn.done; It++, cn = he.next()) cn = Ve(pe, cn.value, He), cn !== null && (ae = R(cn, ae, It), bt === null ? ut = cn : bt.sibling = cn, bt = cn);
        return In && Ns(pe, It), ut;
      }
      for (wt = g(pe, wt); !cn.done; It++, cn = he.next()) cn = et(wt, pe, It, cn.value, He), cn !== null && (r && cn.alternate !== null && wt.delete(cn.key === null ? It : cn.key), ae = R(cn, ae, It), bt === null ? ut = cn : bt.sibling = cn, bt = cn);
      return r && wt.forEach(function (Pb) {
        return o(pe, Pb);
      }), In && Ns(pe, It), ut;
    }
    function Kn(pe, ae, he, He) {
      if (typeof he == "object" && he !== null && he.type === G && he.key === null && (he = he.props.children), typeof he == "object" && he !== null) {
        switch (he.$$typeof) {
          case V:
            e: {
              for (var ut = he.key, bt = ae; bt !== null;) {
                if (bt.key === ut) {
                  if (ut = he.type, ut === G) {
                    if (bt.tag === 7) {
                      d(pe, bt.sibling), ae = S(bt, he.props.children), ae.return = pe, pe = ae;
                      break e;
                    }
                  } else if (bt.elementType === ut || typeof ut == "object" && ut !== null && ut.$$typeof === ue && $g(ut) === bt.type) {
                    d(pe, bt.sibling), ae = S(bt, he.props), ae.ref = Ku(pe, bt, he), ae.return = pe, pe = ae;
                    break e;
                  }
                  d(pe, bt);
                  break;
                } else o(pe, bt);
                bt = bt.sibling;
              }
              he.type === G ? (ae = oo(he.props.children, pe.mode, He, he.key), ae.return = pe, pe = ae) : (He = Js(he.type, he.key, he.props, null, pe.mode, He), He.ref = Ku(pe, ae, he), He.return = pe, pe = He);
            }
            return A(pe);
          case K:
            e: {
              for (bt = he.key; ae !== null;) {
                if (ae.key === bt) {
                  if (ae.tag === 4 && ae.stateNode.containerInfo === he.containerInfo && ae.stateNode.implementation === he.implementation) {
                    d(pe, ae.sibling), ae = S(ae, he.children || []), ae.return = pe, pe = ae;
                    break e;
                  } else {
                    d(pe, ae);
                    break;
                  }
                } else o(pe, ae);
                ae = ae.sibling;
              }
              ae = bf(he, pe.mode, He), ae.return = pe, pe = ae;
            }
            return A(pe);
          case ue:
            return bt = he._init, Kn(pe, ae, bt(he._payload), He);
        }
        if (St(he)) return it(pe, ae, he, He);
        if (le(he)) return st(pe, ae, he, He);
        Gd(pe, he);
      }
      return typeof he == "string" && he !== "" || typeof he == "number" ? (he = "" + he, ae !== null && ae.tag === 6 ? (d(pe, ae.sibling), ae = S(ae, he), ae.return = pe, pe = ae) : (d(pe, ae), ae = yf(he, pe.mode, He), ae.return = pe, pe = ae), A(pe)) : d(pe, ae);
    }
    return Kn;
  }
  var Vs = Wg(!0),
    qg = Wg(!1),
    Nl = {},
    _a = Ki(Nl),
    Qu = Ki(Nl),
    Bs = Ki(Nl);
  function dt(r) {
    if (r === Nl) throw Error(i(174));
    return r;
  }
  function Wt(r, o) {
    switch (ft(Bs, o), ft(Qu, r), ft(_a, Nl), r = o.nodeType, r) {
      case 9:
      case 11:
        o = (o = o.documentElement) ? o.namespaceURI : Xt(null, "");
        break;
      default:
        r = r === 8 ? o.parentNode : o, o = r.namespaceURI || null, r = r.tagName, o = Xt(o, r);
    }
    Sn(_a), ft(_a, o);
  }
  function nn() {
    Sn(_a), Sn(Qu), Sn(Bs);
  }
  function Xn(r) {
    dt(Bs.current);
    var o = dt(_a.current),
      d = Xt(o, r.type);
    o !== d && (ft(Qu, r), ft(_a, d));
  }
  function Ri(r) {
    Qu.current === r && (Sn(_a), Sn(Qu));
  }
  var Mn = Ki(0);
  function Xd(r) {
    for (var o = r; o !== null;) {
      if (o.tag === 13) {
        var d = o.memoizedState;
        if (d !== null && (d = d.dehydrated, d === null || d.data === "$?" || d.data === "$!")) return o;
      } else if (o.tag === 19 && o.memoizedProps.revealOrder !== void 0) {
        if ((o.flags & 128) !== 0) return o;
      } else if (o.child !== null) {
        o.child.return = o, o = o.child;
        continue;
      }
      if (o === r) break;
      for (; o.sibling === null;) {
        if (o.return === null || o.return === r) return null;
        o = o.return;
      }
      o.sibling.return = o.return, o = o.sibling;
    }
    return null;
  }
  var Ph = [];
  function Ah() {
    for (var r = 0; r < Ph.length; r++) Ph[r]._workInProgressVersionPrimary = null;
    Ph.length = 0;
  }
  var zl = j.ReactCurrentDispatcher,
    De = j.ReactCurrentBatchConfig,
    On = 0,
    Je = null,
    Ln = null,
    Cn = null,
    xa = !1,
    Qr = !1,
    no = 0,
    Vl = 0;
  function rr() {
    throw Error(i(321));
  }
  function Zu(r, o) {
    if (o === null) return !1;
    for (var d = 0; d < o.length && d < r.length; d++) if (!Gi(r[d], o[d])) return !1;
    return !0;
  }
  function Ju(r, o, d, g, S, R) {
    if (On = R, Je = o, o.memoizedState = null, o.updateQueue = null, o.lanes = 0, zl.current = r === null || r.memoizedState === null ? Lw : Fh, r = d(g, S), Qr) {
      R = 0;
      do {
        if (Qr = !1, no = 0, 25 <= R) throw Error(i(301));
        R += 1, Cn = Ln = null, o.updateQueue = null, zl.current = Qg, r = d(g, S);
      } while (Qr);
    }
    if (zl.current = ql, o = Ln !== null && Ln.next !== null, On = 0, Cn = Ln = Je = null, xa = !1, o) throw Error(i(300));
    return r;
  }
  function ec() {
    var r = no !== 0;
    return no = 0, r;
  }
  function Di() {
    var r = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return Cn === null ? Je.memoizedState = Cn = r : Cn = Cn.next = r, Cn;
  }
  function Zr() {
    if (Ln === null) {
      var r = Je.alternate;
      r = r !== null ? r.memoizedState : null;
    } else r = Ln.next;
    var o = Cn === null ? Je.memoizedState : Cn.next;
    if (o !== null) Cn = o, Ln = r;else {
      if (r === null) throw Error(i(310));
      Ln = r, r = {
        memoizedState: Ln.memoizedState,
        baseState: Ln.baseState,
        baseQueue: Ln.baseQueue,
        queue: Ln.queue,
        next: null
      }, Cn === null ? Je.memoizedState = Cn = r : Cn = Cn.next = r;
    }
    return Cn;
  }
  function Us(r, o) {
    return typeof o == "function" ? o(r) : o;
  }
  function tc(r) {
    var o = Zr(),
      d = o.queue;
    if (d === null) throw Error(i(311));
    d.lastRenderedReducer = r;
    var g = Ln,
      S = g.baseQueue,
      R = d.pending;
    if (R !== null) {
      if (S !== null) {
        var A = S.next;
        S.next = R.next, R.next = A;
      }
      g.baseQueue = S = R, d.pending = null;
    }
    if (S !== null) {
      R = S.next, g = g.baseState;
      var q = A = null,
        re = null,
        be = R;
      do {
        var Le = be.lane;
        if ((On & Le) === Le) re !== null && (re = re.next = {
          lane: 0,
          action: be.action,
          hasEagerState: be.hasEagerState,
          eagerState: be.eagerState,
          next: null
        }), g = be.hasEagerState ? be.eagerState : r(g, be.action);else {
          var Ve = {
            lane: Le,
            action: be.action,
            hasEagerState: be.hasEagerState,
            eagerState: be.eagerState,
            next: null
          };
          re === null ? (q = re = Ve, A = g) : re = re.next = Ve, Je.lanes |= Le, xo |= Le;
        }
        be = be.next;
      } while (be !== null && be !== R);
      re === null ? A = g : re.next = q, Gi(g, o.memoizedState) || (Dr = !0), o.memoizedState = g, o.baseState = A, o.baseQueue = re, d.lastRenderedState = g;
    }
    if (r = d.interleaved, r !== null) {
      S = r;
      do R = S.lane, Je.lanes |= R, xo |= R, S = S.next; while (S !== r);
    } else S === null && (d.lanes = 0);
    return [o.memoizedState, d.dispatch];
  }
  function nc(r) {
    var o = Zr(),
      d = o.queue;
    if (d === null) throw Error(i(311));
    d.lastRenderedReducer = r;
    var g = d.dispatch,
      S = d.pending,
      R = o.memoizedState;
    if (S !== null) {
      d.pending = null;
      var A = S = S.next;
      do R = r(R, A.action), A = A.next; while (A !== S);
      Gi(R, o.memoizedState) || (Dr = !0), o.memoizedState = R, o.baseQueue === null && (o.baseState = R), d.lastRenderedState = R;
    }
    return [R, g];
  }
  function Kd() {}
  function Qd(r, o) {
    var d = Je,
      g = Zr(),
      S = o(),
      R = !Gi(g.memoizedState, S);
    if (R && (g.memoizedState = S, Dr = !0), g = g.queue, of(ef.bind(null, d, g, r), [r]), g.getSnapshot !== o || R || Cn !== null && Cn.memoizedState.tag & 1) {
      if (d.flags |= 2048, Sa(9, Jd.bind(null, d, g, S, o), void 0, null), pr === null) throw Error(i(349));
      (On & 30) !== 0 || Zd(d, o, S);
    }
    return S;
  }
  function Zd(r, o, d) {
    r.flags |= 16384, r = {
      getSnapshot: o,
      value: d
    }, o = Je.updateQueue, o === null ? (o = {
      lastEffect: null,
      stores: null
    }, Je.updateQueue = o, o.stores = [r]) : (d = o.stores, d === null ? o.stores = [r] : d.push(r));
  }
  function Jd(r, o, d, g) {
    o.value = d, o.getSnapshot = g, tf(o) && nf(r);
  }
  function ef(r, o, d) {
    return d(function () {
      tf(o) && nf(r);
    });
  }
  function tf(r) {
    var o = r.getSnapshot;
    r = r.value;
    try {
      var d = o();
      return !Gi(r, d);
    } catch {
      return !0;
    }
  }
  function nf(r) {
    var o = En(r, 1);
    o !== null && Oi(o, r, 1, -1);
  }
  function rc(r) {
    var o = Di();
    return typeof r == "function" && (r = r()), o.memoizedState = o.baseState = r, r = {
      pending: null,
      interleaved: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: Us,
      lastRenderedState: r
    }, o.queue = r, r = r.dispatch = Ow.bind(null, Je, r), [o.memoizedState, r];
  }
  function Sa(r, o, d, g) {
    return r = {
      tag: r,
      create: o,
      destroy: d,
      deps: g,
      next: null
    }, o = Je.updateQueue, o === null ? (o = {
      lastEffect: null,
      stores: null
    }, Je.updateQueue = o, o.lastEffect = r.next = r) : (d = o.lastEffect, d === null ? o.lastEffect = r.next = r : (g = d.next, d.next = r, r.next = g, o.lastEffect = r)), r;
  }
  function rf() {
    return Zr().memoizedState;
  }
  function Bl(r, o, d, g) {
    var S = Di();
    Je.flags |= r, S.memoizedState = Sa(1 | o, d, void 0, g === void 0 ? null : g);
  }
  function Ul(r, o, d, g) {
    var S = Zr();
    g = g === void 0 ? null : g;
    var R = void 0;
    if (Ln !== null) {
      var A = Ln.memoizedState;
      if (R = A.destroy, g !== null && Zu(g, A.deps)) {
        S.memoizedState = Sa(o, d, R, g);
        return;
      }
    }
    Je.flags |= r, S.memoizedState = Sa(1 | o, d, R, g);
  }
  function af(r, o) {
    return Bl(8390656, 8, r, o);
  }
  function of(r, o) {
    return Ul(2048, 8, r, o);
  }
  function Hl(r, o) {
    return Ul(4, 2, r, o);
  }
  function jh(r, o) {
    return Ul(4, 4, r, o);
  }
  function $l(r, o) {
    if (typeof o == "function") return r = r(), o(r), function () {
      o(null);
    };
    if (o != null) return r = r(), o.current = r, function () {
      o.current = null;
    };
  }
  function Yo(r, o, d) {
    return d = d != null ? d.concat([r]) : null, Ul(4, 4, $l.bind(null, o, r), d);
  }
  function Jr() {}
  function Yg(r, o) {
    var d = Zr();
    o = o === void 0 ? null : o;
    var g = d.memoizedState;
    return g !== null && o !== null && Zu(o, g[1]) ? g[0] : (d.memoizedState = [r, o], r);
  }
  function wn(r, o) {
    var d = Zr();
    o = o === void 0 ? null : o;
    var g = d.memoizedState;
    return g !== null && o !== null && Zu(o, g[1]) ? g[0] : (r = r(), d.memoizedState = [r, o], r);
  }
  function ic(r, o, d) {
    return (On & 21) === 0 ? (r.baseState && (r.baseState = !1, Dr = !0), r.memoizedState = d) : (Gi(d, o) || (d = pd(), Je.lanes |= d, xo |= d, r.baseState = !0), o);
  }
  function sf(r, o) {
    var d = gn;
    gn = d !== 0 && 4 > d ? d : 4, r(!0);
    var g = De.transition;
    De.transition = {};
    try {
      r(!1), o();
    } finally {
      gn = d, De.transition = g;
    }
  }
  function Wl() {
    return Zr().memoizedState;
  }
  function lf(r, o, d) {
    var g = Ca(r);
    if (d = {
      lane: g,
      action: d,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Gg(r)) Xg(o, d);else if (d = Ng(r, o, d, g), d !== null) {
      var S = hr();
      Oi(d, r, g, S), Kg(d, o, g);
    }
  }
  function Ow(r, o, d) {
    var g = Ca(r),
      S = {
        lane: g,
        action: d,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
    if (Gg(r)) Xg(o, S);else {
      var R = r.alternate;
      if (r.lanes === 0 && (R === null || R.lanes === 0) && (R = o.lastRenderedReducer, R !== null)) try {
        var A = o.lastRenderedState,
          q = R(A, d);
        if (S.hasEagerState = !0, S.eagerState = q, Gi(q, A)) {
          var re = o.interleaved;
          re === null ? (S.next = S, Rh(o)) : (S.next = re.next, re.next = S), o.interleaved = S;
          return;
        }
      } catch {} finally {}
      d = Ng(r, o, S, g), d !== null && (S = hr(), Oi(d, r, g, S), Kg(d, o, g));
    }
  }
  function Gg(r) {
    var o = r.alternate;
    return r === Je || o !== null && o === Je;
  }
  function Xg(r, o) {
    Qr = xa = !0;
    var d = r.pending;
    d === null ? o.next = o : (o.next = d.next, d.next = o), r.pending = o;
  }
  function Kg(r, o, d) {
    if ((d & 4194240) !== 0) {
      var g = o.lanes;
      g &= r.pendingLanes, d |= g, o.lanes = d, hd(r, d);
    }
  }
  var ql = {
      readContext: ki,
      useCallback: rr,
      useContext: rr,
      useEffect: rr,
      useImperativeHandle: rr,
      useInsertionEffect: rr,
      useLayoutEffect: rr,
      useMemo: rr,
      useReducer: rr,
      useRef: rr,
      useState: rr,
      useDebugValue: rr,
      useDeferredValue: rr,
      useTransition: rr,
      useMutableSource: rr,
      useSyncExternalStore: rr,
      useId: rr,
      unstable_isNewReconciler: !1
    },
    Lw = {
      readContext: ki,
      useCallback: function (r, o) {
        return Di().memoizedState = [r, o === void 0 ? null : o], r;
      },
      useContext: ki,
      useEffect: af,
      useImperativeHandle: function (r, o, d) {
        return d = d != null ? d.concat([r]) : null, Bl(4194308, 4, $l.bind(null, o, r), d);
      },
      useLayoutEffect: function (r, o) {
        return Bl(4194308, 4, r, o);
      },
      useInsertionEffect: function (r, o) {
        return Bl(4, 2, r, o);
      },
      useMemo: function (r, o) {
        var d = Di();
        return o = o === void 0 ? null : o, r = r(), d.memoizedState = [r, o], r;
      },
      useReducer: function (r, o, d) {
        var g = Di();
        return o = d !== void 0 ? d(o) : o, g.memoizedState = g.baseState = o, r = {
          pending: null,
          interleaved: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: r,
          lastRenderedState: o
        }, g.queue = r, r = r.dispatch = lf.bind(null, Je, r), [g.memoizedState, r];
      },
      useRef: function (r) {
        var o = Di();
        return r = {
          current: r
        }, o.memoizedState = r;
      },
      useState: rc,
      useDebugValue: Jr,
      useDeferredValue: function (r) {
        return Di().memoizedState = r;
      },
      useTransition: function () {
        var r = rc(!1),
          o = r[0];
        return r = sf.bind(null, r[1]), Di().memoizedState = r, [o, r];
      },
      useMutableSource: function () {},
      useSyncExternalStore: function (r, o, d) {
        var g = Je,
          S = Di();
        if (In) {
          if (d === void 0) throw Error(i(407));
          d = d();
        } else {
          if (d = o(), pr === null) throw Error(i(349));
          (On & 30) !== 0 || Zd(g, o, d);
        }
        S.memoizedState = d;
        var R = {
          value: d,
          getSnapshot: o
        };
        return S.queue = R, af(ef.bind(null, g, R, r), [r]), g.flags |= 2048, Sa(9, Jd.bind(null, g, R, d, o), void 0, null), d;
      },
      useId: function () {
        var r = Di(),
          o = pr.identifierPrefix;
        if (In) {
          var d = ba,
            g = ya;
          d = (g & ~(1 << 32 - gi(g) - 1)).toString(32) + d, o = ":" + o + "R" + d, d = no++, 0 < d && (o += "H" + d.toString(32)), o += ":";
        } else d = Vl++, o = ":" + o + "r" + d.toString(32) + ":";
        return r.memoizedState = o;
      },
      unstable_isNewReconciler: !1
    },
    Fh = {
      readContext: ki,
      useCallback: Yg,
      useContext: ki,
      useEffect: of,
      useImperativeHandle: Yo,
      useInsertionEffect: Hl,
      useLayoutEffect: jh,
      useMemo: wn,
      useReducer: tc,
      useRef: rf,
      useState: function () {
        return tc(Us);
      },
      useDebugValue: Jr,
      useDeferredValue: function (r) {
        var o = Zr();
        return ic(o, Ln.memoizedState, r);
      },
      useTransition: function () {
        var r = tc(Us)[0],
          o = Zr().memoizedState;
        return [r, o];
      },
      useMutableSource: Kd,
      useSyncExternalStore: Qd,
      useId: Wl,
      unstable_isNewReconciler: !1
    },
    Qg = {
      readContext: ki,
      useCallback: Yg,
      useContext: ki,
      useEffect: of,
      useImperativeHandle: Yo,
      useInsertionEffect: Hl,
      useLayoutEffect: jh,
      useMemo: wn,
      useReducer: nc,
      useRef: rf,
      useState: function () {
        return nc(Us);
      },
      useDebugValue: Jr,
      useDeferredValue: function (r) {
        var o = Zr();
        return Ln === null ? o.memoizedState = r : ic(o, Ln.memoizedState, r);
      },
      useTransition: function () {
        var r = nc(Us)[0],
          o = Zr().memoizedState;
        return [r, o];
      },
      useMutableSource: Kd,
      useSyncExternalStore: Qd,
      useId: Wl,
      unstable_isNewReconciler: !1
    };
  function Yl(r, o) {
    try {
      var d = "",
        g = o;
      do d += fe(g), g = g.return; while (g);
      var S = d;
    } catch (R) {
      S = `
Error generating stack: ` + R.message + `
` + R.stack;
    }
    return {
      value: r,
      source: o,
      stack: S,
      digest: null
    };
  }
  function Nh(r, o, d) {
    return {
      value: r,
      source: null,
      stack: d ?? null,
      digest: o ?? null
    };
  }
  function Gl(r, o) {
    try {
      console.error(o.value);
    } catch (d) {
      setTimeout(function () {
        throw d;
      });
    }
  }
  var Pw = typeof WeakMap == "function" ? WeakMap : Map;
  function zh(r, o, d) {
    d = wa(-1, d), d.tag = 3, d.payload = {
      element: null
    };
    var g = o.value;
    return d.callback = function () {
      Kl || (Kl = !0, Yh = g), Gl(r, o);
    }, d;
  }
  function Vh(r, o, d) {
    d = wa(-1, d), d.tag = 3;
    var g = r.type.getDerivedStateFromError;
    if (typeof g == "function") {
      var S = o.value;
      d.payload = function () {
        return g(S);
      }, d.callback = function () {
        Gl(r, o);
      };
    }
    var R = r.stateNode;
    return R !== null && typeof R.componentDidCatch == "function" && (d.callback = function () {
      Gl(r, o), typeof g != "function" && (So === null ? So = /* @__PURE__ */new Set([this]) : So.add(this));
      var A = o.stack;
      this.componentDidCatch(o.value, {
        componentStack: A !== null ? A : ""
      });
    }), d;
  }
  function Zg(r, o, d) {
    var g = r.pingCache;
    if (g === null) {
      g = r.pingCache = new Pw();
      var S = /* @__PURE__ */new Set();
      g.set(o, S);
    } else S = g.get(o), S === void 0 && (S = /* @__PURE__ */new Set(), g.set(o, S));
    S.has(d) || (S.add(d), r = Fw.bind(null, r, o, d), o.then(r, r));
  }
  function Go(r) {
    do {
      var o;
      if ((o = r.tag === 13) && (o = r.memoizedState, o = o !== null ? o.dehydrated !== null : !0), o) return r;
      r = r.return;
    } while (r !== null);
    return null;
  }
  function Xl(r, o, d, g, S) {
    return (r.mode & 1) === 0 ? (r === o ? r.flags |= 65536 : (r.flags |= 128, d.flags |= 131072, d.flags &= -52805, d.tag === 1 && (d.alternate === null ? d.tag = 17 : (o = wa(-1, 1), o.tag = 2, Ti(d, o, 1))), d.lanes |= 1), r) : (r.flags |= 65536, r.lanes = S, r);
  }
  var Hs = j.ReactCurrentOwner,
    Dr = !1;
  function _n(r, o, d, g) {
    o.child = r === null ? qg(o, null, d, g) : Vs(o, r.child, d, g);
  }
  function $s(r, o, d, g, S) {
    d = d.render;
    var R = o.ref;
    return Fl(o, S), g = Ju(r, o, d, g, R, S), d = ec(), r !== null && !Dr ? (o.updateQueue = r.updateQueue, o.flags &= -2053, r.lanes &= ~S, Ir(r, o, S)) : (In && d && Bd(o), o.flags |= 1, _n(r, o, g, S), o.child);
  }
  function jt(r, o, d, g, S) {
    if (r === null) {
      var R = d.type;
      return typeof R == "function" && !Zh(R) && R.defaultProps === void 0 && d.compare === null && d.defaultProps === void 0 ? (o.tag = 15, o.type = R, ac(r, o, R, g, S)) : (r = Js(d.type, null, g, o, o.mode, S), r.ref = o.ref, r.return = o, o.child = r);
    }
    if (R = r.child, (r.lanes & S) === 0) {
      var A = R.memoizedProps;
      if (d = d.compare, d = d !== null ? d : Vu, d(A, g) && r.ref === o.ref) return Ir(r, o, S);
    }
    return o.flags |= 1, r = Oa(R, g), r.ref = o.ref, r.return = o, o.child = r;
  }
  function ac(r, o, d, g, S) {
    if (r !== null) {
      var R = r.memoizedProps;
      if (Vu(R, g) && r.ref === o.ref) if (Dr = !1, o.pendingProps = g = R, (r.lanes & S) !== 0) (r.flags & 131072) !== 0 && (Dr = !0);else return o.lanes = r.lanes, Ir(r, o, S);
    }
    return uf(r, o, d, g, S);
  }
  function Bh(r, o, d) {
    var g = o.pendingProps,
      S = g.children,
      R = r !== null ? r.memoizedState : null;
    if (g.mode === "hidden") {
      if ((o.mode & 1) === 0) o.memoizedState = {
        baseLanes: 0,
        cachePool: null,
        transitions: null
      }, ft(Ys, ei), ei |= d;else {
        if ((d & 1073741824) === 0) return r = R !== null ? R.baseLanes | d : d, o.lanes = o.childLanes = 1073741824, o.memoizedState = {
          baseLanes: r,
          cachePool: null,
          transitions: null
        }, o.updateQueue = null, ft(Ys, ei), ei |= r, null;
        o.memoizedState = {
          baseLanes: 0,
          cachePool: null,
          transitions: null
        }, g = R !== null ? R.baseLanes : d, ft(Ys, ei), ei |= g;
      }
    } else R !== null ? (g = R.baseLanes | d, o.memoizedState = null) : g = d, ft(Ys, ei), ei |= g;
    return _n(r, o, S, d), o.child;
  }
  function Sb(r, o) {
    var d = o.ref;
    (r === null && d !== null || r !== null && r.ref !== d) && (o.flags |= 512, o.flags |= 2097152);
  }
  function uf(r, o, d, g, S) {
    var R = tr(d) ? Yr : Hn.current;
    return R = xi(o, R), Fl(o, S), d = Ju(r, o, d, g, R, S), g = ec(), r !== null && !Dr ? (o.updateQueue = r.updateQueue, o.flags &= -2053, r.lanes &= ~S, Ir(r, o, S)) : (In && g && Bd(o), o.flags |= 1, _n(r, o, d, S), o.child);
  }
  function oc(r, o, d, g, S) {
    if (tr(d)) {
      var R = !0;
      Gr(o);
    } else R = !1;
    if (Fl(o, S), o.stateNode === null) ss(r, o), Oh(o, d, g), Lh(o, d, g, S), g = !0;else if (r === null) {
      var A = o.stateNode,
        q = o.memoizedProps;
      A.props = q;
      var re = A.context,
        be = d.contextType;
      typeof be == "object" && be !== null ? be = ki(be) : (be = tr(d) ? Yr : Hn.current, be = xi(o, be));
      var Le = d.getDerivedStateFromProps,
        Ve = typeof Le == "function" || typeof A.getSnapshotBeforeUpdate == "function";
      Ve || typeof A.UNSAFE_componentWillReceiveProps != "function" && typeof A.componentWillReceiveProps != "function" || (q !== g || re !== be) && Hg(o, A, g, be), qo = !1;
      var Oe = o.memoizedState;
      A.state = Oe, qd(o, g, A, S), re = o.memoizedState, q !== g || Oe !== re || or.current || qo ? (typeof Le == "function" && (Ih(o, d, Le, g), re = o.memoizedState), (q = qo || Mh(o, d, q, g, Oe, re, be)) ? (Ve || typeof A.UNSAFE_componentWillMount != "function" && typeof A.componentWillMount != "function" || (typeof A.componentWillMount == "function" && A.componentWillMount(), typeof A.UNSAFE_componentWillMount == "function" && A.UNSAFE_componentWillMount()), typeof A.componentDidMount == "function" && (o.flags |= 4194308)) : (typeof A.componentDidMount == "function" && (o.flags |= 4194308), o.memoizedProps = g, o.memoizedState = re), A.props = g, A.state = re, A.context = be, g = q) : (typeof A.componentDidMount == "function" && (o.flags |= 4194308), g = !1);
    } else {
      A = o.stateNode, zg(r, o), q = o.memoizedProps, be = o.type === o.elementType ? q : li(o.type, q), A.props = be, Ve = o.pendingProps, Oe = A.context, re = d.contextType, typeof re == "object" && re !== null ? re = ki(re) : (re = tr(d) ? Yr : Hn.current, re = xi(o, re));
      var et = d.getDerivedStateFromProps;
      (Le = typeof et == "function" || typeof A.getSnapshotBeforeUpdate == "function") || typeof A.UNSAFE_componentWillReceiveProps != "function" && typeof A.componentWillReceiveProps != "function" || (q !== Ve || Oe !== re) && Hg(o, A, g, re), qo = !1, Oe = o.memoizedState, A.state = Oe, qd(o, g, A, S);
      var it = o.memoizedState;
      q !== Ve || Oe !== it || or.current || qo ? (typeof et == "function" && (Ih(o, d, et, g), it = o.memoizedState), (be = qo || Mh(o, d, be, g, Oe, it, re) || !1) ? (Le || typeof A.UNSAFE_componentWillUpdate != "function" && typeof A.componentWillUpdate != "function" || (typeof A.componentWillUpdate == "function" && A.componentWillUpdate(g, it, re), typeof A.UNSAFE_componentWillUpdate == "function" && A.UNSAFE_componentWillUpdate(g, it, re)), typeof A.componentDidUpdate == "function" && (o.flags |= 4), typeof A.getSnapshotBeforeUpdate == "function" && (o.flags |= 1024)) : (typeof A.componentDidUpdate != "function" || q === r.memoizedProps && Oe === r.memoizedState || (o.flags |= 4), typeof A.getSnapshotBeforeUpdate != "function" || q === r.memoizedProps && Oe === r.memoizedState || (o.flags |= 1024), o.memoizedProps = g, o.memoizedState = it), A.props = g, A.state = it, A.context = re, g = be) : (typeof A.componentDidUpdate != "function" || q === r.memoizedProps && Oe === r.memoizedState || (o.flags |= 4), typeof A.getSnapshotBeforeUpdate != "function" || q === r.memoizedProps && Oe === r.memoizedState || (o.flags |= 1024), g = !1);
    }
    return sc(r, o, d, g, R, S);
  }
  function sc(r, o, d, g, S, R) {
    Sb(r, o);
    var A = (o.flags & 128) !== 0;
    if (!g && !A) return S && zd(o, d, !1), Ir(r, o, R);
    g = o.stateNode, Hs.current = o;
    var q = A && typeof d.getDerivedStateFromError != "function" ? null : g.render();
    return o.flags |= 1, r !== null && A ? (o.child = Vs(o, r.child, null, R), o.child = Vs(o, null, q, R)) : _n(r, o, q, R), o.memoizedState = g.state, S && zd(o, d, !0), o.child;
  }
  function Km(r) {
    var o = r.stateNode;
    o.pendingContext ? Ag(r, o.pendingContext, o.pendingContext !== o.context) : o.context && Ag(r, o.context, !1), Wt(r, o.containerInfo);
  }
  function Qm(r, o, d, g, S) {
    return Wo(), eo(S), o.flags |= 256, _n(r, o, d, g), o.child;
  }
  var cf = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
  };
  function df(r) {
    return {
      baseLanes: r,
      cachePool: null,
      transitions: null
    };
  }
  function Zm(r, o, d) {
    var g = o.pendingProps,
      S = Mn.current,
      R = !1,
      A = (o.flags & 128) !== 0,
      q;
    if ((q = A) || (q = r !== null && r.memoizedState === null ? !1 : (S & 2) !== 0), q ? (R = !0, o.flags &= -129) : (r === null || r.memoizedState !== null) && (S |= 1), ft(Mn, S & 1), r === null) return Th(o), r = o.memoizedState, r !== null && (r = r.dehydrated, r !== null) ? ((o.mode & 1) === 0 ? o.lanes = 1 : r.data === "$!" ? o.lanes = 8 : o.lanes = 1073741824, null) : (A = g.children, r = g.fallback, R ? (g = o.mode, R = o.child, A = {
      mode: "hidden",
      children: A
    }, (g & 1) === 0 && R !== null ? (R.childLanes = 0, R.pendingProps = A) : R = jc(A, g, 0, null), r = oo(r, g, d, null), R.return = o, r.return = o, R.sibling = r, o.child = R, o.child.memoizedState = df(d), o.memoizedState = cf, r) : ff(o, A));
    if (S = r.memoizedState, S !== null && (q = S.dehydrated, q !== null)) return as(r, o, A, g, q, S, d);
    if (R) {
      R = g.fallback, A = o.mode, S = r.child, q = S.sibling;
      var re = {
        mode: "hidden",
        children: g.children
      };
      return (A & 1) === 0 && o.child !== S ? (g = o.child, g.childLanes = 0, g.pendingProps = re, o.deletions = null) : (g = Oa(S, re), g.subtreeFlags = S.subtreeFlags & 14680064), q !== null ? R = Oa(q, R) : (R = oo(R, A, d, null), R.flags |= 2), R.return = o, g.return = o, g.sibling = R, o.child = g, g = R, R = o.child, A = r.child.memoizedState, A = A === null ? df(d) : {
        baseLanes: A.baseLanes | d,
        cachePool: null,
        transitions: A.transitions
      }, R.memoizedState = A, R.childLanes = r.childLanes & ~d, o.memoizedState = cf, g;
    }
    return R = r.child, r = R.sibling, g = Oa(R, {
      mode: "visible",
      children: g.children
    }), (o.mode & 1) === 0 && (g.lanes = d), g.return = o, g.sibling = null, r !== null && (d = o.deletions, d === null ? (o.deletions = [r], o.flags |= 16) : d.push(r)), o.child = g, o.memoizedState = null, g;
  }
  function ff(r, o) {
    return o = jc({
      mode: "visible",
      children: o
    }, r.mode, 0, null), o.return = r, r.child = o;
  }
  function lc(r, o, d, g) {
    return g !== null && eo(g), Vs(o, r.child, null, d), r = ff(o, o.pendingProps.children), r.flags |= 2, o.memoizedState = null, r;
  }
  function as(r, o, d, g, S, R, A) {
    if (d) return o.flags & 256 ? (o.flags &= -257, g = Nh(Error(i(422))), lc(r, o, A, g)) : o.memoizedState !== null ? (o.child = r.child, o.flags |= 128, null) : (R = g.fallback, S = o.mode, g = jc({
      mode: "visible",
      children: g.children
    }, S, 0, null), R = oo(R, S, A, null), R.flags |= 2, g.return = o, R.return = o, g.sibling = R, o.child = g, (o.mode & 1) !== 0 && Vs(o, r.child, null, A), o.child.memoizedState = df(A), o.memoizedState = cf, R);
    if ((o.mode & 1) === 0) return lc(r, o, A, null);
    if (S.data === "$!") {
      if (g = S.nextSibling && S.nextSibling.dataset, g) var q = g.dgst;
      return g = q, R = Error(i(419)), g = Nh(R, g, void 0), lc(r, o, A, g);
    }
    if (q = (A & r.childLanes) !== 0, Dr || q) {
      if (g = pr, g !== null) {
        switch (A & -A) {
          case 4:
            S = 2;
            break;
          case 16:
            S = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            S = 32;
            break;
          case 536870912:
            S = 268435456;
            break;
          default:
            S = 0;
        }
        S = (S & (g.suspendedLanes | A)) !== 0 ? 0 : S, S !== 0 && S !== R.retryLane && (R.retryLane = S, En(r, S), Oi(g, r, S, -1));
      }
      return Kh(), g = Nh(Error(i(421))), lc(r, o, A, g);
    }
    return S.data === "$?" ? (o.flags |= 128, o.child = r.child, o = Rb.bind(null, r), S._reactRetry = o, null) : (r = R.treeContext, Kr = ha(S.nextSibling), Xr = o, In = !0, Ei = null, r !== null && (nr[Si++] = ya, nr[Si++] = ba, nr[Si++] = si, ya = r.id, ba = r.overflow, si = o), o = ff(o, g.children), o.flags |= 4096, o);
  }
  function Ii(r, o, d) {
    r.lanes |= o;
    var g = r.alternate;
    g !== null && (g.lanes |= o), ui(r.return, o, d);
  }
  function Zi(r, o, d, g, S) {
    var R = r.memoizedState;
    R === null ? r.memoizedState = {
      isBackwards: o,
      rendering: null,
      renderingStartTime: 0,
      last: g,
      tail: d,
      tailMode: S
    } : (R.isBackwards = o, R.rendering = null, R.renderingStartTime = 0, R.last = g, R.tail = d, R.tailMode = S);
  }
  function os(r, o, d) {
    var g = o.pendingProps,
      S = g.revealOrder,
      R = g.tail;
    if (_n(r, o, g.children, d), g = Mn.current, (g & 2) !== 0) g = g & 1 | 2, o.flags |= 128;else {
      if (r !== null && (r.flags & 128) !== 0) e: for (r = o.child; r !== null;) {
        if (r.tag === 13) r.memoizedState !== null && Ii(r, d, o);else if (r.tag === 19) Ii(r, d, o);else if (r.child !== null) {
          r.child.return = r, r = r.child;
          continue;
        }
        if (r === o) break e;
        for (; r.sibling === null;) {
          if (r.return === null || r.return === o) break e;
          r = r.return;
        }
        r.sibling.return = r.return, r = r.sibling;
      }
      g &= 1;
    }
    if (ft(Mn, g), (o.mode & 1) === 0) o.memoizedState = null;else switch (S) {
      case "forwards":
        for (d = o.child, S = null; d !== null;) r = d.alternate, r !== null && Xd(r) === null && (S = d), d = d.sibling;
        d = S, d === null ? (S = o.child, o.child = null) : (S = d.sibling, d.sibling = null), Zi(o, !1, S, d, R);
        break;
      case "backwards":
        for (d = null, S = o.child, o.child = null; S !== null;) {
          if (r = S.alternate, r !== null && Xd(r) === null) {
            o.child = S;
            break;
          }
          r = S.sibling, S.sibling = d, d = S, S = r;
        }
        Zi(o, !0, d, null, R);
        break;
      case "together":
        Zi(o, !1, null, null, void 0);
        break;
      default:
        o.memoizedState = null;
    }
    return o.child;
  }
  function ss(r, o) {
    (o.mode & 1) === 0 && r !== null && (r.alternate = null, o.alternate = null, o.flags |= 2);
  }
  function Ir(r, o, d) {
    if (r !== null && (o.dependencies = r.dependencies), xo |= o.lanes, (d & o.childLanes) === 0) return null;
    if (r !== null && o.child !== r.child) throw Error(i(153));
    if (o.child !== null) {
      for (r = o.child, d = Oa(r, r.pendingProps), o.child = d, d.return = o; r.sibling !== null;) r = r.sibling, d = d.sibling = Oa(r, r.pendingProps), d.return = o;
      d.sibling = null;
    }
    return o.child;
  }
  function zr(r, o, d) {
    switch (o.tag) {
      case 3:
        Km(o), Wo();
        break;
      case 5:
        Xn(o);
        break;
      case 1:
        tr(o.type) && Gr(o);
        break;
      case 4:
        Wt(o, o.stateNode.containerInfo);
        break;
      case 10:
        var g = o.type._context,
          S = o.memoizedProps.value;
        ft($d, g._currentValue), g._currentValue = S;
        break;
      case 13:
        if (g = o.memoizedState, g !== null) return g.dehydrated !== null ? (ft(Mn, Mn.current & 1), o.flags |= 128, null) : (d & o.child.childLanes) !== 0 ? Zm(r, o, d) : (ft(Mn, Mn.current & 1), r = Ir(r, o, d), r !== null ? r.sibling : null);
        ft(Mn, Mn.current & 1);
        break;
      case 19:
        if (g = (d & o.childLanes) !== 0, (r.flags & 128) !== 0) {
          if (g) return os(r, o, d);
          o.flags |= 128;
        }
        if (S = o.memoizedState, S !== null && (S.rendering = null, S.tail = null, S.lastEffect = null), ft(Mn, Mn.current), g) break;
        return null;
      case 22:
      case 23:
        return o.lanes = 0, Bh(r, o, d);
    }
    return Ir(r, o, d);
  }
  var la, Uh, Jg, Hh;
  la = function (r, o) {
    for (var d = o.child; d !== null;) {
      if (d.tag === 5 || d.tag === 6) r.appendChild(d.stateNode);else if (d.tag !== 4 && d.child !== null) {
        d.child.return = d, d = d.child;
        continue;
      }
      if (d === o) break;
      for (; d.sibling === null;) {
        if (d.return === null || d.return === o) return;
        d = d.return;
      }
      d.sibling.return = d.return, d = d.sibling;
    }
  }, Uh = function () {}, Jg = function (r, o, d, g) {
    var S = r.memoizedProps;
    if (S !== g) {
      r = o.stateNode, dt(_a.current);
      var R = null;
      switch (d) {
        case "input":
          S = Ae(r, S), g = Ae(r, g), R = [];
          break;
        case "select":
          S = H({}, S, {
            value: void 0
          }), g = H({}, g, {
            value: void 0
          }), R = [];
          break;
        case "textarea":
          S = Kt(r, S), g = Kt(r, g), R = [];
          break;
        default:
          typeof S.onClick != "function" && typeof g.onClick == "function" && (r.onclick = zo);
      }
      kt(d, g);
      var A;
      d = null;
      for (be in S) if (!g.hasOwnProperty(be) && S.hasOwnProperty(be) && S[be] != null) if (be === "style") {
        var q = S[be];
        for (A in q) q.hasOwnProperty(A) && (d || (d = {}), d[A] = "");
      } else be !== "dangerouslySetInnerHTML" && be !== "children" && be !== "suppressContentEditableWarning" && be !== "suppressHydrationWarning" && be !== "autoFocus" && (c.hasOwnProperty(be) ? R || (R = []) : (R = R || []).push(be, null));
      for (be in g) {
        var re = g[be];
        if (q = S != null ? S[be] : void 0, g.hasOwnProperty(be) && re !== q && (re != null || q != null)) if (be === "style") {
          if (q) {
            for (A in q) !q.hasOwnProperty(A) || re && re.hasOwnProperty(A) || (d || (d = {}), d[A] = "");
            for (A in re) re.hasOwnProperty(A) && q[A] !== re[A] && (d || (d = {}), d[A] = re[A]);
          } else d || (R || (R = []), R.push(be, d)), d = re;
        } else be === "dangerouslySetInnerHTML" ? (re = re ? re.__html : void 0, q = q ? q.__html : void 0, re != null && q !== re && (R = R || []).push(be, re)) : be === "children" ? typeof re != "string" && typeof re != "number" || (R = R || []).push(be, "" + re) : be !== "suppressContentEditableWarning" && be !== "suppressHydrationWarning" && (c.hasOwnProperty(be) ? (re != null && be === "onScroll" && mn("scroll", r), R || q === re || (R = [])) : (R = R || []).push(be, re));
      }
      d && (R = R || []).push("style", d);
      var be = R;
      (o.updateQueue = be) && (o.flags |= 4);
    }
  }, Hh = function (r, o, d, g) {
    d !== g && (o.flags |= 4);
  };
  function ul(r, o) {
    if (!In) switch (r.tailMode) {
      case "hidden":
        o = r.tail;
        for (var d = null; o !== null;) o.alternate !== null && (d = o), o = o.sibling;
        d === null ? r.tail = null : d.sibling = null;
        break;
      case "collapsed":
        d = r.tail;
        for (var g = null; d !== null;) d.alternate !== null && (g = d), d = d.sibling;
        g === null ? o || r.tail === null ? r.tail = null : r.tail.sibling = null : g.sibling = null;
    }
  }
  function fr(r) {
    var o = r.alternate !== null && r.alternate.child === r.child,
      d = 0,
      g = 0;
    if (o) for (var S = r.child; S !== null;) d |= S.lanes | S.childLanes, g |= S.subtreeFlags & 14680064, g |= S.flags & 14680064, S.return = r, S = S.sibling;else for (S = r.child; S !== null;) d |= S.lanes | S.childLanes, g |= S.subtreeFlags, g |= S.flags, S.return = r, S = S.sibling;
    return r.subtreeFlags |= g, r.childLanes = d, o;
  }
  function $h(r, o, d) {
    var g = o.pendingProps;
    switch (Ud(o), o.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return fr(o), null;
      case 1:
        return tr(o.type) && Al(), fr(o), null;
      case 3:
        return g = o.stateNode, nn(), Sn(or), Sn(Hn), Ah(), g.pendingContext && (g.context = g.pendingContext, g.pendingContext = null), (r === null || r.child === null) && (Hd(o) ? o.flags |= 4 : r === null || r.memoizedState.isDehydrated && (o.flags & 256) === 0 || (o.flags |= 1024, Ei !== null && (Pc(Ei), Ei = null))), Uh(r, o), fr(o), null;
      case 5:
        Ri(o);
        var S = dt(Bs.current);
        if (d = o.type, r !== null && o.stateNode != null) Jg(r, o, d, g, S), r.ref !== o.ref && (o.flags |= 512, o.flags |= 2097152);else {
          if (!g) {
            if (o.stateNode === null) throw Error(i(166));
            return fr(o), null;
          }
          if (r = dt(_a.current), Hd(o)) {
            g = o.stateNode, d = o.type;
            var R = o.memoizedProps;
            switch (g[ma] = o, g[qu] = R, r = (o.mode & 1) !== 0, d) {
              case "dialog":
                mn("cancel", g), mn("close", g);
                break;
              case "iframe":
              case "object":
              case "embed":
                mn("load", g);
                break;
              case "video":
              case "audio":
                for (S = 0; S < Hu.length; S++) mn(Hu[S], g);
                break;
              case "source":
                mn("error", g);
                break;
              case "img":
              case "image":
              case "link":
                mn("error", g), mn("load", g);
                break;
              case "details":
                mn("toggle", g);
                break;
              case "input":
                Mt(g, R), mn("invalid", g);
                break;
              case "select":
                g._wrapperState = {
                  wasMultiple: !!R.multiple
                }, mn("invalid", g);
                break;
              case "textarea":
                hn(g, R), mn("invalid", g);
            }
            kt(d, R), S = null;
            for (var A in R) if (R.hasOwnProperty(A)) {
              var q = R[A];
              A === "children" ? typeof q == "string" ? g.textContent !== q && (R.suppressHydrationWarning !== !0 && Ad(g.textContent, q, r), S = ["children", q]) : typeof q == "number" && g.textContent !== "" + q && (R.suppressHydrationWarning !== !0 && Ad(g.textContent, q, r), S = ["children", "" + q]) : c.hasOwnProperty(A) && q != null && A === "onScroll" && mn("scroll", g);
            }
            switch (d) {
              case "input":
                Xe(g), gt(g, R, !0);
                break;
              case "textarea":
                Xe(g), Et(g);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof R.onClick == "function" && (g.onclick = zo);
            }
            g = S, o.updateQueue = g, g !== null && (o.flags |= 4);
          } else {
            A = S.nodeType === 9 ? S : S.ownerDocument, r === "http://www.w3.org/1999/xhtml" && (r = Vt(d)), r === "http://www.w3.org/1999/xhtml" ? d === "script" ? (r = A.createElement("div"), r.innerHTML = "<script><\/script>", r = r.removeChild(r.firstChild)) : typeof g.is == "string" ? r = A.createElement(d, {
              is: g.is
            }) : (r = A.createElement(d), d === "select" && (A = r, g.multiple ? A.multiple = !0 : g.size && (A.size = g.size))) : r = A.createElementNS(r, d), r[ma] = o, r[qu] = g, la(r, o, !1, !1), o.stateNode = r;
            e: {
              switch (A = Bt(d, g), d) {
                case "dialog":
                  mn("cancel", r), mn("close", r), S = g;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  mn("load", r), S = g;
                  break;
                case "video":
                case "audio":
                  for (S = 0; S < Hu.length; S++) mn(Hu[S], r);
                  S = g;
                  break;
                case "source":
                  mn("error", r), S = g;
                  break;
                case "img":
                case "image":
                case "link":
                  mn("error", r), mn("load", r), S = g;
                  break;
                case "details":
                  mn("toggle", r), S = g;
                  break;
                case "input":
                  Mt(r, g), S = Ae(r, g), mn("invalid", r);
                  break;
                case "option":
                  S = g;
                  break;
                case "select":
                  r._wrapperState = {
                    wasMultiple: !!g.multiple
                  }, S = H({}, g, {
                    value: void 0
                  }), mn("invalid", r);
                  break;
                case "textarea":
                  hn(r, g), S = Kt(r, g), mn("invalid", r);
                  break;
                default:
                  S = g;
              }
              kt(d, S), q = S;
              for (R in q) if (q.hasOwnProperty(R)) {
                var re = q[R];
                R === "style" ? je(r, re) : R === "dangerouslySetInnerHTML" ? (re = re ? re.__html : void 0, re != null && ot(r, re)) : R === "children" ? typeof re == "string" ? (d !== "textarea" || re !== "") && We(r, re) : typeof re == "number" && We(r, "" + re) : R !== "suppressContentEditableWarning" && R !== "suppressHydrationWarning" && R !== "autoFocus" && (c.hasOwnProperty(R) ? re != null && R === "onScroll" && mn("scroll", r) : re != null && F(r, R, re, A));
              }
              switch (d) {
                case "input":
                  Xe(r), gt(r, g, !1);
                  break;
                case "textarea":
                  Xe(r), Et(r);
                  break;
                case "option":
                  g.value != null && r.setAttribute("value", "" + ve(g.value));
                  break;
                case "select":
                  r.multiple = !!g.multiple, R = g.value, R != null ? Dt(r, !!g.multiple, R, !1) : g.defaultValue != null && Dt(r, !!g.multiple, g.defaultValue, !0);
                  break;
                default:
                  typeof S.onClick == "function" && (r.onclick = zo);
              }
              switch (d) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  g = !!g.autoFocus;
                  break e;
                case "img":
                  g = !0;
                  break e;
                default:
                  g = !1;
              }
            }
            g && (o.flags |= 4);
          }
          o.ref !== null && (o.flags |= 512, o.flags |= 2097152);
        }
        return fr(o), null;
      case 6:
        if (r && o.stateNode != null) Hh(r, o, r.memoizedProps, g);else {
          if (typeof g != "string" && o.stateNode === null) throw Error(i(166));
          if (d = dt(Bs.current), dt(_a.current), Hd(o)) {
            if (g = o.stateNode, d = o.memoizedProps, g[ma] = o, (R = g.nodeValue !== d) && (r = Xr, r !== null)) switch (r.tag) {
              case 3:
                Ad(g.nodeValue, d, (r.mode & 1) !== 0);
                break;
              case 5:
                r.memoizedProps.suppressHydrationWarning !== !0 && Ad(g.nodeValue, d, (r.mode & 1) !== 0);
            }
            R && (o.flags |= 4);
          } else g = (d.nodeType === 9 ? d : d.ownerDocument).createTextNode(g), g[ma] = o, o.stateNode = g;
        }
        return fr(o), null;
      case 13:
        if (Sn(Mn), g = o.memoizedState, r === null || r.memoizedState !== null && r.memoizedState.dehydrated !== null) {
          if (In && Kr !== null && (o.mode & 1) !== 0 && (o.flags & 128) === 0) Xu(), Wo(), o.flags |= 98560, R = !1;else if (R = Hd(o), g !== null && g.dehydrated !== null) {
            if (r === null) {
              if (!R) throw Error(i(318));
              if (R = o.memoizedState, R = R !== null ? R.dehydrated : null, !R) throw Error(i(317));
              R[ma] = o;
            } else Wo(), (o.flags & 128) === 0 && (o.memoizedState = null), o.flags |= 4;
            fr(o), R = !1;
          } else Ei !== null && (Pc(Ei), Ei = null), R = !0;
          if (!R) return o.flags & 65536 ? o : null;
        }
        return (o.flags & 128) !== 0 ? (o.lanes = d, o) : (g = g !== null, g !== (r !== null && r.memoizedState !== null) && g && (o.child.flags |= 8192, (o.mode & 1) !== 0 && (r === null || (Mn.current & 1) !== 0 ? Zn === 0 && (Zn = 3) : Kh())), o.updateQueue !== null && (o.flags |= 4), fr(o), null);
      case 4:
        return nn(), Uh(r, o), r === null && Il(o.stateNode.containerInfo), fr(o), null;
      case 10:
        return Ci(o.type._context), fr(o), null;
      case 17:
        return tr(o.type) && Al(), fr(o), null;
      case 19:
        if (Sn(Mn), R = o.memoizedState, R === null) return fr(o), null;
        if (g = (o.flags & 128) !== 0, A = R.rendering, A === null) {
          if (g) ul(R, !1);else {
            if (Zn !== 0 || r !== null && (r.flags & 128) !== 0) for (r = o.child; r !== null;) {
              if (A = Xd(r), A !== null) {
                for (o.flags |= 128, ul(R, !1), g = A.updateQueue, g !== null && (o.updateQueue = g, o.flags |= 4), o.subtreeFlags = 0, g = d, d = o.child; d !== null;) R = d, r = g, R.flags &= 14680066, A = R.alternate, A === null ? (R.childLanes = 0, R.lanes = r, R.child = null, R.subtreeFlags = 0, R.memoizedProps = null, R.memoizedState = null, R.updateQueue = null, R.dependencies = null, R.stateNode = null) : (R.childLanes = A.childLanes, R.lanes = A.lanes, R.child = A.child, R.subtreeFlags = 0, R.deletions = null, R.memoizedProps = A.memoizedProps, R.memoizedState = A.memoizedState, R.updateQueue = A.updateQueue, R.type = A.type, r = A.dependencies, R.dependencies = r === null ? null : {
                  lanes: r.lanes,
                  firstContext: r.firstContext
                }), d = d.sibling;
                return ft(Mn, Mn.current & 1 | 2), o.child;
              }
              r = r.sibling;
            }
            R.tail !== null && yn() > ao && (o.flags |= 128, g = !0, ul(R, !1), o.lanes = 4194304);
          }
        } else {
          if (!g) if (r = Xd(A), r !== null) {
            if (o.flags |= 128, g = !0, d = r.updateQueue, d !== null && (o.updateQueue = d, o.flags |= 4), ul(R, !0), R.tail === null && R.tailMode === "hidden" && !A.alternate && !In) return fr(o), null;
          } else 2 * yn() - R.renderingStartTime > ao && d !== 1073741824 && (o.flags |= 128, g = !0, ul(R, !1), o.lanes = 4194304);
          R.isBackwards ? (A.sibling = o.child, o.child = A) : (d = R.last, d !== null ? d.sibling = A : o.child = A, R.last = A);
        }
        return R.tail !== null ? (o = R.tail, R.rendering = o, R.tail = o.sibling, R.renderingStartTime = yn(), o.sibling = null, d = Mn.current, ft(Mn, g ? d & 1 | 2 : d & 1), o) : (fr(o), null);
      case 22:
      case 23:
        return gf(), g = o.memoizedState !== null, r !== null && r.memoizedState !== null !== g && (o.flags |= 8192), g && (o.mode & 1) !== 0 ? (ei & 1073741824) !== 0 && (fr(o), o.subtreeFlags & 6 && (o.flags |= 8192)) : fr(o), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(i(156, o.tag));
  }
  function Eb(r, o) {
    switch (Ud(o), o.tag) {
      case 1:
        return tr(o.type) && Al(), r = o.flags, r & 65536 ? (o.flags = r & -65537 | 128, o) : null;
      case 3:
        return nn(), Sn(or), Sn(Hn), Ah(), r = o.flags, (r & 65536) !== 0 && (r & 128) === 0 ? (o.flags = r & -65537 | 128, o) : null;
      case 5:
        return Ri(o), null;
      case 13:
        if (Sn(Mn), r = o.memoizedState, r !== null && r.dehydrated !== null) {
          if (o.alternate === null) throw Error(i(340));
          Wo();
        }
        return r = o.flags, r & 65536 ? (o.flags = r & -65537 | 128, o) : null;
      case 19:
        return Sn(Mn), null;
      case 4:
        return nn(), null;
      case 10:
        return Ci(o.type._context), null;
      case 22:
      case 23:
        return gf(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var pf = !1,
    xr = !1,
    ey = typeof WeakSet == "function" ? WeakSet : Set,
    tt = null;
  function cl(r, o) {
    var d = r.ref;
    if (d !== null) if (typeof d == "function") try {
      d(null);
    } catch (g) {
      $n(r, o, g);
    } else d.current = null;
  }
  function Wh(r, o, d) {
    try {
      d();
    } catch (g) {
      $n(r, o, g);
    }
  }
  var Jm = !1;
  function Cb(r, o) {
    if (Wu = Ds, r = Bu(), Td(r)) {
      if ("selectionStart" in r) var d = {
        start: r.selectionStart,
        end: r.selectionEnd
      };else e: {
        d = (d = r.ownerDocument) && d.defaultView || window;
        var g = d.getSelection && d.getSelection();
        if (g && g.rangeCount !== 0) {
          d = g.anchorNode;
          var S = g.anchorOffset,
            R = g.focusNode;
          g = g.focusOffset;
          try {
            d.nodeType, R.nodeType;
          } catch {
            d = null;
            break e;
          }
          var A = 0,
            q = -1,
            re = -1,
            be = 0,
            Le = 0,
            Ve = r,
            Oe = null;
          t: for (;;) {
            for (var et; Ve !== d || S !== 0 && Ve.nodeType !== 3 || (q = A + S), Ve !== R || g !== 0 && Ve.nodeType !== 3 || (re = A + g), Ve.nodeType === 3 && (A += Ve.nodeValue.length), (et = Ve.firstChild) !== null;) Oe = Ve, Ve = et;
            for (;;) {
              if (Ve === r) break t;
              if (Oe === d && ++be === S && (q = A), Oe === R && ++Le === g && (re = A), (et = Ve.nextSibling) !== null) break;
              Ve = Oe, Oe = Ve.parentNode;
            }
            Ve = et;
          }
          d = q === -1 || re === -1 ? null : {
            start: q,
            end: re
          };
        } else d = null;
      }
      d = d || {
        start: 0,
        end: 0
      };
    } else d = null;
    for (js = {
      focusedElem: r,
      selectionRange: d
    }, Ds = !1, tt = o; tt !== null;) if (o = tt, r = o.child, (o.subtreeFlags & 1028) !== 0 && r !== null) r.return = o, tt = r;else for (; tt !== null;) {
      o = tt;
      try {
        var it = o.alternate;
        if ((o.flags & 1024) !== 0) switch (o.tag) {
          case 0:
          case 11:
          case 15:
            break;
          case 1:
            if (it !== null) {
              var st = it.memoizedProps,
                Kn = it.memoizedState,
                pe = o.stateNode,
                ae = pe.getSnapshotBeforeUpdate(o.elementType === o.type ? st : li(o.type, st), Kn);
              pe.__reactInternalSnapshotBeforeUpdate = ae;
            }
            break;
          case 3:
            var he = o.stateNode.containerInfo;
            he.nodeType === 1 ? he.textContent = "" : he.nodeType === 9 && he.documentElement && he.removeChild(he.documentElement);
            break;
          case 5:
          case 6:
          case 4:
          case 17:
            break;
          default:
            throw Error(i(163));
        }
      } catch (He) {
        $n(o, o.return, He);
      }
      if (r = o.sibling, r !== null) {
        r.return = o.return, tt = r;
        break;
      }
      tt = o.return;
    }
    return it = Jm, Jm = !1, it;
  }
  function du(r, o, d) {
    var g = o.updateQueue;
    if (g = g !== null ? g.lastEffect : null, g !== null) {
      var S = g = g.next;
      do {
        if ((S.tag & r) === r) {
          var R = S.destroy;
          S.destroy = void 0, R !== void 0 && Wh(o, d, R);
        }
        S = S.next;
      } while (S !== g);
    }
  }
  function uc(r, o) {
    if (o = o.updateQueue, o = o !== null ? o.lastEffect : null, o !== null) {
      var d = o = o.next;
      do {
        if ((d.tag & r) === r) {
          var g = d.create;
          d.destroy = g();
        }
        d = d.next;
      } while (d !== o);
    }
  }
  function fu(r) {
    var o = r.ref;
    if (o !== null) {
      var d = r.stateNode;
      switch (r.tag) {
        case 5:
          r = d;
          break;
        default:
          r = d;
      }
      typeof o == "function" ? o(r) : o.current = r;
    }
  }
  function Ws(r) {
    var o = r.alternate;
    o !== null && (r.alternate = null, Ws(o)), r.child = null, r.deletions = null, r.sibling = null, r.tag === 5 && (o = r.stateNode, o !== null && (delete o[ma], delete o[qu], delete o[Yu], delete o[Pl], delete o[Iw])), r.stateNode = null, r.return = null, r.dependencies = null, r.memoizedProps = null, r.memoizedState = null, r.pendingProps = null, r.stateNode = null, r.updateQueue = null;
  }
  function ro(r) {
    return r.tag === 5 || r.tag === 3 || r.tag === 4;
  }
  function io(r) {
    e: for (;;) {
      for (; r.sibling === null;) {
        if (r.return === null || ro(r.return)) return null;
        r = r.return;
      }
      for (r.sibling.return = r.return, r = r.sibling; r.tag !== 5 && r.tag !== 6 && r.tag !== 18;) {
        if (r.flags & 2 || r.child === null || r.tag === 4) continue e;
        r.child.return = r, r = r.child;
      }
      if (!(r.flags & 2)) return r.stateNode;
    }
  }
  function wo(r, o, d) {
    var g = r.tag;
    if (g === 5 || g === 6) r = r.stateNode, o ? d.nodeType === 8 ? d.parentNode.insertBefore(r, o) : d.insertBefore(r, o) : (d.nodeType === 8 ? (o = d.parentNode, o.insertBefore(r, d)) : (o = d, o.appendChild(r)), d = d._reactRootContainer, d != null || o.onclick !== null || (o.onclick = zo));else if (g !== 4 && (r = r.child, r !== null)) for (wo(r, o, d), r = r.sibling; r !== null;) wo(r, o, d), r = r.sibling;
  }
  function qs(r, o, d) {
    var g = r.tag;
    if (g === 5 || g === 6) r = r.stateNode, o ? d.insertBefore(r, o) : d.appendChild(r);else if (g !== 4 && (r = r.child, r !== null)) for (qs(r, o, d), r = r.sibling; r !== null;) qs(r, o, d), r = r.sibling;
  }
  var Nn = null,
    Vr = !1;
  function Xo(r, o, d) {
    for (d = d.child; d !== null;) ty(r, o, d), d = d.sibling;
  }
  function ty(r, o, d) {
    if (qi && typeof qi.onCommitFiberUnmount == "function") try {
      qi.onCommitFiberUnmount(Iu, d);
    } catch {}
    switch (d.tag) {
      case 5:
        xr || cl(d, o);
      case 6:
        var g = Nn,
          S = Vr;
        Nn = null, Xo(r, o, d), Nn = g, Vr = S, Nn !== null && (Vr ? (r = Nn, d = d.stateNode, r.nodeType === 8 ? r.parentNode.removeChild(d) : r.removeChild(d)) : Nn.removeChild(d.stateNode));
        break;
      case 18:
        Nn !== null && (Vr ? (r = Nn, d = d.stateNode, r.nodeType === 8 ? Ll(r.parentNode, d) : r.nodeType === 1 && Ll(r, d), jo(r)) : Ll(Nn, d.stateNode));
        break;
      case 4:
        g = Nn, S = Vr, Nn = d.stateNode.containerInfo, Vr = !0, Xo(r, o, d), Nn = g, Vr = S;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!xr && (g = d.updateQueue, g !== null && (g = g.lastEffect, g !== null))) {
          S = g = g.next;
          do {
            var R = S,
              A = R.destroy;
            R = R.tag, A !== void 0 && ((R & 2) !== 0 || (R & 4) !== 0) && Wh(d, o, A), S = S.next;
          } while (S !== g);
        }
        Xo(r, o, d);
        break;
      case 1:
        if (!xr && (cl(d, o), g = d.stateNode, typeof g.componentWillUnmount == "function")) try {
          g.props = d.memoizedProps, g.state = d.memoizedState, g.componentWillUnmount();
        } catch (q) {
          $n(d, o, q);
        }
        Xo(r, o, d);
        break;
      case 21:
        Xo(r, o, d);
        break;
      case 22:
        d.mode & 1 ? (xr = (g = xr) || d.memoizedState !== null, Xo(r, o, d), xr = g) : Xo(r, o, d);
        break;
      default:
        Xo(r, o, d);
    }
  }
  function ev(r) {
    var o = r.updateQueue;
    if (o !== null) {
      r.updateQueue = null;
      var d = r.stateNode;
      d === null && (d = r.stateNode = new ey()), o.forEach(function (g) {
        var S = Nw.bind(null, r, g);
        d.has(g) || (d.add(g), g.then(S, S));
      });
    }
  }
  function ri(r, o) {
    var d = o.deletions;
    if (d !== null) for (var g = 0; g < d.length; g++) {
      var S = d[g];
      try {
        var R = r,
          A = o,
          q = A;
        e: for (; q !== null;) {
          switch (q.tag) {
            case 5:
              Nn = q.stateNode, Vr = !1;
              break e;
            case 3:
              Nn = q.stateNode.containerInfo, Vr = !0;
              break e;
            case 4:
              Nn = q.stateNode.containerInfo, Vr = !0;
              break e;
          }
          q = q.return;
        }
        if (Nn === null) throw Error(i(160));
        ty(R, A, S), Nn = null, Vr = !1;
        var re = S.alternate;
        re !== null && (re.return = null), S.return = null;
      } catch (be) {
        $n(S, o, be);
      }
    }
    if (o.subtreeFlags & 12854) for (o = o.child; o !== null;) hf(o, r), o = o.sibling;
  }
  function hf(r, o) {
    var d = r.alternate,
      g = r.flags;
    switch (r.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (ri(o, r), ua(r), g & 4) {
          try {
            du(3, r, r.return), uc(3, r);
          } catch (st) {
            $n(r, r.return, st);
          }
          try {
            du(5, r, r.return);
          } catch (st) {
            $n(r, r.return, st);
          }
        }
        break;
      case 1:
        ri(o, r), ua(r), g & 512 && d !== null && cl(d, d.return);
        break;
      case 5:
        if (ri(o, r), ua(r), g & 512 && d !== null && cl(d, d.return), r.flags & 32) {
          var S = r.stateNode;
          try {
            We(S, "");
          } catch (st) {
            $n(r, r.return, st);
          }
        }
        if (g & 4 && (S = r.stateNode, S != null)) {
          var R = r.memoizedProps,
            A = d !== null ? d.memoizedProps : R,
            q = r.type,
            re = r.updateQueue;
          if (r.updateQueue = null, re !== null) try {
            q === "input" && R.type === "radio" && R.name != null && Ft(S, R), Bt(q, A);
            var be = Bt(q, R);
            for (A = 0; A < re.length; A += 2) {
              var Le = re[A],
                Ve = re[A + 1];
              Le === "style" ? je(S, Ve) : Le === "dangerouslySetInnerHTML" ? ot(S, Ve) : Le === "children" ? We(S, Ve) : F(S, Le, Ve, be);
            }
            switch (q) {
              case "input":
                un(S, R);
                break;
              case "textarea":
                Ot(S, R);
                break;
              case "select":
                var Oe = S._wrapperState.wasMultiple;
                S._wrapperState.wasMultiple = !!R.multiple;
                var et = R.value;
                et != null ? Dt(S, !!R.multiple, et, !1) : Oe !== !!R.multiple && (R.defaultValue != null ? Dt(S, !!R.multiple, R.defaultValue, !0) : Dt(S, !!R.multiple, R.multiple ? [] : "", !1));
            }
            S[qu] = R;
          } catch (st) {
            $n(r, r.return, st);
          }
        }
        break;
      case 6:
        if (ri(o, r), ua(r), g & 4) {
          if (r.stateNode === null) throw Error(i(162));
          S = r.stateNode, R = r.memoizedProps;
          try {
            S.nodeValue = R;
          } catch (st) {
            $n(r, r.return, st);
          }
        }
        break;
      case 3:
        if (ri(o, r), ua(r), g & 4 && d !== null && d.memoizedState.isDehydrated) try {
          jo(o.containerInfo);
        } catch (st) {
          $n(r, r.return, st);
        }
        break;
      case 4:
        ri(o, r), ua(r);
        break;
      case 13:
        ri(o, r), ua(r), S = r.child, S.flags & 8192 && (R = S.memoizedState !== null, S.stateNode.isHidden = R, !R || S.alternate !== null && S.alternate.memoizedState !== null || (fc = yn())), g & 4 && ev(r);
        break;
      case 22:
        if (Le = d !== null && d.memoizedState !== null, r.mode & 1 ? (xr = (be = xr) || Le, ri(o, r), xr = be) : ri(o, r), ua(r), g & 8192) {
          if (be = r.memoizedState !== null, (r.stateNode.isHidden = be) && !Le && (r.mode & 1) !== 0) for (tt = r, Le = r.child; Le !== null;) {
            for (Ve = tt = Le; tt !== null;) {
              switch (Oe = tt, et = Oe.child, Oe.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  du(4, Oe, Oe.return);
                  break;
                case 1:
                  cl(Oe, Oe.return);
                  var it = Oe.stateNode;
                  if (typeof it.componentWillUnmount == "function") {
                    g = Oe, d = Oe.return;
                    try {
                      o = g, it.props = o.memoizedProps, it.state = o.memoizedState, it.componentWillUnmount();
                    } catch (st) {
                      $n(g, d, st);
                    }
                  }
                  break;
                case 5:
                  cl(Oe, Oe.return);
                  break;
                case 22:
                  if (Oe.memoizedState !== null) {
                    tv(Ve);
                    continue;
                  }
              }
              et !== null ? (et.return = Oe, tt = et) : tv(Ve);
            }
            Le = Le.sibling;
          }
          e: for (Le = null, Ve = r;;) {
            if (Ve.tag === 5) {
              if (Le === null) {
                Le = Ve;
                try {
                  S = Ve.stateNode, be ? (R = S.style, typeof R.setProperty == "function" ? R.setProperty("display", "none", "important") : R.display = "none") : (q = Ve.stateNode, re = Ve.memoizedProps.style, A = re != null && re.hasOwnProperty("display") ? re.display : null, q.style.display = yt("display", A));
                } catch (st) {
                  $n(r, r.return, st);
                }
              }
            } else if (Ve.tag === 6) {
              if (Le === null) try {
                Ve.stateNode.nodeValue = be ? "" : Ve.memoizedProps;
              } catch (st) {
                $n(r, r.return, st);
              }
            } else if ((Ve.tag !== 22 && Ve.tag !== 23 || Ve.memoizedState === null || Ve === r) && Ve.child !== null) {
              Ve.child.return = Ve, Ve = Ve.child;
              continue;
            }
            if (Ve === r) break e;
            for (; Ve.sibling === null;) {
              if (Ve.return === null || Ve.return === r) break e;
              Le === Ve && (Le = null), Ve = Ve.return;
            }
            Le === Ve && (Le = null), Ve.sibling.return = Ve.return, Ve = Ve.sibling;
          }
        }
        break;
      case 19:
        ri(o, r), ua(r), g & 4 && ev(r);
        break;
      case 21:
        break;
      default:
        ri(o, r), ua(r);
    }
  }
  function ua(r) {
    var o = r.flags;
    if (o & 2) {
      try {
        e: {
          for (var d = r.return; d !== null;) {
            if (ro(d)) {
              var g = d;
              break e;
            }
            d = d.return;
          }
          throw Error(i(160));
        }
        switch (g.tag) {
          case 5:
            var S = g.stateNode;
            g.flags & 32 && (We(S, ""), g.flags &= -33);
            var R = io(r);
            qs(r, R, S);
            break;
          case 3:
          case 4:
            var A = g.stateNode.containerInfo,
              q = io(r);
            wo(r, q, A);
            break;
          default:
            throw Error(i(161));
        }
      } catch (re) {
        $n(r, r.return, re);
      }
      r.flags &= -3;
    }
    o & 4096 && (r.flags &= -4097);
  }
  function kb(r, o, d) {
    tt = r, cp(r);
  }
  function cp(r, o, d) {
    for (var g = (r.mode & 1) !== 0; tt !== null;) {
      var S = tt,
        R = S.child;
      if (S.tag === 22 && g) {
        var A = S.memoizedState !== null || pf;
        if (!A) {
          var q = S.alternate,
            re = q !== null && q.memoizedState !== null || xr;
          q = pf;
          var be = xr;
          if (pf = A, (xr = re) && !be) for (tt = S; tt !== null;) A = tt, re = A.child, A.tag === 22 && A.memoizedState !== null ? vf(S) : re !== null ? (re.return = A, tt = re) : vf(S);
          for (; R !== null;) tt = R, cp(R), R = R.sibling;
          tt = S, pf = q, xr = be;
        }
        mf(r);
      } else (S.subtreeFlags & 8772) !== 0 && R !== null ? (R.return = S, tt = R) : mf(r);
    }
  }
  function mf(r) {
    for (; tt !== null;) {
      var o = tt;
      if ((o.flags & 8772) !== 0) {
        var d = o.alternate;
        try {
          if ((o.flags & 8772) !== 0) switch (o.tag) {
            case 0:
            case 11:
            case 15:
              xr || uc(5, o);
              break;
            case 1:
              var g = o.stateNode;
              if (o.flags & 4 && !xr) if (d === null) g.componentDidMount();else {
                var S = o.elementType === o.type ? d.memoizedProps : li(o.type, d.memoizedProps);
                g.componentDidUpdate(S, d.memoizedState, g.__reactInternalSnapshotBeforeUpdate);
              }
              var R = o.updateQueue;
              R !== null && Bg(o, R, g);
              break;
            case 3:
              var A = o.updateQueue;
              if (A !== null) {
                if (d = null, o.child !== null) switch (o.child.tag) {
                  case 5:
                    d = o.child.stateNode;
                    break;
                  case 1:
                    d = o.child.stateNode;
                }
                Bg(o, A, d);
              }
              break;
            case 5:
              var q = o.stateNode;
              if (d === null && o.flags & 4) {
                d = q;
                var re = o.memoizedProps;
                switch (o.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    re.autoFocus && d.focus();
                    break;
                  case "img":
                    re.src && (d.src = re.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (o.memoizedState === null) {
                var be = o.alternate;
                if (be !== null) {
                  var Le = be.memoizedState;
                  if (Le !== null) {
                    var Ve = Le.dehydrated;
                    Ve !== null && jo(Ve);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(i(163));
          }
          xr || o.flags & 512 && fu(o);
        } catch (Oe) {
          $n(o, o.return, Oe);
        }
      }
      if (o === r) {
        tt = null;
        break;
      }
      if (d = o.sibling, d !== null) {
        d.return = o.return, tt = d;
        break;
      }
      tt = o.return;
    }
  }
  function tv(r) {
    for (; tt !== null;) {
      var o = tt;
      if (o === r) {
        tt = null;
        break;
      }
      var d = o.sibling;
      if (d !== null) {
        d.return = o.return, tt = d;
        break;
      }
      tt = o.return;
    }
  }
  function vf(r) {
    for (; tt !== null;) {
      var o = tt;
      try {
        switch (o.tag) {
          case 0:
          case 11:
          case 15:
            var d = o.return;
            try {
              uc(4, o);
            } catch (re) {
              $n(o, d, re);
            }
            break;
          case 1:
            var g = o.stateNode;
            if (typeof g.componentDidMount == "function") {
              var S = o.return;
              try {
                g.componentDidMount();
              } catch (re) {
                $n(o, S, re);
              }
            }
            var R = o.return;
            try {
              fu(o);
            } catch (re) {
              $n(o, R, re);
            }
            break;
          case 5:
            var A = o.return;
            try {
              fu(o);
            } catch (re) {
              $n(o, A, re);
            }
        }
      } catch (re) {
        $n(o, o.return, re);
      }
      if (o === r) {
        tt = null;
        break;
      }
      var q = o.sibling;
      if (q !== null) {
        q.return = o.return, tt = q;
        break;
      }
      tt = o.return;
    }
  }
  var cc = Math.ceil,
    _o = j.ReactCurrentDispatcher,
    dl = j.ReactCurrentOwner,
    ii = j.ReactCurrentBatchConfig,
    on = 0,
    pr = null,
    ir = null,
    Sr = 0,
    ei = 0,
    Ys = Ki(0),
    Zn = 0,
    ls = null,
    xo = 0,
    Lc = 0,
    qh = 0,
    dc = null,
    ti = null,
    fc = 0,
    ao = 1 / 0,
    Mi = null,
    Kl = !1,
    Yh = null,
    So = null,
    pc = !1,
    Ea = null,
    Gs = 0,
    Xs = 0,
    Ma = null,
    di = -1,
    us = 0;
  function hr() {
    return (on & 6) !== 0 ? yn() : di !== -1 ? di : di = yn();
  }
  function Ca(r) {
    return (r.mode & 1) === 0 ? 1 : (on & 2) !== 0 && Sr !== 0 ? Sr & -Sr : Mw.transition !== null ? (us === 0 && (us = pd()), us) : (r = gn, r !== 0 || (r = window.event, r = r === void 0 ? 16 : gd(r.type)), r);
  }
  function Oi(r, o, d, g) {
    if (50 < Xs) throw Xs = 0, Ma = null, Error(i(185));
    Ts(r, d, g), ((on & 2) === 0 || r !== pr) && (r === pr && ((on & 2) === 0 && (Lc |= d), Zn === 4 && Eo(r, Sr)), Mr(r, g), d === 1 && on === 0 && (o.mode & 1) === 0 && (ao = yn() + 500, jl && ga()));
  }
  function Mr(r, o) {
    var d = r.callbackNode;
    Gp(r, o);
    var g = ks(r, r === pr ? Sr : 0);
    if (g === 0) d !== null && Wa(d), r.callbackNode = null, r.callbackPriority = 0;else if (o = g & -g, r.callbackPriority !== o) {
      if (d != null && Wa(d), o === 1) r.tag === 0 ? Bo(ny.bind(null, r)) : Vd(ny.bind(null, r)), Ol(function () {
        (on & 6) === 0 && ga();
      }), d = null;else {
        switch (Qp(g)) {
          case 1:
            d = Es;
            break;
          case 4:
            d = Wp;
            break;
          case 16:
            d = Du;
            break;
          case 536870912:
            d = qp;
            break;
          default:
            d = Du;
        }
        d = ly(d, hc.bind(null, r));
      }
      r.callbackPriority = o, r.callbackNode = d;
    }
  }
  function hc(r, o) {
    if (di = -1, us = 0, (on & 6) !== 0) throw Error(i(327));
    var d = r.callbackNode;
    if (Zs() && r.callbackNode !== d) return null;
    var g = ks(r, r === pr ? Sr : 0);
    if (g === 0) return null;
    if ((g & 30) !== 0 || (g & r.expiredLanes) !== 0 || o) o = Ac(r, g);else {
      o = g;
      var S = on;
      on |= 2;
      var R = iy();
      (pr !== r || Sr !== o) && (Mi = null, ao = yn() + 500, Ks(r, o));
      do try {
        Aw();
        break;
      } catch (q) {
        ry(r, q);
      } while (!0);
      Ge(), _o.current = R, on = S, ir !== null ? o = 0 : (pr = null, Sr = 0, o = Zn);
    }
    if (o !== 0) {
      if (o === 2 && (S = Xp(r), S !== 0 && (g = S, o = mc(r, S))), o === 1) throw d = ls, Ks(r, 0), Eo(r, g), Mr(r, yn()), d;
      if (o === 6) Eo(r, g);else {
        if (S = r.current.alternate, (g & 30) === 0 && !Gh(S) && (o = Ac(r, g), o === 2 && (R = Xp(r), R !== 0 && (g = R, o = mc(r, R))), o === 1)) throw d = ls, Ks(r, 0), Eo(r, g), Mr(r, yn()), d;
        switch (r.finishedWork = S, r.finishedLanes = g, o) {
          case 0:
          case 1:
            throw Error(i(345));
          case 2:
            Qs(r, ti, Mi);
            break;
          case 3:
            if (Eo(r, g), (g & 130023424) === g && (o = fc + 500 - yn(), 10 < o)) {
              if (ks(r, 0) !== 0) break;
              if (S = r.suspendedLanes, (S & g) !== g) {
                hr(), r.pingedLanes |= r.suspendedLanes & S;
                break;
              }
              r.timeoutHandle = Fd(Qs.bind(null, r, ti, Mi), o);
              break;
            }
            Qs(r, ti, Mi);
            break;
          case 4:
            if (Eo(r, g), (g & 4194240) === g) break;
            for (o = r.eventTimes, S = -1; 0 < g;) {
              var A = 31 - gi(g);
              R = 1 << A, A = o[A], A > S && (S = A), g &= ~R;
            }
            if (g = S, g = yn() - g, g = (120 > g ? 120 : 480 > g ? 480 : 1080 > g ? 1080 : 1920 > g ? 1920 : 3e3 > g ? 3e3 : 4320 > g ? 4320 : 1960 * cc(g / 1960)) - g, 10 < g) {
              r.timeoutHandle = Fd(Qs.bind(null, r, ti, Mi), g);
              break;
            }
            Qs(r, ti, Mi);
            break;
          case 5:
            Qs(r, ti, Mi);
            break;
          default:
            throw Error(i(329));
        }
      }
    }
    return Mr(r, yn()), r.callbackNode === d ? hc.bind(null, r) : null;
  }
  function mc(r, o) {
    var d = dc;
    return r.current.memoizedState.isDehydrated && (Ks(r, o).flags |= 256), r = Ac(r, o), r !== 2 && (o = ti, ti = d, o !== null && Pc(o)), r;
  }
  function Pc(r) {
    ti === null ? ti = r : ti.push.apply(ti, r);
  }
  function Gh(r) {
    for (var o = r;;) {
      if (o.flags & 16384) {
        var d = o.updateQueue;
        if (d !== null && (d = d.stores, d !== null)) for (var g = 0; g < d.length; g++) {
          var S = d[g],
            R = S.getSnapshot;
          S = S.value;
          try {
            if (!Gi(R(), S)) return !1;
          } catch {
            return !1;
          }
        }
      }
      if (d = o.child, o.subtreeFlags & 16384 && d !== null) d.return = o, o = d;else {
        if (o === r) break;
        for (; o.sibling === null;) {
          if (o.return === null || o.return === r) return !0;
          o = o.return;
        }
        o.sibling.return = o.return, o = o.sibling;
      }
    }
    return !0;
  }
  function Eo(r, o) {
    for (o &= ~qh, o &= ~Lc, r.suspendedLanes |= o, r.pingedLanes &= ~o, r = r.expirationTimes; 0 < o;) {
      var d = 31 - gi(o),
        g = 1 << d;
      r[d] = -1, o &= ~g;
    }
  }
  function ny(r) {
    if ((on & 6) !== 0) throw Error(i(327));
    Zs();
    var o = ks(r, 0);
    if ((o & 1) === 0) return Mr(r, yn()), null;
    var d = Ac(r, o);
    if (r.tag !== 0 && d === 2) {
      var g = Xp(r);
      g !== 0 && (o = g, d = mc(r, g));
    }
    if (d === 1) throw d = ls, Ks(r, 0), Eo(r, o), Mr(r, yn()), d;
    if (d === 6) throw Error(i(345));
    return r.finishedWork = r.current.alternate, r.finishedLanes = o, Qs(r, ti, Mi), Mr(r, yn()), null;
  }
  function Xh(r, o) {
    var d = on;
    on |= 1;
    try {
      return r(o);
    } finally {
      on = d, on === 0 && (ao = yn() + 500, jl && ga());
    }
  }
  function Ko(r) {
    Ea !== null && Ea.tag === 0 && (on & 6) === 0 && Zs();
    var o = on;
    on |= 1;
    var d = ii.transition,
      g = gn;
    try {
      if (ii.transition = null, gn = 1, r) return r();
    } finally {
      gn = g, ii.transition = d, on = o, (on & 6) === 0 && ga();
    }
  }
  function gf() {
    ei = Ys.current, Sn(Ys);
  }
  function Ks(r, o) {
    r.finishedWork = null, r.finishedLanes = 0;
    var d = r.timeoutHandle;
    if (d !== -1 && (r.timeoutHandle = -1, Eh(d)), ir !== null) for (d = ir.return; d !== null;) {
      var g = d;
      switch (Ud(g), g.tag) {
        case 1:
          g = g.type.childContextTypes, g != null && Al();
          break;
        case 3:
          nn(), Sn(or), Sn(Hn), Ah();
          break;
        case 5:
          Ri(g);
          break;
        case 4:
          nn();
          break;
        case 13:
          Sn(Mn);
          break;
        case 19:
          Sn(Mn);
          break;
        case 10:
          Ci(g.type._context);
          break;
        case 22:
        case 23:
          gf();
      }
      d = d.return;
    }
    if (pr = r, ir = r = Oa(r.current, null), Sr = ei = o, Zn = 0, ls = null, qh = Lc = xo = 0, ti = dc = null, zs !== null) {
      for (o = 0; o < zs.length; o++) if (d = zs[o], g = d.interleaved, g !== null) {
        d.interleaved = null;
        var S = g.next,
          R = d.pending;
        if (R !== null) {
          var A = R.next;
          R.next = S, g.next = A;
        }
        d.pending = g;
      }
      zs = null;
    }
    return r;
  }
  function ry(r, o) {
    do {
      var d = ir;
      try {
        if (Ge(), zl.current = ql, xa) {
          for (var g = Je.memoizedState; g !== null;) {
            var S = g.queue;
            S !== null && (S.pending = null), g = g.next;
          }
          xa = !1;
        }
        if (On = 0, Cn = Ln = Je = null, Qr = !1, no = 0, dl.current = null, d === null || d.return === null) {
          Zn = 1, ls = o, ir = null;
          break;
        }
        e: {
          var R = r,
            A = d.return,
            q = d,
            re = o;
          if (o = Sr, q.flags |= 32768, re !== null && typeof re == "object" && typeof re.then == "function") {
            var be = re,
              Le = q,
              Ve = Le.tag;
            if ((Le.mode & 1) === 0 && (Ve === 0 || Ve === 11 || Ve === 15)) {
              var Oe = Le.alternate;
              Oe ? (Le.updateQueue = Oe.updateQueue, Le.memoizedState = Oe.memoizedState, Le.lanes = Oe.lanes) : (Le.updateQueue = null, Le.memoizedState = null);
            }
            var et = Go(A);
            if (et !== null) {
              et.flags &= -257, Xl(et, A, q, R, o), et.mode & 1 && Zg(R, be, o), o = et, re = be;
              var it = o.updateQueue;
              if (it === null) {
                var st = /* @__PURE__ */new Set();
                st.add(re), o.updateQueue = st;
              } else it.add(re);
              break e;
            } else {
              if ((o & 1) === 0) {
                Zg(R, be, o), Kh();
                break e;
              }
              re = Error(i(426));
            }
          } else if (In && q.mode & 1) {
            var Kn = Go(A);
            if (Kn !== null) {
              (Kn.flags & 65536) === 0 && (Kn.flags |= 256), Xl(Kn, A, q, R, o), eo(Yl(re, q));
              break e;
            }
          }
          R = re = Yl(re, q), Zn !== 4 && (Zn = 2), dc === null ? dc = [R] : dc.push(R), R = A;
          do {
            switch (R.tag) {
              case 3:
                R.flags |= 65536, o &= -o, R.lanes |= o;
                var pe = zh(R, re, o);
                Vg(R, pe);
                break e;
              case 1:
                q = re;
                var ae = R.type,
                  he = R.stateNode;
                if ((R.flags & 128) === 0 && (typeof ae.getDerivedStateFromError == "function" || he !== null && typeof he.componentDidCatch == "function" && (So === null || !So.has(he)))) {
                  R.flags |= 65536, o &= -o, R.lanes |= o;
                  var He = Vh(R, q, o);
                  Vg(R, He);
                  break e;
                }
            }
            R = R.return;
          } while (R !== null);
        }
        oy(d);
      } catch (ut) {
        o = ut, ir === d && d !== null && (ir = d = d.return);
        continue;
      }
      break;
    } while (!0);
  }
  function iy() {
    var r = _o.current;
    return _o.current = ql, r === null ? ql : r;
  }
  function Kh() {
    (Zn === 0 || Zn === 3 || Zn === 2) && (Zn = 4), pr === null || (xo & 268435455) === 0 && (Lc & 268435455) === 0 || Eo(pr, Sr);
  }
  function Ac(r, o) {
    var d = on;
    on |= 2;
    var g = iy();
    (pr !== r || Sr !== o) && (Mi = null, Ks(r, o));
    do try {
      Tb();
      break;
    } catch (S) {
      ry(r, S);
    } while (!0);
    if (Ge(), on = d, _o.current = g, ir !== null) throw Error(i(261));
    return pr = null, Sr = 0, Zn;
  }
  function Tb() {
    for (; ir !== null;) ay(ir);
  }
  function Aw() {
    for (; ir !== null && !Ru();) ay(ir);
  }
  function ay(r) {
    var o = sy(r.alternate, r, ei);
    r.memoizedProps = r.pendingProps, o === null ? oy(r) : ir = o, dl.current = null;
  }
  function oy(r) {
    var o = r;
    do {
      var d = o.alternate;
      if (r = o.return, (o.flags & 32768) === 0) {
        if (d = $h(d, o, ei), d !== null) {
          ir = d;
          return;
        }
      } else {
        if (d = Eb(d, o), d !== null) {
          d.flags &= 32767, ir = d;
          return;
        }
        if (r !== null) r.flags |= 32768, r.subtreeFlags = 0, r.deletions = null;else {
          Zn = 6, ir = null;
          return;
        }
      }
      if (o = o.sibling, o !== null) {
        ir = o;
        return;
      }
      ir = o = r;
    } while (o !== null);
    Zn === 0 && (Zn = 5);
  }
  function Qs(r, o, d) {
    var g = gn,
      S = ii.transition;
    try {
      ii.transition = null, gn = 1, jw(r, o, d, g);
    } finally {
      ii.transition = S, gn = g;
    }
    return null;
  }
  function jw(r, o, d, g) {
    do Zs(); while (Ea !== null);
    if ((on & 6) !== 0) throw Error(i(327));
    d = r.finishedWork;
    var S = r.finishedLanes;
    if (d === null) return null;
    if (r.finishedWork = null, r.finishedLanes = 0, d === r.current) throw Error(i(177));
    r.callbackNode = null, r.callbackPriority = 0;
    var R = d.lanes | d.childLanes;
    if (fw(r, R), r === pr && (ir = pr = null, Sr = 0), (d.subtreeFlags & 2064) === 0 && (d.flags & 2064) === 0 || pc || (pc = !0, ly(Du, function () {
      return Zs(), null;
    })), R = (d.flags & 15990) !== 0, (d.subtreeFlags & 15990) !== 0 || R) {
      R = ii.transition, ii.transition = null;
      var A = gn;
      gn = 1;
      var q = on;
      on |= 4, dl.current = null, Cb(r, d), hf(d, r), Rl(js), Ds = !!Wu, js = Wu = null, r.current = d, kb(d), Wi(), on = q, gn = A, ii.transition = R;
    } else r.current = d;
    if (pc && (pc = !1, Ea = r, Gs = S), R = r.pendingLanes, R === 0 && (So = null), ng(d.stateNode), Mr(r, yn()), o !== null) for (g = r.onRecoverableError, d = 0; d < o.length; d++) S = o[d], g(S.value, {
      componentStack: S.stack,
      digest: S.digest
    });
    if (Kl) throw Kl = !1, r = Yh, Yh = null, r;
    return (Gs & 1) !== 0 && r.tag !== 0 && Zs(), R = r.pendingLanes, (R & 1) !== 0 ? r === Ma ? Xs++ : (Xs = 0, Ma = r) : Xs = 0, ga(), null;
  }
  function Zs() {
    if (Ea !== null) {
      var r = Qp(Gs),
        o = ii.transition,
        d = gn;
      try {
        if (ii.transition = null, gn = 16 > r ? 16 : r, Ea === null) var g = !1;else {
          if (r = Ea, Ea = null, Gs = 0, (on & 6) !== 0) throw Error(i(331));
          var S = on;
          for (on |= 4, tt = r.current; tt !== null;) {
            var R = tt,
              A = R.child;
            if ((tt.flags & 16) !== 0) {
              var q = R.deletions;
              if (q !== null) {
                for (var re = 0; re < q.length; re++) {
                  var be = q[re];
                  for (tt = be; tt !== null;) {
                    var Le = tt;
                    switch (Le.tag) {
                      case 0:
                      case 11:
                      case 15:
                        du(8, Le, R);
                    }
                    var Ve = Le.child;
                    if (Ve !== null) Ve.return = Le, tt = Ve;else for (; tt !== null;) {
                      Le = tt;
                      var Oe = Le.sibling,
                        et = Le.return;
                      if (Ws(Le), Le === be) {
                        tt = null;
                        break;
                      }
                      if (Oe !== null) {
                        Oe.return = et, tt = Oe;
                        break;
                      }
                      tt = et;
                    }
                  }
                }
                var it = R.alternate;
                if (it !== null) {
                  var st = it.child;
                  if (st !== null) {
                    it.child = null;
                    do {
                      var Kn = st.sibling;
                      st.sibling = null, st = Kn;
                    } while (st !== null);
                  }
                }
                tt = R;
              }
            }
            if ((R.subtreeFlags & 2064) !== 0 && A !== null) A.return = R, tt = A;else e: for (; tt !== null;) {
              if (R = tt, (R.flags & 2048) !== 0) switch (R.tag) {
                case 0:
                case 11:
                case 15:
                  du(9, R, R.return);
              }
              var pe = R.sibling;
              if (pe !== null) {
                pe.return = R.return, tt = pe;
                break e;
              }
              tt = R.return;
            }
          }
          var ae = r.current;
          for (tt = ae; tt !== null;) {
            A = tt;
            var he = A.child;
            if ((A.subtreeFlags & 2064) !== 0 && he !== null) he.return = A, tt = he;else e: for (A = ae; tt !== null;) {
              if (q = tt, (q.flags & 2048) !== 0) try {
                switch (q.tag) {
                  case 0:
                  case 11:
                  case 15:
                    uc(9, q);
                }
              } catch (ut) {
                $n(q, q.return, ut);
              }
              if (q === A) {
                tt = null;
                break e;
              }
              var He = q.sibling;
              if (He !== null) {
                He.return = q.return, tt = He;
                break e;
              }
              tt = q.return;
            }
          }
          if (on = S, ga(), qi && typeof qi.onPostCommitFiberRoot == "function") try {
            qi.onPostCommitFiberRoot(Iu, r);
          } catch {}
          g = !0;
        }
        return g;
      } finally {
        gn = d, ii.transition = o;
      }
    }
    return !1;
  }
  function Qh(r, o, d) {
    o = Yl(d, o), o = zh(r, o, 1), r = Ti(r, o, 1), o = hr(), r !== null && (Ts(r, 1, o), Mr(r, o));
  }
  function $n(r, o, d) {
    if (r.tag === 3) Qh(r, r, d);else for (; o !== null;) {
      if (o.tag === 3) {
        Qh(o, r, d);
        break;
      } else if (o.tag === 1) {
        var g = o.stateNode;
        if (typeof o.type.getDerivedStateFromError == "function" || typeof g.componentDidCatch == "function" && (So === null || !So.has(g))) {
          r = Yl(d, r), r = Vh(o, r, 1), o = Ti(o, r, 1), r = hr(), o !== null && (Ts(o, 1, r), Mr(o, r));
          break;
        }
      }
      o = o.return;
    }
  }
  function Fw(r, o, d) {
    var g = r.pingCache;
    g !== null && g.delete(o), o = hr(), r.pingedLanes |= r.suspendedLanes & d, pr === r && (Sr & d) === d && (Zn === 4 || Zn === 3 && (Sr & 130023424) === Sr && 500 > yn() - fc ? Ks(r, 0) : qh |= d), Mr(r, o);
  }
  function nv(r, o) {
    o === 0 && ((r.mode & 1) === 0 ? o = 1 : (o = Yi, Yi <<= 1, (Yi & 130023424) === 0 && (Yi = 4194304)));
    var d = hr();
    r = En(r, o), r !== null && (Ts(r, o, d), Mr(r, d));
  }
  function Rb(r) {
    var o = r.memoizedState,
      d = 0;
    o !== null && (d = o.retryLane), nv(r, d);
  }
  function Nw(r, o) {
    var d = 0;
    switch (r.tag) {
      case 13:
        var g = r.stateNode,
          S = r.memoizedState;
        S !== null && (d = S.retryLane);
        break;
      case 19:
        g = r.stateNode;
        break;
      default:
        throw Error(i(314));
    }
    g !== null && g.delete(o), nv(r, d);
  }
  var sy;
  sy = function (r, o, d) {
    if (r !== null) {
      if (r.memoizedProps !== o.pendingProps || or.current) Dr = !0;else {
        if ((r.lanes & d) === 0 && (o.flags & 128) === 0) return Dr = !1, zr(r, o, d);
        Dr = (r.flags & 131072) !== 0;
      }
    } else Dr = !1, In && (o.flags & 1048576) !== 0 && jg(o, Ja, o.index);
    switch (o.lanes = 0, o.tag) {
      case 2:
        var g = o.type;
        ss(r, o), r = o.pendingProps;
        var S = xi(o, Hn.current);
        Fl(o, d), S = Ju(null, o, g, r, S, d);
        var R = ec();
        return o.flags |= 1, typeof S == "object" && S !== null && typeof S.render == "function" && S.$$typeof === void 0 ? (o.tag = 1, o.memoizedState = null, o.updateQueue = null, tr(g) ? (R = !0, Gr(o)) : R = !1, o.memoizedState = S.state !== null && S.state !== void 0 ? S.state : null, Dh(o), S.updater = Yd, o.stateNode = S, S._reactInternals = o, Lh(o, g, r, d), o = sc(null, o, g, !0, R, d)) : (o.tag = 0, In && R && Bd(o), _n(null, o, S, d), o = o.child), o;
      case 16:
        g = o.elementType;
        e: {
          switch (ss(r, o), r = o.pendingProps, S = g._init, g = S(g._payload), o.type = g, S = o.tag = Db(g), r = li(g, r), S) {
            case 0:
              o = uf(null, o, g, r, d);
              break e;
            case 1:
              o = oc(null, o, g, r, d);
              break e;
            case 11:
              o = $s(null, o, g, r, d);
              break e;
            case 14:
              o = jt(null, o, g, li(g.type, r), d);
              break e;
          }
          throw Error(i(306, g, ""));
        }
        return o;
      case 0:
        return g = o.type, S = o.pendingProps, S = o.elementType === g ? S : li(g, S), uf(r, o, g, S, d);
      case 1:
        return g = o.type, S = o.pendingProps, S = o.elementType === g ? S : li(g, S), oc(r, o, g, S, d);
      case 3:
        e: {
          if (Km(o), r === null) throw Error(i(387));
          g = o.pendingProps, R = o.memoizedState, S = R.element, zg(r, o), qd(o, g, null, d);
          var A = o.memoizedState;
          if (g = A.element, R.isDehydrated) {
            if (R = {
              element: g,
              isDehydrated: !1,
              cache: A.cache,
              pendingSuspenseBoundaries: A.pendingSuspenseBoundaries,
              transitions: A.transitions
            }, o.updateQueue.baseState = R, o.memoizedState = R, o.flags & 256) {
              S = Yl(Error(i(423)), o), o = Qm(r, o, g, d, S);
              break e;
            } else if (g !== S) {
              S = Yl(Error(i(424)), o), o = Qm(r, o, g, d, S);
              break e;
            } else for (Kr = ha(o.stateNode.containerInfo.firstChild), Xr = o, In = !0, Ei = null, d = qg(o, null, g, d), o.child = d; d;) d.flags = d.flags & -3 | 4096, d = d.sibling;
          } else {
            if (Wo(), g === S) {
              o = Ir(r, o, d);
              break e;
            }
            _n(r, o, g, d);
          }
          o = o.child;
        }
        return o;
      case 5:
        return Xn(o), r === null && Th(o), g = o.type, S = o.pendingProps, R = r !== null ? r.memoizedProps : null, A = S.children, jd(g, S) ? A = null : R !== null && jd(g, R) && (o.flags |= 32), Sb(r, o), _n(r, o, A, d), o.child;
      case 6:
        return r === null && Th(o), null;
      case 13:
        return Zm(r, o, d);
      case 4:
        return Wt(o, o.stateNode.containerInfo), g = o.pendingProps, r === null ? o.child = Vs(o, null, g, d) : _n(r, o, g, d), o.child;
      case 11:
        return g = o.type, S = o.pendingProps, S = o.elementType === g ? S : li(g, S), $s(r, o, g, S, d);
      case 7:
        return _n(r, o, o.pendingProps, d), o.child;
      case 8:
        return _n(r, o, o.pendingProps.children, d), o.child;
      case 12:
        return _n(r, o, o.pendingProps.children, d), o.child;
      case 10:
        e: {
          if (g = o.type._context, S = o.pendingProps, R = o.memoizedProps, A = S.value, ft($d, g._currentValue), g._currentValue = A, R !== null) if (Gi(R.value, A)) {
            if (R.children === S.children && !or.current) {
              o = Ir(r, o, d);
              break e;
            }
          } else for (R = o.child, R !== null && (R.return = o); R !== null;) {
            var q = R.dependencies;
            if (q !== null) {
              A = R.child;
              for (var re = q.firstContext; re !== null;) {
                if (re.context === g) {
                  if (R.tag === 1) {
                    re = wa(-1, d & -d), re.tag = 2;
                    var be = R.updateQueue;
                    if (be !== null) {
                      be = be.shared;
                      var Le = be.pending;
                      Le === null ? re.next = re : (re.next = Le.next, Le.next = re), be.pending = re;
                    }
                  }
                  R.lanes |= d, re = R.alternate, re !== null && (re.lanes |= d), ui(R.return, d, o), q.lanes |= d;
                  break;
                }
                re = re.next;
              }
            } else if (R.tag === 10) A = R.type === o.type ? null : R.child;else if (R.tag === 18) {
              if (A = R.return, A === null) throw Error(i(341));
              A.lanes |= d, q = A.alternate, q !== null && (q.lanes |= d), ui(A, d, o), A = R.sibling;
            } else A = R.child;
            if (A !== null) A.return = R;else for (A = R; A !== null;) {
              if (A === o) {
                A = null;
                break;
              }
              if (R = A.sibling, R !== null) {
                R.return = A.return, A = R;
                break;
              }
              A = A.return;
            }
            R = A;
          }
          _n(r, o, S.children, d), o = o.child;
        }
        return o;
      case 9:
        return S = o.type, g = o.pendingProps.children, Fl(o, d), S = ki(S), g = g(S), o.flags |= 1, _n(r, o, g, d), o.child;
      case 14:
        return g = o.type, S = li(g, o.pendingProps), S = li(g.type, S), jt(r, o, g, S, d);
      case 15:
        return ac(r, o, o.type, o.pendingProps, d);
      case 17:
        return g = o.type, S = o.pendingProps, S = o.elementType === g ? S : li(g, S), ss(r, o), o.tag = 1, tr(g) ? (r = !0, Gr(o)) : r = !1, Fl(o, d), Oh(o, g, S), Lh(o, g, S, d), sc(null, o, g, !0, r, d);
      case 19:
        return os(r, o, d);
      case 22:
        return Bh(r, o, d);
    }
    throw Error(i(156, o.tag));
  };
  function ly(r, o) {
    return Lr(r, o);
  }
  function zw(r, o, d, g) {
    this.tag = r, this.key = d, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = o, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = g, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Li(r, o, d, g) {
    return new zw(r, o, d, g);
  }
  function Zh(r) {
    return r = r.prototype, !(!r || !r.isReactComponent);
  }
  function Db(r) {
    if (typeof r == "function") return Zh(r) ? 1 : 0;
    if (r != null) {
      if (r = r.$$typeof, r === ee) return 11;
      if (r === se) return 14;
    }
    return 2;
  }
  function Oa(r, o) {
    var d = r.alternate;
    return d === null ? (d = Li(r.tag, o, r.key, r.mode), d.elementType = r.elementType, d.type = r.type, d.stateNode = r.stateNode, d.alternate = r, r.alternate = d) : (d.pendingProps = o, d.type = r.type, d.flags = 0, d.subtreeFlags = 0, d.deletions = null), d.flags = r.flags & 14680064, d.childLanes = r.childLanes, d.lanes = r.lanes, d.child = r.child, d.memoizedProps = r.memoizedProps, d.memoizedState = r.memoizedState, d.updateQueue = r.updateQueue, o = r.dependencies, d.dependencies = o === null ? null : {
      lanes: o.lanes,
      firstContext: o.firstContext
    }, d.sibling = r.sibling, d.index = r.index, d.ref = r.ref, d;
  }
  function Js(r, o, d, g, S, R) {
    var A = 2;
    if (g = r, typeof r == "function") Zh(r) && (A = 1);else if (typeof r == "string") A = 5;else e: switch (r) {
      case G:
        return oo(d.children, S, R, o);
      case Q:
        A = 8, S |= 8;
        break;
      case te:
        return r = Li(12, d, o, S | 2), r.elementType = te, r.lanes = R, r;
      case oe:
        return r = Li(13, d, o, S), r.elementType = oe, r.lanes = R, r;
      case ne:
        return r = Li(19, d, o, S), r.elementType = ne, r.lanes = R, r;
      case W:
        return jc(d, S, R, o);
      default:
        if (typeof r == "object" && r !== null) switch (r.$$typeof) {
          case ie:
            A = 10;
            break e;
          case Y:
            A = 9;
            break e;
          case ee:
            A = 11;
            break e;
          case se:
            A = 14;
            break e;
          case ue:
            A = 16, g = null;
            break e;
        }
        throw Error(i(130, r == null ? r : typeof r, ""));
    }
    return o = Li(A, d, o, S), o.elementType = r, o.type = g, o.lanes = R, o;
  }
  function oo(r, o, d, g) {
    return r = Li(7, r, g, o), r.lanes = d, r;
  }
  function jc(r, o, d, g) {
    return r = Li(22, r, g, o), r.elementType = W, r.lanes = d, r.stateNode = {
      isHidden: !1
    }, r;
  }
  function yf(r, o, d) {
    return r = Li(6, r, null, o), r.lanes = d, r;
  }
  function bf(r, o, d) {
    return o = Li(4, r.children !== null ? r.children : [], r.key, o), o.lanes = d, o.stateNode = {
      containerInfo: r.containerInfo,
      pendingChildren: null,
      implementation: r.implementation
    }, o;
  }
  function Ib(r, o, d, g, S) {
    this.tag = o, this.containerInfo = r, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = Kp(0), this.expirationTimes = Kp(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Kp(0), this.identifierPrefix = g, this.onRecoverableError = S, this.mutableSourceEagerHydrationData = null;
  }
  function dp(r, o, d, g, S, R, A, q, re) {
    return r = new Ib(r, o, d, q, re), o === 1 ? (o = 1, R === !0 && (o |= 8)) : o = 0, R = Li(3, null, null, o), r.current = R, R.stateNode = r, R.memoizedState = {
      element: g,
      isDehydrated: d,
      cache: null,
      transitions: null,
      pendingSuspenseBoundaries: null
    }, Dh(R), r;
  }
  function Mb(r, o, d) {
    var g = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      $$typeof: K,
      key: g == null ? null : "" + g,
      children: r,
      containerInfo: o,
      implementation: d
    };
  }
  function uy(r) {
    if (!r) return qr;
    r = r._reactInternals;
    e: {
      if ($t(r) !== r || r.tag !== 1) throw Error(i(170));
      var o = r;
      do {
        switch (o.tag) {
          case 3:
            o = o.stateNode.context;
            break e;
          case 1:
            if (tr(o.type)) {
              o = o.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        o = o.return;
      } while (o !== null);
      throw Error(i(171));
    }
    if (r.tag === 1) {
      var d = r.type;
      if (tr(d)) return Gu(r, d, o);
    }
    return o;
  }
  function cy(r, o, d, g, S, R, A, q, re) {
    return r = dp(d, g, !0, r, S, R, A, q, re), r.context = uy(null), d = r.current, g = hr(), S = Ca(d), R = wa(g, S), R.callback = o ?? null, Ti(d, R, S), r.current.lanes = S, Ts(r, S, g), Mr(r, g), r;
  }
  function Fc(r, o, d, g) {
    var S = o.current,
      R = hr(),
      A = Ca(S);
    return d = uy(d), o.context === null ? o.context = d : o.pendingContext = d, o = wa(R, A), o.payload = {
      element: r
    }, g = g === void 0 ? null : g, g !== null && (o.callback = g), r = Ti(S, o, A), r !== null && (Oi(r, S, A, R), to(r, S, A)), A;
  }
  function vc(r) {
    if (r = r.current, !r.child) return null;
    switch (r.child.tag) {
      case 5:
        return r.child.stateNode;
      default:
        return r.child.stateNode;
    }
  }
  function Jh(r, o) {
    if (r = r.memoizedState, r !== null && r.dehydrated !== null) {
      var d = r.retryLane;
      r.retryLane = d !== 0 && d < o ? d : o;
    }
  }
  function Ql(r, o) {
    Jh(r, o), (r = r.alternate) && Jh(r, o);
  }
  function fp() {
    return null;
  }
  var dy = typeof reportError == "function" ? reportError : function (r) {
    console.error(r);
  };
  function em(r) {
    this._internalRoot = r;
  }
  wf.prototype.render = em.prototype.render = function (r) {
    var o = this._internalRoot;
    if (o === null) throw Error(i(409));
    Fc(r, o, null, null);
  }, wf.prototype.unmount = em.prototype.unmount = function () {
    var r = this._internalRoot;
    if (r !== null) {
      this._internalRoot = null;
      var o = r.containerInfo;
      Ko(function () {
        Fc(null, r, null, null);
      }), o[Qa] = null;
    }
  };
  function wf(r) {
    this._internalRoot = r;
  }
  wf.prototype.unstable_scheduleHydration = function (r) {
    if (r) {
      var o = At();
      r = {
        blockedOn: null,
        target: r,
        priority: o
      };
      for (var d = 0; d < br.length && o !== 0 && o < br[d].priority; d++);
      br.splice(d, 0, r), d === 0 && nh(r);
    }
  };
  function tm(r) {
    return !(!r || r.nodeType !== 1 && r.nodeType !== 9 && r.nodeType !== 11);
  }
  function _f(r) {
    return !(!r || r.nodeType !== 1 && r.nodeType !== 9 && r.nodeType !== 11 && (r.nodeType !== 8 || r.nodeValue !== " react-mount-point-unstable "));
  }
  function rv() {}
  function Ob(r, o, d, g, S) {
    if (S) {
      if (typeof g == "function") {
        var R = g;
        g = function () {
          var be = vc(A);
          R.call(be);
        };
      }
      var A = cy(o, g, r, 0, null, !1, !1, "", rv);
      return r._reactRootContainer = A, r[Qa] = A.current, Il(r.nodeType === 8 ? r.parentNode : r), Ko(), A;
    }
    for (; S = r.lastChild;) r.removeChild(S);
    if (typeof g == "function") {
      var q = g;
      g = function () {
        var be = vc(re);
        q.call(be);
      };
    }
    var re = dp(r, 0, !1, null, null, !1, !1, "", rv);
    return r._reactRootContainer = re, r[Qa] = re.current, Il(r.nodeType === 8 ? r.parentNode : r), Ko(function () {
      Fc(o, re, d, g);
    }), re;
  }
  function xf(r, o, d, g, S) {
    var R = d._reactRootContainer;
    if (R) {
      var A = R;
      if (typeof S == "function") {
        var q = S;
        S = function () {
          var re = vc(A);
          q.call(re);
        };
      }
      Fc(o, A, r, S);
    } else A = Ob(d, o, r, S, g);
    return vc(A);
  }
  bn = function (r) {
    switch (r.tag) {
      case 3:
        var o = r.stateNode;
        if (o.current.memoizedState.isDehydrated) {
          var d = Cs(o.pendingLanes);
          d !== 0 && (hd(o, d | 1), Mr(o, yn()), (on & 6) === 0 && (ao = yn() + 500, ga()));
        }
        break;
      case 13:
        Ko(function () {
          var g = En(r, 1);
          if (g !== null) {
            var S = hr();
            Oi(g, r, 1, S);
          }
        }), Ql(r, 1);
    }
  }, Zp = function (r) {
    if (r.tag === 13) {
      var o = En(r, 134217728);
      if (o !== null) {
        var d = hr();
        Oi(o, r, 134217728, d);
      }
      Ql(r, 134217728);
    }
  }, Jp = function (r) {
    if (r.tag === 13) {
      var o = Ca(r),
        d = En(r, o);
      if (d !== null) {
        var g = hr();
        Oi(d, r, o, g);
      }
      Ql(r, o);
    }
  }, At = function () {
    return gn;
  }, eh = function (r, o) {
    var d = gn;
    try {
      return gn = r, o();
    } finally {
      gn = d;
    }
  }, en = function (r, o, d) {
    switch (o) {
      case "input":
        if (un(r, d), o = d.name, d.type === "radio" && o != null) {
          for (d = r; d.parentNode;) d = d.parentNode;
          for (d = d.querySelectorAll("input[name=" + JSON.stringify("" + o) + '][type="radio"]'), o = 0; o < d.length; o++) {
            var g = d[o];
            if (g !== r && g.form === r.form) {
              var S = Gn(g);
              if (!S) throw Error(i(90));
              ye(g), un(g, S);
            }
          }
        }
        break;
      case "textarea":
        Ot(r, d);
        break;
      case "select":
        o = d.value, o != null && Dt(r, !!d.multiple, o, !1);
    }
  }, _l = Xh, Mo = Ko;
  var Lb = {
      usingClientEntryPoint: !1,
      Events: [pt, Xi, Gn, ll, yo, Xh]
    },
    cs = {
      findFiberByHostInstance: Fs,
      bundleType: 0,
      version: "18.2.0",
      rendererPackageName: "react-dom"
    },
    gc = {
      bundleType: cs.bundleType,
      version: cs.version,
      rendererPackageName: cs.rendererPackageName,
      rendererConfig: cs.rendererConfig,
      overrideHookState: null,
      overrideHookStateDeletePath: null,
      overrideHookStateRenamePath: null,
      overrideProps: null,
      overridePropsDeletePath: null,
      overridePropsRenamePath: null,
      setErrorHandler: null,
      setSuspenseHandler: null,
      scheduleUpdate: null,
      currentDispatcherRef: j.ReactCurrentDispatcher,
      findHostInstanceByFiber: function (r) {
        return r = Tn(r), r === null ? null : r.stateNode;
      },
      findFiberByHostInstance: cs.findFiberByHostInstance || fp,
      findHostInstancesForRefresh: null,
      scheduleRefresh: null,
      scheduleRoot: null,
      setRefreshHandler: null,
      getCurrentFiber: null,
      reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
    };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Zl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Zl.isDisabled && Zl.supportsFiber) try {
      Iu = Zl.inject(gc), qi = Zl;
    } catch {}
  }
  return ed.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Lb, ed.createPortal = function (r, o) {
    var d = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!tm(o)) throw Error(i(200));
    return Mb(r, o, null, d);
  }, ed.createRoot = function (r, o) {
    if (!tm(r)) throw Error(i(299));
    var d = !1,
      g = "",
      S = dy;
    return o != null && (o.unstable_strictMode === !0 && (d = !0), o.identifierPrefix !== void 0 && (g = o.identifierPrefix), o.onRecoverableError !== void 0 && (S = o.onRecoverableError)), o = dp(r, 1, !1, null, null, d, !1, g, S), r[Qa] = o.current, Il(r.nodeType === 8 ? r.parentNode : r), new em(o);
  }, ed.findDOMNode = function (r) {
    if (r == null) return null;
    if (r.nodeType === 1) return r;
    var o = r._reactInternals;
    if (o === void 0) throw typeof r.render == "function" ? Error(i(188)) : (r = Object.keys(r).join(","), Error(i(268, r)));
    return r = Tn(o), r = r === null ? null : r.stateNode, r;
  }, ed.flushSync = function (r) {
    return Ko(r);
  }, ed.hydrate = function (r, o, d) {
    if (!_f(o)) throw Error(i(200));
    return xf(null, r, o, !0, d);
  }, ed.hydrateRoot = function (r, o, d) {
    if (!tm(r)) throw Error(i(405));
    var g = d != null && d.hydratedSources || null,
      S = !1,
      R = "",
      A = dy;
    if (d != null && (d.unstable_strictMode === !0 && (S = !0), d.identifierPrefix !== void 0 && (R = d.identifierPrefix), d.onRecoverableError !== void 0 && (A = d.onRecoverableError)), o = cy(o, null, r, 1, d ?? null, S, !1, R, A), r[Qa] = o.current, Il(r), g) for (r = 0; r < g.length; r++) d = g[r], S = d._getVersion, S = S(d._source), o.mutableSourceEagerHydrationData == null ? o.mutableSourceEagerHydrationData = [d, S] : o.mutableSourceEagerHydrationData.push(d, S);
    return new wf(o);
  }, ed.render = function (r, o, d) {
    if (!_f(o)) throw Error(i(200));
    return xf(null, r, o, !1, d);
  }, ed.unmountComponentAtNode = function (r) {
    if (!_f(r)) throw Error(i(40));
    return r._reactRootContainer ? (Ko(function () {
      xf(null, null, r, !1, function () {
        r._reactRootContainer = null, r[Qa] = null;
      });
    }), !0) : !1;
  }, ed.unstable_batchedUpdates = Xh, ed.unstable_renderSubtreeIntoContainer = function (r, o, d, g) {
    if (!_f(d)) throw Error(i(200));
    if (r == null || r._reactInternals === void 0) throw Error(i(38));
    return xf(r, o, d, !1, g);
  }, ed.version = "18.2.0-next-9e3b772b8-20220608", ed;
}
var td = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bU;
function _ge() {
  return bU || (bU = 1, process.env.NODE_ENV !== "production" && function () {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = Nt,
      e = j8(),
      i = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
      l = !1;
    function c(n) {
      l = n;
    }
    function p(n) {
      if (!l) {
        for (var a = arguments.length, f = new Array(a > 1 ? a - 1 : 0), m = 1; m < a; m++) f[m - 1] = arguments[m];
        y("warn", n, f);
      }
    }
    function h(n) {
      if (!l) {
        for (var a = arguments.length, f = new Array(a > 1 ? a - 1 : 0), m = 1; m < a; m++) f[m - 1] = arguments[m];
        y("error", n, f);
      }
    }
    function y(n, a, f) {
      {
        var m = i.ReactDebugCurrentFrame,
          b = m.getStackAddendum();
        b !== "" && (a += "%s", f = f.concat([b]));
        var T = f.map(function (M) {
          return String(M);
        });
        T.unshift("Warning: " + a), Function.prototype.apply.call(console[n], console, T);
      }
    }
    var w = 0,
      x = 1,
      E = 2,
      C = 3,
      k = 4,
      D = 5,
      I = 6,
      O = 7,
      P = 8,
      N = 9,
      L = 10,
      F = 11,
      j = 12,
      V = 13,
      K = 14,
      G = 15,
      Q = 16,
      te = 17,
      ie = 18,
      Y = 19,
      ee = 21,
      oe = 22,
      ne = 23,
      se = 24,
      ue = 25,
      W = !0,
      $ = !1,
      le = !1,
      H = !1,
      ce = !1,
      de = !1,
      Ce = !0,
      Ee = !0,
      fe = !0,
      xe = /* @__PURE__ */new Set(),
      we = {},
      ve = {};
    function Te(n, a) {
      ze(n, a), ze(n + "Capture", a);
    }
    function ze(n, a) {
      we[n] && h("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", n), we[n] = a;
      {
        var f = n.toLowerCase();
        ve[f] = n, n === "onDoubleClick" && (ve.ondblclick = n);
      }
      for (var m = 0; m < a.length; m++) xe.add(a[m]);
    }
    var Xe = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u",
      ye = Object.prototype.hasOwnProperty;
    function qe(n) {
      {
        var a = typeof Symbol == "function" && Symbol.toStringTag,
          f = a && n[Symbol.toStringTag] || n.constructor.name || "Object";
        return f;
      }
    }
    function Ae(n) {
      try {
        return Mt(n), !1;
      } catch {
        return !0;
      }
    }
    function Mt(n) {
      return "" + n;
    }
    function Ft(n, a) {
      if (Ae(n)) return h("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", a, qe(n)), Mt(n);
    }
    function un(n) {
      if (Ae(n)) return h("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", qe(n)), Mt(n);
    }
    function gt(n, a) {
      if (Ae(n)) return h("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", a, qe(n)), Mt(n);
    }
    function Pt(n, a) {
      if (Ae(n)) return h("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", a, qe(n)), Mt(n);
    }
    function St(n) {
      if (Ae(n)) return h("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", qe(n)), Mt(n);
    }
    function Dt(n) {
      if (Ae(n)) return h("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", qe(n)), Mt(n);
    }
    var Kt = 0,
      hn = 1,
      Ot = 2,
      Et = 3,
      Vt = 4,
      Xt = 5,
      vn = 6,
      ot = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD",
      We = ot + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040",
      ht = new RegExp("^[" + ot + "][" + We + "]*$"),
      Ke = {},
      yt = {};
    function je(n) {
      return ye.call(yt, n) ? !0 : ye.call(Ke, n) ? !1 : ht.test(n) ? (yt[n] = !0, !0) : (Ke[n] = !0, h("Invalid attribute name: `%s`", n), !1);
    }
    function at(n, a, f) {
      return a !== null ? a.type === Kt : f ? !1 : n.length > 2 && (n[0] === "o" || n[0] === "O") && (n[1] === "n" || n[1] === "N");
    }
    function kt(n, a, f, m) {
      if (f !== null && f.type === Kt) return !1;
      switch (typeof a) {
        case "function":
        // $FlowIssue symbol is perfectly valid here
        case "symbol":
          return !0;
        case "boolean":
          {
            if (m) return !1;
            if (f !== null) return !f.acceptsBooleans;
            var b = n.toLowerCase().slice(0, 5);
            return b !== "data-" && b !== "aria-";
          }
        default:
          return !1;
      }
    }
    function Bt(n, a, f, m) {
      if (a === null || typeof a > "u" || kt(n, a, f, m)) return !0;
      if (m) return !1;
      if (f !== null) switch (f.type) {
        case Et:
          return !a;
        case Vt:
          return a === !1;
        case Xt:
          return isNaN(a);
        case vn:
          return isNaN(a) || a < 1;
      }
      return !1;
    }
    function Ht(n) {
      return en.hasOwnProperty(n) ? en[n] : null;
    }
    function ln(n, a, f, m, b, T, M) {
      this.acceptsBooleans = a === Ot || a === Et || a === Vt, this.attributeName = m, this.attributeNamespace = b, this.mustUseProperty = f, this.propertyName = n, this.type = a, this.sanitizeURL = T, this.removeEmptyString = M;
    }
    var en = {},
      Rr = ["children", "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue", "defaultChecked", "innerHTML", "suppressContentEditableWarning", "suppressHydrationWarning", "style"];
    Rr.forEach(function (n) {
      en[n] = new ln(n, Kt, !1,
      // mustUseProperty
      n,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (n) {
      var a = n[0],
        f = n[1];
      en[a] = new ln(a, hn, !1,
      // mustUseProperty
      f,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (n) {
      en[n] = new ln(n, Ot, !1,
      // mustUseProperty
      n.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (n) {
      en[n] = new ln(n, Ot, !1,
      // mustUseProperty
      n,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["allowFullScreen", "async",
    // Note: there is a special case that prevents it from being written to the DOM
    // on the client side because the browsers are inconsistent. Instead we call focus().
    "autoFocus", "autoPlay", "controls", "default", "defer", "disabled", "disablePictureInPicture", "disableRemotePlayback", "formNoValidate", "hidden", "loop", "noModule", "noValidate", "open", "playsInline", "readOnly", "required", "reversed", "scoped", "seamless",
    // Microdata
    "itemScope"].forEach(function (n) {
      en[n] = new ln(n, Et, !1,
      // mustUseProperty
      n.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["checked",
    // Note: `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`. We have special logic for handling this.
    "multiple", "muted", "selected"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
    ].forEach(function (n) {
      en[n] = new ln(n, Et, !0,
      // mustUseProperty
      n,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["capture", "download"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
    ].forEach(function (n) {
      en[n] = new ln(n, Vt, !1,
      // mustUseProperty
      n,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["cols", "rows", "size", "span"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
    ].forEach(function (n) {
      en[n] = new ln(n, vn, !1,
      // mustUseProperty
      n,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["rowSpan", "start"].forEach(function (n) {
      en[n] = new ln(n, Xt, !1,
      // mustUseProperty
      n.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    });
    var Nr = /[\-\:]([a-z])/g,
      Hi = function (n) {
        return n[1].toUpperCase();
      };
    ["accent-height", "alignment-baseline", "arabic-form", "baseline-shift", "cap-height", "clip-path", "clip-rule", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "dominant-baseline", "enable-background", "fill-opacity", "fill-rule", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "glyph-name", "glyph-orientation-horizontal", "glyph-orientation-vertical", "horiz-adv-x", "horiz-origin-x", "image-rendering", "letter-spacing", "lighting-color", "marker-end", "marker-mid", "marker-start", "overline-position", "overline-thickness", "paint-order", "panose-1", "pointer-events", "rendering-intent", "shape-rendering", "stop-color", "stop-opacity", "strikethrough-position", "strikethrough-thickness", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "text-anchor", "text-decoration", "text-rendering", "underline-position", "underline-thickness", "unicode-bidi", "unicode-range", "units-per-em", "v-alphabetic", "v-hanging", "v-ideographic", "v-mathematical", "vector-effect", "vert-adv-y", "vert-origin-x", "vert-origin-y", "word-spacing", "writing-mode", "xmlns:xlink", "x-height"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
    ].forEach(function (n) {
      var a = n.replace(Nr, Hi);
      en[a] = new ln(a, hn, !1,
      // mustUseProperty
      n, null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["xlink:actuate", "xlink:arcrole", "xlink:role", "xlink:show", "xlink:title", "xlink:type"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
    ].forEach(function (n) {
      var a = n.replace(Nr, Hi);
      en[a] = new ln(a, hn, !1,
      // mustUseProperty
      n, "http://www.w3.org/1999/xlink", !1,
      // sanitizeURL
      !1);
    }), ["xml:base", "xml:lang", "xml:space"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
    ].forEach(function (n) {
      var a = n.replace(Nr, Hi);
      en[a] = new ln(a, hn, !1,
      // mustUseProperty
      n, "http://www.w3.org/XML/1998/namespace", !1,
      // sanitizeURL
      !1);
    }), ["tabIndex", "crossOrigin"].forEach(function (n) {
      en[n] = new ln(n, hn, !1,
      // mustUseProperty
      n.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    });
    var ll = "xlinkHref";
    en[ll] = new ln("xlinkHref", hn, !1,
    // mustUseProperty
    "xlink:href", "http://www.w3.org/1999/xlink", !0,
    // sanitizeURL
    !1), ["src", "href", "action", "formAction"].forEach(function (n) {
      en[n] = new ln(n, hn, !1,
      // mustUseProperty
      n.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !0,
      // sanitizeURL
      !0);
    });
    var yo = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i,
      _l = !1;
    function Mo(n) {
      !_l && yo.test(n) && (_l = !0, h("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(n)));
    }
    function bo(n, a, f, m) {
      if (m.mustUseProperty) {
        var b = m.propertyName;
        return n[b];
      } else {
        Ft(f, a), m.sanitizeURL && Mo("" + f);
        var T = m.attributeName,
          M = null;
        if (m.type === Vt) {
          if (n.hasAttribute(T)) {
            var z = n.getAttribute(T);
            return z === "" ? !0 : Bt(a, f, m, !1) ? z : z === "" + f ? f : z;
          }
        } else if (n.hasAttribute(T)) {
          if (Bt(a, f, m, !1)) return n.getAttribute(T);
          if (m.type === Et) return f;
          M = n.getAttribute(T);
        }
        return Bt(a, f, m, !1) ? M === null ? f : M : M === "" + f ? f : M;
      }
    }
    function Tu(n, a, f, m) {
      {
        if (!je(a)) return;
        if (!n.hasAttribute(a)) return f === void 0 ? void 0 : null;
        var b = n.getAttribute(a);
        return Ft(f, a), b === "" + f ? f : b;
      }
    }
    function Ha(n, a, f, m) {
      var b = Ht(a);
      if (!at(a, b, m)) {
        if (Bt(a, f, b, m) && (f = null), m || b === null) {
          if (je(a)) {
            var T = a;
            f === null ? n.removeAttribute(T) : (Ft(f, a), n.setAttribute(T, "" + f));
          }
          return;
        }
        var M = b.mustUseProperty;
        if (M) {
          var z = b.propertyName;
          if (f === null) {
            var U = b.type;
            n[z] = U === Et ? !1 : "";
          } else n[z] = f;
          return;
        }
        var X = b.attributeName,
          J = b.attributeNamespace;
        if (f === null) n.removeAttribute(X);else {
          var me = b.type,
            Se;
          me === Et || me === Vt && f === !0 ? Se = "" : (Ft(f, X), Se = "" + f, b.sanitizeURL && Mo(Se.toString())), J ? n.setAttributeNS(J, X, Se) : n.setAttribute(X, Se);
        }
      }
    }
    var $i = Symbol.for("react.element"),
      oi = Symbol.for("react.portal"),
      Oo = Symbol.for("react.fragment"),
      $a = Symbol.for("react.strict_mode"),
      Lo = Symbol.for("react.profiler"),
      Z = Symbol.for("react.provider"),
      Ne = Symbol.for("react.context"),
      Ye = Symbol.for("react.forward_ref"),
      xt = Symbol.for("react.suspense"),
      rn = Symbol.for("react.suspense_list"),
      $t = Symbol.for("react.memo"),
      Ct = Symbol.for("react.lazy"),
      qt = Symbol.for("react.scope"),
      yr = Symbol.for("react.debug_trace_mode"),
      Tn = Symbol.for("react.offscreen"),
      jn = Symbol.for("react.legacy_hidden"),
      Lr = Symbol.for("react.cache"),
      Wa = Symbol.for("react.tracing_marker"),
      Ru = Symbol.iterator,
      Wi = "@@iterator";
    function yn(n) {
      if (n === null || typeof n != "object") return null;
      var a = Ru && n[Ru] || n[Wi];
      return typeof a == "function" ? a : null;
    }
    var Qt = Object.assign,
      Es = 0,
      Wp,
      Du,
      tg,
      qp,
      Iu,
      qi,
      ng;
    function gi() {}
    gi.__reactDisabledLog = !0;
    function uw() {
      {
        if (Es === 0) {
          Wp = console.log, Du = console.info, tg = console.warn, qp = console.error, Iu = console.group, qi = console.groupCollapsed, ng = console.groupEnd;
          var n = {
            configurable: !0,
            enumerable: !0,
            value: gi,
            writable: !0
          };
          Object.defineProperties(console, {
            info: n,
            log: n,
            warn: n,
            error: n,
            group: n,
            groupCollapsed: n,
            groupEnd: n
          });
        }
        Es++;
      }
    }
    function cw() {
      {
        if (Es--, Es === 0) {
          var n = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Qt({}, n, {
              value: Wp
            }),
            info: Qt({}, n, {
              value: Du
            }),
            warn: Qt({}, n, {
              value: tg
            }),
            error: Qt({}, n, {
              value: qp
            }),
            group: Qt({}, n, {
              value: Iu
            }),
            groupCollapsed: Qt({}, n, {
              value: qi
            }),
            groupEnd: Qt({}, n, {
              value: ng
            })
          });
        }
        Es < 0 && h("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Yp = i.ReactCurrentDispatcher,
      xl;
    function Yi(n, a, f) {
      {
        if (xl === void 0) try {
          throw Error();
        } catch (b) {
          var m = b.stack.trim().match(/\n( *(at )?)/);
          xl = m && m[1] || "";
        }
        return `
` + xl + n;
      }
    }
    var Cs = !1,
      ks;
    {
      var dw = typeof WeakMap == "function" ? WeakMap : Map;
      ks = new dw();
    }
    function Gp(n, a) {
      if (!n || Cs) return "";
      {
        var f = ks.get(n);
        if (f !== void 0) return f;
      }
      var m;
      Cs = !0;
      var b = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Yp.current, Yp.current = null, uw();
      try {
        if (a) {
          var M = function () {
            throw Error();
          };
          if (Object.defineProperty(M.prototype, "props", {
            set: function () {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(M, []);
            } catch (Pe) {
              m = Pe;
            }
            Reflect.construct(n, [], M);
          } else {
            try {
              M.call();
            } catch (Pe) {
              m = Pe;
            }
            n.call(M.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Pe) {
            m = Pe;
          }
          n();
        }
      } catch (Pe) {
        if (Pe && m && typeof Pe.stack == "string") {
          for (var z = Pe.stack.split(`
`), U = m.stack.split(`
`), X = z.length - 1, J = U.length - 1; X >= 1 && J >= 0 && z[X] !== U[J];) J--;
          for (; X >= 1 && J >= 0; X--, J--) if (z[X] !== U[J]) {
            if (X !== 1 || J !== 1) do if (X--, J--, J < 0 || z[X] !== U[J]) {
              var me = `
` + z[X].replace(" at new ", " at ");
              return n.displayName && me.includes("<anonymous>") && (me = me.replace("<anonymous>", n.displayName)), typeof n == "function" && ks.set(n, me), me;
            } while (X >= 1 && J >= 0);
            break;
          }
        }
      } finally {
        Cs = !1, Yp.current = T, cw(), Error.prepareStackTrace = b;
      }
      var Se = n ? n.displayName || n.name : "",
        Me = Se ? Yi(Se) : "";
      return typeof n == "function" && ks.set(n, Me), Me;
    }
    function Xp(n, a, f) {
      return Gp(n, !0);
    }
    function pd(n, a, f) {
      return Gp(n, !1);
    }
    function Kp(n) {
      var a = n.prototype;
      return !!(a && a.isReactComponent);
    }
    function Ts(n, a, f) {
      if (n == null) return "";
      if (typeof n == "function") return Gp(n, Kp(n));
      if (typeof n == "string") return Yi(n);
      switch (n) {
        case xt:
          return Yi("Suspense");
        case rn:
          return Yi("SuspenseList");
      }
      if (typeof n == "object") switch (n.$$typeof) {
        case Ye:
          return pd(n.render);
        case $t:
          return Ts(n.type, a, f);
        case Ct:
          {
            var m = n,
              b = m._payload,
              T = m._init;
            try {
              return Ts(T(b), a, f);
            } catch {}
          }
      }
      return "";
    }
    function fw(n) {
      switch (n._debugOwner && n._debugOwner.type, n._debugSource, n.tag) {
        case D:
          return Yi(n.type);
        case Q:
          return Yi("Lazy");
        case V:
          return Yi("Suspense");
        case Y:
          return Yi("SuspenseList");
        case w:
        case E:
        case G:
          return pd(n.type);
        case F:
          return pd(n.type.render);
        case x:
          return Xp(n.type);
        default:
          return "";
      }
    }
    function hd(n) {
      try {
        var a = "",
          f = n;
        do a += fw(f), f = f.return; while (f);
        return a;
      } catch (m) {
        return `
Error generating stack: ` + m.message + `
` + m.stack;
      }
    }
    function gn(n, a, f) {
      var m = n.displayName;
      if (m) return m;
      var b = a.displayName || a.name || "";
      return b !== "" ? f + "(" + b + ")" : f;
    }
    function Qp(n) {
      return n.displayName || "Context";
    }
    function bn(n) {
      if (n == null) return null;
      if (typeof n.tag == "number" && h("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof n == "function") return n.displayName || n.name || null;
      if (typeof n == "string") return n;
      switch (n) {
        case Oo:
          return "Fragment";
        case oi:
          return "Portal";
        case Lo:
          return "Profiler";
        case $a:
          return "StrictMode";
        case xt:
          return "Suspense";
        case rn:
          return "SuspenseList";
      }
      if (typeof n == "object") switch (n.$$typeof) {
        case Ne:
          var a = n;
          return Qp(a) + ".Consumer";
        case Z:
          var f = n;
          return Qp(f._context) + ".Provider";
        case Ye:
          return gn(n, n.render, "ForwardRef");
        case $t:
          var m = n.displayName || null;
          return m !== null ? m : bn(n.type) || "Memo";
        case Ct:
          {
            var b = n,
              T = b._payload,
              M = b._init;
            try {
              return bn(M(T));
            } catch {
              return null;
            }
          }
      }
      return null;
    }
    function Zp(n, a, f) {
      var m = a.displayName || a.name || "";
      return n.displayName || (m !== "" ? f + "(" + m + ")" : f);
    }
    function Jp(n) {
      return n.displayName || "Context";
    }
    function At(n) {
      var a = n.tag,
        f = n.type;
      switch (a) {
        case se:
          return "Cache";
        case N:
          var m = f;
          return Jp(m) + ".Consumer";
        case L:
          var b = f;
          return Jp(b._context) + ".Provider";
        case ie:
          return "DehydratedFragment";
        case F:
          return Zp(f, f.render, "ForwardRef");
        case O:
          return "Fragment";
        case D:
          return f;
        case k:
          return "Portal";
        case C:
          return "Root";
        case I:
          return "Text";
        case Q:
          return bn(f);
        case P:
          return f === $a ? "StrictMode" : "Mode";
        case oe:
          return "Offscreen";
        case j:
          return "Profiler";
        case ee:
          return "Scope";
        case V:
          return "Suspense";
        case Y:
          return "SuspenseList";
        case ue:
          return "TracingMarker";
        // The display name for this tags come from the user-provided type:
        case x:
        case w:
        case te:
        case E:
        case K:
        case G:
          if (typeof f == "function") return f.displayName || f.name || null;
          if (typeof f == "string") return f;
          break;
      }
      return null;
    }
    var eh = i.ReactDebugCurrentFrame,
      Pr = null,
      Po = !1;
    function yi() {
      {
        if (Pr === null) return null;
        var n = Pr._debugOwner;
        if (n !== null && typeof n < "u") return At(n);
      }
      return null;
    }
    function Ao() {
      return Pr === null ? "" : hd(Pr);
    }
    function Un() {
      eh.getCurrentStack = null, Pr = null, Po = !1;
    }
    function Rn(n) {
      eh.getCurrentStack = n === null ? null : Ao, Pr = n, Po = !1;
    }
    function Mu() {
      return Pr;
    }
    function br(n) {
      Po = n;
    }
    function bi(n) {
      return "" + n;
    }
    function qa(n) {
      switch (typeof n) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return n;
        case "object":
          return Dt(n), n;
        default:
          return "";
      }
    }
    var Ou = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function th(n, a) {
      Ou[a.type] || a.onChange || a.onInput || a.readOnly || a.disabled || a.value == null || h("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), a.onChange || a.readOnly || a.disabled || a.checked == null || h("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function nh(n) {
      var a = n.type,
        f = n.nodeName;
      return f && f.toLowerCase() === "input" && (a === "checkbox" || a === "radio");
    }
    function Lu(n) {
      return n._valueTracker;
    }
    function rg(n) {
      n._valueTracker = null;
    }
    function pw(n) {
      var a = "";
      return n && (nh(n) ? a = n.checked ? "true" : "false" : a = n.value), a;
    }
    function Pu(n) {
      var a = nh(n) ? "checked" : "value",
        f = Object.getOwnPropertyDescriptor(n.constructor.prototype, a);
      Dt(n[a]);
      var m = "" + n[a];
      if (!(n.hasOwnProperty(a) || typeof f > "u" || typeof f.get != "function" || typeof f.set != "function")) {
        var b = f.get,
          T = f.set;
        Object.defineProperty(n, a, {
          configurable: !0,
          get: function () {
            return b.call(this);
          },
          set: function (z) {
            Dt(z), m = "" + z, T.call(this, z);
          }
        }), Object.defineProperty(n, a, {
          enumerable: f.enumerable
        });
        var M = {
          getValue: function () {
            return m;
          },
          setValue: function (z) {
            Dt(z), m = "" + z;
          },
          stopTracking: function () {
            rg(n), delete n[a];
          }
        };
        return M;
      }
    }
    function jo(n) {
      Lu(n) || (n._valueTracker = Pu(n));
    }
    function Rs(n) {
      if (!n) return !1;
      var a = Lu(n);
      if (!a) return !0;
      var f = a.getValue(),
        m = pw(n);
      return m !== f ? (a.setValue(m), !0) : !1;
    }
    function Ds(n) {
      if (n = n || (typeof document < "u" ? document : void 0), typeof n > "u") return null;
      try {
        return n.activeElement || n.body;
      } catch {
        return n.body;
      }
    }
    var ig = !1,
      ag = !1,
      md = !1,
      Au = !1;
    function vd(n) {
      var a = n.type === "checkbox" || n.type === "radio";
      return a ? n.checked != null : n.value != null;
    }
    function gd(n, a) {
      var f = n,
        m = a.checked,
        b = Qt({}, a, {
          defaultChecked: void 0,
          defaultValue: void 0,
          value: void 0,
          checked: m ?? f._wrapperState.initialChecked
        });
      return b;
    }
    function Ya(n, a) {
      th("input", a), a.checked !== void 0 && a.defaultChecked !== void 0 && !ag && (h("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", yi() || "A component", a.type), ag = !0), a.value !== void 0 && a.defaultValue !== void 0 && !ig && (h("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", yi() || "A component", a.type), ig = !0);
      var f = n,
        m = a.defaultValue == null ? "" : a.defaultValue;
      f._wrapperState = {
        initialChecked: a.checked != null ? a.checked : a.defaultChecked,
        initialValue: qa(a.value != null ? a.value : m),
        controlled: vd(a)
      };
    }
    function yd(n, a) {
      var f = n,
        m = a.checked;
      m != null && Ha(f, "checked", m, !1);
    }
    function Sl(n, a) {
      var f = n;
      {
        var m = vd(a);
        !f._wrapperState.controlled && m && !Au && (h("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), Au = !0), f._wrapperState.controlled && !m && !md && (h("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), md = !0);
      }
      yd(n, a);
      var b = qa(a.value),
        T = a.type;
      if (b != null) T === "number" ? (b === 0 && f.value === "" ||
      // We explicitly want to coerce to number here if possible.
      // eslint-disable-next-line
      f.value != b) && (f.value = bi(b)) : f.value !== bi(b) && (f.value = bi(b));else if (T === "submit" || T === "reset") {
        f.removeAttribute("value");
        return;
      }
      a.hasOwnProperty("value") ? _d(f, a.type, b) : a.hasOwnProperty("defaultValue") && _d(f, a.type, qa(a.defaultValue)), a.checked == null && a.defaultChecked != null && (f.defaultChecked = !!a.defaultChecked);
    }
    function rh(n, a, f) {
      var m = n;
      if (a.hasOwnProperty("value") || a.hasOwnProperty("defaultValue")) {
        var b = a.type,
          T = b === "submit" || b === "reset";
        if (T && (a.value === void 0 || a.value === null)) return;
        var M = bi(m._wrapperState.initialValue);
        f || M !== m.value && (m.value = M), m.defaultValue = M;
      }
      var z = m.name;
      z !== "" && (m.name = ""), m.defaultChecked = !m.defaultChecked, m.defaultChecked = !!m._wrapperState.initialChecked, z !== "" && (m.name = z);
    }
    function bd(n, a) {
      var f = n;
      Sl(f, a), wd(f, a);
    }
    function wd(n, a) {
      var f = a.name;
      if (a.type === "radio" && f != null) {
        for (var m = n; m.parentNode;) m = m.parentNode;
        Ft(f, "name");
        for (var b = m.querySelectorAll("input[name=" + JSON.stringify("" + f) + '][type="radio"]'), T = 0; T < b.length; T++) {
          var M = b[T];
          if (!(M === n || M.form !== n.form)) {
            var z = vS(M);
            if (!z) throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            Rs(M), Sl(M, z);
          }
        }
      }
    }
    function _d(n, a, f) {
      // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
      (a !== "number" || Ds(n.ownerDocument) !== n) && (f == null ? n.defaultValue = bi(n._wrapperState.initialValue) : n.defaultValue !== bi(f) && (n.defaultValue = bi(f)));
    }
    var $r = !1,
      Is = !1,
      xd = !1;
    function El(n, a) {
      a.value == null && (typeof a.children == "object" && a.children !== null ? t.Children.forEach(a.children, function (f) {
        f != null && (typeof f == "string" || typeof f == "number" || Is || (Is = !0, h("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }) : a.dangerouslySetInnerHTML != null && (xd || (xd = !0, h("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), a.selected != null && !$r && (h("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), $r = !0);
    }
    function hw(n, a) {
      a.value != null && n.setAttribute("value", bi(qa(a.value)));
    }
    var ih = Array.isArray;
    function wr(n) {
      return ih(n);
    }
    var Ms;
    Ms = !1;
    function ju() {
      var n = yi();
      return n ? `

Check the render method of \`` + n + "`." : "";
    }
    var ah = ["value", "defaultValue"];
    function mw(n) {
      {
        th("select", n);
        for (var a = 0; a < ah.length; a++) {
          var f = ah[a];
          if (n[f] != null) {
            var m = wr(n[f]);
            n.multiple && !m ? h("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", f, ju()) : !n.multiple && m && h("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", f, ju());
          }
        }
      }
    }
    function Cl(n, a, f, m) {
      var b = n.options;
      if (a) {
        for (var T = f, M = {}, z = 0; z < T.length; z++) M["$" + T[z]] = !0;
        for (var U = 0; U < b.length; U++) {
          var X = M.hasOwnProperty("$" + b[U].value);
          b[U].selected !== X && (b[U].selected = X), X && m && (b[U].defaultSelected = !0);
        }
      } else {
        for (var J = bi(qa(f)), me = null, Se = 0; Se < b.length; Se++) {
          if (b[Se].value === J) {
            b[Se].selected = !0, m && (b[Se].defaultSelected = !0);
            return;
          }
          me === null && !b[Se].disabled && (me = b[Se]);
        }
        me !== null && (me.selected = !0);
      }
    }
    function oh(n, a) {
      return Qt({}, a, {
        value: void 0
      });
    }
    function Sd(n, a) {
      var f = n;
      mw(a), f._wrapperState = {
        wasMultiple: !!a.multiple
      }, a.value !== void 0 && a.defaultValue !== void 0 && !Ms && (h("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), Ms = !0);
    }
    function vw(n, a) {
      var f = n;
      f.multiple = !!a.multiple;
      var m = a.value;
      m != null ? Cl(f, !!a.multiple, m, !1) : a.defaultValue != null && Cl(f, !!a.multiple, a.defaultValue, !0);
    }
    function gw(n, a) {
      var f = n,
        m = f._wrapperState.wasMultiple;
      f._wrapperState.wasMultiple = !!a.multiple;
      var b = a.value;
      b != null ? Cl(f, !!a.multiple, b, !1) : m !== !!a.multiple && (a.defaultValue != null ? Cl(f, !!a.multiple, a.defaultValue, !0) : Cl(f, !!a.multiple, a.multiple ? [] : "", !1));
    }
    function yw(n, a) {
      var f = n,
        m = a.value;
      m != null && Cl(f, !!a.multiple, m, !1);
    }
    var og = !1;
    function sh(n, a) {
      var f = n;
      if (a.dangerouslySetInnerHTML != null) throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var m = Qt({}, a, {
        value: void 0,
        defaultValue: void 0,
        children: bi(f._wrapperState.initialValue)
      });
      return m;
    }
    function lh(n, a) {
      var f = n;
      th("textarea", a), a.value !== void 0 && a.defaultValue !== void 0 && !og && (h("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", yi() || "A component"), og = !0);
      var m = a.value;
      if (m == null) {
        var b = a.children,
          T = a.defaultValue;
        if (b != null) {
          h("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (T != null) throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (wr(b)) {
              if (b.length > 1) throw new Error("<textarea> can only have at most one child.");
              b = b[0];
            }
            T = b;
          }
        }
        T == null && (T = ""), m = T;
      }
      f._wrapperState = {
        initialValue: qa(m)
      };
    }
    function sg(n, a) {
      var f = n,
        m = qa(a.value),
        b = qa(a.defaultValue);
      if (m != null) {
        var T = bi(m);
        T !== f.value && (f.value = T), a.defaultValue == null && f.defaultValue !== T && (f.defaultValue = T);
      }
      b != null && (f.defaultValue = bi(b));
    }
    function lg(n, a) {
      var f = n,
        m = f.textContent;
      m === f._wrapperState.initialValue && m !== "" && m !== null && (f.value = m);
    }
    function bw(n, a) {
      sg(n, a);
    }
    var Ga = "http://www.w3.org/1999/xhtml",
      uh = "http://www.w3.org/1998/Math/MathML",
      ch = "http://www.w3.org/2000/svg";
    function dh(n) {
      switch (n) {
        case "svg":
          return ch;
        case "math":
          return uh;
        default:
          return Ga;
      }
    }
    function fh(n, a) {
      return n == null || n === Ga ? dh(a) : n === ch && a === "foreignObject" ? Ga : n;
    }
    var ug = function (n) {
        return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function (a, f, m, b) {
          MSApp.execUnsafeLocalFunction(function () {
            return n(a, f, m, b);
          });
        } : n;
      },
      Ed,
      cg = ug(function (n, a) {
        if (n.namespaceURI === ch && !("innerHTML" in n)) {
          Ed = Ed || document.createElement("div"), Ed.innerHTML = "<svg>" + a.valueOf().toString() + "</svg>";
          for (var f = Ed.firstChild; n.firstChild;) n.removeChild(n.firstChild);
          for (; f.firstChild;) n.appendChild(f.firstChild);
          return;
        }
        n.innerHTML = a;
      }),
      Wr = 1,
      Xa = 3,
      er = 8,
      Ka = 9,
      ph = 11,
      kl = function (n, a) {
        if (a) {
          var f = n.firstChild;
          if (f && f === n.lastChild && f.nodeType === Xa) {
            f.nodeValue = a;
            return;
          }
        }
        n.textContent = a;
      },
      Fu = {
        animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
        background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
        backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
        border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
        borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
        borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
        borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
        borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
        borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
        borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
        borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
        borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
        borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
        borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
        borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
        borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
        borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
        columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
        columns: ["columnCount", "columnWidth"],
        flex: ["flexBasis", "flexGrow", "flexShrink"],
        flexFlow: ["flexDirection", "flexWrap"],
        font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
        fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
        gap: ["columnGap", "rowGap"],
        grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
        gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
        gridColumn: ["gridColumnEnd", "gridColumnStart"],
        gridColumnGap: ["columnGap"],
        gridGap: ["columnGap", "rowGap"],
        gridRow: ["gridRowEnd", "gridRowStart"],
        gridRowGap: ["rowGap"],
        gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
        listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
        margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
        marker: ["markerEnd", "markerMid", "markerStart"],
        mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
        maskPosition: ["maskPositionX", "maskPositionY"],
        outline: ["outlineColor", "outlineStyle", "outlineWidth"],
        overflow: ["overflowX", "overflowY"],
        padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
        placeContent: ["alignContent", "justifyContent"],
        placeItems: ["alignItems", "justifyItems"],
        placeSelf: ["alignSelf", "justifySelf"],
        textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
        textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
        transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
        wordWrap: ["overflowWrap"]
      },
      Nu = {
        animationIterationCount: !0,
        aspectRatio: !0,
        borderImageOutset: !0,
        borderImageSlice: !0,
        borderImageWidth: !0,
        boxFlex: !0,
        boxFlexGroup: !0,
        boxOrdinalGroup: !0,
        columnCount: !0,
        columns: !0,
        flex: !0,
        flexGrow: !0,
        flexPositive: !0,
        flexShrink: !0,
        flexNegative: !0,
        flexOrder: !0,
        gridArea: !0,
        gridRow: !0,
        gridRowEnd: !0,
        gridRowSpan: !0,
        gridRowStart: !0,
        gridColumn: !0,
        gridColumnEnd: !0,
        gridColumnSpan: !0,
        gridColumnStart: !0,
        fontWeight: !0,
        lineClamp: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        tabSize: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
        // SVG-related properties
        fillOpacity: !0,
        floodOpacity: !0,
        stopOpacity: !0,
        strokeDasharray: !0,
        strokeDashoffset: !0,
        strokeMiterlimit: !0,
        strokeOpacity: !0,
        strokeWidth: !0
      };
    function dg(n, a) {
      return n + a.charAt(0).toUpperCase() + a.substring(1);
    }
    var fg = ["Webkit", "ms", "Moz", "O"];
    Object.keys(Nu).forEach(function (n) {
      fg.forEach(function (a) {
        Nu[dg(a, n)] = Nu[n];
      });
    });
    function Cd(n, a, f) {
      var m = a == null || typeof a == "boolean" || a === "";
      return m ? "" : !f && typeof a == "number" && a !== 0 && !(Nu.hasOwnProperty(n) && Nu[n]) ? a + "px" : (Pt(a, n), ("" + a).trim());
    }
    var pg = /([A-Z])/g,
      hg = /^ms-/;
    function Tl(n) {
      return n.replace(pg, "-$1").toLowerCase().replace(hg, "-ms-");
    }
    var mg = function () {};
    {
      var ww = /^(?:webkit|moz|o)[A-Z]/,
        _w = /^-ms-/,
        vg = /-(.)/g,
        hh = /;\s*$/,
        pa = {},
        Os = {},
        gg = !1,
        zu = !1,
        xw = function (n) {
          return n.replace(vg, function (a, f) {
            return f.toUpperCase();
          });
        },
        yg = function (n) {
          pa.hasOwnProperty(n) && pa[n] || (pa[n] = !0, h("Unsupported style property %s. Did you mean %s?", n,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          xw(n.replace(_w, "ms-"))));
        },
        mh = function (n) {
          pa.hasOwnProperty(n) && pa[n] || (pa[n] = !0, h("Unsupported vendor-prefixed style property %s. Did you mean %s?", n, n.charAt(0).toUpperCase() + n.slice(1)));
        },
        vh = function (n, a) {
          Os.hasOwnProperty(a) && Os[a] || (Os[a] = !0, h(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, n, a.replace(hh, "")));
        },
        bg = function (n, a) {
          gg || (gg = !0, h("`NaN` is an invalid value for the `%s` css style property.", n));
        },
        wg = function (n, a) {
          zu || (zu = !0, h("`Infinity` is an invalid value for the `%s` css style property.", n));
        };
      mg = function (n, a) {
        n.indexOf("-") > -1 ? yg(n) : ww.test(n) ? mh(n) : hh.test(a) && vh(n, a), typeof a == "number" && (isNaN(a) ? bg(n, a) : isFinite(a) || wg(n, a));
      };
    }
    var _g = mg;
    function Sw(n) {
      {
        var a = "",
          f = "";
        for (var m in n) if (n.hasOwnProperty(m)) {
          var b = n[m];
          if (b != null) {
            var T = m.indexOf("--") === 0;
            a += f + (T ? m : Tl(m)) + ":", a += Cd(m, b, T), f = ";";
          }
        }
        return a || null;
      }
    }
    function xg(n, a) {
      var f = n.style;
      for (var m in a) if (a.hasOwnProperty(m)) {
        var b = m.indexOf("--") === 0;
        b || _g(m, a[m]);
        var T = Cd(m, a[m], b);
        m === "float" && (m = "cssFloat"), b ? f.setProperty(m, T) : f[m] = T;
      }
    }
    function Ew(n) {
      return n == null || typeof n == "boolean" || n === "";
    }
    function Sg(n) {
      var a = {};
      for (var f in n) for (var m = Fu[f] || [f], b = 0; b < m.length; b++) a[m[b]] = f;
      return a;
    }
    function Cw(n, a) {
      {
        if (!a) return;
        var f = Sg(n),
          m = Sg(a),
          b = {};
        for (var T in f) {
          var M = f[T],
            z = m[T];
          if (z && M !== z) {
            var U = M + "," + z;
            if (b[U]) continue;
            b[U] = !0, h("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", Ew(n[M]) ? "Removing" : "Updating", M, z);
          }
        }
      }
    }
    var Gi = {
        area: !0,
        base: !0,
        br: !0,
        col: !0,
        embed: !0,
        hr: !0,
        img: !0,
        input: !0,
        keygen: !0,
        link: !0,
        meta: !0,
        param: !0,
        source: !0,
        track: !0,
        wbr: !0
        // NOTE: menuitem's close tag should be omitted, but that causes problems.
      },
      Vu = Qt({
        menuitem: !0
      }, Gi),
      Eg = "__html";
    function kd(n, a) {
      if (a) {
        if (Vu[n] && (a.children != null || a.dangerouslySetInnerHTML != null)) throw new Error(n + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (a.dangerouslySetInnerHTML != null) {
          if (a.children != null) throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (typeof a.dangerouslySetInnerHTML != "object" || !(Eg in a.dangerouslySetInnerHTML)) throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!a.suppressContentEditableWarning && a.contentEditable && a.children != null && h("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), a.style != null && typeof a.style != "object") throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function Fo(n, a) {
      if (n.indexOf("-") === -1) return typeof a.is == "string";
      switch (n) {
        // These are reserved SVG and MathML elements.
        // We don't mind this list too much because we expect it to never grow.
        // The alternative is to track the namespace in a few places which is convoluted.
        // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var Bu = {
        // HTML
        accept: "accept",
        acceptcharset: "acceptCharset",
        "accept-charset": "acceptCharset",
        accesskey: "accessKey",
        action: "action",
        allowfullscreen: "allowFullScreen",
        alt: "alt",
        as: "as",
        async: "async",
        autocapitalize: "autoCapitalize",
        autocomplete: "autoComplete",
        autocorrect: "autoCorrect",
        autofocus: "autoFocus",
        autoplay: "autoPlay",
        autosave: "autoSave",
        capture: "capture",
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        challenge: "challenge",
        charset: "charSet",
        checked: "checked",
        children: "children",
        cite: "cite",
        class: "className",
        classid: "classID",
        classname: "className",
        cols: "cols",
        colspan: "colSpan",
        content: "content",
        contenteditable: "contentEditable",
        contextmenu: "contextMenu",
        controls: "controls",
        controlslist: "controlsList",
        coords: "coords",
        crossorigin: "crossOrigin",
        dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
        data: "data",
        datetime: "dateTime",
        default: "default",
        defaultchecked: "defaultChecked",
        defaultvalue: "defaultValue",
        defer: "defer",
        dir: "dir",
        disabled: "disabled",
        disablepictureinpicture: "disablePictureInPicture",
        disableremoteplayback: "disableRemotePlayback",
        download: "download",
        draggable: "draggable",
        enctype: "encType",
        enterkeyhint: "enterKeyHint",
        for: "htmlFor",
        form: "form",
        formmethod: "formMethod",
        formaction: "formAction",
        formenctype: "formEncType",
        formnovalidate: "formNoValidate",
        formtarget: "formTarget",
        frameborder: "frameBorder",
        headers: "headers",
        height: "height",
        hidden: "hidden",
        high: "high",
        href: "href",
        hreflang: "hrefLang",
        htmlfor: "htmlFor",
        httpequiv: "httpEquiv",
        "http-equiv": "httpEquiv",
        icon: "icon",
        id: "id",
        imagesizes: "imageSizes",
        imagesrcset: "imageSrcSet",
        innerhtml: "innerHTML",
        inputmode: "inputMode",
        integrity: "integrity",
        is: "is",
        itemid: "itemID",
        itemprop: "itemProp",
        itemref: "itemRef",
        itemscope: "itemScope",
        itemtype: "itemType",
        keyparams: "keyParams",
        keytype: "keyType",
        kind: "kind",
        label: "label",
        lang: "lang",
        list: "list",
        loop: "loop",
        low: "low",
        manifest: "manifest",
        marginwidth: "marginWidth",
        marginheight: "marginHeight",
        max: "max",
        maxlength: "maxLength",
        media: "media",
        mediagroup: "mediaGroup",
        method: "method",
        min: "min",
        minlength: "minLength",
        multiple: "multiple",
        muted: "muted",
        name: "name",
        nomodule: "noModule",
        nonce: "nonce",
        novalidate: "noValidate",
        open: "open",
        optimum: "optimum",
        pattern: "pattern",
        placeholder: "placeholder",
        playsinline: "playsInline",
        poster: "poster",
        preload: "preload",
        profile: "profile",
        radiogroup: "radioGroup",
        readonly: "readOnly",
        referrerpolicy: "referrerPolicy",
        rel: "rel",
        required: "required",
        reversed: "reversed",
        role: "role",
        rows: "rows",
        rowspan: "rowSpan",
        sandbox: "sandbox",
        scope: "scope",
        scoped: "scoped",
        scrolling: "scrolling",
        seamless: "seamless",
        selected: "selected",
        shape: "shape",
        size: "size",
        sizes: "sizes",
        span: "span",
        spellcheck: "spellCheck",
        src: "src",
        srcdoc: "srcDoc",
        srclang: "srcLang",
        srcset: "srcSet",
        start: "start",
        step: "step",
        style: "style",
        summary: "summary",
        tabindex: "tabIndex",
        target: "target",
        title: "title",
        type: "type",
        usemap: "useMap",
        value: "value",
        width: "width",
        wmode: "wmode",
        wrap: "wrap",
        // SVG
        about: "about",
        accentheight: "accentHeight",
        "accent-height": "accentHeight",
        accumulate: "accumulate",
        additive: "additive",
        alignmentbaseline: "alignmentBaseline",
        "alignment-baseline": "alignmentBaseline",
        allowreorder: "allowReorder",
        alphabetic: "alphabetic",
        amplitude: "amplitude",
        arabicform: "arabicForm",
        "arabic-form": "arabicForm",
        ascent: "ascent",
        attributename: "attributeName",
        attributetype: "attributeType",
        autoreverse: "autoReverse",
        azimuth: "azimuth",
        basefrequency: "baseFrequency",
        baselineshift: "baselineShift",
        "baseline-shift": "baselineShift",
        baseprofile: "baseProfile",
        bbox: "bbox",
        begin: "begin",
        bias: "bias",
        by: "by",
        calcmode: "calcMode",
        capheight: "capHeight",
        "cap-height": "capHeight",
        clip: "clip",
        clippath: "clipPath",
        "clip-path": "clipPath",
        clippathunits: "clipPathUnits",
        cliprule: "clipRule",
        "clip-rule": "clipRule",
        color: "color",
        colorinterpolation: "colorInterpolation",
        "color-interpolation": "colorInterpolation",
        colorinterpolationfilters: "colorInterpolationFilters",
        "color-interpolation-filters": "colorInterpolationFilters",
        colorprofile: "colorProfile",
        "color-profile": "colorProfile",
        colorrendering: "colorRendering",
        "color-rendering": "colorRendering",
        contentscripttype: "contentScriptType",
        contentstyletype: "contentStyleType",
        cursor: "cursor",
        cx: "cx",
        cy: "cy",
        d: "d",
        datatype: "datatype",
        decelerate: "decelerate",
        descent: "descent",
        diffuseconstant: "diffuseConstant",
        direction: "direction",
        display: "display",
        divisor: "divisor",
        dominantbaseline: "dominantBaseline",
        "dominant-baseline": "dominantBaseline",
        dur: "dur",
        dx: "dx",
        dy: "dy",
        edgemode: "edgeMode",
        elevation: "elevation",
        enablebackground: "enableBackground",
        "enable-background": "enableBackground",
        end: "end",
        exponent: "exponent",
        externalresourcesrequired: "externalResourcesRequired",
        fill: "fill",
        fillopacity: "fillOpacity",
        "fill-opacity": "fillOpacity",
        fillrule: "fillRule",
        "fill-rule": "fillRule",
        filter: "filter",
        filterres: "filterRes",
        filterunits: "filterUnits",
        floodopacity: "floodOpacity",
        "flood-opacity": "floodOpacity",
        floodcolor: "floodColor",
        "flood-color": "floodColor",
        focusable: "focusable",
        fontfamily: "fontFamily",
        "font-family": "fontFamily",
        fontsize: "fontSize",
        "font-size": "fontSize",
        fontsizeadjust: "fontSizeAdjust",
        "font-size-adjust": "fontSizeAdjust",
        fontstretch: "fontStretch",
        "font-stretch": "fontStretch",
        fontstyle: "fontStyle",
        "font-style": "fontStyle",
        fontvariant: "fontVariant",
        "font-variant": "fontVariant",
        fontweight: "fontWeight",
        "font-weight": "fontWeight",
        format: "format",
        from: "from",
        fx: "fx",
        fy: "fy",
        g1: "g1",
        g2: "g2",
        glyphname: "glyphName",
        "glyph-name": "glyphName",
        glyphorientationhorizontal: "glyphOrientationHorizontal",
        "glyph-orientation-horizontal": "glyphOrientationHorizontal",
        glyphorientationvertical: "glyphOrientationVertical",
        "glyph-orientation-vertical": "glyphOrientationVertical",
        glyphref: "glyphRef",
        gradienttransform: "gradientTransform",
        gradientunits: "gradientUnits",
        hanging: "hanging",
        horizadvx: "horizAdvX",
        "horiz-adv-x": "horizAdvX",
        horizoriginx: "horizOriginX",
        "horiz-origin-x": "horizOriginX",
        ideographic: "ideographic",
        imagerendering: "imageRendering",
        "image-rendering": "imageRendering",
        in2: "in2",
        in: "in",
        inlist: "inlist",
        intercept: "intercept",
        k1: "k1",
        k2: "k2",
        k3: "k3",
        k4: "k4",
        k: "k",
        kernelmatrix: "kernelMatrix",
        kernelunitlength: "kernelUnitLength",
        kerning: "kerning",
        keypoints: "keyPoints",
        keysplines: "keySplines",
        keytimes: "keyTimes",
        lengthadjust: "lengthAdjust",
        letterspacing: "letterSpacing",
        "letter-spacing": "letterSpacing",
        lightingcolor: "lightingColor",
        "lighting-color": "lightingColor",
        limitingconeangle: "limitingConeAngle",
        local: "local",
        markerend: "markerEnd",
        "marker-end": "markerEnd",
        markerheight: "markerHeight",
        markermid: "markerMid",
        "marker-mid": "markerMid",
        markerstart: "markerStart",
        "marker-start": "markerStart",
        markerunits: "markerUnits",
        markerwidth: "markerWidth",
        mask: "mask",
        maskcontentunits: "maskContentUnits",
        maskunits: "maskUnits",
        mathematical: "mathematical",
        mode: "mode",
        numoctaves: "numOctaves",
        offset: "offset",
        opacity: "opacity",
        operator: "operator",
        order: "order",
        orient: "orient",
        orientation: "orientation",
        origin: "origin",
        overflow: "overflow",
        overlineposition: "overlinePosition",
        "overline-position": "overlinePosition",
        overlinethickness: "overlineThickness",
        "overline-thickness": "overlineThickness",
        paintorder: "paintOrder",
        "paint-order": "paintOrder",
        panose1: "panose1",
        "panose-1": "panose1",
        pathlength: "pathLength",
        patterncontentunits: "patternContentUnits",
        patterntransform: "patternTransform",
        patternunits: "patternUnits",
        pointerevents: "pointerEvents",
        "pointer-events": "pointerEvents",
        points: "points",
        pointsatx: "pointsAtX",
        pointsaty: "pointsAtY",
        pointsatz: "pointsAtZ",
        prefix: "prefix",
        preservealpha: "preserveAlpha",
        preserveaspectratio: "preserveAspectRatio",
        primitiveunits: "primitiveUnits",
        property: "property",
        r: "r",
        radius: "radius",
        refx: "refX",
        refy: "refY",
        renderingintent: "renderingIntent",
        "rendering-intent": "renderingIntent",
        repeatcount: "repeatCount",
        repeatdur: "repeatDur",
        requiredextensions: "requiredExtensions",
        requiredfeatures: "requiredFeatures",
        resource: "resource",
        restart: "restart",
        result: "result",
        results: "results",
        rotate: "rotate",
        rx: "rx",
        ry: "ry",
        scale: "scale",
        security: "security",
        seed: "seed",
        shaperendering: "shapeRendering",
        "shape-rendering": "shapeRendering",
        slope: "slope",
        spacing: "spacing",
        specularconstant: "specularConstant",
        specularexponent: "specularExponent",
        speed: "speed",
        spreadmethod: "spreadMethod",
        startoffset: "startOffset",
        stddeviation: "stdDeviation",
        stemh: "stemh",
        stemv: "stemv",
        stitchtiles: "stitchTiles",
        stopcolor: "stopColor",
        "stop-color": "stopColor",
        stopopacity: "stopOpacity",
        "stop-opacity": "stopOpacity",
        strikethroughposition: "strikethroughPosition",
        "strikethrough-position": "strikethroughPosition",
        strikethroughthickness: "strikethroughThickness",
        "strikethrough-thickness": "strikethroughThickness",
        string: "string",
        stroke: "stroke",
        strokedasharray: "strokeDasharray",
        "stroke-dasharray": "strokeDasharray",
        strokedashoffset: "strokeDashoffset",
        "stroke-dashoffset": "strokeDashoffset",
        strokelinecap: "strokeLinecap",
        "stroke-linecap": "strokeLinecap",
        strokelinejoin: "strokeLinejoin",
        "stroke-linejoin": "strokeLinejoin",
        strokemiterlimit: "strokeMiterlimit",
        "stroke-miterlimit": "strokeMiterlimit",
        strokewidth: "strokeWidth",
        "stroke-width": "strokeWidth",
        strokeopacity: "strokeOpacity",
        "stroke-opacity": "strokeOpacity",
        suppresscontenteditablewarning: "suppressContentEditableWarning",
        suppresshydrationwarning: "suppressHydrationWarning",
        surfacescale: "surfaceScale",
        systemlanguage: "systemLanguage",
        tablevalues: "tableValues",
        targetx: "targetX",
        targety: "targetY",
        textanchor: "textAnchor",
        "text-anchor": "textAnchor",
        textdecoration: "textDecoration",
        "text-decoration": "textDecoration",
        textlength: "textLength",
        textrendering: "textRendering",
        "text-rendering": "textRendering",
        to: "to",
        transform: "transform",
        typeof: "typeof",
        u1: "u1",
        u2: "u2",
        underlineposition: "underlinePosition",
        "underline-position": "underlinePosition",
        underlinethickness: "underlineThickness",
        "underline-thickness": "underlineThickness",
        unicode: "unicode",
        unicodebidi: "unicodeBidi",
        "unicode-bidi": "unicodeBidi",
        unicoderange: "unicodeRange",
        "unicode-range": "unicodeRange",
        unitsperem: "unitsPerEm",
        "units-per-em": "unitsPerEm",
        unselectable: "unselectable",
        valphabetic: "vAlphabetic",
        "v-alphabetic": "vAlphabetic",
        values: "values",
        vectoreffect: "vectorEffect",
        "vector-effect": "vectorEffect",
        version: "version",
        vertadvy: "vertAdvY",
        "vert-adv-y": "vertAdvY",
        vertoriginx: "vertOriginX",
        "vert-origin-x": "vertOriginX",
        vertoriginy: "vertOriginY",
        "vert-origin-y": "vertOriginY",
        vhanging: "vHanging",
        "v-hanging": "vHanging",
        videographic: "vIdeographic",
        "v-ideographic": "vIdeographic",
        viewbox: "viewBox",
        viewtarget: "viewTarget",
        visibility: "visibility",
        vmathematical: "vMathematical",
        "v-mathematical": "vMathematical",
        vocab: "vocab",
        widths: "widths",
        wordspacing: "wordSpacing",
        "word-spacing": "wordSpacing",
        writingmode: "writingMode",
        "writing-mode": "writingMode",
        x1: "x1",
        x2: "x2",
        x: "x",
        xchannelselector: "xChannelSelector",
        xheight: "xHeight",
        "x-height": "xHeight",
        xlinkactuate: "xlinkActuate",
        "xlink:actuate": "xlinkActuate",
        xlinkarcrole: "xlinkArcrole",
        "xlink:arcrole": "xlinkArcrole",
        xlinkhref: "xlinkHref",
        "xlink:href": "xlinkHref",
        xlinkrole: "xlinkRole",
        "xlink:role": "xlinkRole",
        xlinkshow: "xlinkShow",
        "xlink:show": "xlinkShow",
        xlinktitle: "xlinkTitle",
        "xlink:title": "xlinkTitle",
        xlinktype: "xlinkType",
        "xlink:type": "xlinkType",
        xmlbase: "xmlBase",
        "xml:base": "xmlBase",
        xmllang: "xmlLang",
        "xml:lang": "xmlLang",
        xmlns: "xmlns",
        "xml:space": "xmlSpace",
        xmlnsxlink: "xmlnsXlink",
        "xmlns:xlink": "xmlnsXlink",
        xmlspace: "xmlSpace",
        y1: "y1",
        y2: "y2",
        y: "y",
        ychannelselector: "yChannelSelector",
        z: "z",
        zoomandpan: "zoomAndPan"
      },
      Td = {
        "aria-current": 0,
        // state
        "aria-description": 0,
        "aria-details": 0,
        "aria-disabled": 0,
        // state
        "aria-hidden": 0,
        // state
        "aria-invalid": 0,
        // state
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        // Widget Attributes
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        // Live Region Attributes
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        // Drag-and-Drop Attributes
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        // Relationship Attributes
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0
      },
      Rl = {},
      kw = new RegExp("^(aria)-[" + We + "]*$"),
      Dl = new RegExp("^(aria)[A-Z][" + We + "]*$");
    function gh(n, a) {
      {
        if (ye.call(Rl, a) && Rl[a]) return !0;
        if (Dl.test(a)) {
          var f = "aria-" + a.slice(4).toLowerCase(),
            m = Td.hasOwnProperty(f) ? f : null;
          if (m == null) return h("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", a), Rl[a] = !0, !0;
          if (a !== m) return h("Invalid ARIA attribute `%s`. Did you mean `%s`?", a, m), Rl[a] = !0, !0;
        }
        if (kw.test(a)) {
          var b = a.toLowerCase(),
            T = Td.hasOwnProperty(b) ? b : null;
          if (T == null) return Rl[a] = !0, !1;
          if (a !== T) return h("Unknown ARIA attribute `%s`. Did you mean `%s`?", a, T), Rl[a] = !0, !0;
        }
      }
      return !0;
    }
    function Uu(n, a) {
      {
        var f = [];
        for (var m in a) {
          var b = gh(n, m);
          b || f.push(m);
        }
        var T = f.map(function (M) {
          return "`" + M + "`";
        }).join(", ");
        f.length === 1 ? h("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", T, n) : f.length > 1 && h("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", T, n);
      }
    }
    function yh(n, a) {
      Fo(n, a) || Uu(n, a);
    }
    var bh = !1;
    function Rd(n, a) {
      {
        if (n !== "input" && n !== "textarea" && n !== "select") return;
        a != null && a.value === null && !bh && (bh = !0, n === "select" && a.multiple ? h("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", n) : h("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", n));
      }
    }
    var Ls = function () {};
    {
      var _r = {},
        wh = /^on./,
        Dd = /^on[^A-Z]/,
        Cg = new RegExp("^(aria)-[" + We + "]*$"),
        kg = new RegExp("^(aria)[A-Z][" + We + "]*$");
      Ls = function (n, a, f, m) {
        if (ye.call(_r, a) && _r[a]) return !0;
        var b = a.toLowerCase();
        if (b === "onfocusin" || b === "onfocusout") return h("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), _r[a] = !0, !0;
        if (m != null) {
          var T = m.registrationNameDependencies,
            M = m.possibleRegistrationNames;
          if (T.hasOwnProperty(a)) return !0;
          var z = M.hasOwnProperty(b) ? M[b] : null;
          if (z != null) return h("Invalid event handler property `%s`. Did you mean `%s`?", a, z), _r[a] = !0, !0;
          if (wh.test(a)) return h("Unknown event handler property `%s`. It will be ignored.", a), _r[a] = !0, !0;
        } else if (wh.test(a)) return Dd.test(a) && h("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", a), _r[a] = !0, !0;
        if (Cg.test(a) || kg.test(a)) return !0;
        if (b === "innerhtml") return h("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), _r[a] = !0, !0;
        if (b === "aria") return h("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), _r[a] = !0, !0;
        if (b === "is" && f !== null && f !== void 0 && typeof f != "string") return h("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof f), _r[a] = !0, !0;
        if (typeof f == "number" && isNaN(f)) return h("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", a), _r[a] = !0, !0;
        var U = Ht(a),
          X = U !== null && U.type === Kt;
        if (Bu.hasOwnProperty(b)) {
          var J = Bu[b];
          if (J !== a) return h("Invalid DOM property `%s`. Did you mean `%s`?", a, J), _r[a] = !0, !0;
        } else if (!X && a !== b) return h("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", a, b), _r[a] = !0, !0;
        return typeof f == "boolean" && kt(a, f, U, !1) ? (f ? h('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', f, a, a, f, a) : h('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', f, a, a, f, a, a, a), _r[a] = !0, !0) : X ? !0 : kt(a, f, U, !1) ? (_r[a] = !0, !1) : ((f === "false" || f === "true") && U !== null && U.type === Et && (h("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", f, a, f === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', a, f), _r[a] = !0), !0);
      };
    }
    var Tg = function (n, a, f) {
      {
        var m = [];
        for (var b in a) {
          var T = Ls(n, b, a[b], f);
          T || m.push(b);
        }
        var M = m.map(function (z) {
          return "`" + z + "`";
        }).join(", ");
        m.length === 1 ? h("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", M, n) : m.length > 1 && h("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", M, n);
      }
    };
    function Rg(n, a, f) {
      Fo(n, a) || Tg(n, a, f);
    }
    var _h = 1,
      Id = 2,
      wi = 4,
      xh = _h | Id | wi,
      Ps = null;
    function Tw(n) {
      Ps !== null && h("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), Ps = n;
    }
    function Rw() {
      Ps === null && h("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), Ps = null;
    }
    function Hu(n) {
      return n === Ps;
    }
    function Sh(n) {
      var a = n.target || n.srcElement || window;
      return a.correspondingUseElement && (a = a.correspondingUseElement), a.nodeType === Xa ? a.parentNode : a;
    }
    var Md = null,
      As = null,
      mn = null;
    function Od(n) {
      var a = Ef(n);
      if (a) {
        if (typeof Md != "function") throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var f = a.stateNode;
        if (f) {
          var m = vS(f);
          Md(a.stateNode, a.type, m);
        }
      }
    }
    function Ld(n) {
      Md = n;
    }
    function Il(n) {
      As ? mn ? mn.push(n) : mn = [n] : As = n;
    }
    function Dg() {
      return As !== null || mn !== null;
    }
    function Pd() {
      if (As) {
        var n = As,
          a = mn;
        if (As = null, mn = null, Od(n), a) for (var f = 0; f < a.length; f++) Od(a[f]);
      }
    }
    var Ml = function (n, a) {
        return n(a);
      },
      $u = function () {},
      No = !1;
    function Ig() {
      var n = Dg();
      n && ($u(), Pd());
    }
    function Mg(n, a, f) {
      if (No) return n(a, f);
      No = !0;
      try {
        return Ml(n, a, f);
      } finally {
        No = !1, Ig();
      }
    }
    function Dw(n, a, f) {
      Ml = n, $u = f;
    }
    function Og(n) {
      return n === "button" || n === "input" || n === "select" || n === "textarea";
    }
    function Ad(n, a, f) {
      switch (n) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(f.disabled && Og(a));
        default:
          return !1;
      }
    }
    function zo(n, a) {
      var f = n.stateNode;
      if (f === null) return null;
      var m = vS(f);
      if (m === null) return null;
      var b = m[a];
      if (Ad(a, n.type, m)) return null;
      if (b && typeof b != "function") throw new Error("Expected `" + a + "` listener to be a function, instead got a value of `" + typeof b + "` type.");
      return b;
    }
    var Wu = !1;
    if (Xe) try {
      var js = {};
      Object.defineProperty(js, "passive", {
        get: function () {
          Wu = !0;
        }
      }), window.addEventListener("test", js, js), window.removeEventListener("test", js, js);
    } catch {
      Wu = !1;
    }
    function jd(n, a, f, m, b, T, M, z, U) {
      var X = Array.prototype.slice.call(arguments, 3);
      try {
        a.apply(f, X);
      } catch (J) {
        this.onError(J);
      }
    }
    var Fd = jd;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var Eh = document.createElement("react");
      Fd = function (a, f, m, b, T, M, z, U, X) {
        if (typeof document > "u" || document === null) throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var J = document.createEvent("Event"),
          me = !1,
          Se = !0,
          Me = window.event,
          Pe = Object.getOwnPropertyDescriptor(window, "event");
        function $e() {
          Eh.removeEventListener(Fe, Re, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = Me);
        }
        var mt = Array.prototype.slice.call(arguments, 3);
        function Re() {
          me = !0, $e(), f.apply(m, mt), Se = !1;
        }
        var Ue,
          Be = !1,
          nt = !1;
        function ke(Ie) {
          if (Ue = Ie.error, Be = !0, Ue === null && Ie.colno === 0 && Ie.lineno === 0 && (nt = !0), Ie.defaultPrevented && Ue != null && typeof Ue == "object") try {
            Ue._suppressLogging = !0;
          } catch {}
        }
        var Fe = "react-" + (a || "invokeguardedcallback");
        if (window.addEventListener("error", ke), Eh.addEventListener(Fe, Re, !1), J.initEvent(Fe, !1, !1), Eh.dispatchEvent(J), Pe && Object.defineProperty(window, "event", Pe), me && Se && (Be ? nt && (Ue = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : Ue = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(Ue)), window.removeEventListener("error", ke), !me) return $e(), jd.apply(this, arguments);
      };
    }
    var Lg = Fd,
      Ol = !1,
      Nd = null,
      Ll = !1,
      ha = null,
      Pg = {
        onError: function (n) {
          Ol = !0, Nd = n;
        }
      };
    function Vo(n, a, f, m, b, T, M, z, U) {
      Ol = !1, Nd = null, Lg.apply(Pg, arguments);
    }
    function ma(n, a, f, m, b, T, M, z, U) {
      if (Vo.apply(this, arguments), Ol) {
        var X = Yu();
        Ll || (Ll = !0, ha = X);
      }
    }
    function qu() {
      if (Ll) {
        var n = ha;
        throw Ll = !1, ha = null, n;
      }
    }
    function Qa() {
      return Ol;
    }
    function Yu() {
      if (Ol) {
        var n = Nd;
        return Ol = !1, Nd = null, n;
      } else throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function Pl(n) {
      return n._reactInternals;
    }
    function Iw(n) {
      return n._reactInternals !== void 0;
    }
    function Fs(n, a) {
      n._reactInternals = a;
    }
    var pt = /*                      */
      0,
      Xi = /*                */
      1,
      Gn = /*                    */
      2,
      tn = /*                       */
      4,
      _i = /*                */
      16,
      Ki = /*                 */
      32,
      Sn = /*                     */
      64,
      ft = /*                   */
      128,
      qr = /*            */
      256,
      Hn = /*                          */
      512,
      or = /*                     */
      1024,
      Yr = /*                      */
      2048,
      xi = /*                    */
      4096,
      tr = /*                   */
      8192,
      Al = /*             */
      16384,
      Ag = /*               */
      32767,
      Gu = /*                   */
      32768,
      Gr = /*                */
      65536,
      zd = /* */
      131072,
      va = /*                       */
      1048576,
      jl = /*                    */
      2097152,
      Za = /*                 */
      4194304,
      Vd = /*                */
      8388608,
      Bo = /*               */
      16777216,
      ga = /*              */
      33554432,
      Uo =
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      tn | or | 0,
      Ho = Gn | tn | _i | Ki | Hn | xi | tr,
      $o = tn | Sn | Hn | tr,
      Ja = Yr | _i,
      nr = Za | Vd | jl,
      Si = i.ReactCurrentOwner;
    function si(n) {
      var a = n,
        f = n;
      if (n.alternate) for (; a.return;) a = a.return;else {
        var m = a;
        do a = m, (a.flags & (Gn | xi)) !== pt && (f = a.return), m = a.return; while (m);
      }
      return a.tag === C ? f : null;
    }
    function ya(n) {
      if (n.tag === V) {
        var a = n.memoizedState;
        if (a === null) {
          var f = n.alternate;
          f !== null && (a = f.memoizedState);
        }
        if (a !== null) return a.dehydrated;
      }
      return null;
    }
    function ba(n) {
      return n.tag === C ? n.stateNode.containerInfo : null;
    }
    function Ns(n) {
      return si(n) === n;
    }
    function jg(n) {
      {
        var a = Si.current;
        if (a !== null && a.tag === x) {
          var f = a,
            m = f.stateNode;
          m._warnedAboutRefsInRender || h("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", At(f) || "A component"), m._warnedAboutRefsInRender = !0;
        }
      }
      var b = Pl(n);
      return b ? si(b) === b : !1;
    }
    function Bd(n) {
      if (si(n) !== n) throw new Error("Unable to find node on an unmounted component.");
    }
    function Ud(n) {
      var a = n.alternate;
      if (!a) {
        var f = si(n);
        if (f === null) throw new Error("Unable to find node on an unmounted component.");
        return f !== n ? null : n;
      }
      for (var m = n, b = a;;) {
        var T = m.return;
        if (T === null) break;
        var M = T.alternate;
        if (M === null) {
          var z = T.return;
          if (z !== null) {
            m = b = z;
            continue;
          }
          break;
        }
        if (T.child === M.child) {
          for (var U = T.child; U;) {
            if (U === m) return Bd(T), n;
            if (U === b) return Bd(T), a;
            U = U.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (m.return !== b.return) m = T, b = M;else {
          for (var X = !1, J = T.child; J;) {
            if (J === m) {
              X = !0, m = T, b = M;
              break;
            }
            if (J === b) {
              X = !0, b = T, m = M;
              break;
            }
            J = J.sibling;
          }
          if (!X) {
            for (J = M.child; J;) {
              if (J === m) {
                X = !0, m = M, b = T;
                break;
              }
              if (J === b) {
                X = !0, b = M, m = T;
                break;
              }
              J = J.sibling;
            }
            if (!X) throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (m.alternate !== b) throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (m.tag !== C) throw new Error("Unable to find node on an unmounted component.");
      return m.stateNode.current === m ? n : a;
    }
    function Xr(n) {
      var a = Ud(n);
      return a !== null ? Kr(a) : null;
    }
    function Kr(n) {
      if (n.tag === D || n.tag === I) return n;
      for (var a = n.child; a !== null;) {
        var f = Kr(a);
        if (f !== null) return f;
        a = a.sibling;
      }
      return null;
    }
    function In(n) {
      var a = Ud(n);
      return a !== null ? Ei(a) : null;
    }
    function Ei(n) {
      if (n.tag === D || n.tag === I) return n;
      for (var a = n.child; a !== null;) {
        if (a.tag !== k) {
          var f = Ei(a);
          if (f !== null) return f;
        }
        a = a.sibling;
      }
      return null;
    }
    var Ch = e.unstable_scheduleCallback,
      Fg = e.unstable_cancelCallback,
      kh = e.unstable_shouldYield,
      Th = e.unstable_requestPaint,
      sr = e.unstable_now,
      Hd = e.unstable_getCurrentPriorityLevel,
      Xu = e.unstable_ImmediatePriority,
      Wo = e.unstable_UserBlockingPriority,
      eo = e.unstable_NormalPriority,
      Mw = e.unstable_LowPriority,
      li = e.unstable_IdlePriority,
      $d = e.unstable_yieldValue,
      Wd = e.unstable_setDisableYieldValue,
      Qi = null,
      dr = null,
      Ge = null,
      Ci = !1,
      ui = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function Fl(n) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u") return !1;
      var a = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (a.isDisabled) return !0;
      if (!a.supportsFiber) return h("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        Ce && (n = Qt({}, n, {
          getLaneLabelMap: Dh,
          injectProfilingHooks: qo
        })), Qi = a.inject(n), dr = a;
      } catch (f) {
        h("React instrumentation encountered an error: %s.", f);
      }
      return !!a.checkDCE;
    }
    function ki(n, a) {
      if (dr && typeof dr.onScheduleFiberRoot == "function") try {
        dr.onScheduleFiberRoot(Qi, n, a);
      } catch (f) {
        Ci || (Ci = !0, h("React instrumentation encountered an error: %s", f));
      }
    }
    function zs(n, a) {
      if (dr && typeof dr.onCommitFiberRoot == "function") try {
        var f = (n.current.flags & ft) === ft;
        if (Ee) {
          var m;
          switch (a) {
            case Ii:
              m = Xu;
              break;
            case Zi:
              m = Wo;
              break;
            case os:
              m = eo;
              break;
            case ss:
              m = li;
              break;
            default:
              m = eo;
              break;
          }
          dr.onCommitFiberRoot(Qi, n, m, f);
        }
      } catch (b) {
        Ci || (Ci = !0, h("React instrumentation encountered an error: %s", b));
      }
    }
    function Rh(n) {
      if (dr && typeof dr.onPostCommitFiberRoot == "function") try {
        dr.onPostCommitFiberRoot(Qi, n);
      } catch (a) {
        Ci || (Ci = !0, h("React instrumentation encountered an error: %s", a));
      }
    }
    function Ng(n) {
      if (dr && typeof dr.onCommitFiberUnmount == "function") try {
        dr.onCommitFiberUnmount(Qi, n);
      } catch (a) {
        Ci || (Ci = !0, h("React instrumentation encountered an error: %s", a));
      }
    }
    function En(n) {
      if (typeof $d == "function" && (Wd(n), c(n)), dr && typeof dr.setStrictMode == "function") try {
        dr.setStrictMode(Qi, n);
      } catch (a) {
        Ci || (Ci = !0, h("React instrumentation encountered an error: %s", a));
      }
    }
    function qo(n) {
      Ge = n;
    }
    function Dh() {
      {
        for (var n = /* @__PURE__ */new Map(), a = 1, f = 0; f < zl; f++) {
          var m = Yg(a);
          n.set(a, m), a *= 2;
        }
        return n;
      }
    }
    function zg(n) {
      Ge !== null && typeof Ge.markCommitStarted == "function" && Ge.markCommitStarted(n);
    }
    function wa() {
      Ge !== null && typeof Ge.markCommitStopped == "function" && Ge.markCommitStopped();
    }
    function Ti(n) {
      Ge !== null && typeof Ge.markComponentRenderStarted == "function" && Ge.markComponentRenderStarted(n);
    }
    function to() {
      Ge !== null && typeof Ge.markComponentRenderStopped == "function" && Ge.markComponentRenderStopped();
    }
    function Vg(n) {
      Ge !== null && typeof Ge.markComponentPassiveEffectMountStarted == "function" && Ge.markComponentPassiveEffectMountStarted(n);
    }
    function qd() {
      Ge !== null && typeof Ge.markComponentPassiveEffectMountStopped == "function" && Ge.markComponentPassiveEffectMountStopped();
    }
    function Bg(n) {
      Ge !== null && typeof Ge.markComponentPassiveEffectUnmountStarted == "function" && Ge.markComponentPassiveEffectUnmountStarted(n);
    }
    function Ug() {
      Ge !== null && typeof Ge.markComponentPassiveEffectUnmountStopped == "function" && Ge.markComponentPassiveEffectUnmountStopped();
    }
    function Ih(n) {
      Ge !== null && typeof Ge.markComponentLayoutEffectMountStarted == "function" && Ge.markComponentLayoutEffectMountStarted(n);
    }
    function Yd() {
      Ge !== null && typeof Ge.markComponentLayoutEffectMountStopped == "function" && Ge.markComponentLayoutEffectMountStopped();
    }
    function Mh(n) {
      Ge !== null && typeof Ge.markComponentLayoutEffectUnmountStarted == "function" && Ge.markComponentLayoutEffectUnmountStarted(n);
    }
    function Oh() {
      Ge !== null && typeof Ge.markComponentLayoutEffectUnmountStopped == "function" && Ge.markComponentLayoutEffectUnmountStopped();
    }
    function Hg(n, a, f) {
      Ge !== null && typeof Ge.markComponentErrored == "function" && Ge.markComponentErrored(n, a, f);
    }
    function Lh(n, a, f) {
      Ge !== null && typeof Ge.markComponentSuspended == "function" && Ge.markComponentSuspended(n, a, f);
    }
    function Ku(n) {
      Ge !== null && typeof Ge.markLayoutEffectsStarted == "function" && Ge.markLayoutEffectsStarted(n);
    }
    function Gd() {
      Ge !== null && typeof Ge.markLayoutEffectsStopped == "function" && Ge.markLayoutEffectsStopped();
    }
    function $g(n) {
      Ge !== null && typeof Ge.markPassiveEffectsStarted == "function" && Ge.markPassiveEffectsStarted(n);
    }
    function Wg() {
      Ge !== null && typeof Ge.markPassiveEffectsStopped == "function" && Ge.markPassiveEffectsStopped();
    }
    function Vs(n) {
      Ge !== null && typeof Ge.markRenderStarted == "function" && Ge.markRenderStarted(n);
    }
    function qg() {
      Ge !== null && typeof Ge.markRenderYielded == "function" && Ge.markRenderYielded();
    }
    function Nl() {
      Ge !== null && typeof Ge.markRenderStopped == "function" && Ge.markRenderStopped();
    }
    function _a(n) {
      Ge !== null && typeof Ge.markRenderScheduled == "function" && Ge.markRenderScheduled(n);
    }
    function Qu(n, a) {
      Ge !== null && typeof Ge.markForceUpdateScheduled == "function" && Ge.markForceUpdateScheduled(n, a);
    }
    function Bs(n, a) {
      Ge !== null && typeof Ge.markStateUpdateScheduled == "function" && Ge.markStateUpdateScheduled(n, a);
    }
    var dt = /*                         */
      0,
      Wt = /*                 */
      1,
      nn = /*                    */
      2,
      Xn = /*               */
      8,
      Ri = /*              */
      16,
      Mn = Math.clz32 ? Math.clz32 : Ah,
      Xd = Math.log,
      Ph = Math.LN2;
    function Ah(n) {
      var a = n >>> 0;
      return a === 0 ? 32 : 31 - (Xd(a) / Ph | 0) | 0;
    }
    var zl = 31,
      De = /*                        */
      0,
      On = /*                          */
      0,
      Je = /*                        */
      1,
      Ln = /*    */
      2,
      Cn = /*             */
      4,
      xa = /*            */
      8,
      Qr = /*                     */
      16,
      no = /*                */
      32,
      Vl = /*                       */
      4194240,
      rr = /*                        */
      64,
      Zu = /*                        */
      128,
      Ju = /*                        */
      256,
      ec = /*                        */
      512,
      Di = /*                        */
      1024,
      Zr = /*                        */
      2048,
      Us = /*                        */
      4096,
      tc = /*                        */
      8192,
      nc = /*                        */
      16384,
      Kd = /*                       */
      32768,
      Qd = /*                       */
      65536,
      Zd = /*                       */
      131072,
      Jd = /*                       */
      262144,
      ef = /*                       */
      524288,
      tf = /*                       */
      1048576,
      nf = /*                       */
      2097152,
      rc = /*                            */
      130023424,
      Sa = /*                             */
      4194304,
      rf = /*                             */
      8388608,
      Bl = /*                             */
      16777216,
      Ul = /*                             */
      33554432,
      af = /*                             */
      67108864,
      of = Sa,
      Hl = /*          */
      134217728,
      jh = /*                          */
      268435455,
      $l = /*               */
      268435456,
      Yo = /*                        */
      536870912,
      Jr = /*                   */
      1073741824;
    function Yg(n) {
      {
        if (n & Je) return "Sync";
        if (n & Ln) return "InputContinuousHydration";
        if (n & Cn) return "InputContinuous";
        if (n & xa) return "DefaultHydration";
        if (n & Qr) return "Default";
        if (n & no) return "TransitionHydration";
        if (n & Vl) return "Transition";
        if (n & rc) return "Retry";
        if (n & Hl) return "SelectiveHydration";
        if (n & $l) return "IdleHydration";
        if (n & Yo) return "Idle";
        if (n & Jr) return "Offscreen";
      }
    }
    var wn = -1,
      ic = rr,
      sf = Sa;
    function Wl(n) {
      switch (Go(n)) {
        case Je:
          return Je;
        case Ln:
          return Ln;
        case Cn:
          return Cn;
        case xa:
          return xa;
        case Qr:
          return Qr;
        case no:
          return no;
        case rr:
        case Zu:
        case Ju:
        case ec:
        case Di:
        case Zr:
        case Us:
        case tc:
        case nc:
        case Kd:
        case Qd:
        case Zd:
        case Jd:
        case ef:
        case tf:
        case nf:
          return n & Vl;
        case Sa:
        case rf:
        case Bl:
        case Ul:
        case af:
          return n & rc;
        case Hl:
          return Hl;
        case $l:
          return $l;
        case Yo:
          return Yo;
        case Jr:
          return Jr;
        default:
          return h("Should have found matching lanes. This is a bug in React."), n;
      }
    }
    function lf(n, a) {
      var f = n.pendingLanes;
      if (f === De) return De;
      var m = De,
        b = n.suspendedLanes,
        T = n.pingedLanes,
        M = f & jh;
      if (M !== De) {
        var z = M & ~b;
        if (z !== De) m = Wl(z);else {
          var U = M & T;
          U !== De && (m = Wl(U));
        }
      } else {
        var X = f & ~b;
        X !== De ? m = Wl(X) : T !== De && (m = Wl(T));
      }
      if (m === De) return De;
      if (a !== De && a !== m &&
      // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (a & b) === De) {
        var J = Go(m),
          me = Go(a);
        if (
        // Tests whether the next lane is equal or lower priority than the wip
        // one. This works because the bits decrease in priority as you go left.
        J >= me ||
        // Default priority updates should not interrupt transition updates. The
        // only difference between default updates and transition updates is that
        // default updates do not support refresh transitions.
        J === Qr && (me & Vl) !== De) return a;
      }
      (m & Cn) !== De && (m |= f & Qr);
      var Se = n.entangledLanes;
      if (Se !== De) for (var Me = n.entanglements, Pe = m & Se; Pe > 0;) {
        var $e = Hs(Pe),
          mt = 1 << $e;
        m |= Me[$e], Pe &= ~mt;
      }
      return m;
    }
    function Ow(n, a) {
      for (var f = n.eventTimes, m = wn; a > 0;) {
        var b = Hs(a),
          T = 1 << b,
          M = f[b];
        M > m && (m = M), a &= ~T;
      }
      return m;
    }
    function Gg(n, a) {
      switch (n) {
        case Je:
        case Ln:
        case Cn:
          return a + 250;
        case xa:
        case Qr:
        case no:
        case rr:
        case Zu:
        case Ju:
        case ec:
        case Di:
        case Zr:
        case Us:
        case tc:
        case nc:
        case Kd:
        case Qd:
        case Zd:
        case Jd:
        case ef:
        case tf:
        case nf:
          return a + 5e3;
        case Sa:
        case rf:
        case Bl:
        case Ul:
        case af:
          return wn;
        case Hl:
        case $l:
        case Yo:
        case Jr:
          return wn;
        default:
          return h("Should have found matching lanes. This is a bug in React."), wn;
      }
    }
    function Xg(n, a) {
      for (var f = n.pendingLanes, m = n.suspendedLanes, b = n.pingedLanes, T = n.expirationTimes, M = f; M > 0;) {
        var z = Hs(M),
          U = 1 << z,
          X = T[z];
        X === wn ? ((U & m) === De || (U & b) !== De) && (T[z] = Gg(U, a)) : X <= a && (n.expiredLanes |= U), M &= ~U;
      }
    }
    function Kg(n) {
      return Wl(n.pendingLanes);
    }
    function ql(n) {
      var a = n.pendingLanes & -1073741825;
      return a !== De ? a : a & Jr ? Jr : De;
    }
    function Lw(n) {
      return (n & Je) !== De;
    }
    function Fh(n) {
      return (n & jh) !== De;
    }
    function Qg(n) {
      return (n & rc) === n;
    }
    function Yl(n) {
      var a = Je | Cn | Qr;
      return (n & a) === De;
    }
    function Nh(n) {
      return (n & Vl) === n;
    }
    function Gl(n, a) {
      var f = Ln | Cn | xa | Qr;
      return (a & f) !== De;
    }
    function Pw(n, a) {
      return (a & n.expiredLanes) !== De;
    }
    function zh(n) {
      return (n & Vl) !== De;
    }
    function Vh() {
      var n = ic;
      return ic <<= 1, (ic & Vl) === De && (ic = rr), n;
    }
    function Zg() {
      var n = sf;
      return sf <<= 1, (sf & rc) === De && (sf = Sa), n;
    }
    function Go(n) {
      return n & -n;
    }
    function Xl(n) {
      return Go(n);
    }
    function Hs(n) {
      return 31 - Mn(n);
    }
    function Dr(n) {
      return Hs(n);
    }
    function _n(n, a) {
      return (n & a) !== De;
    }
    function $s(n, a) {
      return (n & a) === a;
    }
    function jt(n, a) {
      return n | a;
    }
    function ac(n, a) {
      return n & ~a;
    }
    function Bh(n, a) {
      return n & a;
    }
    function Sb(n) {
      return n;
    }
    function uf(n, a) {
      return n !== On && n < a ? n : a;
    }
    function oc(n) {
      for (var a = [], f = 0; f < zl; f++) a.push(n);
      return a;
    }
    function sc(n, a, f) {
      n.pendingLanes |= a, a !== Yo && (n.suspendedLanes = De, n.pingedLanes = De);
      var m = n.eventTimes,
        b = Dr(a);
      m[b] = f;
    }
    function Km(n, a) {
      n.suspendedLanes |= a, n.pingedLanes &= ~a;
      for (var f = n.expirationTimes, m = a; m > 0;) {
        var b = Hs(m),
          T = 1 << b;
        f[b] = wn, m &= ~T;
      }
    }
    function Qm(n, a, f) {
      n.pingedLanes |= n.suspendedLanes & a;
    }
    function cf(n, a) {
      var f = n.pendingLanes & ~a;
      n.pendingLanes = a, n.suspendedLanes = De, n.pingedLanes = De, n.expiredLanes &= a, n.mutableReadLanes &= a, n.entangledLanes &= a;
      for (var m = n.entanglements, b = n.eventTimes, T = n.expirationTimes, M = f; M > 0;) {
        var z = Hs(M),
          U = 1 << z;
        m[z] = De, b[z] = wn, T[z] = wn, M &= ~U;
      }
    }
    function df(n, a) {
      for (var f = n.entangledLanes |= a, m = n.entanglements, b = f; b;) {
        var T = Hs(b),
          M = 1 << T;
        // Is this one of the newly entangled lanes?
        M & a |
        // Is this lane transitively entangled with the newly entangled lanes?
        m[T] & a && (m[T] |= a), b &= ~M;
      }
    }
    function Zm(n, a) {
      var f = Go(a),
        m;
      switch (f) {
        case Cn:
          m = Ln;
          break;
        case Qr:
          m = xa;
          break;
        case rr:
        case Zu:
        case Ju:
        case ec:
        case Di:
        case Zr:
        case Us:
        case tc:
        case nc:
        case Kd:
        case Qd:
        case Zd:
        case Jd:
        case ef:
        case tf:
        case nf:
        case Sa:
        case rf:
        case Bl:
        case Ul:
        case af:
          m = no;
          break;
        case Yo:
          m = $l;
          break;
        default:
          m = On;
          break;
      }
      return (m & (n.suspendedLanes | a)) !== On ? On : m;
    }
    function ff(n, a, f) {
      if (ui) for (var m = n.pendingUpdatersLaneMap; f > 0;) {
        var b = Dr(f),
          T = 1 << b,
          M = m[b];
        M.add(a), f &= ~T;
      }
    }
    function lc(n, a) {
      if (ui) for (var f = n.pendingUpdatersLaneMap, m = n.memoizedUpdaters; a > 0;) {
        var b = Dr(a),
          T = 1 << b,
          M = f[b];
        M.size > 0 && (M.forEach(function (z) {
          var U = z.alternate;
          (U === null || !m.has(U)) && m.add(z);
        }), M.clear()), a &= ~T;
      }
    }
    function as(n, a) {
      return null;
    }
    var Ii = Je,
      Zi = Cn,
      os = Qr,
      ss = Yo,
      Ir = On;
    function zr() {
      return Ir;
    }
    function la(n) {
      Ir = n;
    }
    function Uh(n, a) {
      var f = Ir;
      try {
        return Ir = n, a();
      } finally {
        Ir = f;
      }
    }
    function Jg(n, a) {
      return n !== 0 && n < a ? n : a;
    }
    function Hh(n, a) {
      return n > a ? n : a;
    }
    function ul(n, a) {
      return n !== 0 && n < a;
    }
    function fr(n) {
      var a = Go(n);
      return ul(Ii, a) ? ul(Zi, a) ? Fh(a) ? os : ss : Zi : Ii;
    }
    function $h(n) {
      var a = n.current.memoizedState;
      return a.isDehydrated;
    }
    var Eb;
    function pf(n) {
      Eb = n;
    }
    function xr(n) {
      Eb(n);
    }
    var ey;
    function tt(n) {
      ey = n;
    }
    var cl;
    function Wh(n) {
      cl = n;
    }
    var Jm;
    function Cb(n) {
      Jm = n;
    }
    var du;
    function uc(n) {
      du = n;
    }
    var fu = !1,
      Ws = [],
      ro = null,
      io = null,
      wo = null,
      qs = /* @__PURE__ */new Map(),
      Nn = /* @__PURE__ */new Map(),
      Vr = [],
      Xo = ["mousedown", "mouseup", "touchcancel", "touchend", "touchstart", "auxclick", "dblclick", "pointercancel", "pointerdown", "pointerup", "dragend", "dragstart", "drop", "compositionend", "compositionstart", "keydown", "keypress", "keyup", "input", "textInput",
      // Intentionally camelCase
      "copy", "cut", "paste", "click", "change", "contextmenu", "reset", "submit"];
    function ty(n) {
      return Xo.indexOf(n) > -1;
    }
    function ev(n, a, f, m, b) {
      return {
        blockedOn: n,
        domEventName: a,
        eventSystemFlags: f,
        nativeEvent: b,
        targetContainers: [m]
      };
    }
    function ri(n, a) {
      switch (n) {
        case "focusin":
        case "focusout":
          ro = null;
          break;
        case "dragenter":
        case "dragleave":
          io = null;
          break;
        case "mouseover":
        case "mouseout":
          wo = null;
          break;
        case "pointerover":
        case "pointerout":
          {
            var f = a.pointerId;
            qs.delete(f);
            break;
          }
        case "gotpointercapture":
        case "lostpointercapture":
          {
            var m = a.pointerId;
            Nn.delete(m);
            break;
          }
      }
    }
    function hf(n, a, f, m, b, T) {
      if (n === null || n.nativeEvent !== T) {
        var M = ev(a, f, m, b, T);
        if (a !== null) {
          var z = Ef(a);
          z !== null && ey(z);
        }
        return M;
      }
      n.eventSystemFlags |= m;
      var U = n.targetContainers;
      return b !== null && U.indexOf(b) === -1 && U.push(b), n;
    }
    function ua(n, a, f, m, b) {
      switch (a) {
        case "focusin":
          {
            var T = b;
            return ro = hf(ro, n, a, f, m, T), !0;
          }
        case "dragenter":
          {
            var M = b;
            return io = hf(io, n, a, f, m, M), !0;
          }
        case "mouseover":
          {
            var z = b;
            return wo = hf(wo, n, a, f, m, z), !0;
          }
        case "pointerover":
          {
            var U = b,
              X = U.pointerId;
            return qs.set(X, hf(qs.get(X) || null, n, a, f, m, U)), !0;
          }
        case "gotpointercapture":
          {
            var J = b,
              me = J.pointerId;
            return Nn.set(me, hf(Nn.get(me) || null, n, a, f, m, J)), !0;
          }
      }
      return !1;
    }
    function kb(n) {
      var a = zc(n.target);
      if (a !== null) {
        var f = si(a);
        if (f !== null) {
          var m = f.tag;
          if (m === V) {
            var b = ya(f);
            if (b !== null) {
              n.blockedOn = b, du(n.priority, function () {
                cl(f);
              });
              return;
            }
          } else if (m === C) {
            var T = f.stateNode;
            if ($h(T)) {
              n.blockedOn = ba(f);
              return;
            }
          }
        }
      }
      n.blockedOn = null;
    }
    function cp(n) {
      for (var a = Jm(), f = {
          blockedOn: null,
          target: n,
          priority: a
        }, m = 0; m < Vr.length && ul(a, Vr[m].priority); m++);
      Vr.splice(m, 0, f), m === 0 && kb(f);
    }
    function mf(n) {
      if (n.blockedOn !== null) return !1;
      for (var a = n.targetContainers; a.length > 0;) {
        var f = a[0],
          m = xo(n.domEventName, n.eventSystemFlags, f, n.nativeEvent);
        if (m === null) {
          var b = n.nativeEvent,
            T = new b.constructor(b.type, b);
          Tw(T), b.target.dispatchEvent(T), Rw();
        } else {
          var M = Ef(m);
          return M !== null && ey(M), n.blockedOn = m, !1;
        }
        a.shift();
      }
      return !0;
    }
    function tv(n, a, f) {
      mf(n) && f.delete(a);
    }
    function vf() {
      fu = !1, ro !== null && mf(ro) && (ro = null), io !== null && mf(io) && (io = null), wo !== null && mf(wo) && (wo = null), qs.forEach(tv), Nn.forEach(tv);
    }
    function cc(n, a) {
      n.blockedOn === a && (n.blockedOn = null, fu || (fu = !0, e.unstable_scheduleCallback(e.unstable_NormalPriority, vf)));
    }
    function _o(n) {
      if (Ws.length > 0) {
        cc(Ws[0], n);
        for (var a = 1; a < Ws.length; a++) {
          var f = Ws[a];
          f.blockedOn === n && (f.blockedOn = null);
        }
      }
      ro !== null && cc(ro, n), io !== null && cc(io, n), wo !== null && cc(wo, n);
      var m = function (z) {
        return cc(z, n);
      };
      qs.forEach(m), Nn.forEach(m);
      for (var b = 0; b < Vr.length; b++) {
        var T = Vr[b];
        T.blockedOn === n && (T.blockedOn = null);
      }
      for (; Vr.length > 0;) {
        var M = Vr[0];
        if (M.blockedOn !== null) break;
        kb(M), M.blockedOn === null && Vr.shift();
      }
    }
    var dl = i.ReactCurrentBatchConfig,
      ii = !0;
    function on(n) {
      ii = !!n;
    }
    function pr() {
      return ii;
    }
    function ir(n, a, f) {
      var m = Lc(a),
        b;
      switch (m) {
        case Ii:
          b = Sr;
          break;
        case Zi:
          b = ei;
          break;
        case os:
        default:
          b = Ys;
          break;
      }
      return b.bind(null, a, f, n);
    }
    function Sr(n, a, f, m) {
      var b = zr(),
        T = dl.transition;
      dl.transition = null;
      try {
        la(Ii), Ys(n, a, f, m);
      } finally {
        la(b), dl.transition = T;
      }
    }
    function ei(n, a, f, m) {
      var b = zr(),
        T = dl.transition;
      dl.transition = null;
      try {
        la(Zi), Ys(n, a, f, m);
      } finally {
        la(b), dl.transition = T;
      }
    }
    function Ys(n, a, f, m) {
      ii && Zn(n, a, f, m);
    }
    function Zn(n, a, f, m) {
      var b = xo(n, a, f, m);
      if (b === null) {
        my(n, a, m, ls, f), ri(n, m);
        return;
      }
      if (ua(b, n, a, f, m)) {
        m.stopPropagation();
        return;
      }
      if (ri(n, m), a & wi && ty(n)) {
        for (; b !== null;) {
          var T = Ef(b);
          T !== null && xr(T);
          var M = xo(n, a, f, m);
          if (M === null && my(n, a, m, ls, f), M === b) break;
          b = M;
        }
        b !== null && m.stopPropagation();
        return;
      }
      my(n, a, m, null, f);
    }
    var ls = null;
    function xo(n, a, f, m) {
      ls = null;
      var b = Sh(m),
        T = zc(b);
      if (T !== null) {
        var M = si(T);
        if (M === null) T = null;else {
          var z = M.tag;
          if (z === V) {
            var U = ya(M);
            if (U !== null) return U;
            T = null;
          } else if (z === C) {
            var X = M.stateNode;
            if ($h(X)) return ba(M);
            T = null;
          } else M !== T && (T = null);
        }
      }
      return ls = T, null;
    }
    function Lc(n) {
      switch (n) {
        // Used by SimpleEventPlugin:
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        // Used by polyfills:
        // eslint-disable-next-line no-fallthrough
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        // Only enableCreateEventHandleAPI:
        // eslint-disable-next-line no-fallthrough
        case "beforeblur":
        case "afterblur":
        // Not used by React but could be by user code:
        // eslint-disable-next-line no-fallthrough
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return Ii;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        // Not used by React but could be by user code:
        // eslint-disable-next-line no-fallthrough
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return Zi;
        case "message":
          {
            var a = Hd();
            switch (a) {
              case Xu:
                return Ii;
              case Wo:
                return Zi;
              case eo:
              case Mw:
                return os;
              case li:
                return ss;
              default:
                return os;
            }
          }
        default:
          return os;
      }
    }
    function qh(n, a, f) {
      return n.addEventListener(a, f, !1), f;
    }
    function dc(n, a, f) {
      return n.addEventListener(a, f, !0), f;
    }
    function ti(n, a, f, m) {
      return n.addEventListener(a, f, {
        capture: !0,
        passive: m
      }), f;
    }
    function fc(n, a, f, m) {
      return n.addEventListener(a, f, {
        passive: m
      }), f;
    }
    var ao = null,
      Mi = null,
      Kl = null;
    function Yh(n) {
      return ao = n, Mi = Ea(), !0;
    }
    function So() {
      ao = null, Mi = null, Kl = null;
    }
    function pc() {
      if (Kl) return Kl;
      var n,
        a = Mi,
        f = a.length,
        m,
        b = Ea(),
        T = b.length;
      for (n = 0; n < f && a[n] === b[n]; n++);
      var M = f - n;
      for (m = 1; m <= M && a[f - m] === b[T - m]; m++);
      var z = m > 1 ? 1 - m : void 0;
      return Kl = b.slice(n, z), Kl;
    }
    function Ea() {
      return "value" in ao ? ao.value : ao.textContent;
    }
    function Gs(n) {
      var a,
        f = n.keyCode;
      return "charCode" in n ? (a = n.charCode, a === 0 && f === 13 && (a = 13)) : a = f, a === 10 && (a = 13), a >= 32 || a === 13 ? a : 0;
    }
    function Xs() {
      return !0;
    }
    function Ma() {
      return !1;
    }
    function di(n) {
      function a(f, m, b, T, M) {
        this._reactName = f, this._targetInst = b, this.type = m, this.nativeEvent = T, this.target = M, this.currentTarget = null;
        for (var z in n) if (n.hasOwnProperty(z)) {
          var U = n[z];
          U ? this[z] = U(T) : this[z] = T[z];
        }
        var X = T.defaultPrevented != null ? T.defaultPrevented : T.returnValue === !1;
        return X ? this.isDefaultPrevented = Xs : this.isDefaultPrevented = Ma, this.isPropagationStopped = Ma, this;
      }
      return Qt(a.prototype, {
        preventDefault: function () {
          this.defaultPrevented = !0;
          var f = this.nativeEvent;
          f && (f.preventDefault ? f.preventDefault() : typeof f.returnValue != "unknown" && (f.returnValue = !1), this.isDefaultPrevented = Xs);
        },
        stopPropagation: function () {
          var f = this.nativeEvent;
          f && (f.stopPropagation ? f.stopPropagation() : typeof f.cancelBubble != "unknown" && (f.cancelBubble = !0), this.isPropagationStopped = Xs);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function () {},
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: Xs
      }), a;
    }
    var us = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function (n) {
          return n.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
      },
      hr = di(us),
      Ca = Qt({}, us, {
        view: 0,
        detail: 0
      }),
      Oi = di(Ca),
      Mr,
      hc,
      mc;
    function Pc(n) {
      n !== mc && (mc && n.type === "mousemove" ? (Mr = n.screenX - mc.screenX, hc = n.screenY - mc.screenY) : (Mr = 0, hc = 0), mc = n);
    }
    var Gh = Qt({}, Ca, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: Qh,
        button: 0,
        buttons: 0,
        relatedTarget: function (n) {
          return n.relatedTarget === void 0 ? n.fromElement === n.srcElement ? n.toElement : n.fromElement : n.relatedTarget;
        },
        movementX: function (n) {
          return "movementX" in n ? n.movementX : (Pc(n), Mr);
        },
        movementY: function (n) {
          return "movementY" in n ? n.movementY : hc;
        }
      }),
      Eo = di(Gh),
      ny = Qt({}, Gh, {
        dataTransfer: 0
      }),
      Xh = di(ny),
      Ko = Qt({}, Ca, {
        relatedTarget: 0
      }),
      gf = di(Ko),
      Ks = Qt({}, us, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
      }),
      ry = di(Ks),
      iy = Qt({}, us, {
        clipboardData: function (n) {
          return "clipboardData" in n ? n.clipboardData : window.clipboardData;
        }
      }),
      Kh = di(iy),
      Ac = Qt({}, us, {
        data: 0
      }),
      Tb = di(Ac),
      Aw = Tb,
      ay = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
      },
      oy = {
        8: "Backspace",
        9: "Tab",
        12: "Clear",
        13: "Enter",
        16: "Shift",
        17: "Control",
        18: "Alt",
        19: "Pause",
        20: "CapsLock",
        27: "Escape",
        32: " ",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "ArrowLeft",
        38: "ArrowUp",
        39: "ArrowRight",
        40: "ArrowDown",
        45: "Insert",
        46: "Delete",
        112: "F1",
        113: "F2",
        114: "F3",
        115: "F4",
        116: "F5",
        117: "F6",
        118: "F7",
        119: "F8",
        120: "F9",
        121: "F10",
        122: "F11",
        123: "F12",
        144: "NumLock",
        145: "ScrollLock",
        224: "Meta"
      };
    function Qs(n) {
      if (n.key) {
        var a = ay[n.key] || n.key;
        if (a !== "Unidentified") return a;
      }
      if (n.type === "keypress") {
        var f = Gs(n);
        return f === 13 ? "Enter" : String.fromCharCode(f);
      }
      return n.type === "keydown" || n.type === "keyup" ? oy[n.keyCode] || "Unidentified" : "";
    }
    var jw = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function Zs(n) {
      var a = this,
        f = a.nativeEvent;
      if (f.getModifierState) return f.getModifierState(n);
      var m = jw[n];
      return m ? !!f[m] : !1;
    }
    function Qh(n) {
      return Zs;
    }
    var $n = Qt({}, Ca, {
        key: Qs,
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: Qh,
        // Legacy Interface
        charCode: function (n) {
          return n.type === "keypress" ? Gs(n) : 0;
        },
        keyCode: function (n) {
          return n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
        },
        which: function (n) {
          return n.type === "keypress" ? Gs(n) : n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
        }
      }),
      Fw = di($n),
      nv = Qt({}, Gh, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
      }),
      Rb = di(nv),
      Nw = Qt({}, Ca, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: Qh
      }),
      sy = di(Nw),
      ly = Qt({}, us, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
      }),
      zw = di(ly),
      Li = Qt({}, Gh, {
        deltaX: function (n) {
          return "deltaX" in n ? n.deltaX :
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in n ? -n.wheelDeltaX : 0;
        },
        deltaY: function (n) {
          return "deltaY" in n ? n.deltaY :
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in n ? -n.wheelDeltaY :
          // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
          "wheelDelta" in n ? -n.wheelDelta : 0;
        },
        deltaZ: 0,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: 0
      }),
      Zh = di(Li),
      Db = [9, 13, 27, 32],
      Oa = 229,
      Js = Xe && "CompositionEvent" in window,
      oo = null;
    Xe && "documentMode" in document && (oo = document.documentMode);
    var jc = Xe && "TextEvent" in window && !oo,
      yf = Xe && (!Js || oo && oo > 8 && oo <= 11),
      bf = 32,
      Ib = String.fromCharCode(bf);
    function dp() {
      Te("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), Te("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), Te("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), Te("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var Mb = !1;
    function uy(n) {
      return (n.ctrlKey || n.altKey || n.metaKey) &&
      // ctrlKey && altKey is equivalent to AltGr, and is not a command.
      !(n.ctrlKey && n.altKey);
    }
    function cy(n) {
      switch (n) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function Fc(n, a) {
      return n === "keydown" && a.keyCode === Oa;
    }
    function vc(n, a) {
      switch (n) {
        case "keyup":
          return Db.indexOf(a.keyCode) !== -1;
        case "keydown":
          return a.keyCode !== Oa;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function Jh(n) {
      var a = n.detail;
      return typeof a == "object" && "data" in a ? a.data : null;
    }
    function Ql(n) {
      return n.locale === "ko";
    }
    var fp = !1;
    function dy(n, a, f, m, b) {
      var T, M;
      if (Js ? T = cy(a) : fp ? vc(a, m) && (T = "onCompositionEnd") : Fc(a, m) && (T = "onCompositionStart"), !T) return null;
      yf && !Ql(m) && (!fp && T === "onCompositionStart" ? fp = Yh(b) : T === "onCompositionEnd" && fp && (M = pc()));
      var z = im(f, T);
      if (z.length > 0) {
        var U = new Tb(T, a, null, m, b);
        if (n.push({
          event: U,
          listeners: z
        }), M) U.data = M;else {
          var X = Jh(m);
          X !== null && (U.data = X);
        }
      }
    }
    function em(n, a) {
      switch (n) {
        case "compositionend":
          return Jh(a);
        case "keypress":
          var f = a.which;
          return f !== bf ? null : (Mb = !0, Ib);
        case "textInput":
          var m = a.data;
          return m === Ib && Mb ? null : m;
        default:
          return null;
      }
    }
    function wf(n, a) {
      if (fp) {
        if (n === "compositionend" || !Js && vc(n, a)) {
          var f = pc();
          return So(), fp = !1, f;
        }
        return null;
      }
      switch (n) {
        case "paste":
          return null;
        case "keypress":
          if (!uy(a)) {
            if (a.char && a.char.length > 1) return a.char;
            if (a.which) return String.fromCharCode(a.which);
          }
          return null;
        case "compositionend":
          return yf && !Ql(a) ? null : a.data;
        default:
          return null;
      }
    }
    function tm(n, a, f, m, b) {
      var T;
      if (jc ? T = em(a, m) : T = wf(a, m), !T) return null;
      var M = im(f, "onBeforeInput");
      if (M.length > 0) {
        var z = new Aw("onBeforeInput", "beforeinput", null, m, b);
        n.push({
          event: z,
          listeners: M
        }), z.data = T;
      }
    }
    function _f(n, a, f, m, b, T, M) {
      dy(n, a, f, m, b), tm(n, a, f, m, b);
    }
    var rv = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function Ob(n) {
      var a = n && n.nodeName && n.nodeName.toLowerCase();
      return a === "input" ? !!rv[n.type] : a === "textarea";
    }
    /**
     * Checks if an event is supported in the current execution environment.
     *
     * NOTE: This will not work correctly for non-generic events such as `change`,
     * `reset`, `load`, `error`, and `select`.
     *
     * Borrows from Modernizr.
     *
     * @param {string} eventNameSuffix Event name, e.g. "click".
     * @return {boolean} True if the event is supported.
     * @internal
     * @license Modernizr 3.0.0pre (Custom Build) | MIT
     */
    function xf(n) {
      if (!Xe) return !1;
      var a = "on" + n,
        f = a in document;
      if (!f) {
        var m = document.createElement("div");
        m.setAttribute(a, "return;"), f = typeof m[a] == "function";
      }
      return f;
    }
    function Lb() {
      Te("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function cs(n, a, f, m) {
      Il(m);
      var b = im(a, "onChange");
      if (b.length > 0) {
        var T = new hr("onChange", "change", null, f, m);
        n.push({
          event: T,
          listeners: b
        });
      }
    }
    var gc = null,
      Zl = null;
    function r(n) {
      var a = n.nodeName && n.nodeName.toLowerCase();
      return a === "select" || a === "input" && n.type === "file";
    }
    function o(n) {
      var a = [];
      cs(a, Zl, n, Sh(n)), Mg(d, a);
    }
    function d(n) {
      nD(n, 0);
    }
    function g(n) {
      var a = mv(n);
      if (Rs(a)) return n;
    }
    function S(n, a) {
      if (n === "change") return a;
    }
    var R = !1;
    Xe && (R = xf("input") && (!document.documentMode || document.documentMode > 9));
    function A(n, a) {
      gc = n, Zl = a, gc.attachEvent("onpropertychange", re);
    }
    function q() {
      gc && (gc.detachEvent("onpropertychange", re), gc = null, Zl = null);
    }
    function re(n) {
      n.propertyName === "value" && g(Zl) && o(n);
    }
    function be(n, a, f) {
      n === "focusin" ? (q(), A(a, f)) : n === "focusout" && q();
    }
    function Le(n, a) {
      if (n === "selectionchange" || n === "keyup" || n === "keydown") return g(Zl);
    }
    function Ve(n) {
      var a = n.nodeName;
      return a && a.toLowerCase() === "input" && (n.type === "checkbox" || n.type === "radio");
    }
    function Oe(n, a) {
      if (n === "click") return g(a);
    }
    function et(n, a) {
      if (n === "input" || n === "change") return g(a);
    }
    function it(n) {
      var a = n._wrapperState;
      !a || !a.controlled || n.type !== "number" || _d(n, "number", n.value);
    }
    function st(n, a, f, m, b, T, M) {
      var z = f ? mv(f) : window,
        U,
        X;
      if (r(z) ? U = S : Ob(z) ? R ? U = et : (U = Le, X = be) : Ve(z) && (U = Oe), U) {
        var J = U(a, f);
        if (J) {
          cs(n, J, m, b);
          return;
        }
      }
      X && X(a, z, f), a === "focusout" && it(z);
    }
    function Kn() {
      ze("onMouseEnter", ["mouseout", "mouseover"]), ze("onMouseLeave", ["mouseout", "mouseover"]), ze("onPointerEnter", ["pointerout", "pointerover"]), ze("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function pe(n, a, f, m, b, T, M) {
      var z = a === "mouseover" || a === "pointerover",
        U = a === "mouseout" || a === "pointerout";
      if (z && !Hu(m)) {
        var X = m.relatedTarget || m.fromElement;
        if (X && (zc(X) || Nc(X))) return;
      }
      if (!(!U && !z)) {
        var J;
        if (b.window === b) J = b;else {
          var me = b.ownerDocument;
          me ? J = me.defaultView || me.parentWindow : J = window;
        }
        var Se, Me;
        if (U) {
          var Pe = m.relatedTarget || m.toElement;
          if (Se = f, Me = Pe ? zc(Pe) : null, Me !== null) {
            var $e = si(Me);
            (Me !== $e || Me.tag !== D && Me.tag !== I) && (Me = null);
          }
        } else Se = null, Me = f;
        if (Se !== Me) {
          var mt = Eo,
            Re = "onMouseLeave",
            Ue = "onMouseEnter",
            Be = "mouse";
          (a === "pointerout" || a === "pointerover") && (mt = Rb, Re = "onPointerLeave", Ue = "onPointerEnter", Be = "pointer");
          var nt = Se == null ? J : mv(Se),
            ke = Me == null ? J : mv(Me),
            Fe = new mt(Re, Be + "leave", Se, m, b);
          Fe.target = nt, Fe.relatedTarget = ke;
          var Ie = null,
            Qe = zc(b);
          if (Qe === f) {
            var Tt = new mt(Ue, Be + "enter", Me, m, b);
            Tt.target = ke, Tt.relatedTarget = nt, Ie = Tt;
          }
          bL(n, Fe, Ie, Se, Me);
        }
      }
    }
    function ae(n, a) {
      return n === a && (n !== 0 || 1 / n === 1 / a) || n !== n && a !== a;
    }
    var he = typeof Object.is == "function" ? Object.is : ae;
    function He(n, a) {
      if (he(n, a)) return !0;
      if (typeof n != "object" || n === null || typeof a != "object" || a === null) return !1;
      var f = Object.keys(n),
        m = Object.keys(a);
      if (f.length !== m.length) return !1;
      for (var b = 0; b < f.length; b++) {
        var T = f[b];
        if (!ye.call(a, T) || !he(n[T], a[T])) return !1;
      }
      return !0;
    }
    function ut(n) {
      for (; n && n.firstChild;) n = n.firstChild;
      return n;
    }
    function bt(n) {
      for (; n;) {
        if (n.nextSibling) return n.nextSibling;
        n = n.parentNode;
      }
    }
    function wt(n, a) {
      for (var f = ut(n), m = 0, b = 0; f;) {
        if (f.nodeType === Xa) {
          if (b = m + f.textContent.length, m <= a && b >= a) return {
            node: f,
            offset: a - m
          };
          m = b;
        }
        f = ut(bt(f));
      }
    }
    function It(n) {
      var a = n.ownerDocument,
        f = a && a.defaultView || window,
        m = f.getSelection && f.getSelection();
      if (!m || m.rangeCount === 0) return null;
      var b = m.anchorNode,
        T = m.anchorOffset,
        M = m.focusNode,
        z = m.focusOffset;
      try {
        b.nodeType, M.nodeType;
      } catch {
        return null;
      }
      return mr(n, b, T, M, z);
    }
    function mr(n, a, f, m, b) {
      var T = 0,
        M = -1,
        z = -1,
        U = 0,
        X = 0,
        J = n,
        me = null;
      e: for (;;) {
        for (var Se = null; J === a && (f === 0 || J.nodeType === Xa) && (M = T + f), J === m && (b === 0 || J.nodeType === Xa) && (z = T + b), J.nodeType === Xa && (T += J.nodeValue.length), (Se = J.firstChild) !== null;) me = J, J = Se;
        for (;;) {
          if (J === n) break e;
          if (me === a && ++U === f && (M = T), me === m && ++X === b && (z = T), (Se = J.nextSibling) !== null) break;
          J = me, me = J.parentNode;
        }
        J = Se;
      }
      return M === -1 || z === -1 ? null : {
        start: M,
        end: z
      };
    }
    function cn(n, a) {
      var f = n.ownerDocument || document,
        m = f && f.defaultView || window;
      if (m.getSelection) {
        var b = m.getSelection(),
          T = n.textContent.length,
          M = Math.min(a.start, T),
          z = a.end === void 0 ? M : Math.min(a.end, T);
        if (!b.extend && M > z) {
          var U = z;
          z = M, M = U;
        }
        var X = wt(n, M),
          J = wt(n, z);
        if (X && J) {
          if (b.rangeCount === 1 && b.anchorNode === X.node && b.anchorOffset === X.offset && b.focusNode === J.node && b.focusOffset === J.offset) return;
          var me = f.createRange();
          me.setStart(X.node, X.offset), b.removeAllRanges(), M > z ? (b.addRange(me), b.extend(J.node, J.offset)) : (me.setEnd(J.node, J.offset), b.addRange(me));
        }
      }
    }
    function so(n) {
      return n && n.nodeType === Xa;
    }
    function Pb(n, a) {
      return !n || !a ? !1 : n === a ? !0 : so(n) ? !1 : so(a) ? Pb(n, a.parentNode) : "contains" in n ? n.contains(a) : n.compareDocumentPosition ? !!(n.compareDocumentPosition(a) & 16) : !1;
    }
    function cL(n) {
      return n && n.ownerDocument && Pb(n.ownerDocument.documentElement, n);
    }
    function QR(n) {
      try {
        return typeof n.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function iS() {
      for (var n = window, a = Ds(); a instanceof n.HTMLIFrameElement;) {
        if (QR(a)) n = a.contentWindow;else return a;
        a = Ds(n.document);
      }
      return a;
    }
    function WE(n) {
      var a = n && n.nodeName && n.nodeName.toLowerCase();
      return a && (a === "input" && (n.type === "text" || n.type === "search" || n.type === "tel" || n.type === "url" || n.type === "password") || a === "textarea" || n.contentEditable === "true");
    }
    function dL() {
      var n = iS();
      return {
        focusedElem: n,
        selectionRange: WE(n) ? pL(n) : null
      };
    }
    function fL(n) {
      var a = iS(),
        f = n.focusedElem,
        m = n.selectionRange;
      if (a !== f && cL(f)) {
        m !== null && WE(f) && hL(f, m);
        for (var b = [], T = f; T = T.parentNode;) T.nodeType === Wr && b.push({
          element: T,
          left: T.scrollLeft,
          top: T.scrollTop
        });
        typeof f.focus == "function" && f.focus();
        for (var M = 0; M < b.length; M++) {
          var z = b[M];
          z.element.scrollLeft = z.left, z.element.scrollTop = z.top;
        }
      }
    }
    function pL(n) {
      var a;
      return "selectionStart" in n ? a = {
        start: n.selectionStart,
        end: n.selectionEnd
      } : a = It(n), a || {
        start: 0,
        end: 0
      };
    }
    function hL(n, a) {
      var f = a.start,
        m = a.end;
      m === void 0 && (m = f), "selectionStart" in n ? (n.selectionStart = f, n.selectionEnd = Math.min(m, n.value.length)) : cn(n, a);
    }
    var mL = Xe && "documentMode" in document && document.documentMode <= 11;
    function Ab() {
      Te("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var iv = null,
      fy = null,
      py = null,
      qE = !1;
    function vL(n) {
      if ("selectionStart" in n && WE(n)) return {
        start: n.selectionStart,
        end: n.selectionEnd
      };
      var a = n.ownerDocument && n.ownerDocument.defaultView || window,
        f = a.getSelection();
      return {
        anchorNode: f.anchorNode,
        anchorOffset: f.anchorOffset,
        focusNode: f.focusNode,
        focusOffset: f.focusOffset
      };
    }
    function ZR(n) {
      return n.window === n ? n.document : n.nodeType === Ka ? n : n.ownerDocument;
    }
    function JR(n, a, f) {
      var m = ZR(f);
      if (!(qE || iv == null || iv !== Ds(m))) {
        var b = vL(iv);
        if (!py || !He(py, b)) {
          py = b;
          var T = im(fy, "onSelect");
          if (T.length > 0) {
            var M = new hr("onSelect", "select", null, a, f);
            n.push({
              event: M,
              listeners: T
            }), M.target = iv;
          }
        }
      }
    }
    function aS(n, a, f, m, b, T, M) {
      var z = f ? mv(f) : window;
      switch (a) {
        // Track the input node that has focus.
        case "focusin":
          (Ob(z) || z.contentEditable === "true") && (iv = z, fy = f, py = null);
          break;
        case "focusout":
          iv = null, fy = null, py = null;
          break;
        // Don't fire the event while the user is dragging. This matches the
        // semantics of the native select event.
        case "mousedown":
          qE = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          qE = !1, JR(n, m, b);
          break;
        // Chrome and IE fire non-standard event when selection is changed (and
        // sometimes when it hasn't). IE's event fires out of order with respect
        // to key and input events on deletion, so we discard it.
        //
        // Firefox doesn't support selectionchange, so check selection status
        // after each key entry. The selection changes after keydown and before
        // keyup, but we check on keydown as well in the case of holding down a
        // key, when multiple keydown events are fired but only one keyup is.
        // This is also our approach for IE handling, for the reason above.
        case "selectionchange":
          if (mL) break;
        // falls through
        case "keydown":
        case "keyup":
          JR(n, m, b);
      }
    }
    function nm(n, a) {
      var f = {};
      return f[n.toLowerCase()] = a.toLowerCase(), f["Webkit" + n] = "webkit" + a, f["Moz" + n] = "moz" + a, f;
    }
    var av = {
        animationend: nm("Animation", "AnimationEnd"),
        animationiteration: nm("Animation", "AnimationIteration"),
        animationstart: nm("Animation", "AnimationStart"),
        transitionend: nm("Transition", "TransitionEnd")
      },
      oS = {},
      Vw = {};
    Xe && (Vw = document.createElement("div").style, "AnimationEvent" in window || (delete av.animationend.animation, delete av.animationiteration.animation, delete av.animationstart.animation), "TransitionEvent" in window || delete av.transitionend.transition);
    function Bw(n) {
      if (oS[n]) return oS[n];
      if (!av[n]) return n;
      var a = av[n];
      for (var f in a) if (a.hasOwnProperty(f) && f in Vw) return oS[n] = a[f];
      return n;
    }
    var YE = Bw("animationend"),
      GE = Bw("animationiteration"),
      XE = Bw("animationstart"),
      KE = Bw("transitionend"),
      QE = /* @__PURE__ */new Map(),
      rm = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
    function ov(n, a) {
      QE.set(n, a), Te(a, [n]);
    }
    function gL() {
      for (var n = 0; n < rm.length; n++) {
        var a = rm[n],
          f = a.toLowerCase(),
          m = a[0].toUpperCase() + a.slice(1);
        ov(f, "on" + m);
      }
      ov(YE, "onAnimationEnd"), ov(GE, "onAnimationIteration"), ov(XE, "onAnimationStart"), ov("dblclick", "onDoubleClick"), ov("focusin", "onFocus"), ov("focusout", "onBlur"), ov(KE, "onTransitionEnd");
    }
    function yL(n, a, f, m, b, T, M) {
      var z = QE.get(a);
      if (z !== void 0) {
        var U = hr,
          X = a;
        switch (a) {
          case "keypress":
            if (Gs(m) === 0) return;
          /* falls through */
          case "keydown":
          case "keyup":
            U = Fw;
            break;
          case "focusin":
            X = "focus", U = gf;
            break;
          case "focusout":
            X = "blur", U = gf;
            break;
          case "beforeblur":
          case "afterblur":
            U = gf;
            break;
          case "click":
            if (m.button === 2) return;
          /* falls through */
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          // TODO: Disabled elements should not respond to mouse events
          /* falls through */
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            U = Eo;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            U = Xh;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            U = sy;
            break;
          case YE:
          case GE:
          case XE:
            U = ry;
            break;
          case KE:
            U = zw;
            break;
          case "scroll":
            U = Oi;
            break;
          case "wheel":
            U = Zh;
            break;
          case "copy":
          case "cut":
          case "paste":
            U = Kh;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            U = Rb;
            break;
        }
        var J = (T & wi) !== 0;
        {
          var me = !J &&
            // TODO: ideally, we'd eventually add all events from
            // nonDelegatedEvents list in DOMPluginEventSystem.
            // Then we can remove this special list.
            // This is a breaking change that can wait until React 18.
            a === "scroll",
            Se = uS(f, z, m.type, J, me);
          if (Se.length > 0) {
            var Me = new U(z, X, null, m, b);
            n.push({
              event: Me,
              listeners: Se
            });
          }
        }
      }
    }
    gL(), Kn(), Lb(), Ab(), dp();
    function Uw(n, a, f, m, b, T, M) {
      yL(n, a, f, m, b, T);
      var z = (T & xh) === 0;
      z && (pe(n, a, f, m, b), st(n, a, f, m, b), aS(n, a, f, m, b), _f(n, a, f, m, b));
    }
    var hy = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"],
      sS = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(hy));
    function eD(n, a, f) {
      var m = n.type || "unknown-event";
      n.currentTarget = f, ma(m, a, void 0, n), n.currentTarget = null;
    }
    function tD(n, a, f) {
      var m;
      if (f) for (var b = a.length - 1; b >= 0; b--) {
        var T = a[b],
          M = T.instance,
          z = T.currentTarget,
          U = T.listener;
        if (M !== m && n.isPropagationStopped()) return;
        eD(n, U, z), m = M;
      } else for (var X = 0; X < a.length; X++) {
        var J = a[X],
          me = J.instance,
          Se = J.currentTarget,
          Me = J.listener;
        if (me !== m && n.isPropagationStopped()) return;
        eD(n, Me, Se), m = me;
      }
    }
    function nD(n, a) {
      for (var f = (a & wi) !== 0, m = 0; m < n.length; m++) {
        var b = n[m],
          T = b.event,
          M = b.listeners;
        tD(T, M, f);
      }
      qu();
    }
    function Ji(n, a, f, m, b) {
      var T = Sh(f),
        M = [];
      Uw(M, n, m, f, T, a), nD(M, a);
    }
    function Pi(n, a) {
      sS.has(n) || h('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', n);
      var f = !1,
        m = wD(a),
        b = pu(n);
      m.has(b) || (ZE(a, n, Id, f), m.add(b));
    }
    function jb(n, a, f) {
      sS.has(n) && !a && h('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', n);
      var m = 0;
      a && (m |= wi), ZE(f, n, m, a);
    }
    var sv = "_reactListening" + Math.random().toString(36).slice(2);
    function Fb(n) {
      if (!n[sv]) {
        n[sv] = !0, xe.forEach(function (f) {
          f !== "selectionchange" && (sS.has(f) || jb(f, !1, n), jb(f, !0, n));
        });
        var a = n.nodeType === Ka ? n : n.ownerDocument;
        a !== null && (a[sv] || (a[sv] = !0, jb("selectionchange", !1, a)));
      }
    }
    function ZE(n, a, f, m, b) {
      var T = ir(n, a, f),
        M = void 0;
      Wu && (a === "touchstart" || a === "touchmove" || a === "wheel") && (M = !0), n = n, m ? M !== void 0 ? ti(n, a, T, M) : dc(n, a, T) : M !== void 0 ? fc(n, a, T, M) : qh(n, a, T);
    }
    function lS(n, a) {
      return n === a || n.nodeType === er && n.parentNode === a;
    }
    function my(n, a, f, m, b) {
      var T = m;
      if ((a & _h) === 0 && (a & Id) === 0) {
        var M = b;
        if (m !== null) {
          var z = m;
          e: for (;;) {
            if (z === null) return;
            var U = z.tag;
            if (U === C || U === k) {
              var X = z.stateNode.containerInfo;
              if (lS(X, M)) break;
              if (U === k) for (var J = z.return; J !== null;) {
                var me = J.tag;
                if (me === C || me === k) {
                  var Se = J.stateNode.containerInfo;
                  if (lS(Se, M)) return;
                }
                J = J.return;
              }
              for (; X !== null;) {
                var Me = zc(X);
                if (Me === null) return;
                var Pe = Me.tag;
                if (Pe === D || Pe === I) {
                  z = T = Me;
                  continue e;
                }
                X = X.parentNode;
              }
            }
            z = z.return;
          }
        }
      }
      Mg(function () {
        return Ji(n, a, f, T);
      });
    }
    function Hw(n, a, f) {
      return {
        instance: n,
        listener: a,
        currentTarget: f
      };
    }
    function uS(n, a, f, m, b, T) {
      for (var M = a !== null ? a + "Capture" : null, z = m ? M : a, U = [], X = n, J = null; X !== null;) {
        var me = X,
          Se = me.stateNode,
          Me = me.tag;
        if (Me === D && Se !== null && (J = Se, z !== null)) {
          var Pe = zo(X, z);
          Pe != null && U.push(Hw(X, Pe, J));
        }
        if (b) break;
        X = X.return;
      }
      return U;
    }
    function im(n, a) {
      for (var f = a + "Capture", m = [], b = n; b !== null;) {
        var T = b,
          M = T.stateNode,
          z = T.tag;
        if (z === D && M !== null) {
          var U = M,
            X = zo(b, f);
          X != null && m.unshift(Hw(b, X, U));
          var J = zo(b, a);
          J != null && m.push(Hw(b, J, U));
        }
        b = b.return;
      }
      return m;
    }
    function Nb(n) {
      if (n === null) return null;
      do n = n.return; while (n && n.tag !== D);
      return n || null;
    }
    function rD(n, a) {
      for (var f = n, m = a, b = 0, T = f; T; T = Nb(T)) b++;
      for (var M = 0, z = m; z; z = Nb(z)) M++;
      for (; b - M > 0;) f = Nb(f), b--;
      for (; M - b > 0;) m = Nb(m), M--;
      for (var U = b; U--;) {
        if (f === m || m !== null && f === m.alternate) return f;
        f = Nb(f), m = Nb(m);
      }
      return null;
    }
    function iD(n, a, f, m, b) {
      for (var T = a._reactName, M = [], z = f; z !== null && z !== m;) {
        var U = z,
          X = U.alternate,
          J = U.stateNode,
          me = U.tag;
        if (X !== null && X === m) break;
        if (me === D && J !== null) {
          var Se = J;
          if (b) {
            var Me = zo(z, T);
            Me != null && M.unshift(Hw(z, Me, Se));
          } else if (!b) {
            var Pe = zo(z, T);
            Pe != null && M.push(Hw(z, Pe, Se));
          }
        }
        z = z.return;
      }
      M.length !== 0 && n.push({
        event: a,
        listeners: M
      });
    }
    function bL(n, a, f, m, b) {
      var T = m && b ? rD(m, b) : null;
      m !== null && iD(n, a, m, T, !1), b !== null && f !== null && iD(n, f, b, T, !0);
    }
    function pu(n, a) {
      return n + "__bubble";
    }
    var ds = !1,
      lv = "dangerouslySetInnerHTML",
      Sf = "suppressContentEditableWarning",
      am = "suppressHydrationWarning",
      uv = "autoFocus",
      yc = "children",
      pp = "style",
      zb = "__html",
      Vb,
      cv,
      Bb,
      $w,
      Ww,
      JE,
      aD;
    Vb = {
      // There are working polyfills for <dialog>. Let people use it.
      dialog: !0,
      // Electron ships a custom <webview> tag to display external web content in
      // an isolated frame and process.
      // This tag is not present in non Electron environments such as JSDom which
      // is often used for testing purposes.
      // @see https://electronjs.org/docs/api/webview-tag
      webview: !0
    }, cv = function (n, a) {
      yh(n, a), Rd(n, a), Rg(n, a, {
        registrationNameDependencies: we,
        possibleRegistrationNames: ve
      });
    }, JE = Xe && !document.documentMode, Bb = function (n, a, f) {
      if (!ds) {
        var m = vy(f),
          b = vy(a);
        b !== m && (ds = !0, h("Prop `%s` did not match. Server: %s Client: %s", n, JSON.stringify(b), JSON.stringify(m)));
      }
    }, $w = function (n) {
      if (!ds) {
        ds = !0;
        var a = [];
        n.forEach(function (f) {
          a.push(f);
        }), h("Extra attributes from the server: %s", a);
      }
    }, Ww = function (n, a) {
      a === !1 ? h("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", n, n, n) : h("Expected `%s` listener to be a function, instead got a value of `%s` type.", n, typeof a);
    }, aD = function (n, a) {
      var f = n.namespaceURI === Ga ? n.ownerDocument.createElement(n.tagName) : n.ownerDocument.createElementNS(n.namespaceURI, n.tagName);
      return f.innerHTML = a, f.innerHTML;
    };
    var wL = /\r\n?/g,
      cS = /\u0000|\uFFFD/g;
    function vy(n) {
      St(n);
      var a = typeof n == "string" ? n : "" + n;
      return a.replace(wL, `
`).replace(cS, "");
    }
    function qw(n, a, f, m) {
      var b = vy(a),
        T = vy(n);
      if (T !== b && (m && (ds || (ds = !0, h('Text content did not match. Server: "%s" Client: "%s"', T, b))), f && W)) throw new Error("Text content does not match server-rendered HTML.");
    }
    function oD(n) {
      return n.nodeType === Ka ? n : n.ownerDocument;
    }
    function dS() {}
    function fS(n) {
      n.onclick = dS;
    }
    function _L(n, a, f, m, b) {
      for (var T in m) if (m.hasOwnProperty(T)) {
        var M = m[T];
        if (T === pp) M && Object.freeze(M), xg(a, M);else if (T === lv) {
          var z = M ? M[zb] : void 0;
          z != null && cg(a, z);
        } else if (T === yc) {
          if (typeof M == "string") {
            var U = n !== "textarea" || M !== "";
            U && kl(a, M);
          } else typeof M == "number" && kl(a, "" + M);
        } else T === Sf || T === am || T === uv || (we.hasOwnProperty(T) ? M != null && (typeof M != "function" && Ww(T, M), T === "onScroll" && Pi("scroll", a)) : M != null && Ha(a, T, M, b));
      }
    }
    function xL(n, a, f, m) {
      for (var b = 0; b < a.length; b += 2) {
        var T = a[b],
          M = a[b + 1];
        T === pp ? xg(n, M) : T === lv ? cg(n, M) : T === yc ? kl(n, M) : Ha(n, T, M, m);
      }
    }
    function SL(n, a, f, m) {
      var b,
        T = oD(f),
        M,
        z = m;
      if (z === Ga && (z = dh(n)), z === Ga) {
        if (b = Fo(n, a), !b && n !== n.toLowerCase() && h("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", n), n === "script") {
          var U = T.createElement("div");
          U.innerHTML = "<script><\/script>";
          var X = U.firstChild;
          M = U.removeChild(X);
        } else if (typeof a.is == "string") M = T.createElement(n, {
          is: a.is
        });else if (M = T.createElement(n), n === "select") {
          var J = M;
          a.multiple ? J.multiple = !0 : a.size && (J.size = a.size);
        }
      } else M = T.createElementNS(z, n);
      return z === Ga && !b && Object.prototype.toString.call(M) === "[object HTMLUnknownElement]" && !ye.call(Vb, n) && (Vb[n] = !0, h("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", n)), M;
    }
    function EL(n, a) {
      return oD(a).createTextNode(n);
    }
    function CL(n, a, f, m) {
      var b = Fo(a, f);
      cv(a, f);
      var T;
      switch (a) {
        case "dialog":
          Pi("cancel", n), Pi("close", n), T = f;
          break;
        case "iframe":
        case "object":
        case "embed":
          Pi("load", n), T = f;
          break;
        case "video":
        case "audio":
          for (var M = 0; M < hy.length; M++) Pi(hy[M], n);
          T = f;
          break;
        case "source":
          Pi("error", n), T = f;
          break;
        case "img":
        case "image":
        case "link":
          Pi("error", n), Pi("load", n), T = f;
          break;
        case "details":
          Pi("toggle", n), T = f;
          break;
        case "input":
          Ya(n, f), T = gd(n, f), Pi("invalid", n);
          break;
        case "option":
          El(n, f), T = f;
          break;
        case "select":
          Sd(n, f), T = oh(n, f), Pi("invalid", n);
          break;
        case "textarea":
          lh(n, f), T = sh(n, f), Pi("invalid", n);
          break;
        default:
          T = f;
      }
      switch (kd(a, T), _L(a, n, m, T, b), a) {
        case "input":
          jo(n), rh(n, f, !1);
          break;
        case "textarea":
          jo(n), lg(n);
          break;
        case "option":
          hw(n, f);
          break;
        case "select":
          vw(n, f);
          break;
        default:
          typeof T.onClick == "function" && fS(n);
          break;
      }
    }
    function kL(n, a, f, m, b) {
      cv(a, m);
      var T = null,
        M,
        z;
      switch (a) {
        case "input":
          M = gd(n, f), z = gd(n, m), T = [];
          break;
        case "select":
          M = oh(n, f), z = oh(n, m), T = [];
          break;
        case "textarea":
          M = sh(n, f), z = sh(n, m), T = [];
          break;
        default:
          M = f, z = m, typeof M.onClick != "function" && typeof z.onClick == "function" && fS(n);
          break;
      }
      kd(a, z);
      var U,
        X,
        J = null;
      for (U in M) if (!(z.hasOwnProperty(U) || !M.hasOwnProperty(U) || M[U] == null)) if (U === pp) {
        var me = M[U];
        for (X in me) me.hasOwnProperty(X) && (J || (J = {}), J[X] = "");
      } else U === lv || U === yc || U === Sf || U === am || U === uv || (we.hasOwnProperty(U) ? T || (T = []) : (T = T || []).push(U, null));
      for (U in z) {
        var Se = z[U],
          Me = M != null ? M[U] : void 0;
        if (!(!z.hasOwnProperty(U) || Se === Me || Se == null && Me == null)) if (U === pp) {
          if (Se && Object.freeze(Se), Me) {
            for (X in Me) Me.hasOwnProperty(X) && (!Se || !Se.hasOwnProperty(X)) && (J || (J = {}), J[X] = "");
            for (X in Se) Se.hasOwnProperty(X) && Me[X] !== Se[X] && (J || (J = {}), J[X] = Se[X]);
          } else J || (T || (T = []), T.push(U, J)), J = Se;
        } else if (U === lv) {
          var Pe = Se ? Se[zb] : void 0,
            $e = Me ? Me[zb] : void 0;
          Pe != null && $e !== Pe && (T = T || []).push(U, Pe);
        } else U === yc ? (typeof Se == "string" || typeof Se == "number") && (T = T || []).push(U, "" + Se) : U === Sf || U === am || (we.hasOwnProperty(U) ? (Se != null && (typeof Se != "function" && Ww(U, Se), U === "onScroll" && Pi("scroll", n)), !T && Me !== Se && (T = [])) : (T = T || []).push(U, Se));
      }
      return J && (Cw(J, z[pp]), (T = T || []).push(pp, J)), T;
    }
    function TL(n, a, f, m, b) {
      f === "input" && b.type === "radio" && b.name != null && yd(n, b);
      var T = Fo(f, m),
        M = Fo(f, b);
      switch (xL(n, a, T, M), f) {
        case "input":
          Sl(n, b);
          break;
        case "textarea":
          sg(n, b);
          break;
        case "select":
          gw(n, b);
          break;
      }
    }
    function RL(n) {
      {
        var a = n.toLowerCase();
        return Bu.hasOwnProperty(a) && Bu[a] || null;
      }
    }
    function DL(n, a, f, m, b, T, M) {
      var z, U;
      switch (z = Fo(a, f), cv(a, f), a) {
        case "dialog":
          Pi("cancel", n), Pi("close", n);
          break;
        case "iframe":
        case "object":
        case "embed":
          Pi("load", n);
          break;
        case "video":
        case "audio":
          for (var X = 0; X < hy.length; X++) Pi(hy[X], n);
          break;
        case "source":
          Pi("error", n);
          break;
        case "img":
        case "image":
        case "link":
          Pi("error", n), Pi("load", n);
          break;
        case "details":
          Pi("toggle", n);
          break;
        case "input":
          Ya(n, f), Pi("invalid", n);
          break;
        case "option":
          El(n, f);
          break;
        case "select":
          Sd(n, f), Pi("invalid", n);
          break;
        case "textarea":
          lh(n, f), Pi("invalid", n);
          break;
      }
      kd(a, f);
      {
        U = /* @__PURE__ */new Set();
        for (var J = n.attributes, me = 0; me < J.length; me++) {
          var Se = J[me].name.toLowerCase();
          switch (Se) {
            // Controlled attributes are not validated
            // TODO: Only ignore them on controlled tags.
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              U.add(J[me].name);
          }
        }
      }
      var Me = null;
      for (var Pe in f) if (f.hasOwnProperty(Pe)) {
        var $e = f[Pe];
        if (Pe === yc) typeof $e == "string" ? n.textContent !== $e && (f[am] !== !0 && qw(n.textContent, $e, T, M), Me = [yc, $e]) : typeof $e == "number" && n.textContent !== "" + $e && (f[am] !== !0 && qw(n.textContent, $e, T, M), Me = [yc, "" + $e]);else if (we.hasOwnProperty(Pe)) $e != null && (typeof $e != "function" && Ww(Pe, $e), Pe === "onScroll" && Pi("scroll", n));else if (M &&
        // Convince Flow we've calculated it (it's DEV-only in this method.)
        typeof z == "boolean") {
          var mt = void 0,
            Re = Ht(Pe);
          if (f[am] !== !0) {
            if (!(Pe === Sf || Pe === am ||
            // Controlled attributes are not validated
            // TODO: Only ignore them on controlled tags.
            Pe === "value" || Pe === "checked" || Pe === "selected")) {
              if (Pe === lv) {
                var Ue = n.innerHTML,
                  Be = $e ? $e[zb] : void 0;
                if (Be != null) {
                  var nt = aD(n, Be);
                  nt !== Ue && Bb(Pe, Ue, nt);
                }
              } else if (Pe === pp) {
                if (U.delete(Pe), JE) {
                  var ke = Sw($e);
                  mt = n.getAttribute("style"), ke !== mt && Bb(Pe, mt, ke);
                }
              } else if (z) U.delete(Pe.toLowerCase()), mt = Tu(n, Pe, $e), $e !== mt && Bb(Pe, mt, $e);else if (!at(Pe, Re, z) && !Bt(Pe, $e, Re, z)) {
                var Fe = !1;
                if (Re !== null) U.delete(Re.attributeName), mt = bo(n, Pe, $e, Re);else {
                  var Ie = m;
                  if (Ie === Ga && (Ie = dh(a)), Ie === Ga) U.delete(Pe.toLowerCase());else {
                    var Qe = RL(Pe);
                    Qe !== null && Qe !== Pe && (Fe = !0, U.delete(Qe)), U.delete(Pe);
                  }
                  mt = Tu(n, Pe, $e);
                }
                var Tt = ce;
                !Tt && $e !== mt && !Fe && Bb(Pe, mt, $e);
              }
            }
          }
        }
      }
      switch (M &&
      // $FlowFixMe - Should be inferred as not undefined.
      U.size > 0 && f[am] !== !0 && $w(U), a) {
        case "input":
          jo(n), rh(n, f, !0);
          break;
        case "textarea":
          jo(n), lg(n);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof f.onClick == "function" && fS(n);
          break;
      }
      return Me;
    }
    function eC(n, a, f) {
      var m = n.nodeValue !== a;
      return m;
    }
    function Yw(n, a) {
      {
        if (ds) return;
        ds = !0, h("Did not expect server HTML to contain a <%s> in <%s>.", a.nodeName.toLowerCase(), n.nodeName.toLowerCase());
      }
    }
    function Gw(n, a) {
      {
        if (ds) return;
        ds = !0, h('Did not expect server HTML to contain the text node "%s" in <%s>.', a.nodeValue, n.nodeName.toLowerCase());
      }
    }
    function Xw(n, a, f) {
      {
        if (ds) return;
        ds = !0, h("Expected server HTML to contain a matching <%s> in <%s>.", a, n.nodeName.toLowerCase());
      }
    }
    function tC(n, a) {
      {
        if (a === "" || ds) return;
        ds = !0, h('Expected server HTML to contain a matching text node for "%s" in <%s>.', a, n.nodeName.toLowerCase());
      }
    }
    function Kw(n, a, f) {
      switch (a) {
        case "input":
          bd(n, f);
          return;
        case "textarea":
          bw(n, f);
          return;
        case "select":
          yw(n, f);
          return;
      }
    }
    var om = function () {},
      Qw = function () {};
    {
      var sD = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"],
        lD = ["applet", "caption", "html", "table", "td", "th", "marquee", "object", "template",
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject", "desc", "title"],
        IL = lD.concat(["button"]),
        uD = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"],
        cD = {
          current: null,
          formTag: null,
          aTagInScope: null,
          buttonTagInScope: null,
          nobrTagInScope: null,
          pTagInButtonScope: null,
          listItemTagAutoclosing: null,
          dlItemTagAutoclosing: null
        };
      Qw = function (n, a) {
        var f = Qt({}, n || cD),
          m = {
            tag: a
          };
        return lD.indexOf(a) !== -1 && (f.aTagInScope = null, f.buttonTagInScope = null, f.nobrTagInScope = null), IL.indexOf(a) !== -1 && (f.pTagInButtonScope = null), sD.indexOf(a) !== -1 && a !== "address" && a !== "div" && a !== "p" && (f.listItemTagAutoclosing = null, f.dlItemTagAutoclosing = null), f.current = m, a === "form" && (f.formTag = m), a === "a" && (f.aTagInScope = m), a === "button" && (f.buttonTagInScope = m), a === "nobr" && (f.nobrTagInScope = m), a === "p" && (f.pTagInButtonScope = m), a === "li" && (f.listItemTagAutoclosing = m), (a === "dd" || a === "dt") && (f.dlItemTagAutoclosing = m), f;
      };
      var ML = function (n, a) {
          switch (a) {
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
            case "select":
              return n === "option" || n === "optgroup" || n === "#text";
            case "optgroup":
              return n === "option" || n === "#text";
            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
            // but
            case "option":
              return n === "#text";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
            // No special behavior since these rules fall back to "in body" mode for
            // all except special table nodes which cause bad parsing behavior anyway.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
            case "tr":
              return n === "th" || n === "td" || n === "style" || n === "script" || n === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
            case "tbody":
            case "thead":
            case "tfoot":
              return n === "tr" || n === "style" || n === "script" || n === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
            case "colgroup":
              return n === "col" || n === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
            case "table":
              return n === "caption" || n === "colgroup" || n === "tbody" || n === "tfoot" || n === "thead" || n === "style" || n === "script" || n === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
            case "head":
              return n === "base" || n === "basefont" || n === "bgsound" || n === "link" || n === "meta" || n === "title" || n === "noscript" || n === "noframes" || n === "style" || n === "script" || n === "template";
            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
            case "html":
              return n === "head" || n === "body" || n === "frameset";
            case "frameset":
              return n === "frame";
            case "#document":
              return n === "html";
          }
          switch (n) {
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
              return a !== "h1" && a !== "h2" && a !== "h3" && a !== "h4" && a !== "h5" && a !== "h6";
            case "rp":
            case "rt":
              return uD.indexOf(a) === -1;
            case "body":
            case "caption":
            case "col":
            case "colgroup":
            case "frameset":
            case "frame":
            case "head":
            case "html":
            case "tbody":
            case "td":
            case "tfoot":
            case "th":
            case "thead":
            case "tr":
              return a == null;
          }
          return !0;
        },
        dD = function (n, a) {
          switch (n) {
            case "address":
            case "article":
            case "aside":
            case "blockquote":
            case "center":
            case "details":
            case "dialog":
            case "dir":
            case "div":
            case "dl":
            case "fieldset":
            case "figcaption":
            case "figure":
            case "footer":
            case "header":
            case "hgroup":
            case "main":
            case "menu":
            case "nav":
            case "ol":
            case "p":
            case "section":
            case "summary":
            case "ul":
            case "pre":
            case "listing":
            case "table":
            case "hr":
            case "xmp":
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
              return a.pTagInButtonScope;
            case "form":
              return a.formTag || a.pTagInButtonScope;
            case "li":
              return a.listItemTagAutoclosing;
            case "dd":
            case "dt":
              return a.dlItemTagAutoclosing;
            case "button":
              return a.buttonTagInScope;
            case "a":
              return a.aTagInScope;
            case "nobr":
              return a.nobrTagInScope;
          }
          return null;
        },
        Zw = {};
      om = function (n, a, f) {
        f = f || cD;
        var m = f.current,
          b = m && m.tag;
        a != null && (n != null && h("validateDOMNesting: when childText is passed, childTag should be null"), n = "#text");
        var T = ML(n, b) ? null : m,
          M = T ? null : dD(n, f),
          z = T || M;
        if (z) {
          var U = z.tag,
            X = !!T + "|" + n + "|" + U;
          if (!Zw[X]) {
            Zw[X] = !0;
            var J = n,
              me = "";
            if (n === "#text" ? /\S/.test(a) ? J = "Text nodes" : (J = "Whitespace text nodes", me = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : J = "<" + n + ">", T) {
              var Se = "";
              U === "table" && n === "tr" && (Se += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), h("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", J, U, me, Se);
            } else h("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", J, U);
          }
        }
      };
    }
    var gy = "suppressHydrationWarning",
      yy = "$",
      dv = "/$",
      sm = "$?",
      Jw = "$!",
      nC = "style",
      e_ = null,
      rC = null;
    function OL(n) {
      var a,
        f,
        m = n.nodeType;
      switch (m) {
        case Ka:
        case ph:
          {
            a = m === Ka ? "#document" : "#fragment";
            var b = n.documentElement;
            f = b ? b.namespaceURI : fh(null, "");
            break;
          }
        default:
          {
            var T = m === er ? n.parentNode : n,
              M = T.namespaceURI || null;
            a = T.tagName, f = fh(M, a);
            break;
          }
      }
      {
        var z = a.toLowerCase(),
          U = Qw(null, z);
        return {
          namespace: f,
          ancestorInfo: U
        };
      }
    }
    function LL(n, a, f) {
      {
        var m = n,
          b = fh(m.namespace, a),
          T = Qw(m.ancestorInfo, a);
        return {
          namespace: b,
          ancestorInfo: T
        };
      }
    }
    function $z(n) {
      return n;
    }
    function PL(n) {
      e_ = pr(), rC = dL();
      var a = null;
      return on(!1), a;
    }
    function AL(n) {
      fL(rC), on(e_), e_ = null, rC = null;
    }
    function jL(n, a, f, m, b) {
      var T;
      {
        var M = m;
        if (om(n, null, M.ancestorInfo), typeof a.children == "string" || typeof a.children == "number") {
          var z = "" + a.children,
            U = Qw(M.ancestorInfo, n);
          om(null, z, U);
        }
        T = M.namespace;
      }
      var X = SL(n, a, f, T);
      return $b(b, X), gS(X, a), X;
    }
    function FL(n, a) {
      n.appendChild(a);
    }
    function iC(n, a, f, m, b) {
      switch (CL(n, a, f, m), a) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!f.autoFocus;
        case "img":
          return !0;
        default:
          return !1;
      }
    }
    function NL(n, a, f, m, b, T) {
      {
        var M = T;
        if (typeof m.children != typeof f.children && (typeof m.children == "string" || typeof m.children == "number")) {
          var z = "" + m.children,
            U = Qw(M.ancestorInfo, a);
          om(null, z, U);
        }
      }
      return kL(n, a, f, m);
    }
    function aC(n, a) {
      return n === "textarea" || n === "noscript" || typeof a.children == "string" || typeof a.children == "number" || typeof a.dangerouslySetInnerHTML == "object" && a.dangerouslySetInnerHTML !== null && a.dangerouslySetInnerHTML.__html != null;
    }
    function oC(n, a, f, m) {
      {
        var b = f;
        om(null, n, b.ancestorInfo);
      }
      var T = EL(n, a);
      return $b(m, T), T;
    }
    function zL() {
      var n = window.event;
      return n === void 0 ? os : Lc(n.type);
    }
    var t_ = typeof setTimeout == "function" ? setTimeout : void 0,
      fD = typeof clearTimeout == "function" ? clearTimeout : void 0,
      sC = -1,
      pD = typeof Promise == "function" ? Promise : void 0,
      VL = typeof queueMicrotask == "function" ? queueMicrotask : typeof pD < "u" ? function (n) {
        return pD.resolve(null).then(n).catch(BL);
      } : t_;
    function BL(n) {
      setTimeout(function () {
        throw n;
      });
    }
    function hD(n, a, f, m) {
      switch (a) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          f.autoFocus && n.focus();
          return;
        case "img":
          {
            f.src && (n.src = f.src);
            return;
          }
      }
    }
    function UL(n, a, f, m, b, T) {
      TL(n, a, f, m, b), gS(n, b);
    }
    function mD(n) {
      kl(n, "");
    }
    function HL(n, a, f) {
      n.nodeValue = f;
    }
    function $L(n, a) {
      n.appendChild(a);
    }
    function WL(n, a) {
      var f;
      n.nodeType === er ? (f = n.parentNode, f.insertBefore(a, n)) : (f = n, f.appendChild(a));
      var m = n._reactRootContainer;
      m == null && f.onclick === null && fS(f);
    }
    function qL(n, a, f) {
      n.insertBefore(a, f);
    }
    function YL(n, a, f) {
      n.nodeType === er ? n.parentNode.insertBefore(a, f) : n.insertBefore(a, f);
    }
    function lC(n, a) {
      n.removeChild(a);
    }
    function GL(n, a) {
      n.nodeType === er ? n.parentNode.removeChild(a) : n.removeChild(a);
    }
    function uC(n, a) {
      var f = a,
        m = 0;
      do {
        var b = f.nextSibling;
        if (n.removeChild(f), b && b.nodeType === er) {
          var T = b.data;
          if (T === dv) {
            if (m === 0) {
              n.removeChild(b), _o(a);
              return;
            } else m--;
          } else (T === yy || T === sm || T === Jw) && m++;
        }
        f = b;
      } while (f);
      _o(a);
    }
    function XL(n, a) {
      n.nodeType === er ? uC(n.parentNode, a) : n.nodeType === Wr && uC(n, a), _o(n);
    }
    function KL(n) {
      n = n;
      var a = n.style;
      typeof a.setProperty == "function" ? a.setProperty("display", "none", "important") : a.display = "none";
    }
    function QL(n) {
      n.nodeValue = "";
    }
    function ZL(n, a) {
      n = n;
      var f = a[nC],
        m = f != null && f.hasOwnProperty("display") ? f.display : null;
      n.style.display = Cd("display", m);
    }
    function JL(n, a) {
      n.nodeValue = a;
    }
    function eP(n) {
      n.nodeType === Wr ? n.textContent = "" : n.nodeType === Ka && n.documentElement && n.removeChild(n.documentElement);
    }
    function tP(n, a, f) {
      return n.nodeType !== Wr || a.toLowerCase() !== n.nodeName.toLowerCase() ? null : n;
    }
    function vD(n, a) {
      return a === "" || n.nodeType !== Xa ? null : n;
    }
    function cC(n) {
      return n.nodeType !== er ? null : n;
    }
    function gD(n) {
      return n.data === sm;
    }
    function dC(n) {
      return n.data === Jw;
    }
    function pS(n) {
      var a = n.nextSibling && n.nextSibling.dataset,
        f,
        m,
        b;
      return a && (f = a.dgst, m = a.msg, b = a.stck), {
        message: m,
        digest: f,
        stack: b
      };
    }
    function n_(n, a) {
      n._reactRetry = a;
    }
    function hS(n) {
      for (; n != null; n = n.nextSibling) {
        var a = n.nodeType;
        if (a === Wr || a === Xa) break;
        if (a === er) {
          var f = n.data;
          if (f === yy || f === Jw || f === sm) break;
          if (f === dv) return null;
        }
      }
      return n;
    }
    function r_(n) {
      return hS(n.nextSibling);
    }
    function nP(n) {
      return hS(n.firstChild);
    }
    function rP(n) {
      return hS(n.firstChild);
    }
    function iP(n) {
      return hS(n.nextSibling);
    }
    function aP(n, a, f, m, b, T, M) {
      $b(T, n), gS(n, f);
      var z;
      {
        var U = b;
        z = U.namespace;
      }
      var X = (T.mode & Wt) !== dt;
      return DL(n, a, f, z, m, X, M);
    }
    function oP(n, a, f, m) {
      return $b(f, n), f.mode & Wt, eC(n, a);
    }
    function yD(n, a) {
      $b(a, n);
    }
    function sP(n) {
      for (var a = n.nextSibling, f = 0; a;) {
        if (a.nodeType === er) {
          var m = a.data;
          if (m === dv) {
            if (f === 0) return r_(a);
            f--;
          } else (m === yy || m === Jw || m === sm) && f++;
        }
        a = a.nextSibling;
      }
      return null;
    }
    function bD(n) {
      for (var a = n.previousSibling, f = 0; a;) {
        if (a.nodeType === er) {
          var m = a.data;
          if (m === yy || m === Jw || m === sm) {
            if (f === 0) return a;
            f--;
          } else m === dv && f++;
        }
        a = a.previousSibling;
      }
      return null;
    }
    function lP(n) {
      _o(n);
    }
    function uP(n) {
      _o(n);
    }
    function cP(n) {
      return n !== "head" && n !== "body";
    }
    function dP(n, a, f, m) {
      var b = !0;
      qw(a.nodeValue, f, m, b);
    }
    function fP(n, a, f, m, b, T) {
      if (a[gy] !== !0) {
        var M = !0;
        qw(m.nodeValue, b, T, M);
      }
    }
    function pP(n, a) {
      a.nodeType === Wr ? Yw(n, a) : a.nodeType === er || Gw(n, a);
    }
    function hP(n, a) {
      {
        var f = n.parentNode;
        f !== null && (a.nodeType === Wr ? Yw(f, a) : a.nodeType === er || Gw(f, a));
      }
    }
    function mP(n, a, f, m, b) {
      (b || a[gy] !== !0) && (m.nodeType === Wr ? Yw(f, m) : m.nodeType === er || Gw(f, m));
    }
    function vP(n, a, f) {
      Xw(n, a);
    }
    function gP(n, a) {
      tC(n, a);
    }
    function yP(n, a, f) {
      {
        var m = n.parentNode;
        m !== null && Xw(m, a);
      }
    }
    function bP(n, a) {
      {
        var f = n.parentNode;
        f !== null && tC(f, a);
      }
    }
    function wP(n, a, f, m, b, T) {
      (T || a[gy] !== !0) && Xw(f, m);
    }
    function _P(n, a, f, m, b) {
      (b || a[gy] !== !0) && tC(f, m);
    }
    function Ub(n) {
      h("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", n.nodeName.toLowerCase());
    }
    function Hb(n) {
      Fb(n);
    }
    var fv = Math.random().toString(36).slice(2),
      hp = "__reactFiber$" + fv,
      i_ = "__reactProps$" + fv,
      a_ = "__reactContainer$" + fv,
      fC = "__reactEvents$" + fv,
      xP = "__reactListeners$" + fv,
      o_ = "__reactHandles$" + fv;
    function mS(n) {
      delete n[hp], delete n[i_], delete n[fC], delete n[xP], delete n[o_];
    }
    function $b(n, a) {
      a[hp] = n;
    }
    function pv(n, a) {
      a[a_] = n;
    }
    function hv(n) {
      n[a_] = null;
    }
    function Nc(n) {
      return !!n[a_];
    }
    function zc(n) {
      var a = n[hp];
      if (a) return a;
      for (var f = n.parentNode; f;) {
        if (a = f[a_] || f[hp], a) {
          var m = a.alternate;
          if (a.child !== null || m !== null && m.child !== null) for (var b = bD(n); b !== null;) {
            var T = b[hp];
            if (T) return T;
            b = bD(b);
          }
          return a;
        }
        n = f, f = n.parentNode;
      }
      return null;
    }
    function Ef(n) {
      var a = n[hp] || n[a_];
      return a && (a.tag === D || a.tag === I || a.tag === V || a.tag === C) ? a : null;
    }
    function mv(n) {
      if (n.tag === D || n.tag === I) return n.stateNode;
      throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function vS(n) {
      return n[i_] || null;
    }
    function gS(n, a) {
      n[i_] = a;
    }
    function wD(n) {
      var a = n[fC];
      return a === void 0 && (a = n[fC] = /* @__PURE__ */new Set()), a;
    }
    var s_ = {},
      Vc = i.ReactDebugCurrentFrame;
    function Wb(n) {
      if (n) {
        var a = n._owner,
          f = Ts(n.type, n._source, a ? a.type : null);
        Vc.setExtraStackFrame(f);
      } else Vc.setExtraStackFrame(null);
    }
    function hu(n, a, f, m, b) {
      {
        var T = Function.call.bind(ye);
        for (var M in n) if (T(n, M)) {
          var z = void 0;
          try {
            if (typeof n[M] != "function") {
              var U = Error((m || "React class") + ": " + f + " type `" + M + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[M] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
              throw U.name = "Invariant Violation", U;
            }
            z = n[M](a, M, m, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
          } catch (X) {
            z = X;
          }
          z && !(z instanceof Error) && (Wb(b), h("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", m || "React class", f, M, typeof z), Wb(null)), z instanceof Error && !(z.message in s_) && (s_[z.message] = !0, Wb(b), h("Failed %s type: %s", f, z.message), Wb(null));
        }
      }
    }
    var Cf = [],
      kf;
    kf = [];
    var ca = -1;
    function ka(n) {
      return {
        current: n
      };
    }
    function fs(n, a) {
      if (ca < 0) {
        h("Unexpected pop.");
        return;
      }
      a !== kf[ca] && h("Unexpected Fiber popped."), n.current = Cf[ca], Cf[ca] = null, kf[ca] = null, ca--;
    }
    function fi(n, a, f) {
      ca++, Cf[ca] = n.current, kf[ca] = f, n.current = a;
    }
    var Tf;
    Tf = {};
    var La = {};
    Object.freeze(La);
    var Rf = ka(La),
      Jl = ka(!1),
      yS = La;
    function Df(n, a, f) {
      return f && Bc(a) ? yS : Rf.current;
    }
    function l_(n, a, f) {
      {
        var m = n.stateNode;
        m.__reactInternalMemoizedUnmaskedChildContext = a, m.__reactInternalMemoizedMaskedChildContext = f;
      }
    }
    function eu(n, a) {
      {
        var f = n.type,
          m = f.contextTypes;
        if (!m) return La;
        var b = n.stateNode;
        if (b && b.__reactInternalMemoizedUnmaskedChildContext === a) return b.__reactInternalMemoizedMaskedChildContext;
        var T = {};
        for (var M in m) T[M] = a[M];
        {
          var z = At(n) || "Unknown";
          hu(m, T, "context", z);
        }
        return b && l_(n, a, T), T;
      }
    }
    function by() {
      return Jl.current;
    }
    function Bc(n) {
      {
        var a = n.childContextTypes;
        return a != null;
      }
    }
    function u_(n) {
      fs(Jl, n), fs(Rf, n);
    }
    function bS(n) {
      fs(Jl, n), fs(Rf, n);
    }
    function c_(n, a, f) {
      {
        if (Rf.current !== La) throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        fi(Rf, a, n), fi(Jl, f, n);
      }
    }
    function pC(n, a, f) {
      {
        var m = n.stateNode,
          b = a.childContextTypes;
        if (typeof m.getChildContext != "function") {
          {
            var T = At(n) || "Unknown";
            Tf[T] || (Tf[T] = !0, h("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", T, T));
          }
          return f;
        }
        var M = m.getChildContext();
        for (var z in M) if (!(z in b)) throw new Error((At(n) || "Unknown") + '.getChildContext(): key "' + z + '" is not defined in childContextTypes.');
        {
          var U = At(n) || "Unknown";
          hu(b, M, "child context", U);
        }
        return Qt({}, f, M);
      }
    }
    function wS(n) {
      {
        var a = n.stateNode,
          f = a && a.__reactInternalMemoizedMergedChildContext || La;
        return yS = Rf.current, fi(Rf, f, n), fi(Jl, Jl.current, n), !0;
      }
    }
    function lm(n, a, f) {
      {
        var m = n.stateNode;
        if (!m) throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (f) {
          var b = pC(n, a, yS);
          m.__reactInternalMemoizedMergedChildContext = b, fs(Jl, n), fs(Rf, n), fi(Rf, b, n), fi(Jl, f, n);
        } else fs(Jl, n), fi(Jl, f, n);
      }
    }
    function _S(n) {
      {
        if (!Ns(n) || n.tag !== x) throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var a = n;
        do {
          switch (a.tag) {
            case C:
              return a.stateNode.context;
            case x:
              {
                var f = a.type;
                if (Bc(f)) return a.stateNode.__reactInternalMemoizedMergedChildContext;
                break;
              }
          }
          a = a.return;
        } while (a !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var fl = 0,
      qb = 1,
      If = null,
      xS = !1,
      hC = !1;
    function mC(n) {
      If === null ? If = [n] : If.push(n);
    }
    function vv(n) {
      xS = !0, mC(n);
    }
    function wy() {
      xS && bc();
    }
    function bc() {
      if (!hC && If !== null) {
        hC = !0;
        var n = 0,
          a = zr();
        try {
          var f = !0,
            m = If;
          for (la(Ii); n < m.length; n++) {
            var b = m[n];
            do b = b(f); while (b !== null);
          }
          If = null, xS = !1;
        } catch (T) {
          throw If !== null && (If = If.slice(n + 1)), Ch(Xu, bc), T;
        } finally {
          la(a), hC = !1;
        }
      }
      return null;
    }
    var um = [],
      cm = 0,
      tu = null,
      nu = 0,
      ps = [],
      Co = 0,
      ru = null,
      dm = 1,
      fm = "";
    function SP(n) {
      return hs(), (n.flags & va) !== pt;
    }
    function _y(n) {
      return hs(), nu;
    }
    function _D() {
      var n = fm,
        a = dm,
        f = a & ~EP(a);
      return f.toString(32) + n;
    }
    function pm(n, a) {
      hs(), um[cm++] = nu, um[cm++] = tu, tu = n, nu = a;
    }
    function d_(n, a, f) {
      hs(), ps[Co++] = dm, ps[Co++] = fm, ps[Co++] = ru, ru = n;
      var m = dm,
        b = fm,
        T = Yb(m) - 1,
        M = m & ~(1 << T),
        z = f + 1,
        U = Yb(a) + T;
      if (U > 30) {
        var X = T - T % 5,
          J = (1 << X) - 1,
          me = (M & J).toString(32),
          Se = M >> X,
          Me = T - X,
          Pe = Yb(a) + Me,
          $e = z << Me,
          mt = $e | Se,
          Re = me + b;
        dm = 1 << Pe | mt, fm = Re;
      } else {
        var Ue = z << T,
          Be = Ue | M,
          nt = b;
        dm = 1 << U | Be, fm = nt;
      }
    }
    function vC(n) {
      hs();
      var a = n.return;
      if (a !== null) {
        var f = 1,
          m = 0;
        pm(n, f), d_(n, f, m);
      }
    }
    function Yb(n) {
      return 32 - Mn(n);
    }
    function EP(n) {
      return 1 << Yb(n) - 1;
    }
    function gC(n) {
      for (; n === tu;) tu = um[--cm], um[cm] = null, nu = um[--cm], um[cm] = null;
      for (; n === ru;) ru = ps[--Co], ps[Co] = null, fm = ps[--Co], ps[Co] = null, dm = ps[--Co], ps[Co] = null;
    }
    function xy() {
      return hs(), ru !== null ? {
        id: dm,
        overflow: fm
      } : null;
    }
    function el(n, a) {
      hs(), ps[Co++] = dm, ps[Co++] = fm, ps[Co++] = ru, dm = a.id, fm = a.overflow, ru = n;
    }
    function hs() {
      tl() || h("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var Ai = null,
      ms = null,
      vs = !1,
      Sy = !1,
      hm = null;
    function CP() {
      vs && h("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function xD() {
      Sy = !0;
    }
    function kP() {
      return Sy;
    }
    function SD(n) {
      var a = n.stateNode.containerInfo;
      return ms = rP(a), Ai = n, vs = !0, hm = null, Sy = !1, !0;
    }
    function ED(n, a, f) {
      return ms = iP(a), Ai = n, vs = !0, hm = null, Sy = !1, f !== null && el(n, f), !0;
    }
    function SS(n, a) {
      switch (n.tag) {
        case C:
          {
            pP(n.stateNode.containerInfo, a);
            break;
          }
        case D:
          {
            var f = (n.mode & Wt) !== dt;
            mP(n.type, n.memoizedProps, n.stateNode, a,
            // TODO: Delete this argument when we remove the legacy root API.
            f);
            break;
          }
        case V:
          {
            var m = n.memoizedState;
            m.dehydrated !== null && hP(m.dehydrated, a);
            break;
          }
      }
    }
    function yC(n, a) {
      SS(n, a);
      var f = UA();
      f.stateNode = a, f.return = n;
      var m = n.deletions;
      m === null ? (n.deletions = [f], n.flags |= _i) : m.push(f);
    }
    function ES(n, a) {
      {
        if (Sy) return;
        switch (n.tag) {
          case C:
            {
              var f = n.stateNode.containerInfo;
              switch (a.tag) {
                case D:
                  var m = a.type;
                  a.pendingProps, vP(f, m);
                  break;
                case I:
                  var b = a.pendingProps;
                  gP(f, b);
                  break;
              }
              break;
            }
          case D:
            {
              var T = n.type,
                M = n.memoizedProps,
                z = n.stateNode;
              switch (a.tag) {
                case D:
                  {
                    var U = a.type,
                      X = a.pendingProps,
                      J = (n.mode & Wt) !== dt;
                    wP(T, M, z, U, X,
                    // TODO: Delete this argument when we remove the legacy root API.
                    J);
                    break;
                  }
                case I:
                  {
                    var me = a.pendingProps,
                      Se = (n.mode & Wt) !== dt;
                    _P(T, M, z, me,
                    // TODO: Delete this argument when we remove the legacy root API.
                    Se);
                    break;
                  }
              }
              break;
            }
          case V:
            {
              var Me = n.memoizedState,
                Pe = Me.dehydrated;
              if (Pe !== null) switch (a.tag) {
                case D:
                  var $e = a.type;
                  a.pendingProps, yP(Pe, $e);
                  break;
                case I:
                  var mt = a.pendingProps;
                  bP(Pe, mt);
                  break;
              }
              break;
            }
          default:
            return;
        }
      }
    }
    function CS(n, a) {
      a.flags = a.flags & -4097 | Gn, ES(n, a);
    }
    function kS(n, a) {
      switch (n.tag) {
        case D:
          {
            var f = n.type;
            n.pendingProps;
            var m = tP(a, f);
            return m !== null ? (n.stateNode = m, Ai = n, ms = nP(m), !0) : !1;
          }
        case I:
          {
            var b = n.pendingProps,
              T = vD(a, b);
            return T !== null ? (n.stateNode = T, Ai = n, ms = null, !0) : !1;
          }
        case V:
          {
            var M = cC(a);
            if (M !== null) {
              var z = {
                dehydrated: M,
                treeContext: xy(),
                retryLane: Jr
              };
              n.memoizedState = z;
              var U = NI(M);
              return U.return = n, n.child = U, Ai = n, ms = null, !0;
            }
            return !1;
          }
        default:
          return !1;
      }
    }
    function f_(n) {
      return (n.mode & Wt) !== dt && (n.flags & ft) === pt;
    }
    function bC(n) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function wC(n) {
      if (vs) {
        var a = ms;
        if (!a) {
          f_(n) && (ES(Ai, n), bC()), CS(Ai, n), vs = !1, Ai = n;
          return;
        }
        var f = a;
        if (!kS(n, a)) {
          f_(n) && (ES(Ai, n), bC()), a = r_(f);
          var m = Ai;
          if (!a || !kS(n, a)) {
            CS(Ai, n), vs = !1, Ai = n;
            return;
          }
          yC(m, f);
        }
      }
    }
    function TP(n, a, f) {
      var m = n.stateNode,
        b = !Sy,
        T = aP(m, n.type, n.memoizedProps, a, f, n, b);
      return n.updateQueue = T, T !== null;
    }
    function RP(n) {
      var a = n.stateNode,
        f = n.memoizedProps,
        m = oP(a, f, n);
      if (m) {
        var b = Ai;
        if (b !== null) switch (b.tag) {
          case C:
            {
              var T = b.stateNode.containerInfo,
                M = (b.mode & Wt) !== dt;
              dP(T, a, f,
              // TODO: Delete this argument when we remove the legacy root API.
              M);
              break;
            }
          case D:
            {
              var z = b.type,
                U = b.memoizedProps,
                X = b.stateNode,
                J = (b.mode & Wt) !== dt;
              fP(z, U, X, a, f,
              // TODO: Delete this argument when we remove the legacy root API.
              J);
              break;
            }
        }
      }
      return m;
    }
    function CD(n) {
      var a = n.memoizedState,
        f = a !== null ? a.dehydrated : null;
      if (!f) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      yD(f, n);
    }
    function TS(n) {
      var a = n.memoizedState,
        f = a !== null ? a.dehydrated : null;
      if (!f) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return sP(f);
    }
    function kD(n) {
      for (var a = n.return; a !== null && a.tag !== D && a.tag !== C && a.tag !== V;) a = a.return;
      Ai = a;
    }
    function p_(n) {
      if (n !== Ai) return !1;
      if (!vs) return kD(n), vs = !0, !1;
      if (n.tag !== C && (n.tag !== D || cP(n.type) && !aC(n.type, n.memoizedProps))) {
        var a = ms;
        if (a) if (f_(n)) _C(n), bC();else for (; a;) yC(n, a), a = r_(a);
      }
      return kD(n), n.tag === V ? ms = TS(n) : ms = Ai ? r_(n.stateNode) : null, !0;
    }
    function Gb() {
      return vs && ms !== null;
    }
    function _C(n) {
      for (var a = ms; a;) SS(n, a), a = r_(a);
    }
    function Pa() {
      Ai = null, ms = null, vs = !1, Sy = !1;
    }
    function RS() {
      hm !== null && (Rk(hm), hm = null);
    }
    function tl() {
      return vs;
    }
    function xC(n) {
      hm === null ? hm = [n] : hm.push(n);
    }
    var DP = i.ReactCurrentBatchConfig,
      Mf = null;
    function IP() {
      return DP.transition;
    }
    var nl = {
      recordUnsafeLifecycleWarnings: function (n, a) {},
      flushPendingUnsafeLifecycleWarnings: function () {},
      recordLegacyContextWarning: function (n, a) {},
      flushLegacyContextWarning: function () {},
      discardPendingWarnings: function () {}
    };
    {
      var h_ = function (n) {
          for (var a = null, f = n; f !== null;) f.mode & Xn && (a = f), f = f.return;
          return a;
        },
        Of = function (n) {
          var a = [];
          return n.forEach(function (f) {
            a.push(f);
          }), a.sort().join(", ");
        },
        mm = [],
        vm = [],
        gm = [],
        ym = [],
        Lf = [],
        gv = [],
        yv = /* @__PURE__ */new Set();
      nl.recordUnsafeLifecycleWarnings = function (n, a) {
        yv.has(n.type) || (typeof a.componentWillMount == "function" &&
        // Don't warn about react-lifecycles-compat polyfilled components.
        a.componentWillMount.__suppressDeprecationWarning !== !0 && mm.push(n), n.mode & Xn && typeof a.UNSAFE_componentWillMount == "function" && vm.push(n), typeof a.componentWillReceiveProps == "function" && a.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && gm.push(n), n.mode & Xn && typeof a.UNSAFE_componentWillReceiveProps == "function" && ym.push(n), typeof a.componentWillUpdate == "function" && a.componentWillUpdate.__suppressDeprecationWarning !== !0 && Lf.push(n), n.mode & Xn && typeof a.UNSAFE_componentWillUpdate == "function" && gv.push(n));
      }, nl.flushPendingUnsafeLifecycleWarnings = function () {
        var n = /* @__PURE__ */new Set();
        mm.length > 0 && (mm.forEach(function (Se) {
          n.add(At(Se) || "Component"), yv.add(Se.type);
        }), mm = []);
        var a = /* @__PURE__ */new Set();
        vm.length > 0 && (vm.forEach(function (Se) {
          a.add(At(Se) || "Component"), yv.add(Se.type);
        }), vm = []);
        var f = /* @__PURE__ */new Set();
        gm.length > 0 && (gm.forEach(function (Se) {
          f.add(At(Se) || "Component"), yv.add(Se.type);
        }), gm = []);
        var m = /* @__PURE__ */new Set();
        ym.length > 0 && (ym.forEach(function (Se) {
          m.add(At(Se) || "Component"), yv.add(Se.type);
        }), ym = []);
        var b = /* @__PURE__ */new Set();
        Lf.length > 0 && (Lf.forEach(function (Se) {
          b.add(At(Se) || "Component"), yv.add(Se.type);
        }), Lf = []);
        var T = /* @__PURE__ */new Set();
        if (gv.length > 0 && (gv.forEach(function (Se) {
          T.add(At(Se) || "Component"), yv.add(Se.type);
        }), gv = []), a.size > 0) {
          var M = Of(a);
          h(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, M);
        }
        if (m.size > 0) {
          var z = Of(m);
          h(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, z);
        }
        if (T.size > 0) {
          var U = Of(T);
          h(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, U);
        }
        if (n.size > 0) {
          var X = Of(n);
          p(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, X);
        }
        if (f.size > 0) {
          var J = Of(f);
          p(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, J);
        }
        if (b.size > 0) {
          var me = Of(b);
          p(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, me);
        }
      };
      var mu = /* @__PURE__ */new Map(),
        DS = /* @__PURE__ */new Set();
      nl.recordLegacyContextWarning = function (n, a) {
        var f = h_(n);
        if (f === null) {
          h("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!DS.has(n.type)) {
          var m = mu.get(f);
          (n.type.contextTypes != null || n.type.childContextTypes != null || a !== null && typeof a.getChildContext == "function") && (m === void 0 && (m = [], mu.set(f, m)), m.push(n));
        }
      }, nl.flushLegacyContextWarning = function () {
        mu.forEach(function (n, a) {
          if (n.length !== 0) {
            var f = n[0],
              m = /* @__PURE__ */new Set();
            n.forEach(function (T) {
              m.add(At(T) || "Component"), DS.add(T.type);
            });
            var b = Of(m);
            try {
              Rn(f), h(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, b);
            } finally {
              Un();
            }
          }
        });
      }, nl.discardPendingWarnings = function () {
        mm = [], vm = [], gm = [], ym = [], Lf = [], gv = [], mu = /* @__PURE__ */new Map();
      };
    }
    function wc(n, a) {
      if (n && n.defaultProps) {
        var f = Qt({}, a),
          m = n.defaultProps;
        for (var b in m) f[b] === void 0 && (f[b] = m[b]);
        return f;
      }
      return a;
    }
    var Xb = ka(null),
      bv;
    bv = {};
    var Kb = null,
      bm = null,
      Qb = null,
      m_ = !1;
    function v_() {
      Kb = null, bm = null, Qb = null, m_ = !1;
    }
    function SC() {
      m_ = !0;
    }
    function IS() {
      m_ = !1;
    }
    function MS(n, a, f) {
      fi(Xb, a._currentValue, n), a._currentValue = f, a._currentRenderer !== void 0 && a._currentRenderer !== null && a._currentRenderer !== bv && h("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), a._currentRenderer = bv;
    }
    function EC(n, a) {
      var f = Xb.current;
      fs(Xb, a), n._currentValue = f;
    }
    function CC(n, a, f) {
      for (var m = n; m !== null;) {
        var b = m.alternate;
        if ($s(m.childLanes, a) ? b !== null && !$s(b.childLanes, a) && (b.childLanes = jt(b.childLanes, a)) : (m.childLanes = jt(m.childLanes, a), b !== null && (b.childLanes = jt(b.childLanes, a))), m === f) break;
        m = m.return;
      }
      m !== f && h("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function Zb(n, a, f) {
      ko(n, a, f);
    }
    function ko(n, a, f) {
      var m = n.child;
      for (m !== null && (m.return = n); m !== null;) {
        var b = void 0,
          T = m.dependencies;
        if (T !== null) {
          b = m.child;
          for (var M = T.firstContext; M !== null;) {
            if (M.context === a) {
              if (m.tag === x) {
                var z = Xl(f),
                  U = Hc(wn, z);
                U.tag = Cy;
                var X = m.updateQueue;
                if (X !== null) {
                  var J = X.shared,
                    me = J.pending;
                  me === null ? U.next = U : (U.next = me.next, me.next = U), J.pending = U;
                }
              }
              m.lanes = jt(m.lanes, f);
              var Se = m.alternate;
              Se !== null && (Se.lanes = jt(Se.lanes, f)), CC(m.return, f, n), T.lanes = jt(T.lanes, f);
              break;
            }
            M = M.next;
          }
        } else if (m.tag === L) b = m.type === n.type ? null : m.child;else if (m.tag === ie) {
          var Me = m.return;
          if (Me === null) throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          Me.lanes = jt(Me.lanes, f);
          var Pe = Me.alternate;
          Pe !== null && (Pe.lanes = jt(Pe.lanes, f)), CC(Me, f, n), b = m.sibling;
        } else b = m.child;
        if (b !== null) b.return = m;else for (b = m; b !== null;) {
          if (b === n) {
            b = null;
            break;
          }
          var $e = b.sibling;
          if ($e !== null) {
            $e.return = b.return, b = $e;
            break;
          }
          b = b.return;
        }
        m = b;
      }
    }
    function Uc(n, a) {
      Kb = n, bm = null, Qb = null;
      var f = n.dependencies;
      if (f !== null) {
        var m = f.firstContext;
        m !== null && (_n(f.lanes, a) && Hy(), f.firstContext = null);
      }
    }
    function Aa(n) {
      m_ && h("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var a = n._currentValue;
      if (Qb !== n) {
        var f = {
          context: n,
          memoizedValue: a,
          next: null
        };
        if (bm === null) {
          if (Kb === null) throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          bm = f, Kb.dependencies = {
            lanes: De,
            firstContext: f
          };
        } else bm = bm.next = f;
      }
      return a;
    }
    var Ey = null;
    function OS(n) {
      Ey === null ? Ey = [n] : Ey.push(n);
    }
    function MP() {
      if (Ey !== null) {
        for (var n = 0; n < Ey.length; n++) {
          var a = Ey[n],
            f = a.interleaved;
          if (f !== null) {
            a.interleaved = null;
            var m = f.next,
              b = a.pending;
            if (b !== null) {
              var T = b.next;
              b.next = m, f.next = T;
            }
            a.pending = f;
          }
        }
        Ey = null;
      }
    }
    function TD(n, a, f, m) {
      var b = a.interleaved;
      return b === null ? (f.next = f, OS(a)) : (f.next = b.next, b.next = f), a.interleaved = f, g_(n, m);
    }
    function vu(n, a, f, m) {
      var b = a.interleaved;
      b === null ? (f.next = f, OS(a)) : (f.next = b.next, b.next = f), a.interleaved = f;
    }
    function OP(n, a, f, m) {
      var b = a.interleaved;
      return b === null ? (f.next = f, OS(a)) : (f.next = b.next, b.next = f), a.interleaved = f, g_(n, m);
    }
    function rl(n, a) {
      return g_(n, a);
    }
    var RD = g_;
    function g_(n, a) {
      n.lanes = jt(n.lanes, a);
      var f = n.alternate;
      f !== null && (f.lanes = jt(f.lanes, a)), f === null && (n.flags & (Gn | xi)) !== pt && R1(n);
      for (var m = n, b = n.return; b !== null;) b.childLanes = jt(b.childLanes, a), f = b.alternate, f !== null ? f.childLanes = jt(f.childLanes, a) : (b.flags & (Gn | xi)) !== pt && R1(n), m = b, b = b.return;
      if (m.tag === C) {
        var T = m.stateNode;
        return T;
      } else return null;
    }
    var y_ = 0,
      LS = 1,
      Cy = 2,
      b_ = 3,
      ky = !1,
      w_,
      __;
    w_ = !1, __ = null;
    function Pf(n) {
      var a = {
        baseState: n.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: De
        },
        effects: null
      };
      n.updateQueue = a;
    }
    function wm(n, a) {
      var f = a.updateQueue,
        m = n.updateQueue;
      if (f === m) {
        var b = {
          baseState: m.baseState,
          firstBaseUpdate: m.firstBaseUpdate,
          lastBaseUpdate: m.lastBaseUpdate,
          shared: m.shared,
          effects: m.effects
        };
        a.updateQueue = b;
      }
    }
    function Hc(n, a) {
      var f = {
        eventTime: n,
        lane: a,
        tag: y_,
        payload: null,
        callback: null,
        next: null
      };
      return f;
    }
    function mp(n, a, f) {
      var m = n.updateQueue;
      if (m === null) return null;
      var b = m.shared;
      if (__ === b && !w_ && (h("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), w_ = !0), _I()) {
        var T = b.pending;
        return T === null ? a.next = a : (a.next = T.next, T.next = a), b.pending = a, RD(n, f);
      } else return OP(n, b, a, f);
    }
    function PS(n, a, f) {
      var m = a.updateQueue;
      if (m !== null) {
        var b = m.shared;
        if (zh(f)) {
          var T = b.lanes;
          T = Bh(T, n.pendingLanes);
          var M = jt(T, f);
          b.lanes = M, df(n, M);
        }
      }
    }
    function Jb(n, a) {
      var f = n.updateQueue,
        m = n.alternate;
      if (m !== null) {
        var b = m.updateQueue;
        if (f === b) {
          var T = null,
            M = null,
            z = f.firstBaseUpdate;
          if (z !== null) {
            var U = z;
            do {
              var X = {
                eventTime: U.eventTime,
                lane: U.lane,
                tag: U.tag,
                payload: U.payload,
                callback: U.callback,
                next: null
              };
              M === null ? T = M = X : (M.next = X, M = X), U = U.next;
            } while (U !== null);
            M === null ? T = M = a : (M.next = a, M = a);
          } else T = M = a;
          f = {
            baseState: b.baseState,
            firstBaseUpdate: T,
            lastBaseUpdate: M,
            shared: b.shared,
            effects: b.effects
          }, n.updateQueue = f;
          return;
        }
      }
      var J = f.lastBaseUpdate;
      J === null ? f.firstBaseUpdate = a : J.next = a, f.lastBaseUpdate = a;
    }
    function LP(n, a, f, m, b, T) {
      switch (f.tag) {
        case LS:
          {
            var M = f.payload;
            if (typeof M == "function") {
              SC();
              var z = M.call(T, m, b);
              {
                if (n.mode & Xn) {
                  En(!0);
                  try {
                    M.call(T, m, b);
                  } finally {
                    En(!1);
                  }
                }
                IS();
              }
              return z;
            }
            return M;
          }
        case b_:
          n.flags = n.flags & -65537 | ft;
        // Intentional fallthrough
        case y_:
          {
            var U = f.payload,
              X;
            if (typeof U == "function") {
              SC(), X = U.call(T, m, b);
              {
                if (n.mode & Xn) {
                  En(!0);
                  try {
                    U.call(T, m, b);
                  } finally {
                    En(!1);
                  }
                }
                IS();
              }
            } else X = U;
            return X == null ? m : Qt({}, m, X);
          }
        case Cy:
          return ky = !0, m;
      }
      return m;
    }
    function x_(n, a, f, m) {
      var b = n.updateQueue;
      ky = !1, __ = b.shared;
      var T = b.firstBaseUpdate,
        M = b.lastBaseUpdate,
        z = b.shared.pending;
      if (z !== null) {
        b.shared.pending = null;
        var U = z,
          X = U.next;
        U.next = null, M === null ? T = X : M.next = X, M = U;
        var J = n.alternate;
        if (J !== null) {
          var me = J.updateQueue,
            Se = me.lastBaseUpdate;
          Se !== M && (Se === null ? me.firstBaseUpdate = X : Se.next = X, me.lastBaseUpdate = U);
        }
      }
      if (T !== null) {
        var Me = b.baseState,
          Pe = De,
          $e = null,
          mt = null,
          Re = null,
          Ue = T;
        do {
          var Be = Ue.lane,
            nt = Ue.eventTime;
          if ($s(m, Be)) {
            if (Re !== null) {
              var Fe = {
                eventTime: nt,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: On,
                tag: Ue.tag,
                payload: Ue.payload,
                callback: Ue.callback,
                next: null
              };
              Re = Re.next = Fe;
            }
            Me = LP(n, b, Ue, Me, a, f);
            var Ie = Ue.callback;
            if (Ie !== null &&
            // If the update was already committed, we should not queue its
            // callback again.
            Ue.lane !== On) {
              n.flags |= Sn;
              var Qe = b.effects;
              Qe === null ? b.effects = [Ue] : Qe.push(Ue);
            }
          } else {
            var ke = {
              eventTime: nt,
              lane: Be,
              tag: Ue.tag,
              payload: Ue.payload,
              callback: Ue.callback,
              next: null
            };
            Re === null ? (mt = Re = ke, $e = Me) : Re = Re.next = ke, Pe = jt(Pe, Be);
          }
          if (Ue = Ue.next, Ue === null) {
            if (z = b.shared.pending, z === null) break;
            var Tt = z,
              _t = Tt.next;
            Tt.next = null, Ue = _t, b.lastBaseUpdate = Tt, b.shared.pending = null;
          }
        } while (!0);
        Re === null && ($e = Me), b.baseState = $e, b.firstBaseUpdate = mt, b.lastBaseUpdate = Re;
        var an = b.shared.interleaved;
        if (an !== null) {
          var Gt = an;
          do Pe = jt(Pe, Gt.lane), Gt = Gt.next; while (Gt !== an);
        } else T === null && (b.shared.lanes = De);
        xx(Pe), n.lanes = Pe, n.memoizedState = Me;
      }
      __ = null;
    }
    function AS(n, a) {
      if (typeof n != "function") throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + n));
      n.call(a);
    }
    function kC() {
      ky = !1;
    }
    function e0() {
      return ky;
    }
    function TC(n, a, f) {
      var m = a.effects;
      if (a.effects = null, m !== null) for (var b = 0; b < m.length; b++) {
        var T = m[b],
          M = T.callback;
        M !== null && (T.callback = null, AS(M, f));
      }
    }
    var S_ = {},
      jS = new t.Component().refs,
      E_,
      C_,
      k_,
      FS,
      t0,
      NS,
      n0,
      T_,
      zS,
      R_;
    {
      E_ = /* @__PURE__ */new Set(), C_ = /* @__PURE__ */new Set(), k_ = /* @__PURE__ */new Set(), FS = /* @__PURE__ */new Set(), T_ = /* @__PURE__ */new Set(), t0 = /* @__PURE__ */new Set(), zS = /* @__PURE__ */new Set(), R_ = /* @__PURE__ */new Set();
      var VS = /* @__PURE__ */new Set();
      n0 = function (n, a) {
        if (!(n === null || typeof n == "function")) {
          var f = a + "_" + n;
          VS.has(f) || (VS.add(f), h("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", a, n));
        }
      }, NS = function (n, a) {
        if (a === void 0) {
          var f = bn(n) || "Component";
          t0.has(f) || (t0.add(f), h("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", f));
        }
      }, Object.defineProperty(S_, "_processChildContext", {
        enumerable: !1,
        value: function () {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(S_);
    }
    function BS(n, a, f, m) {
      var b = n.memoizedState,
        T = f(m, b);
      {
        if (n.mode & Xn) {
          En(!0);
          try {
            T = f(m, b);
          } finally {
            En(!1);
          }
        }
        NS(a, T);
      }
      var M = T == null ? b : Qt({}, b, T);
      if (n.memoizedState = M, n.lanes === De) {
        var z = n.updateQueue;
        z.baseState = M;
      }
    }
    var RC = {
      isMounted: jg,
      enqueueSetState: function (n, a, f) {
        var m = Pl(n),
          b = au(),
          T = jv(m),
          M = Hc(b, T);
        M.payload = a, f != null && (n0(f, "setState"), M.callback = f);
        var z = mp(m, M, T);
        z !== null && (To(z, m, T, b), PS(z, m, T)), Bs(m, T);
      },
      enqueueReplaceState: function (n, a, f) {
        var m = Pl(n),
          b = au(),
          T = jv(m),
          M = Hc(b, T);
        M.tag = LS, M.payload = a, f != null && (n0(f, "replaceState"), M.callback = f);
        var z = mp(m, M, T);
        z !== null && (To(z, m, T, b), PS(z, m, T)), Bs(m, T);
      },
      enqueueForceUpdate: function (n, a) {
        var f = Pl(n),
          m = au(),
          b = jv(f),
          T = Hc(m, b);
        T.tag = Cy, a != null && (n0(a, "forceUpdate"), T.callback = a);
        var M = mp(f, T, b);
        M !== null && (To(M, f, b, m), PS(M, f, b)), Qu(f, b);
      }
    };
    function DC(n, a, f, m, b, T, M) {
      var z = n.stateNode;
      if (typeof z.shouldComponentUpdate == "function") {
        var U = z.shouldComponentUpdate(m, T, M);
        {
          if (n.mode & Xn) {
            En(!0);
            try {
              U = z.shouldComponentUpdate(m, T, M);
            } finally {
              En(!1);
            }
          }
          U === void 0 && h("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", bn(a) || "Component");
        }
        return U;
      }
      return a.prototype && a.prototype.isPureReactComponent ? !He(f, m) || !He(b, T) : !0;
    }
    function DD(n, a, f) {
      var m = n.stateNode;
      {
        var b = bn(a) || "Component",
          T = m.render;
        T || (a.prototype && typeof a.prototype.render == "function" ? h("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", b) : h("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", b)), m.getInitialState && !m.getInitialState.isReactClassApproved && !m.state && h("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", b), m.getDefaultProps && !m.getDefaultProps.isReactClassApproved && h("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", b), m.propTypes && h("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", b), m.contextType && h("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", b), m.contextTypes && h("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", b), a.contextType && a.contextTypes && !zS.has(a) && (zS.add(a), h("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", b)), typeof m.componentShouldUpdate == "function" && h("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", b), a.prototype && a.prototype.isPureReactComponent && typeof m.shouldComponentUpdate < "u" && h("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", bn(a) || "A pure component"), typeof m.componentDidUnmount == "function" && h("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", b), typeof m.componentDidReceiveProps == "function" && h("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", b), typeof m.componentWillRecieveProps == "function" && h("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", b), typeof m.UNSAFE_componentWillRecieveProps == "function" && h("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", b);
        var M = m.props !== f;
        m.props !== void 0 && M && h("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", b, b), m.defaultProps && h("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", b, b), typeof m.getSnapshotBeforeUpdate == "function" && typeof m.componentDidUpdate != "function" && !k_.has(a) && (k_.add(a), h("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", bn(a))), typeof m.getDerivedStateFromProps == "function" && h("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", b), typeof m.getDerivedStateFromError == "function" && h("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", b), typeof a.getSnapshotBeforeUpdate == "function" && h("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", b);
        var z = m.state;
        z && (typeof z != "object" || wr(z)) && h("%s.state: must be set to an object or null", b), typeof m.getChildContext == "function" && typeof a.childContextTypes != "object" && h("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", b);
      }
    }
    function ID(n, a) {
      a.updater = RC, n.stateNode = a, Fs(a, n), a._reactInternalInstance = S_;
    }
    function IC(n, a, f) {
      var m = !1,
        b = La,
        T = La,
        M = a.contextType;
      if ("contextType" in a) {
        var z =
        // Allow null for conditional declaration
        M === null || M !== void 0 && M.$$typeof === Ne && M._context === void 0;
        if (!z && !R_.has(a)) {
          R_.add(a);
          var U = "";
          M === void 0 ? U = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof M != "object" ? U = " However, it is set to a " + typeof M + "." : M.$$typeof === Z ? U = " Did you accidentally pass the Context.Provider instead?" : M._context !== void 0 ? U = " Did you accidentally pass the Context.Consumer instead?" : U = " However, it is set to an object with keys {" + Object.keys(M).join(", ") + "}.", h("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", bn(a) || "Component", U);
        }
      }
      if (typeof M == "object" && M !== null) T = Aa(M);else {
        b = Df(n, a, !0);
        var X = a.contextTypes;
        m = X != null, T = m ? eu(n, b) : La;
      }
      var J = new a(f, T);
      if (n.mode & Xn) {
        En(!0);
        try {
          J = new a(f, T);
        } finally {
          En(!1);
        }
      }
      var me = n.memoizedState = J.state !== null && J.state !== void 0 ? J.state : null;
      ID(n, J);
      {
        if (typeof a.getDerivedStateFromProps == "function" && me === null) {
          var Se = bn(a) || "Component";
          C_.has(Se) || (C_.add(Se), h("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", Se, J.state === null ? "null" : "undefined", Se));
        }
        if (typeof a.getDerivedStateFromProps == "function" || typeof J.getSnapshotBeforeUpdate == "function") {
          var Me = null,
            Pe = null,
            $e = null;
          if (typeof J.componentWillMount == "function" && J.componentWillMount.__suppressDeprecationWarning !== !0 ? Me = "componentWillMount" : typeof J.UNSAFE_componentWillMount == "function" && (Me = "UNSAFE_componentWillMount"), typeof J.componentWillReceiveProps == "function" && J.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? Pe = "componentWillReceiveProps" : typeof J.UNSAFE_componentWillReceiveProps == "function" && (Pe = "UNSAFE_componentWillReceiveProps"), typeof J.componentWillUpdate == "function" && J.componentWillUpdate.__suppressDeprecationWarning !== !0 ? $e = "componentWillUpdate" : typeof J.UNSAFE_componentWillUpdate == "function" && ($e = "UNSAFE_componentWillUpdate"), Me !== null || Pe !== null || $e !== null) {
            var mt = bn(a) || "Component",
              Re = typeof a.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            FS.has(mt) || (FS.add(mt), h(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, mt, Re, Me !== null ? `
  ` + Me : "", Pe !== null ? `
  ` + Pe : "", $e !== null ? `
  ` + $e : ""));
          }
        }
      }
      return m && l_(n, b, T), J;
    }
    function MC(n, a) {
      var f = a.state;
      typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount(), f !== a.state && (h("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", At(n) || "Component"), RC.enqueueReplaceState(a, a.state, null));
    }
    function MD(n, a, f, m) {
      var b = a.state;
      if (typeof a.componentWillReceiveProps == "function" && a.componentWillReceiveProps(f, m), typeof a.UNSAFE_componentWillReceiveProps == "function" && a.UNSAFE_componentWillReceiveProps(f, m), a.state !== b) {
        {
          var T = At(n) || "Component";
          E_.has(T) || (E_.add(T), h("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", T));
        }
        RC.enqueueReplaceState(a, a.state, null);
      }
    }
    function OC(n, a, f, m) {
      DD(n, a, f);
      var b = n.stateNode;
      b.props = f, b.state = n.memoizedState, b.refs = jS, Pf(n);
      var T = a.contextType;
      if (typeof T == "object" && T !== null) b.context = Aa(T);else {
        var M = Df(n, a, !0);
        b.context = eu(n, M);
      }
      {
        if (b.state === f) {
          var z = bn(a) || "Component";
          T_.has(z) || (T_.add(z), h("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", z));
        }
        n.mode & Xn && nl.recordLegacyContextWarning(n, b), nl.recordUnsafeLifecycleWarnings(n, b);
      }
      b.state = n.memoizedState;
      var U = a.getDerivedStateFromProps;
      if (typeof U == "function" && (BS(n, a, U, f), b.state = n.memoizedState), typeof a.getDerivedStateFromProps != "function" && typeof b.getSnapshotBeforeUpdate != "function" && (typeof b.UNSAFE_componentWillMount == "function" || typeof b.componentWillMount == "function") && (MC(n, b), x_(n, f, b, m), b.state = n.memoizedState), typeof b.componentDidMount == "function") {
        var X = tn;
        X |= Za, (n.mode & Ri) !== dt && (X |= Bo), n.flags |= X;
      }
    }
    function LC(n, a, f, m) {
      var b = n.stateNode,
        T = n.memoizedProps;
      b.props = T;
      var M = b.context,
        z = a.contextType,
        U = La;
      if (typeof z == "object" && z !== null) U = Aa(z);else {
        var X = Df(n, a, !0);
        U = eu(n, X);
      }
      var J = a.getDerivedStateFromProps,
        me = typeof J == "function" || typeof b.getSnapshotBeforeUpdate == "function";
      !me && (typeof b.UNSAFE_componentWillReceiveProps == "function" || typeof b.componentWillReceiveProps == "function") && (T !== f || M !== U) && MD(n, b, f, U), kC();
      var Se = n.memoizedState,
        Me = b.state = Se;
      if (x_(n, f, b, m), Me = n.memoizedState, T === f && Se === Me && !by() && !e0()) {
        if (typeof b.componentDidMount == "function") {
          var Pe = tn;
          Pe |= Za, (n.mode & Ri) !== dt && (Pe |= Bo), n.flags |= Pe;
        }
        return !1;
      }
      typeof J == "function" && (BS(n, a, J, f), Me = n.memoizedState);
      var $e = e0() || DC(n, a, T, f, Se, Me, U);
      if ($e) {
        if (!me && (typeof b.UNSAFE_componentWillMount == "function" || typeof b.componentWillMount == "function") && (typeof b.componentWillMount == "function" && b.componentWillMount(), typeof b.UNSAFE_componentWillMount == "function" && b.UNSAFE_componentWillMount()), typeof b.componentDidMount == "function") {
          var mt = tn;
          mt |= Za, (n.mode & Ri) !== dt && (mt |= Bo), n.flags |= mt;
        }
      } else {
        if (typeof b.componentDidMount == "function") {
          var Re = tn;
          Re |= Za, (n.mode & Ri) !== dt && (Re |= Bo), n.flags |= Re;
        }
        n.memoizedProps = f, n.memoizedState = Me;
      }
      return b.props = f, b.state = Me, b.context = U, $e;
    }
    function PC(n, a, f, m, b) {
      var T = a.stateNode;
      wm(n, a);
      var M = a.memoizedProps,
        z = a.type === a.elementType ? M : wc(a.type, M);
      T.props = z;
      var U = a.pendingProps,
        X = T.context,
        J = f.contextType,
        me = La;
      if (typeof J == "object" && J !== null) me = Aa(J);else {
        var Se = Df(a, f, !0);
        me = eu(a, Se);
      }
      var Me = f.getDerivedStateFromProps,
        Pe = typeof Me == "function" || typeof T.getSnapshotBeforeUpdate == "function";
      !Pe && (typeof T.UNSAFE_componentWillReceiveProps == "function" || typeof T.componentWillReceiveProps == "function") && (M !== U || X !== me) && MD(a, T, m, me), kC();
      var $e = a.memoizedState,
        mt = T.state = $e;
      if (x_(a, m, T, b), mt = a.memoizedState, M === U && $e === mt && !by() && !e0()) return typeof T.componentDidUpdate == "function" && (M !== n.memoizedProps || $e !== n.memoizedState) && (a.flags |= tn), typeof T.getSnapshotBeforeUpdate == "function" && (M !== n.memoizedProps || $e !== n.memoizedState) && (a.flags |= or), !1;
      typeof Me == "function" && (BS(a, f, Me, m), mt = a.memoizedState);
      var Re = e0() || DC(a, f, z, m, $e, mt, me) ||
      // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      le;
      return Re ? (!Pe && (typeof T.UNSAFE_componentWillUpdate == "function" || typeof T.componentWillUpdate == "function") && (typeof T.componentWillUpdate == "function" && T.componentWillUpdate(m, mt, me), typeof T.UNSAFE_componentWillUpdate == "function" && T.UNSAFE_componentWillUpdate(m, mt, me)), typeof T.componentDidUpdate == "function" && (a.flags |= tn), typeof T.getSnapshotBeforeUpdate == "function" && (a.flags |= or)) : (typeof T.componentDidUpdate == "function" && (M !== n.memoizedProps || $e !== n.memoizedState) && (a.flags |= tn), typeof T.getSnapshotBeforeUpdate == "function" && (M !== n.memoizedProps || $e !== n.memoizedState) && (a.flags |= or), a.memoizedProps = m, a.memoizedState = mt), T.props = m, T.state = mt, T.context = me, Re;
    }
    var D_,
      I_,
      M_,
      US,
      Ty,
      O_ = function (n, a) {};
    D_ = !1, I_ = !1, M_ = {}, US = {}, Ty = {}, O_ = function (n, a) {
      if (!(n === null || typeof n != "object") && !(!n._store || n._store.validated || n.key != null)) {
        if (typeof n._store != "object") throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        n._store.validated = !0;
        var f = At(a) || "Component";
        US[f] || (US[f] = !0, h('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function wv(n, a, f) {
      var m = f.ref;
      if (m !== null && typeof m != "function" && typeof m != "object") {
        if ((n.mode & Xn || de) &&
        // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(f._owner && f._self && f._owner.stateNode !== f._self)) {
          var b = At(n) || "Component";
          M_[b] || (h('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', m), M_[b] = !0);
        }
        if (f._owner) {
          var T = f._owner,
            M;
          if (T) {
            var z = T;
            if (z.tag !== x) throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            M = z.stateNode;
          }
          if (!M) throw new Error("Missing owner for string ref " + m + ". This error is likely caused by a bug in React. Please file an issue.");
          var U = M;
          gt(m, "ref");
          var X = "" + m;
          if (a !== null && a.ref !== null && typeof a.ref == "function" && a.ref._stringRef === X) return a.ref;
          var J = function (me) {
            var Se = U.refs;
            Se === jS && (Se = U.refs = {}), me === null ? delete Se[X] : Se[X] = me;
          };
          return J._stringRef = X, J;
        } else {
          if (typeof m != "string") throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!f._owner) throw new Error("Element ref was specified as a string (" + m + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return m;
    }
    function L_(n, a) {
      var f = Object.prototype.toString.call(a);
      throw new Error("Objects are not valid as a React child (found: " + (f === "[object Object]" ? "object with keys {" + Object.keys(a).join(", ") + "}" : f) + "). If you meant to render a collection of children, use an array instead.");
    }
    function P_(n) {
      {
        var a = At(n) || "Component";
        if (Ty[a]) return;
        Ty[a] = !0, h("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function Ry(n) {
      var a = n._payload,
        f = n._init;
      return f(a);
    }
    function AC(n) {
      function a(ke, Fe) {
        if (n) {
          var Ie = ke.deletions;
          Ie === null ? (ke.deletions = [Fe], ke.flags |= _i) : Ie.push(Fe);
        }
      }
      function f(ke, Fe) {
        if (!n) return null;
        for (var Ie = Fe; Ie !== null;) a(ke, Ie), Ie = Ie.sibling;
        return null;
      }
      function m(ke, Fe) {
        for (var Ie = /* @__PURE__ */new Map(), Qe = Fe; Qe !== null;) Qe.key !== null ? Ie.set(Qe.key, Qe) : Ie.set(Qe.index, Qe), Qe = Qe.sibling;
        return Ie;
      }
      function b(ke, Fe) {
        var Ie = Om(ke, Fe);
        return Ie.index = 0, Ie.sibling = null, Ie;
      }
      function T(ke, Fe, Ie) {
        if (ke.index = Ie, !n) return ke.flags |= va, Fe;
        var Qe = ke.alternate;
        if (Qe !== null) {
          var Tt = Qe.index;
          return Tt < Fe ? (ke.flags |= Gn, Fe) : Tt;
        } else return ke.flags |= Gn, Fe;
      }
      function M(ke) {
        return n && ke.alternate === null && (ke.flags |= Gn), ke;
      }
      function z(ke, Fe, Ie, Qe) {
        if (Fe === null || Fe.tag !== I) {
          var Tt = O1(Ie, ke.mode, Qe);
          return Tt.return = ke, Tt;
        } else {
          var _t = b(Fe, Ie);
          return _t.return = ke, _t;
        }
      }
      function U(ke, Fe, Ie, Qe) {
        var Tt = Ie.type;
        if (Tt === Oo) return J(ke, Fe, Ie.props.children, Qe, Ie.key);
        if (Fe !== null && (Fe.elementType === Tt ||
        // Keep this check inline so it only runs on the false path:
        I1(Fe, Ie) ||
        // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof Tt == "object" && Tt !== null && Tt.$$typeof === Ct && Ry(Tt) === Fe.type)) {
          var _t = b(Fe, Ie.props);
          return _t.ref = wv(ke, Fe, Ie), _t.return = ke, _t._debugSource = Ie._source, _t._debugOwner = Ie._owner, _t;
        }
        var an = Wk(Ie, ke.mode, Qe);
        return an.ref = wv(ke, Fe, Ie), an.return = ke, an;
      }
      function X(ke, Fe, Ie, Qe) {
        if (Fe === null || Fe.tag !== k || Fe.stateNode.containerInfo !== Ie.containerInfo || Fe.stateNode.implementation !== Ie.implementation) {
          var Tt = Rx(Ie, ke.mode, Qe);
          return Tt.return = ke, Tt;
        } else {
          var _t = b(Fe, Ie.children || []);
          return _t.return = ke, _t;
        }
      }
      function J(ke, Fe, Ie, Qe, Tt) {
        if (Fe === null || Fe.tag !== O) {
          var _t = Lm(Ie, ke.mode, Qe, Tt);
          return _t.return = ke, _t;
        } else {
          var an = b(Fe, Ie);
          return an.return = ke, an;
        }
      }
      function me(ke, Fe, Ie) {
        if (typeof Fe == "string" && Fe !== "" || typeof Fe == "number") {
          var Qe = O1("" + Fe, ke.mode, Ie);
          return Qe.return = ke, Qe;
        }
        if (typeof Fe == "object" && Fe !== null) {
          switch (Fe.$$typeof) {
            case $i:
              {
                var Tt = Wk(Fe, ke.mode, Ie);
                return Tt.ref = wv(ke, null, Fe), Tt.return = ke, Tt;
              }
            case oi:
              {
                var _t = Rx(Fe, ke.mode, Ie);
                return _t.return = ke, _t;
              }
            case Ct:
              {
                var an = Fe._payload,
                  Gt = Fe._init;
                return me(ke, Gt(an), Ie);
              }
          }
          if (wr(Fe) || yn(Fe)) {
            var Pn = Lm(Fe, ke.mode, Ie, null);
            return Pn.return = ke, Pn;
          }
          L_(ke, Fe);
        }
        return typeof Fe == "function" && P_(ke), null;
      }
      function Se(ke, Fe, Ie, Qe) {
        var Tt = Fe !== null ? Fe.key : null;
        if (typeof Ie == "string" && Ie !== "" || typeof Ie == "number") return Tt !== null ? null : z(ke, Fe, "" + Ie, Qe);
        if (typeof Ie == "object" && Ie !== null) {
          switch (Ie.$$typeof) {
            case $i:
              return Ie.key === Tt ? U(ke, Fe, Ie, Qe) : null;
            case oi:
              return Ie.key === Tt ? X(ke, Fe, Ie, Qe) : null;
            case Ct:
              {
                var _t = Ie._payload,
                  an = Ie._init;
                return Se(ke, Fe, an(_t), Qe);
              }
          }
          if (wr(Ie) || yn(Ie)) return Tt !== null ? null : J(ke, Fe, Ie, Qe, null);
          L_(ke, Ie);
        }
        return typeof Ie == "function" && P_(ke), null;
      }
      function Me(ke, Fe, Ie, Qe, Tt) {
        if (typeof Qe == "string" && Qe !== "" || typeof Qe == "number") {
          var _t = ke.get(Ie) || null;
          return z(Fe, _t, "" + Qe, Tt);
        }
        if (typeof Qe == "object" && Qe !== null) {
          switch (Qe.$$typeof) {
            case $i:
              {
                var an = ke.get(Qe.key === null ? Ie : Qe.key) || null;
                return U(Fe, an, Qe, Tt);
              }
            case oi:
              {
                var Gt = ke.get(Qe.key === null ? Ie : Qe.key) || null;
                return X(Fe, Gt, Qe, Tt);
              }
            case Ct:
              var Pn = Qe._payload,
                Fn = Qe._init;
              return Me(ke, Fe, Ie, Fn(Pn), Tt);
          }
          if (wr(Qe) || yn(Qe)) {
            var kr = ke.get(Ie) || null;
            return J(Fe, kr, Qe, Tt, null);
          }
          L_(Fe, Qe);
        }
        return typeof Qe == "function" && P_(Fe), null;
      }
      function Pe(ke, Fe, Ie) {
        {
          if (typeof ke != "object" || ke === null) return Fe;
          switch (ke.$$typeof) {
            case $i:
            case oi:
              O_(ke, Ie);
              var Qe = ke.key;
              if (typeof Qe != "string") break;
              if (Fe === null) {
                Fe = /* @__PURE__ */new Set(), Fe.add(Qe);
                break;
              }
              if (!Fe.has(Qe)) {
                Fe.add(Qe);
                break;
              }
              h("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", Qe);
              break;
            case Ct:
              var Tt = ke._payload,
                _t = ke._init;
              Pe(_t(Tt), Fe, Ie);
              break;
          }
        }
        return Fe;
      }
      function $e(ke, Fe, Ie, Qe) {
        for (var Tt = null, _t = 0; _t < Ie.length; _t++) {
          var an = Ie[_t];
          Tt = Pe(an, Tt, ke);
        }
        for (var Gt = null, Pn = null, Fn = Fe, kr = 0, qn = 0, Tr = null; Fn !== null && qn < Ie.length; qn++) {
          Fn.index > qn ? (Tr = Fn, Fn = null) : Tr = Fn.sibling;
          var ai = Se(ke, Fn, Ie[qn], Qe);
          if (ai === null) {
            Fn === null && (Fn = Tr);
            break;
          }
          n && Fn && ai.alternate === null && a(ke, Fn), kr = T(ai, kr, qn), Pn === null ? Gt = ai : Pn.sibling = ai, Pn = ai, Fn = Tr;
        }
        if (qn === Ie.length) {
          if (f(ke, Fn), tl()) {
            var Br = qn;
            pm(ke, Br);
          }
          return Gt;
        }
        if (Fn === null) {
          for (; qn < Ie.length; qn++) {
            var ho = me(ke, Ie[qn], Qe);
            ho !== null && (kr = T(ho, kr, qn), Pn === null ? Gt = ho : Pn.sibling = ho, Pn = ho);
          }
          if (tl()) {
            var Ro = qn;
            pm(ke, Ro);
          }
          return Gt;
        }
        for (var ns = m(ke, Fn); qn < Ie.length; qn++) {
          var ta = Me(ns, ke, qn, Ie[qn], Qe);
          ta !== null && (n && ta.alternate !== null && ns.delete(ta.key === null ? qn : ta.key), kr = T(ta, kr, qn), Pn === null ? Gt = ta : Pn.sibling = ta, Pn = ta);
        }
        if (n && ns.forEach(function (z0) {
          return a(ke, z0);
        }), tl()) {
          var Pm = qn;
          pm(ke, Pm);
        }
        return Gt;
      }
      function mt(ke, Fe, Ie, Qe) {
        var Tt = yn(Ie);
        if (typeof Tt != "function") throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" &&
          // $FlowFixMe Flow doesn't know about toStringTag
          Ie[Symbol.toStringTag] === "Generator" && (I_ || h("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), I_ = !0), Ie.entries === Tt && (D_ || h("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), D_ = !0);
          var _t = Tt.call(Ie);
          if (_t) for (var an = null, Gt = _t.next(); !Gt.done; Gt = _t.next()) {
            var Pn = Gt.value;
            an = Pe(Pn, an, ke);
          }
        }
        var Fn = Tt.call(Ie);
        if (Fn == null) throw new Error("An iterable object provided no iterator.");
        for (var kr = null, qn = null, Tr = Fe, ai = 0, Br = 0, ho = null, Ro = Fn.next(); Tr !== null && !Ro.done; Br++, Ro = Fn.next()) {
          Tr.index > Br ? (ho = Tr, Tr = null) : ho = Tr.sibling;
          var ns = Se(ke, Tr, Ro.value, Qe);
          if (ns === null) {
            Tr === null && (Tr = ho);
            break;
          }
          n && Tr && ns.alternate === null && a(ke, Tr), ai = T(ns, ai, Br), qn === null ? kr = ns : qn.sibling = ns, qn = ns, Tr = ho;
        }
        if (Ro.done) {
          if (f(ke, Tr), tl()) {
            var ta = Br;
            pm(ke, ta);
          }
          return kr;
        }
        if (Tr === null) {
          for (; !Ro.done; Br++, Ro = Fn.next()) {
            var Pm = me(ke, Ro.value, Qe);
            Pm !== null && (ai = T(Pm, ai, Br), qn === null ? kr = Pm : qn.sibling = Pm, qn = Pm);
          }
          if (tl()) {
            var z0 = Br;
            pm(ke, z0);
          }
          return kr;
        }
        for (var mT = m(ke, Tr); !Ro.done; Br++, Ro = Fn.next()) {
          var Bv = Me(mT, ke, Br, Ro.value, Qe);
          Bv !== null && (n && Bv.alternate !== null && mT.delete(Bv.key === null ? Br : Bv.key), ai = T(Bv, ai, Br), qn === null ? kr = Bv : qn.sibling = Bv, qn = Bv);
        }
        if (n && mT.forEach(function (IW) {
          return a(ke, IW);
        }), tl()) {
          var DW = Br;
          pm(ke, DW);
        }
        return kr;
      }
      function Re(ke, Fe, Ie, Qe) {
        if (Fe !== null && Fe.tag === I) {
          f(ke, Fe.sibling);
          var Tt = b(Fe, Ie);
          return Tt.return = ke, Tt;
        }
        f(ke, Fe);
        var _t = O1(Ie, ke.mode, Qe);
        return _t.return = ke, _t;
      }
      function Ue(ke, Fe, Ie, Qe) {
        for (var Tt = Ie.key, _t = Fe; _t !== null;) {
          if (_t.key === Tt) {
            var an = Ie.type;
            if (an === Oo) {
              if (_t.tag === O) {
                f(ke, _t.sibling);
                var Gt = b(_t, Ie.props.children);
                return Gt.return = ke, Gt._debugSource = Ie._source, Gt._debugOwner = Ie._owner, Gt;
              }
            } else if (_t.elementType === an ||
            // Keep this check inline so it only runs on the false path:
            I1(_t, Ie) ||
            // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof an == "object" && an !== null && an.$$typeof === Ct && Ry(an) === _t.type) {
              f(ke, _t.sibling);
              var Pn = b(_t, Ie.props);
              return Pn.ref = wv(ke, _t, Ie), Pn.return = ke, Pn._debugSource = Ie._source, Pn._debugOwner = Ie._owner, Pn;
            }
            f(ke, _t);
            break;
          } else a(ke, _t);
          _t = _t.sibling;
        }
        if (Ie.type === Oo) {
          var Fn = Lm(Ie.props.children, ke.mode, Qe, Ie.key);
          return Fn.return = ke, Fn;
        } else {
          var kr = Wk(Ie, ke.mode, Qe);
          return kr.ref = wv(ke, Fe, Ie), kr.return = ke, kr;
        }
      }
      function Be(ke, Fe, Ie, Qe) {
        for (var Tt = Ie.key, _t = Fe; _t !== null;) {
          if (_t.key === Tt) {
            if (_t.tag === k && _t.stateNode.containerInfo === Ie.containerInfo && _t.stateNode.implementation === Ie.implementation) {
              f(ke, _t.sibling);
              var an = b(_t, Ie.children || []);
              return an.return = ke, an;
            } else {
              f(ke, _t);
              break;
            }
          } else a(ke, _t);
          _t = _t.sibling;
        }
        var Gt = Rx(Ie, ke.mode, Qe);
        return Gt.return = ke, Gt;
      }
      function nt(ke, Fe, Ie, Qe) {
        var Tt = typeof Ie == "object" && Ie !== null && Ie.type === Oo && Ie.key === null;
        if (Tt && (Ie = Ie.props.children), typeof Ie == "object" && Ie !== null) {
          switch (Ie.$$typeof) {
            case $i:
              return M(Ue(ke, Fe, Ie, Qe));
            case oi:
              return M(Be(ke, Fe, Ie, Qe));
            case Ct:
              var _t = Ie._payload,
                an = Ie._init;
              return nt(ke, Fe, an(_t), Qe);
          }
          if (wr(Ie)) return $e(ke, Fe, Ie, Qe);
          if (yn(Ie)) return mt(ke, Fe, Ie, Qe);
          L_(ke, Ie);
        }
        return typeof Ie == "string" && Ie !== "" || typeof Ie == "number" ? M(Re(ke, Fe, "" + Ie, Qe)) : (typeof Ie == "function" && P_(ke), f(ke, Fe));
      }
      return nt;
    }
    var r0 = AC(!0),
      OD = AC(!1);
    function A_(n, a) {
      if (n !== null && a.child !== n.child) throw new Error("Resuming work not yet implemented.");
      if (a.child !== null) {
        var f = a.child,
          m = Om(f, f.pendingProps);
        for (a.child = m, m.return = a; f.sibling !== null;) f = f.sibling, m = m.sibling = Om(f, f.pendingProps), m.return = a;
        m.sibling = null;
      }
    }
    function _v(n, a) {
      for (var f = n.child; f !== null;) zv(f, a), f = f.sibling;
    }
    var _m = {},
      Af = ka(_m),
      xv = ka(_m),
      j_ = ka(_m);
    function i0(n) {
      if (n === _m) throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return n;
    }
    function Dy() {
      var n = i0(j_.current);
      return n;
    }
    function F_(n, a) {
      fi(j_, a, n), fi(xv, n, n), fi(Af, _m, n);
      var f = OL(a);
      fs(Af, n), fi(Af, f, n);
    }
    function Iy(n) {
      fs(Af, n), fs(xv, n), fs(j_, n);
    }
    function N_() {
      var n = i0(Af.current);
      return n;
    }
    function LD(n) {
      i0(j_.current);
      var a = i0(Af.current),
        f = LL(a, n.type);
      a !== f && (fi(xv, n, n), fi(Af, f, n));
    }
    function HS(n) {
      xv.current === n && (fs(Af, n), fs(xv, n));
    }
    var PD = 0,
      a0 = 1,
      $c = 1,
      My = 2,
      pl = ka(PD);
    function z_(n, a) {
      return (n & a) !== 0;
    }
    function o0(n) {
      return n & a0;
    }
    function vp(n, a) {
      return n & a0 | a;
    }
    function s0(n, a) {
      return n | a;
    }
    function Sv(n, a) {
      fi(pl, a, n);
    }
    function xm(n) {
      fs(pl, n);
    }
    function gu(n, a) {
      var f = n.memoizedState;
      return f !== null ? f.dehydrated !== null : (n.memoizedProps, !0);
    }
    function ja(n) {
      for (var a = n; a !== null;) {
        if (a.tag === V) {
          var f = a.memoizedState;
          if (f !== null) {
            var m = f.dehydrated;
            if (m === null || gD(m) || dC(m)) return a;
          }
        } else if (a.tag === Y &&
        // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        a.memoizedProps.revealOrder !== void 0) {
          var b = (a.flags & ft) !== pt;
          if (b) return a;
        } else if (a.child !== null) {
          a.child.return = a, a = a.child;
          continue;
        }
        if (a === n) return null;
        for (; a.sibling === null;) {
          if (a.return === null || a.return === n) return null;
          a = a.return;
        }
        a.sibling.return = a.return, a = a.sibling;
      }
      return null;
    }
    var Ta = /*   */
      0,
      Er = /* */
      1,
      Ui = /*  */
      2,
      lo = /*    */
      4,
      Qo = /*   */
      8,
      jC = [];
    function Zt() {
      for (var n = 0; n < jC.length; n++) {
        var a = jC[n];
        a._workInProgressVersionPrimary = null;
      }
      jC.length = 0;
    }
    function V_(n, a) {
      var f = a._getVersion,
        m = f(a._source);
      n.mutableSourceEagerHydrationData == null ? n.mutableSourceEagerHydrationData = [a, m] : n.mutableSourceEagerHydrationData.push(a, m);
    }
    var Jt = i.ReactCurrentDispatcher,
      gp = i.ReactCurrentBatchConfig,
      Sm,
      Or;
    Sm = /* @__PURE__ */new Set();
    var ea = De,
      zn = null,
      Fa = null,
      Ra = null,
      Ev = !1,
      B_ = !1,
      U_ = 0,
      ct = 0,
      Wc = 25,
      lt = null,
      yu = null,
      vr = -1,
      Ut = !1;
    function Cr() {
      {
        var n = lt;
        yu === null ? yu = [n] : yu.push(n);
      }
    }
    function Yt() {
      {
        var n = lt;
        yu !== null && (vr++, yu[vr] !== n && FC(n));
      }
    }
    function uo(n) {
      n != null && !wr(n) && h("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", lt, typeof n);
    }
    function FC(n) {
      {
        var a = At(zn);
        if (!Sm.has(a) && (Sm.add(a), yu !== null)) {
          for (var f = "", m = 30, b = 0; b <= vr; b++) {
            for (var T = yu[b], M = b === vr ? n : T, z = b + 1 + ". " + T; z.length < m;) z += " ";
            z += M + `
`, f += z;
          }
          h(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, a, f);
        }
      }
    }
    function co() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function Cv(n, a) {
      if (Ut) return !1;
      if (a === null) return h("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", lt), !1;
      n.length !== a.length && h(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, lt, "[" + a.join(", ") + "]", "[" + n.join(", ") + "]");
      for (var f = 0; f < a.length && f < n.length; f++) if (!he(n[f], a[f])) return !1;
      return !0;
    }
    function Oy(n, a, f, m, b, T) {
      ea = T, zn = a, yu = n !== null ? n._debugHookTypes : null, vr = -1, Ut = n !== null && n.type !== a.type, a.memoizedState = null, a.updateQueue = null, a.lanes = De, n !== null && n.memoizedState !== null ? Jt.current = rx : yu !== null ? Jt.current = qc : Jt.current = Nf;
      var M = f(m, b);
      if (B_) {
        var z = 0;
        do {
          if (B_ = !1, U_ = 0, z >= Wc) throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          z += 1, Ut = !1, Fa = null, Ra = null, a.updateQueue = null, vr = -1, Jt.current = e1, M = f(m, b);
        } while (B_);
      }
      Jt.current = nx, a._debugHookTypes = yu;
      var U = Fa !== null && Fa.next !== null;
      if (ea = De, zn = null, Fa = null, Ra = null, lt = null, yu = null, vr = -1, n !== null && (n.flags & nr) !== (a.flags & nr) &&
      // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (n.mode & Wt) !== dt && h("Internal React error: Expected static flag was missing. Please notify the React team."), Ev = !1, U) throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return M;
    }
    function Ly() {
      var n = U_ !== 0;
      return U_ = 0, n;
    }
    function jf(n, a, f) {
      a.updateQueue = n.updateQueue, (a.mode & Ri) !== dt ? a.flags &= -50333701 : a.flags &= -2053, n.lanes = ac(n.lanes, f);
    }
    function _c() {
      if (Jt.current = nx, Ev) {
        for (var n = zn.memoizedState; n !== null;) {
          var a = n.queue;
          a !== null && (a.pending = null), n = n.next;
        }
        Ev = !1;
      }
      ea = De, zn = null, Fa = null, Ra = null, yu = null, vr = -1, lt = null, jD = !1, B_ = !1, U_ = 0;
    }
    function Ff() {
      var n = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return Ra === null ? zn.memoizedState = Ra = n : Ra = Ra.next = n, Ra;
    }
    function bu() {
      var n;
      if (Fa === null) {
        var a = zn.alternate;
        a !== null ? n = a.memoizedState : n = null;
      } else n = Fa.next;
      var f;
      if (Ra === null ? f = zn.memoizedState : f = Ra.next, f !== null) Ra = f, f = Ra.next, Fa = n;else {
        if (n === null) throw new Error("Rendered more hooks than during the previous render.");
        Fa = n;
        var m = {
          memoizedState: Fa.memoizedState,
          baseState: Fa.baseState,
          baseQueue: Fa.baseQueue,
          queue: Fa.queue,
          next: null
        };
        Ra === null ? zn.memoizedState = Ra = m : Ra = Ra.next = m;
      }
      return Ra;
    }
    function $S() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function H_(n, a) {
      return typeof a == "function" ? a(n) : a;
    }
    function $_(n, a, f) {
      var m = Ff(),
        b;
      f !== void 0 ? b = f(a) : b = a, m.memoizedState = m.baseState = b;
      var T = {
        pending: null,
        interleaved: null,
        lanes: De,
        dispatch: null,
        lastRenderedReducer: n,
        lastRenderedState: b
      };
      m.queue = T;
      var M = T.dispatch = FD.bind(null, zn, T);
      return [m.memoizedState, M];
    }
    function W_(n, a, f) {
      var m = bu(),
        b = m.queue;
      if (b === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      b.lastRenderedReducer = n;
      var T = Fa,
        M = T.baseQueue,
        z = b.pending;
      if (z !== null) {
        if (M !== null) {
          var U = M.next,
            X = z.next;
          M.next = X, z.next = U;
        }
        T.baseQueue !== M && h("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), T.baseQueue = M = z, b.pending = null;
      }
      if (M !== null) {
        var J = M.next,
          me = T.baseState,
          Se = null,
          Me = null,
          Pe = null,
          $e = J;
        do {
          var mt = $e.lane;
          if ($s(ea, mt)) {
            if (Pe !== null) {
              var Ue = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: On,
                action: $e.action,
                hasEagerState: $e.hasEagerState,
                eagerState: $e.eagerState,
                next: null
              };
              Pe = Pe.next = Ue;
            }
            if ($e.hasEagerState) me = $e.eagerState;else {
              var Be = $e.action;
              me = n(me, Be);
            }
          } else {
            var Re = {
              lane: mt,
              action: $e.action,
              hasEagerState: $e.hasEagerState,
              eagerState: $e.eagerState,
              next: null
            };
            Pe === null ? (Me = Pe = Re, Se = me) : Pe = Pe.next = Re, zn.lanes = jt(zn.lanes, mt), xx(mt);
          }
          $e = $e.next;
        } while ($e !== null && $e !== J);
        Pe === null ? Se = me : Pe.next = Me, he(me, m.memoizedState) || Hy(), m.memoizedState = me, m.baseState = Se, m.baseQueue = Pe, b.lastRenderedState = me;
      }
      var nt = b.interleaved;
      if (nt !== null) {
        var ke = nt;
        do {
          var Fe = ke.lane;
          zn.lanes = jt(zn.lanes, Fe), xx(Fe), ke = ke.next;
        } while (ke !== nt);
      } else M === null && (b.lanes = De);
      var Ie = b.dispatch;
      return [m.memoizedState, Ie];
    }
    function l0(n, a, f) {
      var m = bu(),
        b = m.queue;
      if (b === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      b.lastRenderedReducer = n;
      var T = b.dispatch,
        M = b.pending,
        z = m.memoizedState;
      if (M !== null) {
        b.pending = null;
        var U = M.next,
          X = U;
        do {
          var J = X.action;
          z = n(z, J), X = X.next;
        } while (X !== U);
        he(z, m.memoizedState) || Hy(), m.memoizedState = z, m.baseQueue === null && (m.baseState = z), b.lastRenderedState = z;
      }
      return [z, T];
    }
    function PP(n, a, f) {}
    function AP(n, a, f) {}
    function WS(n, a, f) {
      var m = zn,
        b = Ff(),
        T,
        M = tl();
      if (M) {
        if (f === void 0) throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        T = f(), Or || T !== f() && (h("The result of getServerSnapshot should be cached to avoid an infinite loop"), Or = !0);
      } else {
        if (T = a(), !Or) {
          var z = a();
          he(T, z) || (h("The result of getSnapshot should be cached to avoid an infinite loop"), Or = !0);
        }
        var U = Ba();
        if (U === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Gl(U, ea) || NC(m, a, T);
      }
      b.memoizedState = T;
      var X = {
        value: T,
        getSnapshot: a
      };
      return b.queue = X, p0(qS.bind(null, m, X, n), [n]), m.flags |= Yr, kv(Er | Qo, Y_.bind(null, m, X, T, a), void 0, null), T;
    }
    function q_(n, a, f) {
      var m = zn,
        b = bu(),
        T = a();
      if (!Or) {
        var M = a();
        he(T, M) || (h("The result of getSnapshot should be cached to avoid an infinite loop"), Or = !0);
      }
      var z = b.memoizedState,
        U = !he(z, T);
      U && (b.memoizedState = T, Hy());
      var X = b.queue;
      if (Rv(qS.bind(null, m, X, n), [n]), X.getSnapshot !== a || U ||
      // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      Ra !== null && Ra.memoizedState.tag & Er) {
        m.flags |= Yr, kv(Er | Qo, Y_.bind(null, m, X, T, a), void 0, null);
        var J = Ba();
        if (J === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Gl(J, ea) || NC(m, a, T);
      }
      return T;
    }
    function NC(n, a, f) {
      n.flags |= Al;
      var m = {
          getSnapshot: a,
          value: f
        },
        b = zn.updateQueue;
      if (b === null) b = $S(), zn.updateQueue = b, b.stores = [m];else {
        var T = b.stores;
        T === null ? b.stores = [m] : T.push(m);
      }
    }
    function Y_(n, a, f, m) {
      a.value = f, a.getSnapshot = m, YS(a) && u0(n);
    }
    function qS(n, a, f) {
      var m = function () {
        YS(a) && u0(n);
      };
      return f(m);
    }
    function YS(n) {
      var a = n.getSnapshot,
        f = n.value;
      try {
        var m = a();
        return !he(f, m);
      } catch {
        return !0;
      }
    }
    function u0(n) {
      var a = rl(n, Je);
      a !== null && To(a, n, Je, wn);
    }
    function c0(n) {
      var a = Ff();
      typeof n == "function" && (n = n()), a.memoizedState = a.baseState = n;
      var f = {
        pending: null,
        interleaved: null,
        lanes: De,
        dispatch: null,
        lastRenderedReducer: H_,
        lastRenderedState: n
      };
      a.queue = f;
      var m = f.dispatch = ND.bind(null, zn, f);
      return [a.memoizedState, m];
    }
    function d0(n) {
      return W_(H_);
    }
    function Py(n) {
      return l0(H_);
    }
    function kv(n, a, f, m) {
      var b = {
          tag: n,
          create: a,
          destroy: f,
          deps: m,
          // Circular
          next: null
        },
        T = zn.updateQueue;
      if (T === null) T = $S(), zn.updateQueue = T, T.lastEffect = b.next = b;else {
        var M = T.lastEffect;
        if (M === null) T.lastEffect = b.next = b;else {
          var z = M.next;
          M.next = b, b.next = z, T.lastEffect = b;
        }
      }
      return b;
    }
    function f0(n) {
      var a = Ff();
      {
        var f = {
          current: n
        };
        return a.memoizedState = f, f;
      }
    }
    function Tv(n) {
      var a = bu();
      return a.memoizedState;
    }
    function Ay(n, a, f, m) {
      var b = Ff(),
        T = m === void 0 ? null : m;
      zn.flags |= n, b.memoizedState = kv(Er | a, f, void 0, T);
    }
    function jy(n, a, f, m) {
      var b = bu(),
        T = m === void 0 ? null : m,
        M = void 0;
      if (Fa !== null) {
        var z = Fa.memoizedState;
        if (M = z.destroy, T !== null) {
          var U = z.deps;
          if (Cv(T, U)) {
            b.memoizedState = kv(a, f, M, T);
            return;
          }
        }
      }
      zn.flags |= n, b.memoizedState = kv(Er | a, f, M, T);
    }
    function p0(n, a) {
      return (zn.mode & Ri) !== dt ? Ay(ga | Yr | Vd, Qo, n, a) : Ay(Yr | Vd, Qo, n, a);
    }
    function Rv(n, a) {
      return jy(Yr, Qo, n, a);
    }
    function GS(n, a) {
      return Ay(tn, Ui, n, a);
    }
    function h0(n, a) {
      return jy(tn, Ui, n, a);
    }
    function m0(n, a) {
      var f = tn;
      return f |= Za, (zn.mode & Ri) !== dt && (f |= Bo), Ay(f, lo, n, a);
    }
    function XS(n, a) {
      return jy(tn, lo, n, a);
    }
    function G_(n, a) {
      if (typeof a == "function") {
        var f = a,
          m = n();
        return f(m), function () {
          f(null);
        };
      } else if (a != null) {
        var b = a;
        b.hasOwnProperty("current") || h("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(b).join(", ") + "}");
        var T = n();
        return b.current = T, function () {
          b.current = null;
        };
      }
    }
    function X_(n, a, f) {
      typeof a != "function" && h("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", a !== null ? typeof a : "null");
      var m = f != null ? f.concat([n]) : null,
        b = tn;
      return b |= Za, (zn.mode & Ri) !== dt && (b |= Bo), Ay(b, lo, G_.bind(null, a, n), m);
    }
    function Fy(n, a, f) {
      typeof a != "function" && h("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", a !== null ? typeof a : "null");
      var m = f != null ? f.concat([n]) : null;
      return jy(tn, lo, G_.bind(null, a, n), m);
    }
    function zC(n, a) {}
    var Ny = zC;
    function K_(n, a) {
      var f = Ff(),
        m = a === void 0 ? null : a;
      return f.memoizedState = [n, m], n;
    }
    function Q_(n, a) {
      var f = bu(),
        m = a === void 0 ? null : a,
        b = f.memoizedState;
      if (b !== null && m !== null) {
        var T = b[1];
        if (Cv(m, T)) return b[0];
      }
      return f.memoizedState = [n, m], n;
    }
    function KS(n, a) {
      var f = Ff(),
        m = a === void 0 ? null : a,
        b = n();
      return f.memoizedState = [b, m], b;
    }
    function Z_(n, a) {
      var f = bu(),
        m = a === void 0 ? null : a,
        b = f.memoizedState;
      if (b !== null && m !== null) {
        var T = b[1];
        if (Cv(m, T)) return b[0];
      }
      var M = n();
      return f.memoizedState = [M, m], M;
    }
    function VC(n) {
      var a = Ff();
      return a.memoizedState = n, n;
    }
    function QS(n) {
      var a = bu(),
        f = Fa,
        m = f.memoizedState;
      return UC(a, m, n);
    }
    function BC(n) {
      var a = bu();
      if (Fa === null) return a.memoizedState = n, n;
      var f = Fa.memoizedState;
      return UC(a, f, n);
    }
    function UC(n, a, f) {
      var m = !Yl(ea);
      if (m) {
        if (!he(f, a)) {
          var b = Vh();
          zn.lanes = jt(zn.lanes, b), xx(b), n.baseState = !0;
        }
        return a;
      } else return n.baseState && (n.baseState = !1, Hy()), n.memoizedState = f, f;
    }
    function AD(n, a, f) {
      var m = zr();
      la(Jg(m, Zi)), n(!0);
      var b = gp.transition;
      gp.transition = {};
      var T = gp.transition;
      gp.transition._updatedFibers = /* @__PURE__ */new Set();
      try {
        n(!1), a();
      } finally {
        if (la(m), gp.transition = b, b === null && T._updatedFibers) {
          var M = T._updatedFibers.size;
          M > 10 && p("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), T._updatedFibers.clear();
        }
      }
    }
    function HC() {
      var n = c0(!1),
        a = n[0],
        f = n[1],
        m = AD.bind(null, f),
        b = Ff();
      return b.memoizedState = m, [a, m];
    }
    function ZS() {
      var n = d0(),
        a = n[0],
        f = bu(),
        m = f.memoizedState;
      return [a, m];
    }
    function J_() {
      var n = Py(),
        a = n[0],
        f = bu(),
        m = f.memoizedState;
      return [a, m];
    }
    var jD = !1;
    function jP() {
      return jD;
    }
    function JS() {
      var n = Ff(),
        a = Ba(),
        f = a.identifierPrefix,
        m;
      if (tl()) {
        var b = _D();
        m = ":" + f + "R" + b;
        var T = U_++;
        T > 0 && (m += "H" + T.toString(32)), m += ":";
      } else {
        var M = ct++;
        m = ":" + f + "r" + M.toString(32) + ":";
      }
      return n.memoizedState = m, m;
    }
    function ex() {
      var n = bu(),
        a = n.memoizedState;
      return a;
    }
    function FD(n, a, f) {
      typeof arguments[3] == "function" && h("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var m = jv(n),
        b = {
          lane: m,
          action: f,
          hasEagerState: !1,
          eagerState: null,
          next: null
        };
      if (tx(n)) $C(a, b);else {
        var T = TD(n, a, b, m);
        if (T !== null) {
          var M = au();
          To(T, n, m, M), WC(T, a, m);
        }
      }
      qC(n, m);
    }
    function ND(n, a, f) {
      typeof arguments[3] == "function" && h("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var m = jv(n),
        b = {
          lane: m,
          action: f,
          hasEagerState: !1,
          eagerState: null,
          next: null
        };
      if (tx(n)) $C(a, b);else {
        var T = n.alternate;
        if (n.lanes === De && (T === null || T.lanes === De)) {
          var M = a.lastRenderedReducer;
          if (M !== null) {
            var z;
            z = Jt.current, Jt.current = gs;
            try {
              var U = a.lastRenderedState,
                X = M(U, f);
              if (b.hasEagerState = !0, b.eagerState = X, he(X, U)) {
                vu(n, a, b, m);
                return;
              }
            } catch {} finally {
              Jt.current = z;
            }
          }
        }
        var J = TD(n, a, b, m);
        if (J !== null) {
          var me = au();
          To(J, n, m, me), WC(J, a, m);
        }
      }
      qC(n, m);
    }
    function tx(n) {
      var a = n.alternate;
      return n === zn || a !== null && a === zn;
    }
    function $C(n, a) {
      B_ = Ev = !0;
      var f = n.pending;
      f === null ? a.next = a : (a.next = f.next, f.next = a), n.pending = a;
    }
    function WC(n, a, f) {
      if (zh(f)) {
        var m = a.lanes;
        m = Bh(m, n.pendingLanes);
        var b = jt(m, f);
        a.lanes = b, df(n, b);
      }
    }
    function qC(n, a, f) {
      Bs(n, a);
    }
    var nx = {
        readContext: Aa,
        useCallback: co,
        useContext: co,
        useEffect: co,
        useImperativeHandle: co,
        useInsertionEffect: co,
        useLayoutEffect: co,
        useMemo: co,
        useReducer: co,
        useRef: co,
        useState: co,
        useDebugValue: co,
        useDeferredValue: co,
        useTransition: co,
        useMutableSource: co,
        useSyncExternalStore: co,
        useId: co,
        unstable_isNewReconciler: $
      },
      Nf = null,
      qc = null,
      rx = null,
      e1 = null,
      xn = null,
      gs = null,
      ix = null;
    {
      var v0 = function () {
          h("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        },
        Dn = function () {
          h("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
        };
      Nf = {
        readContext: function (n) {
          return Aa(n);
        },
        useCallback: function (n, a) {
          return lt = "useCallback", Cr(), uo(a), K_(n, a);
        },
        useContext: function (n) {
          return lt = "useContext", Cr(), Aa(n);
        },
        useEffect: function (n, a) {
          return lt = "useEffect", Cr(), uo(a), p0(n, a);
        },
        useImperativeHandle: function (n, a, f) {
          return lt = "useImperativeHandle", Cr(), uo(f), X_(n, a, f);
        },
        useInsertionEffect: function (n, a) {
          return lt = "useInsertionEffect", Cr(), uo(a), GS(n, a);
        },
        useLayoutEffect: function (n, a) {
          return lt = "useLayoutEffect", Cr(), uo(a), m0(n, a);
        },
        useMemo: function (n, a) {
          lt = "useMemo", Cr(), uo(a);
          var f = Jt.current;
          Jt.current = xn;
          try {
            return KS(n, a);
          } finally {
            Jt.current = f;
          }
        },
        useReducer: function (n, a, f) {
          lt = "useReducer", Cr();
          var m = Jt.current;
          Jt.current = xn;
          try {
            return $_(n, a, f);
          } finally {
            Jt.current = m;
          }
        },
        useRef: function (n) {
          return lt = "useRef", Cr(), f0(n);
        },
        useState: function (n) {
          lt = "useState", Cr();
          var a = Jt.current;
          Jt.current = xn;
          try {
            return c0(n);
          } finally {
            Jt.current = a;
          }
        },
        useDebugValue: function (n, a) {
          return lt = "useDebugValue", Cr(), void 0;
        },
        useDeferredValue: function (n) {
          return lt = "useDeferredValue", Cr(), VC(n);
        },
        useTransition: function () {
          return lt = "useTransition", Cr(), HC();
        },
        useMutableSource: function (n, a, f) {
          return lt = "useMutableSource", Cr(), void 0;
        },
        useSyncExternalStore: function (n, a, f) {
          return lt = "useSyncExternalStore", Cr(), WS(n, a, f);
        },
        useId: function () {
          return lt = "useId", Cr(), JS();
        },
        unstable_isNewReconciler: $
      }, qc = {
        readContext: function (n) {
          return Aa(n);
        },
        useCallback: function (n, a) {
          return lt = "useCallback", Yt(), K_(n, a);
        },
        useContext: function (n) {
          return lt = "useContext", Yt(), Aa(n);
        },
        useEffect: function (n, a) {
          return lt = "useEffect", Yt(), p0(n, a);
        },
        useImperativeHandle: function (n, a, f) {
          return lt = "useImperativeHandle", Yt(), X_(n, a, f);
        },
        useInsertionEffect: function (n, a) {
          return lt = "useInsertionEffect", Yt(), GS(n, a);
        },
        useLayoutEffect: function (n, a) {
          return lt = "useLayoutEffect", Yt(), m0(n, a);
        },
        useMemo: function (n, a) {
          lt = "useMemo", Yt();
          var f = Jt.current;
          Jt.current = xn;
          try {
            return KS(n, a);
          } finally {
            Jt.current = f;
          }
        },
        useReducer: function (n, a, f) {
          lt = "useReducer", Yt();
          var m = Jt.current;
          Jt.current = xn;
          try {
            return $_(n, a, f);
          } finally {
            Jt.current = m;
          }
        },
        useRef: function (n) {
          return lt = "useRef", Yt(), f0(n);
        },
        useState: function (n) {
          lt = "useState", Yt();
          var a = Jt.current;
          Jt.current = xn;
          try {
            return c0(n);
          } finally {
            Jt.current = a;
          }
        },
        useDebugValue: function (n, a) {
          return lt = "useDebugValue", Yt(), void 0;
        },
        useDeferredValue: function (n) {
          return lt = "useDeferredValue", Yt(), VC(n);
        },
        useTransition: function () {
          return lt = "useTransition", Yt(), HC();
        },
        useMutableSource: function (n, a, f) {
          return lt = "useMutableSource", Yt(), void 0;
        },
        useSyncExternalStore: function (n, a, f) {
          return lt = "useSyncExternalStore", Yt(), WS(n, a, f);
        },
        useId: function () {
          return lt = "useId", Yt(), JS();
        },
        unstable_isNewReconciler: $
      }, rx = {
        readContext: function (n) {
          return Aa(n);
        },
        useCallback: function (n, a) {
          return lt = "useCallback", Yt(), Q_(n, a);
        },
        useContext: function (n) {
          return lt = "useContext", Yt(), Aa(n);
        },
        useEffect: function (n, a) {
          return lt = "useEffect", Yt(), Rv(n, a);
        },
        useImperativeHandle: function (n, a, f) {
          return lt = "useImperativeHandle", Yt(), Fy(n, a, f);
        },
        useInsertionEffect: function (n, a) {
          return lt = "useInsertionEffect", Yt(), h0(n, a);
        },
        useLayoutEffect: function (n, a) {
          return lt = "useLayoutEffect", Yt(), XS(n, a);
        },
        useMemo: function (n, a) {
          lt = "useMemo", Yt();
          var f = Jt.current;
          Jt.current = gs;
          try {
            return Z_(n, a);
          } finally {
            Jt.current = f;
          }
        },
        useReducer: function (n, a, f) {
          lt = "useReducer", Yt();
          var m = Jt.current;
          Jt.current = gs;
          try {
            return W_(n, a, f);
          } finally {
            Jt.current = m;
          }
        },
        useRef: function (n) {
          return lt = "useRef", Yt(), Tv();
        },
        useState: function (n) {
          lt = "useState", Yt();
          var a = Jt.current;
          Jt.current = gs;
          try {
            return d0(n);
          } finally {
            Jt.current = a;
          }
        },
        useDebugValue: function (n, a) {
          return lt = "useDebugValue", Yt(), Ny();
        },
        useDeferredValue: function (n) {
          return lt = "useDeferredValue", Yt(), QS(n);
        },
        useTransition: function () {
          return lt = "useTransition", Yt(), ZS();
        },
        useMutableSource: function (n, a, f) {
          return lt = "useMutableSource", Yt(), void 0;
        },
        useSyncExternalStore: function (n, a, f) {
          return lt = "useSyncExternalStore", Yt(), q_(n, a);
        },
        useId: function () {
          return lt = "useId", Yt(), ex();
        },
        unstable_isNewReconciler: $
      }, e1 = {
        readContext: function (n) {
          return Aa(n);
        },
        useCallback: function (n, a) {
          return lt = "useCallback", Yt(), Q_(n, a);
        },
        useContext: function (n) {
          return lt = "useContext", Yt(), Aa(n);
        },
        useEffect: function (n, a) {
          return lt = "useEffect", Yt(), Rv(n, a);
        },
        useImperativeHandle: function (n, a, f) {
          return lt = "useImperativeHandle", Yt(), Fy(n, a, f);
        },
        useInsertionEffect: function (n, a) {
          return lt = "useInsertionEffect", Yt(), h0(n, a);
        },
        useLayoutEffect: function (n, a) {
          return lt = "useLayoutEffect", Yt(), XS(n, a);
        },
        useMemo: function (n, a) {
          lt = "useMemo", Yt();
          var f = Jt.current;
          Jt.current = ix;
          try {
            return Z_(n, a);
          } finally {
            Jt.current = f;
          }
        },
        useReducer: function (n, a, f) {
          lt = "useReducer", Yt();
          var m = Jt.current;
          Jt.current = ix;
          try {
            return l0(n, a, f);
          } finally {
            Jt.current = m;
          }
        },
        useRef: function (n) {
          return lt = "useRef", Yt(), Tv();
        },
        useState: function (n) {
          lt = "useState", Yt();
          var a = Jt.current;
          Jt.current = ix;
          try {
            return Py(n);
          } finally {
            Jt.current = a;
          }
        },
        useDebugValue: function (n, a) {
          return lt = "useDebugValue", Yt(), Ny();
        },
        useDeferredValue: function (n) {
          return lt = "useDeferredValue", Yt(), BC(n);
        },
        useTransition: function () {
          return lt = "useTransition", Yt(), J_();
        },
        useMutableSource: function (n, a, f) {
          return lt = "useMutableSource", Yt(), void 0;
        },
        useSyncExternalStore: function (n, a, f) {
          return lt = "useSyncExternalStore", Yt(), q_(n, a);
        },
        useId: function () {
          return lt = "useId", Yt(), ex();
        },
        unstable_isNewReconciler: $
      }, xn = {
        readContext: function (n) {
          return v0(), Aa(n);
        },
        useCallback: function (n, a) {
          return lt = "useCallback", Dn(), Cr(), K_(n, a);
        },
        useContext: function (n) {
          return lt = "useContext", Dn(), Cr(), Aa(n);
        },
        useEffect: function (n, a) {
          return lt = "useEffect", Dn(), Cr(), p0(n, a);
        },
        useImperativeHandle: function (n, a, f) {
          return lt = "useImperativeHandle", Dn(), Cr(), X_(n, a, f);
        },
        useInsertionEffect: function (n, a) {
          return lt = "useInsertionEffect", Dn(), Cr(), GS(n, a);
        },
        useLayoutEffect: function (n, a) {
          return lt = "useLayoutEffect", Dn(), Cr(), m0(n, a);
        },
        useMemo: function (n, a) {
          lt = "useMemo", Dn(), Cr();
          var f = Jt.current;
          Jt.current = xn;
          try {
            return KS(n, a);
          } finally {
            Jt.current = f;
          }
        },
        useReducer: function (n, a, f) {
          lt = "useReducer", Dn(), Cr();
          var m = Jt.current;
          Jt.current = xn;
          try {
            return $_(n, a, f);
          } finally {
            Jt.current = m;
          }
        },
        useRef: function (n) {
          return lt = "useRef", Dn(), Cr(), f0(n);
        },
        useState: function (n) {
          lt = "useState", Dn(), Cr();
          var a = Jt.current;
          Jt.current = xn;
          try {
            return c0(n);
          } finally {
            Jt.current = a;
          }
        },
        useDebugValue: function (n, a) {
          return lt = "useDebugValue", Dn(), Cr(), void 0;
        },
        useDeferredValue: function (n) {
          return lt = "useDeferredValue", Dn(), Cr(), VC(n);
        },
        useTransition: function () {
          return lt = "useTransition", Dn(), Cr(), HC();
        },
        useMutableSource: function (n, a, f) {
          return lt = "useMutableSource", Dn(), Cr(), void 0;
        },
        useSyncExternalStore: function (n, a, f) {
          return lt = "useSyncExternalStore", Dn(), Cr(), WS(n, a, f);
        },
        useId: function () {
          return lt = "useId", Dn(), Cr(), JS();
        },
        unstable_isNewReconciler: $
      }, gs = {
        readContext: function (n) {
          return v0(), Aa(n);
        },
        useCallback: function (n, a) {
          return lt = "useCallback", Dn(), Yt(), Q_(n, a);
        },
        useContext: function (n) {
          return lt = "useContext", Dn(), Yt(), Aa(n);
        },
        useEffect: function (n, a) {
          return lt = "useEffect", Dn(), Yt(), Rv(n, a);
        },
        useImperativeHandle: function (n, a, f) {
          return lt = "useImperativeHandle", Dn(), Yt(), Fy(n, a, f);
        },
        useInsertionEffect: function (n, a) {
          return lt = "useInsertionEffect", Dn(), Yt(), h0(n, a);
        },
        useLayoutEffect: function (n, a) {
          return lt = "useLayoutEffect", Dn(), Yt(), XS(n, a);
        },
        useMemo: function (n, a) {
          lt = "useMemo", Dn(), Yt();
          var f = Jt.current;
          Jt.current = gs;
          try {
            return Z_(n, a);
          } finally {
            Jt.current = f;
          }
        },
        useReducer: function (n, a, f) {
          lt = "useReducer", Dn(), Yt();
          var m = Jt.current;
          Jt.current = gs;
          try {
            return W_(n, a, f);
          } finally {
            Jt.current = m;
          }
        },
        useRef: function (n) {
          return lt = "useRef", Dn(), Yt(), Tv();
        },
        useState: function (n) {
          lt = "useState", Dn(), Yt();
          var a = Jt.current;
          Jt.current = gs;
          try {
            return d0(n);
          } finally {
            Jt.current = a;
          }
        },
        useDebugValue: function (n, a) {
          return lt = "useDebugValue", Dn(), Yt(), Ny();
        },
        useDeferredValue: function (n) {
          return lt = "useDeferredValue", Dn(), Yt(), QS(n);
        },
        useTransition: function () {
          return lt = "useTransition", Dn(), Yt(), ZS();
        },
        useMutableSource: function (n, a, f) {
          return lt = "useMutableSource", Dn(), Yt(), void 0;
        },
        useSyncExternalStore: function (n, a, f) {
          return lt = "useSyncExternalStore", Dn(), Yt(), q_(n, a);
        },
        useId: function () {
          return lt = "useId", Dn(), Yt(), ex();
        },
        unstable_isNewReconciler: $
      }, ix = {
        readContext: function (n) {
          return v0(), Aa(n);
        },
        useCallback: function (n, a) {
          return lt = "useCallback", Dn(), Yt(), Q_(n, a);
        },
        useContext: function (n) {
          return lt = "useContext", Dn(), Yt(), Aa(n);
        },
        useEffect: function (n, a) {
          return lt = "useEffect", Dn(), Yt(), Rv(n, a);
        },
        useImperativeHandle: function (n, a, f) {
          return lt = "useImperativeHandle", Dn(), Yt(), Fy(n, a, f);
        },
        useInsertionEffect: function (n, a) {
          return lt = "useInsertionEffect", Dn(), Yt(), h0(n, a);
        },
        useLayoutEffect: function (n, a) {
          return lt = "useLayoutEffect", Dn(), Yt(), XS(n, a);
        },
        useMemo: function (n, a) {
          lt = "useMemo", Dn(), Yt();
          var f = Jt.current;
          Jt.current = gs;
          try {
            return Z_(n, a);
          } finally {
            Jt.current = f;
          }
        },
        useReducer: function (n, a, f) {
          lt = "useReducer", Dn(), Yt();
          var m = Jt.current;
          Jt.current = gs;
          try {
            return l0(n, a, f);
          } finally {
            Jt.current = m;
          }
        },
        useRef: function (n) {
          return lt = "useRef", Dn(), Yt(), Tv();
        },
        useState: function (n) {
          lt = "useState", Dn(), Yt();
          var a = Jt.current;
          Jt.current = gs;
          try {
            return Py(n);
          } finally {
            Jt.current = a;
          }
        },
        useDebugValue: function (n, a) {
          return lt = "useDebugValue", Dn(), Yt(), Ny();
        },
        useDeferredValue: function (n) {
          return lt = "useDeferredValue", Dn(), Yt(), BC(n);
        },
        useTransition: function () {
          return lt = "useTransition", Dn(), Yt(), J_();
        },
        useMutableSource: function (n, a, f) {
          return lt = "useMutableSource", Dn(), Yt(), void 0;
        },
        useSyncExternalStore: function (n, a, f) {
          return lt = "useSyncExternalStore", Dn(), Yt(), q_(n, a);
        },
        useId: function () {
          return lt = "useId", Dn(), Yt(), ex();
        },
        unstable_isNewReconciler: $
      };
    }
    var zf = e.unstable_now,
      t1 = 0,
      zy = -1,
      g0 = -1,
      n1 = -1,
      YC = !1,
      r1 = !1;
    function GC() {
      return YC;
    }
    function zD() {
      r1 = !0;
    }
    function XC() {
      YC = !1, r1 = !1;
    }
    function VD() {
      YC = r1, r1 = !1;
    }
    function ax() {
      return t1;
    }
    function Vf() {
      t1 = zf();
    }
    function ox(n) {
      g0 = zf(), n.actualStartTime < 0 && (n.actualStartTime = zf());
    }
    function Bf(n) {
      g0 = -1;
    }
    function y0(n, a) {
      if (g0 >= 0) {
        var f = zf() - g0;
        n.actualDuration += f, a && (n.selfBaseDuration = f), g0 = -1;
      }
    }
    function Yc(n) {
      if (zy >= 0) {
        var a = zf() - zy;
        zy = -1;
        for (var f = n.return; f !== null;) {
          switch (f.tag) {
            case C:
              var m = f.stateNode;
              m.effectDuration += a;
              return;
            case j:
              var b = f.stateNode;
              b.effectDuration += a;
              return;
          }
          f = f.return;
        }
      }
    }
    function Em(n) {
      if (n1 >= 0) {
        var a = zf() - n1;
        n1 = -1;
        for (var f = n.return; f !== null;) {
          switch (f.tag) {
            case C:
              var m = f.stateNode;
              m !== null && (m.passiveEffectDuration += a);
              return;
            case j:
              var b = f.stateNode;
              b !== null && (b.passiveEffectDuration += a);
              return;
          }
          f = f.return;
        }
      }
    }
    function Gc() {
      zy = zf();
    }
    function KC() {
      n1 = zf();
    }
    function sx(n) {
      for (var a = n.child; a;) n.actualDuration += a.actualDuration, a = a.sibling;
    }
    function Vy(n, a) {
      return {
        value: n,
        source: a,
        stack: hd(a),
        digest: null
      };
    }
    function i1(n, a, f) {
      return {
        value: n,
        source: null,
        stack: f ?? null,
        digest: a ?? null
      };
    }
    function QC(n, a) {
      return !0;
    }
    function a1(n, a) {
      try {
        var f = QC(n, a);
        if (f === !1) return;
        var m = a.value,
          b = a.source,
          T = a.stack,
          M = T !== null ? T : "";
        if (m != null && m._suppressLogging) {
          if (n.tag === x) return;
          console.error(m);
        }
        var z = b ? At(b) : null,
          U = z ? "The above error occurred in the <" + z + "> component:" : "The above error occurred in one of your React components:",
          X;
        if (n.tag === C) X = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;else {
          var J = At(n) || "Anonymous";
          X = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + J + ".");
        }
        var me = U + `
` + M + `

` + ("" + X);
        console.error(me);
      } catch (Se) {
        setTimeout(function () {
          throw Se;
        });
      }
    }
    var FP = typeof WeakMap == "function" ? WeakMap : Map;
    function BD(n, a, f) {
      var m = Hc(wn, f);
      m.tag = b_, m.payload = {
        element: null
      };
      var b = a.value;
      return m.callback = function () {
        RI(b), a1(n, a);
      }, m;
    }
    function o1(n, a, f) {
      var m = Hc(wn, f);
      m.tag = b_;
      var b = n.type.getDerivedStateFromError;
      if (typeof b == "function") {
        var T = a.value;
        m.payload = function () {
          return b(T);
        }, m.callback = function () {
          AI(n), a1(n, a);
        };
      }
      var M = n.stateNode;
      return M !== null && typeof M.componentDidCatch == "function" && (m.callback = function () {
        AI(n), a1(n, a), typeof b != "function" && Fi(this);
        var U = a.value,
          X = a.stack;
        this.componentDidCatch(U, {
          componentStack: X !== null ? X : ""
        }), typeof b != "function" && (_n(n.lanes, Je) || h("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", At(n) || "Unknown"));
      }), m;
    }
    function ZC(n, a, f) {
      var m = n.pingCache,
        b;
      if (m === null ? (m = n.pingCache = new FP(), b = /* @__PURE__ */new Set(), m.set(a, b)) : (b = m.get(a), b === void 0 && (b = /* @__PURE__ */new Set(), m.set(a, b))), !b.has(f)) {
        b.add(f);
        var T = OA.bind(null, n, a, f);
        ui && P0(n, f), a.then(T, T);
      }
    }
    function NP(n, a, f, m) {
      var b = n.updateQueue;
      if (b === null) {
        var T = /* @__PURE__ */new Set();
        T.add(f), n.updateQueue = T;
      } else b.add(f);
    }
    function zP(n, a) {
      var f = n.tag;
      if ((n.mode & Wt) === dt && (f === w || f === F || f === G)) {
        var m = n.alternate;
        m ? (n.updateQueue = m.updateQueue, n.memoizedState = m.memoizedState, n.lanes = m.lanes) : (n.updateQueue = null, n.memoizedState = null);
      }
    }
    function b0(n) {
      var a = n;
      do {
        if (a.tag === V && gu(a)) return a;
        a = a.return;
      } while (a !== null);
      return null;
    }
    function Xc(n, a, f, m, b) {
      if ((n.mode & Wt) === dt) {
        if (n === a) n.flags |= Gr;else {
          if (n.flags |= ft, f.flags |= zd, f.flags &= -52805, f.tag === x) {
            var T = f.alternate;
            if (T === null) f.tag = te;else {
              var M = Hc(wn, Je);
              M.tag = Cy, mp(f, M, Je);
            }
          }
          f.lanes = jt(f.lanes, Je);
        }
        return n;
      }
      return n.flags |= Gr, n.lanes = b, n;
    }
    function JC(n, a, f, m, b) {
      if (f.flags |= Gu, ui && P0(n, b), m !== null && typeof m == "object" && typeof m.then == "function") {
        var T = m;
        zP(f), tl() && f.mode & Wt && xD();
        var M = b0(a);
        if (M !== null) {
          M.flags &= -257, Xc(M, a, f, n, b), M.mode & Wt && ZC(n, T, b), NP(M, n, T);
          return;
        } else {
          if (!Lw(b)) {
            ZC(n, T, b), Ok();
            return;
          }
          var z = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          m = z;
        }
      } else if (tl() && f.mode & Wt) {
        xD();
        var U = b0(a);
        if (U !== null) {
          (U.flags & Gr) === pt && (U.flags |= qr), Xc(U, a, f, n, b), xC(Vy(m, f));
          return;
        }
      }
      m = Vy(m, f), kA(m);
      var X = a;
      do {
        switch (X.tag) {
          case C:
            {
              var J = m;
              X.flags |= Gr;
              var me = Xl(b);
              X.lanes = jt(X.lanes, me);
              var Se = BD(X, J, me);
              Jb(X, Se);
              return;
            }
          case x:
            var Me = m,
              Pe = X.type,
              $e = X.stateNode;
            if ((X.flags & ft) === pt && (typeof Pe.getDerivedStateFromError == "function" || $e !== null && typeof $e.componentDidCatch == "function" && !Lk($e))) {
              X.flags |= Gr;
              var mt = Xl(b);
              X.lanes = jt(X.lanes, mt);
              var Re = o1(X, Me, mt);
              Jb(X, Re);
              return;
            }
            break;
        }
        X = X.return;
      } while (X !== null);
    }
    function lx() {
      return null;
    }
    var By = i.ReactCurrentOwner,
      xc = !1,
      ux,
      Uf,
      cx,
      w0,
      il,
      Uy,
      s1,
      dx;
    ux = {}, Uf = {}, cx = {}, w0 = {}, il = {}, Uy = !1, s1 = {}, dx = {};
    function hl(n, a, f, m) {
      n === null ? a.child = OD(a, null, f, m) : a.child = r0(a, n.child, f, m);
    }
    function UD(n, a, f, m) {
      a.child = r0(a, n.child, null, m), a.child = r0(a, null, f, m);
    }
    function HD(n, a, f, m, b) {
      if (a.type !== a.elementType) {
        var T = f.propTypes;
        T && hu(T, m,
        // Resolved props
        "prop", bn(f));
      }
      var M = f.render,
        z = a.ref,
        U,
        X;
      Uc(a, b), Ti(a);
      {
        if (By.current = a, br(!0), U = Oy(n, a, M, m, z, b), X = Ly(), a.mode & Xn) {
          En(!0);
          try {
            U = Oy(n, a, M, m, z, b), X = Ly();
          } finally {
            En(!1);
          }
        }
        br(!1);
      }
      return to(), n !== null && !xc ? (jf(n, a, b), bp(n, a, b)) : (tl() && X && vC(a), a.flags |= Xi, hl(n, a, U, b), a.child);
    }
    function $D(n, a, f, m, b) {
      if (n === null) {
        var T = f.type;
        if (NA(T) && f.compare === null &&
        // SimpleMemoComponent codepath doesn't resolve outer props either.
        f.defaultProps === void 0) {
          var M = T;
          return M = nb(T), a.tag = G, a.type = M, ck(a, T), WD(n, a, M, m, b);
        }
        {
          var z = T.propTypes;
          z && hu(z, m,
          // Resolved props
          "prop", bn(T));
        }
        var U = $k(f.type, null, m, a, a.mode, b);
        return U.ref = a.ref, U.return = a, a.child = U, U;
      }
      {
        var X = f.type,
          J = X.propTypes;
        J && hu(J, m,
        // Resolved props
        "prop", bn(X));
      }
      var me = n.child,
        Se = d1(n, b);
      if (!Se) {
        var Me = me.memoizedProps,
          Pe = f.compare;
        if (Pe = Pe !== null ? Pe : He, Pe(Me, m) && n.ref === a.ref) return bp(n, a, b);
      }
      a.flags |= Xi;
      var $e = Om(me, m);
      return $e.ref = a.ref, $e.return = a, a.child = $e, $e;
    }
    function WD(n, a, f, m, b) {
      if (a.type !== a.elementType) {
        var T = a.elementType;
        if (T.$$typeof === Ct) {
          var M = T,
            z = M._payload,
            U = M._init;
          try {
            T = U(z);
          } catch {
            T = null;
          }
          var X = T && T.propTypes;
          X && hu(X, m,
          // Resolved (SimpleMemoComponent has no defaultProps)
          "prop", bn(T));
        }
      }
      if (n !== null) {
        var J = n.memoizedProps;
        if (He(J, m) && n.ref === a.ref &&
        // Prevent bailout if the implementation changed due to hot reload.
        a.type === n.type) if (xc = !1, a.pendingProps = m = J, d1(n, b)) (n.flags & zd) !== pt && (xc = !0);else return a.lanes = n.lanes, bp(n, a, b);
      }
      return ik(n, a, f, m, b);
    }
    function ek(n, a, f) {
      var m = a.pendingProps,
        b = m.children,
        T = n !== null ? n.memoizedState : null;
      if (m.mode === "hidden" || H) {
        if ((a.mode & Wt) === dt) {
          var M = {
            baseLanes: De,
            cachePool: null,
            transitions: null
          };
          a.memoizedState = M, _x(a, f);
        } else if (_n(f, Jr)) {
          var me = {
            baseLanes: De,
            cachePool: null,
            transitions: null
          };
          a.memoizedState = me;
          var Se = T !== null ? T.baseLanes : f;
          _x(a, Se);
        } else {
          var z = null,
            U;
          if (T !== null) {
            var X = T.baseLanes;
            U = jt(X, f);
          } else U = f;
          a.lanes = a.childLanes = Jr;
          var J = {
            baseLanes: U,
            cachePool: z,
            transitions: null
          };
          return a.memoizedState = J, a.updateQueue = null, _x(a, U), null;
        }
      } else {
        var Me;
        T !== null ? (Me = jt(T.baseLanes, f), a.memoizedState = null) : Me = f, _x(a, Me);
      }
      return hl(n, a, b, f), a.child;
    }
    function tk(n, a, f) {
      var m = a.pendingProps;
      return hl(n, a, m, f), a.child;
    }
    function qD(n, a, f) {
      var m = a.pendingProps.children;
      return hl(n, a, m, f), a.child;
    }
    function nk(n, a, f) {
      {
        a.flags |= tn;
        {
          var m = a.stateNode;
          m.effectDuration = 0, m.passiveEffectDuration = 0;
        }
      }
      var b = a.pendingProps,
        T = b.children;
      return hl(n, a, T, f), a.child;
    }
    function rk(n, a) {
      var f = a.ref;
      (n === null && f !== null || n !== null && n.ref !== f) && (a.flags |= Hn, a.flags |= jl);
    }
    function ik(n, a, f, m, b) {
      if (a.type !== a.elementType) {
        var T = f.propTypes;
        T && hu(T, m,
        // Resolved props
        "prop", bn(f));
      }
      var M;
      {
        var z = Df(a, f, !0);
        M = eu(a, z);
      }
      var U, X;
      Uc(a, b), Ti(a);
      {
        if (By.current = a, br(!0), U = Oy(n, a, f, m, M, b), X = Ly(), a.mode & Xn) {
          En(!0);
          try {
            U = Oy(n, a, f, m, M, b), X = Ly();
          } finally {
            En(!1);
          }
        }
        br(!1);
      }
      return to(), n !== null && !xc ? (jf(n, a, b), bp(n, a, b)) : (tl() && X && vC(a), a.flags |= Xi, hl(n, a, U, b), a.child);
    }
    function ak(n, a, f, m, b) {
      {
        switch (HI(a)) {
          case !1:
            {
              var T = a.stateNode,
                M = a.type,
                z = new M(a.memoizedProps, T.context),
                U = z.state;
              T.updater.enqueueSetState(T, U, null);
              break;
            }
          case !0:
            {
              a.flags |= ft, a.flags |= Gr;
              var X = new Error("Simulated error coming from DevTools"),
                J = Xl(b);
              a.lanes = jt(a.lanes, J);
              var me = o1(a, Vy(X, a), J);
              Jb(a, me);
              break;
            }
        }
        if (a.type !== a.elementType) {
          var Se = f.propTypes;
          Se && hu(Se, m,
          // Resolved props
          "prop", bn(f));
        }
      }
      var Me;
      Bc(f) ? (Me = !0, wS(a)) : Me = !1, Uc(a, b);
      var Pe = a.stateNode,
        $e;
      Pe === null ? (c1(n, a), IC(a, f, m), OC(a, f, m, b), $e = !0) : n === null ? $e = LC(a, f, m, b) : $e = PC(n, a, f, m, b);
      var mt = ok(n, a, f, $e, Me, b);
      {
        var Re = a.stateNode;
        $e && Re.props !== m && (Uy || h("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", At(a) || "a component"), Uy = !0);
      }
      return mt;
    }
    function ok(n, a, f, m, b, T) {
      rk(n, a);
      var M = (a.flags & ft) !== pt;
      if (!m && !M) return b && lm(a, f, !1), bp(n, a, T);
      var z = a.stateNode;
      By.current = a;
      var U;
      if (M && typeof f.getDerivedStateFromError != "function") U = null, Bf();else {
        Ti(a);
        {
          if (br(!0), U = z.render(), a.mode & Xn) {
            En(!0);
            try {
              z.render();
            } finally {
              En(!1);
            }
          }
          br(!1);
        }
        to();
      }
      return a.flags |= Xi, n !== null && M ? UD(n, a, U, T) : hl(n, a, U, T), a.memoizedState = z.state, b && lm(a, f, !0), a.child;
    }
    function YD(n) {
      var a = n.stateNode;
      a.pendingContext ? c_(n, a.pendingContext, a.pendingContext !== a.context) : a.context && c_(n, a.context, !1), F_(n, a.containerInfo);
    }
    function VP(n, a, f) {
      if (YD(a), n === null) throw new Error("Should have a current fiber. This is a bug in React.");
      var m = a.pendingProps,
        b = a.memoizedState,
        T = b.element;
      wm(n, a), x_(a, m, null, f);
      var M = a.memoizedState;
      a.stateNode;
      var z = M.element;
      if (b.isDehydrated) {
        var U = {
            element: z,
            isDehydrated: !1,
            cache: M.cache,
            pendingSuspenseBoundaries: M.pendingSuspenseBoundaries,
            transitions: M.transitions
          },
          X = a.updateQueue;
        if (X.baseState = U, a.memoizedState = U, a.flags & qr) {
          var J = Vy(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), a);
          return GD(n, a, z, f, J);
        } else if (z !== T) {
          var me = Vy(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), a);
          return GD(n, a, z, f, me);
        } else {
          SD(a);
          var Se = OD(a, null, z, f);
          a.child = Se;
          for (var Me = Se; Me;) Me.flags = Me.flags & -3 | xi, Me = Me.sibling;
        }
      } else {
        if (Pa(), z === T) return bp(n, a, f);
        hl(n, a, z, f);
      }
      return a.child;
    }
    function GD(n, a, f, m, b) {
      return Pa(), xC(b), a.flags |= qr, hl(n, a, f, m), a.child;
    }
    function BP(n, a, f) {
      LD(a), n === null && wC(a);
      var m = a.type,
        b = a.pendingProps,
        T = n !== null ? n.memoizedProps : null,
        M = b.children,
        z = aC(m, b);
      return z ? M = null : T !== null && aC(m, T) && (a.flags |= Ki), rk(n, a), hl(n, a, M, f), a.child;
    }
    function sk(n, a) {
      return n === null && wC(a), null;
    }
    function lk(n, a, f, m) {
      c1(n, a);
      var b = a.pendingProps,
        T = f,
        M = T._payload,
        z = T._init,
        U = z(M);
      a.type = U;
      var X = a.tag = Hk(U),
        J = wc(U, b),
        me;
      switch (X) {
        case w:
          return ck(a, U), a.type = U = nb(U), me = ik(null, a, U, J, m), me;
        case x:
          return a.type = U = Fk(U), me = ak(null, a, U, J, m), me;
        case F:
          return a.type = U = Nk(U), me = HD(null, a, U, J, m), me;
        case K:
          {
            if (a.type !== a.elementType) {
              var Se = U.propTypes;
              Se && hu(Se, J,
              // Resolved for outer only
              "prop", bn(U));
            }
            return me = $D(null, a, U, wc(U.type, J),
            // The inner type can have defaults too
            m), me;
          }
      }
      var Me = "";
      throw U !== null && typeof U == "object" && U.$$typeof === Ct && (Me = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + U + ". " + ("Lazy element type must resolve to a class or function." + Me));
    }
    function uk(n, a, f, m, b) {
      c1(n, a), a.tag = x;
      var T;
      return Bc(f) ? (T = !0, wS(a)) : T = !1, Uc(a, b), IC(a, f, m), OC(a, f, m, b), ok(null, a, f, !0, T, b);
    }
    function UP(n, a, f, m) {
      c1(n, a);
      var b = a.pendingProps,
        T;
      {
        var M = Df(a, f, !1);
        T = eu(a, M);
      }
      Uc(a, m);
      var z, U;
      Ti(a);
      {
        if (f.prototype && typeof f.prototype.render == "function") {
          var X = bn(f) || "Unknown";
          ux[X] || (h("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", X, X), ux[X] = !0);
        }
        a.mode & Xn && nl.recordLegacyContextWarning(a, null), br(!0), By.current = a, z = Oy(null, a, f, b, T, m), U = Ly(), br(!1);
      }
      if (to(), a.flags |= Xi, typeof z == "object" && z !== null && typeof z.render == "function" && z.$$typeof === void 0) {
        var J = bn(f) || "Unknown";
        Uf[J] || (h("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", J, J, J), Uf[J] = !0);
      }
      if (
      // Run these checks in production only if the flag is off.
      // Eventually we'll delete this branch altogether.
      typeof z == "object" && z !== null && typeof z.render == "function" && z.$$typeof === void 0) {
        {
          var me = bn(f) || "Unknown";
          Uf[me] || (h("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", me, me, me), Uf[me] = !0);
        }
        a.tag = x, a.memoizedState = null, a.updateQueue = null;
        var Se = !1;
        return Bc(f) ? (Se = !0, wS(a)) : Se = !1, a.memoizedState = z.state !== null && z.state !== void 0 ? z.state : null, Pf(a), ID(a, z), OC(a, f, b, m), ok(null, a, f, !0, Se, m);
      } else {
        if (a.tag = w, a.mode & Xn) {
          En(!0);
          try {
            z = Oy(null, a, f, b, T, m), U = Ly();
          } finally {
            En(!1);
          }
        }
        return tl() && U && vC(a), hl(null, a, z, m), ck(a, f), a.child;
      }
    }
    function ck(n, a) {
      {
        if (a && a.childContextTypes && h("%s(...): childContextTypes cannot be defined on a function component.", a.displayName || a.name || "Component"), n.ref !== null) {
          var f = "",
            m = yi();
          m && (f += `

Check the render method of \`` + m + "`.");
          var b = m || "",
            T = n._debugSource;
          T && (b = T.fileName + ":" + T.lineNumber), il[b] || (il[b] = !0, h("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", f));
        }
        if (typeof a.getDerivedStateFromProps == "function") {
          var M = bn(a) || "Unknown";
          w0[M] || (h("%s: Function components do not support getDerivedStateFromProps.", M), w0[M] = !0);
        }
        if (typeof a.contextType == "object" && a.contextType !== null) {
          var z = bn(a) || "Unknown";
          cx[z] || (h("%s: Function components do not support contextType.", z), cx[z] = !0);
        }
      }
    }
    var dk = {
      dehydrated: null,
      treeContext: null,
      retryLane: On
    };
    function l1(n) {
      return {
        baseLanes: n,
        cachePool: lx(),
        transitions: null
      };
    }
    function fk(n, a) {
      var f = null;
      return {
        baseLanes: jt(n.baseLanes, a),
        cachePool: f,
        transitions: n.transitions
      };
    }
    function HP(n, a, f, m) {
      if (a !== null) {
        var b = a.memoizedState;
        if (b === null) return !1;
      }
      return z_(n, My);
    }
    function pk(n, a) {
      return ac(n.childLanes, a);
    }
    function hk(n, a, f) {
      var m = a.pendingProps;
      $I(a) && (a.flags |= ft);
      var b = pl.current,
        T = !1,
        M = (a.flags & ft) !== pt;
      if (M || HP(b, n) ? (T = !0, a.flags &= -129) : (n === null || n.memoizedState !== null) && (b = s0(b, $c)), b = o0(b), Sv(a, b), n === null) {
        wC(a);
        var z = a.memoizedState;
        if (z !== null) {
          var U = z.dehydrated;
          if (U !== null) return GP(a, U);
        }
        var X = m.children,
          J = m.fallback;
        if (T) {
          var me = $P(a, X, J, f),
            Se = a.child;
          return Se.memoizedState = l1(f), a.memoizedState = dk, me;
        } else return mk(a, X);
      } else {
        var Me = n.memoizedState;
        if (Me !== null) {
          var Pe = Me.dehydrated;
          if (Pe !== null) return XP(n, a, M, m, Pe, Me, f);
        }
        if (T) {
          var $e = m.fallback,
            mt = m.children,
            Re = qP(n, a, mt, $e, f),
            Ue = a.child,
            Be = n.child.memoizedState;
          return Ue.memoizedState = Be === null ? l1(f) : fk(Be, f), Ue.childLanes = pk(n, f), a.memoizedState = dk, Re;
        } else {
          var nt = m.children,
            ke = WP(n, a, nt, f);
          return a.memoizedState = null, ke;
        }
      }
    }
    function mk(n, a, f) {
      var m = n.mode,
        b = {
          mode: "visible",
          children: a
        },
        T = _0(b, m);
      return T.return = n, n.child = T, T;
    }
    function $P(n, a, f, m) {
      var b = n.mode,
        T = n.child,
        M = {
          mode: "hidden",
          children: a
        },
        z,
        U;
      return (b & Wt) === dt && T !== null ? (z = T, z.childLanes = De, z.pendingProps = M, n.mode & nn && (z.actualDuration = 0, z.actualStartTime = -1, z.selfBaseDuration = 0, z.treeBaseDuration = 0), U = Lm(f, b, m, null)) : (z = _0(M, b), U = Lm(f, b, m, null)), z.return = n, U.return = n, z.sibling = U, n.child = z, U;
    }
    function _0(n, a, f) {
      return M1(n, a, De, null);
    }
    function XD(n, a) {
      return Om(n, a);
    }
    function WP(n, a, f, m) {
      var b = n.child,
        T = b.sibling,
        M = XD(b, {
          mode: "visible",
          children: f
        });
      if ((a.mode & Wt) === dt && (M.lanes = m), M.return = a, M.sibling = null, T !== null) {
        var z = a.deletions;
        z === null ? (a.deletions = [T], a.flags |= _i) : z.push(T);
      }
      return a.child = M, M;
    }
    function qP(n, a, f, m, b) {
      var T = a.mode,
        M = n.child,
        z = M.sibling,
        U = {
          mode: "hidden",
          children: f
        },
        X;
      if (
      // In legacy mode, we commit the primary tree as if it successfully
      // completed, even though it's in an inconsistent state.
      (T & Wt) === dt &&
      // Make sure we're on the second pass, i.e. the primary child fragment was
      // already cloned. In legacy mode, the only case where this isn't true is
      // when DevTools forces us to display a fallback; we skip the first render
      // pass entirely and go straight to rendering the fallback. (In Concurrent
      // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
      // only codepath.)
      a.child !== M) {
        var J = a.child;
        X = J, X.childLanes = De, X.pendingProps = U, a.mode & nn && (X.actualDuration = 0, X.actualStartTime = -1, X.selfBaseDuration = M.selfBaseDuration, X.treeBaseDuration = M.treeBaseDuration), a.deletions = null;
      } else X = XD(M, U), X.subtreeFlags = M.subtreeFlags & nr;
      var me;
      return z !== null ? me = Om(z, m) : (me = Lm(m, T, b, null), me.flags |= Gn), me.return = a, X.return = a, X.sibling = me, a.child = X, me;
    }
    function fx(n, a, f, m) {
      m !== null && xC(m), r0(a, n.child, null, f);
      var b = a.pendingProps,
        T = b.children,
        M = mk(a, T);
      return M.flags |= Gn, a.memoizedState = null, M;
    }
    function YP(n, a, f, m, b) {
      var T = a.mode,
        M = {
          mode: "visible",
          children: f
        },
        z = _0(M, T),
        U = Lm(m, T, b, null);
      return U.flags |= Gn, z.return = a, U.return = a, z.sibling = U, a.child = z, (a.mode & Wt) !== dt && r0(a, n.child, null, b), U;
    }
    function GP(n, a, f) {
      return (n.mode & Wt) === dt ? (h("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), n.lanes = Je) : dC(a) ? n.lanes = xa : n.lanes = Jr, null;
    }
    function XP(n, a, f, m, b, T, M) {
      if (f) {
        if (a.flags & qr) {
          a.flags &= -257;
          var ke = i1(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return fx(n, a, M, ke);
        } else {
          if (a.memoizedState !== null) return a.child = n.child, a.flags |= ft, null;
          var Fe = m.children,
            Ie = m.fallback,
            Qe = YP(n, a, Fe, Ie, M),
            Tt = a.child;
          return Tt.memoizedState = l1(M), a.memoizedState = dk, Qe;
        }
      } else {
        if (CP(), (a.mode & Wt) === dt) return fx(n, a, M,
        // TODO: When we delete legacy mode, we should make this error argument
        // required — every concurrent mode path that causes hydration to
        // de-opt to client rendering should have an error message.
        null);
        if (dC(b)) {
          var z, U, X;
          {
            var J = pS(b);
            z = J.digest, U = J.message, X = J.stack;
          }
          var me;
          U ? me = new Error(U) : me = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var Se = i1(me, z, X);
          return fx(n, a, M, Se);
        }
        var Me = _n(M, n.childLanes);
        if (xc || Me) {
          var Pe = Ba();
          if (Pe !== null) {
            var $e = Zm(Pe, M);
            if ($e !== On && $e !== T.retryLane) {
              T.retryLane = $e;
              var mt = wn;
              rl(n, $e), To(Pe, n, $e, mt);
            }
          }
          Ok();
          var Re = i1(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return fx(n, a, M, Re);
        } else if (gD(b)) {
          a.flags |= ft, a.child = n.child;
          var Ue = LA.bind(null, n);
          return n_(b, Ue), null;
        } else {
          ED(a, b, T.treeContext);
          var Be = m.children,
            nt = mk(a, Be);
          return nt.flags |= xi, nt;
        }
      }
    }
    function KD(n, a, f) {
      n.lanes = jt(n.lanes, a);
      var m = n.alternate;
      m !== null && (m.lanes = jt(m.lanes, a)), CC(n.return, a, f);
    }
    function QD(n, a, f) {
      for (var m = a; m !== null;) {
        if (m.tag === V) {
          var b = m.memoizedState;
          b !== null && KD(m, f, n);
        } else if (m.tag === Y) KD(m, f, n);else if (m.child !== null) {
          m.child.return = m, m = m.child;
          continue;
        }
        if (m === n) return;
        for (; m.sibling === null;) {
          if (m.return === null || m.return === n) return;
          m = m.return;
        }
        m.sibling.return = m.return, m = m.sibling;
      }
    }
    function KP(n) {
      for (var a = n, f = null; a !== null;) {
        var m = a.alternate;
        m !== null && ja(m) === null && (f = a), a = a.sibling;
      }
      return f;
    }
    function vk(n) {
      if (n !== void 0 && n !== "forwards" && n !== "backwards" && n !== "together" && !s1[n]) if (s1[n] = !0, typeof n == "string") switch (n.toLowerCase()) {
        case "together":
        case "forwards":
        case "backwards":
          {
            h('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', n, n.toLowerCase());
            break;
          }
        case "forward":
        case "backward":
          {
            h('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', n, n.toLowerCase());
            break;
          }
        default:
          h('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', n);
          break;
      } else h('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', n);
    }
    function ZD(n, a) {
      n !== void 0 && !dx[n] && (n !== "collapsed" && n !== "hidden" ? (dx[n] = !0, h('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', n)) : a !== "forwards" && a !== "backwards" && (dx[n] = !0, h('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', n)));
    }
    function JD(n, a) {
      {
        var f = wr(n),
          m = !f && typeof yn(n) == "function";
        if (f || m) {
          var b = f ? "array" : "iterable";
          return h("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", b, a, b), !1;
        }
      }
      return !0;
    }
    function eI(n, a) {
      if ((a === "forwards" || a === "backwards") && n !== void 0 && n !== null && n !== !1) if (wr(n)) {
        for (var f = 0; f < n.length; f++) if (!JD(n[f], f)) return;
      } else {
        var m = yn(n);
        if (typeof m == "function") {
          var b = m.call(n);
          if (b) for (var T = b.next(), M = 0; !T.done; T = b.next()) {
            if (!JD(T.value, M)) return;
            M++;
          }
        } else h('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', a);
      }
    }
    function gk(n, a, f, m, b) {
      var T = n.memoizedState;
      T === null ? n.memoizedState = {
        isBackwards: a,
        rendering: null,
        renderingStartTime: 0,
        last: m,
        tail: f,
        tailMode: b
      } : (T.isBackwards = a, T.rendering = null, T.renderingStartTime = 0, T.last = m, T.tail = f, T.tailMode = b);
    }
    function yk(n, a, f) {
      var m = a.pendingProps,
        b = m.revealOrder,
        T = m.tail,
        M = m.children;
      vk(b), ZD(T, b), eI(M, b), hl(n, a, M, f);
      var z = pl.current,
        U = z_(z, My);
      if (U) z = vp(z, My), a.flags |= ft;else {
        var X = n !== null && (n.flags & ft) !== pt;
        X && QD(a, a.child, f), z = o0(z);
      }
      if (Sv(a, z), (a.mode & Wt) === dt) a.memoizedState = null;else switch (b) {
        case "forwards":
          {
            var J = KP(a.child),
              me;
            J === null ? (me = a.child, a.child = null) : (me = J.sibling, J.sibling = null), gk(a, !1,
            // isBackwards
            me, J, T);
            break;
          }
        case "backwards":
          {
            var Se = null,
              Me = a.child;
            for (a.child = null; Me !== null;) {
              var Pe = Me.alternate;
              if (Pe !== null && ja(Pe) === null) {
                a.child = Me;
                break;
              }
              var $e = Me.sibling;
              Me.sibling = Se, Se = Me, Me = $e;
            }
            gk(a, !0,
            // isBackwards
            Se, null,
            // last
            T);
            break;
          }
        case "together":
          {
            gk(a, !1,
            // isBackwards
            null,
            // tail
            null,
            // last
            void 0);
            break;
          }
        default:
          a.memoizedState = null;
      }
      return a.child;
    }
    function QP(n, a, f) {
      F_(a, a.stateNode.containerInfo);
      var m = a.pendingProps;
      return n === null ? a.child = r0(a, null, m, f) : hl(n, a, m, f), a.child;
    }
    var x0 = !1;
    function u1(n, a, f) {
      var m = a.type,
        b = m._context,
        T = a.pendingProps,
        M = a.memoizedProps,
        z = T.value;
      {
        "value" in T || x0 || (x0 = !0, h("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var U = a.type.propTypes;
        U && hu(U, T, "prop", "Context.Provider");
      }
      if (MS(a, b, z), M !== null) {
        var X = M.value;
        if (he(X, z)) {
          if (M.children === T.children && !by()) return bp(n, a, f);
        } else Zb(a, b, f);
      }
      var J = T.children;
      return hl(n, a, J, f), a.child;
    }
    var yp = !1;
    function ZP(n, a, f) {
      var m = a.type;
      m._context === void 0 ? m !== m.Consumer && (yp || (yp = !0, h("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : m = m._context;
      var b = a.pendingProps,
        T = b.children;
      typeof T != "function" && h("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), Uc(a, f);
      var M = Aa(m);
      Ti(a);
      var z;
      return By.current = a, br(!0), z = T(M), br(!1), to(), a.flags |= Xi, hl(n, a, z, f), a.child;
    }
    function Hy() {
      xc = !0;
    }
    function c1(n, a) {
      (a.mode & Wt) === dt && n !== null && (n.alternate = null, a.alternate = null, a.flags |= Gn);
    }
    function bp(n, a, f) {
      return n !== null && (a.dependencies = n.dependencies), Bf(), xx(a.lanes), _n(f, a.childLanes) ? (A_(n, a), a.child) : null;
    }
    function S0(n, a, f) {
      {
        var m = a.return;
        if (m === null) throw new Error("Cannot swap the root fiber.");
        if (n.alternate = null, a.alternate = null, f.index = a.index, f.sibling = a.sibling, f.return = a.return, f.ref = a.ref, a === m.child) m.child = f;else {
          var b = m.child;
          if (b === null) throw new Error("Expected parent to have a child.");
          for (; b.sibling !== a;) if (b = b.sibling, b === null) throw new Error("Expected to find the previous sibling.");
          b.sibling = f;
        }
        var T = m.deletions;
        return T === null ? (m.deletions = [n], m.flags |= _i) : T.push(n), f.flags |= Gn, f;
      }
    }
    function d1(n, a) {
      var f = n.lanes;
      return !!_n(f, a);
    }
    function tI(n, a, f) {
      switch (a.tag) {
        case C:
          YD(a), a.stateNode, Pa();
          break;
        case D:
          LD(a);
          break;
        case x:
          {
            var m = a.type;
            Bc(m) && wS(a);
            break;
          }
        case k:
          F_(a, a.stateNode.containerInfo);
          break;
        case L:
          {
            var b = a.memoizedProps.value,
              T = a.type._context;
            MS(a, T, b);
            break;
          }
        case j:
          {
            var M = _n(f, a.childLanes);
            M && (a.flags |= tn);
            {
              var z = a.stateNode;
              z.effectDuration = 0, z.passiveEffectDuration = 0;
            }
          }
          break;
        case V:
          {
            var U = a.memoizedState;
            if (U !== null) {
              if (U.dehydrated !== null) return Sv(a, o0(pl.current)), a.flags |= ft, null;
              var X = a.child,
                J = X.childLanes;
              if (_n(f, J)) return hk(n, a, f);
              Sv(a, o0(pl.current));
              var me = bp(n, a, f);
              return me !== null ? me.sibling : null;
            } else Sv(a, o0(pl.current));
            break;
          }
        case Y:
          {
            var Se = (n.flags & ft) !== pt,
              Me = _n(f, a.childLanes);
            if (Se) {
              if (Me) return yk(n, a, f);
              a.flags |= ft;
            }
            var Pe = a.memoizedState;
            if (Pe !== null && (Pe.rendering = null, Pe.tail = null, Pe.lastEffect = null), Sv(a, pl.current), Me) break;
            return null;
          }
        case oe:
        case ne:
          return a.lanes = De, ek(n, a, f);
      }
      return bp(n, a, f);
    }
    function f1(n, a, f) {
      if (a._debugNeedsRemount && n !== null) return S0(n, a, $k(a.type, a.key, a.pendingProps, a._debugOwner || null, a.mode, a.lanes));
      if (n !== null) {
        var m = n.memoizedProps,
          b = a.pendingProps;
        if (m !== b || by() ||
        // Force a re-render if the implementation changed due to hot reload:
        a.type !== n.type) xc = !0;else {
          var T = d1(n, f);
          if (!T &&
          // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (a.flags & ft) === pt) return xc = !1, tI(n, a, f);
          (n.flags & zd) !== pt ? xc = !0 : xc = !1;
        }
      } else if (xc = !1, tl() && SP(a)) {
        var M = a.index,
          z = _y();
        d_(a, z, M);
      }
      switch (a.lanes = De, a.tag) {
        case E:
          return UP(n, a, a.type, f);
        case Q:
          {
            var U = a.elementType;
            return lk(n, a, U, f);
          }
        case w:
          {
            var X = a.type,
              J = a.pendingProps,
              me = a.elementType === X ? J : wc(X, J);
            return ik(n, a, X, me, f);
          }
        case x:
          {
            var Se = a.type,
              Me = a.pendingProps,
              Pe = a.elementType === Se ? Me : wc(Se, Me);
            return ak(n, a, Se, Pe, f);
          }
        case C:
          return VP(n, a, f);
        case D:
          return BP(n, a, f);
        case I:
          return sk(n, a);
        case V:
          return hk(n, a, f);
        case k:
          return QP(n, a, f);
        case F:
          {
            var $e = a.type,
              mt = a.pendingProps,
              Re = a.elementType === $e ? mt : wc($e, mt);
            return HD(n, a, $e, Re, f);
          }
        case O:
          return tk(n, a, f);
        case P:
          return qD(n, a, f);
        case j:
          return nk(n, a, f);
        case L:
          return u1(n, a, f);
        case N:
          return ZP(n, a, f);
        case K:
          {
            var Ue = a.type,
              Be = a.pendingProps,
              nt = wc(Ue, Be);
            if (a.type !== a.elementType) {
              var ke = Ue.propTypes;
              ke && hu(ke, nt,
              // Resolved for outer only
              "prop", bn(Ue));
            }
            return nt = wc(Ue.type, nt), $D(n, a, Ue, nt, f);
          }
        case G:
          return WD(n, a, a.type, a.pendingProps, f);
        case te:
          {
            var Fe = a.type,
              Ie = a.pendingProps,
              Qe = a.elementType === Fe ? Ie : wc(Fe, Ie);
            return uk(n, a, Fe, Qe, f);
          }
        case Y:
          return yk(n, a, f);
        case ee:
          break;
        case oe:
          return ek(n, a, f);
      }
      throw new Error("Unknown unit of work tag (" + a.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function $y(n) {
      n.flags |= tn;
    }
    function bk(n) {
      n.flags |= Hn, n.flags |= jl;
    }
    var E0, Zo, nI, wk;
    E0 = function (n, a, f, m) {
      for (var b = a.child; b !== null;) {
        if (b.tag === D || b.tag === I) FL(n, b.stateNode);else if (b.tag !== k) {
          if (b.child !== null) {
            b.child.return = b, b = b.child;
            continue;
          }
        }
        if (b === a) return;
        for (; b.sibling === null;) {
          if (b.return === null || b.return === a) return;
          b = b.return;
        }
        b.sibling.return = b.return, b = b.sibling;
      }
    }, Zo = function (n, a) {}, nI = function (n, a, f, m, b) {
      var T = n.memoizedProps;
      if (T !== m) {
        var M = a.stateNode,
          z = N_(),
          U = NL(M, f, T, m, b, z);
        a.updateQueue = U, U && $y(a);
      }
    }, wk = function (n, a, f, m) {
      f !== m && $y(a);
    };
    function px(n, a) {
      if (!tl()) switch (n.tailMode) {
        case "hidden":
          {
            for (var f = n.tail, m = null; f !== null;) f.alternate !== null && (m = f), f = f.sibling;
            m === null ? n.tail = null : m.sibling = null;
            break;
          }
        case "collapsed":
          {
            for (var b = n.tail, T = null; b !== null;) b.alternate !== null && (T = b), b = b.sibling;
            T === null ? !a && n.tail !== null ? n.tail.sibling = null : n.tail = null : T.sibling = null;
            break;
          }
      }
    }
    function ys(n) {
      var a = n.alternate !== null && n.alternate.child === n.child,
        f = De,
        m = pt;
      if (a) {
        if ((n.mode & nn) !== dt) {
          for (var U = n.selfBaseDuration, X = n.child; X !== null;) f = jt(f, jt(X.lanes, X.childLanes)), m |= X.subtreeFlags & nr, m |= X.flags & nr, U += X.treeBaseDuration, X = X.sibling;
          n.treeBaseDuration = U;
        } else for (var J = n.child; J !== null;) f = jt(f, jt(J.lanes, J.childLanes)), m |= J.subtreeFlags & nr, m |= J.flags & nr, J.return = n, J = J.sibling;
        n.subtreeFlags |= m;
      } else {
        if ((n.mode & nn) !== dt) {
          for (var b = n.actualDuration, T = n.selfBaseDuration, M = n.child; M !== null;) f = jt(f, jt(M.lanes, M.childLanes)), m |= M.subtreeFlags, m |= M.flags, b += M.actualDuration, T += M.treeBaseDuration, M = M.sibling;
          n.actualDuration = b, n.treeBaseDuration = T;
        } else for (var z = n.child; z !== null;) f = jt(f, jt(z.lanes, z.childLanes)), m |= z.subtreeFlags, m |= z.flags, z.return = n, z = z.sibling;
        n.subtreeFlags |= m;
      }
      return n.childLanes = f, a;
    }
    function rI(n, a, f) {
      if (Gb() && (a.mode & Wt) !== dt && (a.flags & ft) === pt) return _C(a), Pa(), a.flags |= qr | Gu | Gr, !1;
      var m = p_(a);
      if (f !== null && f.dehydrated !== null) {
        if (n === null) {
          if (!m) throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (CD(a), ys(a), (a.mode & nn) !== dt) {
            var b = f !== null;
            if (b) {
              var T = a.child;
              T !== null && (a.treeBaseDuration -= T.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (Pa(), (a.flags & ft) === pt && (a.memoizedState = null), a.flags |= tn, ys(a), (a.mode & nn) !== dt) {
            var M = f !== null;
            if (M) {
              var z = a.child;
              z !== null && (a.treeBaseDuration -= z.treeBaseDuration);
            }
          }
          return !1;
        }
      } else return RS(), !0;
    }
    function hx(n, a, f) {
      var m = a.pendingProps;
      switch (gC(a), a.tag) {
        case E:
        case Q:
        case G:
        case w:
        case F:
        case O:
        case P:
        case j:
        case N:
        case K:
          return ys(a), null;
        case x:
          {
            var b = a.type;
            return Bc(b) && u_(a), ys(a), null;
          }
        case C:
          {
            var T = a.stateNode;
            if (Iy(a), bS(a), Zt(), T.pendingContext && (T.context = T.pendingContext, T.pendingContext = null), n === null || n.child === null) {
              var M = p_(a);
              if (M) $y(a);else if (n !== null) {
                var z = n.memoizedState;
                // Check if this is a client root
                (!z.isDehydrated ||
                // Check if we reverted to client rendering (e.g. due to an error)
                (a.flags & qr) !== pt) && (a.flags |= or, RS());
              }
            }
            return Zo(n, a), ys(a), null;
          }
        case D:
          {
            HS(a);
            var U = Dy(),
              X = a.type;
            if (n !== null && a.stateNode != null) nI(n, a, X, m, U), n.ref !== a.ref && bk(a);else {
              if (!m) {
                if (a.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                return ys(a), null;
              }
              var J = N_(),
                me = p_(a);
              if (me) TP(a, U, J) && $y(a);else {
                var Se = jL(X, m, U, J, a);
                E0(Se, a, !1, !1), a.stateNode = Se, iC(Se, X, m, U) && $y(a);
              }
              a.ref !== null && bk(a);
            }
            return ys(a), null;
          }
        case I:
          {
            var Me = m;
            if (n && a.stateNode != null) {
              var Pe = n.memoizedProps;
              wk(n, a, Pe, Me);
            } else {
              if (typeof Me != "string" && a.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              var $e = Dy(),
                mt = N_(),
                Re = p_(a);
              Re ? RP(a) && $y(a) : a.stateNode = oC(Me, $e, mt, a);
            }
            return ys(a), null;
          }
        case V:
          {
            xm(a);
            var Ue = a.memoizedState;
            if (n === null || n.memoizedState !== null && n.memoizedState.dehydrated !== null) {
              var Be = rI(n, a, Ue);
              if (!Be) return a.flags & Gr ? a : null;
            }
            if ((a.flags & ft) !== pt) return a.lanes = f, (a.mode & nn) !== dt && sx(a), a;
            var nt = Ue !== null,
              ke = n !== null && n.memoizedState !== null;
            if (nt !== ke && nt) {
              var Fe = a.child;
              if (Fe.flags |= tr, (a.mode & Wt) !== dt) {
                var Ie = n === null && (a.memoizedProps.unstable_avoidThisFallback !== !0 || !0);
                Ie || z_(pl.current, $c) ? S1() : Ok();
              }
            }
            var Qe = a.updateQueue;
            if (Qe !== null && (a.flags |= tn), ys(a), (a.mode & nn) !== dt && nt) {
              var Tt = a.child;
              Tt !== null && (a.treeBaseDuration -= Tt.treeBaseDuration);
            }
            return null;
          }
        case k:
          return Iy(a), Zo(n, a), n === null && Hb(a.stateNode.containerInfo), ys(a), null;
        case L:
          var _t = a.type._context;
          return EC(_t, a), ys(a), null;
        case te:
          {
            var an = a.type;
            return Bc(an) && u_(a), ys(a), null;
          }
        case Y:
          {
            xm(a);
            var Gt = a.memoizedState;
            if (Gt === null) return ys(a), null;
            var Pn = (a.flags & ft) !== pt,
              Fn = Gt.rendering;
            if (Fn === null) {
              if (Pn) px(Gt, !1);else {
                var kr = TA() && (n === null || (n.flags & ft) === pt);
                if (!kr) for (var qn = a.child; qn !== null;) {
                  var Tr = ja(qn);
                  if (Tr !== null) {
                    Pn = !0, a.flags |= ft, px(Gt, !1);
                    var ai = Tr.updateQueue;
                    return ai !== null && (a.updateQueue = ai, a.flags |= tn), a.subtreeFlags = pt, _v(a, f), Sv(a, vp(pl.current, My)), a.child;
                  }
                  qn = qn.sibling;
                }
                Gt.tail !== null && sr() > Ov() && (a.flags |= ft, Pn = !0, px(Gt, !1), a.lanes = of);
              }
            } else {
              if (!Pn) {
                var Br = ja(Fn);
                if (Br !== null) {
                  a.flags |= ft, Pn = !0;
                  var ho = Br.updateQueue;
                  if (ho !== null && (a.updateQueue = ho, a.flags |= tn), px(Gt, !0), Gt.tail === null && Gt.tailMode === "hidden" && !Fn.alternate && !tl()) return ys(a), null;
                } else
                  // The time it took to render last row is greater than the remaining
                  // time we have to render. So rendering one more row would likely
                  // exceed it.
                  sr() * 2 - Gt.renderingStartTime > Ov() && f !== Jr && (a.flags |= ft, Pn = !0, px(Gt, !1), a.lanes = of);
              }
              if (Gt.isBackwards) Fn.sibling = a.child, a.child = Fn;else {
                var Ro = Gt.last;
                Ro !== null ? Ro.sibling = Fn : a.child = Fn, Gt.last = Fn;
              }
            }
            if (Gt.tail !== null) {
              var ns = Gt.tail;
              Gt.rendering = ns, Gt.tail = ns.sibling, Gt.renderingStartTime = sr(), ns.sibling = null;
              var ta = pl.current;
              return Pn ? ta = vp(ta, My) : ta = o0(ta), Sv(a, ta), ns;
            }
            return ys(a), null;
          }
        case ee:
          break;
        case oe:
        case ne:
          {
            _1(a);
            var Pm = a.memoizedState,
              z0 = Pm !== null;
            if (n !== null) {
              var mT = n.memoizedState,
                Bv = mT !== null;
              Bv !== z0 && (a.flags |= tr);
            }
            return !z0 || (a.mode & Wt) === dt ? ys(a) : _n(Ec, Jr) && (ys(a), a.subtreeFlags & (Gn | tn) && (a.flags |= tr)), null;
          }
        case se:
          return null;
        case ue:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + a.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function al(n, a, f) {
      switch (gC(a), a.tag) {
        case x:
          {
            var m = a.type;
            Bc(m) && u_(a);
            var b = a.flags;
            return b & Gr ? (a.flags = b & -65537 | ft, (a.mode & nn) !== dt && sx(a), a) : null;
          }
        case C:
          {
            a.stateNode, Iy(a), bS(a), Zt();
            var T = a.flags;
            return (T & Gr) !== pt && (T & ft) === pt ? (a.flags = T & -65537 | ft, a) : null;
          }
        case D:
          return HS(a), null;
        case V:
          {
            xm(a);
            var M = a.memoizedState;
            if (M !== null && M.dehydrated !== null) {
              if (a.alternate === null) throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
              Pa();
            }
            var z = a.flags;
            return z & Gr ? (a.flags = z & -65537 | ft, (a.mode & nn) !== dt && sx(a), a) : null;
          }
        case Y:
          return xm(a), null;
        case k:
          return Iy(a), null;
        case L:
          var U = a.type._context;
          return EC(U, a), null;
        case oe:
        case ne:
          return _1(a), null;
        case se:
          return null;
        default:
          return null;
      }
    }
    function iI(n, a, f) {
      switch (gC(a), a.tag) {
        case x:
          {
            var m = a.type.childContextTypes;
            m != null && u_(a);
            break;
          }
        case C:
          {
            a.stateNode, Iy(a), bS(a), Zt();
            break;
          }
        case D:
          {
            HS(a);
            break;
          }
        case k:
          Iy(a);
          break;
        case V:
          xm(a);
          break;
        case Y:
          xm(a);
          break;
        case L:
          var b = a.type._context;
          EC(b, a);
          break;
        case oe:
        case ne:
          _1(a);
          break;
      }
    }
    var dn = null;
    dn = /* @__PURE__ */new Set();
    var Cm = !1,
      Na = !1,
      JP = typeof WeakSet == "function" ? WeakSet : Set,
      fn = null,
      Wy = null,
      Dv = null;
    function eA(n) {
      Vo(null, function () {
        throw n;
      }), Yu();
    }
    var aI = function (n, a) {
      if (a.props = n.memoizedProps, a.state = n.memoizedState, n.mode & nn) try {
        Gc(), a.componentWillUnmount();
      } finally {
        Yc(n);
      } else a.componentWillUnmount();
    };
    function qy(n, a) {
      try {
        Mv(lo, n);
      } catch (f) {
        Ni(n, a, f);
      }
    }
    function C0(n, a, f) {
      try {
        aI(n, f);
      } catch (m) {
        Ni(n, a, m);
      }
    }
    function oI(n, a, f) {
      try {
        f.componentDidMount();
      } catch (m) {
        Ni(n, a, m);
      }
    }
    function sI(n, a) {
      try {
        _k(n);
      } catch (f) {
        Ni(n, a, f);
      }
    }
    function k0(n, a) {
      var f = n.ref;
      if (f !== null) if (typeof f == "function") {
        var m;
        try {
          if (Ee && fe && n.mode & nn) try {
            Gc(), m = f(null);
          } finally {
            Yc(n);
          } else m = f(null);
        } catch (b) {
          Ni(n, a, b);
        }
        typeof m == "function" && h("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", At(n));
      } else f.current = null;
    }
    function p1(n, a, f) {
      try {
        f();
      } catch (m) {
        Ni(n, a, m);
      }
    }
    var lI = !1;
    function Hf(n, a) {
      PL(n.containerInfo), fn = a, Iv();
      var f = lI;
      return lI = !1, f;
    }
    function Iv() {
      for (; fn !== null;) {
        var n = fn,
          a = n.child;
        (n.subtreeFlags & Uo) !== pt && a !== null ? (a.return = n, fn = a) : tA();
      }
    }
    function tA() {
      for (; fn !== null;) {
        var n = fn;
        Rn(n);
        try {
          nA(n);
        } catch (f) {
          Ni(n, n.return, f);
        }
        Un();
        var a = n.sibling;
        if (a !== null) {
          a.return = n.return, fn = a;
          return;
        }
        fn = n.return;
      }
    }
    function nA(n) {
      var a = n.alternate,
        f = n.flags;
      if ((f & or) !== pt) {
        switch (Rn(n), n.tag) {
          case w:
          case F:
          case G:
            break;
          case x:
            {
              if (a !== null) {
                var m = a.memoizedProps,
                  b = a.memoizedState,
                  T = n.stateNode;
                n.type === n.elementType && !Uy && (T.props !== n.memoizedProps && h("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", At(n) || "instance"), T.state !== n.memoizedState && h("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", At(n) || "instance"));
                var M = T.getSnapshotBeforeUpdate(n.elementType === n.type ? m : wc(n.type, m), b);
                {
                  var z = dn;
                  M === void 0 && !z.has(n.type) && (z.add(n.type), h("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", At(n)));
                }
                T.__reactInternalSnapshotBeforeUpdate = M;
              }
              break;
            }
          case C:
            {
              {
                var U = n.stateNode;
                eP(U.containerInfo);
              }
              break;
            }
          case D:
          case I:
          case k:
          case te:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        Un();
      }
    }
    function $f(n, a, f) {
      var m = a.updateQueue,
        b = m !== null ? m.lastEffect : null;
      if (b !== null) {
        var T = b.next,
          M = T;
        do {
          if ((M.tag & n) === n) {
            var z = M.destroy;
            M.destroy = void 0, z !== void 0 && ((n & Qo) !== Ta ? Bg(a) : (n & lo) !== Ta && Mh(a), (n & Ui) !== Ta && kp(!0), p1(a, f, z), (n & Ui) !== Ta && kp(!1), (n & Qo) !== Ta ? Ug() : (n & lo) !== Ta && Oh());
          }
          M = M.next;
        } while (M !== T);
      }
    }
    function Mv(n, a) {
      var f = a.updateQueue,
        m = f !== null ? f.lastEffect : null;
      if (m !== null) {
        var b = m.next,
          T = b;
        do {
          if ((T.tag & n) === n) {
            (n & Qo) !== Ta ? Vg(a) : (n & lo) !== Ta && Ih(a);
            var M = T.create;
            (n & Ui) !== Ta && kp(!0), T.destroy = M(), (n & Ui) !== Ta && kp(!1), (n & Qo) !== Ta ? qd() : (n & lo) !== Ta && Yd();
            {
              var z = T.destroy;
              if (z !== void 0 && typeof z != "function") {
                var U = void 0;
                (T.tag & lo) !== pt ? U = "useLayoutEffect" : (T.tag & Ui) !== pt ? U = "useInsertionEffect" : U = "useEffect";
                var X = void 0;
                z === null ? X = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof z.then == "function" ? X = `

It looks like you wrote ` + U + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + U + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : X = " You returned: " + z, h("%s must not return anything besides a function, which is used for clean-up.%s", U, X);
              }
            }
          }
          T = T.next;
        } while (T !== b);
      }
    }
    function uI(n, a) {
      if ((a.flags & tn) !== pt) switch (a.tag) {
        case j:
          {
            var f = a.stateNode.passiveEffectDuration,
              m = a.memoizedProps,
              b = m.id,
              T = m.onPostCommit,
              M = ax(),
              z = a.alternate === null ? "mount" : "update";
            GC() && (z = "nested-update"), typeof T == "function" && T(b, z, f, M);
            var U = a.return;
            e: for (; U !== null;) {
              switch (U.tag) {
                case C:
                  var X = U.stateNode;
                  X.passiveEffectDuration += f;
                  break e;
                case j:
                  var J = U.stateNode;
                  J.passiveEffectDuration += f;
                  break e;
              }
              U = U.return;
            }
            break;
          }
      }
    }
    function rA(n, a, f, m) {
      if ((f.flags & $o) !== pt) switch (f.tag) {
        case w:
        case F:
        case G:
          {
            if (!Na) if (f.mode & nn) try {
              Gc(), Mv(lo | Er, f);
            } finally {
              Yc(f);
            } else Mv(lo | Er, f);
            break;
          }
        case x:
          {
            var b = f.stateNode;
            if (f.flags & tn && !Na) if (a === null) {
              if (f.type === f.elementType && !Uy && (b.props !== f.memoizedProps && h("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", At(f) || "instance"), b.state !== f.memoizedState && h("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", At(f) || "instance")), f.mode & nn) try {
                Gc(), b.componentDidMount();
              } finally {
                Yc(f);
              } else b.componentDidMount();
            } else {
              var T = f.elementType === f.type ? a.memoizedProps : wc(f.type, a.memoizedProps),
                M = a.memoizedState;
              if (f.type === f.elementType && !Uy && (b.props !== f.memoizedProps && h("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", At(f) || "instance"), b.state !== f.memoizedState && h("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", At(f) || "instance")), f.mode & nn) try {
                Gc(), b.componentDidUpdate(T, M, b.__reactInternalSnapshotBeforeUpdate);
              } finally {
                Yc(f);
              } else b.componentDidUpdate(T, M, b.__reactInternalSnapshotBeforeUpdate);
            }
            var z = f.updateQueue;
            z !== null && (f.type === f.elementType && !Uy && (b.props !== f.memoizedProps && h("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", At(f) || "instance"), b.state !== f.memoizedState && h("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", At(f) || "instance")), TC(f, z, b));
            break;
          }
        case C:
          {
            var U = f.updateQueue;
            if (U !== null) {
              var X = null;
              if (f.child !== null) switch (f.child.tag) {
                case D:
                  X = f.child.stateNode;
                  break;
                case x:
                  X = f.child.stateNode;
                  break;
              }
              TC(f, U, X);
            }
            break;
          }
        case D:
          {
            var J = f.stateNode;
            if (a === null && f.flags & tn) {
              var me = f.type,
                Se = f.memoizedProps;
              hD(J, me, Se);
            }
            break;
          }
        case I:
          break;
        case k:
          break;
        case j:
          {
            {
              var Me = f.memoizedProps,
                Pe = Me.onCommit,
                $e = Me.onRender,
                mt = f.stateNode.effectDuration,
                Re = ax(),
                Ue = a === null ? "mount" : "update";
              GC() && (Ue = "nested-update"), typeof $e == "function" && $e(f.memoizedProps.id, Ue, f.actualDuration, f.treeBaseDuration, f.actualStartTime, Re);
              {
                typeof Pe == "function" && Pe(f.memoizedProps.id, Ue, mt, Re), DA(f);
                var Be = f.return;
                e: for (; Be !== null;) {
                  switch (Be.tag) {
                    case C:
                      var nt = Be.stateNode;
                      nt.effectDuration += mt;
                      break e;
                    case j:
                      var ke = Be.stateNode;
                      ke.effectDuration += mt;
                      break e;
                  }
                  Be = Be.return;
                }
              }
            }
            break;
          }
        case V:
          {
            hI(n, f);
            break;
          }
        case Y:
        case te:
        case ee:
        case oe:
        case ne:
        case ue:
          break;
        default:
          throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
      }
      Na || f.flags & Hn && _k(f);
    }
    function cI(n) {
      switch (n.tag) {
        case w:
        case F:
        case G:
          {
            if (n.mode & nn) try {
              Gc(), qy(n, n.return);
            } finally {
              Yc(n);
            } else qy(n, n.return);
            break;
          }
        case x:
          {
            var a = n.stateNode;
            typeof a.componentDidMount == "function" && oI(n, n.return, a), sI(n, n.return);
            break;
          }
        case D:
          {
            sI(n, n.return);
            break;
          }
      }
    }
    function iA(n, a) {
      for (var f = null, m = n;;) {
        if (m.tag === D) {
          if (f === null) {
            f = m;
            try {
              var b = m.stateNode;
              a ? KL(b) : ZL(m.stateNode, m.memoizedProps);
            } catch (M) {
              Ni(n, n.return, M);
            }
          }
        } else if (m.tag === I) {
          if (f === null) try {
            var T = m.stateNode;
            a ? QL(T) : JL(T, m.memoizedProps);
          } catch (M) {
            Ni(n, n.return, M);
          }
        } else if (!((m.tag === oe || m.tag === ne) && m.memoizedState !== null && m !== n)) {
          if (m.child !== null) {
            m.child.return = m, m = m.child;
            continue;
          }
        }
        if (m === n) return;
        for (; m.sibling === null;) {
          if (m.return === null || m.return === n) return;
          f === m && (f = null), m = m.return;
        }
        f === m && (f = null), m.sibling.return = m.return, m = m.sibling;
      }
    }
    function _k(n) {
      var a = n.ref;
      if (a !== null) {
        var f = n.stateNode,
          m;
        switch (n.tag) {
          case D:
            m = f;
            break;
          default:
            m = f;
        }
        if (typeof a == "function") {
          var b;
          if (n.mode & nn) try {
            Gc(), b = a(m);
          } finally {
            Yc(n);
          } else b = a(m);
          typeof b == "function" && h("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", At(n));
        } else a.hasOwnProperty("current") || h("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", At(n)), a.current = m;
      }
    }
    function dI(n) {
      var a = n.alternate;
      a !== null && (a.return = null), n.return = null;
    }
    function fI(n) {
      var a = n.alternate;
      a !== null && (n.alternate = null, fI(a));
      {
        if (n.child = null, n.deletions = null, n.sibling = null, n.tag === D) {
          var f = n.stateNode;
          f !== null && mS(f);
        }
        n.stateNode = null, n._debugOwner = null, n.return = null, n.dependencies = null, n.memoizedProps = null, n.memoizedState = null, n.pendingProps = null, n.stateNode = null, n.updateQueue = null;
      }
    }
    function xk(n) {
      for (var a = n.return; a !== null;) {
        if (h1(a)) return a;
        a = a.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function h1(n) {
      return n.tag === D || n.tag === C || n.tag === k;
    }
    function bs(n) {
      var a = n;
      e: for (;;) {
        for (; a.sibling === null;) {
          if (a.return === null || h1(a.return)) return null;
          a = a.return;
        }
        for (a.sibling.return = a.return, a = a.sibling; a.tag !== D && a.tag !== I && a.tag !== ie;) {
          if (a.flags & Gn || a.child === null || a.tag === k) continue e;
          a.child.return = a, a = a.child;
        }
        if (!(a.flags & Gn)) return a.stateNode;
      }
    }
    function Wf(n) {
      var a = xk(n);
      switch (a.tag) {
        case D:
          {
            var f = a.stateNode;
            a.flags & Ki && (mD(f), a.flags &= -33);
            var m = bs(n);
            wp(n, m, f);
            break;
          }
        case C:
        case k:
          {
            var b = a.stateNode.containerInfo,
              T = bs(n);
            Sk(n, T, b);
            break;
          }
        // eslint-disable-next-line-no-fallthrough
        default:
          throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function Sk(n, a, f) {
      var m = n.tag,
        b = m === D || m === I;
      if (b) {
        var T = n.stateNode;
        a ? YL(f, T, a) : WL(f, T);
      } else if (m !== k) {
        var M = n.child;
        if (M !== null) {
          Sk(M, a, f);
          for (var z = M.sibling; z !== null;) Sk(z, a, f), z = z.sibling;
        }
      }
    }
    function wp(n, a, f) {
      var m = n.tag,
        b = m === D || m === I;
      if (b) {
        var T = n.stateNode;
        a ? qL(f, T, a) : $L(f, T);
      } else if (m !== k) {
        var M = n.child;
        if (M !== null) {
          wp(M, a, f);
          for (var z = M.sibling; z !== null;) wp(z, a, f), z = z.sibling;
        }
      }
    }
    var ws = null,
      qf = !1;
    function aA(n, a, f) {
      {
        var m = a;
        e: for (; m !== null;) {
          switch (m.tag) {
            case D:
              {
                ws = m.stateNode, qf = !1;
                break e;
              }
            case C:
              {
                ws = m.stateNode.containerInfo, qf = !0;
                break e;
              }
            case k:
              {
                ws = m.stateNode.containerInfo, qf = !0;
                break e;
              }
          }
          m = m.return;
        }
        if (ws === null) throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        pI(n, a, f), ws = null, qf = !1;
      }
      dI(f);
    }
    function km(n, a, f) {
      for (var m = f.child; m !== null;) pI(n, a, m), m = m.sibling;
    }
    function pI(n, a, f) {
      switch (Ng(f), f.tag) {
        case D:
          Na || k0(f, a);
        // eslint-disable-next-line-no-fallthrough
        case I:
          {
            {
              var m = ws,
                b = qf;
              ws = null, km(n, a, f), ws = m, qf = b, ws !== null && (qf ? GL(ws, f.stateNode) : lC(ws, f.stateNode));
            }
            return;
          }
        case ie:
          {
            ws !== null && (qf ? XL(ws, f.stateNode) : uC(ws, f.stateNode));
            return;
          }
        case k:
          {
            {
              var T = ws,
                M = qf;
              ws = f.stateNode.containerInfo, qf = !0, km(n, a, f), ws = T, qf = M;
            }
            return;
          }
        case w:
        case F:
        case K:
        case G:
          {
            if (!Na) {
              var z = f.updateQueue;
              if (z !== null) {
                var U = z.lastEffect;
                if (U !== null) {
                  var X = U.next,
                    J = X;
                  do {
                    var me = J,
                      Se = me.destroy,
                      Me = me.tag;
                    Se !== void 0 && ((Me & Ui) !== Ta ? p1(f, a, Se) : (Me & lo) !== Ta && (Mh(f), f.mode & nn ? (Gc(), p1(f, a, Se), Yc(f)) : p1(f, a, Se), Oh())), J = J.next;
                  } while (J !== X);
                }
              }
            }
            km(n, a, f);
            return;
          }
        case x:
          {
            if (!Na) {
              k0(f, a);
              var Pe = f.stateNode;
              typeof Pe.componentWillUnmount == "function" && C0(f, a, Pe);
            }
            km(n, a, f);
            return;
          }
        case ee:
          {
            km(n, a, f);
            return;
          }
        case oe:
          {
            if (
            // TODO: Remove this dead flag
            f.mode & Wt) {
              var $e = Na;
              Na = $e || f.memoizedState !== null, km(n, a, f), Na = $e;
            } else km(n, a, f);
            break;
          }
        default:
          {
            km(n, a, f);
            return;
          }
      }
    }
    function Yf(n) {
      n.memoizedState;
    }
    function hI(n, a) {
      var f = a.memoizedState;
      if (f === null) {
        var m = a.alternate;
        if (m !== null) {
          var b = m.memoizedState;
          if (b !== null) {
            var T = b.dehydrated;
            T !== null && uP(T);
          }
        }
      }
    }
    function Gf(n) {
      var a = n.updateQueue;
      if (a !== null) {
        n.updateQueue = null;
        var f = n.stateNode;
        f === null && (f = n.stateNode = new JP()), a.forEach(function (m) {
          var b = MI.bind(null, n, m);
          if (!f.has(m)) {
            if (f.add(m), ui) if (Wy !== null && Dv !== null) P0(Dv, Wy);else throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            m.then(b, b);
          }
        });
      }
    }
    function oA(n, a, f) {
      Wy = f, Dv = n, Rn(a), m1(a, n), Rn(a), Wy = null, Dv = null;
    }
    function Kc(n, a, f) {
      var m = a.deletions;
      if (m !== null) for (var b = 0; b < m.length; b++) {
        var T = m[b];
        try {
          aA(n, a, T);
        } catch (U) {
          Ni(T, a, U);
        }
      }
      var M = Mu();
      if (a.subtreeFlags & Ho) for (var z = a.child; z !== null;) Rn(z), m1(z, n), z = z.sibling;
      Rn(M);
    }
    function m1(n, a, f) {
      var m = n.alternate,
        b = n.flags;
      switch (n.tag) {
        case w:
        case F:
        case K:
        case G:
          {
            if (Kc(a, n), _p(n), b & tn) {
              try {
                $f(Ui | Er, n, n.return), Mv(Ui | Er, n);
              } catch (an) {
                Ni(n, n.return, an);
              }
              if (n.mode & nn) {
                try {
                  Gc(), $f(lo | Er, n, n.return);
                } catch (an) {
                  Ni(n, n.return, an);
                }
                Yc(n);
              } else try {
                $f(lo | Er, n, n.return);
              } catch (an) {
                Ni(n, n.return, an);
              }
            }
            return;
          }
        case x:
          {
            Kc(a, n), _p(n), b & Hn && m !== null && k0(m, m.return);
            return;
          }
        case D:
          {
            Kc(a, n), _p(n), b & Hn && m !== null && k0(m, m.return);
            {
              if (n.flags & Ki) {
                var T = n.stateNode;
                try {
                  mD(T);
                } catch (an) {
                  Ni(n, n.return, an);
                }
              }
              if (b & tn) {
                var M = n.stateNode;
                if (M != null) {
                  var z = n.memoizedProps,
                    U = m !== null ? m.memoizedProps : z,
                    X = n.type,
                    J = n.updateQueue;
                  if (n.updateQueue = null, J !== null) try {
                    UL(M, J, X, U, z, n);
                  } catch (an) {
                    Ni(n, n.return, an);
                  }
                }
              }
            }
            return;
          }
        case I:
          {
            if (Kc(a, n), _p(n), b & tn) {
              if (n.stateNode === null) throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
              var me = n.stateNode,
                Se = n.memoizedProps,
                Me = m !== null ? m.memoizedProps : Se;
              try {
                HL(me, Me, Se);
              } catch (an) {
                Ni(n, n.return, an);
              }
            }
            return;
          }
        case C:
          {
            if (Kc(a, n), _p(n), b & tn && m !== null) {
              var Pe = m.memoizedState;
              if (Pe.isDehydrated) try {
                lP(a.containerInfo);
              } catch (an) {
                Ni(n, n.return, an);
              }
            }
            return;
          }
        case k:
          {
            Kc(a, n), _p(n);
            return;
          }
        case V:
          {
            Kc(a, n), _p(n);
            var $e = n.child;
            if ($e.flags & tr) {
              var mt = $e.stateNode,
                Re = $e.memoizedState,
                Ue = Re !== null;
              if (mt.isHidden = Ue, Ue) {
                var Be = $e.alternate !== null && $e.alternate.memoizedState !== null;
                Be || CA();
              }
            }
            if (b & tn) {
              try {
                Yf(n);
              } catch (an) {
                Ni(n, n.return, an);
              }
              Gf(n);
            }
            return;
          }
        case oe:
          {
            var nt = m !== null && m.memoizedState !== null;
            if (
            // TODO: Remove this dead flag
            n.mode & Wt) {
              var ke = Na;
              Na = ke || nt, Kc(a, n), Na = ke;
            } else Kc(a, n);
            if (_p(n), b & tr) {
              var Fe = n.stateNode,
                Ie = n.memoizedState,
                Qe = Ie !== null,
                Tt = n;
              if (Fe.isHidden = Qe, Qe && !nt && (Tt.mode & Wt) !== dt) {
                fn = Tt;
                for (var _t = Tt.child; _t !== null;) fn = _t, sA(_t), _t = _t.sibling;
              }
              iA(Tt, Qe);
            }
            return;
          }
        case Y:
          {
            Kc(a, n), _p(n), b & tn && Gf(n);
            return;
          }
        case ee:
          return;
        default:
          {
            Kc(a, n), _p(n);
            return;
          }
      }
    }
    function _p(n) {
      var a = n.flags;
      if (a & Gn) {
        try {
          Wf(n);
        } catch (f) {
          Ni(n, n.return, f);
        }
        n.flags &= -3;
      }
      a & xi && (n.flags &= -4097);
    }
    function mI(n, a, f) {
      Wy = f, Dv = a, fn = n, vI(n, a, f), Wy = null, Dv = null;
    }
    function vI(n, a, f) {
      for (var m = (n.mode & Wt) !== dt; fn !== null;) {
        var b = fn,
          T = b.child;
        if (b.tag === oe && m) {
          var M = b.memoizedState !== null,
            z = M || Cm;
          if (z) {
            v1(n, a, f);
            continue;
          } else {
            var U = b.alternate,
              X = U !== null && U.memoizedState !== null,
              J = X || Na,
              me = Cm,
              Se = Na;
            Cm = z, Na = J, Na && !Se && (fn = b, lA(b));
            for (var Me = T; Me !== null;) fn = Me, vI(Me,
            // New root; bubble back up to here and stop.
            a, f), Me = Me.sibling;
            fn = b, Cm = me, Na = Se, v1(n, a, f);
            continue;
          }
        }
        (b.subtreeFlags & $o) !== pt && T !== null ? (T.return = b, fn = T) : v1(n, a, f);
      }
    }
    function v1(n, a, f) {
      for (; fn !== null;) {
        var m = fn;
        if ((m.flags & $o) !== pt) {
          var b = m.alternate;
          Rn(m);
          try {
            rA(a, b, m, f);
          } catch (M) {
            Ni(m, m.return, M);
          }
          Un();
        }
        if (m === n) {
          fn = null;
          return;
        }
        var T = m.sibling;
        if (T !== null) {
          T.return = m.return, fn = T;
          return;
        }
        fn = m.return;
      }
    }
    function sA(n) {
      for (; fn !== null;) {
        var a = fn,
          f = a.child;
        switch (a.tag) {
          case w:
          case F:
          case K:
          case G:
            {
              if (a.mode & nn) try {
                Gc(), $f(lo, a, a.return);
              } finally {
                Yc(a);
              } else $f(lo, a, a.return);
              break;
            }
          case x:
            {
              k0(a, a.return);
              var m = a.stateNode;
              typeof m.componentWillUnmount == "function" && C0(a, a.return, m);
              break;
            }
          case D:
            {
              k0(a, a.return);
              break;
            }
          case oe:
            {
              var b = a.memoizedState !== null;
              if (b) {
                gI(n);
                continue;
              }
              break;
            }
        }
        f !== null ? (f.return = a, fn = f) : gI(n);
      }
    }
    function gI(n) {
      for (; fn !== null;) {
        var a = fn;
        if (a === n) {
          fn = null;
          return;
        }
        var f = a.sibling;
        if (f !== null) {
          f.return = a.return, fn = f;
          return;
        }
        fn = a.return;
      }
    }
    function lA(n) {
      for (; fn !== null;) {
        var a = fn,
          f = a.child;
        if (a.tag === oe) {
          var m = a.memoizedState !== null;
          if (m) {
            yI(n);
            continue;
          }
        }
        f !== null ? (f.return = a, fn = f) : yI(n);
      }
    }
    function yI(n) {
      for (; fn !== null;) {
        var a = fn;
        Rn(a);
        try {
          cI(a);
        } catch (m) {
          Ni(a, a.return, m);
        }
        if (Un(), a === n) {
          fn = null;
          return;
        }
        var f = a.sibling;
        if (f !== null) {
          f.return = a.return, fn = f;
          return;
        }
        fn = a.return;
      }
    }
    function uA(n, a, f, m) {
      fn = a, cA(a, n, f, m);
    }
    function cA(n, a, f, m) {
      for (; fn !== null;) {
        var b = fn,
          T = b.child;
        (b.subtreeFlags & Ja) !== pt && T !== null ? (T.return = b, fn = T) : dA(n, a, f, m);
      }
    }
    function dA(n, a, f, m) {
      for (; fn !== null;) {
        var b = fn;
        if ((b.flags & Yr) !== pt) {
          Rn(b);
          try {
            fA(a, b, f, m);
          } catch (M) {
            Ni(b, b.return, M);
          }
          Un();
        }
        if (b === n) {
          fn = null;
          return;
        }
        var T = b.sibling;
        if (T !== null) {
          T.return = b.return, fn = T;
          return;
        }
        fn = b.return;
      }
    }
    function fA(n, a, f, m) {
      switch (a.tag) {
        case w:
        case F:
        case G:
          {
            if (a.mode & nn) {
              KC();
              try {
                Mv(Qo | Er, a);
              } finally {
                Em(a);
              }
            } else Mv(Qo | Er, a);
            break;
          }
      }
    }
    function pA(n) {
      fn = n, hA();
    }
    function hA() {
      for (; fn !== null;) {
        var n = fn,
          a = n.child;
        if ((fn.flags & _i) !== pt) {
          var f = n.deletions;
          if (f !== null) {
            for (var m = 0; m < f.length; m++) {
              var b = f[m];
              fn = b, gA(b, n);
            }
            {
              var T = n.alternate;
              if (T !== null) {
                var M = T.child;
                if (M !== null) {
                  T.child = null;
                  do {
                    var z = M.sibling;
                    M.sibling = null, M = z;
                  } while (M !== null);
                }
              }
            }
            fn = n;
          }
        }
        (n.subtreeFlags & Ja) !== pt && a !== null ? (a.return = n, fn = a) : mA();
      }
    }
    function mA() {
      for (; fn !== null;) {
        var n = fn;
        (n.flags & Yr) !== pt && (Rn(n), vA(n), Un());
        var a = n.sibling;
        if (a !== null) {
          a.return = n.return, fn = a;
          return;
        }
        fn = n.return;
      }
    }
    function vA(n) {
      switch (n.tag) {
        case w:
        case F:
        case G:
          {
            n.mode & nn ? (KC(), $f(Qo | Er, n, n.return), Em(n)) : $f(Qo | Er, n, n.return);
            break;
          }
      }
    }
    function gA(n, a) {
      for (; fn !== null;) {
        var f = fn;
        Rn(f), bA(f, a), Un();
        var m = f.child;
        m !== null ? (m.return = f, fn = m) : yA(n);
      }
    }
    function yA(n) {
      for (; fn !== null;) {
        var a = fn,
          f = a.sibling,
          m = a.return;
        if (fI(a), a === n) {
          fn = null;
          return;
        }
        if (f !== null) {
          f.return = m, fn = f;
          return;
        }
        fn = m;
      }
    }
    function bA(n, a) {
      switch (n.tag) {
        case w:
        case F:
        case G:
          {
            n.mode & nn ? (KC(), $f(Qo, n, a), Em(n)) : $f(Qo, n, a);
            break;
          }
      }
    }
    function mx(n) {
      switch (n.tag) {
        case w:
        case F:
        case G:
          {
            try {
              Mv(lo | Er, n);
            } catch (f) {
              Ni(n, n.return, f);
            }
            break;
          }
        case x:
          {
            var a = n.stateNode;
            try {
              a.componentDidMount();
            } catch (f) {
              Ni(n, n.return, f);
            }
            break;
          }
      }
    }
    function wA(n) {
      switch (n.tag) {
        case w:
        case F:
        case G:
          {
            try {
              Mv(Qo | Er, n);
            } catch (a) {
              Ni(n, n.return, a);
            }
            break;
          }
      }
    }
    function _A(n) {
      switch (n.tag) {
        case w:
        case F:
        case G:
          {
            try {
              $f(lo | Er, n, n.return);
            } catch (f) {
              Ni(n, n.return, f);
            }
            break;
          }
        case x:
          {
            var a = n.stateNode;
            typeof a.componentWillUnmount == "function" && C0(n, n.return, a);
            break;
          }
      }
    }
    function xA(n) {
      switch (n.tag) {
        case w:
        case F:
        case G:
          try {
            $f(Qo | Er, n, n.return);
          } catch (a) {
            Ni(n, n.return, a);
          }
      }
    }
    if (typeof Symbol == "function" && Symbol.for) {
      var vx = Symbol.for;
      vx("selector.component"), vx("selector.has_pseudo_class"), vx("selector.role"), vx("selector.test_id"), vx("selector.text");
    }
    var bI = [];
    function SA() {
      bI.forEach(function (n) {
        return n();
      });
    }
    var Ek = i.ReactCurrentActQueue;
    function Ck(n) {
      {
        var a =
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0,
          f = typeof jest < "u";
        return f && a !== !1;
      }
    }
    function _s() {
      {
        var n =
        // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
        typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0;
        return !n && Ek.current !== null && h("The current testing environment is not configured to support act(...)"), n;
      }
    }
    var Xf = Math.ceil,
      fo = i.ReactCurrentDispatcher,
      g1 = i.ReactCurrentOwner,
      Ar = i.ReactCurrentBatchConfig,
      za = i.ReactCurrentActQueue,
      ji = /*             */
      0,
      T0 = /*               */
      1,
      Da = /*                */
      2,
      iu = /*                */
      4,
      Sc = 0,
      R0 = 1,
      Tm = 2,
      cr = 3,
      Jo = 4,
      da = 5,
      po = 6,
      Wn = ji,
      ol = null,
      lr = null,
      Ia = De,
      Ec = De,
      Yy = ka(De),
      Va = Sc,
      Rm = null,
      sl = De,
      Gy = De,
      gx = De,
      D0 = null,
      wu = null,
      Kf = 0,
      I0 = 500,
      kk = 1 / 0,
      y1 = 500,
      Qf = null;
    function xp() {
      kk = sr() + y1;
    }
    function Ov() {
      return kk;
    }
    var Zf = !1,
      Xy = null,
      Lv = null,
      Dm = !1,
      Pv = null,
      Im = De,
      yx = [],
      bx = null,
      b1 = 50,
      wx = 0,
      Av = null,
      M0 = !1,
      Ky = !1,
      w1 = 50,
      Qy = 0,
      Zy = null,
      es = wn,
      Jf = De,
      wI = !1;
    function Ba() {
      return ol;
    }
    function au() {
      return (Wn & (Da | iu)) !== ji ? sr() : (es !== wn || (es = sr()), es);
    }
    function jv(n) {
      var a = n.mode;
      if ((a & Wt) === dt) return Je;
      if ((Wn & Da) !== ji && Ia !== De) return Xl(Ia);
      var f = IP() !== Mf;
      if (f) {
        if (Ar.transition !== null) {
          var m = Ar.transition;
          m._updatedFibers || (m._updatedFibers = /* @__PURE__ */new Set()), m._updatedFibers.add(n);
        }
        return Jf === On && (Jf = Vh()), Jf;
      }
      var b = zr();
      if (b !== On) return b;
      var T = zL();
      return T;
    }
    function _u(n) {
      var a = n.mode;
      return (a & Wt) === dt ? Je : Zg();
    }
    function To(n, a, f, m) {
      C1(), wI && h("useInsertionEffect must not schedule updates."), M0 && (Ky = !0), sc(n, f, m), (Wn & Da) !== De && n === ol ? LI(a) : (ui && ff(n, a, f), j0(a), n === ol && ((Wn & Da) === ji && (Gy = jt(Gy, f)), Va === Jo && Fv(n, Ia)), xu(n, m), f === Je && Wn === ji && (a.mode & Wt) === dt &&
      // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !za.isBatchingLegacy && (xp(), wy()));
    }
    function Tk(n, a, f) {
      var m = n.current;
      m.lanes = a, sc(n, a, f), xu(n, f);
    }
    function _I(n) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (Wn & Da) !== ji
      );
    }
    function xu(n, a) {
      var f = n.callbackNode;
      Xg(n, a);
      var m = lf(n, n === ol ? Ia : De);
      if (m === De) {
        f !== null && A0(f), n.callbackNode = null, n.callbackPriority = On;
        return;
      }
      var b = Go(m),
        T = n.callbackPriority;
      if (T === b &&
      // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(za.current !== null && f !== Ak)) {
        f == null && T !== Je && h("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      f != null && A0(f);
      var M;
      if (b === Je) n.tag === fl ? (za.isBatchingLegacy !== null && (za.didScheduleLegacyUpdate = !0), vv(Ep.bind(null, n))) : mC(Ep.bind(null, n)), za.current !== null ? za.current.push(bc) : VL(function () {
        (Wn & (Da | iu)) === ji && bc();
      }), M = null;else {
        var z;
        switch (fr(m)) {
          case Ii:
            z = Xu;
            break;
          case Zi:
            z = Wo;
            break;
          case os:
            z = eo;
            break;
          case ss:
            z = li;
            break;
          default:
            z = eo;
            break;
        }
        M = jk(z, xI.bind(null, n));
      }
      n.callbackPriority = b, n.callbackNode = M;
    }
    function xI(n, a) {
      if (XC(), es = wn, Jf = De, (Wn & (Da | iu)) !== ji) throw new Error("Should not already be working.");
      var f = n.callbackNode,
        m = Mm();
      if (m && n.callbackNode !== f) return null;
      var b = lf(n, n === ol ? Ia : De);
      if (b === De) return null;
      var T = !Gl(n, b) && !Pw(n, b) && !a,
        M = T ? eb(n, b) : Sx(n, b);
      if (M !== Sc) {
        if (M === Tm) {
          var z = ql(n);
          z !== De && (b = z, M = Sp(n, z));
        }
        if (M === R0) {
          var U = Rm;
          throw Jy(n, De), Fv(n, b), xu(n, sr()), U;
        }
        if (M === po) Fv(n, b);else {
          var X = !Gl(n, b),
            J = n.current.alternate;
          if (X && !Dk(J)) {
            if (M = Sx(n, b), M === Tm) {
              var me = ql(n);
              me !== De && (b = me, M = Sp(n, me));
            }
            if (M === R0) {
              var Se = Rm;
              throw Jy(n, De), Fv(n, b), xu(n, sr()), Se;
            }
          }
          n.finishedWork = J, n.finishedLanes = b, EA(n, M, b);
        }
      }
      return xu(n, sr()), n.callbackNode === f ? xI.bind(null, n) : null;
    }
    function Sp(n, a) {
      var f = D0;
      if ($h(n)) {
        var m = Jy(n, a);
        m.flags |= qr, Ub(n.containerInfo);
      }
      var b = Sx(n, a);
      if (b !== Tm) {
        var T = wu;
        wu = f, T !== null && Rk(T);
      }
      return b;
    }
    function Rk(n) {
      wu === null ? wu = n : wu.push.apply(wu, n);
    }
    function EA(n, a, f) {
      switch (a) {
        case Sc:
        case R0:
          throw new Error("Root did not complete. This is a bug in React.");
        // Flow knows about invariant, so it complains if I add a break
        // statement, but eslint doesn't know about invariant, so it complains
        // if I do. eslint-disable-next-line no-fallthrough
        case Tm:
          {
            tb(n, wu, Qf);
            break;
          }
        case cr:
          {
            if (Fv(n, f), Qg(f) &&
            // do not delay if we're inside an act() scope
            !Cc()) {
              var m = Kf + I0 - sr();
              if (m > 10) {
                var b = lf(n, De);
                if (b !== De) break;
                var T = n.suspendedLanes;
                if (!$s(T, f)) {
                  au(), Qm(n, T);
                  break;
                }
                n.timeoutHandle = t_(tb.bind(null, n, wu, Qf), m);
                break;
              }
            }
            tb(n, wu, Qf);
            break;
          }
        case Jo:
          {
            if (Fv(n, f), Nh(f)) break;
            if (!Cc()) {
              var M = Ow(n, f),
                z = M,
                U = sr() - z,
                X = E1(U) - U;
              if (X > 10) {
                n.timeoutHandle = t_(tb.bind(null, n, wu, Qf), X);
                break;
              }
            }
            tb(n, wu, Qf);
            break;
          }
        case da:
          {
            tb(n, wu, Qf);
            break;
          }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function Dk(n) {
      for (var a = n;;) {
        if (a.flags & Al) {
          var f = a.updateQueue;
          if (f !== null) {
            var m = f.stores;
            if (m !== null) for (var b = 0; b < m.length; b++) {
              var T = m[b],
                M = T.getSnapshot,
                z = T.value;
              try {
                if (!he(M(), z)) return !1;
              } catch {
                return !1;
              }
            }
          }
        }
        var U = a.child;
        if (a.subtreeFlags & Al && U !== null) {
          U.return = a, a = U;
          continue;
        }
        if (a === n) return !0;
        for (; a.sibling === null;) {
          if (a.return === null || a.return === n) return !0;
          a = a.return;
        }
        a.sibling.return = a.return, a = a.sibling;
      }
      return !0;
    }
    function Fv(n, a) {
      a = ac(a, gx), a = ac(a, Gy), Km(n, a);
    }
    function Ep(n) {
      if (VD(), (Wn & (Da | iu)) !== ji) throw new Error("Should not already be working.");
      Mm();
      var a = lf(n, De);
      if (!_n(a, Je)) return xu(n, sr()), null;
      var f = Sx(n, a);
      if (n.tag !== fl && f === Tm) {
        var m = ql(n);
        m !== De && (a = m, f = Sp(n, m));
      }
      if (f === R0) {
        var b = Rm;
        throw Jy(n, De), Fv(n, a), xu(n, sr()), b;
      }
      if (f === po) throw new Error("Root did not complete. This is a bug in React.");
      var T = n.current.alternate;
      return n.finishedWork = T, n.finishedLanes = a, tb(n, wu, Qf), xu(n, sr()), null;
    }
    function SI(n, a) {
      a !== De && (df(n, jt(a, Je)), xu(n, sr()), (Wn & (Da | iu)) === ji && (xp(), bc()));
    }
    function O0(n, a) {
      var f = Wn;
      Wn |= T0;
      try {
        return n(a);
      } finally {
        Wn = f, Wn === ji &&
        // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !za.isBatchingLegacy && (xp(), wy());
      }
    }
    function Ik(n, a, f, m, b) {
      var T = zr(),
        M = Ar.transition;
      try {
        return Ar.transition = null, la(Ii), n(a, f, m, b);
      } finally {
        la(T), Ar.transition = M, Wn === ji && xp();
      }
    }
    function ou(n) {
      Pv !== null && Pv.tag === fl && (Wn & (Da | iu)) === ji && Mm();
      var a = Wn;
      Wn |= T0;
      var f = Ar.transition,
        m = zr();
      try {
        return Ar.transition = null, la(Ii), n ? n() : void 0;
      } finally {
        la(m), Ar.transition = f, Wn = a, (Wn & (Da | iu)) === ji && bc();
      }
    }
    function Mk() {
      return (Wn & (Da | iu)) !== ji;
    }
    function _x(n, a) {
      fi(Yy, Ec, n), Ec = jt(Ec, a);
    }
    function _1(n) {
      Ec = Yy.current, fs(Yy, n);
    }
    function Jy(n, a) {
      n.finishedWork = null, n.finishedLanes = De;
      var f = n.timeoutHandle;
      if (f !== sC && (n.timeoutHandle = sC, fD(f)), lr !== null) for (var m = lr.return; m !== null;) {
        var b = m.alternate;
        iI(b, m), m = m.return;
      }
      ol = n;
      var T = Om(n.current, null);
      return lr = T, Ia = Ec = a, Va = Sc, Rm = null, sl = De, Gy = De, gx = De, D0 = null, wu = null, MP(), nl.discardPendingWarnings(), T;
    }
    function L0(n, a) {
      do {
        var f = lr;
        try {
          if (v_(), _c(), Un(), g1.current = null, f === null || f.return === null) {
            Va = R0, Rm = a, lr = null;
            return;
          }
          if (Ee && f.mode & nn && y0(f, !0), Ce) if (to(), a !== null && typeof a == "object" && typeof a.then == "function") {
            var m = a;
            Lh(f, m, Ia);
          } else Hg(f, a, Ia);
          JC(n, f.return, f, a, Ia), kI(f);
        } catch (b) {
          a = b, lr === f && f !== null ? (f = f.return, lr = f) : f = lr;
          continue;
        }
        return;
      } while (!0);
    }
    function EI() {
      var n = fo.current;
      return fo.current = nx, n === null ? nx : n;
    }
    function x1(n) {
      fo.current = n;
    }
    function CA() {
      Kf = sr();
    }
    function xx(n) {
      sl = jt(n, sl);
    }
    function S1() {
      Va === Sc && (Va = cr);
    }
    function Ok() {
      (Va === Sc || Va === cr || Va === Tm) && (Va = Jo), ol !== null && (Fh(sl) || Fh(Gy)) && Fv(ol, Ia);
    }
    function kA(n) {
      Va !== Jo && (Va = Tm), D0 === null ? D0 = [n] : D0.push(n);
    }
    function TA() {
      return Va === Sc;
    }
    function Sx(n, a) {
      var f = Wn;
      Wn |= Da;
      var m = EI();
      if (ol !== n || Ia !== a) {
        if (ui) {
          var b = n.memoizedUpdaters;
          b.size > 0 && (P0(n, Ia), b.clear()), lc(n, a);
        }
        Qf = as(), Jy(n, a);
      }
      Vs(a);
      do try {
        CI();
        break;
      } catch (T) {
        L0(n, T);
      } while (!0);
      if (v_(), Wn = f, x1(m), lr !== null) throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return Nl(), ol = null, Ia = De, Va;
    }
    function CI() {
      for (; lr !== null;) Cp(lr);
    }
    function eb(n, a) {
      var f = Wn;
      Wn |= Da;
      var m = EI();
      if (ol !== n || Ia !== a) {
        if (ui) {
          var b = n.memoizedUpdaters;
          b.size > 0 && (P0(n, Ia), b.clear()), lc(n, a);
        }
        Qf = as(), xp(), Jy(n, a);
      }
      Vs(a);
      do try {
        RA();
        break;
      } catch (T) {
        L0(n, T);
      } while (!0);
      return v_(), x1(m), Wn = f, lr !== null ? (qg(), Sc) : (Nl(), ol = null, Ia = De, Va);
    }
    function RA() {
      for (; lr !== null && !kh();) Cp(lr);
    }
    function Cp(n) {
      var a = n.alternate;
      Rn(n);
      var f;
      (n.mode & nn) !== dt ? (ox(n), f = Pk(a, n, Ec), y0(n, !0)) : f = Pk(a, n, Ec), Un(), n.memoizedProps = n.pendingProps, f === null ? kI(n) : lr = f, g1.current = null;
    }
    function kI(n) {
      var a = n;
      do {
        var f = a.alternate,
          m = a.return;
        if ((a.flags & Gu) === pt) {
          Rn(a);
          var b = void 0;
          if ((a.mode & nn) === dt ? b = hx(f, a, Ec) : (ox(a), b = hx(f, a, Ec), y0(a, !1)), Un(), b !== null) {
            lr = b;
            return;
          }
        } else {
          var T = al(f, a);
          if (T !== null) {
            T.flags &= Ag, lr = T;
            return;
          }
          if ((a.mode & nn) !== dt) {
            y0(a, !1);
            for (var M = a.actualDuration, z = a.child; z !== null;) M += z.actualDuration, z = z.sibling;
            a.actualDuration = M;
          }
          if (m !== null) m.flags |= Gu, m.subtreeFlags = pt, m.deletions = null;else {
            Va = po, lr = null;
            return;
          }
        }
        var U = a.sibling;
        if (U !== null) {
          lr = U;
          return;
        }
        a = m, lr = a;
      } while (a !== null);
      Va === Sc && (Va = da);
    }
    function tb(n, a, f) {
      var m = zr(),
        b = Ar.transition;
      try {
        Ar.transition = null, la(Ii), TI(n, a, f, m);
      } finally {
        Ar.transition = b, la(m);
      }
      return null;
    }
    function TI(n, a, f, m) {
      do Mm(); while (Pv !== null);
      if (OI(), (Wn & (Da | iu)) !== ji) throw new Error("Should not already be working.");
      var b = n.finishedWork,
        T = n.finishedLanes;
      if (zg(T), b === null) return wa(), null;
      if (T === De && h("root.finishedLanes should not be empty during a commit. This is a bug in React."), n.finishedWork = null, n.finishedLanes = De, b === n.current) throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      n.callbackNode = null, n.callbackPriority = On;
      var M = jt(b.lanes, b.childLanes);
      cf(n, M), n === ol && (ol = null, lr = null, Ia = De), ((b.subtreeFlags & Ja) !== pt || (b.flags & Ja) !== pt) && (Dm || (Dm = !0, bx = f, jk(eo, function () {
        return Mm(), null;
      })));
      var z = (b.subtreeFlags & (Uo | Ho | $o | Ja)) !== pt,
        U = (b.flags & (Uo | Ho | $o | Ja)) !== pt;
      if (z || U) {
        var X = Ar.transition;
        Ar.transition = null;
        var J = zr();
        la(Ii);
        var me = Wn;
        Wn |= iu, g1.current = null, Hf(n, b), Vf(), oA(n, b, T), AL(n.containerInfo), n.current = b, Ku(T), mI(b, n, T), Gd(), Th(), Wn = me, la(J), Ar.transition = X;
      } else n.current = b, Vf();
      var Se = Dm;
      if (Dm ? (Dm = !1, Pv = n, Im = T) : (Qy = 0, Zy = null), M = n.pendingLanes, M === De && (Lv = null), Se || k1(n.current, !1), zs(b.stateNode, m), ui && n.memoizedUpdaters.clear(), SA(), xu(n, sr()), a !== null) for (var Me = n.onRecoverableError, Pe = 0; Pe < a.length; Pe++) {
        var $e = a[Pe],
          mt = $e.stack,
          Re = $e.digest;
        Me($e.value, {
          componentStack: mt,
          digest: Re
        });
      }
      if (Zf) {
        Zf = !1;
        var Ue = Xy;
        throw Xy = null, Ue;
      }
      return _n(Im, Je) && n.tag !== fl && Mm(), M = n.pendingLanes, _n(M, Je) ? (zD(), n === Av ? wx++ : (wx = 0, Av = n)) : wx = 0, bc(), wa(), null;
    }
    function Mm() {
      if (Pv !== null) {
        var n = fr(Im),
          a = Hh(os, n),
          f = Ar.transition,
          m = zr();
        try {
          return Ar.transition = null, la(a), IA();
        } finally {
          la(m), Ar.transition = f;
        }
      }
      return !1;
    }
    function DA(n) {
      yx.push(n), Dm || (Dm = !0, jk(eo, function () {
        return Mm(), null;
      }));
    }
    function IA() {
      if (Pv === null) return !1;
      var n = bx;
      bx = null;
      var a = Pv,
        f = Im;
      if (Pv = null, Im = De, (Wn & (Da | iu)) !== ji) throw new Error("Cannot flush passive effects while already rendering.");
      M0 = !0, Ky = !1, $g(f);
      var m = Wn;
      Wn |= iu, pA(a.current), uA(a, a.current, f, n);
      {
        var b = yx;
        yx = [];
        for (var T = 0; T < b.length; T++) {
          var M = b[T];
          uI(a, M);
        }
      }
      Wg(), k1(a.current, !0), Wn = m, bc(), Ky ? a === Zy ? Qy++ : (Qy = 0, Zy = a) : Qy = 0, M0 = !1, Ky = !1, Rh(a);
      {
        var z = a.current.stateNode;
        z.effectDuration = 0, z.passiveEffectDuration = 0;
      }
      return !0;
    }
    function Lk(n) {
      return Lv !== null && Lv.has(n);
    }
    function Fi(n) {
      Lv === null ? Lv = /* @__PURE__ */new Set([n]) : Lv.add(n);
    }
    function MA(n) {
      Zf || (Zf = !0, Xy = n);
    }
    var RI = MA;
    function DI(n, a, f) {
      var m = Vy(f, a),
        b = BD(n, m, Je),
        T = mp(n, b, Je),
        M = au();
      T !== null && (sc(T, Je, M), xu(T, M));
    }
    function Ni(n, a, f) {
      if (eA(f), kp(!1), n.tag === C) {
        DI(n, n, f);
        return;
      }
      var m = null;
      for (m = a; m !== null;) {
        if (m.tag === C) {
          DI(m, n, f);
          return;
        } else if (m.tag === x) {
          var b = m.type,
            T = m.stateNode;
          if (typeof b.getDerivedStateFromError == "function" || typeof T.componentDidCatch == "function" && !Lk(T)) {
            var M = Vy(f, n),
              z = o1(m, M, Je),
              U = mp(m, z, Je),
              X = au();
            U !== null && (sc(U, Je, X), xu(U, X));
            return;
          }
        }
        m = m.return;
      }
      h(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, f);
    }
    function OA(n, a, f) {
      var m = n.pingCache;
      m !== null && m.delete(a);
      var b = au();
      Qm(n, f), PA(n), ol === n && $s(Ia, f) && (Va === Jo || Va === cr && Qg(Ia) && sr() - Kf < I0 ? Jy(n, De) : gx = jt(gx, f)), xu(n, b);
    }
    function II(n, a) {
      a === On && (a = _u(n));
      var f = au(),
        m = rl(n, a);
      m !== null && (sc(m, a, f), xu(m, f));
    }
    function LA(n) {
      var a = n.memoizedState,
        f = On;
      a !== null && (f = a.retryLane), II(n, f);
    }
    function MI(n, a) {
      var f = On,
        m;
      switch (n.tag) {
        case V:
          m = n.stateNode;
          var b = n.memoizedState;
          b !== null && (f = b.retryLane);
          break;
        case Y:
          m = n.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      m !== null && m.delete(a), II(n, f);
    }
    function E1(n) {
      return n < 120 ? 120 : n < 480 ? 480 : n < 1080 ? 1080 : n < 1920 ? 1920 : n < 3e3 ? 3e3 : n < 4320 ? 4320 : Xf(n / 1960) * 1960;
    }
    function C1() {
      if (wx > b1) throw wx = 0, Av = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      Qy > w1 && (Qy = 0, Zy = null, h("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function OI() {
      nl.flushLegacyContextWarning(), nl.flushPendingUnsafeLifecycleWarnings();
    }
    function k1(n, a) {
      Rn(n), T1(n, Bo, _A), a && T1(n, ga, xA), T1(n, Bo, mx), a && T1(n, ga, wA), Un();
    }
    function T1(n, a, f) {
      for (var m = n, b = null; m !== null;) {
        var T = m.subtreeFlags & a;
        m !== b && m.child !== null && T !== pt ? m = m.child : ((m.flags & a) !== pt && f(m), m.sibling !== null ? m = m.sibling : m = b = m.return);
      }
    }
    var Ex = null;
    function R1(n) {
      {
        if ((Wn & Da) !== ji || !(n.mode & Wt)) return;
        var a = n.tag;
        if (a !== E && a !== C && a !== x && a !== w && a !== F && a !== K && a !== G) return;
        var f = At(n) || "ReactComponent";
        if (Ex !== null) {
          if (Ex.has(f)) return;
          Ex.add(f);
        } else Ex = /* @__PURE__ */new Set([f]);
        var m = Pr;
        try {
          Rn(n), h("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          m ? Rn(n) : Un();
        }
      }
    }
    var Pk;
    {
      var Cx = null;
      Pk = function (n, a, f) {
        var m = zI(Cx, a);
        try {
          return f1(n, a, f);
        } catch (T) {
          if (kP() || T !== null && typeof T == "object" && typeof T.then == "function") throw T;
          if (v_(), _c(), iI(n, a), zI(a, m), a.mode & nn && ox(a), Vo(null, f1, null, n, a, f), Qa()) {
            var b = Yu();
            typeof b == "object" && b !== null && b._suppressLogging && typeof T == "object" && T !== null && !T._suppressLogging && (T._suppressLogging = !0);
          }
          throw T;
        }
      };
    }
    var D1 = !1,
      kx;
    kx = /* @__PURE__ */new Set();
    function LI(n) {
      if (Po && !jP()) switch (n.tag) {
        case w:
        case F:
        case G:
          {
            var a = lr && At(lr) || "Unknown",
              f = a;
            if (!kx.has(f)) {
              kx.add(f);
              var m = At(n) || "Unknown";
              h("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", m, a, a);
            }
            break;
          }
        case x:
          {
            D1 || (h("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), D1 = !0);
            break;
          }
      }
    }
    function P0(n, a) {
      if (ui) {
        var f = n.memoizedUpdaters;
        f.forEach(function (m) {
          ff(n, m, a);
        });
      }
    }
    var Ak = {};
    function jk(n, a) {
      {
        var f = za.current;
        return f !== null ? (f.push(a), Ak) : Ch(n, a);
      }
    }
    function A0(n) {
      if (n !== Ak) return Fg(n);
    }
    function Cc() {
      return za.current !== null;
    }
    function j0(n) {
      {
        if (n.mode & Wt) {
          if (!_s()) return;
        } else if (!Ck() || Wn !== ji || n.tag !== w && n.tag !== F && n.tag !== G) return;
        if (za.current === null) {
          var a = Pr;
          try {
            Rn(n), h(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, At(n));
          } finally {
            a ? Rn(n) : Un();
          }
        }
      }
    }
    function PA(n) {
      n.tag !== fl && _s() && za.current === null && h(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function kp(n) {
      wI = n;
    }
    var Su = null,
      Nv = null,
      PI = function (n) {
        Su = n;
      };
    function nb(n) {
      {
        if (Su === null) return n;
        var a = Su(n);
        return a === void 0 ? n : a.current;
      }
    }
    function Fk(n) {
      return nb(n);
    }
    function Nk(n) {
      {
        if (Su === null) return n;
        var a = Su(n);
        if (a === void 0) {
          if (n != null && typeof n.render == "function") {
            var f = nb(n.render);
            if (n.render !== f) {
              var m = {
                $$typeof: Ye,
                render: f
              };
              return n.displayName !== void 0 && (m.displayName = n.displayName), m;
            }
          }
          return n;
        }
        return a.current;
      }
    }
    function I1(n, a) {
      {
        if (Su === null) return !1;
        var f = n.elementType,
          m = a.type,
          b = !1,
          T = typeof m == "object" && m !== null ? m.$$typeof : null;
        switch (n.tag) {
          case x:
            {
              typeof m == "function" && (b = !0);
              break;
            }
          case w:
            {
              (typeof m == "function" || T === Ct) && (b = !0);
              break;
            }
          case F:
            {
              (T === Ye || T === Ct) && (b = !0);
              break;
            }
          case K:
          case G:
            {
              (T === $t || T === Ct) && (b = !0);
              break;
            }
          default:
            return !1;
        }
        if (b) {
          var M = Su(f);
          if (M !== void 0 && M === Su(m)) return !0;
        }
        return !1;
      }
    }
    function AI(n) {
      {
        if (Su === null || typeof WeakSet != "function") return;
        Nv === null && (Nv = /* @__PURE__ */new WeakSet()), Nv.add(n);
      }
    }
    var zk = function (n, a) {
        {
          if (Su === null) return;
          var f = a.staleFamilies,
            m = a.updatedFamilies;
          Mm(), ou(function () {
            Vk(n.current, m, f);
          });
        }
      },
      AA = function (n, a) {
        {
          if (n.context !== La) return;
          Mm(), ou(function () {
            rb(a, n, null, null);
          });
        }
      };
    function Vk(n, a, f) {
      {
        var m = n.alternate,
          b = n.child,
          T = n.sibling,
          M = n.tag,
          z = n.type,
          U = null;
        switch (M) {
          case w:
          case G:
          case x:
            U = z;
            break;
          case F:
            U = z.render;
            break;
        }
        if (Su === null) throw new Error("Expected resolveFamily to be set during hot reload.");
        var X = !1,
          J = !1;
        if (U !== null) {
          var me = Su(U);
          me !== void 0 && (f.has(me) ? J = !0 : a.has(me) && (M === x ? J = !0 : X = !0));
        }
        if (Nv !== null && (Nv.has(n) || m !== null && Nv.has(m)) && (J = !0), J && (n._debugNeedsRemount = !0), J || X) {
          var Se = rl(n, Je);
          Se !== null && To(Se, n, Je, wn);
        }
        b !== null && !J && Vk(b, a, f), T !== null && Vk(T, a, f);
      }
    }
    var Bk = function (n, a) {
      {
        var f = /* @__PURE__ */new Set(),
          m = new Set(a.map(function (b) {
            return b.current;
          }));
        return jI(n.current, m, f), f;
      }
    };
    function jI(n, a, f) {
      {
        var m = n.child,
          b = n.sibling,
          T = n.tag,
          M = n.type,
          z = null;
        switch (T) {
          case w:
          case G:
          case x:
            z = M;
            break;
          case F:
            z = M.render;
            break;
        }
        var U = !1;
        z !== null && a.has(z) && (U = !0), U ? jA(n, f) : m !== null && jI(m, a, f), b !== null && jI(b, a, f);
      }
    }
    function jA(n, a) {
      {
        var f = kc(n, a);
        if (f) return;
        for (var m = n;;) {
          switch (m.tag) {
            case D:
              a.add(m.stateNode);
              return;
            case k:
              a.add(m.stateNode.containerInfo);
              return;
            case C:
              a.add(m.stateNode.containerInfo);
              return;
          }
          if (m.return === null) throw new Error("Expected to reach root first.");
          m = m.return;
        }
      }
    }
    function kc(n, a) {
      for (var f = n, m = !1;;) {
        if (f.tag === D) m = !0, a.add(f.stateNode);else if (f.child !== null) {
          f.child.return = f, f = f.child;
          continue;
        }
        if (f === n) return m;
        for (; f.sibling === null;) {
          if (f.return === null || f.return === n) return m;
          f = f.return;
        }
        f.sibling.return = f.return, f = f.sibling;
      }
      return !1;
    }
    var Tx;
    {
      Tx = !1;
      try {
        var FI = Object.preventExtensions({});
      } catch {
        Tx = !0;
      }
    }
    function FA(n, a, f, m) {
      this.tag = n, this.key = f, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = a, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = m, this.flags = pt, this.subtreeFlags = pt, this.deletions = null, this.lanes = De, this.childLanes = De, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !Tx && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var ts = function (n, a, f, m) {
      return new FA(n, a, f, m);
    };
    function Uk(n) {
      var a = n.prototype;
      return !!(a && a.isReactComponent);
    }
    function NA(n) {
      return typeof n == "function" && !Uk(n) && n.defaultProps === void 0;
    }
    function Hk(n) {
      if (typeof n == "function") return Uk(n) ? x : w;
      if (n != null) {
        var a = n.$$typeof;
        if (a === Ye) return F;
        if (a === $t) return K;
      }
      return E;
    }
    function Om(n, a) {
      var f = n.alternate;
      f === null ? (f = ts(n.tag, a, n.key, n.mode), f.elementType = n.elementType, f.type = n.type, f.stateNode = n.stateNode, f._debugSource = n._debugSource, f._debugOwner = n._debugOwner, f._debugHookTypes = n._debugHookTypes, f.alternate = n, n.alternate = f) : (f.pendingProps = a, f.type = n.type, f.flags = pt, f.subtreeFlags = pt, f.deletions = null, f.actualDuration = 0, f.actualStartTime = -1), f.flags = n.flags & nr, f.childLanes = n.childLanes, f.lanes = n.lanes, f.child = n.child, f.memoizedProps = n.memoizedProps, f.memoizedState = n.memoizedState, f.updateQueue = n.updateQueue;
      var m = n.dependencies;
      switch (f.dependencies = m === null ? null : {
        lanes: m.lanes,
        firstContext: m.firstContext
      }, f.sibling = n.sibling, f.index = n.index, f.ref = n.ref, f.selfBaseDuration = n.selfBaseDuration, f.treeBaseDuration = n.treeBaseDuration, f._debugNeedsRemount = n._debugNeedsRemount, f.tag) {
        case E:
        case w:
        case G:
          f.type = nb(n.type);
          break;
        case x:
          f.type = Fk(n.type);
          break;
        case F:
          f.type = Nk(n.type);
          break;
      }
      return f;
    }
    function zv(n, a) {
      n.flags &= nr | Gn;
      var f = n.alternate;
      if (f === null) n.childLanes = De, n.lanes = a, n.child = null, n.subtreeFlags = pt, n.memoizedProps = null, n.memoizedState = null, n.updateQueue = null, n.dependencies = null, n.stateNode = null, n.selfBaseDuration = 0, n.treeBaseDuration = 0;else {
        n.childLanes = f.childLanes, n.lanes = f.lanes, n.child = f.child, n.subtreeFlags = pt, n.deletions = null, n.memoizedProps = f.memoizedProps, n.memoizedState = f.memoizedState, n.updateQueue = f.updateQueue, n.type = f.type;
        var m = f.dependencies;
        n.dependencies = m === null ? null : {
          lanes: m.lanes,
          firstContext: m.firstContext
        }, n.selfBaseDuration = f.selfBaseDuration, n.treeBaseDuration = f.treeBaseDuration;
      }
      return n;
    }
    function zA(n, a, f) {
      var m;
      return n === qb ? (m = Wt, a === !0 && (m |= Xn, m |= Ri)) : m = dt, ui && (m |= nn), ts(C, null, null, m);
    }
    function $k(n, a, f, m, b, T) {
      var M = E,
        z = n;
      if (typeof n == "function") Uk(n) ? (M = x, z = Fk(z)) : z = nb(z);else if (typeof n == "string") M = D;else e: switch (n) {
        case Oo:
          return Lm(f.children, b, T, a);
        case $a:
          M = P, b |= Xn, (b & Wt) !== dt && (b |= Ri);
          break;
        case Lo:
          return qk(f, b, T, a);
        case xt:
          return VA(f, b, T, a);
        case rn:
          return BA(f, b, T, a);
        case Tn:
          return M1(f, b, T, a);
        case jn:
        // eslint-disable-next-line no-fallthrough
        case qt:
        // eslint-disable-next-line no-fallthrough
        case Lr:
        // eslint-disable-next-line no-fallthrough
        case Wa:
        // eslint-disable-next-line no-fallthrough
        case yr:
        // eslint-disable-next-line no-fallthrough
        default:
          {
            if (typeof n == "object" && n !== null) switch (n.$$typeof) {
              case Z:
                M = L;
                break e;
              case Ne:
                M = N;
                break e;
              case Ye:
                M = F, z = Nk(z);
                break e;
              case $t:
                M = K;
                break e;
              case Ct:
                M = Q, z = null;
                break e;
            }
            var U = "";
            {
              (n === void 0 || typeof n == "object" && n !== null && Object.keys(n).length === 0) && (U += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
              var X = m ? At(m) : null;
              X && (U += `

Check the render method of \`` + X + "`.");
            }
            throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (n == null ? n : typeof n) + "." + U));
          }
      }
      var J = ts(M, f, a, b);
      return J.elementType = n, J.type = z, J.lanes = T, J._debugOwner = m, J;
    }
    function Wk(n, a, f) {
      var m = null;
      m = n._owner;
      var b = n.type,
        T = n.key,
        M = n.props,
        z = $k(b, T, M, m, a, f);
      return z._debugSource = n._source, z._debugOwner = n._owner, z;
    }
    function Lm(n, a, f, m) {
      var b = ts(O, n, m, a);
      return b.lanes = f, b;
    }
    function qk(n, a, f, m) {
      typeof n.id != "string" && h('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof n.id);
      var b = ts(j, n, m, a | nn);
      return b.elementType = Lo, b.lanes = f, b.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, b;
    }
    function VA(n, a, f, m) {
      var b = ts(V, n, m, a);
      return b.elementType = xt, b.lanes = f, b;
    }
    function BA(n, a, f, m) {
      var b = ts(Y, n, m, a);
      return b.elementType = rn, b.lanes = f, b;
    }
    function M1(n, a, f, m) {
      var b = ts(oe, n, m, a);
      b.elementType = Tn, b.lanes = f;
      var T = {
        isHidden: !1
      };
      return b.stateNode = T, b;
    }
    function O1(n, a, f) {
      var m = ts(I, n, null, a);
      return m.lanes = f, m;
    }
    function UA() {
      var n = ts(D, null, null, dt);
      return n.elementType = "DELETED", n;
    }
    function NI(n) {
      var a = ts(ie, null, null, dt);
      return a.stateNode = n, a;
    }
    function Rx(n, a, f) {
      var m = n.children !== null ? n.children : [],
        b = ts(k, m, n.key, a);
      return b.lanes = f, b.stateNode = {
        containerInfo: n.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: n.implementation
      }, b;
    }
    function zI(n, a) {
      return n === null && (n = ts(E, null, null, dt)), n.tag = a.tag, n.key = a.key, n.elementType = a.elementType, n.type = a.type, n.stateNode = a.stateNode, n.return = a.return, n.child = a.child, n.sibling = a.sibling, n.index = a.index, n.ref = a.ref, n.pendingProps = a.pendingProps, n.memoizedProps = a.memoizedProps, n.updateQueue = a.updateQueue, n.memoizedState = a.memoizedState, n.dependencies = a.dependencies, n.mode = a.mode, n.flags = a.flags, n.subtreeFlags = a.subtreeFlags, n.deletions = a.deletions, n.lanes = a.lanes, n.childLanes = a.childLanes, n.alternate = a.alternate, n.actualDuration = a.actualDuration, n.actualStartTime = a.actualStartTime, n.selfBaseDuration = a.selfBaseDuration, n.treeBaseDuration = a.treeBaseDuration, n._debugSource = a._debugSource, n._debugOwner = a._debugOwner, n._debugNeedsRemount = a._debugNeedsRemount, n._debugHookTypes = a._debugHookTypes, n;
    }
    function Yk(n, a, f, m, b) {
      this.tag = a, this.containerInfo = n, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = sC, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = On, this.eventTimes = oc(De), this.expirationTimes = oc(wn), this.pendingLanes = De, this.suspendedLanes = De, this.pingedLanes = De, this.expiredLanes = De, this.mutableReadLanes = De, this.finishedLanes = De, this.entangledLanes = De, this.entanglements = oc(De), this.identifierPrefix = m, this.onRecoverableError = b, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */new Set();
        for (var T = this.pendingUpdatersLaneMap = [], M = 0; M < zl; M++) T.push(/* @__PURE__ */new Set());
      }
      switch (a) {
        case qb:
          this._debugRootType = f ? "hydrateRoot()" : "createRoot()";
          break;
        case fl:
          this._debugRootType = f ? "hydrate()" : "render()";
          break;
      }
    }
    function L1(n, a, f, m, b, T, M, z, U, X) {
      var J = new Yk(n, a, f, z, U),
        me = zA(a, T);
      J.current = me, me.stateNode = J;
      {
        var Se = {
          element: m,
          isDehydrated: f,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        me.memoizedState = Se;
      }
      return Pf(me), J;
    }
    var P1 = "18.2.0";
    function HA(n, a, f) {
      var m = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return un(m), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: oi,
        key: m == null ? null : "" + m,
        children: n,
        containerInfo: a,
        implementation: f
      };
    }
    var A1, j1;
    A1 = !1, j1 = {};
    function F0(n) {
      if (!n) return La;
      var a = Pl(n),
        f = _S(a);
      if (a.tag === x) {
        var m = a.type;
        if (Bc(m)) return pC(a, m, f);
      }
      return f;
    }
    function F1(n, a) {
      {
        var f = Pl(n);
        if (f === void 0) {
          if (typeof n.render == "function") throw new Error("Unable to find node on an unmounted component.");
          var m = Object.keys(n).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + m);
        }
        var b = Xr(f);
        if (b === null) return null;
        if (b.mode & Xn) {
          var T = At(f) || "Component";
          if (!j1[T]) {
            j1[T] = !0;
            var M = Pr;
            try {
              Rn(b), f.mode & Xn ? h("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", a, a, T) : h("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", a, a, T);
            } finally {
              M ? Rn(M) : Un();
            }
          }
        }
        return b.stateNode;
      }
    }
    function VI(n, a, f, m, b, T, M, z) {
      var U = !1,
        X = null;
      return L1(n, a, U, X, f, m, b, T, M);
    }
    function Gk(n, a, f, m, b, T, M, z, U, X) {
      var J = !0,
        me = L1(f, m, J, n, b, T, M, z, U);
      me.context = F0(null);
      var Se = me.current,
        Me = au(),
        Pe = jv(Se),
        $e = Hc(Me, Pe);
      return $e.callback = a ?? null, mp(Se, $e, Pe), Tk(me, Pe, Me), me;
    }
    function rb(n, a, f, m) {
      ki(a, n);
      var b = a.current,
        T = au(),
        M = jv(b);
      _a(M);
      var z = F0(f);
      a.context === null ? a.context = z : a.pendingContext = z, Po && Pr !== null && !A1 && (A1 = !0, h(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, At(Pr) || "Unknown"));
      var U = Hc(T, M);
      U.payload = {
        element: n
      }, m = m === void 0 ? null : m, m !== null && (typeof m != "function" && h("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", m), U.callback = m);
      var X = mp(b, U, M);
      return X !== null && (To(X, b, M, T), PS(X, b, M)), M;
    }
    function N1(n) {
      var a = n.current;
      if (!a.child) return null;
      switch (a.child.tag) {
        case D:
          return a.child.stateNode;
        default:
          return a.child.stateNode;
      }
    }
    function $A(n) {
      switch (n.tag) {
        case C:
          {
            var a = n.stateNode;
            if ($h(a)) {
              var f = Kg(a);
              SI(a, f);
            }
            break;
          }
        case V:
          {
            ou(function () {
              var b = rl(n, Je);
              if (b !== null) {
                var T = au();
                To(b, n, Je, T);
              }
            });
            var m = Je;
            z1(n, m);
            break;
          }
      }
    }
    function Xk(n, a) {
      var f = n.memoizedState;
      f !== null && f.dehydrated !== null && (f.retryLane = uf(f.retryLane, a));
    }
    function z1(n, a) {
      Xk(n, a);
      var f = n.alternate;
      f && Xk(f, a);
    }
    function WA(n) {
      if (n.tag === V) {
        var a = Hl,
          f = rl(n, a);
        if (f !== null) {
          var m = au();
          To(f, n, a, m);
        }
        z1(n, a);
      }
    }
    function BI(n) {
      if (n.tag === V) {
        var a = jv(n),
          f = rl(n, a);
        if (f !== null) {
          var m = au();
          To(f, n, a, m);
        }
        z1(n, a);
      }
    }
    function UI(n) {
      var a = In(n);
      return a === null ? null : a.stateNode;
    }
    var Kk = function (n) {
      return null;
    };
    function HI(n) {
      return Kk(n);
    }
    var Qk = function (n) {
      return !1;
    };
    function $I(n) {
      return Qk(n);
    }
    var Zk = null,
      Jk = null,
      eT = null,
      tT = null,
      nT = null,
      rT = null,
      iT = null,
      aT = null,
      oT = null;
    {
      var sT = function (n, a, f) {
          var m = a[f],
            b = wr(n) ? n.slice() : Qt({}, n);
          return f + 1 === a.length ? (wr(b) ? b.splice(m, 1) : delete b[m], b) : (b[m] = sT(n[m], a, f + 1), b);
        },
        lT = function (n, a) {
          return sT(n, a, 0);
        },
        V1 = function (n, a, f, m) {
          var b = a[m],
            T = wr(n) ? n.slice() : Qt({}, n);
          if (m + 1 === a.length) {
            var M = f[m];
            T[M] = T[b], wr(T) ? T.splice(b, 1) : delete T[b];
          } else T[b] = V1(
          // $FlowFixMe number or string is fine here
          n[b], a, f, m + 1);
          return T;
        },
        WI = function (n, a, f) {
          if (a.length !== f.length) {
            p("copyWithRename() expects paths of the same length");
            return;
          } else for (var m = 0; m < f.length - 1; m++) if (a[m] !== f[m]) {
            p("copyWithRename() expects paths to be the same except for the deepest key");
            return;
          }
          return V1(n, a, f, 0);
        },
        qI = function (n, a, f, m) {
          if (f >= a.length) return m;
          var b = a[f],
            T = wr(n) ? n.slice() : Qt({}, n);
          return T[b] = qI(n[b], a, f + 1, m), T;
        },
        YI = function (n, a, f) {
          return qI(n, a, 0, f);
        },
        uT = function (n, a) {
          for (var f = n.memoizedState; f !== null && a > 0;) f = f.next, a--;
          return f;
        };
      Zk = function (n, a, f, m) {
        var b = uT(n, a);
        if (b !== null) {
          var T = YI(b.memoizedState, f, m);
          b.memoizedState = T, b.baseState = T, n.memoizedProps = Qt({}, n.memoizedProps);
          var M = rl(n, Je);
          M !== null && To(M, n, Je, wn);
        }
      }, Jk = function (n, a, f) {
        var m = uT(n, a);
        if (m !== null) {
          var b = lT(m.memoizedState, f);
          m.memoizedState = b, m.baseState = b, n.memoizedProps = Qt({}, n.memoizedProps);
          var T = rl(n, Je);
          T !== null && To(T, n, Je, wn);
        }
      }, eT = function (n, a, f, m) {
        var b = uT(n, a);
        if (b !== null) {
          var T = WI(b.memoizedState, f, m);
          b.memoizedState = T, b.baseState = T, n.memoizedProps = Qt({}, n.memoizedProps);
          var M = rl(n, Je);
          M !== null && To(M, n, Je, wn);
        }
      }, tT = function (n, a, f) {
        n.pendingProps = YI(n.memoizedProps, a, f), n.alternate && (n.alternate.pendingProps = n.pendingProps);
        var m = rl(n, Je);
        m !== null && To(m, n, Je, wn);
      }, nT = function (n, a) {
        n.pendingProps = lT(n.memoizedProps, a), n.alternate && (n.alternate.pendingProps = n.pendingProps);
        var f = rl(n, Je);
        f !== null && To(f, n, Je, wn);
      }, rT = function (n, a, f) {
        n.pendingProps = WI(n.memoizedProps, a, f), n.alternate && (n.alternate.pendingProps = n.pendingProps);
        var m = rl(n, Je);
        m !== null && To(m, n, Je, wn);
      }, iT = function (n) {
        var a = rl(n, Je);
        a !== null && To(a, n, Je, wn);
      }, aT = function (n) {
        Kk = n;
      }, oT = function (n) {
        Qk = n;
      };
    }
    function GI(n) {
      var a = Xr(n);
      return a === null ? null : a.stateNode;
    }
    function cT(n) {
      return null;
    }
    function qA() {
      return Pr;
    }
    function B1(n) {
      var a = n.findFiberByHostInstance,
        f = i.ReactCurrentDispatcher;
      return Fl({
        bundleType: n.bundleType,
        version: n.version,
        rendererPackageName: n.rendererPackageName,
        rendererConfig: n.rendererConfig,
        overrideHookState: Zk,
        overrideHookStateDeletePath: Jk,
        overrideHookStateRenamePath: eT,
        overrideProps: tT,
        overridePropsDeletePath: nT,
        overridePropsRenamePath: rT,
        setErrorHandler: aT,
        setSuspenseHandler: oT,
        scheduleUpdate: iT,
        currentDispatcherRef: f,
        findHostInstanceByFiber: GI,
        findFiberByHostInstance: a || cT,
        // React Refresh
        findHostInstancesForRefresh: Bk,
        scheduleRefresh: zk,
        scheduleRoot: AA,
        setRefreshHandler: PI,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: qA,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: P1
      });
    }
    var XI = typeof reportError == "function" ?
    // In modern browsers, reportError will dispatch an error event,
    // emulating an uncaught JavaScript error.
    reportError : function (n) {
      console.error(n);
    };
    function dT(n) {
      this._internalRoot = n;
    }
    Vv.prototype.render = dT.prototype.render = function (n) {
      var a = this._internalRoot;
      if (a === null) throw new Error("Cannot update an unmounted root.");
      {
        typeof arguments[1] == "function" ? h("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : Dx(arguments[1]) ? h("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && h("You passed a second argument to root.render(...) but it only accepts one argument.");
        var f = a.containerInfo;
        if (f.nodeType !== er) {
          var m = UI(a.current);
          m && m.parentNode !== f && h("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      rb(n, a, null, null);
    }, Vv.prototype.unmount = dT.prototype.unmount = function () {
      typeof arguments[0] == "function" && h("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var n = this._internalRoot;
      if (n !== null) {
        this._internalRoot = null;
        var a = n.containerInfo;
        Mk() && h("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), ou(function () {
          rb(null, n, null, null);
        }), hv(a);
      }
    };
    function U1(n, a) {
      if (!Dx(n)) throw new Error("createRoot(...): Target container is not a DOM element.");
      fT(n);
      var f = !1,
        m = !1,
        b = "",
        T = XI;
      a != null && (a.hydrate ? p("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof a == "object" && a !== null && a.$$typeof === $i && h(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), a.unstable_strictMode === !0 && (f = !0), a.identifierPrefix !== void 0 && (b = a.identifierPrefix), a.onRecoverableError !== void 0 && (T = a.onRecoverableError), a.transitionCallbacks !== void 0 && a.transitionCallbacks);
      var M = VI(n, qb, null, f, m, b, T);
      pv(M.current, n);
      var z = n.nodeType === er ? n.parentNode : n;
      return Fb(z), new dT(M);
    }
    function Vv(n) {
      this._internalRoot = n;
    }
    function KI(n) {
      n && cp(n);
    }
    Vv.prototype.unstable_scheduleHydration = KI;
    function YA(n, a, f) {
      if (!Dx(n)) throw new Error("hydrateRoot(...): Target container is not a DOM element.");
      fT(n), a === void 0 && h("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var m = f ?? null,
        b = f != null && f.hydratedSources || null,
        T = !1,
        M = !1,
        z = "",
        U = XI;
      f != null && (f.unstable_strictMode === !0 && (T = !0), f.identifierPrefix !== void 0 && (z = f.identifierPrefix), f.onRecoverableError !== void 0 && (U = f.onRecoverableError));
      var X = Gk(a, null, n, qb, m, T, M, z, U);
      if (pv(X.current, n), Fb(n), b) for (var J = 0; J < b.length; J++) {
        var me = b[J];
        V_(X, me);
      }
      return new Vv(X);
    }
    function Dx(n) {
      return !!(n && (n.nodeType === Wr || n.nodeType === Ka || n.nodeType === ph));
    }
    function ib(n) {
      return !!(n && (n.nodeType === Wr || n.nodeType === Ka || n.nodeType === ph || n.nodeType === er && n.nodeValue === " react-mount-point-unstable "));
    }
    function fT(n) {
      n.nodeType === Wr && n.tagName && n.tagName.toUpperCase() === "BODY" && h("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), Nc(n) && (n._reactRootContainer ? h("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : h("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    var GA = i.ReactCurrentOwner,
      QI;
    QI = function (n) {
      if (n._reactRootContainer && n.nodeType !== er) {
        var a = UI(n._reactRootContainer.current);
        a && a.parentNode !== n && h("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var f = !!n._reactRootContainer,
        m = N0(n),
        b = !!(m && Ef(m));
      b && !f && h("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), n.nodeType === Wr && n.tagName && n.tagName.toUpperCase() === "BODY" && h("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function N0(n) {
      return n ? n.nodeType === Ka ? n.documentElement : n.firstChild : null;
    }
    function ZI() {}
    function XA(n, a, f, m, b) {
      if (b) {
        if (typeof m == "function") {
          var T = m;
          m = function () {
            var Se = N1(M);
            T.call(Se);
          };
        }
        var M = Gk(a, m, n, fl, null,
        // hydrationCallbacks
        !1,
        // isStrictMode
        !1,
        // concurrentUpdatesByDefaultOverride,
        "",
        // identifierPrefix
        ZI);
        n._reactRootContainer = M, pv(M.current, n);
        var z = n.nodeType === er ? n.parentNode : n;
        return Fb(z), ou(), M;
      } else {
        for (var U; U = n.lastChild;) n.removeChild(U);
        if (typeof m == "function") {
          var X = m;
          m = function () {
            var Se = N1(J);
            X.call(Se);
          };
        }
        var J = VI(n, fl, null,
        // hydrationCallbacks
        !1,
        // isStrictMode
        !1,
        // concurrentUpdatesByDefaultOverride,
        "",
        // identifierPrefix
        ZI);
        n._reactRootContainer = J, pv(J.current, n);
        var me = n.nodeType === er ? n.parentNode : n;
        return Fb(me), ou(function () {
          rb(a, J, f, m);
        }), J;
      }
    }
    function KA(n, a) {
      n !== null && typeof n != "function" && h("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", a, n);
    }
    function H1(n, a, f, m, b) {
      QI(f), KA(b === void 0 ? null : b, "render");
      var T = f._reactRootContainer,
        M;
      if (!T) M = XA(f, a, n, b, m);else {
        if (M = T, typeof b == "function") {
          var z = b;
          b = function () {
            var U = N1(M);
            z.call(U);
          };
        }
        rb(a, M, n, b);
      }
      return N1(M);
    }
    function QA(n) {
      {
        var a = GA.current;
        if (a !== null && a.stateNode !== null) {
          var f = a.stateNode._warnedAboutRefsInRender;
          f || h("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", bn(a.type) || "A component"), a.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return n == null ? null : n.nodeType === Wr ? n : F1(n, "findDOMNode");
    }
    function ZA(n, a, f) {
      if (h("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !ib(a)) throw new Error("Target container is not a DOM element.");
      {
        var m = Nc(a) && a._reactRootContainer === void 0;
        m && h("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
      }
      return H1(null, n, a, !0, f);
    }
    function JA(n, a, f) {
      if (h("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !ib(a)) throw new Error("Target container is not a DOM element.");
      {
        var m = Nc(a) && a._reactRootContainer === void 0;
        m && h("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return H1(null, n, a, !1, f);
    }
    function pT(n, a, f, m) {
      if (h("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !ib(f)) throw new Error("Target container is not a DOM element.");
      if (n == null || !Iw(n)) throw new Error("parentComponent must be a valid React Component");
      return H1(n, a, f, !1, m);
    }
    function e2(n) {
      if (!ib(n)) throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var a = Nc(n) && n._reactRootContainer === void 0;
        a && h("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (n._reactRootContainer) {
        {
          var f = N0(n),
            m = f && !Ef(f);
          m && h("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return ou(function () {
          H1(null, null, n, !1, function () {
            n._reactRootContainer = null, hv(n);
          });
        }), !0;
      } else {
        {
          var b = N0(n),
            T = !!(b && Ef(b)),
            M = n.nodeType === Wr && ib(n.parentNode) && !!n.parentNode._reactRootContainer;
          T && h("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", M ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    pf($A), tt(WA), Wh(BI), Cb(zr), uc(Uh), (typeof Map != "function" ||
    // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" ||
    // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && h("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), Ld(Kw), Dw(O0, Ik, ou);
    function t2(n, a) {
      var f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!Dx(a)) throw new Error("Target container is not a DOM element.");
      return HA(n, a, null, f);
    }
    function n2(n, a, f, m) {
      return pT(n, a, f, m);
    }
    var hT = {
      usingClientEntryPoint: !1,
      // Keep in sync with ReactTestUtils.js.
      // This is an array for better minification.
      Events: [Ef, mv, vS, Il, Pd, O0]
    };
    function JI(n, a) {
      return hT.usingClientEntryPoint || h('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), U1(n, a);
    }
    function s(n, a, f) {
      return hT.usingClientEntryPoint || h('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), YA(n, a, f);
    }
    function u(n) {
      return Mk() && h("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), ou(n);
    }
    var v = B1({
      findFiberByHostInstance: zc,
      bundleType: 1,
      version: P1,
      rendererPackageName: "react-dom"
    });
    if (!v && Xe && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var _ = window.location.protocol;
      /^(https?|file):$/.test(_) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (_ === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    td.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = hT, td.createPortal = t2, td.createRoot = JI, td.findDOMNode = QA, td.flushSync = u, td.hydrate = ZA, td.hydrateRoot = s, td.render = JA, td.unmountComponentAtNode = e2, td.unstable_batchedUpdates = O0, td.unstable_renderSubtreeIntoContainer = n2, td.version = P1, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), td;
}
var wU;
function F8() {
  if (wU) return RM.exports;
  wU = 1;
  function t() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
      if (process.env.NODE_ENV !== "production") throw new Error("^_^");
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(t);
      } catch (e) {
        console.error(e);
      }
    }
  }
  return process.env.NODE_ENV === "production" ? (t(), RM.exports = wge()) : RM.exports = _ge(), RM.exports;
}
var IM = {
    exports: {}
  },
  Mp = {},
  MM = {
    exports: {}
  },
  _U;
function N8() {
  return _U || (_U = 1, function (t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = E;
    /*!
     * Adapted from jQuery UI core
     *
     * http://jqueryui.com
     *
     * Copyright 2014 jQuery Foundation and other contributors
     * Released under the MIT license.
     * http://jquery.org/license
     *
     * http://api.jqueryui.com/category/ui-core/
     */
    var i = "none",
      l = "contents",
      c = /^(input|select|textarea|button|object|iframe)$/;
    function p(C, k) {
      return k.getPropertyValue("overflow") !== "visible" ||
      // if 'overflow: visible' set, check if there is actually any overflow
      C.scrollWidth <= 0 && C.scrollHeight <= 0;
    }
    function h(C) {
      var k = C.offsetWidth <= 0 && C.offsetHeight <= 0;
      if (k && !C.innerHTML) return !0;
      try {
        var D = window.getComputedStyle(C),
          I = D.getPropertyValue("display");
        return k ? I !== l && p(C, D) : I === i;
      } catch {
        return console.warn("Failed to inspect element style"), !1;
      }
    }
    function y(C) {
      for (var k = C, D = C.getRootNode && C.getRootNode(); k && k !== document.body;) {
        if (D && k === D && (k = D.host.parentNode), h(k)) return !1;
        k = k.parentNode;
      }
      return !0;
    }
    function w(C, k) {
      var D = C.nodeName.toLowerCase(),
        I = c.test(D) && !C.disabled || D === "a" && C.href || k;
      return I && y(C);
    }
    function x(C) {
      var k = C.getAttribute("tabindex");
      k === null && (k = void 0);
      var D = isNaN(k);
      return (D || k >= 0) && w(C, !D);
    }
    function E(C) {
      var k = [].slice.call(C.querySelectorAll("*"), 0).reduce(function (D, I) {
        return D.concat(I.shadowRoot ? E(I.shadowRoot) : [I]);
      }, []);
      return k.filter(x);
    }
    t.exports = e.default;
  }(MM, MM.exports)), MM.exports;
}
var xU;
function xge() {
  if (xU) return Mp;
  xU = 1, Object.defineProperty(Mp, "__esModule", {
    value: !0
  }), Mp.resetState = h, Mp.log = y, Mp.handleBlur = w, Mp.handleFocus = x, Mp.markForFocusLater = E, Mp.returnFocus = C, Mp.popWithoutFocus = k, Mp.setupScopedFocus = D, Mp.teardownScopedFocus = I;
  var t = N8(),
    e = i(t);
  function i(O) {
    return O && O.__esModule ? O : {
      default: O
    };
  }
  var l = [],
    c = null,
    p = !1;
  function h() {
    l = [];
  }
  function y() {
    process.env.NODE_ENV !== "production" && (console.log("focusManager ----------"), l.forEach(function (O) {
      var P = O || {};
      console.log(P.nodeName, P.className, P.id);
    }), console.log("end focusManager ----------"));
  }
  function w() {
    p = !0;
  }
  function x() {
    if (p) {
      if (p = !1, !c) return;
      setTimeout(function () {
        if (!c.contains(document.activeElement)) {
          var O = (0, e.default)(c)[0] || c;
          O.focus();
        }
      }, 0);
    }
  }
  function E() {
    l.push(document.activeElement);
  }
  function C() {
    var O = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1,
      P = null;
    try {
      l.length !== 0 && (P = l.pop(), P.focus({
        preventScroll: O
      }));
      return;
    } catch {
      console.warn(["You tried to return focus to", P, "but it is not in the DOM anymore"].join(" "));
    }
  }
  function k() {
    l.length > 0 && l.pop();
  }
  function D(O) {
    c = O, window.addEventListener ? (window.addEventListener("blur", w, !1), document.addEventListener("focus", x, !0)) : (window.attachEvent("onBlur", w), document.attachEvent("onFocus", x));
  }
  function I() {
    c = null, window.addEventListener ? (window.removeEventListener("blur", w), document.removeEventListener("focus", x)) : (window.detachEvent("onBlur", w), document.detachEvent("onFocus", x));
  }
  return Mp;
}
var OM = {
    exports: {}
  },
  SU;
function Sge() {
  return SU || (SU = 1, function (t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = h;
    var i = N8(),
      l = c(i);
    function c(y) {
      return y && y.__esModule ? y : {
        default: y
      };
    }
    function p() {
      var y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
      return y.activeElement.shadowRoot ? p(y.activeElement.shadowRoot) : y.activeElement;
    }
    function h(y, w) {
      var x = (0, l.default)(y);
      if (!x.length) {
        w.preventDefault();
        return;
      }
      var E = void 0,
        C = w.shiftKey,
        k = x[0],
        D = x[x.length - 1],
        I = p();
      if (y === I) {
        if (!C) return;
        E = D;
      }
      if (D === I && !C && (E = k), k === I && C && (E = D), E) {
        w.preventDefault(), E.focus();
        return;
      }
      var O = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent),
        P = O != null && O[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
      if (P) {
        var N = x.indexOf(I);
        if (N > -1 && (N += C ? -1 : 1), E = x[N], typeof E > "u") {
          w.preventDefault(), E = C ? D : k, E.focus();
          return;
        }
        w.preventDefault(), E.focus();
      }
    }
    t.exports = e.default;
  }(OM, OM.exports)), OM.exports;
}
var zm = {},
  dj,
  EU;
function Ege() {
  if (EU) return dj;
  EU = 1;
  var t = process.env.NODE_ENV !== "production",
    e = function () {};
  if (t) {
    var i = function (c, p) {
      var h = arguments.length;
      p = new Array(h > 1 ? h - 1 : 0);
      for (var y = 1; y < h; y++) p[y - 1] = arguments[y];
      var w = 0,
        x = "Warning: " + c.replace(/%s/g, function () {
          return p[w++];
        });
      typeof console < "u" && console.error(x);
      try {
        throw new Error(x);
      } catch {}
    };
    e = function (l, c, p) {
      var h = arguments.length;
      p = new Array(h > 2 ? h - 2 : 0);
      for (var y = 2; y < h; y++) p[y - 2] = arguments[y];
      if (c === void 0) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
      l || i.apply(null, [c].concat(p));
    };
  }
  return dj = e, dj;
}
var Hv = {},
  fj = {
    exports: {}
  };
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
var CU;
function Cge() {
  return CU || (CU = 1, function (t) {
    (function () {
      var e = !!(typeof window < "u" && window.document && window.document.createElement),
        i = {
          canUseDOM: e,
          canUseWorkers: typeof Worker < "u",
          canUseEventListeners: e && !!(window.addEventListener || window.attachEvent),
          canUseViewport: e && !!window.screen
        };
      t.exports ? t.exports = i : window.ExecutionEnvironment = i;
    })();
  }(fj)), fj.exports;
}
var kU;
function Rz() {
  if (kU) return Hv;
  kU = 1, Object.defineProperty(Hv, "__esModule", {
    value: !0
  }), Hv.canUseDOM = Hv.SafeNodeList = Hv.SafeHTMLCollection = void 0;
  var t = Cge(),
    e = i(t);
  function i(p) {
    return p && p.__esModule ? p : {
      default: p
    };
  }
  var l = e.default,
    c = l.canUseDOM ? window.HTMLElement : {};
  return Hv.SafeHTMLCollection = l.canUseDOM ? window.HTMLCollection : {}, Hv.SafeNodeList = l.canUseDOM ? window.NodeList : {}, Hv.canUseDOM = l.canUseDOM, Hv.default = c, Hv;
}
var TU;
function z8() {
  if (TU) return zm;
  TU = 1, Object.defineProperty(zm, "__esModule", {
    value: !0
  }), zm.resetState = p, zm.log = h, zm.assertNodeList = y, zm.setElement = w, zm.validateElement = x, zm.hide = E, zm.show = C, zm.documentNotReadyOrSSRTesting = k;
  var t = Ege(),
    e = l(t),
    i = Rz();
  function l(D) {
    return D && D.__esModule ? D : {
      default: D
    };
  }
  var c = null;
  function p() {
    c && (c.removeAttribute ? c.removeAttribute("aria-hidden") : c.length != null ? c.forEach(function (D) {
      return D.removeAttribute("aria-hidden");
    }) : document.querySelectorAll(c).forEach(function (D) {
      return D.removeAttribute("aria-hidden");
    })), c = null;
  }
  function h() {
    if (process.env.NODE_ENV !== "production") {
      var D = c || {};
      console.log("ariaAppHider ----------"), console.log(D.nodeName, D.className, D.id), console.log("end ariaAppHider ----------");
    }
  }
  function y(D, I) {
    if (!D || !D.length) throw new Error("react-modal: No elements were found for selector " + I + ".");
  }
  function w(D) {
    var I = D;
    if (typeof I == "string" && i.canUseDOM) {
      var O = document.querySelectorAll(I);
      y(O, I), I = O;
    }
    return c = I || c, c;
  }
  function x(D) {
    var I = D || c;
    return I ? Array.isArray(I) || I instanceof HTMLCollection || I instanceof NodeList ? I : [I] : ((0, e.default)(!1, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" ")), []);
  }
  function E(D) {
    var I = !0,
      O = !1,
      P = void 0;
    try {
      for (var N = x(D)[Symbol.iterator](), L; !(I = (L = N.next()).done); I = !0) {
        var F = L.value;
        F.setAttribute("aria-hidden", "true");
      }
    } catch (j) {
      O = !0, P = j;
    } finally {
      try {
        !I && N.return && N.return();
      } finally {
        if (O) throw P;
      }
    }
  }
  function C(D) {
    var I = !0,
      O = !1,
      P = void 0;
    try {
      for (var N = x(D)[Symbol.iterator](), L; !(I = (L = N.next()).done); I = !0) {
        var F = L.value;
        F.removeAttribute("aria-hidden");
      }
    } catch (j) {
      O = !0, P = j;
    } finally {
      try {
        !I && N.return && N.return();
      } finally {
        if (O) throw P;
      }
    }
  }
  function k() {
    c = null;
  }
  return zm;
}
var jx = {},
  RU;
function kge() {
  if (RU) return jx;
  RU = 1, Object.defineProperty(jx, "__esModule", {
    value: !0
  }), jx.resetState = l, jx.log = c;
  var t = {},
    e = {};
  function i(x, E) {
    x.classList.remove(E);
  }
  function l() {
    var x = document.getElementsByTagName("html")[0];
    for (var E in t) i(x, t[E]);
    var C = document.body;
    for (var k in e) i(C, e[k]);
    t = {}, e = {};
  }
  function c() {
    if (process.env.NODE_ENV !== "production") {
      var x = document.getElementsByTagName("html")[0].className,
        E = `Show tracked classes:

`;
      E += "<html /> (" + x + `):
  `;
      for (var C in t) E += "  " + C + " " + t[C] + `
  `;
      x = document.body.className, E += `

doc.body (` + x + `):
  `;
      for (var k in e) E += "  " + k + " " + e[k] + `
  `;
      E += `
`, console.log(E);
    }
  }
  var p = function (E, C) {
      return E[C] || (E[C] = 0), E[C] += 1, C;
    },
    h = function (E, C) {
      return E[C] && (E[C] -= 1), C;
    },
    y = function (E, C, k) {
      k.forEach(function (D) {
        p(C, D), E.add(D);
      });
    },
    w = function (E, C, k) {
      k.forEach(function (D) {
        h(C, D), C[D] === 0 && E.remove(D);
      });
    };
  return jx.add = function (E, C) {
    return y(E.classList, E.nodeName.toLowerCase() == "html" ? t : e, C.split(" "));
  }, jx.remove = function (E, C) {
    return w(E.classList, E.nodeName.toLowerCase() == "html" ? t : e, C.split(" "));
  }, jx;
}
var tE = {},
  DU;
function V8() {
  if (DU) return tE;
  DU = 1, Object.defineProperty(tE, "__esModule", {
    value: !0
  }), tE.log = l, tE.resetState = c;
  function t(p, h) {
    if (!(p instanceof h)) throw new TypeError("Cannot call a class as a function");
  }
  var e = function p() {
      var h = this;
      t(this, p), this.register = function (y) {
        if (h.openInstances.indexOf(y) !== -1) {
          process.env.NODE_ENV !== "production" && console.warn("React-Modal: Cannot register modal instance that's already open");
          return;
        }
        h.openInstances.push(y), h.emit("register");
      }, this.deregister = function (y) {
        var w = h.openInstances.indexOf(y);
        if (w === -1) {
          process.env.NODE_ENV !== "production" && console.warn("React-Modal: Unable to deregister " + y + " as it was never registered");
          return;
        }
        h.openInstances.splice(w, 1), h.emit("deregister");
      }, this.subscribe = function (y) {
        h.subscribers.push(y);
      }, this.emit = function (y) {
        h.subscribers.forEach(function (w) {
          return w(y,
          // shallow copy to avoid accidental mutation
          h.openInstances.slice());
        });
      }, this.openInstances = [], this.subscribers = [];
    },
    i = new e();
  function l() {
    console.log("portalOpenInstances ----------"), console.log(i.openInstances.length), i.openInstances.forEach(function (p) {
      return console.log(p);
    }), console.log("end portalOpenInstances ----------");
  }
  function c() {
    i = new e();
  }
  return tE.default = i, tE;
}
var TT = {},
  IU;
function Tge() {
  if (IU) return TT;
  IU = 1, Object.defineProperty(TT, "__esModule", {
    value: !0
  }), TT.resetState = h, TT.log = y;
  var t = V8(),
    e = i(t);
  function i(E) {
    return E && E.__esModule ? E : {
      default: E
    };
  }
  var l = void 0,
    c = void 0,
    p = [];
  function h() {
    for (var E = [l, c], C = 0; C < E.length; C++) {
      var k = E[C];
      k && k.parentNode && k.parentNode.removeChild(k);
    }
    l = c = null, p = [];
  }
  function y() {
    console.log("bodyTrap ----------"), console.log(p.length);
    for (var E = [l, c], C = 0; C < E.length; C++) {
      var k = E[C],
        D = k || {};
      console.log(D.nodeName, D.className, D.id);
    }
    console.log("edn bodyTrap ----------");
  }
  function w() {
    if (p.length === 0) {
      process.env.NODE_ENV !== "production" && console.warn("React-Modal: Open instances > 0 expected");
      return;
    }
    p[p.length - 1].focusContent();
  }
  function x(E, C) {
    !l && !c && (l = document.createElement("div"), l.setAttribute("data-react-modal-body-trap", ""), l.style.position = "absolute", l.style.opacity = "0", l.setAttribute("tabindex", "0"), l.addEventListener("focus", w), c = l.cloneNode(), c.addEventListener("focus", w)), p = C, p.length > 0 ? (document.body.firstChild !== l && document.body.insertBefore(l, document.body.firstChild), document.body.lastChild !== c && document.body.appendChild(c)) : (l.parentElement && l.parentElement.removeChild(l), c.parentElement && c.parentElement.removeChild(c));
  }
  return e.default.subscribe(x), TT;
}
var MU;
function Rge() {
  return MU || (MU = 1, function (t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var i = Object.assign || function (ne) {
        for (var se = 1; se < arguments.length; se++) {
          var ue = arguments[se];
          for (var W in ue) Object.prototype.hasOwnProperty.call(ue, W) && (ne[W] = ue[W]);
        }
        return ne;
      },
      l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (ne) {
        return typeof ne;
      } : function (ne) {
        return ne && typeof Symbol == "function" && ne.constructor === Symbol && ne !== Symbol.prototype ? "symbol" : typeof ne;
      },
      c = /* @__PURE__ */function () {
        function ne(se, ue) {
          for (var W = 0; W < ue.length; W++) {
            var $ = ue[W];
            $.enumerable = $.enumerable || !1, $.configurable = !0, "value" in $ && ($.writable = !0), Object.defineProperty(se, $.key, $);
          }
        }
        return function (se, ue, W) {
          return ue && ne(se.prototype, ue), W && ne(se, W), se;
        };
      }(),
      p = Nt,
      h = /* @__PURE__ */AN(),
      y = V(h),
      w = xge(),
      x = j(w),
      E = Sge(),
      C = V(E),
      k = z8(),
      D = j(k),
      I = kge(),
      O = j(I),
      P = Rz(),
      N = V(P),
      L = V8(),
      F = V(L);
    Tge();
    function j(ne) {
      if (ne && ne.__esModule) return ne;
      var se = {};
      if (ne != null) for (var ue in ne) Object.prototype.hasOwnProperty.call(ne, ue) && (se[ue] = ne[ue]);
      return se.default = ne, se;
    }
    function V(ne) {
      return ne && ne.__esModule ? ne : {
        default: ne
      };
    }
    function K(ne, se) {
      if (!(ne instanceof se)) throw new TypeError("Cannot call a class as a function");
    }
    function G(ne, se) {
      if (!ne) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return se && (typeof se == "object" || typeof se == "function") ? se : ne;
    }
    function Q(ne, se) {
      if (typeof se != "function" && se !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof se);
      ne.prototype = Object.create(se && se.prototype, {
        constructor: {
          value: ne,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), se && (Object.setPrototypeOf ? Object.setPrototypeOf(ne, se) : ne.__proto__ = se);
    }
    var te = {
        overlay: "ReactModal__Overlay",
        content: "ReactModal__Content"
      },
      ie = function (se) {
        return se.code === "Tab" || se.keyCode === 9;
      },
      Y = function (se) {
        return se.code === "Escape" || se.keyCode === 27;
      },
      ee = 0,
      oe = function (ne) {
        Q(se, ne);
        function se(ue) {
          K(this, se);
          var W = G(this, (se.__proto__ || Object.getPrototypeOf(se)).call(this, ue));
          return W.setOverlayRef = function ($) {
            W.overlay = $, W.props.overlayRef && W.props.overlayRef($);
          }, W.setContentRef = function ($) {
            W.content = $, W.props.contentRef && W.props.contentRef($);
          }, W.afterClose = function () {
            var $ = W.props,
              le = $.appElement,
              H = $.ariaHideApp,
              ce = $.htmlOpenClassName,
              de = $.bodyOpenClassName,
              Ce = $.parentSelector,
              Ee = Ce && Ce().ownerDocument || document;
            de && O.remove(Ee.body, de), ce && O.remove(Ee.getElementsByTagName("html")[0], ce), H && ee > 0 && (ee -= 1, ee === 0 && D.show(le)), W.props.shouldFocusAfterRender && (W.props.shouldReturnFocusAfterClose ? (x.returnFocus(W.props.preventScroll), x.teardownScopedFocus()) : x.popWithoutFocus()), W.props.onAfterClose && W.props.onAfterClose(), F.default.deregister(W);
          }, W.open = function () {
            W.beforeOpen(), W.state.afterOpen && W.state.beforeClose ? (clearTimeout(W.closeTimer), W.setState({
              beforeClose: !1
            })) : (W.props.shouldFocusAfterRender && (x.setupScopedFocus(W.node), x.markForFocusLater()), W.setState({
              isOpen: !0
            }, function () {
              W.openAnimationFrame = requestAnimationFrame(function () {
                W.setState({
                  afterOpen: !0
                }), W.props.isOpen && W.props.onAfterOpen && W.props.onAfterOpen({
                  overlayEl: W.overlay,
                  contentEl: W.content
                });
              });
            }));
          }, W.close = function () {
            W.props.closeTimeoutMS > 0 ? W.closeWithTimeout() : W.closeWithoutTimeout();
          }, W.focusContent = function () {
            return W.content && !W.contentHasFocus() && W.content.focus({
              preventScroll: !0
            });
          }, W.closeWithTimeout = function () {
            var $ = Date.now() + W.props.closeTimeoutMS;
            W.setState({
              beforeClose: !0,
              closesAt: $
            }, function () {
              W.closeTimer = setTimeout(W.closeWithoutTimeout, W.state.closesAt - Date.now());
            });
          }, W.closeWithoutTimeout = function () {
            W.setState({
              beforeClose: !1,
              isOpen: !1,
              afterOpen: !1,
              closesAt: null
            }, W.afterClose);
          }, W.handleKeyDown = function ($) {
            ie($) && (0, C.default)(W.content, $), W.props.shouldCloseOnEsc && Y($) && ($.stopPropagation(), W.requestClose($));
          }, W.handleOverlayOnClick = function ($) {
            W.shouldClose === null && (W.shouldClose = !0), W.shouldClose && W.props.shouldCloseOnOverlayClick && (W.ownerHandlesClose() ? W.requestClose($) : W.focusContent()), W.shouldClose = null;
          }, W.handleContentOnMouseUp = function () {
            W.shouldClose = !1;
          }, W.handleOverlayOnMouseDown = function ($) {
            !W.props.shouldCloseOnOverlayClick && $.target == W.overlay && $.preventDefault();
          }, W.handleContentOnClick = function () {
            W.shouldClose = !1;
          }, W.handleContentOnMouseDown = function () {
            W.shouldClose = !1;
          }, W.requestClose = function ($) {
            return W.ownerHandlesClose() && W.props.onRequestClose($);
          }, W.ownerHandlesClose = function () {
            return W.props.onRequestClose;
          }, W.shouldBeClosed = function () {
            return !W.state.isOpen && !W.state.beforeClose;
          }, W.contentHasFocus = function () {
            return document.activeElement === W.content || W.content.contains(document.activeElement);
          }, W.buildClassName = function ($, le) {
            var H = (typeof le > "u" ? "undefined" : l(le)) === "object" ? le : {
                base: te[$],
                afterOpen: te[$] + "--after-open",
                beforeClose: te[$] + "--before-close"
              },
              ce = H.base;
            return W.state.afterOpen && (ce = ce + " " + H.afterOpen), W.state.beforeClose && (ce = ce + " " + H.beforeClose), typeof le == "string" && le ? ce + " " + le : ce;
          }, W.attributesFromObject = function ($, le) {
            return Object.keys(le).reduce(function (H, ce) {
              return H[$ + "-" + ce] = le[ce], H;
            }, {});
          }, W.state = {
            afterOpen: !1,
            beforeClose: !1
          }, W.shouldClose = null, W.moveFromContentToOverlay = null, W;
        }
        return c(se, [{
          key: "componentDidMount",
          value: function () {
            this.props.isOpen && this.open();
          }
        }, {
          key: "componentDidUpdate",
          value: function (W, $) {
            process.env.NODE_ENV !== "production" && (W.bodyOpenClassName !== this.props.bodyOpenClassName && console.warn('React-Modal: "bodyOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.'), W.htmlOpenClassName !== this.props.htmlOpenClassName && console.warn('React-Modal: "htmlOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.')), this.props.isOpen && !W.isOpen ? this.open() : !this.props.isOpen && W.isOpen && this.close(), this.props.shouldFocusAfterRender && this.state.isOpen && !$.isOpen && this.focusContent();
          }
        }, {
          key: "componentWillUnmount",
          value: function () {
            this.state.isOpen && this.afterClose(), clearTimeout(this.closeTimer), cancelAnimationFrame(this.openAnimationFrame);
          }
        }, {
          key: "beforeOpen",
          value: function () {
            var W = this.props,
              $ = W.appElement,
              le = W.ariaHideApp,
              H = W.htmlOpenClassName,
              ce = W.bodyOpenClassName,
              de = W.parentSelector,
              Ce = de && de().ownerDocument || document;
            ce && O.add(Ce.body, ce), H && O.add(Ce.getElementsByTagName("html")[0], H), le && (ee += 1, D.hide($)), F.default.register(this);
          }
          // Don't steal focus from inner elements
        }, {
          key: "render",
          value: function () {
            var W = this.props,
              $ = W.id,
              le = W.className,
              H = W.overlayClassName,
              ce = W.defaultStyles,
              de = W.children,
              Ce = le ? {} : ce.content,
              Ee = H ? {} : ce.overlay;
            if (this.shouldBeClosed()) return null;
            var fe = {
                ref: this.setOverlayRef,
                className: this.buildClassName("overlay", H),
                style: i({}, Ee, this.props.style.overlay),
                onClick: this.handleOverlayOnClick,
                onMouseDown: this.handleOverlayOnMouseDown
              },
              xe = i({
                id: $,
                ref: this.setContentRef,
                style: i({}, Ce, this.props.style.content),
                className: this.buildClassName("content", le),
                tabIndex: "-1",
                onKeyDown: this.handleKeyDown,
                onMouseDown: this.handleContentOnMouseDown,
                onMouseUp: this.handleContentOnMouseUp,
                onClick: this.handleContentOnClick,
                role: this.props.role,
                "aria-label": this.props.contentLabel
              }, this.attributesFromObject("aria", i({
                modal: !0
              }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
                "data-testid": this.props.testId
              }),
              we = this.props.contentElement(xe, de);
            return this.props.overlayElement(fe, we);
          }
        }]), se;
      }(p.Component);
    oe.defaultProps = {
      style: {
        overlay: {},
        content: {}
      },
      defaultStyles: {}
    }, oe.propTypes = {
      isOpen: y.default.bool.isRequired,
      defaultStyles: y.default.shape({
        content: y.default.object,
        overlay: y.default.object
      }),
      style: y.default.shape({
        content: y.default.object,
        overlay: y.default.object
      }),
      className: y.default.oneOfType([y.default.string, y.default.object]),
      overlayClassName: y.default.oneOfType([y.default.string, y.default.object]),
      parentSelector: y.default.func,
      bodyOpenClassName: y.default.string,
      htmlOpenClassName: y.default.string,
      ariaHideApp: y.default.bool,
      appElement: y.default.oneOfType([y.default.instanceOf(N.default), y.default.instanceOf(P.SafeHTMLCollection), y.default.instanceOf(P.SafeNodeList), y.default.arrayOf(y.default.instanceOf(N.default))]),
      onAfterOpen: y.default.func,
      onAfterClose: y.default.func,
      onRequestClose: y.default.func,
      closeTimeoutMS: y.default.number,
      shouldFocusAfterRender: y.default.bool,
      shouldCloseOnOverlayClick: y.default.bool,
      shouldReturnFocusAfterClose: y.default.bool,
      preventScroll: y.default.bool,
      role: y.default.string,
      contentLabel: y.default.string,
      aria: y.default.object,
      data: y.default.object,
      children: y.default.node,
      shouldCloseOnEsc: y.default.bool,
      overlayRef: y.default.func,
      contentRef: y.default.func,
      id: y.default.string,
      overlayElement: y.default.func,
      contentElement: y.default.func,
      testId: y.default.string
    }, e.default = oe, t.exports = e.default;
  }(IM, IM.exports)), IM.exports;
}
function B8() {
  var t = this.constructor.getDerivedStateFromProps(this.props, this.state);
  t != null && this.setState(t);
}
function U8(t) {
  function e(i) {
    var l = this.constructor.getDerivedStateFromProps(t, i);
    return l ?? null;
  }
  this.setState(e.bind(this));
}
function H8(t, e) {
  try {
    var i = this.props,
      l = this.state;
    this.props = t, this.state = e, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(i, l);
  } finally {
    this.props = i, this.state = l;
  }
}
B8.__suppressDeprecationWarning = !0;
U8.__suppressDeprecationWarning = !0;
H8.__suppressDeprecationWarning = !0;
function Dge(t) {
  var e = t.prototype;
  if (!e || !e.isReactComponent) throw new Error("Can only polyfill class components");
  if (typeof t.getDerivedStateFromProps != "function" && typeof e.getSnapshotBeforeUpdate != "function") return t;
  var i = null,
    l = null,
    c = null;
  if (typeof e.componentWillMount == "function" ? i = "componentWillMount" : typeof e.UNSAFE_componentWillMount == "function" && (i = "UNSAFE_componentWillMount"), typeof e.componentWillReceiveProps == "function" ? l = "componentWillReceiveProps" : typeof e.UNSAFE_componentWillReceiveProps == "function" && (l = "UNSAFE_componentWillReceiveProps"), typeof e.componentWillUpdate == "function" ? c = "componentWillUpdate" : typeof e.UNSAFE_componentWillUpdate == "function" && (c = "UNSAFE_componentWillUpdate"), i !== null || l !== null || c !== null) {
    var p = t.displayName || t.name,
      h = typeof t.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error(`Unsafe legacy lifecycles will not be called for components using new component APIs.

` + p + " uses " + h + " but also contains the following legacy lifecycles:" + (i !== null ? `
  ` + i : "") + (l !== null ? `
  ` + l : "") + (c !== null ? `
  ` + c : "") + `

The above lifecycles should be removed. Learn more about this warning here:
https://fb.me/react-async-component-lifecycle-hooks`);
  }
  if (typeof t.getDerivedStateFromProps == "function" && (e.componentWillMount = B8, e.componentWillReceiveProps = U8), typeof e.getSnapshotBeforeUpdate == "function") {
    if (typeof e.componentDidUpdate != "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
    e.componentWillUpdate = H8;
    var y = e.componentDidUpdate;
    e.componentDidUpdate = function (x, E, C) {
      var k = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : C;
      y.call(this, x, E, k);
    };
  }
  return t;
}
const Ige = /* @__PURE__ */Object.freeze(/* @__PURE__ */Object.defineProperty({
    __proto__: null,
    polyfill: Dge
  }, Symbol.toStringTag, {
    value: "Module"
  })),
  Mge = /* @__PURE__ */cQ(Ige);
var OU;
function Oge() {
  if (OU) return q0;
  OU = 1, Object.defineProperty(q0, "__esModule", {
    value: !0
  }), q0.bodyOpenClassName = q0.portalClassName = void 0;
  var t = Object.assign || function (Y) {
      for (var ee = 1; ee < arguments.length; ee++) {
        var oe = arguments[ee];
        for (var ne in oe) Object.prototype.hasOwnProperty.call(oe, ne) && (Y[ne] = oe[ne]);
      }
      return Y;
    },
    e = /* @__PURE__ */function () {
      function Y(ee, oe) {
        for (var ne = 0; ne < oe.length; ne++) {
          var se = oe[ne];
          se.enumerable = se.enumerable || !1, se.configurable = !0, "value" in se && (se.writable = !0), Object.defineProperty(ee, se.key, se);
        }
      }
      return function (ee, oe, ne) {
        return oe && Y(ee.prototype, oe), ne && Y(ee, ne), ee;
      };
    }(),
    i = Nt,
    l = P(i),
    c = F8(),
    p = P(c),
    h = /* @__PURE__ */AN(),
    y = P(h),
    w = Rge(),
    x = P(w),
    E = z8(),
    C = O(E),
    k = Rz(),
    D = P(k),
    I = Mge;
  function O(Y) {
    if (Y && Y.__esModule) return Y;
    var ee = {};
    if (Y != null) for (var oe in Y) Object.prototype.hasOwnProperty.call(Y, oe) && (ee[oe] = Y[oe]);
    return ee.default = Y, ee;
  }
  function P(Y) {
    return Y && Y.__esModule ? Y : {
      default: Y
    };
  }
  function N(Y, ee) {
    if (!(Y instanceof ee)) throw new TypeError("Cannot call a class as a function");
  }
  function L(Y, ee) {
    if (!Y) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return ee && (typeof ee == "object" || typeof ee == "function") ? ee : Y;
  }
  function F(Y, ee) {
    if (typeof ee != "function" && ee !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof ee);
    Y.prototype = Object.create(ee && ee.prototype, {
      constructor: {
        value: Y,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), ee && (Object.setPrototypeOf ? Object.setPrototypeOf(Y, ee) : Y.__proto__ = ee);
  }
  var j = q0.portalClassName = "ReactModalPortal",
    V = q0.bodyOpenClassName = "ReactModal__Body--open",
    K = k.canUseDOM && p.default.createPortal !== void 0,
    G = function (ee) {
      return document.createElement(ee);
    },
    Q = function () {
      return K ? p.default.createPortal : p.default.unstable_renderSubtreeIntoContainer;
    };
  function te(Y) {
    return Y();
  }
  var ie = function (Y) {
    F(ee, Y);
    function ee() {
      var oe, ne, se, ue;
      N(this, ee);
      for (var W = arguments.length, $ = Array(W), le = 0; le < W; le++) $[le] = arguments[le];
      return ue = (ne = (se = L(this, (oe = ee.__proto__ || Object.getPrototypeOf(ee)).call.apply(oe, [this].concat($))), se), se.removePortal = function () {
        !K && p.default.unmountComponentAtNode(se.node);
        var H = te(se.props.parentSelector);
        H && H.contains(se.node) ? H.removeChild(se.node) : console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
      }, se.portalRef = function (H) {
        se.portal = H;
      }, se.renderPortal = function (H) {
        var ce = Q(),
          de = ce(se, l.default.createElement(x.default, t({
            defaultStyles: ee.defaultStyles
          }, H)), se.node);
        se.portalRef(de);
      }, ne), L(se, ue);
    }
    return e(ee, [{
      key: "componentDidMount",
      value: function () {
        if (k.canUseDOM) {
          K || (this.node = G("div")), this.node.className = this.props.portalClassName;
          var ne = te(this.props.parentSelector);
          ne.appendChild(this.node), !K && this.renderPortal(this.props);
        }
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function (ne) {
        var se = te(ne.parentSelector),
          ue = te(this.props.parentSelector);
        return {
          prevParent: se,
          nextParent: ue
        };
      }
    }, {
      key: "componentDidUpdate",
      value: function (ne, se, ue) {
        if (k.canUseDOM) {
          var W = this.props,
            $ = W.isOpen,
            le = W.portalClassName;
          ne.portalClassName !== le && (this.node.className = le);
          var H = ue.prevParent,
            ce = ue.nextParent;
          ce !== H && (H.removeChild(this.node), ce.appendChild(this.node)), !(!ne.isOpen && !$) && !K && this.renderPortal(this.props);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function () {
        if (!(!k.canUseDOM || !this.node || !this.portal)) {
          var ne = this.portal.state,
            se = Date.now(),
            ue = ne.isOpen && this.props.closeTimeoutMS && (ne.closesAt || se + this.props.closeTimeoutMS);
          ue ? (ne.beforeClose || this.portal.closeWithTimeout(), setTimeout(this.removePortal, ue - se)) : this.removePortal();
        }
      }
    }, {
      key: "render",
      value: function () {
        if (!k.canUseDOM || !K) return null;
        !this.node && K && (this.node = G("div"));
        var ne = Q();
        return ne(l.default.createElement(x.default, t({
          ref: this.portalRef,
          defaultStyles: ee.defaultStyles
        }, this.props)), this.node);
      }
    }], [{
      key: "setAppElement",
      value: function (ne) {
        C.setElement(ne);
      }
      /* eslint-disable react/no-unused-prop-types */
      /* eslint-enable react/no-unused-prop-types */
    }]), ee;
  }(i.Component);
  return ie.propTypes = {
    isOpen: y.default.bool.isRequired,
    style: y.default.shape({
      content: y.default.object,
      overlay: y.default.object
    }),
    portalClassName: y.default.string,
    bodyOpenClassName: y.default.string,
    htmlOpenClassName: y.default.string,
    className: y.default.oneOfType([y.default.string, y.default.shape({
      base: y.default.string.isRequired,
      afterOpen: y.default.string.isRequired,
      beforeClose: y.default.string.isRequired
    })]),
    overlayClassName: y.default.oneOfType([y.default.string, y.default.shape({
      base: y.default.string.isRequired,
      afterOpen: y.default.string.isRequired,
      beforeClose: y.default.string.isRequired
    })]),
    appElement: y.default.oneOfType([y.default.instanceOf(D.default), y.default.instanceOf(k.SafeHTMLCollection), y.default.instanceOf(k.SafeNodeList), y.default.arrayOf(y.default.instanceOf(D.default))]),
    onAfterOpen: y.default.func,
    onRequestClose: y.default.func,
    closeTimeoutMS: y.default.number,
    ariaHideApp: y.default.bool,
    shouldFocusAfterRender: y.default.bool,
    shouldCloseOnOverlayClick: y.default.bool,
    shouldReturnFocusAfterClose: y.default.bool,
    preventScroll: y.default.bool,
    parentSelector: y.default.func,
    aria: y.default.object,
    data: y.default.object,
    role: y.default.string,
    contentLabel: y.default.string,
    shouldCloseOnEsc: y.default.bool,
    overlayRef: y.default.func,
    contentRef: y.default.func,
    id: y.default.string,
    overlayElement: y.default.func,
    contentElement: y.default.func
  }, ie.defaultProps = {
    isOpen: !1,
    portalClassName: j,
    bodyOpenClassName: V,
    role: "dialog",
    ariaHideApp: !0,
    closeTimeoutMS: 0,
    shouldFocusAfterRender: !0,
    shouldCloseOnEsc: !0,
    shouldCloseOnOverlayClick: !0,
    shouldReturnFocusAfterClose: !0,
    preventScroll: !1,
    parentSelector: function () {
      return document.body;
    },
    overlayElement: function (ee, oe) {
      return l.default.createElement("div", ee, oe);
    },
    contentElement: function (ee, oe) {
      return l.default.createElement("div", ee, oe);
    }
  }, ie.defaultStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
      position: "absolute",
      top: "40px",
      left: "40px",
      right: "40px",
      bottom: "40px",
      border: "1px solid #ccc",
      background: "#fff",
      overflow: "auto",
      WebkitOverflowScrolling: "touch",
      borderRadius: "4px",
      outline: "none",
      padding: "20px"
    }
  }, (0, I.polyfill)(ie), process.env.NODE_ENV !== "production" && (ie.setCreateHTMLElement = function (Y) {
    return G = Y;
  }), q0.default = ie, q0;
}
var LU;
function Lge() {
  return LU || (LU = 1, function (t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var i = Oge(),
      l = c(i);
    function c(p) {
      return p && p.__esModule ? p : {
        default: p
      };
    }
    e.default = l.default, t.exports = e.default;
  }(TM, TM.exports)), TM.exports;
}
var Pge = Lge();
const Age = /* @__PURE__ */KO(Pge);
function jge(t) {
  if (Array.isArray(t)) {
    for (var e = 0, i = Array(t.length); e < t.length; e++) i[e] = t[e];
    return i;
  } else return Array.from(t);
}
var Dz = !1;
if (typeof window < "u") {
  var PU = {
    get passive() {
      Dz = !0;
    }
  };
  window.addEventListener("testPassive", null, PU), window.removeEventListener("testPassive", null, PU);
}
var $8 = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1),
  J0 = [],
  PO = !1,
  W8 = -1,
  QT = void 0,
  ZT = void 0,
  q8 = function (e) {
    return J0.some(function (i) {
      return !!(i.options.allowTouchMove && i.options.allowTouchMove(e));
    });
  },
  AO = function (e) {
    var i = e || window.event;
    return q8(i.target) || i.touches.length > 1 ? !0 : (i.preventDefault && i.preventDefault(), !1);
  },
  Fge = function (e) {
    if (ZT === void 0) {
      var i = !!e && e.reserveScrollBarGap === !0,
        l = window.innerWidth - document.documentElement.clientWidth;
      i && l > 0 && (ZT = document.body.style.paddingRight, document.body.style.paddingRight = l + "px");
    }
    QT === void 0 && (QT = document.body.style.overflow, document.body.style.overflow = "hidden");
  },
  Nge = function () {
    ZT !== void 0 && (document.body.style.paddingRight = ZT, ZT = void 0), QT !== void 0 && (document.body.style.overflow = QT, QT = void 0);
  },
  zge = function (e) {
    return e ? e.scrollHeight - e.scrollTop <= e.clientHeight : !1;
  },
  Vge = function (e, i) {
    var l = e.targetTouches[0].clientY - W8;
    return q8(e.target) ? !1 : i && i.scrollTop === 0 && l > 0 || zge(i) && l < 0 ? AO(e) : (e.stopPropagation(), !0);
  },
  Bge = function (e, i) {
    if (!e) {
      console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
      return;
    }
    if (!J0.some(function (c) {
      return c.targetElement === e;
    })) {
      var l = {
        targetElement: e,
        options: i || {}
      };
      J0 = [].concat(jge(J0), [l]), $8 ? (e.ontouchstart = function (c) {
        c.targetTouches.length === 1 && (W8 = c.targetTouches[0].clientY);
      }, e.ontouchmove = function (c) {
        c.targetTouches.length === 1 && Vge(c, e);
      }, PO || (document.addEventListener("touchmove", AO, Dz ? {
        passive: !1
      } : void 0), PO = !0)) : Fge(i);
    }
  },
  AU = function (e) {
    if (!e) {
      console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
      return;
    }
    J0 = J0.filter(function (i) {
      return i.targetElement !== e;
    }), $8 ? (e.ontouchstart = null, e.ontouchmove = null, PO && J0.length === 0 && (document.removeEventListener("touchmove", AO, Dz ? {
      passive: !1
    } : void 0), PO = !1)) : J0.length || Nge();
  };
const Uge = "_scrim_1fq8u_1",
  Hge = "_dark_1fq8u_19",
  $ge = "_light_1fq8u_22",
  Wge = "_mobileFullScreen_1fq8u_26",
  qge = "_modal_1fq8u_33",
  Yge = "_modalOpen_1fq8u_54",
  Gge = "_md_1fq8u_58",
  Xge = "_lg_1fq8u_61",
  Kge = "_modalTitle_1fq8u_72",
  Qge = "_modalHeader_1fq8u_80",
  Zge = "_modalCloseButton_1fq8u_87",
  Jge = "_content_1fq8u_113",
  xs = {
    scrim: Uge,
    dark: Hge,
    light: $ge,
    mobileFullScreen: Wge,
    modal: qge,
    modalOpen: Yge,
    md: Gge,
    lg: Xge,
    modalTitle: Kge,
    modalHeader: Qge,
    modalCloseButton: Zge,
    content: Jge
  },
  jU = {
    content: "Modal",
    close: "Close"
  },
  eye = ({
    appElement: t,
    children: e,
    title: i,
    header: l,
    className: c,
    classNames: p,
    labels: h = jU,
    size: y = "sm",
    variant: w = "dark",
    mobileFullScreen: x = !1,
    isOpen: E,
    onClose: C,
    isDismissible: k = !0,
    withoutContentWrapper: D = !1,
    ...I
  }) => {
    const O = {
        ...jU,
        ...h
      },
      P = vt(null),
      N = vt(null),
      L = () => {
        var K;
        P.current && Bge(P.current, {
          reserveScrollBarGap: !0
        }), (K = N.current) == null || K.focus();
      },
      F = () => {
        P.current && AU(P.current);
      },
      j = () => {
        P.current && AU(P.current), C == null || C();
      },
      V = k ? /* @__PURE__ */B.jsx("button", {
        type: "button",
        ref: N,
        className: ge(xs.modalCloseButton, p == null ? void 0 : p.closeButton),
        "aria-label": O.close,
        onClick: j,
        children: /* @__PURE__ */B.jsx(sn, {
          name: "close",
          hidden: !0
        })
      }) : null;
    return /* @__PURE__ */B.jsxs(Age, {
      appElement: t,
      className: ge(c, xs.modal, y && xs[y], E && xs.modalOpen, x && xs.mobileFullScreen),
      overlayClassName: ge(xs.scrim, p == null ? void 0 : p.scrim, x && xs.mobileFullScreen, xs[w]),
      contentLabel: O.content,
      isOpen: E,
      onAfterOpen: L,
      onAfterClose: F,
      onRequestClose: j,
      contentRef: K => {
        K && (P.current = K);
      },
      shouldCloseOnOverlayClick: k,
      shouldCloseOnEsc: k,
      ...I,
      children: [i && /* @__PURE__ */B.jsxs("div", {
        className: ge(xs.modalHeader),
        children: [/* @__PURE__ */B.jsx("div", {
          className: ge(xs.modalTitle, p == null ? void 0 : p.title),
          children: i
        }), V]
      }), !i && V, l && /* @__PURE__ */B.jsx("div", {
        className: ge(xs.modalHeader),
        children: l
      }), D ? e : /* @__PURE__ */B.jsx("div", {
        className: ge(xs.content, p == null ? void 0 : p.content),
        children: e
      })]
    });
  },
  FU = {
    content: "Modal",
    close: "Close"
  },
  tye = ({
    isOpen: t = !1,
    isDismissible: e = !0,
    onClose: i = () => !0,
    className: l,
    classNames: c,
    size: p = "sm",
    variant: h = "dark",
    withoutContentWrapper: y = !1,
    mobileFullScreen: w = !1,
    children: x,
    title: E,
    header: C,
    labels: k = FU
  }) => {
    const D = vt(null),
      I = vt(!1),
      O = {
        ...FU,
        ...k
      },
      P = j => {
        j && j.stopPropagation();
        let V = !1;
        if (typeof i == "function" ? i() !== !1 && (V = !0) : V = !0, V) {
          const K = D.current;
          K && K.open && K.close();
        }
      },
      N = j => {
        j.key === "Escape" && (e ? P() : (j.preventDefault(), j.stopPropagation()));
      },
      L = (j, V) => {
        const K = D.current;
        if (!K || !e) return;
        const G = K.getBoundingClientRect(),
          Q = j.clientX >= G.left && j.clientX <= G.right && j.clientY >= G.top && j.clientY <= G.bottom;
        V === "down" ? I.current = Q : V === "up" && !I.current && !Q && P(j);
      };
    Rt(() => {
      D.current && (t ? D.current.showModal() : P());
    }, [t]);
    const F = e ? /* @__PURE__ */B.jsx("button", {
      type: "button",
      className: ge(xs.modalCloseButton, c == null ? void 0 : c.closeButton),
      "aria-label": O.close,
      onClick: P,
      children: /* @__PURE__ */B.jsx(sn, {
        name: "close",
        hidden: !0
      })
    }) : null;
    return /* @__PURE__ */B.jsxs("dialog", {
      ref: D,
      role: "dialog",
      "aria-modal": "true",
      "aria-label": O.content,
      "data-theme": h,
      className: ge(xs.modal, c == null ? void 0 : c.scrim, p && xs[p], w && xs.mobileFullScreen, l),
      "data-modal": !0,
      onKeyDown: N,
      onMouseDown: j => L(j, "down"),
      onMouseUp: j => L(j, "up"),
      children: [E && /* @__PURE__ */B.jsxs("div", {
        className: ge(xs.modalHeader),
        children: [E && /* @__PURE__ */B.jsx("div", {
          className: ge(xs.modalTitle, c == null ? void 0 : c.title),
          children: E
        }), F]
      }), !E && F, C && /* @__PURE__ */B.jsx("div", {
        className: ge(xs.modalHeader),
        children: C
      }), y ? x : /* @__PURE__ */B.jsx("div", {
        className: ge(xs.content, c == null ? void 0 : c.content),
        children: x
      })]
    });
  },
  Q_e = ({
    implementation: t,
    ...e
  }) => t === "react" ? /* @__PURE__ */B.jsx(eye, {
    ...e
  }) : /* @__PURE__ */B.jsx(tye, {
    ...e
  }),
  Z_e = {
    sm: "sm",
    md: "md",
    lg: "lg"
  },
  J_e = {
    light: "light",
    dark: "dark",
    custom: "custom"
  },
  nye = "_container_12id3_1",
  rye = "_gridImages_12id3_5",
  iye = "_gridItem_12id3_13",
  aye = "_threeQuarters_12id3_18",
  oye = "_twoThirds_12id3_18",
  sye = "_fullWidth_12id3_22",
  lye = "_logo_12id3_34",
  uye = "_topLeft_12id3_49",
  cye = "_topRight_12id3_54",
  dye = "_btmLeft_12id3_59",
  fye = "_btmRight_12id3_64",
  Vm = {
    container: nye,
    gridImages: rye,
    gridItem: iye,
    threeQuarters: aye,
    twoThirds: oye,
    fullWidth: sye,
    logo: lye,
    topLeft: uye,
    topRight: cye,
    btmLeft: dye,
    btmRight: fye
  },
  RT = {
    topLeft: "top-left",
    topRight: "top-right",
    bottomLeft: "bottom-left",
    bottomRight: "bottom-right"
  },
  pj = {
    oneHalf: "1/2",
    twoThirds: "2/3",
    threeQuarters: "3/4"
  },
  exe = ({
    className: t,
    images: e,
    logo: i,
    logoPosition: l = RT.topLeft,
    populateImagesRightToLeft: c,
    populateImagesAsRows: p,
    columnProportions: h = pj.oneHalf,
    photoCredit: y,
    renderImage: w = x => /* @__PURE__ */B.jsx("img", {
      ...x
    })
  }) => {
    const x = ge(Vm.gridItem, {
      [Vm.fullWidth]: p,
      [Vm.threeQuarters]: h === pj.threeQuarters,
      [Vm.twoThirds]: h === pj.twoThirds
    });
    return c && e.reverse(), /* @__PURE__ */B.jsxs("div", {
      className: t,
      children: [/* @__PURE__ */B.jsxs("div", {
        className: Vm.container,
        children: [i && /* @__PURE__ */B.jsx("div", {
          className: ge(Vm.logo, {
            [Vm.topLeft]: l === RT.topLeft,
            [Vm.topRight]: l === RT.topRight,
            [Vm.btmLeft]: l === RT.bottomLeft,
            [Vm.btmRight]: l === RT.bottomRight
          }),
          children: w(i)
        }), /* @__PURE__ */B.jsx("div", {
          className: ge(Vm.gridImages),
          children: e.map(E => /* @__PURE__ */B.jsx("div", {
            className: x,
            children: w(E)
          }, E.id))
        })]
      }), y && /* @__PURE__ */B.jsx("p", {
        children: y
      })]
    });
  },
  pye = "_notifications_bl1sf_1",
  hye = "_menuWrapper_bl1sf_15",
  mye = "_menuItem_bl1sf_19",
  vye = "_active_bl1sf_27",
  gye = "_icon_bl1sf_30",
  yye = "_type_bl1sf_33",
  bye = "_listBody_bl1sf_40",
  wye = "_listContainer_bl1sf_44",
  _ye = "_listHeader_bl1sf_51",
  xye = "_listHeading_bl1sf_55",
  Sye = "_listClose_bl1sf_61",
  Eye = "_listCloseButton_bl1sf_64",
  Cye = "_listContent_bl1sf_77",
  kye = "_missingNotifications_bl1sf_80",
  Tye = "_listFooter_bl1sf_86",
  Rye = "_listFooterLink_bl1sf_91",
  Dye = "_listItemWrapper_bl1sf_94",
  Iye = "_listItemMessage_bl1sf_109",
  Mye = "_listItemHeader_bl1sf_114",
  Oye = "_listItemHeading_bl1sf_123",
  Lye = "_listItemIcon_bl1sf_126",
  Pye = "_listItemTitle_bl1sf_135",
  Aye = "_listItemDate_bl1sf_145",
  jye = "_listItemSubHeading_bl1sf_151",
  Fye = "_listItemAnchor_bl1sf_173",
  Nye = "_desktop_bl1sf_186",
  zye = "_mobile_bl1sf_189",
  Vye = "_auto_bl1sf_205",
  Bye = "_srOnly_bl1sf_228",
  Bi = {
    notifications: pye,
    menuWrapper: hye,
    menuItem: mye,
    active: vye,
    icon: gye,
    type: yye,
    listBody: bye,
    listContainer: wye,
    listHeader: _ye,
    listHeading: xye,
    listClose: Sye,
    listCloseButton: Eye,
    listContent: Cye,
    missingNotifications: kye,
    listFooter: Tye,
    listFooterLink: Rye,
    listItemWrapper: Dye,
    listItemMessage: Iye,
    listItemHeader: Mye,
    listItemHeading: Oye,
    listItemIcon: Lye,
    listItemTitle: Pye,
    listItemDate: Aye,
    listItemSubHeading: jye,
    listItemAnchor: Fye,
    desktop: Nye,
    mobile: zye,
    auto: Vye,
    srOnly: Bye
  },
  txe = ({
    storageId: t,
    locale: e = "en-CA",
    labels: i,
    data: l,
    triggerElement: c,
    menuSettings: p,
    template: h = "auto",
    onGetActiveTotal: y,
    renderCloseIcon: w,
    renderMenuIcon: x,
    renderFilterLink: E,
    renderNotificationLink: C,
    renderNotificationIcon: k,
    className: D,
    classNames: I
  }) => /* @__PURE__ */B.jsx(cG, {
    storageId: t,
    locale: e,
    labels: i,
    data: l,
    triggerElement: c,
    menuSettings: p,
    onGetActiveTotal: y,
    renderCloseIcon: w,
    renderMenuIcon: x,
    renderFilterLink: E ?? ((O, P) => /* @__PURE__ */B.jsx(fd, {
      className: P,
      href: O.filterLink,
      icon: "chevron-right-micro",
      children: O.filterLinkText
    })),
    renderNotificationLink: C,
    renderNotificationIcon: k,
    className: ge(Bi.notifications, Bi == null ? void 0 : Bi[h], D),
    classNames: {
      // Menu extensions
      menuWrapper: ge(Bi.menuWrapper, I == null ? void 0 : I.menuWrapper),
      menuContainer: ge(I == null ? void 0 : I.menuContainer),
      menuItem: ge(Bi.menuItem, I == null ? void 0 : I.menuItem),
      menuItemActive: ge(Bi.active, I == null ? void 0 : I.menuItemActive),
      menuItemIcon: ge(Bi.icon, I == null ? void 0 : I.menuItemIcon),
      menuItemType: ge(Bi.type, I == null ? void 0 : I.menuItemType),
      // List extensions
      listBody: ge(Bi.listBody, I == null ? void 0 : I.listBody),
      listContainer: ge(Bi.listContainer, I == null ? void 0 : I.listContainer),
      listHeader: ge(Bi.listHeader, I == null ? void 0 : I.listHeader),
      listHeading: ge(Bi.listHeading, I == null ? void 0 : I.listHeading),
      listClose: ge(Bi.listClose, I == null ? void 0 : I.listClose),
      listCloseButton: ge(Bi.listCloseButton, I == null ? void 0 : I.listCloseButton),
      listContent: ge(Bi.listContent, I == null ? void 0 : I.listContent),
      listFooter: ge(Bi.listFooter, I == null ? void 0 : I.listFooter),
      listFooterLink: ge(Bi.listFooterLink, I == null ? void 0 : I.listFooterLink),
      // List Items
      listItemWrapper: ge(Bi.listItemWrapper, I == null ? void 0 : I.listItemWrapper),
      listItemActive: ge(Bi.active, I == null ? void 0 : I.listItemActive),
      listItemHeader: ge(Bi.listItemHeader, I == null ? void 0 : I.listItemHeader),
      listItemHeading: ge(Bi.listItemHeading, I == null ? void 0 : I.listItemHeading),
      listItemAnchor: ge(Bi.listItemAnchor, I == null ? void 0 : I.listItemAnchor),
      listItemDate: ge(Bi.listItemDate, I == null ? void 0 : I.listItemDate),
      listItemIcon: ge(Bi.listItemIcon, I == null ? void 0 : I.listItemIcon),
      listItemMessage: ge(Bi.listItemMessage, I == null ? void 0 : I.listItemMessage),
      listItemSubHeading: ge(Bi.listItemSubHeading, I == null ? void 0 : I.listItemSubHeading),
      listItemTitle: ge(Bi.listItemTitle, I == null ? void 0 : I.listItemTitle),
      // Missing message
      listMissing: ge(Bi.missingNotifications, I == null ? void 0 : I.listMissing)
    }
  }),
  Uye = "_messageContainer_oxxbr_1",
  Hye = {
    messageContainer: Uye
  },
  nxe = ({
    align: t,
    size: e,
    status: i,
    responsive: l,
    disableLarge: c,
    message: p,
    title: h,
    theme: y,
    className: w,
    classNames: x
  }) => {
    let E = gl.color.white.value,
      C = gl.color.white.value;
    return y === "teal" && (E = gl.color.gray[400].value, C = gl.color.teal[500].value), /* @__PURE__ */B.jsx(FE, {
      align: t,
      size: e,
      status: i,
      responsive: l,
      disableLarge: c,
      message: p,
      trackColor: E,
      strokeColor: C,
      title: h,
      className: w,
      classNames: {
        messageContainer: ge(Hye.messageContainer, x == null ? void 0 : x.messageContainer),
        title: x == null ? void 0 : x.title,
        message: x == null ? void 0 : x.message
      }
    });
  };
function LM(t, e) {
  const i = vt(t),
    l = vt();
  return Rt(() => {
    i.current = t;
  }, [t]), Rt(() => () => {
    l.current && clearTimeout(l.current);
  }, []), pn((...c) => {
    l.current && clearTimeout(l.current), l.current = setTimeout(() => {
      i.current(...c);
    }, e);
  }, [e]);
}
const $ye = "_tabsWrapper_1enm5_1",
  Wye = "_tablist_1enm5_13",
  qye = "_trigger_1enm5_30",
  Yye = "_triggerText_1enm5_43",
  Gye = "_scrollButton_1enm5_77",
  Xye = "_icon_1enm5_98",
  fb = {
    tabsWrapper: $ye,
    tablist: Wye,
    trigger: qye,
    triggerText: Yye,
    scrollButton: Gye,
    icon: Xye
  },
  Kye = 100,
  PM = 50,
  Qye = 65,
  Zye = ({
    sections: t,
    offset: e = Qye,
    ...i
  }) => {
    var G;
    const l = vt(null),
      [c, p] = rt(!1),
      [h, y] = rt(!1),
      [w, x] = rt(!1),
      [E, C] = rt(((G = t[0]) == null ? void 0 : G.cardKey) ?? ""),
      k = pn(Q => {
        l.current && (l.current.scrollLeft += Q);
      }, []),
      D = pn(() => {
        const Q = l.current;
        if (!Q) return;
        const {
          scrollLeft: te,
          scrollWidth: ie,
          clientWidth: Y
        } = Q;
        y(te > 0), x(te < ie - Y - 1);
      }, []),
      I = pn(() => {
        const Q = l.current;
        Q && (p(Q.scrollWidth > Q.clientWidth), D());
      }, [D]),
      O = pn(Q => {
        const te = l.current;
        if (!te) return;
        const ie = te.querySelector(`[data-value="${Q}"]`);
        if (!ie) return;
        const Y = te.getBoundingClientRect(),
          ee = ie.getBoundingClientRect();
        if (!(ee.left >= Y.left && ee.right <= Y.right)) {
          const ne = ie.offsetLeft - Y.width / 2 + ee.width / 2;
          te.scrollTo({
            left: ne,
            behavior: "smooth"
          });
        }
      }, []),
      P = pn(Q => {
        const te = document.getElementById(Q.id);
        if (!te) return;
        const ie = te.offsetTop - e;
        window.scrollTo({
          top: ie,
          behavior: "smooth"
        });
      }, [e]),
      N = pn(() => {
        const Q = window.scrollY + e,
          te = window.scrollY + window.innerHeight,
          ie = document.documentElement.scrollHeight;
        if (Math.abs(te - ie) < 10) {
          const ee = t[t.length - 1];
          C(ee.cardKey), V(ee.cardKey);
          return;
        }
        const Y = t.find(ee => ee.cardKey === E);
        if (Y) {
          const ee = document.getElementById(Y.id);
          if (ee) {
            const oe = ee.offsetTop - e,
              ne = oe + ee.offsetHeight;
            if (oe <= Q && ne >= Q) return;
          }
        }
        for (let ee = t.length - 1; ee >= 0; ee--) {
          const oe = t[ee],
            ne = document.getElementById(oe.id);
          if (!ne) continue;
          if (ne.offsetTop - e <= Q) {
            C(oe.cardKey), V(oe.cardKey);
            return;
          }
        }
        C(t[0].cardKey), V(t[0].cardKey);
      }, [t, e, E]),
      L = pn(Q => {
        const te = t.find(ie => ie.cardKey === Q);
        te && (C(Q), P(te), O(Q));
      }, [t, P, O]),
      F = LM(D, PM),
      j = LM(I, PM),
      V = LM(Q => {
        typeof Q == "string" && O(Q);
      }, PM),
      K = LM(N, PM);
    return Rt(() => {
      const Q = l.current;
      if (!Q) return;
      const te = new ResizeObserver(j);
      return te.observe(Q), () => te.disconnect();
    }, [j]), Rt(() => {
      const Q = l.current;
      if (Q) return F(), Q.addEventListener("scroll", F), window.addEventListener("resize", j), () => {
        Q.removeEventListener("scroll", F), window.removeEventListener("resize", j);
      };
    }, [F, j]), Rt(() => (window.addEventListener("scroll", K), N(), () => window.removeEventListener("scroll", K)), [N, K]), /* @__PURE__ */B.jsxs(sa.div, {
      className: fb.tabsWrapper,
      children: [c && /* @__PURE__ */B.jsx(sa.button, {
        className: fb.scrollButton,
        onClick: () => k(-100),
        disabled: !h,
        "aria-label": "Scroll left",
        children: /* @__PURE__ */B.jsx(sn, {
          name: "chevron-left",
          "aria-hidden": !0
        })
      }), /* @__PURE__ */B.jsx(oY, {
        id: "navlist",
        className: fb.tablist,
        ref: l,
        value: E,
        onValueChange: L,
        ...i
      }), c && /* @__PURE__ */B.jsx(sa.button, {
        className: fb.scrollButton,
        onClick: () => k(Kye),
        disabled: !w,
        "aria-label": "Scroll right",
        children: /* @__PURE__ */B.jsx(sn, {
          name: "chevron-right",
          "aria-hidden": !0
        })
      })]
    });
  },
  Jye = ({
    children: t,
    value: e,
    icon: i
  }) => /* @__PURE__ */B.jsxs(aY, {
    className: ge(fb == null ? void 0 : fb.trigger),
    value: e,
    "data-value": e,
    children: [i && /* @__PURE__ */B.jsx(sn, {
      name: i,
      className: fb.icon,
      "aria-hidden": !0
    }), /* @__PURE__ */B.jsx("span", {
      className: fb.triggerText,
      children: t
    })]
  });
Zye.Item = Jye;
const ebe = {
    breakpoint: {
      sm: {
        value: "576px"
      }
    }
  },
  kR = parseInt(ebe.breakpoint.sm.value, 10),
  tbe = -100,
  nbe = "^[^@\\s]+@([^@\\s]+\\.)+[^@\\s]+$",
  tL = {
    mobileImage: "https://placehold.co/351x140",
    desktopLargeImage: "https://placehold.co/570x486",
    desktopSmallImage: "https://placehold.co/386x547",
    title: "Subscribe now",
    subtitle: "Sign up to be one of the first to hear about the latest offers from WestJet Vacations and for vacation planning inspiration.",
    submit: "Submit",
    confirmTitle: "Thank you",
    confirmMessage: "Lorem ipsum dolor sit amet consectetur. Fermentum sed suspendisse eu etiam faucibus. Etiam pulvinar quis habitant eu ultricies risus cursus donec.",
    inputFieldLabel: "Email",
    dropdownFieldLabel: "Preferred departure city",
    dropdownFieldErrorMissing: "Please select a departure city",
    optInMessage: "I want emails from WestJet Vacations Inc. on exclusive offers, promotions and vacation inspiration, including special offers from WestJet Vacations’ travel partners. You may unsubscribe at anytime by clicking the link in any marketing email we send you.",
    optInPrivacyLink: "https://www.westjet.com/en/privacy-policy",
    optInPrivacyLabel: "Privacy policy",
    optInContactLink: "https://www.westjet.com/en/contact-us",
    optInContactLabel: "Contact us",
    optInA11yMessage: " (opens in a new tab)",
    validityMessages: {
      valueMissing: "Please enter an email address",
      typeMismatch: "That doesn't look like a valid email.",
      patternMismatch: "Please use a full domain (e.g. name@example.com)."
    },
    errorUnknown: "An unexpected error occurred"
  };
var Iz = XR(),
  ur = t => GR(t, Iz),
  Mz = XR();
ur.write = t => GR(t, Mz);
var nL = XR();
ur.onStart = t => GR(t, nL);
var Oz = XR();
ur.onFrame = t => GR(t, Oz);
var Lz = XR();
ur.onFinish = t => GR(t, Lz);
var bE = [];
ur.setTimeout = (t, e) => {
  const i = ur.now() + e,
    l = () => {
      const p = bE.findIndex(h => h.cancel == l);
      ~p && bE.splice(p, 1), tw -= ~p ? 1 : 0;
    },
    c = {
      time: i,
      handler: t,
      cancel: l
    };
  return bE.splice(Y8(i), 0, c), tw += 1, G8(), c;
};
var Y8 = t => ~(~bE.findIndex(e => e.time > t) || ~bE.length);
ur.cancel = t => {
  nL.delete(t), Oz.delete(t), Lz.delete(t), Iz.delete(t), Mz.delete(t);
};
ur.sync = t => {
  yF = !0, ur.batchedUpdates(t), yF = !1;
};
ur.throttle = t => {
  let e;
  function i() {
    try {
      t(...e);
    } finally {
      e = null;
    }
  }
  function l(...c) {
    e = c, ur.onStart(i);
  }
  return l.handler = t, l.cancel = () => {
    nL.delete(i), e = null;
  }, l;
};
var Pz = typeof window < "u" ? window.requestAnimationFrame :
// eslint-disable-next-line @typescript-eslint/no-empty-function
() => {};
ur.use = t => Pz = t;
ur.now = typeof performance < "u" ? () => performance.now() : Date.now;
ur.batchedUpdates = t => t();
ur.catch = console.error;
ur.frameLoop = "always";
ur.advance = () => {
  ur.frameLoop !== "demand" ? console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand") : K8();
};
var ew = -1,
  tw = 0,
  yF = !1;
function GR(t, e) {
  yF ? (e.delete(t), t(0)) : (e.add(t), G8());
}
function G8() {
  ew < 0 && (ew = 0, ur.frameLoop !== "demand" && Pz(X8));
}
function rbe() {
  ew = -1;
}
function X8() {
  ~ew && (Pz(X8), ur.batchedUpdates(K8));
}
function K8() {
  const t = ew;
  ew = ur.now();
  const e = Y8(ew);
  if (e && (Q8(bE.splice(0, e), i => i.handler()), tw -= e), !tw) {
    rbe();
    return;
  }
  nL.flush(), Iz.flush(t ? Math.min(64, ew - t) : 16.667), Oz.flush(), Mz.flush(), Lz.flush();
}
function XR() {
  let t = /* @__PURE__ */new Set(),
    e = t;
  return {
    add(i) {
      tw += e == t && !t.has(i) ? 1 : 0, t.add(i);
    },
    delete(i) {
      return tw -= e == t && t.has(i) ? 1 : 0, t.delete(i);
    },
    flush(i) {
      e.size && (t = /* @__PURE__ */new Set(), tw -= e.size, Q8(e, l => l(i) && t.add(l)), tw += t.size, e = t);
    }
  };
}
function Q8(t, e) {
  t.forEach(i => {
    try {
      e(i);
    } catch (l) {
      ur.catch(l);
    }
  });
}
var ibe = Object.defineProperty,
  abe = (t, e) => {
    for (var i in e) ibe(t, i, {
      get: e[i],
      enumerable: !0
    });
  },
  Xm = {};
abe(Xm, {
  assign: () => sbe,
  colors: () => rw,
  createStringInterpolator: () => jz,
  skipAnimation: () => J8,
  to: () => Z8,
  willAdvance: () => Fz
});
function bF() {}
var obe = (t, e, i) => Object.defineProperty(t, e, {
    value: i,
    writable: !0,
    configurable: !0
  }),
  zt = {
    arr: Array.isArray,
    obj: t => !!t && t.constructor.name === "Object",
    fun: t => typeof t == "function",
    str: t => typeof t == "string",
    num: t => typeof t == "number",
    und: t => t === void 0
  };
function db(t, e) {
  if (zt.arr(t)) {
    if (!zt.arr(e) || t.length !== e.length) return !1;
    for (let i = 0; i < t.length; i++) if (t[i] !== e[i]) return !1;
    return !0;
  }
  return t === e;
}
var Fr = (t, e) => t.forEach(e);
function Jv(t, e, i) {
  if (zt.arr(t)) {
    for (let l = 0; l < t.length; l++) e.call(i, t[l], `${l}`);
    return;
  }
  for (const l in t) t.hasOwnProperty(l) && e.call(i, t[l], l);
}
var sp = t => zt.und(t) ? [] : zt.arr(t) ? t : [t];
function JT(t, e) {
  if (t.size) {
    const i = Array.from(t);
    t.clear(), Fr(i, e);
  }
}
var PT = (t, ...e) => JT(t, i => i(...e)),
  Az = () => typeof window > "u" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent),
  jz,
  Z8,
  rw = null,
  J8 = !1,
  Fz = bF,
  sbe = t => {
    t.to && (Z8 = t.to), t.now && (ur.now = t.now), t.colors !== void 0 && (rw = t.colors), t.skipAnimation != null && (J8 = t.skipAnimation), t.createStringInterpolator && (jz = t.createStringInterpolator), t.requestAnimationFrame && ur.use(t.requestAnimationFrame), t.batchedUpdates && (ur.batchedUpdates = t.batchedUpdates), t.willAdvance && (Fz = t.willAdvance), t.frameLoop && (ur.frameLoop = t.frameLoop);
  },
  eR = /* @__PURE__ */new Set(),
  Fp = [],
  hj = [],
  jO = 0,
  rL = {
    get idle() {
      return !eR.size && !Fp.length;
    },
    /** Advance the given animation on every frame until idle. */
    start(t) {
      jO > t.priority ? (eR.add(t), ur.onStart(lbe)) : (eW(t), ur(wF));
    },
    /** Advance all animations by the given time. */
    advance: wF,
    /** Call this when an animation's priority changes. */
    sort(t) {
      if (jO) ur.onFrame(() => rL.sort(t));else {
        const e = Fp.indexOf(t);
        ~e && (Fp.splice(e, 1), tW(t));
      }
    },
    /**
     * Clear all animations. For testing purposes.
     *
     * ☠️ Never call this from within the frameloop.
     */
    clear() {
      Fp = [], eR.clear();
    }
  };
function lbe() {
  eR.forEach(eW), eR.clear(), ur(wF);
}
function eW(t) {
  Fp.includes(t) || tW(t);
}
function tW(t) {
  Fp.splice(ube(Fp, e => e.priority > t.priority), 0, t);
}
function wF(t) {
  const e = hj;
  for (let i = 0; i < Fp.length; i++) {
    const l = Fp[i];
    jO = l.priority, l.idle || (Fz(l), l.advance(t), l.idle || e.push(l));
  }
  return jO = 0, hj = Fp, hj.length = 0, Fp = e, Fp.length > 0;
}
function ube(t, e) {
  const i = t.findIndex(e);
  return i < 0 ? t.length : i;
}
var cbe = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
  },
  Wm = "[-+]?\\d*\\.?\\d+",
  FO = Wm + "%";
function iL(...t) {
  return "\\(\\s*(" + t.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var dbe = new RegExp("rgb" + iL(Wm, Wm, Wm)),
  fbe = new RegExp("rgba" + iL(Wm, Wm, Wm, Wm)),
  pbe = new RegExp("hsl" + iL(Wm, FO, FO)),
  hbe = new RegExp("hsla" + iL(Wm, FO, FO, Wm)),
  mbe = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  vbe = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  gbe = /^#([0-9a-fA-F]{6})$/,
  ybe = /^#([0-9a-fA-F]{8})$/;
function bbe(t) {
  let e;
  return typeof t == "number" ? t >>> 0 === t && t >= 0 && t <= 4294967295 ? t : null : (e = gbe.exec(t)) ? parseInt(e[1] + "ff", 16) >>> 0 : rw && rw[t] !== void 0 ? rw[t] : (e = dbe.exec(t)) ? (nE(e[1]) << 24 |
  // r
  nE(e[2]) << 16 |
  // g
  nE(e[3]) << 8 |
  // b
  255) >>>
  // a
  0 : (e = fbe.exec(t)) ? (nE(e[1]) << 24 |
  // r
  nE(e[2]) << 16 |
  // g
  nE(e[3]) << 8 |
  // b
  VU(e[4])) >>>
  // a
  0 : (e = mbe.exec(t)) ? parseInt(e[1] + e[1] +
  // r
  e[2] + e[2] +
  // g
  e[3] + e[3] +
  // b
  "ff",
  // a
  16) >>> 0 : (e = ybe.exec(t)) ? parseInt(e[1], 16) >>> 0 : (e = vbe.exec(t)) ? parseInt(e[1] + e[1] +
  // r
  e[2] + e[2] +
  // g
  e[3] + e[3] +
  // b
  e[4] + e[4],
  // a
  16) >>> 0 : (e = pbe.exec(t)) ? (NU(zU(e[1]),
  // h
  AM(e[2]),
  // s
  AM(e[3])
  // l
  ) | 255) >>>
  // a
  0 : (e = hbe.exec(t)) ? (NU(zU(e[1]),
  // h
  AM(e[2]),
  // s
  AM(e[3])
  // l
  ) | VU(e[4])) >>>
  // a
  0 : null;
}
function mj(t, e, i) {
  return i < 0 && (i += 1), i > 1 && (i -= 1), i < 1 / 6 ? t + (e - t) * 6 * i : i < 1 / 2 ? e : i < 2 / 3 ? t + (e - t) * (2 / 3 - i) * 6 : t;
}
function NU(t, e, i) {
  const l = i < 0.5 ? i * (1 + e) : i + e - i * e,
    c = 2 * i - l,
    p = mj(c, l, t + 1 / 3),
    h = mj(c, l, t),
    y = mj(c, l, t - 1 / 3);
  return Math.round(p * 255) << 24 | Math.round(h * 255) << 16 | Math.round(y * 255) << 8;
}
function nE(t) {
  const e = parseInt(t, 10);
  return e < 0 ? 0 : e > 255 ? 255 : e;
}
function zU(t) {
  return (parseFloat(t) % 360 + 360) % 360 / 360;
}
function VU(t) {
  const e = parseFloat(t);
  return e < 0 ? 0 : e > 1 ? 255 : Math.round(e * 255);
}
function AM(t) {
  const e = parseFloat(t);
  return e < 0 ? 0 : e > 100 ? 1 : e / 100;
}
function BU(t) {
  let e = bbe(t);
  if (e === null) return t;
  e = e || 0;
  const i = (e & 4278190080) >>> 24,
    l = (e & 16711680) >>> 16,
    c = (e & 65280) >>> 8,
    p = (e & 255) / 255;
  return `rgba(${i}, ${l}, ${c}, ${p})`;
}
var TR = (t, e, i) => {
  if (zt.fun(t)) return t;
  if (zt.arr(t)) return TR({
    range: t,
    output: e,
    extrapolate: i
  });
  if (zt.str(t.output[0])) return jz(t);
  const l = t,
    c = l.output,
    p = l.range || [0, 1],
    h = l.extrapolateLeft || l.extrapolate || "extend",
    y = l.extrapolateRight || l.extrapolate || "extend",
    w = l.easing || (x => x);
  return x => {
    const E = _be(x, p);
    return wbe(x, p[E], p[E + 1], c[E], c[E + 1], w, h, y, l.map);
  };
};
function wbe(t, e, i, l, c, p, h, y, w) {
  let x = w ? w(t) : t;
  if (x < e) {
    if (h === "identity") return x;
    h === "clamp" && (x = e);
  }
  if (x > i) {
    if (y === "identity") return x;
    y === "clamp" && (x = i);
  }
  return l === c ? l : e === i ? t <= e ? l : c : (e === -1 / 0 ? x = -x : i === 1 / 0 ? x = x - e : x = (x - e) / (i - e), x = p(x), l === -1 / 0 ? x = -x : c === 1 / 0 ? x = x + l : x = x * (c - l) + l, x);
}
function _be(t, e) {
  for (var i = 1; i < e.length - 1 && !(e[i] >= t); ++i);
  return i - 1;
}
var xbe = {
    linear: t => t
  },
  RR = Symbol.for("FluidValue.get"),
  IE = Symbol.for("FluidValue.observers"),
  Ap = t => !!(t && t[RR]),
  od = t => t && t[RR] ? t[RR]() : t,
  UU = t => t[IE] || null;
function Sbe(t, e) {
  t.eventObserved ? t.eventObserved(e) : t(e);
}
function DR(t, e) {
  const i = t[IE];
  i && i.forEach(l => {
    Sbe(l, e);
  });
}
var nW = class {
    constructor(t) {
      if (!t && !(t = this.get)) throw Error("Unknown getter");
      Ebe(this, t);
    }
  },
  Ebe = (t, e) => rW(t, RR, e);
function $E(t, e) {
  if (t[RR]) {
    let i = t[IE];
    i || rW(t, IE, i = /* @__PURE__ */new Set()), i.has(e) || (i.add(e), t.observerAdded && t.observerAdded(i.size, e));
  }
  return e;
}
function IR(t, e) {
  const i = t[IE];
  if (i && i.has(e)) {
    const l = i.size - 1;
    l ? i.delete(e) : t[IE] = null, t.observerRemoved && t.observerRemoved(l, e);
  }
}
var rW = (t, e, i) => Object.defineProperty(t, e, {
    value: i,
    writable: !0,
    configurable: !0
  }),
  JM = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
  Cbe = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi,
  HU = new RegExp(`(${JM.source})(%|[a-z]+)`, "i"),
  kbe = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi,
  aL = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/,
  iW = t => {
    const [e, i] = Tbe(t);
    if (!e || Az()) return t;
    const l = window.getComputedStyle(document.documentElement).getPropertyValue(e);
    if (l) return l.trim();
    if (i && i.startsWith("--")) {
      const c = window.getComputedStyle(document.documentElement).getPropertyValue(i);
      return c || t;
    } else {
      if (i && aL.test(i)) return iW(i);
      if (i) return i;
    }
    return t;
  },
  Tbe = t => {
    const e = aL.exec(t);
    if (!e) return [,];
    const [, i, l] = e;
    return [i, l];
  },
  vj,
  Rbe = (t, e, i, l, c) => `rgba(${Math.round(e)}, ${Math.round(i)}, ${Math.round(l)}, ${c})`,
  aW = t => {
    vj || (vj = rw ?
    // match color names, ignore partial matches
    new RegExp(`(${Object.keys(rw).join("|")})(?!\\w)`, "g") :
    // never match
    /^\b$/);
    const e = t.output.map(p => od(p).replace(aL, iW).replace(Cbe, BU).replace(vj, BU)),
      i = e.map(p => p.match(JM).map(Number)),
      c = i[0].map((p, h) => i.map(y => {
        if (!(h in y)) throw Error('The arity of each "output" value must be equal');
        return y[h];
      })).map(p => TR({
        ...t,
        output: p
      }));
    return p => {
      var w;
      const h = !HU.test(e[0]) && ((w = e.find(x => HU.test(x))) == null ? void 0 : w.replace(JM, ""));
      let y = 0;
      return e[0].replace(JM, () => `${c[y++](p)}${h || ""}`).replace(kbe, Rbe);
    };
  },
  Nz = "react-spring: ",
  oW = t => {
    const e = t;
    let i = !1;
    if (typeof e != "function") throw new TypeError(`${Nz}once requires a function parameter`);
    return (...l) => {
      i || (e(...l), i = !0);
    };
  },
  Dbe = oW(console.warn);
function Ibe() {
  Dbe(`${Nz}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
var Mbe = oW(console.warn);
function Obe() {
  Mbe(`${Nz}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}
function oL(t) {
  return zt.str(t) && (t[0] == "#" || /\d/.test(t) ||
  // Do not identify a CSS variable as an AnimatedString if its SSR
  !Az() && aL.test(t) || t in (rw || {}));
}
var zz = Az() ? Rt : NR,
  Lbe = () => {
    const t = vt(!1);
    return zz(() => (t.current = !0, () => {
      t.current = !1;
    }), []), t;
  };
function sW() {
  const t = rt()[1],
    e = Lbe();
  return () => {
    e.current && t(Math.random());
  };
}
function Pbe(t, e) {
  const [i] = rt(() => ({
      inputs: e,
      result: t()
    })),
    l = vt(),
    c = l.current;
  let p = c;
  return p ? e && p.inputs && Abe(e, p.inputs) || (p = {
    inputs: e,
    result: t()
  }) : p = i, Rt(() => {
    l.current = p, c == i && (i.inputs = i.result = void 0);
  }, [p]), p.result;
}
function Abe(t, e) {
  if (t.length !== e.length) return !1;
  for (let i = 0; i < t.length; i++) if (t[i] !== e[i]) return !1;
  return !0;
}
var lW = t => Rt(t, jbe),
  jbe = [];
function $U(t) {
  const e = vt();
  return Rt(() => {
    e.current = t;
  }), e.current;
}
var MR = Symbol.for("Animated:node"),
  Fbe = t => !!t && t[MR] === t,
  $v = t => t && t[MR],
  Vz = (t, e) => obe(t, MR, e),
  sL = t => t && t[MR] && t[MR].getPayload(),
  uW = class {
    constructor() {
      Vz(this, this);
    }
    /** Get every `AnimatedValue` used by this node. */
    getPayload() {
      return this.payload || [];
    }
  },
  KR = class extends uW {
    constructor(t) {
      super(), this._value = t, this.done = !0, this.durationProgress = 0, zt.num(this._value) && (this.lastPosition = this._value);
    }
    /** @internal */
    static create(t) {
      return new KR(t);
    }
    getPayload() {
      return [this];
    }
    getValue() {
      return this._value;
    }
    setValue(t, e) {
      return zt.num(t) && (this.lastPosition = t, e && (t = Math.round(t / e) * e, this.done && (this.lastPosition = t))), this._value === t ? !1 : (this._value = t, !0);
    }
    reset() {
      const {
        done: t
      } = this;
      this.done = !1, zt.num(this._value) && (this.elapsedTime = 0, this.durationProgress = 0, this.lastPosition = this._value, t && (this.lastVelocity = null), this.v0 = null);
    }
  },
  OR = class extends KR {
    constructor(t) {
      super(0), this._string = null, this._toString = TR({
        output: [t, t]
      });
    }
    /** @internal */
    static create(t) {
      return new OR(t);
    }
    getValue() {
      const t = this._string;
      return t ?? (this._string = this._toString(this._value));
    }
    setValue(t) {
      if (zt.str(t)) {
        if (t == this._string) return !1;
        this._string = t, this._value = 1;
      } else if (super.setValue(t)) this._string = null;else return !1;
      return !0;
    }
    reset(t) {
      t && (this._toString = TR({
        output: [this.getValue(), t]
      })), this._value = 0, super.reset();
    }
  },
  NO = {
    dependencies: null
  },
  lL = class extends uW {
    constructor(t) {
      super(), this.source = t, this.setValue(t);
    }
    getValue(t) {
      const e = {};
      return Jv(this.source, (i, l) => {
        Fbe(i) ? e[l] = i.getValue(t) : Ap(i) ? e[l] = od(i) : t || (e[l] = i);
      }), e;
    }
    /** Replace the raw object data */
    setValue(t) {
      this.source = t, this.payload = this._makePayload(t);
    }
    reset() {
      this.payload && Fr(this.payload, t => t.reset());
    }
    /** Create a payload set. */
    _makePayload(t) {
      if (t) {
        const e = /* @__PURE__ */new Set();
        return Jv(t, this._addToPayload, e), Array.from(e);
      }
    }
    /** Add to a payload set. */
    _addToPayload(t) {
      NO.dependencies && Ap(t) && NO.dependencies.add(t);
      const e = sL(t);
      e && Fr(e, i => this.add(i));
    }
  },
  cW = class extends lL {
    constructor(t) {
      super(t);
    }
    /** @internal */
    static create(t) {
      return new cW(t);
    }
    getValue() {
      return this.source.map(t => t.getValue());
    }
    setValue(t) {
      const e = this.getPayload();
      return t.length == e.length ? e.map((i, l) => i.setValue(t[l])).some(Boolean) : (super.setValue(t.map(Nbe)), !0);
    }
  };
function Nbe(t) {
  return (oL(t) ? OR : KR).create(t);
}
function _F(t) {
  const e = $v(t);
  return e ? e.constructor : zt.arr(t) ? cW : oL(t) ? OR : KR;
}
var WU = (t, e) => {
    const i =
    // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !zt.fun(t) || t.prototype && t.prototype.isReactComponent;
    return Qn((l, c) => {
      const p = vt(null),
        h = i &&
        // eslint-disable-next-line react-hooks/rules-of-hooks
        pn(I => {
          p.current = Bbe(c, I);
        }, [c]),
        [y, w] = Vbe(l, e),
        x = sW(),
        E = () => {
          const I = p.current;
          if (i && !I) return;
          (I ? e.applyAnimatedValues(I, y.getValue(!0)) : !1) === !1 && x();
        },
        C = new zbe(E, w),
        k = vt();
      zz(() => (k.current = C, Fr(w, I => $E(I, C)), () => {
        k.current && (Fr(k.current.deps, I => IR(I, k.current)), ur.cancel(k.current.update));
      })), Rt(E, []), lW(() => () => {
        const I = k.current;
        Fr(I.deps, O => IR(O, I));
      });
      const D = e.getComponentProps(y.getValue());
      return /* @__PURE__ */Bn.createElement(t, {
        ...D,
        ref: h
      });
    });
  },
  zbe = class {
    constructor(t, e) {
      this.update = t, this.deps = e;
    }
    eventObserved(t) {
      t.type == "change" && ur.write(this.update);
    }
  };
function Vbe(t, e) {
  const i = /* @__PURE__ */new Set();
  return NO.dependencies = i, t.style && (t = {
    ...t,
    style: e.createAnimatedStyle(t.style)
  }), t = new lL(t), NO.dependencies = null, [t, i];
}
function Bbe(t, e) {
  return t && (zt.fun(t) ? t(e) : t.current = e), e;
}
var qU = Symbol.for("AnimatedComponent"),
  Ube = (t, {
    applyAnimatedValues: e = () => !1,
    createAnimatedStyle: i = c => new lL(c),
    getComponentProps: l = c => c
  } = {}) => {
    const c = {
        applyAnimatedValues: e,
        createAnimatedStyle: i,
        getComponentProps: l
      },
      p = h => {
        const y = YU(h) || "Anonymous";
        return zt.str(h) ? h = p[h] || (p[h] = WU(h, c)) : h = h[qU] || (h[qU] = WU(h, c)), h.displayName = `Animated(${y})`, h;
      };
    return Jv(t, (h, y) => {
      zt.arr(t) && (y = YU(h)), p[y] = p(h);
    }), {
      animated: p
    };
  },
  YU = t => zt.str(t) ? t : t && zt.str(t.displayName) ? t.displayName : zt.fun(t) && t.name || null;
function Ux(t, ...e) {
  return zt.fun(t) ? t(...e) : t;
}
var tR = (t, e) => t === !0 || !!(e && t && (zt.fun(t) ? t(e) : sp(t).includes(e))),
  dW = (t, e) => zt.obj(t) ? e && t[e] : t,
  fW = (t, e) => t.default === !0 ? t[e] : t.default ? t.default[e] : void 0,
  Hbe = t => t,
  Bz = (t, e = Hbe) => {
    let i = $be;
    t.default && t.default !== !0 && (t = t.default, i = Object.keys(t));
    const l = {};
    for (const c of i) {
      const p = e(t[c], c);
      zt.und(p) || (l[c] = p);
    }
    return l;
  },
  $be = ["config", "onProps", "onStart", "onChange", "onPause", "onResume", "onRest"],
  Wbe = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    // Transition props
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    // Internal props
    keys: 1,
    callId: 1,
    parentId: 1
  };
function qbe(t) {
  const e = {};
  let i = 0;
  if (Jv(t, (l, c) => {
    Wbe[c] || (e[c] = l, i++);
  }), i) return e;
}
function pW(t) {
  const e = qbe(t);
  if (e) {
    const i = {
      to: e
    };
    return Jv(t, (l, c) => c in e || (i[c] = l)), i;
  }
  return {
    ...t
  };
}
function LR(t) {
  return t = od(t), zt.arr(t) ? t.map(LR) : oL(t) ? Xm.createStringInterpolator({
    range: [0, 1],
    output: [t, t]
  })(1) : t;
}
function Ybe(t) {
  for (const e in t) return !0;
  return !1;
}
function xF(t) {
  return zt.fun(t) || zt.arr(t) && zt.obj(t[0]);
}
function Gbe(t, e) {
  var i;
  (i = t.ref) == null || i.delete(t), e == null || e.delete(t);
}
function Xbe(t, e) {
  var i;
  e && t.ref !== e && ((i = t.ref) == null || i.delete(t), e.add(t), t.ref = e);
}
var Kbe = {
    default: {
      tension: 170,
      friction: 26
    }
  },
  SF = {
    ...Kbe.default,
    mass: 1,
    damping: 1,
    easing: xbe.linear,
    clamp: !1
  },
  Qbe = class {
    constructor() {
      this.velocity = 0, Object.assign(this, SF);
    }
  };
function Zbe(t, e, i) {
  i && (i = {
    ...i
  }, GU(i, e), e = {
    ...i,
    ...e
  }), GU(t, e), Object.assign(t, e);
  for (const h in SF) t[h] == null && (t[h] = SF[h]);
  let {
    frequency: l,
    damping: c
  } = t;
  const {
    mass: p
  } = t;
  return zt.und(l) || (l < 0.01 && (l = 0.01), c < 0 && (c = 0), t.tension = Math.pow(2 * Math.PI / l, 2) * p, t.friction = 4 * Math.PI * c * p / l), t;
}
function GU(t, e) {
  if (!zt.und(e.decay)) t.duration = void 0;else {
    const i = !zt.und(e.tension) || !zt.und(e.friction);
    (i || !zt.und(e.frequency) || !zt.und(e.damping) || !zt.und(e.mass)) && (t.duration = void 0, t.decay = void 0), i && (t.frequency = void 0);
  }
}
var XU = [],
  Jbe = class {
    constructor() {
      this.changed = !1, this.values = XU, this.toValues = null, this.fromValues = XU, this.config = new Qbe(), this.immediate = !1;
    }
  };
function hW(t, {
  key: e,
  props: i,
  defaultProps: l,
  state: c,
  actions: p
}) {
  return new Promise((h, y) => {
    let w,
      x,
      E = tR(i.cancel ?? (l == null ? void 0 : l.cancel), e);
    if (E) D();else {
      zt.und(i.pause) || (c.paused = tR(i.pause, e));
      let I = l == null ? void 0 : l.pause;
      I !== !0 && (I = c.paused || tR(I, e)), w = Ux(i.delay || 0, e), I ? (c.resumeQueue.add(k), p.pause()) : (p.resume(), k());
    }
    function C() {
      c.resumeQueue.add(k), c.timeouts.delete(x), x.cancel(), w = x.time - ur.now();
    }
    function k() {
      w > 0 && !Xm.skipAnimation ? (c.delayed = !0, x = ur.setTimeout(D, w), c.pauseQueue.add(C), c.timeouts.add(x)) : D();
    }
    function D() {
      c.delayed && (c.delayed = !1), c.pauseQueue.delete(C), c.timeouts.delete(x), t <= (c.cancelId || 0) && (E = !0);
      try {
        p.start({
          ...i,
          callId: t,
          cancel: E
        }, h);
      } catch (I) {
        y(I);
      }
    }
  });
}
var Uz = (t, e) => e.length == 1 ? e[0] : e.some(i => i.cancelled) ? wE(t.get()) : e.every(i => i.noop) ? mW(t.get()) : Hm(t.get(), e.every(i => i.finished)),
  mW = t => ({
    value: t,
    noop: !0,
    finished: !0,
    cancelled: !1
  }),
  Hm = (t, e, i = !1) => ({
    value: t,
    finished: e,
    cancelled: i
  }),
  wE = t => ({
    value: t,
    cancelled: !0,
    finished: !1
  });
function vW(t, e, i, l) {
  const {
      callId: c,
      parentId: p,
      onRest: h
    } = e,
    {
      asyncTo: y,
      promise: w
    } = i;
  return !p && t === y && !e.reset ? w : i.promise = (async () => {
    i.asyncId = c, i.asyncTo = t;
    const x = Bz(e, (P, N) =>
    // The `onRest` prop is only called when the `runAsync` promise is resolved.
    N === "onRest" ? void 0 : P);
    let E, C;
    const k = new Promise((P, N) => (E = P, C = N)),
      D = P => {
        const N =
        // The `cancel` prop or `stop` method was used.
        c <= (i.cancelId || 0) && wE(l) ||
        // The async `to` prop was replaced.
        c !== i.asyncId && Hm(l, !1);
        if (N) throw P.result = N, C(P), P;
      },
      I = (P, N) => {
        const L = new KU(),
          F = new QU();
        return (async () => {
          if (Xm.skipAnimation) throw PR(i), F.result = Hm(l, !1), C(F), F;
          D(L);
          const j = zt.obj(P) ? {
            ...P
          } : {
            ...N,
            to: P
          };
          j.parentId = c, Jv(x, (K, G) => {
            zt.und(j[G]) && (j[G] = K);
          });
          const V = await l.start(j);
          return D(L), i.paused && (await new Promise(K => {
            i.resumeQueue.add(K);
          })), V;
        })();
      };
    let O;
    if (Xm.skipAnimation) return PR(i), Hm(l, !1);
    try {
      let P;
      zt.arr(t) ? P = (async N => {
        for (const L of N) await I(L);
      })(t) : P = Promise.resolve(t(I, l.stop.bind(l))), await Promise.all([P.then(E), k]), O = Hm(l.get(), !0, !1);
    } catch (P) {
      if (P instanceof KU) O = P.result;else if (P instanceof QU) O = P.result;else throw P;
    } finally {
      c == i.asyncId && (i.asyncId = p, i.asyncTo = p ? y : void 0, i.promise = p ? w : void 0);
    }
    return zt.fun(h) && ur.batchedUpdates(() => {
      h(O, l, l.item);
    }), O;
  })();
}
function PR(t, e) {
  JT(t.timeouts, i => i.cancel()), t.pauseQueue.clear(), t.resumeQueue.clear(), t.asyncId = t.asyncTo = t.promise = void 0, e && (t.cancelId = e);
}
var KU = class extends Error {
    constructor() {
      super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
    }
  },
  QU = class extends Error {
    constructor() {
      super("SkipAnimationSignal");
    }
  },
  EF = t => t instanceof Hz,
  e0e = 1,
  Hz = class extends nW {
    constructor() {
      super(...arguments), this.id = e0e++, this._priority = 0;
    }
    get priority() {
      return this._priority;
    }
    set priority(t) {
      this._priority != t && (this._priority = t, this._onPriorityChange(t));
    }
    /** Get the current value */
    get() {
      const t = $v(this);
      return t && t.getValue();
    }
    /** Create a spring that maps our value to another value */
    to(...t) {
      return Xm.to(this, t);
    }
    /** @deprecated Use the `to` method instead. */
    interpolate(...t) {
      return Ibe(), Xm.to(this, t);
    }
    toJSON() {
      return this.get();
    }
    observerAdded(t) {
      t == 1 && this._attach();
    }
    observerRemoved(t) {
      t == 0 && this._detach();
    }
    /** Called when the first child is added. */
    _attach() {}
    /** Called when the last child is removed. */
    _detach() {}
    /** Tell our children about our new value */
    _onChange(t, e = !1) {
      DR(this, {
        type: "change",
        parent: this,
        value: t,
        idle: e
      });
    }
    /** Tell our children about our new priority */
    _onPriorityChange(t) {
      this.idle || rL.sort(this), DR(this, {
        type: "priority",
        parent: this,
        priority: t
      });
    }
  },
  nS = Symbol.for("SpringPhase"),
  gW = 1,
  yW = 2,
  bW = 4,
  gj = t => (t[nS] & gW) > 0,
  Y0 = t => (t[nS] & yW) > 0,
  DT = t => (t[nS] & bW) > 0,
  ZU = (t, e) => e ? t[nS] |= yW | gW : t[nS] &= -3,
  JU = (t, e) => e ? t[nS] |= bW : t[nS] &= -5,
  t0e = class extends Hz {
    constructor(t, e) {
      if (super(), this.animation = new Jbe(), this.defaultProps = {}, this._state = {
        paused: !1,
        delayed: !1,
        pauseQueue: /* @__PURE__ */new Set(),
        resumeQueue: /* @__PURE__ */new Set(),
        timeouts: /* @__PURE__ */new Set()
      }, this._pendingCalls = /* @__PURE__ */new Set(), this._lastCallId = 0, this._lastToId = 0, this._memoizedDuration = 0, !zt.und(t) || !zt.und(e)) {
        const i = zt.obj(t) ? {
          ...t
        } : {
          ...e,
          from: t
        };
        zt.und(i.default) && (i.default = !0), this.start(i);
      }
    }
    /** Equals true when not advancing on each frame. */
    get idle() {
      return !(Y0(this) || this._state.asyncTo) || DT(this);
    }
    get goal() {
      return od(this.animation.to);
    }
    get velocity() {
      const t = $v(this);
      return t instanceof KR ? t.lastVelocity || 0 : t.getPayload().map(e => e.lastVelocity || 0);
    }
    /**
     * When true, this value has been animated at least once.
     */
    get hasAnimated() {
      return gj(this);
    }
    /**
     * When true, this value has an unfinished animation,
     * which is either active or paused.
     */
    get isAnimating() {
      return Y0(this);
    }
    /**
     * When true, all current and future animations are paused.
     */
    get isPaused() {
      return DT(this);
    }
    /**
     *
     *
     */
    get isDelayed() {
      return this._state.delayed;
    }
    /** Advance the current animation by a number of milliseconds */
    advance(t) {
      let e = !0,
        i = !1;
      const l = this.animation;
      let {
        toValues: c
      } = l;
      const {
          config: p
        } = l,
        h = sL(l.to);
      !h && Ap(l.to) && (c = sp(od(l.to))), l.values.forEach((x, E) => {
        if (x.done) return;
        const C =
        // Animated strings always go from 0 to 1.
        x.constructor == OR ? 1 : h ? h[E].lastPosition : c[E];
        let k = l.immediate,
          D = C;
        if (!k) {
          if (D = x.lastPosition, p.tension <= 0) {
            x.done = !0;
            return;
          }
          let I = x.elapsedTime += t;
          const O = l.fromValues[E],
            P = x.v0 != null ? x.v0 : x.v0 = zt.arr(p.velocity) ? p.velocity[E] : p.velocity;
          let N;
          const L = p.precision || (O == C ? 5e-3 : Math.min(1, Math.abs(C - O) * 1e-3));
          if (zt.und(p.duration)) {
            if (p.decay) {
              const F = p.decay === !0 ? 0.998 : p.decay,
                j = Math.exp(-(1 - F) * I);
              D = O + P / (1 - F) * (1 - j), k = Math.abs(x.lastPosition - D) <= L, N = P * j;
            } else {
              N = x.lastVelocity == null ? P : x.lastVelocity;
              const F = p.restVelocity || L / 10,
                j = p.clamp ? 0 : p.bounce,
                V = !zt.und(j),
                K = O == C ? x.v0 > 0 : O < C;
              let G,
                Q = !1;
              const te = 1,
                ie = Math.ceil(t / te);
              for (let Y = 0; Y < ie && (G = Math.abs(N) > F, !(!G && (k = Math.abs(C - D) <= L, k))); ++Y) {
                V && (Q = D == C || D > C == K, Q && (N = -N * j, D = C));
                const ee = -p.tension * 1e-6 * (D - C),
                  oe = -p.friction * 1e-3 * N,
                  ne = (ee + oe) / p.mass;
                N = N + ne * te, D = D + N * te;
              }
            }
          } else {
            let F = 1;
            p.duration > 0 && (this._memoizedDuration !== p.duration && (this._memoizedDuration = p.duration, x.durationProgress > 0 && (x.elapsedTime = p.duration * x.durationProgress, I = x.elapsedTime += t)), F = (p.progress || 0) + I / this._memoizedDuration, F = F > 1 ? 1 : F < 0 ? 0 : F, x.durationProgress = F), D = O + p.easing(F) * (C - O), N = (D - x.lastPosition) / t, k = F == 1;
          }
          x.lastVelocity = N, Number.isNaN(D) && (console.warn("Got NaN while animating:", this), k = !0);
        }
        h && !h[E].done && (k = !1), k ? x.done = !0 : e = !1, x.setValue(D, p.round) && (i = !0);
      });
      const y = $v(this),
        w = y.getValue();
      if (e) {
        const x = od(l.to);
        (w !== x || i) && !p.decay ? (y.setValue(x), this._onChange(x)) : i && p.decay && this._onChange(w), this._stop();
      } else i && this._onChange(w);
    }
    /** Set the current value, while stopping the current animation */
    set(t) {
      return ur.batchedUpdates(() => {
        this._stop(), this._focus(t), this._set(t);
      }), this;
    }
    /**
     * Freeze the active animation in time, as well as any updates merged
     * before `resume` is called.
     */
    pause() {
      this._update({
        pause: !0
      });
    }
    /** Resume the animation if paused. */
    resume() {
      this._update({
        pause: !1
      });
    }
    /** Skip to the end of the current animation. */
    finish() {
      if (Y0(this)) {
        const {
          to: t,
          config: e
        } = this.animation;
        ur.batchedUpdates(() => {
          this._onStart(), e.decay || this._set(t, !1), this._stop();
        });
      }
      return this;
    }
    /** Push props into the pending queue. */
    update(t) {
      return (this.queue || (this.queue = [])).push(t), this;
    }
    start(t, e) {
      let i;
      return zt.und(t) ? (i = this.queue || [], this.queue = []) : i = [zt.obj(t) ? t : {
        ...e,
        to: t
      }], Promise.all(i.map(l => this._update(l))).then(l => Uz(this, l));
    }
    /**
     * Stop the current animation, and cancel any delayed updates.
     *
     * Pass `true` to call `onRest` with `cancelled: true`.
     */
    stop(t) {
      const {
        to: e
      } = this.animation;
      return this._focus(this.get()), PR(this._state, t && this._lastCallId), ur.batchedUpdates(() => this._stop(e, t)), this;
    }
    /** Restart the animation. */
    reset() {
      this._update({
        reset: !0
      });
    }
    /** @internal */
    eventObserved(t) {
      t.type == "change" ? this._start() : t.type == "priority" && (this.priority = t.priority + 1);
    }
    /**
     * Parse the `to` and `from` range from the given `props` object.
     *
     * This also ensures the initial value is available to animated components
     * during the render phase.
     */
    _prepareNode(t) {
      const e = this.key || "";
      let {
        to: i,
        from: l
      } = t;
      i = zt.obj(i) ? i[e] : i, (i == null || xF(i)) && (i = void 0), l = zt.obj(l) ? l[e] : l, l == null && (l = void 0);
      const c = {
        to: i,
        from: l
      };
      return gj(this) || (t.reverse && ([i, l] = [l, i]), l = od(l), zt.und(l) ? $v(this) || this._set(i) : this._set(l)), c;
    }
    /** Every update is processed by this method before merging. */
    _update({
      ...t
    }, e) {
      const {
        key: i,
        defaultProps: l
      } = this;
      t.default && Object.assign(l, Bz(t, (h, y) => /^on/.test(y) ? dW(h, i) : h)), tH(this, t, "onProps"), MT(this, "onProps", t, this);
      const c = this._prepareNode(t);
      if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
      const p = this._state;
      return hW(++this._lastCallId, {
        key: i,
        props: t,
        defaultProps: l,
        state: p,
        actions: {
          pause: () => {
            DT(this) || (JU(this, !0), PT(p.pauseQueue), MT(this, "onPause", Hm(this, IT(this, this.animation.to)), this));
          },
          resume: () => {
            DT(this) && (JU(this, !1), Y0(this) && this._resume(), PT(p.resumeQueue), MT(this, "onResume", Hm(this, IT(this, this.animation.to)), this));
          },
          start: this._merge.bind(this, c)
        }
      }).then(h => {
        if (t.loop && h.finished && !(e && h.noop)) {
          const y = wW(t);
          if (y) return this._update(y, !0);
        }
        return h;
      });
    }
    /** Merge props into the current animation */
    _merge(t, e, i) {
      if (e.cancel) return this.stop(!0), i(wE(this));
      const l = !zt.und(t.to),
        c = !zt.und(t.from);
      if (l || c) if (e.callId > this._lastToId) this._lastToId = e.callId;else return i(wE(this));
      const {
          key: p,
          defaultProps: h,
          animation: y
        } = this,
        {
          to: w,
          from: x
        } = y;
      let {
        to: E = w,
        from: C = x
      } = t;
      c && !l && (!e.default || zt.und(E)) && (E = C), e.reverse && ([E, C] = [C, E]);
      const k = !db(C, x);
      k && (y.from = C), C = od(C);
      const D = !db(E, w);
      D && this._focus(E);
      const I = xF(e.to),
        {
          config: O
        } = y,
        {
          decay: P,
          velocity: N
        } = O;
      (l || c) && (O.velocity = 0), e.config && !I && Zbe(O, Ux(e.config, p),
      // Avoid calling the same "config" prop twice.
      e.config !== h.config ? Ux(h.config, p) : void 0);
      let L = $v(this);
      if (!L || zt.und(E)) return i(Hm(this, !0));
      const F =
        // When `reset` is undefined, the `from` prop implies `reset: true`,
        // except for declarative updates. When `reset` is defined, there
        // must exist a value to animate from.
        zt.und(e.reset) ? c && !e.default : !zt.und(C) && tR(e.reset, p),
        j = F ? C : this.get(),
        V = LR(E),
        K = zt.num(V) || zt.arr(V) || oL(V),
        G = !I && (!K || tR(h.immediate || e.immediate, p));
      if (D) {
        const Y = _F(E);
        if (Y !== L.constructor) if (G) L = this._set(V);else throw Error(`Cannot animate between ${L.constructor.name} and ${Y.name}, as the "to" prop suggests`);
      }
      const Q = L.constructor;
      let te = Ap(E),
        ie = !1;
      if (!te) {
        const Y = F || !gj(this) && k;
        (D || Y) && (ie = db(LR(j), V), te = !ie), (!db(y.immediate, G) && !G || !db(O.decay, P) || !db(O.velocity, N)) && (te = !0);
      }
      if (ie && Y0(this) && (y.changed && !F ? te = !0 : te || this._stop(w)), !I && ((te || Ap(w)) && (y.values = L.getPayload(), y.toValues = Ap(E) ? null : Q == OR ? [1] : sp(V)), y.immediate != G && (y.immediate = G, !G && !F && this._set(w)), te)) {
        const {
          onRest: Y
        } = y;
        Fr(r0e, oe => tH(this, e, oe));
        const ee = Hm(this, IT(this, w));
        PT(this._pendingCalls, ee), this._pendingCalls.add(i), y.changed && ur.batchedUpdates(() => {
          var oe;
          y.changed = !F, Y == null || Y(ee, this), F ? Ux(h.onRest, ee) : (oe = y.onStart) == null || oe.call(y, ee, this);
        });
      }
      F && this._set(j), I ? i(vW(e.to, e, this._state, this)) : te ? this._start() : Y0(this) && !D ? this._pendingCalls.add(i) : i(mW(j));
    }
    /** Update the `animation.to` value, which might be a `FluidValue` */
    _focus(t) {
      const e = this.animation;
      t !== e.to && (UU(this) && this._detach(), e.to = t, UU(this) && this._attach());
    }
    _attach() {
      let t = 0;
      const {
        to: e
      } = this.animation;
      Ap(e) && ($E(e, this), EF(e) && (t = e.priority + 1)), this.priority = t;
    }
    _detach() {
      const {
        to: t
      } = this.animation;
      Ap(t) && IR(t, this);
    }
    /**
     * Update the current value from outside the frameloop,
     * and return the `Animated` node.
     */
    _set(t, e = !0) {
      const i = od(t);
      if (!zt.und(i)) {
        const l = $v(this);
        if (!l || !db(i, l.getValue())) {
          const c = _F(i);
          !l || l.constructor != c ? Vz(this, c.create(i)) : l.setValue(i), l && ur.batchedUpdates(() => {
            this._onChange(i, e);
          });
        }
      }
      return $v(this);
    }
    _onStart() {
      const t = this.animation;
      t.changed || (t.changed = !0, MT(this, "onStart", Hm(this, IT(this, t.to)), this));
    }
    _onChange(t, e) {
      e || (this._onStart(), Ux(this.animation.onChange, t, this)), Ux(this.defaultProps.onChange, t, this), super._onChange(t, e);
    }
    // This method resets the animation state (even if already animating) to
    // ensure the latest from/to range is used, and it also ensures this spring
    // is added to the frameloop.
    _start() {
      const t = this.animation;
      $v(this).reset(od(t.to)), t.immediate || (t.fromValues = t.values.map(e => e.lastPosition)), Y0(this) || (ZU(this, !0), DT(this) || this._resume());
    }
    _resume() {
      Xm.skipAnimation ? this.finish() : rL.start(this);
    }
    /**
     * Exit the frameloop and notify `onRest` listeners.
     *
     * Always wrap `_stop` calls with `batchedUpdates`.
     */
    _stop(t, e) {
      if (Y0(this)) {
        ZU(this, !1);
        const i = this.animation;
        Fr(i.values, c => {
          c.done = !0;
        }), i.toValues && (i.onChange = i.onPause = i.onResume = void 0), DR(this, {
          type: "idle",
          parent: this
        });
        const l = e ? wE(this.get()) : Hm(this.get(), IT(this, t ?? i.to));
        PT(this._pendingCalls, l), i.changed && (i.changed = !1, MT(this, "onRest", l, this));
      }
    }
  };
function IT(t, e) {
  const i = LR(e),
    l = LR(t.get());
  return db(l, i);
}
function wW(t, e = t.loop, i = t.to) {
  const l = Ux(e);
  if (l) {
    const c = l !== !0 && pW(l),
      p = (c || t).reverse,
      h = !c || c.reset;
    return AR({
      ...t,
      loop: e,
      // Avoid updating default props when looping.
      default: !1,
      // Never loop the `pause` prop.
      pause: void 0,
      // For the "reverse" prop to loop as expected, the "to" prop
      // must be undefined. The "reverse" prop is ignored when the
      // "to" prop is an array or function.
      to: !p || xF(i) ? i : void 0,
      // Ignore the "from" prop except on reset.
      from: h ? t.from : void 0,
      reset: h,
      // The "loop" prop can return a "useSpring" props object to
      // override any of the original props.
      ...c
    });
  }
}
function AR(t) {
  const {
      to: e,
      from: i
    } = t = pW(t),
    l = /* @__PURE__ */new Set();
  return zt.obj(e) && eH(e, l), zt.obj(i) && eH(i, l), t.keys = l.size ? Array.from(l) : null, t;
}
function n0e(t) {
  const e = AR(t);
  return zt.und(e.default) && (e.default = Bz(e)), e;
}
function eH(t, e) {
  Jv(t, (i, l) => i != null && e.add(l));
}
var r0e = ["onStart", "onRest", "onChange", "onPause", "onResume"];
function tH(t, e, i) {
  t.animation[i] = e[i] !== fW(e, i) ? dW(e[i], t.key) : void 0;
}
function MT(t, e, ...i) {
  var l, c, p, h;
  (c = (l = t.animation)[e]) == null || c.call(l, ...i), (h = (p = t.defaultProps)[e]) == null || h.call(p, ...i);
}
var i0e = ["onStart", "onChange", "onRest"],
  a0e = 1,
  o0e = class {
    constructor(t, e) {
      this.id = a0e++, this.springs = {}, this.queue = [], this._lastAsyncId = 0, this._active = /* @__PURE__ */new Set(), this._changed = /* @__PURE__ */new Set(), this._started = !1, this._state = {
        paused: !1,
        pauseQueue: /* @__PURE__ */new Set(),
        resumeQueue: /* @__PURE__ */new Set(),
        timeouts: /* @__PURE__ */new Set()
      }, this._events = {
        onStart: /* @__PURE__ */new Map(),
        onChange: /* @__PURE__ */new Map(),
        onRest: /* @__PURE__ */new Map()
      }, this._onFrame = this._onFrame.bind(this), e && (this._flush = e), t && this.start({
        default: !0,
        ...t
      });
    }
    /**
     * Equals `true` when no spring values are in the frameloop, and
     * no async animation is currently active.
     */
    get idle() {
      return !this._state.asyncTo && Object.values(this.springs).every(t => t.idle && !t.isDelayed && !t.isPaused);
    }
    get item() {
      return this._item;
    }
    set item(t) {
      this._item = t;
    }
    /** Get the current values of our springs */
    get() {
      const t = {};
      return this.each((e, i) => t[i] = e.get()), t;
    }
    /** Set the current values without animating. */
    set(t) {
      for (const e in t) {
        const i = t[e];
        zt.und(i) || this.springs[e].set(i);
      }
    }
    /** Push an update onto the queue of each value. */
    update(t) {
      return t && this.queue.push(AR(t)), this;
    }
    /**
     * Start the queued animations for every spring, and resolve the returned
     * promise once all queued animations have finished or been cancelled.
     *
     * When you pass a queue (instead of nothing), that queue is used instead of
     * the queued animations added with the `update` method, which are left alone.
     */
    start(t) {
      let {
        queue: e
      } = this;
      return t ? e = sp(t).map(AR) : this.queue = [], this._flush ? this._flush(this, e) : (CW(this, e), CF(this, e));
    }
    /** @internal */
    stop(t, e) {
      if (t !== !!t && (e = t), e) {
        const i = this.springs;
        Fr(sp(e), l => i[l].stop(!!t));
      } else PR(this._state, this._lastAsyncId), this.each(i => i.stop(!!t));
      return this;
    }
    /** Freeze the active animation in time */
    pause(t) {
      if (zt.und(t)) this.start({
        pause: !0
      });else {
        const e = this.springs;
        Fr(sp(t), i => e[i].pause());
      }
      return this;
    }
    /** Resume the animation if paused. */
    resume(t) {
      if (zt.und(t)) this.start({
        pause: !1
      });else {
        const e = this.springs;
        Fr(sp(t), i => e[i].resume());
      }
      return this;
    }
    /** Call a function once per spring value */
    each(t) {
      Jv(this.springs, t);
    }
    /** @internal Called at the end of every animation frame */
    _onFrame() {
      const {
          onStart: t,
          onChange: e,
          onRest: i
        } = this._events,
        l = this._active.size > 0,
        c = this._changed.size > 0;
      (l && !this._started || c && !this._started) && (this._started = !0, JT(t, ([y, w]) => {
        w.value = this.get(), y(w, this, this._item);
      }));
      const p = !l && this._started,
        h = c || p && i.size ? this.get() : null;
      c && e.size && JT(e, ([y, w]) => {
        w.value = h, y(w, this, this._item);
      }), p && (this._started = !1, JT(i, ([y, w]) => {
        w.value = h, y(w, this, this._item);
      }));
    }
    /** @internal */
    eventObserved(t) {
      if (t.type == "change") this._changed.add(t.parent), t.idle || this._active.add(t.parent);else if (t.type == "idle") this._active.delete(t.parent);else return;
      ur.onFrame(this._onFrame);
    }
  };
function CF(t, e) {
  return Promise.all(e.map(i => _W(t, i))).then(i => Uz(t, i));
}
async function _W(t, e, i) {
  const {
      keys: l,
      to: c,
      from: p,
      loop: h,
      onRest: y,
      onResolve: w
    } = e,
    x = zt.obj(e.default) && e.default;
  h && (e.loop = !1), c === !1 && (e.to = null), p === !1 && (e.from = null);
  const E = zt.arr(c) || zt.fun(c) ? c : void 0;
  E ? (e.to = void 0, e.onRest = void 0, x && (x.onRest = void 0)) : Fr(i0e, O => {
    const P = e[O];
    if (zt.fun(P)) {
      const N = t._events[O];
      e[O] = ({
        finished: L,
        cancelled: F
      }) => {
        const j = N.get(P);
        j ? (L || (j.finished = !1), F && (j.cancelled = !0)) : N.set(P, {
          value: null,
          finished: L || !1,
          cancelled: F || !1
        });
      }, x && (x[O] = e[O]);
    }
  });
  const C = t._state;
  e.pause === !C.paused ? (C.paused = e.pause, PT(e.pause ? C.pauseQueue : C.resumeQueue)) : C.paused && (e.pause = !0);
  const k = (l || Object.keys(t.springs)).map(O => t.springs[O].start(e)),
    D = e.cancel === !0 || fW(e, "cancel") === !0;
  (E || D && C.asyncId) && k.push(hW(++t._lastAsyncId, {
    props: e,
    state: C,
    actions: {
      pause: bF,
      resume: bF,
      start(O, P) {
        D ? (PR(C, t._lastAsyncId), P(wE(t))) : (O.onRest = y, P(vW(E, O, C, t)));
      }
    }
  })), C.paused && (await new Promise(O => {
    C.resumeQueue.add(O);
  }));
  const I = Uz(t, await Promise.all(k));
  if (h && I.finished && !(i && I.noop)) {
    const O = wW(e, h, c);
    if (O) return CW(t, [O]), _W(t, O, !0);
  }
  return w && ur.batchedUpdates(() => w(I, t, t.item)), I;
}
function nH(t, e) {
  const i = {
    ...t.springs
  };
  return e && Fr(sp(e), l => {
    zt.und(l.keys) && (l = AR(l)), zt.obj(l.to) || (l = {
      ...l,
      to: void 0
    }), EW(i, l, c => SW(c));
  }), xW(t, i), i;
}
function xW(t, e) {
  Jv(e, (i, l) => {
    t.springs[l] || (t.springs[l] = i, $E(i, t));
  });
}
function SW(t, e) {
  const i = new t0e();
  return i.key = t, e && $E(i, e), i;
}
function EW(t, e, i) {
  e.keys && Fr(e.keys, l => {
    (t[l] || (t[l] = i(l)))._prepareNode(e);
  });
}
function CW(t, e) {
  Fr(e, i => {
    EW(t.springs, i, l => SW(l, t));
  });
}
var uL = ({
    children: t,
    ...e
  }) => {
    const i = bl(zO),
      l = e.pause || !!i.pause,
      c = e.immediate || !!i.immediate;
    e = Pbe(() => ({
      pause: l,
      immediate: c
    }), [l, c]);
    const {
      Provider: p
    } = zO;
    return /* @__PURE__ */Bn.createElement(p, {
      value: e
    }, t);
  },
  zO = s0e(uL, {});
uL.Provider = zO.Provider;
uL.Consumer = zO.Consumer;
function s0e(t, e) {
  return Object.assign(t, Bn.createContext(e)), t.Provider._context = t, t.Consumer._context = t, t;
}
var l0e = () => {
  const t = [],
    e = function (l) {
      Obe();
      const c = [];
      return Fr(t, (p, h) => {
        if (zt.und(l)) c.push(p.start());else {
          const y = i(l, p, h);
          y && c.push(p.start(y));
        }
      }), c;
    };
  e.current = t, e.add = function (l) {
    t.includes(l) || t.push(l);
  }, e.delete = function (l) {
    const c = t.indexOf(l);
    ~c && t.splice(c, 1);
  }, e.pause = function () {
    return Fr(t, l => l.pause(...arguments)), this;
  }, e.resume = function () {
    return Fr(t, l => l.resume(...arguments)), this;
  }, e.set = function (l) {
    Fr(t, (c, p) => {
      const h = zt.fun(l) ? l(p, c) : l;
      h && c.set(h);
    });
  }, e.start = function (l) {
    const c = [];
    return Fr(t, (p, h) => {
      if (zt.und(l)) c.push(p.start());else {
        const y = this._getProps(l, p, h);
        y && c.push(p.start(y));
      }
    }), c;
  }, e.stop = function () {
    return Fr(t, l => l.stop(...arguments)), this;
  }, e.update = function (l) {
    return Fr(t, (c, p) => c.update(this._getProps(l, c, p))), this;
  };
  const i = function (l, c, p) {
    return zt.fun(l) ? l(p, c) : l;
  };
  return e._getProps = i, e;
};
function u0e(t, e, i) {
  const l = zt.fun(e) && e;
  l && !i && (i = []);
  const c = ci(() => l || arguments.length == 3 ? l0e() : void 0, []),
    p = vt(0),
    h = sW(),
    y = ci(() => ({
      ctrls: [],
      queue: [],
      flush(N, L) {
        const F = nH(N, L);
        return p.current > 0 && !y.queue.length && !Object.keys(F).some(V => !N.springs[V]) ? CF(N, L) : new Promise(V => {
          xW(N, F), y.queue.push(() => {
            V(CF(N, L));
          }), h();
        });
      }
    }), []),
    w = vt([...y.ctrls]),
    x = [],
    E = $U(t) || 0;
  ci(() => {
    Fr(w.current.slice(t, E), N => {
      Gbe(N, c), N.stop(!0);
    }), w.current.length = t, C(E, t);
  }, [t]), ci(() => {
    C(0, Math.min(E, t));
  }, i);
  function C(N, L) {
    for (let F = N; F < L; F++) {
      const j = w.current[F] || (w.current[F] = new o0e(null, y.flush)),
        V = l ? l(F, j) : e[F];
      V && (x[F] = n0e(V));
    }
  }
  const k = w.current.map((N, L) => nH(N, x[L])),
    D = bl(uL),
    I = $U(D),
    O = D !== I && Ybe(D);
  zz(() => {
    p.current++, y.ctrls = w.current;
    const {
      queue: N
    } = y;
    N.length && (y.queue = [], Fr(N, L => L())), Fr(w.current, (L, F) => {
      c == null || c.add(L), O && L.start({
        default: D
      });
      const j = x[F];
      j && (Xbe(L, j.ref), L.ref ? L.queue.push(j) : L.start(j));
    });
  }), lW(() => () => {
    Fr(y.ctrls, N => N.stop(!0));
  });
  const P = k.map(N => ({
    ...N
  }));
  return c ? [P, c] : P;
}
function c0e(t, e) {
  const i = zt.fun(t),
    [[l], c] = u0e(1, i ? t : [t], i ? [] : e);
  return i || arguments.length == 2 ? [l, c] : l;
}
var d0e = class extends Hz {
  constructor(t, e) {
    super(), this.source = t, this.idle = !0, this._active = /* @__PURE__ */new Set(), this.calc = TR(...e);
    const i = this._get(),
      l = _F(i);
    Vz(this, l.create(i));
  }
  advance(t) {
    const e = this._get(),
      i = this.get();
    db(e, i) || ($v(this).setValue(e), this._onChange(e, this.idle)), !this.idle && rH(this._active) && yj(this);
  }
  _get() {
    const t = zt.arr(this.source) ? this.source.map(od) : sp(od(this.source));
    return this.calc(...t);
  }
  _start() {
    this.idle && !rH(this._active) && (this.idle = !1, Fr(sL(this), t => {
      t.done = !1;
    }), Xm.skipAnimation ? (ur.batchedUpdates(() => this.advance()), yj(this)) : rL.start(this));
  }
  // Observe our sources only when we're observed.
  _attach() {
    let t = 1;
    Fr(sp(this.source), e => {
      Ap(e) && $E(e, this), EF(e) && (e.idle || this._active.add(e), t = Math.max(t, e.priority + 1));
    }), this.priority = t, this._start();
  }
  // Stop observing our sources once we have no observers.
  _detach() {
    Fr(sp(this.source), t => {
      Ap(t) && IR(t, this);
    }), this._active.clear(), yj(this);
  }
  /** @internal */
  eventObserved(t) {
    t.type == "change" ? t.idle ? this.advance() : (this._active.add(t.parent), this._start()) : t.type == "idle" ? this._active.delete(t.parent) : t.type == "priority" && (this.priority = sp(this.source).reduce((e, i) => Math.max(e, (EF(i) ? i.priority : 0) + 1), 0));
  }
};
function f0e(t) {
  return t.idle !== !1;
}
function rH(t) {
  return !t.size || Array.from(t).every(f0e);
}
function yj(t) {
  t.idle || (t.idle = !0, Fr(sL(t), e => {
    e.done = !0;
  }), DR(t, {
    type: "idle",
    parent: t
  }));
}
Xm.assign({
  createStringInterpolator: aW,
  to: (t, e) => new d0e(t, e)
});
var p0e = F8(),
  kW = /^--/;
function h0e(t, e) {
  return e == null || typeof e == "boolean" || e === "" ? "" : typeof e == "number" && e !== 0 && !kW.test(t) && !(nR.hasOwnProperty(t) && nR[t]) ? e + "px" : ("" + e).trim();
}
var iH = {};
function m0e(t, e) {
  if (!t.nodeType || !t.setAttribute) return !1;
  const i = t.nodeName === "filter" || t.parentNode && t.parentNode.nodeName === "filter",
    {
      className: l,
      style: c,
      children: p,
      scrollTop: h,
      scrollLeft: y,
      viewBox: w,
      ...x
    } = e,
    E = Object.values(x),
    C = Object.keys(x).map(k => i || t.hasAttribute(k) ? k : iH[k] || (iH[k] = k.replace(/([A-Z])/g,
    // Attributes are written in dash case
    D => "-" + D.toLowerCase())));
  p !== void 0 && (t.textContent = p);
  for (const k in c) if (c.hasOwnProperty(k)) {
    const D = h0e(k, c[k]);
    kW.test(k) ? t.style.setProperty(k, D) : t.style[k] = D;
  }
  C.forEach((k, D) => {
    t.setAttribute(k, E[D]);
  }), l !== void 0 && (t.className = l), h !== void 0 && (t.scrollTop = h), y !== void 0 && (t.scrollLeft = y), w !== void 0 && t.setAttribute("viewBox", w);
}
var nR = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    // SVG-related properties
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  },
  v0e = (t, e) => t + e.charAt(0).toUpperCase() + e.substring(1),
  g0e = ["Webkit", "Ms", "Moz", "O"];
nR = Object.keys(nR).reduce((t, e) => (g0e.forEach(i => t[v0e(i, e)] = t[e]), t), nR);
var y0e = /^(matrix|translate|scale|rotate|skew)/,
  b0e = /^(translate)/,
  w0e = /^(rotate|skew)/,
  bj = (t, e) => zt.num(t) && t !== 0 ? t + e : t,
  eO = (t, e) => zt.arr(t) ? t.every(i => eO(i, e)) : zt.num(t) ? t === e : parseFloat(t) === e,
  _0e = class extends lL {
    constructor({
      x: t,
      y: e,
      z: i,
      ...l
    }) {
      const c = [],
        p = [];
      (t || e || i) && (c.push([t || 0, e || 0, i || 0]), p.push(h => [`translate3d(${h.map(y => bj(y, "px")).join(",")})`,
      // prettier-ignore
      eO(h, 0)])), Jv(l, (h, y) => {
        if (y === "transform") c.push([h || ""]), p.push(w => [w, w === ""]);else if (y0e.test(y)) {
          if (delete l[y], zt.und(h)) return;
          const w = b0e.test(y) ? "px" : w0e.test(y) ? "deg" : "";
          c.push(sp(h)), p.push(y === "rotate3d" ? ([x, E, C, k]) => [`rotate3d(${x},${E},${C},${bj(k, w)})`, eO(k, 0)] : x => [`${y}(${x.map(E => bj(E, w)).join(",")})`, eO(x, y.startsWith("scale") ? 1 : 0)]);
        }
      }), c.length && (l.transform = new x0e(c, p)), super(l);
    }
  },
  x0e = class extends nW {
    constructor(t, e) {
      super(), this.inputs = t, this.transforms = e, this._value = null;
    }
    get() {
      return this._value || (this._value = this._get());
    }
    _get() {
      let t = "",
        e = !0;
      return Fr(this.inputs, (i, l) => {
        const c = od(i[0]),
          [p, h] = this.transforms[l](zt.arr(c) ? c : i.map(od));
        t += " " + p, e = e && h;
      }), e ? "none" : t;
    }
    // Start observing our inputs once we have an observer.
    observerAdded(t) {
      t == 1 && Fr(this.inputs, e => Fr(e, i => Ap(i) && $E(i, this)));
    }
    // Stop observing our inputs once we have no observers.
    observerRemoved(t) {
      t == 0 && Fr(this.inputs, e => Fr(e, i => Ap(i) && IR(i, this)));
    }
    eventObserved(t) {
      t.type == "change" && (this._value = null), DR(this, t);
    }
  },
  S0e = ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr",
  // SVG
  "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"];
Xm.assign({
  batchedUpdates: p0e.unstable_batchedUpdates,
  createStringInterpolator: aW,
  colors: cbe
});
var E0e = Ube(S0e, {
    applyAnimatedValues: m0e,
    createAnimatedStyle: t => new _0e(t),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getComponentProps: ({
      scrollTop: t,
      scrollLeft: e,
      ...i
    }) => i
  }),
  C0e = E0e.animated;
const k0e = "_formSection_a9tuc_1",
  T0e = "_formWrapper_a9tuc_11",
  R0e = "_imageBanner_a9tuc_19",
  D0e = "_formContainer_a9tuc_40",
  I0e = "_formElements_a9tuc_44",
  M0e = "_subtitle_a9tuc_47",
  O0e = "_inputContainer_a9tuc_52",
  L0e = "_emailInput_a9tuc_55",
  P0e = "_dropdownContainer_a9tuc_58",
  A0e = "_submitButton_a9tuc_61",
  j0e = "_button_a9tuc_66",
  F0e = "_legal_a9tuc_70",
  N0e = "_message_a9tuc_70",
  z0e = "_optInMessage_a9tuc_73",
  V0e = "_links_a9tuc_79",
  B0e = "_divider_a9tuc_83",
  U0e = "_link_a9tuc_79",
  H0e = "_errorAlert_a9tuc_99",
  $0e = "_srOnly_a9tuc_106",
  W0e = "_closeIcon_a9tuc_117",
  q0e = "_confirmation_a9tuc_134",
  Y0e = "_confirmIcon_a9tuc_150",
  G0e = "_heading_a9tuc_154",
  X0e = "_title_a9tuc_172",
  K0e = "_hiddenFields_a9tuc_179",
  Hr = {
    formSection: k0e,
    formWrapper: T0e,
    imageBanner: R0e,
    formContainer: D0e,
    formElements: I0e,
    subtitle: M0e,
    inputContainer: O0e,
    emailInput: L0e,
    dropdownContainer: P0e,
    submitButton: A0e,
    button: j0e,
    legal: F0e,
    message: N0e,
    optInMessage: z0e,
    links: V0e,
    divider: B0e,
    link: U0e,
    errorAlert: H0e,
    srOnly: $0e,
    closeIcon: W0e,
    confirmation: q0e,
    confirmIcon: Y0e,
    heading: G0e,
    title: X0e,
    hiddenFields: K0e,
    "inline-horizontal": "_inline-horizontal_a9tuc_192"
  },
  TW = Qn(({
    id: t,
    type: e,
    labels: i,
    mode: l,
    setWidgetOpen: c,
    userEmail: p,
    setUserEmail: h,
    userGateway: y,
    setUserGateway: w,
    setRegistered: x,
    isRegistered: E,
    setHasSubmitted: C = () => {},
    onValidateEmail: k,
    onSubmitForm: D,
    renderLink: I,
    gatewayData: O,
    emailError: P,
    setEmailError: N,
    gatewayError: L,
    setGatewayError: F,
    submitError: j,
    setSubmitError: V
  }, K) => {
    const {
        isSm: G
      } = WO(),
      Q = t ?? "email-subscription",
      [te, ie] = rt(!1),
      Y = vt(`email-${Q}`),
      [ee, oe] = rt(!1),
      ne = vt(null),
      [se, ue] = rt(),
      W = vt(null),
      $ = fe => {
        fe != null && fe.statusCode && fe != null && fe.errorMessage ? (console.error(`Error: onSubmitForm: Failed with statusCode: ${fe == null ? void 0 : fe.statusCode}: ${fe.errorMessage}`), V(fe.errorMessage)) : (console.error("Error: onSubmitForm: An unknown error occured"), i != null && i.errorUnknown && V(i.errorUnknown)), setTimeout(() => {
          C(!0);
        }, 10);
      },
      le = async fe => {
        fe.preventDefault(), oe(!0), V("");
        const xe = fe.target.querySelector(`#${Y.current}`),
          we = xe == null ? void 0 : xe.validity,
          ve = Ee(p, void 0, we),
          Te = ce(y);
        if (p && y && !ve && !Te) try {
          const ze = await (D == null ? void 0 : D(p, y));
          (ze == null ? void 0 : ze.statusCode) && ze.statusCode >= 200 && ze.statusCode <= 299 ? (l === "desktop" && ne != null && ne.current && ue(ne.current.getBoundingClientRect().height), ie(!0), x(!0), h(""), w(void 0)) : $(ze);
        } catch (ze) {
          $(ze);
        }
        oe(!1);
      },
      H = fe => {
        ce(fe), fe && w(fe);
      },
      ce = fe => {
        let xe = !1;
        return fe != null && fe.value || y != null && y.value ? F("") : (i != null && i.dropdownFieldErrorMissing && F(i.dropdownFieldErrorMissing), xe = !0), C(!0), xe;
      },
      de = fe => {
        h(fe.target.value), Ee(fe.currentTarget.value, fe);
      },
      Ce = fe => {
        var ve, Te, ze;
        const xe = {
          valueMissing: (ve = i == null ? void 0 : i.validityMessages) == null ? void 0 : ve.valueMissing,
          typeMismatch: (Te = i == null ? void 0 : i.validityMessages) == null ? void 0 : Te.typeMismatch,
          patternMismatch: (ze = i == null ? void 0 : i.validityMessages) == null ? void 0 : ze.patternMismatch
        };
        let we = !1;
        return i != null && i.validityMessages && Object.keys(i.validityMessages).forEach(Xe => {
          if (fe[Xe]) {
            const ye = xe[Xe];
            typeof ye == "string" && (N(ye), we = !0);
            return;
          }
        }), we || N(""), we;
      },
      Ee = (fe, xe, we) => {
        let ve = !1;
        if (typeof k == "function") {
          const Te = k == null ? void 0 : k(fe);
          typeof Te == "string" ? (N(Te), ve = !!Te) : xe != null && xe.target.validity.valid || we != null && we.valid ? N("") : ve = !0;
        } else xe != null && xe.target.validity ? ve = Ce(xe.target.validity) : we && (ve = Ce(we));
        return C(!0), ve;
      };
    return Rt(() => {
      var fe;
      j && W != null && W.current && ((fe = W.current) == null || fe.focus());
    }, [j]), /* @__PURE__ */B.jsx("div", {
      className: ge(Hr.formSection, l === "desktop" && (Hr == null ? void 0 : Hr[e])),
      ref: K,
      children: /* @__PURE__ */B.jsxs("div", {
        className: Hr.formWrapper,
        children: [/* @__PURE__ */B.jsx("div", {
          className: Hr.imageBanner,
          children: (i.desktopSmallImage || i.desktopLargeImage) && /* @__PURE__ */B.jsx("img", {
            src: G ? i.desktopSmallImage : i.desktopLargeImage,
            alt: ""
          })
        }), /* @__PURE__ */B.jsxs("div", {
          className: Hr.formContainer,
          children: [!E && /* @__PURE__ */B.jsx("form", {
            acceptCharset: "utf-8",
            noValidate: !0,
            onSubmit: le,
            ref: ne,
            children: /* @__PURE__ */B.jsxs("div", {
              className: Hr.formElements,
              children: [l === "mobile" && /* @__PURE__ */B.jsx(op, {
                onClick: fe => {
                  fe.preventDefault(), c(!1);
                },
                defaultStyle: !0,
                iconPlacement: "left",
                icon: "close",
                disabled: ee,
                className: Hr.closeIcon
              }), i.title && /* @__PURE__ */B.jsx("h2", {
                className: Hr.heading,
                children: i.title
              }), i.subtitle && /* @__PURE__ */B.jsx("div", {
                className: Hr.subtitle,
                children: i.subtitle
              }), j && /* @__PURE__ */B.jsx(U4, {
                ref: W,
                dismissible: !1,
                heading: j,
                variant: "error",
                headingAs: "p",
                className: Hr.errorAlert,
                children: null,
                tabIndex: -1
              }), /* @__PURE__ */B.jsxs("div", {
                className: Hr.inputContainer,
                children: [/* @__PURE__ */B.jsx("div", {
                  className: Hr.emailInput,
                  children: /* @__PURE__ */B.jsx(Ahe, {
                    label: i.inputFieldLabel,
                    type: "email",
                    pattern: typeof k != "function" ? nbe : void 0,
                    value: p,
                    required: !0,
                    theme: "grey",
                    onChange: de,
                    errorMessage: P,
                    id: `email-${Q}`,
                    name: `email-${Q}`,
                    disabled: ee
                  })
                }), /* @__PURE__ */B.jsx("div", {
                  className: Hr.dropdownContainer,
                  children: /* @__PURE__ */B.jsx(qT, {
                    className: Hr.dropdownInput,
                    label: i.dropdownFieldLabel,
                    theme: "grey",
                    data: O,
                    onChange: H,
                    errorMessage: L,
                    selectedItem: y,
                    initialSelectedItem: y,
                    id: `gateway-${Q}`,
                    isDisabled: ee
                  })
                }), /* @__PURE__ */B.jsx("div", {
                  className: Hr.submitButton,
                  children: /* @__PURE__ */B.jsx(op, {
                    className: Hr.button,
                    type: "submit",
                    variant: "primary",
                    disabled: ee,
                    children: i.submit
                  })
                })]
              }), /* @__PURE__ */B.jsxs("div", {
                className: ge(Hr.legal, (i == null ? void 0 : i.optInMessage) && Hr.message),
                children: [(i == null ? void 0 : i.optInMessage) && /* @__PURE__ */B.jsx("p", {
                  className: Hr.optInMessage,
                  children: i.optInMessage
                }), /* @__PURE__ */B.jsxs("div", {
                  className: Hr.links,
                  children: [(i == null ? void 0 : i.optInPrivacyLabel) && (i == null ? void 0 : i.optInPrivacyLink) && /* @__PURE__ */B.jsxs(fd, {
                    renderLink: I,
                    rel: "noopener",
                    href: i.optInPrivacyLink,
                    className: Hr.link,
                    target: "_blank",
                    children: [i.optInPrivacyLabel, i.optInA11yMessage && /* @__PURE__ */B.jsx("span", {
                      className: Hr.srOnly,
                      children: i.optInA11yMessage
                    })]
                  }), (i == null ? void 0 : i.optInPrivacyLink) && (i == null ? void 0 : i.optInContactLink) && /* @__PURE__ */B.jsx("span", {
                    className: Hr.divider,
                    children: "|"
                  }), (i == null ? void 0 : i.optInContactLabel) && (i == null ? void 0 : i.optInContactLink) && /* @__PURE__ */B.jsxs(fd, {
                    renderLink: I,
                    rel: "noopener noreferrer",
                    href: i.optInContactLink,
                    className: Hr.link,
                    target: "_blank",
                    children: [i.optInContactLabel, i.optInA11yMessage && /* @__PURE__ */B.jsx("span", {
                      className: Hr.srOnly,
                      children: i.optInA11yMessage
                    })]
                  })]
                })]
              })]
            })
          }), (E || te) && /* @__PURE__ */B.jsx("div", {
            className: Hr.confirmation,
            style: {
              minHeight: se || `${se}px`
            },
            children: /* @__PURE__ */B.jsxs("section", {
              children: [l === "mobile" && /* @__PURE__ */B.jsx(op, {
                onClick: fe => {
                  fe.preventDefault(), c(!1), (te || E) && (x(!1), ie(!1));
                },
                defaultStyle: !0,
                iconPlacement: "left",
                icon: "close",
                disabled: ee,
                className: Hr.closeIcon
              }), /* @__PURE__ */B.jsx("h2", {
                className: Hr.heading,
                children: i.title
              }), /* @__PURE__ */B.jsxs("div", {
                className: Hr.subtitle,
                children: [/* @__PURE__ */B.jsx(sn, {
                  name: "success-solid",
                  hidden: !0,
                  className: Hr.confirmIcon
                }), /* @__PURE__ */B.jsx("span", {
                  className: Hr.title,
                  children: i.confirmTitle
                })]
              }), /* @__PURE__ */B.jsx("div", {
                className: Hr.message,
                children: i.confirmMessage
              })]
            })
          })]
        })]
      })
    });
  }),
  Q0e = "_mobileWidgetWrapper_1oda1_1",
  Z0e = "_open_1oda1_11",
  J0e = "_container_1oda1_22",
  ewe = "_formContents_1oda1_49",
  twe = "_formContainer_1oda1_54",
  OT = {
    mobileWidgetWrapper: Q0e,
    open: Z0e,
    container: J0e,
    formContents: ewe,
    formContainer: twe
  },
  nwe = ({
    id: t,
    type: e,
    config: i,
    labels: l,
    mode: c,
    isWidgetOpen: p,
    setWidgetOpen: h,
    userEmail: y,
    setUserEmail: w,
    userGateway: x,
    setUserGateway: E,
    setRegistered: C,
    isRegistered: k,
    onValidateEmail: D,
    onSubmitForm: I,
    gatewayData: O,
    emailError: P,
    setEmailError: N,
    gatewayError: L,
    setGatewayError: F,
    submitError: j,
    setSubmitError: V,
    mobileButtonRef: K
  }) => {
    var we, ve, Te, ze, Xe, ye;
    const G = {
        marginBottom: tbe
      },
      Q = vt(p),
      [te, ie] = rt(null),
      [Y, ee] = rt(null),
      [oe, ne] = rt(p ? null : G),
      se = vt(!1),
      ue = vt(!1),
      W = vt(null),
      $ = vt(null),
      [le, H] = rt(!1),
      ce = vt(null),
      de = vt(!0),
      Ce = {
        title: ((Te = (ve = (we = i == null ? void 0 : i.content) == null ? void 0 : we[e]) == null ? void 0 : ve.mobileWidget) == null ? void 0 : Te.title) ?? l.title,
        subtitle: ((ye = (Xe = (ze = i == null ? void 0 : i.content) == null ? void 0 : ze[e]) == null ? void 0 : Xe.mobileWidget) == null ? void 0 : ye.subtitle) ?? l.subtitle
      };
    l = {
      ...tL,
      ...l,
      ...Ce
    };
    const [Ee, fe] = c0e(() => ({
        height: "0px",
        transition: "height 0.25s ease-out",
        onRest(qe) {
          qe.value.height === "0px" && setTimeout(() => {
            var Ae;
            (Ae = K == null ? void 0 : K.current) == null || Ae.focus();
          }, 10);
        }
      })),
      xe = pn(() => {
        if (W != null && W.current && $ != null && $.current && Q.current && (ue.current = $.current.getBoundingClientRect().height !== W.current.getBoundingClientRect().height, ue.current)) {
          const qe = W.current.getBoundingClientRect().height;
          fe.start({
            height: `${qe}px`
          }), ne(null);
        }
        se.current = !0, ie(window.innerWidth || document.documentElement.clientWidth), ee(window.innerHeight || document.documentElement.clientHeight);
      }, []);
    return Rt(() => (window.addEventListener("resize", xe, !1), de.current = !1, xe(), () => {
      window.removeEventListener("resize", xe);
    }), []), Rt(() => {
      !p && $ != null && $.current ? (Q.current = !1, document.getElementsByTagName("body")[0].style.overflow = "", fe.start({
        height: "0px"
      })) : p && $ != null && $.current && (Q.current = !0, xe());
    }, [k, p, kR, te, Y]), Rt(() => {
      if ($ != null && $.current || $ != null && $.current && ue.current) {
        ue.current = !1;
        const qe = W != null && W.current ? W.current.scrollHeight : 0;
        fe.start({
          height: `${p ? qe : 0}px`
        });
      }
    }, [p]), Rt(() => {
      if ((e === "inline-split" || e === "inline-horizontal") && W != null && W.current && k) {
        ue.current = !0;
        const qe = W.current.getBoundingClientRect().height;
        (p || k) && fe.start({
          height: `${qe}px`
        }), !p && (e === "inline-split" || e === "inline-horizontal") && k && h(!0);
      }
    }, [e, k, p, te]), Rt(() => {
      if (le && W != null && W.current && p) {
        const qe = W.current.getBoundingClientRect().height;
        fe.start({
          height: `${qe}px`
        }), H(!1);
      }
    }, [le]), /* @__PURE__ */B.jsx(B.Fragment, {
      children: te && te < kR && !de.current && /* @__PURE__ */B.jsx("div", {
        ref: ce,
        className: ge(OT.mobileWidgetWrapper, p ? OT.open : null),
        style: (e === "inline-split" || e === "inline-horizontal") && !p ? G : oe ?? void 0,
        children: /* @__PURE__ */B.jsx("div", {
          className: OT.container,
          children: /* @__PURE__ */B.jsx("div", {
            className: OT.formContents,
            children: /* @__PURE__ */B.jsx(C0e.div, {
              className: OT.formContainer,
              ref: $,
              style: {
                ...Ee
              },
              children: /* @__PURE__ */B.jsx(TW, {
                ref: W,
                id: t,
                type: e,
                labels: l,
                mode: c,
                setWidgetOpen: h,
                userEmail: y,
                setUserEmail: w,
                userGateway: x,
                setUserGateway: E,
                setRegistered: C,
                isRegistered: k,
                setHasSubmitted: H,
                onValidateEmail: D,
                onSubmitForm: I,
                gatewayData: O,
                emailError: P,
                setEmailError: N,
                gatewayError: L,
                setGatewayError: F,
                submitError: j,
                setSubmitError: V,
                mobileButtonRef: K
              })
            })
          })
        })
      })
    });
  },
  rwe = ({
    id: t,
    type: e,
    config: i,
    labels: l,
    mode: c,
    isWidgetOpen: p,
    setWidgetOpen: h,
    userEmail: y,
    setUserEmail: w,
    userGateway: x,
    setUserGateway: E,
    setRegistered: C,
    isRegistered: k,
    onValidateEmail: D,
    onSubmitForm: I,
    gatewayData: O,
    emailError: P,
    setEmailError: N,
    gatewayError: L,
    setGatewayError: F,
    submitError: j,
    setSubmitError: V
  }) => {
    let K = null;
    return c === "mobile" && (K = /* @__PURE__ */B.jsx(nwe, {
      id: t,
      type: e,
      config: i,
      labels: l,
      mode: c,
      isWidgetOpen: p,
      setWidgetOpen: h,
      userEmail: y,
      setUserEmail: w,
      userGateway: x,
      setUserGateway: E,
      setRegistered: C,
      isRegistered: k,
      onValidateEmail: D,
      onSubmitForm: I,
      gatewayData: O,
      emailError: P,
      setEmailError: N,
      gatewayError: L,
      setGatewayError: F,
      submitError: j,
      setSubmitError: V
    })), K;
  },
  iwe = "_formSection_55pyy_1",
  awe = "_formWrapper_55pyy_6",
  owe = "_imageBanner_55pyy_10",
  swe = "_formContainer_55pyy_29",
  lwe = "_formElements_55pyy_34",
  uwe = "_heading_55pyy_38",
  cwe = "_subtitle_55pyy_45",
  dwe = "_inputContainer_55pyy_50",
  fwe = "_submitButton_55pyy_53",
  lb = {
    formSection: iwe,
    formWrapper: awe,
    imageBanner: owe,
    formContainer: swe,
    formElements: lwe,
    heading: uwe,
    subtitle: cwe,
    inputContainer: dwe,
    submitButton: fwe
  },
  pwe = ({
    id: t,
    type: e,
    embed: i,
    config: l,
    labels: c,
    mode: p,
    isWidgetOpen: h,
    setWidgetOpen: y,
    userEmail: w,
    setUserEmail: x,
    userGateway: E,
    setUserGateway: C,
    setRegistered: k,
    isRegistered: D,
    onValidateEmail: I,
    onSubmitForm: O,
    gatewayData: P,
    emailError: N,
    setEmailError: L,
    gatewayError: F,
    setGatewayError: j,
    submitError: V,
    setSubmitError: K,
    mobileButtonRef: G,
    className: Q
  }) => {
    var oe, ne, se, ue, W, $, le, H, ce;
    const te = () => {
        y(!0);
      },
      ie = {
        image: ((se = (ne = (oe = l == null ? void 0 : l.content) == null ? void 0 : oe[e]) == null ? void 0 : ne.mobileBanner) == null ? void 0 : se.image) ?? c.mobileImage,
        title: (($ = (W = (ue = l == null ? void 0 : l.content) == null ? void 0 : ue[e]) == null ? void 0 : W.mobileBanner) == null ? void 0 : $.title) ?? c.title,
        subtitle: ((ce = (H = (le = l == null ? void 0 : l.content) == null ? void 0 : le[e]) == null ? void 0 : H.mobileBanner) == null ? void 0 : ce.subtitle) ?? c.subtitle
      },
      Y = {
        ...tL,
        ...c,
        ...ie
      },
      ee = /* @__PURE__ */B.jsx("div", {
        className: lb.formSection,
        children: /* @__PURE__ */B.jsxs("div", {
          className: lb.formWrapper,
          children: [/* @__PURE__ */B.jsx(gb, {
            className: lb.imageBanner,
            children: /* @__PURE__ */B.jsx("img", {
              src: Y.image,
              alt: ""
            })
          }), /* @__PURE__ */B.jsx(gb, {
            className: lb.formContainer,
            children: /* @__PURE__ */B.jsx(NE, {
              cols: 1,
              className: lb.formElements,
              children: /* @__PURE__ */B.jsx(gb, {
                children: /* @__PURE__ */B.jsxs("section", {
                  children: [/* @__PURE__ */B.jsx("div", {
                    className: lb.heading,
                    children: Y.title
                  }), /* @__PURE__ */B.jsx("div", {
                    className: lb.subtitle,
                    children: Y.subtitle
                  }), /* @__PURE__ */B.jsx("div", {
                    className: lb.inputContainer,
                    children: /* @__PURE__ */B.jsx(op, {
                      ref: G,
                      className: lb.submitButton,
                      type: "button",
                      variant: "primary",
                      onClick: () => te(),
                      children: Y.submit
                    })
                  })]
                })
              })
            })
          })]
        })
      });
    return /* @__PURE__ */B.jsxs(B.Fragment, {
      children: [/* @__PURE__ */B.jsx("section", {
        className: Q,
        children: ee
      }), /* @__PURE__ */B.jsx(GN, {
        autoFocus: !0,
        enabled: h,
        scrollLock: h && p === "mobile",
        children: /* @__PURE__ */B.jsx(rwe, {
          id: t,
          type: e,
          embed: i,
          config: l,
          mode: p,
          labels: c,
          isWidgetOpen: h,
          setWidgetOpen: y,
          userEmail: w,
          setUserEmail: x,
          userGateway: E,
          setUserGateway: C,
          setRegistered: k,
          isRegistered: D,
          onValidateEmail: I,
          onSubmitForm: O,
          gatewayData: P,
          emailError: N,
          setEmailError: L,
          gatewayError: F,
          setGatewayError: j,
          submitError: V,
          setSubmitError: K
        })
      })]
    });
  },
  hwe = ({
    id: t,
    type: e,
    config: i,
    labels: l,
    mode: c,
    setWidgetOpen: p,
    userEmail: h,
    setUserEmail: y,
    userGateway: w,
    setUserGateway: x,
    setRegistered: E,
    isRegistered: C,
    onValidateEmail: k,
    onSubmitForm: D,
    renderLink: I,
    gatewayData: O,
    emailError: P,
    setEmailError: N,
    gatewayError: L,
    setGatewayError: F,
    submitError: j,
    setSubmitError: V,
    className: K
  }) => {
    var Y, ee, oe, ne, se, ue, W, $, le, H, ce, de;
    const [G, Q] = rt(null),
      te = {
        desktopLargeImage: ((oe = (ee = (Y = i == null ? void 0 : i.content) == null ? void 0 : Y[e]) == null ? void 0 : ee.desktopWidget) == null ? void 0 : oe.imageLarge) ?? l.desktopLargeImage,
        desktopSmallImage: ((ue = (se = (ne = i == null ? void 0 : i.content) == null ? void 0 : ne[e]) == null ? void 0 : se.desktopWidget) == null ? void 0 : ue.imageSmall) ?? l.desktopSmallImage,
        title: ((le = ($ = (W = i == null ? void 0 : i.content) == null ? void 0 : W[e]) == null ? void 0 : $.desktopWidget) == null ? void 0 : le.title) ?? l.title,
        subtitle: ((de = (ce = (H = i == null ? void 0 : i.content) == null ? void 0 : H[e]) == null ? void 0 : ce.desktopWidget) == null ? void 0 : de.subtitle) ?? l.subtitle
      };
    l = {
      ...tL,
      ...l,
      ...te
    };
    const ie = () => {
      Q(window.innerWidth || document.documentElement.clientWidth);
    };
    return Rt(() => (window.addEventListener("resize", ie, !1), ie(), () => {
      window.removeEventListener("resize", ie);
    }), []), G && G >= kR ? /* @__PURE__ */B.jsx("section", {
      className: K,
      children: /* @__PURE__ */B.jsx(TW, {
        id: t,
        type: e,
        mode: c,
        labels: l,
        setWidgetOpen: p,
        userEmail: h,
        setUserEmail: y,
        userGateway: w,
        setUserGateway: x,
        setRegistered: E,
        isRegistered: C,
        onValidateEmail: k,
        onSubmitForm: D,
        renderLink: I,
        gatewayData: O,
        emailError: P,
        setEmailError: N,
        gatewayError: L,
        setGatewayError: F,
        submitError: j,
        setSubmitError: V
      })
    }) : null;
  },
  mwe = ({
    id: t,
    type: e,
    config: i,
    labels: l,
    isWidgetOpen: c,
    setWidgetOpen: p,
    userEmail: h,
    setUserEmail: y,
    userGateway: w,
    setUserGateway: x,
    setRegistered: E,
    isRegistered: C,
    onValidateEmail: k,
    onSubmitForm: D,
    renderLink: I,
    gatewayData: O,
    emailError: P,
    setEmailError: N,
    gatewayError: L,
    setGatewayError: F,
    submitError: j,
    setSubmitError: V,
    className: K
  }) => {
    const [G, Q] = rt(null),
      te = vt(null);
    let ie = null;
    const Y = () => {
      Q(window.innerWidth || document.documentElement.clientWidth);
    };
    return Rt(() => (window.addEventListener("resize", Y, !1), Y(), () => {
      window.removeEventListener("resize", Y);
    }), []), G && (G < kR ? ie = /* @__PURE__ */B.jsx(pwe, {
      id: t,
      type: e,
      embed: !0,
      config: i,
      mode: "mobile",
      labels: l,
      isWidgetOpen: c,
      setWidgetOpen: p,
      userEmail: h,
      setUserEmail: y,
      userGateway: w,
      setUserGateway: x,
      setRegistered: E,
      isRegistered: C,
      onValidateEmail: k,
      onSubmitForm: D,
      renderLink: I,
      gatewayData: O,
      emailError: P,
      setEmailError: N,
      gatewayError: L,
      setGatewayError: F,
      submitError: j,
      setSubmitError: V,
      mobileButtonRef: te,
      className: K
    }) : G >= kR && (ie = /* @__PURE__ */B.jsx(B.Fragment, {
      children: /* @__PURE__ */B.jsx(hwe, {
        id: t,
        type: e,
        embed: !0,
        config: i,
        mode: "desktop",
        labels: l,
        isWidgetOpen: c,
        setWidgetOpen: p,
        userEmail: h,
        setUserEmail: y,
        userGateway: w,
        setUserGateway: x,
        setRegistered: E,
        isRegistered: C,
        onValidateEmail: k,
        onSubmitForm: D,
        renderLink: I,
        gatewayData: O,
        emailError: P,
        setEmailError: N,
        gatewayError: L,
        setGatewayError: F,
        submitError: j,
        setSubmitError: V,
        className: K
      })
    }))), ie;
  },
  rxe = ({
    id: t,
    type: e,
    config: i,
    gatewayData: l,
    labels: c = {},
    onValidateEmail: p,
    onSubmitForm: h,
    renderLink: y,
    className: w
  }) => {
    const x = {
        ...tL,
        ...c
      },
      [E, C] = rt(!1),
      [k, D] = rt(""),
      [I, O] = rt(void 0),
      [P, N] = rt(),
      [L, F] = rt(""),
      [j, V] = rt(""),
      [K, G] = rt("");
    return e === "inline-split" || e === "inline-horizontal" ? /* @__PURE__ */B.jsx(mwe, {
      id: t,
      type: e,
      config: i,
      gatewayData: l,
      labels: x,
      userEmail: k,
      setUserEmail: D,
      isWidgetOpen: E,
      setWidgetOpen: C,
      userGateway: I,
      setUserGateway: O,
      setRegistered: N,
      isRegistered: P,
      onValidateEmail: p,
      onSubmitForm: h,
      renderLink: y,
      emailError: L,
      setEmailError: F,
      gatewayError: j,
      setGatewayError: V,
      submitError: K,
      setSubmitError: G,
      className: w
    }) : null;
  },
  vwe = "_tableWrapper_12dg5_1",
  gwe = "_table_12dg5_1",
  ywe = "_rowHeading_12dg5_19",
  bwe = "_headerBorderBottom_12dg5_28",
  wwe = "_header_12dg5_28",
  _we = "_tableHeading_12dg5_38",
  xwe = "_tableHeadingText_12dg5_46",
  Swe = "_headerCellEyebrow_12dg5_53",
  Ewe = "_row_12dg5_19",
  Cwe = "_actionRow_12dg5_65",
  kwe = "_pricingRow_12dg5_65",
  Twe = "_cell_12dg5_69",
  Rwe = "_actionCell_12dg5_69",
  Dwe = "_pricingCell_12dg5_69",
  Iwe = "_cellIconGreen_12dg5_79",
  Mwe = "_cellIconRed_12dg5_84",
  Owe = "_pricingCellPrice_12dg5_114",
  Lwe = "_pricingCellPriceText_12dg5_119",
  Pwe = "_pricingCellPricePlusSign_12dg5_124",
  Awe = "_pricingIcon_12dg5_135",
  jwe = "_right_12dg5_156",
  Io = {
    tableWrapper: vwe,
    table: gwe,
    rowHeading: ywe,
    headerBorderBottom: bwe,
    header: wwe,
    tableHeading: _we,
    tableHeadingText: xwe,
    headerCellEyebrow: Swe,
    row: Ewe,
    actionRow: Cwe,
    pricingRow: kwe,
    cell: Twe,
    actionCell: Rwe,
    pricingCell: Dwe,
    cellIconGreen: Iwe,
    cellIconRed: Mwe,
    pricingCellPrice: Owe,
    pricingCellPriceText: Lwe,
    pricingCellPricePlusSign: Pwe,
    pricingIcon: Awe,
    right: jwe
  },
  Oc = ({
    children: t,
    className: e,
    caption: i,
    ...l
  }) => /* @__PURE__ */B.jsx("div", {
    className: ge(Io.tableWrapper, e),
    children: /* @__PURE__ */B.jsxs("table", {
      className: Io.table,
      ...l,
      children: [i && /* @__PURE__ */B.jsx("caption", {
        children: i
      }), t]
    })
  }),
  Fwe = ({
    children: t,
    className: e,
    ...i
  }) => /* @__PURE__ */B.jsx("thead", {
    className: Io.headerBorderBottom,
    ...i,
    children: /* @__PURE__ */B.jsx("tr", {
      className: ge(Io.header, e),
      children: t
    })
  }),
  Nwe = ({
    eyebrow: t,
    title: e,
    span: i = 1,
    className: l = "",
    scope: c = "col",
    ...p
  }) => /* @__PURE__ */B.jsxs("th", {
    colSpan: i > 1 ? i : void 0,
    scope: c,
    className: ge(Io.tableHeading, l),
    ...p,
    children: [t && /* @__PURE__ */B.jsx(RW, {
      children: t
    }), /* @__PURE__ */B.jsx("h3", {
      className: Io.tableHeadingText,
      children: e
    })]
  }),
  RW = ({
    children: t
  }) => /* @__PURE__ */B.jsx("span", {
    className: Io.headerCellEyebrow,
    children: t
  }),
  zwe = ({
    children: t,
    className: e,
    ...i
  }) => /* @__PURE__ */B.jsx("tbody", {
    className: e,
    ...i,
    children: t
  }),
  Vwe = ({
    children: t,
    ...e
  }) => /* @__PURE__ */B.jsx(B.Fragment, {
    children: Nt.Children.map(t, (i, l) => Nt.isValidElement(i) ? Nt.cloneElement(i, {
      key: i.key || l,
      ...e
    }) : i)
  }),
  Bwe = ({
    children: t,
    className: e,
    ...i
  }) => /* @__PURE__ */B.jsx("tr", {
    className: ge(Io.row, e),
    ...i,
    children: t
  }),
  Uwe = ({
    children: t,
    ...e
  }) => /* @__PURE__ */B.jsx("tr", {
    className: Io.pricingRow,
    ...e,
    children: t
  }),
  Hwe = ({
    children: t,
    ...e
  }) => /* @__PURE__ */B.jsx("tr", {
    className: Io.actionRow,
    ...e,
    children: t
  }),
  $we = ({
    children: t,
    span: e = 1,
    className: i = "",
    scope: l = "row",
    ...c
  }) => /* @__PURE__ */B.jsx("th", {
    rowSpan: e > 1 ? e : void 0,
    scope: l,
    className: ge(Io.rowHeading, i),
    ...c,
    children: t
  }),
  Wwe = ({
    children: t,
    span: e = 1,
    className: i,
    icon: l,
    ...c
  }) => /* @__PURE__ */B.jsx("td", {
    colSpan: e > 1 ? e : void 0,
    className: i,
    ...c,
    children: /* @__PURE__ */B.jsxs("div", {
      className: Io.cell,
      children: [l && /* @__PURE__ */B.jsx(sn, {
        name: l,
        className: l === "checkmark" ? Io.cellIconGreen : Io.cellIconRed
      }), t]
    })
  }),
  qwe = ({
    align: t,
    children: e,
    className: i,
    ...l
  }) => /* @__PURE__ */B.jsx("td", {
    colSpan: 1,
    className: ge(i),
    ...l,
    children: /* @__PURE__ */B.jsx("div", {
      className: ge(Io.pricingCell, t && Io[t]),
      children: e
    })
  }),
  Ywe = ({
    children: t
  }) => /* @__PURE__ */B.jsx("div", {
    children: t
  }),
  Gwe = ({
    children: t,
    className: e
  }) => /* @__PURE__ */B.jsx("div", {
    className: ge(Io.pricingCellBody, e),
    children: t
  }),
  Xwe = ({
    icon: t,
    price: e
  }) => {
    const i = e && dR(e);
    return /* @__PURE__ */B.jsxs("div", {
      className: Io.pricingCellPrice,
      children: [t && /* @__PURE__ */B.jsx(sn, {
        name: t,
        className: Io.pricingIcon
      }), /* @__PURE__ */B.jsxs(cu, {
        size: "md",
        Tag: "h3",
        children: [/* @__PURE__ */B.jsx("span", {
          className: Io.pricingCellPricePlusSign,
          children: "+"
        }), /* @__PURE__ */B.jsx("span", {
          className: Io.pricingCellPriceText,
          children: i
        })]
      })]
    });
  },
  Kwe = ({
    children: t,
    className: e,
    ...i
  }) => /* @__PURE__ */B.jsx("td", {
    colSpan: 1,
    className: ge(e),
    ...i,
    children: /* @__PURE__ */B.jsx("div", {
      className: Io.actionCell,
      children: t
    })
  });
Oc.Header = Fwe;
Oc.Body = zwe;
Oc.Item = Vwe;
Oc.Row = Bwe;
Oc.PricingRow = Uwe;
Oc.ActionRow = Hwe;
Oc.Cell = Wwe;
Oc.HeaderCell = Nwe;
Oc.HeaderCellEyebrow = RW;
Oc.RowHeaderCell = $we;
Oc.PricingCell = qwe;
Oc.PricingCellEyebrow = Ywe;
Oc.PricingCellBody = Gwe;
Oc.PricingCellPrice = Xwe;
Oc.ActionCell = Kwe;
const Qwe = "_wrapper_td2nq_1",
  Zwe = "_input_td2nq_5",
  Jwe = "_border_td2nq_20",
  e_e = "_inputError_td2nq_30",
  t_e = "_inputIcon_td2nq_42",
  n_e = "_icon_td2nq_57",
  r_e = "_inputLabel_td2nq_64",
  i_e = "_inputLabelDisabled_td2nq_75",
  a_e = "_inputFocus_td2nq_78",
  o_e = "_helperText_td2nq_82",
  s_e = "_textError_td2nq_93",
  Op = {
    wrapper: Qwe,
    input: Zwe,
    border: Jwe,
    inputError: e_e,
    inputIcon: t_e,
    icon: n_e,
    inputLabel: r_e,
    inputLabelDisabled: i_e,
    inputFocus: a_e,
    helperText: o_e,
    textError: s_e
  },
  ixe = Qn(({
    className: t,
    classNames: e,
    rows: i = 4,
    ...l
  }, c) => {
    const p = vt(null);
    return jR(c, () => p.current, []), /* @__PURE__ */B.jsx(JK, {
      ref: p,
      className: ge(Op.wrapper, t),
      classNames: {
        input: ge(Op.input, e == null ? void 0 : e.input),
        inputBorder: ge(Op.border, e == null ? void 0 : e.inputBorder),
        inputError: ge(Op.inputError, e == null ? void 0 : e.inputError),
        inputErrorText: ge(Op.helperText, Op.textError, e == null ? void 0 : e.inputErrorText),
        inputFocus: ge(Op.inputFocus, e == null ? void 0 : e.inputFocus),
        inputHelperText: ge(Op.helperText, e == null ? void 0 : e.inputHelperText),
        inputLabel: ge(Op.inputLabel, e == null ? void 0 : e.inputLabel),
        inputLabelDisabled: ge(Op.inputLabelDisabled, e == null ? void 0 : e.inputLabelDisabled),
        iconDisable: ge(Op.inputIcon, e == null ? void 0 : e.iconDisable),
        value: e == null ? void 0 : e.value
      },
      iconOptions: {
        disabled: /* @__PURE__ */B.jsx(sn, {
          className: Op.icon,
          name: "nope"
        })
      },
      rows: i,
      ...l
    });
  }),
  l_e = "_topTileCard_1gjdl_1",
  u_e = "_topTileCardHeading_1gjdl_30",
  c_e = "_cardButton_1gjdl_50",
  d_e = "_topTileCardDesc_1gjdl_60",
  jM = {
    topTileCard: l_e,
    topTileCardHeading: u_e,
    cardButton: c_e,
    topTileCardDesc: d_e
  },
  f_e = ({
    header: t,
    headerAs: e = "h1",
    children: i,
    button: l,
    className: c,
    renderLink: p
  }) => /* @__PURE__ */B.jsxs("div", {
    className: ge(jM.topTileCard, c),
    children: [/* @__PURE__ */B.jsx(cu, {
      className: jM.topTileCardHeading,
      Tag: e,
      children: t.length >= 50 ? `${t.substring(0, 50)}…` : t
    }), /* @__PURE__ */B.jsx("div", {
      className: jM.topTileCardDesc,
      children: i
    }), /* @__PURE__ */B.jsx(op, {
      className: jM.cardButton,
      as: "a",
      href: l.href,
      renderLink: p,
      children: l.children
    })]
  }),
  p_e = "_topTileContainer_csvuy_1",
  h_e = "_topTileImage_csvuy_15",
  aH = {
    topTileContainer: p_e,
    topTileImage: h_e
  },
  axe = ({
    image: t,
    className: e,
    classNames: i,
    theme: l = "light",
    header: c,
    headerAs: p,
    children: h,
    button: y,
    renderLink: w
  }) => {
    var x, E, C;
    return /* @__PURE__ */B.jsxs("div", {
      className: ge(aH.topTileContainer, e),
      "data-theme": l,
      children: [/* @__PURE__ */B.jsx(f_e, {
        header: c,
        headerAs: p,
        children: h,
        button: y,
        renderLink: w,
        className: i == null ? void 0 : i.card
      }), /* @__PURE__ */B.jsx("div", {
        className: aH.topTileImage,
        children: /* @__PURE__ */B.jsx(Ym, {
          src: (x = t == null ? void 0 : t.source) == null ? void 0 : x.src,
          srcSet: (E = t == null ? void 0 : t.source) == null ? void 0 : E.srcSet,
          sizes: (C = t == null ? void 0 : t.source) == null ? void 0 : C.sizes,
          alt: t.alt,
          source: t.source,
          loading: "lazy"
        })
      })]
    });
  },
  m_e = "_link_1xyzf_9",
  v_e = "_refreshLink_1xyzf_27",
  g_e = "_refreshText_1xyzf_27",
  y_e = "_linkTop_1xyzf_35",
  b_e = "_updatedTitle_1xyzf_48",
  w_e = "_updatedDate_1xyzf_53",
  __e = "_refreshLinkSpin_1xyzf_76",
  Fx = {
    link: m_e,
    refreshLink: v_e,
    refreshText: g_e,
    linkTop: y_e,
    updatedTitle: b_e,
    updatedDate: w_e,
    refreshLinkSpin: __e
  },
  oxe = ({
    labels: t,
    date: e,
    icon: i,
    isUpdating: l,
    className: c,
    refreshTimestamp: p
  }) => /* @__PURE__ */B.jsxs("button", {
    type: "button",
    onClick: p,
    "aria-label": l ? t.updating : t.refresh,
    className: ge(Fx.link, c),
    children: [/* @__PURE__ */B.jsxs("div", {
      className: Fx.linkTop,
      children: [/* @__PURE__ */B.jsx("p", {
        className: Fx.updatedTitle,
        children: l ? t.updating : t == null ? void 0 : t.lastUpdated
      }), /* @__PURE__ */B.jsx("p", {
        className: Fx.updatedDate,
        children: e
      })]
    }), /* @__PURE__ */B.jsxs("div", {
      className: Fx.refreshLink,
      children: [/* @__PURE__ */B.jsx("p", {
        className: Fx.refreshText,
        children: l ? t.updating : t.refresh
      }), /* @__PURE__ */B.jsx("div", {
        className: l ? Fx.refreshLinkSpin : "",
        children: i || /* @__PURE__ */B.jsx(sn, {
          name: "refresh-micro",
          size: "3xl"
        })
      })]
    })]
  });
export { J_e as $, rS as A, op as B, O_e as C, H_e as D, qT as E, W_e as F, jne as G, cu as H, sn as I, V_e as J, Y_e as K, j_e as L, Q_e as M, C_e as N, k_e as O, F_e as P, M_e as Q, B_e as R, $_e as S, G_e as T, fd as U, E_e as V, X_e as W, R_e as X, Ahe as Y, K_e as Z, Z_e as _, Ox as a, RT as a0, pj as a1, exe as a2, txe as a3, Tre as a4, nxe as a5, Ame as a6, lj as a7, wO as a8, Zye as a9, rxe as aa, Oc as ab, mb as ac, jJ as ad, ixe as ae, axe as af, oxe as ag, Ape as ah, fne as b, Cee as c, EN as d, ge as e, pB as f, Ym as g, NE as h, gb as i, B as j, N4 as k, M8 as l, I_e as m, PQ as n, U4 as o, L_e as p, P_e as q, wJ as r, Jc as s, A_e as t, ZJ as u, N_e as v, fB as w, z_e as x, Hj as y, U_e as z };